webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(309);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _app = __webpack_require__(310);
	
	var _vacationsAbsences = __webpack_require__(1098);
	
	var _vacationsAbsences2 = _interopRequireDefault(_vacationsAbsences);
	
	var _foodBenefit = __webpack_require__(1561);
	
	var _foodBenefit2 = _interopRequireDefault(_foodBenefit);
	
	var _loans = __webpack_require__(1760);
	
	var _loans2 = _interopRequireDefault(_loans);
	
	var _solidarity = __webpack_require__(2200);
	
	var _solidarity2 = _interopRequireDefault(_solidarity);
	
	var _socialSecurity = __webpack_require__(2288);
	
	var _socialSecurity2 = _interopRequireDefault(_socialSecurity);
	
	var _mobile = __webpack_require__(2339);
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// App launch
	
	
	// Modules
	angular.module('app', _app.dependencies.concat([_vacationsAbsences2.default, _foodBenefit2.default, _loans2.default, _solidarity2.default, _socialSecurity2.default, _mobile2.default])).config(_app.appConfig).run(_app.appRun).value('entryPoint', null).component('app', _app.AppComponent);

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STATES = exports.dependencies = exports.AppComponent = exports.appRunMobile = exports.appRun = exports.appConfig = exports.angular = undefined;
	
	__webpack_require__(311);
	
	__webpack_require__(422);
	
	__webpack_require__(426);
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(531);
	
	__webpack_require__(533);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	__webpack_require__(540);
	
	__webpack_require__(542);
	
	__webpack_require__(544);
	
	var _common = __webpack_require__(545);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(617);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _features = __webpack_require__(1027);
	
	var _features2 = _interopRequireDefault(_features);
	
	var _states = __webpack_require__(565);
	
	var _app = __webpack_require__(1063);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(1064);
	
	var _app4 = _interopRequireDefault(_app3);
	
	var _appRun = __webpack_require__(1065);
	
	var _appRun2 = _interopRequireDefault(_appRun);
	
	var _app5 = __webpack_require__(1066);
	
	var _app6 = _interopRequireDefault(_app5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Our components
	// Dependencies that must be import before angular
	var dependencies = [_angularUiRouter2.default, 'pascalprecht.translate', 'ngCookies', 'ngSanitize', 'ngAnimate', 'toastr', 'ngPromiseExtras', _features2.default, _common2.default, _components2.default];
	
	// Dependencies that must be import after angular
	
	
	// Angular
	exports.angular = _angular2.default;
	exports.appConfig = _app2.default;
	exports.appRun = _app4.default;
	exports.appRunMobile = _appRun2.default;
	exports.AppComponent = _app6.default;
	exports.dependencies = dependencies;
	exports.STATES = _states.STATES;

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventEmitter = __webpack_require__(546);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	__webpack_require__(547);
	
	var _accessToken = __webpack_require__(549);
	
	var _accessToken2 = _interopRequireDefault(_accessToken);
	
	var _errorInterceptor = __webpack_require__(560);
	
	var _errorInterceptor2 = _interopRequireDefault(_errorInterceptor);
	
	var _services = __webpack_require__(566);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _filters = __webpack_require__(603);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _directives = __webpack_require__(609);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = angular.module('common', [_services2.default, _filters2.default, _directives2.default, _accessToken2.default, _errorInterceptor2.default]).value('EventEmitter', _eventEmitter2.default).name;
	
	exports.default = commonModule;

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (payload) {
	  return { $event: payload };
	};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectFitImages = __webpack_require__(548);
	
	var _objectFitImages2 = _interopRequireDefault(_objectFitImages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(function () {
	  return (0, _objectFitImages2.default)();
	});

/***/ }),
/* 548 */,
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _authentication = __webpack_require__(550);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _cookie = __webpack_require__(558);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _accessToken = __webpack_require__(559);
	
	var _accessToken2 = _interopRequireDefault(_accessToken);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accessTokenModule = _angular2.default.module('app.accessToken', []).service('AccessTokenService', _accessToken2.default).service('AuthenticationService', _authentication2.default).service('cookieService', _cookie2.default).factory('accessTokenInjector', ["$injector", "$log", function ($injector, $log) {
	  'ngInject';
	
	  function avoidTokenInjection(config) {
	    var hasToSkipRequest = config.headers['Skip-Request'] === 'true';
	    var isStaticFile = config.url.indexOf('uib/template/') !== -1 || config.url.indexOf('bootstrap/') !== -1 || config.url.indexOf('i18n/es.json') !== -1;
	    return hasToSkipRequest || isStaticFile;
	  }
	
	  return {
	    request: function request(config) {
	      if (avoidTokenInjection(config)) {
	        delete config.headers['Skip-Request']; // Delete flag for avoid infinite loop
	        $log.info('accessTokenInjector: ignoring ' + config.url);
	        return config;
	      }
	
	      var AccessTokenService = $injector.get('AccessTokenService');
	      var cookieService = $injector.get('cookieService');
	      var token = AccessTokenService.getToken();
	      var isPortalSenior = cookieService.get('isPortalSenior');
	      if (isPortalSenior === 'true') {
	        var _AuthenticationService = $injector.get('AuthenticationService');
	        var employee = _AuthenticationService.getEmployeeId();
	        if (!config.params) {
	          config.params = {};
	        }
	        config.params.isPortalSenior = true;
	        config.params.uid = employee;
	      }
	      if (token) {
	        config.headers['Authorization'] = token;
	      }
	      // $log.info(`accessTokenInjector url: ${JSON.stringify(config)}`);
	      return config;
	    }
	  };
	}]).config(["$httpProvider", function ($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('accessTokenInjector');
	}]).name;
	
	exports.default = accessTokenModule;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _endpoints = __webpack_require__(556);
	
	var _authentication = __webpack_require__(557);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var USER_KEY = 'userId';
	var SSO_URL = ("https://dev-bbva-launcher.appspot.com/s/to/foodhelp?target=");
	
	var AuthenticationService = function () {
	  AuthenticationService.$inject = ["$http", "$cookies", "$window", "$state", "$log", "$timeout", "AccessTokenService", "entryPoint"];
	  function AuthenticationService($http, $cookies, $window, $state, $log, $timeout, AccessTokenService, entryPoint) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AuthenticationService);
	    this.$http = $http;
	    this.cookies = $cookies;
	    this.window = $window;
	    this.state = $state;
	    this.log = $log;
	    this.timeout = $timeout;
	
	    this.accessTokenService = AccessTokenService;
	    this.entryPoint = entryPoint;
	
	    this.employeeId = $cookies.get(USER_KEY) ? $cookies.get(USER_KEY) : _authentication.DEFAULT_USER;
	  }
	
	  (0, _createClass3.default)(AuthenticationService, [{
	    key: 'authenticate',
	    value: function authenticate(token, target) {
	      var _this = this;
	
	      // this.log.info(('authenticate token ' + token);
	      var data = 'token=' + token + '&target=' + target;
	
	      if (true) {
	        data += '&employeeId=' + this.employeeId;
	      }
	
	      return this.$http({
	        method: 'POST',
	        url: _endpoints.AUTHENTICATION_URL,
	        data: data,
	        headers: {
	          'Skip-Request': 'true', // Avoid infinite loop!
	          'Content-Type': 'application/x-www-form-urlencoded'
	        }
	      }).then(function (response) {
	        _this.accessTokenService.setToken(response.data.token);
	        _this.cookies.put(USER_KEY, response.data.employee_id);
	        _this.employeeId = response.data.employee_id;
	        return response;
	      });
	    }
	  }, {
	    key: 'authenticatePortal',
	    value: function authenticatePortal(token, employee) {
	      var _this2 = this;
	
	      return this.$http({
	        method: 'GET',
	        url: _endpoints.VALIDATION_PORTAL_LOGIN_URL,
	        params: {
	          'token': token,
	          'employeeId': employee
	        },
	        headers: {
	          'Skip-Request': 'true', // Avoid infinite loop!
	          'Content-Type': 'application/x-www-form-urlencoded'
	        }
	      }).then(function (response) {
	        _this2.accessTokenService.setToken(response.data.token);
	        _this2.cookies.put(USER_KEY, response.data.employeeId);
	        _this2.employeeId = response.data.employeeId;
	        return response;
	      });
	    }
	  }, {
	    key: 'isAuthenticated',
	    value: function isAuthenticated() {
	      if (true) {
	        return true;
	      }
	
	      return this.cookies.get('token') !== undefined;
	    }
	  }, {
	    key: 'getEmployeeId',
	    value: function getEmployeeId() {
	      return this.employeeId;
	    }
	  }, {
	    key: 'reload',
	    value: function reload() {
	      this.window.location.reload();
	    }
	  }, {
	    key: 'redirectToLogin',
	    value: function redirectToLogin() {
	      this.setStorageState();
	      var ssoTarget = '' + SSO_URL + this.state.current.name;
	      this.window.location.href = ssoTarget;
	    }
	  }, {
	    key: 'setStorageState',
	    value: function setStorageState() {
	      localStorage.setItem('path', this.window.location.pathname);
	    }
	  }, {
	    key: 'pluginLogout',
	    value: function pluginLogout() {
	      this.clear();
	    }
	  }, {
	    key: 'setDefaultToken',
	    value: function setDefaultToken() {
	      this.accessTokenService.setToken('ourSecretToken');
	      this.cookies.put(USER_KEY, _authentication.DEFAULT_USER);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.accessTokenService.removeToken();
	      //this.window.location.href = `${SSO_URL}index`;
	    }
	  }]);
	  return AuthenticationService;
	}();
	
	exports.default = AuthenticationService;

/***/ }),
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API_URL = ("https://dev.autoservicios1.bbva.com/v01");
	
	var VACATIONS_ABSENCES_ROOT = 'vacations-absences';
	var VACATIONS_ABSENCES_URLS = {
	  EMPLOYEE_ROOT: VACATIONS_ABSENCES_ROOT + '/employee',
	  MANAGER_ROOT: VACATIONS_ABSENCES_ROOT + '/manager'
	};
	
	var LOANS_URLS = {
	  ROOT: 'loans',
	  CREDITWORTHINESS_ROOT: 'creditworthiness',
	  MODALITIES_ROOT: 'modalities',
	  SIGN_UP_ROOT: 'signup',
	  MY_LOANS_ROOT: 'list',
	  REPAYMENT_ROOT: 'amortizations',
	  SIMULATION_ROOT: 'simulate',
	  CADASTRAL_REFERENCE: 'cadastral-references',
	  FAMILIES: 'families-purposes',
	  EURIBOR: 'euribor',
	  WAGE_ADVANCE_REASONS_LIST: 'wages-advance/reasons-list',
	  WAGE_ADVANCE_EMPLOYEE: 'wages-advance',
	  SERVICE_CLOSED: 'service-and-payroll-closure-date',
	  SIGN_UP: 'signup',
	  FIXED_SV: 'interest-fixed-sv',
	  FIXED_VC: 'interest-fixed-vc'
	};
	
	var FOOD_BENEFIT_ROOT = 'food-benefit';
	var FOOD_BENEFIT_URLS = {
	  EMPLOYEE_ROOT: FOOD_BENEFIT_ROOT + '/employee',
	  MANAGER_ROOT: FOOD_BENEFIT_ROOT + '/manager'
	};
	
	var DELEGATIONS_ROOT = 'delegations';
	var DELEGATIONS_URLS = {
	  ROOT: DELEGATIONS_ROOT,
	  DELEGABLE_EMPLOYEES: DELEGATIONS_ROOT + '/load-delegable-employees'
	};
	
	var MANAGER_FOR_EMPLOYEE_ROOT_URL = 'users';
	var MANAGER_FOR_EMPLOYEE_URL = {
	  ROOT_MANAGER_FOR_EMPLOYEE: MANAGER_FOR_EMPLOYEE_ROOT_URL + '/obtain-manager-for-employee'
	};
	
	var SOLIDARITY_ROOT = 'euro-solidarity';
	var SOLIDARITY_URLS = {
	  ROOT: SOLIDARITY_ROOT,
	  ONG_LIST: 'ong',
	  CONTRIBUTIONS: 'contributions'
	};
	
	var SOCIAL_SECURITY_ROOT = 'social-security';
	var SOCIAL_SECURITY_URLS = {
	  ROOT: SOCIAL_SECURITY_ROOT,
	  QUOTE_BASIS_INITIAL: 'quote-basis-initial'
	};
	
	var AUTHENTICATION_URL = API_URL + '/login';
	var AUTHENTICATION_PORTAL_URL = API_URL + '/login-portal';
	
	var VALIDATION_PORTAL_LOGIN_URL = API_URL + '/login-portal/validation';
	
	exports.VACATIONS_ABSENCES_URLS = VACATIONS_ABSENCES_URLS;
	exports.LOANS_URLS = LOANS_URLS;
	exports.VALIDATION_PORTAL_LOGIN_URL = VALIDATION_PORTAL_LOGIN_URL;
	exports.FOOD_BENEFIT_URLS = FOOD_BENEFIT_URLS;
	exports.AUTHENTICATION_URL = AUTHENTICATION_URL;
	exports.AUTHENTICATION_PORTAL_URL = AUTHENTICATION_PORTAL_URL;
	exports.MANAGER_FOR_EMPLOYEE_URL = MANAGER_FOR_EMPLOYEE_URL;
	exports.DELEGATIONS_URLS = DELEGATIONS_URLS;
	exports.SOLIDARITY_URLS = SOLIDARITY_URLS;
	exports.SOCIAL_SECURITY_URLS = SOCIAL_SECURITY_URLS;

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DEFAULT_USER = '0079340';
	
	exports.DEFAULT_USER = DEFAULT_USER;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cookieService = function () {
	  cookieService.$inject = ["$cookies"];
	  function cookieService($cookies) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, cookieService);
	    this.cookies = $cookies;
	  }
	
	  (0, _createClass3.default)(cookieService, [{
	    key: 'get',
	    value: function get(cookieName) {
	      return this.cookies.get(cookieName);
	    }
	  }, {
	    key: 'put',
	    value: function put(cookieName, value) {
	      return this.cookies.put(cookieName, value, { expires: this.getCookieExpireDate() });
	    }
	  }, {
	    key: 'getCookieExpireDate',
	    value: function getCookieExpireDate() {
	      var days = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
	
	      var date = new Date();
	      date.setDate(date.getDate() + days);
	      return date;
	    }
	  }]);
	  return cookieService;
	}();
	
	exports.default = cookieService;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccessTokenService = function () {
	  AccessTokenService.$inject = ["$cookies"];
	  function AccessTokenService($cookies) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AccessTokenService);
	    this.cookies = $cookies;
	  }
	
	  (0, _createClass3.default)(AccessTokenService, [{
	    key: 'getToken',
	    value: function getToken() {
	      return this.cookies.get('token');
	    }
	  }, {
	    key: 'setToken',
	    value: function setToken(token) {
	      this.cookies.put('token', token);
	    }
	  }, {
	    key: 'removeToken',
	    value: function removeToken() {
	      this.cookies.remove('token');
	    }
	  }]);
	  return AccessTokenService;
	}();
	
	exports.default = AccessTokenService;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(561);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _errorInterceptor = __webpack_require__(563);
	
	var _errorInterceptor2 = _interopRequireDefault(_errorInterceptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorInterceptorModule = _angular2.default.module('app.errorInterceptor', []).service('ErrorInterceptorService', _errorInterceptor2.default).factory('errorInterceptorInjector', ["$injector", "$q", "$log", function ($injector, $q, $log) {
	  'ngInject';
	
	  return {
	    responseError: function responseError(response) {
	      $log.info('errorInterceptorInjector: responseError ' + response.status);
	      $log.info('errorInterceptorInjector: response ' + (0, _stringify2.default)(response));
	      var ErrorInterceptorService = $injector.get('ErrorInterceptorService');
	      ErrorInterceptorService.manageError(response);
	      return $q.reject(response);
	    }
	  };
	}]).config(["$httpProvider", function ($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('errorInterceptorInjector');
	}]).name;
	
	exports.default = errorInterceptorModule;

/***/ }),
/* 561 */,
/* 562 */,
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(561);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(564);
	
	var _states = __webpack_require__(565);
	
	var _endpoints = __webpack_require__(556);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorInterceptorService = function () {
	  ErrorInterceptorService.$inject = ["$state", "$log", "$window", "AuthenticationService", "networkService"];
	  function ErrorInterceptorService($state, $log, $window, AuthenticationService, networkService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ErrorInterceptorService);
	    this.state = $state;
	    this.log = $log;
	    this.window = $window;
	    this.authenticationService = AuthenticationService;
	    this.networkService = networkService;
	  }
	
	  (0, _createClass3.default)(ErrorInterceptorService, [{
	    key: 'manageError',
	    value: function manageError(responseError) {
	      this.networkService.checkNetworkStatus();
	      this._checkRedirectLogin(responseError);
	    }
	  }, {
	    key: '_checkRedirectLogin',
	    value: function _checkRedirectLogin(responseError) {
	      var isStatusToRedirectLogin = responseError.status === _constants.CODE_ERRORS.FORBIDDEN;
	      var isAPIUrl = responseError.config.url.includes(("https://dev.autoservicios1.bbva.com/v01"));
	      var isNotUrlAuthentication = responseError.config.url !== _endpoints.AUTHENTICATION_URL;
	      var hasToRedirectLogin = isStatusToRedirectLogin && isAPIUrl && isNotUrlAuthentication;
	      var isUnAuthorized = responseError.status === _constants.CODE_ERRORS.UNAUTHORIZED;
	      if (hasToRedirectLogin || isUnAuthorized) {
	        this.authenticationService.redirectToLogin();
	        return;
	      }
	
	      this._checkRedirectError(responseError);
	    }
	  }, {
	    key: '_checkRedirectError',
	    value: function _checkRedirectError(responseError) {
	      var isAPIUrl = responseError.config.url.includes(("https://dev.autoservicios1.bbva.com/v01"));
	      var isHRInternalServerError = responseError.status === _constants.CODE_ERRORS.INTERNAL_SERVER_ERROR && responseError.data.errors === _constants.HR_ERRORS.HR_SERVER_RESPONSE_ERRROR_OFFLINE;
	      var isAngularCodeServerDownOrNoInternet = responseError.status === _constants.CODE_ERRORS.ANGULARJS_SERVER_DOWN_OR_NO_INTERNET && isAPIUrl;
	      var isBackInternalServerError = responseError.status === _constants.CODE_ERRORS.INTERNAL_SERVER_ERROR;
	      var hasToRedirectError = isHRInternalServerError || isAngularCodeServerDownOrNoInternet || isBackInternalServerError;
	
	      this.log.info('_checkRedirectError hasToRedirectError', hasToRedirectError, 'isHRInternalServerError', isHRInternalServerError, 'isAngularCodeServerDownOrNoInternet', isAngularCodeServerDownOrNoInternet, 'isBackInternalServerError', isBackInternalServerError);
	
	      if (hasToRedirectError) {
	        this.log.info('Error en el back con redirecci\xF3n a la p\xE1gina de error: ' + (0, _stringify2.default)(responseError));
	        this._redirectToError();
	      } else {
	        this.log.info('Error en el back sin redirecci\xF3n a la p\xE1gina de error: ' + (0, _stringify2.default)(responseError));
	      }
	    }
	  }, {
	    key: '_redirectToError',
	    value: function _redirectToError() {
	      this.state.go(_states.STATES.ERROR);
	      this.state.go = function () {};
	      var isNativeWebview = /BBVAAutoservicios/.test(this.window.navigator.userAgent);
	      if (!isNativeWebview) {
	        this.window.location.reload();
	      }
	    }
	  }]);
	  return ErrorInterceptorService;
	}();
	
	exports.default = ErrorInterceptorService;

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var HR_ERRORS = {
	  DEFAULT_VISIBLE_TEXT: '--',
	  NOT_AVAILABLE: 'not available yet',
	  NOT_EXISTS: 'not exist in HRA',
	  HR_SERVER_RESPONSE_ERRROR_OFFLINE: 404
	};
	
	var CODE_ERRORS = {
	  UNAUTHORIZED: 401,
	  FORBIDDEN: 403,
	  NOT_FOUND: 404,
	  INTERNAL_SERVER_ERROR: 500,
	  ANGULARJS_SERVER_DOWN_OR_NO_INTERNET: -1
	};
	
	var TIMEOUT = 'Connection timeout error';
	
	exports.HR_ERRORS = HR_ERRORS;
	exports.CODE_ERRORS = CODE_ERRORS;
	exports.TIMEOUT = TIMEOUT;

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var VACATIONS_ABSENCES_ROOT = 'vacations-absences';
	var LOANS_ROOT = 'loans';
	var FOOD_BENEFIT_ROOT = 'food-benefit';
	var SOLIDARITY_ROOT = 'solidarity';
	
	var STATES = {
	  MAIN_ROUTING: 'main',
	  MAINTENANCE: 'maintenance',
	  INDEX: 'index',
	  LOGIN: 'login',
	  ERROR: 'error',
	  AUTHENTICATION: 'authentication',
	  NOT_ALLOWED: 'not-allowed',
	
	  VACATIONS_ABSENCES: {
	    ROOT: VACATIONS_ABSENCES_ROOT,
	    EMPLOYEE_CALENDAR: VACATIONS_ABSENCES_ROOT + '.employee-calendar',
	    EMPLOYEE_CALENDAR_MOBILE: VACATIONS_ABSENCES_ROOT + '.employee-calendar-mobile',
	    MY_VACATIONS: VACATIONS_ABSENCES_ROOT + '.my-vacations',
	    MY_VACATIONS_MOBILE: VACATIONS_ABSENCES_ROOT + '.my-vacations-mobile',
	    TEAM_CALENDAR: VACATIONS_ABSENCES_ROOT + '.team-calendar',
	    TEAM_CALENDAR_MOBILE: VACATIONS_ABSENCES_ROOT + '.team-calendar-mobile',
	    TEAM_REQUESTS: VACATIONS_ABSENCES_ROOT + '.team-requests',
	    DELEGATE: VACATIONS_ABSENCES_ROOT + '.delegations',
	    PERIOD_LIST_MOBILE: VACATIONS_ABSENCES_ROOT + '.period-list-mobile',
	    SCHEDULE_MOBILE: VACATIONS_ABSENCES_ROOT + '.schedule-mobile'
	  },
	
	  LOANS: {
	    ROOT: LOANS_ROOT,
	    CREDITWORTHINESS: LOANS_ROOT + '.my-creditworthiness',
	    NEED_A_LOAN: LOANS_ROOT + '.need-a-loan',
	    NEED_A_LOAN_RESULTS: LOANS_ROOT + '.results',
	    LOANS_CATALOG: LOANS_ROOT + '.loans-catalog',
	    MY_LOANS: LOANS_ROOT + '.my-loans',
	    WAGE_ADVANCE: LOANS_ROOT + '.wage-advance',
	    DETAIL: LOANS_ROOT + '.detail',
	    SIGN_UP: LOANS_ROOT + '.sign-up',
	    REPAYMENT: LOANS_ROOT + '.repayment',
	    CADASTRAL_REFERENCE: LOANS_ROOT + '.cadastral-reference',
	    DETAILSADHESION: LOANS_ROOT + '.adhesion'
	  },
	
	  FOOD_BENEFIT: {
	    ROOT: FOOD_BENEFIT_ROOT,
	    MY_FOOD_BENEFIT: FOOD_BENEFIT_ROOT + '.my-food-benefit',
	    MANAGER: FOOD_BENEFIT_ROOT + '.food-benefit-manager',
	    DELEGATE: FOOD_BENEFIT_ROOT + '.delegations',
	    WORK_TEAM: FOOD_BENEFIT_ROOT + '.work-team'
	  },
	
	  SOLIDARITY: {
	    ROOT: SOLIDARITY_ROOT,
	    MY_SOLIDARITY: SOLIDARITY_ROOT + '.my-solidarity'
	  },
	
	  SOCIAL_SECURITY: 'social-security'
	};
	
	exports.STATES = STATES;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userData = __webpack_require__(567);
	
	var _userData2 = _interopRequireDefault(_userData);
	
	var _managerData = __webpack_require__(568);
	
	var _managerData2 = _interopRequireDefault(_managerData);
	
	var _autoservicesDictionary = __webpack_require__(569);
	
	var _autoservicesDictionary2 = _interopRequireDefault(_autoservicesDictionary);
	
	var _authentication = __webpack_require__(550);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _managerForEmployee = __webpack_require__(570);
	
	var _managerForEmployee2 = _interopRequireDefault(_managerForEmployee);
	
	var _delegations = __webpack_require__(572);
	
	var _delegations2 = _interopRequireDefault(_delegations);
	
	var _managerNavigation = __webpack_require__(574);
	
	var _managerNavigation2 = _interopRequireDefault(_managerNavigation);
	
	var _statusAppCheckers = __webpack_require__(575);
	
	var _statusAppCheckers2 = _interopRequireDefault(_statusAppCheckers);
	
	var _cookie = __webpack_require__(558);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _helperDelegations = __webpack_require__(577);
	
	var _helperDelegations2 = _interopRequireDefault(_helperDelegations);
	
	var _visitedStates = __webpack_require__(599);
	
	var _visitedStates2 = _interopRequireDefault(_visitedStates);
	
	var _visitedPages = __webpack_require__(600);
	
	var _visitedPages2 = _interopRequireDefault(_visitedPages);
	
	var _loadingMobile = __webpack_require__(601);
	
	var _loadingMobile2 = _interopRequireDefault(_loadingMobile);
	
	var _network = __webpack_require__(602);
	
	var _network2 = _interopRequireDefault(_network);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var serviceModule = _angular2.default.module('common.services', []).service('UserDataService', _userData2.default).service('ManagerDataService', _managerData2.default).service('AppDictionary', _autoservicesDictionary2.default).service('AuthenticationService', _authentication2.default).service('ManagerForEmployeeService', _managerForEmployee2.default).service('DelegationService', _delegations2.default).service('ManagerNavigationService', _managerNavigation2.default).service('StatusAppCheckers', _statusAppCheckers2.default).service('cookieService', _cookie2.default).service('HelperDelegationsService', _helperDelegations2.default).service('visitedStatesService', _visitedStates2.default).service('visitedPagesService', _visitedPages2.default).service('loadingMobileService', _loadingMobile2.default).service('networkService', _network2.default).name;
	
	exports.default = serviceModule;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserDataService = function () {
	  function UserDataService() {
	    (0, _classCallCheck3.default)(this, UserDataService);
	  }
	
	  (0, _createClass3.default)(UserDataService, [{
	    key: "setEmployee",
	    value: function setEmployee(employee) {
	      this._employee = employee;
	    }
	  }, {
	    key: "getEmployee",
	    value: function getEmployee() {
	      return this._employee;
	    }
	  }, {
	    key: "clean",
	    value: function clean() {
	      this._employee = undefined;
	    }
	  }, {
	    key: "isEmpty",
	    value: function isEmpty() {
	      return this._employee === undefined;
	    }
	  }]);
	  return UserDataService;
	}();
	
	exports.default = UserDataService;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManagerDataService = function () {
	  function ManagerDataService() {
	    (0, _classCallCheck3.default)(this, ManagerDataService);
	  }
	
	  (0, _createClass3.default)(ManagerDataService, [{
	    key: "setManager",
	    value: function setManager(manager) {
	      this._manager = manager;
	    }
	  }, {
	    key: "getManager",
	    value: function getManager() {
	      return this._manager;
	    }
	  }, {
	    key: "clean",
	    value: function clean() {
	      this._manager = undefined;
	    }
	  }, {
	    key: "isEmpty",
	    value: function isEmpty() {
	      return this._manager === undefined;
	    }
	  }]);
	  return ManagerDataService;
	}();
	
	exports.default = ManagerDataService;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HolidayTypesService = function () {
	  function HolidayTypesService() {
	    (0, _classCallCheck3.default)(this, HolidayTypesService);
	
	    this.HOLIDAY = 'holiday';
	    this.VACATION = 'vacation';
	    this.ABSENCE = 'absence';
	    this.APPROVED = 'approved';
	    this.REQUESTED = 'requested';
	  }
	
	  (0, _createClass3.default)(HolidayTypesService, [{
	    key: 'getHoliday',
	    value: function getHoliday() {
	      return this.HOLIDAY;
	    }
	  }, {
	    key: 'getVacation',
	    value: function getVacation() {
	      return this.VACATION;
	    }
	  }, {
	    key: 'getAbsence',
	    value: function getAbsence() {
	      return this.ABSENCE;
	    }
	  }, {
	    key: 'getApproved',
	    value: function getApproved() {
	      return this.APPROVED;
	    }
	  }, {
	    key: 'getRequested',
	    value: function getRequested() {
	      return this.REQUESTED;
	    }
	  }]);
	  return HolidayTypesService;
	}();
	
	exports.default = HolidayTypesService;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _managerForEmployee = __webpack_require__(571);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManagerForEmployeeService = function () {
	  ManagerForEmployeeService.$inject = ["$http"];
	  function ManagerForEmployeeService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ManagerForEmployeeService);
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(ManagerForEmployeeService, [{
	    key: 'getManagerForEmployee',
	    value: function getManagerForEmployee(employeeId) {
	      return this.http.get(_managerForEmployee.ENDPOINTS_MANAGER_FOR_EMPLOYEE.get.managerForEmployee(employeeId)).then(function (response) {
	        return response.data;
	      });
	    }
	  }]);
	  return ManagerForEmployeeService;
	}();
	
	exports.default = ManagerForEmployeeService;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ENDPOINTS_MANAGER_FOR_EMPLOYEE = undefined;
	
	var _endpoints = __webpack_require__(556);
	
	var API_URL = ("https://dev.autoservicios1.bbva.com/v01");
	var MANAGER_FOR_EMPLOYEE = API_URL + '/' + _endpoints.MANAGER_FOR_EMPLOYEE_URL.ROOT_MANAGER_FOR_EMPLOYEE;
	
	var ENDPOINTS_MANAGER_FOR_EMPLOYEE = {
	  get: {
	    managerForEmployee: function managerForEmployee(employeeId) {
	      return MANAGER_FOR_EMPLOYEE + '/' + employeeId;
	    }
	  }
	};
	
	exports.ENDPOINTS_MANAGER_FOR_EMPLOYEE = ENDPOINTS_MANAGER_FOR_EMPLOYEE;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _delegations = __webpack_require__(573);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DelegationService = function () {
	  DelegationService.$inject = ["$http"];
	  function DelegationService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DelegationService);
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(DelegationService, [{
	    key: 'getDelegations',
	    value: function getDelegations(employeeId, service) {
	      var config = {
	        params: {
	          service: service
	        }
	      };
	      return this.http.get(_delegations.ENDPOINTS_DELEGATIONS.get.delegations(employeeId), config);
	    }
	  }, {
	    key: 'getDelegableEmployees',
	    value: function getDelegableEmployees(nameToSearch, employee) {
	      return this.http.get(_delegations.ENDPOINTS_DELEGATIONS.get.delegableEmployees(employee), {
	        params: {
	          employeeName: nameToSearch
	        }
	      });
	    }
	  }, {
	    key: 'cancelDelegation',
	    value: function cancelDelegation(employeeId, delegationToDelete) {
	      var config = {
	        data: delegationToDelete
	      };
	      return this.http.delete(_delegations.ENDPOINTS_DELEGATIONS.delete.delegations(employeeId), config);
	    }
	  }, {
	    key: 'updateDelegations',
	    value: function updateDelegations(employeeId, delegationToUpdate) {
	      return this.http.put(_delegations.ENDPOINTS_DELEGATIONS.put.delegations(employeeId), delegationToUpdate);
	    }
	  }, {
	    key: 'createDelegations',
	    value: function createDelegations(employeeId, delegationToCreate) {
	      return this.http.post(_delegations.ENDPOINTS_DELEGATIONS.post.delegations(employeeId), delegationToCreate);
	    }
	  }]);
	  return DelegationService;
	}();
	
	exports.default = DelegationService;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ENDPOINTS_DELEGATIONS = undefined;
	
	var _endpoints = __webpack_require__(556);
	
	var API_URL = ("https://dev.autoservicios1.bbva.com/v01");
	
	var ENDPOINTS_DELEGATIONS = {
	  get: {
	    delegations: function delegations(employeeId) {
	      return API_URL + '/' + _endpoints.DELEGATIONS_URLS.ROOT + '/' + employeeId;
	    },
	    delegableEmployees: function delegableEmployees(employeeId) {
	      return API_URL + '/' + _endpoints.DELEGATIONS_URLS.DELEGABLE_EMPLOYEES + '/' + employeeId;
	    }
	  },
	  post: {
	    delegations: function delegations(employeeId) {
	      return API_URL + '/' + _endpoints.DELEGATIONS_URLS.ROOT + '/' + employeeId;
	    }
	  },
	  put: {
	    delegations: function delegations(employeeId) {
	      return API_URL + '/' + _endpoints.DELEGATIONS_URLS.ROOT + '/' + employeeId;
	    }
	  },
	  delete: {
	    delegations: function delegations(employeeId) {
	      return API_URL + '/' + _endpoints.DELEGATIONS_URLS.ROOT + '/' + employeeId;
	    }
	  }
	};
	
	exports.ENDPOINTS_DELEGATIONS = ENDPOINTS_DELEGATIONS;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManagerNavigation = function () {
	  ManagerNavigation.$inject = ["$http", "$state"];
	  function ManagerNavigation($http, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ManagerNavigation);
	    this.http = $http;
	    this.state = $state;
	  }
	
	  (0, _createClass3.default)(ManagerNavigation, [{
	    key: 'canNavigateToState',
	    value: function canNavigateToState(isManager) {
	      var requiresManager = this.state.current.data.requiresManager;
	      if (requiresManager && !isManager) this.state.go(_states.STATES.NOT_ALLOWED);
	    }
	  }]);
	  return ManagerNavigation;
	}();
	
	exports.default = ManagerNavigation;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _loans = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: [Manu] Change this to close a module, until the client approves to call a http service instead.
	var MODULE_CLOSED = {
	  vacationsAbsences: false,
	  foodBenefit: false,
	  loans: false,
	  wageAdvance: false,
	  solidarityEuro: false
	};
	
	var StatusAppCheckers = function () {
	  StatusAppCheckers.$inject = ["$http", "$q"];
	  function StatusAppCheckers($http, $q) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, StatusAppCheckers);
	    this.http = $http;
	    this.q = $q;
	  }
	
	  (0, _createClass3.default)(StatusAppCheckers, [{
	    key: '_getLoansStatus',
	    value: function _getLoansStatus() {
	      var _this = this;
	
	      if (this.cacheLoansStatus !== undefined) {
	        var deferred = this.q.defer();
	        deferred.resolve(this.cacheLoansStatus);
	        return deferred.promise;
	      }
	
	      return this.http.get(_loans.ENDPOINTS_LOANS.get.serviceClosed()).then(function (response) {
	        _this.cacheLoansStatus = response.data;
	        return response.data;
	      });
	    }
	  }, {
	    key: 'isWageInProcess',
	    value: function isWageInProcess() {
	      return this._getLoansStatus().then(function (status) {
	        return status.payrollUpdate;
	      });
	    }
	  }, {
	    key: 'isServiceClosed',
	    value: function isServiceClosed() {
	      return this._getLoansStatus().then(function (status) {
	        return status.serviceClosed;
	      });
	    }
	  }, {
	    key: 'getClosedModules',
	    value: function getClosedModules() {
	      return this._getLoansStatus().then(function (response) {
	        if (true) {
	          response.isFoodBenefitClosed = MODULE_CLOSED.foodBenefit;
	          response.isVacationsAbsencesClosed = MODULE_CLOSED.vacationsAbsences;
	          response.isWageAdvanceClosed = MODULE_CLOSED.wageAdvance;
	          response.isSolidarityEuroClosed = MODULE_CLOSED.solidarityEuro;
	          response.isLoansClosed = MODULE_CLOSED.loans;
	        }
	        return response;
	      });
	    }
	  }]);
	  return StatusAppCheckers;
	}();
	
	exports.default = StatusAppCheckers;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ENDPOINTS_LOANS = undefined;
	
	var _endpoints = __webpack_require__(556);
	
	var API_URL = ("https://dev.autoservicios1.bbva.com/v01");
	
	var ENDPOINTS_LOANS = {
	  get: {
	    serviceClosed: function serviceClosed() {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.SERVICE_CLOSED;
	    },
	    creditworthiness: function creditworthiness(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + employeeId + '/' + _endpoints.LOANS_URLS.CREDITWORTHINESS_ROOT;
	    },
	    modalities: function modalities(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + employeeId + '/' + _endpoints.LOANS_URLS.MODALITIES_ROOT;
	    },
	    myLoans: function myLoans(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + employeeId + '/' + _endpoints.LOANS_URLS.MY_LOANS_ROOT;
	    },
	    familiesNeedALoan: function familiesNeedALoan() {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.FAMILIES;
	    },
	    dataEuribor: function dataEuribor() {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.EURIBOR;
	    },
	    dataSV: function dataSV() {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.FIXED_SV;
	    },
	    dataVC: function dataVC() {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.FIXED_VC;
	    },
	    wageAdvanceReasonsList: function wageAdvanceReasonsList() {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.WAGE_ADVANCE_REASONS_LIST;
	    },
	    employeeWagesAdvance: function employeeWagesAdvance(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.WAGE_ADVANCE_EMPLOYEE + '/' + employeeId + '/list';
	    }
	  },
	  post: {
	    createLoan: function createLoan(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + employeeId + '/' + _endpoints.LOANS_URLS.SIGN_UP_ROOT;
	    },
	    createPartialRepayment: function createPartialRepayment(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.REPAYMENT_ROOT + '/partial/' + employeeId;
	    },
	    simulateRepayment: function simulateRepayment(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.REPAYMENT_ROOT + '/simulate/' + employeeId;
	    },
	    createTotalRepayment: function createTotalRepayment(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.REPAYMENT_ROOT + '/total/' + employeeId;
	    },
	    createSimulation: function createSimulation(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + employeeId + '/' + _endpoints.LOANS_URLS.SIMULATION_ROOT;
	    },
	    createWageAdvance: function createWageAdvance(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.WAGE_ADVANCE_EMPLOYEE + '/' + employeeId;
	    },
	    requestNovation: function requestNovation(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + employeeId + '/' + _endpoints.LOANS_URLS.SIGN_UP;
	    }
	  },
	  put: {
	    modifyCadastralReference: function modifyCadastralReference(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + employeeId + '/' + _endpoints.LOANS_URLS.CADASTRAL_REFERENCE;
	    }
	  },
	  delete: {
	    amortization: function amortization(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.REPAYMENT_ROOT + '/' + employeeId;
	    },
	    deleteWageAdvance: function deleteWageAdvance(employeeId) {
	      return API_URL + '/' + _endpoints.LOANS_URLS.ROOT + '/' + _endpoints.LOANS_URLS.WAGE_ADVANCE_EMPLOYEE + '/' + employeeId;
	    }
	  }
	};
	
	exports.ENDPOINTS_LOANS = ENDPOINTS_LOANS;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelperDelegationsService = function () {
	  HelperDelegationsService.$inject = ["$rootScope", "$q", "$transitions"];
	  function HelperDelegationsService($rootScope, $q, $transitions) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, HelperDelegationsService);
	    this.rootScope = $rootScope;
	    this.q = $q;
	    this.transitions = $transitions;
	    this.visited = {};
	  }
	
	  (0, _createClass3.default)(HelperDelegationsService, [{
	    key: 'isDelegationEmpty',
	    value: function isDelegationEmpty(delegation) {
	      return (0, _keys2.default)(delegation).length === 0;
	    }
	  }, {
	    key: 'setVisitedDelegation',
	    value: function setVisitedDelegation(employeeId, typeEmployee) {
	      var employeeHash = this._getEmployeeHash(employeeId, typeEmployee);
	      this.visited[employeeHash] = true;
	    }
	  }, {
	    key: 'getVisitDelegation',
	    value: function getVisitDelegation(employeeId, typeEmployee) {
	      var employeeHash = this._getEmployeeHash(employeeId, typeEmployee);
	      return this.visited[employeeHash] === true;
	    }
	  }, {
	    key: '_getEmployeeHash',
	    value: function _getEmployeeHash(employeeId, typeEmployee) {
	      return '' + typeEmployee + employeeId;
	    }
	  }, {
	    key: 'sendEventToChangeIconDelegations',
	    value: function sendEventToChangeIconDelegations() {
	      this.rootScope.$broadcast(_constants.EVENTS.ICON_DELEGATIONS, {});
	    }
	  }, {
	    key: 'onSearchEmployeeDelegations',
	    value: function onSearchEmployeeDelegations(employees) {
	      var deferred = this.q.defer();
	      deferred.resolve(employees);
	      return deferred.promise;
	    }
	  }]);
	  return HelperDelegationsService;
	}();
	
	exports.default = HelperDelegationsService;

/***/ }),
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STATUS_CODE_OK = 200;
	
	var PAGE_ERROR = {
	  ERROR: 'error',
	  CLOSED: 'closed',
	  LOANS_CLOSED_TO_USER_WITHOUT_CREDITWORTHINESS: 'loansClosedToUserWithoutCreditWorthiness'
	};
	
	var CODES = {
	  ACCIDENT: 'ANL',
	  DISPLACEMENT_CHILD_BIRTH: 'CP4',
	  DISPLACEMENT_DEATH_SPOUSE: 'CP2',
	  DISPLACEMENT_DEATH_CHILD: 'CQ2',
	  DISPLACEMENT_DEATH_FAMILY: 'CM2'
	};
	
	var SICKNESS = {
	  CATALOGATION: '001',
	  CODES: [CODES.ACCIDENT, 'ENF', 'ANL']
	};
	
	var DISPLACEMENT = {
	  CODES: [CODES.DISPLACEMENT_DEATH_CHILD, CODES.DISPLACEMENT_DEATH_SPOUSE, CODES.DISPLACEMENT_CHILD_BIRTH, CODES.DISPLACEMENT_DEATH_FAMILY]
	};
	
	var MODALS = {
	  REQUEST: '#modalRequest',
	  VACATION: '#modalCalendarGrid',
	  WARNING_REQUEST_VACATION: '#warningRequestVacation',
	  COACHMARK: '#modalCoachmark',
	  TEAM_REQUESTS: {
	    APPROVE_ALL: '#modalTeamRequestsApproveAll',
	    APPROVE: '#modalTeamRequestApprove',
	    REMOVE: '#modalTeamRequestRemove'
	  },
	  REMOVE_PERIOD: '#modalRemovePeriod',
	  CALENDAR_GRID: '#modalCalendarGrid',
	  SIGN_UP: '#modalSignUp',
	  LOANS_CONFIRMATION_SIGN_UP: '#loansConfirmationSignUpModal',
	  MANDATORY_INSURANCE: '#modalMandatoryInsurance',
	  BENEFIT_REQUEST: '#modalBenefitRequest',
	  BENEFIT_REQUEST_LIST: '#modalRequestList',
	  BENEFIT_DELEGATED_REQUEST_LIST: '#modalDelegatedRequestList',
	  LOANS_REPAYMENT: '#modalLoansRepayment',
	  MY_LOANS: '#modalMyLoans',
	  REQUEST_CADASTRAL: '#modalRequestCadastral',
	  QUESTION_CADASTRAL: '#modalQuestionCadastral',
	  DELEGATIONS_MANAGER: '#modalDelegationManager',
	  WARNING_DELEGATION_MODAL: '#modalWarningDelegation',
	  NEED_A_LOAN: '#modalNeedALoan',
	  CANNOT_SIGNUP: '#modalCannotSignup',
	  WAGE_ADVANCE_MODAL: '#wageAdvanceModal',
	  SOLIDARITY_REQUEST_MODAL: '#solidarityRequestModal',
	  AUTHENTICATION_ERROR_MODAL: '#authenticationErrorModal',
	  SOCIAL_SECURITY_MODAL: '#socialSecurityModal',
	  DEV_CHANGE_EMPLOYEE_MOBILE: '#devChangeEmployeeMobile',
	  DELEGATED_REQUEST_MODAL: '#modalDelegatedRequest'
	};
	
	var ANSWERS = {
	  YES: 'yes',
	  NO: 'no'
	};
	
	var MODES = {
	  CREATE: 'create',
	  EDIT: 'edit'
	};
	
	var EVENTS = {
	  CONTEXT_MENU_REMOVE: 'CONTEXTMENU_REMOVE_PERIOD',
	  REQUEST_DAY_CLICK: 'REQUEST_DAY_CLICK',
	  CALENDAR_INLINE_CHANGE_DATE: 'CALENDAR_INLINE_CHANGE_DATE',
	  ADD_PERIOD: 'add-period',
	  FILTER_PERIOD: 'filter-period',
	  ICON_DELEGATIONS: 'icon-delegations',
	  CHANGE_TITLE: 'change-title',
	  BADGE_NUMBER: 'badge-number',
	  REFRESH_ON_FOOD_BENEFIT_MANAGER: 'refresh-on-food-benefit-manager',
	  LOANS_AMOUNT_SIMULATION_REFRESH_ERRORS: 'loans-amount-simulation-refresh-errors',
	  WITHOUT_LOANS_ACCESS: 'withoutloansAccess',
	  BUTTON_SICK_LEAVE_REPORTS_DISABLED: 'button-sick-leave-reports-disabled',
	  REFRESH_EMPLOYEE: 'refresh-employee'
	};
	
	var VACATIONS_ABSENCES_ROOT = 'vacations-absences';
	
	var MANAGER_MAINNAVBAR_STATES = {
	  ROOT: VACATIONS_ABSENCES_ROOT,
	  EMPLOYEE_CALENDAR: VACATIONS_ABSENCES_ROOT + '.employee-calendar',
	  MY_VACATIONS: VACATIONS_ABSENCES_ROOT + '.my-vacations',
	  TEAM_CALENDAR: VACATIONS_ABSENCES_ROOT + '.team-calendar',
	  TEAM_REQUESTS: VACATIONS_ABSENCES_ROOT + '.team-requests',
	  DELEGATE: VACATIONS_ABSENCES_ROOT + '.delegations'
	};
	
	var HOLIDAY_SUMMARY_VISIBILITY_STATES = [MANAGER_MAINNAVBAR_STATES.MY_VACATIONS, MANAGER_MAINNAVBAR_STATES.EMPLOYEE_CALENDAR];
	
	var EMPLOYEE_AFK_VISIBILITY_STATES = [MANAGER_MAINNAVBAR_STATES.TEAM_REQUESTS, MANAGER_MAINNAVBAR_STATES.TEAM_CALENDAR, MANAGER_MAINNAVBAR_STATES.DELEGATE];
	
	var MAX_PERIODS = 4;
	
	var COOKIES = {
	  COACHMARK: 'dontshowcoachmark'
	};
	
	var CONTEXT_MENU_TAG = 'calendar-context-menu';
	
	var VALIDATION_ERRORS = {
	  SICK_LEAVE_REPORTS: {
	    INVALID_ORDER: 'sickLeaveReportsInvalidOrder',
	    INVALID_DATE: 'sickLeaveReportsInvalidDate'
	  }
	};
	
	var FOOD_BENEFIT_STATES = {
	  initial: '',
	  success: 'success',
	  error: 'error',
	  requested: 'requested',
	  approved: 'approved',
	  approve: 'approve',
	  modified: 'modified'
	};
	
	var VACATIONS_ABSENCES_STATES = {
	  requested: 'requested',
	  approved: 'approved'
	};
	
	var VACATION = 'vacation';
	
	var CALENDAR_LAST_YEAR_PAGINATION_ALLOWED = 2017;
	
	var ABSENCE = 'absence';
	
	var DELEGATION_STATES = {
	  CREATE: 'create',
	  CANCEL: 'cancel',
	  EDIT: 'edit',
	  SUCCESS: 'success',
	  ERROR: 'error'
	};
	
	var CURRENCIES = {
	  EURO: '€'
	};
	
	var CURRENCY = CURRENCIES.EURO;
	
	var USEROLES = {
	  MANAGER: 'manager',
	  USER: 'usuario'
	};
	
	var SWITCHOPTIONS = {
	  USER: 'user',
	  MANAGER: 'manager'
	};
	
	var DELEGATIONS_SWITCH_CONFIG = [{
	  text: 'GLOBALS.AS_USER',
	  value: 'user'
	}, {
	  text: 'GLOBALS.AS_MANAGER',
	  value: 'manager'
	}];
	
	var VISITED_PAGES_VALUES = {
	  INDEX_INIT_PAGE: 2,
	  VALUE_TO_ADD: 1,
	  VALUE_TO_SUBTRACT: 2 //When we back on the app, it adds 1 because the route changes and the "app.run" method is executed too.
	};
	
	var ENVIRONMENTS = {
	  dev: 'desarrollo',
	  pre: 'preproducción',
	  pro: 'producción'
	};
	
	var JANUARY_INDEX = 0;
	var NOVEMBER_INDEX = 10;
	var DECEMBER_INDEX = 11;
	
	exports.STATUS_CODE_OK = STATUS_CODE_OK;
	exports.CODES = CODES;
	exports.SICKNESS = SICKNESS;
	exports.MODALS = MODALS;
	exports.ANSWERS = ANSWERS;
	exports.MODES = MODES;
	exports.EVENTS = EVENTS;
	exports.MANAGER_MAINNAVBAR_STATES = MANAGER_MAINNAVBAR_STATES;
	exports.HOLIDAY_SUMMARY_VISIBILITY_STATES = HOLIDAY_SUMMARY_VISIBILITY_STATES;
	exports.EMPLOYEE_AFK_VISIBILITY_STATES = EMPLOYEE_AFK_VISIBILITY_STATES;
	exports.MAX_PERIODS = MAX_PERIODS;
	exports.COOKIES = COOKIES;
	exports.CONTEXT_MENU_TAG = CONTEXT_MENU_TAG;
	exports.VALIDATION_ERRORS = VALIDATION_ERRORS;
	exports.DISPLACEMENT = DISPLACEMENT;
	exports.FOOD_BENEFIT_STATES = FOOD_BENEFIT_STATES;
	exports.CURRENCIES = CURRENCIES;
	exports.CURRENCY = CURRENCY;
	exports.DELEGATION_STATES = DELEGATION_STATES;
	exports.USEROLES = USEROLES;
	exports.SWITCHOPTIONS = SWITCHOPTIONS;
	exports.DELEGATIONS_SWITCH_CONFIG = DELEGATIONS_SWITCH_CONFIG;
	exports.VISITED_PAGES_VALUES = VISITED_PAGES_VALUES;
	exports.PAGE_ERROR = PAGE_ERROR;
	exports.ENVIRONMENTS = ENVIRONMENTS;
	exports.VACATIONS_ABSENCES_STATES = VACATIONS_ABSENCES_STATES;
	exports.VACATION = VACATION;
	exports.ABSENCE = ABSENCE;
	exports.CALENDAR_LAST_YEAR_PAGINATION_ALLOWED = CALENDAR_LAST_YEAR_PAGINATION_ALLOWED;
	exports.JANUARY_INDEX = JANUARY_INDEX;
	exports.NOVEMBER_INDEX = NOVEMBER_INDEX;
	exports.DECEMBER_INDEX = DECEMBER_INDEX;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VisitedStatesService = function () {
	  VisitedStatesService.$inject = ["$transitions"];
	  function VisitedStatesService($transitions) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, VisitedStatesService);
	    this.transitions = $transitions;
	    this.start();
	  }
	
	  (0, _createClass3.default)(VisitedStatesService, [{
	    key: 'start',
	    value: function start() {
	      this.visited = {};
	      this.registerOnBeforeTo('my-vacations');
	    }
	  }, {
	    key: 'registerOnBeforeTo',
	    value: function registerOnBeforeTo(stateName) {
	      var _this = this;
	
	      var state = { to: stateName };
	      this.transitions.onBefore(state, function () {
	        return _this.setVisited(stateName);
	      });
	    }
	  }, {
	    key: 'setVisited',
	    value: function setVisited(stateName) {
	      this.visited[stateName] = true;
	    }
	  }, {
	    key: 'stateVisited',
	    value: function stateVisited(stateName) {
	      return this.visited[stateName] === true;
	    }
	  }]);
	  return VisitedStatesService;
	}();
	
	exports.default = VisitedStatesService;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var visitedPagesService = function () {
	  function visitedPagesService() {
	    (0, _classCallCheck3.default)(this, visitedPagesService);
	
	    this.counterVisitedPages = 0;
	  }
	
	  (0, _createClass3.default)(visitedPagesService, [{
	    key: 'getCounterVisitedPages',
	    value: function getCounterVisitedPages() {
	      return this.counterVisitedPages;
	    }
	  }, {
	    key: 'shouldExitApp',
	    value: function shouldExitApp() {
	      return this.counterVisitedPages <= _constants.VISITED_PAGES_VALUES.INDEX_INIT_PAGE;
	    }
	  }, {
	    key: 'addPageToCounter',
	    value: function addPageToCounter() {
	      this.counterVisitedPages += _constants.VISITED_PAGES_VALUES.VALUE_TO_ADD;
	    }
	  }, {
	    key: 'subtractPageToCounter',
	    value: function subtractPageToCounter() {
	      this.counterVisitedPages -= _constants.VISITED_PAGES_VALUES.VALUE_TO_SUBTRACT;
	    }
	  }]);
	  return visitedPagesService;
	}();
	
	exports.default = visitedPagesService;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SPINNER_ID = 'mobile-spinner-overlay';
	
	var loadingMobileService =
	
	/**
	 * @name loadingMobileService
	 * @module common.services
	 * @description
	 * A wrapper for a loading dialog.
	* By default it does nothing, but in mobile flows it can show a web overlay spinner.
	 *
	 * @usage
	 * ```js
	 * //show a loading dialog
	 * loadingMobileService.show();
	 * this.loansOperationsService.getCreditworthiness(this.userId).then(creditworthiness => {
	 *   //do whatever you want
	 * }, error => {
	 *   //do whatever you want
	 * }).finally(()=> {
	 * //when everything is done, hide the loading dialog
	 *   this.loadingMobileService.hide();
	 * });
	 * ```
	 */
	function loadingMobileService() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, loadingMobileService);
	  this.show = function () {};
	  this.hide = function () {};
	
	  this.show = function () {
	    if (document.getElementById(SPINNER_ID)) return;
	    var overlay = document.createElement('div');
	    overlay.id = SPINNER_ID;
	    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);display:flex;align-items:center;justify-content:center;z-index:99999';
	    overlay.innerHTML = '<div style="width:48px;height:48px;border:5px solid #fff;border-top-color:transparent;border-radius:50%;animation:spin 0.8s linear infinite"></div><style>@keyframes spin{to{transform:rotate(360deg)}}</style>';
	    document.body.appendChild(overlay);
	  };
	  this.hide = function () {
	    var overlay = document.getElementById(SPINNER_ID);
	    if (overlay) overlay.parentNode.removeChild(overlay);
	  };
	};
	
	exports.default = loadingMobileService;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetworkService = function () {
	  NetworkService.$inject = ["$window", "$state", "$translate", "$q"];
	  function NetworkService($window, $state, $translate, $q) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, NetworkService);
	    this.window = $window;
	    this.state = $state;
	    this.translate = $translate;
	    this.isOffline = false;
	    this.q = $q;
	    this.translate('GLOBALS.NETWORK_ERROR').then(function (translation) {
	      return _this.message = translation;
	    });
	  }
	
	  (0, _createClass3.default)(NetworkService, [{
	    key: 'run',
	    value: function run() {
	      var _this2 = this;
	
	      this.window.addEventListener('online', function () {
	        return _this2.online();
	      });
	      this.window.addEventListener('offline', function () {
	        return _this2.offline();
	      });
	
	      if (this.window.navigator && this.window.navigator.onLine === false) {
	        this.offline();
	      }
	    }
	  }, {
	    key: 'networkInformationPluginAvailable',
	    value: function networkInformationPluginAvailable() {
	      return !!(this.window && this.window.navigator);
	    }
	  }, {
	    key: 'offline',
	    value: function offline() {
	      this.isOffline = true;
	    }
	  }, {
	    key: 'checkNetworkStatus',
	    value: function checkNetworkStatus() {
	      if (this.isOffline) {
	        this.state.go(_states.STATES.ERROR, { errorMessage: this.message });
	      }
	    }
	  }, {
	    key: 'online',
	    value: function online() {
	      if (this.isOffline) {
	        this.isOffline = false;
	        this.window.history.back();
	      }
	    }
	  }]);
	  return NetworkService;
	}();
	
	exports.default = NetworkService;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _capitalizeFirst = __webpack_require__(604);
	
	var _capitalizeFirst2 = _interopRequireDefault(_capitalizeFirst);
	
	var _slashDate = __webpack_require__(605);
	
	var _slashDate2 = _interopRequireDefault(_slashDate);
	
	var _employee = __webpack_require__(606);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	var _lpadAuto = __webpack_require__(607);
	
	var _lpadAuto2 = _interopRequireDefault(_lpadAuto);
	
	var _lpad = __webpack_require__(608);
	
	var _lpad2 = _interopRequireDefault(_lpad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filtersModule = angular.module('common.filters', []).filter('capitalizeFirst', _capitalizeFirst2.default).filter('slashDate', _slashDate2.default).filter('employeeFilter', _employee2.default).filter('lpadAuto', _lpadAuto2.default).filter('lpad', _lpad2.default).name;
	
	exports.default = filtersModule;

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return function (string) {
	    return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : '';
	  };
	};

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return function (date) {
	    if (!date) {
	      return '';
	    }
	
	    if (typeof date === 'string') {
	      var parts = date.split('-');
	      return [parts[2], parts[1], parts[0]].join('/');
	    }
	
	    if (Object.prototype.toString.call(date) === '[object Date]') {
	      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
	      var year = date.getFullYear();
	      return day + '/' + month + '/' + year;
	    }
	
	    return '';
	  };
	};

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return function (items, selectedEmployees) {
	    if (!selectedEmployees || selectedEmployees.length === 0) {
	      return items;
	    }
	
	    if (selectedEmployees[0].userId !== undefined) {
	      return items.filter(function (item) {
	        var userIdMatch = selectedEmployees.some(function (employee) {
	          return item.employeeId === employee.userId;
	        });
	        return userIdMatch;
	      });
	    }
	
	    return items.filter(function (item) {
	      var userIdMatch = selectedEmployees.some(function (employee) {
	        return item.employeeId === employee.employeeId;
	      });
	      return userIdMatch;
	    });
	  };
	};

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return function (input) {
	    if (parseInt(input) < 10) {
	      return '0' + input;
	    }
	    return input.toString();
	  };
	};

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return function (string, length, padString) {
	    var DEFAULT_LENGTH = 2;
	    var DEFAULT_PADSTRING = '0';
	    length = length || DEFAULT_LENGTH;
	    padString = padString || DEFAULT_PADSTRING;
	    var pad = Array(length + 1).join(padString);
	    return (pad + string).slice(-length);
	  };
	};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _currencyInput = __webpack_require__(610);
	
	var _currencyInput2 = _interopRequireDefault(_currencyInput);
	
	var _pullToRefresh = __webpack_require__(611);
	
	var _pullToRefresh2 = _interopRequireDefault(_pullToRefresh);
	
	var _focusPositionEnd = __webpack_require__(615);
	
	var _focusPositionEnd2 = _interopRequireDefault(_focusPositionEnd);
	
	var _onLongPress = __webpack_require__(616);
	
	var _onLongPress2 = _interopRequireDefault(_onLongPress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var directivesModule = angular.module('common.directives', []).directive('currencyInput', ['$filter', _currencyInput2.default]).directive('pullToRefresh', ['$q', '$translate', '$timeout', _pullToRefresh2.default]).directive('focusPositionEnd', ['$timeout', _focusPositionEnd2.default]).directive('onLongPress', ['$timeout', _onLongPress2.default]).name;
	
	exports.default = directivesModule;

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($filter) {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	
	    link: function link(scope, elem, attrs, ngModel) {
	
	      // Focus event
	
	      elem.on('focus', onFocus);
	
	      function onFocus() {
	        var currentVal = elem.val();
	
	        if (currentVal === EMPTY) {
	          return elem.val('');
	        }
	
	        var newVal = currentVal.replace(/\./g, '').replace('€', '');
	        elem.val(newVal);
	      }
	
	      // Blur and paste events
	
	      elem.on('blur paste', function () {
	        return setViewValue();
	      });
	
	      function setViewValue(previousVal) {
	        var val = elem.val();
	
	        if (previousVal) {
	          val = previousVal.toString();
	        }
	
	        val = val.trim();
	        val = removeValuesAfterCurrency(val);
	        val = getNumberFromVal(val);
	        val = $filter('currency')(val);
	        elem.val(val);
	        return val;
	      }
	
	      // Formatter
	
	      ngModel.$formatters.push(formatter);
	
	      function formatter(val) {
	        if (val > 0) {
	          return setViewValue(val);
	        }
	
	        return attrs.placeholder ? '' : setViewValue(val);
	      }
	
	      // Parser
	
	      ngModel.$parsers.push(parser);
	
	      function parser(val) {
	        val = val.trim();
	        val = removeValuesAfterCurrency(val);
	        val = getNumberFromVal(val);
	        val = parseFloat(val, 10);
	        val = isNaN(val) ? 0 : val;
	        return val;
	      }
	
	      // Helpers
	
	      function getNumberFromVal(val) {
	        return removeLetters(val).replace(/€/g, '').replace(/\./g, '').replace(/\,/, '.').replace(/,/g, '');
	      }
	
	      function removeLetters(val) {
	        var preserve = /[^\d|\-+|,|\.|+]/g;
	        return val.replace(preserve, '');
	      }
	
	      function removeValuesAfterCurrency(val) {
	        if (val.charAt(val.lenght - 1) !== CURRENCY) {
	          return val.split(CURRENCY)[0];
	        } else {
	          return val;
	        }
	      }
	    }
	  };
	};
	
	var CURRENCY = '€';
	var EMPTY = '0,00 €';

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($q, $translate, $timeout) {
	  var pullToRefresh = __webpack_require__(612);
	
	  return {
	    restrict: 'A',
	
	    scope: { pullToRefresh: '&' },
	
	    link: function link(scope, elem) {
	      var refresher = void 0;
	      var instructionsPullToRefresh = void 0;
	      var instructionsReleaseToRefresh = void 0;
	      var instructionsRefreshing = void 0;
	
	      initLiterals(init);
	
	      scope.$on('$destroy', function () {
	        refresher.destroy();
	      });
	
	      function initLiterals(cb) {
	        $q.all([$translate('GLOBALS.PULL_TO_REFRESH.FIRST').then(function (translation) {
	          return instructionsPullToRefresh = translation;
	        }), $translate('GLOBALS.PULL_TO_REFRESH.SECOND').then(function (translation) {
	          return instructionsReleaseToRefresh = translation;
	        }), $translate('GLOBALS.PULL_TO_REFRESH.THIRD').then(function (translation) {
	          return instructionsRefreshing = translation;
	        })]).then(function () {
	          cb();
	        });
	      }
	
	      function init() {
	        refresher = pullToRefresh.init({
	          mainElement: elem[0],
	          onRefresh: function onRefresh() {
	            return $timeout(function () {
	              return scope.pullToRefresh();
	            });
	          },
	          shouldPullToRefresh: shouldPullToRefresh,
	          distThreshold: 50,
	          instructionsPullToRefresh: instructionsPullToRefresh,
	          instructionsReleaseToRefresh: instructionsReleaseToRefresh,
	          instructionsRefreshing: instructionsRefreshing
	        });
	      }
	
	      function shouldPullToRefresh() {
	        return isOnTop() && !isModalOpen();
	      }
	
	      function isOnTop() {
	        return window.pageYOffset === 0 || window.scrollY === 0;
	      }
	
	      function isModalOpen() {
	        return document.body.className.indexOf('modal-open') > -1;
	      }
	    }
	  };
	};
	
	__webpack_require__(613);

/***/ }),
/* 612 */,
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(614);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./pullToRefresh.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./pullToRefresh.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, ".ptr--ptr{box-shadow:none!important;font-weight:400!important;margin-bottom:-60px;margin-top:60px}.ptr--ptr.ptr--pull,.ptr--ptr.ptr--refresh,.ptr--ptr.ptr--release{border-bottom:1px solid #0072c9}.ptr--ptr .ptr--box .ptr--content .ptr--icon,.ptr--ptr .ptr--box .ptr--content .ptr--text{margin-top:-5px!important;color:#0072c9!important}.ptr--ptr .ptr--box .ptr--content .ptr--text{font-size:12px!important}.ptr--ptr .ptr--box .ptr--content .ptr--icon{font-size:16px!important;display:block;margin-bottom:5px}.inception-pull-to-refresh .ptr--ptr{margin-bottom:-188px;margin-top:188px}", ""]);
	
	// exports


/***/ }),
/* 615 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($timeout) {
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	
	    link: function link(scope, element) {
	      element.on('focus', onFocus);
	
	      function onFocus() {
	        //The element has to have focus first, then when the value is changed it will goto the end.
	        var currentValue = element.val();
	        element.val('');
	        $timeout(function () {
	          return element.val(currentValue);
	        });
	      }
	    }
	  };
	};

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($timeout) {
	
	  return {
	    restrict: 'A',
	
	    link: function link($scope, $element, $attrs) {
	      $element.bind('touchstart', function () {
	        $scope.longPress = true;
	        $timeout(function () {
	          if ($scope.longPress) {
	            $scope.$apply(function () {
	              $scope.$eval($attrs.onLongPress);
	            });
	          }
	        }, 600);
	      });
	
	      $element.bind('touchend', function () {
	        $scope.longPress = false;
	        if ($attrs.onTouchEnd) {
	          $scope.$apply(function () {
	            $scope.$eval($attrs.onTouchEnd);
	          });
	        }
	      });
	    }
	  };
	};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _inputDatepicker = __webpack_require__(618);
	
	var _inputDatepicker2 = _interopRequireDefault(_inputDatepicker);
	
	var _select = __webpack_require__(686);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _formErrorsSummary = __webpack_require__(692);
	
	var _formErrorsSummary2 = _interopRequireDefault(_formErrorsSummary);
	
	var _avatar = __webpack_require__(698);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _toggleSwitch = __webpack_require__(705);
	
	var _toggleSwitch2 = _interopRequireDefault(_toggleSwitch);
	
	var _mainMenu = __webpack_require__(713);
	
	var _mainMenu2 = _interopRequireDefault(_mainMenu);
	
	var _mainMenuMobile = __webpack_require__(719);
	
	var _mainMenuMobile2 = _interopRequireDefault(_mainMenuMobile);
	
	var _loading = __webpack_require__(734);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _table = __webpack_require__(740);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _delegationsList = __webpack_require__(748);
	
	var _delegationsList2 = _interopRequireDefault(_delegationsList);
	
	var _alertCard = __webpack_require__(900);
	
	var _alertCard2 = _interopRequireDefault(_alertCard);
	
	var _modalDelegationManager = __webpack_require__(906);
	
	var _modalDelegationManager2 = _interopRequireDefault(_modalDelegationManager);
	
	var _modalWarningDelegation = __webpack_require__(937);
	
	var _modalWarningDelegation2 = _interopRequireDefault(_modalWarningDelegation);
	
	var _employeeDropdownList = __webpack_require__(943);
	
	var _employeeDropdownList2 = _interopRequireDefault(_employeeDropdownList);
	
	var _employeeSearch = __webpack_require__(949);
	
	var _employeeSearch2 = _interopRequireDefault(_employeeSearch);
	
	var _confirmCloseModal = __webpack_require__(955);
	
	var _confirmCloseModal2 = _interopRequireDefault(_confirmCloseModal);
	
	var _cannotSignupModal = __webpack_require__(961);
	
	var _cannotSignupModal2 = _interopRequireDefault(_cannotSignupModal);
	
	var _successfulAction = __webpack_require__(967);
	
	var _successfulAction2 = _interopRequireDefault(_successfulAction);
	
	var _failedAction = __webpack_require__(973);
	
	var _failedAction2 = _interopRequireDefault(_failedAction);
	
	var _cardDetails = __webpack_require__(979);
	
	var _cardDetails2 = _interopRequireDefault(_cardDetails);
	
	var _questionModal = __webpack_require__(985);
	
	var _questionModal2 = _interopRequireDefault(_questionModal);
	
	var _optionSwitch = __webpack_require__(991);
	
	var _optionSwitch2 = _interopRequireDefault(_optionSwitch);
	
	var _modalCoachmark = __webpack_require__(997);
	
	var _modalCoachmark2 = _interopRequireDefault(_modalCoachmark);
	
	var _employeeName = __webpack_require__(1003);
	
	var _employeeName2 = _interopRequireDefault(_employeeName);
	
	var _floatingActionButtons = __webpack_require__(1009);
	
	var _floatingActionButtons2 = _interopRequireDefault(_floatingActionButtons);
	
	var _tooltipDesktop = __webpack_require__(1017);
	
	var _tooltipDesktop2 = _interopRequireDefault(_tooltipDesktop);
	
	var _tooltipMobile = __webpack_require__(1021);
	
	var _tooltipMobile2 = _interopRequireDefault(_tooltipMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('components', [_inputDatepicker2.default, _select2.default, _formErrorsSummary2.default, _avatar2.default, _toggleSwitch2.default, _mainMenu2.default, _mainMenuMobile2.default, _table2.default, _loading2.default, _delegationsList2.default, _alertCard2.default, _modalDelegationManager2.default, _modalWarningDelegation2.default, _employeeDropdownList2.default, _employeeSearch2.default, _confirmCloseModal2.default, _cannotSignupModal2.default, _successfulAction2.default, _failedAction2.default, _cardDetails2.default, _questionModal2.default, _optionSwitch2.default, _modalCoachmark2.default, _employeeName2.default, _floatingActionButtons2.default, _tooltipDesktop2.default, _tooltipMobile2.default]).name;
	
	exports.default = componentModule;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularAnimate = __webpack_require__(542);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _angularTouch = __webpack_require__(619);
	
	var _angularTouch2 = _interopRequireDefault(_angularTouch);
	
	var _datepickerPopup = __webpack_require__(621);
	
	var _datepickerPopup2 = _interopRequireDefault(_datepickerPopup);
	
	__webpack_require__(643);
	
	var _inputDatepicker = __webpack_require__(644);
	
	var _inputDatepicker2 = _interopRequireDefault(_inputDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputDatepickerModule = angular.module('components.inputDatepicker', [_angularAnimate2.default, _angularTouch2.default, _datepickerPopup2.default]).component('inputDatepicker', _inputDatepicker2.default).name;
	
	exports.default = inputDatepickerModule;

/***/ }),
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */
/***/ (function(module, exports) {

	/*eslint-disable */
	
	'use strict';
	
	angular.module("ngLocale", [], ["$provide", function ($provide) {
	  var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
	  $provide.value("$locale", {
	    "DATETIME_FORMATS": {
	      "AMPMS": ["a. m.", "p. m."],
	      "DAY": ["domingo", "lunes", "martes", "mi\xE9rcoles", "jueves", "viernes", "s\xE1bado"],
	      "ERANAMES": ["antes de Cristo", "despu\xE9s de Cristo"],
	      "ERAS": ["a. C.", "d. C."],
	      "FIRSTDAYOFWEEK": 0,
	      "MONTH": ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
	      "SHORTDAY": ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
	      "SHORTMONTH": ["ene.", "feb.", "mar.", "abr.", "may.", "jun.", "jul.", "ago.", "sept.", "oct.", "nov.", "dic."],
	      "STANDALONEMONTH": ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
	      "WEEKENDRANGE": [5, 6],
	      "fullDate": "EEEE, d 'de' MMMM 'de' y",
	      "longDate": "d 'de' MMMM 'de' y",
	      "medium": "d MMM y H:mm:ss",
	      "mediumDate": "d MMM y",
	      "mediumTime": "H:mm:ss",
	      "short": "d/M/yy H:mm",
	      "shortDate": "d/M/yy",
	      "shortTime": "H:mm"
	    },
	    "NUMBER_FORMATS": {
	      "CURRENCY_SYM": "\u20AC",
	      "DECIMAL_SEP": ",",
	      "GROUP_SEP": ".",
	      "PATTERNS": [{
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      }, {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "\xA0\xA4",
	        "posPre": "",
	        "posSuf": "\xA0\xA4"
	      }]
	    },
	    "id": "es-es",
	    "localeID": "es_ES",
	    "pluralCat": function pluralCat(n, opt_precision) {
	      if (n == 1) {
	        return PLURAL_CATEGORY.ONE;
	      }return PLURAL_CATEGORY.OTHER;
	    }
	  });
	}]);
	
	/*eslint-enable */

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inputDatepicker = __webpack_require__(645);
	
	var _inputDatepicker2 = _interopRequireDefault(_inputDatepicker);
	
	var _inputDatepicker3 = __webpack_require__(646);
	
	var _inputDatepicker4 = _interopRequireDefault(_inputDatepicker3);
	
	__webpack_require__(684);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputDatepickerComponent = {
	  restrict: 'E',
	  bindings: {
	    label: '@',
	    onDatepick: '&',
	    disabled: '<',
	    name: '@',
	    startDate: '<',
	    initDate: '<',
	    disableBeforeStartDate: '@',
	    isMobileApp: '<',
	    minDate: '<',
	    isRequired: '<'
	  },
	  template: _inputDatepicker2.default,
	  controller: _inputDatepicker4.default
	};
	
	exports.default = inputDatepickerComponent;

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"input-datepicker-wrapper\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <p class=\"label\" ng-if=\"$ctrl.label\">{{$ctrl.label}}</p>\n  <div class=\"datepicker-field\">\n    <input ng-if=\"!$ctrl.isMobileApp\" type=\"text\" name=\"{{$ctrl.name}}\" readonly class=\"form-control\"\n      ng-class=\"{focus:focus}\" ng-model=\"$ctrl.dateModel\" is-open=\"$parent.focus\" ng-focus=\"$parent.focus = true\"\n      datepicker-options=\"$ctrl.options\" ng-required=\"$ctrl.isInputRequired()\" show-button-bar=\"false\"\n      placeholder=\"DD/MM/AAAA\" max-mode=\"day\" ng-disabled=\"$ctrl.disabled\" uib-datepicker-popup=\"{{$ctrl.format}}\"\n      datepicker-append-to-body=\"true\" />\n\n    <input ng-if=\"$ctrl.isMobileApp\" type=\"text\" name=\"{{$ctrl.name}}\" readonly class=\"form-control\"\n      ng-class=\"{focus:focus}\" ng-model=\"$ctrl.dateModel\" is-open=\"$parent.focus\" ng-focus=\"$parent.focus = true\"\n      datepicker-options=\"$ctrl.options\" ng-required=\"$ctrl.isInputRequired()\" show-button-bar=\"false\"\n      placeholder=\"DD/MM/AAAA\" max-mode=\"day\" ng-disabled=\"$ctrl.disabled\" uib-datepicker-popup=\"{{$ctrl.format}}\"\n      datepicker-append-to-body=\"true\" />\n\n    <i ng-if=\"!$ctrl.isMobileApp\" class=\"icon-calendar\" ng-class=\"{'not-label': !$ctrl.label}\"\n      ng-click=\"$parent.focus = true\" ng-disabled=\"$ctrl.disabled\">\n    </i>\n\n    <i ng-if=\"$ctrl.isMobileApp\" class=\"icon-calendar\" ng-class=\"{'not-label': !$ctrl.label}\"\n      ng-click=\"$ctrl.openMobile($event)\" ng-disabled=\"$ctrl.disabled\">\n    </i>\n  </div>\n</div>"

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _blur = __webpack_require__(647);
	
	var _blur2 = _interopRequireDefault(_blur);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputDatepickerController = function () {
	  InputDatepickerController.$inject = ["$scope", "EventEmitter", "$timeout"];
	  function InputDatepickerController($scope, EventEmitter, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, InputDatepickerController);
	    this.scope = $scope;
	    this.EventEmitter = EventEmitter;
	    var format = 'dd/MM/yyyy';
	    this.format = format;
	    this.altInputFormats = [format];
	    this.options = this.getDefaultOptions();
	    this.dateModel = null;
	    this.initDate = null;
	    this.timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(InputDatepickerController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.setMinDateInMobile();
	      this.emitDateOnChange();
	      this.assignInitialDate();
	
	      this.scope.$watch(function () {
	        return _this.initDate;
	      }, function (initDate) {
	        _this.setInitDate(initDate);
	      });
	
	      this.scope.$watch(function () {
	        return _this.startDate;
	      }, function () {
	        _this.assignInitialDate();
	      });
	    }
	  }, {
	    key: 'setMinDateInMobile',
	    value: function setMinDateInMobile() {
	      var _this2 = this;
	
	      if (this.isMobileApp) {
	        this.scope.$watch(function () {
	          return _this2.minDate;
	        }, function () {
	          _this2.minDateMobile = _this2.minDate;
	        });
	      }
	    }
	  }, {
	    key: 'emitDateOnChange',
	    value: function emitDateOnChange() {
	      var _this3 = this;
	
	      this.scope.$watch(function () {
	        return _this3.dateModel;
	      }, function (newValue) {
	        if (!_this3.isDate(newValue)) {
	          return;
	        }
	
	        _this3.onDatepick(_this3.EventEmitter({ date: newValue }));
	
	        (0, _blur2.default)(_this3.timeout);
	      });
	    }
	  }, {
	    key: 'isInputRequired',
	    value: function isInputRequired() {
	      if ((0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.isRequired)) {
	        return true;
	      }
	      return this.isRequired;
	    }
	  }, {
	    key: 'assignInitialDate',
	    value: function assignInitialDate() {
	      if (this.startDate) {
	        this.dateModel = this.startDate;
	      }
	    }
	  }, {
	    key: 'getDefaultOptions',
	    value: function getDefaultOptions() {
	      var _this4 = this;
	
	      var me = this;
	      return {
	        startingDay: 1,
	        showWeeks: false,
	        minMode: 'day',
	        maxMode: 'day',
	        dateDisabled: function dateDisabled(_ref) {
	          var date = _ref.date,
	              mode = _ref.mode;
	          return _this4.dateDisabled.apply(me, [date, mode]);
	        }
	      };
	    }
	  }, {
	    key: 'setInitDate',
	    value: function setInitDate(initDate) {
	      if (initDate) this.options.initDate = new Date(initDate.getTime());
	    }
	  }, {
	    key: 'dateDisabled',
	    value: function dateDisabled() {
	      var selectedDate = arguments[0];
	
	      if (this.disableBeforeStartDate) {
	        var beforeStartDay = selectedDate <= this.startDate;
	        return beforeStartDay;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isDate',
	    value: function isDate(date) {
	      return Object.prototype.toString.call(date) === '[object Date]';
	    }
	  }, {
	    key: 'openMobile',
	    value: function openMobile($event) {
	      var currentTarget = $event.currentTarget;
	      var wrapper = currentTarget.parentElement;
	      var input = $(wrapper).find('input');
	      $(input).focus();
	    }
	  }]);
	  return InputDatepickerController;
	}();
	
	exports.default = InputDatepickerController;

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($timeout) {
	  $timeout(function () {
	    var tmp = document.createElement('input');
	    document.body.appendChild(tmp);
	    tmp.click();
	    document.body.removeChild(tmp);
	  });
	};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isUndefinedOrNullOrEmpty = undefined;
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(649);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check varible or object to 'is undefined', 'is empty' or 'is null'
	 * @param obj
	 */
	function isUndefinedOrNullOrEmpty(obj) {
	  return angular.isUndefined(obj) || obj === null || obj.length === 0 || (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && (0, _keys2.default)(obj).length === 0;
	}
	
	exports.isUndefinedOrNullOrEmpty = isUndefinedOrNullOrEmpty;

/***/ }),
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(685);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./inputDatepicker.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./inputDatepicker.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "ul.uib-datepicker-popup{z-index:10001;border:0;border-radius:0;box-shadow:0 2px 4px 0 #dddfe2,0 -1px 4px 0 #dddfe2;margin:1px 0 0!important;outline:none!important;padding:0}ul.uib-datepicker-popup *{outline:none!important}ul.uib-datepicker-popup table{min-width:253px;width:100%}ul.uib-datepicker-popup thead tr:first-child{vertical-align:top}ul.uib-datepicker-popup thead tr:first-child button.uib-left,ul.uib-datepicker-popup thead tr:first-child button.uib-right{background:#0072c9;border:0;border-radius:0;color:#fff;height:31px;width:33px}ul.uib-datepicker-popup thead tr:first-child button.uib-left i,ul.uib-datepicker-popup thead tr:first-child button.uib-right i{font-weight:100}ul.uib-datepicker-popup thead tr:first-child button.uib-left:focus,ul.uib-datepicker-popup thead tr:first-child button.uib-right:focus{outline:none}ul.uib-datepicker-popup thead tr:first-child button.uib-title{border:0;border-bottom:1px solid #eaebed;border-radius:0;color:#0072c9;cursor:auto;display:block;font-family:ArialMT;font-size:13px;margin:0 auto;opacity:1!important;padding-bottom:4px;padding-top:8px;width:80%}ul.uib-datepicker-popup thead tr:first-child button.uib-title:hover{background:#fff}ul.uib-datepicker-popup thead tr:first-child button.uib-title strong{display:inline-block;font-family:ArialMT;font-weight:400;width:98%}ul.uib-datepicker-popup thead tr:nth-child(2) th{height:11px;padding:12px 10px 7px}ul.uib-datepicker-popup thead tr:nth-child(2) th:first-child{padding-left:17px}ul.uib-datepicker-popup thead tr:nth-child(2) th:last-child{padding-right:17px}ul.uib-datepicker-popup thead tr:nth-child(2) th small{color:#666;font-family:ArialMT;font-size:11px;height:11px;line-height:11px}ul.uib-datepicker-popup tbody tr td:first-child{padding-left:7px}ul.uib-datepicker-popup tbody tr td:last-child{padding-right:7px}ul.uib-datepicker-popup tbody tr td button{border:0;border-radius:0;font-family:Stag Sans;font-size:12px;height:29px;padding:0;width:34px}ul.uib-datepicker-popup tbody tr td button[disabled]{pointer-events:none}ul.uib-datepicker-popup tbody tr td button.btn-default{color:#0072c9}ul.uib-datepicker-popup tbody tr td button.btn-default:hover{background-color:#0072c9;color:#fff}ul.uib-datepicker-popup tbody tr td button.btn-default.active{background:#fff;border-color:#fff;box-shadow:none;color:#0072c9}ul.uib-datepicker-popup tbody tr td button.btn-default.active:hover{background-color:#0072c9;color:#fff}ul.uib-datepicker-popup tbody tr td button.btn-default.active:hover span{color:#fff}ul.uib-datepicker-popup tbody tr td button.btn-info,ul.uib-datepicker-popup tbody tr td button.btn-info.active{background-color:#0072c9;color:#fff}ul.uib-datepicker-popup tbody tr td button.btn-default.btn-info span{color:#fff}ul.uib-datepicker-popup tbody tr td button.btn[disabled]{color:#666;font-weight:300;opacity:1}ul.uib-datepicker-popup tbody tr td button.btn[disabled]:hover{background:#fff;color:#666}ul.uib-datepicker-popup tbody tr td button.btn-default:not(.btn-info) .text-muted{font-weight:300}ul.uib-datepicker-popup tbody tr td button.btn-default:not(.btn-info):hover:not([disabled]) .text-muted{color:#fff;font-weight:400}input-datepicker .input-datepicker-wrapper{position:relative}input-datepicker .input-datepicker-wrapper .datepicker-field{position:relative;display:inline-block}input-datepicker .input-datepicker-wrapper .icon-calendar{position:absolute;right:10px;top:50%;transform:translateY(-50%)}input-datepicker input.form-control{border:1px solid #dddfe2;border-radius:3px;box-shadow:none;color:#666;font-family:Stag Sans;font-size:13px;height:37px;padding:0 20px;padding-left:15px;padding-top:3px;width:150px}input-datepicker input.form-control.ng-invalid.ng-dirty{border-color:#c8175e;color:#c8175e}input-datepicker input.form-control.ng-invalid.ng-dirty::-moz-placeholder{color:#c8175e;opacity:1}input-datepicker input.form-control.ng-invalid.ng-dirty:-ms-input-placeholder{color:#c8175e}input-datepicker input.form-control.ng-invalid.ng-dirty::-webkit-input-placeholder{color:#c8175e}input-datepicker input.form-control.ng-invalid.ng-dirty+div+i{color:#c8175e}input-datepicker input.form-control.focus,input-datepicker input.form-control:focus,input-datepicker input.form-control:hover{border-color:#0072c9!important;box-shadow:none;color:#0072c9;outline:none}input-datepicker input.form-control.focus::-moz-placeholder,input-datepicker input.form-control:focus::-moz-placeholder,input-datepicker input.form-control:hover::-moz-placeholder{color:#0072c9;opacity:1}input-datepicker input.form-control.focus:-ms-input-placeholder,input-datepicker input.form-control:focus:-ms-input-placeholder,input-datepicker input.form-control:hover:-ms-input-placeholder{color:#0072c9}input-datepicker input.form-control.focus::-webkit-input-placeholder,input-datepicker input.form-control:focus::-webkit-input-placeholder,input-datepicker input.form-control:hover::-webkit-input-placeholder{color:#0072c9}input-datepicker input.form-control.focus+div+i,input-datepicker input.form-control:focus+div+i,input-datepicker input.form-control:hover+div+i{color:#0072c9}input-datepicker .form-control[disabled]{background:#fff;border:1px solid #dddfe2;color:#aeaeae;opacity:1}input-datepicker .form-control[readonly]{background:#fff;border:1px solid #dddfe2;color:#666;opacity:1}input-datepicker .icon-calendar{color:#666;font-size:17px;right:10px;position:absolute;top:32px}input-datepicker .icon-calendar[disabled],input-datepicker .icon-calendar[disabled]:hover{color:#aeaeae;cursor:not-allowed}input-datepicker .icon-calendar.not-label{top:10px}input-datepicker .icon-calendar:hover{color:#0072c9;cursor:pointer}input-datepicker input[type=date]{-webkit-appearance:none!important;-webkit-user-select:text!important;text-transform:uppercase}input-datepicker input[type=date]:focus+i{color:#0072c9}input-datepicker input[type=date].ng-dirty.ng-invalid+i{color:#c8175e!important}input-datepicker input[type=date]::-webkit-calendar-picker-indicator,input-datepicker input[type=date]::-webkit-inner-spin-button{display:none}input-datepicker .responsiveMobile input.form-control{height:60px;line-height:50px;width:100%}input-datepicker .responsiveMobile input.form-control.focus,input-datepicker .responsiveMobile input.form-control:focus,input-datepicker .responsiveMobile input.form-control:hover{border:1px solid #dddfe2!important;color:#666}input-datepicker .responsiveMobile .icon-calendar{top:43px}input-datepicker .responsiveMobile input[type=date]:focus+i{color:#666}", ""]);
	
	// exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _select = __webpack_require__(687);
	
	var _select2 = _interopRequireDefault(_select);
	
	__webpack_require__(531);
	
	__webpack_require__(533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectModule = angular.module('components.selectApp', ['ui.select', 'ngSanitize']).component('selectApp', _select2.default).name;
	
	exports.default = selectModule;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _select = __webpack_require__(688);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _select3 = __webpack_require__(689);
	
	var _select4 = _interopRequireDefault(_select3);
	
	__webpack_require__(690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectComponent = {
	  restrict: 'E',
	  bindings: {
	    name: '@',
	    required: '=',
	    options: '<',
	    onSelect: '&',
	    placeholder: '@',
	    disabled: '<',
	    initialValue: '<',
	    label: '@',
	    limit: '<',
	    inTwoLines: '<'
	  },
	  template: _select2.default,
	  controller: _select4.default
	};
	
	exports.default = selectComponent;

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"$ctrl.getClasses()\">\n\n  <p ng-if=\"$ctrl.label\" class=\"label\">\n    {{$ctrl.label}}\n  </p>\n\n  <ui-select\n    name=\"{{$ctrl.name}}\"\n    onkeypress=\"return false;\"\n    ng-required=\"$ctrl.required\"\n    class=\"selectApp ng-pristine\"\n    ng-model=\"$ctrl.selectedValue\"\n    theme=\"bootstrap\"\n    search-enabled=\"false\"\n    ng-disabled=\"$ctrl.disabled\"\n    uis-open-close=\"$ctrl.removeInputSearch()\"\n    on-select=\"$ctrl.select($item, $model);\">\n\n    <ui-select-match placeholder=\"{{$ctrl.placeholder | uppercase}}\">\n      {{ $ctrl.selectedValue.option | uppercase }}\n    </ui-select-match>\n\n    <ui-select-choices repeat=\"choice in $ctrl.options | limitTo: $ctrl.limit\" position=\"down\">\n      <span class=\"select-option\">{{choice.option | uppercase}}</span>\n    </ui-select-choices>\n\n  </ui-select>\n\n  <span ng-class=\"{'with-label': !!$ctrl.label}\" class=\"icon icon-arrow-select-down\"></span>\n  <span ng-class=\"{'with-label': !!$ctrl.label}\" class=\"icon icon-arrow-select-up\"></span>\n\n</div>\n"

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectController = function () {
	  SelectController.$inject = ["EventEmitter", "$scope", "$window"];
	  function SelectController(EventEmitter, $scope, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SelectController);
	    this.EventEmitter = EventEmitter;
	    this.scope = $scope;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.cleanSelectedValue();
	  }
	
	  (0, _createClass3.default)(SelectController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (this.initialValue && this.options && this.options.length > 0) {
	        this.selectedValue = this.initialValue;
	      }
	
	      this.scope.$watch(function () {
	        return _this.initialValue;
	      }, function (value) {
	        _this.selectedValue = value;
	      });
	    }
	  }, {
	    key: 'removeInputSearch',
	    value: function removeInputSearch() {
	      var inputsSearch = angular.element('.ui-select-search').first();
	      inputsSearch.remove();
	      this.removeInputSelectFocusser();
	    }
	  }, {
	    key: 'removeInputSelectFocusser',
	    value: function removeInputSelectFocusser() {
	      var inputsSearch = angular.element('.ui-select-focusser').first();
	      inputsSearch.remove();
	    }
	  }, {
	    key: 'select',
	    value: function select(item, model) {
	      this.onSelect(this.EventEmitter({ $item: item, $model: model }));
	    }
	  }, {
	    key: 'cleanSelectedValue',
	    value: function cleanSelectedValue() {
	      var _this2 = this;
	
	      this.scope.$watch(function () {
	        return _this2.options;
	      }, function (newValue) {
	        if (newValue && newValue.length === 0) {
	          _this2.selectedValue = undefined;
	        }
	      });
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        'responsiveMobile': this.isMobileApp,
	        'two-lines': this.isMobileApp && this.inTwoLines
	      };
	    }
	  }]);
	  return SelectController;
	}();
	
	exports.default = SelectController;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(691);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./select.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./select.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * ui-select\n * http://github.com/angular-ui/ui-select\n * Version: 0.19.8 - 2017-04-18T05:43:43.881Z\n * License: MIT\n */.ui-select-highlight{font-weight:700}.ui-select-offscreen{clip:rect(0 0 0 0)!important;width:1px!important;height:1px!important;border:0!important;margin:0!important;padding:0!important;overflow:hidden!important;position:absolute!important;outline:0!important;left:0!important;top:0!important}.selectize-control.single>.selectize-input>input,.selectize-control>.selectize-dropdown{width:100%}.ui-select-choices-row:hover{background-color:#f5f5f5}.ng-dirty.ng-invalid>a.select2-choice{border-color:#d44950}.select2-result-single{padding-left:0}.select2-locked>.select2-search-choice-close,.select-locked>.ui-select-match-close{display:none}body>.select2-container.open{z-index:9999}.ui-select-container.select2.direction-up .ui-select-match,.ui-select-container[theme=select2].direction-up .ui-select-match{border-radius:0 0 4px 4px}.ui-select-container.select2.direction-up .ui-select-dropdown,.ui-select-container[theme=select2].direction-up .ui-select-dropdown{border-radius:4px 4px 0 0;border-top-width:1px;border-top-style:solid;box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-4px}.ui-select-container.select2.direction-up .ui-select-dropdown .select2-search,.ui-select-container[theme=select2].direction-up .ui-select-dropdown .select2-search{margin-top:4px}.ui-select-container.select2.direction-up.select2-dropdown-open .ui-select-match,.ui-select-container[theme=select2].direction-up.select2-dropdown-open .ui-select-match{border-bottom-color:#5897fb}.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden,.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden input{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.selectize-input.selectize-focus{border-color:#007fbb!important}.selectize-control.multi>.selectize-input>input{margin:0!important}.ng-dirty.ng-invalid>div.selectize-input{border-color:#d44950}.ui-select-container[theme=selectize].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-2px}.ui-select-container[theme=selectize] input.ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0;width:0}.btn-default-focus{color:#333;background-color:#ebebeb;border-color:#adadad;text-decoration:none;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-select-bootstrap .ui-select-toggle{position:relative}.ui-select-bootstrap .ui-select-toggle>.caret{position:absolute;height:10px;top:50%;right:10px;margin-top:-2px}.input-group>.ui-select-bootstrap.dropdown{position:static}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control{border-radius:4px 0 0 4px}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control.direction-up{border-radius:4px 0 0 4px!important}.ui-select-bootstrap .ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.ui-select-bootstrap>.ui-select-match>.btn{text-align:left!important}.ui-select-bootstrap>.ui-select-match>.caret{position:absolute;top:45%;right:15px}.ui-select-bootstrap>.ui-select-choices,.ui-select-bootstrap>.ui-select-no-choice{width:100%;height:auto;max-height:200px;overflow-x:hidden;margin-top:-1px}body>.ui-select-bootstrap.open{z-index:1000}.ui-select-multiple.ui-select-bootstrap{height:auto;padding:3px 3px 0}.ui-select-multiple.ui-select-bootstrap input.ui-select-search{background-color:transparent!important;border:none;outline:0;height:1.666666em;margin-bottom:3px}.ui-select-multiple.ui-select-bootstrap .ui-select-match .close{font-size:1.6em;line-height:.75}.ui-select-multiple.ui-select-bootstrap .ui-select-match-item{outline:0;margin:0 3px 3px 0}.ui-select-multiple .ui-select-match-item{position:relative}.ui-select-multiple .ui-select-match-item.dropping .ui-select-match-close{pointer-events:none}.ui-select-multiple:hover .ui-select-match-item.dropping-before:before{content:\"\";position:absolute;top:0;right:100%;height:100%;margin-right:2px;border-left:1px solid #428bca}.ui-select-multiple:hover .ui-select-match-item.dropping-after:after{content:\"\";position:absolute;top:0;left:100%;height:100%;margin-left:2px;border-right:1px solid #428bca}.ui-select-bootstrap .ui-select-choices-row>span{cursor:pointer;display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.ui-select-bootstrap .ui-select-choices-row>span:focus,.ui-select-bootstrap .ui-select-choices-row>span:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.ui-select-bootstrap .ui-select-choices-row.active>span{color:#fff;text-decoration:none;outline:0;background-color:#428bca}.ui-select-bootstrap .ui-select-choices-row.active.disabled>span,.ui-select-bootstrap .ui-select-choices-row.disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.ui-select-match.ng-hide-add,.ui-select-search.ng-hide-add{display:none!important}.ui-select-bootstrap.ng-dirty.ng-invalid>button.btn.ui-select-match{border-color:#d44950}.ui-select-container[theme=bootstrap].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25)}.ui-select-bootstrap .ui-select-match-text{width:100%;padding-right:1em}.ui-select-bootstrap .ui-select-match-text span{display:inline-block;width:100%;overflow:hidden}.ui-select-bootstrap .ui-select-toggle>a.btn{position:absolute;height:10px;right:10px;margin-top:-2px}.ui-select-refreshing.glyphicon{position:absolute;right:0;padding:8px 27px}@keyframes ui-select-spin{0%{transform:rotate(0)}to{transform:rotate(359deg)}}.ui-select-spin{animation:ui-select-spin 2s infinite linear}.ui-select-refreshing.ng-animate{-webkit-animation:none 0s}select-app{display:block;position:relative}select-app .responsiveMobile{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;-moz-align-items:center;align-items:center}select-app .responsiveMobile.two-lines{-ms-flex-wrap:wrap;flex-wrap:wrap}select-app .responsiveMobile .selectApp{width:100%}select-app .responsiveMobile .selectApp .ui-select-search{height:60px}select-app .responsiveMobile .selectApp span .ui-select-placeholder,select-app .responsiveMobile .selectApp span .ui-select-placeholder:hover{color:#666}select-app .responsiveMobile .selectApp .ui-select-toggle{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;height:60px;border-radius:2px!important;border-color:#eaebed}select-app .responsiveMobile .selectApp .ui-select-toggle:active{border-color:#dddfe2}select-app .responsiveMobile .selectApp .ui-select-toggle:focus:not([disabled]){border-color:#0072c9}select-app .responsiveMobile .selectApp .ui-select-toggle:focus:not([disabled]) .ui-select-match-text{color:#0072c9!important}select-app .responsiveMobile .selectApp .ui-select-choices{border-color:#dddfe2;border-top:0;padding-top:0;padding-bottom:0;max-height:200px!important}select-app .responsiveMobile .selectApp .ui-select-choices.dropdown-menu{top:102%}select-app .responsiveMobile .selectApp .ui-select-choices-row{font-size:15px;height:60px}select-app .responsiveMobile .selectApp .ui-select-choices-row>span{display:inline-block;width:100%;white-space:normal}select-app .responsiveMobile .selectApp .ui-select-choices-row>span:hover{background-color:#dddfe2;color:#0072c9}select-app .responsiveMobile .selectApp .ui-select-choices-row>span>span{display:inline-block;width:100%;white-space:normal}select-app .responsiveMobile .selectApp .ui-select-choices-row>span>span:hover{background-color:#dddfe2;color:#0072c9}select-app .responsiveMobile .selectApp .ui-select-choices-row-inner{height:100%}select-app .responsiveMobile .selectApp .ui-select-choices-row-inner .select-option{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;margin-top:0;padding-bottom:0;padding-top:0;height:100%}select-app .responsiveMobile .select-option{padding-right:0}select-app .responsiveMobile .icon{position:unset;margin-left:-30px;z-index:1}select-app .responsiveMobile input[type=search]{display:none}select-app .ui-select-choices.ui-select-choices-content.ui-select-dropdown.dropdown-menu{opacity:1!important}select-app.small-options .ui-select-choices{height:300px;overflow-y:auto}select-app>div{position:relative;width:100%}select-app *,select-app:focus,select-app :focus{outline:0!important;box-shadow:none!important}select-app .icon-arrow-select-down,select-app .icon-arrow-select-up{color:#666;cursor:pointer;font-size:10px;position:absolute;right:20px;top:15px}select-app .icon-arrow-select-down.with-label,select-app .icon-arrow-select-up.with-label{top:36px!important}select-app .icon-arrow-select-up{display:none}select-app .icon-arrow-select-down{pointer-events:none}select-app .selectApp.open+.icon-arrow-select-down+.icon-arrow-select-up{display:block;color:#0072c9}select-app .selectApp.open+.icon-arrow-select-down{display:none}select-app .selectApp.open input{border:1px solid #0072c9}select-app .selectApp.open input::-moz-placeholder{color:#0072c9;opacity:1}select-app .selectApp.open input:-ms-input-placeholder{color:#0072c9}select-app .selectApp.open input::-webkit-input-placeholder{color:#0072c9}select-app .form-control{height:37px;line-height:1.5;width:100%}select-app .form-control:focus{border-color:#aeaeae;box-shadow:none}select-app input[type=search]{box-sizing:border-box;line-height:37px;padding:3px 12px 0 20px;cursor:pointer;color:transparent;text-shadow:0 0 0 #0072c9}select-app input[type=search] .ng-invalid:not(.ng-pristine) .form-control{border-color:#c8175e}select-app input[type=search] .ui-select-container:focus{outline:0}select-app span.form-control{overflow:hidden;padding-right:35px}select-app .ui-select-toggle{height:37px}select-app .ui-select-toggle,select-app .ui-select-toggle:hover{background-color:#fff!important;border-radius:3px!important;box-shadow:none;color:#aeaeae;overflow-y:hidden}select-app .ui-select-toggle:focus{width:100%!important}select-app .caret{display:none}select-app .ui-select-match-text{color:#666!important;font-family:Stag Sans;font-size:15px;margin-left:7px;margin-top:2px;overflow:hidden;text-overflow:ellipsis}select-app .ui-select-match-text:hover{background-color:transparent!important;font-family:Stag Sans;font-size:15px}select-app .select-option{color:#666;font-family:Stag Sans;font-size:12px;margin-left:-21px;margin-top:8px;padding:13px 100% 12px 20px}select-app .select-option:hover{background-color:#dddfe2;color:#0072c9}select-app span .ui-select-placeholder{text-transform:uppercase;background:#fff;color:#aeaeae;line-height:1.9;margin-left:8px}select-app span .ui-select-placeholder:hover{background:#fff;color:#aeaeae}select-app .ui-select-choices{border-radius:0;height:373px;max-height:373px!important;overflow-y:auto;padding-top:-2.15px;width:100%!important;margin-top:0!important}select-app .ui-select-choices-row{background-color:#fff;height:34px;margin-bottom:2px;margin-top:1.2px}select-app .ui-select-choices-row:hover{background-color:transparent!important}select-app .active span{background-color:#fff!important;color:#666}select-app .active span:hover{background-color:#dddfe2!important;color:#0072c9!important}", ""]);
	
	// exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formErrorsSummary = __webpack_require__(693);
	
	var _formErrorsSummary2 = _interopRequireDefault(_formErrorsSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formErrorsSummaryModule = angular.module('components.formErrorsSummary', []).component('formErrorsSummary', _formErrorsSummary2.default).name;
	
	exports.default = formErrorsSummaryModule;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formErrorsSummary = __webpack_require__(694);
	
	var _formErrorsSummary2 = _interopRequireDefault(_formErrorsSummary);
	
	var _formErrorsSummary3 = __webpack_require__(695);
	
	var _formErrorsSummary4 = _interopRequireDefault(_formErrorsSummary3);
	
	__webpack_require__(696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formErrorsSummaryComponent = {
	  restrict: 'E',
	  bindings: {
	    errors: '<'
	  },
	  template: _formErrorsSummary2.default,
	  controller: _formErrorsSummary4.default
	};
	
	exports.default = formErrorsSummaryComponent;

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"border\">\n  <span class=\"icon-warning\"></span>\n  <div class=\"errors\">\n    <p ng-if=\"!$ctrl.errors ||  $ctrl.errors.length === 0\">Campos invalidos y/o requeridos</p>\n    <ul ng-if=\"$ctrl.errors && $ctrl.errors.length > 0\">\n      <li ng-repeat=\"error in $ctrl.errors\">{{error}}</li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormErrorsSummaryController = function FormErrorsSummaryController() {
	  (0, _classCallCheck3.default)(this, FormErrorsSummaryController);
	};
	
	exports.default = FormErrorsSummaryController;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(697);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./formErrorsSummary.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./formErrorsSummary.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "form-errors-summary .border{border:1px solid #c8175e;border-radius:6px;display:block;margin:0 auto 20px;margin-bottom:20px;min-height:56px;padding:20px 20px 8px;position:relative}form-errors-summary .icon-warning{color:#c8175e;font-size:34px;left:20px;position:absolute;top:10px}form-errors-summary p,form-errors-summary ul{padding-left:50px}form-errors-summary ul{list-style:none}form-errors-summary li,form-errors-summary p{color:#c8175e;font-family:ArialMT;font-size:15px;line-height:1.13}", ""]);
	
	// exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _avatar = __webpack_require__(699);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _avatarCache = __webpack_require__(704);
	
	var _avatarCache2 = _interopRequireDefault(_avatarCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var avatarModule = angular.module('components.avatar', []).config(["$sceDelegateProvider", function ($sceDelegateProvider) {
	  'ngInject';
	
	  $sceDelegateProvider.resourceUrlWhitelist([
	  // Allow same origin resource loads.
	  'self',
	  // Allow loading from our assets domain.  Notice the difference between * and **.
	  '*']);
	}]).component('avatarApp', _avatar2.default).service('avatarCache', _avatarCache2.default).name;
	
	exports.default = avatarModule;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _avatar = __webpack_require__(700);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _avatar3 = __webpack_require__(701);
	
	var _avatar4 = _interopRequireDefault(_avatar3);
	
	__webpack_require__(702);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @param sizeBig makes the component with dimensions 80px instead of default 40px
	 */
	var avatarComponent = {
	  restrict: 'E',
	  bindings: {
	    source: '<',
	    name: '<',
	    sizeBig: '@',
	    email: '<',
	    userId: '<',
	    bbvaUId: '<',
	    mediumSize: '@'
	  },
	  template: _avatar2.default,
	  controller: _avatar4.default
	};
	
	exports.default = avatarComponent;

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"avatar-container\" ng-class=\"$ctrl.getContainerCss()\">\n  <img ng-if=\"$ctrl.source\" ng-src=\"{{$ctrl.source}}\" alt=\"{{'GLOBALS.AVATAR_TITLE' | translate}}\"/>\n  <div ng-if=\"!$ctrl.source\" class=\"initials-container\">\n    <span>{{$ctrl.nameFirstLetter}}</span>\n    <span>{{$ctrl.lastNameFirstLetter}}</span>\n  </div>\n</div>\n"

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvatarController = function () {
	  AvatarController.$inject = ["$log", "$window"];
	  function AvatarController($log, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AvatarController);
	    this.log = $log;
	    this.window = $window;
	  }
	
	  (0, _createClass3.default)(AvatarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var name = this.name;
	      var email = this.email;
	      var userId = this.userId;
	      this.log.log('Avatar', { name: name }, { email: email }, { userId: userId });
	
	      if (this.hasName()) {
	        var _initFirstLetters = this.initFirstLetters(this.name),
	            nameFirstLetter = _initFirstLetters.nameFirstLetter,
	            lastNameFirstLetter = _initFirstLetters.lastNameFirstLetter;
	
	        this.nameFirstLetter = nameFirstLetter;
	        this.lastNameFirstLetter = lastNameFirstLetter;
	      }
	    }
	  }, {
	    key: 'hasName',
	    value: function hasName() {
	      return !(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.name);
	    }
	  }, {
	    key: 'hasEmail',
	    value: function hasEmail() {
	      return !(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.email);
	    }
	  }, {
	    key: 'hasUserId',
	    value: function hasUserId() {
	      return !(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.userId);
	    }
	  }, {
	    key: 'hasBbvaUId',
	    value: function hasBbvaUId() {
	      return !(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.bbvaUId);
	    }
	  }, {
	    key: 'initFirstLetters',
	    value: function initFirstLetters(name) {
	      name = this.cleanSpaces(name);
	      var namesplit = name.split(' ');
	      var nameFirstLetter = namesplit[0].substring(0, 1).toUpperCase();
	      var lastNameFirstLetter = namesplit[1].substring(0, 1).toUpperCase();
	      return { nameFirstLetter: nameFirstLetter, lastNameFirstLetter: lastNameFirstLetter };
	    }
	  }, {
	    key: 'cleanSpaces',
	    value: function cleanSpaces(string) {
	      return string.replace(/ +(?= )/g, '');
	    }
	  }, {
	    key: 'getContainerCss',
	    value: function getContainerCss() {
	      return {
	        'size-big': angular.isDefined(this.sizeBig),
	        'size-medium': angular.isDefined(this.mediumSize),
	        'with-picture': this.source
	      };
	    }
	  }]);
	  return AvatarController;
	}();
	
	exports.default = AvatarController;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(703);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./avatar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./avatar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "avatar-app{display:inline-block}avatar-app .avatar-container{background-color:#0072c9;border-radius:100%;height:40px;width:40px;line-height:40px;display:inline-block}avatar-app .avatar-container.size-big{height:80px;width:80px;line-height:80px}avatar-app .avatar-container.size-big .initials-container span{font-size:35px}avatar-app .avatar-container.size-medium{height:40px;width:40px;line-height:40px}avatar-app .avatar-container.size-medium .initials-container span{font-size:15px}avatar-app .avatar-container.with-picture{background-color:transparent}avatar-app .avatar-container .initials-container{text-align:center}avatar-app .avatar-container .initials-container::selection{background-color:transparent}avatar-app .avatar-container img{object-fit:cover;font-family:object-fit\\: cover;border-radius:100%;height:100%;width:100%}avatar-app .avatar-container span{color:#f9f9f9;font-family:Stag Sans;font-size:16px;font-weight:500}avatar-app .avatar-container span::selection{background-color:transparent}", ""]);
	
	// exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvatarCache = function () {
	  function AvatarCache() {
	    (0, _classCallCheck3.default)(this, AvatarCache);
	
	    this.urls = {};
	  }
	
	  (0, _createClass3.default)(AvatarCache, [{
	    key: "getUrl",
	    value: function getUrl(username) {
	      return this.urls[username];
	    }
	  }, {
	    key: "setUrl",
	    value: function setUrl(username, url) {
	      this.urls[username] = url;
	    }
	  }]);
	  return AvatarCache;
	}();
	
	exports.default = AvatarCache;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(706);
	
	var _toggleSwitch = __webpack_require__(707);
	
	var _toggleSwitch2 = _interopRequireDefault(_toggleSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toggleSwitchModule = angular.module('components.toggleSwitch', ['uiSwitch']).component('toggleSwitch', _toggleSwitch2.default).name;
	
	exports.default = toggleSwitchModule;

/***/ }),
/* 706 */,
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toggleSwitch = __webpack_require__(708);
	
	var _toggleSwitch2 = _interopRequireDefault(_toggleSwitch);
	
	var _toggleSwitch3 = __webpack_require__(709);
	
	var _toggleSwitch4 = _interopRequireDefault(_toggleSwitch3);
	
	__webpack_require__(710);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toggleSwitchComponent = {
	  restrict: 'E',
	  bindings: {
	    enabled: '<',
	    onChange: '&',
	    label: '@',
	    disabled: '@',
	    isMobileApp: '<'
	  },
	  template: _toggleSwitch2.default,
	  controller: _toggleSwitch4.default
	};
	
	exports.default = toggleSwitchComponent;

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"{ 'disabled': $ctrl.isDisabled() }\" ng-click=\"$ctrl.mandatoryInsuranceAlert()\">\n  <p ng-if=\"$ctrl.label\" class=\"label\">{{$ctrl.label}}</p>\n  <switch id=\"ui-switch\" ng-model=\"$ctrl.enabled\"></switch>\n</div>\n\n<loans-mandatory-insurance-modal\nerror=\"$ctrl.showAlert\"\nmessage=\"$ctrl.alertMessage\"\nis-mobile-app=\"$ctrl.isMobileApp\">\n</loans-mandatory-insurance-modal>"

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleSwitchController = function () {
	  ToggleSwitchController.$inject = ["$scope", "EventEmitter"];
	  function ToggleSwitchController($scope, EventEmitter) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ToggleSwitchController);
	    this.$scope = $scope;
	    this.EventEmitter = EventEmitter;
	
	    this.$scope.$watch(function () {
	      return _this.enabled;
	    }, function (newValue, oldValue) {
	      if (newValue !== oldValue) {
	        return _this.onChange(_this.EventEmitter({ enabled: newValue }));
	      }
	    });
	  }
	
	  (0, _createClass3.default)(ToggleSwitchController, [{
	    key: 'isDisabled',
	    value: function isDisabled() {
	      return !!this.disabled;
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'mandatoryInsuranceAlert',
	    value: function mandatoryInsuranceAlert() {
	      if (this.isDisabled()) {
	        this.alertMessage = '{{ "LOANS.SIGN_UP.FORM_SIMULATION.MANDATORY_INSURANCE_WARNING" | translate }}';
	        this.showAlert = true;
	        this.openModal();
	        return;
	      }
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      var $modal = $(_constants.MODALS.MANDATORY_INSURANCE);
	      return $modal;
	    }
	  }]);
	  return ToggleSwitchController;
	}();
	
	exports.default = ToggleSwitchController;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(711);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./toggleSwitch.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./toggleSwitch.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	exports.i(__webpack_require__(712), "");
	
	// module
	exports.push([module.id, "toggle-switch .disabled{pointer-events:auto;width:35%}toggle-switch .switch{height:27px;width:53px}toggle-switch .switch small{height:24px;top:1px;width:24px}toggle-switch .switch.checked{background:#0072c9;border-color:#0072c9}toggle-switch .switch.checked small{left:28px}", ""]);
	
	// exports


/***/ }),
/* 712 */,
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mainMenu = __webpack_require__(714);
	
	var _mainMenu2 = _interopRequireDefault(_mainMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuModule = angular.module('mainMenu', []).component('mainMenu', _mainMenu2.default).name;
	
	exports.default = menuModule;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mainMenu = __webpack_require__(715);
	
	var _mainMenu2 = _interopRequireDefault(_mainMenu);
	
	var _mainMenu3 = __webpack_require__(716);
	
	var _mainMenu4 = _interopRequireDefault(_mainMenu3);
	
	__webpack_require__(717);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuComponent = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {
	    links: '<'
	  },
	  template: _mainMenu2.default,
	  controller: _mainMenu4.default
	};
	
	exports.default = menuComponent;

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	module.exports = "<nav role=\"navigation\">\n  <div class=\"container hpd\">\n    <div class=\"main-navbar\">\n      <span ng-repeat=\"link in $ctrl.links\">\n        <span class=\"separator\" ng-if=\"link.hasSeparator\"></span>\n        <a\n          ng-if=\"!$ctrl.senior(link)\"\n          title=\"{{link.title | translate}}\"\n          ui-sref-active=\"active\"\n          ui-sref=\"{{link.target}}\"\n          ng-click=\"link.onClick()\"\n          class=\"link\"\n          ng-class=\"$ctrl.getCssLink(link)\"\n          >{{link.label | translate}}\n        </a>\n        <span\n          ng-if=\"link.hasAlert\"\n          class=\"icon in-navbar\"\n          ng-class=\"link.iconName\"\n        ></span>\n      </span>\n      <ng-transclude class=\"transcluded-content\"></ng-transclude>\n    </div>\n  </div>\n</nav>\n"

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainMenuController = function () {
	  MainMenuController.$inject = ["$state", "$location", "LoansUserDataService"];
	  function MainMenuController($state, $location, LoansUserDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MainMenuController);
	    this.state = $state;
	    this.location = $location;
	    this.loansUserDataService = LoansUserDataService;
	  }
	
	  (0, _createClass3.default)(MainMenuController, [{
	    key: 'senior',
	    value: function senior(link) {
	      return link.title === 'LOANS.WAGE_ADVANCE.TITLE' && this.loansUserDataService.getSenior();
	    }
	  }, {
	    key: 'getCssLink',
	    value: function getCssLink(link) {
	      return {
	        'has-separator': link.hasSeparator,
	        'alt-active': link.target === this.state.current.name || link.altStates.includes(this.state.current.name) || link.target.includes(this.location.search().from) || link.fromStates.includes(this.location.search().from)
	      };
	    }
	  }]);
	  return MainMenuController;
	}();
	
	exports.default = MainMenuController;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(718);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./mainMenu.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./mainMenu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "main-menu{display:block}@media print{main-menu{display:none}}main-menu.food-benefit .main-navbar .transcluded-content{padding-right:22px}@media(max-width:944px){main-menu .container.hpd{width:929px;overflow-x:visible}}main-menu .main-navbar{height:60px;border-bottom:2px solid #eaebed;margin-left:-15px;margin-right:-15px}main-menu .main-navbar .link{cursor:pointer;text-transform:uppercase;height:38px;position:relative;top:19px;margin-left:20px;margin-right:20px;display:inline-block;font-family:Stag Sans;font-size:13px;text-align:center;color:#666}main-menu .main-navbar .link.active,main-menu .main-navbar .link.alt-active,main-menu .main-navbar .link:hover{color:#0072c9;border-bottom:4px solid #0072c9;background:none;text-decoration:none}main-menu .main-navbar .link:focus{outline:none!important;text-decoration-color:#0072c9;color:#0072c9}main-menu .main-navbar .transcluded-content{float:right;margin-top:5px;margin-bottom:5px;padding-right:30px}main-menu .main-navbar .separator{width:2px;height:17px;border:1px solid #aeaeae;position:relative;margin-left:15px;top:19px}main-menu .main-navbar .has-separator{margin-left:38px}main-menu .main-navbar .icon-warning.in-navbar{font-weight:700;position:relative;top:20px;right:15px;color:#c8175e}main-menu.no-border .main-navbar{border:0}", ""]);
	
	// exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _mainMenuMobile = __webpack_require__(720);
	
	var _mainMenuMobile2 = _interopRequireDefault(_mainMenuMobile);
	
	var _devChangeEmployeeMobile = __webpack_require__(727);
	
	var _devChangeEmployeeMobile2 = _interopRequireDefault(_devChangeEmployeeMobile);
	
	var _mainMenuMobileBehaviour = __webpack_require__(733);
	
	var _mainMenuMobileBehaviour2 = _interopRequireDefault(_mainMenuMobileBehaviour);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mainMenuMobileModule = _angular2.default.module('mainMenuMobile', [_devChangeEmployeeMobile2.default]).component('mainMenuMobile', _mainMenuMobile2.default).service('mainMenuMobileBehaviourService', _mainMenuMobileBehaviour2.default).name;
	
	exports.default = mainMenuMobileModule;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mainMenuMobile = __webpack_require__(721);
	
	var _mainMenuMobile2 = _interopRequireDefault(_mainMenuMobile);
	
	var _mainMenuMobile3 = __webpack_require__(722);
	
	var _mainMenuMobile4 = _interopRequireDefault(_mainMenuMobile3);
	
	__webpack_require__(725);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mainMenuMobileComponent = {
	  restrict: 'E',
	  bindings: {
	    links: '<',
	    employeeInfo: '<',
	    managerInfo: '<',
	    module: '@',
	    isMobileApp: '<',
	    showLinks: '<'
	  },
	  template: _mainMenuMobile2.default,
	  controller: _mainMenuMobile4.default
	};
	
	exports.default = mainMenuMobileComponent;

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	module.exports = "<nav ng-if=\"$ctrl.render\"\n     role=\"navigation\">\n\n  <div class=\"back-button\"\n       ng-click=\"$ctrl.goBack()\">\n    <span class=\"icon icon-arrow-select-down\"\n          ng-show=\"$ctrl.showBackButton()\">\n    </span>\n  </div>\n\n  <h1>{{ $ctrl.titleLiteral | translate }}</h1>\n\n  <div class=\"menu-toggle-wrapper\">\n    <div class=\"menu-toggle\" ng-if=\"$ctrl.showMenuButton()\">\n      <input type=\"checkbox\" id=\"inputMenuToggle\" ng-click=\"$ctrl.toggleOpen()\"/>\n      <span class=\"icon\" ng-class=\"{ 'menu-opened': $ctrl.isMenuOpened() }\"></span>\n      <span class=\"icon\" ng-class=\"{ 'menu-opened': $ctrl.isMenuOpened() }\"></span>\n      <span class=\"icon\" ng-class=\"{ 'menu-opened': $ctrl.isMenuOpened() }\"></span>\n\n      <div id=\"mobile-nav\">\n        <div class=\"overlay\" ng-click=\"$ctrl.onOverlayClick()\"></div>\n        <ul class=\"menu\">\n          <li class=\"menu-title employee-info\">\n            <avatar-app name=\"$ctrl.employee.name\" email=\"$ctrl.employee.mail\" user-id=\"$ctrl.employee.userId\" bbva-u-id=\"$ctrl.employee.bbvaUserId\"></avatar-app>\n            <div class=\"menu-title-name\">\n              <span>{{$ctrl.employeeInfo._profile.name}}</span>\n            </div>\n          </li>\n          <li ng-repeat=\"link in $ctrl.links\"\n              ng-if=\"$ctrl.showLinks\"\n              ui-sref-active=\"active\"\n              ui-sref=\"{{link.target}}\"\n              class=\"link\"\n              ng-click=\"$ctrl.closeMenu(); link.onClick();\"\n              ng-class=\"$ctrl.getCssLink(link)\">\n            <a>\n              {{link.label | translate}}\n              <span ng-if=\"$ctrl.isTeamRequestLink(link)\" class=\"menu-badge\">\n                {{$ctrl.requestBadgeNumber}}\n              </span>\n              <span ng-if=\"link.hasAlert\" class=\"icon in-mobile-menu\" ng-class=\"link.iconName\"></span>\n            </a>\n          </li>\n          <li ng-if=\"$ctrl.isDev\"\n              ng-click=\"$ctrl.goToChangeEmployee()\"\n              class=\"warning\">\n            <a>{{\"INDEX.CHANGE_EMPLOYEE\" | translate}}</a>\n          </li>\n          <li ng-click=\"$ctrl.onLogout()\">\n            <a>{{\"GLOBALS.LOGOUT\" | translate}}</a>\n          </li>\n          <li ng-class=\"$ctrl.getCssVersion()\" class=\"version-info\"><span>{{\"GLOBALS.VERSION\" | translate}}: {{$ctrl.version}}</span></li>\n        </ul>\n      </div>\n\n    </div>\n  </div>\n\n</nav>\n\n<dev-change-employee-mobile></dev-change-employee-mobile>\n"

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	var _constants2 = __webpack_require__(723);
	
	var _swipe = __webpack_require__(724);
	
	var _swipe2 = _interopRequireDefault(_swipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import {MODULE_ID as FOOD_BENEFIT_MODULE_ID} from 'food-benefit.module/common/domain/constants';
	var STATES_MAIN_MENU = {
	  CURRENT_STATE: 'current-state',
	  STATE_ON_EVENT: 'state-on-event'
	};
	
	var MainMenuMobileController = function () {
	  MainMenuMobileController.$inject = ["$state", "$location", "$window", "$timeout", "$scope", "$rootScope", "visitedPagesService", "AuthenticationService", "mainMenuMobileBehaviourService"];
	  function MainMenuMobileController($state, $location, $window, $timeout, $scope, $rootScope, visitedPagesService, AuthenticationService, mainMenuMobileBehaviourService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MainMenuMobileController);
	    this.state = $state;
	    this.location = $location;
	    this.window = $window;
	    this.timeout = $timeout;
	    this.scope = $scope;
	    this.rootScope = $rootScope;
	    this.visitedPagesService = visitedPagesService;
	    this.authenticationService = AuthenticationService;
	    this.mainMenuMobileBehaviourService = mainMenuMobileBehaviourService;
	    this.isClosing = false;
	
	    this.stateMainMenu = STATES_MAIN_MENU.CURRENT_STATE;
	    this.isDev = (true);
	    this.version = ("1.4.4-undefined");
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.render = this.shouldRender();
	  }
	
	  (0, _createClass3.default)(MainMenuMobileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.changeStateVacationsToMobile();
	      this._setAvatarInfo();
	      this._setRequestNumberOfEmployees();
	      this.onChangeCurrentState();
	      this.onChangeTitle();
	      this.onChangeBadgeNumber();
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      this.run();
	    }
	  }, {
	    key: 'run',
	    value: function run() {
	      this.initSwipe();
	    }
	  }, {
	    key: 'shouldRender',
	    value: function shouldRender() {
	      return this.state.current.name !== _states.STATES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR_MOBILE;
	    }
	  }, {
	    key: 'initSwipe',
	    value: function initSwipe() {
	      var _this = this;
	
	      var swiper = new _swipe2.default('html');
	      swiper.onLeft(function (event) {
	        return _this.onSwipeLeft(event);
	      });
	      swiper.onRight(function (event) {
	        return _this.onSwipeRight(event);
	      });
	      swiper.run();
	    }
	  }, {
	    key: 'onSwipeLeft',
	    value: function onSwipeLeft(event) {
	      if (this.avoidSwipe(event)) {
	        return false;
	      }
	
	      if (!this.isMenuOpened()) {
	        this.inputMenuToggle.click();
	      }
	    }
	  }, {
	    key: 'onSwipeRight',
	    value: function onSwipeRight(event) {
	      if (this.avoidSwipe(event)) {
	        return false;
	      }
	
	      if (this.isMenuOpened()) {
	        this.inputMenuToggle.click();
	      }
	    }
	  }, {
	    key: 'avoidSwipe',
	    value: function avoidSwipe(event) {
	      return $('main-menu-mobile').hasClass('focus-fixed') || $(event.target).closest('.swipe-container').length > 0;
	    }
	  }, {
	    key: 'onChangeCurrentState',
	    value: function onChangeCurrentState() {
	      var _this2 = this;
	
	      this.scope.$watch(function () {
	        return _this2.state.current.name;
	      }, function (newValue) {
	        _this2.render = _this2.shouldRender();
	        _this2.configure(newValue);
	      });
	    }
	  }, {
	    key: '_setAvatarInfo',
	    value: function _setAvatarInfo() {
	      this.employee = {
	        name: this.employeeInfo._profile.name,
	        email: this.employeeInfo._profile.email,
	        userId: this.employeeInfo._profile.userId,
	        bbvaUserId: this.employeeInfo._profile.bbvaUserId
	      };
	    }
	  }, {
	    key: '_setRequestNumberOfEmployees',
	    value: function _setRequestNumberOfEmployees() {
	      //[AA TEAM REQUEST CODE]
	      //if (this.module === FOOD_BENEFIT_MODULE_ID) this._setRequestNumberOfEmployeesFoodBenefit();
	      if (this.module === _constants2.MODULE_ID) this._setRequestNumberOfEmployeesVacationsAbsences();
	    }
	
	    //[AA TEAM REQUEST CODE]
	    // _setRequestNumberOfEmployeesFoodBenefit() {
	    //   const managerInfo = this.managerInfo;
	    //   this.requestBadgeNumber = (managerInfo) ? managerInfo.employeesFoodBenefitPeriods.length : null;
	    // }
	
	  }, {
	    key: '_setRequestNumberOfEmployeesVacationsAbsences',
	    value: function _setRequestNumberOfEmployeesVacationsAbsences() {
	      var teamRequestInfo = this.managerInfo;
	      this.requestBadgeNumber = teamRequestInfo ? teamRequestInfo.length : null;
	    }
	  }, {
	    key: 'isTeamRequestLink',
	    value: function isTeamRequestLink(link) {
	      var TEAM_REQUEST_FOOD_BENEFIT = _states.STATES.FOOD_BENEFIT.MANAGER;
	      var TEAM_REQUEST_VACATIONS_ABSENCES = _states.STATES.VACATIONS_ABSENCES.TEAM_REQUESTS;
	      return link.target === TEAM_REQUEST_FOOD_BENEFIT || link.target === TEAM_REQUEST_VACATIONS_ABSENCES;
	    }
	  }, {
	    key: 'isMenuOpened',
	    value: function isMenuOpened() {
	      return this.menuOpened;
	    }
	  }, {
	    key: 'onChangeBadgeNumber',
	    value: function onChangeBadgeNumber() {
	      var _this3 = this;
	
	      this.rootScope.$on(_constants.EVENTS.BADGE_NUMBER, function (event, data) {
	        _this3.requestBadgeNumber = data.badgeNumber;
	      });
	    }
	  }, {
	    key: 'onChangeTitle',
	    value: function onChangeTitle() {
	      var _this4 = this;
	
	      this.rootScope.$on(_constants.EVENTS.CHANGE_TITLE, function (event, data) {
	        _this4.titleLiteral = data.title;
	        _this4.stateMainMenu = STATES_MAIN_MENU.STATE_ON_EVENT;
	      });
	    }
	  }, {
	    key: 'configure',
	    value: function configure(newValue) {
	      var _this5 = this;
	
	      var current = newValue;
	
	      var link = this.links.find(function (link) {
	
	        _this5.linkMatch = link.target === current;
	
	        if (_this5.linkMatch) {
	          _this5.fromMatch = false;
	          _this5.altMatch = false;
	        } else {
	          _this5.fromMatch = link.fromStates.indexOf(newValue) > -1;
	          _this5.altMatch = link.altStates.indexOf(newValue) > -1;
	        }
	
	        return _this5.linkMatch || _this5.fromMatch || _this5.altMatch;
	      });
	
	      if (this.stateMainMenu === STATES_MAIN_MENU.CURRENT_STATE) {
	        this.titleLiteral = link.title;
	      }
	
	      this.stateMainMenu = STATES_MAIN_MENU.CURRENT_STATE;
	    }
	  }, {
	    key: 'showMenuButton',
	    value: function showMenuButton() {
	      return this.linkMatch;
	    }
	  }, {
	    key: 'showBackButton',
	    value: function showBackButton() {
	      return this.fromMatch || this.altMatch;
	    }
	  }, {
	    key: 'onOverlayClick',
	    value: function onOverlayClick() {
	      if (!this.isClosing) {
	        this.closeMenu();
	        this.hideOverlay();
	      }
	    }
	  }, {
	    key: 'toggleOpen',
	    value: function toggleOpen() {
	      this.menuOpened = !this.menuOpened;
	      this.menuOpened ? this.showOverlay() : this.hideOverlay();
	    }
	  }, {
	    key: 'closeMenu',
	    value: function closeMenu() {
	      this.button.click();
	      this.hideOverlay();
	    }
	  }, {
	    key: 'showOverlay',
	    value: function showOverlay() {
	      this.html.addClass('mobile-overflow');
	      this.body.addClass('mobile-overflow');
	      this.overlay.addClass('fade-in');
	      this.movileNav.removeClass('fade-out');
	      this.menuOpened = true;
	      this.isClosing = false;
	      this.overlay.show();
	    }
	  }, {
	    key: 'hideOverlay',
	    value: function hideOverlay() {
	      var _this6 = this;
	
	      this.html.removeClass('mobile-overflow');
	      this.body.removeClass('mobile-overflow');
	      this.movileNav.addClass('fade-out');
	      this.overlay.removeClass('fade-in');
	      this.menuOpened = false;
	      this.isClosing = true;
	      this.timeout(function () {
	        if (_this6.menuOpened === false) {
	          _this6.overlay.hide();
	          _this6.isClosing = false;
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      if (this.mainMenuMobileBehaviourService.hasCustomBehaviour()) {
	        try {
	          this.mainMenuMobileBehaviourService.invoke();
	        } catch (err) {
	          this.visitedPagesService.subtractPageToCounter();
	          this.window.history.back();
	        }
	        this.mainMenuMobileBehaviourService.clean();
	      } else {
	        this.visitedPagesService.subtractPageToCounter();
	        var params = this.location.search() || {};
	        delete params.from;
	        this.location.search(params);
	        this.window.history.back();
	      }
	    }
	  }, {
	    key: 'getCssLink',
	    value: function getCssLink(link) {
	      var query = this.location.search() || {};
	      var from = query.from || '';
	      return {
	        'alt-active': link.target === this.state.current.name || link.altStates.includes(this.state.current.name) || link.target.includes(from) || link.fromStates.includes(from)
	      };
	    }
	  }, {
	    key: 'goToChangeEmployee',
	    value: function goToChangeEmployee() {
	      this.closeMenu();
	      $(_constants.MODALS.DEV_CHANGE_EMPLOYEE_MOBILE).modal('show');
	    }
	  }, {
	    key: 'onLogout',
	    value: function onLogout() {
	      this.authenticationService.pluginLogout();
	    }
	  }, {
	    key: 'getCssVersion',
	    value: function getCssVersion() {
	      return {
	        'warning': this.isDev
	      };
	    }
	  }, {
	    key: 'changeStateVacationsToMobile',
	    value: function changeStateVacationsToMobile() {
	      if (this.isMobileApp && this.state.current.name === _states.STATES.VACATIONS_ABSENCES.MY_VACATIONS) {
	        this.state.go(_states.STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE, { dateToLoad: this.dateToLoad });
	      }
	    }
	  }, {
	    key: 'overlay',
	    get: function get() {
	      return angular.element(document.querySelector('main-menu-mobile .overlay'));
	    }
	  }, {
	    key: 'html',
	    get: function get() {
	      return angular.element(document.querySelector('html'));
	    }
	  }, {
	    key: 'body',
	    get: function get() {
	      return angular.element(document.querySelector('body'));
	    }
	  }, {
	    key: 'button',
	    get: function get() {
	      return angular.element(document.querySelector('main-menu-mobile .menu-toggle input'));
	    }
	  }, {
	    key: 'movileNav',
	    get: function get() {
	      return angular.element('#mobile-nav');
	    }
	  }, {
	    key: 'inputMenuToggle',
	    get: function get() {
	      return angular.element('#inputMenuToggle');
	    }
	  }]);
	  return MainMenuMobileController;
	}();
	
	exports.default = MainMenuMobileController;

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MODULE_ID = 'VU';
	
	var BIRTH_OF_CHILDREN_CATALOGATION_CODE = '004';
	var MATERNITY_CODE = 'MAT';
	var PATERNITY_CODE = 'PAT';
	var PATERNITY_SECOND_PERIOD_CODE = 'PA5';
	var MATERNITY_SECOND_PERIOD_CODE = 'MA5';
	
	var VA_SWITCH_CONFIG = [{
	  text: 'VACATIONS_ABSENCES.GENERAL.VACATIONS',
	  value: 'vacation'
	}, {
	  text: 'VACATIONS_ABSENCES.GENERAL.ABSENCE',
	  value: 'absence'
	}];
	
	var COOKIES = {
	  MODAL_WARNING_DELEGATION: 'dontShowModalDelegation'
	};
	
	var VA_MY_VACATIONS_MODAL_COACHMARK_CONFIG = {
	  module: 'VA',
	  tab: 'myVacations',
	  state: 'my-vacations',
	  title: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.TITLE',
	  subtitles: [{
	    text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP0'
	  }, {
	    text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP1'
	  }, {
	    text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP2'
	  }, {
	    text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP3'
	  }, {
	    text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP4'
	  }, {
	    text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP5'
	  }, {
	    text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP6'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/vacations-absences/01-MV/01.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/vacations-absences/01-MV/02.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/vacations-absences/01-MV/03.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/vacations-absences/01-MV/04.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/vacations-absences/01-MV/05.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/vacations-absences/01-MV/06.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/vacations-absences/01-MV/07.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var VA_TEAM_REQUESTS_MODAL_COACHMARK_CONFIG = {
	  module: 'VA',
	  tab: 'teamRequests',
	  state: 'team-requests',
	  title: 'VACATIONS_ABSENCES.COACHMARK.TEAM_REQUESTS.TITLE',
	  subtitles: [{
	    text: 'VACATIONS_ABSENCES.COACHMARK.TEAM_REQUESTS.STEP0'
	  }, {
	    text: 'VACATIONS_ABSENCES.COACHMARK.TEAM_REQUESTS.STEP1'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/vacations-absences/02-TR/01.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/vacations-absences/02-TR/02.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var VA_TEAM_CALENDAR_MODAL_COACHMARK_CONFIG = {
	  module: 'VA',
	  tab: 'teamCalendar',
	  state: 'team-calendar',
	  title: 'VACATIONS_ABSENCES.COACHMARK.TEAM_CALENDAR.TITLE',
	  subtitles: [{
	    text: 'VACATIONS_ABSENCES.COACHMARK.TEAM_CALENDAR.STEP0'
	  }, {
	    text: 'VACATIONS_ABSENCES.COACHMARK.TEAM_CALENDAR.STEP1'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/vacations-absences/03-TC/01.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/vacations-absences/03-TC/02.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var VA_DELEGATIONS_MODAL_COACHMARK_CONFIG = {
	  module: 'VA',
	  tab: 'delegations',
	  state: 'delegations',
	  title: 'VACATIONS_ABSENCES.COACHMARK.DELEGATIONS.TITLE',
	  subtitles: [{
	    text: 'VACATIONS_ABSENCES.COACHMARK.DELEGATIONS.STEP0'
	  }, {
	    text: 'VACATIONS_ABSENCES.COACHMARK.DELEGATIONS.STEP1'
	  }, {
	    text: 'VACATIONS_ABSENCES.COACHMARK.DELEGATIONS.STEP2'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/vacations-absences/04-PD/01.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/vacations-absences/04-PD/02.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/vacations-absences/04-PD/03.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var RESOLUTION = {
	  DESKTOP: 1200
	};
	
	var SINDICAL_REPRESENTATION_HOURS_CODE = 'CS1';
	
	var MAX_HOURS = {
	  SINDICAL_REPRESENTATION: 9.75,
	  GENERAL_HOURLY_ABSENCES: 7
	};
	
	var REQUEST_ERRORS = {
	  DATE: 'FECHAS_PARTE_INCORRECTAS',
	  COLEGIATE: '0NUU02',
	  DATE_OVERLAP: 'W8AG24',
	  NO_FUTURE: 'ERROR_AUSENCIA_NOFUTURO',
	  BAD_REQUEST: 400
	};
	
	exports.MODULE_ID = MODULE_ID;
	exports.BIRTH_OF_CHILDREN_CATALOGATION_CODE = BIRTH_OF_CHILDREN_CATALOGATION_CODE;
	exports.PATERNITY_CODE = PATERNITY_CODE;
	exports.PATERNITY_SECOND_PERIOD_CODE = PATERNITY_SECOND_PERIOD_CODE;
	exports.MATERNITY_SECOND_PERIOD_CODE = MATERNITY_SECOND_PERIOD_CODE;
	exports.MATERNITY_CODE = MATERNITY_CODE;
	exports.VA_SWITCH_CONFIG = VA_SWITCH_CONFIG;
	exports.COOKIES = COOKIES;
	exports.VA_MY_VACATIONS_MODAL_COACHMARK_CONFIG = VA_MY_VACATIONS_MODAL_COACHMARK_CONFIG;
	exports.VA_TEAM_CALENDAR_MODAL_COACHMARK_CONFIG = VA_TEAM_CALENDAR_MODAL_COACHMARK_CONFIG;
	exports.VA_TEAM_REQUESTS_MODAL_COACHMARK_CONFIG = VA_TEAM_REQUESTS_MODAL_COACHMARK_CONFIG;
	exports.VA_DELEGATIONS_MODAL_COACHMARK_CONFIG = VA_DELEGATIONS_MODAL_COACHMARK_CONFIG;
	exports.RESOLUTION = RESOLUTION;
	exports.SINDICAL_REPRESENTATION_HOURS_CODE = SINDICAL_REPRESENTATION_HOURS_CODE;
	exports.MAX_HOURS = MAX_HOURS;
	exports.REQUEST_ERRORS = REQUEST_ERRORS;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Swipe = function () {
	  function Swipe(element) {
	    (0, _classCallCheck3.default)(this, Swipe);
	
	    this.xDown = null;
	    this.yDown = null;
	    this.element = typeof element === 'string' ? document.querySelector(element) : element;
	
	    this.element.addEventListener('touchstart', function (evt) {
	      this.xDown = evt.touches[0].clientX;
	      this.yDown = evt.touches[0].clientY;
	    }.bind(this), false);
	  }
	
	  (0, _createClass3.default)(Swipe, [{
	    key: 'onLeft',
	    value: function onLeft(callback) {
	      this.onLeft = callback;
	      return this;
	    }
	  }, {
	    key: 'onRight',
	    value: function onRight(callback) {
	      this.onRight = callback;
	      return this;
	    }
	  }, {
	    key: 'onUp',
	    value: function onUp(callback) {
	      this.onUp = callback;
	      return this;
	    }
	  }, {
	    key: 'onDown',
	    value: function onDown(callback) {
	      this.onDown = callback;
	      return this;
	    }
	  }, {
	    key: 'handleTouchMove',
	    value: function handleTouchMove(evt) {
	      if (!this.xDown || !this.yDown) {
	        return;
	      }
	
	      var xUp = evt.touches[0].clientX;
	      var yUp = evt.touches[0].clientY;
	
	      this.xDiff = this.xDown - xUp;
	      this.yDiff = this.yDown - yUp;
	
	      if (Math.abs(this.xDiff) > Math.abs(this.yDiff)) {
	        // Most significant.
	        if (this.xDiff > 0) {
	          if (typeof this.onLeft === 'function') this.onLeft(evt);
	        } else {
	          if (typeof this.onRight === 'function') this.onRight(evt);
	        }
	      } else {
	        if (this.yDiff > 0) {
	          if (typeof this.onUp === 'function') this.onUp(evt);
	        } else {
	          if (typeof this.onDown === 'function') this.onDown(evt);
	        }
	      }
	
	      // Reset values.
	      this.xDown = null;
	      this.yDown = null;
	    }
	  }, {
	    key: 'run',
	    value: function run() {
	      this.element.addEventListener('touchmove', function (evt) {
	        this.handleTouchMove(evt);
	      }.bind(this), false);
	    }
	  }]);
	  return Swipe;
	}();
	
	exports.default = Swipe;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(726);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./mainMenuMobile.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./mainMenuMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "main-menu-mobile{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;position:fixed;top:0;left:0;background-color:#fff;z-index:9999}main-menu-mobile.focus-fixed{position:absolute}main-menu-mobile.focus-fixed .menu{display:none}main-menu-mobile .fade-in{animation:fade_navbar 1s}main-menu-mobile .fade-out{animation:fade_navbar_out 1s}main-menu-mobile nav{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:100vw;height:60px;border-bottom:1px solid #dddfe2;position:relative}main-menu-mobile nav .back-button{position:relative;width:40px;padding-left:10px}main-menu-mobile nav .back-button .icon{color:#dddfe2;cursor:pointer;display:inline-block;font-size:20px;transform:rotate(90deg)}main-menu-mobile nav h1{font-family:Stag Sans;text-align:center;font-size:18px;margin:0;padding:5px 0 0;color:#0072c9;font-weight:400}main-menu-mobile nav .menu-toggle-wrapper{width:40px}main-menu-mobile .menu-toggle{display:block;z-index:9999;-webkit-user-select:none;user-select:none}main-menu-mobile .menu-toggle input{display:block;top:0;right:0;margin-top:0;width:60px;height:60px;position:absolute;cursor:pointer;opacity:0;z-index:10000;-webkit-touch-callout:none}main-menu-mobile .menu-toggle input:checked~span{opacity:1;transform:rotate(45deg) translateY(1px);background-color:#979797}main-menu-mobile .menu-toggle input:checked~span:nth-last-child(3){opacity:0;transform:rotate(0deg) scale(.2)}main-menu-mobile .menu-toggle input:checked~span:nth-last-child(2){opacity:1;transform:rotate(-45deg) translateY(-1px)}main-menu-mobile .menu-toggle input:checked~div ul{transform:scale(1);opacity:1}main-menu-mobile .menu-toggle span{width:20px;height:2px;margin-bottom:4px;position:relative;border-radius:3px;z-index:10000;transform-origin:4px 0;transition:transform .5s cubic-bezier(.77,.2,.05,1),background .5s cubic-bezier(.77,.2,.05,1),opacity .55s ease}main-menu-mobile .menu-toggle span.icon{display:block;background-color:#979797;pointer-events:none}main-menu-mobile .menu-toggle span.icon.icon-warning{margin:0;width:auto;height:auto;background-color:#fff;font-size:24px;color:#c8175e;line-height:60px;display:inline-block;float:right}main-menu-mobile .menu-toggle span.icon.menu-opened{display:none}main-menu-mobile .menu-toggle span:first-child{transform-origin:0 0}main-menu-mobile .menu-toggle span:nth-last-child(2){transform-origin:0 100%;margin-bottom:0}main-menu-mobile .overlay{z-index:9999;display:none;position:fixed;width:100vh;height:100vh;background-color:#2a86ca;top:0;left:0;opacity:1}main-menu-mobile .menu{z-index:9999;position:absolute;top:0;right:0;width:270px;height:100vh;padding:0;list-style-type:none;-webkit-font-smoothing:antialiased;transform-origin:0 0;transform:translate(100%);transition:transform .5s cubic-bezier(.77,.2,.05,1);background-color:#f9f9f9}main-menu-mobile .menu li{height:60px;line-height:60px;width:100%;text-align:left;border-bottom:1px solid #eaebed}main-menu-mobile .menu li.alt-active a{color:#0072c9}main-menu-mobile .menu li.menu-title{background-color:#fff;font-family:Stag Sans;font-size:15px;line-height:17px;text-transform:uppercase;padding:0 40px 0 20px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}main-menu-mobile .menu li.menu-title .menu-title-name{margin-left:8px}main-menu-mobile .menu li.version-info{position:fixed;bottom:0;padding:0 20px;border-top:1px solid #dddfe2;color:#aeaeae;font-size:13px;background-color:#fff}main-menu-mobile .menu li.warning{color:#c8175e!important;border-top:1px solid #c8175e!important;border-bottom:1px solid #c8175e}main-menu-mobile .menu li.warning a{color:#c8175e}main-menu-mobile .menu a{font-family:Stag Sans;font-size:15px;background-color:#fff;height:100%;width:100%;display:block;text-transform:uppercase;padding:0 20px;color:#666}main-menu-mobile .menu a:focus,main-menu-mobile .menu a:hover{text-decoration:none}main-menu-mobile .menu a span.menu-badge{position:relative;float:right;background-color:#0072c9;color:#f9f9f9;border-radius:100%;width:24px;height:24px;line-height:26px;margin-top:15px;text-align:center;font-size:14px}@keyframes fade_navbar{0%{opacity:0}to{opacity:1}}@keyframes fade_navbar_out{0%{opacity:1}to{opacity:0}}", ""]);
	
	// exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _devChangeEmployeeMobile = __webpack_require__(728);
	
	var _devChangeEmployeeMobile2 = _interopRequireDefault(_devChangeEmployeeMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var devChangeEmployeeMobileModule = angular.module('components.devChangeEmployeeMobile', []).component('devChangeEmployeeMobile', _devChangeEmployeeMobile2.default).name;
	
	exports.default = devChangeEmployeeMobileModule;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _devChangeEmployeeMobile = __webpack_require__(729);
	
	var _devChangeEmployeeMobile2 = _interopRequireDefault(_devChangeEmployeeMobile);
	
	var _devChangeEmployeeMobile3 = __webpack_require__(730);
	
	var _devChangeEmployeeMobile4 = _interopRequireDefault(_devChangeEmployeeMobile3);
	
	__webpack_require__(731);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var devChangeEmployeeMobileComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _devChangeEmployeeMobile2.default,
	  controller: _devChangeEmployeeMobile4.default
	};
	
	exports.default = devChangeEmployeeMobileComponent;

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal responsiveMobile\" id=\"devChangeEmployeeMobile\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalMyLoansLabel\">\n<div class=\"modal responsiveMobile\" id=\"devChangeEmployeeMobile\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalMyLoansLabel\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n      <div class=\"modal-header text-center\">\n        <span class=\"icon-warning\"></span>\n        <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n        <h4 class=\"modal-title\">\n          {{\"INDEX.ENV_OF\" | translate}} {{$ctrl.env}}\n        </h4>\n      </div>\n\n      <div class=\"modal-body\">\n        <div class=\"modal-subtitle text-center\">\n          <h4 class=\"modal-title\">\n            {{\"INDEX.CHANGE_EMPLOYEE\" | translate}}\n          </h4>\n        </div>\n\n        <div class=\"form-content\">\n          <div class=\"form-group\">\n            <label for=\"employeeId\">\n              {{\"INDEX.ACTUAL_EMPLOYEE_ENROLLMENT\" | translate}}\n            </label>\n            <input\n              id=\"employeeId\"\n              type=\"text\"\n              pattern=\"[0-9]*\"\n              name=\"employeeId\"\n              class=\"mobile\"\n              ng-model=\"$ctrl.employeeId\">\n          </div>\n        </div>\n\n        <floating-action-buttons\n          buttons=\"$ctrl.floatingActionButtons\"\n          on-click-first-button=\"$ctrl.changeUser()\"\n          on-click-second-button=\"$ctrl.cancel()\">\n        </floating-action-buttons>\n      </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _authentication = __webpack_require__(557);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DevChangeEmployeeMobileController = function () {
	  DevChangeEmployeeMobileController.$inject = ["$cookies", "$window", "$state", "entryPoint"];
	  function DevChangeEmployeeMobileController($cookies, $window, $state, entryPoint) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DevChangeEmployeeMobileController);
	    this.cookies = $cookies;
	    this.window = $window;
	    this.state = $state;
	    this.entryPoint = entryPoint;
	
	    this.initUser();
	    this.floatingActionButtons = this.getFloatingActionButtons();
	    this.env = _constants.ENVIRONMENTS[("dev")];
	  }
	
	  (0, _createClass3.default)(DevChangeEmployeeMobileController, [{
	    key: 'initUser',
	    value: function initUser() {
	      this.employeeId = this.cookies.get('userId') ? this.cookies.get('userId') : _authentication.DEFAULT_USER;
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.initUser();
	      this.hideModal();
	    }
	  }, {
	    key: 'changeUser',
	    value: function changeUser() {
	      this.cookies.put('userId', this.employeeId);
	      this.state.go(this.entryPoint);
	      this.hideModal();
	      this.window.location.reload();
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.SAVE'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }, {
	    key: 'hideModal',
	    value: function hideModal() {
	      $('.modal').modal('hide');
	    }
	  }]);
	  return DevChangeEmployeeMobileController;
	}();
	
	exports.default = DevChangeEmployeeMobileController;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(732);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./devChangeEmployeeMobile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./devChangeEmployeeMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "dev-change-employee-mobile .modal-content .modal-header{border-bottom:1px solid #dddfe2}dev-change-employee-mobile .modal-content .modal-header .icon-warning{color:#c8175e;display:block;font-size:77px;height:76px;margin:0 auto 22px;width:76px}dev-change-employee-mobile .modal-content .modal-header h4{color:#c8175e!important;padding-bottom:10px}dev-change-employee-mobile .modal-content .modal-body .modal-subtitle h4{font-family:Stag Sans;font-weight:400;color:#0072c9!important;font-size:20px;margin-top:20px}dev-change-employee-mobile .modal-content .modal-body .form-group{min-height:300px}dev-change-employee-mobile .modal-content .modal-body .form-group label{color:#0072c9;font-family:Stag Sans;font-weight:400;font-size:16px;line-height:18px;margin-top:40px;margin-bottom:20px}dev-change-employee-mobile .modal-content .modal-body .form-group input{height:60px;border-color:#dddfe2;border-radius:2px;font-size:24px;padding-left:12px;width:100%}dev-change-employee-mobile .modal-content .modal-body .form-group input:focus{border-color:#0072c9}", ""]);
	
	// exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainMenuMobileBehaviourService = function () {
	  function MainMenuMobileBehaviourService() {
	    (0, _classCallCheck3.default)(this, MainMenuMobileBehaviourService);
	
	    this.func = null;
	  }
	
	  (0, _createClass3.default)(MainMenuMobileBehaviourService, [{
	    key: 'setCustomBehaviour',
	    value: function setCustomBehaviour(func) {
	      this.func = func;
	    }
	  }, {
	    key: 'hasCustomBehaviour',
	    value: function hasCustomBehaviour() {
	      return this.func !== null;
	    }
	  }, {
	    key: 'clean',
	    value: function clean() {
	      this.func = null;
	    }
	  }, {
	    key: 'invoke',
	    value: function invoke() {
	      if (typeof this.func === 'function') {
	        this.func();
	      }
	    }
	  }]);
	  return MainMenuMobileBehaviourService;
	}();
	
	exports.default = MainMenuMobileBehaviourService;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loading = __webpack_require__(735);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loadingModule = angular.module('loading', []).component('loading', _loading2.default).name;
	
	exports.default = loadingModule;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loading = __webpack_require__(736);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _loading3 = __webpack_require__(737);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	__webpack_require__(738);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loadingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _loading2.default,
	  controller: _loading4.default
	};
	
	exports.default = loadingComponent;

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loading\">\n  <img src=\"img/loading-bbva.gif\">\n</div>\n"

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadingController = function LoadingController() {
	  (0, _classCallCheck3.default)(this, LoadingController);
	};
	
	exports.default = LoadingController;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(739);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./loading.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./loading.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loading{display:block;position:relative;top:110px;height:100%}loading .loading{display:flex;height:100%;width:100%}loading img{margin-left:auto;margin-right:auto;width:60px;height:60px}", ""]);
	
	// exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _table = __webpack_require__(741);
	
	var _table2 = _interopRequireDefault(_table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tableModule = _angular2.default.module('table', []).component('tableApp', _table2.default).name;
	
	exports.default = tableModule;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _table = __webpack_require__(742);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _table3 = __webpack_require__(743);
	
	var _table4 = _interopRequireDefault(_table3);
	
	__webpack_require__(746);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tableComponent = {
	  restrict: 'E',
	  bindings: {
	    data: '<'
	  },
	  template: _table2.default,
	  controller: _table4.default
	};
	
	exports.default = tableComponent;

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"table-responsive\">\n  <table class=\"table\" ng-style=\"$ctrl.getTableStyle($ctrl.data)\">\n    <thead>\n    <tr>\n      <th ng-style=\"$ctrl.getThStyle(header)\" ng-repeat=\"header in $ctrl.data.headers track by $index\">\n        <span ng-if=\"header.translate\">\n          {{ header.text | translate }}\n        </span>\n        <span ng-if=\"!header.translate\">\n          {{ header.text }}\n        </span>\n        <span\n          ng-init=\"$ctrl.tooltip()\"\n          ng-if=\"header.tooltip\"\n          class=\"icon icon-interrogation-color\"\n          data-toggle=\"tooltip\"\n          data-placement=\"bottom\"\n          title=\"{{ header.tooltip | translate }}\">\n        </span>\n      </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"row in $ctrl.data.rows track by $index\">\n      <td ng-repeat=\"cell in row\">\n        <span ng-if=\"!cell.translate && !cell.currency\">\n          {{ cell.text }}\n        </span>\n        <span ng-if=\"cell.translate\">\n          {{ cell.text | translate }}\n        </span>\n        <span ng-if=\"cell.currency\">{{ cell.text | currency }}</span>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _tooltip = __webpack_require__(744);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableController = function () {
	  function TableController() {
	    (0, _classCallCheck3.default)(this, TableController);
	
	    this.tooltip = _tooltip2.default;
	  }
	
	  (0, _createClass3.default)(TableController, [{
	    key: 'getTableStyle',
	    value: function getTableStyle(config) {
	      var style = {};
	      if (config.fullWidth) {
	        style.width = '100%';
	      }
	      return style;
	    }
	  }, {
	    key: 'getThStyle',
	    value: function getThStyle(header) {
	      var style = {};
	      if (header.width) {
	        style.width = header.width;
	        style.maxWidth = header.width;
	      }
	      return style;
	    }
	  }]);
	  return TableController;
	}();
	
	exports.default = TableController;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = tooltip;
	
	var _isMobile = __webpack_require__(745);
	
	var _isMobile2 = _interopRequireDefault(_isMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function tooltip() {
	  $(function () {
	    $('[data-toggle="tooltip"]').tooltip().on('shown.bs.tooltip', function () {
	      if ((0, _isMobile2.default)()) $('body').css('cursor', 'pointer');
	    }).on('hide.bs.tooltip', function () {
	      if ((0, _isMobile2.default)()) $('body').css('cursor', 'auto');
	    });
	  });
	}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return window.isMobileApp || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(747);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./table.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "table-app{display:block}table-app .table-responsive{border:0}table-app .table{width:auto;table-layout:fixed;margin-bottom:10px}table-app .table thead tr th{color:#666;font-family:Stag Sans;font-size:15px;font-weight:400;border-bottom:2px solid #dddfe2;border-right:2px solid #dddfe2;padding:0 15px 10px;text-align:center;white-space:nowrap;text-transform:uppercase}table-app .table thead tr th .icon.icon-interrogation-color{display:inline-block;margin-left:6px;font-size:19px;vertical-align:middle;margin-bottom:4px;font-weight:400}table-app .table thead tr th:first-of-type{text-align:left;padding-left:0}table-app .table tbody tr:last-of-type td{padding-bottom:25px}table-app .table tbody tr td{color:#666;font-family:Stag Sans;font-size:15px;font-weight:400;border-right:2px solid #dddfe2;border-top:0;padding:27px 25px 0 0;text-align:right;white-space:nowrap}table-app .table tbody tr td:first-of-type{text-align:left}", ""]);
	
	// exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _delegationsList = __webpack_require__(749);
	
	var _delegationsList2 = _interopRequireDefault(_delegationsList);
	
	var _delegationCard = __webpack_require__(754);
	
	var _delegationCard2 = _interopRequireDefault(_delegationCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegationsListModule = _angular2.default.module('delegationsList', [_delegationCard2.default]).component('delegationsList', _delegationsList2.default).name;
	
	exports.default = delegationsListModule;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _delegationsList = __webpack_require__(750);
	
	var _delegationsList2 = _interopRequireDefault(_delegationsList);
	
	var _delegationsList3 = __webpack_require__(751);
	
	var _delegationsList4 = _interopRequireDefault(_delegationsList3);
	
	__webpack_require__(752);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegationsListComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    openDelegationModal: '&',
	    delegations: '<'
	  },
	  template: _delegationsList2.default,
	  controller: _delegationsList4.default
	};
	
	exports.default = delegationsListComponent;

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports = "<div\n  ng-if=\"!$ctrl.isMobileApp\"\n  class=\"create-delegation-container\">\n  <button\n    type=\"button\"\n    class=\"btn btn-app btn-primary right-aligned\"\n    ng-click=\"$ctrl.openModal()\"\n  >\n    {{ 'GLOBALS.BUTTON_ACTION.CREATE_DELEGATION' | translate }}\n  </button>\n</div>\n\n<div ng-repeat=\"delegation in $ctrl.delegations\">\n  <delegation-card\n    card-id=\"delegation-card-{{$index}}\"\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    delegation-info=\"delegation\"\n    on-cancel=\"$ctrl.cancel($event)\"\n    on-edit=\"$ctrl.edit($event)\">\n  </delegation-card>\n</div>\n\n<div class=\"list-empty\"\n     ng-if=\"$ctrl.isEmpty()\"\n     ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <span class=\"icon-warning\"></span>\n  <br ng-if=\"$ctrl.isMobileApp\">\n  <span>{{'GLOBALS.EMPTY_REQUESTS_DELEGATION' | translate}}</span>\n</div>\n\n<floating-action-buttons\n  ng-if=\"$ctrl.isMobileApp\"\n  buttons=\"$ctrl.floatingActionButtons\"\n  on-click-first-button=\"$ctrl.openModal()\">\n</floating-action-buttons>\n"

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DelegationsListController = function () {
	  DelegationsListController.$inject = ["EventEmitter"];
	  function DelegationsListController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DelegationsListController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(DelegationsListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.initFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.openDelegationModal(this.EventEmitter({ action: _constants.DELEGATION_STATES.CREATE }));
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(_ref) {
	      var delegation = _ref.delegation;
	
	      this.openDelegationModal(this.EventEmitter({ action: _constants.DELEGATION_STATES.CANCEL, delegation: delegation }));
	    }
	  }, {
	    key: 'edit',
	    value: function edit(_ref2) {
	      var delegation = _ref2.delegation;
	
	      this.openDelegationModal(this.EventEmitter({ action: _constants.DELEGATION_STATES.EDIT, delegation: delegation }));
	    }
	  }, {
	    key: 'isEmpty',
	    value: function isEmpty() {
	      if (!this.delegations) return true;
	      return !this.delegations.length;
	    }
	  }, {
	    key: 'initFloatingActionButtons',
	    value: function initFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.CREATE_DELEGATION'
	      }];
	    }
	  }]);
	  return DelegationsListController;
	}();
	
	exports.default = DelegationsListController;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(753);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./delegationsList.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./delegationsList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "delegations-list{width:100%}delegations-list .create-delegation-container{float:right;margin-top:15px;margin-bottom:15px}delegations-list .right-aligned{float:right}delegations-list .card-container{margin-bottom:5px;margin-top:5px}delegations-list .list-empty{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}delegations-list .list-empty.responsiveMobile{margin-top:120px;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;padding-bottom:10px;border-bottom:1px solid #dddfe2}delegations-list .list-empty.responsiveMobile .icon-warning{margin-right:0}delegations-list .list-empty.shown-filter{margin-top:0}delegations-list .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _delegationCard = __webpack_require__(755);
	
	var _delegationCard2 = _interopRequireDefault(_delegationCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegationCardModule = _angular2.default.module('delegationCard', []).component('delegationCard', _delegationCard2.default).name;
	
	exports.default = delegationCardModule;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _delegationCard = __webpack_require__(756);
	
	var _delegationCard2 = _interopRequireDefault(_delegationCard);
	
	var _delegationCard3 = __webpack_require__(757);
	
	var _delegationCard4 = _interopRequireDefault(_delegationCard3);
	
	__webpack_require__(898);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegationCardComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    employeeWithPower: '<',
	    delegationInfo: '<',
	    onCancel: '&',
	    onEdit: '&',
	    cardId: '@'
	  },
	  template: _delegationCard2.default,
	  controller: _delegationCard4.default
	};
	
	exports.default = delegationCardComponent;

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"card-container {{$ctrl.cardId}} swipe-container\" ng-class=\"$ctrl.getClasses()\">\n  <div class=\"user-info-avatar\">\n    <avatar-app email=\"$ctrl.delegationInfo.email\" name=\"$ctrl.delegationInfo.name\" user-id=\"$ctrl.delegationInfo.userId\"></avatar-app>\n  </div>\n\n  <div class=\"user-info-text\">\n    <employee-name name=\"{{$ctrl.delegationInfo.name}}\" enrollment=\"{{$ctrl.delegationInfo.employeeId}}\"></employee-name>\n\n    <div class=\"requested-date\">\n      <span class=\"period\" ng-if=\"!$ctrl.isMobileApp\">{{::$ctrl.startDate}} - {{::$ctrl.endDate}}</span>\n      <span class=\"period\" ng-if=\"$ctrl.isMobileApp\">{{::$ctrl.startDate}} <br> {{::$ctrl.endDate}}</span>\n      <span class=\"days\">\n        {{::$ctrl.request.enjoymentDays}}\n      </span>\n      <p class=\"delegation-type\">{{::$ctrl.permissionType}}</p>\n      <div class=\"line\" ng-if=\"!$ctrl.isMobileApp\"></div>\n    </div>\n  </div>\n\n  <div class=\"buttons-container\" ng-if=\"!$ctrl.isMobileApp\">\n    <div class=\"request-reject-accept\">\n      <button type=\"button\" class=\"btn btn-app btn-default\"\n              ng-click=\"$ctrl.onCancel({$event: {delegation: $ctrl.delegationInfo}})\">\n              {{'GLOBALS.BUTTON_ACTION.CANCEL' | translate}}\n      </button>\n      <button type=\"button\" class=\"btn btn-app btn-primary\"\n              ng-click=\"$ctrl.onEdit({$event: {delegation: $ctrl.delegationInfo}})\">\n              {{'GLOBALS.BUTTON_ACTION.EDIT' | translate}}\n      </button>\n    </div>\n  </div>\n\n  <div class=\"mobile-buttons-container\" ng-if=\"$ctrl.isMobileApp\">\n    <div class=\"swipe-button remove\" ng-click=\"$ctrl.onCancel({$event: {delegation: $ctrl.delegationInfo}})\">\n      <span class=\"icon-cross-white\"></span>\n    </div>\n    <div class=\"swipe-button edit\" ng-click=\"$ctrl.onEdit({$event: {delegation: $ctrl.delegationInfo}})\">\n      <span class=\"icon-icon-edit\"><span class=\"path1\"></span><span class=\"path2\"></span></span>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(598);
	
	var _swipe = __webpack_require__(724);
	
	var _swipe2 = _interopRequireDefault(_swipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MANAGER_PERMISSION = 'A';
	
	var DelegationCardController = function () {
	  DelegationCardController.$inject = ["$timeout"];
	  function DelegationCardController($timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DelegationCardController);
	    this.timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(DelegationCardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.startDate = this.formatDate(this.delegationInfo.startDate);
	      this.endDate = this.formatDate(this.delegationInfo.endDate);
	      this._initType();
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      var _this = this;
	
	      if (this.isMobileApp) {
	        this.timeout(function () {
	          _this.initSwipe();
	        });
	      }
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        responsiveMobile: this.isMobileApp,
	        swiped: this.swiped
	      };
	    }
	  }, {
	    key: 'initSwipe',
	    value: function initSwipe() {
	      var _this2 = this;
	
	      var swiper = new _swipe2.default(this.getDelegationCardSelector());
	      swiper.onLeft(function () {
	        return _this2.onSwipeLeft();
	      });
	      swiper.onRight(function () {
	        return _this2.onSwipeRight();
	      });
	      swiper.run();
	    }
	  }, {
	    key: 'getDelegationCardSelector',
	    value: function getDelegationCardSelector() {
	      return 'delegation-card .' + this.cardId;
	    }
	  }, {
	    key: 'onSwipeRight',
	    value: function onSwipeRight() {
	      var _this3 = this;
	
	      this.timeout(function () {
	        _this3.swiped = false;
	      });
	    }
	  }, {
	    key: 'onSwipeLeft',
	    value: function onSwipeLeft() {
	      var _this4 = this;
	
	      this.timeout(function () {
	        _this4.swiped = true;
	      });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
	
	      _moment2.default.locale(lang);
	      var result = (0, _moment2.default)(date).format('dddd DD MMMM YYYY');
	      return result;
	    }
	  }, {
	    key: '_initType',
	    value: function _initType() {
	      if (!this.delegationInfo.type) return;
	      if (this.delegationInfo.type === MANAGER_PERMISSION) {
	        this.permissionType = _constants.USEROLES.MANAGER;
	      } else {
	        this.permissionType = _constants.USEROLES.USER;
	      }
	    }
	  }]);
	  return DelegationCardController;
	}();
	
	exports.default = DelegationCardController;

/***/ }),
/* 758 */,
/* 759 */,
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 761,
		"./af.js": 761,
		"./ar": 762,
		"./ar-dz": 763,
		"./ar-dz.js": 763,
		"./ar-kw": 764,
		"./ar-kw.js": 764,
		"./ar-ly": 765,
		"./ar-ly.js": 765,
		"./ar-ma": 766,
		"./ar-ma.js": 766,
		"./ar-ps": 767,
		"./ar-ps.js": 767,
		"./ar-sa": 768,
		"./ar-sa.js": 768,
		"./ar-tn": 769,
		"./ar-tn.js": 769,
		"./ar.js": 762,
		"./az": 770,
		"./az.js": 770,
		"./be": 771,
		"./be.js": 771,
		"./bg": 772,
		"./bg.js": 772,
		"./bm": 773,
		"./bm.js": 773,
		"./bn": 774,
		"./bn-bd": 775,
		"./bn-bd.js": 775,
		"./bn.js": 774,
		"./bo": 776,
		"./bo.js": 776,
		"./br": 777,
		"./br.js": 777,
		"./bs": 778,
		"./bs.js": 778,
		"./ca": 779,
		"./ca.js": 779,
		"./cs": 780,
		"./cs.js": 780,
		"./cv": 781,
		"./cv.js": 781,
		"./cy": 782,
		"./cy.js": 782,
		"./da": 783,
		"./da.js": 783,
		"./de": 784,
		"./de-at": 785,
		"./de-at.js": 785,
		"./de-ch": 786,
		"./de-ch.js": 786,
		"./de.js": 784,
		"./dv": 787,
		"./dv.js": 787,
		"./el": 788,
		"./el.js": 788,
		"./en-au": 789,
		"./en-au.js": 789,
		"./en-ca": 790,
		"./en-ca.js": 790,
		"./en-gb": 791,
		"./en-gb.js": 791,
		"./en-ie": 792,
		"./en-ie.js": 792,
		"./en-il": 793,
		"./en-il.js": 793,
		"./en-in": 794,
		"./en-in.js": 794,
		"./en-nz": 795,
		"./en-nz.js": 795,
		"./en-sg": 796,
		"./en-sg.js": 796,
		"./eo": 797,
		"./eo.js": 797,
		"./es": 798,
		"./es-do": 799,
		"./es-do.js": 799,
		"./es-mx": 800,
		"./es-mx.js": 800,
		"./es-us": 801,
		"./es-us.js": 801,
		"./es.js": 798,
		"./et": 802,
		"./et.js": 802,
		"./eu": 803,
		"./eu.js": 803,
		"./fa": 804,
		"./fa.js": 804,
		"./fi": 805,
		"./fi.js": 805,
		"./fil": 806,
		"./fil.js": 806,
		"./fo": 807,
		"./fo.js": 807,
		"./fr": 808,
		"./fr-ca": 809,
		"./fr-ca.js": 809,
		"./fr-ch": 810,
		"./fr-ch.js": 810,
		"./fr.js": 808,
		"./fy": 811,
		"./fy.js": 811,
		"./ga": 812,
		"./ga.js": 812,
		"./gd": 813,
		"./gd.js": 813,
		"./gl": 814,
		"./gl.js": 814,
		"./gom-deva": 815,
		"./gom-deva.js": 815,
		"./gom-latn": 816,
		"./gom-latn.js": 816,
		"./gu": 817,
		"./gu.js": 817,
		"./he": 818,
		"./he.js": 818,
		"./hi": 819,
		"./hi.js": 819,
		"./hr": 820,
		"./hr.js": 820,
		"./hu": 821,
		"./hu.js": 821,
		"./hy-am": 822,
		"./hy-am.js": 822,
		"./id": 823,
		"./id.js": 823,
		"./is": 824,
		"./is.js": 824,
		"./it": 825,
		"./it-ch": 826,
		"./it-ch.js": 826,
		"./it.js": 825,
		"./ja": 827,
		"./ja.js": 827,
		"./jv": 828,
		"./jv.js": 828,
		"./ka": 829,
		"./ka.js": 829,
		"./kk": 830,
		"./kk.js": 830,
		"./km": 831,
		"./km.js": 831,
		"./kn": 832,
		"./kn.js": 832,
		"./ko": 833,
		"./ko.js": 833,
		"./ku": 834,
		"./ku-kmr": 835,
		"./ku-kmr.js": 835,
		"./ku.js": 834,
		"./ky": 836,
		"./ky.js": 836,
		"./lb": 837,
		"./lb.js": 837,
		"./lo": 838,
		"./lo.js": 838,
		"./lt": 839,
		"./lt.js": 839,
		"./lv": 840,
		"./lv.js": 840,
		"./me": 841,
		"./me.js": 841,
		"./mi": 842,
		"./mi.js": 842,
		"./mk": 843,
		"./mk.js": 843,
		"./ml": 844,
		"./ml.js": 844,
		"./mn": 845,
		"./mn.js": 845,
		"./mr": 846,
		"./mr.js": 846,
		"./ms": 847,
		"./ms-my": 848,
		"./ms-my.js": 848,
		"./ms.js": 847,
		"./mt": 849,
		"./mt.js": 849,
		"./my": 850,
		"./my.js": 850,
		"./nb": 851,
		"./nb.js": 851,
		"./ne": 852,
		"./ne.js": 852,
		"./nl": 853,
		"./nl-be": 854,
		"./nl-be.js": 854,
		"./nl.js": 853,
		"./nn": 855,
		"./nn.js": 855,
		"./oc-lnc": 856,
		"./oc-lnc.js": 856,
		"./pa-in": 857,
		"./pa-in.js": 857,
		"./pl": 858,
		"./pl.js": 858,
		"./pt": 859,
		"./pt-br": 860,
		"./pt-br.js": 860,
		"./pt.js": 859,
		"./ro": 861,
		"./ro.js": 861,
		"./ru": 862,
		"./ru.js": 862,
		"./sd": 863,
		"./sd.js": 863,
		"./se": 864,
		"./se.js": 864,
		"./si": 865,
		"./si.js": 865,
		"./sk": 866,
		"./sk.js": 866,
		"./sl": 867,
		"./sl.js": 867,
		"./sq": 868,
		"./sq.js": 868,
		"./sr": 869,
		"./sr-cyrl": 870,
		"./sr-cyrl.js": 870,
		"./sr.js": 869,
		"./ss": 871,
		"./ss.js": 871,
		"./sv": 872,
		"./sv.js": 872,
		"./sw": 873,
		"./sw.js": 873,
		"./ta": 874,
		"./ta.js": 874,
		"./te": 875,
		"./te.js": 875,
		"./tet": 876,
		"./tet.js": 876,
		"./tg": 877,
		"./tg.js": 877,
		"./th": 878,
		"./th.js": 878,
		"./tk": 879,
		"./tk.js": 879,
		"./tl-ph": 880,
		"./tl-ph.js": 880,
		"./tlh": 881,
		"./tlh.js": 881,
		"./tr": 882,
		"./tr.js": 882,
		"./tzl": 883,
		"./tzl.js": 883,
		"./tzm": 884,
		"./tzm-latn": 885,
		"./tzm-latn.js": 885,
		"./tzm.js": 884,
		"./ug-cn": 886,
		"./ug-cn.js": 886,
		"./uk": 887,
		"./uk.js": 887,
		"./ur": 888,
		"./ur.js": 888,
		"./uz": 889,
		"./uz-latn": 890,
		"./uz-latn.js": 890,
		"./uz.js": 889,
		"./vi": 891,
		"./vi.js": 891,
		"./x-pseudo": 892,
		"./x-pseudo.js": 892,
		"./yo": 893,
		"./yo.js": 893,
		"./zh-cn": 894,
		"./zh-cn.js": 894,
		"./zh-hk": 895,
		"./zh-hk.js": 895,
		"./zh-mo": 896,
		"./zh-mo.js": 896,
		"./zh-tw": 897,
		"./zh-tw.js": 897
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 760;


/***/ }),
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(899);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./delegationCard.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./delegationCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "delegation-card .card-container{width:100%;min-height:170px;display:inline-block;background-color:#fff;box-shadow:0 2px 4px 0 hsla(216,8%,88%,.32);border:1px solid #dddfe2}delegation-card .card-container.responsiveMobile{position:relative;margin:0 -30px;min-width:100vw;min-height:100px;display:block;box-shadow:none;border:0;border-bottom:1px solid #dddfe2;cursor:pointer;left:0;transition:all .5s ease}delegation-card .card-container.responsiveMobile.swiped{left:-160px}delegation-card .card-container.responsiveMobile .user-info-avatar{margin-top:0;padding-left:15px;padding-top:25px}delegation-card .card-container.responsiveMobile .user-info-avatar avatar-app{margin-top:0;margin-left:0;transform:scale(1)}delegation-card .card-container.responsiveMobile .user-info-text{margin-top:0;margin-left:15px}delegation-card .card-container.responsiveMobile .user-info-text employee-name{line-height:1;margin-top:15px;font-size:16px;color:#0072c9}delegation-card .card-container.responsiveMobile .user-info-text .requested-date{font-size:12px;color:#666!important}delegation-card .card-container.responsiveMobile .user-info-text .delegation-type{font-style:italic}delegation-card .mobile-buttons-container{position:absolute;right:-160px;min-height:100px;float:right}delegation-card .mobile-buttons-container,delegation-card .mobile-buttons-container .swipe-button{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row}delegation-card .mobile-buttons-container .swipe-button{-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;width:80px;height:100px}delegation-card .mobile-buttons-container .swipe-button.remove{background:#eaebed;font-size:18px}delegation-card .mobile-buttons-container .swipe-button.remove span:before{color:#c8175e!important}delegation-card .mobile-buttons-container .swipe-button.edit{background:#86c82d;font-size:24px}delegation-card .user-info-avatar{padding-top:26px;padding-left:30px;float:left}delegation-card .user-info-avatar avatar-app{margin-top:41px;margin-left:19px;transform:scale(1.9)}delegation-card .user-info-text{margin-left:35px;margin-top:24px;float:left}delegation-card .user-info-text .request-date{font-family:Stag Sans;font-size:12px;font-weight:300;text-align:left;color:#666}delegation-card .user-info-text employee-name{margin-top:30px;font-family:Stag Sans;font-size:22px;text-align:left;color:#666;text-transform:capitalize}delegation-card .user-info-text .requested-date{font-family:Stag Sans;font-size:15px;font-weight:300;text-align:left;color:#666}delegation-card .user-info-text .requested-date .period{text-transform:capitalize;font-weight:400}delegation-card .user-info-text .requested-date .line{margin-top:10px;border-bottom:1px solid #eaebed}delegation-card .request-container{margin-left:30px;min-width:300px}delegation-card .line{min-width:280px;background-color:#dddfe2;border-bottom:2px solid #dddfe2}delegation-card .buttons-container{float:right;margin-top:80px;margin-right:30px}delegation-card .buttons-container .request-reject-accept{-ms-flex-item-align:start;align-self:flex-start;padding-bottom:11px}delegation-card .buttons-container .request-reject-accept .btn{margin-left:23px}delegation-card .buttons-container .request-reject-accept .btn.btn-default,delegation-card .buttons-container .request-reject-accept .btn.btn-primary{width:154px;height:38px;line-height:40px}", ""]);
	
	// exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _alertCard = __webpack_require__(901);
	
	var _alertCard2 = _interopRequireDefault(_alertCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alertCardModule = _angular2.default.module('alertCard', []).component('alertCard', _alertCard2.default).name;
	
	exports.default = alertCardModule;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alertCard = __webpack_require__(902);
	
	var _alertCard2 = _interopRequireDefault(_alertCard);
	
	var _alertCard3 = __webpack_require__(903);
	
	var _alertCard4 = _interopRequireDefault(_alertCard3);
	
	__webpack_require__(904);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alertCardComponent = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {
	    isMobileApp: '<',
	    alertStyle: '@',
	    disabledClose: '<'
	  },
	  template: _alertCard2.default,
	  controller: _alertCard4.default
	};
	
	exports.default = alertCardComponent;

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card-message-alert\" ng-if=\"$ctrl.messageAlert\" ng-class=\"$ctrl.getClasses()\">\n  <span class=\"icon-warning\"></span>\n  <p class=\"message-container\">\n    <ng-transclude></ng-transclude>\n  </p>\n  <span ng-hide=\"$ctrl.disabledClose\" class=\"icon-cross\" ng-click=\"$ctrl.messageAlert = false\"></span>\n</div>\n"

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertCardController = function () {
	  function AlertCardController() {
	    (0, _classCallCheck3.default)(this, AlertCardController);
	  }
	
	  (0, _createClass3.default)(AlertCardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.messageAlert = true;
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        'responsiveMobile': this.isMobileApp,
	        'bluish-style': this.alertStyle == 'bluish',
	        'red-style': this.alertStyle == 'red'
	      };
	    }
	  }]);
	  return AlertCardController;
	}();
	
	exports.default = AlertCardController;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(905);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./alertCard.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./alertCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "alert-card{width:100vw}alert-card .card-message-alert{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center;font-size:1.2em;margin-top:10px;padding:5px 10px;color:#0072c9!important;border:1px solid #0072c9;border-radius:2px;background-color:#fff!important}alert-card .card-message-alert.responsiveMobile{font-size:12px;padding:5px 20px 5px 10px}alert-card .card-message-alert.responsiveMobile .message-container{color:#0072c9!important;margin:0 10px}alert-card .card-message-alert.responsiveMobile .icon-warning{top:0}alert-card .card-message-alert .message-container{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;margin:0}alert-card .card-message-alert .icon-warning{font-size:2em;margin-right:10px;right:0;color:#0072c9}alert-card .card-message-alert .icon-cross{-ms-flex-item-align:center;align-self:center;cursor:pointer}alert-card .card-message-alert.bluish-style{border:none}alert-card .card-message-alert.bluish-style .message-container{padding-right:35px;height:66px;width:100%;font-family:Stag Sans;font-size:14px;font-weight:300;font-style:normal;font-stretch:normal;line-height:1.21;letter-spacing:normal;color:#121212!important;padding-left:0}alert-card .card-message-alert.bluish-style .icon-warning{color:#0072c9;font-size:20px}alert-card .card-message-alert.bluish-style .icon-cross{display:none}alert-card .card-message-alert.bluish-style.responsiveMobile{background-color:#d4edfc!important}alert-card .card-message-alert.bluish-style.responsiveMobile .message-container{padding-top:25px;padding-bottom:24px}alert-card .card-message-alert.bluish-style.responsiveMobile .icon-warning{margin-right:0;top:unset;position:relative;bottom:21px;font-size:18px}alert-card .card-message-alert.bluish-style.responsiveMobile .icon-cross{display:block;bottom:21px;position:relative}alert-card .card-message-alert.red-style{border-color:#c8175e;justify-content:unset;-webkit-justify-content:unset;display:inline-block;max-width:978px;width:90%;border-radius:5px}alert-card .card-message-alert.red-style .message-container{position:relative;top:7px;left:9px;color:#c8175e}alert-card .card-message-alert.red-style .icon-warning{position:relative;float:left;left:9px;color:#c8175e}alert-card .card-message-alert.red-style .icon-cross{float:right;position:relative;bottom:13px;right:8px;color:#c8175e}", ""]);
	
	// exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalDelegationManager = __webpack_require__(907);
	
	var _modalDelegationManager2 = _interopRequireDefault(_modalDelegationManager);
	
	var _modalCreateDelegation = __webpack_require__(912);
	
	var _modalCreateDelegation2 = _interopRequireDefault(_modalCreateDelegation);
	
	var _modalEditDelegation = __webpack_require__(925);
	
	var _modalEditDelegation2 = _interopRequireDefault(_modalEditDelegation);
	
	var _modalCancelDelegation = __webpack_require__(931);
	
	var _modalCancelDelegation2 = _interopRequireDefault(_modalCancelDelegation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalDelegationManagerModule = _angular2.default.module('modalDelegationManager', [_modalCreateDelegation2.default, _modalCancelDelegation2.default, _modalEditDelegation2.default]).component('modalDelegationManager', _modalDelegationManager2.default).name;
	
	exports.default = modalDelegationManagerModule;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalDelegationManager = __webpack_require__(908);
	
	var _modalDelegationManager2 = _interopRequireDefault(_modalDelegationManager);
	
	var _modalDelegationManager3 = __webpack_require__(909);
	
	var _modalDelegationManager4 = _interopRequireDefault(_modalDelegationManager3);
	
	__webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalDelegationManagerComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    state: '<',
	    delegation: '<',
	    message: '<',
	    customTitle: '<',
	    moduleId: '<',
	    modalClose: '&',
	    editDelegationRequest: '&',
	    onSendDelegation: '&',
	    employeeRole: '<',
	    cancelDelegationRequest: '&',
	    setDelegationType: '&',
	    employeeId: '<'
	  },
	  template: _modalDelegationManager2.default,
	  controller: _modalDelegationManager4.default
	};
	
	exports.default = modalDelegationManagerComponent;

/***/ }),
/* 908 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"modal\"\n  ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n  id=\"modalDelegationManager\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"modalDelegationManagerLabel\"\n  data-keyboard=\"false\"\n  data-backdrop=\"static\">\n\n  <div class=\"modal-dialog\" role=\"document\">\n    <modal-create-delegation\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.isCreating()\"\n      module=\"$ctrl.moduleId\"\n      on-send=\"$ctrl.onSendDelegation({$event:$event})\"\n      role=\"$ctrl.employeeRole\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      on-delegation-type-change=\"$ctrl.setDelegationType({$event:$event})\"\n      employee-id=\"$ctrl.employeeId\">\n    </modal-create-delegation>\n\n    <modal-cancel-delegation\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.isDeleting()\"\n      delegation=\"$ctrl.delegation\"\n      close-modal=\"true\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      cancel-delegation=\"$ctrl.cancelDelegationRequest({$event: $event})\">\n    </modal-cancel-delegation>\n\n    <modal-edit-delegation\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.isEditing()\"\n      delegation=\"$ctrl.delegation\"\n      module=\"$ctrl.moduleId\"\n      role=\"$ctrl.employeeRole\"\n      edit-delegation=\"$ctrl.editDelegationRequest({$event: $event})\"\n      close-modal=\"true\"\n      on-dismiss=\"$ctrl.onDismiss()\">\n    </modal-edit-delegation>\n\n    <successful-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ $ctrl.customTitle | translate }}\"\n      ng-if=\"$ctrl.isSuccess() \"\n      close-modal=\"true\"\n      message=\"{{ $ctrl.modalTitle }}\"\n      message-journey=\"{{ $ctrl.modalMessage}}\"\n      on-dismiss=\"$ctrl.onDismiss()\">\n    </successful-action>\n\n    <failed-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.isError()\"\n      title=\"{{ 'GLOBALS.ATTENTION' | translate }}\"\n      description=\"{{ $ctrl.message }}\"\n      close-modal=\"true\"\n      button-text=\"{{'GLOBALS.BUTTON_ACTION.OK' | translate}}\"\n      on-dismiss=\"$ctrl.onDismiss()\">\n    </failed-action>\n  </div>\n</div>\n"

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalDelegationManagerController = function () {
	  ModalDelegationManagerController.$inject = ["EventEmitter"];
	  function ModalDelegationManagerController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalDelegationManagerController);
	    this.EventEmitter = EventEmitter;
	    this.state = '';
	    this.modalTitle = '';
	    this.modalMessage = '';
	  }
	
	  (0, _createClass3.default)(ModalDelegationManagerController, [{
	    key: 'isCreating',
	    value: function isCreating() {
	      return this.state === _constants.DELEGATION_STATES.CREATE;
	    }
	  }, {
	    key: 'isEditing',
	    value: function isEditing() {
	      return this.state === _constants.DELEGATION_STATES.EDIT;
	    }
	  }, {
	    key: 'isDeleting',
	    value: function isDeleting() {
	      return this.state === _constants.DELEGATION_STATES.CANCEL;
	    }
	  }, {
	    key: 'isSuccess',
	    value: function isSuccess() {
	      return this.state === _constants.DELEGATION_STATES.SUCCESS;
	    }
	  }, {
	    key: 'isError',
	    value: function isError() {
	      return this.state === _constants.DELEGATION_STATES.ERROR;
	    }
	  }, {
	    key: 'onDismiss',
	    value: function onDismiss() {
	      this.modalClose();
	    }
	  }]);
	  return ModalDelegationManagerController;
	}();
	
	exports.default = ModalDelegationManagerController;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(911);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./modalDelegationManager.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./modalDelegationManager.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-delegation-manager .modal .modal-dialog{max-height:410px;max-width:520px}modal-delegation-manager .modal.mobile .modal-dialog{max-height:none;max-width:none}modal-delegation-manager .modal.mobile .modal-dialog .modal-content{padding:30px}", ""]);
	
	// exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalCreateDelegation = __webpack_require__(913);
	
	var _modalCreateDelegation2 = _interopRequireDefault(_modalCreateDelegation);
	
	var _createDelegationHelp = __webpack_require__(919);
	
	var _createDelegationHelp2 = _interopRequireDefault(_createDelegationHelp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCreateDelegationModule = _angular2.default.module('modalCreateDelegation', [_createDelegationHelp2.default]).component('modalCreateDelegation', _modalCreateDelegation2.default).name;
	
	exports.default = modalCreateDelegationModule;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalCreateDelegation = __webpack_require__(914);
	
	var _modalCreateDelegation2 = _interopRequireDefault(_modalCreateDelegation);
	
	var _modalCreateDelegation3 = __webpack_require__(915);
	
	var _modalCreateDelegation4 = _interopRequireDefault(_modalCreateDelegation3);
	
	__webpack_require__(917);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCreateDelegationComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    role: '<',
	    module: '<',
	    onSend: '&',
	    onDismiss: '&',
	    onDelegationTypeChange: '&',
	    employeeId: '<'
	  },
	  template: _modalCreateDelegation2.default,
	  controller: _modalCreateDelegation4.default
	};
	
	exports.default = modalCreateDelegationComponent;

/***/ }),
/* 914 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <form name=\"$ctrl.form\" novalidate ng-submit=\"$ctrl.submit()\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" ng-click=\"$ctrl.onDismiss()\" class=\"close\">\n        <span class=\"icon-cross\"></span>\n      </button>\n      <h4>{{ 'GLOBALS.PERMISSION_DELEGATION' | translate }}</h4>\n    </div>\n\n    <div class=\"modal-body\" ng-class=\"{ 'reduced-padding': $ctrl.isSicknessRequestCreate() }\">\n\n      <div class=\"row\">\n        <option-switch\n          ng-if=\"$ctrl.showSwitch()\"\n          options-data=\"$ctrl.switchOptions\"\n          on-select=\"$ctrl.setDelegationType({$event:$event})\"\n          auto-return-default-option=\"true\">\n        </option-switch>\n      </div>\n\n      <div class=\"row\">\n        <create-delegation-help\n          delegation-type=\"$ctrl.delegationType\"\n          module=\"$ctrl.module\">\n        </create-delegation-help>\n      </div>\n\n      <div class=\"row\">\n        <employee-search\n          min-length-search=\"3\"\n          on-search=\"$ctrl.onSearch($event)\"\n          on-select-employee=\"$ctrl.setSelectedEmployee({$event:$event})\"\n          show-alert-card=\"true\"\n          fixed-selection=\"true\"\n          is-mobile-app=\"$ctrl.isMobileApp\">\n        </employee-search>\n      </div>\n\n      <div class=\"row datepicker-inputs\">\n        <div class=\"datepicker-wrapper\">\n          <input-datepicker\n            is-mobile-app=\"$ctrl.isMobileApp\"\n            name=\"startDate\"\n            start-date=\"$ctrl.startDate || $ctrl.periodToEdit.startDate\"\n            init-date=\"$ctrl.initStartDate\"\n            on-datepick=\"$ctrl.setDelegationPeriodStartDate($event);\"\n            label=\"{{ 'GLOBALS.START_DATE' | translate }}\"\n          ></input-datepicker>\n        </div>\n        <div class=\"datepicker-wrapper\">\n          <input-datepicker\n            is-mobile-app=\"$ctrl.isMobileApp\"\n            name=\"endDate\"\n            start-date=\"$ctrl.periodToEdit.endDate\"\n            init-date=\"$ctrl.initEndDate\"\n            on-datepick=\"$ctrl.setDelegationPeriodEndDate($event);\"\n            label=\"{{ 'GLOBALS.END_DATE' | translate }}\"\n          ></input-datepicker>\n        </div>\n      </div>\n\n      <div class=\"displacement-warning\" ng-if=\"$ctrl.isDisplacementRequest\">\n        <p>{{ 'VACATIONS_ABSENCES.REQUEST_MODAL.DISPLACEMENT_WARNING' | translate }}</p>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\" ng-if=\"!$ctrl.isMobileApp\">\n      <button type=\"button\" class=\"btn btn-app btn-default\" ng-click=\"$ctrl.onDismiss()\">{{ 'GLOBALS.BUTTON_ACTION.CANCEL' | translate }}</button>\n      <button type=\"submit\" class=\"btn btn-app btn-primary\" ng-click=\"$ctrl.sendDelegation();\" ng-disabled=\"$ctrl.setButtonDisabled()\">{{ 'GLOBALS.BUTTON_ACTION.ACTIVATE' | translate }}</button>\n    </div>\n  </form>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp && !$ctrl.isInputFocused()\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.sendDelegation()\"\n    on-click-second-button=\"$ctrl.onDismiss()\">\n  </floating-action-buttons>\n\n</div>"

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(916);
	
	var _constants3 = __webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalCreateDelegationController = function () {
	  ModalCreateDelegationController.$inject = ["EventEmitter", "DelegationService", "$scope", "floatingActionButtonsService"];
	  function ModalCreateDelegationController(EventEmitter, DelegationService, $scope, floatingActionButtonsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalCreateDelegationController);
	    this.EventEmitter = EventEmitter;
	    this.DelegationService = DelegationService;
	    this.scope = $scope;
	    this.switchOptions = _constants.DELEGATIONS_SWITCH_CONFIG;
	    this.floatingActionButtonsService = floatingActionButtonsService;
	  }
	
	  (0, _createClass3.default)(ModalCreateDelegationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.initStartDate = null;
	      this.initEndDate = null;
	      this.sendButtonDisabled = true;
	      this.delegationType = this.initDelegationType();
	
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	
	        this.scope.$watch(function () {
	          return _this.form.$invalid;
	        }, function () {
	          return _this.setFloatingActionButtonDisabled();
	        });
	        this.scope.$watch(function () {
	          return _this.ongoing;
	        }, function () {
	          return _this.setFloatingActionButtonDisabled();
	        });
	        this.scope.$watch(function () {
	          return _this.employeeToDelegate;
	        }, function () {
	          return _this.setFloatingActionButtonDisabled();
	        });
	      }
	    }
	  }, {
	    key: 'isInputFocused',
	    value: function isInputFocused() {
	      return this.floatingActionButtonsService.isFocused;
	    }
	  }, {
	    key: 'initDelegationType',
	    value: function initDelegationType() {
	      if (this.module === _constants3.MODULE_ID) {
	        return _constants.SWITCHOPTIONS.MANAGER;
	      }
	      return _constants.SWITCHOPTIONS.USER;
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.ACTIVATE',
	        disabled: true
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }, {
	    key: 'setFloatingActionButtonDisabled',
	    value: function setFloatingActionButtonDisabled() {
	      this.floatingActionButtons[0].disabled = this.setButtonDisabled();
	    }
	  }, {
	    key: 'formatSearch',
	    value: function formatSearch(dataArray) {
	      var delegables = [];
	      dataArray.forEach(function (data) {
	        var delegable = {};
	        delegable.name = data.employeeName || '';
	        delegable.userId = data.employeeId || '';
	        delegables.push(delegable);
	      });
	
	      return delegables;
	    }
	  }, {
	    key: 'onSearch',
	    value: function onSearch($event) {
	      var _this2 = this;
	
	      return this.DelegationService.getDelegableEmployees($event.searchText, this.employeeId).then(function (response) {
	        return _this2.formatSearch(response.data.delegableEmployees);
	      });
	    }
	  }, {
	    key: 'setSelectedEmployee',
	    value: function setSelectedEmployee(_ref) {
	      var $event = _ref.$event;
	
	      this.employeeToDelegate = $event;
	    }
	  }, {
	    key: 'setDelegationPeriodStartDate',
	    value: function setDelegationPeriodStartDate($event) {
	      this.startDate = $event.date;
	
	      if (this.endDate && this.startDate > this.endDate) {
	        this.form.startDate.$setValidity('validRange', false);
	      } else {
	        this.setValidRange();
	      }
	    }
	  }, {
	    key: 'setDelegationPeriodEndDate',
	    value: function setDelegationPeriodEndDate($event) {
	      this.endDate = $event.date;
	
	      if (this.startDate && this.endDate < this.startDate) {
	        this.form.endDate.$setValidity('validRange', false);
	      } else {
	        this.setValidRange();
	      }
	    }
	  }, {
	    key: 'setValidRange',
	    value: function setValidRange() {
	      if (!this.startDate) {
	        this.initStartDate = angular.copy(this.endDate);
	      }
	
	      if (!this.endDate) {
	        this.initEndDate = angular.copy(this.startDate);
	      }
	
	      this.form.endDate.$setValidity('validRange', true);
	      this.form.startDate.$setValidity('validRange', true);
	    }
	  }, {
	    key: 'formatDelegation',
	    value: function formatDelegation() {
	      var delegation = {
	        startDate: this.startDate,
	        endDate: this.endDate,
	        employee: this.employeeToDelegate.userId
	      };
	
	      return delegation;
	    }
	  }, {
	    key: 'sendDelegation',
	    value: function sendDelegation() {
	      var delegation = this.formatDelegation();
	      this.onSend(this.EventEmitter(delegation));
	    }
	  }, {
	    key: 'setButtonDisabled',
	    value: function setButtonDisabled() {
	      return this.form.$invalid || this.ongoing || !this.employeeToDelegate;
	    }
	  }, {
	    key: 'employeeIsManager',
	    value: function employeeIsManager() {
	      return this.role === _constants.USEROLES.MANAGER;
	    }
	  }, {
	    key: 'isFoodBenefitModule',
	    value: function isFoodBenefitModule() {
	      return this.module === _constants2.MODULE_ID;
	    }
	  }, {
	    key: 'isVacationsAbsencesModule',
	    value: function isVacationsAbsencesModule() {
	      return this.module === _constants3.MODULE_ID;
	    }
	  }, {
	    key: 'showSwitch',
	    value: function showSwitch() {
	      return this.isFoodBenefitModule() && this.employeeIsManager();
	    }
	  }, {
	    key: 'setDelegationType',
	    value: function setDelegationType($event) {
	      this.delegationType = $event.$event.option;
	      this.onDelegationTypeChange({ $event: $event.$event });
	    }
	  }]);
	  return ModalCreateDelegationController;
	}();
	
	exports.default = ModalCreateDelegationController;

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MODULE_ID = 'AA';
	
	var REQUEST_TYPE = {
	  INDIVIDUAL: 'individual',
	  COLLECTIVE: 'collective'
	};
	
	var CARD_STATUS = {
	  APPROVE: 'approve',
	  REJECT: 'reject'
	};
	
	var MODAL_ACTIONS = {
	  SEND: 'send',
	  CANCEL: 'cancel',
	  REJECT: 'reject',
	  APPROVED: 'approve',
	  APPROVE_ALL: 'approve_all'
	};
	
	var DELEGATION_TYPE = {
	  EMPLOYEE: 'R',
	  MANAGER: 'A'
	};
	
	var MODAL_STATES = {
	  managerListConfirmAll: 'managerListConfirmAll',
	  isManagerRejecting: 'isManagerRejecting',
	  isSendingAllCards: 'isSendingAllCards',
	  approve: 'approve',
	  rejected: 'reject',
	  failed: 'failed',
	  isDelegated: 'isDelegated',
	  approveReject: 'approveReject'
	};
	
	var AA_MY_FOOD_BENEFIT_MODAL_COACHMARK_CONFIG = {
	  module: 'AA',
	  tab: 'myFoodBenefit',
	  state: 'my-food-benefit',
	  title: 'FOOD_BENEFIT.COACHMARK.MY_FOOD_BENEFIT.TITLE',
	  subtitles: [{
	    text: 'FOOD_BENEFIT.COACHMARK.MY_FOOD_BENEFIT.STEP0'
	  }, {
	    text: 'FOOD_BENEFIT.COACHMARK.MY_FOOD_BENEFIT.STEP1'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/foodBenefit/Mi_Ayuda_Alimentaria_1.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/foodBenefit/Mi_Ayuda_Alimentaria_2.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var AA_MANAGER_MODAL_COACHMARK_CONFIG = {
	  module: 'AA',
	  tab: 'foodBenefitManager',
	  state: 'food-benefit-manager',
	  title: 'FOOD_BENEFIT.COACHMARK.FOOD_BENEFIT_MANAGER.TITLE',
	  subtitles: [{
	    text: 'FOOD_BENEFIT.COACHMARK.FOOD_BENEFIT_MANAGER.STEP0'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/foodBenefit/Solicitudes_Equipo_1.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var AA_WORK_TEAM_MODAL_COACHMARK_CONFIG = {
	  module: 'AA',
	  tab: 'foodBenefitWorkTeam',
	  state: 'food-benefit-work-team',
	  title: 'FOOD_BENEFIT.COACHMARK.FOOD_BENEFIT_WORK_TEAM.TITLE',
	  subtitles: [{
	    text: 'FOOD_BENEFIT.COACHMARK.FOOD_BENEFIT_WORK_TEAM.STEP0'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/foodBenefit/Work_Team_1.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var AA_DELEGATIONS_MANAGER_MODAL_COACHMARK_CONFIG = {
	  module: 'AA',
	  tab: 'delegations',
	  state: 'delegations',
	  title: 'FOOD_BENEFIT.COACHMARK.DELEGATIONS.TITLE',
	  subtitles: [{
	    text: 'FOOD_BENEFIT.COACHMARK.DELEGATIONS.STEP0'
	  }, {
	    text: 'FOOD_BENEFIT.COACHMARK.DELEGATIONS.STEP1'
	  }, {
	    text: 'FOOD_BENEFIT.COACHMARK.DELEGATIONS.STEP2'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/foodBenefit/Delegacion_Permiso_1.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/foodBenefit/Delegacion_Permiso_2.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/foodBenefit/Delegacion_Permiso_3.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	exports.MODULE_ID = MODULE_ID;
	exports.REQUEST_TYPE = REQUEST_TYPE;
	exports.CARD_STATUS = CARD_STATUS;
	exports.DELEGATION_TYPE = DELEGATION_TYPE;
	exports.MODAL_STATES = MODAL_STATES;
	exports.MODAL_ACTIONS = MODAL_ACTIONS;
	exports.AA_MY_FOOD_BENEFIT_MODAL_COACHMARK_CONFIG = AA_MY_FOOD_BENEFIT_MODAL_COACHMARK_CONFIG;
	exports.AA_MANAGER_MODAL_COACHMARK_CONFIG = AA_MANAGER_MODAL_COACHMARK_CONFIG;
	exports.AA_DELEGATIONS_MANAGER_MODAL_COACHMARK_CONFIG = AA_DELEGATIONS_MANAGER_MODAL_COACHMARK_CONFIG;
	exports.AA_WORK_TEAM_MODAL_COACHMARK_CONFIG = AA_WORK_TEAM_MODAL_COACHMARK_CONFIG;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(918);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./modalCreateDelegation.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./modalCreateDelegation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-create-delegation .modal-content.responsiveMobile p.label{font-size:15px}modal-create-delegation .modal-content.responsiveMobile .datepicker-inputs{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;padding:0 15px!important;margin:24px 0 0!important}modal-create-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:calc(50% - 5px)!important;padding:0!important;margin:0!important;box-sizing:border-box}modal-create-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper>.label,modal-create-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper>label,modal-create-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper>p.label{flex-shrink:0;width:90px;margin-right:10px;text-align:left}modal-create-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper input-datepicker{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex:1;-ms-flex:1;flex:1;min-width:0;float:none!important;margin:0!important}modal-create-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper input-datepicker .input-datepicker-wrapper{width:100%!important;float:none!important;margin:0!important}modal-create-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper input[type=date]{width:100%!important;text-align:center;margin:0!important;box-sizing:border-box}modal-create-delegation .modal-content.responsiveMobile .employee-search-input input[type=text]{height:60px}modal-create-delegation .modal-content.responsiveMobile .employee-search-input i{top:30px!important}modal-create-delegation .modal-content .datepicker-inputs{padding:0 15px}modal-create-delegation .modal-content .datepicker-inputs.row{display:flex!important}modal-create-delegation .modal-content .datepicker-inputs .datepicker-wrapper .input-datepicker-wrapper,modal-create-delegation .modal-content .datepicker-inputs .datepicker-wrapper input-datepicker{float:none!important;margin:0!important}modal-create-delegation .modal-content h4{margin-bottom:3px}modal-create-delegation .modal-content ul{width:100%!important}modal-create-delegation .modal-content .employee-search-container{float:left!important;max-width:none!important;padding:0 15px;margin-top:24px}modal-create-delegation .modal-content .employee-search-input,modal-create-delegation .modal-content .employee-search-input input{width:100%;max-width:none!important}modal-create-delegation .modal-content .employee-search-input i{position:absolute;top:18px!important;transform:translateY(-50%)}modal-create-delegation .modal-content .employee-search-input i.icon-cross{font-size:13px;font-weight:100;left:1.25rem;cursor:pointer;color:#aeaeae}modal-create-delegation .modal-content .employee-search-input i.icon-cross:hover{color:#0072c9}modal-create-delegation .modal-content .employee-search-input i.icon-search{font-size:17px;right:30px;color:#aeaeae}modal-create-delegation .modal-content .employee-search-input i.icon-search.focus{color:#0072c9}modal-create-delegation .modal-content .modal-body{margin-top:24px}modal-create-delegation .modal-content .modal-body.reduced-padding{padding-top:7px}modal-create-delegation .modal-content .modal-body .checkbox{margin-top:0}modal-create-delegation .modal-content .modal-body .separator{margin-bottom:30px}modal-create-delegation .modal-content .modal-body .datepicker-inputs{margin-top:24px}modal-create-delegation .modal-content .modal-body .request-form-sickness-panel-bottom{margin-bottom:21px}modal-create-delegation .modal-content .modal-body .optional-advice{font-family:Stag Sans;font-size:11px;font-weight:300;color:#666;text-align:center;margin-bottom:7px}modal-create-delegation .modal-content .modal-body .displacement-warning{margin:30px auto 16px;width:300px}modal-create-delegation .modal-content .modal-body .displacement-warning p{margin:0;width:307px;font-family:ArialMT;font-size:15px;line-height:1.4;color:#666}modal-create-delegation .modal-content .modal-body .write-message-panel p{font-family:Stag Sans;font-size:12px;color:#666}modal-create-delegation .modal-content .modal-footer{border:0;margin-top:50px}modal-create-delegation .modal-content .modal-footer .btn-default{float:left}modal-create-delegation .modal-content .modal-footer .btn-primary{float:right}", ""]);
	
	// exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createDelegationHelp = __webpack_require__(920);
	
	var _createDelegationHelp2 = _interopRequireDefault(_createDelegationHelp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createDelegationHelpModule = angular.module('vacations-absences.createDelegationHelp', []).component('createDelegationHelp', _createDelegationHelp2.default).name;
	
	exports.default = createDelegationHelpModule;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createDelegationHelpController = __webpack_require__(921);
	
	var _createDelegationHelpController2 = _interopRequireDefault(_createDelegationHelpController);
	
	var _createDelegationHelp = __webpack_require__(922);
	
	var _createDelegationHelp2 = _interopRequireDefault(_createDelegationHelp);
	
	__webpack_require__(923);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createDelegationHelpComponent = {
	  restrict: 'E',
	  bindings: {
	    delegationType: '<',
	    module: '<'
	  },
	  template: _createDelegationHelp2.default,
	  controller: _createDelegationHelpController2.default
	};
	
	exports.default = createDelegationHelpComponent;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(916);
	
	var _constants3 = __webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreateDelegationHelpController = function () {
	  CreateDelegationHelpController.$inject = ["$translate", "$q"];
	  function CreateDelegationHelpController($translate, $q) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CreateDelegationHelpController);
	    this.translate = $translate;
	    this.q = $q;
	
	    this.texts = {};
	    this._translate();
	  }
	
	  (0, _createClass3.default)(CreateDelegationHelpController, [{
	    key: 'getHelpText',
	    value: function getHelpText() {
	      if (this.isManager()) {
	        return this.texts[this.module].manager;
	      }
	      return this.texts[this.module].user;
	    }
	  }, {
	    key: 'isUser',
	    value: function isUser() {
	      return this.delegationType === _constants.SWITCHOPTIONS.USER;
	    }
	  }, {
	    key: 'isManager',
	    value: function isManager() {
	      return this.delegationType === _constants.SWITCHOPTIONS.MANAGER;
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this = this;
	
	      this.texts[_constants2.MODULE_ID] = {
	        user: '',
	        manager: ''
	      };
	      this.texts[_constants3.MODULE_ID] = {
	        manager: ''
	      };
	
	      return this.q.all([this.translate('GLOBALS.DELEGATION_HELP.FOOD_BENEFIT.USER').then(function (translation) {
	        _this.texts[_constants2.MODULE_ID].user = translation;
	      }), this.translate('GLOBALS.DELEGATION_HELP.FOOD_BENEFIT.MANAGER').then(function (translation) {
	        _this.texts[_constants2.MODULE_ID].manager = translation;
	      }), this.translate('GLOBALS.DELEGATION_HELP.VACATIONS_ABSENCES.MANAGER').then(function (translation) {
	        _this.texts[_constants3.MODULE_ID].manager = translation;
	      })]);
	    }
	  }]);
	  return CreateDelegationHelpController;
	}();
	
	exports.default = CreateDelegationHelpController;

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  {{$ctrl.getHelpText()}}\n</div>\n"

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(924);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./createDelegationHelp.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./createDelegationHelp.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "create-delegation-help{display:block;border-radius:3px;background-color:#f9f9f9;padding:11px 16px;font-family:ArialMT;font-size:14px;line-height:1.29;letter-spacing:normal;text-align:left;color:#666}", ""]);
	
	// exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalEditDelegation = __webpack_require__(926);
	
	var _modalEditDelegation2 = _interopRequireDefault(_modalEditDelegation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalEditDelegationModule = _angular2.default.module('ModalEditDelegation', []).component('modalEditDelegation', _modalEditDelegation2.default).name;
	
	exports.default = ModalEditDelegationModule;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalEditDelegation = __webpack_require__(927);
	
	var _modalEditDelegation2 = _interopRequireDefault(_modalEditDelegation);
	
	var _modalEditDelegation3 = __webpack_require__(928);
	
	var _modalEditDelegation4 = _interopRequireDefault(_modalEditDelegation3);
	
	__webpack_require__(929);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalEditDelegationComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    role: '<',
	    module: '<',
	    delegation: '<',
	    editDelegation: '&',
	    onDismiss: '&'
	  },
	  template: _modalEditDelegation2.default,
	  controller: _modalEditDelegation4.default
	};
	
	exports.default = ModalEditDelegationComponent;

/***/ }),
/* 927 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <form name=\"$ctrl.form\" novalidate ng-submit=\"$ctrl.submit()\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\" ng-click=\"$ctrl.onDismiss()\"><span class=\"icon-cross\"></span></button>\n      <h4>{{ 'GLOBALS.PERMISSION_DELEGATION' | translate }}</h4>\n    </div>\n\n    <div class=\"modal-body\" ng-class=\"{'reduced-padding': $ctrl.isSicknessRequestCreate()}\">\n\n      <div class=\"row\">\n        <option-switch\n          class=\"disabled\"\n          ng-if=\"$ctrl.showSwitch()\"\n          options-data=\"$ctrl.switchOptions\"\n          selected-option=\"$ctrl.option\">\n        </option-switch>\n      </div>\n\n      <div class=\"row\">\n        <create-delegation-help\n          delegation-type=\"$ctrl.delegationType\"\n          module=\"$ctrl.module\">\n        </create-delegation-help>\n      </div>\n\n      <div class=\"row\">\n        <!--Request type-->\n        <employee-search\n          class=\"disabled\"\n          placeholder-text=\"$ctrl.delegation.name\"\n          is-mobile-app=\"$ctrl.isMobileApp\">\n        </employee-search>\n      </div>\n\n      <!--Start date and end date-->\n      <div class=\"row datepicker-inputs\">\n        <div class=\"datepicker-wrapper\">\n          <input-datepicker\n            is-mobile-app=\"$ctrl.isMobileApp\"\n            name=\"startDate\"\n            start-date=\"$ctrl.startDate\"\n            init-date=\"$ctrl.initStartDate\"\n            on-datepick=\"$ctrl.datepickInitDate($event);\"\n            disabled=\"$ctrl.disableStartDate\"\n            label=\"{{ 'GLOBALS.START_DATE' | translate }}\"\n            ></input-datepicker>\n        </div>\n        <div class=\"datepicker-wrapper\">\n          <input-datepicker\n            is-mobile-app=\"$ctrl.isMobileApp\"\n            name=\"endDate\"\n            start-date=\"$ctrl.endDate\"\n            init-date=\"$ctrl.initEndDate\"\n            on-datepick=\"$ctrl.datepickEndDate($event);\"\n            label=\"{{ 'GLOBALS.END_DATE' | translate }}\"\n            ></input-datepicker>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\" ng-if=\"!$ctrl.isMobileApp\">\n      <button type=\"button\" class=\"btn btn-app btn-default\" ng-click=\"$ctrl.onDismiss();\">{{ 'GLOBALS.BUTTON_ACTION.CANCEL' | translate }}</button>\n      <button type=\"submit\" class=\"btn btn-app btn-primary\" ng-click=\"$ctrl.send()\" ng-disabled=\"$ctrl.setButtonDisabled()\">{{ 'GLOBALS.BUTTON_ACTION.SEND' | translate }}</button>\n    </div>\n  </form>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.send()\"\n    on-click-second-button=\"$ctrl.onDismiss()\">\n  </floating-action-buttons>\n\n</div>"

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(916);
	
	var _constants3 = __webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SWITCH_ID_EMPLOYEE = 0;
	var SWITCH_ID_MANAGER = 1;
	var MANAGER_PERMISSION = 'A';
	
	var ModalEditDelegationController = function () {
	  ModalEditDelegationController.$inject = ["DelegationService", "EventEmitter", "$scope"];
	  function ModalEditDelegationController(DelegationService, EventEmitter, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalEditDelegationController);
	    this.DelegationService = DelegationService;
	    this.EventEmitter = EventEmitter;
	    this.switchOptions = _constants.DELEGATIONS_SWITCH_CONFIG;
	    this.scope = $scope;
	  }
	
	  (0, _createClass3.default)(ModalEditDelegationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this._initDefaultSwitchOption();
	      this.startDate = new Date(this.delegation.startDate);
	      this.endDate = new Date(this.delegation.endDate);
	      this.dateToSend = {
	        startDate: this.startDate,
	        endDate: this.endDate
	      };
	      this.initStartDate = null;
	      this.initEndDate = null;
	      this.disableStartDate = true;
	
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	        this.scope.$watch(function () {
	          return _this.form.$invalid;
	        }, function () {
	          _this.floatingActionButtons[0].disabled = _this.form.$invalid;
	        });
	      }
	    }
	  }, {
	    key: '_initDefaultSwitchOption',
	    value: function _initDefaultSwitchOption() {
	      var delegationEmployeeIsManager = this.delegation.type === MANAGER_PERMISSION;
	
	      this.option = this.switchOptions[SWITCH_ID_EMPLOYEE].value;
	      if (delegationEmployeeIsManager) this.option = this.switchOptions[SWITCH_ID_MANAGER].value;
	
	      this.delegationType = this.option;
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      this.setValidRange();
	    }
	  }, {
	    key: 'datepickInitDate',
	    value: function datepickInitDate(_ref) {
	      var date = _ref.date;
	
	      this.startDate = date;
	      this.dateToSend = {
	        startDate: date,
	        endDate: this.endDate
	      };
	
	      var isSameDay = this.isSameDay(date, this.endDate);
	
	      if (!isSameDay && this.dateToSend.startDate > this.dateToSend.endDate) {
	        this.form.startDate.$setValidity('validRange', false);
	        return;
	      }
	
	      this.setValidRange();
	    }
	  }, {
	    key: 'datepickEndDate',
	    value: function datepickEndDate(_ref2) {
	      var date = _ref2.date;
	
	      this.endDate = date;
	      this.dateToSend = {
	        startDate: this.startDate,
	        endDate: date
	      };
	
	      var isSameDay = this.isSameDay(this.startDate, date);
	
	      if (!isSameDay && this.dateToSend.endDate < this.dateToSend.startDate) {
	        this.form.endDate.$setValidity('validRange', false);
	        return;
	      }
	
	      this.setValidRange();
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      var event = this.EventEmitter(this.dateToSend);
	      this.editDelegation(event);
	    }
	  }, {
	    key: 'setValidRange',
	    value: function setValidRange() {
	      if (!this.startDate) {
	        this.initStartDate = angular.copy(this.endDate);
	      }
	
	      if (!this.endDate) {
	        this.initEndDate = angular.copy(this.startDate);
	      }
	
	      if (this.form && this.form.endDate) {
	        this.form.endDate.$setValidity('validRange', true);
	      }
	
	      if (this.form && this.form.startDate) {
	        this.form.startDate.$setValidity('validRange', true);
	      }
	    }
	  }, {
	    key: 'setButtonDisabled',
	    value: function setButtonDisabled() {
	      return this.form.$invalid;
	    }
	  }, {
	    key: 'employeeIsManager',
	    value: function employeeIsManager() {
	      return this.role === _constants.USEROLES.MANAGER;
	    }
	  }, {
	    key: 'isFoodBenefitModule',
	    value: function isFoodBenefitModule() {
	      return this.module === _constants2.MODULE_ID;
	    }
	  }, {
	    key: 'isVacationsAbsencesModule',
	    value: function isVacationsAbsencesModule() {
	      return this.module === _constants3.MODULE_ID;
	    }
	  }, {
	    key: 'showSwitch',
	    value: function showSwitch() {
	      return this.isFoodBenefitModule() && this.employeeIsManager();
	    }
	  }, {
	    key: 'isSameDay',
	    value: function isSameDay(firstDate, secondDate) {
	      return firstDate.getFullYear() === secondDate.getFullYear() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getDate() === secondDate.getDate();
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.SEND'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }]);
	  return ModalEditDelegationController;
	}();
	
	exports.default = ModalEditDelegationController;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(930);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./modalEditDelegation.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./modalEditDelegation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-edit-delegation .modal-content.responsiveMobile p.label{font-size:15px}modal-edit-delegation .modal-content.responsiveMobile .datepicker-inputs{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;padding:0 15px!important;margin:24px 0 0!important}modal-edit-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:calc(50% - 5px)!important;padding:0!important;margin:0!important;box-sizing:border-box}modal-edit-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper>.label,modal-edit-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper>label,modal-edit-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper>p.label{flex-shrink:0;width:90px;margin-right:10px;text-align:left}modal-edit-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper input-datepicker{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex:1;-ms-flex:1;flex:1;min-width:0;float:none!important;margin:0!important}modal-edit-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper input-datepicker .input-datepicker-wrapper{width:100%!important;float:none!important;margin:0!important}modal-edit-delegation .modal-content.responsiveMobile .datepicker-inputs .datepicker-wrapper input[type=date]{width:100%!important;text-align:center;margin:0!important;padding:0;box-sizing:border-box}modal-edit-delegation .modal-content.responsiveMobile .employee-search-input input[type=text]{height:60px}modal-edit-delegation .modal-content.responsiveMobile .employee-search-input i{top:30px!important}modal-edit-delegation .modal-content .datepicker-inputs{padding:0 15px}modal-edit-delegation .modal-content .datepicker-inputs.row{display:flex!important;margin-left:0!important;margin-right:0!important}modal-edit-delegation .modal-content .datepicker-inputs .datepicker-wrapper .input-datepicker-wrapper,modal-edit-delegation .modal-content .datepicker-inputs .datepicker-wrapper input-datepicker{float:none!important;margin:0!important}modal-edit-delegation .modal-content h4{margin-bottom:3px}modal-edit-delegation .modal-content ul{width:100%!important}modal-edit-delegation .modal-content .employee-search-container{float:left!important;max-width:none!important;padding:0 15px;margin-top:24px}modal-edit-delegation .modal-content .employee-search-input,modal-edit-delegation .modal-content .employee-search-input input{width:100%;max-width:none!important}modal-edit-delegation .modal-content .employee-search-input i{position:absolute;top:18px!important;transform:translateY(-50%)}modal-edit-delegation .modal-content .employee-search-input i.icon-cross{font-size:13px;font-weight:100;left:1.25rem;cursor:pointer;color:#aeaeae}modal-edit-delegation .modal-content .employee-search-input i.icon-cross:hover{color:#0072c9}modal-edit-delegation .modal-content .employee-search-input i.icon-search{font-size:17px;right:30px;color:#aeaeae}modal-edit-delegation .modal-content .employee-search-input i.icon-search.focus{color:#0072c9}modal-edit-delegation .modal-content .modal-body{margin-top:24px}modal-edit-delegation .modal-content .modal-body.reduced-padding{padding-top:7px}modal-edit-delegation .modal-content .modal-body .checkbox{margin-top:0}modal-edit-delegation .modal-content .modal-body .separator{margin-bottom:30px}modal-edit-delegation .modal-content .modal-body .datepicker-inputs{margin-top:24px}modal-edit-delegation .modal-content .modal-body .request-form-sickness-panel-bottom{margin-bottom:21px}modal-edit-delegation .modal-content .modal-body .optional-advice{font-family:Stag Sans;font-size:11px;font-weight:300;color:#666;text-align:center;margin-bottom:7px}modal-edit-delegation .modal-content .modal-body .displacement-warning{margin:30px auto 16px;width:300px}modal-edit-delegation .modal-content .modal-body .displacement-warning p{margin:0;width:307px;font-family:ArialMT;font-size:15px;line-height:1.4;color:#666}modal-edit-delegation .modal-content .modal-body .write-message-panel p{font-family:Stag Sans;font-size:12px;color:#666}modal-edit-delegation .modal-content .modal-footer{border:0;margin-top:50px}modal-edit-delegation .modal-content .modal-footer .btn-default{float:left}modal-edit-delegation .modal-content .modal-footer .btn-primary{float:right}modal-edit-delegation .modal-content .disabled{pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalCancelDelegation = __webpack_require__(932);
	
	var _modalCancelDelegation2 = _interopRequireDefault(_modalCancelDelegation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCancelDelegationModule = _angular2.default.module('modalCancelDelegation', []).component('modalCancelDelegation', _modalCancelDelegation2.default).name;
	
	exports.default = modalCancelDelegationModule;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalCancelDelegation = __webpack_require__(933);
	
	var _modalCancelDelegation2 = _interopRequireDefault(_modalCancelDelegation);
	
	var _modalCancelDelegation3 = __webpack_require__(934);
	
	var _modalCancelDelegation4 = _interopRequireDefault(_modalCancelDelegation3);
	
	__webpack_require__(935);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCancelDelegationComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    delegation: '<',
	    cancelDelegation: '&',
	    onDismiss: '&'
	  },
	  template: _modalCancelDelegation2.default,
	  controller: _modalCancelDelegation4.default
	};
	
	exports.default = modalCancelDelegationComponent;

/***/ }),
/* 933 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\">\n\n  <div class=\"modal-header\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\" ng-click=\"$ctrl.onDismiss()\"><span class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\" id=\"{{$ctrl.modalId}}Label\">{{\"GLOBALS.CANCEL_DELEGATION\" | translate }}</h4>\n  </div>\n\n  <div class=\"modal-body\">\n\n    <div class=\"body-header\">\n      <p class=\"detail\">\n        <span>{{$ctrl.delegatePerson}}</span>\n        <span>{{$ctrl.delegateDate}}</span>\n        <span ng-if=\"$ctrl.hasPermissionType\">{{$ctrl.permissionType}}</span>\n      </p>\n    </div>\n\n  </div>\n\n  <div class=\"modal-footer row\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-one btn-default\"\n      data-dismiss=\"modal\"\n      ng-click=\"$ctrl.onDismiss()\" >{{\"GLOBALS.BUTTON_ACTION.CANCEL\" | translate}}</button>\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-two btn-primary\"\n      ng-click=\"$ctrl.send()\" >{{\"GLOBALS.BUTTON_ACTION.ACCEPT\" | translate}}</button>\n  </div>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.send()\"\n    on-click-second-button=\"$ctrl.onDismiss()\">\n  </floating-action-buttons>\n\n</div>\n"

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(916);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalCancelDelegationController = function () {
	  ModalCancelDelegationController.$inject = ["EventEmitter"];
	  function ModalCancelDelegationController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalCancelDelegationController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(ModalCancelDelegationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.startDate = new Date(this.delegation.startDate);
	      this.employeeId = this.delegation.employeeId;
	      this.delegatePerson = this.delegation.name;
	      this.delegateDate = this.formatDate(this.delegation.startDate) + ' - ' + this.formatDate(this.delegation.endDate);
	
	      this.data = {
	        startDate: this.startDate,
	        employeeId: this.employeeId
	      };
	
	      if (this.delegation.type === _constants.MODULE_ID) {
	        this.permissionType = this.delegation.type;
	        this.hasPermissionType = true;
	      }
	
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      var event = this.EventEmitter(this.data);
	      this.cancelDelegation(event);
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
	
	      _moment2.default.locale(lang);
	      var result = (0, _moment2.default)(date).format('DD MMMM YYYY');
	      return result;
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.ACCEPT'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }]);
	  return ModalCancelDelegationController;
	}();
	
	exports.default = ModalCancelDelegationController;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(936);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./modalCancelDelegation.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./modalCancelDelegation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-cancel-delegation .modal-content{padding-top:58px}modal-cancel-delegation .modal-content .modal-header{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}modal-cancel-delegation .modal-content .modal-header .icon-interrogation{font-size:77px;display:block;width:76px;height:76px;margin:0 auto 22px;margin-bottom:26px;color:#0072c9}modal-cancel-delegation .modal-content .modal-header h4{-ms-flex-item-align:center;align-self:center;width:12em;padding-bottom:10px;color:#0072c9}modal-cancel-delegation .modal-content .modal-body{padding-top:17px}modal-cancel-delegation .modal-content .modal-body .body-header{margin-bottom:24px;padding-top:1px;padding-bottom:16px;text-align:center;color:#666}modal-cancel-delegation .modal-content .modal-body .body-header p{font-family:ArialMT;font-size:18px;line-height:1.3;margin:0;color:#666}modal-cancel-delegation .modal-content .modal-body .body-header p.detail{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;text-transform:capitalize;font-size:15px}modal-cancel-delegation .modal-content .modal-footer{margin-top:35px;text-align:center}modal-cancel-delegation .modal-content .modal-footer .btn{line-height:38px;float:left;width:160px;height:48px;margin-left:14px}modal-cancel-delegation .modal-content .modal-footer .btn-one{line-height:38px;float:left;width:160px;height:48px;margin-right:14px;padding-top:1px;padding-left:1px;color:#0072c9;border-color:#dddfe2;background-color:#f9f9f9}modal-cancel-delegation .modal-content .modal-footer .btn-two{line-height:38px;float:right;width:160px;height:48px;margin-right:16px;padding-top:3px}", ""]);
	
	// exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalWarningDelegation = __webpack_require__(938);
	
	var _modalWarningDelegation2 = _interopRequireDefault(_modalWarningDelegation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalWarningDelegationModule = _angular2.default.module('modalWarningDelegation', []).component('modalWarningDelegation', _modalWarningDelegation2.default).name;
	
	exports.default = modalWarningDelegationModule;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalWarningDelegation = __webpack_require__(939);
	
	var _modalWarningDelegation2 = _interopRequireDefault(_modalWarningDelegation);
	
	var _modalWarningDelegation3 = __webpack_require__(940);
	
	var _modalWarningDelegation4 = _interopRequireDefault(_modalWarningDelegation3);
	
	__webpack_require__(941);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalWarningDelegationComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    titleBody: '@',
	    delegation: '<',
	    urlDestination: '<'
	  },
	  template: _modalWarningDelegation2.default,
	  controller: _modalWarningDelegation4.default
	};
	
	exports.default = modalWarningDelegationComponent;

/***/ }),
/* 939 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\"\n     id=\"modalWarningDelegation\"\n     tabindex=\"-1\"\n     role=\"dialog\"\n     aria-labelledby=\"modalWarningDelegationLabel\"\n     ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <div class=\"modal-dialog\"\n       role=\"document\">\n    <div class=\"modal-content\">\n\n      <div class=\"modal-header\">\n        <span class=\"icon-warning\"></span>\n        <button type=\"button\"\n                data-dismiss=\"modal\"\n                aria-label=\"Close\"\n                class=\"close\"\n                ng-click=\"$ctrl.onDismiss()\">\n          <span class=\"icon-cross\"></span>\n        </button>\n        <h4 class=\"modal-title\">\n          {{ \"GLOBALS.ATTENTION\" | translate }}\n        </h4>\n      </div>\n\n      <div class=\"modal-body\">\n        <div class=\"body-header\">\n          <div class=\"detail\">\n            <span class=\"detail-title\">{{ $ctrl.titleBody }}</span>\n            <span class=\"person\">{{ $ctrl.delegation.name }}</span>\n            <span class=\"date\">{{ $ctrl.getTextForStartDate() }}</span>\n            <span class=\"date\">{{ $ctrl.getTextForEndDate() }}</span>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"modal-footer row\"\n           ng-if=\"!$ctrl.isMobileApp\">\n        <a ui-sref=\"{{$ctrl.urlDestination}}\"\n           class=\"btn btn-app btn-one btn-primary\"\n           data-dismiss=\"modal\">\n          {{\"GLOBALS.BUTTON_ACTION.GOTO_DELEGACION\" | translate}}\n        </a>\n      </div>\n\n      <floating-action-buttons ng-if=\"$ctrl.isMobileApp\"\n                               buttons=\"$ctrl.floatingActionButtons\"\n                               on-click-first-button=\"$ctrl.goToUrlDestination()\">\n      </floating-action-buttons>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalWarningDelegationController = function () {
	  ModalWarningDelegationController.$inject = ["EventEmitter", "$translate", "$state"];
	  function ModalWarningDelegationController(EventEmitter, $translate, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalWarningDelegationController);
	    this.EventEmitter = EventEmitter;
	    this.translate = $translate;
	    this.state = $state;
	    _moment2.default.locale('es');
	  }
	
	  (0, _createClass3.default)(ModalWarningDelegationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this._translateText();
	
	      if (this.isMobileApp) {
	        this.floatingActionButtons = [{
	          literal: 'GLOBALS.BUTTON_ACTION.GOTO_DELEGACION'
	        }];
	      }
	    }
	  }, {
	    key: 'goToUrlDestination',
	    value: function goToUrlDestination() {
	      this.onDismiss();
	      this.state.go(this.urlDestination);
	    }
	  }, {
	    key: 'onDismiss',
	    value: function onDismiss() {
	      this.modal.modal('hide');
	    }
	  }, {
	    key: '_translateText',
	    value: function _translateText() {
	      var _this = this;
	
	      this.translate('GLOBALS.FROM').then(function (translation) {
	        _this.textTranslationStartDate = translation.$$unwrapTrustedValue();
	
	        _this.translate('GLOBALS.TO').then(function (translation) {
	          _this.textTranslationEndDate = translation.$$unwrapTrustedValue();
	        });
	      });
	    }
	  }, {
	    key: 'getTextForStartDate',
	    value: function getTextForStartDate() {
	      var startDateFormatted = (0, _moment2.default)(this.delegation.startDate).format('dddd DD MMMM YYYY');
	      return this.textTranslationStartDate + ' ' + startDateFormatted;
	    }
	  }, {
	    key: 'getTextForEndDate',
	    value: function getTextForEndDate() {
	      var endDateFormatted = (0, _moment2.default)(this.delegation.endDate).format('dddd DD MMMM YYYY');
	      return this.textTranslationEndDate + ' ' + endDateFormatted;
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return $(_constants.MODALS.WARNING_DELEGATION_MODAL);
	    }
	  }]);
	  return ModalWarningDelegationController;
	}();
	
	exports.default = ModalWarningDelegationController;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(942);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./modalWarningDelegation.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./modalWarningDelegation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-warning-delegation .modal-dialog{width:520px;height:441px}modal-warning-delegation .modal-dialog .modal-content{padding-top:58px;padding-left:30px;padding-right:30px}modal-warning-delegation .modal-dialog .modal-content .modal-header{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}modal-warning-delegation .modal-dialog .modal-content .modal-header .icon-warning{font-size:77px;display:block;width:76px;height:76px;margin:0 auto 22px;margin-bottom:26px;color:#c8175e}modal-warning-delegation .modal-dialog .modal-content .modal-header h4.modal-title{-ms-flex-item-align:center;align-self:center;width:12em;padding-bottom:10px;color:#c8175e!important}modal-warning-delegation .modal-dialog .modal-content .modal-body{padding-top:20px}modal-warning-delegation .modal-dialog .modal-content .modal-body .body-header{padding-bottom:16px;text-align:center}modal-warning-delegation .modal-dialog .modal-content .modal-body .body-header .detail{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;font-family:ArialMT;font-size:15px;line-height:1.3;margin:0;color:#666}modal-warning-delegation .modal-dialog .modal-content .modal-body .body-header span.person{margin:10px 0;font-weight:700}modal-warning-delegation .modal-dialog .modal-content .modal-body .body-header span.date{text-transform:capitalize}modal-warning-delegation .modal-dialog .modal-content .modal-footer{margin-top:25px;text-align:center}modal-warning-delegation .modal-dialog .modal-content .modal-footer .btn-one{padding-top:6px;line-height:38px;width:160px;height:48px}", ""]);
	
	// exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _employeeDropdownList = __webpack_require__(944);
	
	var _employeeDropdownList2 = _interopRequireDefault(_employeeDropdownList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeDropdownListModule = angular.module('vacations-absences.employeeDropdownList', []).component('employeeDropdownList', _employeeDropdownList2.default).name;
	
	exports.default = employeeDropdownListModule;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _employeeDropdownList = __webpack_require__(945);
	
	var _employeeDropdownList2 = _interopRequireDefault(_employeeDropdownList);
	
	var _employeeDropdownList3 = __webpack_require__(946);
	
	var _employeeDropdownList4 = _interopRequireDefault(_employeeDropdownList3);
	
	__webpack_require__(947);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeDropdownListComponent = {
	  restrict: 'E',
	  bindings: {
	    employees: '<',
	    onSelectEmployee: '&',
	    isDisabled: '<',
	    enableAlert: '<',
	    isMobileApp: '<',
	    limitResults: '<'
	  },
	  template: _employeeDropdownList2.default,
	  controller: _employeeDropdownList4.default
	};
	
	exports.default = employeeDropdownListComponent;

/***/ }),
/* 945 */
/***/ (function(module, exports) {

	module.exports = "<ul ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <li ng-if=\"$ctrl.hasEmployees()\"\n      ng-class=\"{'remove-pointer-events': $ctrl.isDisabled}\"\n      ng-repeat=\"employee in $ctrl.employees | limitTo: $ctrl.limitResults\"\n      ng-mouseup=\"$ctrl.emitEmployee(employee)\"\n      on-long-press=\"$ctrl.emitEmployee(employee)\">\n    <employee-name name=\"{{employee.name}}\"\n                   enrollment=\"{{employee.employeeId}}\">\n    </employee-name>\n  </li>\n  <li ng-if=\"!$ctrl.hasEmployees() && $ctrl.enableAlert\">\n    <span class=\"icon-warning\"></span>\n    <p class=\"message-container\">\n      {{'EMPLOYEE_SEARCH.MSG_ALERT' | translate}}\n    </p>>\n  </li>\n</ul>\n"

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeDropdownListController = function () {
	  EmployeeDropdownListController.$inject = ["EventEmitter"];
	  function EmployeeDropdownListController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, EmployeeDropdownListController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(EmployeeDropdownListController, [{
	    key: 'hasEmployees',
	    value: function hasEmployees() {
	      return this.employees && this.employees.length > 0;
	    }
	  }, {
	    key: 'emitEmployee',
	    value: function emitEmployee(employee) {
	      this.onSelectEmployee(this.EventEmitter(employee));
	    }
	  }]);
	  return EmployeeDropdownListController;
	}();
	
	exports.default = EmployeeDropdownListController;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(948);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./employeeDropdownList.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./employeeDropdownList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "employee-dropdown-list ul{background:#fff;padding:0;margin:0;list-style:none;width:300px;border:1px solid #dddfe2;box-shadow:0 1px 3px 0 hsla(220,8%,92%,.5)}employee-dropdown-list ul.responsiveMobile{max-height:153px;overflow-y:scroll;width:100%}employee-dropdown-list ul li{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:center;-moz-align-items:center;align-items:center;height:60px;padding-left:26px}employee-dropdown-list ul li:hover{background-color:#dddfe2;cursor:pointer}employee-dropdown-list ul li:hover employee-name span{color:#0072c9}employee-dropdown-list ul li span{display:inline-block;height:12px;font-family:Stag Sans;font-size:12px;color:#666;text-transform:uppercase;height:auto}employee-dropdown-list ul li avatar-app .avatar-container{margin-right:14px}employee-dropdown-list ul .message-container{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;margin:0;color:#c8175e}employee-dropdown-list ul .icon-warning{font-size:2em;margin-right:10px;right:0;color:#c8175e}", ""]);
	
	// exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _employeeSearch = __webpack_require__(950);
	
	var _employeeSearch2 = _interopRequireDefault(_employeeSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeSearchModule = angular.module('vacations-absences.employeeSearch', []).component('employeeSearch', _employeeSearch2.default).name;
	
	exports.default = employeeSearchModule;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _employeeSearch = __webpack_require__(951);
	
	var _employeeSearch2 = _interopRequireDefault(_employeeSearch);
	
	var _employeeSearch3 = __webpack_require__(952);
	
	var _employeeSearch4 = _interopRequireDefault(_employeeSearch3);
	
	__webpack_require__(953);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeSearchComponent = {
	  restrict: 'E',
	  bindings: {
	    onSelectEmployee: '&',
	    onSearch: '&?',
	    minLengthSearch: '<?',
	    placeholderText: '<?',
	    fixedSelection: '<?',
	    showAlertCard: '<',
	    isMobileApp: '<',
	    onCleanSearch: '&?',
	    enableAlert: '<',
	    reportSearchState: '&?'
	  },
	  template: _employeeSearch2.default,
	  controller: _employeeSearch4.default
	};
	
	exports.default = employeeSearchComponent;

/***/ }),
/* 951 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"employee-search-container\"\n     ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n  <div class=\"employee-search-input\">\n    <i class=\"icon icon-cross\"\n       ng-class=\"{'focus': focus}\"\n       ng-if=\"$ctrl.hasText()\"\n       ng-click=\"$ctrl.cleanSearch()\">\n    </i>\n    <input type=\"text\"\n           placeholder=\"{{ $ctrl.placeholderText || 'EMPLOYEE_SEARCH.HINT' | translate }}\"\n           ng-focus=\"focus=true; $ctrl.search();\"\n           ng-blur=\"focus=false; $ctrl.onCleanSearch({$event:{searchText: $ctrl.searchText}});\"\n           ng-model=\"$ctrl.searchText\"\n           ng-change=\"$ctrl.search()\"\n           ng-model-options=\"{debounce: 750}\"/>\n    <i class=\"icon icon-search\"\n       ng-class=\"{'focus': focus}\">\n    </i>\n  </div>\n\n  <employee-dropdown-list ng-if=\"$ctrl.isVisibleList()\"\n                          employees=\"$ctrl.filteredEmployees\"\n                          on-select-employee=\"$ctrl.onSelectEmployeeAndHide({$event: $event});\"\n                          enable-alert=\"$ctrl.enableAlert\"\n                          is-mobile-app=\"$ctrl.isMobileApp\"\n                          limit-results=\"5\">\n  </employee-dropdown-list>\n\n  <alert-card ng-if=\"$ctrl.isVisibleAlertCard()\">\n    {{ 'EMPLOYEE_SEARCH.MSG_ALERT' | translate }} \"{{ $ctrl.searchText }}\"\n  </alert-card>\n</div>\n"

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_MIN_SEARCH_LENGTH = 1;
	
	var EmployeeSearchController = function () {
	  EmployeeSearchController.$inject = ["DelegationService", "EventEmitter"];
	  function EmployeeSearchController(DelegationService, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, EmployeeSearchController);
	    this.searchText = '';
	    this.filteredEmployees = [];
	    this.showList = false;
	    this.DelegationService = DelegationService;
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(EmployeeSearchController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.minLengthSearch = this.minLengthSearch || DEFAULT_MIN_SEARCH_LENGTH;
	      this.preFiltered = this.preFiltered || false;
	      this.onSearch = this.onSearch || this._defaultOnSearch;
	    }
	  }, {
	    key: '_defaultOnSearch',
	    value: function _defaultOnSearch() {
	      return {
	        then: function then(f) {
	          f();
	        }
	      };
	    }
	  }, {
	    key: 'minLengthOfSearchText',
	    value: function minLengthOfSearchText() {
	      return this.searchText.length >= parseInt(this.minLengthSearch);
	    }
	  }, {
	    key: 'hasText',
	    value: function hasText() {
	      return this.searchText.length >= 1;
	    }
	  }, {
	    key: 'isVisibleList',
	    value: function isVisibleList() {
	      return this.minLengthOfSearchText() && this.showList && !this.isSearching;
	    }
	  }, {
	    key: 'isVisibleAlertCard',
	    value: function isVisibleAlertCard() {
	      var isEmptyFilteredEmployees = this.filteredEmployees.length === 0;
	      return this.showAlertCard && isEmptyFilteredEmployees && this.minLengthOfSearchText() && !this.isSearching;
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.searchText = '';
	      this.filteredEmployees = [];
	      if (this.onCleanSearch) {
	        this.onCleanSearch(this.EventEmitter({ searchText: this.searchText }));
	      }
	    }
	  }, {
	    key: 'search',
	    value: function search() {
	      if (!this.minLengthOfSearchText()) {
	        return;
	      }
	
	      this._showEmployees();
	    }
	  }, {
	    key: '_showEmployees',
	    value: function _showEmployees() {
	      var _this = this;
	
	      this.isSearching = true;
	      this.onSearch(this.EventEmitter({ searchText: this.searchText })).then(function (response) {
	        _this.employees = response;
	        _this.filteredEmployees = _this._getEmployeesToShow();
	        _this.showList = _this.filteredEmployees.length > 0;
	        _this.isSearching = false;
	        if (_this.reportSearchState) {
	          _this.reportSearchState(_this.EventEmitter({ searchText: _this.searchText, hasResults: _this.showList }));
	        }
	      });
	    }
	  }, {
	    key: 'getProfile',
	    value: function getProfile(employee) {
	      return employee.profile;
	    }
	  }, {
	    key: '_getEmployeesToShow',
	    value: function _getEmployeesToShow() {
	      var _this2 = this;
	
	      return this.employees.filter(function (_ref) {
	        var userId = _ref.userId,
	            employeeId = _ref.employeeId,
	            name = _ref.name;
	
	        var id = userId || employeeId;
	        var searchText = _this2.searchText.toLowerCase();
	        var userIdMatch = id.toLowerCase().indexOf(searchText) > -1;
	        var nameMatch = name.toLowerCase().indexOf(searchText) > -1;
	        return userIdMatch || nameMatch;
	      });
	    }
	  }, {
	    key: 'onSelectEmployeeAndHide',
	    value: function onSelectEmployeeAndHide(_ref2) {
	      var $event = _ref2.$event;
	
	      this.hideList();
	      this.onSelectEmployee(this.EventEmitter($event));
	      this._updateSelectedEmployee($event.name);
	    }
	  }, {
	    key: '_updateSelectedEmployee',
	    value: function _updateSelectedEmployee(name) {
	      if (this.fixedSelection) {
	        this.searchText = name;
	        return;
	      }
	
	      this.searchText = '';
	    }
	  }, {
	    key: 'hideList',
	    value: function hideList() {
	      this.showList = false;
	    }
	  }]);
	  return EmployeeSearchController;
	}();
	
	exports.default = EmployeeSearchController;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(954);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./employeeSearch.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./employeeSearch.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "employee-search{width:100%;min-width:300px}@media(max-width:1065px){employee-search.in-team-calendar{display:block;min-width:0;width:100%}}employee-search ::placeholder{right:20px;color:#aeaeae}employee-search employee-dropdown-list{top:37px;right:0}employee-search employee-dropdown-list ul{position:absolute;z-index:999}employee-search .employee-search-container{float:right;width:100%;max-width:300px;margin-top:18px}employee-search .employee-search-container .employee-search-input{position:relative;width:100%;max-width:300px;display:-moz-flex;display:-ms-flexbox;display:flex}employee-search .employee-search-container .employee-search-input i{position:absolute;top:50%;transform:translateY(-50%)}employee-search .employee-search-container .employee-search-input i.icon-cross{font-size:13px;font-weight:100;left:1.25rem;cursor:pointer;color:#aeaeae}employee-search .employee-search-container .employee-search-input i.icon-cross:hover{color:#0072c9}employee-search .employee-search-container .employee-search-input i.icon-search{font-size:17px;right:1.25rem;color:#aeaeae}employee-search .employee-search-container .employee-search-input i.icon-search.focus{color:#0072c9}employee-search .employee-search-container alert-card .card-message-alert{border-color:#c8175e;border-radius:5px;padding:10px}employee-search .employee-search-container alert-card .icon-warning{color:#c8175e!important}employee-search .employee-search-container alert-card .message-container{color:#c8175e!important;font-size:15px}employee-search .employee-search-container alert-card .icon-cross{display:none}employee-search .employee-search-container input[type=text]{font-family:Stag Sans;font-size:13px;width:100%;max-width:300px;height:37px;padding-left:35px;text-align:left;color:#0072c9;border:1px solid #dddfe2;background-color:#fff;box-shadow:0 2px 4px 0 hsla(216,8%,88%,.32)}@media(max-width:1065px){employee-search .employee-search-container input[type=text]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding-right:38px}}employee-search .employee-search-container input[type=text]:focus{border:1px solid #0072c9}employee-search .employee-search-container.responsiveMobile{float:none;max-width:none;padding:0;position:relative;margin-top:10px}employee-search .employee-search-container.responsiveMobile input[type=text]{padding-left:47px!important}employee-search .employee-search-container.responsiveMobile ul{width:100%}employee-search .employee-search-container.responsiveMobile .icon-cross{font-size:20px!important}employee-search .employee-search-container.responsiveMobile input[type=text]{padding-left:30px;font-size:13px;max-width:none;height:60px;line-height:normal}employee-search .employee-search-container.responsiveMobile .employee-search-input{max-width:none}", ""]);
	
	// exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _confirmCloseModal = __webpack_require__(956);
	
	var _confirmCloseModal2 = _interopRequireDefault(_confirmCloseModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmCloseModalModule = _angular2.default.module('confirmCloseModal', []).component('confirmCloseModal', _confirmCloseModal2.default).name;
	
	exports.default = confirmCloseModalModule;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _confirmCloseModal = __webpack_require__(957);
	
	var _confirmCloseModal2 = _interopRequireDefault(_confirmCloseModal);
	
	var _confirmCloseModal3 = __webpack_require__(958);
	
	var _confirmCloseModal4 = _interopRequireDefault(_confirmCloseModal3);
	
	__webpack_require__(959);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmCloseModalComponent = {
	  restrict: 'E',
	  bindings: {
	    description: '@',
	    smallDescription: '@',
	    buttonYes: '<',
	    literalLoansConfirmation: '@',
	    onConfirm: '&',
	    buttonNo: '<',
	    onClickNo: '&',
	    titleModal: '@',
	    isMobileApp: '<'
	  },
	  template: _confirmCloseModal2.default,
	  controller: _confirmCloseModal4.default
	};
	
	exports.default = confirmCloseModalComponent;

/***/ }),
/* 957 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <div class=\"modal-header text-center\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" ng-click=\"$ctrl.hideModal()\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n    <h4 ng-if=\"$ctrl.titleModal\" class=\"modal-title\">{{ $ctrl.titleModal }}</h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <p ng-if=\"$ctrl.description\"\n          class=\"description\">{{ $ctrl.description }}</p>\n        <p ng-if=\"!$ctrl.description && $ctrl.description !== undefined\" class=\"description\">\n          ¿{{ \"GLOBALS.CONFIRM_CLOSE\" | translate }}?\n        </p>\n        <p ng-if=\"$ctrl.smallDescription\"\n           class=\"small-description\">{{ $ctrl.smallDescription }}</p>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      ng-if=\"$ctrl.buttonNo\"\n      type=\"button\"\n      class=\"btn btn-app btn-default btn-cancel\"\n      ng-click=\"$ctrl.onClickNo()\" >{{ \"GLOBALS.BUTTON_ACTION.NO\" | translate }}</button>\n    <button\n      ng-if=\"$ctrl.buttonYes\"\n      type=\"button\"\n      class=\"btn btn-app btn-primary btn-confirm\"\n      ng-click=\"$ctrl.confirm()\" > {{ $ctrl.literalLoansConfirmation ? $ctrl.literalLoansConfirmation : \"GLOBALS.BUTTON_ACTION.YES\" | translate }}</button>\n    \n    \n    </div>\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.confirm()\"\n    on-click-second-button=\"$ctrl.hideModal()\">\n  </floating-action-buttons>\n</div>\n"

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmCloseModalController = function () {
	  function ConfirmCloseModalController() {
	    (0, _classCallCheck3.default)(this, ConfirmCloseModalController);
	  }
	
	  (0, _createClass3.default)(ConfirmCloseModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm() {
	      this.hideModal();
	      if (this.onConfirm) this.onConfirm();
	    }
	  }, {
	    key: 'hideModal',
	    value: function hideModal() {
	      $('.modal').modal('hide');
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.YES'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.NO'
	      }];
	    }
	  }]);
	  return ConfirmCloseModalController;
	}();
	
	exports.default = ConfirmCloseModalController;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(960);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./confirmCloseModal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./confirmCloseModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "confirm-close-modal .modal-content.responsiveMobile{padding-left:30px;padding-right:30px;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}confirm-close-modal .modal-body{margin:20px 0;text-align:center}confirm-close-modal .modal-body .description{font-size:24px}confirm-close-modal .modal-body .small-description{font-size:15px;margin:0 80px 20px}confirm-close-modal .modal-footer{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}", ""]);
	
	// exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _cannotSignupModal = __webpack_require__(962);
	
	var _cannotSignupModal2 = _interopRequireDefault(_cannotSignupModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cannotSignupModalModule = _angular2.default.module('cannotSignupModal', []).component('cannotSignupModal', _cannotSignupModal2.default).name;
	
	exports.default = cannotSignupModalModule;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cannotSignupModal = __webpack_require__(963);
	
	var _cannotSignupModal2 = _interopRequireDefault(_cannotSignupModal);
	
	var _cannotSignupModal3 = __webpack_require__(964);
	
	var _cannotSignupModal4 = _interopRequireDefault(_cannotSignupModal3);
	
	__webpack_require__(965);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cannotSignupModalComponent = {
	  restrict: 'E',
	  bindings: {
	    cannotSignUpError: '<',
	    onDismiss: '&',
	    isMobileApp: '<',
	    loanModality: '<'
	  },
	  template: _cannotSignupModal2.default,
	  controller: _cannotSignupModal4.default
	};
	
	exports.default = cannotSignupModalComponent;

/***/ }),
/* 963 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalCannotSignup\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalLoansDetail\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <failed-action\n      ng-if=\"$ctrl.cannotSignUpError === 'creditworthinessError'&& $ctrl.loanModality !== 'agreementHousingLoan'\"\n      class=\"failed-action-creditworthiness\"\n      title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n      description=\"{{ 'LOANS.LOANS_DETAIL.CANNOT_SIGN_UP_ERROR_CREDITWORTHINESS' | translate }}\"\n      close-modal=\"true\"\n      avoid-callback-on-close=\"$ctrl.avoidCallbackOnClose\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      button-text=\"{{ 'LOANS.LOANS_DETAIL.GO_TO_MY_LOANS' | translate}}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </failed-action>\n    \n    <failed-action\n      ng-if=\"$ctrl.cannotSignUpError === 'creditworthinessError'&& $ctrl.loanModality === 'agreementHousingLoan'\"\n      class=\"failed-action-creditworthiness\"\n      title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n      description=\"{{ 'LOANS.LOANS_DETAIL.CANNOT_SIGN_UP_ERROR_CREDITWORTHINESS_ON_CV' | translate }}\"\n      close-modal=\"true\"\n      avoid-callback-on-close=\"$ctrl.avoidCallbackOnClose\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      button-text=\"{{ 'LOANS.LOANS_DETAIL.GO_TO_MY_LOANS' | translate}}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </failed-action>\n\n    <failed-action\n      ng-if=\"$ctrl.cannotSignUpError === 'lengthOfServiceError'\"\n      class=\"failed-action-lengthofservice\"\n      title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n      description=\"{{ 'LOANS.LOANS_DETAIL.CANNOT_SIGN_UP_ERROR_SERVICE' | translate }}\"\n      close-modal=\"true\"\n      avoid-callback-on-close=\"$ctrl.avoidCallbackOnClose\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      button-text=\"{{ 'LOANS.LOANS_DETAIL.GO_TO_MY_LOANS' | translate}}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </failed-action>\n    \n  </div>\n</div>"

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CannotSignupModalController = function CannotSignupModalController() {
	  (0, _classCallCheck3.default)(this, CannotSignupModalController);
	
	  this.avoidCallbackOnClose = true;
	};
	
	exports.default = CannotSignupModalController;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(966);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./cannotSignupModal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./cannotSignupModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _successfulAction = __webpack_require__(968);
	
	var _successfulAction2 = _interopRequireDefault(_successfulAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var successfulActionModule = angular.module('vacations-absences.successfulAction', []).component('successfulAction', _successfulAction2.default).name;
	
	exports.default = successfulActionModule;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _successfulAction = __webpack_require__(969);
	
	var _successfulAction2 = _interopRequireDefault(_successfulAction);
	
	var _successfulAction3 = __webpack_require__(970);
	
	var _successfulAction4 = _interopRequireDefault(_successfulAction3);
	
	__webpack_require__(971);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var successfulActionComponent = {
	  restrict: 'E',
	  bindings: {
	    closeModal: '@',
	    modalId: '@',
	    modalIdToClose: '@',
	    onDismiss: '&',
	    title: '@',
	    message: '@',
	    messageJourney: '@',
	    description: '<',
	    descriptionBig: '@',
	    onClick: '&',
	    isMobileApp: '<',
	    withoutManager: '<',
	    scrollableBody: '<',
	    repaymentMessage: '<'
	  },
	  transclude: {
	    descriptionTextarea: '?descriptionTextarea'
	  },
	  template: _successfulAction2.default,
	  controller: _successfulAction4.default
	};
	
	exports.default = successfulActionComponent;

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <div class=\"modal-header text-center\">\n    <span class=\"icon icon-confirmation\"></span>\n    <button type=\"button\" ng-click=\"$ctrl.dismiss()\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\" id=\"{{$ctrl.modalId}}Label\">{{ $ctrl.title || (\"GLOBALS.SUCCESS_ACTION.DEFAULT_TITLE\" | translate) }}</h4>\n  </div>\n\n  <div class=\"modal-body\" ng-class=\"{ 'scrollable': $ctrl.isMobileApp && $ctrl.scrollableBody}\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <p ng-if=\"$ctrl.message && !$ctrl.withoutManager\"\n          ng-bind-html=\"$ctrl.message\"\n          class=\"description\"\n          ng-class=\"$ctrl.getCssSize()\"></p>\n\n        <p ng-if=\"$ctrl.repaymentMessage\"\n          ng-bind-html=\"$ctrl.repaymentMessage\"\n          class=\"description\"\n          ng-class=\"$ctrl.getCssSize()\"></p>\n\n        <p ng-if=\"$ctrl.withoutManager\" \n          class=\"description\">\n          {{\"FOOD_BENEFIT.MODAL_APPROVE_ALL.MESSAGE_WITHOUT_MANAGER\" | translate }}\n        </p>\n\n        <p ng-if=\"$ctrl.description\"\n          ng-bind-html=\"$ctrl.description\"\n          class=\"strong-description\"\n          ng-class=\"$ctrl.getCssSize()\"></p>\n\n        <p ng-if=\"$ctrl.messageJourney\"\n          ng-bind-html=\"$ctrl.messageJourney\"\n          class=\"description\"\n          ng-class=\"$ctrl.getCssSize()\"></p>        \n        <p ng-if=\"$ctrl.showMessage()  && !$ctrl.withoutManager && !$ctrl.repaymentMessage\" class=\"description\">{{\"GLOBALS.SUCCESS_ACTION.DEFAULT_DESCRIPTION\" | translate }}</p>        \n      </div>\n    </div>\n  </div>\n\n  <div class=\"big-description\" ng-if=\"$ctrl.hasDescriptionTextarea\" ng-transclude=\"descriptionTextarea\"></div>\n\n  <div class=\"modal-footer\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      ng-if=\"$ctrl.closeModal\"\n      type=\"button\"\n      class=\"btn btn-app btn-primary\"\n      ng-click=\"$ctrl.dismiss();\" >{{\"GLOBALS.BUTTON_ACTION.OK\" | translate }}</button>\n  </div>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.dismiss()\">\n  </floating-action-buttons>\n</div>\n"

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessfulActionController = function () {
	  SuccessfulActionController.$inject = ["$transclude"];
	  function SuccessfulActionController($transclude) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SuccessfulActionController);
	    this.transclude = $transclude;
	  }
	
	  (0, _createClass3.default)(SuccessfulActionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      this.hasDescriptionTextarea = this.transclude.isSlotFilled('descriptionTextarea');
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      this.hideModal();
	      if (this.onDismiss) this.onDismiss();
	      if (this.onClick) this.onClick();
	    }
	  }, {
	    key: 'hideModal',
	    value: function hideModal() {
	      if (this.modalIdToClose) {
	        $('#' + this.modalIdToClose).modal('hide');
	        return;
	      }
	      $('.modal').modal('hide');
	    }
	  }, {
	    key: 'getCssSize',
	    value: function getCssSize() {
	      return {
	        'size-big': angular.isDefined(this.descriptionBig)
	      };
	    }
	  }, {
	    key: 'showMessage',
	    value: function showMessage() {
	      return !this.message && !this.description;
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.OK'
	      }];
	    }
	  }]);
	  return SuccessfulActionController;
	}();
	
	exports.default = SuccessfulActionController;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(972);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./successfulAction.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./successfulAction.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "successful-action .modal-content{padding-top:58px}successful-action .modal-content.responsiveMobile{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}successful-action .modal-content .modal-header{border-bottom:1px solid #dddfe2}successful-action .modal-content .modal-header .icon-confirmation{display:block;font-size:76px;margin-bottom:24px}successful-action .modal-content .modal-header h4{color:#86c82d!important;padding-bottom:10px}successful-action .modal-content .modal-body{padding-top:17px;text-align:center}successful-action .modal-content .modal-body.scrollable{max-height:260px;overflow-y:scroll;overflow-x:hidden}successful-action .modal-content .modal-body .description{color:#666;font-family:ArialMT;font-size:15px;line-height:1.4;margin:0 auto;margin-bottom:31px;max-width:200px}successful-action .modal-content .modal-body .description.size-big{max-width:100%}successful-action .modal-content .big-description{border:1px solid #dddfe2;height:168px;overflow-y:scroll;padding-left:38px;padding-top:21px;padding-bottom:21px;margin-bottom:44px}successful-action .modal-content .strong-description{font-size:18px;font-family:Stag Sans}successful-action .modal-content .modal-footer{text-align:center}successful-action .modal-content .modal-footer .btn{height:38px;line-height:38px;width:150px}", ""]);
	
	// exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _failedAction = __webpack_require__(974);
	
	var _failedAction2 = _interopRequireDefault(_failedAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var failedActionModule = angular.module('vacations-absences.failedAction', []).component('failedAction', _failedAction2.default).name;
	
	exports.default = failedActionModule;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _failedAction = __webpack_require__(975);
	
	var _failedAction2 = _interopRequireDefault(_failedAction);
	
	var _failedActionController = __webpack_require__(976);
	
	var _failedActionController2 = _interopRequireDefault(_failedActionController);
	
	__webpack_require__(977);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var failedActionComponent = {
	  restrict: 'E',
	  bindings: {
	    title: '@',
	    description: '@',
	    closeModal: '@',
	    modalId: '@',
	    buttonText: '@',
	    onDismiss: '&',
	    modSize: '@',
	    avoidCallbackOnClose: '<',
	    isMobileApp: '<',
	    onClick: '&'
	  },
	  template: _failedAction2.default,
	  controller: _failedActionController2.default
	};
	
	exports.default = failedActionComponent;

/***/ }),
/* 975 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <div class=\"modal-header\">\n    <span ng-if=\"!$ctrl.isTimeoutError()\" class=\"icon-warning\"></span>\n    <span ng-if=\"$ctrl.isTimeoutError()\" class=\"icon-warning blue\"></span>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\" ng-click=\"$ctrl.close()\"></span></button>\n    <h4 ng-if=\"!$ctrl.isTimeoutError()\" class=\"modal-title\" id=\"{{$ctrl.modalId}}Label\">{{$ctrl.title}}</h4>\n    <h4 ng-if=\"$ctrl.isTimeoutError()\" class=\"modal-title blue\" id=\"{{$ctrl.modalId}}Label\">{{'GLOBALS.ATTENTION' | translate}}</h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <p ng-if=\"!$ctrl.isTimeoutError()\" class=\"description\" ng-class=\"$ctrl.getClass()\">\n          {{$ctrl.description || 'GLOBALS.ERROR' | translate }}\n        </p>\n        <p ng-if=\"$ctrl.isTimeoutError()\" class=\"description\" ng-class=\"$ctrl.getClass()\">\n          {{'GLOBALS.TIMEOUT' | translate }}\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      ng-if=\"$ctrl.closeModal && $ctrl.linkText === undefined\"\n      type=\"button\"\n      class=\"btn btn-app btn-primary\"\n      data-dismiss=\"modal\"\n      ng-click=\"$ctrl.hideModalAndOnDismiss()\" >{{$ctrl.buttonText}}</button>\n  </div>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.hideModalAndOnDismiss()\">\n  </floating-action-buttons>\n</div>\n"

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FailedActionController = function () {
	  function FailedActionController() {
	    (0, _classCallCheck3.default)(this, FailedActionController);
	  }
	
	  (0, _createClass3.default)(FailedActionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (this.avoidCallbackOnClose) {
	        return;
	      }
	
	      this.onDismiss();
	    }
	  }, {
	    key: 'hideModalAndOnDismiss',
	    value: function hideModalAndOnDismiss() {
	      if (this.onClick) {
	        this.onClick();
	      }
	      $('.modal').modal('hide');
	      this.onDismiss();
	    }
	  }, {
	    key: 'getClass',
	    value: function getClass() {
	      return {
	        'mod-size': this.modSize
	      };
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: this.buttonText
	      }];
	    }
	  }, {
	    key: 'isTimeoutError',
	    value: function isTimeoutError() {
	      return this.description === _constants.TIMEOUT;
	    }
	  }]);
	  return FailedActionController;
	}();
	
	exports.default = FailedActionController;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(978);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./failedAction.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./failedAction.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "failed-action .modal-content{padding-top:58px}failed-action .modal-content.responsiveMobile{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}failed-action .modal-content .modal-header{border-bottom:1px solid #dddfe2}failed-action .modal-content .modal-header .icon-warning{color:#c8175e;display:block;font-size:77px;height:76px;margin:0 auto 22px;width:76px}failed-action .modal-content .modal-header .blue{color:#0072c9!important}failed-action .modal-content .modal-header h4{color:#c8175e!important;padding-bottom:10px}failed-action .modal-content .modal-body{padding-top:17px;text-align:center}failed-action .modal-content .modal-body .description{color:#666;font-family:ArialMT;font-size:15px;line-height:1.4;margin-bottom:31px;margin:0 auto 29px;max-width:200px}failed-action .modal-content .modal-body .mod-size{max-width:310px}failed-action .modal-content .modal-footer{text-align:center}failed-action .modal-content .modal-footer .btn{height:38px;line-height:38px;width:150px}failed-action .modal-content .modal-footer .link{height:48px;line-height:50px;width:221px}", ""]);
	
	// exports


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardDetails = __webpack_require__(980);
	
	var _cardDetails2 = _interopRequireDefault(_cardDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardDetailsModule = angular.module('vacations-absences.cardDetails', []).component('cardDetails', _cardDetails2.default).name;
	
	exports.default = cardDetailsModule;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardDetails = __webpack_require__(981);
	
	var _cardDetails2 = _interopRequireDefault(_cardDetails);
	
	var _cardDetails3 = __webpack_require__(982);
	
	var _cardDetails4 = _interopRequireDefault(_cardDetails3);
	
	__webpack_require__(983);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardDetailComponent = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {
	    headerLinkTitle: '@?',
	    headerClass: '@?'
	  },
	  template: _cardDetails2.default,
	  controller: _cardDetails4.default
	};
	
	exports.default = cardDetailComponent;

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"details-header-content\">\n  <header ng-class=\"$ctrl.getCardClass()\">\n    <h1>\n      <a href=\"\"\n         title=\"{{$ctrl.headerLinkTitle}}\"\n         ng-click=\"$ctrl.toggle()\">\n        {{'GLOBALS.BUTTON_ACTION.DETAILS' | translate}}\n        <span ng-if=\"!$ctrl.isOpen()\" class=\"icon icon-arrow-select-down\"></span>\n        <span ng-if=\"$ctrl.isOpen()\" class=\"icon icon-arrow-select-up\"></span>\n      </a>\n    </h1>\n  </header>\n</div>\n\n<section class=\"details-content\" ng-if=\"$ctrl.isOpen()\"><!-- ng-class=\"$ctrl.getContentClass()\" -->\n  <ng-transclude></ng-transclude>\n</section>\n"

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HIDE_DETAIL = 'CARD_DETAILS_HIDE';
	
	var cardDetailsController = function () {
	  cardDetailsController.$inject = ["$log", "$scope"];
	  function cardDetailsController($log, $scope) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, cardDetailsController);
	    this.log = $log;
	    this.open = false;
	
	    $scope.$on(HIDE_DETAIL, function () {
	      _this.open = false;
	    });
	  }
	
	  (0, _createClass3.default)(cardDetailsController, [{
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.open === true;
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.open = !this.open;
	      this.log.info('detail toggle(): isOpen', this.open);
	    }
	  }, {
	    key: 'getCardClass',
	    value: function getCardClass() {
	      return this.headerClass;
	    }
	  }, {
	    key: 'getContentClass',
	    value: function getContentClass() {
	      return {
	        'is-open': this.isOpen()
	      };
	    }
	  }]);
	  return cardDetailsController;
	}();
	
	exports.default = cardDetailsController;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(984);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./cardDetails.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./cardDetails.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "card-details{display:block}card-details .details-header-content header{height:30px}card-details .details-header-content header h1{margin:0;font-size:inherit;height:inherit;line-height:32px;text-align:center;background-color:#f2f3f4;border:1px solid #dddfe2;border-top:none}card-details .details-header-content header h1 a{margin-right:8px;font-family:Stag Sans;font-weight:400;color:#0072c9;font-size:15px;text-decoration:none}card-details .details-header-content header h1 a:hover{text-decoration:none;background-color:inherit}card-details .details-header-content header h1 a .icon{font-size:12px;vertical-align:middle;margin-left:6px}card-details .details-content{background-color:#fbfbfb}", ""]);
	
	// exports


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _questionModal = __webpack_require__(986);
	
	var _questionModal2 = _interopRequireDefault(_questionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questionModalModule = _angular2.default.module('questionModal', []).component('questionModal', _questionModal2.default).name;
	
	exports.default = questionModalModule;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _questionModal = __webpack_require__(987);
	
	var _questionModal2 = _interopRequireDefault(_questionModal);
	
	var _questionModal3 = __webpack_require__(988);
	
	var _questionModal4 = _interopRequireDefault(_questionModal3);
	
	__webpack_require__(989);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questionModalComponent = {
	  restrict: 'E',
	  bindings: {
	    modalId: '<',
	    title: '@',
	    description: '<',
	    options: '<',
	    onSelection: '&',
	    isInception: '&',
	    data: '<'
	  },
	  transclude: {
	    descriptionTextarea: '?descriptionTextarea'
	  },
	  template: _questionModal2.default,
	  controller: _questionModal4.default
	};
	
	exports.default = questionModalComponent;

/***/ }),
/* 987 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\">\n  <div class=\"modal-header\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\" id=\"{{$ctrl.modalId}}Label\">{{$ctrl.title}}</h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <span class=\"description\" ng-bind-html=\"$ctrl.description\"></span>\n      </div>\n    </div>\n  </div>\n\n   <div class=\"big-description\" ng-if=\"$ctrl.hasDescriptionTextarea\" ng-transclude=\"descriptionTextarea\"></div>\n\n  <div class=\"modal-footer\">\n\n    <button ng-repeat=\"option in $ctrl.options\"\n      type=\"button\"\n      class=\"btn btn-app btn-primary\"\n      ng-click=\"$ctrl.buttonClick(option.value)\">{{option.text| translate}}</button>\n\n  </div>\n</div>\n"

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuestionModalController = function () {
	  QuestionModalController.$inject = ["EventEmitter", "$transclude"];
	  function QuestionModalController(EventEmitter, $transclude) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, QuestionModalController);
	    this.EventEmitter = EventEmitter;
	    this.transclude = $transclude;
	  }
	
	  (0, _createClass3.default)(QuestionModalController, [{
	    key: 'buttonClick',
	    value: function buttonClick(option) {
	      this.onSelection(this.EventEmitter({ selection: option }));
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      this.hasDescriptionTextarea = this.transclude.isSlotFilled('descriptionTextarea');
	    }
	  }]);
	  return QuestionModalController;
	}();
	
	exports.default = QuestionModalController;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(990);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./questionModal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./questionModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "question-modal .modal-content{padding-top:58px}question-modal .modal-content.responsiveMobile{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}question-modal .modal-content .modal-header{border-bottom:1px solid #dddfe2}question-modal .modal-content .modal-header h4{color:#0072c9;padding-bottom:10px}question-modal .modal-content .modal-body{padding-top:17px;text-align:center}question-modal .modal-content .modal-body .description{color:#666;font-family:ArialMT;font-size:15px;line-height:1.4;margin:0 auto 29px;margin-bottom:31px;max-width:200px}question-modal .modal-content .big-description{border:1px solid #dddfe2;height:168px;overflow-y:scroll;padding-left:38px;padding-top:21px;padding-bottom:21px;margin-bottom:44px}question-modal .modal-content .strong-description{font-size:18px;font-family:Stag Sans}question-modal .modal-content .modal-footer{margin-top:51px;text-align:center}question-modal .modal-content .modal-footer .btn{height:38px;line-height:38px;width:150px}", ""]);
	
	// exports


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _optionSwitch = __webpack_require__(992);
	
	var _optionSwitch2 = _interopRequireDefault(_optionSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionSwitchModule = _angular2.default.module('optionSwitch', []).component('optionSwitch', _optionSwitch2.default).name;
	
	exports.default = optionSwitchModule;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _optionSwitch = __webpack_require__(993);
	
	var _optionSwitch2 = _interopRequireDefault(_optionSwitch);
	
	var _optionSwitch3 = __webpack_require__(994);
	
	var _optionSwitch4 = _interopRequireDefault(_optionSwitch3);
	
	__webpack_require__(995);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionSwitchComponent = {
	  restrict: 'E',
	  bindings: {
	    optionsData: '<',
	    onSelect: '&',
	    lockOn: '<',
	    editable: '<',
	    autoReturnDefaultOption: '<',
	    selectedOption: '<'
	  },
	  template: _optionSwitch2.default,
	  controller: _optionSwitch4.default
	};
	
	exports.default = optionSwitchComponent;

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"$ctrl.getClasses()\">\n  <div ng-repeat=\"option in $ctrl.optionsData\"\n      class=\"request-type-button pull-left\"\n      ng-class=\"$ctrl.getCssActive(option.value , $last)\"\n      ng-click=\"$ctrl.selectOption(option.value)\">\n      <p>{{option.text | translate}}</p>\n  </div>\n</div>\n"

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OptionSwitchController = function () {
	  OptionSwitchController.$inject = ["EventEmitter", "$scope"];
	  function OptionSwitchController(EventEmitter, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OptionSwitchController);
	    this.EventEmitter = EventEmitter;
	    this.scope = $scope;
	  }
	
	  (0, _createClass3.default)(OptionSwitchController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this._initOptions();
	      this._setInitialModeAndLock();
	      this._setWatchSelectedOption();
	    }
	  }, {
	    key: '_initOptions',
	    value: function _initOptions() {
	      this.options = [];
	    }
	  }, {
	    key: '_setInitialModeAndLock',
	    value: function _setInitialModeAndLock() {
	      var initOption = this.lockOn ? this.lockOn : this.optionsData[0].value;
	      this.options[initOption] = true;
	      this._returnDefaultOption(initOption);
	    }
	  }, {
	    key: '_returnDefaultOption',
	    value: function _returnDefaultOption(initOption) {
	      if (this.autoReturnDefaultOption === true) {
	        this._emitOption(initOption);
	      }
	    }
	  }, {
	    key: '_setWatchSelectedOption',
	    value: function _setWatchSelectedOption() {
	      var _this = this;
	
	      if (this.selectedOption) {
	        this.scope.$watch(function () {
	          return _this.selectedOption;
	        }, function (selection) {
	          _this._setOptionsStatus(selection);
	        });
	      }
	    }
	  }, {
	    key: 'selectOption',
	    value: function selectOption(selection) {
	      if (this._avoidDispatch()) {
	        return;
	      }
	
	      this._setOptionsStatus(selection);
	      this._emitOption(selection);
	    }
	  }, {
	    key: '_avoidDispatch',
	    value: function _avoidDispatch() {
	      return this.lockOn && !this.editable;
	    }
	  }, {
	    key: '_setOptionsStatus',
	    value: function _setOptionsStatus(selection) {
	      var _this2 = this;
	
	      this.options[selection] = true;
	
	      (0, _keys2.default)(this.options).forEach(function (option) {
	        if (selection !== option) {
	          _this2.options[option] = false;
	        }
	      });
	    }
	  }, {
	    key: '_emitOption',
	    value: function _emitOption(selection) {
	      this.onSelect(this.EventEmitter({ option: selection }));
	    }
	  }, {
	    key: 'getCssActive',
	    value: function getCssActive(selected, last) {
	      return {
	        'active': this.options[selected],
	        'shadow-on-left': last
	      };
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        locked: !!this.lockOn && !this.editable
	      };
	    }
	  }]);
	  return OptionSwitchController;
	}();
	
	exports.default = OptionSwitchController;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(996);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./optionSwitch.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./optionSwitch.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "option-switch{display:block;margin-bottom:22px;height:37px}option-switch .locked{pointer-events:none}option-switch .request-type-button{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:0;width:50%;height:37px;line-height:37px;background-color:#eaebed;border:.5px solid #0072c9;cursor:pointer;display:inline-block}option-switch .request-type-button p{color:#aeaeae;font-family:Stag Sans!important;font-size:13px;text-align:center;text-transform:uppercase}option-switch .request-type-button:not(.active){box-shadow:inset -2px 0 2px 0 #aeaeae}option-switch .request-type-button:not(.active).shadow-on-left{box-shadow:inset 2px 0 2px 0 #aeaeae}option-switch .request-type-button.active{height:37px;background-color:#0072c9;border:1px solid #0072c9;box-shadow:none}option-switch .request-type-button.active p{color:#fff!important}", ""]);
	
	// exports


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalCoachmark = __webpack_require__(998);
	
	var _modalCoachmark2 = _interopRequireDefault(_modalCoachmark);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCoachmarkModule = angular.module('vacations-absences.modalCoachmark', []).component('modalCoachmark', _modalCoachmark2.default).name;
	
	exports.default = modalCoachmarkModule;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalCoachmark = __webpack_require__(999);
	
	var _modalCoachmark2 = _interopRequireDefault(_modalCoachmark);
	
	var _modalCoachmark3 = __webpack_require__(1000);
	
	var _modalCoachmark4 = _interopRequireDefault(_modalCoachmark3);
	
	__webpack_require__(1001);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCoachmarkComponent = {
	  restrict: 'E',
	  bindings: {
	    isInception: '<',
	    coachmarkDismissed: '&',
	    data: '<',
	    userId: '<'
	  },
	  template: _modalCoachmark2.default,
	  controller: _modalCoachmark4.default
	};
	
	exports.default = modalCoachmarkComponent;

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalCoachmark\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"modalCoachmarkLabel\">\n\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <div class=\"modal-content\">\n\n      <div class=\"modal-header text-left\">\n        <h4 class=\"modal-title\" id=\"modalCoachmarkLabel\">{{ $ctrl.data.title | translate}}</h4>\n         <p ng-repeat=\"subtitle in $ctrl.data.subtitles\" ng-show=\"$ctrl.currentSlide === $index\">{{ subtitle.text | translate }}</p>\n      </div>\n\n      <div class=\"modal-body\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n\n            <div id=\"modalCoachmarkCarousel\" class=\"carousel slide\" data-ride=\"carousel\">\n              <!-- Indicators -->\n              <ol class=\"carousel-indicators\">\n                <li ng-repeat=\"img in $ctrl.data.imgs\" href=\"#modalCoachmarkCarousel\" data-slide-to=\"{{$index}}\" ng-class=\"{active: $first}\"></li>\n              </ol>\n\n              <!-- Wrapper for slides -->\n              <div class=\"carousel-inner\" role=\"listbox\">\n                <div ng-repeat=\"img in $ctrl.data.imgs\" class=\"item\" ng-class=\"{active: $first}\"><img ng-src=\"{{img.source}}\" alt=\"{{ img.alt | translate}}\"></div>\n              </div>\n\n              <!-- Controls -->\n              <a ng-show=\"$ctrl.data.imgs.length > 1\" class=\"left carousel-control\" href=\"#modalCoachmarkCarousel\" role=\"button\"\n                 data-slide=\"prev\">\n                <span class=\"icon-arrow-coachmark-left\"></span>\n                <span class=\"sr-only\">{{ 'GLOBALS.BUTTON_ACTION.PREVIOUS' | translate }}</span>\n              </a>\n              <a ng-show=\"$ctrl.data.imgs.length > 1\" class=\"right carousel-control\" href=\"#modalCoachmarkCarousel\" role=\"button\"\n                 data-slide=\"next\">\n                <span class=\"icon-arrow-coachmark-right\"></span>\n                <span class=\"sr-only\">{{ 'GLOBALS.BUTTON_ACTION.NEXT' | translate }}</span>\n              </a>\n            </div>\n\n          </div>\n        </div>\n      </div>\n\n      <div class=\"modal-footer\">\n        <div class=\"row\">\n          <div class=\"col-xs-6\">\n            <div class=\"checkbox pull-left\">\n              <input type=\"checkbox\" id=\"dontShowAgain\" ng-model=\"$ctrl.dontShowAgain\"\n                     ng-true-value=\"true\">\n              <label for=\"dontShowAgain\">{{ 'GLOBALS.COACHMARK.DONTSHOWAGAIN' | translate }}</label>\n            </div>\n          </div>\n          <div class=\"col-xs-6\">\n            <button type=\"button\" class=\"btn btn-app btn-primary\" ng-click=\"$ctrl.onDismiss();\">\n              {{'GLOBALS.COACHMARK.SKIP' | translate }}\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalCoachmarkController = function () {
	  ModalCoachmarkController.$inject = ["cookieService", "$scope", "visitedStatesService", "EventEmitter"];
	  function ModalCoachmarkController(cookieService, $scope, visitedStatesService, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalCoachmarkController);
	    this.cookieService = cookieService;
	    this.scope = $scope;
	    this.EventEmitter = EventEmitter;
	    this.currentSlide = 0;
	    this.visitedStatesService = visitedStatesService;
	  }
	
	  (0, _createClass3.default)(ModalCoachmarkController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isInception || this.visitedStatesService.stateVisited(this.data.state)) {
	        return;
	      }
	
	      if (!this.userHasSeenCoachmark()) {
	        this.visitedStatesService.setVisited(this.data.state);
	        this.initModal();
	        this.initCarousel();
	      }
	    }
	  }, {
	    key: 'initModal',
	    value: function initModal() {
	      var _this = this;
	
	      this.modal = $(_constants.MODALS.COACHMARK);
	      this.modal.on('hidden.bs.modal', function () {
	        return _this.onDismiss();
	      });
	      this.modal.modal();
	    }
	  }, {
	    key: 'initCarousel',
	    value: function initCarousel() {
	      var _this2 = this;
	
	      this.carousel.on('slide.bs.carousel', function (_ref) {
	        var direction = _ref.direction;
	
	        _this2.currentSlide = direction === 'left' ? _this2.currentSlide + 1 : _this2.currentSlide - 1;
	        _this2.checkOutOfBounds();
	        _this2.scope.$apply();
	      });
	    }
	  }, {
	    key: 'checkOutOfBounds',
	    value: function checkOutOfBounds() {
	      if (this.currentSlide < this.FIRST_SLIDE) this.currentSlide = this.LAST_SLIDE;
	      if (this.currentSlide > this.LAST_SLIDE) this.currentSlide = this.FIRST_SLIDE;
	    }
	  }, {
	    key: 'userHasSeenCoachmark',
	    value: function userHasSeenCoachmark() {
	      return this.cookieService && this.cookieService.get(this.getCookieName());
	    }
	  }, {
	    key: 'onDismiss',
	    value: function onDismiss() {
	      this.cookieService.put(this.getCookieName(), this.dontShowAgain);
	
	      this.coachmarkDismissed(this.EventEmitter({
	        modalDismissed: true
	      }));
	
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'getNumberArray',
	    value: function getNumberArray(num) {
	      return new Array(num);
	    }
	  }, {
	    key: 'getCookieName',
	    value: function getCookieName() {
	      return '' + this.data.module + this.data.tab + _constants.COOKIES.COACHMARK + this.userId;
	    }
	  }, {
	    key: 'FIRST_SLIDE',
	    get: function get() {
	      return 0;
	    }
	  }, {
	    key: 'LAST_SLIDE',
	    get: function get() {
	      return this.data.imgs.length - 1;
	    }
	  }, {
	    key: 'carousel',
	    get: function get() {
	      return $('#modalCoachmarkCarousel');
	    }
	  }]);
	  return ModalCoachmarkController;
	}();
	
	exports.default = ModalCoachmarkController;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1002);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./modalCoachmark.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./modalCoachmark.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-coachmark .modal{z-index:2000000001}modal-coachmark .modal-dialog{height:550px;width:720px}modal-coachmark .modal-dialog .modal-content{box-shadow:none!important;background-color:#f9f9f9;border-radius:5px!important;padding:32px 20px 18px}modal-coachmark .modal-dialog .modal-content .modal-header{border:0;padding-left:50px}modal-coachmark .modal-dialog .modal-content .modal-header h4{font-size:18px;text-align:left;margin-bottom:10px;padding:0;height:20px}modal-coachmark .modal-dialog .modal-content .modal-header p{margin-top:0;font-size:15px;color:#666;letter-spacing:-.18px;padding-right:30px;min-height:42px;white-space:pre-wrap;height:100px}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-indicators{bottom:-56px}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-indicators li{background-color:#aeaeae;width:14px;height:14px;margin:0 2px}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-indicators li.active{background:#52bcec;width:14px;height:14px;margin:0 2px}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-inner{width:500px;margin:0 auto;margin-bottom:42px;background:#fff}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-inner .item{height:338px}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-inner .item.active,modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-inner .item.next,modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-inner .item.prev{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-inner .item img{width:100%;max-width:500px;height:auto;display:block;margin:0 auto}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-control{background:none;opacity:1}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-control .icon-arrow-coachmark-left,modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-control .icon-arrow-coachmark-right{font-size:40px;position:absolute;text-shadow:0;opacity:.6}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-control .icon-arrow-coachmark-left:hover,modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-control .icon-arrow-coachmark-right:hover{opacity:1}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-control .icon-arrow-coachmark-left{right:61px;top:151px}modal-coachmark .modal-dialog .modal-content .modal-body .carousel .carousel-control .icon-arrow-coachmark-right{left:63px;top:151px}modal-coachmark .modal-dialog .modal-content .modal-footer{padding-left:40px;padding-right:20px}modal-coachmark .modal-dialog .modal-content .modal-footer .btn{width:150px;height:38px;line-height:38px}", ""]);
	
	// exports


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _employeeName = __webpack_require__(1004);
	
	var _employeeName2 = _interopRequireDefault(_employeeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeNameModule = angular.module('employeeName', []).component('employeeName', _employeeName2.default).name;
	
	exports.default = employeeNameModule;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _employeeName = __webpack_require__(1005);
	
	var _employeeName2 = _interopRequireDefault(_employeeName);
	
	var _employeeName3 = __webpack_require__(1006);
	
	var _employeeName4 = _interopRequireDefault(_employeeName3);
	
	__webpack_require__(1007);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeNameComponent = {
	  restrict: 'E',
	  bindings: {
	    name: '@',
	    enrollment: '@'
	  },
	  template: _employeeName2.default,
	  controller: _employeeName4.default
	};
	
	exports.default = employeeNameComponent;

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	module.exports = "<span title=\"{{$ctrl.title}}\">{{$ctrl.name | lowercase}}</span>\n"

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeNameController = function () {
	  function EmployeeNameController() {
	    (0, _classCallCheck3.default)(this, EmployeeNameController);
	  }
	
	  (0, _createClass3.default)(EmployeeNameController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.title = this.getTitle();
	    }
	  }, {
	    key: "getTitle",
	    value: function getTitle() {
	      var title = this.name;
	      if (true) {
	        title = this.enrollment;
	      }
	      return title;
	    }
	  }]);
	  return EmployeeNameController;
	}();
	
	exports.default = EmployeeNameController;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1008);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./employeeName.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./employeeName.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "employee-name{display:inline-block}employee-name span{text-transform:capitalize}", ""]);
	
	// exports


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _floatingActionButtons = __webpack_require__(1010);
	
	var _floatingActionButtons2 = _interopRequireDefault(_floatingActionButtons);
	
	var _floatingActionButtons3 = __webpack_require__(1015);
	
	var _floatingActionButtons4 = _interopRequireDefault(_floatingActionButtons3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var floatingActionButtonsModule = _angular2.default.module('floatingActionButtons', []).component('floatingActionButtons', _floatingActionButtons2.default).service('floatingActionButtonsService', _floatingActionButtons4.default).name;
	
	exports.default = floatingActionButtonsModule;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _floatingActionButtons = __webpack_require__(1011);
	
	var _floatingActionButtons2 = _interopRequireDefault(_floatingActionButtons);
	
	var _floatingActionButtons3 = __webpack_require__(1012);
	
	var _floatingActionButtons4 = _interopRequireDefault(_floatingActionButtons3);
	
	__webpack_require__(1013);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var floatingActionButtonsComponent = {
	  restrict: 'E',
	  bindings: {
	    buttons: '<',
	    onClickFirstButton: '&',
	    onClickSecondButton: '&',
	    isSimulate: '<',
	    isChoicesOpen: '<',
	    switchColors: '<'
	  },
	  template: _floatingActionButtons2.default,
	  controller: _floatingActionButtons4.default
	};
	
	exports.default = floatingActionButtonsComponent;

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"floating-action-buttons-list\"\n  ng-class=\"$ctrl.getClass()\">\n\n  <button\n    type=\"button\"\n    id=\"secondFloatingButton\"\n    class=\"btn btn-app btn-default pull-left\"\n    ng-show=\"!$ctrl.isSingleAction\"\n    ng-click=\"$ctrl.onClickSecondButton()\">\n    {{ $ctrl.buttons[1].literal | translate }}\n  </button>\n  <button\n    type=\"button\"\n    id=\"firstFloatingButton\"\n    class=\"btn btn-app btn-primary pull-left\"\n    ng-click=\"$ctrl.onClickFirstButton()\"\n    ng-disabled=\"$ctrl.buttons[0].disabled\">\n    {{ $ctrl.literalFirstButton | translate }}\n  </button>\n\n</div>\n"

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FloatingActionButtonsController = function () {
	  FloatingActionButtonsController.$inject = ["floatingActionButtonsService", "$translate"];
	  function FloatingActionButtonsController(floatingActionButtonsService, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FloatingActionButtonsController);
	    this.translate = $translate;
	    this.floatingActionButtonsService = floatingActionButtonsService;
	  }
	
	  (0, _createClass3.default)(FloatingActionButtonsController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.floatingActionButtonsService.run();
	      if (this.switchColors) {
	        this.switchColorButtons();
	      }
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      this.isSingleAction = this.buttons.length === 1;
	      this.literalFirstButton = this.getLiteralFirstButton();
	      this.$onChanges = function () {
	        this.literalFirstButton = this.getLiteralFirstButton();
	      };
	    }
	  }, {
	    key: 'getLiteralFirstButton',
	    value: function getLiteralFirstButton() {
	      if (this.isSimulate) {
	        return this.buttons[0].simulate;
	      }
	      if (this.isChoicesOpen) {
	        return this.buttons[0].literalWithChoices;
	      }
	      return this.buttons[0].literal;
	    }
	  }, {
	    key: 'getClass',
	    value: function getClass() {
	      return {
	        'one-button': this.isSingleAction,
	        'two-buttons': !this.isSingleAction
	      };
	    }
	  }, {
	    key: 'switchColorButtons',
	    value: function switchColorButtons() {
	      $('#firstFloatingButton').removeClass('btn-primary');
	      $('#firstFloatingButton').addClass('btn-default');
	
	      $('#secondFloatingButton').removeClass('btn-default');
	      $('#secondFloatingButton').addClass('btn-primary');
	    }
	  }]);
	  return FloatingActionButtonsController;
	}();
	
	exports.default = FloatingActionButtonsController;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1014);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./floatingActionButtons.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./floatingActionButtons.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "floating-action-buttons{display:block;position:fixed;bottom:0;left:0;width:100%;z-index:1000;opacity:1}floating-action-buttons.ng-hide{opacity:0}floating-action-buttons.ng-hide-add,floating-action-buttons.ng-hide-remove{transition:all .5s linear}floating-action-buttons.with-choices{bottom:75px}floating-action-buttons .floating-action-buttons-list .btn[disabled]{opacity:1;background-color:#5aa4dc}floating-action-buttons .floating-action-buttons-list.one-button .btn,floating-action-buttons .floating-action-buttons-list.two-buttons .btn{height:75px;font-size:16px}floating-action-buttons .floating-action-buttons-list.one-button .btn{width:100%}floating-action-buttons .floating-action-buttons-list.two-buttons .btn{width:50%}floating-action-buttons .floating-action-buttons-list .btn.btn-app.btn-primary:focus{color:#fff;background-color:#0072c9;outline:0}", ""]);
	
	// exports


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _isIOS = __webpack_require__(1016);
	
	var _isIOS2 = _interopRequireDefault(_isIOS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_EVENT = {
	  target: null
	};
	
	var FloatingActionButtonsBehaviour = function () {
	  FloatingActionButtonsBehaviour.$inject = ["$timeout", "$window"];
	  function FloatingActionButtonsBehaviour($timeout, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FloatingActionButtonsBehaviour);
	    this.timeout = $timeout;
	    this.window = $window;
	    this.isFocused = false;
	  }
	
	  (0, _createClass3.default)(FloatingActionButtonsBehaviour, [{
	    key: 'run',
	    value: function run() {
	      var _this = this;
	
	      if (!this.window.isMobileApp) {
	        return;
	      }
	
	      this.timeout(function () {
	        _this.setInputsBehaviour();
	        _this.setSelectsBehaviour();
	      }, 200);
	    }
	  }, {
	    key: 'getInputs',
	    value: function getInputs() {
	      return $('input[type="text"], input[type="number"], input[type="tel"], input[type="date"]');
	    }
	  }, {
	    key: 'getSelects',
	    value: function getSelects() {
	      return $('select-app span.ui-select-toggle');
	    }
	  }, {
	    key: 'setInputsBehaviour',
	    value: function setInputsBehaviour() {
	      var _this2 = this;
	
	      this.getInputs().click(function () {
	        _this2.timeout(function () {
	          $('body').click(function () {
	            return _this2.outsideClick(false);
	          });
	          _this2.onFocus(DEFAULT_EVENT, false);
	        }, 100);
	      });
	    }
	  }, {
	    key: 'setSelectsBehaviour',
	    value: function setSelectsBehaviour() {
	      var _this3 = this;
	
	      this.getSelects().click(function () {
	
	        _this3.timeout(function () {
	
	          var options = $('select-app .select-option');
	          var optionsAreOpen = options.length > 0;
	
	          if (optionsAreOpen) {
	            $('body').click(function () {
	              return _this3.outsideClick(true);
	            });
	            options.click(function () {
	              return _this3.outsideClick(true);
	            });
	
	            _this3.onFocus(DEFAULT_EVENT, true);
	          }
	        }, 100);
	      });
	    }
	  }, {
	    key: 'outsideClick',
	    value: function outsideClick(isSelect) {
	      this.onBlur(DEFAULT_EVENT, isSelect);
	      $('body').unbind('click');
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      var isSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var $target = $(event.target);
	      this.isFocused = true;
	      $('body').css('cursor', 'pointer');
	      $('.container.hpd').addClass('with-floating-action-buttons-hidden');
	
	      $('floating-action-buttons').hide(0, function () {
	        if ($target.closest('.modal-dialog').length > 0) {
	          $target.closest('.modal-dialog').addClass('on-focus');
	        }
	      });
	
	      if ((0, _isIOS2.default)() && !isSelect) {
	        $('main-menu-mobile').addClass('focus-fixed');
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      var _this4 = this;
	
	      var isSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var $target = $(event.target);
	      this.isFocused = false;
	      $('body').css('cursor', 'auto');
	      $('.container.hpd').removeClass('with-floating-action-buttons-hidden');
	
	      if (isSelect) {
	        this.timeout(function () {
	          document.activeElement.blur();
	        }, 200);
	      }
	
	      this.timeout(function () {
	        $('floating-action-buttons').fadeIn(250, function () {
	          _this4.timeout(function () {
	            if ($target.closest('.modal-dialog').length > 0) {
	              $target.closest('.modal-dialog').removeClass('on-focus');
	            }
	          }, 800);
	        });
	      }, 1000);
	
	      if ((0, _isIOS2.default)() && !isSelect) {
	        $('main-menu-mobile').removeClass('focus-fixed');
	      }
	    }
	  }]);
	  return FloatingActionButtonsBehaviour;
	}();
	
	exports.default = FloatingActionButtonsBehaviour;

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return (/iPad|iPhone|iPod/.test(window.navigator.userAgent)
	  );
	};

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tooltipDesktop = __webpack_require__(1018);
	
	var _tooltipDesktop2 = _interopRequireDefault(_tooltipDesktop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tooltipDesktopModule = _angular2.default.module('tooltipDesktop', []).component('tooltipDesktop', _tooltipDesktop2.default).name;
	
	exports.default = tooltipDesktopModule;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tooltipDesktop = __webpack_require__(1019);
	
	var _tooltipDesktop2 = _interopRequireDefault(_tooltipDesktop);
	
	var _tooltipDesktop3 = __webpack_require__(1020);
	
	var _tooltipDesktop4 = _interopRequireDefault(_tooltipDesktop3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tooltipDesktopComponent = {
	  restrict: 'E',
	  bindings: {
	    placement: '@',
	    title: '@'
	  },
	  template: _tooltipDesktop2.default,
	  controller: _tooltipDesktop4.default
	};
	
	exports.default = tooltipDesktopComponent;

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	module.exports = "<span\n  ng-init=\"$ctrl.tooltip()\"\n  class=\"icon icon-interrogation-color\"\n  data-toggle=\"tooltip\"\n  data-placement=\"{{$ctrl.placement}}\"\n  title=\"{{ $ctrl.title | translate }}\">\n</span>\n"

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _tooltip = __webpack_require__(744);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TooltipDesktopController = function TooltipDesktopController() {
	  (0, _classCallCheck3.default)(this, TooltipDesktopController);
	
	  this.tooltip = _tooltip2.default;
	};
	
	exports.default = TooltipDesktopController;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tooltipMobile = __webpack_require__(1022);
	
	var _tooltipMobile2 = _interopRequireDefault(_tooltipMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tooltipMobileModule = _angular2.default.module('tooltipMobile', []).component('tooltipMobile', _tooltipMobile2.default).name;
	
	exports.default = tooltipMobileModule;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tooltipMobile = __webpack_require__(1023);
	
	var _tooltipMobile2 = _interopRequireDefault(_tooltipMobile);
	
	var _tooltipMobile3 = __webpack_require__(1024);
	
	var _tooltipMobile4 = _interopRequireDefault(_tooltipMobile3);
	
	__webpack_require__(1025);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tooltipMobileComponent = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {
	    name: '@',
	    nestedModals: '<',
	    idNestedModal: '@'
	  },
	  template: _tooltipMobile2.default,
	  controller: _tooltipMobile4.default
	};
	
	exports.default = tooltipMobileComponent;

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	module.exports = "<span\n  ng-if=\"!$ctrl.nestedModals\"\n  ng-init=\"$ctrl.tooltip()\"\n  class=\"icon icon-interrogation-color\"\n  data-toggle=\"modal\"\n  ng-click=\"$ctrl.openModal()\"\n  data-target=\"#{{$ctrl.name}}\">\n</span>\n\n<span\n  ng-if=\"$ctrl.nestedModals\"\n  ng-click=\"$ctrl.openSimulatedModal()\"\n  class=\"icon icon-interrogation-color\">\n</span>\n\n  <div ng-if=\"!$ctrl.nestedModals\" class=\"modal fade responsiveMobile\" id=\"{{$ctrl.name}}\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"{{$ctrl.label}}\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <span class=\"icon icon-cross\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeModal()\"></span>\n      <div class=\"modal-body\">\n        <ng-transclude></ng-transclude>\n      </div>\n    </div>\n  </div>\n</div>\n\n<section id=\"simulatedModal\" ng-if=\"$ctrl.nestedModals\" class=\"simulated-modal\">\n  <span class=\"icon icon-cross\" ng-click=\"$ctrl.closeSimulatedModal()\"></span>\n  <div class=\"tooltip-content\">\n    <ng-transclude></ng-transclude>\n  </div>\n</section>"

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _tooltip = __webpack_require__(744);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIMULATED_MODAL_ID = '#simulatedModal';
	
	var TooltipMobileController = function () {
	  function TooltipMobileController() {
	    (0, _classCallCheck3.default)(this, TooltipMobileController);
	
	    this.tooltip = _tooltip2.default;
	  }
	
	  (0, _createClass3.default)(TooltipMobileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modalId = '#' + this.name;
	      this.modal = $(this.modalId);
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'openSimulatedModal',
	    value: function openSimulatedModal() {
	      $('#' + this.idNestedModal).before($(SIMULATED_MODAL_ID));
	      $('#' + this.idNestedModal).css('display', 'none');
	      $(SIMULATED_MODAL_ID).css('display', 'block');
	    }
	  }, {
	    key: 'closeSimulatedModal',
	    value: function closeSimulatedModal() {
	      $(SIMULATED_MODAL_ID).css('display', 'none');
	      $('#' + this.idNestedModal).css('display', 'block');
	    }
	  }]);
	  return TooltipMobileController;
	}();
	
	exports.default = TooltipMobileController;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1026);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./tooltipMobile.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./tooltipMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "tooltip-mobile .icon-interrogation-color{font-size:16px;cursor:pointer}tooltip-mobile .modal .modal-dialog .modal-content{background:#0072c9;padding:30px}tooltip-mobile .modal .modal-dialog .modal-content .icon-cross{position:absolute;top:30px;right:30px;color:#fff;font-size:22px;cursor:pointer;z-index:1}tooltip-mobile .modal .modal-dialog .modal-content .modal-body{padding-top:30px}tooltip-mobile .modal .modal-dialog .modal-content p{font-size:13px;color:#fff;font-family:Stag Sans;text-align:left;text-transform:none}tooltip-mobile .modal .modal-dialog .modal-content p.tooltip-title{font-size:16px;text-align:left;font-weight:500}", ""]);
	
	// exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mainRouting = __webpack_require__(1028);
	
	var _mainRouting2 = _interopRequireDefault(_mainRouting);
	
	var _errorPage = __webpack_require__(1048);
	
	var _errorPage2 = _interopRequireDefault(_errorPage);
	
	var _authentication = __webpack_require__(1054);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _notAllowed = __webpack_require__(1058);
	
	var _notAllowed2 = _interopRequireDefault(_notAllowed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var features = angular.module('features', [_mainRouting2.default, _errorPage2.default, _authentication2.default, _notAllowed2.default]).name;
	
	exports.default = features;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _mainRouting = __webpack_require__(1029);
	
	var _mainRouting2 = _interopRequireDefault(_mainRouting);
	
	var _index = __webpack_require__(1034);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _checkRoutesHelper = __webpack_require__(1047);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mainRoutingModule = angular.module('components.mainRouting', [_angularUiRouter2.default, _index2.default
	//maintenance
	]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  function redirectToEntryPoint($window, $state, $log, entryPoint) {
	    $window.innerWidth < 1024 ? $state.go(entryPoint) : $state.go(_states.STATES.INDEX);
	  }
	
	  $urlRouterProvider.when(_routes.ROUTES.ROOT, ['$window', '$state', '$log', 'entryPoint', redirectToEntryPoint]);
	
	  $urlRouterProvider.otherwise(_checkRoutesHelper.checkRoutes);
	
	  $stateProvider.state(_states.STATES.MAIN_ROUTING, {
	    abstract: true,
	    url: _routes.ROUTES.ROOT,
	    component: 'mainRouting'
	  });
	}]).component('mainRouting', _mainRouting2.default).name;
	//import maintenance from './maintenance/maintenance';
	exports.default = mainRoutingModule;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mainRouting = __webpack_require__(1030);
	
	var _mainRouting2 = _interopRequireDefault(_mainRouting);
	
	var _mainRouting3 = __webpack_require__(1031);
	
	var _mainRouting4 = _interopRequireDefault(_mainRouting3);
	
	__webpack_require__(1032);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mainRoutingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _mainRouting2.default,
	  controller: _mainRouting4.default
	};
	
	exports.default = mainRoutingComponent;

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	module.exports = "<main-navbar\n  ng-if=\"$ctrl.manager\"\n  employee=\"$ctrl.employee\"></main-navbar>\n\n<div ui-view></div>\n"

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainRoutingController = function MainRoutingController() {
	  (0, _classCallCheck3.default)(this, MainRoutingController);
	};
	
	exports.default = MainRoutingController;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1033);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./mainRouting.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./mainRouting.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _index = __webpack_require__(1035);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _devChangeEmployee = __webpack_require__(1041);
	
	var _devChangeEmployee2 = _interopRequireDefault(_devChangeEmployee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var indexModule = angular.module('components.index', [_angularUiRouter2.default, _devChangeEmployee2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.INDEX, {
	    parent: _states.STATES.MAIN_ROUTING,
	    url: _routes.ROUTES.INDEX,
	    component: 'index',
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).component('index', _index2.default).name;
	
	exports.default = indexModule;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(1036);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(1037);
	
	var _index4 = _interopRequireDefault(_index3);
	
	__webpack_require__(1038);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var indexComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _index2.default,
	  controller: _index4.default
	};
	
	exports.default = indexComponent;

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\" ng-if=\"$ctrl.isVisibleChangeEmployee || (!$ctrl.isVisibleChangeEmployee && !$ctrl.isMobileApp)\">\n  <header>\n    <h1>{{\"GLOBALS.APP_TITLE\" | translate}}</h1>\n  </header>\n\n  <section class=\"cards-container\">\n    <a class=\"card\" ui-sref=\"{{$ctrl.isMobileApp ? 'vacations-absences.my-vacations-mobile' : 'vacations-absences.my-vacations'}}\">{{\"VACATIONS_ABSENCES.MAIN.VACATIONS_AND_ABSENCES\" | translate}}</a>\n\n    <a class=\"card\" ui-sref=\"food-benefit.my-food-benefit\">{{\"FOOD_BENEFIT.MAIN.FOOD_BENEFIT\" | translate}}</a>\n\n    <a class=\"card\" ui-sref=\"loans.my-creditworthiness\">{{\"LOANS.MAIN.LOANS\" | translate}}</a>\n\n    <a class=\"card\" ui-sref=\"solidarity.my-solidarity\">{{\"SOLIDARITY.MAIN.SOLIDARITY\" | translate}}</a>\n\n    <a class=\"card\" ui-sref=\"social-security\">{{\"SOCIAL_SECURITY.MAIN.SOCIAL_SECURITY\" | translate}}</a>\n\n    <a class=\"card\" ng-href=\"{{$ctrl.baseUrl}}?token=ourSecretToken&employeeId={{$ctrl.userId}}\">{{\"GLOBALS.CERTIFICATES\" | translate}} </a>\n  </section>\n\n  <dev-change-employee ng-if=\"$ctrl.isVisibleChangeEmployee\"></dev-change-employee>\n</div>"

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var URL_VAC = '/vacations-absences/my-vacations-mobile';
	var URL_FB = '/food-benefit/my-food-benefit';
	var URL_LOANS = '/loans/my-creditworthiness';
	
	var URL_PREQA = 'https://dev.autocertificados.bbva.com';
	var URL_PRE = 'https://pre-autocertificados.bbva.com/';
	var URL_PRO = 'https://autocertificados.bbva.com/';
	
	var IndexController = function () {
	  IndexController.$inject = ["UserDataService", "AuthenticationService", "ManagerDataService", "$cookies", "$window", "$state"];
	  function IndexController(UserDataService, AuthenticationService, ManagerDataService, $cookies, $window, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, IndexController);
	    this.window = $window;
	    this.userDataService = UserDataService;
	    this.authenticationService = AuthenticationService;
	    this.managerDataService = ManagerDataService;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.state = $state;
	    this.redirect();
	
	    this.isVisibleChangeEmployee = (true);
	    this.clean();
	
	    this.userId = $cookies.get('userId');
	    this.token = $cookies.get('token');
	
	    switch (("dev")) {
	      case 'dev':
	        this.baseUrl = URL_PREQA;
	        break;
	
	      case 'pre':
	        this.baseUrl = URL_PRE;
	        break;
	
	      case 'pro':
	        this.baseUrl = URL_PRO;
	        break;
	    }
	  }
	
	  (0, _createClass3.default)(IndexController, [{
	    key: 'clean',
	    value: function clean() {
	      this.userDataService.clean();
	      this.managerDataService.clean();
	    }
	  }, {
	    key: 'redirect',
	    value: function redirect() {
	      if (true) {
	        this.state.go(_states.STATES.INDEX);
	        return;
	      }
	
	      if (this.isMobileApp) {
	        this.mobileRedirect();
	      } else {
	        this.redirectToLogin();
	      }
	    }
	  }, {
	    key: 'mobileRedirect',
	    value: function mobileRedirect() {
	      var path = localStorage.getItem('path');
	
	      if (!path) {
	        this.redirectToLogin();
	        return;
	      }
	
	      if (path === URL_LOANS) {
	        this.state.go(_states.STATES.LOANS.LOANS_CATALOG);
	      }
	
	      if (path === URL_FB) {
	        this.state.go(_states.STATES.FOOD_BENEFIT.MY_FOOD_BENEFIT);
	      }
	
	      if (path === URL_VAC) {
	        this.state.go(_states.STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE);
	      }
	    }
	  }, {
	    key: 'redirectToLogin',
	    value: function redirectToLogin() {
	      if (!this.authenticationService.isAuthenticated()) {
	        return this.authenticationService.redirectToLogin();
	      }
	    }
	  }]);
	  return IndexController;
	}();
	
	exports.default = IndexController;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1039);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./index.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./index.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "index{display:block}index header h1{font-family:Stag Sans;font-weight:400;font-size:36px;color:#0072c9;text-align:center}index .cards-container{-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-ms-flex-line-pack:center;align-content:center;width:480px;min-height:450px;margin:auto}index .cards-container,index a.card{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-align-items:center;align-items:center}index a.card{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;width:210px;height:100px;background-color:#fff;border-radius:10px;border:1px solid #dddfe2;margin:10px;font-size:15px;cursor:pointer}index a.card:hover{text-decoration:none;background-color:#0072c9;color:#fff}index a.card:focus{text-decoration:none;background-color:#04408f;color:#fff}", ""]);
	
	// exports


/***/ }),
/* 1040 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ROUTES = {
	  ROOT: '/',
	  INDEX: 'index',
	  MAINTENANCE: 'maintenance',
	  ERROR: '/error',
	  LOGIN: '/login',
	  NOT_ALLOWED: '/not-allowed',
	  AUTHENTICATION: '/authentication',
	  VACATIONS_ABSENCES: {
	    ROOT: 'vacations-absences',
	    EMPLOYEE_CALENDAR: '/employee-calendar/:employeeId?from',
	    EMPLOYEE_CALENDAR_MOBILE: '/employee-calendar-mobile/:employeeId?from',
	    MY_VACATIONS: '/my-vacations',
	    MY_VACATIONS_MOBILE: '/my-vacations-mobile',
	    TEAM_CALENDAR: '/team-calendar',
	    TEAM_CALENDAR_MOBILE: '/team-calendar-mobile',
	    TEAM_REQUESTS: '/team-requests',
	    DELEGATE: '/delegations',
	    PERIOD_LIST_MOBILE: '/period-list-mobile',
	    SCHEDULE_MOBILE: '/schedule-mobile'
	  },
	  LOANS: {
	    ROOT: 'loans',
	    CREDITWORTHINESS: '/my-creditworthiness',
	    LOANS_CATALOG: '/catalog',
	    DETAIL: '/detail/:loanId?panel',
	    SIGN_UP: '/sign-up/:loanId?from',
	    MY_LOANS: '/my-loans',
	    REPAYMENT: '/repayment',
	    NEED_A_LOAN: '/need-a-loan',
	    NEED_A_LOAN_RESULTS: '/need-a-loan/results',
	    WAGE_ADVANCE: '/wage-advance',
	    CADASTRAL_REFERENCE: '/cadastral-reference',
	    DETAILSADHESION: '/adhesion'
	  },
	  FOOD_BENEFIT: {
	    ROOT: 'food-benefit',
	    MY_FOOD_BENEFIT: '/my-food-benefit',
	    MANAGER: '/food-benefit-manager',
	    DELEGATE: '/delegations',
	    WORK_TEAM: '/work-team'
	  },
	  SOLIDARITY: {
	    ROOT: 'solidarity',
	    MY_SOLIDARITY: '/my-solidarity'
	  },
	  SOCIAL_SECURITY: 'social-security'
	};
	
	exports.ROUTES = ROUTES;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _devChangeEmployee = __webpack_require__(1042);
	
	var _devChangeEmployee2 = _interopRequireDefault(_devChangeEmployee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var devChangeEmployeeModule = angular.module('components.devChangeEmployee', []).component('devChangeEmployee', _devChangeEmployee2.default).name;
	
	exports.default = devChangeEmployeeModule;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _devChangeEmployee = __webpack_require__(1043);
	
	var _devChangeEmployee2 = _interopRequireDefault(_devChangeEmployee);
	
	var _devChangeEmployee3 = __webpack_require__(1044);
	
	var _devChangeEmployee4 = _interopRequireDefault(_devChangeEmployee3);
	
	__webpack_require__(1045);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var devChangeEmployeeComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _devChangeEmployee2.default,
	  controller: _devChangeEmployee4.default
	};
	
	exports.default = devChangeEmployeeComponent;

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content\">\n  <header>\n    <h1>{{\"INDEX.ENV_OF\" | translate}} {{$ctrl.env}} <span>v{{$ctrl.version}}</span></h1>\n  </header>\n\n  <section>\n      <header>\n        <h2>{{\"INDEX.CHANGE_EMPLOYEE\" | translate}}</h2>\n      </header>\n      <div>\n        <div ng-if=\"$ctrl.isReadOnly()\">\n          <span>{{\"INDEX.ACTUAL_EMPLOYEE_ENROLLMENT\" | translate}}:</span> <span class=\"user\">{{ $ctrl.employeeId }}</span>\n          <button class=\"btn btn-default edit\" ng-click=\"$ctrl.edit()\">{{\"GLOBALS.BUTTON_ACTION.EDIT\" | translate}}</button>\n        </div>\n        <div ng-if=\"$ctrl.isEditable()\">\n          <input type=\"text\" ng-model=\"$ctrl.employeeId\"></input>\n          <button class=\"btn btn-default\" ng-click=\"$ctrl.changeUser()\">{{\"GLOBALS.BUTTON_ACTION.SAVE\" | translate}}</button>\n          <a href=\"#\" ng-click=\"$ctrl.cancel()\">Cancelar</input>\n        </div>\n      </div>\n    </div>\n  </section>\n\n</div>\n"

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _authentication = __webpack_require__(557);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATES = {
	  READ_ONLY: 'READ_ONLY',
	  EDITABLE: 'EDITABLE'
	};
	
	var DevChangeEmployeeController = function () {
	  DevChangeEmployeeController.$inject = ["$cookies", "$window"];
	  function DevChangeEmployeeController($cookies, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DevChangeEmployeeController);
	    this.cookies = $cookies;
	    this.window = $window;
	
	    this.initUser();
	    this.env = _constants.ENVIRONMENTS[("dev")];
	    this.version = ("1.4.4-undefined");
	  }
	
	  (0, _createClass3.default)(DevChangeEmployeeController, [{
	    key: 'initUser',
	    value: function initUser() {
	      this.employeeId = this.cookies.get('userId') ? this.cookies.get('userId') : _authentication.DEFAULT_USER;
	      this.status = STATES.READ_ONLY;
	    }
	  }, {
	    key: 'isReadOnly',
	    value: function isReadOnly() {
	      return this.status === STATES.READ_ONLY;
	    }
	  }, {
	    key: 'isEditable',
	    value: function isEditable() {
	      return this.status === STATES.EDITABLE;
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      this.status = STATES.EDITABLE;
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.initUser();
	    }
	  }, {
	    key: 'changeUser',
	    value: function changeUser() {
	      this.cookies.put('userId', this.employeeId);
	      this.status = STATES.READ_ONLY;
	      this.window.location.reload();
	    }
	  }]);
	  return DevChangeEmployeeController;
	}();
	
	exports.default = DevChangeEmployeeController;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1046);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./devChangeEmployee.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./devChangeEmployee.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "dev-change-employee{display:block;margin:15px;border:1px solid #c8175e;background:rgba(213,45,112,.1)}dev-change-employee .content{padding:15px;color:#333}dev-change-employee .content header h1{margin-top:0;font-family:Stag Sans;font-size:24px;font-weight:500;color:#c8175e;text-align:inherit}dev-change-employee .content header h1 span{font-weight:400;font-size:medium}dev-change-employee .content header h2{font-family:Stag Sans;font-size:18px}dev-change-employee .user{color:#666;font-size:16px}dev-change-employee input[type=text]{min-height:34px;padding:6px 8px;line-height:20px;color:#333;border:1px solid #dddfe2;border-radius:3px;width:760px;padding:7px 10px;margin-right:10px;font-size:16px;background-color:#f9f9f9}dev-change-employee a{text-decoration:none}dev-change-employee a:hover{text-decoration:underline;background-color:inherit}", ""]);
	
	// exports


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkRoutes = undefined;
	
	var _routes = __webpack_require__(1040);
	
	function checkRoutes($injector, $location) {
	  if (!$location || !$location.url()) {
	    return $location.path('' + _routes.ROUTES.ROOT); // In mobile runtime $location.url() is not accessible: redirect to root
	  }
	
	  if ($location.url().includes(_routes.ROUTES.VACATIONS_ABSENCES.ROOT)) {
	    return $location.path('' + _routes.ROUTES.VACATIONS_ABSENCES.ROOT + _routes.ROUTES.VACATIONS_ABSENCES.MY_VACATIONS);
	  }
	
	  if ($location.url().includes(_routes.ROUTES.FOOD_BENEFIT.ROOT)) {
	    return $location.path('' + _routes.ROUTES.FOOD_BENEFIT.ROOT + _routes.ROUTES.FOOD_BENEFIT.MY_FOOD_BENEFIT);
	  }
	
	  if ($location.url().includes(_routes.ROUTES.LOANS.ROOT)) {
	    return $location.path('' + _routes.ROUTES.LOANS.ROOT + _routes.ROUTES.LOANS.CREDITWORTHINESS);
	  }
	
	  if ($location.url().includes(_routes.ROUTES.SOLIDARITY.ROOT)) {
	    return $location.path('' + _routes.ROUTES.SOLIDARITY.ROOT + _routes.ROUTES.SOLIDARITY.MY_SOLIDARITY);
	  }
	
	  if ($location.url().includes(_routes.ROUTES.SOCIAL_SECURITY)) {
	    return $location.path('' + _routes.ROUTES.SOCIAL_SECURITY);
	  }
	
	  if ($location.url().includes(_routes.ROUTES.NOT_ALLOWED)) {
	    return $location.path('' + _routes.ROUTES.NOT_ALLOWED);
	  }
	
	  return $location.path('' + _routes.ROUTES.INDEX);
	}
	
	exports.checkRoutes = checkRoutes;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _errorPage = __webpack_require__(1049);
	
	var _errorPage2 = _interopRequireDefault(_errorPage);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorPageModule = angular.module('components.errorPage', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.ERROR, {
	    url: _routes.ROUTES.ERROR,
	    component: 'errorPage',
	    params: {
	      stateName: null,
	      errorMessage: null,
	      stateRedirection: null
	    },
	    data: {
	      requiresAuth: false
	    }
	  });
	}]).component('errorPage', _errorPage2.default).name;
	
	exports.default = errorPageModule;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _errorPage = __webpack_require__(1050);
	
	var _errorPage2 = _interopRequireDefault(_errorPage);
	
	var _errorPage3 = __webpack_require__(1051);
	
	var _errorPage4 = _interopRequireDefault(_errorPage3);
	
	__webpack_require__(1052);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorPageComponent = {
	  restrict: 'E',
	  template: _errorPage2.default,
	  controller: _errorPage4.default
	};
	
	exports.default = errorPageComponent;

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

	module.exports = "<div ng-init=\"$ctrl.goToEntryPoint()\">\n\n</div>\n\n<div class=\"list-empty\">\n  <div class=\"message-default\" ng-if=\"!$ctrl.isMobileApp\">\n    <span class=\"icon-warning\"></span>\n    <p ng-if=\"$ctrl.shouldRenderErrorMessage()\">\n      {{$ctrl.errorMessage}}\n    </p>\n    <p ng-if=\"$ctrl.shouldRenderStateClosed()\">\n      {{ 'GLOBALS.CLOSED' | translate }}\n    </p>\n    <p ng-if=\"$ctrl.shouldRenderDefault()\">\n      {{ 'GLOBALS.ERROR' | translate }}\n    </p>\n    <p ng-if=\"$ctrl.shouldRenderClosedToUserWithoutCreditWorthiness()\">\n      {{ 'GLOBALS.CLOSED_TO_USER_WITHOUT_CREDITWORTHINESS' | translate }}\n    </p>\n    <p ng-if=\"$ctrl.shouldLinkToWageAdvance()\">\n      {{ 'GLOBALS.ACCESS' | translate }}\n      <span class=\"redirection\" ng-click=\"$ctrl.goToLink()\">Anticipo de nómina</span>\n    </p>\n  </div>\n</div>"

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var URL_VAC = '/vacations-absences/my-vacations-mobile';
	var URL_FB = '/food-benefit/my-food-benefit';
	var URL_LOANS = '/loans/my-creditworthiness';
	
	var ErrorPageController = function () {
	  ErrorPageController.$inject = ["$window", "$stateParams", "$state", "entryPoint"];
	  function ErrorPageController($window, $stateParams, $state, entryPoint) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ErrorPageController);
	    this.state = $state;
	    this.stateParams = $stateParams;
	    this.state = $state;
	    this.entryPoint = entryPoint;
	    this.errorMessage = this.stateParams.errorMessage;
	    this.isMobileApp = $window.innerWidth < 1024;
	  }
	
	  (0, _createClass3.default)(ErrorPageController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.switchColorFloatingButton = true;
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'shouldRenderErrorMessage',
	    value: function shouldRenderErrorMessage() {
	      return !!this.errorMessage;
	    }
	  }, {
	    key: 'shouldRenderStateClosed',
	    value: function shouldRenderStateClosed() {
	      return this.stateParams.stateName === _constants.PAGE_ERROR.CLOSED && !this.errorMessage;
	    }
	  }, {
	    key: 'shouldRenderClosedToUserWithoutCreditWorthiness',
	    value: function shouldRenderClosedToUserWithoutCreditWorthiness() {
	      return this.stateParams.stateName === _constants.PAGE_ERROR.LOANS_CLOSED_TO_USER_WITHOUT_CREDITWORTHINESS;
	    }
	  }, {
	    key: 'shouldRenderDefault',
	    value: function shouldRenderDefault() {
	      return !(this.shouldRenderErrorMessage() || this.shouldRenderStateClosed() || this.shouldRenderClosedToUserWithoutCreditWorthiness());
	    }
	  }, {
	    key: 'goToEntryPoint',
	    value: function goToEntryPoint() {
	      this.state.go(this.entryPoint);
	      var path = localStorage.getItem('path');
	
	      if (this.isMobileApp) {
	        if (path === URL_LOANS) {
	          this.state.go(_states.STATES.LOANS.LOANS_CATALOG);
	        }
	
	        if (path === URL_FB) {
	          this.state.go(_states.STATES.FOOD_BENEFIT.MY_FOOD_BENEFIT);
	        }
	
	        if (path === URL_VAC) {
	          this.state.go(_states.STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE);
	        }
	      }
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.GO_TO_START'
	      }];
	    }
	  }, {
	    key: 'shouldLinkToWageAdvance',
	    value: function shouldLinkToWageAdvance() {
	      return this.stateParams.stateRedirection;
	    }
	  }, {
	    key: 'goToLink',
	    value: function goToLink() {
	      this.state.go(_states.STATES.LOANS.WAGE_ADVANCE, { goWageAdvance: true });
	    }
	  }]);
	  return ErrorPageController;
	}();
	
	exports.default = ErrorPageController;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1053);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./errorPage.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./errorPage.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "error-page .list-empty{margin-top:0;padding-top:40px;padding-bottom:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9;background-color:#fff}error-page .list-empty.responsiveMobile{height:100vh;color:#fff;background-color:#fff}error-page .list-empty.responsiveMobile .message-default{height:80%;width:80%;margin:0 auto;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}error-page .list-empty.responsiveMobile .message-default p{color:#fff}error-page .list-empty.responsiveMobile .message-default .message-ups{border-bottom:1px solid #fff;padding-bottom:15px;margin-bottom:15px;font-size:30px}error-page .list-empty.responsiveMobile .message-default .icon-warning{font-size:110px}error-page .list-empty p{color:#0072c9}error-page .list-empty p .redirection{cursor:pointer}error-page .list-empty.shown-filter{margin-top:0}error-page .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _authentication = __webpack_require__(1055);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authenticationModule = angular.module('components.authentication', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.AUTHENTICATION, {
	    url: _routes.ROUTES.AUTHENTICATION,
	    component: 'authentication'
	  });
	}]).component('authentication', _authentication2.default).name;
	
	exports.default = authenticationModule;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authentication = __webpack_require__(1056);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _authentication3 = __webpack_require__(1057);
	
	var _authentication4 = _interopRequireDefault(_authentication3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authenticationComponent = {
	  restrict: 'E',
	  bindings: {},
	  controller: _authentication2.default,
	  template: _authentication4.default
	};
	
	exports.default = authenticationComponent;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _routes = __webpack_require__(1040);
	
	var _endpoints = __webpack_require__(556);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthenticationController = function () {
	  AuthenticationController.$inject = ["AuthenticationService", "$cookies", "$location", "$log", "$translate", "$state", "$window"];
	  function AuthenticationController(AuthenticationService, $cookies, $location, $log, $translate, $state, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AuthenticationController);
	    this.location = $location;
	    this.log = $log;
	    this.authenticationService = AuthenticationService;
	    this.params = $location.search();
	    this.translate = $translate;
	    this.cookies = $cookies;
	    this.state = $state;
	    this.window = $window;
	  }
	
	  (0, _createClass3.default)(AuthenticationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this._authenticateAndRedirect();
	      this._translate();
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this = this;
	
	      this.translate('GLOBALS.AUTHENTICATION_ERROR').then(function (translation) {
	        _this.title = translation;
	      });
	      this.translate('GLOBALS.BUTTON_ACTION.TRY_AGAIN').then(function (translation) {
	        _this.buttonText = translation;
	      });
	    }
	  }, {
	    key: '_authenticateAndRedirect',
	    value: function _authenticateAndRedirect() {
	      var _this2 = this;
	
	      if (this.params.isPortalSenior && this.params.isPortalSenior === 'true') {
	        this.log.log('PortalSenior Auth with params: ', this.params);
	        this.cookies.put('isPortalSenior', true);
	        if (this.params.token && this.params.employeeId) {
	          return this.authenticationService.authenticatePortal(this.params.token, this.params.employeeId).then(function () {
	            _this2.log.log('PortalSenior: authentication.controller: authenticated', _this2.params.token);
	            _this2._redirectToLoans();
	          }, function (error) {
	            _this2.log.log('PortalSenior: authentication.controller: error authenticate token', _this2.params.token);
	            _this2.description = error.data;
	            _this2.openModal();
	          });
	        } else {
	          this.log.log('redirecting to AUTHENTICATION_PORTAL_URL');
	          this.window.location.href = _endpoints.AUTHENTICATION_PORTAL_URL;
	        }
	      } else {
	        this.cookies.put('isPortalSenior', false);
	
	        if (this.params.token === undefined || this.params.target === undefined) {
	          this.openModal();
	          return;
	        }
	
	        this.authenticationService.authenticate(this.params.token, this.params.target).then(function () {
	          _this2.log.log('authentication.controller: authenticated', _this2.params.token);
	          _this2._redirectToTarget();
	        }, function (error) {
	          _this2.log.log('authentication.controller: error authenticate token', _this2.params.token);
	          _this2.description = error.data;
	          _this2.openModal();
	        });
	      }
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      $(_constants.MODALS.AUTHENTICATION_ERROR_MODAL).modal('show');
	    }
	  }, {
	    key: 'retry',
	    value: function retry() {
	      if (this.cookies.get('isPortalSenior') === 'true') {
	        window.location.href = _endpoints.AUTHENTICATION_PORTAL_URL;
	      } else {
	        this.authenticationService.redirectToLogin();
	      }
	    }
	  }, {
	    key: '_redirectToTarget',
	    value: function _redirectToTarget() {
	      var defaultRedirect = _routes.ROUTES.ERROR;
	      if (true) {
	        defaultRedirect = _routes.ROUTES.INDEX;
	      }
	      if (Array.isArray(this.params.target)) {
	        var validTarget = this.params.target.find(function (t) {
	          return t !== 'error';
	        }) || defaultRedirect;
	        this.params.target = validTarget;
	      }
	      this.params.target = this.params.target || defaultRedirect;
	      this.location.url(this.params.target);
	    }
	  }, {
	    key: '_redirectToLoans',
	    value: function _redirectToLoans() {
	      this.log.log('authentication.controller (PortalSenior): redirect to loans');
	      this.location.url('loans');
	      // this.state.go(STATES.LOANS.CREDITWORTHINESS);
	      // this.location.url(ROUTES.LOANS.ROOT + ROUTES.LOANS.CREDITWORTHINESS);
	    }
	  }]);
	  return AuthenticationController;
	}();
	
	exports.default = AuthenticationController;

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"modal\" data-backdrop=\"static\" id=\"authenticationErrorModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalDelegationManagerLabel\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <span class=\"icon-interrogation\"></span>\n        <button ng-click=\"$ctrl.retry()\" type=\"button\"  aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n        <h4 class=\"modal-title\" >{{$ctrl.title}}</h4>\n      </div>\n\n      <div class=\"modal-body\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <span  class=\"description\">{{$ctrl.description}}</span>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"modal-footer\">\n\n        <button\n          type=\"button\"\n          class=\"btn btn-app btn-primary\"\n          ng-click=\"$ctrl.retry()\">{{$ctrl.buttonText}}</button>\n\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _notAllowed = __webpack_require__(1059);
	
	var _notAllowed2 = _interopRequireDefault(_notAllowed);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notAllowedModule = angular.module('features.notAllowed', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.NOT_ALLOWED, {
	    url: _routes.ROUTES.NOT_ALLOWED,
	    component: 'notAllowed'
	  });
	}]).component('notAllowed', _notAllowed2.default).name;
	
	exports.default = notAllowedModule;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _notAllowed = __webpack_require__(1060);
	
	var _notAllowed2 = _interopRequireDefault(_notAllowed);
	
	__webpack_require__(1061);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notAllowedComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _notAllowed2.default
	};
	
	exports.default = notAllowedComponent;

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"list-empty\">\n  <span class=\"icon-warning\"></span>\n  <span>{{'GLOBALS.NOT_ALLOWED' | translate}}</span>\n</div>\n"

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1062);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./notAllowed.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./notAllowed.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "not-allowed .list-empty{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}not-allowed .list-empty.shown-filter{margin-top:0}not-allowed .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ["$locationProvider", "$translateProvider", "$translatePartialLoaderProvider", "$logProvider", "$provide", "$windowProvider", function ($locationProvider, $translateProvider, $translatePartialLoaderProvider, $logProvider, $provide, $windowProvider) {
	  'ngInject';
	
	  if (false) {
	    $logProvider.debugEnabled(false);
	    $provide.decorator('$log', ["$delegate", function ($delegate) {
	      'ngInject';
	
	      $delegate.warn = angular.noop;
	      $delegate.info = angular.noop;
	      $delegate.error = angular.noop;
	      $delegate.log = angular.noop;
	      return $delegate;
	    }]);
	  }
	
	  // Disabled because we don't have control over the server rewrites
	  var $window = $windowProvider.$get();
	  if (!$window.innerWidth < 1024) {
	    $locationProvider.html5Mode(true).hashPrefix('!'); // Use the HTML5 History API
	  }
	
	  $translateProvider.useSanitizeValueStrategy('sce');
	  $translatePartialLoaderProvider.addPart('common');
	
	  $translateProvider.useLoader('$translatePartialLoader', {
	    urlTemplate: 'app/{part}/i18n/{lang}.json'
	  });
	
	  $translateProvider.preferredLanguage('es');
	}];

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ["$rootScope", "$state", "$anchorScroll", "visitedPagesService", function ($rootScope, $state, $anchorScroll, visitedPagesService) {
	  'ngInject';
	
	  $rootScope.$on('$locationChangeSuccess', function ($event, next, current) {
	    $anchorScroll();
	
	    if (next !== current) visitedPagesService.addPageToCounter();
	  });
	}];

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ["$log", "$rootScope", "$state", "$anchorScroll", "$window", "visitedPagesService", function ($log, $rootScope, $state, $anchorScroll, $window, visitedPagesService) {
	  'ngInject';
	
	  $rootScope.$on('$locationChangeSuccess', function ($event, next, current) {
	    $anchorScroll();
	
	    if (next !== current) visitedPagesService.addPageToCounter();
	  });
	
	  // document.addEventListener('resume', requestAccessToken, false);
	
	  // TODO: [Manu]: si fuera necesario añadir refrescar el token cuando la APP regresa de segundo plano
	  // function requestAccessToken() {
	  // }
	}];

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(1067);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(1068);
	
	var _app4 = _interopRequireDefault(_app3);
	
	__webpack_require__(1070);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  controller: _app4.default,
	  restrict: 'E'
	};
	
	exports.default = appComponent;

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div ng-show=\"$ctrl.showApp()\">\n  <div ui-view></div>\n</div>\n"

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	var _removeModalBackdrop = __webpack_require__(1069);
	
	var _removeModalBackdrop2 = _interopRequireDefault(_removeModalBackdrop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppCtrl = function () {
	  AppCtrl.$inject = ["$window", "$log", "visitedPagesService", "networkService", "AuthenticationService", "$state"];
	  function AppCtrl($window, $log, visitedPagesService, networkService, AuthenticationService, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AppCtrl);
	    this.window = $window;
	    this.log = $log;
	    this.visitedPagesService = visitedPagesService;
	    this.networkService = networkService;
	    this.authenticationService = AuthenticationService;
	    this.state = $state;
	  }
	
	  (0, _createClass3.default)(AppCtrl, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this._setOnWindowPopstate();
	
	      if (this.window.innerWidth < 1024) {
	        this._setAppOverflow();
	        this._setMinHeight();
	        this.networkService.run();
	        this.configureBackButton();
	        this.configureMobileAccessibility();
	      }
	    }
	  }, {
	    key: 'showApp',
	    value: function showApp() {
	      var isAuthenticated = this.authenticationService.isAuthenticated();
	      var isAuthentication = this.state.current.name === _states.STATES.AUTHENTICATION;
	      var isError = this.state.current.name === _states.STATES.ERROR;
	      var isNotAllowed = this.state.current.name === _states.STATES.NOT_ALLOWED;
	      var isDevWeb = (true);
	      return isAuthenticated || isAuthentication || isError || isNotAllowed || isDevWeb;
	    }
	  }, {
	    key: 'configureBackButton',
	    value: function configureBackButton() {
	      var _this = this;
	
	      document.addEventListener('backbutton', function () {
	        return _this.onBackKeyDown();
	      }, false);
	    }
	  }, {
	    key: 'onBackKeyDown',
	    value: function onBackKeyDown() {
	      if (this.visitedPagesService.shouldExitApp()) {
	        navigator.app.exitApp();
	      } else {
	        this.visitedPagesService.subtractPageToCounter();
	        navigator.app.backHistory();
	      }
	    }
	  }, {
	    key: 'configureMobileAccessibility',
	    value: function configureMobileAccessibility() {
	      if (this.window.MobileAccessibility) {
	        this.window.MobileAccessibility.usePreferredTextZoom(false);
	        this.log.info('Mobile accessibility plugin available: disabling preferred text zoom.');
	      } else {
	        this.log.warn('Mobile accessibility plugin not available.');
	      }
	    }
	  }, {
	    key: '_setOnWindowPopstate',
	    value: function _setOnWindowPopstate() {
	      $(window).on('popstate', function () {
	        (0, _removeModalBackdrop2.default)();
	      });
	    }
	  }, {
	    key: '_setAppOverflow',
	    value: function _setAppOverflow() {
	      angular.element('html').css('overflow-x', 'hidden');
	      angular.element('body').css('overflow-x', 'hidden');
	    }
	  }, {
	    key: '_setMinHeight',
	    value: function _setMinHeight() {
	      angular.element('body').css('min-height', '100vh');
	    }
	  }]);
	  return AppCtrl;
	}();
	
	exports.default = AppCtrl;

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeModalBackdrop;
	function removeModalBackdrop() {
	  _removeModalBackdrop();
	  _getModal().on('hidden.bs.modal', function () {
	    return _removeModalBackdrop();
	  });
	}
	
	function _removeModalBackdrop() {
	  if (!_getModalIn().length) {
	    _getBackdrop().remove();
	  }
	}
	
	function _getModal() {
	  return $('.modal');
	}
	
	function _getModalIn() {
	  return $('.modal.in');
	}
	
	function _getBackdrop() {
	  return $('.modal-backdrop.in');
	}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1071);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/dist/cjs.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/dist/cjs.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.4.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:transparent!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(twbs-font-path(\"bootstrap/glyphicons-halflings-regular.eot\"));src:url(twbs-font-path(\"bootstrap/glyphicons-halflings-regular.eot?#iefix\")) format(\"embedded-opentype\"),url(twbs-font-path(\"bootstrap/glyphicons-halflings-regular.woff2\")) format(\"woff2\"),url(twbs-font-path(\"bootstrap/glyphicons-halflings-regular.woff\")) format(\"woff\"),url(twbs-font-path(\"bootstrap/glyphicons-halflings-regular.ttf\")) format(\"truetype\"),url(twbs-font-path(\"bootstrap/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\")) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.428571429;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media(min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.428571429}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{display:table;content:\" \"}.dl-horizontal dd:after{clear:both}@media(min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.428571429;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014\\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0\\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.428571429}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.428571429;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.container:after,.container:before{display:table;content:\" \"}.container:after{clear:both}@media(min-width:768px){.container{width:750px}}@media(min-width:992px){.container{width:970px}}@media(min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.container-fluid:after,.container-fluid:before{display:table;content:\" \"}.container-fluid:after{clear:both}.row{margin-right:-15px;margin-left:-15px}.row:after,.row:before{display:table;content:\" \"}.row:after{clear:both}.row-no-gutters{margin-right:0;margin-left:0}.row-no-gutters [class*=col-]{padding-right:0;padding-left:0}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.3333333333%}.col-xs-2{width:16.6666666667%}.col-xs-3{width:25%}.col-xs-4{width:33.3333333333%}.col-xs-5{width:41.6666666667%}.col-xs-6{width:50%}.col-xs-7{width:58.3333333333%}.col-xs-8{width:66.6666666667%}.col-xs-9{width:75%}.col-xs-10{width:83.3333333333%}.col-xs-11{width:91.6666666667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.3333333333%}.col-xs-pull-2{right:16.6666666667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.3333333333%}.col-xs-pull-5{right:41.6666666667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.3333333333%}.col-xs-pull-8{right:66.6666666667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.3333333333%}.col-xs-pull-11{right:91.6666666667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.3333333333%}.col-xs-push-2{left:16.6666666667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.3333333333%}.col-xs-push-5{left:41.6666666667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.3333333333%}.col-xs-push-8{left:66.6666666667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.3333333333%}.col-xs-push-11{left:91.6666666667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.3333333333%}.col-xs-offset-2{margin-left:16.6666666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.3333333333%}.col-xs-offset-5{margin-left:41.6666666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.3333333333%}.col-xs-offset-8{margin-left:66.6666666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.3333333333%}.col-xs-offset-11{margin-left:91.6666666667%}.col-xs-offset-12{margin-left:100%}@media(min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.3333333333%}.col-sm-2{width:16.6666666667%}.col-sm-3{width:25%}.col-sm-4{width:33.3333333333%}.col-sm-5{width:41.6666666667%}.col-sm-6{width:50%}.col-sm-7{width:58.3333333333%}.col-sm-8{width:66.6666666667%}.col-sm-9{width:75%}.col-sm-10{width:83.3333333333%}.col-sm-11{width:91.6666666667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.3333333333%}.col-sm-pull-2{right:16.6666666667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.3333333333%}.col-sm-pull-5{right:41.6666666667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.3333333333%}.col-sm-pull-8{right:66.6666666667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.3333333333%}.col-sm-pull-11{right:91.6666666667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.3333333333%}.col-sm-push-2{left:16.6666666667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.3333333333%}.col-sm-push-5{left:41.6666666667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.3333333333%}.col-sm-push-8{left:66.6666666667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.3333333333%}.col-sm-push-11{left:91.6666666667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.3333333333%}.col-sm-offset-2{margin-left:16.6666666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.3333333333%}.col-sm-offset-5{margin-left:41.6666666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.3333333333%}.col-sm-offset-8{margin-left:66.6666666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.3333333333%}.col-sm-offset-11{margin-left:91.6666666667%}.col-sm-offset-12{margin-left:100%}}@media(min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.3333333333%}.col-md-2{width:16.6666666667%}.col-md-3{width:25%}.col-md-4{width:33.3333333333%}.col-md-5{width:41.6666666667%}.col-md-6{width:50%}.col-md-7{width:58.3333333333%}.col-md-8{width:66.6666666667%}.col-md-9{width:75%}.col-md-10{width:83.3333333333%}.col-md-11{width:91.6666666667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.3333333333%}.col-md-pull-2{right:16.6666666667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.3333333333%}.col-md-pull-5{right:41.6666666667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.3333333333%}.col-md-pull-8{right:66.6666666667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.3333333333%}.col-md-pull-11{right:91.6666666667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.3333333333%}.col-md-push-2{left:16.6666666667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.3333333333%}.col-md-push-5{left:41.6666666667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.3333333333%}.col-md-push-8{left:66.6666666667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.3333333333%}.col-md-push-11{left:91.6666666667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.3333333333%}.col-md-offset-2{margin-left:16.6666666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.3333333333%}.col-md-offset-5{margin-left:41.6666666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.3333333333%}.col-md-offset-8{margin-left:66.6666666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.3333333333%}.col-md-offset-11{margin-left:91.6666666667%}.col-md-offset-12{margin-left:100%}}@media(min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.3333333333%}.col-lg-2{width:16.6666666667%}.col-lg-3{width:25%}.col-lg-4{width:33.3333333333%}.col-lg-5{width:41.6666666667%}.col-lg-6{width:50%}.col-lg-7{width:58.3333333333%}.col-lg-8{width:66.6666666667%}.col-lg-9{width:75%}.col-lg-10{width:83.3333333333%}.col-lg-11{width:91.6666666667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.3333333333%}.col-lg-pull-2{right:16.6666666667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.3333333333%}.col-lg-pull-5{right:41.6666666667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.3333333333%}.col-lg-pull-8{right:66.6666666667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.3333333333%}.col-lg-pull-11{right:91.6666666667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.3333333333%}.col-lg-push-2{left:16.6666666667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.3333333333%}.col-lg-push-5{left:41.6666666667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.3333333333%}.col-lg-push-8{left:66.6666666667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.3333333333%}.col-lg-push-11{left:91.6666666667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.3333333333%}.col-lg-offset-2{margin-left:16.6666666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.3333333333%}.col-lg-offset-5{margin-left:41.6666666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.3333333333%}.col-lg-offset-8{margin-left:66.6666666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.3333333333%}.col-lg-offset-11{margin-left:91.6666666667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.428571429;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover,.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box;appearance:none}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.428571429;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox.disabled label,.radio.disabled label,fieldset[disabled] .checkbox label,fieldset[disabled] .radio label{cursor:not-allowed}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline.disabled,.radio-inline.disabled,fieldset[disabled] .checkbox-inline,fieldset[disabled] .radio-inline{cursor:not-allowed}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-right:0;padding-left:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media(min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{display:table;content:\" \"}.form-horizontal .form-group:after{clear:both}@media(min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media(min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media(min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;padding:6px 12px;font-size:14px;line-height:1.428571429;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);opacity:.65;box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default:hover{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e6e6;background-image:none;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary:hover{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#286090;background-image:none;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success:hover{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;background-image:none;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info:hover{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;background-image:none;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning:hover{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;background-image:none;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger:hover{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;background-image:none;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.428571429;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.428571429;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media(min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{display:table;content:\" \"}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav:after,.nav:before{display:table;content:\" \"}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.428571429;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media(min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a{border:1px solid #ddd}@media(min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{display:table;content:\" \"}.navbar:after{clear:both}@media(min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{display:table;content:\" \"}.navbar-header:after{clear:both}@media(min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{display:table;content:\" \"}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media(min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media(max-device-width:480px)and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}@media(min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media(min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media(min-width:768px){.navbar-static-top{border-radius:0}}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media(min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-right:15px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media(min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media(max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media(min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media(min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media(max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media(min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media(min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media(min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media(max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#090909}@media(max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.428571429;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager:after,.pager:before{display:table;content:\" \"}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-right:auto;margin-left:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{display:table;content:\" \"}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{padding:0;cursor:pointer;background:transparent;border:0;appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{display:table;content:\" \"}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.428571429}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{display:table;content:\" \"}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media(min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media(min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.428571429;line-break:auto;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;font-size:12px;filter:alpha(opacity=0);opacity:0}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.428571429;line-break:auto;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover>.arrow{border-width:11px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;outline:0;filter:alpha(opacity=90);opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{display:table;content:\" \"}.clearfix:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media(max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media(max-width:767px){.visible-xs-block{display:block!important}}@media(max-width:767px){.visible-xs-inline{display:inline!important}}@media(max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media(min-width:768px)and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media(min-width:768px)and (max-width:991px){.visible-sm-block{display:block!important}}@media(min-width:768px)and (max-width:991px){.visible-sm-inline{display:inline!important}}@media(min-width:768px)and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media(min-width:992px)and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media(min-width:992px)and (max-width:1199px){.visible-md-block{display:block!important}}@media(min-width:992px)and (max-width:1199px){.visible-md-inline{display:inline!important}}@media(min-width:992px)and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media(min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media(min-width:1200px){.visible-lg-block{display:block!important}}@media(min-width:1200px){.visible-lg-inline{display:inline!important}}@media(min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media(max-width:767px){.hidden-xs{display:none!important}}@media(min-width:768px)and (max-width:991px){.hidden-sm{display:none!important}}@media(min-width:992px)and (max-width:1199px){.hidden-md{display:none!important}}@media(min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}.toast-title{font-weight:700}.toast-message{word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8}.toast-close-button:focus,.toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4}button.toast-close-button{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.toast-top-center{top:0;right:0;width:100%}.toast-bottom-center{bottom:0;right:0;width:100%}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-left{bottom:12px;left:12px}#toast-container{position:fixed;z-index:999999}#toast-container *{box-sizing:border-box}#toast-container .toast{position:relative;overflow:hidden;margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;border-radius:3px 3px 3px 3px;background-position:15px;background-repeat:no-repeat;box-shadow:0 0 12px #999;color:#fff;opacity:.8}#toast-container .toast:hover{box-shadow:0 0 12px #000;opacity:1;cursor:pointer}#toast-container .toast.toast-info{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=\")!important}#toast-container .toast.toast-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=\")!important}#toast-container .toast.toast-success{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==\")!important}#toast-container .toast.toast-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=\")!important}#toast-container.toast-bottom-center .toast,#toast-container.toast-top-center .toast{width:300px;margin-left:auto;margin-right:auto}#toast-container.toast-bottom-full-width .toast,#toast-container.toast-top-full-width .toast{width:96%;margin-left:auto;margin-right:auto}.toast{background-color:#030303}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info{background-color:#2f96b4}.toast-warning{background-color:#f89406}progress-bar{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4}div[toast]{opacity:1!important}div[toast].ng-enter{opacity:0!important;transition:opacity .3s linear}div[toast].ng-enter.ng-enter-active{opacity:1!important}div[toast].ng-leave{opacity:1;transition:opacity .3s linear}div[toast].ng-leave.ng-leave-active{opacity:0!important}@media (max-width:240px){#toast-container .toast.div{padding:8px 8px 8px 50px;width:11em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media (min-width:241px)and (max-width:480px){#toast-container .toast.div{padding:8px 8px 8px 50px;width:18em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media (min-width:481px)and (max-width:768px){#toast-container .toast.div{padding:15px 15px 15px 50px;width:25em}}.animation-appear .ng-enter{transition:.3s;opacity:0}.animation-appear .ng-enter .ng-enter-active{opacity:1}.animation-appear .ng-leave{transition:.3s}.animation-appear .ng-leave .ng-leave-active{opacity:0}.btn.btn-app{font-size:13px;line-height:48px;height:48px;margin:0;padding:0;text-transform:uppercase;border:0;border-radius:0}.btn.btn-app.btn-default{width:160px;color:#0072c9;border:1px solid #dddfe2;background-color:#f9f9f9}.btn.btn-app.btn-default:focus{color:#005596;border:1px solid #c1c5cb;outline:0;background-color:#e0e0e0}.btn.btn-app.btn-primary{width:160px;color:#fff;background-color:#0072c9}.btn.btn-app.btn-primary:focus{color:#e6e6e6;outline:0;background-color:#005596}.checkbox{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:center;-moz-align-items:center;align-items:center}.checkbox.on-right input[type=checkbox]+label,.checkbox.on-right input[type=checkbox]:checked+label{padding:1px 20px 0 0;background-position-x:100%}.checkbox.on-right label{padding-left:0!important}.checkbox.on-right .checked{transition:.3s ease-in;color:#0072c9}.checkbox.on-right .unchecked{transition:.3s ease-in}.checkbox input[type=checkbox]{display:none}.checkbox input[type=checkbox]+label{display:inline-block;height:18px;padding:1px 0 0 20px;background:url(" + __webpack_require__(1072) + ") no-repeat}.checkbox input[type=checkbox]:checked+label{display:inline-block;height:18px;padding:1px 0 0 20px;color:#0072c9;background:url(" + __webpack_require__(1073) + ") no-repeat}.checkbox label{transition:background .3s ease-in;font-family:Stag Sans;font-size:13px;font-weight:400;max-width:100%;margin:0;cursor:pointer;color:#aeaeae}.checkbox .before-checkbox{margin-left:12px}.radio{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:center;-moz-align-items:center;align-items:center}.radio.on-right input[type=radio]+label,.radio.on-right input[type=radio]:checked+label{padding:1px 20px 0 0;background-position-x:100%}.radio input[type=radio]{display:none}.radio input[type=radio]+label{display:inline-block;height:18px;padding:1px 0 0 28px;background:url(" + __webpack_require__(1074) + ") no-repeat;background-size:18px}.radio input[type=radio]:checked+label{display:inline-block;height:18px;padding:1px 0 0 28px;color:#0072c9;background:url(" + __webpack_require__(1075) + ") no-repeat;background-size:18px}.radio label{transition:background .3s ease-in;font-size:13px;font-weight:400;max-width:100%;margin:0;cursor:pointer;color:#aeaeae}.radio label,body{font-family:Stag Sans}body{-moz-osx-font-smoothing:grayscale;osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;padding-top:env(safe-area-inset-top)}body *{-webkit-print-color-adjust:exact!important;color-adjust:exact!important}a:hover{background-color:#52bcec}li,p{font-family:ArialMT;color:#666}.title{color:#0072c9}.subtitle{color:#04408f}.remove-pointer-events{pointer-events:none}.cursor-not-allowed{cursor:not-allowed}.mobile-overflow{height:100%;position:relative;overflow-y:hidden}input#ui-switch{display:none!important}@font-face{font-family:icons;font-weight:400;font-style:normal;src:url(" + __webpack_require__(1076) + ") format(\"embedded-opentype\"),url(" + __webpack_require__(1077) + ") format(\"truetype\"),url(" + __webpack_require__(1078) + ") format(\"woff\"),url(" + __webpack_require__(1079) + ") format(\"svg\")}[class*=\" icon-\"],[class^=icon-]{-moz-osx-font-smoothing:grayscale;osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-family:icons!important;font-weight:400;font-style:normal;font-variant:normal;line-height:1;text-transform:none;speak:none}.icon-icon-edit:before{content:\"\\E943\";color:#fff}.icon-icon-mas:before{content:\"\\E944\";color:#fff}.icon-icon-trash:before{content:\"\\E945\";color:#fff}.icon-list-view-icon:before{content:\"\\E921\";color:#0072c9}.icon-authorized .path1:before{content:\"\\E91F\";color:#86c82d}.icon-authorized .path2:before{content:\"\\E920\";margin-left:-1em;color:#fff}.icon-cancel .path1:before{content:\"\\E91C\";color:#f7893b!important}.icon-cancel .path2:before{content:\"\\E941\";margin-left:-1em;color:#fff!important}.icon-cancel .path3:before{content:\"\\E942\";margin-left:-1em;color:#fff!important}.icon-alert-red:before{content:\"\\E90B\";color:#c8175e!important}.icon-alert-white:before{content:\"\\E90C\";color:#fff!important}.icon-cross-blue:before{content:\"\\E91B\";color:#0072c9!important}.icon-cross-white:before{content:\"\\E91D\";color:#fff!important}.icon-calendar-blue:before{content:\"\\E91E\";color:#0072c9!important}.icon-check-blue:before{content:\"\\E922\";color:#0072c9!important}.icon-cross-circle-deny .path1:before{content:\"\\E923\";color:#da3851!important}.icon-cross-circle-deny .path2:before{content:\"\\E924\";margin-left:-1em;color:#fff!important}.icon-cross-circle-deny .path3:before{content:\"\\E925\";margin-left:-1em;color:#da3851!important}.icon-search-circle .path1:before{content:\"\\E926\";color:#52bcec!important}.icon-search-circle .path2:before{content:\"\\E927\";margin-left:-1em;color:#fff!important}.icon-legend-orange:before{content:\"\\E928\";color:#f7893b!important}.icon-legend-red:before{content:\"\\E929\";color:#da3851!important}.icon-legend-blue:before{content:\"\\E92A\";color:#52bcec!important}.icon-legend-green:before{content:\"\\E92B\";color:#86c82d!important}.icon-legend-grey:before{content:\"\\E92C\";color:#bdbdbd!important}.icon-legend-cyan:before{content:\"\\E92D\";color:#27cbcd!important}.icon-family:before{content:\"\\E92E\";color:#287cba!important}.icon-education:before{content:\"\\E92F\";color:#287cba!important}.icon-house:before{content:\"\\E930\";color:#287cba!important}.icon-euro-ticket .path1:before{content:\"\\E931\";color:#287cba!important}.icon-euro-ticket .path2:before{content:\"\\E932\";margin-left:-1em;color:#fff!important}.icon-info:before{content:\"\\E933\";color:#0072c9!important}.icon-cross-circle .path1:before{content:\"\\E934\";color:#bdbdbd!important}.icon-cross-circle .path2:before{content:\"\\E935\";margin-left:-1em;color:#fff!important}.icon-pencil-circle .path1:before{content:\"\\E936\";color:#27cbcd!important}.icon-pencil-circle .path2:before{content:\"\\E937\";margin-left:-1em;color:#fff!important}.icon-pencil-circle .path3:before{content:\"\\E938\";margin-left:-1em;color:#27cbcd!important}.icon-euro-hand .path1:before{content:\"\\E939\";color:#0072c9!important}.icon-euro-hand .path2:before{content:\"\\E93A\";margin-left:-1em;color:#fff!important}.icon-euro-hand .path3:before{content:\"\\E93B\";margin-left:-1em;color:#0072c9!important}.icon-euro-hand .path4:before{content:\"\\E93C\";margin-left:-1em;color:#fff!important}.icon-euro-hand .path5:before{content:\"\\E93D\";margin-left:-1em;color:#fff!important}.icon-search-blue:before{content:\"\\E93E\";color:#0072c9!important}.icon-car:before{content:\"\\E93F\";color:#287cba!important}.icon-plus-circle-big:before{content:\"\\E940\";color:#0072c9!important}.icon-plus-circle:before{content:\"\\E909\";color:#0072c9!important}.icon-minus-circle:before{content:\"\\E90A\";color:#0072c9!important}.icon-interrogation-color:before{content:\"\\E908\";color:#0072c9!important}.icon-hide:before{content:\"\\E904\";color:#0072c9!important}.icon-expand:before{content:\"\\E905\";color:#0072c9}.icon-bell:before{content:\"\\E906\";color:#aeaeae!important}.icon-insight:before{content:\"\\E907\";color:#0072c9}.icon-arrow-coachmark-left:before{content:\"\\E90D\";color:#666!important}.icon-arrow-coachmark-right:before{content:\"\\E90E\";color:#666!important}.icon-search:before{content:\"\\E900\"}.icon-check:before{content:\"\\E901\"}.icon-approved .path1:before{content:\"\\E902\";color:#86c82d!important}.icon-approved .path2:before{margin-left:-1em;content:\"\\E903\";color:#fff!important}.icon-requested .path1:before{content:\"\\E90F\";color:#f6891e!important}.icon-requested .path2:before{margin-left:-1em;content:\"\\E910\";color:#fff!important}.icon-requested .path3:before{margin-left:-1em;content:\"\\E911\";color:#fff!important}.icon-legend-absence:before{content:\"\\E912\"}.icon-legend-vacation:before{content:\"\\E913\"}.icon-cross:before{content:\"\\E914\"}.icon-arrow-select-up:before{content:\"\\E915\"}.icon-arrow-select-down:before{content:\"\\E916\"}.icon-calendar:before{content:\"\\E917\"}.icon-confirmation:before{content:\"\\E918\";color:#86c82d}.icon-interrogation:before{content:\"\\E919\"}.icon-warning:before{content:\"\\E91A\"}input[type=number],input[type=tel],input[type=text]{-moz-appearance:none;appearance:none}input[type=number]{-moz-appearance:textfield}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=date],input[type=number],input[type=password],input[type=text]{font-family:Stag Sans;font-size:13px;line-height:37px;height:37px;padding-left:21px;color:#666;border:1px solid #dddfe2;border-radius:3px;background-color:#fff}input[type=date][disabled],input[type=number][disabled],input[type=password][disabled],input[type=text][disabled]{color:#aeaeae}input[type=date].amount,input[type=number].amount,input[type=password].amount,input[type=text].amount{width:150px;padding-right:15px;text-align:right}input[type=date].amount.responsiveMobile,input[type=number].amount.responsiveMobile,input[type=password].amount.responsiveMobile,input[type=text].amount.responsiveMobile{width:100%;height:50px;font-size:24px}input[type=date].amount.small,input[type=number].amount.small,input[type=password].amount.small,input[type=text].amount.small{width:100px;height:37px;border:1px solid #dddfe2;border-radius:3px;background-color:#fff}input[type=date].text-center,input[type=number].text-center,input[type=password].text-center,input[type=text].text-center{padding-right:0;padding-left:0}input[type=date].full,input[type=number].full,input[type=password].full,input[type=text].full{width:100%}input[type=date]:focus,input[type=number]:focus,input[type=password]:focus,input[type=text]:focus{outline:0!important}input[type=date].ng-invalid.ng-dirty,input[type=date].ng-invalid.ng-dirty.ng-invalid.ng-touched,input[type=number].ng-invalid.ng-dirty,input[type=number].ng-invalid.ng-dirty.ng-invalid.ng-touched,input[type=password].ng-invalid.ng-dirty,input[type=password].ng-invalid.ng-dirty.ng-invalid.ng-touched,input[type=text].ng-invalid.ng-dirty,input[type=text].ng-invalid.ng-dirty.ng-invalid.ng-touched{border-color:#c8175e}p.label{font-family:Stag Sans;font-size:13px;font-weight:400;display:inline-block;min-height:21px;margin-bottom:0;padding-top:0;padding-left:5px;color:#666}p.label .icon{font-size:18px;display:inline-block;margin-left:5px;color:#0072c9}p.label .icon.icon-interrogation{font-weight:100}p.error{color:#c8175e}label.uppercase{text-transform:uppercase}label.block{display:block}label.medium{font-family:Stag Sans;font-size:13px;font-weight:400;margin:0;padding:0}label.blue{color:#0072c9}label.error{color:#c8175e}label.with-icon span.icon{font-size:17px;display:inline-block;margin-left:5px}@media print{@page{size:A4 portrait}body.printing-calendar-grid,html.printing-calendar-grid{border:0!important;overflow-y:hidden!important;padding:0!important;background:#fff!important}body.printing-calendar-grid .container .gutter,body.printing-calendar-grid .modal-backdrop .in,body.printing-calendar-grid .toast .gutter,body.printing-calendar-grid calendar-context-menu .gutter,body.printing-calendar-grid main-menu .gutter,body.printing-calendar-grid modal-coachmark .gutter,body.printing-calendar-grid vacations-absences-navbar .gutter,html.printing-calendar-grid .container .gutter,html.printing-calendar-grid .modal-backdrop .in,html.printing-calendar-grid .toast .gutter,html.printing-calendar-grid calendar-context-menu .gutter,html.printing-calendar-grid main-menu .gutter,html.printing-calendar-grid modal-coachmark .gutter,html.printing-calendar-grid vacations-absences-navbar .gutter{display:none}}.toast-container{font-family:Stag Sans}.toast-container .toast{opacity:1}.toast-container .toast .toast-title{font-weight:500}.toast-container .toast.responsiveMobile{position:fixed;bottom:0;left:0;margin:0;width:100%;box-shadow:none;opacity:1;min-height:65px;padding-left:60px;padding-right:60px}.toast-container .toast.responsiveMobile.toast-error{background-position:12px}.toast-container .toast.toast-error{background-image:url(" + __webpack_require__(1080) + ")!important;background-size:36px;font-family:Stag Sans;background-color:#f8d7dc;background-position:7px;color:#333;box-shadow:none;border-radius:0}@media print{.toast-container .toast.toast-error{background-color:#f8d7dc!important;background-repeat:no-repeat!important;background-position:7px!important;background-size:36px!important}}.toast-container .toast.toast-error .toast-close-button{color:#c8175e;font-weight:300;font-size:30px;position:absolute;top:0;right:15px}.tooltip.in{opacity:1!important}.tooltip.bottom .tooltip-arrow{z-index:90;left:-58px!important;width:20px;height:0!important;margin-top:1px;border-top:20px solid transparent!important;border-right:22px solid #0072c9!important;border-bottom:0 solid transparent!important;border-left:40px solid transparent!important}.tooltip.bottom .tooltip-inner{font-family:Stag Sans;font-size:12px;line-height:1.3;z-index:100;min-width:219px;max-width:219px!important;height:auto;margin-top:10px;margin-left:-220px;padding:6px;color:#fff;border-radius:0;background-color:#0072c9}.tooltip.top .tooltip-arrow{z-index:90;left:-58px!important;width:20px;height:0!important;margin-bottom:-5px;border-top:0 solid transparent!important;border-right:22px solid #0072c9!important;border-bottom:20px solid transparent!important;border-left:40px solid transparent!important}.tooltip.top .tooltip-inner{font-family:Stag Sans;font-size:12px;line-height:1.3;z-index:100;min-width:219px;max-width:219px!important;height:auto;margin-bottom:5px;margin-left:-220px;padding:6px;color:#fff;border-radius:0;background-color:#0072c9}.tooltip.left .tooltip-arrow{z-index:90;top:54%!important;left:-3px!important;width:20px;height:0!important;border-top:20px solid #0072c9!important;border-right:20px solid transparent!important;border-bottom:20px solid transparent!important;border-left:0 solid transparent!important}.tooltip.left .tooltip-inner{font-family:Stag Sans;font-size:12px;line-height:1.3;z-index:100;min-width:219px;max-width:219px!important;height:auto;margin-top:18px;margin-left:-222px;padding:6px;color:#fff;border-radius:0;background-color:#0072c9}.tooltip.right .tooltip-arrow{top:5px!important;left:-5px!important;height:0!important;border-top:20px solid #0072c9!important;border-right:0 solid transparent!important;border-bottom:20px solid transparent!important;border-left:20px solid transparent!important}.tooltip.right .tooltip-inner{font-family:Stag Sans;font-size:12px;line-height:1.3;position:absolute;z-index:100;top:0;min-width:219px;max-width:219px!important;height:auto;padding:6px;color:#fff;border-radius:0;background-color:#0072c9}@font-face{font-family:ArialMT;font-style:normal;font-weight:400;src:url(" + __webpack_require__(1081) + ") format(\"truetype\")}@font-face{font-family:Stag Sans;font-style:normal;font-weight:100;src:url(" + __webpack_require__(1082) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:italic;font-weight:100;src:url(" + __webpack_require__(1083) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:normal;font-weight:300;src:url(" + __webpack_require__(1084) + ") format(\"opentype\"),url(" + __webpack_require__(1085) + ") format(\"truetype\")}@font-face{font-family:Stag Sans;font-style:italic;font-weight:300;src:url(" + __webpack_require__(1086) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:normal;font-weight:400;src:url(" + __webpack_require__(1087) + ") format(\"opentype\"),url(" + __webpack_require__(1088) + ") format(\"truetype\")}@font-face{font-family:Stag Sans;font-style:italic;font-weight:400;src:url(" + __webpack_require__(1089) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:normal;font-weight:500;src:url(" + __webpack_require__(1090) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:italic;font-weight:500;src:url(" + __webpack_require__(1091) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:normal;font-weight:600;src:url(" + __webpack_require__(1092) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:italic;font-weight:600;src:url(" + __webpack_require__(1093) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:normal;font-weight:700;src:url(" + __webpack_require__(1094) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:italic;font-weight:700;src:url(" + __webpack_require__(1095) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:normal;font-weight:900;src:url(" + __webpack_require__(1096) + ") format(\"opentype\")}@font-face{font-family:Stag Sans;font-style:italic;font-weight:900;src:url(" + __webpack_require__(1097) + ") format(\"opentype\")}.modal.mobile,.modal.responsiveMobile{z-index:10000}.modal.mobile .modal-dialog,.modal.responsiveMobile .modal-dialog{margin:0;width:100%;height:100%;overflow-y:hidden!important;transform:none}.modal.mobile .modal-dialog.on-focus,.modal.responsiveMobile .modal-dialog.on-focus{transform:translate(0)}.modal.mobile .modal-dialog .modal-content,.modal.responsiveMobile .modal-dialog .modal-content{border-radius:0!important;border:0!important;box-shadow:none!important;height:100%;position:fixed;width:100%}.modal.mobile .modal-dialog .modal-body,.modal.responsiveMobile .modal-dialog .modal-body{max-height:600px;padding:30px 0 300px!important;overflow-y:scroll;overflow-x:hidden}.modal.mobile .modal-dialog .modal-body .row,.modal.responsiveMobile .modal-dialog .modal-body .row{margin-left:0;margin-right:0}.modal-backdrop{background-color:#333!important;opacity:.5}@media print{.modal-backdrop{background:#fff!important;opacity:1!important}}.modal-content{border-radius:10px!important;border:1px solid #eaebed!important;box-shadow:0 2px 4px 0 #dddfe2,0 -1px 4px 0 #dddfe2!important;padding:43px 75px 50px}.modal-content .modal-header{border-bottom:1px solid #dddfe2;padding:0}.modal-content .modal-header .icon-interrogation{color:#0072c9;display:block;font-size:77px;height:76px;margin:0 auto 22px;width:76px}.modal-content .modal-header h4{color:#0072c9!important;font-family:Stag Sans;font-size:24px;font-weight:400;padding-bottom:5px;text-align:center}.modal-content .modal-header button{position:absolute;right:18px;top:19px;cursor:pointer}@media print{.modal-content .modal-header button{display:none}}.modal-content .modal-header .icon-cross{cursor:pointer;font-size:16px}.modal-content .modal-body{padding:0}.modal-content .modal-footer{border:0;padding:0}.simulated-modal{display:none;width:100%;height:100%;min-height:100%}.simulated-modal .tooltip-content{width:100%;height:100%;min-height:100%;position:relative;background:#0072c9;padding:60px 30px;font-size:13px;font-family:Stag Sans;text-align:left;text-transform:none}.simulated-modal .tooltip-content p{color:#fff}.simulated-modal .tooltip-content .tooltip-title{font-size:16px;text-align:left;font-weight:500}.simulated-modal .icon-cross{position:absolute;top:30px;right:30px;color:#fff;font-size:22px;cursor:pointer;z-index:1}.container.hpd{max-width:1200px;width:100%}@media screen and (max-width:944px){.container.hpd{width:929px;overflow-x:auto}}@media screen and (max-width:1500px){.container.hpd.mobile,.container.hpd.responsiveMobile{width:929px;overflow-x:auto;padding-top:60px;padding-right:30px;padding-left:30px;width:100%;overflow-x:hidden}.container.hpd.mobile.with-floating-action-buttons,.container.hpd.responsiveMobile.with-floating-action-buttons{padding-bottom:90px}.container.hpd.mobile.with-floating-action-buttons.with-floating-action-buttons-hidden,.container.hpd.responsiveMobile.with-floating-action-buttons.with-floating-action-buttons-hidden{padding-bottom:0}}", ""]);
	
	// exports


/***/ }),
/* 1072 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTUgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQyICgzNjc4MSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+Q2hlY2sgQm94PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPHJlY3QgaWQ9InBhdGgtMSIgeD0iMCIgeT0iMCIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE1IiByeD0iMyI+PC9yZWN0PgogICAgICAgIDxtYXNrIGlkPSJtYXNrLTIiIG1hc2tDb250ZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBtYXNrVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiB4PSIwIiB5PSIwIiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICA8L21hc2s+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iUGFudGFsbGxhcy1WSVNVQUwtRURJVCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkVTVEFETy02IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODE5LjAwMDAwMCwgLTQ2Ni4wMDAwMDApIiBzdHJva2U9IiNBRUFFQUUiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCdG4tTm8tdm9sdmVyLWEtbW9zdHJhci1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4MTkuMDAwMDAwLCA0NjYuMTYzODMxKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iQ2hlY2stQm94IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgLTAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPHVzZSBpZD0iUmVjdGFuZ2xlLTYtQ29weS0yIiBtYXNrPSJ1cmwoI21hc2stMikiIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQyICgzNjc4MSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+Q2hlY2sgQm94IE9uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPHJlY3QgaWQ9InBhdGgtMSIgeD0iMCIgeT0iMCIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE1IiByeD0iMyI+PC9yZWN0PgogICAgICAgIDxtYXNrIGlkPSJtYXNrLTIiIG1hc2tDb250ZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBtYXNrVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiB4PSIwIiB5PSIwIiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICA8L21hc2s+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iUGFudGFsbGxhcy1WSVNVQUwtRURJVCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkVTVEFETy02IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAxNC4wMDAwMDAsIC00NjYuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJCdG4tTm8tdm9sdmVyLWEtbW9zdHJhciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAxNC44Nzg5MDYsIDQ2Ni43ODEyNTApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJDaGVjay1Cb3gtT24iPgogICAgICAgICAgICAgICAgICAgIDx1c2UgaWQ9IlJlY3RhbmdsZS02LUNvcHktMiIgc3Ryb2tlPSIjMDA3MmM5IiBtYXNrPSJ1cmwoI21hc2stMikiIHN0cm9rZS13aWR0aD0iMiIgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9Imlvbi1hbmRyb2lkLWRvbmUtLS1Jb25pY29ucyIgZmlsbD0iIzA0NDA4ZiIgcG9pbnRzPSI2LjE0NDUzMTI1IDkuMTAxNTYyNSAxMC4xODc1IDUuMDU4NTkzNzUgMTAuNzUgNS42MDM1MTU2MiA2LjE0NDUzMTI1IDEwLjE5MTQwNjIgNCA4LjA0Njg3NSA0LjU2MjUgNy41MDE5NTMxMiI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAIAAABKGoy8AAAAA3NCSVQICAjb4U/gAAAAEHRFWHRTb2Z0d2FyZQBTaHV0dGVyY4LQCQAAAolJREFUWMPtWduqqzAQnVjdGhCJSEv7/x/X0gsREdI0Np6HYfeko3isVamHrgcfFF3LydwyYXVdw6fCgw+GP+Aday0AKKWu12tVVff7HQDwulqt8Or7fhRFAMA597yBJmAvLatSqigKrTUA9HyRMRaGYZIknPP/all7WU5rnec5AFyv18FMuMpCiDAMRxMnpSyKYkR7JEmSpulb4vD+6XRSSrWHku9HURSGIfo7hgKGhbVWa41mrqqq+S7633q9Zoy9LK6u6/1+DwDGmOZ34zhGcX3+vqqqsixb/zAIgt1u16FvgQFxPB7Jv6KdhBBBEAygMcZgSJFV5pxvNpsXxDUj4OfnB114cDp9pG4p5e126xkfT+Iwux4OB6Isy7IRF+tyuRB92+0WAJop5qN97klcnufoGa6r9cxJ/ZGmqe/7brA3eWnhx0JOHgsh3vGzdnt4nhACAM7nM95BXqUUqb9/iUkQcM4558Ni858IgiAIAiKlWYeW0M9hwXEfYBmYFHEcu9lUa22tdb3Iezicm1P8X0xrmGeKuq5J5vdclyTtzQwgRESG9yjP7t3+LdebIERExhKSMPZhbiqaif6ZiMpovYud4wwgRO3ivpvqoeK6zTsdut2pXRw2hjOAELWLI8WAlLLpQIiIDK9Ppp4O3ZVpCQHBOXf3j9UvJuUmFIyx9mbT8zxS5sqyLMtyUnHk+4/hQcuyJklCpl1KqeaOfxQYY4wxpEEiAmAxk03OOQaLG0F5nmdZNm4fYK0le63HDLTLckII3Be5PiulHNceUkoSCk3eBYwjvlOmEadM8DHDwwWOXbvj4030H1h/zyGcTDvyOQQpuHMeL7EBR5qzHcwt3+e++9alifsDa0vdC4BfUeoAAAAASUVORK5CYII="

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAxCAIAAAAXyW1IAAAAA3NCSVQICAjb4U/gAAAAEHRFWHRTb2Z0d2FyZQBTaHV0dGVyY4LQCQAAA4lJREFUWMPtWU1O20AUfmNPyBgM2AoJmG4q6LpSRFWJC3CALIrUI3TNMbLuEaqy4QC5ABIqQuo6IFYJ+dO4KMU22J4uph1GYztNnLRyJN4ujmfeN+9972+MGGNQPNGgkILzLYvj2PM83/fDMASAKIqiKOJ/6bqu6zrGmBACAIZhaNrMh0czOdHzvPv7ewAIgmDKhQihcrm8sbHBIS63E6eyVhAEAOC6ru/78ygjhFiWVS6XFwCLUsodtyjhDrVtOw8s/nwwGHielx4sGBNC+NE1TdN1nT+PoiiO4yAIuGl5TCTFMIxqtYoQmgEWY6zb7QLA09NTcjsAME0T46miOAzD8XicerZSqeQ4TiqypaJ8v99Png9jbFlWqVTKoYZb3XVdxaeGYdRqtalgJTm+srLCSZojMSpJmFL6+Pj41whQYQVBcHd3p2CqVCoLdNBoNAIABdzOzo6cOArKLRWW67oKnyYnmBxi27Zt20ogq3rlegcASh63LGsCn64HD2dXXQA4v6HdH78XOpvkcM9u1J396mq6JTSN7zwcDsVD3/c9zxNF85lbvV5PhsXfsCwrPbIi1my1Ty87WTUCITg+2AWAk6M3JT09Z7quK8c7IWR7e3sZ+i1eLuQ/TNPMshMAfPry/eLWnbAvY/D1WwcAboYPnz++TTWYaZqytYIgiOOYe1kTxGKMCYfiP5Lcq9lqN1vtyZhkubh1m612VlWVVTDGPM/jQLFgnNKBZHH89LIzq0dOLzsf3r0CgGQQEELG47FMfABYW1vTREGV385qic6uuozBrEMJY3B21eUxq4iiKAxDjqTYlBcDgpxaknJ+Q/OpyVqoKBIw0mGJnk4RkTNnlayFiiIBY0lqYrFgZRlTEWeT5FPjbJLUtUnycCRY/Jbbdp5tk3K4Z18PfuaAdbhnZzWGqVTTRMJNDoZJadQdhCBjWpkwWEOj7jTqTtYEmsz7OCvbrq+vJ3fZr67yvoDXuynl+GA3q8nJqi7FTqeGYfB5jVdrUQSS1frk6A3vC6as1u9fW3xJ6ggpFz2EUNHbwGdY/I1+vy+v3NramjAY5muaxeQoN80AUKvVhLWWZKru9XpydGCMK5XKnFNraq4ajUYysWQPplhLIVMYhpTSxVqCUkopVTo8RW9Bh/2XG5s5b2yKcO22VJeUkyNgTpnmSvflXn6x9/Ky/LePKyjfh7t//SmqoNz6BRimc0rvTOxYAAAAAElFTkSuQmCC"

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e23a0bd1842a82b0cb0c1c2ff97d8908.eot";

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/icons.ttf";

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f3fddefd3f6e9e20a4883e3ba7e8a243.woff";

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f52f2d7c69959aebecf54d75cf51e37c.svg";

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzNweCIgaGVpZ2h0PSIzMnB4IiB2aWV3Qm94PSIwIDAgMzMgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQyICgzNjc4MSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+SWNvbm8gd2FybmluZ18zMjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxjaXJjbGUgaWQ9InBhdGgtMSIgY3g9IjE2LjE4OTEyMzQiIGN5PSIxNS44NDQ5Njc1IiByPSIxNS43OTIyMDc4Ij48L2NpcmNsZT4KICAgICAgICA8bWFzayBpZD0ibWFzay0yIiBtYXNrQ29udGVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgbWFza1VuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeD0iMCIgeT0iMCIgd2lkdGg9IjMxLjU4NDQxNTYiIGhlaWdodD0iMzEuNTg0NDE1NiIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgogICAgICAgIDwvbWFzaz4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJTaW1ib2xvcyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkhPTUUtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMDAuMDAwMDAwLCAtOTg0LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iMDAtSWNvbm8tV2FybmluZy1WZWN0b3ItMzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMDAuMzQyNDIyLCA5ODQuMTI2OTUzKSI+CiAgICAgICAgICAgICAgICA8dXNlIGlkPSJPdmFsIiBzdHJva2U9IiNDODE3NUUiIG1hc2s9InVybCgjbWFzay0yKSIgc3Ryb2tlLXdpZHRoPSIyLjQ5MzUwNjQ5IiB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiNDODE3NUUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgeD0iMTQuNzM0NTc3OSIgeT0iNy44ODMyNTY5IiB3aWR0aD0iMi45MDkwOTA5MSIgaGVpZ2h0PSIxMS40MjMwOTI1IiByeD0iMS4yNDY3NTMyNSI+PC9yZWN0PgogICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbC0zIiBmaWxsPSIjQzgxNzVFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGN4PSIxNi4xODkxMjM0IiBjeT0iMjEuOTM2NTQ4MyIgcj0iMS44NzAxMjk4NyI+PC9jaXJjbGU+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/ArialMT.ttf";

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Thin.otf";

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Thin-Italic.otf";

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Light.otf";

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Light.ttf";

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Light-Italic.otf";

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Book.otf";

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Book.ttf";

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Book-Italic.otf";

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Medium.otf";

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Medium-Italic.otf";

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Semibold.otf";

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Semibold-Italic.otf";

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Bold.otf";

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Bold-Italic.otf";

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Black.otf";

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/StagSans-Black-Italic.otf";

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vacationsAbsences = __webpack_require__(1099);
	
	var _vacationsAbsences2 = _interopRequireDefault(_vacationsAbsences);
	
	var _vacationsAbsences3 = __webpack_require__(1365);
	
	var _vacationsAbsences4 = _interopRequireDefault(_vacationsAbsences3);
	
	var _vacationsAbsences5 = __webpack_require__(1527);
	
	var _vacationsAbsences6 = _interopRequireDefault(_vacationsAbsences5);
	
	var _vacationsAbsences7 = __webpack_require__(1559);
	
	var _vacationsAbsences8 = _interopRequireDefault(_vacationsAbsences7);
	
	var _angularToastr = __webpack_require__(540);
	
	var _angularToastr2 = _interopRequireDefault(_angularToastr);
	
	var _toastUtils = __webpack_require__(1560);
	
	var _toastUtils2 = _interopRequireDefault(_toastUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationsAbsencesModule = angular.module('vacations-absences', [_vacationsAbsences6.default, _vacationsAbsences2.default, _vacationsAbsences4.default, _angularToastr2.default]).config(["$translatePartialLoaderProvider", "toastrConfig", "$windowProvider", function ($translatePartialLoaderProvider, toastrConfig, $windowProvider) {
	  'ngInject';
	
	  _toastUtils2.default.setGlobalConfig(toastrConfig, $windowProvider.$get().isMobileApp);
	  $translatePartialLoaderProvider.addPart('vacations-absences.module');
	}]).service('vacationsAbsencesService', _vacationsAbsences8.default).name;
	
	exports.default = vacationsAbsencesModule;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vacationsAbsencesRouting = __webpack_require__(1100);
	
	var _vacationsAbsencesRouting2 = _interopRequireDefault(_vacationsAbsencesRouting);
	
	var _myVacations = __webpack_require__(1108);
	
	var _myVacations2 = _interopRequireDefault(_myVacations);
	
	var _myVacationsMobile = __webpack_require__(1155);
	
	var _myVacationsMobile2 = _interopRequireDefault(_myVacationsMobile);
	
	var _teamRequests = __webpack_require__(1167);
	
	var _teamRequests2 = _interopRequireDefault(_teamRequests);
	
	var _teamCalendar = __webpack_require__(1284);
	
	var _teamCalendar2 = _interopRequireDefault(_teamCalendar);
	
	var _teamCalendarMobile = __webpack_require__(1299);
	
	var _teamCalendarMobile2 = _interopRequireDefault(_teamCalendarMobile);
	
	var _managerAsEmployeeCalendar = __webpack_require__(1329);
	
	var _managerAsEmployeeCalendar2 = _interopRequireDefault(_managerAsEmployeeCalendar);
	
	var _managerAsEmployeeCalendarMobile = __webpack_require__(1333);
	
	var _managerAsEmployeeCalendarMobile2 = _interopRequireDefault(_managerAsEmployeeCalendarMobile);
	
	var _vacationsAbsencesDelegations = __webpack_require__(1343);
	
	var _vacationsAbsencesDelegations2 = _interopRequireDefault(_vacationsAbsencesDelegations);
	
	var _periodListMobile = __webpack_require__(1349);
	
	var _periodListMobile2 = _interopRequireDefault(_periodListMobile);
	
	var _scheduleMobile = __webpack_require__(1355);
	
	var _scheduleMobile2 = _interopRequireDefault(_scheduleMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationsAbsencesFeatures = angular.module('vacations-absences.features', [_vacationsAbsencesRouting2.default, _myVacations2.default, _myVacationsMobile2.default, _teamRequests2.default, _teamCalendar2.default, _teamCalendarMobile2.default, _managerAsEmployeeCalendar2.default, _managerAsEmployeeCalendarMobile2.default, _vacationsAbsencesDelegations2.default, _periodListMobile2.default, _scheduleMobile2.default]).name;
	
	exports.default = vacationsAbsencesFeatures;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vacationsAbsencesRouting = __webpack_require__(1101);
	
	var _vacationsAbsencesRouting2 = _interopRequireDefault(_vacationsAbsencesRouting);
	
	var _vacationsAbsencesRouting3 = __webpack_require__(1107);
	
	var _vacationsAbsencesRouting4 = _interopRequireDefault(_vacationsAbsencesRouting3);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationsAbsencesRoutingModule = angular.module('vacations-absences.routing', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.ROOT, {
	    abstract: true,
	    parent: _states.STATES.MAIN_ROUTING,
	    url: _routes.ROUTES.VACATIONS_ABSENCES.ROOT,
	    component: 'vacationsAbsencesRouting',
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      moduleClosed: ["StatusAppCheckers", function moduleClosed(StatusAppCheckers) {
	        return StatusAppCheckers.getClosedModules();
	      }]
	    }
	  });
	}]).component('vacationsAbsencesRouting', _vacationsAbsencesRouting2.default).service('vacationsAbsencesRoutingService', _vacationsAbsencesRouting4.default).name;
	
	exports.default = vacationsAbsencesRoutingModule;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vacationsAbsencesRouting = __webpack_require__(1102);
	
	var _vacationsAbsencesRouting2 = _interopRequireDefault(_vacationsAbsencesRouting);
	
	var _vacationsAbsencesRouting3 = __webpack_require__(1103);
	
	var _vacationsAbsencesRouting4 = _interopRequireDefault(_vacationsAbsencesRouting3);
	
	__webpack_require__(1105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationsAbsencesRoutingComponent = {
	  restrict: 'E',
	  bindings: {
	    moduleClosed: '<'
	  },
	  template: _vacationsAbsencesRouting2.default,
	  controller: _vacationsAbsencesRouting4.default
	};
	
	exports.default = vacationsAbsencesRoutingComponent;

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	module.exports = "<main-menu ng-if=\"$ctrl.showMenuDesktop()\" links=\"$ctrl.links\">\n  <employee-afk\n    user-id=\"{{$ctrl.employee.userId}}\"\n    has-delegated=\"$ctrl.hasDelegated\"\n    delegation=\"$ctrl.delegation\"\n    send-incept=\"$ctrl.onSendIncept($event)\"\n    ng-if=\"$ctrl.showEmployeeAfk()\"\n    is-disabled=\"$ctrl.moduleClosed.isWageInProcess\">\n  </employee-afk>\n\n  <holiday-summary\n    ng-if=\"$ctrl.showHolidaySummary()\"\n    class=\"hidden-lg\"\n    pending-days=\"$ctrl.employee.availableVacations.pendingDays\"\n    own-days=\"$ctrl.employee.availableVacations.ownDays\"\n    christmas-days=\"$ctrl.employee.availableVacations.christmasDays\"\n    last-year=\"$ctrl.employee.availableVacations.lastYear\"\n    is-manager=\"true\"\n    is-inception=\"$ctrl.isInception\"\n    inserted-in=\"mainNavbar\"></holiday-summary>\n</main-menu>\n\n<main-menu-mobile ng-if=\"$ctrl.showMenuMobile()\"\n                  links=\"$ctrl.links\" \n                  employee-info=\"$ctrl.employee\"\n                  manager-info=\"$ctrl.teamRequestData\"\n                  module=\"VU\"\n                  show-links=\"true\"></main-menu-mobile>\n\n<div ng-if=\"$ctrl.isLoaded\" ui-view></div>\n"

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _states = __webpack_require__(565);
	
	var _constants = __webpack_require__(598);
	
	var _link = __webpack_require__(1104);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VacationsAbsencesRoutingController = function () {
	  VacationsAbsencesRoutingController.$inject = ["$scope", "$translate", "$location", "$state", "$q", "$window", "vacationsAbsencesService", "vacationDelegationService", "vacationUserDataService", "ManagerNavigationService", "toastr", "inceptionService", "metricsService"];
	  function VacationsAbsencesRoutingController($scope, $translate, $location, $state, $q, $window, vacationsAbsencesService, vacationDelegationService, vacationUserDataService, ManagerNavigationService, toastr, inceptionService, metricsService) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, VacationsAbsencesRoutingController);
	    this.scope = $scope;
	    this.translate = $translate;
	    this.location = $location;
	    this.state = $state;
	    this.q = $q;
	
	    this.vacationUserDataService = vacationUserDataService;
	    this.vacationsAbsencesService = vacationsAbsencesService;
	    this.vacationDelegationService = vacationDelegationService;
	    this.ManagerNavigationService = ManagerNavigationService;
	    this.toastr = toastr;
	    this.inceptionService = inceptionService;
	    this.metricsService = metricsService;
	
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.isLoaded = false;
	    this.hasDelegated = false;
	    this.links = [];
	
	    this.scope.$on(_constants.EVENTS.ICON_DELEGATIONS, function () {
	      _this._initData();
	    });
	
	    this.scope.$on(_constants.EVENTS.REFRESH_EMPLOYEE, function (event, data) {
	      _this.employee = data;
	    });
	  }
	
	  (0, _createClass3.default)(VacationsAbsencesRoutingController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      if (this.isModuleClosed()) {
	        return;
	      }
	
	      this.vacationsAbsencesService.loadData();
	
	      this.metricsService.init();
	
	      this.scope.$watch(function () {
	        return _this2.vacationsAbsencesService.loaded;
	      }, function (newValue) {
	        if (newValue) {
	          _this2.isLoaded = true;
	          _this2.employee = _this2.vacationUserDataService.getEmployee();
	          _this2.manager = _this2.vacationsAbsencesService.ManagerDataService._manager;
	          _this2.teamRequestData = _this2.vacationsAbsencesService.TeamRequestDataService.getData();
	          _this2.userId = _this2.employee.userId;
	          _this2.employeeHasDelegations = _this2.employee.hasDelegation();
	          _this2.isManager = _this2.employee.isManager();
	          _this2._initData();
	          var hasElevatedRights = _this2.employee.hasDelegation() || _this2.employee.isManager();
	          _this2.ManagerNavigationService.canNavigateToState(hasElevatedRights);
	        }
	      });
	
	      this.setInceptionFlag();
	      this.refreshInceptionFlag();
	    }
	  }, {
	    key: '_initData',
	    value: function _initData() {
	      var _this3 = this;
	
	      this.q.all([this._translate(), this._checkDelegations()]).then(function () {
	        _this3._initLinks();
	        _this3._showToasts();
	      });
	    }
	  }, {
	    key: '_showToasts',
	    value: function _showToasts() {
	      if (this.moduleClosed.payrollUpdate) {
	        this.toastr.error(this.textToast, this.titleToast);
	      }
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this4 = this;
	
	      return this.q.all([this.translate('VACATIONS_ABSENCES.MAIN.MY_VACATIONS').then(function (translation) {
	        _this4.myVacations = translation;
	      }), this.translate('VACATIONS_ABSENCES.MAIN.TEAM_REQUESTS').then(function (translation) {
	        _this4.teamRequests = translation;
	      }), this.translate('VACATIONS_ABSENCES.MAIN.TEAM_CALENDAR').then(function (translation) {
	        _this4.teamCalendarLiteral = translation;
	      }), this.translate('VACATIONS_ABSENCES.MAIN.SCHEDULE_MOBILE').then(function (translation) {
	        _this4.scheduleMobileLiteral = translation;
	      }), this.translate('VACATIONS_ABSENCES.MAIN.DELEGATE_RIGHTS').then(function (translation) {
	        _this4.delegations = translation;
	      }), this.translate('GLOBALS.WARNING_TITLE').then(function (translation) {
	        _this4.titleToast = translation.$$unwrapTrustedValue();
	      }), this.translate('GLOBALS.READ_ONLY_WAGE_IN_PROCESS').then(function (translation) {
	        _this4.textToast = translation.$$unwrapTrustedValue();
	      })]);
	    }
	  }, {
	    key: '_initLinks',
	    value: function _initLinks() {
	      this.links = [];
	
	      var teamRequestsLink = new _link2.default(this.teamRequests, this.teamRequests, _states.STATES.VACATIONS_ABSENCES.TEAM_REQUESTS, '');
	      teamRequestsLink.setFromStates([_states.STATES.VACATIONS_ABSENCES.TEAM_REQUESTS]);
	
	      var teamCalendarLink = this._getTeamCalendarLink();
	
	      var delegationLink = new _link2.default(this.delegations, this.delegations, _states.STATES.VACATIONS_ABSENCES.DELEGATE, '');
	
	      if (this.isMobileApp) {
	        var myVacationsMobileLink = new _link2.default(this.myVacations, this.myVacations, _states.STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE, '');
	
	        myVacationsMobileLink.setAltStates([_states.STATES.VACATIONS_ABSENCES.PERIOD_LIST_MOBILE, _states.STATES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR_MOBILE]);
	
	        this.links.push(myVacationsMobileLink);
	      } else {
	        this.links.push(new _link2.default(this.myVacations, this.myVacations, _states.STATES.VACATIONS_ABSENCES.MY_VACATIONS, ''));
	      }
	
	      if (this.isDelegatedUser() || this.isManager) {
	        this.links.push(teamRequestsLink);
	        this.links.push(teamCalendarLink);
	      }
	
	      if (this.isDelegatedUser()) return;
	
	      if (this.hasDelegated) {
	        delegationLink.setAlertIcon('icon-warning');
	      }
	
	      if (this.isManager) {
	        this.links.push(delegationLink);
	      }
	
	      if (this.isMobileApp) {
	        var scheduleMobile = new _link2.default(this.scheduleMobileLiteral, this.scheduleMobileLiteral, _states.STATES.VACATIONS_ABSENCES.SCHEDULE_MOBILE, '');
	        this.links.push(scheduleMobile);
	      }
	    }
	  }, {
	    key: '_getTeamCalendarLink',
	    value: function _getTeamCalendarLink() {
	      var _STATES$VACATIONS_ABS = _states.STATES.VACATIONS_ABSENCES,
	          TEAM_CALENDAR = _STATES$VACATIONS_ABS.TEAM_CALENDAR,
	          TEAM_CALENDAR_MOBILE = _STATES$VACATIONS_ABS.TEAM_CALENDAR_MOBILE;
	
	      var destination = this.isMobileApp ? TEAM_CALENDAR_MOBILE : TEAM_CALENDAR;
	      var teamCalendarLink = new _link2.default(this.teamCalendarLiteral, this.teamCalendarLiteral, destination, '');
	      teamCalendarLink.setFromStates([TEAM_CALENDAR, TEAM_CALENDAR_MOBILE]);
	      return teamCalendarLink;
	    }
	  }, {
	    key: 'isDelegatedUser',
	    value: function isDelegatedUser() {
	      return this.employeeHasDelegations && !this.isManager;
	    }
	  }, {
	    key: '_checkDelegations',
	    value: function _checkDelegations() {
	      var _this5 = this;
	
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	      return this.vacationDelegationService.getDelegations(this.userId).then(function (delegations) {
	        _this5.delegation = _this5.vacationDelegationService.findDelegationActive(today, delegations);
	        _this5.hasDelegated = (0, _keys2.default)(_this5.delegation).length > 0;
	      }, function (error) {
	        _this5.delegationsErrorMessage = error.data.message;
	        _this5.hasDelegated = false;
	      });
	    }
	  }, {
	    key: 'showHolidaySummary',
	    value: function showHolidaySummary() {
	      this.currentState = this.state.current.name;
	      return _constants.HOLIDAY_SUMMARY_VISIBILITY_STATES.includes(this.currentState);
	    }
	  }, {
	    key: 'refreshInceptionFlag',
	    value: function refreshInceptionFlag() {
	      var _this6 = this;
	
	      this.scope.$watch(function () {
	        return _this6.state.current.name;
	      }, function () {
	        _this6.setInceptionFlag();
	      });
	    }
	  }, {
	    key: 'setInceptionFlag',
	    value: function setInceptionFlag() {
	      this.isInception = this.state.current.name === _constants.MANAGER_MAINNAVBAR_STATES.EMPLOYEE_CALENDAR;
	    }
	  }, {
	    key: 'showEmployeeAfk',
	    value: function showEmployeeAfk() {
	      var STATE_TO_DISPLAY = ['/team-requests', '/team-calendar'];
	      return _constants.EMPLOYEE_AFK_VISIBILITY_STATES.includes(this.currentState) || STATE_TO_DISPLAY.includes(this.location.path());
	    }
	  }, {
	    key: 'getTeamRequestsClasses',
	    value: function getTeamRequestsClasses() {
	      var currentStateIsTeamRequests = this.state.current.name === _constants.MANAGER_MAINNAVBAR_STATES.TEAM_REQUESTS;
	      var redirectionFromTeamRequests = this.stateParams.from === _constants.MANAGER_MAINNAVBAR_STATES.TEAM_REQUESTS;
	      return {
	        active: currentStateIsTeamRequests || redirectionFromTeamRequests,
	        link: true
	      };
	    }
	  }, {
	    key: 'getTeamCalendarClasses',
	    value: function getTeamCalendarClasses() {
	      var currentStateIsTeamCalendar = this.state.current.name === _constants.MANAGER_MAINNAVBAR_STATES.TEAM_CALENDAR;
	      var redirectionFromTeamCalendar = this.stateParams.from === _constants.MANAGER_MAINNAVBAR_STATES.TEAM_CALENDAR;
	      return {
	        active: currentStateIsTeamCalendar || redirectionFromTeamCalendar,
	        link: true
	      };
	    }
	  }, {
	    key: 'onSendIncept',
	    value: function onSendIncept($event) {
	      this.inceptionService.incept($event.employee, $event.from);
	    }
	  }, {
	    key: 'showMenuDesktop',
	    value: function showMenuDesktop() {
	      return (this.isManager || this.employeeHasDelegations) && !this.isMobileApp;
	    }
	  }, {
	    key: 'showMenuMobile',
	    value: function showMenuMobile() {
	      return this.isMobileApp && this.links && this.links.length > 0;
	    }
	  }, {
	    key: 'isModuleClosed',
	    value: function isModuleClosed() {
	      if (this.moduleClosed.isVacationsAbsencesClosed && this.moduleClosed.vacationsAbsencesClosedMessage) {
	        this.state.go(_states.STATES.ERROR, { stateName: _constants.PAGE_ERROR.CLOSED, errorMessage: this.moduleClosed.vacationsAbsencesClosedMessage });
	        return true;
	      } else if (this.moduleClosed.isVacationsAbsencesClosed) {
	        this.state.go(_states.STATES.ERROR, { stateName: _constants.PAGE_ERROR.CLOSED });
	        return true;
	      }
	      return false;
	    }
	  }]);
	  return VacationsAbsencesRoutingController;
	}();
	
	exports.default = VacationsAbsencesRoutingController;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Link = function () {
	  function Link(label, title, target, onClick) {
	    (0, _classCallCheck3.default)(this, Link);
	
	    this.label = label;
	    this.title = title;
	    this.target = target;
	    this.iconName = '';
	    this.hasSeparator = false;
	    this.hasAlert = false;
	    this.hasMenuBorder = true;
	    this.onClick = onClick || this.defaultOnClick;
	    this.altStates = [];
	    this.fromStates = [];
	  }
	
	  (0, _createClass3.default)(Link, [{
	    key: 'defaultOnClick',
	    value: function defaultOnClick() {
	      return false;
	    }
	  }, {
	    key: 'setNoMenuBorder',
	    value: function setNoMenuBorder() {
	      this.hasMenuBorder = false;
	    }
	  }, {
	    key: 'setAlertIcon',
	    value: function setAlertIcon(iconName) {
	      this.iconName = iconName;
	      this.hasAlert = true;
	    }
	  }, {
	    key: 'setSeparator',
	    value: function setSeparator() {
	      this.hasSeparator = true;
	    }
	  }, {
	    key: 'setAltStates',
	    value: function setAltStates(altStates) {
	      this.altStates = altStates;
	    }
	  }, {
	    key: 'setFromStates',
	    value: function setFromStates(fromStates) {
	      this.fromStates = fromStates;
	    }
	  }]);
	  return Link;
	}();
	
	exports.default = Link;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1106);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./vacationsAbsencesRouting.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./vacationsAbsencesRouting.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VacationsAbsencesRoutingService = function () {
	  VacationsAbsencesRoutingService.$inject = ["$transitions"];
	  function VacationsAbsencesRoutingService($transitions) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, VacationsAbsencesRoutingService);
	    this.transitions = $transitions;
	    this.start();
	  }
	
	  (0, _createClass3.default)(VacationsAbsencesRoutingService, [{
	    key: 'start',
	    value: function start() {
	      this.visited = {};
	      this.registerOnBeforeTo('my-vacations');
	    }
	  }, {
	    key: 'registerOnBeforeTo',
	    value: function registerOnBeforeTo(stateName) {
	      var _this = this;
	
	      var criteria = { to: stateName };
	      this.transitions.onBefore(criteria, function () {
	        return _this.setVisited(stateName);
	      });
	    }
	  }, {
	    key: 'setVisited',
	    value: function setVisited(stateName) {
	      this.visited[stateName] = true;
	    }
	  }, {
	    key: 'stateVisited',
	    value: function stateVisited(stateName) {
	      return this.visited[stateName] === true;
	    }
	  }]);
	  return VacationsAbsencesRoutingService;
	}();
	
	exports.default = VacationsAbsencesRoutingService;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(533);
	
	__webpack_require__(1109);
	
	var _myVacations = __webpack_require__(1110);
	
	var _myVacations2 = _interopRequireDefault(_myVacations);
	
	var _vacationScheduleEndDate = __webpack_require__(1119);
	
	var _vacationScheduleEndDate2 = _interopRequireDefault(_vacationScheduleEndDate);
	
	var _periodList = __webpack_require__(1121);
	
	var _periodList2 = _interopRequireDefault(_periodList);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myVacationsModule = angular.module('vacations-absences.myVacations', [_angularUiRouter2.default, _periodList2.default, 'ngSanitize', 'ngCsv']).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.MY_VACATIONS, {
	    url: _routes.ROUTES.VACATIONS_ABSENCES.MY_VACATIONS,
	    component: 'myVacations',
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      isWageInProcess: ["StatusAppCheckers", function isWageInProcess(StatusAppCheckers) {
	        return StatusAppCheckers.isWageInProcess();
	      }]
	    }
	  });
	}]).component('myVacations', _myVacations2.default).service('VacationScheduleEndDateService', _vacationScheduleEndDate2.default).name;
	
	exports.default = myVacationsModule;

/***/ }),
/* 1109 */,
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myVacations = __webpack_require__(1111);
	
	var _myVacations2 = _interopRequireDefault(_myVacations);
	
	var _myVacations3 = __webpack_require__(1112);
	
	var _myVacations4 = _interopRequireDefault(_myVacations3);
	
	__webpack_require__(1117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myVacationsComponent = {
	  restrict: 'E',
	  bindings: {
	    userInceptionId: '<',
	    isWageInProcess: '<'
	  },
	  template: _myVacations2.default,
	  controller: _myVacations4.default
	};
	
	exports.default = myVacationsComponent;

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

	module.exports = "<modal-request\n  ng-if=\"$ctrl.modalIsInitialized && $ctrl.loaded\"\n  user-id=\"$ctrl.userId\"\n  user-inception-id=\"$ctrl.userInceptionId\"\n  start-date=\"$ctrl.startDate\"\n  add-event=\"$ctrl.addEvent($event);\"\n  vacation-period-count=\"$ctrl.vacationCount\"\n  mode=\"$ctrl.requestHolidayMode\"\n  period-to-edit=\"$ctrl.periodToEdit\"\n  original-period=\"$ctrl.originalPeriod\"\n  is-inception=\"$ctrl.isInception()\"\n  open-on=\"$ctrl.requestModalOpenOn\"\n  year-pagination=\"$ctrl.year\"></modal-request>\n\n<modal-remove-period\n  user-id=\"$ctrl.userId\"\n  user-inception-id=\"$ctrl.userInceptionId\"\n  is-inception=\"$ctrl.isInception()\"\n  on-remove=\"$ctrl.removePeriod($event)\"></modal-remove-period>\n\n<modal-coachmark\n  ng-if=\"!$ctrl.isMobileApp\"\n  is-inception=\"$ctrl.isInception()\"\n  coachmark-dismissed=\"$ctrl.coachmarkIsDismissed($event)\"\n  data=\"$ctrl.coachmarkData\"\n  user-id=\"$ctrl.userId\"></modal-coachmark>\n\n<modal-warning-delegation\n  title-body=\"{{ 'VACATIONS_ABSENCES.MAIN.WARNING_DELEGATION_TITLE' | translate }}\"\n  delegation=\"$ctrl.delegation\"\n  url-destination=\"$ctrl.urlDestination\">\n</modal-warning-delegation>\n\n<modal-calendar-grid\n  ng-if=\"$ctrl.modalScheduleIsVisible\"\n  on-dismiss=\"$ctrl.closeModalSchedule()\"\n  user-id=\"$ctrl.userId\"\n  user-inception-id=\"$ctrl.userInceptionId\"\n  is-inception=\"$ctrl.isInception()\"></modal-calendar-grid>\n\n<calendar-context-menu\n  on-open-absences=\"$ctrl.openAbsences($event);\"\n  is-inception=\"$ctrl.isInception()\"\n  on-edit-period=\"$ctrl.onEditPeriod($event);\"\n  is-disabled=\"$ctrl.isDisabled()\">\n</calendar-context-menu>\n\n<warning-request-vacation ng-if=\"!$ctrl.isWarnModalBeenDisplayed()\"\n                          date=\"$ctrl.vacationScheduleEndDate\"\n                          on-dismiss=\"$ctrl.setWarnModalDisplayed()\">\n</warning-request-vacation>\n\n <section ng-if=\"!$ctrl.loaded\">\n  <loading></loading>\n</section>\n\n<div class=\"container gutter hpd animation-appear\" ng-if=\"$ctrl.loaded\" ng-class=\"$ctrl.isModalOpen()\">\n  <section class=\"row my-vacations-header\" ng-class=\"$ctrl.getManagerClass()\">\n    <div class=\"col-xs-8 col-sm-8 col-md-9 col-lg-12\">\n      <h2 ng-if=\"$ctrl.isInception()\" class=\"subtitle-manager\" ng-class=\"$ctrl.getManagerClass()\">\n        <avatar-app\n          email=\"$ctrl.user.email\"\n          name=\"$ctrl.user.name\"\n          user-id=\"$ctrl.user.userId\"></avatar-app>\n        <employee-name name=\"{{$ctrl.user.name}}\" enrollment=\"{{$ctrl.user.userId}}\"></employee-name>, {{\"VACATIONS_ABSENCES.HOME.CLICK_TO_START\" | translate}}\n        <span class=\"close-btn close-inception\"\n              ng-click=\"$ctrl.closeInception()\">{{'GLOBALS.BUTTON_ACTION.CLOSE' | translate}} <span\n          class=\"icon icon-cross\"></span></span>\n      </h2>\n      <h2 ng-if=\"!$ctrl.isInception()\" class=\"subtitle\" ng-class=\"$ctrl.getManagerClass()\">\n        <employee-name name=\"{{$ctrl.user.name}}\" enrollment=\"{{$ctrl.user.userId}}\"></employee-name>,\n        {{\"VACATIONS_ABSENCES.HOME.CLICK_TO_START\" | translate}}\n      </h2>\n    </div>\n\n    <div class=\"hidden-lg col-xs-4 col-sm-4 col-md-3\">\n      <holiday-summary\n        ng-if=\"!$ctrl.currentEmployee.isManager() && !$ctrl.isInception()\"\n        class=\"holiday-summary-header\"\n        pending-days=\"$ctrl.availableVacations.pendingDays\"\n        own-days=\"$ctrl.availableVacations.ownDays\"\n        christmas-days=\"$ctrl.availableVacations.christmasDays\"\n        last-year=\"$ctrl.availableVacations.lastYear\"\n        is-inception=\"$ctrl.isInception()\"\n        is-manager=\"$ctrl.currentEmployee.isManager()\"\n        inserted-in=\"header\"></holiday-summary>\n    </div>\n  </section>\n\n  <div class=\"row filters-row\">\n    <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-9 filters-main\">\n      <calendar-filters on-change-filters=\"$ctrl.onChangeFilters($event);\"></calendar-filters>\n    </div>\n    <div class=\"visible-lg col-lg-3 filters-sidebar\">\n      <holiday-summary\n        pending-days=\"$ctrl.availableVacations.pendingDays\"\n        own-days=\"$ctrl.availableVacations.ownDays\"\n        christmas-days=\"$ctrl.availableVacations.christmasDays\"\n        last-year=\"$ctrl.availableVacations.lastYear\"\n        is-inception=\"$ctrl.isInception()\"\n        is-manager=\"$ctrl.currentEmployee.isManager()\"\n        inserted-in=\"filters\"></holiday-summary>\n    </div>\n  </div>\n\n  <div class=\"grid\">\n    <div class=\"row\">\n      <div class=\"col-xs-8 col-sm-8 col-md-9 grid-main\">\n        <header>\n          <h1>\n            <span ng-if=\"$ctrl.showPreviousArrow()\"class=\"pagination\" ng-click=\"$ctrl.paginationPrevious()\"><</span>\n            <span class=\"year-title\">{{$ctrl.year}}</span>\n            <span ng-if=\"$ctrl.showNextArrow()\" class=\"pagination\"  ng-click=\"$ctrl.paginationNext()\">></span>\n          </h1>\n        </header>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-xs-8 col-sm-8 col-md-9 grid-main\">\n        <calendar-grid\n          loaded=\"$ctrl.loaded\"\n          events-dates=\"$ctrl.eventsDates\"\n          select-day=\"$ctrl.selectDay($event);\"\n          filters=\"$ctrl.filters\"\n          user=\"$ctrl.currentEmployee\"\n          is-inception=\"$ctrl.isInception()\"\n          is-tablet-resolution=\"$ctrl.isTabletResolution()\"\n          format=\"$ctrl.resolution\"\n          date-today=\"$ctrl.dateToday\">\n        </calendar-grid>\n      </div>\n\n      <div class=\"col-xs-4 col-sm-4 col-md-3 grid-sidebar\">\n        <div class=\"sticky-sidebar\">\n          <period-list\n            events=\"$ctrl.allPeriods\"\n            filters=\"$ctrl.filters\"\n            format=\"$ctrl.resolution\"\n            show-warning=\"$ctrl.modalsBehaviourService.warnLastDayShouldBeVisible\">\n          </period-list>\n\n          <a title=\"{{'VACATIONS_ABSENCES.VACATIONSBOX_TITLE' | translate }}\" class=\"sidebar-link second\" ng-click=\"$ctrl.openModalSchedule()\">\n            {{'VACATIONS_ABSENCES.VACATIONSBOX' | translate }}\n          </a>\n\n          <a\n            title=\"{{ 'VACATIONS_ABSENCES.CSV.BUTTON' | translate }}\"\n            class=\"sidebar-link second\"\n            ng-csv=\"$ctrl.getMyVacationsCsv()\"\n            csv-header=\"$ctrl.getMyVacationsCsvHeader()\"\n            filename=\"{{ 'VACATIONS_ABSENCES.CSV.FILENAME' | translate }}\">\n            {{ 'VACATIONS_ABSENCES.CSV.BUTTON' | translate }}\n            <tooltip-desktop  placement=\"top\" title=\"VACATIONS_ABSENCES.CSV.TOOLTIP\">\n            </tooltip-desktop>\n          </a>\n\n          <warn-last-day\n            ng-if=\"$ctrl.modalsBehaviourService.warnLastDayShouldBeVisible\"\n            date=\"$ctrl.vacationScheduleEndDate\">\n          </warn-last-day>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _request = __webpack_require__(1114);
	
	var _states = __webpack_require__(565);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants2 = __webpack_require__(723);
	
	var _myVacations = __webpack_require__(1115);
	
	var _myVacations2 = _interopRequireDefault(_myVacations);
	
	var _vacationScheduleEndDate = __webpack_require__(1116);
	
	var _vacationScheduleEndDate2 = _interopRequireDefault(_vacationScheduleEndDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyVacationsController = function () {
	  MyVacationsController.$inject = ["vacationUserDataService", "$scope", "$timeout", "$rootScope", "$filter", "$window", "$q", "$log", "vacationDelegationService", "VacationScheduleEndDateService", "vacationEmployeeRepositoryService", "ManagerForEmployeeService", "vacationsAbsencesService", "modalsBehaviourService", "HelperDelegationsService"];
	  function MyVacationsController(vacationUserDataService, $scope, $timeout, $rootScope, $filter, $window, $q, $log, vacationDelegationService, VacationScheduleEndDateService, vacationEmployeeRepositoryService, ManagerForEmployeeService, vacationsAbsencesService, modalsBehaviourService, HelperDelegationsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyVacationsController);
	    this.filter = $filter;
	    this.rootScope = $rootScope;
	    this.timeout = $timeout;
	    this.scope = $scope;
	    this.window = $window;
	    this.q = $q;
	    this.log = $log;
	
	    this.vacationDelegationService = vacationDelegationService;
	    this.VacationScheduleEndDateService = VacationScheduleEndDateService;
	    this.employeeRepositoryService = vacationEmployeeRepositoryService;
	    this.UserDataService = vacationUserDataService;
	    this.vacationsAbsencesService = vacationsAbsencesService;
	    this.ManagerForEmployeeService = ManagerForEmployeeService;
	    this.modalsBehaviourService = modalsBehaviourService;
	    this.helperDelegations = HelperDelegationsService;
	
	    this.loaded = false;
	    this.myVacationsCsv = new _myVacations2.default();
	    this.filters = [];
	    this.hasNoManager = false;
	    this.startDate = '';
	    this.dateToday = new Date();
	    this.dateTodayMonth = this.dateToday.getMonth();
	    this.year = this.dateToday.getFullYear();
	    this.currentEmployee = {};
	    this.delegation = {};
	    this.coachmarkData = _constants2.VA_MY_VACATIONS_MODAL_COACHMARK_CONFIG;
	    this.isMobileApp = $window.innerWidth < 1024;
	  }
	
	  (0, _createClass3.default)(MyVacationsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userId = this.UserDataService.getEmployee().userId;
	      this.urlDestination = _states.STATES.VACATIONS_ABSENCES.DELEGATE;
	      this.modalIsInitialized = true;
	
	      var promises = {
	        employee: this.employeeRepositoryService.getEmployee(this.userId, this.year, this.userInceptionId),
	        schedule: this.VacationScheduleEndDateService.get(),
	        delegations: this.vacationDelegationService.getDelegations(this.userId),
	        manager: this.ManagerForEmployeeService.getManagerForEmployee(this.userId)
	      };
	
	      this.q.allSettled(promises).then(function (responses) {
	        if (responses.employee.isFulfilled) {
	          _this._loadData(responses.employee.value);
	        } else {
	          _this.log.error('MyVacationsController endpoint getEmployee', responses.employee.reason);
	        }
	
	        if (responses.schedule.isFulfilled) {
	          _this._initVacationSchedule(responses.schedule.value);
	        } else {
	          _this.log.error('MyVacationsController endpoint get scheduleEndDate', responses.schedule.reason);
	        }
	
	        if (responses.delegations.isFulfilled) {
	          _this._initDelegations(responses.delegations.value);
	        } else {
	          _this.log.error('MyVacationsController endpoint getDelegations', responses.delegations.reason);
	        }
	        if (responses.manager.isRejected || responses.manager.value.managerId === null) {
	          var errorMsg = responses.manager.reason && responses.manager.reason.data && responses.manager.reason.data.message ? responses.manager.reason.data.message : 'No manager data';
	          _this._initManagerForEmployee(errorMsg);
	        } else if (responses.manager.isRejected) {
	          _this.log.error('MyVacationsController endpoint getManagerForEmployee', responses.delegations.reason);
	        }
	      });
	
	      this.resolution = this.getResolution();
	
	      this.modalsBehaviourService.reset();
	      this.visitedDelegation = this.helperDelegations.getVisitDelegation(this.userId);
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      var _this2 = this;
	
	      angular.element(this.window).bind('resize', function () {
	        _this2.resolution = _this2.getResolution();
	        _this2.scope.$apply();
	      });
	    }
	  }, {
	    key: '_loadData',
	    value: function _loadData(employee) {
	      this.currentEmployee = employee;
	      this.rootScope.$broadcast(_constants.EVENTS.REFRESH_EMPLOYEE, this.currentEmployee);
	      this.rawPeriodDays = employee.periodInDays;
	      this.user = employee.getProfile();
	      this.availableVacations = employee.availableVacations;
	      this.vacationCount = employee.getAgreementVacationCount();
	      this.allPeriods = employee.allPeriods;
	      this.loaded = true;
	    }
	  }, {
	    key: '_initVacationSchedule',
	    value: function _initVacationSchedule(schedule) {
	      this.vacationScheduleEndDateHelper = new _vacationScheduleEndDate2.default(schedule.startDate, schedule.endDate, this.availableVacations);
	      this.modalsBehaviourService.warnLastDayShouldBeVisible = this.vacationScheduleEndDateHelper.start();
	      this.vacationScheduleEndDate = this.vacationScheduleEndDateHelper.getViewDate();
	    }
	  }, {
	    key: '_initDelegations',
	    value: function _initDelegations(delegations) {
	      this._findDelegationActive(delegations);
	      this._showModalWarningDelegation();
	    }
	  }, {
	    key: '_initManagerForEmployee',
	    value: function _initManagerForEmployee(message) {
	      this.noManagerMessage = message;
	      this.hasNoManager = true;
	    }
	  }, {
	    key: '_requestData',
	    value: function _requestData(userId, userInceptionId) {
	      var _this3 = this;
	
	      return this.employeeRepositoryService.getEmployee(userId, this.year, userInceptionId).then(function (employee) {
	        _this3._loadData(employee);
	      });
	    }
	  }, {
	    key: '_reloadData',
	    value: function _reloadData(startDate, endDate) {
	      var _this4 = this;
	
	      this._requestData(this.userId, this.userInceptionId).then(function () {
	        _this4.rootScope.$broadcast(_constants.EVENTS.ADD_PERIOD, {
	          startDate: startDate.getMonth(),
	          endDate: endDate
	        });
	      });
	    }
	  }, {
	    key: '_findDelegationActive',
	    value: function _findDelegationActive(delegations) {
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	      this.delegation = this.vacationDelegationService.findDelegationActive(today, delegations);
	      this.isDelegationDateRight = (0, _keys2.default)(this.delegation).length;
	    }
	  }, {
	    key: '_showModalWarningDelegation',
	    value: function _showModalWarningDelegation() {
	      var delegationEmpty = this.helperDelegations.isDelegationEmpty(this.delegation);
	      if (delegationEmpty || this.visitedDelegation) {
	        return;
	      }
	
	      this.modalWarningDelegation.modal('show');
	    }
	  }, {
	    key: 'addEvent',
	    value: function addEvent(_ref) {
	      var startDate = _ref.startDate,
	          endDate = _ref.endDate;
	
	      this._reloadData(startDate, endDate);
	    }
	  }, {
	    key: 'removePeriod',
	    value: function removePeriod(_ref2) {
	      var status = _ref2.status,
	          startDate = _ref2.startDate,
	          endDate = _ref2.endDate;
	
	      if (status === _constants.STATUS_CODE_OK) {
	        this._reloadData(startDate, endDate);
	      }
	    }
	  }, {
	    key: 'selectDay',
	    value: function selectDay(_ref3) {
	      var date = _ref3.date;
	
	      if (this.isWageInProcess) {
	        return;
	      }
	
	      this.startDate = date;
	      this.openRequestHolidayModal();
	    }
	  }, {
	    key: 'onChangeFilters',
	    value: function onChangeFilters(_ref4) {
	      var filters = _ref4.filters;
	
	      this.filters = filters;
	      this.filterPeriods();
	    }
	  }, {
	    key: 'filterPeriods',
	    value: function filterPeriods() {
	      this.currentEmployee.periodInDays = this.filter('filterPeriods')(this.rawPeriodDays, this.filters);
	      this.rootScope.$broadcast(_constants.EVENTS.FILTER_PERIOD);
	    }
	  }, {
	    key: 'onEditPeriod',
	    value: function onEditPeriod($event) {
	      this.startDate = $event.dateDayClicked;
	      this.requestHolidayMode = _constants.MODES.EDIT;
	      this.periodToEdit = $event.period;
	      this.originalPeriod = angular.copy($event.period);
	      this.periodToEdit.startDate = new Date(this.periodToEdit.startDate);
	
	      if (this.periodToEdit.endDate) {
	        this.periodToEdit.endDate = new Date(this.periodToEdit.endDate);
	      }
	
	      this.openRequestHolidayModal();
	    }
	  }, {
	    key: 'openAbsences',
	    value: function openAbsences($event) {
	      this.startDate = $event.dateDayClicked;
	      this.requestModalOpenOn = 'absence';
	      this.openRequestHolidayModal();
	    }
	  }, {
	    key: 'openRequestHolidayModal',
	    value: function openRequestHolidayModal() {
	      var _this5 = this;
	
	      if (!this.requestHolidayMode) {
	        this.requestHolidayMode = _constants.MODES.CREATE;
	      }
	
	      this.timeout(function () {
	        _this5.modalIsInitialized = true;
	        _this5.scope.$apply();
	        _this5.requestModal.modal('show');
	      });
	    }
	  }, {
	    key: 'configRequestHolidayModal',
	    value: function configRequestHolidayModal(modal) {
	      var _this6 = this;
	
	      modal.on('hidden.bs.modal', function () {
	        _this6.modalIsInitialized = false;
	        _this6.timeout(function () {
	          _this6.startDate = '';
	          _this6.requestHolidayMode = _constants.MODES.CREATE;
	          _this6.unSelectActiveDay();
	          delete _this6.requestModalOpenOn;
	          delete _this6.periodToEdit;
	        });
	      });
	    }
	  }, {
	    key: 'unSelectActiveDay',
	    value: function unSelectActiveDay() {
	      var activeDay = angular.element('.datepicker table tr td.active');
	      var activeClass = 'active';
	      activeDay.removeClass(activeClass);
	    }
	  }, {
	    key: 'findPeriod',
	    value: function findPeriod(startDate, endDate) {
	      return this.currentEmployee.periodInDays.find(function (event) {
	        var day = event.day;
	        if (!day) return;
	        var compareDate = new Date(day);
	        return compareDate.getTime() === startDate.getTime() || compareDate.getTime() === endDate.getTime();
	      });
	    }
	  }, {
	    key: 'getManagerClass',
	    value: function getManagerClass() {
	      if ((0, _keys2.default)(this.currentEmployee).length === 0) {
	        return;
	      }
	
	      return {
	        manager: this.currentEmployee.isManager()
	      };
	    }
	  }, {
	    key: 'closeInception',
	    value: function closeInception() {
	      var _this7 = this;
	
	      this.window.history.back();
	      this.timeout(function () {
	        return _this7.scope.$apply();
	      });
	    }
	  }, {
	    key: 'isInception',
	    value: function isInception() {
	      return !!this.userInceptionId;
	    }
	  }, {
	    key: 'getResolution',
	    value: function getResolution() {
	      return this.isTabletResolution() ? 'tablet' : 'desktop';
	    }
	  }, {
	    key: 'isTabletResolution',
	    value: function isTabletResolution() {
	      return this.window.innerWidth <= _constants2.RESOLUTION.DESKTOP;
	    }
	  }, {
	    key: 'setWarnModalDisplayed',
	    value: function setWarnModalDisplayed() {
	      process.isWarnModalBeenDisplayed = true;
	    }
	  }, {
	    key: 'isWarnModalBeenDisplayed',
	    value: function isWarnModalBeenDisplayed() {
	      return process.isWarnModalBeenDisplayed;
	    }
	  }, {
	    key: 'coachmarkIsDismissed',
	    value: function coachmarkIsDismissed(_ref5) {
	      var modalDismissed = _ref5.modalDismissed;
	
	      this.modalsBehaviourService.coachmarkModalDismissed = modalDismissed;
	    }
	  }, {
	    key: 'openModalSchedule',
	    value: function openModalSchedule() {
	      var _this8 = this;
	
	      this.modalScheduleIsVisible = true;
	      this.timeout(function () {
	        return _this8.modalSchedule.modal('show');
	      });
	    }
	  }, {
	    key: 'closeModalSchedule',
	    value: function closeModalSchedule() {
	      var _this9 = this;
	
	      this.timeout(function () {
	        return _this9.modalScheduleIsVisible = false;
	      });
	    }
	  }, {
	    key: 'isModalOpen',
	    value: function isModalOpen() {
	      return {
	        'modal-open': this.modalScheduleIsVisible
	      };
	    }
	  }, {
	    key: 'getMyVacationsCsv',
	    value: function getMyVacationsCsv() {
	      var periodsWithoutHolidays = this.allPeriods.filter(function (period) {
	        return period.type !== _request.Request.TYPES.HOLIDAY;
	      });
	      return this.myVacationsCsv.getMyVacationsCsv(periodsWithoutHolidays);
	    }
	  }, {
	    key: 'getMyVacationsCsvHeader',
	    value: function getMyVacationsCsvHeader() {
	      return this.myVacationsCsv.getMyVacationsCsvHeader();
	    }
	  }, {
	    key: 'paginationPrevious',
	    value: function paginationPrevious() {
	      this.loaded = false;
	      this.year = this.year - 1;
	      this.dateToday.setFullYear(this.year);
	      this.$onInit();
	    }
	  }, {
	    key: 'paginationNext',
	    value: function paginationNext() {
	      this.loaded = false;
	      this.year = this.year + 1;
	      this.dateToday.setFullYear(this.year);
	      this.$onInit();
	    }
	  }, {
	    key: 'showNextArrow',
	    value: function showNextArrow() {
	      var today = new Date();
	      var currentYear = today.getFullYear();
	      var currentDay = today.getDate();
	
	      var isPrevYear = this.isPreviousYear(currentYear);
	      var isEndPeriod = this.endPeriodOfCurrentYear(currentDay, this.dateTodayMonth, currentYear);
	
	      return isPrevYear || isEndPeriod;
	    }
	  }, {
	    key: 'isPreviousYear',
	    value: function isPreviousYear(currentYear) {
	      return this.year < currentYear;
	    }
	  }, {
	    key: 'endPeriodOfCurrentYear',
	    value: function endPeriodOfCurrentYear(currentDay, currentMonth, currentYear) {
	      return this.year !== currentYear ? false : this.isEndOfYearPeriod(currentDay, currentMonth);
	    }
	  }, {
	    key: 'isEndOfYearPeriod',
	    value: function isEndOfYearPeriod(currentDay, currentMonth) {
	      return currentMonth === _constants.NOVEMBER_INDEX && currentDay >= 20 || currentMonth === _constants.DECEMBER_INDEX;
	    }
	  }, {
	    key: 'showPreviousArrow',
	    value: function showPreviousArrow() {
	      var lastAlowedYear = _constants.CALENDAR_LAST_YEAR_PAGINATION_ALLOWED;
	      return this.year !== lastAlowedYear;
	    }
	  }, {
	    key: 'requestModal',
	    get: function get() {
	      var $modal = $(_constants.MODALS.REQUEST);
	
	      if ($modal.length > 0) {
	        this.configRequestHolidayModal($modal);
	      }
	
	      return $modal;
	    }
	  }, {
	    key: 'modalSchedule',
	    get: function get() {
	      return $(_constants.MODALS.CALENDAR_GRID);
	    }
	  }, {
	    key: 'modalWarningDelegation',
	    get: function get() {
	      var _this10 = this;
	
	      var $modal = $(_constants.MODALS.WARNING_DELEGATION_MODAL);
	      $modal.on('hidden.bs.modal', function () {
	        _this10.helperDelegations.setVisitedDelegation(_this10.userId);
	      });
	      return $modal;
	    }
	  }]);
	  return MyVacationsController;
	}();
	
	exports.default = MyVacationsController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1113)))

/***/ }),
/* 1113 */,
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Request = undefined;
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(564);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Request = exports.Request = function () {
	  function Request(type) {
	    (0, _classCallCheck3.default)(this, Request);
	
	    this.type = type;
	  }
	
	  (0, _createClass3.default)(Request, null, [{
	    key: 'getTranslation',
	    value: function getTranslation(key) {
	      var TRANSLATIONS = {};
	      TRANSLATIONS[this.TYPES.VACATION] = 'VACATIONS_ABSENCES.GENERAL.VACATIONS';
	      TRANSLATIONS[this.TYPES.ABSENCE] = 'VACATIONS_ABSENCES.GENERAL.ABSENCES';
	      TRANSLATIONS[this.STATUS_REQUESTED.DELETE] = 'GLOBALS.CANCELLATION';
	      TRANSLATIONS[this.STATUS_REQUESTED.DISCARD] = 'GLOBALS.NOTIFICATION';
	
	      if ((0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(TRANSLATIONS[key])) {
	        return _constants2.HR_ERRORS.DEFAULT_VISIBLE_TEXT;
	      }
	
	      return TRANSLATIONS[key];
	    }
	  }, {
	    key: 'isVacation',
	    value: function isVacation(request) {
	      return request.type === this.TYPES.VACATION;
	    }
	  }, {
	    key: 'isSick',
	    value: function isSick(request) {
	      return _constants.SICKNESS.CODES.indexOf(request.code) > -1;
	    }
	  }, {
	    key: 'isDisplacement',
	    value: function isDisplacement(request) {
	      return _constants.DISPLACEMENT.CODES.indexOf(request.code) > -1;
	    }
	  }, {
	    key: 'isFinishedSick',
	    value: function isFinishedSick(request) {
	      return this.isSick(request) && !request.forcedEndDate;
	    }
	  }, {
	    key: 'isApproved',
	    value: function isApproved(request) {
	      return request.status === this.STATUS.APPROVED;
	    }
	  }, {
	    key: 'isRequested',
	    value: function isRequested(request) {
	      return request.status === this.STATUS.REQUESTED;
	    }
	  }, {
	    key: 'isDeleted',
	    value: function isDeleted(request) {
	      return request.status === this.STATUS.DELETED;
	    }
	  }, {
	    key: 'isHourly',
	    value: function isHourly(request) {
	      return request.hours !== undefined && request.hours !== null && request.hours > 0;
	    }
	  }, {
	    key: 'TYPES',
	    get: function get() {
	      return {
	        VACATION: 'vacation',
	        ABSENCE: 'absence',
	        HOLIDAY: 'holiday'
	      };
	    }
	  }, {
	    key: 'STATUS',
	    get: function get() {
	      return {
	        APPROVED: 'approved',
	        REQUESTED: 'requested',
	        DELETED: 'deleted'
	      };
	    }
	  }, {
	    key: 'STATUS_REQUESTED',
	    get: function get() {
	      return {
	        APPROVE: 'approve',
	        DELETE: 'delete',
	        DISCARD: 'discard'
	      };
	    }
	  }, {
	    key: 'ACTIONS',
	    get: function get() {
	      return {
	        APPROVE: 'approve',
	        REJECT: 'reject'
	      };
	    }
	  }]);
	  return Request;
	}();

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyVacationsCsv = function () {
	  function MyVacationsCsv() {
	    (0, _classCallCheck3.default)(this, MyVacationsCsv);
	  }
	
	  (0, _createClass3.default)(MyVacationsCsv, [{
	    key: 'getMyVacationsCsvHeader',
	    value: function getMyVacationsCsvHeader() {
	      return [// Warning: Headers must be in English, don't translate them
	      'Subject', 'Start date', 'End date'];
	    }
	  }, {
	    key: 'getMyVacationsCsv',
	    value: function getMyVacationsCsv(periods) {
	      return periods.map(this._periodToRow, this);
	    }
	  }, {
	    key: '_periodToRow',
	    value: function _periodToRow(period) {
	      return [this._getEventName(period), this._getEventDate(period.startDate), this._getEventDate(period.endDate)];
	    }
	  }, {
	    key: '_getEventName',
	    value: function _getEventName(period) {
	      var type = period.absenceType || period.vacationType;
	      var category = period.category;
	
	      if (type === category) {
	        return '' + category;
	      }
	
	      return type + '-' + category;
	    }
	  }, {
	    key: '_getEventDate',
	    value: function _getEventDate(date) {
	      var parts = date.split('-');
	      var year = parts[0];
	      var month = parts[1];
	      var day = parts[2];
	      return month + '/' + day + '/' + year;
	    }
	  }]);
	  return MyVacationsCsv;
	}();
	
	exports.default = MyVacationsCsv;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _slashDate = __webpack_require__(605);
	
	var _slashDate2 = _interopRequireDefault(_slashDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var slashDate = (0, _slashDate2.default)();
	
	var VacationScheduleEndDateHelper = function () {
	  VacationScheduleEndDateHelper.$inject = ["startDate", "endDate", "availableVacations"];
	  function VacationScheduleEndDateHelper(startDate, endDate, availableVacations) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, VacationScheduleEndDateHelper);
	    this.startDate = startDate;
	    this.endDate = endDate;
	    this.availableVacations = availableVacations;
	
	    this.dateOfStartDate = new Date(this.startDate);
	    this.dateOfEndDate = new Date(this.endDate);
	    this.modal = angular.element(_constants.MODALS.WARNING_REQUEST_VACATION);
	    this.coachMarkModal = angular.element(_constants.MODALS.COACHMARK);
	  }
	
	  (0, _createClass3.default)(VacationScheduleEndDateHelper, [{
	    key: 'getViewDate',
	    value: function getViewDate() {
	      return slashDate(this.endDate);
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      var _this = this;
	
	      if (!this.shouldBeVisible(this.dateOfStartDate, this.dateOfEndDate, this.availableVacations)) {
	        return false;
	      }
	
	      if (this.coachMarkIsPresent(this.coachMarkModal)) {
	        this.coachMarkModal.on('hidden.bs.modal', function () {
	          return _this.showModal(_this.modal);
	        });
	      } else {
	        this.showModal(this.modal);
	      }
	
	      return true;
	    }
	  }, {
	    key: 'showModal',
	    value: function showModal(modal) {
	      modal.modal('show');
	    }
	  }, {
	    key: 'shouldBeVisible',
	    value: function shouldBeVisible(startDate, endDate) {
	      var today = new Date();
	      endDate.setDate(endDate.getDate() + 1);
	      var dateStarted = today >= startDate;
	      var dateNotPassed = today <= endDate;
	      var todayDateIsInsideThePeriod = dateStarted && dateNotPassed;
	      return todayDateIsInsideThePeriod;
	    }
	  }, {
	    key: 'coachMarkIsPresent',
	    value: function coachMarkIsPresent(coachMarkModal) {
	      return coachMarkModal.hasClass('in');
	    }
	  }]);
	  return VacationScheduleEndDateHelper;
	}();
	
	exports.default = VacationScheduleEndDateHelper;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1118);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./myVacations.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./myVacations.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "my-vacations{display:block}@media print{my-vacations .gutter{display:flex}my-vacations .gutter.modal-open{display:none}}@media(min-width:992px)and (max-width:1199px){my-vacations .container.hpd .col-md-9{width:66.6667%}my-vacations .container.hpd .col-md-3{width:33.33333%}}my-vacations .gutter .my-vacations-header{margin-top:20px;border-bottom:2px solid #eaebed}@media print{my-vacations .gutter .my-vacations-header{display:none}}my-vacations .gutter .my-vacations-header.manager{margin-top:15px}my-vacations .gutter .my-vacations-header h1.title{font-size:24px;font-weight:300;color:#04408f;width:200px;margin:0 auto 5px}my-vacations .gutter .my-vacations-header .close-inception{font-family:ArialMT;font-size:12px;text-transform:uppercase;color:#777676}my-vacations .gutter .my-vacations-header .close-inception .icon{font-size:10px;font-weight:100;display:inline-block;margin-bottom:1px;margin-left:4px;color:#aeaeae}my-vacations .gutter .my-vacations-header .close-inception:hover{background-color:transparent;text-decoration:none}my-vacations .gutter .my-vacations-header .subtitle{font-size:15px;font-weight:400;margin-bottom:43px;color:#666}my-vacations .gutter .my-vacations-header .subtitle.manager{margin-bottom:21px}my-vacations .gutter .my-vacations-header .subtitle-manager{font-size:15px;font-weight:400;position:relative;bottom:10px;left:15px;margin-bottom:43px;color:#666}my-vacations .gutter .my-vacations-header .subtitle-manager avatar-app{position:relative;top:0;margin-right:5px}my-vacations .gutter .my-vacations-header .subtitle-manager .close-btn{position:relative;top:15px;float:right;cursor:pointer}my-vacations .gutter .my-vacations-header .subtitle-manager.manager{margin-top:14px;margin-bottom:12px}my-vacations .gutter .year-title{margin-left:15px;margin-right:15px;user-select:none}my-vacations .gutter .pagination{cursor:pointer;user-select:none}my-vacations .filters-row{margin-top:10px}@media print{my-vacations .filters-row{display:none}}my-vacations .filters-row .filters-main{padding-left:2px}my-vacations .filters-row .filters-sidebar{padding-right:8px;padding-left:20px}@media(max-width:1199px){my-vacations .filters-row .filters-sidebar{padding-right:30px}}my-vacations .holiday-summary-header{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end;-ms-flex-align:center;-moz-align-items:center;align-items:center;padding-right:47px}my-vacations .grid h1{font-family:Stag Sans;font-size:24px;position:relative;margin-top:16px;margin-bottom:20px;padding-right:30px;text-align:center;color:#0072c9}@media print{my-vacations .grid h1{display:none}}@media(max-width:1199px){my-vacations .grid h1{margin-top:18px;margin-bottom:18px;padding-left:32px}}my-vacations .grid .grid-main{padding-right:0}@media print{my-vacations .grid .grid-main{padding-top:30px;width:100%}}my-vacations .grid .grid-sidebar{padding-right:13px;padding-left:16px}@media print{my-vacations .grid .grid-sidebar{display:none}}@media(max-width:1199px){my-vacations .grid .grid-sidebar{padding-right:30px}}my-vacations .grid .grid-sidebar .sidebar-link{font-family:ArialMT;font-size:13px;display:block;margin:7px 20px;text-decoration:none!important;color:#0072c9}my-vacations .grid .grid-sidebar .sidebar-link.first{margin-top:12px;cursor:pointer}my-vacations .grid .grid-sidebar .sidebar-link.second{margin-bottom:7px;cursor:pointer}my-vacations .grid .grid-sidebar .sidebar-link:hover{color:#04408f;background:#fff}my-vacations .grid .grid-sidebar .sidebar-link:focus{outline:0!important}my-vacations .sticky-sidebar{position:sticky;width:263px}my-vacations .sticky-sidebar.sticky{position:fixed;top:0}", ""]);
	
	// exports


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vacationsAbsences = __webpack_require__(1120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VacationScheduleEndDate = function () {
	  VacationScheduleEndDate.$inject = ["$http", "$log"];
	  function VacationScheduleEndDate($http, $log) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, VacationScheduleEndDate);
	    this.http = $http;
	    this.$log = $log;
	  }
	
	  (0, _createClass3.default)(VacationScheduleEndDate, [{
	    key: 'get',
	    value: function get() {
	      return this.http.get(_vacationsAbsences.ENDPOINTS_EMPLOYEE.get.vacationScheduleEndDate).then(function (response) {
	        return response.data;
	      });
	    }
	  }]);
	  return VacationScheduleEndDate;
	}();
	
	exports.default = VacationScheduleEndDate;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ENDPOINTS_MANAGER = exports.ENDPOINTS_EMPLOYEE = undefined;
	
	var _endpoints = __webpack_require__(556);
	
	var API_URL = ("https://dev.autoservicios1.bbva.com/v01");
	var EMPLOYEE_URL = API_URL + '/' + _endpoints.VACATIONS_ABSENCES_URLS.EMPLOYEE_ROOT;
	var MANAGER_URL = API_URL + '/' + _endpoints.VACATIONS_ABSENCES_URLS.MANAGER_ROOT;
	
	var ENDPOINTS_EMPLOYEE = {
	  get: {
	    initial: function initial(employeeId, year) {
	      return EMPLOYEE_URL + '/' + employeeId + '/initial/' + year;
	    },
	    relapses: function relapses(employeeId) {
	      return EMPLOYEE_URL + '/' + employeeId + '/relapses';
	    },
	    vacationScheduleEndDate: EMPLOYEE_URL + '/vacation-schedule-end-date',
	    schedule: function schedule(employeeId) {
	      return EMPLOYEE_URL + '/' + employeeId + '/schedule';
	    }
	  },
	  post: {
	    request: function request(employeeId) {
	      return EMPLOYEE_URL + '/' + employeeId + '/holidays';
	    },
	    medicalParts: function medicalParts(employeeId) {
	      return EMPLOYEE_URL + '/' + employeeId + '/holidays/medical-parts';
	    }
	  },
	  put: {
	    request: function request(employeeId) {
	      return EMPLOYEE_URL + '/' + employeeId + '/holidays';
	    },
	    discharge: function discharge(employeeId) {
	      return EMPLOYEE_URL + '/' + employeeId + '/holidays/discharge';
	    }
	  },
	  delete: {
	    request: function request(employeeId) {
	      return EMPLOYEE_URL + '/' + employeeId + '/holidays';
	    }
	  }
	};
	
	var ENDPOINTS_MANAGER = {
	  get: {
	    initial: function initial(managerId, year) {
	      return MANAGER_URL + '/' + managerId + '/initial/' + year;
	    },
	    initialEmployee: function initialEmployee(userId, userInceptionId, year) {
	      var employeeId = userInceptionId;
	      var managerId = userId;
	      return MANAGER_URL + '/inception/' + managerId + '/initial/' + employeeId + '/' + year;
	    },
	    coincidences: function coincidences(managerId) {
	      return MANAGER_URL + '/' + managerId + '/coincidences';
	    },
	    requests: function requests(managerId) {
	      return MANAGER_URL + '/' + managerId + '/requests';
	    },
	    relapses: function relapses(employeeId, managerId) {
	      return MANAGER_URL + '/inception/' + managerId + '/relapses/' + employeeId;
	    },
	    schedule: function schedule(employeeId, managerId) {
	      return MANAGER_URL + '/inception/' + managerId + '/schedule/' + employeeId;
	    }
	  },
	  post: {
	    request: function request(employeeId, managerId) {
	      return MANAGER_URL + '/inception/' + managerId + '/requests/' + employeeId;
	    },
	    medicalParts: function medicalParts(employeeId, managerId) {
	      return MANAGER_URL + '/inception/' + managerId + '/holidays/medical-parts/' + employeeId;
	    }
	  },
	  put: {
	    request: function request(employeeId, managerId) {
	      return MANAGER_URL + '/inception/' + managerId + '/requests/' + employeeId;
	    },
	    requests: function requests(managerId) {
	      return MANAGER_URL + '/' + managerId + '/requests';
	    },
	    discardRequest: function discardRequest(managerId) {
	      return MANAGER_URL + '/' + managerId + '/requests/discard';
	    },
	    discharge: function discharge(employeeId, managerId) {
	      return MANAGER_URL + '/inception/' + managerId + '/holidays/discharge/' + employeeId;
	    }
	  },
	  delete: {
	    request: function request(employeeId, managerId) {
	      return MANAGER_URL + '/inception/' + managerId + '/requests/' + employeeId;
	    }
	  }
	};
	
	exports.ENDPOINTS_EMPLOYEE = ENDPOINTS_EMPLOYEE;
	exports.ENDPOINTS_MANAGER = ENDPOINTS_MANAGER;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _periodList = __webpack_require__(1122);
	
	var _periodList2 = _interopRequireDefault(_periodList);
	
	var _periodCard = __webpack_require__(1128);
	
	var _periodCard2 = _interopRequireDefault(_periodCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodListModule = angular.module('periodList', [_periodCard2.default]).component('periodList', _periodList2.default).name;
	
	exports.default = periodListModule;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _periodList = __webpack_require__(1123);
	
	var _periodList2 = _interopRequireDefault(_periodList);
	
	var _periodList3 = __webpack_require__(1124);
	
	var _periodList4 = _interopRequireDefault(_periodList3);
	
	__webpack_require__(1126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodListComponent = {
	  restrict: 'E',
	  bindings: {
	    events: '<',
	    filters: '<',
	    format: '<',
	    isMobileApp: '<',
	    onRemovePeriod: '&',
	    onEditPeriod: '&',
	    onAddPeriod: '&',
	    isInception: '<',
	    showWarning: '<'
	  },
	  template: _periodList2.default,
	  controller: _periodList4.default
	};
	
	exports.default = periodListComponent;

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"period-list\" ng-class=\"{responsiveMobile: $ctrl.isMobileApp}\">\n  <div class=\"period-list-header\" ng-if=\"!$ctrl.isMobileApp\">\n    <span class=\"title\">\n      {{'VACATIONS_ABSENCES.PERIOD_LIST.REQUEST_STATUS' | translate}}\n    </span>\n  </div>\n  <div class=\"period-list-body\" ng-class=\"{'pay-period': $ctrl.showWarning}\">\n    <period-card card-id=\"period-card-{{$index}}\"\n                 ng-repeat=\"period in $ctrl.events | filter:'!holiday' | filterPeriods:$ctrl.filters | orderBy :'startDate'\"\n                 period=\"period\"\n                 is-mobile-app=\"$ctrl.isMobileApp\"\n                 is-inception=\"$ctrl.isInception\"\n                 on-remove-period=\"$ctrl.onRemovePeriod({$event: $event})\"\n                 on-edit-period=\"$ctrl.onEditPeriod({$event: $event})\"\n                 on-add-period=\"$ctrl.onAddPeriod({$event: $event})\">\n    </period-card>\n    <div ng-if=\"!$ctrl.isHolidayAbsenceEvents\" class=\"list-empty\">\n      <span class=\"icon-warning\"></span>\n      <span>{{'VACATIONS_ABSENCES.TEAM_REQUESTS.NO_VACATION_REQUEST_MADE' | translate}}</span>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeriodListController = function () {
	  PeriodListController.$inject = ["$scope", "$translate"];
	  function PeriodListController($scope, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PeriodListController);
	    this.scope = $scope;
	    this.translate = $translate;
	    this.hoverDate = 100;
	    this.viewAll = false;
	  }
	
	  (0, _createClass3.default)(PeriodListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.hasEventsToShow();
	
	      this.scope.$watch(function () {
	        return _this.events;
	      }, function () {
	        _this.hasEventsToShow();
	      });
	
	      this.currentList = document.querySelector('.period-list');
	      this._translate();
	
	      if (!this.isMobileApp) {
	        this.scope.$on('period-hover-in', _lodash2.default.debounce(function () {
	          _this.scrollToElement();
	        }, 500, {
	          maxWait: 2000
	        }));
	
	        this.scope.$watch(function () {
	          return _this.format;
	        }, function () {
	          _this.setFormat();
	        });
	      }
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      if (!this.isMobileApp) {
	        this.makeMeSticky();
	      }
	    }
	  }, {
	    key: 'setFormat',
	    value: function setFormat() {
	      this.format === 'tablet' ? $('.period-list').addClass('tablet') : $('.period-list').removeClass('tablet');
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this2 = this;
	
	      this.translate('GLOBALS.BUTTON_ACTION.VIEW_MORE').then(function (translation) {
	        _this2.VIEW_MORE = translation;
	      });
	      this.translate('GLOBALS.BUTTON_ACTION.VIEW_LESS').then(function (translation) {
	        _this2.VIEW_LESS = translation;
	      });
	      this.translate('VACATIONS_ABSENCES.GENERAL.AGREEMENT').then(function (translation) {
	        _this2.AGREEMENT = translation;
	      });
	      this.translate('VACATIONS_ABSENCES.GENERAL.FREE').then(function (translation) {
	        _this2.FREE = translation;
	      });
	      this.translate('VACATIONS_ABSENCES.GENERAL.CHRISTMAS').then(function (translation) {
	        _this2.CHRISTMAS = translation;
	      });
	      this.translate('GLOBALS.DAYS').then(function (translation) {
	        _this2.DIAS = translation;
	      });
	    }
	  }, {
	    key: 'scrollToElement',
	    value: function scrollToElement() {
	      var list = $('.period-list .period-list-body');
	      var card = $('.period-card.hover');
	      var cardOffset = card.offset();
	      if (!cardOffset) return;
	      list.animate({
	        scrollTop: card.offset().top - list.offset().top + list.scrollTop()
	      }, 500);
	    }
	  }, {
	    key: 'makeMeSticky',
	    value: function makeMeSticky() {
	      var _this3 = this;
	
	      var list = document.querySelector('.sticky-sidebar');
	
	      if (!list) return;
	
	      var menuPosition = list.getBoundingClientRect();
	      var placeholder = document.createElement('listPlaceholder');
	      placeholder.style.width = menuPosition.width + 'px';
	      placeholder.style.height = menuPosition.height + 'px';
	      var isAdded = false;
	
	      window.addEventListener('scroll', function () {
	        if (window.pageYOffset >= menuPosition.top && !isAdded && !_this3.viewAll) {
	          list.classList.add('sticky');
	          list.parentNode.insertBefore(placeholder, list);
	          isAdded = true;
	        } else if (window.pageYOffset < menuPosition.top && isAdded) {
	          list.classList.remove('sticky');
	          list.parentNode.removeChild(placeholder);
	          isAdded = false;
	        }
	      });
	    }
	  }, {
	    key: 'hasEventsToShow',
	    value: function hasEventsToShow() {
	      this.isHolidayAbsenceEvents = this.events.some(function (event) {
	        return event.type !== 'holiday';
	      });
	    }
	  }]);
	  return PeriodListController;
	}();
	
	exports.default = PeriodListController;

/***/ }),
/* 1125 */,
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1127);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./periodList.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./periodList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "period-list{display:block}period-list .period-list{position:relative;width:100%;height:auto;max-height:604px;background-color:#fff;border:1px solid #dddfe2}period-list .period-list.responsiveMobile{max-height:none;border:0}period-list .period-list.responsiveMobile .period-list-body{max-height:none;overflow-x:hidden;overflow-y:scroll}period-list .period-list.tablet-body{max-height:339px}period-list .period-list-header{height:62px;padding-left:49px;padding-top:23px;border-bottom:1px solid #dddfe2}period-list .period-list-header .title{width:168px;height:15px;font-family:Stag Sans;font-size:15px;color:#0072c9}period-list .period-list-body{overflow-y:auto;height:auto;max-height:428px}@media(max-height:560px){period-list .period-list-body{max-height:169px}}period-list .period-list-body .list-empty{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;font-family:Stag Sans;font-size:16px;font-weight:400;padding:10px;color:#0072c9}period-list .period-list-body .list-empty .icon-warning{font-size:50px;margin-bottom:10px}.pay-period{max-height:169px}", ""]);
	
	// exports


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _periodCard = __webpack_require__(1129);
	
	var _periodCard2 = _interopRequireDefault(_periodCard);
	
	var _periodCardIcon = __webpack_require__(1149);
	
	var _periodCardIcon2 = _interopRequireDefault(_periodCardIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodCardModule = angular.module('vacations-absences.periodCard', [_periodCardIcon2.default]).component('periodCard', _periodCard2.default).name;
	
	exports.default = periodCardModule;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _periodCard = __webpack_require__(1130);
	
	var _periodCard2 = _interopRequireDefault(_periodCard);
	
	var _periodCard3 = __webpack_require__(1131);
	
	var _periodCard4 = _interopRequireDefault(_periodCard3);
	
	__webpack_require__(1147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodCardComponent = {
	  restrict: 'E',
	  bindings: {
	    period: '<',
	    cardId: '@',
	    isMobileApp: '<',
	    onRemovePeriod: '&',
	    onEditPeriod: '&',
	    onAddPeriod: '&',
	    isInception: '<',
	    readOnly: '<',
	    isTeamCalendarMobile: '<'
	  },
	  template: _periodCard2.default,
	  controller: _periodCard4.default
	};
	
	exports.default = periodCardComponent;

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"period-card {{$ctrl.cardId}} swipe-container\"\n     ng-class=\"$ctrl.getCssClasses()\">\n  <p>\n    <span class=\"type\">{{$ctrl.type | translate}}</span>\n    <span class=\"pending-text\" ng-if=\"$ctrl.isRequested() && !$ctrl.isSick() && !$ctrl.isSickPedingLeave()\">- {{'VACATIONS_ABSENCES.PERIOD_CARD.PENDING_APPROVE' | translate}}</span>\n    <span class=\"pending-text\" ng-if=\"$ctrl.isSickPedingLeave()\">- {{'VACATIONS_ABSENCES.PERIOD_CARD.PENDING_SICK_LEAVE' | translate}}</span>\n    <span class=\"pending-text\" ng-if=\"$ctrl.isDeleted()\">- {{'VACATIONS_ABSENCES.PERIOD_CARD.PENDING_DELETE' | translate}}</span>\n  </p>\n\n  <p class=\"category\">{{$ctrl.category | capitalizeFirst }}</p>\n\n  <p class=\"available-day-type\">{{$ctrl.availableDayType | translate}}&nbsp;</p>\n\n  <period-card-icon status=\"$ctrl.status\"></period-card-icon>\n\n  <p ng-if=\"!$ctrl.period.hours\">\n    <span class=\"start-date\">{{$ctrl.period.startDate | date:'dd/MM/yy'}} -</span> <span class=\"end-date\">{{$ctrl.period.endDate | date:'dd/MM/yy'}} -</span> <span class=\"total\">{{$ctrl.maximumDuration}} {{'GLOBALS.DAYS' | translate}}</span>\n  </p>\n\n  <p ng-if=\"$ctrl.period.hours\">\n    <span class=\"start-date\">{{$ctrl.period.startDate | date:'dd/MM/yy'}} -</span> <span class=\"total\">{{$ctrl.period.hours}} {{'GLOBALS.HOURS' | translate}}</span>\n  </p>\n\n  <div ng-if=\"$ctrl.renderRemarks()\"\n       class=\"remarks\">\n    <span class=\"icon-insight\"></span>\n    <span>{{$ctrl.period.remarks}}</span>\n  </div>\n\n  <div class=\"mobile-buttons-container\" ng-if=\"$ctrl.isMobileApp\" ng-class=\"$ctrl.getMobileButtonsContainerClasses()\">\n    <div class=\"swipe-button remove\"\n         ng-click=\"$ctrl.removePeriod()\"\n         ng-if=\"$ctrl.periodActionsHelper.periodCanBeRemoved()\">\n      <span class=\"icon-cross-white\"></span>\n    </div>\n    <div class=\"swipe-button edit\"\n         ng-click=\"$ctrl.editPeriod()\"\n         ng-if=\"$ctrl.periodActionsHelper.periodCanBeEdited()\">\n      <span class=\"icon-icon-edit\"><span class=\"path1\"></span><span class=\"path2\"></span></span>\n    </div>\n    <div class=\"swipe-button add-absence\"\n         ng-click=\"$ctrl.addPeriod()\"\n         ng-if=\"$ctrl.periodActionsHelper.canInsertAbsence()\">\n      <span class=\"icon-icon-mas\"></span>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _dateUtils = __webpack_require__(1132);
	
	var _availableDayTypes = __webpack_require__(1145);
	
	var _request = __webpack_require__(1114);
	
	var _swipe = __webpack_require__(724);
	
	var _swipe2 = _interopRequireDefault(_swipe);
	
	var _periodActions = __webpack_require__(1146);
	
	var _periodActions2 = _interopRequireDefault(_periodActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeriodCardController = function () {
	  PeriodCardController.$inject = ["$scope", "$timeout", "EventEmitter"];
	  function PeriodCardController($scope, $timeout, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PeriodCardController);
	    this.scope = $scope;
	    this.isHover = false;
	    this.timeout = $timeout;
	    this.eventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(PeriodCardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.type = _request.Request.getTranslation(this.period.type);
	      this.category = this.period.category;
	      this.availableDayType = _availableDayTypes.AvailableDay.getTranslation(this.period.availableDayType);
	      this.status = this.period.status;
	      this.code = this.period.code;
	      this.maximumDuration = this.period.maximumDuration || this.period.duration;
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      var _this = this;
	
	      if (this.readOnly) {
	        return;
	      }
	
	      if (this.isMobileApp) {
	        this.periodActionsHelper = new _periodActions2.default(this.period, this.isInception);
	
	        if (this.periodActionsHelper.available()) {
	          this.timeout(function () {
	            _this.numberOfSwipeButtons = _this.getNumberOfSwipeButtons();
	            _this.initSwipe();
	          });
	        }
	      } else {
	        this.initHoverListener();
	      }
	    }
	  }, {
	    key: 'initSwipe',
	    value: function initSwipe() {
	      var _this2 = this;
	
	      var swiper = new _swipe2.default(this.getPeriodCardIdSelector());
	      swiper.onLeft(function (event) {
	        return _this2.onSwipeLeft(event);
	      });
	      swiper.onRight(function (event) {
	        return _this2.onSwipeRight(event);
	      });
	      swiper.run();
	    }
	  }, {
	    key: 'getPeriodCardIdSelector',
	    value: function getPeriodCardIdSelector() {
	      return 'period-card .' + this.cardId;
	    }
	  }, {
	    key: 'onSwipeRight',
	    value: function onSwipeRight() {
	      var _this3 = this;
	
	      this.timeout(function () {
	        _this3.swiped = false;
	      });
	    }
	  }, {
	    key: 'onSwipeLeft',
	    value: function onSwipeLeft() {
	      var _this4 = this;
	
	      this.timeout(function () {
	        _this4.swiped = true;
	      });
	    }
	  }, {
	    key: 'getNumberOfSwipeButtons',
	    value: function getNumberOfSwipeButtons() {
	      var numberOfSwipeButtons = 0;
	
	      if (this.periodActionsHelper.canInsertAbsence()) {
	        numberOfSwipeButtons++;
	      }
	
	      if (this.periodActionsHelper.periodCanBeRemoved()) {
	        numberOfSwipeButtons++;
	      }
	
	      if (this.periodActionsHelper.periodCanBeEdited()) {
	        numberOfSwipeButtons++;
	      }
	
	      return numberOfSwipeButtons;
	    }
	  }, {
	    key: 'initHoverListener',
	    value: function initHoverListener() {
	      var _this5 = this;
	
	      this.scope.$on('period-hover-in', function (event, args) {
	        if ((0, _dateUtils.findPeriodOfDate)(args.date, _this5.period.startDate, _this5.period.endDate)) {
	          _this5.isHover = true;
	          _this5.scope.$apply();
	        }
	      });
	
	      this.scope.$on('period-hover-out', function () {
	        _this5.isHover = false;
	        _this5.scope.$apply();
	      });
	    }
	  }, {
	    key: 'isRequested',
	    value: function isRequested() {
	      return this.status === _request.Request.STATUS.REQUESTED;
	    }
	  }, {
	    key: 'isSickPedingLeave',
	    value: function isSickPedingLeave() {
	      var posibleSicks = ['ENF', 'ACC', 'ANL'];
	      var sick = posibleSicks.includes(this.code);
	
	      return sick && this.status === _request.Request.STATUS.REQUESTED;
	    }
	  }, {
	    key: 'isDeleted',
	    value: function isDeleted() {
	      return this.status === _request.Request.STATUS.DELETED;
	    }
	  }, {
	    key: 'getCssClasses',
	    value: function getCssClasses() {
	      var classes = [this.period.type];
	
	      if (this.isHover) {
	        classes.push('hover');
	      }
	
	      if (this.isMobileApp) {
	        classes.push('responsiveMobile');
	      }
	
	      if (this.renderRemarks()) {
	        classes.push('remarks');
	      }
	
	      if (this.swiped) {
	        classes.push('swiped');
	
	        if (this.numberOfSwipeButtons === 1) {
	          classes.push('swiped-one-button');
	        }
	      }
	
	      return classes;
	    }
	  }, {
	    key: 'getMobileButtonsContainerClasses',
	    value: function getMobileButtonsContainerClasses() {
	      var classes = [];
	
	      if (this.numberOfSwipeButtons === 1) {
	        classes.push('one-button');
	      }
	
	      return classes;
	    }
	  }, {
	    key: 'removePeriod',
	    value: function removePeriod() {
	      this.swiped = false;
	      this.onRemovePeriod(this.eventEmitter({ period: this.period }));
	    }
	  }, {
	    key: 'editPeriod',
	    value: function editPeriod() {
	      this.swiped = false;
	
	      this.onEditPeriod(this.eventEmitter({ period: this.period }));
	    }
	  }, {
	    key: 'addPeriod',
	    value: function addPeriod() {
	      this.swiped = false;
	      this.onAddPeriod(this.eventEmitter({ startDate: this.period.startDate }));
	    }
	  }, {
	    key: 'renderRemarks',
	    value: function renderRemarks() {
	      return this.period.remarks && this.isTeamCalendarMobile;
	    }
	  }]);
	  return PeriodCardController;
	}();
	
	exports.default = PeriodCardController;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseLocalDate = exports.areEqualDates = exports.formatDateForView = exports.isWeekDay = exports.isIconDay = exports.formatDate = exports.findPeriodOfDate = exports.returnIconDays = exports.fromRangeToArray = undefined;
	
	var _slicedToArray2 = __webpack_require__(1133);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1142);
	
	var _calendarRender = __webpack_require__(1143);
	
	var _request = __webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SUN = 7;
	var HOLIDAY = 'holiday';
	
	function fromRangeToArray(rangeStart, rangeEnd, status, periodId, type, code, iconDays) {
	  var start = (0, _moment2.default)(rangeStart, 'YYYY-MM-DD').startOf('day');
	  var end = (0, _moment2.default)(rangeEnd, 'YYYY-MM-DD').endOf('day');
	  var itr = _moment2.default.twix(start, end).iterate('days');
	
	  var range = [];
	  while (itr.hasNext()) {
	    var day = itr.next();
	    var iconDay = isIconDay(day, iconDays);
	    var html = (0, _calendarRender.getHTML)(day, status, iconDay, iconDays, rangeEnd, type, code);
	    var backupType = type;
	
	    var startEqual = areEqualDates(new Date(rangeStart), day.toDate());
	    var endEqual = areEqualDates(new Date(rangeEnd), day.toDate());
	
	    if (startEqual && backupType !== HOLIDAY) {
	      type += ' start-period';
	    }
	
	    if (endEqual && backupType !== HOLIDAY) {
	      type += ' end-period';
	    }
	
	    range.push({
	      day: day.toDate(),
	      periodId: periodId,
	      status: status,
	      type: type,
	      code: code,
	      html: {
	        classes: type,
	        content: html
	      }
	    });
	
	    type = backupType;
	  }
	
	  return range;
	}
	
	function areEqualDates(firstDate, secondDate) {
	  firstDate.setHours(0, 0, 0, 0);
	  secondDate.setHours(0, 0, 0, 0);
	  return firstDate.getTime() === secondDate.getTime();
	}
	
	function isIconDay(day, iconDays) {
	  return iconDays.some(function (iconDay) {
	    return iconDay.getTime() === day.toDate().getTime();
	  });
	}
	
	function returnIconDays(arrayWithEvents) {
	  var iconDays = [];
	
	  arrayWithEvents.forEach(function (event) {
	    if (event.type === _request.Request.TYPES.HOLIDAY) return;
	
	    var iconDay = void 0;
	    setEventEndDate(event);
	
	    var start = (0, _moment2.default)(event.startDate, 'YYYY-MM-DD').startOf('day');
	    var end = (0, _moment2.default)(event.endDate, 'YYYY-MM-DD').endOf('day');
	    var itr = _moment2.default.twix(start, end).iterate('days');
	
	    iconDays.push((0, _moment2.default)(event.endDate)._d);
	
	    while (itr.hasNext()) {
	      var day = itr.next();
	      iconDay = day;
	
	      if (!isWeekDay(day)) break;
	    }
	
	    if (iconDay) iconDays.push(iconDay._d);
	  });
	
	  return iconDays;
	}
	
	function setEventEndDate(event) {
	  if (event.endDate || event.date) {
	    event.endDate = event.endDate || event.date;
	  } else {
	    event.endDate = new Date();
	    event.forcedEndDate = true;
	  }
	}
	
	function findPeriodOfDate(date, rangeStart, rangeEnd) {
	  var start = (0, _moment2.default)(rangeStart, 'YYYY-MM-DD').startOf('day');
	  var end = (0, _moment2.default)(rangeEnd, 'YYYY-MM-DD').endOf('day');
	  var current = (0, _moment2.default)(date, 'YYYY-MM-DD').startOf('day');
	  var period = _moment2.default.twix(start, end);
	  return current.twix(current).overlaps(period);
	}
	
	function isWeekDay(date) {
	  if (date.isoWeekday() !== SUN) {
	    return date;
	  }
	  return false;
	}
	
	function formatDate(date) {
	  var d = new Date(date);
	  var month = '' + (d.getMonth() + 1);
	  var day = '' + d.getDate();
	  var year = d.getFullYear();
	
	  if (month.length < 2) month = '0' + month;
	  if (day.length < 2) day = '0' + day;
	
	  return [year, month, day].join('-');
	}
	
	function parseLocalDate(date) {
	  if (!date) return null;
	  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
	    var _date$split$map = date.split('-').map(Number),
	        _date$split$map2 = (0, _slicedToArray3.default)(_date$split$map, 3),
	        y = _date$split$map2[0],
	        m = _date$split$map2[1],
	        _d = _date$split$map2[2];
	
	    return new Date(y, m - 1, _d);
	  }
	  var d = new Date(date);
	  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
	}
	
	/**
	 * Returns a date in a long format. Only for presentation purposes.
	 * Example: Given a 2017-08-08, returns 'Martes 08 agosto 2017'
	 *
	 * @param {date} date - String or Date object
	 * @param {locale} locale - Language, default spanish
	 * @returns {String} Returns a formatted string
	 */
	function formatDateForView(date) {
	  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
	
	  _moment2.default.locale(lang);
	  var result = (0, _moment2.default)(date).format('dddd DD MMMM YYYY');
	  result = result.charAt(0).toUpperCase() + result.slice(1);
	  return result;
	}
	
	exports.fromRangeToArray = fromRangeToArray;
	exports.returnIconDays = returnIconDays;
	exports.findPeriodOfDate = findPeriodOfDate;
	exports.formatDate = formatDate;
	exports.isIconDay = isIconDay;
	exports.isWeekDay = isWeekDay;
	exports.formatDateForView = formatDateForView;
	exports.areEqualDates = areEqualDates;
	exports.parseLocalDate = parseLocalDate;

/***/ }),
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHTML = undefined;
	
	var _constants = __webpack_require__(598);
	
	var _calendar = __webpack_require__(1144);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var APPROVED = 'approved';
	var SHOULD_PAINT_ALWAYS = 1;
	
	function getHTML(day, status, isIconDay, iconDays, rangeEnd, type, code) {
	  rangeEnd = (0, _moment2.default)(rangeEnd).format('YYYY-MM-DD');
	  var isSickChecker = _checkIfIsSickness(rangeEnd, day, code);
	  return _buildHtml(isIconDay, day, status, rangeEnd, iconDays, isSickChecker);
	}
	
	function _checkIfIsSickness(rangeEnd, day, code) {
	  var today = new Date();
	  var isSickness = _constants.SICKNESS.CODES.indexOf(code) > -1;
	  var rangeEndIsToday = rangeEnd === (0, _moment2.default)(today).format('YYYY-MM-DD') && day.format('YYYY-MM-DD') === (0, _moment2.default)(today).format('YYYY-MM-DD');
	  return isSickness && rangeEndIsToday;
	}
	
	function _buildHtml(isIconDay, day, status, rangeEnd, iconDays, isSickChecker) {
	  var htmlEndDate = _getPaintCase(day, rangeEnd, iconDays, isSickChecker);
	  day = day.format('DD');
	  var html = void 0;
	  if (isIconDay) {
	    html = _paintIcon(status, day);
	  } else {
	    html = day;
	  }
	  return htmlEndDate + html;
	}
	
	function _getPaintCase(day, rangeEnd, iconDays, isSickChecker) {
	  var ALWAYS_PAINT_CASE = _caseShouldAlwaysPaint(iconDays, day, isSickChecker);
	  return day._d.getTime() === (0, _moment2.default)(rangeEnd)._d.getTime() ? ALWAYS_PAINT_CASE && !isSickChecker ? _calendar.DIV_LAST_DAY : _calendar.DIV_ALWAYS_PAINT : '';
	}
	
	function _paintIcon(status, date) {
	  var iconHtml = status === APPROVED ? _calendar.ICON_APPROVED_HTML : _calendar.ICON_REQUESTED_HTML;
	  return date + iconHtml;
	}
	
	function _caseShouldAlwaysPaint(iconDays, day, isSickChecker) {
	  if (isSickChecker) return true;
	  var count = getIconDayRepeated(iconDays, day);
	  return count === SHOULD_PAINT_ALWAYS;
	}
	
	function getIconDayRepeated(iconDays, day) {
	  var count = 0;
	  iconDays.forEach(function (dayToCompare) {
	    if (day._d.getTime() === dayToCompare.getTime()) {
	      count++;
	    }
	  });
	  return count;
	}
	
	exports.getHTML = getHTML;

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ICON_APPROVED_HTML = exports.ICON_APPROVED_HTML = '<span class="icon-approved"><span class="path1"></span><span class="path2"></span></span>';
	var ICON_REQUESTED_HTML = exports.ICON_REQUESTED_HTML = '<span class="icon-requested"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>';
	var DIV_ALWAYS_PAINT = exports.DIV_ALWAYS_PAINT = '<div class="always-paint">';
	var DIV_LAST_DAY = exports.DIV_LAST_DAY = '<div class="last-day">';

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AvailableDay = undefined;
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvailableDay = exports.AvailableDay = function () {
	  function AvailableDay() {
	    (0, _classCallCheck3.default)(this, AvailableDay);
	  }
	
	  (0, _createClass3.default)(AvailableDay, null, [{
	    key: 'getTranslation',
	    value: function getTranslation(key) {
	      var TRANSLATIONS = {};
	      TRANSLATIONS[this.TYPES.AGREEMENT] = 'VACATIONS_ABSENCES.GENERAL.AGREEMENT';
	      TRANSLATIONS[this.TYPES.FREE] = 'VACATIONS_ABSENCES.GENERAL.FREE';
	      TRANSLATIONS[this.TYPES.CHRISTMAS] = 'VACATIONS_ABSENCES.GENERAL.CHRISTMAS';
	
	      return TRANSLATIONS[key];
	    }
	  }, {
	    key: 'TYPES',
	    get: function get() {
	      return {
	        AGREEMENT: 'AGREEMENT',
	        FREE: 'FREE',
	        CHRISTMAS: 'CHRISTMAS'
	      };
	    }
	  }]);
	  return AvailableDay;
	}();

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(598);
	
	var _request = __webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeriodActionsHelper = function () {
	  function PeriodActionsHelper(period, isInception) {
	    (0, _classCallCheck3.default)(this, PeriodActionsHelper);
	
	    this.period = period;
	    this.isInception = isInception;
	  }
	
	  (0, _createClass3.default)(PeriodActionsHelper, [{
	    key: 'available',
	    value: function available() {
	      if (!this.period) {
	        return false;
	      }
	
	      return this.canInsertAbsence() || this.periodCanBeEdited() || this.periodCanBeRemoved();
	    }
	  }, {
	    key: 'canInsertAbsence',
	    value: function canInsertAbsence() {
	      return _request.Request.isApproved(this.period) && !(this.period.code === _constants.SICKNESS.CODES[1] || this.period.code === _constants.SICKNESS.CODES[2]);
	    }
	  }, {
	    key: 'periodCanBeEdited',
	    value: function periodCanBeEdited() {
	      var isNotSickness = _constants.SICKNESS.CODES.indexOf(this.period.code) === -1;
	      var finishedPeriod = (0, _moment2.default)().isAfter(this.period.endDate);
	
	      if (isNotSickness && finishedPeriod) {
	
	        return false;
	      }
	
	      if (this.isVacationOnInception()) {
	        return false;
	      }
	
	      if (this.isInception) {
	        return _request.Request.isRequested(this.period) && (this.period.code === _constants.SICKNESS.CODES[1] || this.period.code === _constants.SICKNESS.CODES[2]);
	      }
	
	      return _request.Request.isRequested(this.period);
	    }
	  }, {
	    key: 'periodCanBeRemoved',
	    value: function periodCanBeRemoved() {
	      var approvedOrRequested = _request.Request.isRequested(this.period) || _request.Request.isApproved(this.period);
	      var isSick = _request.Request.isSick(this.period);
	      return approvedOrRequested && !isSick && !this.isInception;
	    }
	  }, {
	    key: 'isFinishedSickPeriod',
	    value: function isFinishedSickPeriod() {
	      return _request.Request.isFinishedSick(this.period) && _request.Request.isApproved(this.period);
	    }
	  }, {
	    key: 'isVacationOnInception',
	    value: function isVacationOnInception() {
	      return _request.Request.isVacation(this.period) && this.isInception;
	    }
	  }]);
	  return PeriodActionsHelper;
	}();
	
	exports.default = PeriodActionsHelper;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1148);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./periodCard.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./periodCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "period-card{display:block}period-card:not(:last-child){border-bottom:1px solid #dddfe2}period-card .period-card{height:84px;padding-top:5px;padding-left:26px;background-color:#fff;position:relative;border-left:7px solid transparent}period-card .period-card.responsiveMobile{transition:all .5s ease;cursor:pointer;left:0;-webkit-backface-visibility:hidden!important}period-card .period-card.responsiveMobile.remarks{height:auto}period-card .period-card.responsiveMobile.vacation{border-color:#52bcec}period-card .period-card.responsiveMobile.vacation.hover,period-card .period-card.responsiveMobile.vacation:hover{background-color:#fff}period-card .period-card.responsiveMobile.vacation.hover p,period-card .period-card.responsiveMobile.vacation:hover p{color:#666}period-card .period-card.responsiveMobile.absence{border-color:#fdbd2c}period-card .period-card.responsiveMobile.absence.hover,period-card .period-card.responsiveMobile.absence:hover{background-color:#fff}period-card .period-card.responsiveMobile:hover .pending-text{font-weight:300}period-card .period-card.responsiveMobile.swiped{left:-160px}period-card .period-card.responsiveMobile.swiped-one-button{left:-80px}period-card .period-card.responsiveMobile.swiped-one-button .mobile-buttons-container{right:-80px}period-card .period-card.responsiveMobile .remarks{font-size:10px;color:#0072c9;padding-bottom:5px}period-card .period-card.responsiveMobile .mobile-buttons-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;position:absolute;top:0;right:-160px;min-height:84px}period-card .period-card.responsiveMobile .mobile-buttons-container.one-button{right:-80px}period-card .period-card.responsiveMobile .mobile-buttons-container .swipe-button{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;width:80px;height:84px}period-card .period-card.responsiveMobile .mobile-buttons-container .swipe-button.remove{background:#eaebed}period-card .period-card.responsiveMobile .mobile-buttons-container .swipe-button.remove span:before{color:#c8175e!important}period-card .period-card.responsiveMobile .mobile-buttons-container .swipe-button.add-absence{background:#0072c9}period-card .period-card.responsiveMobile .mobile-buttons-container .swipe-button.add-absence span{font-size:18px}period-card .period-card.responsiveMobile .mobile-buttons-container .swipe-button.edit{background:#0072c9}period-card .period-card.responsiveMobile .mobile-buttons-container .swipe-button.edit span{font-size:18px}period-card .period-card p{margin:0;font-family:Stag Sans;color:#666}period-card .period-card p.available-day-type,period-card .period-card p.category{font-size:14px;font-weight:300;line-height:16px;width:75%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}period-card .period-card .type{font-size:15px;font-weight:400}period-card .period-card .pending-text{font-size:11px;font-weight:300;position:relative;bottom:1px}period-card .period-card .end-date,period-card .period-card .start-date,period-card .period-card .total{font-size:12px;font-weight:300;line-height:24px}period-card .period-card .total{font-weight:500;text-transform:lowercase}period-card .period-card.vacation{border-color:#52bcec}period-card .period-card.vacation.hover,period-card .period-card.vacation:hover{background-color:#52bcec}period-card .period-card.vacation.hover p,period-card .period-card.vacation:hover p{color:#fff}period-card .period-card.absence{border-color:#fdbd2c}period-card .period-card.absence.hover,period-card .period-card.absence:hover{background-color:#fdbd2c}period-card .period-card:hover .pending-text{font-weight:400}", ""]);
	
	// exports


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _periodCardIcon = __webpack_require__(1150);
	
	var _periodCardIcon2 = _interopRequireDefault(_periodCardIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodCardIconModule = angular.module('vacations-absences.periodCardIcon', []).component('periodCardIcon', _periodCardIcon2.default).name;
	
	exports.default = periodCardIconModule;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _periodCardIcon = __webpack_require__(1151);
	
	var _periodCardIcon2 = _interopRequireDefault(_periodCardIcon);
	
	var _periodCardIcon3 = __webpack_require__(1152);
	
	var _periodCardIcon4 = _interopRequireDefault(_periodCardIcon3);
	
	__webpack_require__(1153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodCardIconComponent = {
	  restrict: 'E',
	  bindings: {
	    status: '<'
	  },
	  template: _periodCardIcon2.default,
	  controller: _periodCardIcon4.default
	};
	
	exports.default = periodCardIconComponent;

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	module.exports = "<span class=\"period-card-icon\" ng-show=\"$ctrl.isApproved()\">\n  <span class=\"icon-approved\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></span>\n</span>\n<span class=\"period-card-icon\" ng-show=\"$ctrl.isRequested()\">\n  <span class=\"icon-requested\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></span>\n</span>\n"

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _request = __webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeriodCardIconController = function () {
	  function PeriodCardIconController() {
	    (0, _classCallCheck3.default)(this, PeriodCardIconController);
	  }
	
	  (0, _createClass3.default)(PeriodCardIconController, [{
	    key: 'isRequested',
	    value: function isRequested() {
	      return this.status === _request.Request.STATUS.REQUESTED || this.status === _request.Request.STATUS.DELETED;
	    }
	  }, {
	    key: 'isApproved',
	    value: function isApproved() {
	      return this.status === _request.Request.STATUS.APPROVED;
	    }
	  }]);
	  return PeriodCardIconController;
	}();
	
	exports.default = PeriodCardIconController;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1154);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./periodCardIcon.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./periodCardIcon.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "period-card-icon{display:block}period-card-icon .period-card-icon{float:none;top:calc(50% - 10px);position:absolute;right:20px;font-size:20px}", ""]);
	
	// exports


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myVacationsMobile = __webpack_require__(1156);
	
	var _myVacationsMobile2 = _interopRequireDefault(_myVacationsMobile);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _periodListLink = __webpack_require__(1161);
	
	var _periodListLink2 = _interopRequireDefault(_periodListLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myVacationsMobileModule = angular.module('vacations-absences.myVacationsMobile', [_angularUiRouter2.default, _periodListLink2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE, {
	    url: _routes.ROUTES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE,
	    component: 'myVacationsMobile',
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).component('myVacationsMobile', _myVacationsMobile2.default).name;
	
	exports.default = myVacationsMobileModule;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myVacationsMobile = __webpack_require__(1157);
	
	var _myVacationsMobile2 = _interopRequireDefault(_myVacationsMobile);
	
	var _myVacationsMobile3 = __webpack_require__(1158);
	
	var _myVacationsMobile4 = _interopRequireDefault(_myVacationsMobile3);
	
	__webpack_require__(1159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myVacationsMobileComponent = {
	  restrict: 'E',
	  bindings: {
	    userInceptionId: '<',
	    onClickPeriodMobileListLink: '&'
	  },
	  template: _myVacationsMobile2.default,
	  controller: _myVacationsMobile4.default
	};
	
	exports.default = myVacationsMobileComponent;

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	module.exports = "<modal-request\n  user-id=\"$ctrl.userId\"\n  start-date=\"$ctrl.startDate\"\n  user-inception-id=\"$ctrl.userInceptionId\"\n  mode=\"$ctrl.requestHolidayMode\"\n  vacation-period-count=\"$ctrl.vacationCount\"\n  add-event=\"$ctrl.addEvent($event);\"\n  is-inception=\"$ctrl.isInception()\"\n  request-type=\"$ctrl.requestType\"\n  is-mobile-app=\"$ctrl.isMobileApp\"\n  reload-modal=\"$ctrl.reopenModalAfterFail()\">\n</modal-request>\n\n<modal-warning-delegation is-mobile-app=\"$ctrl.isMobileApp\"\n                          title-body=\"{{ 'VACATIONS_ABSENCES.MAIN.WARNING_DELEGATION_TITLE' | translate }}\"\n                          delegation=\"$ctrl.delegation\"\n                          url-destination=\"$ctrl.urlDestination\">\n</modal-warning-delegation>\n\n<warning-request-vacation is-mobile-app=\"$ctrl.isMobileApp\"\n                          ng-if=\"!$ctrl.isWarnModalBeenDisplayed()\"\n                          date=\"$ctrl.vacationScheduleEndDate\"\n                          on-dismiss=\"$ctrl.setWarnModalDisplayed()\">\n</warning-request-vacation>\n\n<div class=\"container hpd animation-appear\"\n     ng-class=\"$ctrl.getClasses()\"\n     ng-if=\"$ctrl.loaded\"\n     pull-to-refresh=\"$ctrl.$onInit()\">\n\n  <div class=\"my-vacations-wrapper\">\n\n    <div class=\"calendar-container\"\n         ng-class=\"{'is-inception': $ctrl.isInception()}\"\n         ng-click=\"$ctrl.hideChoicesButtons()\">\n\n      <calendar-grid\n        loaded=\"$ctrl.loaded\"\n        events-dates=\"$ctrl.eventsDates\"\n        user=\"$ctrl.currentEmployee\"\n        is-inception=\"$ctrl.isInception()\"\n        is-mobile-app=\"$ctrl.isMobileApp\"\n        date-today=\"$ctrl.dateToday\"\n        on-click-previous=\"$ctrl.paginationPrevious()\"\n        on-click-next=\"$ctrl.paginationNext()\">\n      </calendar-grid>\n\n    </div>\n\n    <div class=\"request-status-container animate-block\"\n         ng-hide=\"$ctrl.openChoicesButtons\"\n         ng-if=\"$ctrl.loadedCalendarGrid\">\n        <period-list-link user-inception-id=\"$ctrl.userInceptionId\"\n                          on-click-period-mobile-list-link=\"$ctrl.onClickPeriodMobileListLink()\"\n                          date-to-load=\"$ctrl.dateToday\">\n        </period-list-link>\n    </div>\n\n    <div ng-if=\"!$ctrl.isInception() && $ctrl.loadedCalendarGrid\"\n         ng-hide=\"$ctrl.openChoicesButtons\"\n         class=\"available-days-container animate-block\">\n\n      <holiday-summary class=\"holiday-summary-header\"\n                       pending-days=\"$ctrl.availableVacations.pendingDays\"\n                       own-days=\"$ctrl.availableVacations.ownDays\"\n                       christmas-days=\"$ctrl.availableVacations.christmasDays\"\n                       last-year=\"$ctrl.availableVacations.lastYear\"\n                       is-inception=\"$ctrl.isInception()\"\n                       is-manager=\"$ctrl.currentEmployee.isManager()\"\n                       inserted-in=\"header\"\n                       is-mobile-app=\"$ctrl.isMobileApp\">\n      </holiday-summary>\n    </div>\n\n    <floating-action-buttons\n      ng-if=\"!$ctrl.isInception()\"\n      buttons=\"$ctrl.floatingActionButtons\"\n      on-click-first-button=\"$ctrl.toggleButtons()\"\n      ng-class=\"$ctrl.getFloatingClass()\"\n      is-choices-open=\"$ctrl.openChoicesButtons\">\n    </floating-action-buttons>\n\n    <floating-action-buttons\n      ng-if=\"!$ctrl.isInception()\"\n      class=\"choices-buttons animate-button\"\n      buttons=\"$ctrl.choicesFloatingActionButtons\"\n      on-click-first-button=\"$ctrl.requestAbsences()\"\n      on-click-second-button=\"$ctrl.requestVacations()\"\n      ng-show=\"$ctrl.openChoicesButtons\">\n    </floating-action-buttons>\n\n    <floating-action-buttons ng-if=\"$ctrl.isInception()\"\n                             buttons=\"$ctrl.inceptionFloatingActionButtons\"\n                             on-click-first-button=\"$ctrl.requestAbsences()\">\n    </floating-action-buttons>\n\n  </div>\n\n  <warn-last-day ng-if=\"$ctrl.modalsBehaviourService.warnLastDayShouldBeVisible\"\n                 ng-hide=\"$ctrl.openChoicesButtons\"\n                 ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\"\n                 is-mobile-app=\"$ctrl.isMobileApp\"\n                 date=\"$ctrl.vacationScheduleEndDate\">\n  </warn-last-day>\n\n</div>\n"

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _request = __webpack_require__(1114);
	
	var _constants = __webpack_require__(598);
	
	var _vacationScheduleEndDate = __webpack_require__(1116);
	
	var _vacationScheduleEndDate2 = _interopRequireDefault(_vacationScheduleEndDate);
	
	var _states = __webpack_require__(565);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyVacationsMobileController = function () {
	  MyVacationsMobileController.$inject = ["$scope", "$rootScope", "$timeout", "$window", "$q", "$log", "vacationEmployeeRepositoryService", "vacationUserDataService", "VacationScheduleEndDateService", "loadingMobileService", "vacationDelegationService", "HelperDelegationsService", "modalsBehaviourService", "ManagerForEmployeeService"];
	  function MyVacationsMobileController($scope, $rootScope, $timeout, $window, $q, $log, vacationEmployeeRepositoryService, vacationUserDataService, VacationScheduleEndDateService, loadingMobileService, vacationDelegationService, HelperDelegationsService, modalsBehaviourService, ManagerForEmployeeService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyVacationsMobileController);
	    this.scope = $scope;
	    this.rootScope = $rootScope;
	    this.timeout = $timeout;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.window = $window;
	    this.q = $q;
	    this.log = $log;
	
	    this.vacationDelegationService = vacationDelegationService;
	    this.modalsBehaviourService = modalsBehaviourService;
	    this.helperDelegations = HelperDelegationsService;
	    this.UserDataService = vacationUserDataService;
	    this.employeeRepositoryService = vacationEmployeeRepositoryService;
	    this.ManagerForEmployeeService = ManagerForEmployeeService;
	    this.VacationScheduleEndDateService = VacationScheduleEndDateService;
	    this.loadingMobileService = loadingMobileService;
	
	    this.dateToday = new Date();
	    this.year = this.dateToday.getFullYear();
	    this.loaded = false;
	    this.currentEmployee = {};
	    this.openChoicesButtons = false;
	    this.dayIsSelected = false;
	    this.delegation = {};
	    this.startDate = '';
	  }
	
	  (0, _createClass3.default)(MyVacationsMobileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userId = this.UserDataService.getEmployee().userId;
	      this.urlDestination = _states.STATES.VACATIONS_ABSENCES.DELEGATE;
	
	      this.loadingMobileService.show();
	      var promises = {
	        employee: this.employeeRepositoryService.getEmployee(this.userId, this.year, this.userInceptionId),
	        schedule: this.VacationScheduleEndDateService.get(),
	        delegations: this.vacationDelegationService.getDelegations(this.userId)
	      };
	      this.q.all(promises).then(function (responses) {
	        _this._loadData(responses.employee);
	        _this._initVacationSchedule(responses.schedule);
	        _this._initDelegations(responses.delegations);
	      }, function (error) {
	        _this.log.error('MyVacationsMobileController $onInit()', error);
	      }).finally(function () {
	        _this.loadingMobileService.hide();
	      });
	
	      this.initFloatingActionButtons();
	
	      this.modalsBehaviourService.reset();
	      this.visitedDelegation = this.helperDelegations.getVisitDelegation(this.userId);
	    }
	  }, {
	    key: '_loadData',
	    value: function _loadData(employee) {
	      var _this2 = this;
	
	      this.currentEmployee = employee;
	      this.rawPeriodDays = employee.periodInDays;
	      this.user = employee.getProfile();
	      this.availableVacations = employee.availableVacations;
	      this.vacationCount = employee.getAgreementVacationCount();
	      this.allPeriods = employee.allPeriods;
	      this.loaded = true;
	      this.loadedCalendarGrid = false;
	      this.timeout(function () {
	        _this2.loadedCalendarGrid = true;
	      }, 200);
	    }
	  }, {
	    key: '_initVacationSchedule',
	    value: function _initVacationSchedule(schedule) {
	      this.vacationScheduleEndDateHelper = new _vacationScheduleEndDate2.default(schedule.startDate, schedule.endDate, this.availableVacations);
	      this.modalsBehaviourService.warnLastDayShouldBeVisible = this.vacationScheduleEndDateHelper.start();
	      this.vacationScheduleEndDate = this.vacationScheduleEndDateHelper.getViewDate();
	    }
	  }, {
	    key: '_initDelegations',
	    value: function _initDelegations(delegations) {
	      this._findDelegationActive(delegations);
	      this._showModalWarningDelegation();
	    }
	  }, {
	    key: 'requestData',
	    value: function requestData() {
	      var _this3 = this;
	
	      this.loaded = false;
	
	      this.loadingMobileService.show();
	      return this.employeeRepositoryService.getEmployee(this.userId, this.year, this.userInceptionId).then(function (employee) {
	        _this3._loadData(employee);
	      }).finally(function () {
	        return _this3.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '_findDelegationActive',
	    value: function _findDelegationActive(delegations) {
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	      this.delegation = this.vacationDelegationService.findDelegationActive(today, delegations);
	    }
	  }, {
	    key: '_showModalWarningDelegation',
	    value: function _showModalWarningDelegation() {
	      var delegationEmpty = this.helperDelegations.isDelegationEmpty(this.delegation);
	      if (delegationEmpty || this.visitedDelegation) {
	        return;
	      }
	
	      this.modalWarningDelegation.modal('show');
	    }
	  }, {
	    key: 'addEvent',
	    value: function addEvent(_ref) {
	      var _this4 = this;
	
	      var startDate = _ref.startDate,
	          endDate = _ref.endDate;
	
	      this.requestData(this.userId, this.userInceptionId).then(function () {
	        _this4.rootScope.$broadcast(_constants.EVENTS.ADD_PERIOD, {
	          startDate: startDate.getMonth(),
	          endDate: endDate
	        });
	      });
	    }
	  }, {
	    key: 'openRequestHolidayModal',
	    value: function openRequestHolidayModal() {
	      var _this5 = this;
	
	      this.requestHolidayMode = _constants.MODES.CREATE;
	      this.timeout(function () {
	        _this5.requestModal.modal('show');
	        _this5.openChoicesButtons = false;
	      });
	    }
	  }, {
	    key: 'reopenModalAfterFail',
	    value: function reopenModalAfterFail() {
	      var _this6 = this;
	
	      this.requestHolidayMode = _constants.MODES.EDIT;
	      this.timeout(function () {
	        _this6.requestModal.modal('show');
	        _this6.openChoicesButtons = false;
	      });
	    }
	  }, {
	    key: 'isInception',
	    value: function isInception() {
	      return !!this.userInceptionId;
	    }
	  }, {
	    key: 'setWarnModalDisplayed',
	    value: function setWarnModalDisplayed() {
	      process.isWarnModalBeenDisplayed = true;
	    }
	  }, {
	    key: 'isWarnModalBeenDisplayed',
	    value: function isWarnModalBeenDisplayed() {
	      return process.isWarnModalBeenDisplayed;
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        'responsiveMobile': this.isMobileApp,
	        'with-floating-action-buttons': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'initFloatingActionButtons',
	    value: function initFloatingActionButtons() {
	      this.floatingActionButtons = this._getFloatingActionButtons();
	      this.choicesFloatingActionButtons = this._getChoicesFloatingActionButtons();
	      this.inceptionFloatingActionButtons = this._getInceptionFloatingActionButtons();
	    }
	  }, {
	    key: '_getFloatingActionButtons',
	    value: function _getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.SUBMIT',
	        literalWithChoices: 'GLOBALS.BUTTON_ACTION.CHOICES_QUESTION'
	      }];
	    }
	  }, {
	    key: '_getChoicesFloatingActionButtons',
	    value: function _getChoicesFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.ABSENCES'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.VACATIONS'
	      }];
	    }
	  }, {
	    key: '_getInceptionFloatingActionButtons',
	    value: function _getInceptionFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.ASK_FOR_ABSENCES'
	      }];
	    }
	  }, {
	    key: 'getFloatingClass',
	    value: function getFloatingClass() {
	      return {
	        'with-choices': this.openChoicesButtons
	      };
	    }
	  }, {
	    key: 'hideChoicesButtons',
	    value: function hideChoicesButtons() {
	      if (this.openChoicesButtons) {
	        this.openChoicesButtons = false;
	      }
	    }
	  }, {
	    key: 'toggleButtons',
	    value: function toggleButtons() {
	      this.openChoicesButtons = !this.openChoicesButtons;
	    }
	  }, {
	    key: 'requestVacations',
	    value: function requestVacations() {
	      this.requestType = _request.Request.TYPES.VACATION;
	      this.openRequestHolidayModal();
	    }
	  }, {
	    key: 'requestAbsences',
	    value: function requestAbsences() {
	      this.requestType = _request.Request.TYPES.ABSENCE;
	      this.openRequestHolidayModal();
	    }
	  }, {
	    key: 'paginationPrevious',
	    value: function paginationPrevious() {
	      this.loaded = false;
	      this.year = this.year - 1;
	      this.dateToday = new Date(this.year, 11, 1);
	      this.dateToday.setFullYear(this.year);
	      this.$onInit();
	    }
	  }, {
	    key: 'paginationNext',
	    value: function paginationNext() {
	      this.loaded = false;
	      this.year = this.year + 1;
	      this.dateToday = new Date(this.year, 0, 1);
	      this.$onInit();
	    }
	  }, {
	    key: 'requestModal',
	    get: function get() {
	      var $modal = $(_constants.MODALS.REQUEST);
	      return $modal;
	    }
	  }, {
	    key: 'warningVacationModal',
	    get: function get() {
	      var $modal = $(_constants.MODALS.WARNING_REQUEST_VACATION);
	      return $modal;
	    }
	  }, {
	    key: 'modalWarningDelegation',
	    get: function get() {
	      var _this7 = this;
	
	      var $modal = $(_constants.MODALS.WARNING_DELEGATION_MODAL);
	      $modal.on('hidden.bs.modal', function () {
	        _this7.helperDelegations.setVisitedDelegation(_this7.userId);
	      });
	      return $modal;
	    }
	  }]);
	  return MyVacationsMobileController;
	}();
	
	exports.default = MyVacationsMobileController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1113)))

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1160);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./myVacationsMobile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./myVacationsMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "my-vacations-mobile .container.hpd.responsiveMobile{margin:0;padding:0;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}my-vacations-mobile .container.hpd.responsiveMobile .calendar-container{margin-top:60px;padding:0 15px;z-index:0;overflow:hidden}my-vacations-mobile .container.hpd.responsiveMobile .calendar-container.is-inception{margin-top:128px}my-vacations-mobile .container.hpd.responsiveMobile .available-days-container{width:100%;align-self:center;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;padding:0 15px;box-sizing:border-box}my-vacations-mobile .container.hpd.responsiveMobile .available-days-container,my-vacations-mobile .container.hpd.responsiveMobile .request-status-container{opacity:1}my-vacations-mobile .container.hpd.responsiveMobile .request-status-container{margin-top:5px;z-index:1;padding:0 15px;box-sizing:border-box}my-vacations-mobile .container.hpd.responsiveMobile .animate-block.ng-hide{opacity:0}my-vacations-mobile .container.hpd.responsiveMobile .choices-buttons{opacity:1;height:75px}my-vacations-mobile .container.hpd.responsiveMobile .choices-buttons button{color:#0072c9;background-color:#f9f9f9;border:1px solid #dddfe2}my-vacations-mobile .container.hpd.responsiveMobile .animate-button.ng-hide{opacity:0;height:0}my-vacations-mobile .container.hpd.responsiveMobile .animate-block.ng-hide-add,my-vacations-mobile .container.hpd.responsiveMobile .animate-block.ng-hide-remove,my-vacations-mobile .container.hpd.responsiveMobile .animate-button.ng-hide-add,my-vacations-mobile .container.hpd.responsiveMobile .animate-button.ng-hide-remove{transition:all .5s linear}", ""]);
	
	// exports


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _periodListLink = __webpack_require__(1162);
	
	var _periodListLink2 = _interopRequireDefault(_periodListLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodListLinkModule = _angular2.default.module('periodListLink', []).component('periodListLink', _periodListLink2.default).name;
	
	exports.default = periodListLinkModule;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _periodListLink = __webpack_require__(1163);
	
	var _periodListLink2 = _interopRequireDefault(_periodListLink);
	
	var _periodListLink3 = __webpack_require__(1164);
	
	var _periodListLink4 = _interopRequireDefault(_periodListLink3);
	
	__webpack_require__(1165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodListLinkComponent = {
	  restrict: 'E',
	  bindings: {
	    userInceptionId: '<',
	    onClickPeriodMobileListLink: '&',
	    dateToLoad: '<'
	  },
	  template: _periodListLink2.default,
	  controller: _periodListLink4.default
	};
	
	exports.default = periodListLinkComponent;

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"periodListLink\" ng-click=\"$ctrl.goToPeriodListMobile()\">\n  <p>{{'VACATIONS_ABSENCES.PERIOD_LIST.REQUEST_STATUS' | translate}}</p>\n  <span class=\"icon-arrow-select-up\"></span>\n</div>\n"

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeriodListLinkController = function () {
	  PeriodListLinkController.$inject = ["$state"];
	  function PeriodListLinkController($state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PeriodListLinkController);
	    this.state = $state;
	  }
	
	  (0, _createClass3.default)(PeriodListLinkController, [{
	    key: 'goToPeriodListMobile',
	    value: function goToPeriodListMobile() {
	      if (this.isInception()) {
	        return this.onClickPeriodMobileListLink();
	      }
	
	      this.state.go(_states.STATES.VACATIONS_ABSENCES.PERIOD_LIST_MOBILE, { dateToLoad: this.dateToLoad });
	    }
	  }, {
	    key: 'isInception',
	    value: function isInception() {
	      return !!this.userInceptionId;
	    }
	  }]);
	  return PeriodListLinkController;
	}();
	
	exports.default = PeriodListLinkController;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1166);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./periodListLink.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./periodListLink.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "period-list-link .periodListLink{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:auto;height:80px;font-size:15px;text-transform:uppercase;text-align:center;border-bottom:1px solid #dddfe2;border-top:1px solid #dddfe2;padding:0 25px;color:#0072c9}period-list-link .periodListLink p{font-family:Stag Sans;margin:0;margin-left:10px;color:#0072c9}period-list-link .periodListLink .icon-arrow-select-up{transform:rotate(90deg);font-size:14px}", ""]);
	
	// exports


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _teamRequests = __webpack_require__(1168);
	
	var _teamRequests2 = _interopRequireDefault(_teamRequests);
	
	var _teamRequests3 = __webpack_require__(1175);
	
	var _teamRequests4 = _interopRequireDefault(_teamRequests3);
	
	var _teamRequests5 = __webpack_require__(1176);
	
	var _teamRequests6 = _interopRequireDefault(_teamRequests5);
	
	var _teamRequestsList = __webpack_require__(1177);
	
	var _teamRequestsList2 = _interopRequireDefault(_teamRequestsList);
	
	var _teamRequests7 = __webpack_require__(1273);
	
	var _teamRequests8 = _interopRequireDefault(_teamRequests7);
	
	var _teamRequestsModalApproveAll = __webpack_require__(1274);
	
	var _teamRequestsModalApproveAll2 = _interopRequireDefault(_teamRequestsModalApproveAll);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsModule = angular.module('vacations-absences.teamRequests', [_angularUiRouter2.default, _teamRequestsList2.default, _teamRequestsModalApproveAll2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.TEAM_REQUESTS, {
	    url: _routes.ROUTES.VACATIONS_ABSENCES.TEAM_REQUESTS,
	    component: 'teamRequests',
	    data: {
	      requiresAuth: true,
	      requiresManager: true
	    },
	    resolve: {
	      /* @ngInject */
	      isWageInProcess: ["StatusAppCheckers", function isWageInProcess(StatusAppCheckers) {
	        return StatusAppCheckers.isWageInProcess();
	      }]
	    }
	  });
	}]).component('teamRequests', _teamRequests2.default).filter('filterRequests', _teamRequests8.default).service('teamRequestsService', _teamRequests4.default).service('teamRequestsFormatters', _teamRequests6.default).name;
	
	exports.default = teamRequestsModule;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequests = __webpack_require__(1169);
	
	var _teamRequests2 = _interopRequireDefault(_teamRequests);
	
	var _teamRequests3 = __webpack_require__(1170);
	
	var _teamRequests4 = _interopRequireDefault(_teamRequests3);
	
	__webpack_require__(1173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsComponent = {
	  restrict: 'E',
	  bindings: {
	    isWageInProcess: '<'
	  },
	  template: _teamRequests2.default,
	  controller: _teamRequests4.default
	};
	
	exports.default = teamRequestsComponent;

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

	module.exports = "<team-requests-modal-approve-all on-approve-all=\"$ctrl.approveAll()\"\n                                 error=\"$ctrl.approveAllError\"\n                                 success=\"$ctrl.approveAllSuccess\"\n                                 is-mobile-app =\"$ctrl.isMobileApp\">\n</team-requests-modal-approve-all>\n\n<modal-coachmark data=\"$ctrl.coachmarkData\"\n                 user-id=\"$ctrl.managerId\"\n                 ng-if=\"!$ctrl.isMobileApp\">\n</modal-coachmark>\n\n<div class=\"container hpd animation-appear team-request-list-container\"\n     pull-to-refresh=\"$ctrl._loadData()\"\n     ng-if=\"$ctrl.loaded\"\n     ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n  <team-requests-list requests=\"$ctrl.requests\"\n                      on-approve-all=\"$ctrl.confirmApproveAll($event)\"\n                      employees=\"$ctrl.employees\"\n                      loaded=\"$ctrl.loaded\"\n                      has-delegations=\"$ctrl.hasDelegations\"\n                      is-disabled=\"$ctrl.isDisabled()\"\n                      is-mobile-app =\"$ctrl.isMobileApp\"\n                      on-action=\"$ctrl._loadData()\">\n  </team-requests-list>\n</div>\n\n<loading ng-if=\"!$ctrl.isMobileApp\"\n         ng-hide=\"$ctrl.loaded\">\n</loading>\n"

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	var _teamRequestsList = __webpack_require__(1171);
	
	var _teamRequestsList2 = _interopRequireDefault(_teamRequestsList);
	
	var _constants2 = __webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestsController = function () {
	  TeamRequestsController.$inject = ["$window", "$rootScope", "teamRequestsService", "vacationUserDataService", "$log", "vacationDelegationService", "vacationsAbsencesService", "loadingMobileService"];
	  function TeamRequestsController($window, $rootScope, teamRequestsService, vacationUserDataService, $log, vacationDelegationService, vacationsAbsencesService, loadingMobileService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamRequestsController);
	    this.teamRequestsService = teamRequestsService;
	    this.vacationsAbsencesService = vacationsAbsencesService;
	    this.rootScope = $rootScope;
	    this.window = $window;
	    this.log = $log;
	    this.teamRequestsListAssembler = new _teamRequestsList2.default();
	    this.loaded = false;
	    this.managerId = vacationUserDataService.getEmployee().userId;
	    this.nextId = 0;
	    this.coachmarkData = _constants2.VA_TEAM_REQUESTS_MODAL_COACHMARK_CONFIG;
	    this.vacationDelegationService = vacationDelegationService;
	    this.loadingMobileService = loadingMobileService;
	    this.isMobileApp = $window.innerWidth < 1024;
	  }
	
	  (0, _createClass3.default)(TeamRequestsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this._loadData();
	      this._resetApproveAllModalState();
	      this.vacationDelegationService.hasDelegated(this.managerId).then(function (response) {
	        _this.hasDelegations = response.hasDelegated;
	      });
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled() {
	      return this.isWageInProcess;
	    }
	  }, {
	    key: '_loadData',
	    value: function _loadData() {
	      var _this2 = this;
	
	      this.loadingMobileService.show();
	      this.loaded = false;
	      this.vacationsAbsencesService._loadTeamRequestData().then(function () {
	        _this2.requests = _this2.vacationsAbsencesService.TeamRequestDataService.getData();
	        var requestsNumber = _this2.requests.length;
	        _this2.rootScope.$broadcast(_constants.EVENTS.BADGE_NUMBER, { badgeNumber: requestsNumber });
	        _this2.employees = [];
	
	        if (!(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(_this2.requests)) {
	          _this2.employees = _this2.teamRequestsListAssembler.buildListFromRequestList(_this2.requests);
	        }
	
	        _this2.loaded = true;
	        _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '_resetApproveAllModalState',
	    value: function _resetApproveAllModalState() {
	      var _this3 = this;
	
	      $(_constants.MODALS.TEAM_REQUESTS.APPROVE_ALL).on('hidden.bs.modal', function () {
	        _this3.approveAllSuccess = null;
	        _this3.approveAllError = null;
	      });
	    }
	  }, {
	    key: 'confirmApproveAll',
	    value: function confirmApproveAll($event) {
	      this.requestsForApproveAll = $event.requests;
	      $(_constants.MODALS.TEAM_REQUESTS.APPROVE_ALL).modal('show');
	    }
	  }, {
	    key: 'approveAll',
	    value: function approveAll() {
	      var _this4 = this;
	
	      this.loadingMobileService.show();
	      return this.teamRequestsService.approveAll(this.managerId, this.requestsForApproveAll).then(function () {
	        _this4.approveAllSuccess = true;
	        _this4.requestsForApproveAll.forEach(function (approved) {
	          _this4.requests = _this4.requests.filter(function (request) {
	            return request !== approved;
	          });
	
	          if (_this4.isMobileApp) {
	            var requestsNumber = _this4.requests.length;
	            _this4.rootScope.$broadcast(_constants.EVENTS.BADGE_NUMBER, { badgeNumber: requestsNumber });
	          }
	
	          _this4.loadingMobileService.hide();
	        });
	      }, function (error) {
	        _this4.approveAllError = error;
	        _this4.loadingMobileService.hide();
	      });
	    }
	  }]);
	  return TeamRequestsController;
	}();
	
	exports.default = TeamRequestsController;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _profile = __webpack_require__(1172);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestsListAssembler = function () {
	  function TeamRequestsListAssembler() {
	    (0, _classCallCheck3.default)(this, TeamRequestsListAssembler);
	  }
	
	  (0, _createClass3.default)(TeamRequestsListAssembler, [{
	    key: 'buildListFromRequestList',
	    value: function buildListFromRequestList(requests) {
	      return _lodash2.default.uniqBy(requests.map(this.buildFromRequest), 'userId');
	    }
	  }, {
	    key: 'buildFromRequest',
	    value: function buildFromRequest(request) {
	      return new _profile2.default(request.employeeId, request.name, request.email);
	    }
	  }]);
	  return TeamRequestsListAssembler;
	}();
	
	exports.default = TeamRequestsListAssembler;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Profile = function () {
	  function Profile(userId, name, email) {
	    (0, _classCallCheck3.default)(this, Profile);
	
	    this.userId = userId;
	    this.name = name;
	    this.email = email;
	    this.role = Profile.ROLE_EMPLOYEE;
	    this.delegation = false;
	    this.employeeopplus = true;
	  }
	
	  (0, _createClass3.default)(Profile, [{
	    key: 'compareTo',
	    value: function compareTo(profile) {
	      return this.profile.userId === profile.userId;
	    }
	  }], [{
	    key: 'ROLE_EMPLOYEE',
	    value: function ROLE_EMPLOYEE() {
	      return 'normal';
	    }
	  }, {
	    key: 'ROLE_MANAGER',
	    value: function ROLE_MANAGER() {
	      return 'manager';
	    }
	  }, {
	    key: 'DELEGATION_USER',
	    value: function DELEGATION_USER() {
	      return 'R';
	    }
	  }, {
	    key: 'DELEGATION_MANAGER',
	    value: function DELEGATION_MANAGER() {
	      return 'A';
	    }
	  }]);
	  return Profile;
	}();
	
	exports.default = Profile;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1174);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequests.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequests.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-requests{display:block}@media only screen and (device-width:375px)and (device-height:812px)and (-webkit-device-pixel-ratio:3){team-requests{padding-bottom:30px}}", ""]);
	
	// exports


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vacationsAbsences = __webpack_require__(1120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsService = function () {
	  teamRequestsService.$inject = ["$http", "teamRequestsFormatters"];
	  function teamRequestsService($http, teamRequestsFormatters) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, teamRequestsService);
	    this.http = $http;
	    this.formatters = teamRequestsFormatters;
	  }
	
	  (0, _createClass3.default)(teamRequestsService, [{
	    key: 'getRequests',
	    value: function getRequests(managerId) {
	      return this.http.get(_vacationsAbsences.ENDPOINTS_MANAGER.get.requests(managerId)).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'reject',
	    value: function reject(managerId, request) {
	      var params = this.formatters.formatReject(request);
	
	      return this.http.put(_vacationsAbsences.ENDPOINTS_MANAGER.put.requests(managerId), params).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'approveAll',
	    value: function approveAll(managerId, requests) {
	      var params = this.formatters.formatApproveAll(requests);
	      return this.http.put(_vacationsAbsences.ENDPOINTS_MANAGER.put.requests(managerId), params).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'approve',
	    value: function approve(managerId, request) {
	      var params = this.formatters.formatApprove(request);
	
	      return this.http.put(_vacationsAbsences.ENDPOINTS_MANAGER.put.requests(managerId), params).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'discard',
	    value: function discard(managerId, request) {
	      var params = this.formatters.formatDiscard(request);
	
	      return this.http.put(_vacationsAbsences.ENDPOINTS_MANAGER.put.discardRequest(managerId), params).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getCoincidences',
	    value: function getCoincidences(managerId, startDate, endDate) {
	      var data = {
	        params: {
	          'filter_start_date': startDate,
	          'filter_end_date': endDate
	        }
	      };
	
	      return this.http.get(_vacationsAbsences.ENDPOINTS_MANAGER.get.coincidences(managerId), data).then(function (response) {
	        return response.data;
	      });
	    }
	  }]);
	  return teamRequestsService;
	}();
	
	exports.default = teamRequestsService;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _request = __webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestsFormatter = function () {
	  function TeamRequestsFormatter() {
	    (0, _classCallCheck3.default)(this, TeamRequestsFormatter);
	  }
	
	  (0, _createClass3.default)(TeamRequestsFormatter, [{
	    key: 'formatReject',
	    value: function formatReject(request) {
	      var params = [];
	      var requestFormmated = this.formatRequest(request);
	      requestFormmated.action = _request.Request.ACTIONS.REJECT;
	      params.push(requestFormmated);
	      return params;
	    }
	  }, {
	    key: 'formatApproveAll',
	    value: function formatApproveAll(requests) {
	      var _this = this;
	
	      var params = [];
	      requests.forEach(function (request) {
	        var requestApproved = _this.formatApprove(request);
	        params.push(requestApproved[0]);
	      });
	      return params;
	    }
	  }, {
	    key: 'formatApprove',
	    value: function formatApprove(request) {
	      var params = [];
	      var requestFormmated = this.formatRequest(request);
	      requestFormmated.action = _request.Request.ACTIONS.APPROVE;
	      params.push(requestFormmated);
	      return params;
	    }
	  }, {
	    key: 'formatRequest',
	    value: function formatRequest(request) {
	      return {
	        employeeId: request.employeeId,
	        startDate: request.startDate,
	        endDate: request.endDate,
	        code: request.code
	      };
	    }
	  }, {
	    key: 'formatDiscard',
	    value: function formatDiscard(request) {
	      var params = this.formatRequest(request);
	      delete params.endDate;
	      return params;
	    }
	  }, {
	    key: 'formatRequestInfo',
	    value: function formatRequestInfo(request, formatDateForView, daysLiteral, hoursLiteral) {
	      if (request.hours) {
	        return '\n        <h1>' + request.name + '</h1>\n        <p>' + request.periodType + ' - ' + request.category + '</p>\n        <p>' + formatDateForView(request.startDate) + '</p>\n        <p>(' + request.hours + ' ' + hoursLiteral + ')</p>\n      ';
	      }
	
	      return '\n      <h1>' + request.name + '</h1>\n      <p>' + request.periodType + ' - ' + request.category + '</p>\n      <p>' + formatDateForView(request.startDate) + '</p><p> ' + formatDateForView(request.endDate) + '</p>\n      <p>(' + request.duration + ' ' + daysLiteral + ')</p>\n    ';
	    }
	  }]);
	  return TeamRequestsFormatter;
	}();
	
	exports.default = TeamRequestsFormatter;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestsList = __webpack_require__(1178);
	
	var _teamRequestsList2 = _interopRequireDefault(_teamRequestsList);
	
	var _teamRequestCard = __webpack_require__(1185);
	
	var _teamRequestCard2 = _interopRequireDefault(_teamRequestCard);
	
	var _teamRequestsFilters = __webpack_require__(1240);
	
	var _teamRequestsFilters2 = _interopRequireDefault(_teamRequestsFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsListModule = angular.module('vacations-absences.teamRequestsList', [_teamRequestCard2.default, _teamRequestsFilters2.default]).component('teamRequestsList', _teamRequestsList2.default).name;
	
	exports.default = teamRequestsListModule;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestsList = __webpack_require__(1179);
	
	var _teamRequestsList2 = _interopRequireDefault(_teamRequestsList);
	
	var _teamRequestsList3 = __webpack_require__(1180);
	
	var _teamRequestsList4 = _interopRequireDefault(_teamRequestsList3);
	
	__webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsListComponent = {
	  restrict: 'E',
	  bindings: {
	    requests: '<',
	    onApproveAll: '&',
	    employees: '<',
	    loaded: '<',
	    hasDelegations: '<',
	    isDisabled: '<',
	    isMobileApp: '<',
	    onAction: '&'
	  },
	  template: _teamRequestsList2.default,
	  controller: _teamRequestsList4.default
	};
	
	exports.default = teamRequestsListComponent;

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n\n  <div class=\"filters-and-search-employee\"\n       ng-class=\"{ 'filter-search-fixed':$ctrl.hasFilters() }\"\n       ng-hide=\"$ctrl.isMobileApp && $ctrl.requests.length === 0\">\n      <team-requests-filters\n        on-filter=\"$ctrl.onFilter($event)\"\n        exclusive=\"$ctrl.exclusiveFilters\"\n        filters=\"$ctrl.filters\"\n        is-mobile-app=\"$ctrl.isMobileApp\">\n      </team-requests-filters>\n\n      <employee-search\n        ng-if=\"!$ctrl.isMobileApp\"\n        on-search=\"$ctrl.onSearch()\"\n        on-select-employee=\"$ctrl.onSelectEmployee($event)\">\n      </employee-search>\n\n      <employee-search\n        ng-if=\"$ctrl.isMobileApp\"\n        fixed-selection=\"true\"\n        on-search=\"$ctrl.onSearch()\"\n        on-select-employee=\"$ctrl.onSelectEmployee($event)\"\n        on-clean-search=\"$ctrl.onCleanEmployeeFilters()\"\n        is-mobile-app=\"$ctrl.isMobileApp\">\n      </employee-search>\n  </div>\n\n  <div class=\"tags-and-approve\" ng-if=\"$ctrl.showFiltersDesktop()\">\n    <employee-search-tags\n      employee-filters=\"$ctrl.employeeFilters\"\n      on-remove-employee-filter=\"$ctrl.onRemoveEmployeeFilter($event)\"\n      on-clean-employee-filters=\"$ctrl.onCleanEmployeeFilters()\"\n      >\n    </employee-search-tags>\n    <button\n      ng-if=\"$ctrl.showApproveAll()\"\n      ng-click=\"$ctrl.approveAll($ctrl.filteredRequests)\"\n      class=\"pull-right btn btn-app btn-primary btn-approve-all\">{{ 'VACATIONS_ABSENCES.GENERAL.APPROVE_ALL' | translate }}\n    </button>\n  </div>\n\n  <div class=\"requested-cards-container\"\n       ng-class=\"{'requested-card-fixed': $ctrl.hasFilters(), 'with-floating-action-buttons': $ctrl.showFiltersMobile()}\">\n    <team-request-card\n      modal-id=\"{{request._id}}\"\n      ng-repeat=\"request in ($ctrl.filteredRequests = ($ctrl.requests | filterRequests:$ctrl.currentFilters | employeeFilter: $ctrl.employeeFilters)) track by request._id\"\n      ng-class=\"$ctrl.getCardClass()\"\n      request=\"request\"\n      on-accept=\"$ctrl.removeCard(request)\"\n      on-reject=\"$ctrl.removeCard(request)\"\n      on-discard=\"$ctrl.removeCard(request)\"\n      with-delegation=\"$ctrl.hasDelegations\"\n      is-disabled=\"$ctrl.isDisabled\"\n      card-id=\"team-request-card-{{$index}}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </team-request-card>\n\n    <div ng-if=\"$ctrl.isEmpty() && $ctrl.isLoaded()\" class=\"list-empty\" ng-class=\"$ctrl.getCardClass()\">\n      <span class=\"icon-warning\"></span>\n      <span>{{'VACATIONS_ABSENCES.TEAM_REQUESTS.EMPTY_REQUESTS_LIST' | translate}}</span>\n    </div>\n  </div>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.showFiltersMobile()\"\n    buttons=\"$ctrl.floatingActionsButtons\"\n    on-click-first-button=\"$ctrl.approveAll($ctrl.filteredRequests)\">\n  </floating-action-buttons>\n</div>\n"

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _request = __webpack_require__(1114);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	var _teamRequestsFilters = __webpack_require__(1181);
	
	var _teamRequestCardDetails = __webpack_require__(1182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestsListController = function () {
	  TeamRequestsListController.$inject = ["EventEmitter", "$filter", "$scope", "HelperDelegationsService", "$rootScope"];
	  function TeamRequestsListController(EventEmitter, $filter, $scope, HelperDelegationsService, $rootScope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamRequestsListController);
	    this.EventEmitter = EventEmitter;
	    this.filter = $filter;
	    this.currentFilters = [];
	    this.employeeFilters = [];
	    this.scope = $scope;
	    this.rootScope = $rootScope;
	    this.helperDelegationsService = HelperDelegationsService;
	    this.exclusiveFilters = {};
	    this.exclusiveFilters[_teamRequestsFilters.EXCLUSIVE.ALL] = true;
	  }
	
	  (0, _createClass3.default)(TeamRequestsListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.filters = [{
	        name: _request.Request.TYPES.VACATION,
	        label: 'VACATIONS_ABSENCES.GENERAL.VACATIONS',
	        type: _request.Request.TYPES.VACATION
	      }, {
	        name: _request.Request.TYPES.ABSENCE,
	        label: 'VACATIONS_ABSENCES.GENERAL.ABSENCES',
	        type: _request.Request.TYPES.ABSENCE
	      }, {
	        name: _request.Request.STATUS_REQUESTED.DISCARD,
	        label: 'GLOBALS.NOTIFICATIONS',
	        type: _request.Request.STATUS_REQUESTED.DISCARD,
	        icon: 'icon icon-bell'
	      }];
	
	      this.floatingActionsButtons = this.getFloatingActionButtons();
	    }
	  }, {
	    key: 'isEmpty',
	    value: function isEmpty() {
	      return (0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.requests) || this._hasNotFilteredResults();
	    }
	  }, {
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.loaded === true;
	    }
	  }, {
	    key: '_hasNotFilteredResults',
	    value: function _hasNotFilteredResults() {
	      var filtered = this.filter('filterRequests')(this.requests, this.currentFilters);
	      filtered = this.filter('employeeFilter')(filtered, this.employeeFilters);
	      return filtered.length === 0;
	    }
	  }, {
	    key: 'hasFilters',
	    value: function hasFilters() {
	      return this.currentFilters.length > 0;
	    }
	  }, {
	    key: 'onSearch',
	    value: function onSearch() {
	      return this.helperDelegationsService.onSearchEmployeeDelegations(this.employees);
	    }
	  }, {
	    key: 'showFilterActions',
	    value: function showFilterActions() {
	      return this.employeeFilters.length > 0 || this.showApproveAll();
	    }
	  }, {
	    key: 'showApproveAll',
	    value: function showApproveAll() {
	      if (this.isDisabled) {
	        return false;
	      }
	
	      var atLeastOneRequest = this.filteredRequests && this.filteredRequests.length > 0;
	      var filteredByVacations = this.currentFilters.indexOf(_request.Request.TYPES.VACATION) > -1;
	      var notFilteredByAbsences = this.currentFilters.indexOf(_request.Request.TYPES.ABSENCE) === -1;
	
	      return atLeastOneRequest && filteredByVacations && notFilteredByAbsences;
	    }
	  }, {
	    key: 'onFilter',
	    value: function onFilter($event) {
	      this.scope.$broadcast(_teamRequestCardDetails.HIDE_DETAIL);
	      this.currentFilters = $event.selectedFilters;
	    }
	  }, {
	    key: 'onSelectEmployee',
	    value: function onSelectEmployee($event) {
	      if (!this.employeeFilters.find(function (employee) {
	        return employee.userId === $event.userId;
	      })) {
	        this.employeeFilters.push(angular.copy($event));
	      }
	    }
	  }, {
	    key: 'onRemoveEmployeeFilter',
	    value: function onRemoveEmployeeFilter($event) {
	      _lodash2.default.remove(this.employeeFilters, function (filter) {
	        return filter.userId === $event.userId;
	      });
	    }
	  }, {
	    key: 'onCleanEmployeeFilters',
	    value: function onCleanEmployeeFilters() {
	      this.employeeFilters = [];
	    }
	  }, {
	    key: 'getCardClass',
	    value: function getCardClass() {
	      return {
	        'shown-filter': this.showFilterActions(),
	        'responsiveMobile': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'removeCard',
	    value: function removeCard() {
	      this.scope.$broadcast(_teamRequestCardDetails.HIDE_DETAIL);
	      this.onAction();
	    }
	  }, {
	    key: 'approveAll',
	    value: function approveAll(filteredRequests) {
	      this.onApproveAll(this.EventEmitter({ requests: filteredRequests }));
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'VACATIONS_ABSENCES.GENERAL.APPROVE_ALL'
	      }];
	    }
	  }, {
	    key: 'showFiltersMobile',
	    value: function showFiltersMobile() {
	      return this.isMobileApp && this.showFilters();
	    }
	  }, {
	    key: 'showFiltersDesktop',
	    value: function showFiltersDesktop() {
	      return !this.isMobileApp && this.showFilterActions();
	    }
	  }, {
	    key: 'showFilters',
	    value: function showFilters() {
	      return this.showFilterActions() && this.showApproveAll();
	    }
	  }]);
	  return TeamRequestsListController;
	}();
	
	exports.default = TeamRequestsListController;

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EXCLUSIVE = {
	  ALL: 'all'
	};
	
	exports.EXCLUSIVE = EXCLUSIVE;

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var HIDE_DETAIL = 'hideDetail';
	
	exports.HIDE_DETAIL = HIDE_DETAIL;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1184);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestsList.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestsList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-requests-list{display:block}team-requests-list .responsiveMobile .list-empty{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}team-requests-list .responsiveMobile .list-empty .icon-warning{margin-right:0}team-requests-list .responsiveMobile .filters-and-search-employee{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;-ms-flex-align:start;-moz-align-items:start;align-items:start;margin-right:-15px;margin-left:-15px;height:147px}team-requests-list .responsiveMobile .filters-and-search-employee employee-search{min-width:260px}team-requests-list .responsiveMobile .filters-and-search-employee team-requests-filters{margin-top:0}team-requests-list .responsiveMobile .filter-search-fixed{position:fixed;top:60px;width:100%;z-index:2;left:0;background-color:#fff;margin-left:0;margin-right:0;padding-left:15px;padding-right:15px}team-requests-list .responsiveMobile .requested-card-fixed{padding-top:147px}team-requests-list .responsiveMobile .requested-card-fixed.with-floating-action-buttons{padding-bottom:75px}team-requests-list .filters-and-search-employee{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}team-requests-list .filter-buttons,team-requests-list .filters-and-search-employee{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row}team-requests-list .tags-and-approve{margin-top:23px;margin-left:-15px;margin-right:-15px;padding:0 15px;border-top:1px solid #dddfe2}team-requests-list .list-empty{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}team-requests-list .list-empty.shown-filter{margin-top:0}team-requests-list .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}team-requests-list .tags-and-approve{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;min-height:45px}team-requests-list .tags-and-approve .btn.btn-app.btn-primary.btn-approve-all{text-transform:uppercase;height:38px;line-height:38px}", ""]);
	
	// exports


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestCard = __webpack_require__(1186);
	
	var _teamRequestCard2 = _interopRequireDefault(_teamRequestCard);
	
	var _teamRequestCardActions = __webpack_require__(1192);
	
	var _teamRequestCardActions2 = _interopRequireDefault(_teamRequestCardActions);
	
	var _teamRequestCardActionsMobile = __webpack_require__(1198);
	
	var _teamRequestCardActionsMobile2 = _interopRequireDefault(_teamRequestCardActionsMobile);
	
	var _teamRequestCardDetails = __webpack_require__(1204);
	
	var _teamRequestCardDetails2 = _interopRequireDefault(_teamRequestCardDetails);
	
	var _teamRequestModalApprove = __webpack_require__(1222);
	
	var _teamRequestModalApprove2 = _interopRequireDefault(_teamRequestModalApprove);
	
	var _teamRequestModalRemove = __webpack_require__(1228);
	
	var _teamRequestModalRemove2 = _interopRequireDefault(_teamRequestModalRemove);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCardModule = angular.module('vacations-absences.teamRequestCard', [_teamRequestCardActions2.default, _teamRequestCardDetails2.default, _teamRequestModalApprove2.default, _teamRequestModalRemove2.default, _teamRequestCardActionsMobile2.default]).component('teamRequestCard', _teamRequestCard2.default).name;
	
	exports.default = teamRequestCardModule;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestCard = __webpack_require__(1187);
	
	var _teamRequestCard2 = _interopRequireDefault(_teamRequestCard);
	
	var _teamRequestCard3 = __webpack_require__(1188);
	
	var _teamRequestCard4 = _interopRequireDefault(_teamRequestCard3);
	
	__webpack_require__(1190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCardComponent = {
	  restrict: 'E',
	  bindings: {
	    modalId: '@',
	    request: '<',
	    onAccept: '&',
	    onReject: '&',
	    onDiscard: '&',
	    withDelegation: '<',
	    isDisabled: '<',
	    isMobileApp: '<',
	    cardId: '@'
	  },
	  template: _teamRequestCard2.default,
	  controller: _teamRequestCard4.default
	};
	
	exports.default = teamRequestCardComponent;

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

	module.exports = "<team-request-modal-approve modal-id=\"{{$ctrl.modalId}}\"\n                            request=\"$ctrl.request\"\n                            error=\"$ctrl.error\"\n                            show-success=\"$ctrl.showSuccess\"\n                            on-accept=\"$ctrl.onAccept()\"\n                            delegation=\"$ctrl.withDelegation\"\n                            is-mobile-app=\"$ctrl.isMobileApp\">\n</team-request-modal-approve>\n\n<modal-warning-delegation ng-if=\"$ctrl.hasDelegated\"\n                          is-mobile-app=\"$ctrl.isMobileApp\"\n                          title-body=\"{{ 'VACATIONS_ABSENCES.MAIN.WARNING_DELEGATION_TITLE' | translate }}\"\n                          delegation=\"$ctrl.delegation\"\n                          url-destination=\"$ctrl.urlDestination\">\n</modal-warning-delegation>\n\n<team-request-modal-remove modal-id=\"{{$ctrl.modalId}}\"\n                           request=\"$ctrl.request\"\n                           error=\"$ctrl.rejectCardError\"\n                           show-success=\"$ctrl.rejectCardSuccess\"\n                           on-confirm=\"$ctrl.confirmReject()\"\n                           on-reject=\"$ctrl.onReject()\"\n                           is-mobile-app=\"$ctrl.isMobileApp\">\n</team-request-modal-remove>\n\n<div ng-if=\"!$ctrl.isMobileApp\">\n  <div class=\"request-card\" ng-class=\"$ctrl.getCardClass()\">\n    <aside class=\"request-avatar\">\n      <avatar-app\n        size-big\n        email=\"$ctrl.request.email\"\n        name=\"$ctrl.request.name\"\n        source=\"$ctrl.request.image\"\n        user-id=\"$ctrl.request.userId\"></avatar-app>\n    </aside>\n\n    <div class=\"request-content\">\n      <header>\n        <h1>\n          <a href=\"\" ng-class=\"{'remove-pointer-events': $ctrl.isDisabled}\" class=\"request-applicant-name\" ng-click=\"$ctrl.inceptEmployee($ctrl.request.employeeId)\">\n            <employee-name name=\"{{$ctrl.request.name}}\" enrollment=\"{{$ctrl.request.employeeId}}\"></employee-name>\n          </a>\n        </h1>\n      </header>\n\n      <section class=\"request-type\">\n        {{$ctrl.request.typeText | translate}}: {{$ctrl.request.periodType | capitalizeFirst}} / {{$ctrl.request.category | capitalizeFirst}}\n      </section>\n\n      <section class=\"request-period\">\n        <span class=\"period\" ng-if=\"!$ctrl.teamRequestCardHelper.isHourly($ctrl.request)\">\n          {{$ctrl.request.startDate | date : 'EEEE dd MMMM yyyy'}} <span ng-show=\"$ctrl.existEndDate()\">- {{$ctrl.request.endDate | date : 'EEEE dd MMMM yyyy'}}</span>\n          (<span class=\"days\">{{$ctrl.request.duration | lpadAuto}}</span> <span class=\"days-text\">{{'GLOBALS.DAYS' | translate}}</span>)\n        </span>\n        <span class=\"period\" ng-if=\"$ctrl.teamRequestCardHelper.isHourly($ctrl.request)\">\n          {{$ctrl.request.startDate | date : 'EEEE dd MMMM yyyy'}}\n          <div></div>\n          (<span class=\"days\">{{$ctrl.request.hours | lpadAuto}}</span> <span class=\"days-text\">{{'GLOBALS.HOURS' | translate}}</span>)\n        </span>\n      </section>\n\n      <footer>\n        <span class=\"request-action-tag\" ng-if=\"$ctrl.teamRequestCardHelper.showActionTag($ctrl.request)\">{{$ctrl.request.statusText | translate}}</span>\n        <span class=\"request-available-days\">\n          <span class=\"days\">{{$ctrl.request.availableDays | lpadAuto}}</span>\n          {{'VACATIONS_ABSENCES.GENERAL.AVAILABLE_DAYS' | translate}}</span>\n      </footer>\n    </div>\n\n    <aside class=\"request-actions\">\n      <team-request-card-actions\n        is-disabled=\"$ctrl.isDisabled\"\n        request=\"$ctrl.request\"\n        on-accept=\"$ctrl.accept()\"\n        on-reject=\"$ctrl.reject()\"\n        on-discard=\"$ctrl.discard()\"></team-request-card-actions>\n    </aside>\n  </div>\n\n  <team-request-card-details\n    request=\"$ctrl.request\"\n    is-disabled=\"$ctrl.isDisabled\"\n    is-disabled-by-delegation=\"$ctrl.isDisabledInceptionByDelegation\"\n    show-modal-warning-delegation=\"$ctrl._showModalWarningDelegation()\">\n  </team-request-card-details>\n</div>\n\n<div ng-if=\"$ctrl.isMobileApp\">\n  <div class=\"request-card {{$ctrl.cardId}} swipe-container\"\n       ng-class=\"$ctrl.getCardClass()\">\n    <aside class=\"request-avatar\">\n      <avatar-app size-medium=\"true\"\n                  email=\"$ctrl.request.email\"\n                  name=\"$ctrl.request.name\"\n                  source=\"$ctrl.request.image\">\n      </avatar-app>\n    </aside>\n\n    <div class=\"request-content\">\n      <div class=\"request-content-data\">\n        <div class=\"request-content-container\">\n          <header>\n              <h1>\n                <a href=\"\"\n                   ng-class=\"{'remove-pointer-events': $ctrl.isDisabled}\"\n                   class=\"request-applicant-name\"\n                   ng-click=\"$ctrl.inceptEmployee($ctrl.request.employeeId)\">\n                  <employee-name name=\"{{$ctrl.request.name}}\"\n                                 enrollment=\"{{$ctrl.request.employeeId}}\">\n                  </employee-name>\n                </a>\n              </h1>\n          </header>\n\n          <section class=\"request-type\">\n              {{$ctrl.request.typeText | translate}}: {{$ctrl.request.periodType | capitalizeFirst}}\n              <br>\n              {{$ctrl.request.category | capitalizeFirst}}\n          </section>\n\n          <section class=\"request-period\">\n              <span class=\"period\"\n                    ng-if=\"!$ctrl.teamRequestCardHelper.isHourly($ctrl.request)\">\n                {{$ctrl.request.startDate | date : 'EEEE dd MMMM yyyy'}}\n                <br>\n              <span ng-show=\"$ctrl.existEndDate()\"> {{$ctrl.request.endDate | date : 'EEEE dd MMMM yyyy'}}</span>\n              </span>\n              <span class=\"period\"\n                    ng-if=\"$ctrl.teamRequestCardHelper.isHourly($ctrl.request)\">\n                {{$ctrl.request.startDate | date : 'EEEE dd MMMM yyyy'}}\n              </span>\n          </section>\n        </div>\n\n        <div class=\"request-content-days\">\n          <div class=\"days-mobile\">\n              <span class=\"period\"\n                    ng-if=\"!$ctrl.teamRequestCardHelper.isHourly($ctrl.request)\">\n                <span class=\"days\">{{$ctrl.request.duration | lpadAuto}}</span>\n                <span class=\"days-text\">{{'GLOBALS.DAYS' | translate}}</span>\n              </span>\n              <span class=\"period\"\n                    ng-if=\"$ctrl.teamRequestCardHelper.isHourly($ctrl.request)\">\n                <span class=\"days\">{{$ctrl.request.hours | lpadAuto}}</span>\n                <span class=\"days-text\">{{'GLOBALS.HOURS' | translate}}</span>\n              </span>\n            </div>\n        </div>\n      </div>\n\n      <footer ng-if=\"!$ctrl.teamRequestCardHelper.hasObservations($ctrl.request)\">\n          <span class=\"request-available-days\">\n              <span class=\"days\">{{$ctrl.request.availableDays | lpadAuto}}</span>\n               {{'VACATIONS_ABSENCES.GENERAL.AVAILABLE_DAYS' | translate}}</span>\n          <span class=\"request-action-tag\"\n                ng-if=\"$ctrl.teamRequestCardHelper.showActionTag($ctrl.request)\">{{$ctrl.request.statusText | translate}}</span>\n      </footer>\n\n      <footer ng-if=\"$ctrl.teamRequestCardHelper.hasObservations($ctrl.request)\">\n        <div class=\"request-observations\"\n             ng-if=\"$ctrl.teamRequestCardHelper.hasObservations($ctrl.request)\">\n          <span class=\"icon icon-insight\"></span>\n          <span class=\"remark-text\">{{$ctrl.request.remarks}}</span>\n        </div>\n        <span class=\"request-action-tag\"\n              ng-if=\"$ctrl.teamRequestCardHelper.showActionTag($ctrl.request)\">{{$ctrl.request.statusText | translate}}</span>\n      </footer>\n    </div>\n\n    <aside class=\"request-actions-mobile\">\n      <team-request-card-actions-mobile ng-if=\"$ctrl.shouldSwipe()\"\n                                        is-disabled=\"$ctrl.isDisabled\"\n                                        request=\"$ctrl.request\"\n                                        on-accept=\"$ctrl.accept()\"\n                                        on-reject=\"$ctrl.reject()\"\n                                        on-discard=\"$ctrl.discard()\"\n                                        is-mobile-app=\"$ctrl.isMobileApp\">\n      </team-request-card-actions-mobile>\n    </aside>\n  </div>\n\n  <team-request-card-details request=\"$ctrl.request\"\n                             is-disabled=\"$ctrl.isDisabled\"\n                             is-disabled-by-delegation=\"$ctrl.isDisabledInceptionByDelegation\"\n                             show-modal-warning-delegation=\"$ctrl._showModalWarningDelegation()\"\n                             is-mobile-app=\"$ctrl.isMobileApp\">\n  </team-request-card-details>\n</div>\n"

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _request = __webpack_require__(1114);
	
	var _constants = __webpack_require__(564);
	
	var _constants2 = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	var _swipe = __webpack_require__(724);
	
	var _swipe2 = _interopRequireDefault(_swipe);
	
	var _teamRequestCard = __webpack_require__(1189);
	
	var _teamRequestCard2 = _interopRequireDefault(_teamRequestCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestCardController = function () {
	  TeamRequestCardController.$inject = ["$log", "$location", "teamRequestsService", "vacationUserDataService", "inceptionService", "vacationDelegationService", "$timeout", "loadingMobileService"];
	  function TeamRequestCardController($log, $location, teamRequestsService, vacationUserDataService, inceptionService, vacationDelegationService, $timeout, loadingMobileService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamRequestCardController);
	    this.log = $log;
	    this.teamRequestsService = teamRequestsService;
	    this.inceptionService = inceptionService;
	    this.managerId = vacationUserDataService.getEmployee().userId;
	    this.vacationDelegationService = vacationDelegationService;
	    this.timeout = $timeout;
	    this.teamRequestCardHelper = new _teamRequestCard2.default();
	    this.loadingMobileService = loadingMobileService;
	  }
	
	  (0, _createClass3.default)(TeamRequestCardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.urlDestination = _states.STATES.VACATIONS_ABSENCES.DELEGATE;
	      this._initImage();
	      this._initAvailableDays();
	      this._initStatus();
	      this._initRequestDate();
	      this._initResetApproveModal();
	      this.request.typeText = _request.Request.getTranslation(this.request.type);
	      this.request.statusText = this._getStatusText();
	      this.endDate = angular.copy(this.request.endDate);
	
	      this._disableInceptionInCoincidencesIfHasDelegations();
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      if (this.shouldSwipe()) {
	        this.initSwipe();
	      }
	    }
	  }, {
	    key: 'shouldSwipe',
	    value: function shouldSwipe() {
	      var isRejectAccept = this.teamRequestCardHelper.isRejectAccept(this.request);
	      var isDiscard = this.teamRequestCardHelper.isDiscard(this.request);
	      return this.isMobileApp && (isRejectAccept || isDiscard);
	    }
	  }, {
	    key: 'initSwipe',
	    value: function initSwipe() {
	      var _this = this;
	
	      this.timeout(function () {
	        var swiper = new _swipe2.default(_this.getCardSelector());
	        swiper.onLeft(function (event) {
	          return _this.onSwipeLeft(event);
	        });
	        swiper.onRight(function (event) {
	          return _this.onSwipeRight(event);
	        });
	        swiper.run();
	      });
	    }
	  }, {
	    key: 'onSwipeRight',
	    value: function onSwipeRight() {
	      var _this2 = this;
	
	      this.timeout(function () {
	        _this2.swiped = false;
	      });
	    }
	  }, {
	    key: 'onSwipeLeft',
	    value: function onSwipeLeft() {
	      var _this3 = this;
	
	      this.timeout(function () {
	        _this3.swiped = true;
	      });
	    }
	  }, {
	    key: 'getCardSelector',
	    value: function getCardSelector() {
	      return 'team-request-card .' + this.cardId;
	    }
	  }, {
	    key: 'getCardClass',
	    value: function getCardClass() {
	      var cardClassList = [this.request.type];
	
	      if (this.isMobileApp) {
	        cardClassList.push('responsiveMobile');
	      }
	
	      if (this.swiped) {
	        cardClassList.push('swiped');
	
	        if (this.teamRequestCardHelper.isDiscard(this.request)) {
	          cardClassList.push('discard');
	        }
	      }
	
	      return cardClassList;
	    }
	  }, {
	    key: '_getStatusText',
	    value: function _getStatusText() {
	      if (this.request.status !== _request.Request.STATUS_REQUESTED.APPROVE) {
	        return _request.Request.getTranslation(this.request.status);
	      }
	    }
	  }, {
	    key: '_initImage',
	    value: function _initImage() {
	      if (this.request.image === _constants.HR_ERRORS.NOT_AVAILABLE) {
	        delete this.request.image;
	      }
	    }
	  }, {
	    key: '_initAvailableDays',
	    value: function _initAvailableDays() {
	      if (this.request.availableDays === _constants.HR_ERRORS.NOT_EXISTS) {
	        this.request.availableDays = _constants.HR_ERRORS.DEFAULT_VISIBLE_TEXT;
	      }
	    }
	  }, {
	    key: '_initStatus',
	    value: function _initStatus() {
	      var HR_HAS_INCONSISTENT_STATUS = this.request.status === 'without status';
	      if (HR_HAS_INCONSISTENT_STATUS) {
	        this.request.status = _constants.HR_ERRORS.DEFAULT_VISIBLE_TEXT;
	        return;
	      }
	
	      var HR_HAS_INCONGRUENT_VACATIONS_DISCARD = this.request.type === _request.Request.TYPES.VACATION && this.request.status === _request.Request.STATUS_REQUESTED.DISCARD;
	      if (HR_HAS_INCONGRUENT_VACATIONS_DISCARD) {
	        this.request.status = _constants.HR_ERRORS.DEFAULT_VISIBLE_TEXT;
	        return;
	      }
	    }
	  }, {
	    key: '_initRequestDate',
	    value: function _initRequestDate() {
	      if ((0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.request.requestDate)) {
	        this.request.requestDate = _constants.HR_ERRORS.DEFAULT_VISIBLE_TEXT;
	      }
	    }
	  }, {
	    key: 'inceptEmployee',
	    value: function inceptEmployee(employeeId) {
	      var _this4 = this;
	
	      this._getDelegations().then(function () {
	        if (_this4.hasDelegated) {
	          return _this4._showModalWarningDelegation();
	        }
	
	        _this4.inceptionService.incept(employeeId, 'team-requests');
	      });
	    }
	  }, {
	    key: '_getDelegations',
	    value: function _getDelegations() {
	      var _this5 = this;
	
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	      return this.vacationDelegationService.hasDelegated(this.managerId).then(function (response) {
	        _this5.hasDelegated = response.hasDelegated;
	        if (_this5.hasDelegated) {
	          _this5.delegation = _this5.vacationDelegationService.findDelegationActive(today, response.delegations);
	        }
	      });
	    }
	  }, {
	    key: '_showModalWarningDelegation',
	    value: function _showModalWarningDelegation() {
	      this.modalWarningDelegation.modal('show');
	    }
	  }, {
	    key: '_disableInceptionInCoincidencesIfHasDelegations',
	    value: function _disableInceptionInCoincidencesIfHasDelegations() {
	      var _this6 = this;
	
	      this._getDelegations().then(function () {
	        _this6.isDisabledInceptionByDelegation = _this6.hasDelegated;
	      });
	    }
	  }, {
	    key: 'accept',
	    value: function accept() {
	      var _this7 = this;
	
	      this.loadingMobileService.show();
	
	      this.teamRequestsService.approve(this.managerId, this.request).then(function () {
	        _this7.log.info('TeamRequestCardController accept()', _this7.request);
	        _this7._showModalAcceptSuccess();
	      }).catch(function (error) {
	        _this7.log.error('TeamRequestCardController approve():', _this7.managerId, _this7.request, error);
	        _this7._showModalAcceptError(error);
	      }).finally(function () {
	        return _this7.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '_showModalAcceptSuccess',
	    value: function _showModalAcceptSuccess() {
	      this.showSuccess = true;
	      this._getApproveModal().modal('show');
	    }
	  }, {
	    key: '_showModalAcceptError',
	    value: function _showModalAcceptError(error) {
	      this.error = error;
	      this._getApproveModal().modal('show');
	    }
	  }, {
	    key: '_initResetApproveModal',
	    value: function _initResetApproveModal() {
	      var _this8 = this;
	
	      this._getApproveModal().on('hidden.bs.modal', function () {
	        _this8.showSuccess = null;
	        _this8.error = null;
	      });
	    }
	  }, {
	    key: '_getApproveModal',
	    value: function _getApproveModal() {
	      return $('' + _constants2.MODALS.TEAM_REQUESTS.APPROVE + this.modalId);
	    }
	  }, {
	    key: 'reject',
	    value: function reject() {
	      this.log.info('reject()', this.request, 'show confirm modal ...');
	      this.withDelegation ? this.confirmReject() : this._getRemoveModal().modal('show');
	    }
	  }, {
	    key: 'confirmReject',
	    value: function confirmReject() {
	      var _this9 = this;
	
	      this.loadingMobileService.show();
	
	      this.teamRequestsService.reject(this.managerId, this.request).then(function () {
	        _this9.rejectCardSuccess = true;
	      }).catch(function (error) {
	        _this9.rejectCardError = error;
	        _this9._getRemoveModal().modal('show');
	      }).finally(function () {
	        return _this9.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '_getRemoveModal',
	    value: function _getRemoveModal() {
	      return $('' + _constants2.MODALS.TEAM_REQUESTS.REMOVE + this.modalId);
	    }
	  }, {
	    key: 'discard',
	    value: function discard() {
	      var _this10 = this;
	
	      this.loadingMobileService.show();
	
	      this.teamRequestsService.discard(this.managerId, this.request).then(function () {
	        _this10.log.info('TeamRequestCardController discard()', _this10.managerId, _this10.request);
	        _this10.onDiscard();
	      }).catch(function (error) {
	        _this10.log.error('TeamRequestCardController discard():', _this10.managerId, _this10.request, error);
	        _this10._showModalAcceptError(error);
	      }).finally(function () {
	        return _this10.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'existEndDate',
	    value: function existEndDate() {
	      return !!this.endDate;
	    }
	  }, {
	    key: 'modalWarningDelegation',
	    get: function get() {
	      var $modal = $(_constants2.MODALS.WARNING_DELEGATION_MODAL);
	      return $modal;
	    }
	  }]);
	  return TeamRequestCardController;
	}();
	
	exports.default = TeamRequestCardController;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	var _request = __webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestCardHelper = function () {
	  function TeamRequestCardHelper() {
	    (0, _classCallCheck3.default)(this, TeamRequestCardHelper);
	  }
	
	  (0, _createClass3.default)(TeamRequestCardHelper, [{
	    key: 'isHourly',
	    value: function isHourly(request) {
	      return request.hours !== undefined && request.hours !== null && request.hours > 0;
	    }
	  }, {
	    key: 'hasObservations',
	    value: function hasObservations(request) {
	      return !(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(request.remarks);
	    }
	  }, {
	    key: 'isRejectAccept',
	    value: function isRejectAccept(request) {
	      return request.status === _request.Request.STATUS_REQUESTED.APPROVE || request.status === _request.Request.STATUS_REQUESTED.DELETE;
	    }
	  }, {
	    key: 'isDiscard',
	    value: function isDiscard(request) {
	      return request.status === _request.Request.STATUS_REQUESTED.DISCARD;
	    }
	  }, {
	    key: 'showActionTag',
	    value: function showActionTag(request) {
	      return request.status !== _request.Request.STATUS_REQUESTED.APPROVE;
	    }
	  }]);
	  return TeamRequestCardHelper;
	}();
	
	exports.default = TeamRequestCardHelper;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1191);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCard.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-request-card{display:block;margin-bottom:16px}team-request-card.responsiveMobile{margin-left:-30px;margin-right:-30px;margin-bottom:0}team-request-card.responsiveMobile:first-child,team-request-card.responsiveMobile:first-child.shown-filter{margin-top:0}team-request-card.responsiveMobile .request-card{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;transition:left .5s ease;height:122px;padding-top:17px;padding-bottom:0;padding-left:10px;left:0;border-right:0}team-request-card.responsiveMobile .request-card.swiped{left:-140px}team-request-card.responsiveMobile .request-card.swiped.discard{left:-70px}team-request-card.responsiveMobile .request-card .request-avatar{margin-right:17px;margin-top:1px}team-request-card.responsiveMobile .request-card .days-mobile .days{width:38px;display:block;height:32px;font-size:32px;color:#0072c9}team-request-card.responsiveMobile .request-card .days-mobile .days-text{font-size:12px;margin-right:0;color:#0072c9;text-transform:lowercase}team-request-card.responsiveMobile .request-card .request-actions-mobile{margin-top:-18px}team-request-card.responsiveMobile .request-card .request-content .request-content-data{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;min-height:76px}team-request-card.responsiveMobile .request-card .request-content .request-content-data .request-content-days{text-align:right;margin-right:15px}team-request-card.responsiveMobile .request-card .request-content .request-applicant-name{font-size:14px}team-request-card.responsiveMobile .request-card .request-content .request-date{font-size:10px}team-request-card.responsiveMobile .request-card .request-content .request-type{font-size:11px}team-request-card.responsiveMobile .request-card .request-content .request-period{font-size:10px}team-request-card.responsiveMobile .request-card .request-content .request-period .period{border-bottom:none}team-request-card.responsiveMobile .request-card .request-content .request-action-tag{font-size:10px;margin-right:11px;width:66px;height:12px;line-height:12px;padding:0}team-request-card.responsiveMobile .request-card .request-content .request-available-days{font-size:11px}team-request-card.responsiveMobile .request-card .request-content .request-observations{-ms-flex-item-align:end;align-self:flex-end;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;-moz-align-items:center;align-items:center;line-height:1.2;max-width:160px}team-request-card.responsiveMobile .request-card .request-content .request-observations .icon{font-size:16px;display:inline-block;margin-right:12px}team-request-card.responsiveMobile .request-card .request-content .request-observations .remark-text{font-family:ArialMT;font-size:10px;color:#287cba}team-request-card.responsiveMobile .request-card .request-content footer{margin-top:0;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}team-request-card:first-child{margin-top:25px}team-request-card:first-child.shown-filter{margin-top:0}team-request-card .vacation{border-left:12px solid #52bcec}team-request-card .absence{border-left:12px solid #fdbd2c}team-request-card .request-card{position:relative;height:140px;padding:25px 1.5% 0 27px;border-top:1px solid #dddfe2;border-right:1px solid #dddfe2;background-color:#fff;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}team-request-card .request-card .request-avatar{margin-right:25px;margin-top:4px}team-request-card .request-card .request-content{-moz-flex-grow:1;-ms-flex-positive:1;flex-grow:1}team-request-card .request-card .request-content header h1{margin:0;font-size:inherit;height:inherit}team-request-card .request-card .request-content .request-applicant-name{font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9;text-transform:capitalize;display:inline-block}team-request-card .request-card .request-content .request-applicant-name:hover{background-color:transparent;text-decoration:none}team-request-card .request-card .request-content .request-date{font-family:Stag Sans;font-weight:300;font-size:12px;color:#666;margin-left:18px}team-request-card .request-card .request-content .request-type{margin-top:3px;font-family:Stag Sans;font-weight:400;font-size:16px;color:#666}team-request-card .request-card .request-content .request-period{margin-top:1px;font-family:Stag Sans;font-weight:300;font-size:16px;color:#666}team-request-card .request-card .request-content .request-period .period{display:inline-block;border-bottom:1px solid #dddfe2;padding-bottom:2px;text-transform:capitalize}team-request-card .request-card .request-content .request-period .days{font-family:Stag Sans;font-weight:400}team-request-card .request-card .request-content .request-period .days-text{text-transform:lowercase}team-request-card .request-card .request-content footer{margin-top:10px}team-request-card .request-card .request-content .request-action-tag{margin-right:22px;padding:2px;border:.5px solid #dddfe2;background-color:#fbfbfb;width:89px;display:inline-block;text-align:center;font-size:12px;color:#666}team-request-card .request-card .request-content .request-available-days{font-family:Stag Sans;font-weight:300;font-size:14px;color:#666}team-request-card .request-card .request-content .request-available-days .days{font-family:Stag Sans;font-weight:500}team-request-card .request-card .request-actions{-ms-flex-align:center;-moz-align-items:center;align-items:center;height:100%}", ""]);
	
	// exports


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestCardActions = __webpack_require__(1193);
	
	var _teamRequestCardActions2 = _interopRequireDefault(_teamRequestCardActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCardActionsModule = angular.module('vacations-absences.teamRequestCardActions', []).component('teamRequestCardActions', _teamRequestCardActions2.default).name;
	
	exports.default = teamRequestCardActionsModule;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestCardActions = __webpack_require__(1194);
	
	var _teamRequestCardActions2 = _interopRequireDefault(_teamRequestCardActions);
	
	var _teamRequestCardActions3 = __webpack_require__(1195);
	
	var _teamRequestCardActions4 = _interopRequireDefault(_teamRequestCardActions3);
	
	__webpack_require__(1196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCardActionsComponent = {
	  restrict: 'E',
	  bindings: {
	    request: '<',
	    onAccept: '&',
	    onReject: '&',
	    onDiscard: '&',
	    isDisabled: '<'
	  },
	  template: _teamRequestCardActions2.default,
	  controller: _teamRequestCardActions4.default
	};
	
	exports.default = teamRequestCardActionsComponent;

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"$ctrl.getTeamRequestCardActionsClasses()\">\n  <div class=\"request-discard\"\n       ng-class=\"{'cursor-not-allowed': $ctrl.isDisabled}\"\n       ng-if=\"$ctrl.teamRequestCardHelper.isDiscard($ctrl.request)\">\n    <a  href=\"\"\n        ng-class=\"{'remove-pointer-events': $ctrl.isDisabled}\"\n        ng-click=\"$ctrl.onDiscard()\">\n      <span class=\"icon icon-cross\"></span>\n    </a>\n  </div>\n\n  <div class=\"request-observations\"\n       ng-if=\"$ctrl.teamRequestCardHelper.hasObservations($ctrl.request)\">\n    <span class=\"icon icon-insight\"></span>\n    <span class=\"remark-text\">{{$ctrl.request.remarks}}</span>\n  </div>\n\n  <div class=\"request-reject-accept\"\n       ng-if=\"$ctrl.teamRequestCardHelper.isRejectAccept($ctrl.request)\">\n    <button ng-disabled=\"$ctrl.isDisabled\"\n            type=\"button\"\n            class=\"btn btn-app btn-default\"\n            ng-click=\"$ctrl.onReject()\">\n      {{'GLOBALS.BUTTON_ACTION.REJECT' | translate}}\n    </button>\n    <button ng-disabled=\"$ctrl.isDisabled\"\n            type=\"button\"\n            class=\"btn btn-app btn-primary\"\n            ng-click=\"$ctrl.onAccept()\">\n      {{'GLOBALS.BUTTON_ACTION.ACCEPT' | translate}}\n    </button>\n  </div>\n</div>\n"

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _teamRequestCard = __webpack_require__(1189);
	
	var _teamRequestCard2 = _interopRequireDefault(_teamRequestCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestCardActionsController = function () {
	  function TeamRequestCardActionsController() {
	    (0, _classCallCheck3.default)(this, TeamRequestCardActionsController);
	
	    this.teamRequestCardHelper = new _teamRequestCard2.default();
	  }
	
	  (0, _createClass3.default)(TeamRequestCardActionsController, [{
	    key: 'getTeamRequestCardActionsClasses',
	    value: function getTeamRequestCardActionsClasses() {
	      var onlyButtons = this.teamRequestCardHelper.isRejectAccept(this.request) && !this.teamRequestCardHelper.isDiscard(this.request) && !this.teamRequestCardHelper.hasObservations(this.request);
	      return {
	        'team-request-card-actions': true,
	        'only-buttons': onlyButtons
	      };
	    }
	  }]);
	  return TeamRequestCardActionsController;
	}();
	
	exports.default = TeamRequestCardActionsController;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1197);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCardActions.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCardActions.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-request-card-actions .team-request-card-actions{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;height:100%;padding-bottom:16px}team-request-card-actions .team-request-card-actions.only-buttons{-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}team-request-card-actions .team-request-card-actions .request-reject-accept{-ms-flex-item-align:start;align-self:flex-start;padding-bottom:11px}@media(max-width:1000px){team-request-card-actions .team-request-card-actions .request-reject-accept{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;padding-bottom:0}}team-request-card-actions .team-request-card-actions .request-reject-accept .btn{margin-left:23px}@media(max-width:1000px){team-request-card-actions .team-request-card-actions .request-reject-accept .btn{margin-left:0}team-request-card-actions .team-request-card-actions .request-reject-accept .btn.btn-primary{margin-bottom:20px}}team-request-card-actions .team-request-card-actions .request-reject-accept .btn.btn-default,team-request-card-actions .team-request-card-actions .request-reject-accept .btn.btn-primary{width:154px;height:38px;line-height:40px}team-request-card-actions .team-request-card-actions .request-discard{-ms-flex-item-align:end;align-self:flex-end;margin-top:-6px}team-request-card-actions .team-request-card-actions .request-discard a{font-family:ArialMT;font-weight:400;font-size:12px;color:#777676;text-decoration:none;text-transform:uppercase}team-request-card-actions .team-request-card-actions .request-discard a:hover{text-decoration:none;background-color:inherit}team-request-card-actions .team-request-card-actions .request-discard a .icon{color:#aeaeae;font-size:10px;margin-left:4px}team-request-card-actions .team-request-card-actions .request-observations{-ms-flex-item-align:end;align-self:flex-end;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;-moz-align-items:center;align-items:center;max-width:228px;line-height:1.2}team-request-card-actions .team-request-card-actions .request-observations .icon{font-size:30px;display:inline-block;margin-right:12px}team-request-card-actions .team-request-card-actions .request-observations .remark-text{font-family:ArialMT;font-size:14px;color:#287cba}", ""]);
	
	// exports


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _teamRequestCardActionsMobile = __webpack_require__(1199);
	
	var _teamRequestCardActionsMobile2 = _interopRequireDefault(_teamRequestCardActionsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCardActionsMobileModule = _angular2.default.module('teamRequestCardActionsMobile', []).component('teamRequestCardActionsMobile', _teamRequestCardActionsMobile2.default).name;
	
	exports.default = teamRequestCardActionsMobileModule;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestCardActionsMobile = __webpack_require__(1200);
	
	var _teamRequestCardActionsMobile2 = _interopRequireDefault(_teamRequestCardActionsMobile);
	
	var _teamRequestCardActionsMobile3 = __webpack_require__(1201);
	
	var _teamRequestCardActionsMobile4 = _interopRequireDefault(_teamRequestCardActionsMobile3);
	
	__webpack_require__(1202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCardActionsMobileComponent = {
	  restrict: 'E',
	  bindings: {
	    request: '<',
	    onAccept: '&',
	    onReject: '&',
	    onDiscard: '&',
	    isDisabled: '<'
	  },
	  template: _teamRequestCardActionsMobile2.default,
	  controller: _teamRequestCardActionsMobile4.default
	};
	
	exports.default = teamRequestCardActionsMobileComponent;

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"$ctrl.getTeamRequestCardActionsMobileClasses()\">\n  <div class=\"swipe-button remove\"\n       ng-click=\"$ctrl.onReject()\"\n       ng-if=\"$ctrl.teamRequestCardHelper.isRejectAccept($ctrl.request)\">\n    <span class=\"icon-cross-white\"></span>\n  </div>\n  <div class=\"swipe-button edit\"\n       ng-click=\"$ctrl.onAccept()\"\n       ng-if=\"$ctrl.teamRequestCardHelper.isRejectAccept($ctrl.request)\">\n    <span class=\"icon-approved\"><span class=\"path1\"></span><span class=\"path2\"></span></span>\n  </div>\n  <div class=\"swipe-button discard\"\n       ng-click=\"$ctrl.onDiscard()\"\n       ng-if=\"$ctrl.teamRequestCardHelper.isDiscard($ctrl.request)\">\n    <span class=\"icon-icon-trash\"></span>\n  </div>\n</div>\n"

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _teamRequestCard = __webpack_require__(1189);
	
	var _teamRequestCard2 = _interopRequireDefault(_teamRequestCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestCardActionsMobileController = function () {
	  function TeamRequestCardActionsMobileController() {
	    (0, _classCallCheck3.default)(this, TeamRequestCardActionsMobileController);
	
	    this.teamRequestCardHelper = new _teamRequestCard2.default();
	  }
	
	  (0, _createClass3.default)(TeamRequestCardActionsMobileController, [{
	    key: 'getTeamRequestCardActionsMobileClasses',
	    value: function getTeamRequestCardActionsMobileClasses() {
	      var classes = ['mobile-buttons-container'];
	
	      if (this.teamRequestCardHelper.isDiscard(this.request)) {
	        classes.push('discard');
	      }
	
	      return classes;
	    }
	  }]);
	  return TeamRequestCardActionsMobileController;
	}();
	
	exports.default = TeamRequestCardActionsMobileController;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1203);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCardActionsMobile.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCardActionsMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-request-card-actions-mobile .mobile-buttons-container{position:absolute;right:-140px;min-height:122px;float:right;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row}team-request-card-actions-mobile .mobile-buttons-container.discard{right:-70px}team-request-card-actions-mobile .mobile-buttons-container .swipe-button{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;width:70px;height:122px}team-request-card-actions-mobile .mobile-buttons-container .swipe-button span{font-size:24px}team-request-card-actions-mobile .mobile-buttons-container .swipe-button.remove{background:#eaebed}team-request-card-actions-mobile .mobile-buttons-container .swipe-button.remove span{font-size:18px}team-request-card-actions-mobile .mobile-buttons-container .swipe-button.remove span:before{color:#c8175e!important}team-request-card-actions-mobile .mobile-buttons-container .swipe-button.edit{background:#86c82d}team-request-card-actions-mobile .mobile-buttons-container .swipe-button.edit span{font-size:44px}team-request-card-actions-mobile .mobile-buttons-container .swipe-button.discard{background:#0072c9}", ""]);
	
	// exports


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestCardDetails = __webpack_require__(1205);
	
	var _teamRequestCardDetails2 = _interopRequireDefault(_teamRequestCardDetails);
	
	var _teamRequestCoincidences = __webpack_require__(1210);
	
	var _teamRequestCoincidences2 = _interopRequireDefault(_teamRequestCoincidences);
	
	var _teamRequestCoincidencesMobile = __webpack_require__(1216);
	
	var _teamRequestCoincidencesMobile2 = _interopRequireDefault(_teamRequestCoincidencesMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCardDetailsModule = angular.module('vacations-absences.teamRequestCardDetails', [_teamRequestCoincidences2.default, _teamRequestCoincidencesMobile2.default]).component('teamRequestCardDetails', _teamRequestCardDetails2.default).name;
	
	exports.default = teamRequestCardDetailsModule;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestCardDetails = __webpack_require__(1206);
	
	var _teamRequestCardDetails2 = _interopRequireDefault(_teamRequestCardDetails);
	
	var _teamRequestCardDetails3 = __webpack_require__(1207);
	
	var _teamRequestCardDetails4 = _interopRequireDefault(_teamRequestCardDetails3);
	
	__webpack_require__(1208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCardDetailsComponent = {
	  restrict: 'E',
	  bindings: {
	    request: '<',
	    isDisabled: '<',
	    isDisabledByDelegation: '<',
	    showModalWarningDelegation: '&',
	    isMobileApp: '<'
	  },
	  template: _teamRequestCardDetails2.default,
	  controller: _teamRequestCardDetails4.default
	};
	
	exports.default = teamRequestCardDetailsComponent;

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"request-details\"\n     ng-class=\"{responsiveMobile: $ctrl.responsiveMobile}\">\n\n  <header ng-class=\"$ctrl.getCardClass()\">\n    <h1>\n      <a href=\"\"\n         title=\"{{'VACATIONS_ABSENCES.TEAM_REQUESTS.COINCIDENCES.DETAILS_TITLE' | translate}}\"\n         ng-click=\"$ctrl.toggle()\">\n\n        <span ng-if=\"!$ctrl.isMobileApp\">{{'GLOBALS.BUTTON_ACTION.DETAILS' | translate}}</span>\n\n        <span ng-if=\"!$ctrl.isOpen()\" class=\"icon icon-arrow-select-down\"></span>\n\n        <span ng-if=\"$ctrl.isOpen()\" class=\"icon icon-arrow-select-up\"></span>\n\n      </a>\n    </h1>\n  </header>\n\n</div>\n\n<section class=\"request-details-content\"\n         ng-if=\"$ctrl.isOpen()\"\n         ng-class=\"$ctrl.getRequestDetailContentClasses()\">\n\n  <team-request-coincidences ng-if=\"!$ctrl.isMobileApp\"\n                             request=\"$ctrl.request\"\n                             is-disabled=\"$ctrl.isDisabled\"\n                             is-disabled-by-delegation=\"$ctrl.isDisabledByDelegation\"\n                             show-modal-warning-delegation=\"$ctrl.showModalWarningDelegation()\">\n  </team-request-coincidences>\n\n  <team-request-coincidences-mobile ng-if=\"$ctrl.isMobileApp\"\n                                    request=\"$ctrl.request\">\n  </team-request-coincidences-mobile>\n\n</section>\n"

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _teamRequestCardDetails = __webpack_require__(1182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestCardDetailsController = function () {
	  TeamRequestCardDetailsController.$inject = ["$log", "$scope"];
	  function TeamRequestCardDetailsController($log, $scope) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, TeamRequestCardDetailsController);
	    this.open = false;
	
	    $scope.$on(_teamRequestCardDetails.HIDE_DETAIL, function () {
	      _this.open = false;
	    });
	  }
	
	  (0, _createClass3.default)(TeamRequestCardDetailsController, [{
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.open === true;
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.open = !this.open;
	    }
	  }, {
	    key: 'getCardClass',
	    value: function getCardClass() {
	      var classes = [this.request.type];
	
	      if (this.isMobileApp) {
	        classes.push('responsiveMobile');
	      }
	
	      return classes;
	    }
	  }, {
	    key: 'getRequestDetailContentClasses',
	    value: function getRequestDetailContentClasses() {
	      return {
	        responsiveMobile: this.isMobileApp
	      };
	    }
	  }]);
	  return TeamRequestCardDetailsController;
	}();
	
	exports.default = TeamRequestCardDetailsController;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1209);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCardDetails.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCardDetails.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-request-card-details{display:block}team-request-card-details .request-details.responsiveMobile header h1 a{margin-right:0}team-request-card-details .request-details header{height:30px}team-request-card-details .request-details header.vacation{border-left:12px solid #52bcec}team-request-card-details .request-details header.absence{border-left:12px solid #fdbd2c}team-request-card-details .request-details header.responsiveMobile{border-left:0!important;height:26px}team-request-card-details .request-details header.responsiveMobile h1{border:0!important}team-request-card-details .request-details header h1{margin:0;font-size:inherit;height:inherit;line-height:32px;text-align:center;background-color:#f2f3f4;border-bottom:1px solid #dddfe2;border-right:1px solid #dddfe2}team-request-card-details .request-details header h1 a{margin-right:8px;font-family:Stag Sans;font-weight:400;color:#0072c9;font-size:15px;text-decoration:none}team-request-card-details .request-details header h1 a:hover{text-decoration:none;background-color:inherit}team-request-card-details .request-details header h1 a .icon{font-size:12px;vertical-align:middle;margin-left:6px}team-request-card-details .request-details-content{background-color:#fbfbfb;height:100%;min-height:250px}team-request-card-details .request-details-content.responsiveMobile{min-height:0}", ""]);
	
	// exports


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestCoincidences = __webpack_require__(1211);
	
	var _teamRequestCoincidences2 = _interopRequireDefault(_teamRequestCoincidences);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCoincidencesModule = angular.module('vacations-absences.teamRequestCoincidences', []).component('teamRequestCoincidences', _teamRequestCoincidences2.default).name;
	
	exports.default = teamRequestCoincidencesModule;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestCoincidences = __webpack_require__(1212);
	
	var _teamRequestCoincidences2 = _interopRequireDefault(_teamRequestCoincidences);
	
	var _teamRequestCoincidences3 = __webpack_require__(1213);
	
	var _teamRequestCoincidences4 = _interopRequireDefault(_teamRequestCoincidences3);
	
	__webpack_require__(1214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCoincidencesComponent = {
	  restrict: 'E',
	  bindings: {
	    request: '<',
	    isDisabled: '<',
	    isDisabledByDelegation: '<',
	    showModalWarningDelegation: '&'
	  },
	  template: _teamRequestCoincidences2.default,
	  controller: _teamRequestCoincidences4.default
	};
	
	exports.default = teamRequestCoincidencesComponent;

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

	module.exports = "<div ng-show=\"$ctrl.loaded\">\n\n  <div class=\"request-widget\" ng-if=\"$ctrl.shouldDisplayList()\">\n    <div>\n      <calendar-inline-paginator\n        date=\"$ctrl.date\"\n        id=\"$ctrl.ids\"\n        next-page=\"$ctrl.nextPage()\"\n        prev-page=\"$ctrl.prevPage()\">\n      </calendar-inline-paginator>\n    </div>\n    <div class=\"content\">\n      <div class=\"cards\">\n        <div class=\"card\" ng-repeat=\"employee in $ctrl.periodInDays\">\n          <calendar-inline-card employee=\"employee\" incept-employee=\"$ctrl.inceptEmployee($event)\" is-disabled=\"$ctrl.isDisabled\"></calendar-inline-card>\n        </div>\n      </div>\n      <div class=\"calendars\">\n        <calendar-inline-header id=\"$ctrl.ids\" date=\"$ctrl.date\"></calendar-inline-header>\n        <div class=\"calendar-inline-row\" ng-repeat=\"event in $ctrl.periodInDays \">\n          <calendar-inline id=\"event.periodInDays[0].periodId\" events=\"event.periodInDays\" date=\"$ctrl.date\">\n          </calendar-inline>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"request-widget\" ng-if=\"$ctrl.shouldDisplayNoCoincidences()\">\n    <div class=\"list-empty\">\n      <span class=\"icon-warning\"></span>\n      <span>{{'VACATIONS_ABSENCES.REQUEST_COINCIDENCES.NOT_FOUND' | translate}}</span>\n    </div>\n  </div>\n\n</div>\n\n<loading ng-show=\"!$ctrl.loaded\"></loading>\n"

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dateUtils = __webpack_require__(1132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCoincidencesController = function () {
	  teamRequestCoincidencesController.$inject = ["$rootScope", "$scope", "$timeout", "teamRequestsService", "vacationUserDataService", "inceptionService"];
	  function teamRequestCoincidencesController($rootScope, $scope, $timeout, teamRequestsService, vacationUserDataService, inceptionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, teamRequestCoincidencesController);
	    this.rootScope = $rootScope;
	    this.inceptionService = inceptionService;
	    this.scope = $scope;
	    this.timeout = $timeout;
	    this.teamRequestsService = teamRequestsService;
	    this.managerId = vacationUserDataService.getEmployee().userId;
	    this.loaded = false;
	  }
	
	  (0, _createClass3.default)(teamRequestCoincidencesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.id = this.createId();
	      this.request.endDate = this.request.endDate || (0, _moment2.default)().format('YYYY-MM-DD');
	
	      this.teamRequestsService.getCoincidences(this.managerId, this.request.startDate, this.request.endDate).then(function (response) {
	        _this.coincidences = response;
	        _this.loaded = true;
	
	        if (_this.coincidences.length === 0) {
	          return;
	        }
	
	        _this.date = _this.getDateOfFirstCoincidence(_this.request, _this.coincidences);
	        _this.periodInDays = _this.loadPeriodInDays();
	      });
	    }
	  }, {
	    key: 'getDateOfFirstCoincidence',
	    value: function getDateOfFirstCoincidence(request, coincidences) {
	      var email = request.email;
	      var firstCoincidence = void 0;
	
	      coincidences.forEach(function (coincidence) {
	        var sameEmail = email === coincidence.email;
	        var coincidenceBefore = coincidence.startDate < firstCoincidence;
	
	        if (!sameEmail && (!firstCoincidence || coincidenceBefore)) {
	          firstCoincidence = coincidence.startDate;
	        }
	      });
	
	      return new Date(firstCoincidence);
	    }
	  }, {
	    key: 'isAnyCoincidences',
	    value: function isAnyCoincidences() {
	      if (!this.periodInDays) return false;
	      var coincidencesExist = false;
	      if (this.periodInDays.length !== 0) coincidencesExist = true;
	      return coincidencesExist;
	    }
	  }, {
	    key: 'shouldDisplayList',
	    value: function shouldDisplayList() {
	      if (!this.loaded) return false;
	
	      return this.isAnyCoincidences();
	    }
	  }, {
	    key: 'shouldDisplayNoCoincidences',
	    value: function shouldDisplayNoCoincidences() {
	      return this.loaded === true && !this.shouldDisplayList();
	    }
	  }, {
	    key: 'loadPeriodInDays',
	    value: function loadPeriodInDays() {
	      var _this2 = this;
	
	      this.ids = [];
	      var list = [];
	      var id = this.createId();
	      var iconDays = (0, _dateUtils.returnIconDays)(this.coincidences);
	      this.coincidences.map(function (item) {
	        var name = item.name;
	        var daysAvailables = item.daysAvailables;
	        var email = item.email;
	        var employeeId = item.employeeId;
	        var startDate = item.startDate || item.date;
	        var endDate = item.endDate || item.date || new Date();
	        var status = item.status || '';
	        var periodId = id++;
	        var type = item.type || '';
	        var code = item.code || '';
	        var periodInDays = (0, _dateUtils.fromRangeToArray)(startDate, endDate, status, periodId, type, code, iconDays);
	
	        if (_this2.ifObjectExists(list, periodInDays, employeeId)) {
	          _this2.insertDays(list, periodInDays, employeeId);
	        } else {
	          _this2.insertNewObject(list, employeeId, name, daysAvailables, periodInDays, periodId, email);
	        }
	      });
	
	      return list;
	    }
	  }, {
	    key: 'ifObjectExists',
	    value: function ifObjectExists(list, periodInDays, employeeId) {
	      return list.find(function (obj) {
	        return obj.employeeId === employeeId;
	      });
	    }
	  }, {
	    key: 'insertDays',
	    value: function insertDays(list, periodInDays, employeeId) {
	      list.forEach(function (obj) {
	        if (obj.employeeId === employeeId) {
	          periodInDays.forEach(function (day) {
	            obj.periodInDays.push(day);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'insertNewObject',
	    value: function insertNewObject(list, employeeId, name, daysAvailables, periodInDays, periodId, email) {
	      var object = { employeeId: employeeId, name: name, daysAvailables: daysAvailables, periodInDays: periodInDays, email: email };
	      list.push(object);
	      this.setRowIds(periodId);
	    }
	  }, {
	    key: 'setRowIds',
	    value: function setRowIds(periodId) {
	      this.ids.push(periodId);
	    }
	  }, {
	    key: 'nextPage',
	    value: function nextPage() {
	      var currentMonth = this.date.getMonth();
	      this.date = new Date(this.date.getFullYear(), currentMonth + 1, 1);
	    }
	  }, {
	    key: 'prevPage',
	    value: function prevPage() {
	      var currentMonth = this.date.getMonth();
	      this.date = new Date(this.date.getFullYear(), currentMonth - 1, 1);
	    }
	  }, {
	    key: 'generateIdFromPeriod',
	    value: function generateIdFromPeriod(startDate, endDate) {
	      var millenium = 2000;
	      var generatedId = startDate[0] - millenium + startDate[1] + endDate[2];
	      return generatedId;
	    }
	  }, {
	    key: 'createId',
	    value: function createId() {
	      var startDate = this.request.startDate.split('-');
	      var today = new Date();
	      var endDate = [today.getDay(), today.getMonth(), today.getFullYear()];
	      if (this.request.endDate) {
	        endDate = this.request.endDate.split('-');
	      }
	      var constructId = this.generateIdFromPeriod(startDate, endDate);
	      var hash = '' + this.request.employeeId + constructId;
	      return hash;
	    }
	  }, {
	    key: 'inceptEmployee',
	    value: function inceptEmployee($event) {
	      if (this.isDisabledByDelegation) {
	        return this.showModalWarningDelegation();
	      }
	
	      this.inceptionService.incept($event.employeeId, 'team-requests');
	    }
	  }]);
	  return teamRequestCoincidencesController;
	}();
	
	exports.default = teamRequestCoincidencesController;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1215);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCoincidences.scss", function() {
				var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCoincidences.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-request-coincidences{display:block}team-request-coincidences .request-widget{margin-left:20.5px;margin-right:20.5px;height:auto;background-color:#fff;margin-bottom:33px;min-height:200px}team-request-coincidences calendar-inline{min-height:10px}team-request-coincidences calendar-inline-card{position:relative;top:1px}team-request-coincidences calendar-inline-paginator .head{border-top:none}team-request-coincidences calendar-inline-paginator .head .month{position:relative;left:30%;top:30%;letter-spacing:1px}team-request-coincidences td{max-height:60px}team-request-coincidences .calendar-inline-row{box-shadow:0 1px 3px 0 hsla(220,8%,92%,.5);margin-bottom:9px}team-request-coincidences .content{display:flex}team-request-coincidences .calendars{overflow-x:auto;margin-left:64px}team-request-coincidences .cards{position:relative;top:40px;max-width:170px}team-request-coincidences .card{margin-bottom:9px}team-request-coincidences .list-empty{margin-top:0;padding-top:40px;padding-bottom:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9;background-color:#fff}team-request-coincidences .list-empty.shown-filter{margin-top:0}team-request-coincidences .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _teamRequestCoincidencesMobile = __webpack_require__(1217);
	
	var _teamRequestCoincidencesMobile2 = _interopRequireDefault(_teamRequestCoincidencesMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCoincidencesMobileModule = _angular2.default.module('teamRequestCoincidencesMobile', []).component('teamRequestCoincidencesMobile', _teamRequestCoincidencesMobile2.default).name;
	
	exports.default = teamRequestCoincidencesMobileModule;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestCoincidencesMobile = __webpack_require__(1218);
	
	var _teamRequestCoincidencesMobile2 = _interopRequireDefault(_teamRequestCoincidencesMobile);
	
	var _teamRequestCoincidencesMobile3 = __webpack_require__(1219);
	
	var _teamRequestCoincidencesMobile4 = _interopRequireDefault(_teamRequestCoincidencesMobile3);
	
	__webpack_require__(1220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestCoincidencesMobileComponent = {
	  restrict: 'E',
	  bindings: {
	    request: '<'
	  },
	  template: _teamRequestCoincidencesMobile2.default,
	  controller: _teamRequestCoincidencesMobile4.default
	};
	
	exports.default = teamRequestCoincidencesMobileComponent;

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

	module.exports = "<div>\n\n  <section ng-if=\"$ctrl.isLoaded() && $ctrl.showCoincidences()\"\n           class=\"team-request-coincidences-mobile\">\n    <h3 class=\"coincidences-title\">\n      {{'VACATIONS_ABSENCES.TEAM_REQUESTS.COINCIDENCES.TITLE' | translate}}\n    </h3>\n    <div class=\"coincidence\"\n         ng-repeat=\"coincidence in $ctrl.coincidences\">\n      <p class=\"coincidences-name\">\n        {{coincidence.name}}\n      </p>\n      <p class=\"coincidences-dates\">\n        {{coincidence.startDate}} -\n      </p>\n      <p class=\"coincidences-dates\">\n        {{coincidence.endDate}}\n      </p>\n    </div>\n  </section>\n\n  <section ng-if=\"$ctrl.isLoaded() && !$ctrl.showCoincidences()\">\n    <div class=\"list-empty\">\n      <span class=\"icon-warning\"></span>\n      <span>{{'VACATIONS_ABSENCES.REQUEST_COINCIDENCES.NOT_FOUND' | translate}}</span>\n    </div>\n  </section>\n\n</div>\n"

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestCoincidencesMobileController = function () {
	  TeamRequestCoincidencesMobileController.$inject = ["teamRequestsService", "vacationUserDataService", "loadingMobileService"];
	  function TeamRequestCoincidencesMobileController(teamRequestsService, vacationUserDataService, loadingMobileService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamRequestCoincidencesMobileController);
	    this.teamRequestsService = teamRequestsService;
	    this.managerId = vacationUserDataService.getEmployee().userId;
	    this.loadingMobileService = loadingMobileService;
	
	    this.loaded = false;
	    this.coincidences = [];
	  }
	
	  (0, _createClass3.default)(TeamRequestCoincidencesMobileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.loadingMobileService.show();
	      this.request.endDate = this.request.endDate || (0, _moment2.default)().format('YYYY-MM-DD');
	      this.teamRequestsService.getCoincidences(this.managerId, this.request.startDate, this.request.endDate).then(function (response) {
	        _this.coincidences = response;
	        _this.loaded = true;
	      }).finally(function () {
	        return _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.loaded === true;
	    }
	  }, {
	    key: 'showCoincidences',
	    value: function showCoincidences() {
	      return this.coincidences.length > 0;
	    }
	  }]);
	  return TeamRequestCoincidencesMobileController;
	}();
	
	exports.default = TeamRequestCoincidencesMobileController;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1221);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCoincidencesMobile.scss", function() {
				var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestCoincidencesMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-request-coincidences-mobile .team-request-coincidences-mobile{padding:22px 58px;background:#f9f9f9}team-request-coincidences-mobile .team-request-coincidences-mobile .coincidence{padding-top:7px;padding-bottom:7px;border-bottom:1px solid #dddfe2}team-request-coincidences-mobile .team-request-coincidences-mobile .coincidences-dates,team-request-coincidences-mobile .team-request-coincidences-mobile .coincidences-name,team-request-coincidences-mobile .team-request-coincidences-mobile .coincidences-title{font-weight:400;font-size:12px;font-family:Stag Sans}team-request-coincidences-mobile .team-request-coincidences-mobile .coincidences-title{color:#0072c9;margin:0 0 10px}team-request-coincidences-mobile .team-request-coincidences-mobile .coincidences-name{color:#666;margin-bottom:5px}team-request-coincidences-mobile .team-request-coincidences-mobile .coincidences-dates{color:#666;margin-bottom:2px;font-size:10px;font-weight:300}team-request-coincidences-mobile .list-empty{margin-top:0;padding:30px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:14px;color:#0072c9}team-request-coincidences-mobile .list-empty .icon-warning{font-size:52px;vertical-align:middle;margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestModalApprove = __webpack_require__(1223);
	
	var _teamRequestModalApprove2 = _interopRequireDefault(_teamRequestModalApprove);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestModalApproveModule = angular.module('vacations-absences.teamRequestModalApprove', []).component('teamRequestModalApprove', _teamRequestModalApprove2.default).name;
	
	exports.default = teamRequestModalApproveModule;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestModalApprove = __webpack_require__(1224);
	
	var _teamRequestModalApprove2 = _interopRequireDefault(_teamRequestModalApprove);
	
	var _teamRequestModalApprove3 = __webpack_require__(1225);
	
	var _teamRequestModalApprove4 = _interopRequireDefault(_teamRequestModalApprove3);
	
	__webpack_require__(1226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestModalApproveComponent = {
	  restrict: 'E',
	  bindings: {
	    modalId: '@',
	    request: '<',
	    showSuccess: '<',
	    error: '<',
	    onAccept: '&',
	    delegation: '<',
	    isMobileApp: '<'
	  },
	  template: _teamRequestModalApprove2.default,
	  controller: _teamRequestModalApprove4.default
	};
	
	exports.default = teamRequestModalApproveComponent;

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalTeamRequestApprove{{$ctrl.modalId}}\"\n     tabindex=\"-1\"\n     role=\"dialog\"\n     aria-labelledby=\"modalTeamRequestApproveLabel\"\n     ng-class=\"{'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp}\">\n\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <successful-action\n      ng-if=\"$ctrl.isSuccess()\"\n      description-big\n      close-modal=\"true\"\n      modal-id=\"modalTeamRequestApproveOnSuccess\"\n      title=\"{{ 'VACATIONS_ABSENCES.TEAM_REQUESTS.APPROVE_TITLE' | translate }}\"\n      message=\"{{$ctrl.message}}\"\n      on-dismiss=\"$ctrl.onAccept()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"></successful-action>\n\n   <failed-action\n     ng-if=\"$ctrl.isError()\"\n     modal-id=\"modalTeamRequestApproveOnError\"\n     close-modal=\"true\"\n     title=\"{{ 'GLOBALS.ATTENTION' | translate }}\"\n     description=\"{{ $ctrl.error.data.message || ('TEAM_REQUESTS.APPROVE_ERROR_MESSAGE' | translate)}}\"\n     button-text=\"{{'GLOBALS.BUTTON_ACTION.OK_GOT_IT' | translate}}\"\n     is-mobile-app=\"$ctrl.isMobileApp\"></failed-action>\n\n  </div>\n</div>\n"

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _teamRequests = __webpack_require__(1176);
	
	var _teamRequests2 = _interopRequireDefault(_teamRequests);
	
	var _dateUtils = __webpack_require__(1132);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestModalApproveController = function () {
	  TeamRequestModalApproveController.$inject = ["$translate", "$q"];
	  function TeamRequestModalApproveController($translate, $q) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamRequestModalApproveController);
	    this.translate = $translate;
	    this.q = $q;
	    this.formatter = new _teamRequests2.default();
	  }
	
	  (0, _createClass3.default)(TeamRequestModalApproveController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.translateKeys().then(function (_ref) {
	        var daysLiteral = _ref.daysLiteral,
	            hoursLiteral = _ref.hoursLiteral;
	
	        _this.daysLiteral = daysLiteral;
	        _this.hoursLiteral = hoursLiteral;
	        _this._getRequestInfo();
	      });
	    }
	  }, {
	    key: 'isError',
	    value: function isError() {
	      return !(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.error);
	    }
	  }, {
	    key: 'isDelegated',
	    value: function isDelegated() {
	      return this.delegation === true;
	    }
	  }, {
	    key: 'isSuccess',
	    value: function isSuccess() {
	      return this.showSuccess === true;
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;
	
	      return this.q(function (resolve) {
	        _this2.translate('GLOBALS.DAYS').then(function (daysLiteral) {
	          _this2.translate('GLOBALS.HOURS').then(function (hoursLiteral) {
	            resolve({ daysLiteral: daysLiteral, hoursLiteral: hoursLiteral });
	          });
	        });
	      });
	    }
	  }, {
	    key: '_getRequestInfo',
	    value: function _getRequestInfo() {
	      this.message = this.formatter.formatRequestInfo(this.request, _dateUtils.formatDateForView, this.daysLiteral, this.hoursLiteral);
	    }
	  }]);
	  return TeamRequestModalApproveController;
	}();
	
	exports.default = TeamRequestModalApproveController;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1227);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestModalApprove.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestModalApprove.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-request-modal-approve{display:block}team-request-modal-approve .modal-dialog{width:520px}team-request-modal-approve successful-action .description{margin-bottom:28px!important}team-request-modal-approve successful-action .description h1{margin-top:9px;font-size:18px;font-family:Stag Sans;font-weight:400;margin-bottom:5px}team-request-modal-approve successful-action .description p{margin-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestModalRemove = __webpack_require__(1229);
	
	var _teamRequestModalRemove2 = _interopRequireDefault(_teamRequestModalRemove);
	
	var _teamRequestModalRemoveQuestion = __webpack_require__(1234);
	
	var _teamRequestModalRemoveQuestion2 = _interopRequireDefault(_teamRequestModalRemoveQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestModalRemoveModule = angular.module('vacations-absences.teamRequestModalRemove', [_teamRequestModalRemoveQuestion2.default]).component('teamRequestModalRemove', _teamRequestModalRemove2.default).name;
	
	exports.default = teamRequestModalRemoveModule;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestModalRemove = __webpack_require__(1230);
	
	var _teamRequestModalRemove2 = _interopRequireDefault(_teamRequestModalRemove);
	
	var _teamRequestModalRemove3 = __webpack_require__(1231);
	
	var _teamRequestModalRemove4 = _interopRequireDefault(_teamRequestModalRemove3);
	
	__webpack_require__(1232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestModalRemoveComponent = {
	  restrict: 'E',
	  bindings: {
	    modalId: '@',
	    request: '<',
	    showSuccess: '<',
	    error: '<',
	    onConfirm: '&',
	    onReject: '&',
	    isMobileApp: '<'
	  },
	  template: _teamRequestModalRemove2.default,
	  controller: _teamRequestModalRemove4.default
	};
	
	exports.default = teamRequestModalRemoveComponent;

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalTeamRequestRemove{{$ctrl.modalId}}\"\n     tabindex=\"-1\"\n     role=\"dialog\"\n     aria-labelledby=\"modalTeamRequestRemoveLabel\"\n     ng-class=\"{'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp}\">\n\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <team-request-modal-remove-question\n      ng-if=\"$ctrl.isQuestion()\"\n      message=\"{{$ctrl.message}}\"\n      on-confirm=\"$ctrl.onConfirm()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"></team-request-modal-remove-question>\n\n    <successful-action\n      ng-if=\"$ctrl.isSuccess()\"\n      description-big\n      close-modal=\"true\"\n      modal-id=\"modalTeamRequestRemoveOnSuccess\"\n      title=\"{{ 'VACATIONS_ABSENCES.TEAM_REQUESTS.REJECT.OK_TITLE' | translate }}\"\n      message=\"{{$ctrl.message}}\"\n      on-dismiss=\"$ctrl.onReject()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"></successful-action>\n\n   <failed-action\n     ng-if=\"$ctrl.isError()\"\n     modal-id=\"modalTeamRequestRemoveOnError\"\n     close-modal=\"true\"\n     title=\"{{ 'GLOBALS.ATTENTION' | translate }}\"\n     description=\"{{ $ctrl.error.data.message || ('VACATIONS_ABSENCES.TEAM_REQUESTS.APPROVE_ERROR_MESSAGE' | translate)}}\"\n     button-text=\"{{'GLOBALS.BUTTON_ACTION.OK_GOT_IT' | translate}}\"\n     is-mobile-app=\"$ctrl.isMobileApp\"></failed-action>\n\n  </div>\n</div>\n"

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _teamRequests = __webpack_require__(1176);
	
	var _teamRequests2 = _interopRequireDefault(_teamRequests);
	
	var _dateUtils = __webpack_require__(1132);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestModalRemoveController = function () {
	  TeamRequestModalRemoveController.$inject = ["$translate", "$q"];
	  function TeamRequestModalRemoveController($translate, $q) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamRequestModalRemoveController);
	    this.translate = $translate;
	    this.q = $q;
	    this.formatter = new _teamRequests2.default();
	  }
	
	  (0, _createClass3.default)(TeamRequestModalRemoveController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.translateKeys().then(function (_ref) {
	        var daysLiteral = _ref.daysLiteral,
	            hoursLiteral = _ref.hoursLiteral;
	
	        _this.daysLiteral = daysLiteral;
	        _this.hoursLiteral = hoursLiteral;
	        _this._getRequestInfo();
	      });
	    }
	  }, {
	    key: 'isQuestion',
	    value: function isQuestion() {
	      return !this.isError() && !this.isSuccess();
	    }
	  }, {
	    key: 'isError',
	    value: function isError() {
	      return !(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.error);
	    }
	  }, {
	    key: 'isSuccess',
	    value: function isSuccess() {
	      return this.showSuccess === true;
	    }
	  }, {
	    key: 'translateKeys',
	    value: function translateKeys() {
	      var _this2 = this;
	
	      return this.q(function (resolve) {
	        _this2.translate('GLOBALS.DAYS').then(function (daysLiteral) {
	          _this2.translate('GLOBALS.HOURS').then(function (hoursLiteral) {
	            resolve({ daysLiteral: daysLiteral, hoursLiteral: hoursLiteral });
	          });
	        });
	      });
	    }
	  }, {
	    key: '_getRequestInfo',
	    value: function _getRequestInfo() {
	      this.message = this.formatter.formatRequestInfo(this.request, _dateUtils.formatDateForView, this.daysLiteral, this.hoursLiteral);
	    }
	  }]);
	  return TeamRequestModalRemoveController;
	}();
	
	exports.default = TeamRequestModalRemoveController;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1233);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestModalRemove.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestModalRemove.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-request-modal-remove{display:block}team-request-modal-remove .modal-dialog{width:520px}team-request-modal-remove successful-action .description{margin-bottom:50px!important}team-request-modal-remove successful-action .description h1{font-size:18px;font-family:Stag Sans;font-weight:400;margin-bottom:5px}team-request-modal-remove successful-action .description p{margin-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _teamRequestModalRemoveQuestion = __webpack_require__(1235);
	
	var _teamRequestModalRemoveQuestion2 = _interopRequireDefault(_teamRequestModalRemoveQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestModalRemoveQuestionModule = _angular2.default.module('vacations-absences.teamRequestModalRemoveQuestion', []).component('teamRequestModalRemoveQuestion', _teamRequestModalRemoveQuestion2.default).name;
	
	exports.default = teamRequestModalRemoveQuestionModule;

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestModalRemoveQuestion = __webpack_require__(1236);
	
	var _teamRequestModalRemoveQuestion2 = _interopRequireDefault(_teamRequestModalRemoveQuestion);
	
	var _teamRequestModalRemoveQuestion3 = __webpack_require__(1237);
	
	var _teamRequestModalRemoveQuestion4 = _interopRequireDefault(_teamRequestModalRemoveQuestion3);
	
	__webpack_require__(1238);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestModalRemoveQuestionComponent = {
	  restrict: 'E',
	  bindings: {
	    message: '@',
	    onConfirm: '&',
	    isMobileApp: '<'
	  },
	  template: _teamRequestModalRemoveQuestion2.default,
	  controller: _teamRequestModalRemoveQuestion4.default
	};
	
	exports.default = teamRequestModalRemoveQuestionComponent;

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\">\n\n  <div class=\"modal-header\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\">{{ 'VACATIONS_ABSENCES.TEAM_REQUESTS.REJECT.CONFIRM_TITLE' | translate }}</h4>\n  </div>\n\n  <div class=\"modal-body\">\n\n    <p ng-if=\"$ctrl.message\"\n       ng-bind-html=\"$ctrl.message\"\n       class=\"description\"></p>\n\n    <form-errors-summary\n      ng-if=\"$ctrl.form.$invalid\"\n      errors=\"$ctrl.errors\"></form-errors-summary>\n  </div>\n\n  <div class=\"modal-footer\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      type=\"button\"\n      class=\"btn btn-one btn-app btn-primary\"\n      data-dismiss=\"modal\">{{\"GLOBALS.BUTTON_ACTION.CANCEL\" | translate}}</button>\n    <button\n      type=\"button\"\n      class=\"btn btn-two btn-app btn-primary\"\n      ng-disabled=\"$ctrl.form.$invalid\"\n      ng-click=\"$ctrl.onConfirm()\" >{{\"GLOBALS.BUTTON_ACTION.REMOVE\" | translate}}</button>\n  </div>\n\n  <floating-action-buttons\n      ng-if=\"$ctrl.isMobileApp\"\n      buttons=\"$ctrl.floatingActionButtons\"\n      on-click-first-button=\"$ctrl.onConfirm()\"\n      on-click-second-button=\"$ctrl.onDismiss()\">\n  </floating-action-buttons>\n\n</div>\n"

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestModalRemoveQuestionController = function () {
	  teamRequestModalRemoveQuestionController.$inject = ["$translate"];
	  function teamRequestModalRemoveQuestionController($translate) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, teamRequestModalRemoveQuestionController);
	    this.$translate = $translate;
	    this.errors = [];
	
	    this.$translate('VACATIONS_ABSENCES.VALIDATION_ERRORS.REMOVE_REASON_MAX_LENGTH').then(function (translation) {
	      _this.errors.push(translation);
	    });
	  }
	
	  (0, _createClass3.default)(teamRequestModalRemoveQuestionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.REMOVE'
	
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }, {
	    key: 'onDismiss',
	    value: function onDismiss() {
	      angular.element('.modal').modal('hide');
	    }
	  }]);
	  return teamRequestModalRemoveQuestionController;
	}();
	
	exports.default = teamRequestModalRemoveQuestionController;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1239);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestModalRemoveQuestion.scss", function() {
				var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestModalRemoveQuestion.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-request-modal-remove-question{display:block}team-request-modal-remove-question .modal-content{padding:57px 59px 50px}team-request-modal-remove-question .modal-content .modal-header h4{padding-bottom:11px}team-request-modal-remove-question .modal-content .modal-body{padding:27px 16px 0}team-request-modal-remove-question .modal-content .modal-body .body-header{border-bottom:1px solid #dddfe2;color:#666;margin-bottom:24px;padding-bottom:16px;padding-top:1px;text-align:center}team-request-modal-remove-question .modal-content .modal-body .body-header p{font-family:ArialMT;font-size:15px;line-height:1.3;margin:0}team-request-modal-remove-question .modal-content .modal-body .textarea-description{margin-bottom:7px}team-request-modal-remove-question .modal-content .modal-body textarea{border-color:#dddfe2;box-shadow:0 2px 4px 0 #dddfe2,0 -1px 4px 0 #dddfe2;color:#666;font-family:Stag Sans;font-style:italic;height:135.3px;margin-left:-1px;padding-left:20px;padding-right:26px;padding-top:9.2px;resize:none;width:100%}team-request-modal-remove-question .modal-content .modal-body textarea::-moz-placeholder{color:#aeaeae;opacity:1}team-request-modal-remove-question .modal-content .modal-body textarea:-ms-input-placeholder{color:#aeaeae}team-request-modal-remove-question .modal-content .modal-body textarea::-webkit-input-placeholder{color:#aeaeae}team-request-modal-remove-question .modal-content .modal-body textarea:focus{outline:none}team-request-modal-remove-question .modal-content .modal-body span:not(.icon-warning){color:#666;font-family:Stag Sans;font-size:13px;font-style:normal}team-request-modal-remove-question .modal-content .modal-body .light{color:#666;font-size:13px;font-weight:300}team-request-modal-remove-question .modal-content .modal-body .description{text-align:center;margin-bottom:22px!important;padding-bottom:22px;border-bottom:1px solid #dddfe2}team-request-modal-remove-question .modal-content .modal-body .description h1{margin-top:0;font-size:18px;font-family:Stag Sans;font-weight:400;margin-bottom:5px}team-request-modal-remove-question .modal-content .modal-body .description p{margin-bottom:0}team-request-modal-remove-question .modal-content .modal-footer{margin-top:30px;text-align:center;padding:0 16px}team-request-modal-remove-question .modal-content .modal-footer .btn{float:left;height:48px;line-height:38px;width:160px}team-request-modal-remove-question .modal-content .modal-footer .btn-one{background-color:#f9f9f9;border-color:#dddfe2;color:#0072c9;float:left}team-request-modal-remove-question .modal-content .modal-footer .btn-two{float:right}", ""]);
	
	// exports


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestsFilters = __webpack_require__(1241);
	
	var _teamRequestsFilters2 = _interopRequireDefault(_teamRequestsFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsFiltersModule = angular.module('vacations-absences.teamRequestsFilters', []).component('teamRequestsFilters', _teamRequestsFilters2.default).name;
	
	exports.default = teamRequestsFiltersModule;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestsFilters = __webpack_require__(1242);
	
	var _teamRequestsFilters2 = _interopRequireDefault(_teamRequestsFilters);
	
	var _teamRequestsFilters3 = __webpack_require__(1243);
	
	var _teamRequestsFilters4 = _interopRequireDefault(_teamRequestsFilters3);
	
	__webpack_require__(1271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsFiltersComponent = {
	  restrict: 'E',
	  bindings: {
	    onFilter: '&',
	    filters: '<',
	    exclusive: '<',
	    isMobileApp: '<'
	  },
	  template: _teamRequestsFilters2.default,
	  controller: _teamRequestsFilters4.default
	};
	
	exports.default = teamRequestsFiltersComponent;

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex-container\" ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n\n  <p class=\"filter-description\" ng-if=\"!$ctrl.isMobileApp\">\n    {{'VACATIONS_ABSENCES.CALENDAR_FILTERS.FILTER_BY' | translate}}:\n  </p>\n\n  <div class=\"mobile-labels\" ng-if=\"$ctrl.isMobileApp\">\n      <p class=\"filter-description\" ng-if=\"$ctrl.isMobileApp\">\n          {{'VACATIONS_ABSENCES.CALENDAR_FILTERS.FILTER_TITLE_MOBILE' | translate}}:\n      </p>\n      <a href=\"\"\n          title=\"{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.CLEAN_FILTER_TITLE' | translate}}\"\n          class=\"calendar-filter-button calendar-filter-button-clean\"\n          ng-show=\"$ctrl.hasFilters()\"\n          ng-click=\"$ctrl.cleanFilters()\">\n      <p>{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.CLEAN' | translate}}</p>\n      <span class=\"icon-cross\"></span>\n      </a>\n  </div>\n  <div class=\"filter-buttons\">\n    <a ng-repeat=\"filter in $ctrl.filters\"\n      class=\"calendar-filter-button\"\n      href=\"\"\n      title=\"{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.FILTER_BY_TITLE' | translate}}\"\n      ng-class=\"$ctrl.getCssActive(filter.name)\"\n      ng-click=\"$ctrl.toogleFilter(filter.name)\">\n      <div ng-class=\"$ctrl.getClassIcon(filter)\"></div>\n      <p>{{filter.label | translate}}</p>\n    </a>\n\n    <a href=\"\"\n      title=\"{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.CLEAN_FILTER_TITLE' | translate}}\"\n      class=\"calendar-filter-button calendar-filter-button-clean\"\n      ng-show=\"$ctrl.hasFilters()\"\n      ng-if=\"!$ctrl.isMobileApp\"\n      ng-click=\"$ctrl.cleanFilters()\">\n      <p>{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.CLEAN' | translate}}</p>\n      <span class=\"icon-cross\"></span>\n    </a>\n  </div>\n\n</div>\n"

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(1244);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _set = __webpack_require__(1251);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _teamRequestsFilters = __webpack_require__(1181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestsFiltersController = function () {
	  TeamRequestsFiltersController.$inject = ["$scope", "EventEmitter"];
	  function TeamRequestsFiltersController($scope, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamRequestsFiltersController);
	    this.$scope = $scope;
	    this.EventEmitter = EventEmitter;
	    this.name = 'teamRequestsFilters';
	    this.selectedFilters = new _set2.default([]);
	  }
	
	  (0, _createClass3.default)(TeamRequestsFiltersController, [{
	    key: '_getResponseFilter',
	    value: function _getResponseFilter() {
	      var response = {
	        selectedFilters: (0, _from2.default)(this.selectedFilters)
	      };
	      return this.EventEmitter(response);
	    }
	  }, {
	    key: 'checkExclusiveFilters',
	    value: function checkExclusiveFilters(filterName) {
	      if (this.exclusive === undefined) {
	        return;
	      }
	
	      if (_teamRequestsFilters.EXCLUSIVE.ALL in this.exclusive && this.exclusive[_teamRequestsFilters.EXCLUSIVE.ALL]) {
	        this.selectedFilters.clear();
	      }
	      if (filterName in this.exclusive) {
	        this.selectedFilters.delete(this.exclusive[filterName]);
	      }
	    }
	  }, {
	    key: 'addFilter',
	    value: function addFilter(filterName) {
	      this.checkExclusiveFilters(filterName);
	      this.selectedFilters.add(filterName);
	      this.onFilter(this._getResponseFilter());
	    }
	  }, {
	    key: 'removeFilter',
	    value: function removeFilter(filterName) {
	      this.selectedFilters.delete(filterName);
	      this.onFilter(this._getResponseFilter());
	    }
	  }, {
	    key: 'toogleFilter',
	    value: function toogleFilter(filterName) {
	      if (this.selectedFilters.has(filterName)) {
	        return this.removeFilter(filterName);
	      }
	
	      this.addFilter(filterName);
	    }
	  }, {
	    key: 'getCssActive',
	    value: function getCssActive(filterName) {
	      return {
	        'active': this.selectedFilters.has(filterName)
	      };
	    }
	  }, {
	    key: 'getClassIcon',
	    value: function getClassIcon(filter) {
	      if ('icon' in filter) {
	        return filter.icon;
	      }
	
	      return filter.type;
	    }
	  }, {
	    key: 'hasFilters',
	    value: function hasFilters() {
	      return this.selectedFilters.size > 0;
	    }
	  }, {
	    key: 'cleanFilters',
	    value: function cleanFilters() {
	      this.selectedFilters.clear();
	      this.onFilter(this._getResponseFilter());
	    }
	  }]);
	  return TeamRequestsFiltersController;
	}();
	
	exports.default = TeamRequestsFiltersController;

/***/ }),
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1272);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestsFilters.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestsFilters.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-requests-filters{display:block;margin-top:18px;width:100%}team-requests-filters .flex-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:center;-moz-align-items:center;align-items:center}team-requests-filters .flex-container.responsiveMobile{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}team-requests-filters .flex-container.responsiveMobile .mobile-labels{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:100%;height:37px}team-requests-filters .flex-container.responsiveMobile .mobile-labels .calendar-filter-button,team-requests-filters .flex-container.responsiveMobile .mobile-labels .filter-description{padding-top:0;margin:0;margin-top:0;width:auto;font-size:11px}team-requests-filters .flex-container.responsiveMobile .mobile-labels .calendar-filter-button.calendar-filter-button-clean{padding-right:10px}team-requests-filters .flex-container.responsiveMobile .mobile-labels .calendar-filter-button.calendar-filter-button-clean p{font-size:11px}team-requests-filters .flex-container.responsiveMobile .filter-buttons{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;width:100%;height:40px;overflow-x:scroll}team-requests-filters .flex-container.responsiveMobile .filter-buttons .calendar-filter-button{width:90px;height:30px;-webkit-backface-visibility:hidden!important}team-requests-filters .flex-container.responsiveMobile .filter-buttons .calendar-filter-button p{font-size:10px}team-requests-filters .flex-container.responsiveMobile .filter-buttons .calendar-filter-button .absence,team-requests-filters .flex-container.responsiveMobile .filter-buttons .calendar-filter-button .vacation{width:12px;height:12px}team-requests-filters .flex-container.responsiveMobile .filter-buttons .calendar-filter-button .icon-bell{font-size:12px}team-requests-filters .flex-container .filter-description{color:#0072c9;font-family:Stag Sans;font-size:13px;height:19px;width:60px;margin:0;margin-right:8px}team-requests-filters .flex-container .calendar-filter-button{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;border:1px solid #dddfe2;border-radius:4px;text-decoration:none;height:37px;margin-right:10px;width:150px}team-requests-filters .flex-container .calendar-filter-button.active,team-requests-filters .flex-container .calendar-filter-button.active+team-requests-filters .flex-container .calendar-filter-button:focus{border-color:#0072c9;outline:none}team-requests-filters .flex-container .calendar-filter-button .vacation{background-color:#52bcec;border-radius:1px;height:20px;margin-right:10px;width:20px}team-requests-filters .flex-container .calendar-filter-button .absence{background-color:#fdbd2c;border-radius:1px;height:20px;margin-right:10px;width:20px}team-requests-filters .flex-container .calendar-filter-button .icon-bell{margin-right:8px;font-size:19px}team-requests-filters .flex-container .calendar-filter-button p{font-family:Stag Sans;font-size:13px;font-weight:300;margin:0;margin-top:2px}team-requests-filters .flex-container .calendar-filter-button .icon-approved,team-requests-filters .flex-container .calendar-filter-button .icon-requested{display:inline-block;font-size:21px;margin-right:8px}team-requests-filters .flex-container .calendar-filter-button.calendar-filter-button-clean{border:none;margin-left:auto;margin-right:9%;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start}@media(min-width:1199px){team-requests-filters .flex-container .calendar-filter-button.calendar-filter-button-clean{width:35px;margin-left:4px}}team-requests-filters .flex-container .calendar-filter-button.calendar-filter-button-clean:focus .icon-cross,team-requests-filters .flex-container .calendar-filter-button.calendar-filter-button-clean:focus p{color:#0072c9}team-requests-filters .flex-container .calendar-filter-button.calendar-filter-button-clean p{line-height:16px}team-requests-filters .flex-container .calendar-filter-button.calendar-filter-button-clean .icon-cross{display:inline-block;font-size:10px;color:#aeaeae;margin-left:10px;margin-top:3px}", ""]);
	
	// exports


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(1251);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _request = __webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterByType(items, filtersSet) {
	  return items.filter(function (item) {
	    return filtersSet.has(item.type);
	  });
	}
	
	function filterByNotifications(items, filtersSet) {
	  return items.filter(function (item) {
	    return !filtersSet.has(item.type) && item.status === _request.Request.STATUS_REQUESTED.DISCARD;
	  });
	}
	
	exports.default = function () {
	  return function (items, filters) {
	    if (filters.length === 0) {
	      return items;
	    }
	    var filtersSet = new _set2.default(filters);
	    var filteredItems = filterByType(items, filtersSet);
	
	    if (filtersSet.has(_request.Request.STATUS_REQUESTED.DISCARD)) {
	      filteredItems = filteredItems.concat(filterByNotifications(items, filtersSet));
	    }
	
	    return filteredItems;
	  };
	};

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestsModalApproveAll = __webpack_require__(1275);
	
	var _teamRequestsModalApproveAll2 = _interopRequireDefault(_teamRequestsModalApproveAll);
	
	var _teamRequestsModalApproveAllConfirm = __webpack_require__(1280);
	
	var _teamRequestsModalApproveAllConfirm2 = _interopRequireDefault(_teamRequestsModalApproveAllConfirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsModalApproveAllModule = angular.module('vacations-absences.teamRequestsModalApproveAll', [_teamRequestsModalApproveAllConfirm2.default]).component('teamRequestsModalApproveAll', _teamRequestsModalApproveAll2.default).name;
	
	exports.default = teamRequestsModalApproveAllModule;

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestsModalApproveAll = __webpack_require__(1276);
	
	var _teamRequestsModalApproveAll2 = _interopRequireDefault(_teamRequestsModalApproveAll);
	
	var _teamRequestsModalApproveAll3 = __webpack_require__(1277);
	
	var _teamRequestsModalApproveAll4 = _interopRequireDefault(_teamRequestsModalApproveAll3);
	
	__webpack_require__(1278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsModalApproveAllComponent = {
	  restrict: 'E',
	  bindings: {
	    onApproveAll: '&',
	    success: '<',
	    error: '<',
	    isMobileApp: '<'
	  },
	  template: _teamRequestsModalApproveAll2.default,
	  controller: _teamRequestsModalApproveAll4.default
	};
	
	exports.default = teamRequestsModalApproveAllComponent;

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalTeamRequestsApproveAll\"\n     tabindex=\"-1\"\n     role=\"dialog\"\n     aria-labelledby=\"modalTeamRequestsApproveAllLabel\"\n     ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-dialog\" role=\"document\">\n\n  <team-requests-modal-approve-all-confirm\n      ng-if=\"$ctrl.isQuestion()\"\n      on-approve-all=\"$ctrl.onApproveAll()\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n  </team-requests-modal-approve-all-confirm>\n\n    <successful-action\n      ng-if=\"$ctrl.isSuccess()\"\n      close-modal=\"true\"\n      modal-id=\"modalTeamRequestsApproveAllOnSuccess\"\n      title=\"{{ 'VACATIONS_ABSENCES.TEAM_REQUESTS.APPROVE_ALL_QUESTION_SUCCESS_TITLE' | translate }}\"\n      message=\"{{ 'VACATIONS_ABSENCES.TEAM_REQUESTS.APPROVE_ALL_QUESTION_SUCCESS_MESSAGE' | translate }}\"\n      is-mobile-app=\"$ctrl.isMobileApp\"></successful-action>\n\n    <failed-action\n      ng-if=\"$ctrl.isError()\"\n      title=\"{{ 'GLOBALS.ATTENTION' | translate }}\"\n      description=\"{{ $ctrl.error.data.message || ('VACATIONS_ABSENCES.TEAM_REQUESTS.APPROVE_ALL_QUESTION_ERROR_MESSAGE' | translate)}}\"\n      close-modal=\"true\"\n      modal-id=\"modalTeamRequestsApproveAllOnError\"\n      button-text=\"{{'GLOBALS.BUTTON_ACTION.OK_GOT_IT' | translate}}\"\n      is-mobile-app=\"$ctrl.isMobileApp\"></failed-action>\n\n  </div>\n</div>\n"

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestsModalApproveAllController = function () {
	  function TeamRequestsModalApproveAllController() {
	    (0, _classCallCheck3.default)(this, TeamRequestsModalApproveAllController);
	  }
	
	  (0, _createClass3.default)(TeamRequestsModalApproveAllController, [{
	    key: "isQuestion",
	    value: function isQuestion() {
	      return !this.isError() && !this.isSuccess();
	    }
	  }, {
	    key: "isError",
	    value: function isError() {
	      return this.error !== undefined && this.error !== null;
	    }
	  }, {
	    key: "isSuccess",
	    value: function isSuccess() {
	      return this.success === true;
	    }
	  }]);
	  return TeamRequestsModalApproveAllController;
	}();
	
	exports.default = TeamRequestsModalApproveAllController;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1279);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestsModalApproveAll.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./teamRequestsModalApproveAll.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-requests-modal-approve-all .modal-dialog{width:520px;height:350px}team-requests-modal-approve-all .modal-dialog .modal-content .modal-body .description{margin-bottom:0}team-requests-modal-approve-all .modal-dialog .modal-content .modal-footer{margin-top:51px}", ""]);
	
	// exports


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestsModalApproveAllConfirm = __webpack_require__(1281);
	
	var _teamRequestsModalApproveAllConfirm2 = _interopRequireDefault(_teamRequestsModalApproveAllConfirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsModalApproveAllConfirmModule = angular.module('vacations-absences.teamRequestsModalApproveAllConfirm', []).component('teamRequestsModalApproveAllConfirm', _teamRequestsModalApproveAllConfirm2.default).name;
	
	exports.default = teamRequestsModalApproveAllConfirmModule;

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamRequestsModalApproveAllConfirm = __webpack_require__(1282);
	
	var _teamRequestsModalApproveAllConfirm2 = _interopRequireDefault(_teamRequestsModalApproveAllConfirm);
	
	var _teamRequestsModalApproveAllConfirm3 = __webpack_require__(1283);
	
	var _teamRequestsModalApproveAllConfirm4 = _interopRequireDefault(_teamRequestsModalApproveAllConfirm3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamRequestsModalApproveAllConfirmComponent = {
	  restrict: 'E',
	  bindings: {
	    onApproveAll: '&',
	    isMobileApp: '<'
	  },
	  template: _teamRequestsModalApproveAllConfirm2.default,
	  controller: _teamRequestsModalApproveAllConfirm4.default
	};
	
	exports.default = teamRequestsModalApproveAllConfirmComponent;

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\">\n\n  <div class=\"modal-header\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span\n      class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\" id=\"modalTeamRequestsApproveAllLabel\">\n      {{ 'VACATIONS_ABSENCES.TEAM_REQUESTS.APPROVE_ALL_QUESTION' | translate }}\n    </h4>\n  </div>\n\n  <div class=\"modal-footer\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      type=\"button\"\n      class=\"btn btn-app btnone btn-primary pull-left\"\n      data-dismiss=\"modal\">{{ 'GLOBALS.BUTTON_ACTION.CANCEL' | translate }}\n    </button>\n    <button\n      type=\"button\"\n      class=\"btn btn-app btntwo btn-primary pull-right\"\n      ng-click=\"$ctrl.approveAll()\">{{ 'VACATIONS_ABSENCES.GENERAL.APPROVE_ALL' | translate }}\n    </button>\n  </div>\n\n  <floating-action-buttons\n      ng-if=\"$ctrl.isMobileApp\"\n      buttons=\"$ctrl.floatingActionButtons\"\n      on-click-first-button=\"$ctrl.approveAll()\"\n      on-click-second-button=\"$ctrl.onDismiss()\">\n  </floating-action-buttons>\n\n</div>\n"

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestsModalApproveAllConfirmController = function () {
	  function TeamRequestsModalApproveAllConfirmController() {
	    (0, _classCallCheck3.default)(this, TeamRequestsModalApproveAllConfirmController);
	  }
	
	  (0, _createClass3.default)(TeamRequestsModalApproveAllConfirmController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.floatingActionButtons = this.getFloatingActionButtons();
	    }
	  }, {
	    key: 'approveAll',
	    value: function approveAll() {
	      this.onApproveAll();
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'VACATIONS_ABSENCES.GENERAL.APPROVE_ALL'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }, {
	    key: 'onDismiss',
	    value: function onDismiss() {
	      angular.element('.modal').modal('hide');
	    }
	  }]);
	  return TeamRequestsModalApproveAllConfirmController;
	}();
	
	exports.default = TeamRequestsModalApproveAllConfirmController;

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _teamCalendar = __webpack_require__(1285);
	
	var _teamCalendar2 = _interopRequireDefault(_teamCalendar);
	
	var _managerYearInline = __webpack_require__(1290);
	
	var _managerYearInline2 = _interopRequireDefault(_managerYearInline);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamCalendarModule = angular.module('vacations-absences.teamCalendar', [_angularUiRouter2.default, _managerYearInline2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.TEAM_CALENDAR, {
	    url: _routes.ROUTES.VACATIONS_ABSENCES.TEAM_CALENDAR,
	    component: 'teamCalendar',
	    data: {
	      requiresAuth: true,
	      requiresManager: true
	    },
	    resolve: {
	      /* @ngInject */
	      isWageInProcess: ["StatusAppCheckers", function isWageInProcess(StatusAppCheckers) {
	        return StatusAppCheckers.isWageInProcess();
	      }]
	    }
	  });
	}]).component('teamCalendar', _teamCalendar2.default).name;
	
	exports.default = teamCalendarModule;

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamCalendar = __webpack_require__(1286);
	
	var _teamCalendar2 = _interopRequireDefault(_teamCalendar);
	
	var _teamCalendar3 = __webpack_require__(1287);
	
	var _teamCalendar4 = _interopRequireDefault(_teamCalendar3);
	
	__webpack_require__(1288);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamCalendarComponent = {
	  restrict: 'E',
	  bindings: {
	    isWageInProcess: '<'
	  },
	  template: _teamCalendar2.default,
	  controller: _teamCalendar4.default
	};
	
	exports.default = teamCalendarComponent;

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.loaded\" class=\"animation-appear\">\n  <div class=\"container hpd\">\n\n    <modal-coachmark\n      data=\"$ctrl.coachmarkData\"\n      user-id=\"$ctrl.userId\"\n    ></modal-coachmark>\n\n    <div class=\"filters-and-search\">\n      <calendar-filters on-change-filters=\"$ctrl.onChangeFilters($event);\"></calendar-filters>\n      <employee-search\n        class=\"in-team-calendar\"\n        on-search=\"$ctrl.onSearch($event)\"\n        on-select-employee=\"$ctrl.onSelectEmployeeSearch($event)\">\n      </employee-search>\n    </div>\n\n    <div class=\"tags-and-approve\">\n      <employee-search-tags\n        ng-if=\"$ctrl.existFilters()\"\n        employee-filters=\"$ctrl.employeeFilters\"\n        on-remove-employee-filter=\"$ctrl.onRemoveEmployeeFilter($event)\"\n        on-clean-employee-filters=\"$ctrl.onCleanEmployeeFilters()\">\n      </employee-search-tags>\n    </div>\n\n    <manager-year-inline\n      ng-if=\"$ctrl.loaded\"\n      employee-filters=\"$ctrl.employeeFilters\"\n      calendar-lines=\"$ctrl.calendarLines\"\n      on-change-date=\"$ctrl.onChangeDate($event)\"\n      is-disabled=\"$ctrl.isDisabled()\"\n      on-inception=\"$ctrl.inceptEmployee($event)\"\n      on-year-pagination-changes=\"$ctrl.yearChanges($event)\">\n    </manager-year-inline>\n\n    <modal-warning-delegation\n      ng-if=\"$ctrl.hasDelegated\"\n      title-body=\"{{ 'VACATIONS_ABSENCES.MAIN.WARNING_DELEGATION_TITLE' | translate }}\"\n      delegation=\"$ctrl.delegation\"\n      url-destination=\"$ctrl.urlDestination\">\n    </modal-warning-delegation>\n\n  </div>\n</div>\n\n<loading ng-hide=\"$ctrl.loaded\"></loading>\n"

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	var _constants2 = __webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamCalendarController = function () {
	  TeamCalendarController.$inject = ["$filter", "vacationUserDataService", "inceptionService", "teamCalendarService", "HelperDelegationsService"];
	  function TeamCalendarController($filter, vacationUserDataService, inceptionService, teamCalendarService, HelperDelegationsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamCalendarController);
	    this.filter = $filter;
	
	    this.vacationUserDataService = vacationUserDataService;
	    this.inceptionService = inceptionService;
	    this.teamCalendarService = teamCalendarService;
	    this.helperDelegationsService = HelperDelegationsService;
	
	    this.loaded = false;
	    this.employeeFilters = [];
	    this.calendarLines = [];
	    this.periodFilters = [];
	
	    this.dateToday = new Date();
	    this.year = this.dateToday.getFullYear();
	
	    this.coachmarkData = _constants2.VA_TEAM_CALENDAR_MODAL_COACHMARK_CONFIG;
	  }
	
	  (0, _createClass3.default)(TeamCalendarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.urlDestination = _states.STATES.VACATIONS_ABSENCES.DELEGATE;
	      this._initData();
	    }
	  }, {
	    key: '_initData',
	    value: function _initData() {
	      var _this = this;
	
	      this.userId = this.vacationUserDataService.getEmployee().userId;
	
	      this.teamCalendarService.initData(this.userId, this.year).then(function (_ref) {
	        var rawEmployeeList = _ref.rawEmployeeList,
	            employeeList = _ref.employeeList,
	            employeesForSearch = _ref.employeesForSearch,
	            hasDelegated = _ref.hasDelegated,
	            delegation = _ref.delegation;
	
	        _this.rawEmployeeList = rawEmployeeList;
	        _this.employeeList = employeeList;
	        _this.calendarLines = _this.teamCalendarService.formatEmployeeList(_this.employeeList);
	        _this.employeesForSearch = employeesForSearch;
	        _this.hasDelegated = hasDelegated;
	        _this.delegation = delegation;
	        _this.loaded = true;
	      });
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled() {
	      return this.isWageInProcess;
	    }
	  }, {
	    key: 'onChangeDate',
	    value: function onChangeDate($event) {
	      this.currentDate = $event.currentDate;
	      this.onChangeFilters({ filters: this.periodFilters });
	    }
	  }, {
	    key: 'onSearch',
	    value: function onSearch() {
	      return this.helperDelegationsService.onSearchEmployeeDelegations(this.employeesForSearch);
	    }
	  }, {
	    key: 'onSelectEmployeeSearch',
	    value: function onSelectEmployeeSearch($event) {
	      if (!this.employeeFilters.find(function (employee) {
	        return employee.userId === $event.userId;
	      })) {
	        this.employeeFilters.push($event);
	      }
	    }
	  }, {
	    key: 'onChangeFilters',
	    value: function onChangeFilters(_ref2) {
	      var filters = _ref2.filters;
	
	      this.periodFilters = filters;
	      this.employeeList = this.rawEmployeeList;
	
	      if (!this.loaded) {
	        return;
	      }
	
	      this.employeeList = this.filter('managerYearInlineFilter')(this.employeeList, filters, this.currentDate);
	      this.calendarLines = this.teamCalendarService.formatEmployeeList(this.employeeList);
	    }
	  }, {
	    key: 'onRemoveEmployeeFilter',
	    value: function onRemoveEmployeeFilter($event) {
	      _lodash2.default.remove(this.employeeFilters, function (filter) {
	        return filter.userId === $event.userId;
	      });
	    }
	  }, {
	    key: 'onCleanEmployeeFilters',
	    value: function onCleanEmployeeFilters() {
	      this.employeeFilters = [];
	    }
	  }, {
	    key: 'existFilters',
	    value: function existFilters() {
	      return !!this.employeeFilters.length;
	    }
	  }, {
	    key: 'inceptEmployee',
	    value: function inceptEmployee(_ref3) {
	      var employeeId = _ref3.employeeId;
	
	      if (this.hasDelegated) {
	        return this._showModalWarningDelegation();
	      }
	
	      this.inceptionService.incept(employeeId, 'team-calendar');
	    }
	  }, {
	    key: '_showModalWarningDelegation',
	    value: function _showModalWarningDelegation() {
	      this.modalWarningDelegation.modal('show');
	    }
	  }, {
	    key: 'yearChanges',
	    value: function yearChanges($event) {
	      this.year = $event.year;
	      this.$onInit();
	    }
	  }, {
	    key: 'modalWarningDelegation',
	    get: function get() {
	      return $(_constants.MODALS.WARNING_DELEGATION_MODAL);
	    }
	  }]);
	  return TeamCalendarController;
	}();
	
	exports.default = TeamCalendarController;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1289);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./teamCalendar.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./teamCalendar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-calendar{display:block}team-calendar .filters-and-search{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;padding-top:20px;padding-bottom:25px}team-calendar .filters-and-search employee-search .employee-search-container{margin-top:0}", ""]);
	
	// exports


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _managerYearInline = __webpack_require__(1291);
	
	var _managerYearInline2 = _interopRequireDefault(_managerYearInline);
	
	var _managerYearInline3 = __webpack_require__(1296);
	
	var _managerYearInline4 = _interopRequireDefault(_managerYearInline3);
	
	var _managerYearInline5 = __webpack_require__(1297);
	
	var _managerYearInline6 = _interopRequireDefault(_managerYearInline5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerYearInlineModule = angular.module('vacations-absences.managerYearInline', []).component('managerYearInline', _managerYearInline2.default).service('managerYearInlineService', _managerYearInline4.default).filter('managerYearInlineFilter', _managerYearInline6.default).name;
	
	exports.default = managerYearInlineModule;

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _managerYearInline = __webpack_require__(1292);
	
	var _managerYearInline2 = _interopRequireDefault(_managerYearInline);
	
	var _managerYearInline3 = __webpack_require__(1293);
	
	var _managerYearInline4 = _interopRequireDefault(_managerYearInline3);
	
	__webpack_require__(1294);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerYearInlineComponent = {
	  restrict: 'E',
	  bindings: {
	    employeeFilters: '<',
	    periodFilters: '<',
	    calendarLines: '<',
	    onChangeDate: '&',
	    onInception: '&',
	    isDisabled: '<',
	    onYearPaginationChanges: '&'
	  },
	  template: _managerYearInline2.default,
	  controller: _managerYearInline4.default
	};
	
	exports.default = managerYearInlineComponent;

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"request-widget\">\n\n  <calendar-inline-paginator \n    date=\"$ctrl.date\" \n    id=\"$ctrl.id\" \n    next-page=\"$ctrl.nextPage()\" \n    prev-page=\"$ctrl.prevPage()\"\n    on-year-pagination-changes=\"$ctrl.yearChanges($event)\">\n  </calendar-inline-paginator>\n\n  <div class=\"content\">\n\n    <div\n      class=\"cards\"\n      ng-class=\"{'hidden-cards': $ctrl.isHiddenInfo}\">\n      <calendar-inline-hide is-hide=\"$ctrl.isHiddenInfo\" clicked=\"$ctrl.hideInfo($event)\"></calendar-inline-hide>\n      <div class=\"card\" ng-repeat=\"line in $ctrl.calendarLines | employeeFilter: $ctrl.employeeFilters\">\n        <div ng-if=\"line.remarks\" class=\"remark-container\">\n          <span class=\"icon-warning remark\"></span>\n          <span\n            ng-init=\"$ctrl.tooltip();\"\n            class=\"icon-warning remark\"\n            data-toggle=\"tooltip\"\n            data-placement=\"right\"\n            title=\"{{line.remarks}}\"></span>\n        </div>\n        <calendar-inline-card\n        ng-class=\"{'slim': $ctrl.isHiddenInfo}\"\n        employee=\"line.employee\"\n        incept-employee=\"$ctrl.onInception({$event: $event})\"\n        is-disabled=\"$ctrl.isDisabled\">\n        </calendar-inline-card>\n      </div>\n    </div>\n\n    <div\n      class=\"calendars\"\n      ng-class=\"{'hidden-calendars': !$ctrl.isHiddenInfo}\">\n      <calendar-inline-header id=\"$ctrl.id\" date=\"$ctrl.date\"></calendar-inline-header>\n      <div class=\"calendar-inline-row\" ng-repeat=\"line in $ctrl.calendarLines | employeeFilter: $ctrl.employeeFilters \">\n        <calendar-inline id=\"line.employeeId\" events=\"line.periodInDays\" date=\"$ctrl.date\"></calendar-inline>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _tooltip = __webpack_require__(744);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManagerYearInlineController = function () {
	  ManagerYearInlineController.$inject = ["$rootScope", "$scope", "$timeout", "EventEmitter"];
	  function ManagerYearInlineController($rootScope, $scope, $timeout, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ManagerYearInlineController);
	    this.rootScope = $rootScope;
	    this.scope = $scope;
	    this.timeout = $timeout;
	    this.loaded = false;
	    this.today = new Date();
	    this.tooltip = _tooltip2.default;
	    this.isHiddenInfo = false;
	    this.date = this.today;
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(ManagerYearInlineController, [{
	    key: 'hideInfo',
	    value: function hideInfo(_ref) {
	      var hide = _ref.hide;
	
	      this.isHiddenInfo = hide;
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      this.onChangeDate(this.EventEmitter({ currentDate: this.date }));
	    }
	  }, {
	    key: 'nextPage',
	    value: function nextPage() {
	      var currentMonth = this.date.getMonth();
	      this.date = new Date(this.date.getFullYear(), currentMonth + 1, 1);
	      this.onChangeDate(this.EventEmitter({ currentDate: this.date }));
	    }
	  }, {
	    key: 'prevPage',
	    value: function prevPage() {
	      var currentMonth = this.date.getMonth();
	      this.date = new Date(this.date.getFullYear(), currentMonth - 1, 1);
	      this.onChangeDate(this.EventEmitter({ currentDate: this.date }));
	    }
	  }, {
	    key: 'yearChanges',
	    value: function yearChanges($event) {
	      this.onYearPaginationChanges(this.EventEmitter($event));
	    }
	  }]);
	  return ManagerYearInlineController;
	}();
	
	exports.default = ManagerYearInlineController;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1295);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./managerYearInline.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./managerYearInline.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "manager-year-inline{display:block}manager-year-inline calendar-inline{min-height:10px}manager-year-inline calendar-inline-paginator .subtitle{display:none}manager-year-inline calendar-inline-card{position:relative;top:1px}manager-year-inline .container-hide-info-btn{width:134px;height:40px;padding-left:10px;border-bottom:1px solid #f9f9f9;border-left:1px solid #f9f9f9}manager-year-inline td{max-height:60px}manager-year-inline .calendar-inline-row{margin-bottom:7px}manager-year-inline .content{display:flex}manager-year-inline .calendars{position:relative;overflow-x:auto;margin-left:65px}manager-year-inline .cards{max-width:170px}manager-year-inline .cards.hidden-cards{max-width:5px}manager-year-inline .card{margin-bottom:9px}manager-year-inline .card .remark-container{position:relative;z-index:99}manager-year-inline .card .remark-container .remark{position:absolute;top:10px;left:49px;display:block;color:#c8175e;border-radius:10px;background:#fff}", ""]);
	
	// exports


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vacationsAbsences = __webpack_require__(1120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerYearInlineService = function () {
	  managerYearInlineService.$inject = ["$http"];
	  function managerYearInlineService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, managerYearInlineService);
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(managerYearInlineService, [{
	    key: 'getData',
	    value: function getData(managerId, year) {
	      return this.http.get(_vacationsAbsences.ENDPOINTS_MANAGER.get.initial(managerId, year)).then(function (response) {
	        return response.data.listRequestsEmployees;
	      });
	    }
	  }]);
	  return managerYearInlineService;
	}();
	
	exports.default = managerYearInlineService;

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _periods = __webpack_require__(1298);
	
	var _periods2 = _interopRequireDefault(_periods);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return function (employeeList, filters, currentDate) {
	    if (filters.length === 0) {
	      return employeeList;
	    }
	
	    var response = [];
	    employeeList.forEach(function (employee) {
	      var periods = (0, _periods2.default)()(employee.periods, filters).filter(function (period) {
	        var startDate = new Date(period.startDate);
	        var endDate = new Date(period.endDate);
	        var sameMonth = currentDate.getMonth() === startDate.getMonth() || currentDate.getMonth() === endDate.getMonth();
	        var sameYear = currentDate.getYear() === startDate.getYear() || currentDate.getYear() === endDate.getYear();
	        var isCurrentDateBetweenStartAndEnd = currentDate > startDate && currentDate < endDate;
	
	        return sameMonth && sameYear || isCurrentDateBetweenStartAndEnd;
	      });
	      if (periods.length > 0) {
	        response.push(employee);
	      }
	    });
	    return response;
	  };
	};

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _request = __webpack_require__(1114);
	
	exports.default = function () {
	  return function (items, filters) {
	    var filtered = [];
	    var JUST_ONE_FILTER = filters.length === 1;
	    var IS_EMPTY = filters.length === 0;
	    items.filter(function (item) {
	      var isVisibleByType = filters.some(function (filter) {
	        return item.type.includes(filter) || item.type.includes('holiday');
	      });
	      var isVisibleByStatus = filters.some(function (filter) {
	        if (filter == _request.Request.STATUS.REQUESTED) {
	          return filter === item.status || item.status === _request.Request.STATUS.DELETED || item.type.includes('holiday');
	        }
	        return filter === item.status || item.type.includes('holiday');
	      });
	      var isVisible = isVisibleByType && JUST_ONE_FILTER || isVisibleByStatus && JUST_ONE_FILTER || isVisibleByType && isVisibleByStatus || IS_EMPTY;
	
	      if (isVisible) {
	        filtered.push(item);
	      }
	    });
	    return filtered;
	  };
	};

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _teamCalendarMobile = __webpack_require__(1300);
	
	var _teamCalendarMobile2 = _interopRequireDefault(_teamCalendarMobile);
	
	var _states = __webpack_require__(565);
	
	var _routes = __webpack_require__(1040);
	
	var _monthSelector = __webpack_require__(1305);
	
	var _monthSelector2 = _interopRequireDefault(_monthSelector);
	
	var _teamCalendarList = __webpack_require__(1311);
	
	var _teamCalendarList2 = _interopRequireDefault(_teamCalendarList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamCalendarMobileModule = _angular2.default.module('teamCalendarMobile', [_angularUiRouter2.default, _monthSelector2.default, _teamCalendarList2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.TEAM_CALENDAR_MOBILE, {
	    url: _routes.ROUTES.VACATIONS_ABSENCES.TEAM_CALENDAR_MOBILE,
	    component: 'teamCalendarMobile',
	    data: {
	      requiresAuth: true,
	      requiresManager: true
	    },
	    resolve: {
	      /* @ngInject */
	      isWageInProcess: ["StatusAppCheckers", function isWageInProcess(StatusAppCheckers) {
	        return StatusAppCheckers.isWageInProcess();
	      }]
	    }
	  });
	}]).component('teamCalendarMobile', _teamCalendarMobile2.default).name;
	
	exports.default = teamCalendarMobileModule;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamCalendarMobile = __webpack_require__(1301);
	
	var _teamCalendarMobile2 = _interopRequireDefault(_teamCalendarMobile);
	
	var _teamCalendarMobile3 = __webpack_require__(1302);
	
	var _teamCalendarMobile4 = _interopRequireDefault(_teamCalendarMobile3);
	
	__webpack_require__(1303);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamCalendarMobileComponent = {
	  restrict: 'E',
	  bindings: {
	    isWageInProcess: '<'
	  },
	  template: _teamCalendarMobile2.default,
	  controller: _teamCalendarMobile4.default
	};
	
	exports.default = teamCalendarMobileComponent;

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container responsiveMobile hpd animation-appear\"\n     pull-to-refresh=\"$ctrl._initData()\"\n     ng-if=\"$ctrl.loaded\">\n\n  <employee-search fixed-selection=\"true\"\n                   on-search=\"$ctrl.onSearch()\"\n                   on-select-employee=\"$ctrl.onSelectEmployee($event)\"\n                   on-clean-search=\"$ctrl.onCleanEmployeeFilters()\"\n                   is-mobile-app=\"$ctrl.isMobileApp\">\n  </employee-search>\n\n  <section class=\"team-calendar-mobile\">\n    <month-selector on-change=\"$ctrl.onChangeMonth($event)\">\n    </month-selector>\n    <team-calendar-list team-calendar-list=\"$ctrl.teamCalendarList\" has-delegated=\"$ctrl.hasDelegated\" delegation=\"$ctrl.delegation\" is-disabled=\"$ctrl.isDisabled()\">\n    </team-calendar-list>\n  </section>\n\n</div>\n"

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamCalendarMobileController = function () {
	  TeamCalendarMobileController.$inject = ["$window", "vacationUserDataService", "vacationDelegationService", "inceptionService", "teamCalendarService", "HelperDelegationsService", "loadingMobileService", "metricsService"];
	  function TeamCalendarMobileController($window, vacationUserDataService, vacationDelegationService, inceptionService, teamCalendarService, HelperDelegationsService, loadingMobileService, metricsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamCalendarMobileController);
	    this.vacationUserDataService = vacationUserDataService;
	    this.vacationDelegationService = vacationDelegationService;
	    this.inceptionService = inceptionService;
	    this.teamCalendarService = teamCalendarService;
	    this.helperDelegationsService = HelperDelegationsService;
	    this.loadingMobileService = loadingMobileService;
	    this.metricsService = metricsService;
	
	    this.year = new Date().getFullYear();
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.managerId = vacationUserDataService.getEmployee().userId;
	  }
	
	  (0, _createClass3.default)(TeamCalendarMobileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this._initData();
	      this._getDelegations();
	    }
	  }, {
	    key: '_initData',
	    value: function _initData() {
	      var _this = this;
	
	      this.loadingMobileService.show();
	
	      this.loaded = false;
	      this.employeeFilters = [];
	      this.userId = this.vacationUserDataService.getEmployee().userId;
	
	      this.teamCalendarService.initData(this.userId, this.year).then(function (_ref) {
	        var rawEmployeeList = _ref.rawEmployeeList,
	            employeeList = _ref.employeeList,
	            employeesForSearch = _ref.employeesForSearch,
	            hasDelegated = _ref.hasDelegated,
	            delegation = _ref.delegation;
	
	        _this.rawEmployeeList = rawEmployeeList;
	        _this.employeeList = employeeList;
	        _this.teamCalendarService.formatEmployeeList(_this.employeeList);
	        _this.employeesForSearch = employeesForSearch;
	        _this.hasDelegated = hasDelegated;
	        _this.delegation = delegation;
	        _this.loaded = true;
	
	        _this.metricsService.trackNavigationVacationsAbsencesTeamCalendar();
	      }).finally(function () {
	        return _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'onSearch',
	    value: function onSearch() {
	      return this.helperDelegationsService.onSearchEmployeeDelegations(this.employeesForSearch);
	    }
	  }, {
	    key: 'onSelectEmployee',
	    value: function onSelectEmployee($event) {
	      var alreadyInFilters = this.employeeFilters.find(function (employee) {
	        employee.userId === $event.userId;
	      });
	
	      if (!alreadyInFilters) {
	        this.employeeFilters.push($event);
	        this._initTeamCalendarList();
	      }
	    }
	  }, {
	    key: 'onCleanEmployeeFilters',
	    value: function onCleanEmployeeFilters() {
	      this.employeeFilters = [];
	      this._initTeamCalendarList();
	    }
	  }, {
	    key: 'onChangeMonth',
	    value: function onChangeMonth($event) {
	      this.teamCalendarDate = $event;
	      this._initTeamCalendarList();
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled() {
	      return this.isWageInProcess;
	    }
	  }, {
	    key: '_getDelegations',
	    value: function _getDelegations() {
	      var _this2 = this;
	
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	      return this.vacationDelegationService.hasDelegated(this.managerId).then(function (response) {
	        _this2.hasDelegated = response.hasDelegated;
	        if (_this2.hasDelegated) {
	          _this2.delegation = _this2.vacationDelegationService.findDelegationActive(today, response.delegations);
	        }
	      });
	    }
	  }, {
	    key: '_initTeamCalendarList',
	    value: function _initTeamCalendarList() {
	      this.teamCalendarList = this.teamCalendarService.getTeamCalendarList(this.employeeList, this.teamCalendarDate, this.employeeFilters);
	    }
	  }]);
	  return TeamCalendarMobileController;
	}();
	
	exports.default = TeamCalendarMobileController;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1304);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./teamCalendarMobile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./teamCalendarMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "@media only screen and (device-width:375px)and (device-height:812px)and (-webkit-device-pixel-ratio:3){team-calendar-mobile .container.responsiveMobile{padding-bottom:30px}}team-calendar-mobile employee-search .employee-search-container.responsiveMobile{margin-top:10px;margin-bottom:20px}team-calendar-mobile .team-calendar-mobile{margin-right:-30px;margin-left:-30px}", ""]);
	
	// exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _monthSelector = __webpack_require__(1306);
	
	var _monthSelector2 = _interopRequireDefault(_monthSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var monthSelectorModule = _angular2.default.module('monthSelector', []).component('monthSelector', _monthSelector2.default).name;
	
	exports.default = monthSelectorModule;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _monthSelector = __webpack_require__(1307);
	
	var _monthSelector2 = _interopRequireDefault(_monthSelector);
	
	var _monthSelector3 = __webpack_require__(1308);
	
	var _monthSelector4 = _interopRequireDefault(_monthSelector3);
	
	__webpack_require__(1309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var monthSelectorComponent = {
	  restrict: 'E',
	  bindings: {
	    onChange: '&'
	  },
	  template: _monthSelector2.default,
	  controller: _monthSelector4.default
	};
	
	exports.default = monthSelectorComponent;

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"month-selector\">\n  <div class=\"previous-month\"\n       ng-click=\"$ctrl.prev()\">\n    <span class=\"icon-arrow-select-up\"></span>\n  </div>\n  <div class=\"month-literals\">\n    {{$ctrl.monthLiteral}} {{$ctrl.yearLiteral}}\n  </div>\n  <div class=\"next-month\"\n       ng-click=\"$ctrl.next()\">\n    <span class=\"icon-arrow-select-up\"></span>\n  </div>\n</div>\n"

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MonthSelectorController = function () {
	  MonthSelectorController.$inject = ["EventEmitter"];
	  function MonthSelectorController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MonthSelectorController);
	    this.eventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(MonthSelectorController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      _moment2.default.locale('es');
	      this.moment = (0, _moment2.default)();
	      this._initLiterals();
	      this.onChange(this.eventEmitter(this._toDate()));
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      this.moment.subtract(1, 'month');
	      this._initLiterals();
	      this.onChange(this.eventEmitter(this._toDate()));
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.moment.add(1, 'month');
	      this._initLiterals();
	      this.onChange(this.eventEmitter(this._toDate()));
	    }
	  }, {
	    key: '_initLiterals',
	    value: function _initLiterals() {
	      this.monthLiteral = this.moment.format('MMMM');
	      this.yearLiteral = this.moment.format('YYYY');
	    }
	  }, {
	    key: '_toDate',
	    value: function _toDate() {
	      return this.moment.toDate();
	    }
	  }]);
	  return MonthSelectorController;
	}();
	
	exports.default = MonthSelectorController;

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1310);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./monthSelector.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./monthSelector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "month-selector .month-selector{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;width:100%;border-top:1px solid #eaebed;border-bottom:1px solid #eaebed}month-selector .month-selector,month-selector .month-selector .next-month,month-selector .month-selector .previous-month{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;height:35px}month-selector .month-selector .next-month,month-selector .month-selector .previous-month{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;cursor:pointer;width:41px;background:#0072c9}month-selector .month-selector .next-month .icon-arrow-select-up,month-selector .month-selector .previous-month .icon-arrow-select-up{color:#fff;font-size:10px}month-selector .month-selector .previous-month .icon-arrow-select-up{transform:rotate(270deg)}month-selector .month-selector .next-month .icon-arrow-select-up{transform:rotate(90deg)}month-selector .month-selector .month-literals{color:#0072c9;font-size:13px;text-transform:capitalize}", ""]);
	
	// exports


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _teamCalendarList = __webpack_require__(1312);
	
	var _teamCalendarList2 = _interopRequireDefault(_teamCalendarList);
	
	var _teamCalendarListCard = __webpack_require__(1317);
	
	var _teamCalendarListCard2 = _interopRequireDefault(_teamCalendarListCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamCalendarListModule = _angular2.default.module('teamCalendarList', [_teamCalendarListCard2.default]).component('teamCalendarList', _teamCalendarList2.default).name;
	
	exports.default = teamCalendarListModule;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamCalendarList = __webpack_require__(1313);
	
	var _teamCalendarList2 = _interopRequireDefault(_teamCalendarList);
	
	var _teamCalendarList3 = __webpack_require__(1314);
	
	var _teamCalendarList4 = _interopRequireDefault(_teamCalendarList3);
	
	__webpack_require__(1315);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamCalendarListComponent = {
	  restrict: 'E',
	  bindings: {
	    teamCalendarList: '<',
	    isDisabled: '<',
	    hasDelegated: '<',
	    delegation: '<'
	  },
	  template: _teamCalendarList2.default,
	  controller: _teamCalendarList4.default
	};
	
	exports.default = teamCalendarListComponent;

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"team-calendar-list-wrapper\">\n\n  <section ng-if=\"!$ctrl.isEmptyList($ctrl.teamCalendarList)\">\n    <team-calendar-list-card  is-disabled-incept=\"$ctrl.isDisabled\" has-delegated=\"$ctrl.hasDelegated\" delegation=\"$ctrl.delegation\" ng-repeat=\"card in $ctrl.teamCalendarList\"\n                             card=\"card\">\n    </team-calendar-list-card>\n  </section>\n\n  <section ng-if=\"$ctrl.isEmptyList($ctrl.teamCalendarList)\">\n    <div class=\"list-empty\">\n      <span class=\"icon-warning\"></span>\n      <p>{{'VACATIONS_ABSENCES.TEAM_CALENDAR.EMPTY_MSG' | translate}}</p>\n    </div>\n  </section>\n\n</div>\n"

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamCalendarListController = function () {
	  function TeamCalendarListController() {
	    (0, _classCallCheck3.default)(this, TeamCalendarListController);
	  }
	
	  (0, _createClass3.default)(TeamCalendarListController, [{
	    key: "isEmptyList",
	    value: function isEmptyList() {
	      var teamCalendarList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      return teamCalendarList.length === 0;
	    }
	  }]);
	  return TeamCalendarListController;
	}();
	
	exports.default = TeamCalendarListController;

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1316);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./teamCalendarList.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./teamCalendarList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-calendar-list .team-calendar-list-wrapper{margin-top:20px}team-calendar-list .list-empty{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;margin:45px 20px 0;text-align:center;border-bottom:1px solid #eaebed}team-calendar-list .list-empty p{font-size:20px;margin:15px 0 30px;font-family:Stag Sans}team-calendar-list .list-empty .icon-warning{font-size:60px}team-calendar-list .list-empty .icon-warning,team-calendar-list .list-empty p{color:#0072c9}", ""]);
	
	// exports


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _teamCalendarListCard = __webpack_require__(1318);
	
	var _teamCalendarListCard2 = _interopRequireDefault(_teamCalendarListCard);
	
	var _teamCalendarListCardDetail = __webpack_require__(1323);
	
	var _teamCalendarListCardDetail2 = _interopRequireDefault(_teamCalendarListCardDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamCalendarListCardModule = _angular2.default.module('teamCalendarListCard', [_teamCalendarListCardDetail2.default]).component('teamCalendarListCard', _teamCalendarListCard2.default).name;
	
	exports.default = teamCalendarListCardModule;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamCalendarListCard = __webpack_require__(1319);
	
	var _teamCalendarListCard2 = _interopRequireDefault(_teamCalendarListCard);
	
	var _teamCalendarListCard3 = __webpack_require__(1320);
	
	var _teamCalendarListCard4 = _interopRequireDefault(_teamCalendarListCard3);
	
	__webpack_require__(1321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamCalendarListCardComponent = {
	  restrict: 'E',
	  bindings: {
	    card: '<',
	    isDisabledIncept: '<',
	    hasDelegated: '<',
	    delegation: '<'
	  },
	  template: _teamCalendarListCard2.default,
	  controller: _teamCalendarListCard4.default
	};
	
	exports.default = teamCalendarListCardComponent;

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	module.exports = "<modal-warning-delegation ng-if=\"$ctrl.hasDelegated\"\n                          is-mobile-app = true\n                          title-body=\"{{ 'VACATIONS_ABSENCES.MAIN.WARNING_DELEGATION_TITLE' | translate }}\"\n                          delegation=\"$ctrl.delegation\"\n                          url-destination=\"$ctrl.urlDestination\">\n</modal-warning-delegation>\n\n<div class=\"team-calendar-list-card\">\n\n  <section class=\"card\"\n           ng-click=\"$ctrl.toggle()\">\n    <avatar-app name=\"$ctrl.card.name\"\n                email=\"$ctrl.card.email\"\n                user-id=\"$ctrl.card.userId\">\n    </avatar-app>\n    <div class=\"name\">\n      <span>{{$ctrl.card.name}}</span>\n    </div>\n    <span class=\"icon-arrow-select-up\"\n          ng-class=\"{'open': $ctrl.open}\">\n    </span>\n  </section>\n\n  <section class=\"detail\"\n           ng-class=\"{'open': $ctrl.open}\">\n    <div\n        class=\"inception-row\"\n        ng-class=\"{'remove-pointer-events': $ctrl.isDisabledIncept}\"\n        ng-click=\"$ctrl.incept($ctrl.card)\">\n      <i class=\"icon-calendar-blue\"></i>\n      <span>{{'VACATIONS_ABSENCES.TEAM_CALENDAR.INCEPT' | translate}}</span>\n    </div>\n\n    <team-calendar-list-card-detail periods-in-date=\"$ctrl.card.periodsInDate\">\n    </team-calendar-list-card-detail>\n\n  </section>\n\n</div>\n"

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamCalendarListCardController = function () {
	  TeamCalendarListCardController.$inject = ["inceptionService"];
	  function TeamCalendarListCardController(inceptionService) {
	
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamCalendarListCardController);
	    this.inceptionService = inceptionService;
	    this.open = false;
	  }
	
	  (0, _createClass3.default)(TeamCalendarListCardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.urlDestination = _states.STATES.VACATIONS_ABSENCES.DELEGATE;
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.open = !this.open;
	    }
	  }, {
	    key: '_showModalWarningDelegation',
	    value: function _showModalWarningDelegation() {
	      this.modalWarningDelegation.modal('show');
	    }
	  }, {
	    key: 'incept',
	    value: function incept(employee) {
	      if (this.hasDelegated) {
	        return this._showModalWarningDelegation();
	      }
	      this.inceptionService.incept(employee.employeeId, 'team-calendar-mobile');
	    }
	  }, {
	    key: 'modalWarningDelegation',
	    get: function get() {
	      var $modal = $(_constants.MODALS.WARNING_DELEGATION_MODAL);
	      return $modal;
	    }
	  }]);
	  return TeamCalendarListCardController;
	}();
	
	exports.default = TeamCalendarListCardController;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1322);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamCalendarListCard.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamCalendarListCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-calendar-list-card .team-calendar-list-card{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}team-calendar-list-card .team-calendar-list-card .card{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;height:60px;border-bottom:1px solid #eaebed;padding:0 20px}team-calendar-list-card .team-calendar-list-card .card .name{width:100%;text-align:left;margin:0;padding-left:20px}team-calendar-list-card .team-calendar-list-card .card .name span{font-family:Stag Sans;font-size:14px;color:#0072c9}team-calendar-list-card .team-calendar-list-card .card .icon-arrow-select-up{transition:transform .5s ease-in;display:inline-block;transform:rotate(180deg);font-size:10px;color:#0072c9}team-calendar-list-card .team-calendar-list-card .card .icon-arrow-select-up.open{transform:rotate(0deg)}team-calendar-list-card .team-calendar-list-card .detail{transform:scaleY(0);transform-origin:top;height:0;border-bottom:1px solid #eaebed}team-calendar-list-card .team-calendar-list-card .detail.open{transform:scaleY(1);height:auto;transition:transform .3s ease}team-calendar-list-card .team-calendar-list-card .detail .inception-row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:flexstart;-moz-justify-content:flexstart;justify-content:flexstart;cursor:pointer;height:45px;padding-left:30px;border-bottom:1px solid #eaebed}team-calendar-list-card .team-calendar-list-card .detail .inception-row span{display:inline-block;color:#0072c9;font-size:11px;padding-top:1px;padding-left:10px}", ""]);
	
	// exports


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _teamCalendarListCardDetail = __webpack_require__(1324);
	
	var _teamCalendarListCardDetail2 = _interopRequireDefault(_teamCalendarListCardDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamCalendarListCardDetailModule = _angular2.default.module('teamCalendarListCardDetail', []).component('teamCalendarListCardDetail', _teamCalendarListCardDetail2.default).name;
	
	exports.default = teamCalendarListCardDetailModule;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamCalendarListCardDetail = __webpack_require__(1325);
	
	var _teamCalendarListCardDetail2 = _interopRequireDefault(_teamCalendarListCardDetail);
	
	var _teamCalendarListCardDetail3 = __webpack_require__(1326);
	
	var _teamCalendarListCardDetail4 = _interopRequireDefault(_teamCalendarListCardDetail3);
	
	__webpack_require__(1327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamCalendarListCardDetailComponent = {
	  restrict: 'E',
	  bindings: {
	    periodsInDate: '<'
	  },
	  template: _teamCalendarListCardDetail2.default,
	  controller: _teamCalendarListCardDetail4.default
	};
	
	exports.default = teamCalendarListCardDetailComponent;

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

	module.exports = "<div>\n\n  <section ng-if=\"$ctrl.hasPeriods()\">\n\n    <header ng-if=\"$ctrl.hasVacations()\">\n        {{'VACATIONS_ABSENCES.GENERAL.VACATIONS' | translate}}\n    </header>\n    <period-card read-only=\"$ctrl.readOnly\"\n                  ng-repeat=\"period in $ctrl.vacations\"\n                  is-mobile-app=\"$ctrl.isMobileApp\"\n                  is-team-calendar-mobile=\"$ctrl.isTeamCalendarMobile\"\n                  period=\"period\">\n    </period-card>\n\n    <header ng-if=\"$ctrl.hasAbsences()\">\n      {{'VACATIONS_ABSENCES.GENERAL.ABSENCES'|translate}}\n    </header>\n    <period-card read-only=\"$ctrl.readOnly\"\n                  ng-repeat=\"period in $ctrl.absences\"\n                  is-mobile-app=\"$ctrl.isMobileApp\"\n                  is-team-calendar-mobile=\"$ctrl.isTeamCalendarMobile\"\n                  period=\"period\">\n    </period-card>\n\n  </section>\n\n  <section ng-if=\"!$ctrl.hasPeriods()\">\n\n    <div class=\"list-empty\">\n      <span class=\"icon-warning\"></span>\n      <p>{{'VACATIONS_ABSENCES.TEAM_CALENDAR.NO_EMPLOYEE_PERIODS' | translate}}</p>\n    </div>\n\n  </section>\n\n\n</div>\n"

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamCalendarListCardDetailController = function () {
	  function TeamCalendarListCardDetailController() {
	    (0, _classCallCheck3.default)(this, TeamCalendarListCardDetailController);
	  }
	
	  (0, _createClass3.default)(TeamCalendarListCardDetailController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.readOnly = true;
	      this.isMobileApp = true;
	      this.isTeamCalendarMobile = true;
	      this.vacations = this.periodsInDate.filter(function (period) {
	        return period.type === 'vacation';
	      });
	      this.absences = this.periodsInDate.filter(function (period) {
	        return period.type === 'absence';
	      });
	    }
	  }, {
	    key: 'hasPeriods',
	    value: function hasPeriods() {
	      return this.hasVacations() || this.hasAbsences();
	    }
	  }, {
	    key: 'hasVacations',
	    value: function hasVacations() {
	      return this.vacations.length > 0;
	    }
	  }, {
	    key: 'hasAbsences',
	    value: function hasAbsences() {
	      return this.absences.length > 0;
	    }
	  }]);
	  return TeamCalendarListCardDetailController;
	}();
	
	exports.default = TeamCalendarListCardDetailController;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1328);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamCalendarListCardDetail.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./teamCalendarListCardDetail.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "team-calendar-list-card-detail header{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;height:37px;background:#f4f4f4;padding-left:37px;font-size:14px;color:#666}", ""]);
	
	// exports


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _managerAsEmployeeCalendar = __webpack_require__(1330);
	
	var _managerAsEmployeeCalendar2 = _interopRequireDefault(_managerAsEmployeeCalendar);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerAsEmployeeCalendarModule = _angular2.default.module('vacations-absences.managerAsEmployeeCalendar', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR, {
	    url: _routes.ROUTES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR,
	    component: 'managerAsEmployeeCalendar'
	  });
	}]).component('managerAsEmployeeCalendar', _managerAsEmployeeCalendar2.default).name;
	
	exports.default = managerAsEmployeeCalendarModule;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _managerAsEmployeeCalendar = __webpack_require__(1331);
	
	var _managerAsEmployeeCalendar2 = _interopRequireDefault(_managerAsEmployeeCalendar);
	
	var _managerAsEmployeeCalendar3 = __webpack_require__(1332);
	
	var _managerAsEmployeeCalendar4 = _interopRequireDefault(_managerAsEmployeeCalendar3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerAsEmployeeCalendarComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _managerAsEmployeeCalendar2.default,
	  controller: _managerAsEmployeeCalendar4.default
	};
	
	exports.default = managerAsEmployeeCalendarComponent;

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

	module.exports = "<my-vacations user-inception-id=\"$ctrl.userInceptionId\"></my-vacations>\n"

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManagerAsEmployeeCalendarController = function ManagerAsEmployeeCalendarController($stateParams) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, ManagerAsEmployeeCalendarController);
	  this.userInceptionId = $stateParams.employeeId;
	};
	ManagerAsEmployeeCalendarController.$inject = ["$stateParams"];
	
	exports.default = ManagerAsEmployeeCalendarController;

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _managerAsEmployeeCalendarMobile = __webpack_require__(1334);
	
	var _managerAsEmployeeCalendarMobile2 = _interopRequireDefault(_managerAsEmployeeCalendarMobile);
	
	var _inceptionHeader = __webpack_require__(1337);
	
	var _inceptionHeader2 = _interopRequireDefault(_inceptionHeader);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerAsEmployeeCalendarMobileModule = _angular2.default.module('vacations-absences.managerAsEmployeeCalendarMobile', [_angularUiRouter2.default, _inceptionHeader2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR_MOBILE, {
	    url: _routes.ROUTES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR_MOBILE,
	    component: 'managerAsEmployeeCalendarMobile'
	  });
	}]).component('managerAsEmployeeCalendarMobile', _managerAsEmployeeCalendarMobile2.default).name;
	
	exports.default = managerAsEmployeeCalendarMobileModule;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _managerAsEmployeeCalendarMobile = __webpack_require__(1335);
	
	var _managerAsEmployeeCalendarMobile2 = _interopRequireDefault(_managerAsEmployeeCalendarMobile);
	
	var _managerAsEmployeeCalendarMobile3 = __webpack_require__(1336);
	
	var _managerAsEmployeeCalendarMobile4 = _interopRequireDefault(_managerAsEmployeeCalendarMobile3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerAsEmployeeCalendarMobileComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _managerAsEmployeeCalendarMobile2.default,
	  controller: _managerAsEmployeeCalendarMobile4.default
	};
	
	exports.default = managerAsEmployeeCalendarMobileComponent;

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	module.exports = "<inception-header view=\"$ctrl.view\"\n                  views=\"$ctrl.views\"\n                  on-exit-inception=\"$ctrl.onExitInception()\"\n                  on-change-view=\"$ctrl.onChangeView($event)\"\n                  available-vacations=\"$ctrl.availableVacations\"\n                  current-employee=\"$ctrl.currentEmployee\"\n                  is-mobile-app=\"$ctrl.isMobileApp\">\n</inception-header>\n\n<my-vacations-mobile ng-if=\"$ctrl.isMyVacationsMobile()\"\n                     class=\"inception-pull-to-refresh\"\n                     user-inception-id=\"$ctrl.userInceptionId\"\n                     on-click-period-mobile-list-link=\"$ctrl.onClickPeriodMobileListLink()\">\n</my-vacations-mobile>\n\n<period-list-mobile ng-if=\"$ctrl.isPeriodListMobile()\"\n                    class=\"inception-pull-to-refresh\"\n                    user-inception-id=\"$ctrl.userInceptionId\">\n</period-list-mobile>\n"

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var views = {
	  myVacationsMobile: 'myVacationsMobile',
	  periodListMobile: 'periodListMobile'
	};
	
	var from = {
	  'team-requests': _states.STATES.VACATIONS_ABSENCES.TEAM_REQUESTS,
	  'team-calendar-mobile': _states.STATES.VACATIONS_ABSENCES.TEAM_CALENDAR_MOBILE
	};
	
	var ManagerAsEmployeeCalendarMobileController = function () {
	  ManagerAsEmployeeCalendarMobileController.$inject = ["$stateParams", "$state", "vacationEmployeeRepositoryService", "vacationUserDataService", "loadingMobileService", "$window"];
	  function ManagerAsEmployeeCalendarMobileController($stateParams, $state, vacationEmployeeRepositoryService, vacationUserDataService, loadingMobileService, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ManagerAsEmployeeCalendarMobileController);
	    this.stateParams = $stateParams;
	    this.userInceptionId = $stateParams.employeeId;
	    this.state = $state;
	    this.views = views;
	    this.view = views.myVacationsMobile;
	    this.UserDataService = vacationUserDataService;
	    this.employeeRepositoryService = vacationEmployeeRepositoryService;
	    this.loadingMobileService = loadingMobileService;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.dateToday = new Date();
	    this.year = this.dateToday.getFullYear();
	  }
	
	  (0, _createClass3.default)(ManagerAsEmployeeCalendarMobileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.userId = this.UserDataService.getEmployee().userId;
	      this._requestData(this.userId, this.userInceptionId);
	    }
	  }, {
	    key: '_requestData',
	    value: function _requestData(userId, userInceptionId) {
	      var _this = this;
	
	      this.loadingMobileService.show();
	      return this.employeeRepositoryService.getEmployee(userId, this.year, userInceptionId).then(function (employee) {
	        _this._loadData(employee);
	      }).finally(function () {
	        return _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '_loadData',
	    value: function _loadData(employee) {
	      this.currentEmployee = employee;
	      this.rawPeriodDays = employee.periodInDays;
	      this.user = employee.getProfile();
	      this.availableVacations = employee.availableVacations;
	      this.vacationCount = employee.getAgreementVacationCount();
	      this.allPeriods = employee.allPeriods;
	    }
	  }, {
	    key: 'onExitInception',
	    value: function onExitInception() {
	      this.state.go(from[this.stateParams.from]);
	    }
	  }, {
	    key: 'onChangeView',
	    value: function onChangeView($event) {
	      this.loadingMobileService.show();
	      this.view = $event.view;
	    }
	  }, {
	    key: 'isMyVacationsMobile',
	    value: function isMyVacationsMobile() {
	      return this.view === this.views.myVacationsMobile;
	    }
	  }, {
	    key: 'isPeriodListMobile',
	    value: function isPeriodListMobile() {
	      return this.view === this.views.periodListMobile;
	    }
	  }, {
	    key: 'onClickPeriodMobileListLink',
	    value: function onClickPeriodMobileListLink() {
	      this.view = this.views.periodListMobile;
	    }
	  }]);
	  return ManagerAsEmployeeCalendarMobileController;
	}();
	
	exports.default = ManagerAsEmployeeCalendarMobileController;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _inceptionHeader = __webpack_require__(1338);
	
	var _inceptionHeader2 = _interopRequireDefault(_inceptionHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inceptionHeaderModule = _angular2.default.module('inceptionHeader', [_angularUiRouter2.default]).component('inceptionHeader', _inceptionHeader2.default).name;
	
	exports.default = inceptionHeaderModule;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inceptionHeader = __webpack_require__(1339);
	
	var _inceptionHeader2 = _interopRequireDefault(_inceptionHeader);
	
	var _inceptionHeader3 = __webpack_require__(1340);
	
	var _inceptionHeader4 = _interopRequireDefault(_inceptionHeader3);
	
	__webpack_require__(1341);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inceptionHeaderComponent = {
	  restrict: 'E',
	  bindings: {
	    view: '<',
	    views: '<',
	    onExitInception: '&',
	    onChangeView: '&',
	    availableVacations: '<',
	    currentEmployee: '<',
	    isMobileApp: '<'
	  },
	  template: _inceptionHeader2.default,
	  controller: _inceptionHeader4.default
	};
	
	exports.default = inceptionHeaderComponent;

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"inception-header\"\n     ng-if=\"$ctrl.currentEmployee\">\n\n  <div class=\"inception-switch\">\n    <span class=\"icon-calendar\"\n          ng-if=\"$ctrl.isPeriodListMobile()\"\n          ng-click=\"$ctrl.onMyVacationsMobile()\">\n    </span>\n    <span class=\"icon-list-view-icon\"\n          ng-if=\"$ctrl.isMyVacationsMobile()\"\n          ng-click=\"$ctrl.onPeriodListMobile()\">\n    </span>\n  </div>\n\n  <div class=\"inception-info\">\n    <avatar-app name=\"$ctrl.currentEmployee.getProfile().name\"\n                email=\"$ctrl.currentEmployee.getProfile().email\"\n                user-id=\"$ctrl.currentEmployee.getProfile().userId\">\n    </avatar-app>\n    <h1 class=\"inception-employee-name\">\n      {{$ctrl.currentEmployee.getProfile().name}}\n    </h1>\n    <holiday-summary class=\"holiday-summary-header\"\n                     pending-days=\"$ctrl.availableVacations.pendingDays\"\n                     own-days=\"$ctrl.availableVacations.ownDays\"\n                     christmas-days=\"$ctrl.availableVacations.christmasDays\"\n                     last-year=\"$ctrl.availableVacations.lastYear\"\n                     is-inception=\"$ctrl.isInception\"\n                     is-manager=\"$ctrl.currentEmployee.isManager()\"\n                     inserted-in=\"header\"\n                     is-mobile-app=\"$ctrl.isMobileApp\">\n    </holiday-summary>\n  </div>\n\n  <div class=\"inception-exit\"\n       ng-click=\"$ctrl.onExitInception()\">\n    <span class=\"icon icon-cross\"></span>\n  </div>\n\n</div>\n"

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InceptionHeaderController = function () {
	  InceptionHeaderController.$inject = ["EventEmitter"];
	  function InceptionHeaderController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, InceptionHeaderController);
	    this.eventEmitter = EventEmitter;
	    this.isInception = true;
	  }
	
	  (0, _createClass3.default)(InceptionHeaderController, [{
	    key: 'isMyVacationsMobile',
	    value: function isMyVacationsMobile() {
	      return this.view === this.views.myVacationsMobile;
	    }
	  }, {
	    key: 'isPeriodListMobile',
	    value: function isPeriodListMobile() {
	      return this.view === this.views.periodListMobile;
	    }
	  }, {
	    key: 'onMyVacationsMobile',
	    value: function onMyVacationsMobile() {
	      this.onChangeView(this.eventEmitter({ view: this.views.myVacationsMobile }));
	    }
	  }, {
	    key: 'onPeriodListMobile',
	    value: function onPeriodListMobile() {
	      this.onChangeView(this.eventEmitter({ view: this.views.periodListMobile }));
	    }
	  }]);
	  return InceptionHeaderController;
	}();
	
	exports.default = InceptionHeaderController;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1342);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./inceptionHeader.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./inceptionHeader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "inception-header .inception-header{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;position:fixed;z-index:2000;top:60px;left:0;width:100%;height:128px;padding:22px 11px 0;background:#fff;box-shadow:0 0 4px 0 #d3d3d3}inception-header .inception-header .inception-exit{width:35px;text-align:center;padding-top:9px}inception-header .inception-header .inception-exit span{color:#979797;display:inline-block;font-size:14px}inception-header .inception-header .inception-switch{width:35px;text-align:center;padding-top:5px}inception-header .inception-header .inception-switch span{color:#0072c9;display:inline-block;font-size:25px}inception-header .inception-header .inception-info{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center}inception-header .inception-header .inception-info .inception-employee-name{text-align:center;margin:0;font-family:Stag Sans;font-weight:400;font-size:16px;color:#0072c9;margin-top:7px}inception-header .inception-header .inception-info holiday-summary .summary-container.responsiveMobile{background:transparent;border:none;padding:0 5px;height:auto;min-height:0}inception-header .inception-header .inception-info holiday-summary .summary-container.responsiveMobile .summary-title{display:none}inception-header .inception-header .inception-info holiday-summary .summary-container.responsiveMobile .summary-content span{padding-right:3px;margin-right:3px;font-size:11px;color:#666}", ""]);
	
	// exports


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vacationsAbsencesDelegations = __webpack_require__(1344);
	
	var _vacationsAbsencesDelegations2 = _interopRequireDefault(_vacationsAbsencesDelegations);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationsAbsencesDelegationsModule = _angular2.default.module('vacations-absences.vacationsAbsencesDelegations', [_angularUiRouter2.default]).component('vacationsAbsencesDelegations', _vacationsAbsencesDelegations2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.DELEGATE, {
	    url: _routes.ROUTES.VACATIONS_ABSENCES.DELEGATE,
	    component: 'vacationsAbsencesDelegations',
	    data: {
	      requiresAuth: true,
	      requiresManager: true
	    }
	  });
	}]).name;
	
	exports.default = vacationsAbsencesDelegationsModule;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vacationsAbsencesDelegations = __webpack_require__(1345);
	
	var _vacationsAbsencesDelegations2 = _interopRequireDefault(_vacationsAbsencesDelegations);
	
	var _vacationsAbsencesDelegations3 = __webpack_require__(1346);
	
	var _vacationsAbsencesDelegations4 = _interopRequireDefault(_vacationsAbsencesDelegations3);
	
	__webpack_require__(1347);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationsAbsencesDelegationsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _vacationsAbsencesDelegations2.default,
	  controller: _vacationsAbsencesDelegations4.default
	};
	
	exports.default = vacationsAbsencesDelegationsComponent;

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

	module.exports = "<modal-coachmark ng-if=\"!$ctrl.isMobileApp\"\n                 data=\"$ctrl.coachmarkData\"\n                 user-id=\"$ctrl.userId\">\n</modal-coachmark>\n\n<modal-delegation-manager is-mobile-app=\"$ctrl.isMobileApp\"\n                          state=\"$ctrl.modalState\"\n                          delegation=\"$ctrl.selectedDelegation\"\n                          modal-close=\"$ctrl.closeModal()\"\n                          module-id=\"$ctrl.moduleId\"\n                          custom-title=\"$ctrl.modalTitle\"\n                          message=\"$ctrl.modalMessage\"\n                          cancel-delegation-request=\"$ctrl.sendCancelDelegation($event)\"\n                          edit-delegation-request=\"$ctrl.sendEditDelegation($event)\"\n                          on-send-delegation=\"$ctrl.sendDelegation($event)\"\n                          employee-id=\"$ctrl.userId\">\n</modal-delegation-manager>\n\n<div ng-if=\"$ctrl.loaded\"\n     class=\"container hpd animation-appear\"\n     ng-class=\"{'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp, 'with-floating-action-buttons': $ctrl.isMobileApp}\"\n     pull-to-refresh=\"$ctrl.getDelegationsFromBack()\">\n\n    <delegations-list is-mobile-app=\"$ctrl.isMobileApp\"\n                      open-delegation-modal=\"$ctrl.openModal($event)\"\n                      delegations=\"$ctrl.delegationsObject\">\n    </delegations-list>\n</div>\n\n<loading ng-if=\"!$ctrl.isMobileApp\"\n         ng-hide=\"$ctrl.loaded\">\n</loading>\n"

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(723);
	
	var _dateUtils = __webpack_require__(1132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VacationsAbsencesDelegationsController = function () {
	  VacationsAbsencesDelegationsController.$inject = ["$window", "$log", "vacationDelegationService", "vacationUserDataService", "HelperDelegationsService", "loadingMobileService", "metricsService"];
	  function VacationsAbsencesDelegationsController($window, $log, vacationDelegationService, vacationUserDataService, HelperDelegationsService, loadingMobileService, metricsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, VacationsAbsencesDelegationsController);
	    this.log = $log;
	    this.vacationDelegationService = vacationDelegationService;
	    this.vacationUserDataService = vacationUserDataService;
	    this.helperDelegations = HelperDelegationsService;
	    this.loadingMobileService = loadingMobileService;
	    this.metricsService = metricsService;
	
	    this.loaded = false;
	    this.moduleId = _constants2.MODULE_ID;
	    this.userId = this.vacationUserDataService.getEmployee().userId;
	    this.successTitle = 'GLOBALS.SUCCESS_DELEGATION';
	    this.cancelDelegationSuccessTitle = 'GLOBALS.CANCEL_SUCCESS_DELEGATION';
	    this.coachmarkData = _constants2.VA_DELEGATIONS_MODAL_COACHMARK_CONFIG;
	    this.isMobileApp = $window.innerWidth < 1024;
	  }
	
	  (0, _createClass3.default)(VacationsAbsencesDelegationsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getDelegationsFromBack();
	    }
	  }, {
	    key: 'getDelegationsFromBack',
	    value: function getDelegationsFromBack() {
	      var _this = this;
	
	      this.loadingMobileService.show();
	      this.vacationDelegationService.getDelegations(this.userId).then(function (delegations) {
	        _this.delegationsObject = delegations;
	        _this.helperDelegations.sendEventToChangeIconDelegations();
	        _this.loaded = true;
	      }).finally(function () {
	        return _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(_ref) {
	      var action = _ref.action,
	          delegation = _ref.delegation;
	
	      this.modalState = action;
	      this.selectedDelegation = delegation;
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.modalState = '';
	      this.selectedDelegation = {};
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'sendCancelDelegation',
	    value: function sendCancelDelegation() {
	      var _this2 = this;
	
	      var objectToCancel = {
	        startDate: this.selectedDelegation.startDate,
	        employeeId: this.selectedDelegation.employeeId,
	        service: _constants2.MODULE_ID
	      };
	
	      this.loadingMobileService.show();
	      this.vacationDelegationService.deleteDelegation(this.userId, objectToCancel).then(function () {
	        _this2.modalState = _constants.DELEGATION_STATES.SUCCESS;
	        _this2.modalTitle = _this2.cancelDelegationSuccessTitle;
	        _this2.getDelegationsFromBack();
	      }, function (error) {
	        _this2.modalState = _constants.DELEGATION_STATES.ERROR;
	        _this2.modalMessage = error.data.message;
	        _this2.modalTitle = error.data.errors.codigo;
	      }).finally(function () {
	        return _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'sendEditDelegation',
	    value: function sendEditDelegation(_ref2) {
	      var _this3 = this;
	
	      var startDate = _ref2.startDate,
	          endDate = _ref2.endDate;
	
	      startDate = (0, _dateUtils.formatDate)(startDate);
	      endDate = (0, _dateUtils.formatDate)(endDate);
	
	      var objectToSend = {
	        startDate: startDate,
	        endDate: endDate,
	        id: this.selectedDelegation.id,
	        service: _constants2.MODULE_ID
	      };
	
	      this.loadingMobileService.show();
	      this.vacationDelegationService.updateDelegation(this.userId, objectToSend).then(function () {
	        _this3.modalState = _constants.DELEGATION_STATES.SUCCESS;
	        _this3.modalTitle = _this3.successTitle;
	        _this3.getDelegationsFromBack();
	      }, function (error) {
	        _this3.modalState = _constants.DELEGATION_STATES.ERROR;
	        _this3.modalMessage = error.data.message;
	        _this3.modalTitle = error.data.errors.codigo;
	      }).finally(function () {
	        return _this3.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'sendDelegation',
	    value: function sendDelegation(delegation) {
	      var _this4 = this;
	
	      var startDate = (0, _dateUtils.formatDate)(delegation.startDate);
	      var endDate = (0, _dateUtils.formatDate)(delegation.endDate);
	      var employeeId = delegation.employee;
	
	      var delegationToCreate = {
	        startDate: startDate,
	        endDate: endDate,
	        employeeId: employeeId,
	        service: _constants2.MODULE_ID
	      };
	
	      this.log.info({ delegationToCreate: delegationToCreate });
	      this.loadingMobileService.show();
	      this.vacationDelegationService.createDelegation(this.userId, delegationToCreate).then(function () {
	        _this4.modalState = _constants.DELEGATION_STATES.SUCCESS;
	        _this4.modalTitle = _this4.successTitle;
	        _this4.getDelegationsFromBack();
	
	        _this4.metricsService.trackVacationsAbsencesDelegation();
	      }, function (error) {
	        _this4.modalState = _constants.DELEGATION_STATES.ERROR;
	        _this4.modalMessage = error.data.message;
	        _this4.modalTitle = error.data.errors.codigo;
	      }).finally(function () {
	        return _this4.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      var _this5 = this;
	
	      var $modal = $(_constants.MODALS.DELEGATIONS_MANAGER);
	      $modal.on('hidden.bs.modal', function () {
	        return _this5.closeModal();
	      });
	      return $modal;
	    }
	  }]);
	  return VacationsAbsencesDelegationsController;
	}();
	
	exports.default = VacationsAbsencesDelegationsController;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1348);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./vacationsAbsencesDelegations.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./vacationsAbsencesDelegations.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _periodListMobile = __webpack_require__(1350);
	
	var _periodListMobile2 = _interopRequireDefault(_periodListMobile);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodListMobileModule = _angular2.default.module('periodListMobile', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.PERIOD_LIST_MOBILE, {
	    url: _routes.ROUTES.VACATIONS_ABSENCES.PERIOD_LIST_MOBILE,
	    component: 'periodListMobile',
	    params: {
	      dateToLoad: null
	    },
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).component('periodListMobile', _periodListMobile2.default).name;
	
	exports.default = periodListMobileModule;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _periodListMobile = __webpack_require__(1351);
	
	var _periodListMobile2 = _interopRequireDefault(_periodListMobile);
	
	var _periodListMobile3 = __webpack_require__(1352);
	
	var _periodListMobile4 = _interopRequireDefault(_periodListMobile3);
	
	__webpack_require__(1353);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodListMobileComponent = {
	  restrict: 'E',
	  bindings: {
	    userInceptionId: '<',
	    dateToLoad: '<'
	  },
	  template: _periodListMobile2.default,
	  controller: _periodListMobile4.default
	};
	
	exports.default = periodListMobileComponent;

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	module.exports = "<modal-remove-period user-id=\"$ctrl.userId\"\n                     is-inception=\"$ctrl.isInception()\"\n                     user-inception-id=\"$ctrl.userInceptionId\"\n                     on-remove=\"$ctrl.removePeriod($event)\"\n                     is-mobile-app=\"$ctrl.isMobileApp\">\n</modal-remove-period>\n\n<modal-request ng-if=\"$ctrl.modalExists()\"\n               user-id=\"$ctrl.userId\"\n               user-inception-id=\"$ctrl.userInceptionId\"\n               start-date=\"$ctrl.startDate\"\n               add-event=\"$ctrl.editPeriodEvent($event);\"\n               vacation-period-count=\"$ctrl.vacationCount\"\n               mode=\"$ctrl.requestHolidayMode\"\n               period-to-edit=\"$ctrl.periodToEdit\"\n               original-period=\"$ctrl.originalPeriod\"\n               is-inception=\"$ctrl.isInception()\"\n               open-on=\"$ctrl.requestModalOpenOn\"\n               is-mobile-app=\"$ctrl.isMobileApp\"\n               open-modal-event=\"$ctrl.openModalEvent()\">\n</modal-request>\n\n<div ng-if=\"$ctrl.loaded\"\n     class=\"container hpd responsiveMobile animation-appear\"\n     ng-class=\"{'is-inception': $ctrl.isInception()}\"\n     pull-to-refresh=\"$ctrl.$onInit()\">\n\n  <div class=\"period-list-filters-container\">\n      <calendar-filters class=\"period-list-filters\"\n                        is-mobile-app=\"$ctrl.isMobileApp\"\n                        ng-if=\"$ctrl.isHolidayAbsenceEvents\"\n                        on-change-filters=\"$ctrl.onChangeFilters($event);\">\n      </calendar-filters>\n  </div>\n\n  <period-list is-mobile-app=\"$ctrl.isMobileApp\"\n               is-inception=\"$ctrl.isInception()\"\n               events=\"$ctrl.allPeriods\"\n               filters=\"$ctrl.filters\"\n               format=\"$ctrl.format\"\n               on-remove-period=\"$ctrl.onRemovePeriod($event)\"\n               on-edit-period=\"$ctrl.onEditPeriod($event)\"\n               on-add-period=\"$ctrl.onAddPeriod($event)\">\n  </period-list>\n</div>\n"

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _request = __webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeriodListMobileController = function () {
	  PeriodListMobileController.$inject = ["$rootScope", "$stateParams", "$window", "$state", "$timeout", "$scope", "vacationUserDataService", "vacationEmployeeRepositoryService", "loadingMobileService"];
	  function PeriodListMobileController($rootScope, $stateParams, $window, $state, $timeout, $scope, vacationUserDataService, vacationEmployeeRepositoryService, loadingMobileService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PeriodListMobileController);
	    this.rootScope = $rootScope;
	    this.stateParams = $stateParams;
	    this.state = $state;
	    this.timeout = $timeout;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.UserDataService = vacationUserDataService;
	    this.employeeRepositoryService = vacationEmployeeRepositoryService;
	    this.loadingMobileService = loadingMobileService;
	    this.scope = $scope;
	    this.start();
	  }
	
	  (0, _createClass3.default)(PeriodListMobileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.year = this.stateParams.dateToLoad ? this.stateParams.dateToLoad.getFullYear() : new Date().getFullYear();
	      this.userId = this.UserDataService.getEmployee().userId;
	      if (!this.isInception()) {
	        this.changeTitle();
	      }
	      this._requestData(this.userId, this.year, this.userInceptionId);
	    }
	  }, {
	    key: 'modalExists',
	    value: function modalExists() {
	      return this.requestHolidayMode !== undefined;
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this.filters = [];
	      this.format = '';
	    }
	  }, {
	    key: '_requestData',
	    value: function _requestData(userId, year, userInceptionId) {
	      var _this = this;
	
	      this.loaded = false;
	      this.loadingMobileService.show();
	      return this.employeeRepositoryService.getEmployee(userId, year, userInceptionId).then(function (employee) {
	        _this._loadData(employee);
	      }).finally(function () {
	        return _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '_loadData',
	    value: function _loadData(employee) {
	      this.currentEmployee = employee;
	      this.allPeriods = employee.allPeriods;
	      this.vacationCount = employee.getAgreementVacationCount();
	      this.hasEventsToShow();
	      this.loaded = true;
	    }
	  }, {
	    key: 'onChangeFilters',
	    value: function onChangeFilters($event) {
	      this.filters = $event.filters;
	    }
	  }, {
	    key: 'changeTitle',
	    value: function changeTitle() {
	      this.rootScope.$broadcast(_constants.EVENTS.CHANGE_TITLE, {
	        title: 'VACATIONS_ABSENCES.PERIOD_LIST.REQUEST_STATUS_MENU_TITLE'
	      });
	    }
	  }, {
	    key: 'onRemovePeriod',
	    value: function onRemovePeriod($event) {
	      this.rootScope.$broadcast(_constants.EVENTS.CONTEXT_MENU_REMOVE, { period: $event.period });
	    }
	  }, {
	    key: 'onEditPeriod',
	    value: function onEditPeriod($event) {
	      this.requestHolidayMode = _constants.MODES.EDIT;
	      this.periodToEdit = $event.period;
	      this.originalPeriod = angular.copy($event.period);
	      this.periodToEdit.startDate = new Date(this.periodToEdit.startDate);
	
	      if (this.periodToEdit.endDate) {
	        this.periodToEdit.endDate = new Date(this.periodToEdit.endDate);
	      }
	
	      this._openRequestModal();
	    }
	  }, {
	    key: 'onAddPeriod',
	    value: function onAddPeriod($event) {
	      this.requestHolidayMode = _constants.MODES.CREATE;
	      this.requestModalOpenOn = _request.Request.TYPES.ABSENCE;
	      this.startDate = new Date($event.startDate);
	
	      this._openRequestModal();
	    }
	  }, {
	    key: '_openRequestModal',
	    value: function _openRequestModal() {
	      var _this2 = this;
	
	      this.timeout(function () {
	        return _this2.requestModal.modal('show');
	      });
	    }
	  }, {
	    key: 'openModalEvent',
	    value: function openModalEvent() {
	      var _this3 = this;
	
	      this._openRequestModal();
	      this.timeout(function () {
	        return _this3.requestHolidayMode = _constants.MODES.EDIT;
	      }, 100);
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.loadingMobileService.hide();
	    }
	  }, {
	    key: 'removePeriod',
	    value: function removePeriod(_ref) {
	      var status = _ref.status;
	
	      if (status === _constants.STATUS_CODE_OK) {
	        this._requestData(this.userId, this.year, this.userInceptionId);
	      }
	    }
	  }, {
	    key: 'editPeriodEvent',
	    value: function editPeriodEvent(_ref2) {
	      var _this4 = this;
	
	      var startDate = _ref2.startDate,
	          endDate = _ref2.endDate;
	
	      this._requestData(this.userId, this.year, this.userInceptionId).then(function () {
	        _this4.rootScope.$broadcast(_constants.EVENTS.ADD_PERIOD, {
	          startDate: startDate.getMonth(),
	          endDate: endDate
	        });
	      });
	    }
	  }, {
	    key: 'hasEventsToShow',
	    value: function hasEventsToShow() {
	      this.isHolidayAbsenceEvents = this.allPeriods.some(function (event) {
	        return event.type !== 'holiday';
	      });
	    }
	  }, {
	    key: 'isInception',
	    value: function isInception() {
	      return !!this.userInceptionId;
	    }
	  }, {
	    key: 'requestModal',
	    get: function get() {
	      var _this5 = this;
	
	      var $modal = $(_constants.MODALS.REQUEST);
	
	      if ($modal.length > 0) {
	        $modal.on('hidden.bs.modal', function () {
	          _this5.timeout(function () {
	            _this5.startDate = '';
	            _this5.requestHolidayMode = _constants.MODES.CREATE;
	            delete _this5.requestModalOpenOn;
	            delete _this5.periodToEdit;
	          });
	        });
	      }
	
	      return $modal;
	    }
	  }]);
	  return PeriodListMobileController;
	}();
	
	exports.default = PeriodListMobileController;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1354);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./periodListMobile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./periodListMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "period-list-mobile .container.hpd.responsiveMobile{padding-left:0;padding-right:0}@media only screen and (device-width:375px)and (device-height:812px)and (-webkit-device-pixel-ratio:3){period-list-mobile .container.hpd.responsiveMobile{padding-bottom:30px}}period-list-mobile .container.hpd.responsiveMobile.is-inception{padding-top:128px}period-list-mobile .period-list-filters{padding-top:10px;padding-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _scheduleMobile = __webpack_require__(1356);
	
	var _scheduleMobile2 = _interopRequireDefault(_scheduleMobile);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheduleMobileModule = _angular2.default.module('scheduleMobile', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.VACATIONS_ABSENCES.SCHEDULE_MOBILE, {
	    url: _routes.ROUTES.VACATIONS_ABSENCES.SCHEDULE_MOBILE,
	    component: 'scheduleMobile',
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).component('scheduleMobile', _scheduleMobile2.default).name;
	
	exports.default = scheduleMobileModule;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _scheduleMobile = __webpack_require__(1357);
	
	var _scheduleMobile2 = _interopRequireDefault(_scheduleMobile);
	
	var _scheduleMobile3 = __webpack_require__(1358);
	
	var _scheduleMobile4 = _interopRequireDefault(_scheduleMobile3);
	
	__webpack_require__(1363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheduleMobileComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _scheduleMobile2.default,
	  controller: _scheduleMobile4.default
	};
	
	exports.default = scheduleMobileComponent;

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd responsiveMobile schedule-mobile\">\n  <calendar-grid user=\"$ctrl.scheduleData\"\n                 loaded=\"$ctrl.loaded\"\n                 is-mobile-app=\"$ctrl.isMobileApp\"\n                 is-mobile-schedule=\"$ctrl.isMobileSchedule\"\n                 date-today=\"$ctrl.dateToday\">\n  </calendar-grid>\n</div>"

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _periods = __webpack_require__(1359);
	
	var _periods2 = _interopRequireDefault(_periods);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduleMobileController = function () {
	  ScheduleMobileController.$inject = ["$window", "modalCalendarGridService", "vacationUserDataService"];
	  function ScheduleMobileController($window, modalCalendarGridService, vacationUserDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ScheduleMobileController);
	    this.modalCalendarGridService = modalCalendarGridService;
	    this.window = $window;
	    this.UserDataService = vacationUserDataService;
	
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.isMobileSchedule = true;
	    this.dateToday = new Date();
	  }
	
	  (0, _createClass3.default)(ScheduleMobileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userId = this.UserDataService.getEmployee().userId;
	
	      this.scheduleData = {};
	
	      this.modalCalendarGridService.getRequestModalPeriods(this.userId).then(function (response) {
	        _this.scheduleData.vacationPeriods = response.data;
	        _this.scheduleData.absencePeriods = [];
	        _this.scheduleData.periodInDays = _periods2.default.formatPeriodInDays(_this.scheduleData.vacationPeriods);
	        _this.loaded = true;
	      });
	    }
	  }]);
	  return ScheduleMobileController;
	}();
	
	exports.default = ScheduleMobileController;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(1360);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _dateUtils = __webpack_require__(1132);
	
	var _error = __webpack_require__(1361);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _formatter = __webpack_require__(1362);
	
	var _formatter2 = _interopRequireDefault(_formatter);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatters = {
	
	  formatAvailableVacations: function formatAvailableVacations(data) {
	    return {
	      pendingDays: data.agreement,
	      ownDays: data.free,
	      christmasDays: data.christmas,
	      lastYear: data.last_year
	    };
	  },
	
	  formatHolidays: function formatHolidays(national, local) {
	    var result = void 0;
	    (0, _error2.default)(function () {
	      result = [].concat((0, _toConsumableArray3.default)(national), (0, _toConsumableArray3.default)(local));
	    }, _formatter2.default.FORMAT_HOLIDAYS);
	
	    return result;
	  },
	
	  formatAllPeriods: function formatAllPeriods(absences, vacations, holidays) {
	    var result = void 0;
	    (0, _error2.default)(function () {
	      result = [].concat((0, _toConsumableArray3.default)(absences), (0, _toConsumableArray3.default)(vacations), (0, _toConsumableArray3.default)(holidays));
	    }, _formatter2.default.FORMAT_ALL_PERIODS);
	
	    return result;
	  },
	
	  formatPeriodInDays: function formatPeriodInDays(allPeriods) {
	    var list = [];
	    var id = 0;
	    var iconDays = [];
	    iconDays = (0, _dateUtils.returnIconDays)(allPeriods);
	    allPeriods.map(function (item) {
	      var startDate = item.startDate || item.date;
	      var endDate = item.endDate || item.date || new Date();
	      var status = item.status || '';
	      var periodId = id++;
	      var type = item.type || '';
	      var code = item.code || '';
	      list = list.concat((0, _dateUtils.fromRangeToArray)(startDate, endDate, status, periodId, type, code, iconDays));
	    });
	    return list;
	  },
	
	  getDayWithContent: function getDayWithContent(date, dayInEvents) {
	    var day = {
	      content: (0, _moment2.default)(date).format('DD')
	    };
	    if (dayInEvents.length > 0) {
	      day.content = dayInEvents[0].html.content;
	      if (dayInEvents.length > 1) {
	        if (dayInEvents[1].status === _constants.VACATIONS_ABSENCES_STATES.requested && dayInEvents[1].type.includes(_constants.VACATION)) {
	          day.content = dayInEvents[1].html.content;
	        }
	      }
	
	      var getClasses = function getClasses(day) {
	        return day.html.classes;
	      };
	      var reducer = function reducer(firstValue, currentValue) {
	        return firstValue + ' ' + currentValue;
	      };
	      day.classes = dayInEvents.map(getClasses).reduce(reducer);
	    }
	
	    return day;
	  }
	
	};
	
	exports.default = formatters;

/***/ }),
/* 1360 */,
/* 1361 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function catchAndThrow(fn, error) {
	  try {
	    fn();
	  } catch (e) {
	    throw new Error(error);
	  }
	}
	
	exports.default = catchAndThrow;

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ERRORS = {
	  ASSEMBLE_PROFILE: 'error assembling profile in InitialDataAssembler',
	  FORMAT_HOLIDAYS: 'errors formatting holidays in InitialDataAssembler',
	  FORMAT_ALL_PERIODS: 'errors formatting all periods in InitialDataAssembler'
	};
	
	exports.default = ERRORS;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1364);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./scheduleMobile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./scheduleMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "schedule-mobile{pointer-events:none}schedule-mobile .container.hpd.responsiveMobile.schedule-mobile{padding-left:0;padding-right:0}schedule-mobile .container.hpd.responsiveMobile calendar-component{margin-bottom:0}schedule-mobile .container.hpd.responsiveMobile calendar-component .datepicker-days{height:280px;margin-bottom:20px;box-shadow:0 2px 4px 0 #dddfe2!important;padding-left:30px;padding-right:30px}schedule-mobile .container.hpd.responsiveMobile calendar-component th{font-size:12px}schedule-mobile .container.hpd.responsiveMobile calendar-component td{font-size:15px}schedule-mobile .container.hpd.responsiveMobile calendar-component .icon-approved,schedule-mobile .container.hpd.responsiveMobile calendar-component .icon-requested{left:10px;float:right}schedule-mobile .container.hpd.responsiveMobile calendar-component .new,schedule-mobile .container.hpd.responsiveMobile calendar-component .old{visibility:hidden}", ""]);
	
	// exports


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modals = __webpack_require__(1366);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _calendar = __webpack_require__(1435);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _calendarGrid = __webpack_require__(1443);
	
	var _calendarGrid2 = _interopRequireDefault(_calendarGrid);
	
	var _calendarFilters = __webpack_require__(1449);
	
	var _calendarFilters2 = _interopRequireDefault(_calendarFilters);
	
	var _calendarContextMenu = __webpack_require__(1455);
	
	var _calendarContextMenu2 = _interopRequireDefault(_calendarContextMenu);
	
	var _calendarComponent = __webpack_require__(1462);
	
	var _calendarComponent2 = _interopRequireDefault(_calendarComponent);
	
	var _calendarInline = __webpack_require__(1468);
	
	var _calendarInline2 = _interopRequireDefault(_calendarInline);
	
	var _calendarInlineHeader = __webpack_require__(1474);
	
	var _calendarInlineHeader2 = _interopRequireDefault(_calendarInlineHeader);
	
	var _calendarInlineCard = __webpack_require__(1480);
	
	var _calendarInlineCard2 = _interopRequireDefault(_calendarInlineCard);
	
	var _calendarInlinePaginator = __webpack_require__(1485);
	
	var _calendarInlinePaginator2 = _interopRequireDefault(_calendarInlinePaginator);
	
	var _calendarInlineHide = __webpack_require__(1491);
	
	var _calendarInlineHide2 = _interopRequireDefault(_calendarInlineHide);
	
	var _holidaySummary = __webpack_require__(1496);
	
	var _holidaySummary2 = _interopRequireDefault(_holidaySummary);
	
	var _warnLastDay = __webpack_require__(1502);
	
	var _warnLastDay2 = _interopRequireDefault(_warnLastDay);
	
	var _employeeAfk = __webpack_require__(1508);
	
	var _employeeAfk2 = _interopRequireDefault(_employeeAfk);
	
	var _employeeSearchTags = __webpack_require__(1515);
	
	var _employeeSearchTags2 = _interopRequireDefault(_employeeSearchTags);
	
	var _sicknessLeaveDate = __webpack_require__(1521);
	
	var _sicknessLeaveDate2 = _interopRequireDefault(_sicknessLeaveDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationsAbsencesComponents = angular.module('vacations-absences.components', [_modals2.default, _calendar2.default, _calendarGrid2.default, _calendarFilters2.default, _calendarContextMenu2.default, _calendarComponent2.default, _calendarInline2.default, _calendarInlineHeader2.default, _calendarInlineCard2.default, _calendarInlinePaginator2.default, _calendarInlineHide2.default, _holidaySummary2.default, _warnLastDay2.default, _employeeAfk2.default, _employeeSearchTags2.default, _sicknessLeaveDate2.default]).name;
	
	exports.default = vacationsAbsencesComponents;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalRequest = __webpack_require__(1367);
	
	var _modalRequest2 = _interopRequireDefault(_modalRequest);
	
	var _modalCalendarGrid = __webpack_require__(1409);
	
	var _modalCalendarGrid2 = _interopRequireDefault(_modalCalendarGrid);
	
	var _modalRemovePeriod = __webpack_require__(1416);
	
	var _modalRemovePeriod2 = _interopRequireDefault(_modalRemovePeriod);
	
	var _warningRequestVacation = __webpack_require__(1429);
	
	var _warningRequestVacation2 = _interopRequireDefault(_warningRequestVacation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = angular.module('vacations-absences.components.modals', [_modalRequest2.default, _modalCalendarGrid2.default, _modalRemovePeriod2.default, _warningRequestVacation2.default]).name;
	
	exports.default = componentModule;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalRequest = __webpack_require__(1368);
	
	var _modalRequest2 = _interopRequireDefault(_modalRequest);
	
	var _requestQuestion = __webpack_require__(1373);
	
	var _requestQuestion2 = _interopRequireDefault(_requestQuestion);
	
	var _requestForm = __webpack_require__(1379);
	
	var _requestForm2 = _interopRequireDefault(_requestForm);
	
	var _sickLeaveQuestion = __webpack_require__(1403);
	
	var _sickLeaveQuestion2 = _interopRequireDefault(_sickLeaveQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalRequestModule = angular.module('vacations-absences.modalRequest', [_requestQuestion2.default, _requestForm2.default, _sickLeaveQuestion2.default]).component('modalRequest', _modalRequest2.default).name;
	
	exports.default = modalRequestModule;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalRequest = __webpack_require__(1369);
	
	var _modalRequest2 = _interopRequireDefault(_modalRequest);
	
	var _modalRequest3 = __webpack_require__(1370);
	
	var _modalRequest4 = _interopRequireDefault(_modalRequest3);
	
	__webpack_require__(1371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalRequestComponent = {
	  restrict: 'E',
	  bindings: {
	    userId: '<',
	    userInceptionId: '<',
	    startDate: '<',
	    addEvent: '&',
	    vacationPeriodCount: '<',
	    mode: '<',
	    periodToEdit: '<',
	    originalPeriod: '<',
	    isInception: '<',
	    openOn: '<',
	    requestType: '<',
	    isMobileApp: '<',
	    openModalEvent: '&',
	    yearPagination: '<'
	  },
	  template: _modalRequest2.default,
	  controller: _modalRequest4.default
	};
	
	exports.default = modalRequestComponent;

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalRequest\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"requestModalLabel\"\n     ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <request-question\n      ng-if=\"$ctrl.requestQuestionShouldBeVisible() && !$ctrl.isMobileApp\"\n      text=\"¿Qué deseas solicitar?\"\n      start-date=\"$ctrl.startDate\"\n      button-text-one=\"{{'VACATIONS_ABSENCES.GENERAL.VACATIONS' | translate}}\"\n      button-text-two=\"{{'VACATIONS_ABSENCES.GENERAL.ABSENCE' | translate}}\"\n      on-selection=\"$ctrl.onRequestQuestionSelect($event);\"\n      modal-id=\"modal-selector-step-one\"\n      is-inception=\"$ctrl.isInception\"\n      year-pagination=\"$ctrl.yearPagination\"></request-question>\n\n    <sick-leave-question\n      ng-if=\"$ctrl.sickLeaveQuestionShouldBeVisible($ctrl.status)\"\n      on-selection=\"$ctrl.onSickLeaveQuestionAnswer($event);\"\n      is-mobile-app=\"$ctrl.isMobileApp\"></sick-leave-question>\n\n    <request-form\n      ng-if=\"$ctrl.onGoingRequestForm\"\n      ng-show=\"$ctrl.requestFormShouldBeVisible()\"\n      user-id=\"$ctrl.userId\"\n      user-inception-id=\"$ctrl.userInceptionId\"\n      type=\"$ctrl.type\"\n      mode=\"$ctrl.mode\"\n      start-date=\"$ctrl.startDate\"\n      on-success=\"$ctrl.requestSuccess($event);\"\n      on-error=\"$ctrl.requestError($event);\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      add-event=\"$ctrl.addEvent({$event : $event});\"\n      period-to-edit=\"$ctrl.periodToEdit\"\n      original-period=\"$ctrl.originalPeriod\"\n      sickness-leave-answer=\"$ctrl.sicknessLeaveAnswer\"\n      lock-on=\"$ctrl.openOn\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      reset-form=\"$ctrl.emitResetModalForm()\"\n      backup=\"$ctrl.formBackup\"\n      emit-data=\"$ctrl.emitData($event)\"\n      ></request-form>\n\n    <successful-action\n      ng-if=\"$ctrl.requestIsSuccessful();\"\n      close-modal=\"true\"\n      modal-id=\"modalRequest\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"></successful-action>\n\n    <failed-action\n      ng-if=\"$ctrl.requestIsFailed();\"\n      title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n      description={{$ctrl.errorRequestMessage}}\n      close-modal=\"true\"\n      modal-id=\"modalRequest\"\n      button-text=\"{{'GLOBALS.BUTTON_ACTION.OK_GOT_IT' | translate}}\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"></failed-action> \n      \n    <failed-action\n      ng-if=\"$ctrl.souldRenderSaeModal()\"\n      title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n      description=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.SAE_MSG' | translate}}\"\n      close-modal=\"true\"\n      modal-id=\"modalRequest\"\n      button-text=\"{{'GLOBALS.BUTTON_ACTION.OK_GOT_IT' | translate}}\"\n      on-dismiss=\"$ctrl.acceptSAE()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"></failed-action>\n\n  </div>\n</div>\n"

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _request = __webpack_require__(1114);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATUS = {
	  TYPE_SELECTION: 'type_selection',
	  FORM_EDITION: 'form_edition',
	  SUCCESS: 'success',
	  REQUEST_ERROR: 'request_error',
	  SICK_LEAVE_QUESTION: 'sick_leave_question'
	};
	
	var ModalRequestController = function () {
	  ModalRequestController.$inject = ["$translate", "EventEmitter", "$scope"];
	  function ModalRequestController($translate, EventEmitter, $scope) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ModalRequestController);
	    this.translate = $translate;
	    this.EventEmitter = EventEmitter;
	    this.scope = $scope;
	
	    this.status = STATUS.TYPE_SELECTION;
	    this.modal.on('hidden.bs.modal', function () {
	      return _this.resetState();
	    });
	    this.MAX_PERIODS = 4;
	  }
	
	  (0, _createClass3.default)(ModalRequestController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this._translate();
	      this.formBackup = undefined;
	      this.onGoingRequestForm = false;
	
	      this.modal.on('show.bs.modal', function () {
	
	        if (_this2.isMobileApp) {
	          _this2.type = _this2.requestType;
	          _this2.status = STATUS.FORM_EDITION;
	          _this2.onGoingRequestForm = true;
	        }
	
	        if (_this2.mode === _constants.MODES.EDIT) {
	          _this2.onGoingRequestForm = true;
	          var editingSickness = _request.Request.isSick(_this2.periodToEdit);
	          _this2.status = editingSickness ? STATUS.SICK_LEAVE_QUESTION : _this2.status = STATUS.FORM_EDITION;
	        }
	
	        if (_this2.openOn) {
	          _this2.onGoingRequestForm = true;
	          _this2.type = _this2.openOn;
	          _this2.status = STATUS.FORM_EDITION;
	        }
	      });
	    }
	  }, {
	    key: 'emitResetModalForm',
	    value: function emitResetModalForm() {
	      this.closeModal();
	    }
	  }, {
	    key: 'requestQuestionShouldBeVisible',
	    value: function requestQuestionShouldBeVisible() {
	      return this.status === STATUS.TYPE_SELECTION;
	    }
	  }, {
	    key: 'sickLeaveQuestionShouldBeVisible',
	    value: function sickLeaveQuestionShouldBeVisible(status) {
	      return status === STATUS.SICK_LEAVE_QUESTION;
	    }
	  }, {
	    key: 'onSickLeaveQuestionAnswer',
	    value: function onSickLeaveQuestionAnswer($event) {
	      this.sicknessLeaveAnswer = $event.answer;
	      this.status = STATUS.FORM_EDITION;
	    }
	  }, {
	    key: 'requestFormShouldBeVisible',
	    value: function requestFormShouldBeVisible() {
	      return this.status === STATUS.FORM_EDITION;
	    }
	  }, {
	    key: 'requestNotDone',
	    value: function requestNotDone() {
	      return !this.requestIsSuccessful() && !this.requestIsFailed();
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this3 = this;
	
	      this.translate('VACATIONS_ABSENCES.MODAL_REQUEST_HOLIDAY.ERROR_1').then(function (translation) {
	        _this3.errorMsg = translation;
	      });
	
	      this.translate('VACATIONS_ABSENCES.MODAL_REQUEST_HOLIDAY.ERROR_2').then(function (translation) {
	        _this3.errorMsgTooMuchPeriods = translation.$$unwrapTrustedValue();
	      });
	    }
	  }, {
	    key: 'isRequestStepOne',
	    value: function isRequestStepOne() {
	      return this.type === undefined;
	    }
	  }, {
	    key: 'isRequestAbsences',
	    value: function isRequestAbsences() {
	      return this.type === _request.Request.TYPES.ABSENCE;
	    }
	  }, {
	    key: 'onRequestQuestionSelect',
	    value: function onRequestQuestionSelect($event) {
	      this.type = $event.type;
	      this.onGoingRequestForm = true;
	      return this.status = STATUS.FORM_EDITION;
	    }
	  }, {
	    key: 'requestIsSuccessful',
	    value: function requestIsSuccessful() {
	      return this.status === STATUS.SUCCESS;
	    }
	  }, {
	    key: 'requestIsFailed',
	    value: function requestIsFailed() {
	      return this.status === STATUS.REQUEST_ERROR;
	    }
	  }, {
	    key: 'requestSuccess',
	    value: function requestSuccess() {
	      this.status = STATUS.SUCCESS;
	    }
	  }, {
	    key: 'requestError',
	    value: function requestError($event) {
	      try {
	        this.errorRequestMessage = $event.data.message;
	      } catch (err) {
	        this.errorRequestMessage = this.errorMsg;
	      }
	
	      this.requestStatus = $event.status;
	      this.errorCode = $event.data.errors.codigo;
	      this.status = STATUS.REQUEST_ERROR;
	    }
	  }, {
	    key: 'onDismiss',
	    value: function onDismiss() {
	      this.closeModal();
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var hasErrorsToEdit = this.requestStatus === _constants2.REQUEST_ERRORS.BAD_REQUEST;
	
	      if (hasErrorsToEdit) {
	        this.requestStatus = '';
	        this.status = STATUS.FORM_EDITION;
	        this.onGoingRequestForm = true;
	        if (this.isMobileApp) {
	          this.openModalEvent();
	        }
	      } else {
	        this.resetFormBackup();
	        this.modal.modal('hide');
	      }
	    }
	  }, {
	    key: 'resetFormBackup',
	    value: function resetFormBackup() {
	      this.onGoingRequestForm = false;
	      this.sicknessLeaveAnswer = undefined;
	      this.formBackup = undefined;
	    }
	  }, {
	    key: 'resetState',
	    value: function resetState() {
	      this.status = STATUS.TYPE_SELECTION;
	    }
	  }, {
	    key: 'goToRequestForm',
	    value: function goToRequestForm() {
	      this.status = STATUS.FORM_EDITION;
	    }
	  }, {
	    key: 'emitData',
	    value: function emitData($event) {
	      this.selectedCategory = $event.value;
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return angular.element('#modalRequest');
	    }
	  }]);
	  return ModalRequestController;
	}();
	
	exports.default = ModalRequestController;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1372);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./modalRequest.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./modalRequest.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-request .responsiveMobile .modal-dialog{max-height:none;max-width:none}modal-request .modal-dialog{max-height:410px;max-width:520px}modal-request .modal{transition:.3s;opacity:0;top:-50px}modal-request .modal.in{opacity:1;top:0;transition:.3s}", ""]);
	
	// exports


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestQuestion = __webpack_require__(1374);
	
	var _requestQuestion2 = _interopRequireDefault(_requestQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestQuestionModule = angular.module('vacations-absences.requestQuestion', []).component('requestQuestion', _requestQuestion2.default).name;
	
	exports.default = requestQuestionModule;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestQuestion = __webpack_require__(1375);
	
	var _requestQuestion2 = _interopRequireDefault(_requestQuestion);
	
	var _requestQuestion3 = __webpack_require__(1376);
	
	var _requestQuestion4 = _interopRequireDefault(_requestQuestion3);
	
	__webpack_require__(1377);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestQuestionComponent = {
	  restrict: 'E',
	  bindings: {
	    text: '@',
	    buttonTextOne: '@',
	    buttonTextTwo: '@',
	    modalId: '@',
	    onSelection: '&',
	    isInception: '<',
	    startDate: '<',
	    yearPagination: '<'
	  },
	  template: _requestQuestion2.default,
	  controller: _requestQuestion4.default
	};
	
	exports.default = requestQuestionComponent;

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\">\n\n  <div class=\"modal-header\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\" id=\"{{$ctrl.modalId}}Label\">{{\"VACATIONS_ABSENCES.REQUEST_QUESTION.TITLE\" | translate }}</h4>\n  </div>\n\n  <div class=\"modal-footer row\">\n    <button\n      type=\"button\"\n      class=\"btn btn-app btnone btn-primary\"\n      data-dismiss=\"modal\"\n      ng-click=\"$ctrl.chooseVacation()\"\n      ng-disabled=\"$ctrl.disableVacationsButton()\">{{\"VACATIONS_ABSENCES.GENERAL.HOLIDAYS\" | translate }}</button>\n    <button\n      type=\"button\"\n      class=\"btn btn-app btntwo btn-primary\"\n      data-dismiss=\"modal\"\n      ng-click=\"$ctrl.chooseAbsence()\">{{\"VACATIONS_ABSENCES.GENERAL.ABSENCES_LICENSES\" | translate }}</button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _request = __webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestQuestionController = function () {
	  RequestQuestionController.$inject = ["EventEmitter"];
	  function RequestQuestionController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, RequestQuestionController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(RequestQuestionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.dayClicked = this.startDate;
	    }
	  }, {
	    key: 'chooseVacation',
	    value: function chooseVacation() {
	      this.onSelection(this.EventEmitter({ type: _request.Request.TYPES.VACATION }));
	    }
	  }, {
	    key: 'chooseAbsence',
	    value: function chooseAbsence() {
	      this.onSelection(this.EventEmitter({ type: _request.Request.TYPES.ABSENCE }));
	    }
	
	    /**
	     * Regla confirmada por BBVA en el Jira 12071
	     * - Se permite seleccionar el mes anterior SOLO hasta el día 17 (incluido) del mes actual.
	     * - Mes actual y futuros: permitido.
	     * - Más antiguo que el mes anterior: no permitido.
	     */
	
	  }, {
	    key: 'isPreviousMonthNotAllowed',
	    value: function isPreviousMonthNotAllowed() {
	      if (!this.startDate) return false;
	
	      var now = new Date();
	      var selected = this.startDate;
	
	      var nowYear = now.getFullYear();
	      var nowMonth = now.getMonth();
	
	      var selectedYear = selected.getFullYear();
	      var selectedMonth = selected.getMonth();
	
	      var nowAbs = nowYear * 12 + nowMonth;
	      var selectedAbs = selectedYear * 12 + selectedMonth;
	
	      if (selectedAbs >= nowAbs) return false;
	
	      if (selectedAbs === nowAbs - 1) {
	        return now.getDate() > 17;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'disableVacationsButton',
	    value: function disableVacationsButton() {
	      return this.isInception || this.isPreviousMonthNotAllowed();
	    }
	  }]);
	  return RequestQuestionController;
	}();
	
	exports.default = RequestQuestionController;

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1378);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./requestQuestion.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./requestQuestion.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "request-question .modal-content{padding-top:58px}request-question .modal-content .modal-header{border-bottom:1px solid #dddfe2}request-question .modal-content .modal-header h4{color:#0072c9;padding-bottom:10px}request-question .modal-content .modal-body{padding-top:17px;text-align:center}request-question .modal-content .modal-body .description{color:#666;font-family:ArialMT;font-size:15px;line-height:1.4;margin:0 auto 29px;margin-bottom:31px;max-width:200px}request-question .modal-content .modal-footer{margin-top:51px;text-align:center}request-question .modal-content .modal-footer .btn{float:left;height:48px;line-height:38px;margin-left:14px;width:160px}request-question .modal-content .modal-footer .btnone{float:left;height:48px;line-height:38px;margin-right:14px;padding-left:.8px;padding-top:1px;width:160px}request-question .modal-content .modal-footer .btntwo{float:right;height:48px;line-height:38px;margin-right:14px;padding-top:3px;width:160px}", ""]);
	
	// exports


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestForm = __webpack_require__(1380);
	
	var _requestForm2 = _interopRequireDefault(_requestForm);
	
	var _requestForm3 = __webpack_require__(1386);
	
	var _requestForm4 = _interopRequireDefault(_requestForm3);
	
	var _requestFormTitle = __webpack_require__(1387);
	
	var _requestFormTitle2 = _interopRequireDefault(_requestFormTitle);
	
	var _requestFormSicknessPanel = __webpack_require__(1391);
	
	var _requestFormSicknessPanel2 = _interopRequireDefault(_requestFormSicknessPanel);
	
	var _requestFormSickLeaveReports = __webpack_require__(1397);
	
	var _requestFormSickLeaveReports2 = _interopRequireDefault(_requestFormSickLeaveReports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestFormModule = angular.module('vacations-absences.requestForm', [_requestFormTitle2.default, _requestFormSicknessPanel2.default, _requestFormSickLeaveReports2.default]).component('requestForm', _requestForm2.default).service('requestFormService', _requestForm4.default).name;
	
	exports.default = requestFormModule;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestForm = __webpack_require__(1381);
	
	var _requestForm2 = _interopRequireDefault(_requestForm);
	
	var _requestForm3 = __webpack_require__(1382);
	
	var _requestForm4 = _interopRequireDefault(_requestForm3);
	
	__webpack_require__(1384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestFormComponent = {
	  restrict: 'E',
	  bindings: {
	    userId: '<',
	    userInceptionId: '<',
	    onSuccess: '&',
	    onError: '&',
	    onDismiss: '&',
	    startDate: '<',
	    addEvent: '&',
	    mode: '<',
	    periodToEdit: '<',
	    originalPeriod: '<',
	    type: '<',
	    sicknessLeaveAnswer: '<',
	    lockOn: '<',
	    isMobileApp: '<',
	    resetForm: '&',
	    backup: '<',
	    emitData: '&'
	  },
	  template: _requestForm2.default,
	  controller: _requestForm4.default
	};
	
	exports.default = requestFormComponent;

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"requestFormModalId\" class=\"modal-content request-form-modal\" ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n\n  <form name=\"$ctrl.form\" novalidate>\n\n    <div class=\"modal-header\">\n      <button ng-click=\"$ctrl.resetBackup()\" type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span\n          class=\"icon-cross\"></span></button>\n      <request-form-title is-edit=\"$ctrl.isEdit()\" is-edit-sickness=\"$ctrl.isEditSickness()\"\n        is-vacation=\"$ctrl.isVacation()\" is-absence=\"$ctrl.isAbsence()\" is-hourly=\"$ctrl.isHourlyRequest\"\n        initial-request-category=\"$ctrl.initialRequestCategory.option\">\n      </request-form-title>\n    </div>\n\n    <div class=\"modal-body\" ng-class=\"{'reduced-padding': $ctrl.isSicknessRequestCreate()}\">\n\n      <option-switch options-data=\"$ctrl.switchOptions\" ng-if=\"$ctrl.requestTypeSwitchVisible() && !$ctrl.isMobileApp\"\n        lock-on=\"$ctrl.type || $ctrl.lockOn\" editable=\"$ctrl.requestTypeSwitchEditable()\"\n        on-select=\"$ctrl.switchRequestTypes($event)\">\n      </option-switch>\n\n      <form-errors-summary ng-if=\"$ctrl.isInvalid($ctrl.form)\" errors=\"$ctrl.errors\">\n      </form-errors-summary>\n\n      <div class=\"row\" ng-show=\"!$ctrl.isEditSickness() && !$ctrl.restartRequestSelects\">\n        <div class=\"col-xs-12\">\n          <select-app name=\"requestTypes\" placeholder=\"{{ 'VACATIONS_ABSENCES.TYPE' | translate }}\"\n            required=\"!$ctrl.isEditSickness() && !$ctrl.restartRequestSelects\" options=\"$ctrl.requestTypes\"\n            on-select=\"$ctrl.onSelectRequestType($event);\" initial-value=\"$ctrl.initialRequestType\"\n            disabled=\"$ctrl.disableRequestTypesSelector()\"></select-app>\n        </div>\n      </div>\n\n      <div class=\"row\" ng-show=\"!$ctrl.isEditSickness() && !$ctrl.restartRequestSelects\">\n        <div class=\"col-xs-12\">\n          <select-app name=\"requestCategories\" placeholder=\"{{ 'VACATIONS_ABSENCES.CLASS' | translate }}\"\n            class=\"second-select\" required=\"!$ctrl.isEditSickness() && !$ctrl.restartRequestSelects\"\n            options=\"$ctrl.requestCategories\" initial-value=\"$ctrl.initialRequestCategory\"\n            on-select=\"$ctrl.onSelectRequestCategory($event);\"\n            disabled=\"$ctrl.disableRequestCategoriesSelector()\"></select-app>\n        </div>\n      </div>\n\n      <h5 ng-if=\"!$ctrl.continuousPatenity && $ctrl.selectedRequestCode == 'PAT'\">\n        {{'VACATIONS_ABSENCES.REQUEST_MODAL.FIRST_PERIOD' | translate}}</h5>\n      <h5 ng-if=\"$ctrl.continuousPatenity && $ctrl.selectedRequestCode == 'PAT'\">\n        {{'VACATIONS_ABSENCES.REQUEST_MODAL.PATERNITY_PERIOD' | translate}}</h5>\n      <h5 ng-if=\"$ctrl.selectedRequestCode === 'MAT'\">{{'VACATIONS_ABSENCES.REQUEST_MODAL.MATERNITY_PERIOD' |\n        translate}}</h5>\n\n      <div class=\"row\" ng-show=\"!$ctrl.isCreateSickness() && !$ctrl.isEditSickness()\"\n        ng-class=\"{'separator': $ctrl.isCreateSickness()}\">\n\n        <div class=\"col-xs-6\">\n          <input-datepicker is-mobile-app=\"$ctrl.isMobileApp\" name=\"startDate\"\n            start-date=\"$ctrl.periodToEdit.startDate || $ctrl.startDate\" init-date=\"$ctrl.initStartDate\"\n            class=\"pull-left\" is-required=\"!$ctrl.isCreateSickness() && !$ctrl.isEditSickness()\"\n            disabled=\"$ctrl.periodToEdit.startDate !== undefined\" on-datepick=\"$ctrl.datepickInitDate($event);\"\n            min-date=\"$ctrl.minInitialDate\" label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.START_DATE' | translate}}\">\n          </input-datepicker>\n\n        </div>\n\n        <div class=\"col-xs-6\">\n          <input-datepicker ng-show=\"!$ctrl.isHourlyRequest\" is-mobile-app=\"$ctrl.isMobileApp\" name=\"endDate\"\n            start-date=\"$ctrl.endDate || $ctrl.periodToEdit.endDate\" init-date=\"$ctrl.initEndDate\" class=\"pull-right\"\n            is-required=\"!$ctrl.isCreateSickness() && !$ctrl.isEditSickness() && !$ctrl.isHourlyRequest\"\n            on-datepick=\"$ctrl.datepickEndDate($event);\" min-date=\"$ctrl.minEndDate\"\n            label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.END_DATE' | translate}}\">\n          </input-datepicker>\n\n          <p ng-if=\"$ctrl.isHourlyRequest\" class=\"label\">\n            {{ 'GLOBALS.HOURS' | translate }}\n          </p>\n          <input type=\"number\" name=\"absenceHours\" ng-show=\"$ctrl.isHourlyRequest\" ng-max=\"$ctrl.absenceMaxHours\"\n            ng-min=\"$ctrl.absenceMinHours\" ng-model=\"$ctrl.absenceHours\" ng-pattern=\"$ctrl.numberWithPrecisionTwo\"\n            ng-required=\"!$ctrl.isCreateSickness() && !$ctrl.isEditSickness() && $ctrl.isHourlyRequest\">\n        </div>\n\n        <div class=\"row birthdate-row\" ng-if=\"$ctrl.selectedRequestCode === 'MA5' || $ctrl.selectedRequestCode === 'PA5'\">\n        <div class=\"birthdate-center col-xs-6\">\n          <p ng-show=\"!$ctrl.isHourlyRequest\" class=\"label\"> {{'VACATIONS_ABSENCES.REQUEST_MODAL.DATE_OF_BIRTH_OF_THE_CHILD' | translate}} </p>\n          <input\n          name=\"birthDateChild\"\n          type=\"text\"\n          ng-show=\"!$ctrl.isHourlyRequest\"\n          ng-model=\"$ctrl.birthDateChildInput\"\n          ng-model-options=\"{ allowInvalid: true }\"\n          ng-blur=\"$ctrl.onBirthDateChildInputChange()\"\n          placeholder=\"DD/MM/AAAA\"\n          maxlength=\"10\"\n          ng-pattern=\"/^\\d{2}\\/\\d{2}\\/\\d{4}$/\"\n          required\n          class=\"form-control\"\n        />\n        </div>\n\n      </div>\n\n      </div>\n\n      <h5 ng-if=\"!$ctrl.continuousPatenity && $ctrl.selectedRequestCode == 'PAT'\">\n        {{'VACATIONS_ABSENCES.REQUEST_MODAL.SECOND_PERIOD' | translate}}</h5>\n\n      <div class=\"row\" ng-if=\"(!$ctrl.continuousPatenity && $ctrl.selectedRequestCode == 'PAT')\"\n        ng-show=\"!$ctrl.isCreateSickness() && !$ctrl.isEditSickness()\"\n        ng-class=\"{'separator': $ctrl.isCreateSickness()}\">\n\n        <div class=\"col-xs-6\">\n          <input-datepicker is-mobile-app=\"$ctrl.isMobileApp\" name=\"startDate2Period\"\n            start-date=\"$ctrl.startDate2Period\" init-date=\"$ctrl.initStartDate\" class=\"pull-left\"\n            is-required=\"!$ctrl.isCreateSickness() && !$ctrl.isEditSickness() && !$ctrl.continuousPatenity && $ctrl.selectedRequestCode == 'PAT'\"\n            disabled=\"$ctrl.periodToEdit.startDate !== undefined\" on-datepick=\"$ctrl.datepickInitDate2Period($event);\"\n            label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.START_DATE' | translate}}\">\n          </input-datepicker>\n\n        </div>\n\n        <div class=\"col-xs-6\">\n          <input-datepicker ng-show=\"!$ctrl.isHourlyRequest\" is-mobile-app=\"$ctrl.isMobileApp\" name=\"endDate2Period\"\n            start-date=\"$ctrl.endDate2Period\" init-date=\"$ctrl.initEndDate\" class=\"pull-right\"\n            is-required=\"!$ctrl.isCreateSickness() && !$ctrl.isEditSickness() && !$ctrl.isHourlyRequest && !$ctrl.continuousPatenity && $ctrl.selectedRequestCode == 'PAT'\"\n            on-datepick=\"$ctrl.datepickEndDate2Period($event);\" min-date=\"$ctrl.minEndDate\"\n            label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.END_DATE' | translate}}\">\n          </input-datepicker>\n        </div>\n\n      </div>\n\n      <div class=\"displacement-warning\" ng-if=\"$ctrl.isDisplacementRequest\">\n        <p>{{ 'VACATIONS_ABSENCES.REQUEST_MODAL.DISPLACEMENT_WARNING' | translate }}</p>\n      </div>\n\n      <request-form-sickness-panel ng-if=\"$ctrl.isEditSickness()\"\n        ng-class=\"{'request-form-sickness-panel-bottom': !$ctrl.sicknessPanelIsOpen()}\"\n        original-period=\"$ctrl.originalPeriod\" open-sickness-panel=\"$ctrl.openSicknessPanel();\"\n        sickness-panel-is-open=\"$ctrl.sicknessPanelIsOpen();\" is-edit-sickness=\"$ctrl.isEditSickness();\"\n        sick-description=\"$ctrl.initialRequestCategory.option\" reports=\"$ctrl.sickLeaveReports\"\n        is-mobile-app=\"$ctrl.isMobileApp\"></request-form-sickness-panel>\n\n      <!--Sickness start date/leave date and collegiate number-->\n      <div class=\"row separator\"\n        ng-show=\"($ctrl.isCreateSickness() || $ctrl.isSicknessEditOnCancel()) && !$ctrl.sicknessPanelIsOpen()\">\n        <div ng-class=\"$ctrl.getInputDateSicknessClass()\">\n          <input-datepicker ng-show=\"$ctrl.isCreateSickness() && !$ctrl.sicknessPanelIsOpen()\"\n            is-mobile-app=\"$ctrl.isMobileApp\" name=\"sicknessStartDate\"\n            start-date=\"$ctrl.startDate || $ctrl.periodToEdit.startDate\" init-date=\"$ctrl.initStartDate\"\n            is-required=\"$ctrl.isCreateSickness() && !$ctrl.sicknessPanelIsOpen()\" class=\"pull-left\"\n            on-datepick=\"$ctrl.datepickSicknessStartDate($event);\"\n            label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.SICKNESS_START_DATE' | translate}}\"></input-datepicker>\n          <input-datepicker ng-show=\"$ctrl.isSicknessEditOnCancel() && !$ctrl.sicknessPanelIsOpen()\"\n            is-mobile-app=\"$ctrl.isMobileApp\" name=\"sicknessLeaveDate\" start-date=\"$ctrl.initEndDate\"\n            init-date=\"$ctrl.initEndDate\" is-required=\"$ctrl.isSicknessEditOnCancel() && !$ctrl.sicknessPanelIsOpen()\"\n            class=\"pull-left\" on-datepick=\"$ctrl.datepickSicknessLeaveDate($event);\" min-date=\"$ctrl.minEndDate\"\n            label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.SICKNESS_LEAVE_DATE' | translate}}\"></input-datepicker>\n        </div>\n\n        <div ng-if=\"$ctrl.isCreateSickness() || $ctrl.isSicknessEditOnCancel()\"\n          ng-class=\"$ctrl.getInputCollegiateNumberClass()\">\n          <div>\n            <label class=\"label-tooltip block with-icon\">\n              {{'VACATIONS_ABSENCES.REQUEST_MODAL.COLLEGIATE_NUMBER' | translate}}\n              <tooltip-desktop ng-if=\"!$ctrl.isMobileApp\" placement=\"right\"\n                title=\"VACATIONS_ABSENCES.REQUEST_MODAL.COLLEGIATE_NUMBER_INFO\">\n              </tooltip-desktop>\n              <tooltip-mobile ng-if=\"$ctrl.isMobileApp\" name=\"collegiateNumberTooltip\"\n                nested-modals=\"$ctrl.openTooltipNestedModals\" id-nested-modal=\"requestFormModalId\">\n                <p class=\"tooltip-title\">\n                  {{ 'VACATIONS_ABSENCES.REQUEST_MODAL.COLLEGIATE_NUMBER' | translate }}\n                </p>\n                <p>\n                  {{ 'VACATIONS_ABSENCES.REQUEST_MODAL.COLLEGIATE_NUMBER_INFO' | translate }}\n                </p>\n              </tooltip-mobile>\n            </label>\n            <input name=\"collegiateNumber\" ng-model=\"$ctrl.collegiateNumber\" type=\"text\" class=\"full\" ng-minlength=\"8\"\n              ng-maxlength=\"8\">\n          </div>\n        </div>\n      </div>\n\n      <!--Is relapse and relapse date selector-->\n      <div class=\"row\" ng-show=\"$ctrl.shouldRenderRelapseCheckbox()\">\n        <div ng-class=\"$ctrl.getRelapseCheckClass()\">\n          <div class=\"checkbox on-right\">\n            <input type=\"checkbox\" id=\"isRelapse\" ng-model=\"$ctrl.isRelapse\" ng-true-value=\"true\">\n            <label for=\"isRelapse\">{{ 'VACATIONS_ABSENCES.REQUEST_MODAL.RELAPSE' | translate }}</label>\n          </div>\n        </div>\n        <div class=\"col-xs-6\" ng-show=\"$ctrl.isRelapse && !$ctrl.isMobileApp\">\n          <select-app class=\"relapse-select\" name=\"relapsesSelect\" options=\"$ctrl.relapses\"\n            limit=\"$ctrl.relapsesOcurrences\" disabled=\"!$ctrl.relapses || $ctrl.relapses.length === 0\"\n            label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.PREVIOUS_SICK_LEAVES' | translate}}\"\n            required=\"$ctrl.shouldRenderRelapseCheckbox() && $ctrl.isRelapse && !$ctrl.isMobileApp\"\n            on-select=\"$ctrl.onSelectRelapse($event);\"></select-app>\n        </div>\n      </div>\n\n      <div class=\"row relapse-mobile\" ng-show=\"$ctrl.isRelapse && $ctrl.isMobileApp\">\n        <div class=\"col-xs-12\">\n          <select-app class=\"relapse-select\" name=\"relapsesSelect\" options=\"$ctrl.relapses\"\n            limit=\"$ctrl.relapsesOcurrences\" disabled=\"!$ctrl.relapses || $ctrl.relapses.length === 0\"\n            label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.PREVIOUS_SICK_LEAVES' | translate}}\"\n            required=\"$ctrl.isRelapse && $ctrl.isMobileApp\" on-select=\"$ctrl.onSelectRelapse($event);\"\n            in-two-lines=\"true\"></select-app>\n        </div>\n      </div>\n\n      <!-- Sickness leave date known?  -->\n      <sickness-leave-date is-mobile-app=\"$ctrl.isMobileApp\" is-relapse=\"$ctrl.isRelapse\"\n        is-create-sickness=\"$ctrl.isCreateSickness()\" sickness-start-date=\"$ctrl.sicknessLeaveDate\"\n        init-leave-date-known=\"$ctrl.initLeaveDateKnown\"\n        datepick-leave-date-known=\"$ctrl.datepickLeaveDateKnown($event)\"\n        sickness-leave-date-known-reasons=\"$ctrl.sicknessLeaveDateKnownReasons\"\n        select-sickness-leave-date-known-reason=\"$ctrl.selectSicknessLeaveDateKnownReason($event)\"\n        set-leave-date-send-status=\"$ctrl.setLeaveDateSendStatus($event)\"\n        min-date=\"$ctrl.minEndDate\"></sickness-leave-date>\n\n      <!--Reason for leave the sickness-->\n      <div class=\"row\" ng-if=\"$ctrl.isSicknessEditOnCancel() && !$ctrl.sicknessPanelIsOpen()\">\n        <div class=\"col-xs-12\">\n          <select-app name=\"leaveSicknessReason\" options=\"$ctrl.leaveSicknessReasons\"\n            disabled=\"!$ctrl.leaveSicknessReasons || $ctrl.leaveSicknessReasons.length === 0\"\n            label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.LEAVE_SICKNESS_REASON' | translate}}\"\n            required=\"$ctrl.isSicknessEditOnCancel() && !$ctrl.sicknessPanelIsOpen()\"\n            on-select=\"$ctrl.onSelectLeaveSicknessReason($event);\" initial-value=\"$ctrl.leaveSicknessReasonInitialValue\"\n            in-two-lines=\"true\"></select-app>\n        </div>\n      </div>\n\n      <request-form-sick-leave-reports ng-show=\"$ctrl.showFormSickLeaveReports()\" is-mobile-app=\"$ctrl.isMobileApp\"\n        form=\"$ctrl.form\" class=\"sick-leave-reports\" sick-leave-reports=\"$ctrl.sickLeaveReports\"\n        add-sick-leave-report=\"$ctrl.addSickLeaveReport();\"\n        start-date=\"$ctrl.dayClicked\"></request-form-sick-leave-reports>\n\n    </div>\n\n    <div class=\"modal-footer\" ng-if=\"!$ctrl.sicknessPanelIsOpen() && !$ctrl.isMobileApp\">\n      <button type=\"button\" class=\"btn btn-app btn-default\" ng-click=\"$ctrl.cancel()\">\n        {{ 'GLOBALS.BUTTON_ACTION.CANCEL' | translate }}</button>\n      <button type=\"submit\" class=\"btn btn-app btn-primary\" ng-click=\"$ctrl.submit()\"\n        ng-disabled=\"$ctrl.submitButtonIsDisabled()\">\n        {{ 'GLOBALS.BUTTON_ACTION.SUBMIT' | translate }}</button>\n    </div>\n    <floating-action-buttons ng-if=\"!$ctrl.sicknessPanelIsOpen() && $ctrl.isMobileApp && !$ctrl.isInputFocused()\"\n      buttons=\"$ctrl.floatingActionButtons\" on-click-first-button=\"$ctrl.submit()\"\n      on-click-second-button=\"$ctrl.cancel()\">\n    </floating-action-buttons>\n  </form>\n\n</div>\n"

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(1133);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(598);
	
	var _tooltip = __webpack_require__(744);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _request = __webpack_require__(1114);
	
	var _requestFormHelper = __webpack_require__(1383);
	
	var _requestFormHelper2 = _interopRequireDefault(_requestFormHelper);
	
	var _constants2 = __webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestFormController = function () {
	  RequestFormController.$inject = ["$scope", "$rootScope", "$state", "$log", "$timeout", "$location", "EventEmitter", "requestFormService", "vacationUserDataService", "ManagerDataService", "loadingMobileService", "floatingActionButtonsService", "metricsService"];
	  function RequestFormController($scope, $rootScope, $state, $log, $timeout, $location, EventEmitter, requestFormService, vacationUserDataService, ManagerDataService, loadingMobileService, floatingActionButtonsService, metricsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, RequestFormController);
	    this.log = $log;
	    this.scope = $scope;
	    this.rootScope = $rootScope;
	    this.state = $state;
	    this.location = $location;
	    this.timeout = $timeout;
	    this.EventEmitter = EventEmitter;
	
	    this.tooltip = _tooltip2.default;
	    this.requestFormService = requestFormService;
	    this.UserDataService = vacationUserDataService;
	    this.ManagerDataService = ManagerDataService;
	    this.floatingActionButtonsService = floatingActionButtonsService;
	    this.loadingMobileService = loadingMobileService;
	    this.metricsService = metricsService;
	    this.success = undefined;
	    this.error = undefined;
	    this.errors = [];
	    this.sickLeaveReports = [];
	    this.ongoing = false;
	    this.relapsesOcurrences = 3;
	    this.isSubmitted = false;
	    this.numberWithPrecisionTwo = /^[0-9]+(\.[0-9]{1,2})?$/;
	    this.absenceMinHours = 0.1;
	    this.absenceMaxHours = 9.75;
	    this.initVisibilityFunctions();
	    this.switchOptions = _constants2.VA_SWITCH_CONFIG;
	  }
	
	  (0, _createClass3.default)(RequestFormController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.checkMedicalPartsAdded();
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      this.openTooltipNestedModals = true;
	      this.managerAsEmployeeData = this.getUserRequestFromManagerData();
	      this.initialRequestType = undefined;
	      this.initialRequestCategory = undefined;
	      this.requestTypes = this.getRequestTypes();
	      this.requestCategories = [];
	      this.endDate = null;
	      this.initStartDate = null;
	      this.startDate2Period = null;
	      this.endDate2Period = null;
	      this.initEndDate = this.startDate;
	      this.sicknessLeaveDate = null;
	      this.isDisabledSickLeaveReports = false;
	      this.continuousPatenity = true;
	      this.continuousOldPatenity = false;
	      this.dayClicked = this.startDate;
	      this.birthDateChild = null;
	
	      this.setVacationsMinDateOnNewYear();
	      this.setAbsencesMinDateOnNewYear();
	
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	        this.setFloatingActionButtonsDisabled();
	      }
	
	      if (_requestFormHelper2.default.isAbsenceRequest(this.type)) {
	        this.getRelapses();
	        this.sicknessLeaveDateKnownReasons = _requestFormHelper2.default.getLeaveSicknessReasons(this.UserDataService);
	      }
	
	      if (!this.isEdit()) {
	        return;
	      }
	
	      // Prefill form and other stuff if we are on inception
	
	      var type = this.getRequestTypeFromPeriod(this.periodToEdit);
	      this.setTypeAndRequestTypes(type);
	
	      this.initialRequestType = _requestFormHelper2.default.findRequestTypeByCode(this.requestTypes, this.periodToEdit.code);
	
	      if (!this.initialRequestType) {
	        this.log.warn('requestForm.controller: editing but initialRequestType empty...');
	      }
	
	      this.initialRequestCategory = _requestFormHelper2.default.findRequestCategoryByCode(this.requestCategories, this.periodToEdit.code);
	
	      if (!this.initialRequestCategory) {
	        this.log.warn('requestForm.controller: editing but initialRequestCategory empty...');
	      }
	
	      this.initialRequestTypeBackup = _lodash2.default.cloneDeep(this.initialRequestType);
	      this.initialRequestCategoryBackup = _lodash2.default.cloneDeep(this.initialRequestCategory);
	
	      this.leaveSicknessReasons = _requestFormHelper2.default.getLeaveSicknessReasons(this.UserDataService);
	
	      if (this.originalPeriod.sickLeaveReport) {
	        this.sickLeaveReports = _requestFormHelper2.default.mapSickLeaveReports(this.originalPeriod.sickLeaveReport);
	        this.sickLeaveReports.sort(function (a, b) {
	          return new Date(a.date) > new Date(b.date);
	        });
	      }
	
	      if (this.initialRequestCategory) {
	        this.avoidEmptyCodeOnEdit();
	      }
	
	      this.forceShowAbsenceFlowWhenVacationEditOnInception();
	      this.setAbsenceHours();
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.SUBMIT',
	        disabled: true
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }, {
	    key: 'isInputFocused',
	    value: function isInputFocused() {
	      return this.floatingActionButtonsService.isFocused;
	    }
	  }, {
	    key: 'getInputDateSicknessClass',
	    value: function getInputDateSicknessClass() {
	      return {
	        'col-xs-5': !this.isMobileApp,
	        'col-xs-6': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'getInputCollegiateNumberClass',
	    value: function getInputCollegiateNumberClass() {
	      return {
	        'col-xs-7': !this.isMobileApp,
	        'col-xs-6': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'getRelapseCheckClass',
	    value: function getRelapseCheckClass() {
	      return {
	        'col-xs-6': !this.isMobileApp,
	        'col-xs-12': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'setFloatingActionButtonsDisabled',
	    value: function setFloatingActionButtonsDisabled() {
	      var _this = this;
	
	      this.scope.$watch(function () {
	        return _this.form.$invalid;
	      }, function (newValue) {
	        if (newValue || _this.isDisabledSickLeaveReports || _this.isBirthDateChildMissing()) {
	          _this.floatingActionButtons[0].disabled = true;
	        } else {
	          _this.floatingActionButtons[0].disabled = false;
	        }
	      });
	    }
	  }, {
	    key: 'setTypeAndRequestTypes',
	    value: function setTypeAndRequestTypes(type) {
	      this.type = type;
	      this.requestTypes = [];
	      this.requestTypes = this.getRequestTypes();
	      this.requestCategories = _requestFormHelper2.default.getRequestCategoriesByCode(this.requestTypes, this.periodToEdit.code);
	    }
	  }, {
	    key: 'initVisibilityFunctions',
	    value: function initVisibilityFunctions() {
	      var _this2 = this;
	
	      this.isCreate = function () {
	        return _this2.mode === _constants.MODES.CREATE;
	      };
	
	      this.isEdit = function () {
	        return _this2.mode === _constants.MODES.EDIT;
	      };
	
	      this.isSickness = function () {
	        return _this2.isSicknessRequest;
	      };
	
	      this.isCreateSickness = function () {
	        return _this2.isCreate() && _this2.isSicknessRequest;
	      };
	
	      this.isEditSickness = function () {
	        return _this2.isEdit() && _this2.isSicknessRequest;
	      };
	
	      this.isSicknessEditOnCancel = function () {
	        return _this2.isEditSickness() && _this2.sicknessLeaveAnswer === _constants.ANSWERS.NO;
	      };
	
	      this.isSicknessEditOnContinue = function () {
	        return _this2.isEditSickness() && _this2.sicknessLeaveAnswer === _constants.ANSWERS.YES;
	      };
	
	      this.isVacation = function () {
	        return _requestFormHelper2.default.isVacationRequest(_this2.type);
	      };
	
	      this.isAbsence = function () {
	        return _requestFormHelper2.default.isAbsenceRequest(_this2.type);
	      };
	    }
	  }, {
	    key: 'resetBackup',
	    value: function resetBackup() {
	      this.resetForm();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this3 = this;
	
	      var request = this.getRequest(this.isSicknessRequest, this.originalPeriod);
	      this.isSubmitted = true;
	
	      var data = void 0;
	
	      var onError = function onError(response) {
	        _this3.onError(_this3.EventEmitter(response));
	      };
	
	      var onSuccess = function onSuccess() {
	        if (_this3.isMobileApp && _this3.isInception()) {
	          _this3.metricsService.trackVacationsAbsencesCreateAbsenceFromManagerToEmployee();
	        }
	        _this3.addEvent(_this3.EventEmitter(request));
	        _this3.ongoing = false;
	        _this3.onSuccess();
	      };
	
	      this.ongoing = true;
	
	      var isEditingANonSick = this.isEdit() && !this.isSicknessEditOnCancel() && !this.isSicknessEditOnContinue();
	      var isAbsenceInVacation = this.isEdit() && request.type !== this.originalPeriod.type;
	
	      this.loadingMobileService.show();
	      var userId = this.userInceptionId || this.getUserId();
	      var managerId = this.UserDataService._employee.userId;
	
	      if (isEditingANonSick && !isAbsenceInVacation) {
	        data = _requestFormHelper2.default.getRequestOnUpdate(request, this.originalPeriod);
	        this.requestFormService.update(userId, data, this.isInception(), managerId).then(onSuccess, onError).finally(function () {
	          return _this3.loadingMobileService.hide();
	        });
	      } else if (this.isSicknessEditOnCancel()) {
	        data = _requestFormHelper2.default.getRequestOnUpdateSicknessOnCancel(request, this.originalPeriod);
	        this.requestFormService.updateSicknessWhenNo(userId, data, this.isInception(), managerId).then(onSuccess, onError).finally(function () {
	          return _this3.loadingMobileService.hide();
	        });
	      } else if (this.isSicknessEditOnContinue()) {
	        data = _requestFormHelper2.default.getSickLeaveReportsOnCreate(this.sickLeaveReports, this.originalPeriod);
	        this.requestFormService.createSickLeaveReports(userId, data, this.isInception(), managerId).then(onSuccess, onError).finally(function () {
	          return _this3.loadingMobileService.hide();
	        });
	      } else {
	        data = _requestFormHelper2.default.getRequestOnCreate(request);
	        this.requestFormService.create(userId, data, this.isInception(), managerId).then(onSuccess, onError).finally(function () {
	          return _this3.loadingMobileService.hide();
	        });
	      }
	
	      this.ongoing = false;
	    }
	  }, {
	    key: '_getRequestStartDate',
	    value: function _getRequestStartDate(originalPeriod) {
	      if (this.isCreateSickness()) {
	        return this.startDate;
	      }
	      return this.startDate || new Date(originalPeriod.startDate);
	    }
	  }, {
	    key: 'getRequest',
	    value: function getRequest(isSicknessRequest, originalPeriod) {
	      var requestStartDate = this._getRequestStartDate(originalPeriod);
	
	      var request = {
	        endDate: this.endDate,
	        startDate: requestStartDate,
	        code: this.selectedRequestCode,
	        codeCategory: this.selectedRequestCode,
	        type: this.type
	      };
	
	      if (!this.continuousPatenity && this.isPaternity5Week()) {
	        request.endDateFifthWeek = this.endDate2Period;
	        request.startDateFifthWeek = this.startDate2Period;
	      }
	
	      if (isSicknessRequest) {
	        delete request.endDate;
	        request.collegiateNumber = this.collegiateNumber || '';
	        if (this.isRelapse) {
	          request.relapseDate = this.relapseDate;
	        }
	
	        if (this.isLeaveDateSelected || this.isEditSickness()) {
	          request.endDate = this.sicknessLeaveDate;
	        }
	
	        if (this.sicknessLeaveDateKnownReason) {
	          request.sicknessLeaveDateKnownReason = this.sicknessLeaveDateKnownReason;
	        }
	
	        if (this.leaveSicknessReason) {
	          request.leaveSicknessReason = this.leaveSicknessReason;
	        }
	
	        if (this.isCreateSickness()) {
	          request.startDate = this.sicknessStartDate;
	        }
	      }
	
	      if (this.isHourlyRequest) {
	        request.hours = this.absenceHours;
	      }
	
	      if (this.birthDateChild) {
	        request.birthDateChild = this.birthDateChild;
	      }
	      return request;
	    }
	  }, {
	    key: 'getUserRequestFromManagerData',
	    value: function getUserRequestFromManagerData() {
	      var _this4 = this;
	
	      if (!this.isInception()) {
	        return;
	      }
	
	      return this.ManagerDataService.getManager().listRequestsEmployees.find(function (user) {
	        return user.employeeId === _this4.userInceptionId;
	      });
	    }
	  }, {
	    key: 'isInception',
	    value: function isInception() {
	      return this.state.current.component !== 'myVacations' && this.state.current.component !== 'myVacationsMobile' && this.state.current.component !== 'periodListMobile';
	    }
	  }, {
	    key: 'filterRelapsesBeforeStartDate',
	    value: function filterRelapsesBeforeStartDate() {
	      var _this5 = this;
	
	      return this.relapses.filter(function (relapseObject) {
	        var dateFormatted = new Date(relapseObject.value);
	        return dateFormatted <= _this5.sicknessStartDate;
	      });
	    }
	  }, {
	    key: 'getRelapses',
	    value: function getRelapses() {
	      var _this6 = this;
	
	      this.loadingMobileService.show();
	      var userId = this.userInceptionId || this.getUserId();
	      var managerId = this.UserDataService._employee.userId;
	      var isInception = this.isInception();
	
	      this.requestFormService.getRelapses(userId, isInception, managerId).then(function (_ref) {
	        var data = _ref.data;
	
	        _this6.relapses = _requestFormHelper2.default.sanitizeRelapses(data.relapsesPeriods);
	        if (_this6.sicknessStartDate) _this6.relapses = _this6.filterRelapsesBeforeStartDate();
	      }).catch(function () {
	        _this6.relapsesError = true;
	      }).finally(function () {
	        return _this6.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'shouldRenderRelapseCheckbox',
	    value: function shouldRenderRelapseCheckbox() {
	      return this.isCreateSickness() && this.relapses.length !== 0;
	    }
	  }, {
	    key: 'getCurrentSessionUserID',
	    value: function getCurrentSessionUserID() {
	      return this.UserDataService.getEmployee().userId;
	    }
	  }, {
	    key: 'getRequestTypes',
	    value: function getRequestTypes() {
	      var typesToReturn = [];
	      if (this.isInception()) {
	        typesToReturn = _requestFormHelper2.default.getRequestTypesManager(this.managerAsEmployeeData);
	      } else {
	        typesToReturn = _requestFormHelper2.default.getRequestTypes(this.UserDataService, this.type);
	      }
	      return typesToReturn;
	    }
	  }, {
	    key: 'getUserId',
	    value: function getUserId() {
	      return this.userId;
	    }
	
	    /**
	     * When we switch the type of a request, we must recharge the types and categories, and also
	     * restore the vacation selection when we return from absence to vacation. Also, when is an
	     * absence, set the mode to create, for avoid collision when edit-sickness flow.
	     */
	
	  }, {
	    key: 'switchRequestTypes',
	    value: function switchRequestTypes($event) {
	      var _this7 = this;
	
	      this.timeout(function () {
	        _this7.restartRequestSelects = true;
	        _this7.showSwitchRequestTypes = true;
	        _this7.mode = _constants.MODES.CREATE; // Avoid show sick extra elements because previous mode was edit
	        _this7.scope.$apply(); // Force select component repaint
	        _this7.newRequestType = $event.option;
	        _this7.log.info('Switch request type, new request type is ...', _this7.newRequestType);
	        _this7.setTypeAndRequestTypes(_this7.newRequestType);
	        _this7.initialRequestType = null;
	        _this7.initialRequestCategory = null;
	        _this7.isSicknessRequest = false;
	
	        if (_this7.newRequestType === _request.Request.TYPES.VACATION) {
	          _this7.initialRequestType = _this7.initialRequestTypeBackup;
	          _this7.initialRequestCategory = _this7.initialRequestCategoryBackup;
	          _this7.restoredInitialRequestValues = true;
	          _this7.mode = _constants.MODES.EDIT;
	        } else {
	          _this7.restoredInitialRequestValues = false;
	          _this7.mode = _constants.MODES.CREATE;
	        }
	
	        _this7.scope.$apply(); // Force select component repaint
	        _this7.restartRequestSelects = false;
	      });
	    }
	  }, {
	    key: 'avoidEmptyCodeOnEdit',
	    value: function avoidEmptyCodeOnEdit() {
	      this.onSelectRequestCategory({ $item: this.initialRequestCategory });
	    }
	  }, {
	    key: 'getRequestTypeFromPeriod',
	    value: function getRequestTypeFromPeriod(period) {
	      return period.type;
	    }
	  }, {
	    key: 'isInvalid',
	    value: function isInvalid(form) {
	      return _requestFormHelper2.default.formIsInvalid(form) && this.isSubmitted;
	    }
	  }, {
	    key: 'onSelectRequestType',
	    value: function onSelectRequestType(_ref2) {
	      var $item = _ref2.$item;
	
	      this.requestCategories = [];
	      this.selectedRequestCode = null;
	      this.form.requestCategories.$setPristine(); // Avoid show error on second select on clean code
	      this.scope.$apply();
	      this.requestCategories = $item.value.map(_requestFormHelper2.default.mapRequestCategory);
	    }
	
	    /**
	     * This function determines if the request type select must be disabled.
	     * The request type select must be disabled when:
	     *   - We do not have request types
	     *   - We are editing
	     *   - The request switch has not been touched
	     *   - The initial request types has been restored (this means, insert absence in a vacation period
	     *     but clicked again vacation)
	     *
	     * @returns {boolean} - Request type select must be disabled.
	     */
	
	  }, {
	    key: 'disableRequestTypesSelector',
	    value: function disableRequestTypesSelector() {
	      var noRequestTypes = !this.requestTypes;
	      var isEdit = this.isEdit();
	      var requestSwitchPristine = !this.newRequestType;
	      return (noRequestTypes || isEdit) && requestSwitchPristine || this.restoredInitialRequestValues;
	    }
	  }, {
	    key: 'onSelectRequestCategory',
	    value: function onSelectRequestCategory(_ref3) {
	      var _this8 = this;
	
	      var $item = _ref3.$item;
	
	      this.selectedRequestCode = $item.value;
	      this.emitData(this.EventEmitter($item));
	      this.absenceMaxHours = this.selectedRequestCode === _constants2.SINDICAL_REPRESENTATION_HOURS_CODE ? _constants2.MAX_HOURS.SINDICAL_REPRESENTATION : _constants2.MAX_HOURS.GENERAL_HOURLY_ABSENCES;
	      if (!this.selectedRequestCode) {
	        this.log.warn('requestForm.controller: Cannot discern if period is sickness, no given code');
	      }
	
	      this.isDisplacementRequest = _requestFormHelper2.default.isDisplacement(this.selectedRequestCode);
	      this.isSicknessRequest = _requestFormHelper2.default.periodIsSickness(this.selectedRequestCode);
	      this.isHourlyRequest = _requestFormHelper2.default.isHourly(this.requestCategories, this.selectedRequestCode);
	      if (this.isHourlyRequest) {
	        this.absenceMaxHours = _requestFormHelper2.default.getHourlyMax(this.requestCategories, this.selectedRequestCode);
	      }
	
	      if (_requestFormHelper2.default.isAbsenceRequest(this.type)) {
	        this.setMaximumDurationWhenPaternityOrMaternity(this.selectedRequestCode);
	      }
	      this.timeout(function () {
	        _this8.floatingActionButtonsService.run();
	      });
	    }
	  }, {
	    key: 'setMaximumDurationWhenPaternityOrMaternity',
	    value: function setMaximumDurationWhenPaternityOrMaternity(selectedRequestCode) {
	      /*  let duration;
	       let maximumDuration = RequestHelper.getMaximumDurationPaternityAndMaternity(requestTypes); */
	      var maximumDurationMatPat = _requestFormHelper2.default.getMaximumDurationMATPAT(this.startDate, selectedRequestCode, this.UserDataService.getMatPatPeriods());
	
	      var isMaternityOrPaternity = this.checkMaternity(selectedRequestCode) || this.checkPaternity(selectedRequestCode);
	      if (isMaternityOrPaternity) {
	        /*     duration = this.checkMaternity(selectedRequestCode) ? maximumDuration.maternity : maximumDuration.paternity; */
	        this.endDate = (0, _moment2.default)(this.startDate).add(maximumDurationMatPat - 1, 'days').toDate();
	      }
	    }
	  }, {
	    key: 'checkMaternity',
	    value: function checkMaternity(selectedRequestCode) {
	      return selectedRequestCode === _constants2.MATERNITY_CODE;
	    }
	  }, {
	    key: 'checkPaternity',
	    value: function checkPaternity(selectedRequestCode) {
	      return selectedRequestCode === _constants2.PATERNITY_CODE;
	    }
	
	    /**
	     * This function determines if the request category select must be disabled.
	     * The request category select must be disabled when:
	     *   - We do not have request categories. But in this case by lenght.
	     *   - We are editing.
	     *   - The request switch has been not touched.
	     *   - The initial request types has been restored (this means, insert absence in a vacation period
	     *     but clicked again vacation).
	     *
	     * @returns {boolean} - Request category select must be disabled.
	     */
	
	  }, {
	    key: 'disableRequestCategoriesSelector',
	    value: function disableRequestCategoriesSelector() {
	      var noRequestCategories = this.requestCategories.length === 0;
	      var isEdit = this.isEdit();
	      var requestSwitchPristine = !this.newRequestType;
	      return (noRequestCategories || isEdit) && requestSwitchPristine || this.restoredInitialRequestValues;
	    }
	  }, {
	    key: 'datepickInitDate',
	    value: function datepickInitDate(_ref4) {
	      var date = _ref4.date;
	
	      this.startDate = date;
	
	      if (!this.form.endDate) {
	        return;
	      }
	
	      this.setMaximumDurationWhenPaternityOrMaternity(this.selectedRequestCode);
	      if (this.isMobileApp) {
	        this.setMinEndDateToMobile(this.startDate);
	      }
	
	      if (this.endDate && this.startDate > this.endDate) {
	        this.form.startDate.$setValidity('validRange', false);
	      } else {
	        this.setValidRange();
	      }
	    }
	  }, {
	    key: 'datepickInitDate2Period',
	    value: function datepickInitDate2Period(_ref5) {
	      var date = _ref5.date;
	
	      this.startDate2Period = date;
	      if (!this.form.endDate2Period) {
	        return;
	      }
	
	      if (this.isMobileApp) {
	        this.setMinEndDateToMobile(this.startDate);
	      }
	
	      if (this.endDate2Period && this.startDate2Period > this.endDate2Period) {
	        this.form.startDate.$setValidity('validRange2Period', false);
	      } else {
	        this.setValidRange();
	      }
	    }
	  }, {
	    key: 'datepickEndDate',
	    value: function datepickEndDate(_ref6) {
	      var date = _ref6.date;
	
	      this.endDate = date;
	      if (this.startDate && this.endDate < this.startDate) {
	        this.form.endDate.$setValidity('validRange', false);
	      } else {
	        this.setValidRange();
	      }
	    }
	  }, {
	    key: 'datepickEndDate2Period',
	    value: function datepickEndDate2Period(_ref7) {
	      var date = _ref7.date;
	
	      this.endDate2Period = date;
	      if (this.startDate2Period === null) {
	        return;
	      }
	
	      if (this.startDate2Period && this.endDate2Period < this.startDate2Period) {
	        this.form.endDate2Period.$setValidity('validRange2Period', false);
	      } else {
	        this.setValidRange();
	      }
	    }
	  }, {
	    key: 'isBirthDateChildRequired',
	    value: function isBirthDateChildRequired() {
	      return this.selectedRequestCode === _constants2.PATERNITY_SECOND_PERIOD_CODE || this.selectedRequestCode === _constants2.MATERNITY_SECOND_PERIOD_CODE;
	    }
	  }, {
	    key: 'isBirthDateChildMissing',
	    value: function isBirthDateChildMissing() {
	      return this.isBirthDateChildRequired() && !this.birthDateChild;
	    }
	  }, {
	    key: 'onChangePaternityConinuos',
	    value: function onChangePaternityConinuos() {
	      this.setMaximumDurationWhenPaternityOrMaternity(this.selectedRequestCode);
	    }
	  }, {
	    key: 'datepickLeaveDateKnown',
	    value: function datepickLeaveDateKnown(_ref8) {
	      var date = _ref8.date;
	
	      this.sicknessLeaveDate = date;
	      this.checkSicknessLeaveValidity();
	    }
	  }, {
	    key: 'setMinInitialDateToMobile',
	    value: function setMinInitialDateToMobile(minDate) {
	      this.minInitialDate = minDate;
	    }
	  }, {
	    key: 'setMinEndDateToMobile',
	    value: function setMinEndDateToMobile(startDate) {
	      this.minEndDate = startDate;
	    }
	  }, {
	    key: 'setLeaveDateSendStatus',
	    value: function setLeaveDateSendStatus(_ref9) {
	      var selected = _ref9.selected;
	
	      this.isLeaveDateSelected = selected;
	    }
	  }, {
	    key: 'checkSicknessLeaveValidity',
	    value: function checkSicknessLeaveValidity() {
	      if (!this.isCreateSickness()) return;
	      if (this.sicknessStartDate && this.sicknessLeaveDate && this.sicknessLeaveDate < this.sicknessStartDate) {
	        this.form.sicknessLeaveDate.$setValidity('validRange', false);
	      } else {
	        this.setValidRangeLeaveDateKnown();
	      }
	    }
	  }, {
	    key: 'datepickSicknessStartDate',
	    value: function datepickSicknessStartDate($event) {
	      this.sicknessStartDate = $event.date;
	      if (this.isMobileApp) {
	        this.setMinEndDateToMobile(this.sicknessStartDate);
	      }
	      this.checkSicknessLeaveValidity();
	      this.getRelapses();
	    }
	  }, {
	    key: 'datepickSicknessLeaveDate',
	    value: function datepickSicknessLeaveDate($event) {
	      this.sicknessLeaveDate = $event.date;
	    }
	  }, {
	    key: 'setValidRangeLeaveDateKnown',
	    value: function setValidRangeLeaveDateKnown() {
	      if (!this.sicknessStartDate) {
	        this.initStartDate = angular.copy(this.sicknessLeaveDate);
	      }
	
	      if (!this.sicknessLeaveDate) {
	        this.initLeaveDateKnown = angular.copy(this.sicknessStartDate);
	      }
	
	      this.form.sicknessLeaveDate.$setValidity('validRange', true);
	      this.form.sicknessStartDate.$setValidity('validRange', true);
	    }
	  }, {
	    key: 'setValidRange',
	    value: function setValidRange() {
	      if (!this.startDate) {
	        this.initStartDate = angular.copy(this.endDate);
	      }
	
	      if (!this.endDate) {
	        this.initEndDate = angular.copy(this.startDate);
	      }
	
	      this.form.endDate.$setValidity('validRange', true);
	      this.form.startDate.$setValidity('validRange', true);
	      if (!this.continuousOldPatenity && !this.continuousPatenity && this.isAbsence() && this.isPaternity5Week()) {
	        this.form.endDate2Period.$setValidity('validRange2Period', true);
	        this.form.startDate2Period.$setValidity('validRange2Period', true);
	      }
	    }
	  }, {
	    key: 'isPaternity5Week',
	    value: function isPaternity5Week() {
	      return this.selectedRequestCode == _constants2.PATERNITY_CODE;
	    }
	  }, {
	    key: 'onSelectRelapse',
	    value: function onSelectRelapse($event) {
	      this.relapseDate = $event.$item.value;
	    }
	  }, {
	    key: 'openSicknessPanel',
	    value: function openSicknessPanel() {
	      this.sicknessPanelOpened = !this.sicknessPanelOpened;
	    }
	  }, {
	    key: 'sicknessPanelIsOpen',
	    value: function sicknessPanelIsOpen() {
	      return this.sicknessPanelOpened;
	    }
	  }, {
	    key: 'onSelectLeaveSicknessReason',
	    value: function onSelectLeaveSicknessReason($event) {
	      this.leaveSicknessReasonInitialValue = $event.$item;
	      this.leaveSicknessReason = $event.$item.value;
	    }
	  }, {
	    key: 'selectSicknessLeaveDateKnownReason',
	    value: function selectSicknessLeaveDateKnownReason($event) {
	      this.sicknessLeaveDateKnownReason = $event.value;
	    }
	  }, {
	    key: 'requestTypeSwitchVisible',
	    value: function requestTypeSwitchVisible() {
	      var isEditingANonSick = this.isEdit() && !this.isEditSickness();
	      var locked = !!this.lockOn;
	      return isEditingANonSick || locked || this.showSwitchRequestTypes;
	    }
	  }, {
	    key: 'requestTypeSwitchEditable',
	    value: function requestTypeSwitchEditable() {
	      if (!this.periodToEdit) {
	        return false;
	      }
	
	      return _requestFormHelper2.default.requestTypeSwitchEditable(this.periodToEdit, this.isInception());
	    }
	
	    /**
	     * When we are on inception, and edit a vacation, only allow to insert absence, not modify the
	     * vacation request.
	     */
	
	  }, {
	    key: 'forceShowAbsenceFlowWhenVacationEditOnInception',
	    value: function forceShowAbsenceFlowWhenVacationEditOnInception() {
	      if (this.isInception() && _requestFormHelper2.default.isVacationRequest(this.originalPeriod.type)) {
	        this.type = _request.Request.TYPES.ABSENCE;
	        this.switchRequestTypes({ requestType: _request.Request.TYPES.ABSENCE });
	      }
	    }
	  }, {
	    key: 'setAbsenceHours',
	    value: function setAbsenceHours() {
	      if (!_request.Request.isHourly(this.periodToEdit)) {
	        return;
	      }
	
	      this.absenceHours = parseFloat(this.periodToEdit.hours);
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      return this.onDismiss();
	    }
	  }, {
	    key: 'showFormSickLeaveReports',
	    value: function showFormSickLeaveReports() {
	      return this.isSicknessEditOnContinue() && !this.sicknessPanelIsOpen();
	    }
	  }, {
	    key: 'submitButtonIsDisabled',
	    value: function submitButtonIsDisabled() {
	      return this.form.$invalid === true || this.ongoing || this.isDisabledSickLeaveReports || this.isBirthDateChildMissing();
	    }
	  }, {
	    key: 'checkMedicalPartsAdded',
	    value: function checkMedicalPartsAdded() {
	      var _this9 = this;
	
	      if (this.showFormSickLeaveReports()) {
	        this.isDisabledSickLeaveReports = true;
	        this.rootScope.$on(_constants.EVENTS.BUTTON_SICK_LEAVE_REPORTS_DISABLED, function () {
	          _this9.isDisabledSickLeaveReports = false;
	        });
	      }
	    }
	  }, {
	    key: 'setVacationsMinDateOnNewYear',
	    value: function setVacationsMinDateOnNewYear() {
	      var isRequestingVacationsInMobile = this.isMobileApp && this.type === _request.Request.TYPES.VACATION;
	
	      if (isRequestingVacationsInMobile) {
	        var currentYear = new Date().getFullYear();
	        var currentMonth = new Date().getMonth();
	        this.setMinInitialDateToMobile(new Date(currentYear, currentMonth, 1));
	      }
	    }
	  }, {
	    key: 'setAbsencesMinDateOnNewYear',
	    value: function setAbsencesMinDateOnNewYear() {
	      var isRequestingAbsencesInMobile = this.isMobileApp && this.type === _request.Request.TYPES.ABSENCE;
	      var isActuallyJanuary = new Date().getMonth() === _constants.JANUARY_INDEX;
	
	      if (isRequestingAbsencesInMobile && isActuallyJanuary) {
	        var currentYear = new Date().getFullYear();
	        this.setMinInitialDateToMobile(new Date(currentYear - 1, _constants.DECEMBER_INDEX, 1));
	      } else if (isRequestingAbsencesInMobile && !isActuallyJanuary) {
	        var _currentYear = new Date().getFullYear();
	        this.setMinInitialDateToMobile(new Date(_currentYear, _constants.JANUARY_INDEX, 1));
	      }
	    }
	  }, {
	    key: 'onBirthDateChildInputChange',
	    value: function onBirthDateChildInputChange() {
	      var input = this.birthDateChildInput || '';
	      var digits = input.replace(/\D/g, '').slice(0, 8);
	
	      var formatted = digits;
	      if (digits.length > 4) {
	        formatted = digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
	      } else if (digits.length > 2) {
	        formatted = digits.slice(0, 2) + '/' + digits.slice(2);
	      }
	
	      this.birthDateChildInput = formatted;
	      this.birthDateChild = null;
	      this.form.birthDateChild.$setValidity('invalidYear', true);
	
	      var match = formatted.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
	      if (match) {
	        var _match = (0, _slicedToArray3.default)(match, 4),
	            day = _match[1],
	            month = _match[2],
	            year = _match[3];
	
	        var currentYear = new Date().getFullYear();
	        var parsedYear = parseInt(year, 10);
	
	        if (parsedYear > currentYear || parsedYear < 1900) {
	          this.form.birthDateChild.$setValidity('invalidYear', false);
	          return;
	        }
	
	        this.birthDateChild = year + '-' + month + '-' + day;
	      }
	    }
	  }]);
	  return RequestFormController;
	}();
	
	exports.default = RequestFormController;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dateUtils = __webpack_require__(1132);
	
	var _request = __webpack_require__(1114);
	
	var _constants = __webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestFormHelper = function () {
	  function RequestFormHelper() {
	    (0, _classCallCheck3.default)(this, RequestFormHelper);
	  }
	
	  (0, _createClass3.default)(RequestFormHelper, null, [{
	    key: 'isVacationRequest',
	    value: function isVacationRequest(type) {
	      return type === _request.Request.TYPES.VACATION;
	    }
	  }, {
	    key: 'isAbsenceRequest',
	    value: function isAbsenceRequest(type) {
	      return type === _request.Request.TYPES.ABSENCE;
	    }
	  }, {
	    key: 'getRequestTypes',
	    value: function getRequestTypes(vacationUserDataService, type) {
	      var vacationTypes = vacationUserDataService.getVacationTypes();
	      var absenceTypes = vacationUserDataService.getAbsenceTypes();
	      var requestTypes = this.isVacationRequest(type) ? vacationTypes : absenceTypes;
	      return requestTypes.map(this.mapRequestType);
	    }
	  }, {
	    key: 'getRequestTypesManager',
	    value: function getRequestTypesManager(ManagerDataService) {
	      if (!ManagerDataService) return;
	      var absenceTypes = ManagerDataService.absenceTypes;
	      return absenceTypes.map(this.mapRequestType);
	    }
	  }, {
	    key: 'getRequestCategoriesByCode',
	    value: function getRequestCategoriesByCode(requestTypes, code) {
	      var _this = this;
	
	      var requestCategories = [];
	
	      requestTypes.forEach(function (option) {
	        var optionValue = option.value;
	        var match = optionValue.find(function (vc) {
	          return vc.code === code;
	        });
	        if (match) {
	          requestCategories = optionValue.map(_this.mapRequestCategory);
	        }
	      });
	      return requestCategories;
	    }
	  }, {
	    key: 'findRequestTypeByCode',
	    value: function findRequestTypeByCode(requestTypes, code) {
	      var result = void 0;
	
	      requestTypes.forEach(function (requestType) {
	        requestType.value.forEach(function (requestCategory) {
	          if (requestCategory.code === code) result = requestType;
	        });
	      });
	
	      return result;
	    }
	  }, {
	    key: 'findRequestCategoryByCode',
	    value: function findRequestCategoryByCode(requestCategories, code) {
	      return requestCategories.find(function (vc) {
	        return vc.value === code;
	      });
	    }
	  }, {
	    key: 'findSicknessLeaveReasonByCode',
	    value: function findSicknessLeaveReasonByCode(sicknessLeaveReasons, code) {
	      return sicknessLeaveReasons.find(function (vc) {
	        return vc.value === code;
	      });
	    }
	  }, {
	    key: 'mapRequestType',
	    value: function mapRequestType(type) {
	      var result = {
	        option: type.description,
	        value: type.categories,
	        catalogation: type.catalogation
	      };
	      if (type.hourly !== undefined) {
	        result.hourly = type.hourly;
	      }
	
	      return result;
	    }
	  }, {
	    key: 'mapRequestCategory',
	    value: function mapRequestCategory(category) {
	      var result = {
	        option: category.description,
	        value: category.code || category.catalogation
	      };
	
	      if (category.maximumDuration !== undefined) {
	        result.maximumDuration = category.maximumDuration;
	      }
	      if (category.hourly !== undefined) {
	        result.hourly = category.hourly;
	      }
	
	      return result;
	    }
	  }, {
	    key: 'sanitizeRelapses',
	    value: function sanitizeRelapses(relapses) {
	      relapses = relapses.map(this.mapRelapse);
	      relapses = _lodash2.default.sortBy(relapses, 'value').reverse();
	      return relapses;
	    }
	  }, {
	    key: 'mapRelapse',
	    value: function mapRelapse(relapse) {
	      var parts = relapse.startDate.split('-');
	      var option = [parts[2], parts[1], parts[0]].join('/');
	      return {
	        option: option,
	        value: relapse.startDate
	      };
	    }
	  }, {
	    key: 'periodIsSickness',
	    value: function periodIsSickness(code) {
	      return _request.Request.isSick({ code: code });
	    }
	  }, {
	    key: 'isDisplacement',
	    value: function isDisplacement(code) {
	      return _request.Request.isDisplacement({ code: code });
	    }
	  }, {
	    key: 'isHourly',
	    value: function isHourly(requestCategories, code) {
	      var category = this.findRequestCategoryByCode(requestCategories, code);
	      return category.hourly;
	    }
	  }, {
	    key: 'getHourlyMax',
	    value: function getHourlyMax(requestCategories, code) {
	      var category = this.findRequestCategoryByCode(requestCategories, code);
	      return category.maximumDuration;
	    }
	  }, {
	    key: 'formIsInvalid',
	    value: function formIsInvalid(form) {
	      return form.$invalid && form.$dirty;
	    }
	  }, {
	    key: 'getRequestOnCreate',
	    value: function getRequestOnCreate(rawRequest) {
	      var request = {
	        startDate: (0, _dateUtils.formatDate)(rawRequest.startDate),
	        code: rawRequest.code
	      };
	
	      if (rawRequest.endDate) {
	        request.endDate = (0, _dateUtils.formatDate)(rawRequest.endDate);
	      }
	
	      if (rawRequest.collegiateNumber) {
	        request.collegiateNumber = rawRequest.collegiateNumber;
	      }
	
	      if (rawRequest.relapseDate) {
	        request.relapseStartDate = rawRequest.relapseDate;
	      }
	
	      if (rawRequest.hours) {
	        request.hours = rawRequest.hours;
	      }
	
	      if (rawRequest.sicknessLeaveDateKnownReason) {
	        request.dischargeReason = rawRequest.sicknessLeaveDateKnownReason;
	      }
	
	      if (rawRequest.startDateFifthWeek) {
	        request.startDateFifthWeek = (0, _dateUtils.formatDate)(rawRequest.startDateFifthWeek);
	      }
	
	      if (rawRequest.endDateFifthWeek) {
	        request.endDateFifthWeek = (0, _dateUtils.formatDate)(rawRequest.endDateFifthWeek);
	      }
	
	      if (rawRequest.birthDateChild) {
	        request.birthDateChild = (0, _dateUtils.formatDate)(rawRequest.birthDateChild);
	      }
	
	      return request;
	    }
	  }, {
	    key: 'getRequestOnUpdate',
	    value: function getRequestOnUpdate(rawRequest, originalRequest) {
	      var request = {
	        startDate: (0, _dateUtils.formatDate)(originalRequest.startDate),
	        endDate: (0, _dateUtils.formatDate)(originalRequest.endDate),
	        newStartDate: (0, _dateUtils.formatDate)(rawRequest.startDate),
	        newEndDate: (0, _dateUtils.formatDate)(rawRequest.endDate),
	        code: rawRequest.code
	      };
	
	      if (rawRequest.hours) {
	        delete request.newEndDate;
	        request.hours = rawRequest.hours;
	      }
	
	      return request;
	    }
	  }, {
	    key: 'getRequestOnUpdateSicknessOnCancel',
	    value: function getRequestOnUpdateSicknessOnCancel(rawRequest, originalRequest) {
	      return {
	        startDate: (0, _dateUtils.formatDate)(originalRequest.startDate),
	        endDate: (0, _dateUtils.formatDate)(rawRequest.endDate),
	        code: originalRequest.code,
	        dischargeReason: rawRequest.leaveSicknessReason,
	        collegiateNumber: rawRequest.collegiateNumber
	      };
	    }
	  }, {
	    key: 'getLeaveSicknessReasons',
	    value: function getLeaveSicknessReasons(UserDataService) {
	      var reasonsTypes = UserDataService.getDischargeReasons();
	      var mappedReasons = reasonsTypes.map(this.mapRequestCategory);
	      return mappedReasons;
	    }
	  }, {
	    key: 'mapSickLeaveReports',
	    value: function mapSickLeaveReports(sickLeaveReports) {
	      return sickLeaveReports.map(function (report) {
	        report.date = new Date(report.sickPartDate);
	        report.disabled = true;
	        return report;
	      });
	    }
	  }, {
	    key: 'getSickLeaveReportsOnCreate',
	    value: function getSickLeaveReportsOnCreate(sickLeaveReports, originalPeriod) {
	      return sickLeaveReports.filter(function (report) {
	        var reportIsFromDatabase = report.disabled === true;
	        return !reportIsFromDatabase;
	      }).map(function (report) {
	        report.date.setHours(0, 0, 0, 0);
	        return {
	          absenceDate: (0, _dateUtils.formatDate)(originalPeriod.startDate),
	          sickPartDate: (0, _dateUtils.formatDate)(report.date),
	          order: parseInt(report.order)
	        };
	      });
	    }
	  }, {
	    key: 'requestTypeSwitchEditable',
	    value: function requestTypeSwitchEditable(request, isInception) {
	      var requestedVacation = _request.Request.isVacation(request) && _request.Request.isRequested(request);
	      var pastRequest = (0, _moment2.default)().isAfter(request.startDate);
	      return requestedVacation && pastRequest && !isInception;
	    }
	  }, {
	    key: 'getMaximumDurationPaternityAndMaternity',
	    value: function getMaximumDurationPaternityAndMaternity(requestTypes) {
	      var maximumDuration = {
	        paternity: 0,
	        oldPaternity: 0,
	        maternity: 0
	      };
	      var resultType = requestTypes.filter(function (objectFiltered) {
	        return objectFiltered.catalogation === _constants.BIRTH_OF_CHILDREN_CATALOGATION_CODE;
	      });
	
	      if (resultType.length > 0) {
	        var resultPaternity = resultType[0].value.filter(function (objectFiltered) {
	          return objectFiltered.code === _constants.PATERNITY_CODE;
	        });
	
	        var resultMaternity = resultType[0].value.filter(function (objectFiltered) {
	          return objectFiltered.code === _constants.MATERNITY_CODE;
	        });
	        if (resultPaternity.length || resultMaternity.length) {
	          maximumDuration.paternity = resultPaternity[0].maximumDuration;
	          maximumDuration.maternity = resultMaternity[0].maximumDuration;
	        }
	      }
	
	      return maximumDuration;
	    }
	  }, {
	    key: 'getMaximumDurationMATPAT',
	    value: function getMaximumDurationMATPAT(initDate, reason, periods) {
	
	      var targetDate = (0, _moment2.default)(initDate);
	
	      var match = periods.find(function (p) {
	        var start = (0, _moment2.default)(p.startDate, 'YYYY-MM-DD');
	        var end = (0, _moment2.default)(p.endDate, 'YYYY-MM-DD');
	        return p.reason === reason && targetDate.isBetween(start, end, undefined, '[]');
	      });
	
	      return match ? match.totalDuration : null;
	    }
	  }]);
	  return RequestFormHelper;
	}();
	
	exports.default = RequestFormHelper;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1385);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./requestForm.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./requestForm.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "request-form h5{height:15px;font-family:Stag Sans;font-size:15px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#0072c9;margin-top:30px;margin-bottom:22px}request-form .sick-leave-reports{animation:my_fade_animation 6s}@keyframes my_fade_animation{0%{opacity:0!important}to{opacity:1!important}}request-form .request-form-modal.responsiveMobile{padding:60px 10px 75px}request-form .request-form-modal.responsiveMobile form{padding-bottom:200px}request-form .request-form-modal.responsiveMobile .row{margin-top:30px;margin-bottom:30px}request-form .request-form-modal.responsiveMobile .row.relapse-mobile{margin-top:10px;padding-bottom:20px}request-form .request-form-modal.responsiveMobile .checkbox{padding-left:5px}request-form .request-form-modal.responsiveMobile input[type=number],request-form .request-form-modal.responsiveMobile input[type=text]{height:60px;width:100%}request-form .request-form-modal.responsiveMobile input-datepicker{width:100%}request-form .request-form-modal .modal-body{padding:29px 0 32px}request-form .request-form-modal .modal-body.reduced-padding{padding-top:7px}request-form .request-form-modal .modal-body .label-tooltip{font-size:13px;font-weight:400;min-height:21px;padding-bottom:3px;margin-bottom:0;padding-top:0;padding-left:5px;color:#666}request-form .request-form-modal .modal-body .label-tooltip span.icon{font-size:15px}request-form .request-form-modal .modal-body .checkbox{margin-top:0}request-form .request-form-modal .modal-body .separator{margin-bottom:30px}request-form .request-form-modal .modal-body .request-form-sickness-panel-bottom{margin-bottom:21px}request-form .request-form-modal .modal-body .optional-advice{font-family:Stag Sans;font-size:11px;font-weight:300;color:#666;text-align:center;margin-bottom:7px}request-form .request-form-modal .modal-body select-app{display:block;height:37px;margin-bottom:20px;width:100%}request-form .request-form-modal .modal-body select-app.second-select{margin-bottom:15px}request-form .request-form-modal .modal-body .displacement-warning{margin:30px auto 16px;width:300px}request-form .request-form-modal .modal-body .displacement-warning p{margin:0;width:307px;font-family:ArialMT;font-size:15px;line-height:1.4;color:#666}request-form .request-form-modal .modal-body .write-message-panel p{font-family:Stag Sans;font-size:12px;color:#666}request-form .request-form-modal .modal-body .write-message-panel textarea{border-color:#dddfe2;box-shadow:0 2px 4px 0 #dddfe2,0 -1px 4px 0 #dddfe2;color:#666;font-family:Stag Sans;font-style:italic;height:135.3px;margin-left:-1px;padding-left:20px;padding-right:26px;padding-top:9.2px;resize:none;width:100%}request-form .request-form-modal .modal-body .write-message-panel textarea:focus{outline:0}request-form .request-form-modal .modal-footer{border:0}request-form .request-form-modal .modal-footer .btn-default{float:left}request-form .request-form-modal .modal-footer .btn-primary{float:right}.birthdate-row{width:100%;display:flex;justify-content:center;align-items:center}.birthdate-row .birthdate-center{margin:2rem 0 1rem 1rem}", ""]);
	
	// exports


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vacationsAbsences = __webpack_require__(1120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestFormService = function () {
	  RequestFormService.$inject = ["$http", "$log"];
	  function RequestFormService($http, $log) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, RequestFormService);
	    this.http = $http;
	    this.log = $log;
	  }
	
	  (0, _createClass3.default)(RequestFormService, [{
	    key: 'create',
	    value: function create(employeeId, data, isInception, managerId) {
	      this.log.info('RequestFormService.create:', employeeId, data, isInception, managerId);
	      if (isInception) {
	        return this.http.post(_vacationsAbsences.ENDPOINTS_MANAGER.post.request(employeeId, managerId), data);
	      }
	      return this.http.post(_vacationsAbsences.ENDPOINTS_EMPLOYEE.post.request(employeeId), data);
	    }
	  }, {
	    key: 'createSickLeaveReports',
	    value: function createSickLeaveReports(employeeId, sickLeaveReports, isInception, managerId) {
	      var data = { sickLeaveReports: sickLeaveReports };
	      this.log.info('RequestFormService.createSickLeaveReports:', employeeId, data, isInception, managerId);
	      if (isInception) {
	        return this.http.post(_vacationsAbsences.ENDPOINTS_MANAGER.post.medicalParts(employeeId, managerId), data);
	      }
	      return this.http.post(_vacationsAbsences.ENDPOINTS_EMPLOYEE.post.medicalParts(employeeId), data);
	    }
	  }, {
	    key: 'update',
	    value: function update(employeeId, data, isInception, managerId) {
	      this.log.info('RequestFormService.update:', employeeId, data, isInception, managerId);
	      if (isInception) {
	        return this.http.put(_vacationsAbsences.ENDPOINTS_MANAGER.put.request(employeeId, managerId), data);
	      }
	      return this.http.put(_vacationsAbsences.ENDPOINTS_EMPLOYEE.put.request(employeeId), data);
	    }
	  }, {
	    key: 'updateSicknessWhenNo',
	    value: function updateSicknessWhenNo(employeeId, data, isInception, managerId) {
	      this.log.info('RequestFormService.updateSicknessWhenNo:', employeeId, data, isInception, managerId);
	      if (isInception) {
	        return this.http.put(_vacationsAbsences.ENDPOINTS_MANAGER.put.discharge(employeeId, managerId), data);
	      }
	      return this.http.put(_vacationsAbsences.ENDPOINTS_EMPLOYEE.put.discharge(employeeId), data);
	    }
	  }, {
	    key: 'getRelapses',
	    value: function getRelapses(employeeId, isInception, managerId) {
	      this.log.info('RequestFormService.getRelapses:', employeeId, isInception, managerId);
	      if (isInception) {
	        return this.http.get(_vacationsAbsences.ENDPOINTS_MANAGER.get.relapses(employeeId, managerId));
	      }
	      return this.http.get(_vacationsAbsences.ENDPOINTS_EMPLOYEE.get.relapses(employeeId));
	    }
	  }]);
	  return RequestFormService;
	}();
	
	exports.default = RequestFormService;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestFormTitle = __webpack_require__(1388);
	
	var _requestFormTitle2 = _interopRequireDefault(_requestFormTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestFormTitleModule = angular.module('vacations-absences.requestFormTitle', []).component('requestFormTitle', _requestFormTitle2.default).name;
	
	exports.default = requestFormTitleModule;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestFormTitle = __webpack_require__(1389);
	
	var _requestFormTitle2 = _interopRequireDefault(_requestFormTitle);
	
	var _requestFormTitle3 = __webpack_require__(1390);
	
	var _requestFormTitle4 = _interopRequireDefault(_requestFormTitle3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestFormTitleComponent = {
	  restrict: 'E',
	  bindings: {
	    isEdit: '<',
	    isEditSickness: '<',
	    isVacation: '<',
	    isAbsence: '<',
	    isHourly: '<',
	    initialRequestCategory: '<'
	  },
	  template: _requestFormTitle2.default,
	  controller: _requestFormTitle4.default
	};
	
	exports.default = requestFormTitleComponent;

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.showHourly()\">\n  <h4 class=\"modal-title\">\n    {{ 'VACATIONS_ABSENCES.REQUEST_MODAL.CREATE_HOURLY_REQUEST' | translate }}\n  </h4>\n</div>\n\n<div ng-if=\"!$ctrl.showHourly()\">\n  <h4 ng-if=\"$ctrl.showCreateVacationTitle()\" class=\"modal-title\">\n    {{ 'VACATIONS_ABSENCES.REQUEST_MODAL.CREATE_VACATION' | translate }}\n  </h4>\n\n  <h4 ng-if=\"$ctrl.showEditVacationTitle()\" class=\"modal-title\">\n    {{ 'VACATIONS_ABSENCES.REQUEST_MODAL.EDIT_VACATION' | translate }}\n  </h4>\n\n  <h4 ng-if=\"$ctrl.showCreateAbsenceTitle()\" class=\"modal-title\">\n    {{ 'VACATIONS_ABSENCES.REQUEST_MODAL.CREATE_ABSENCE' | translate }}\n  </h4>\n\n  <h4 ng-if=\"$ctrl.showEditAbsenceTitle()\" class=\"modal-title\">\n    {{ 'VACATIONS_ABSENCES.REQUEST_MODAL.EDIT_ABSENCE' | translate }}\n  </h4>\n\n  <h4 ng-if=\"$ctrl.showSicknessTitle()\" class=\"modal-title\">\n    {{ 'VACATIONS_ABSENCES.REQUEST_MODAL.ABSENCE_FOR' | translate}} <br> {{$ctrl.initialRequestCategory | capitalizeFirst}}\n  </h4>\n</div>\n"

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestFormTitleController = function () {
	  function RequestFormTitleController() {
	    (0, _classCallCheck3.default)(this, RequestFormTitleController);
	  }
	
	  (0, _createClass3.default)(RequestFormTitleController, [{
	    key: "showHourly",
	    value: function showHourly() {
	      return this.isHourly;
	    }
	  }, {
	    key: "showCreateVacationTitle",
	    value: function showCreateVacationTitle() {
	      return this.isVacation && !this.isEdit;
	    }
	  }, {
	    key: "showEditVacationTitle",
	    value: function showEditVacationTitle() {
	      return this.isVacation && this.isEdit;
	    }
	  }, {
	    key: "showCreateAbsenceTitle",
	    value: function showCreateAbsenceTitle() {
	      return this.isAbsence && !this.isEdit && !this.isEditSickness;
	    }
	  }, {
	    key: "showEditAbsenceTitle",
	    value: function showEditAbsenceTitle() {
	      return this.isAbsence && this.isEdit && !this.isEditSickness;
	    }
	  }, {
	    key: "showSicknessTitle",
	    value: function showSicknessTitle() {
	      return this.isEditSickness;
	    }
	  }]);
	  return RequestFormTitleController;
	}();
	
	exports.default = RequestFormTitleController;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestFormSicknessPanel = __webpack_require__(1392);
	
	var _requestFormSicknessPanel2 = _interopRequireDefault(_requestFormSicknessPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestFormSicknessPanelModule = angular.module('vacations-absences.requestFormSicknessPanel', []).component('requestFormSicknessPanel', _requestFormSicknessPanel2.default).name;
	
	exports.default = requestFormSicknessPanelModule;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestFormSicknessPanel = __webpack_require__(1393);
	
	var _requestFormSicknessPanel2 = _interopRequireDefault(_requestFormSicknessPanel);
	
	var _requestFormSicknessPanel3 = __webpack_require__(1394);
	
	var _requestFormSicknessPanel4 = _interopRequireDefault(_requestFormSicknessPanel3);
	
	__webpack_require__(1395);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestFormSicknessPanelComponent = {
	  restrict: 'E',
	  bindings: {
	    originalPeriod: '<',
	    openSicknessPanel: '&',
	    sicknessPanelIsOpen: '&',
	    isEditSickness: '&',
	    sickDescription: '<',
	    reports: '<',
	    isMobileApp: '<'
	  },
	  template: _requestFormSicknessPanel2.default,
	  controller: _requestFormSicknessPanel4.default
	};
	
	exports.default = requestFormSicknessPanelComponent;

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\" ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n  <div class=\"col-xs-12\">\n    <div class=\"sickness-panel\">\n      <div class=\"sickness-panel-title\">{{$ctrl.sickDescription | uppercase}}</div>\n      <div\n        class=\"sickness-panel-more\"\n        ng-click=\"$ctrl.openSicknessPanel();\"\n        ng-class=\"{'border-bottom': $ctrl.sicknessPanelIsOpen()}\">\n        <span>Ver detalles</span>\n        <span ng-if=\"!$ctrl.sicknessPanelIsOpen();\" class=\"glyphicon glyphicon-menu-down\"></span>\n        <span ng-if=\"$ctrl.sicknessPanelIsOpen();\" class=\"glyphicon glyphicon-menu-up\"></span>\n      </div>\n      <div class=\"sickness-panel-body\" ng-if=\"$ctrl.sicknessPanelIsOpen();\">\n        <div class=\"sickness-panel-status border-bottom\">\n          <p>{{'VACATIONS_ABSENCES.REQUEST_MODAL.REPORTED_SICKNESS' | translate}}</p>\n          <strong>{{'VACATIONS_ABSENCES.REQUEST_MODAL.LEAVE_DATE' | translate}}</strong><span>{{$ctrl.originalPeriod.startDate | slashDate}}</span>\n        </div>\n        <div class=\"sickness-panel-collegiate-number border-bottom\">\n          <strong>{{'VACATIONS_ABSENCES.REQUEST_MODAL.COLLEGIATE_NUMBER' | translate}}</strong><span>{{$ctrl.originalPeriod.collegiateNumber}}</span>\n        </div>\n        <div class=\"sickness-panel-list border-bottom\">\n          <div class=\"row\">\n            <div class=\"col-xs-6\">\n              <strong>{{'VACATIONS_ABSENCES.REQUEST_MODAL.PART' | translate}}</strong>\n            </div>\n            <div class=\"col-xs-6\">\n              <strong>{{'GLOBALS.DATE' | translate}}</strong>\n            </div>\n          </div>\n          <div class=\"row\" ng-repeat=\"sickLeaveReport in $ctrl.reports track by $index\">\n            <div class=\"col-xs-6\">\n              <p ng-if=\"$index === 0\">{{'VACATIONS_ABSENCES.REQUEST_MODAL.LOW' | translate}}</p>\n              <p ng-if=\"$index > 0\">{{sickLeaveReport.order}}</p>\n            </div>\n            <div class=\"col-xs-6\">\n              <p>{{ sickLeaveReport.sickPartDate | slashDate }}</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"sickness-panel-write-message\">\n          <a href=\"mailto:{{$ctrl.SAE_EMAIL}}\" target=\"_blank\">{{'VACATIONS_ABSENCES.REQUEST_MODAL.WRITE_MESSAGE' | translate}}</a>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SAE_EMAIL = 'sae.es@bbva.com';
	
	var RequestFormSicknessPanelController = function RequestFormSicknessPanelController() {
	  (0, _classCallCheck3.default)(this, RequestFormSicknessPanelController);
	
	  this.SAE_EMAIL = SAE_EMAIL;
	};
	
	exports.default = RequestFormSicknessPanelController;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1396);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./requestFormSicknessPanel.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./requestFormSicknessPanel.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "request-form-sickness-panel{display:block}request-form-sickness-panel .sickness-panel-body.ng-enter{transition:all 1s cubic-bezier(.25,.46,.45,.94)}request-form-sickness-panel .sickness-panel-body.ng-enter,request-form-sickness-panel .sickness-panel-body.ng-leave.ng-leave-active{opacity:0}request-form-sickness-panel .sickness-panel-body.ng-enter.ng-enter-active,request-form-sickness-panel .sickness-panel-body.ng-leave{opacity:1}request-form-sickness-panel .sickness-panel{color:#666;border:1px solid #dddfe2;border-radius:3px}request-form-sickness-panel .sickness-panel .border-bottom{border-bottom:1px solid #dddfe2}request-form-sickness-panel .sickness-panel .sickness-panel-title{padding:7px 20px 8px;font-size:15px;color:#666;text-transform:uppercase}request-form-sickness-panel .sickness-panel .sickness-panel-more{padding:6px 0;height:30px;background-color:hsla(220,8%,92%,.5);text-align:center}request-form-sickness-panel .sickness-panel .sickness-panel-more span{cursor:pointer;color:#0072c9;display:inline-block}request-form-sickness-panel .sickness-panel .sickness-panel-more span:not(.glyphicon){font-size:13px}request-form-sickness-panel .sickness-panel .sickness-panel-more span.glyphicon{font-size:10px}request-form-sickness-panel .sickness-panel .sickness-panel-body p,request-form-sickness-panel .sickness-panel .sickness-panel-body span,request-form-sickness-panel .sickness-panel .sickness-panel-body strong{font-family:Stag Sans;font-size:12px;color:#666;text-transform:uppercase}request-form-sickness-panel .sickness-panel .sickness-panel-body strong{font-weight:500;display:inline-block;margin-right:8px}request-form-sickness-panel .sickness-panel .sickness-panel-body .sickness-panel-status{padding:19px 20px 15px}request-form-sickness-panel .sickness-panel .sickness-panel-body .sickness-panel-collegiate-number{padding:19px 20px 11px}request-form-sickness-panel .sickness-panel .sickness-panel-body .sickness-panel-list{padding:19px 20px 10px}request-form-sickness-panel .sickness-panel .sickness-panel-body .sickness-panel-list p,request-form-sickness-panel .sickness-panel .sickness-panel-body .sickness-panel-list strong{margin-bottom:5px}request-form-sickness-panel .sickness-panel .sickness-panel-body .sickness-panel-write-message{padding:8px 0;text-align:center}request-form-sickness-panel .sickness-panel .sickness-panel-body .sickness-panel-write-message a{text-decoration:none;cursor:pointer;text-transform:none;font-size:13px;color:#0072c9}request-form-sickness-panel .sickness-panel .sickness-panel-body .sickness-panel-write-message a:hover{background:#fff;text-decoration:none;color:#0072c9}", ""]);
	
	// exports


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestFormSickLeaveReports = __webpack_require__(1398);
	
	var _requestFormSickLeaveReports2 = _interopRequireDefault(_requestFormSickLeaveReports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestFormSickLeaveReportsModule = angular.module('vacations-absences.requestFormSickLeaveReports', []).component('requestFormSickLeaveReports', _requestFormSickLeaveReports2.default).name;
	
	exports.default = requestFormSickLeaveReportsModule;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestFormSickLeaveReports = __webpack_require__(1399);
	
	var _requestFormSickLeaveReports2 = _interopRequireDefault(_requestFormSickLeaveReports);
	
	var _requestFormSickLeaveReports3 = __webpack_require__(1400);
	
	var _requestFormSickLeaveReports4 = _interopRequireDefault(_requestFormSickLeaveReports3);
	
	__webpack_require__(1401);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestFormSickLeaveReportsComponent = {
	  restrict: 'E',
	  bindings: {
	    form: '<',
	    startDate: '<',
	    sickLeaveReports: '<',
	    isMobileApp: '<'
	  },
	  template: _requestFormSickLeaveReports2.default,
	  controller: _requestFormSickLeaveReports4.default
	};
	
	exports.default = requestFormSickLeaveReportsComponent;

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row request-form-sick-leave-reports-container\" ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n\n  <div ng-repeat=\"sickLeaveReport in $ctrl.sickLeaveReports\" ng-show=\"!$first\">\n    <div class=\"col-xs-6 sick-leave-report-row\">\n      <p class=\"label\">{{'VACATIONS_ABSENCES.REQUEST_MODAL.SICKNESS_LEAVE_REPORT_ID' | translate}}</p>\n      <input\n        name=\"reportOrder{{$index}}\"\n        type=\"text\"\n        class=\"text-center\"\n        ng-required=\"!$first\"\n        ng-maxlength=\"2\"\n        ng-model=\"sickLeaveReport.order\"\n        ng-disabled=\"sickLeaveReport.disabled\"\n        ng-change=\"$ctrl.validateReportOrder($ctrl.form['reportOrder' + $index], sickLeaveReport.order)\">\n    </div>\n    <div class=\"col-xs-6 sick-leave-report-row\">\n      <input-datepicker\n        is-mobile-app=\"$ctrl.isMobileApp\"\n        name=\"sicknessLeaveReport{{$index}}\"\n        start-date=\"sickLeaveReport.date\"\n        class=\"pull-right\"\n        on-datepick=\"$ctrl.setLeaveReportDate($event, $ctrl.form['sicknessLeaveReport' + $index], sickLeaveReport);\"\n        label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.SICKNESS_START_DATE' | translate}}\"\n        disabled=\"sickLeaveReport.disabled\"\n        disable-before-start-date=\"true\"></input-datepicker>\n    </div>\n  </div>\n\n  <div class=\"text-center\">\n    <a\n      class=\"sick-leave-report-add\"\n      href=\"\"\n      ng-click=\"$ctrl.addSickLeaveReport($ctrl.sickLeaveReports);\">\n      <span ng-class=\"$ctrl.getIconClass()\"></span>{{ 'VACATIONS_ABSENCES.REQUEST_MODAL.ADD_NEW_REPORTS' | translate }}\n    </a>\n  </div>\n</div>\n"

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestFormSickLeaveReportsController = function () {
	  RequestFormSickLeaveReportsController.$inject = ["$timeout", "$rootScope", "floatingActionButtonsService"];
	  function RequestFormSickLeaveReportsController($timeout, $rootScope, floatingActionButtonsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, RequestFormSickLeaveReportsController);
	    this.timeout = $timeout;
	    this.rootScope = $rootScope;
	    this.onlyNumbersPattern = new RegExp('^[0-9]*$');
	    this.floatingActionButtonsService = floatingActionButtonsService;
	  }
	
	  (0, _createClass3.default)(RequestFormSickLeaveReportsController, [{
	    key: '_getNextOrder',
	    value: function _getNextOrder() {
	      var orders = _lodash2.default.map(this.sickLeaveReports, 'order');
	      orders = _lodash2.default.map(orders, Number);
	      return _lodash2.default.max(orders) + 1;
	    }
	  }, {
	    key: 'addSickLeaveReport',
	    value: function addSickLeaveReport(sickLeaveReports) {
	      var _this = this;
	
	      this.timeout(function () {
	        _this.floatingActionButtonsService.run();
	      });
	      var order = this._getNextOrder();
	      var date = this.getSickLeaveReportDate();
	      var sickPartDate = date; // View purposes
	      var disabled = false;
	      sickLeaveReports.push({ order: order, date: date, sickPartDate: sickPartDate, disabled: disabled });
	      this._validateReportDate(date);
	      this._medicalPartAdded();
	    }
	  }, {
	    key: '_medicalPartAdded',
	    value: function _medicalPartAdded() {
	      this.rootScope.$broadcast(_constants.EVENTS.BUTTON_SICK_LEAVE_REPORTS_DISABLED, {});
	    }
	
	    /**
	     * If we're trying to create a report on the same date that the sick date, force to create it the
	     * next day at least.
	     */
	
	  }, {
	    key: 'getSickLeaveReportDate',
	    value: function getSickLeaveReportDate() {
	      return this.startDate;
	    }
	  }, {
	    key: 'getIconClass',
	    value: function getIconClass() {
	      return {
	        'glyphicon glyphicon-plus-sign': !this.isMobileApp,
	        'icon icon-plus-circle-big': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'validateReportOrder',
	    value: function validateReportOrder(input, order) {
	      var orderNumber = parseInt(order, 10);
	      var notDuplicated = this.reportOrderNotDuplicated(orderNumber);
	      var validNumber = this.onlyNumbersPattern.test(order);
	      var gtzero = orderNumber > 0;
	      var valid = notDuplicated && validNumber && gtzero;
	      input.$setValidity(_constants.VALIDATION_ERRORS.SICK_LEAVE_REPORTS.INVALID_ORDER, valid);
	      input.$setDirty();
	    }
	  }, {
	    key: 'reportOrderNotDuplicated',
	    value: function reportOrderNotDuplicated(order) {
	      return this.sickLeaveReports.find(function (report) {
	        return report.order === order;
	      }) === undefined;
	    }
	  }, {
	    key: '_validateReportDate',
	    value: function _validateReportDate(date) {
	      var _this2 = this;
	
	      var form = this.form;
	      var formPosition = this.sickLeaveReports.length - 1;
	
	      this.timeout(function () {
	        var input = form['sicknessLeaveReport' + formPosition];
	        var sickDate = _this2.getSickDate();
	        var valid = date > sickDate;
	        input.$setValidity(_constants.VALIDATION_ERRORS.SICK_LEAVE_REPORTS.INVALID_DATE, valid);
	        input.$setDirty();
	      });
	    }
	
	    /**
	     * When change some datepicker, set the date to the report, but also if is at least greater than
	     * sick date. Also, refresh view.
	     */
	
	  }, {
	    key: 'setLeaveReportDate',
	    value: function setLeaveReportDate($event, input, report) {
	      var sickDate = this.getSickDate();
	      var valid = $event.date > sickDate;
	      input.$setValidity(_constants.VALIDATION_ERRORS.SICK_LEAVE_REPORTS.INVALID_DATE, valid);
	      report.date = $event.date;
	      report.sickPartDate = $event.date; // View purposes
	    }
	
	    /**
	     * The sick date is always the date of the first part, because is the first one created.
	     */
	
	  }, {
	    key: 'getSickDate',
	    value: function getSickDate() {
	      var originalSickReport = this.sickLeaveReports[0];
	      return new Date(originalSickReport.absenceDate);
	    }
	  }]);
	  return RequestFormSickLeaveReportsController;
	}();
	
	exports.default = RequestFormSickLeaveReportsController;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1402);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./requestFormSickLeaveReports.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./requestFormSickLeaveReports.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "request-form-sick-leave-reports .request-form-sick-leave-reports-container.responsiveMobile .icon{display:inline-block;margin-right:10px}request-form-sick-leave-reports .request-form-sick-leave-reports-container .sick-leave-report-row{margin-bottom:24px}request-form-sick-leave-reports .request-form-sick-leave-reports-container .sick-leave-report-add{font-size:15px;color:#0072c9;margin-top:27px;display:inline-block;margin-bottom:14px}request-form-sick-leave-reports .request-form-sick-leave-reports-container .sick-leave-report-add:focus,request-form-sick-leave-reports .request-form-sick-leave-reports-container .sick-leave-report-add:hover{color:#0072c9;background:#fff;text-decoration:none}request-form-sick-leave-reports .request-form-sick-leave-reports-container .sick-leave-report-add .glyphicon{display:inline-block;margin-right:8px}", ""]);
	
	// exports


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sickLeaveQuestion = __webpack_require__(1404);
	
	var _sickLeaveQuestion2 = _interopRequireDefault(_sickLeaveQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sickLeaveQuestionModule = angular.module('vacations-absences.sickLeaveQuestion', []).component('sickLeaveQuestion', _sickLeaveQuestion2.default).name;
	
	exports.default = sickLeaveQuestionModule;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sickLeaveQuestion = __webpack_require__(1405);
	
	var _sickLeaveQuestion2 = _interopRequireDefault(_sickLeaveQuestion);
	
	var _sickLeaveQuestion3 = __webpack_require__(1406);
	
	var _sickLeaveQuestion4 = _interopRequireDefault(_sickLeaveQuestion3);
	
	__webpack_require__(1407);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sickLeaveQuestionComponent = {
	  restrict: 'E',
	  bindings: {
	    modalId: '@',
	    onSelection: '&',
	    isMobileApp: '<'
	  },
	  template: _sickLeaveQuestion2.default,
	  controller: _sickLeaveQuestion4.default
	};
	
	exports.default = sickLeaveQuestionComponent;

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-header\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\" id=\"{{$ctrl.modalId}}Label\">{{\"VACATIONS_ABSENCES.SICK_LEAVE_QUESTION.TITLE\" | translate }}</h4>\n  </div>\n  <div class=\"modal-footer row\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-one btn-primary\"\n      ng-click=\"$ctrl.continueSickness()\">{{\"VACATIONS_ABSENCES.SICK_LEAVE_QUESTION.BUTTON_CONFIRMATION_PART\" | translate }}</button>\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-two btn-primary\"\n      ng-click=\"$ctrl.cancelSickness()\">{{\"VACATIONS_ABSENCES.SICK_LEAVE_QUESTION.BUTTON_SICK_LEAVE_PART\" | translate }}</button>\n  </div>\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.continueSickness()\"\n    on-click-second-button=\"$ctrl.cancelSickness()\">\n  </floating-action-buttons>\n</div>\n"

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SickLeaveQuestionController = function () {
	  SickLeaveQuestionController.$inject = ["EventEmitter"];
	  function SickLeaveQuestionController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SickLeaveQuestionController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(SickLeaveQuestionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'VACATIONS_ABSENCES.SICK_LEAVE_QUESTION.BUTTON_CONFIRMATION_PART'
	      }, {
	        literal: 'VACATIONS_ABSENCES.SICK_LEAVE_QUESTION.BUTTON_SICK_LEAVE_PART'
	      }];
	    }
	  }, {
	    key: 'continueSickness',
	    value: function continueSickness() {
	      this.choose(_constants.ANSWERS.YES);
	    }
	  }, {
	    key: 'cancelSickness',
	    value: function cancelSickness() {
	      this.choose(_constants.ANSWERS.NO);
	    }
	  }, {
	    key: 'choose',
	    value: function choose(answer) {
	      this.onSelection(this.EventEmitter({ answer: answer }));
	    }
	  }]);
	  return SickLeaveQuestionController;
	}();
	
	exports.default = SickLeaveQuestionController;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1408);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./sickLeaveQuestion.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./sickLeaveQuestion.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "sick-leave-question .modal-content{padding-top:58px}sick-leave-question .modal-content.responsiveMobile{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;padding:43px 75px 200px}sick-leave-question .modal-content.responsiveMobile .modal-header h4{font-size:23px}sick-leave-question .modal-content.responsiveMobile floating-action-buttons .two-buttons .btn{font-size:15px}sick-leave-question .modal-content .modal-header{border-bottom:1px solid #dddfe2}sick-leave-question .modal-content .modal-header .icon-interrogation{color:#0072c9;display:block;font-size:77px;height:76px;margin:0 auto 22px;width:76px}sick-leave-question .modal-content .modal-header h4{color:#0072c9;padding-bottom:10px;margin-top:-1px}sick-leave-question .modal-content .modal-body{padding-top:17px;text-align:center}sick-leave-question .modal-content .modal-body .description{color:#666;font-family:ArialMT;font-size:15px;line-height:1.4;margin:0 auto 29px;margin-bottom:31px;max-width:200px}sick-leave-question .modal-content .modal-footer{margin-top:53px;text-align:center}sick-leave-question .modal-content .modal-footer .btn{float:left;height:48px;line-height:38px;margin-left:14px;width:160px}sick-leave-question .modal-content .modal-footer .btn-one{float:left;height:47px;line-height:38px;margin-right:14px;padding-left:.8px;padding-top:2px;width:160px}sick-leave-question .modal-content .modal-footer .btn-two{float:right;height:47px;line-height:38px;margin-right:13px;padding-top:1.5px;width:160px}", ""]);
	
	// exports


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalCalendarGrid = __webpack_require__(1410);
	
	var _modalCalendarGrid2 = _interopRequireDefault(_modalCalendarGrid);
	
	var _modalCalendarGrid3 = __webpack_require__(1415);
	
	var _modalCalendarGrid4 = _interopRequireDefault(_modalCalendarGrid3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCalendarGridModule = angular.module('vacations-absences.modalCalendarGrid', []).component('modalCalendarGrid', _modalCalendarGrid2.default).service('modalCalendarGridService', _modalCalendarGrid4.default).name;
	
	exports.default = modalCalendarGridModule;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalCalendarGrid = __webpack_require__(1411);
	
	var _modalCalendarGrid2 = _interopRequireDefault(_modalCalendarGrid);
	
	var _modalCalendarGrid3 = __webpack_require__(1412);
	
	var _modalCalendarGrid4 = _interopRequireDefault(_modalCalendarGrid3);
	
	__webpack_require__(1413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCalendarGridComponent = {
	  restrict: 'E',
	  bindings: {
	    userId: '<',
	    userInceptionId: '<',
	    onDismiss: '&',
	    isInception: '<'
	  },
	  template: _modalCalendarGrid2.default,
	  controller: _modalCalendarGrid4.default
	};
	
	exports.default = modalCalendarGridComponent;

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalCalendarGrid\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"modalCalendarGridLabel\">\n\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <div class=\"modal-content\">\n      <div class=\"modal-header text-left\">\n        <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span\n          class=\"icon-cross\"></span></button>\n        <h4 class=\"modal-title\" id=\"modalCalendarGridLabel\">{{ 'VACATIONS_ABSENCES.VACATIONSBOX' | translate }}</h4>\n      </div>\n\n      <div class=\"modal-body\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\" ng-if=\"$ctrl.loaded\">\n            <calendar-grid\n              user=\"$ctrl.scheduleData\"\n              loaded=\"$ctrl.loaded\"\n              is-desktop=\"true\"\n              date-today=\"$ctrl.dateToday\"\n              ></calendar-grid>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-app btn-primary pull-right\" ng-click=\"$ctrl.print();\">\n          {{ 'VACATIONS_ABSENCES.PRINT' | translate }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _periods = __webpack_require__(1359);
	
	var _periods2 = _interopRequireDefault(_periods);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalCalendarGridController = function () {
	  ModalCalendarGridController.$inject = ["$window", "modalCalendarGridService", "vacationUserDataService"];
	  function ModalCalendarGridController($window, modalCalendarGridService, vacationUserDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalCalendarGridController);
	    this.window = $window;
	    this.modalCalendarGridService = modalCalendarGridService;
	    this.UserDataService = vacationUserDataService;
	    this.loaded = false;
	    this.dateToday = new Date();
	  }
	
	  (0, _createClass3.default)(ModalCalendarGridController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var userId = this.userInceptionId || this.userId;
	      var managerId = this.UserDataService._employee.userId;
	      this.scheduleData = {};
	      this.modalCalendarGridService.getRequestModalPeriods(userId, this.isInception, managerId).then(function (response) {
	        _this.scheduleData.vacationPeriods = response.data;
	        _this.scheduleData.absencePeriods = [];
	        _this.scheduleData.periodInDays = _periods2.default.formatPeriodInDays(_this.scheduleData.vacationPeriods);
	        _this.loaded = true;
	      });
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      var _this2 = this;
	
	      var modalId = _constants.MODALS.CALENDAR_GRID.slice(1);
	      this.modal = document.getElementById(modalId);
	      this.body = document.getElementsByTagName('body')[0];
	      this.initPrintEvents();
	
	      $(_constants.MODALS.CALENDAR_GRID).on('hidden.bs.modal', function () {
	        return _this2.onDismiss();
	      });
	    }
	  }, {
	    key: 'initPrintEvents',
	    value: function initPrintEvents() {
	      var _this3 = this;
	
	      var beforePrint = function beforePrint() {
	        if (_this3.visible(_this3.modal)) {
	          _this3.body.classList.add('printing-calendar-grid');
	        }
	      };
	
	      var afterPrint = function afterPrint() {
	        if (_this3.visible(_this3.modal)) {
	          _this3.body.classList.remove('printing-calendar-grid');
	        }
	      };
	
	      if (this.window.matchMedia) {
	        var mediaQueryList = this.window.matchMedia('print');
	        mediaQueryList.addListener(function (mql) {
	          if (mql.matches) {
	            beforePrint();
	          } else {
	            afterPrint();
	          }
	        });
	      }
	
	      this.window.onbeforeprint = beforePrint;
	      this.window.onafterprint = afterPrint;
	    }
	  }, {
	    key: 'print',
	    value: function print() {
	      this.window.print();
	    }
	  }, {
	    key: 'visible',
	    value: function visible(elem) {
	      return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
	    }
	  }]);
	  return ModalCalendarGridController;
	}();
	
	exports.default = ModalCalendarGridController;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1414);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./modalCalendarGrid.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./modalCalendarGrid.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "@media print{modal-calendar-grid .modal{background:#fff!important;position:relative}}modal-calendar-grid calendar{pointer-events:none!important}modal-calendar-grid .modal-dialog{width:914px}@media print{modal-calendar-grid .modal-dialog{border:0!important;overflow:hidden;margin:0;width:100%}}modal-calendar-grid .modal-dialog .modal-content{padding:50px 85px;border-radius:4px!important}@media print{modal-calendar-grid .modal-dialog .modal-content{box-shadow:none!important;border:0!important;padding:0 20px!important}}modal-calendar-grid .modal-dialog .modal-header{border:none;padding-bottom:20px}@media print{modal-calendar-grid .modal-dialog .modal-header{padding-bottom:0!important}modal-calendar-grid .modal-dialog .modal-header h4{padding-bottom:0;font-size:20px}}@media print{modal-calendar-grid .modal-dialog .modal-footer{display:none!important}}modal-calendar-grid .modal-dialog .modal-footer .btn{height:37px;line-height:37px;width:150px}", ""]);
	
	// exports


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vacationsAbsences = __webpack_require__(1120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCalendarGridService = function () {
	  modalCalendarGridService.$inject = ["$http"];
	  function modalCalendarGridService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, modalCalendarGridService);
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(modalCalendarGridService, [{
	    key: 'getRequestModalPeriods',
	    value: function getRequestModalPeriods(employeeId, isInception, managerId) {
	      if (isInception) {
	        return this.http.get(_vacationsAbsences.ENDPOINTS_MANAGER.get.schedule(employeeId, managerId));
	      }
	      return this.http.get(_vacationsAbsences.ENDPOINTS_EMPLOYEE.get.schedule(employeeId));
	    }
	  }]);
	  return modalCalendarGridService;
	}();
	
	exports.default = modalCalendarGridService;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalRemovePeriod = __webpack_require__(1417);
	
	var _modalRemovePeriod2 = _interopRequireDefault(_modalRemovePeriod);
	
	var _removePeriod = __webpack_require__(1422);
	
	var _removePeriod2 = _interopRequireDefault(_removePeriod);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalRemovePeriodModule = angular.module('vacations-absences.modalRemovePeriod', [_removePeriod2.default]).component('modalRemovePeriod', _modalRemovePeriod2.default).name;
	
	exports.default = modalRemovePeriodModule;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalRemovePeriod = __webpack_require__(1418);
	
	var _modalRemovePeriod2 = _interopRequireDefault(_modalRemovePeriod);
	
	var _modalRemovePeriod3 = __webpack_require__(1419);
	
	var _modalRemovePeriod4 = _interopRequireDefault(_modalRemovePeriod3);
	
	__webpack_require__(1420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalRemovePeriodComponent = {
	  restrict: 'E',
	  bindings: {
	    userId: '<',
	    userInceptionId: '<',
	    isInception: '<',
	    onRemove: '&',
	    isMobileApp: '<'
	  },
	  template: _modalRemovePeriod2.default,
	  controller: _modalRemovePeriod4.default
	};
	
	exports.default = modalRemovePeriodComponent;

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\"\n     id=\"modalRemovePeriod\"\n     tabindex=\"-1\"\n     role=\"dialog\"\n     aria-labelledby=\"removePeriodModalLabel\"\n     ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <remove-period\n      ng-if=\"$ctrl.startRemoving()\"\n      user-id=\"$ctrl.userId\"\n      user-inception-id=\"$ctrl.userInceptionId\"\n      is-inception=\"$ctrl.isInception\"\n      modal-id=\"modal-del-holidays\"\n      on-remove=\"$ctrl.onSelection($event)\"\n      on-error=\"$ctrl.requestError($event)\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </remove-period>\n\n    <successful-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.requestIsSuccessful()\"\n      close-modal=\"true\"\n      modal-id=\"modal-del-holidays-success\"\n      on-click=\"$ctrl.onRemoveOnClickSuccess()\"\n      on-dismiss=\"$ctrl.onDismiss()\">\n    </successful-action>\n\n    <failed-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.requestIsFailed()\"\n      title=\"{{ 'GLOBALS.ATTENTION' | translate }}\"\n      description=\"{{ $ctrl.errorRequestMessage }}\"\n      close-modal=\"true\"\n      modal-id=\"modal-del-holidays-failed\"\n      button-text=\"{{ 'GLOBALS.BUTTON_ACTION.OK_GOT_IT' | translate }}\"\n      on-dismiss=\"$ctrl.onDismiss()\">\n    </failed-action>\n\n  </div>\n</div>\n"

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalRemovePeriodController = function () {
	  ModalRemovePeriodController.$inject = ["$translate", "$scope", "EventEmitter"];
	  function ModalRemovePeriodController($translate, $scope, EventEmitter) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ModalRemovePeriodController);
	    this.scope = $scope;
	    this.translate = $translate;
	    this.EventEmitter = EventEmitter;
	
	    this._translate();
	    this.scope.$on(_constants.EVENTS.CONTEXT_MENU_REMOVE, function () {
	      return _this.openModal();
	    });
	  }
	
	  (0, _createClass3.default)(ModalRemovePeriodController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.modal.on('hidden.bs.modal', function () {
	        return _this2.resetFlags();
	      });
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this3 = this;
	
	      this.translate('VACATIONS_ABSENCES.DELETE_HOLIDAYS_APPROVED.SUCCESS_ACTION.TITLE').then(function (translation) {
	        _this3.SUCCESS_TITLE = translation;
	      });
	
	      this.translate('VACATIONS_ABSENCES.DELETE_HOLIDAYS_APPROVED.SUCCESS_ACTION.DESCRIPTION').then(function (translation) {
	        _this3.SUCCESS_DESCRIPTION = translation;
	      });
	
	      this.translate('GLOBALS.BUTTON_ACTION.OK').then(function (translation) {
	        _this3.SUCCESS_BUTTON = translation;
	      });
	
	      this.translate('VACATIONS_ABSENCES.MODAL_REQUEST_HOLIDAY.ERROR_1').then(function (translation) {
	        _this3.errorMsg = translation;
	      });
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'startRemoving',
	    value: function startRemoving() {
	      return this.success === undefined && this.error === undefined;
	    }
	  }, {
	    key: 'requestIsSuccessful',
	    value: function requestIsSuccessful() {
	      return this.success === true;
	    }
	  }, {
	    key: 'requestIsFailed',
	    value: function requestIsFailed() {
	      return this.error === true;
	    }
	  }, {
	    key: 'requestSuccess',
	    value: function requestSuccess() {
	      this.success = true;
	    }
	  }, {
	    key: 'requestError',
	    value: function requestError($event) {
	      try {
	        this.errorRequestMessage = $event.data.message;
	      } catch (err) {
	        this.errorRequestMessage = this.errorMsg;
	      }
	
	      this.error = true;
	    }
	  }, {
	    key: 'onSelection',
	    value: function onSelection(_ref) {
	      var status = _ref.status,
	          startDate = _ref.startDate,
	          endDate = _ref.endDate;
	
	      if (status === _constants.STATUS_CODE_OK) {
	
	        var response = this.EventEmitter({ status: status, startDate: startDate, endDate: endDate });
	        this.response = response;
	        this.requestSuccess();
	
	        if (!this.isMobileApp) {
	          this.onRemove(response);
	        }
	      } else {
	        this.requestError();
	      }
	    }
	  }, {
	    key: 'onRemoveOnClickSuccess',
	    value: function onRemoveOnClickSuccess() {
	      this.onRemove(this.response);
	    }
	  }, {
	    key: 'onDismiss',
	    value: function onDismiss() {
	      this.closeModal();
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'resetFlags',
	    value: function resetFlags() {
	      this.success = undefined;
	      this.error = undefined;
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return angular.element(_constants.MODALS.REMOVE_PERIOD);
	    }
	  }]);
	  return ModalRemovePeriodController;
	}();
	
	exports.default = ModalRemovePeriodController;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1421);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./modalRemovePeriod.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./modalRemovePeriod.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-remove-period .responsiveMobile .modal-dialog{max-height:none;max-width:none}modal-remove-period .modal-dialog{max-height:410px;max-width:520px}", ""]);
	
	// exports


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _removePeriod = __webpack_require__(1423);
	
	var _removePeriod2 = _interopRequireDefault(_removePeriod);
	
	var _removePeriodService = __webpack_require__(1428);
	
	var _removePeriodService2 = _interopRequireDefault(_removePeriodService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var removePeriodModule = angular.module('vacations-absences.removePeriod', []).service('RemovePeriodService', _removePeriodService2.default).component('removePeriod', _removePeriod2.default).name;
	
	exports.default = removePeriodModule;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _removePeriod = __webpack_require__(1424);
	
	var _removePeriod2 = _interopRequireDefault(_removePeriod);
	
	var _removePeriod3 = __webpack_require__(1425);
	
	var _removePeriod4 = _interopRequireDefault(_removePeriod3);
	
	__webpack_require__(1426);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var removePeriodComponent = {
	  restrict: 'E',
	  bindings: {
	    modalId: '@',
	    onRemove: '&',
	    onError: '&',
	    userId: '<',
	    userInceptionId: '<',
	    isInception: '<',
	    isMobileApp: '<'
	  },
	  template: _removePeriod2.default,
	  controller: _removePeriod4.default
	};
	
	exports.default = removePeriodComponent;

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n\n  <div class=\"modal-header\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\" id=\"{{$ctrl.modalId}}Label\">\n      {{ 'VACATIONS_ABSENCES.DELETE_HOLIDAYS_APPROVED.TITLE' | translate }}\n    </h4>\n  </div>\n\n  <div class=\"modal-body\">\n\n    <div class=\"body-header\">\n      <p>\n        {{$ctrl.type | translate}} {{$ctrl.availableDayType | translate}} - {{$ctrl.category | capitalizeFirst}}\n      </p>\n      <p ng-if=\"!$ctrl.isHourly\">\n        {{$ctrl.startDate| date :\"dd\"}} {{$ctrl.startDate| date :\"MMMM\"}} - {{$ctrl.endDate| date :\"dd\"}} {{$ctrl.endDate| date :\"MMMM\"}}  ({{$ctrl.numberDays}} {{\"GLOBALS.DAYS\" | translate}})\n      </p>\n      <p ng-if=\"$ctrl.isHourly\">\n        {{$ctrl.startDate| date :\"dd\"}} {{$ctrl.startDate| date :\"MMMM\"}} -  ({{$ctrl.hours}} {{\"GLOBALS.HOURS\" | translate}})\n      </p>\n    </div>\n\n    <form-errors-summary\n      ng-if=\"$ctrl.form.$invalid\"\n      errors=\"$ctrl.errors\">\n    </form-errors-summary>\n\n  </div>\n\n  <div class=\"modal-footer row\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-one btn-primary\"\n      data-dismiss=\"modal\">{{\"GLOBALS.BUTTON_ACTION.CANCEL\" | translate}}</button>\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-two btn-primary\"\n      ng-disabled=\"$ctrl.form.$invalid\"\n      ng-click=\"$ctrl.submit()\" >{{\"GLOBALS.BUTTON_ACTION.REMOVE\" | translate}}</button>\n  </div>\n\n  <floating-action-buttons\n      ng-if=\"$ctrl.isMobileApp\"\n      buttons=\"$ctrl.floatingActionButtons\"\n      on-click-first-button=\"$ctrl.submit()\"\n      on-click-second-button=\"$ctrl.onCancel()\">\n  </floating-action-buttons>\n\n</div>\n"

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _request = __webpack_require__(1114);
	
	var _availableDayTypes = __webpack_require__(1145);
	
	var _constants = __webpack_require__(598);
	
	var _dateUtils = __webpack_require__(1132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var removePeriodController = function () {
	  removePeriodController.$inject = ["EventEmitter", "$scope", "RemovePeriodService", "$translate", "AuthenticationService", "vacationUserDataService", "loadingMobileService"];
	  function removePeriodController(EventEmitter, $scope, RemovePeriodService, $translate, AuthenticationService, vacationUserDataService, loadingMobileService) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, removePeriodController);
	    this.scope = $scope;
	    this.RemovePeriodService = RemovePeriodService;
	    this.EventEmitter = EventEmitter;
	    this.$translate = $translate;
	    this.AuthenticationService = AuthenticationService;
	    this.vacationUserDataService = vacationUserDataService;
	    this.loadingMobileService = loadingMobileService;
	    this.userId = this.AuthenticationService.getEmployeeId();
	    this.errors = [];
	
	    this.scope.$on(_constants.EVENTS.CONTEXT_MENU_REMOVE, function (event, args) {
	      _this.setData(args.dayClicked, args.dateDayClicked, args.period);
	    });
	
	    this.$translate('VACATIONS_ABSENCES.VALIDATION_ERRORS.REMOVE_REASON_MAX_LENGTH').then(function (translation) {
	      _this.errors.push(translation);
	    });
	  }
	
	  (0, _createClass3.default)(removePeriodController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.REMOVE'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }, {
	    key: 'daysInMonth',
	    value: function daysInMonth(month, year) {
	      return new Date(year, month, 0).getDate();
	    }
	  }, {
	    key: 'setData',
	    value: function setData(dayClicked, dateDayClicked, period) {
	      this.startDate = (0, _dateUtils.parseLocalDate)(period.startDate);
	      this.endDate = period.endDate === null ? null : (0, _dateUtils.parseLocalDate)(period.endDate);
	
	      this.type = _request.Request.getTranslation(period.type);
	      this.availableDayType = _availableDayTypes.AvailableDay.getTranslation(period.availableDayType);
	      this.category = period.category;
	      this.code = period.code;
	      this.numberDays = period.maximumDuration;
	
	      if (_request.Request.isHourly(period)) {
	        this.isHourly = true;
	        this.hours = period.hours;
	      } else {
	        this.isHourly = false;
	        delete this.hours;
	      }
	    }
	  }, {
	    key: 'getRequest',
	    value: function getRequest() {
	      var startDate = this.startDate;
	      var endDate = this.endDate;
	      var periodCode = this.code;
	      return { startDate: startDate, endDate: endDate, periodCode: periodCode };
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.loadingMobileService.show();
	
	      var request = this.getRequest();
	      var managerId = this.vacationUserDataService._employee.userId;
	      var userId = this.userInceptionId || this.userId;
	      this.RemovePeriodService.removeRequest(userId, request, this.isInception, managerId).then(function (response) {
	        var $event = _this2.EventEmitter({ status: response.status, startDate: request.startDate, endDate: request.endDate });
	        _this2.onRemove($event);
	      }, function (response) {
	        _this2.onError(_this2.EventEmitter(response));
	      }).finally(function () {
	        return _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'onCancel',
	    value: function onCancel() {
	      $('.modal').modal('hide');
	    }
	  }]);
	  return removePeriodController;
	}();
	
	exports.default = removePeriodController;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1427);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./removePeriod.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./removePeriod.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "remove-period .modal-content{padding-top:58px}remove-period .modal-content.responsiveMobile{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}remove-period .modal-content.responsiveMobile .modal-header{max-width:none}remove-period .modal-content .modal-header{border-bottom:1px solid #dddfe2;max-width:380px}remove-period .modal-content .modal-header .icon-interrogation{color:#0072c9;display:block;font-size:77px;height:76px;margin:0 auto 22px;margin-bottom:26px;width:76px}remove-period .modal-content .modal-header h4{color:#0072c9;margin-left:-18px;padding-bottom:10px;width:110%}remove-period .modal-content .modal-body{padding-top:17px}remove-period .modal-content .modal-body .body-header{border-bottom:1px solid #dddfe2;color:#666;margin-bottom:24px;padding-bottom:16px;padding-top:1px;text-align:center}remove-period .modal-content .modal-body .body-header p{font-family:ArialMT;font-size:15px;line-height:1.3;margin:0}remove-period .modal-content .modal-body .textarea-description{margin-bottom:7px}remove-period .modal-content .modal-body textarea{border-color:#dddfe2;box-shadow:0 2px 4px 0 #dddfe2,0 -1px 4px 0 #dddfe2;color:#666;font-family:Stag Sans;font-style:italic;height:135.3px;margin-left:-1px;padding-left:20px;padding-right:26px;padding-top:9.2px;resize:none;width:100%}remove-period .modal-content .modal-body textarea::-moz-placeholder{color:#aeaeae;opacity:1}remove-period .modal-content .modal-body textarea:-ms-input-placeholder{color:#aeaeae}remove-period .modal-content .modal-body textarea::-webkit-input-placeholder{color:#aeaeae}remove-period .modal-content .modal-body textarea:focus{outline:none}remove-period .modal-content .modal-body span:not(.icon-warning){color:#666;font-family:Stag Sans;font-size:13px;font-style:normal}remove-period .modal-content .modal-body .light{color:#666;font-size:13px;font-weight:300}remove-period .modal-content .modal-body .description{color:#666;font-family:ArialMT;font-size:15px;line-height:1.4;margin:0 auto 29px;margin-bottom:31px;max-width:200px}remove-period .modal-content .modal-footer{margin-top:35px;text-align:center}remove-period .modal-content .modal-footer .btn{float:left;height:48px;line-height:38px;margin-left:14px;width:160px}remove-period .modal-content .modal-footer .btn-one{background-color:#f9f9f9;border-color:#dddfe2;color:#0072c9;float:left;height:48px;line-height:38px;margin-right:14px;padding-left:1px;padding-top:1px;width:160px}remove-period .modal-content .modal-footer .btn-two{float:right;height:48px;line-height:38px;margin-right:16px;padding-top:3px;width:160px}", ""]);
	
	// exports


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _dateUtils = __webpack_require__(1132);
	
	var _vacationsAbsences = __webpack_require__(1120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemovePeriodService = function () {
	  RemovePeriodService.$inject = ["$http"];
	  function RemovePeriodService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, RemovePeriodService);
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(RemovePeriodService, [{
	    key: 'removeRequest',
	    value: function removeRequest(employeeId, request, isInception, managerId) {
	      var endDate = request.endDate === null ? null : (0, _dateUtils.formatDate)(request.endDate);
	      var config = {
	        data: {
	          startDate: (0, _dateUtils.formatDate)(request.startDate),
	          endDate: endDate,
	          code: request.periodCode,
	          remarks: request.remarks
	        }
	      };
	
	      if (isInception) {
	        return this.http.delete(_vacationsAbsences.ENDPOINTS_MANAGER.delete.request(employeeId, managerId), config);
	      } else {
	        return this.http.delete(_vacationsAbsences.ENDPOINTS_EMPLOYEE.delete.request(employeeId), config);
	      }
	    }
	  }]);
	  return RemovePeriodService;
	}();
	
	exports.default = RemovePeriodService;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warningRequestVacation = __webpack_require__(1430);
	
	var _warningRequestVacation2 = _interopRequireDefault(_warningRequestVacation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warningRequestVacationModule = angular.module('vacations-absences.warningRequestVacation', []).component('warningRequestVacation', _warningRequestVacation2.default).name;
	
	exports.default = warningRequestVacationModule;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warningRequestVacation = __webpack_require__(1431);
	
	var _warningRequestVacation2 = _interopRequireDefault(_warningRequestVacation);
	
	var _warningRequestVacation3 = __webpack_require__(1432);
	
	var _warningRequestVacation4 = _interopRequireDefault(_warningRequestVacation3);
	
	__webpack_require__(1433);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warningRequestVacationComponent = {
	  restrict: 'E',
	  bindings: {
	    date: '<',
	    onDismiss: '&',
	    isMobileApp: '<'
	  },
	  template: _warningRequestVacation2.default,
	  controller: _warningRequestVacation4.default
	};
	
	exports.default = warningRequestVacationComponent;

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"warningRequestVacation\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"warningRequestVacationLabel\" ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <div class=\"modal-content\">\n\n      <div class=\"modal-header\">\n        <span class=\"icon-warning\"></span>\n        <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\" ng-click=\"$ctrl.dismissModal()\"><span\n          class=\"icon-cross\"></span></button>\n        <h4 class=\"modal-title\" id=\"warningRequestVacationLabel\">\n          {{\"VACATIONS_ABSENCES.WARNING_REQUEST_VACATION.TITLE\" | translate }}\n        </h4>\n      </div>\n\n      <div class=\"modal-body\">\n        <div class=\"firs-paragraph\">\n          <span>{{\"VACATIONS_ABSENCES.WARNING_REQUEST_VACATION.BODY_LINE_ONE\" | translate }}</span><br>\n          <span>{{\"VACATIONS_ABSENCES.WARNING_REQUEST_VACATION.BODY_LINE_TWO\" | translate }}{{$ctrl.date}}</span><br>\n        </div>\n        <div class=\"second-paragraph\">\n          <span>{{\"VACATIONS_ABSENCES.WARNING_REQUEST_VACATION.NOTICE_LINE_ONE\" | translate }}</span><br>\n          <span>{{\"VACATIONS_ABSENCES.WARNING_REQUEST_VACATION.NOTICE_LINE_TWO\" | translate }}</span>\n        </div>\n      </div>\n\n      <floating-action-buttons\n        buttons=\"$ctrl.floatingActionButtons\"\n        on-click-first-button=\"$ctrl.openVacationLink()\">\n      </floating-action-buttons>\n     </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WarningRequestVacationController = function () {
	  WarningRequestVacationController.$inject = ["$state", "$window"];
	  function WarningRequestVacationController($state, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WarningRequestVacationController);
	    this.state = $state;
	    this.isMobileApp = $window.innerWidth < 1024;
	  }
	
	  (0, _createClass3.default)(WarningRequestVacationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modal = angular.element(_constants.MODALS.WARNING_REQUEST_VACATION);
	      this.floatingActionButtons = this.getFloatingActionButtons();
	    }
	  }, {
	    key: 'openVacationModal',
	    value: function openVacationModal() {
	      this.vacationModal = angular.element(_constants.MODALS.VACATION);
	      this.vacationModal.modal('show');
	      this.dismissModal();
	    }
	  }, {
	    key: 'openVacationLink',
	    value: function openVacationLink() {
	      this.isMobileApp ? this.goToScheduleMobile() : this.openVacationModal();
	    }
	  }, {
	    key: 'hideModal',
	    value: function hideModal() {
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'dismissModal',
	    value: function dismissModal() {
	      this.hideModal();
	      this.onDismiss();
	    }
	  }, {
	    key: 'goToScheduleMobile',
	    value: function goToScheduleMobile() {
	      this.hideModal();
	      this.state.go(_states.STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE);
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'VACATIONS_ABSENCES.WARNING_REQUEST_VACATION.BUTTON'
	      }];
	    }
	  }]);
	  return WarningRequestVacationController;
	}();
	
	exports.default = WarningRequestVacationController;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1434);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./warningRequestVacation.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./warningRequestVacation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "warning-request-vacation .modal{padding-right:0!important}warning-request-vacation .modal-dialog{width:520px}warning-request-vacation .modal-content{height:462px;padding-top:55px;border-radius:4px!important}warning-request-vacation .modal-content .modal-header{border-bottom:1px solid #dddfe2}warning-request-vacation .modal-content .modal-header .icon-warning{color:#c8175e;display:block;font-size:78px;height:76px;margin:0 auto 25px;width:78px}warning-request-vacation .modal-content .modal-header h4{color:#c8175e!important;padding-bottom:10px}warning-request-vacation .modal-content .modal-body{line-height:1.38;padding-top:17px;text-align:center}warning-request-vacation .modal-content .modal-body span{color:#666;font-family:ArialMT;font-size:15px;height:42px;text-align:center;width:282px}warning-request-vacation .modal-content .modal-body .second-paragraph{margin-left:-1px;margin-top:12px}warning-request-vacation .modal-content .modal-footer{margin-top:40px;text-align:center}warning-request-vacation .modal-content .modal-footer .btn{height:37.4px;line-height:38px;margin-left:-1px;padding-top:1px;width:256px}", ""]);
	
	// exports


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendar = __webpack_require__(1436);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	__webpack_require__(311);
	
	__webpack_require__(1441);
	
	__webpack_require__(1442);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarModule = angular.module('vacations-absences.calendar', []).component('calendar', _calendar2.default).name;
	
	exports.default = calendarModule;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendar = __webpack_require__(1437);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _calendar3 = __webpack_require__(1438);
	
	var _calendar4 = _interopRequireDefault(_calendar3);
	
	__webpack_require__(1439);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarComponent = {
	  restrict: 'E',
	  bindings: {
	    date: '<',
	    selectDay: '&',
	    filters: '<',
	    user: '<',
	    isInception: '<',
	    isMobileApp: '<',
	    dateToday: '<',
	    onClickPrevious: '&',
	    onClickNext: '&'
	  },
	  template: _calendar2.default,
	  controller: _calendar4.default
	};
	
	exports.default = calendarComponent;

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	module.exports = "<calendar-component\n  options=\"$ctrl.options\"\n  on-click=\"$ctrl.clicked($event)\"\n  before-show-day=\"$ctrl.onDayRender($event)\"\n  on-hover-in=\"$ctrl.hoverIn($event)\"\n  on-hover-out=\"$ctrl.hoverOut($event)\"\n  ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\"\n  is-mobile-app=\"$ctrl.isMobileApp\"\n  on-click-previous=\"$ctrl.onClickPrevious()\"\n  on-click-next=\"$ctrl.onClickNext()\"\n  date-today=\"$ctrl.dateToday\"\n></calendar-component>\n"

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _periods = __webpack_require__(1359);
	
	var _periods2 = _interopRequireDefault(_periods);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarController = function () {
	  CalendarController.$inject = ["$scope", "$timeout", "$rootScope", "AppDictionary"];
	  function CalendarController($scope, $timeout, $rootScope, AppDictionary) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CalendarController);
	    this.scope = $scope;
	    this.rootScope = $rootScope;
	    this.timeout = $timeout;
	    this.dictionary = AppDictionary;
	  }
	
	  (0, _createClass3.default)(CalendarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.month = this.date.getMonth();
	      this.year = this.date.getFullYear();
	      this.options = this._initOptions();
	    }
	  }, {
	    key: '_initOptions',
	    value: function _initOptions() {
	      var dateToInsert = {
	        year: this.year,
	        month: this.month,
	        day: 1
	      };
	      var option = {
	        displayYear: false,
	        todayHighlight: true,
	        language: 'es',
	        defaultViewDate: dateToInsert
	      };
	      if (this.isMobileApp) {
	        option.displayYear = true;
	      }
	      return option;
	    }
	  }, {
	    key: 'onDayRender',
	    value: function onDayRender(_ref) {
	      var date = _ref.date;
	
	      var dayInEvents = this.findDayInEvents(date);
	      return _periods2.default.getDayWithContent(date, dayInEvents);
	    }
	  }, {
	    key: 'findDayInEvents',
	    value: function findDayInEvents(date) {
	      var day = this.user.periodInDays.filter(function (event) {
	        return event.day.getTime() === date.getTime();
	      });
	      return day;
	    }
	  }, {
	    key: 'clicked',
	    value: function clicked(_ref2) {
	      var dayClicked = _ref2.dayClicked,
	          dateDayClicked = _ref2.dateDayClicked;
	
	      if (this.dayClickedIsRequestDay(dayClicked)) {
	        // Request day
	        var day = this.findDayInEvents(dateDayClicked);
	        if (day.length === 0) return;
	        this.emitRequestDayClickEvent(dayClicked, dateDayClicked, this.user.getPeriodById(day[0].periodId));
	      } else {
	        // Day without request
	        $('calendar .active').removeClass('active');
	        $(dayClicked).addClass('active');
	        this.selectDay({ $event: { date: dateDayClicked, inception: !!this.isInception } });
	      }
	    }
	  }, {
	    key: 'dayClickedIsRequestDay',
	    value: function dayClickedIsRequestDay(dayClicked) {
	      return $(dayClicked).hasClass(this.dictionary.getVacation()) || $(dayClicked).hasClass(this.dictionary.getAbsence());
	    }
	  }, {
	    key: 'emitRequestDayClickEvent',
	    value: function emitRequestDayClickEvent(dayClicked, dateDayClicked, period) {
	      return this.rootScope.$broadcast('REQUEST_DAY_CLICK', { $event: { dayClicked: dayClicked, dateDayClicked: dateDayClicked, period: period } });
	    }
	  }, {
	    key: 'hoverOut',
	    value: function hoverOut(_ref3) {
	      var dayHovered = _ref3.dayHovered;
	
	      if (!this.dayClickedIsRequestDay(dayHovered)) return;
	      this.rootScope.$broadcast('period-hover-out', {});
	    }
	  }, {
	    key: 'hoverIn',
	    value: function hoverIn(_ref4) {
	      var dayHovered = _ref4.dayHovered,
	          dateDayHovered = _ref4.dateDayHovered;
	
	      if (!this.dayClickedIsRequestDay(dayHovered)) return;
	      this.rootScope.$broadcast('period-hover-in', {
	        dayHovered: dayHovered,
	        date: dateDayHovered
	      });
	    }
	  }]);
	  return CalendarController;
	}();
	
	exports.default = CalendarController;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1440);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./calendar.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./calendar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Datepicker for Bootstrap v1.7.0-dev (https://github.com/uxsolutions/bootstrap-datepicker)\n *\n * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)\n */.datepicker{border-radius:4px;direction:ltr}.datepicker-inline{width:220px}.datepicker.datepicker-rtl{direction:rtl}.datepicker.datepicker-rtl.dropdown-menu{left:auto}.datepicker.datepicker-rtl table tr td span{float:right}.datepicker-dropdown{top:0;left:0;padding:4px}.datepicker-dropdown:before{content:\"\";display:inline-block;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid rgba(0,0,0,.15);border-top:0;border-bottom-color:rgba(0,0,0,.2);position:absolute}.datepicker-dropdown:after{content:\"\";display:inline-block;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;border-top:0;position:absolute}.datepicker-dropdown.datepicker-orient-left:before{left:6px}.datepicker-dropdown.datepicker-orient-left:after{left:7px}.datepicker-dropdown.datepicker-orient-right:before{right:6px}.datepicker-dropdown.datepicker-orient-right:after{right:7px}.datepicker-dropdown.datepicker-orient-bottom:before{top:-7px}.datepicker-dropdown.datepicker-orient-bottom:after{top:-6px}.datepicker-dropdown.datepicker-orient-top:before{bottom:-7px;border-bottom:0;border-top:7px solid rgba(0,0,0,.15)}.datepicker-dropdown.datepicker-orient-top:after{bottom:-6px;border-bottom:0;border-top:6px solid #fff}.datepicker table{margin:0;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.datepicker table tr td,.datepicker table tr th{text-align:center;width:30px;height:30px;border-radius:4px;border:none}.table-striped .datepicker table tr td,.table-striped .datepicker table tr th{background-color:transparent}.datepicker table tr td.new,.datepicker table tr td.old{color:#777}.datepicker table tr td.day:hover,.datepicker table tr td.focused{background:#eee;cursor:pointer}.datepicker table tr td.disabled,.datepicker table tr td.disabled:hover{background:0 0;color:#777;cursor:default}.datepicker table tr td.highlighted{color:#000;background-color:#d9edf7;border-color:#85c5e5;border-radius:0}.datepicker table tr td.highlighted.focus,.datepicker table tr td.highlighted:focus{color:#000;background-color:#afd9ee;border-color:#298fc2}.datepicker table tr td.highlighted.active,.datepicker table tr td.highlighted:active,.datepicker table tr td.highlighted:hover{color:#000;background-color:#afd9ee;border-color:#52addb}.datepicker table tr td.highlighted.active.focus,.datepicker table tr td.highlighted.active:focus,.datepicker table tr td.highlighted.active:hover,.datepicker table tr td.highlighted:active.focus,.datepicker table tr td.highlighted:active:focus,.datepicker table tr td.highlighted:active:hover{color:#000;background-color:#91cbe8;border-color:#298fc2}.datepicker table tr td.highlighted.disabled.focus,.datepicker table tr td.highlighted.disabled:focus,.datepicker table tr td.highlighted.disabled:hover,.datepicker table tr td.highlighted[disabled].focus,.datepicker table tr td.highlighted[disabled]:focus,.datepicker table tr td.highlighted[disabled]:hover,fieldset[disabled] .datepicker table tr td.highlighted.focus,fieldset[disabled] .datepicker table tr td.highlighted:focus,fieldset[disabled] .datepicker table tr td.highlighted:hover{background-color:#d9edf7;border-color:#85c5e5}.datepicker table tr td.highlighted.focused{background:#afd9ee}.datepicker table tr td.highlighted.disabled,.datepicker table tr td.highlighted.disabled:active{background:#d9edf7;color:#777}.datepicker table tr td.today{color:#000;background-color:#ffdb99;border-color:#ffb733}.datepicker table tr td.today.focus,.datepicker table tr td.today:focus{color:#000;background-color:#ffc966;border-color:#b37400}.datepicker table tr td.today.active,.datepicker table tr td.today:active,.datepicker table tr td.today:hover{color:#000;background-color:#ffc966;border-color:#f59e00}.datepicker table tr td.today.active.focus,.datepicker table tr td.today.active:focus,.datepicker table tr td.today.active:hover,.datepicker table tr td.today:active.focus,.datepicker table tr td.today:active:focus,.datepicker table tr td.today:active:hover{color:#000;background-color:#ffbc42;border-color:#b37400}.datepicker table tr td.today.disabled.focus,.datepicker table tr td.today.disabled:focus,.datepicker table tr td.today.disabled:hover,.datepicker table tr td.today[disabled].focus,.datepicker table tr td.today[disabled]:focus,.datepicker table tr td.today[disabled]:hover,fieldset[disabled] .datepicker table tr td.today.focus,fieldset[disabled] .datepicker table tr td.today:focus,fieldset[disabled] .datepicker table tr td.today:hover{background-color:#ffdb99;border-color:#ffb733}.datepicker table tr td.today.focused{background:#ffc966}.datepicker table tr td.today.disabled,.datepicker table tr td.today.disabled:active{background:#ffdb99;color:#777}.datepicker table tr td.range{color:#000;background-color:#eee;border-color:#bbb;border-radius:0}.datepicker table tr td.range.focus,.datepicker table tr td.range:focus{color:#000;background-color:#d5d5d5;border-color:#7c7c7c}.datepicker table tr td.range.active,.datepicker table tr td.range:active,.datepicker table tr td.range:hover{color:#000;background-color:#d5d5d5;border-color:#9d9d9d}.datepicker table tr td.range.active.focus,.datepicker table tr td.range.active:focus,.datepicker table tr td.range.active:hover,.datepicker table tr td.range:active.focus,.datepicker table tr td.range:active:focus,.datepicker table tr td.range:active:hover{color:#000;background-color:#c3c3c3;border-color:#7c7c7c}.datepicker table tr td.range.disabled.focus,.datepicker table tr td.range.disabled:focus,.datepicker table tr td.range.disabled:hover,.datepicker table tr td.range[disabled].focus,.datepicker table tr td.range[disabled]:focus,.datepicker table tr td.range[disabled]:hover,fieldset[disabled] .datepicker table tr td.range.focus,fieldset[disabled] .datepicker table tr td.range:focus,fieldset[disabled] .datepicker table tr td.range:hover{background-color:#eee;border-color:#bbb}.datepicker table tr td.range.focused{background:#d5d5d5}.datepicker table tr td.range.disabled,.datepicker table tr td.range.disabled:active{background:#eee;color:#777}.datepicker table tr td.range.highlighted{color:#000;background-color:#e4eef3;border-color:#9dc1d3}.datepicker table tr td.range.highlighted.focus,.datepicker table tr td.range.highlighted:focus{color:#000;background-color:#c1d7e3;border-color:#4b88a6}.datepicker table tr td.range.highlighted.active,.datepicker table tr td.range.highlighted:active,.datepicker table tr td.range.highlighted:hover{color:#000;background-color:#c1d7e3;border-color:#73a6c0}.datepicker table tr td.range.highlighted.active.focus,.datepicker table tr td.range.highlighted.active:focus,.datepicker table tr td.range.highlighted.active:hover,.datepicker table tr td.range.highlighted:active.focus,.datepicker table tr td.range.highlighted:active:focus,.datepicker table tr td.range.highlighted:active:hover{color:#000;background-color:#a8c8d8;border-color:#4b88a6}.datepicker table tr td.range.highlighted.disabled.focus,.datepicker table tr td.range.highlighted.disabled:focus,.datepicker table tr td.range.highlighted.disabled:hover,.datepicker table tr td.range.highlighted[disabled].focus,.datepicker table tr td.range.highlighted[disabled]:focus,.datepicker table tr td.range.highlighted[disabled]:hover,fieldset[disabled] .datepicker table tr td.range.highlighted.focus,fieldset[disabled] .datepicker table tr td.range.highlighted:focus,fieldset[disabled] .datepicker table tr td.range.highlighted:hover{background-color:#e4eef3;border-color:#9dc1d3}.datepicker table tr td.range.highlighted.focused{background:#c1d7e3}.datepicker table tr td.range.highlighted.disabled,.datepicker table tr td.range.highlighted.disabled:active{background:#e4eef3;color:#777}.datepicker table tr td.range.today{color:#000;background-color:#f7ca77;border-color:#f1a417}.datepicker table tr td.range.today.focus,.datepicker table tr td.range.today:focus{color:#000;background-color:#f4b747;border-color:#815608}.datepicker table tr td.range.today.active,.datepicker table tr td.range.today:active,.datepicker table tr td.range.today:hover{color:#000;background-color:#f4b747;border-color:#bf800c}.datepicker table tr td.range.today.active.focus,.datepicker table tr td.range.today.active:focus,.datepicker table tr td.range.today.active:hover,.datepicker table tr td.range.today:active.focus,.datepicker table tr td.range.today:active:focus,.datepicker table tr td.range.today:active:hover{color:#000;background-color:#f2aa25;border-color:#815608}.datepicker table tr td.range.today.disabled.focus,.datepicker table tr td.range.today.disabled:focus,.datepicker table tr td.range.today.disabled:hover,.datepicker table tr td.range.today[disabled].focus,.datepicker table tr td.range.today[disabled]:focus,.datepicker table tr td.range.today[disabled]:hover,fieldset[disabled] .datepicker table tr td.range.today.focus,fieldset[disabled] .datepicker table tr td.range.today:focus,fieldset[disabled] .datepicker table tr td.range.today:hover{background-color:#f7ca77;border-color:#f1a417}.datepicker table tr td.range.today.disabled,.datepicker table tr td.range.today.disabled:active{background:#f7ca77;color:#777}.datepicker table tr td.selected,.datepicker table tr td.selected.highlighted{color:#fff;background-color:#777;border-color:#555;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.datepicker table tr td.selected.focus,.datepicker table tr td.selected.highlighted.focus,.datepicker table tr td.selected.highlighted:focus,.datepicker table tr td.selected:focus{color:#fff;background-color:#5e5e5e;border-color:#161616}.datepicker table tr td.selected.active,.datepicker table tr td.selected.highlighted.active,.datepicker table tr td.selected.highlighted:active,.datepicker table tr td.selected.highlighted:hover,.datepicker table tr td.selected:active,.datepicker table tr td.selected:hover{color:#fff;background-color:#5e5e5e;border-color:#373737}.datepicker table tr td.selected.active.focus,.datepicker table tr td.selected.active:focus,.datepicker table tr td.selected.active:hover,.datepicker table tr td.selected.highlighted.active.focus,.datepicker table tr td.selected.highlighted.active:focus,.datepicker table tr td.selected.highlighted.active:hover,.datepicker table tr td.selected.highlighted:active.focus,.datepicker table tr td.selected.highlighted:active:focus,.datepicker table tr td.selected.highlighted:active:hover,.datepicker table tr td.selected:active.focus,.datepicker table tr td.selected:active:focus,.datepicker table tr td.selected:active:hover{color:#fff;background-color:#4c4c4c;border-color:#161616}.datepicker table tr td.selected.disabled.focus,.datepicker table tr td.selected.disabled:focus,.datepicker table tr td.selected.disabled:hover,.datepicker table tr td.selected.highlighted.disabled.focus,.datepicker table tr td.selected.highlighted.disabled:focus,.datepicker table tr td.selected.highlighted.disabled:hover,.datepicker table tr td.selected.highlighted[disabled].focus,.datepicker table tr td.selected.highlighted[disabled]:focus,.datepicker table tr td.selected.highlighted[disabled]:hover,.datepicker table tr td.selected[disabled].focus,.datepicker table tr td.selected[disabled]:focus,.datepicker table tr td.selected[disabled]:hover,fieldset[disabled] .datepicker table tr td.selected.focus,fieldset[disabled] .datepicker table tr td.selected.highlighted.focus,fieldset[disabled] .datepicker table tr td.selected.highlighted:focus,fieldset[disabled] .datepicker table tr td.selected.highlighted:hover,fieldset[disabled] .datepicker table tr td.selected:focus,fieldset[disabled] .datepicker table tr td.selected:hover{background-color:#777;border-color:#555}.datepicker table tr td.active,.datepicker table tr td.active.highlighted{color:#fff;background-color:#337ab7;border-color:#2e6da4;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.datepicker table tr td.active.focus,.datepicker table tr td.active.highlighted.focus,.datepicker table tr td.active.highlighted:focus,.datepicker table tr td.active:focus{color:#fff;background-color:#286090;border-color:#122b40}.datepicker table tr td.active.active,.datepicker table tr td.active.highlighted.active,.datepicker table tr td.active.highlighted:active,.datepicker table tr td.active.highlighted:hover,.datepicker table tr td.active:active,.datepicker table tr td.active:hover{color:#fff;background-color:#286090;border-color:#204d74}.datepicker table tr td.active.active.focus,.datepicker table tr td.active.active:focus,.datepicker table tr td.active.active:hover,.datepicker table tr td.active.highlighted.active.focus,.datepicker table tr td.active.highlighted.active:focus,.datepicker table tr td.active.highlighted.active:hover,.datepicker table tr td.active.highlighted:active.focus,.datepicker table tr td.active.highlighted:active:focus,.datepicker table tr td.active.highlighted:active:hover,.datepicker table tr td.active:active.focus,.datepicker table tr td.active:active:focus,.datepicker table tr td.active:active:hover{color:#fff;background-color:#204d74;border-color:#122b40}.datepicker table tr td.active.disabled.focus,.datepicker table tr td.active.disabled:focus,.datepicker table tr td.active.disabled:hover,.datepicker table tr td.active.highlighted.disabled.focus,.datepicker table tr td.active.highlighted.disabled:focus,.datepicker table tr td.active.highlighted.disabled:hover,.datepicker table tr td.active.highlighted[disabled].focus,.datepicker table tr td.active.highlighted[disabled]:focus,.datepicker table tr td.active.highlighted[disabled]:hover,.datepicker table tr td.active[disabled].focus,.datepicker table tr td.active[disabled]:focus,.datepicker table tr td.active[disabled]:hover,fieldset[disabled] .datepicker table tr td.active.focus,fieldset[disabled] .datepicker table tr td.active.highlighted.focus,fieldset[disabled] .datepicker table tr td.active.highlighted:focus,fieldset[disabled] .datepicker table tr td.active.highlighted:hover,fieldset[disabled] .datepicker table tr td.active:focus,fieldset[disabled] .datepicker table tr td.active:hover{background-color:#337ab7;border-color:#2e6da4}.datepicker table tr td span{display:block;width:23%;height:54px;line-height:54px;float:left;margin:1%;cursor:pointer;border-radius:4px}.datepicker table tr td span.focused,.datepicker table tr td span:hover{background:#eee}.datepicker table tr td span.disabled,.datepicker table tr td span.disabled:hover{background:0 0;color:#777;cursor:default}.datepicker table tr td span.active,.datepicker table tr td span.active.disabled,.datepicker table tr td span.active.disabled:hover,.datepicker table tr td span.active:hover{color:#fff;background-color:#337ab7;border-color:#2e6da4;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.datepicker table tr td span.active.disabled.focus,.datepicker table tr td span.active.disabled:focus,.datepicker table tr td span.active.disabled:hover.focus,.datepicker table tr td span.active.disabled:hover:focus,.datepicker table tr td span.active.focus,.datepicker table tr td span.active:focus,.datepicker table tr td span.active:hover.focus,.datepicker table tr td span.active:hover:focus{color:#fff;background-color:#286090;border-color:#122b40}.datepicker table tr td span.active.active,.datepicker table tr td span.active.disabled.active,.datepicker table tr td span.active.disabled:active,.datepicker table tr td span.active.disabled:hover,.datepicker table tr td span.active.disabled:hover.active,.datepicker table tr td span.active.disabled:hover:active,.datepicker table tr td span.active.disabled:hover:hover,.datepicker table tr td span.active:active,.datepicker table tr td span.active:hover,.datepicker table tr td span.active:hover.active,.datepicker table tr td span.active:hover:active,.datepicker table tr td span.active:hover:hover{color:#fff;background-color:#286090;border-color:#204d74}.datepicker table tr td span.active.active.focus,.datepicker table tr td span.active.active:focus,.datepicker table tr td span.active.active:hover,.datepicker table tr td span.active.disabled.active.focus,.datepicker table tr td span.active.disabled.active:focus,.datepicker table tr td span.active.disabled.active:hover,.datepicker table tr td span.active.disabled:active.focus,.datepicker table tr td span.active.disabled:active:focus,.datepicker table tr td span.active.disabled:active:hover,.datepicker table tr td span.active.disabled:hover.active.focus,.datepicker table tr td span.active.disabled:hover.active:focus,.datepicker table tr td span.active.disabled:hover.active:hover,.datepicker table tr td span.active.disabled:hover:active.focus,.datepicker table tr td span.active.disabled:hover:active:focus,.datepicker table tr td span.active.disabled:hover:active:hover,.datepicker table tr td span.active:active.focus,.datepicker table tr td span.active:active:focus,.datepicker table tr td span.active:active:hover,.datepicker table tr td span.active:hover.active.focus,.datepicker table tr td span.active:hover.active:focus,.datepicker table tr td span.active:hover.active:hover,.datepicker table tr td span.active:hover:active.focus,.datepicker table tr td span.active:hover:active:focus,.datepicker table tr td span.active:hover:active:hover{color:#fff;background-color:#204d74;border-color:#122b40}.datepicker table tr td span.active.disabled.disabled.focus,.datepicker table tr td span.active.disabled.disabled:focus,.datepicker table tr td span.active.disabled.disabled:hover,.datepicker table tr td span.active.disabled.focus,.datepicker table tr td span.active.disabled:focus,.datepicker table tr td span.active.disabled:hover,.datepicker table tr td span.active.disabled:hover.disabled.focus,.datepicker table tr td span.active.disabled:hover.disabled:focus,.datepicker table tr td span.active.disabled:hover.disabled:hover,.datepicker table tr td span.active.disabled:hover[disabled].focus,.datepicker table tr td span.active.disabled:hover[disabled]:focus,.datepicker table tr td span.active.disabled:hover[disabled]:hover,.datepicker table tr td span.active.disabled[disabled].focus,.datepicker table tr td span.active.disabled[disabled]:focus,.datepicker table tr td span.active.disabled[disabled]:hover,.datepicker table tr td span.active:hover.disabled.focus,.datepicker table tr td span.active:hover.disabled:focus,.datepicker table tr td span.active:hover.disabled:hover,.datepicker table tr td span.active:hover[disabled].focus,.datepicker table tr td span.active:hover[disabled]:focus,.datepicker table tr td span.active:hover[disabled]:hover,.datepicker table tr td span.active[disabled].focus,.datepicker table tr td span.active[disabled]:focus,.datepicker table tr td span.active[disabled]:hover,fieldset[disabled] .datepicker table tr td span.active.disabled.focus,fieldset[disabled] .datepicker table tr td span.active.disabled:focus,fieldset[disabled] .datepicker table tr td span.active.disabled:hover,fieldset[disabled] .datepicker table tr td span.active.disabled:hover.focus,fieldset[disabled] .datepicker table tr td span.active.disabled:hover:focus,fieldset[disabled] .datepicker table tr td span.active.disabled:hover:hover,fieldset[disabled] .datepicker table tr td span.active.focus,fieldset[disabled] .datepicker table tr td span.active:focus,fieldset[disabled] .datepicker table tr td span.active:hover,fieldset[disabled] .datepicker table tr td span.active:hover.focus,fieldset[disabled] .datepicker table tr td span.active:hover:focus,fieldset[disabled] .datepicker table tr td span.active:hover:hover{background-color:#337ab7;border-color:#2e6da4}.datepicker table tr td span.new,.datepicker table tr td span.old{color:#777}.datepicker .datepicker-switch{width:145px}.datepicker .datepicker-switch,.datepicker .next,.datepicker .prev,.datepicker tfoot tr th{cursor:pointer}.datepicker .datepicker-switch:hover,.datepicker .next:hover,.datepicker .prev:hover,.datepicker tfoot tr th:hover{background:#eee}.datepicker .next.disabled,.datepicker .prev.disabled{visibility:hidden}.datepicker .cw{font-size:10px;width:12px;padding:0 2px 0 5px;vertical-align:middle}.input-group.date .input-group-addon{cursor:pointer}.input-daterange{width:100%}.input-daterange input{text-align:center}.input-daterange input:first-child{border-radius:3px 0 0 3px}.input-daterange input:last-child{border-radius:0 3px 3px 0}.input-daterange .input-group-addon{width:auto;min-width:16px;padding:4px 5px;line-height:1.42857143;text-shadow:0 1px 0 #fff;border-width:1px 0;margin-left:-5px;margin-right:-5px}calendar-component.responsiveMobile .new,calendar-component.responsiveMobile .old{visibility:hidden}calendar-component.responsiveMobile .icon-approved,calendar-component.responsiveMobile .icon-requested{left:10px;float:right}calendar-component.responsiveMobile .today{outline:3px solid #0072c9!important;outline-offset:-3px;border:none!important}calendar-component.responsiveMobile .day{font-size:15px}calendar-component .active{background-color:#0072c9!important;border:#dddfe2!important;border-radius:0!important;text-shadow:none!important;color:#fff!important}calendar-component .disabled{pointer-events:none;background-color:#fff!important}calendar-component .disabled .icon-approved,calendar-component .disabled .icon-requested,calendar-component .new .icon-approved,calendar-component .new .icon-requested,calendar-component .old .icon-approved,calendar-component .old .icon-requested{display:none}calendar-component .today{background-color:#fff!important;border:2px solid #0072c9!important;margin:5px!important}calendar-component .today.new .last-day .icon-approved,calendar-component .today.new .last-day .icon-requested,calendar-component .today.old .last-day .icon-approved,calendar-component .today.old .last-day .icon-requested{display:none!important}calendar-component .vacation{background-color:#52bcec!important;color:#fff!important;border-radius:0!important}calendar-component .vacation.disabled,calendar-component .vacation.filtered{color:#666!important;background-color:#fff!important}calendar-component .vacation.filtered .icon-approved,calendar-component .vacation.filtered .icon-requested{display:none}calendar-component .holiday,calendar-component .holiday.holiday{color:#000!important;border-radius:0!important}calendar-component .holiday.holiday{font-weight:500}calendar-component .absence{background-color:#fdbd2c!important;color:#666!important;border-radius:0!important}calendar-component .absence.holiday{pointer-events:none;color:#000!important;border-radius:0!important}calendar-component .absence.disabled,calendar-component .absence.filtered{color:#666!important;background-color:#fff!important}calendar-component .absence.filtered .icon-approved,calendar-component .absence.filtered .icon-requested{display:none}calendar-component .last-day .icon-approved,calendar-component .last-day .icon-requested{display:none!important}calendar-component .icon-approved,calendar-component .icon-requested{object-fit:contain;font-family:object-fit\\: contain;width:0!important;height:0!important;position:relative;top:-31px;left:38px;font-size:20px;pointer-events:none}calendar-component .icon-approved .path1:before,calendar-component .icon-requested .path1:before{position:relative;left:-18px}calendar-component .icon-approved .path2:before,calendar-component .icon-approved .path3:before,calendar-component .icon-requested .path2:before,calendar-component .icon-requested .path3:before{position:relative;left:2px}@media(max-width:1199px){calendar-component calendar{font-weight:bolder!important}calendar-component calendar .day{width:31px!important;height:26px!important}}.tablet calendar-component>div .datepicker-days{margin-right:auto;padding-top:1px;width:290px;height:310px;box-shadow:0 2px 4px 0 #dddfe2,0 -1px 4px 0 #dddfe2;margin-bottom:14px}.tablet calendar-component>div .datepicker-days .table-condensed{position:relative;width:100%;height:100%}.tablet calendar-component>div .day{font-size:14px}.tablet calendar-component>div .day .last-day .icon-approved,.tablet calendar-component>div .day .last-day .icon-requested{display:none!important}.tablet calendar-component>div .icon-approved,.tablet calendar-component>div .icon-requested{width:0!important;height:0!important;position:relative;top:-37px;left:45px;font-size:20px;object-fit:contain;pointer-events:none}.tablet calendar-component>div .icon-approved .path1:before,.tablet calendar-component>div .icon-requested .path1:before{position:relative;left:-18px}.tablet calendar-component>div .icon-approved .path2:before,.tablet calendar-component>div .icon-approved .path3:before,.tablet calendar-component>div .icon-requested .path2:before,.tablet calendar-component>div .icon-requested .path3:before{position:relative;left:2px}", ""]);
	
	// exports


/***/ }),
/* 1441 */,
/* 1442 */,
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarGrid = __webpack_require__(1444);
	
	var _calendarGrid2 = _interopRequireDefault(_calendarGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarGridModule = angular.module('vacations-absences.calendarGrid', []).component('calendarGrid', _calendarGrid2.default).name;
	
	exports.default = calendarGridModule;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarGrid = __webpack_require__(1445);
	
	var _calendarGrid2 = _interopRequireDefault(_calendarGrid);
	
	var _calendarGrid3 = __webpack_require__(1446);
	
	var _calendarGrid4 = _interopRequireDefault(_calendarGrid3);
	
	__webpack_require__(1447);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarGridComponent = {
	  restrict: 'E',
	  bindings: {
	    loaded: '<',
	    selectDay: '&',
	    filters: '<',
	    user: '<',
	    isInception: '<',
	    isTabletResolution: '<',
	    format: '<',
	    isMobileApp: '<',
	    isMobileSchedule: '<',
	    dateToday: '<',
	    onClickPrevious: '&',
	    onClickNext: '&'
	  },
	  template: _calendarGrid2.default,
	  controller: _calendarGrid4.default
	};
	
	exports.default = calendarGridComponent;

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	module.exports = "<div>\n\n  <!--Desktop calendars-->\n  <div class=\"row\" ng-class=\"$ctrl.format\" ng-if=\"$ctrl.showDesktopCalendar()\">\n    <div class=\"col-md-4 col-sm-4 col-xs-4\">\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[0]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[3]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[6]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[9]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n    </div>\n    <div class=\"col-md-4 col-sm-4 col-xs-4\">\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[1]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[4]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[7]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[10]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n    </div>\n    <div class=\"col-md-4 col-sm-4 col-xs-4\">\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[2]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[5]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[8]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\"  date=\"$ctrl.months[11]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n    </div>\n  </div>\n\n  <!--Tablet calendars-->\n  <div class=\"row\" ng-class=\"$ctrl.format\" ng-if=\"$ctrl.showTabletCalendar()\">\n    <div class=\"col-sm-6 col-xs-6\">\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[0]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[2]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[4]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[6]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[8]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[10]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n    </div>\n    <div class=\"col-sm-6 col-xs-6\">\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[1]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[3]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[5]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[7]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[9]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n      <calendar user=\"$ctrl.user\" date=\"$ctrl.months[11]\" select-day=\"$ctrl.selectDay({ $event: $event });\" filters=\"$ctrl.filters\" is-inception=\"$ctrl.isInception\"></calendar>\n    </div>\n  </div>\n\n  <!--Mobile calendars-->\n  <div class=\"row\" ng-if=\"$ctrl.showMobileCalendar()\">\n      <calendar user=\"$ctrl.user\"\n                date=\"$ctrl.months[$ctrl.month]\"\n                select-day=\"$ctrl.selectDay({ $event: $event });\"\n                filters=\"$ctrl.filters\"\n                is-inception=\"$ctrl.isInception\"\n                is-mobile-app=\"$ctrl.isMobileApp\"\n                on-click-previous=\"$ctrl.onClickPrevious()\"\n                on-click-next=\"$ctrl.onClickNext()\"\n                date-today=\"$ctrl.dateToday\">\n      </calendar>\n  </div>\n\n  <!--Mobile schedule calendars-->\n  <div ng-if=\"$ctrl.showMobileSchedule()\">\n      <calendar ng-repeat=\"month in [0,1,2,3,4,5,6,7,8,9,10,11]\"\n                user=\"$ctrl.user\"\n                date=\"$ctrl.months[month]\">\n      </calendar>\n  </div>\n\n</div>\n"

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarGridController = function () {
	  CalendarGridController.$inject = ["$scope"];
	  function CalendarGridController($scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CalendarGridController);
	    this.scope = $scope;
	    // this.dateToday = new Date();
	  }
	
	  (0, _createClass3.default)(CalendarGridController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.year = this.dateToday.getFullYear();
	      this.month = this.dateToday.getMonth();
	      this.day = this.dateToday.getDate();
	      this.months = this.initMonths();
	    }
	  }, {
	    key: 'initMonths',
	    value: function initMonths() {
	      var months = [];
	
	      for (var i = 0; i < 12; i++) {
	        months.push(new Date(this.year, i, 1, 2, 0, 0));
	      }
	
	      return months;
	    }
	  }, {
	    key: 'showMobileCalendar',
	    value: function showMobileCalendar() {
	      return this.isMobileApp && this.loaded && !this.isMobileSchedule;
	    }
	  }, {
	    key: 'showTabletCalendar',
	    value: function showTabletCalendar() {
	      return !this.isMobileApp && this.loaded && this.isTabletResolution;
	    }
	  }, {
	    key: 'showDesktopCalendar',
	    value: function showDesktopCalendar() {
	      return !this.isMobileApp && this.loaded && !this.isTabletResolution;
	    }
	  }, {
	    key: 'showMobileSchedule',
	    value: function showMobileSchedule() {
	      return this.isMobileApp && this.loaded && this.isMobileSchedule;
	    }
	  }]);
	  return CalendarGridController;
	}();
	
	exports.default = CalendarGridController;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1448);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./calendarGrid.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./calendarGrid.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarFilters = __webpack_require__(1450);
	
	var _calendarFilters2 = _interopRequireDefault(_calendarFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarFiltersModule = angular.module('vacations-absences.calendarFilters', []).component('calendarFilters', _calendarFilters2.default).name;
	
	exports.default = calendarFiltersModule;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarFilters = __webpack_require__(1451);
	
	var _calendarFilters2 = _interopRequireDefault(_calendarFilters);
	
	var _calendarFilters3 = __webpack_require__(1452);
	
	var _calendarFilters4 = _interopRequireDefault(_calendarFilters3);
	
	__webpack_require__(1453);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarFiltersComponent = {
	  restrict: 'E',
	  bindings: {
	    onChangeFilters: '&',
	    isMobileApp: '<'
	  },
	  template: _calendarFilters2.default,
	  controller: _calendarFilters4.default
	};
	
	exports.default = calendarFiltersComponent;

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex-container\" ng-class=\"{'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp}\">\n\n  <p class=\"filter-description\" ng-if=\"!$ctrl.isMobileApp\">\n    {{'VACATIONS_ABSENCES.CALENDAR_FILTERS.FILTER_BY' | translate}}:\n  </p>\n\n  <div class=\"mobile-labels\" ng-if=\"$ctrl.isMobileApp\">\n    <p class=\"filter-description\" ng-click=\"$ctrl.toggleFilters()\">\n      {{'VACATIONS_ABSENCES.CALENDAR_FILTERS.FILTER_TITLE_MOBILE' | translate}}\n    </p>\n    <a\n      class=\"calendar-filter-button calendar-filter-button-clean\"\n      href=\"\"\n      title=\"{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.CLEAN_FILTER_TITLE' | translate}}\"\n      ng-show=\"$ctrl.hasFilters() && $ctrl.clicked\"\n      ng-click=\"$ctrl.cleanFilters()\">\n      <p>{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.CLEAN' | translate}}</p>\n      <span class=\"icon-cross\"></span>\n    </a>\n  </div>\n\n  <div class=\"filter-buttons\" ng-show=\"$ctrl.showCalendarFilterButtons()\">\n    <a\n      class=\"calendar-filter-button\"\n      href=\"\"\n      title=\"{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.FILTER_BY_VACATION' | translate}}\"\n      ng-class=\"$ctrl.getCssActiveVacation()\"\n      ng-click=\"$ctrl.filterByVacation()\">\n      <div class=\"blue-square\"></div>\n      <p>{{'VACATIONS_ABSENCES.GENERAL.VACATIONS' | translate}}</p>\n    </a>\n\n    <a\n      class=\"calendar-filter-button\"\n      href=\"\"\n      title=\"{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.FILTER_BY_ABSENCES' | translate}}\"\n      ng-class=\"$ctrl.getCssActiveAbsence()\"\n      ng-click=\"$ctrl.filterByAbsence()\">\n      <div class=\"yellow-square\"></div>\n      <p>{{'VACATIONS_ABSENCES.GENERAL.ABSENCES' | translate}}</p>\n    </a>\n\n    <a\n      class=\"calendar-filter-button\"\n      href=\"\"\n      title=\"{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.FILTER_BY_REQUESTED' | translate}}\"\n      ng-class=\"$ctrl.getCssActiveRequested()\"\n      ng-click=\"$ctrl.filterByRequested()\">\n      <span class=\"icon-requested\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></span>\n      <p>{{'VACATIONS_ABSENCES.GENERAL.REQUESTED' | translate}}</p>\n    </a>\n\n\n    <div class=\"filter-buttons-group\">\n      <a\n        class=\"calendar-filter-button\"\n        href=\"\"\n        title=\"{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.FILTER_BY_APPROVED' | translate}}\"\n        ng-class=\"$ctrl.getCssActiveApproved()\"\n        ng-click=\"$ctrl.filterByApproved()\">\n        <span class=\"icon-approved\"><span class=\"path1\"></span><span class=\"path2\"></span></span>\n        <p>{{'VACATIONS_ABSENCES.GENERAL.APPROVED' | translate}}</p>\n      </a>\n\n      <a\n        ng-if=\"!$ctrl.isMobileApp\"\n        class=\"calendar-filter-button calendar-filter-button-clean\"\n        href=\"\"\n        title=\"{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.CLEAN_FILTER_TITLE' | translate}}\"\n        ng-show=\"$ctrl.hasFilters()\"\n        ng-click=\"$ctrl.cleanFilters()\">\n        <p>{{'VACATIONS_ABSENCES.CALENDAR_FILTERS.CLEAN' | translate}}</p>\n        <span class=\"icon-cross\"></span>\n      </a>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _request = __webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FILTERS = {};
	FILTERS[_request.Request.TYPES.VACATION] = false;
	FILTERS[_request.Request.TYPES.ABSENCE] = false;
	FILTERS[_request.Request.STATUS.REQUESTED] = false;
	FILTERS[_request.Request.STATUS.APPROVED] = false;
	
	var CalendarFiltersController = function () {
	  CalendarFiltersController.$inject = ["EventEmitter"];
	  function CalendarFiltersController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CalendarFiltersController);
	    this.EventEmitter = EventEmitter;
	    this.filters = this.initFilters();
	  }
	
	  (0, _createClass3.default)(CalendarFiltersController, [{
	    key: 'filterDispatcher',
	    value: function filterDispatcher() {
	      var filters = this.formatFilters(this.filters);
	      this.onChangeFilters(this.EventEmitter({ filters: filters }));
	    }
	  }, {
	    key: 'formatFilters',
	    value: function formatFilters(filters) {
	      var filterTypes = (0, _keys2.default)(filters);
	      var isActive = function isActive(filterType) {
	        return filters[filterType] === true;
	      };
	      var getName = function getName(filterType) {
	        return filterType;
	      };
	
	      return filterTypes.filter(isActive).map(getName);
	    }
	  }, {
	    key: 'filterByVacation',
	    value: function filterByVacation() {
	      this.filters[_request.Request.TYPES.VACATION] = !this.filters[_request.Request.TYPES.VACATION];
	      this.filters[_request.Request.TYPES.ABSENCE] = false;
	
	      this.filterDispatcher();
	    }
	  }, {
	    key: 'filterByAbsence',
	    value: function filterByAbsence() {
	      this.filters[_request.Request.TYPES.VACATION] = false;
	      this.filters[_request.Request.TYPES.ABSENCE] = !this.filters[_request.Request.TYPES.ABSENCE];
	
	      this.filterDispatcher();
	    }
	  }, {
	    key: 'filterByRequested',
	    value: function filterByRequested() {
	      this.filters[_request.Request.STATUS.REQUESTED] = !this.filters[_request.Request.STATUS.REQUESTED];
	      this.filters[_request.Request.STATUS.APPROVED] = false;
	
	      this.filterDispatcher();
	    }
	  }, {
	    key: 'filterByApproved',
	    value: function filterByApproved() {
	      this.filters[_request.Request.STATUS.REQUESTED] = false;
	      this.filters[_request.Request.STATUS.APPROVED] = !this.filters[_request.Request.STATUS.APPROVED];
	
	      this.filterDispatcher();
	    }
	  }, {
	    key: 'initFilters',
	    value: function initFilters() {
	      return angular.copy(FILTERS);
	    }
	  }, {
	    key: 'cleanFilters',
	    value: function cleanFilters() {
	      this.filters = this.initFilters();
	
	      this.filterDispatcher();
	    }
	  }, {
	    key: 'hasFilters',
	    value: function hasFilters() {
	      return !angular.equals(this.filters, FILTERS);
	    }
	  }, {
	    key: 'getCssActiveVacation',
	    value: function getCssActiveVacation() {
	      return this.getCssActive(_request.Request.TYPES.VACATION);
	    }
	  }, {
	    key: 'getCssActiveAbsence',
	    value: function getCssActiveAbsence() {
	      return this.getCssActive(_request.Request.TYPES.ABSENCE);
	    }
	  }, {
	    key: 'getCssActiveRequested',
	    value: function getCssActiveRequested() {
	      return this.getCssActive(_request.Request.STATUS.REQUESTED);
	    }
	  }, {
	    key: 'getCssActiveApproved',
	    value: function getCssActiveApproved() {
	      return this.getCssActive(_request.Request.STATUS.APPROVED);
	    }
	  }, {
	    key: 'getCssActive',
	    value: function getCssActive(filter) {
	      return {
	        'active': this.filters[filter] === true
	      };
	    }
	  }, {
	    key: 'toggleFilters',
	    value: function toggleFilters() {
	      this.clicked = !this.clicked;
	    }
	  }, {
	    key: 'showCalendarFilterButtons',
	    value: function showCalendarFilterButtons() {
	      if (!this.isMobileApp) {
	        return true;
	      }
	
	      return this.clicked;
	    }
	  }]);
	  return CalendarFiltersController;
	}();
	
	exports.default = CalendarFiltersController;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1454);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./calendarFilters.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./calendarFilters.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "calendar-filters{display:block;padding-left:15px;z-index:3}calendar-filters .flex-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}calendar-filters .flex-container.responsiveMobile{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;padding-right:15px}calendar-filters .flex-container.responsiveMobile .mobile-labels{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:100%;height:37px}calendar-filters .flex-container.responsiveMobile .mobile-labels .calendar-filter-button,calendar-filters .flex-container.responsiveMobile .mobile-labels .filter-description{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding-top:0;margin:0;margin-top:0;width:auto}calendar-filters .flex-container.responsiveMobile .mobile-labels .calendar-filter-button-clean p{margin-top:0}calendar-filters .flex-container.responsiveMobile .filter-buttons{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;width:100%;height:50px;overflow-x:scroll}calendar-filters .flex-container.responsiveMobile .calendar-filter-button{min-width:150px}calendar-filters .flex-container .filter-description{color:#0072c9;font-family:Stag Sans;font-size:13px;margin:0;margin-right:8px;margin-top:9px}calendar-filters .flex-container .filter-buttons{-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}calendar-filters .flex-container .calendar-filter-button,calendar-filters .flex-container .filter-buttons{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row}calendar-filters .flex-container .calendar-filter-button{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;border:1px solid #dddfe2;border-radius:4px;cursor:pointer;height:37px;margin-right:10px;width:150px;text-decoration:none}calendar-filters .flex-container .calendar-filter-button.active,calendar-filters .flex-container .calendar-filter-button.active+calendar-filters .flex-container .calendar-filter-button:focus{border-color:#0072c9;outline:0}calendar-filters .flex-container .calendar-filter-button .blue-square{background-color:#52bcec;border-radius:1px;height:20px;margin-right:10px;width:20px}calendar-filters .flex-container .calendar-filter-button .yellow-square{background-color:#fdbd2c;border-radius:1px;height:20px;margin-right:10px;width:20px}calendar-filters .flex-container .calendar-filter-button .glyphicon{right:10px}calendar-filters .flex-container .calendar-filter-button p{font-family:Stag Sans;font-size:13px;font-weight:300;margin:0;margin-top:2px}calendar-filters .flex-container .calendar-filter-button .icon-approved,calendar-filters .flex-container .calendar-filter-button .icon-requested{display:inline-block;font-size:21px;margin-right:8px}calendar-filters .flex-container .calendar-filter-button .filter-buttons-group{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}calendar-filters .flex-container .calendar-filter-button.calendar-filter-button-clean{border:none;margin-left:auto;margin-right:12px;width:inherit;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end;padding-top:7px}calendar-filters .flex-container .calendar-filter-button.calendar-filter-button-clean:focus .icon-cross,calendar-filters .flex-container .calendar-filter-button.calendar-filter-button-clean:focus p{color:#0072c9}calendar-filters .flex-container .calendar-filter-button.calendar-filter-button-clean p{line-height:16px}calendar-filters .flex-container .calendar-filter-button.calendar-filter-button-clean .icon-cross{display:inline-block;font-size:10px;color:#aeaeae;margin-left:10px}", ""]);
	
	// exports


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarContextMenu = __webpack_require__(1456);
	
	var _calendarContextMenu2 = _interopRequireDefault(_calendarContextMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarContextMenuModule = angular.module('vacations-absences.calendarContextMenu', []).component('calendarContextMenu', _calendarContextMenu2.default).name;
	
	exports.default = calendarContextMenuModule;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarContextMenu = __webpack_require__(1457);
	
	var _calendarContextMenu2 = _interopRequireDefault(_calendarContextMenu);
	
	var _calendarContextMenu3 = __webpack_require__(1458);
	
	var _calendarContextMenu4 = _interopRequireDefault(_calendarContextMenu3);
	
	__webpack_require__(1460);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarContextMenuComponent = {
	  restrict: 'E',
	  bindings: {
	    onOpenAbsences: '&',
	    onEditPeriod: '&',
	    isInception: '<',
	    isDisabled: '<'
	  },
	  template: _calendarContextMenu2.default,
	  controller: _calendarContextMenu4.default
	};
	
	exports.default = calendarContextMenuComponent;

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.periodAvailable()\">\n\n  <div class=\"arrow-up\">\n  </div>\n\n  <div\n    class=\"option\"\n    ng-class=\"{ 'border': $ctrl.periodActionsHelper.periodCanBeEdited() || $ctrl.periodCanBeRemoved() }\"\n    ng-if=\"$ctrl.periodActionsHelper.canInsertAbsence()\"\n    ng-click=\"$ctrl.openAbsences()\">\n    {{ 'VACATIONS_ABSENCES.GENERAL.ABSENCE' | translate }}\n  </div>\n\n  <div\n    class=\"option\"\n    ng-class=\"{ 'border': $ctrl.periodCanBeRemoved() }\"\n    ng-if=\"$ctrl.periodActionsHelper.periodCanBeEdited()\"\n    ng-click=\"$ctrl.editPeriod()\">\n    {{ 'GLOBALS.BUTTON_ACTION.EDIT' | translate }}\n  </div>\n\n  <div\n    class=\"option\"\n    ng-if=\"$ctrl.periodCanBeRemoved()\"\n    ng-click=\"$ctrl.removePeriod()\">\n    {{ 'GLOBALS.BUTTON_ACTION.REMOVE' | translate }}\n  </div>\n\n</div>\n"

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(598);
	
	var _request = __webpack_require__(1114);
	
	var _calendarContextMenu = __webpack_require__(1459);
	
	var _calendarContextMenu2 = _interopRequireDefault(_calendarContextMenu);
	
	var _periodActions = __webpack_require__(1146);
	
	var _periodActions2 = _interopRequireDefault(_periodActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarContextMenuController = function () {
	  CalendarContextMenuController.$inject = ["$scope", "$rootScope", "$timeout", "$window"];
	  function CalendarContextMenuController($scope, $rootScope, $timeout, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CalendarContextMenuController);
	    this.scope = $scope;
	    this.rootScope = $rootScope;
	    this.timeout = $timeout;
	    this.window = $window;
	    this.renderer = new _calendarContextMenu2.default();
	    this.hideContextMenuOnOutsideClick();
	    this.showContextMenuOnRequestDayClick();
	  }
	
	  (0, _createClass3.default)(CalendarContextMenuController, [{
	    key: 'periodAvailable',
	    value: function periodAvailable() {
	      return this.period !== undefined && this.period !== null;
	    }
	  }, {
	    key: 'openAbsences',
	    value: function openAbsences() {
	      this.onOpenAbsences({ $event: this.getEmittedData() });
	    }
	  }, {
	    key: 'editPeriod',
	    value: function editPeriod() {
	      this.onEditPeriod({ $event: this.getEmittedData() });
	    }
	  }, {
	    key: 'removePeriod',
	    value: function removePeriod() {
	      this.rootScope.$broadcast(_constants.EVENTS.CONTEXT_MENU_REMOVE, this.getEmittedData());
	    }
	  }, {
	    key: 'showContextMenuOnRequestDayClick',
	    value: function showContextMenuOnRequestDayClick() {
	      var _this = this;
	
	      this.scope.$on(_constants.EVENTS.REQUEST_DAY_CLICK, function (event, args) {
	        if (_this.isDisabled) {
	          return;
	        }
	
	        _this.showContextMenu(args.$event);
	      });
	    }
	  }, {
	    key: 'cancelShow',
	    value: function cancelShow() {
	      if (!this.period) {
	        return false;
	      }
	
	      return !this.canInsertAbsence() && !this.periodCanBeEdited() && !this.periodCanBeRemoved();
	    }
	  }, {
	    key: 'canInsertAbsence',
	    value: function canInsertAbsence() {
	      return _request.Request.isVacation(this.period) && _request.Request.isApproved(this.period);
	    }
	  }, {
	    key: 'periodCanBeEdited',
	    value: function periodCanBeEdited() {
	      if (_constants.SICKNESS.CODES.indexOf(this.period.code) === -1 && (0, _moment2.default)().isAfter(this.period.endDate)) {
	        return false;
	      }
	
	      if (this.period.code === _constants.PATERNITY_CODE || this.period.code === _constants.PATERNITY_SECOND_PERIOD_CODE) {
	        return false;
	      }
	
	      if (this.vacationOnInception(this.dayClicked, this.isInception)) {
	        return false;
	      }
	
	      if (this.period.onlyVisualization === true) {
	        return false;
	      }
	      if (this.isInception) {
	        return _request.Request.isRequested(this.period) && (this.period.code === _constants.SICKNESS.CODES[1] || this.period.code === _constants.SICKNESS.CODES[2]);
	      }
	
	      return _request.Request.isRequested(this.period) && !this.isInception;
	    }
	  }, {
	    key: 'periodCanBeRemoved',
	    value: function periodCanBeRemoved() {
	      var approvedOrRequested = _request.Request.isRequested(this.period) || _request.Request.isApproved(this.period);
	      var isSick = _request.Request.isSick(this.period);
	
	      if (this.period.onlyVisualization === true) {
	        return false;
	      }
	      return approvedOrRequested && !isSick && !this.isInception;
	    }
	  }, {
	    key: 'isFinishedSickPeriod',
	    value: function isFinishedSickPeriod() {
	      return _request.Request.isFinishedSick(this.period) && _request.Request.isApproved(this.period);
	    }
	  }, {
	    key: 'getEmittedData',
	    value: function getEmittedData() {
	      return {
	        dayClicked: this.dayClicked,
	        dateDayClicked: this.dateDayClicked,
	        period: this.period
	      };
	    }
	  }, {
	    key: 'setHandlerResize',
	    value: function setHandlerResize() {
	      var _this2 = this;
	
	      this.renderer.onresize(this.dayClicked, function () {
	        _this2.showContextMenu({
	          dayClicked: _this2.dayClicked,
	          dateDayClicked: _this2.dateDayClicked
	        });
	      });
	    }
	  }, {
	    key: 'showContextMenu',
	    value: function showContextMenu(_ref) {
	      var _this3 = this;
	
	      var dayClicked = _ref.dayClicked,
	          dateDayClicked = _ref.dateDayClicked,
	          period = _ref.period;
	
	      this.period = period;
	      this.periodActionsHelper = new _periodActions2.default(this.period, this.isInception);
	      this.dayClicked = dayClicked;
	      this.dateDayClicked = dateDayClicked;
	      this.setHandlerResize();
	
	      if (!this.periodActionsHelper.available()) {
	        return this.hideContextMenu();
	      }
	
	      this.timeout(function () {
	        return _this3.renderer.show(dayClicked);
	      });
	    }
	  }, {
	    key: 'hideContextMenuOnOutsideClick',
	    value: function hideContextMenuOnOutsideClick() {
	      var _this4 = this;
	
	      this.renderer.hideContextMenuOnOutsideClick(function () {
	        return _this4.hideContextMenu();
	      });
	    }
	  }, {
	    key: 'hideContextMenu',
	    value: function hideContextMenu() {
	      this.dayClicked = null;
	      this.renderer.hide();
	    }
	  }]);
	  return CalendarContextMenuController;
	}();
	
	exports.default = CalendarContextMenuController;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarContextMenuRenderer = function () {
	  function CalendarContextMenuRenderer() {
	    (0, _classCallCheck3.default)(this, CalendarContextMenuRenderer);
	
	    this._shown = false;
	    this._menu = document.getElementsByTagName(_constants.CONTEXT_MENU_TAG)[0];
	  }
	
	  (0, _createClass3.default)(CalendarContextMenuRenderer, [{
	    key: 'show',
	    value: function show(dayClicked) {
	      this._shown = true;
	      this.applyPosition(this.getPosition(dayClicked));
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this._shown = false;
	      this._menu.style.display = 'none';
	    }
	  }, {
	    key: 'onresize',
	    value: function onresize(dayClicked, resizeCallback) {
	      var _this = this;
	
	      $(window).resize(function () {
	        if (!_this._shown) {
	          return;
	        }
	
	        if (!_this.dayIsVisible(dayClicked)) {
	          return _this.hide();
	        }
	
	        resizeCallback();
	      });
	    }
	  }, {
	    key: 'getPosition',
	    value: function getPosition(dayClicked) {
	      var _dayClicked$getBoundi = dayClicked.getBoundingClientRect(),
	          top = _dayClicked$getBoundi.top,
	          left = _dayClicked$getBoundi.left,
	          right = _dayClicked$getBoundi.right,
	          bottom = _dayClicked$getBoundi.bottom;
	
	      var dayWidth = right - left;
	      var dayHeight = bottom - top;
	      top = top + dayHeight + window.scrollY - 3;
	      left = left - dayWidth + window.scrollX + 7;
	      return { top: top, left: left };
	    }
	  }, {
	    key: 'applyPosition',
	    value: function applyPosition(_ref) {
	      var top = _ref.top,
	          left = _ref.left;
	
	      this._menu.style.display = 'block';
	      this._menu.style.top = top + 'px';
	      this._menu.style.left = left + 'px';
	    }
	  }, {
	    key: 'hideContextMenuOnOutsideClick',
	    value: function hideContextMenuOnOutsideClick(hideCallback) {
	      $(document).click(function (event) {
	        if (!$(event.target).closest(_constants.CONTEXT_MENU_TAG).length) {
	          if ($(_constants.CONTEXT_MENU_TAG).is(':visible')) {
	            hideCallback();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'dayIsVisible',
	    value: function dayIsVisible(dayClicked) {
	      return $(dayClicked).is(':visible');
	    }
	  }, {
	    key: 'dayIsVacation',
	    value: function dayIsVacation(dayClicked) {
	      return $(dayClicked).hasClass('vacation');
	    }
	  }, {
	    key: 'shown',
	    get: function get() {
	      return this._shown;
	    }
	  }]);
	  return CalendarContextMenuRenderer;
	}();
	
	exports.default = CalendarContextMenuRenderer;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1461);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./calendarContextMenu.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./calendarContextMenu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "calendar-context-menu{position:absolute;display:none;top:0;bottom:0;z-index:1;cursor:pointer;border-radius:1px}calendar-context-menu .arrow-up{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-bottom:3px solid #0072c9;margin:0 auto}calendar-context-menu .option{width:100px;height:32px;background:#0072c9;text-align:center;color:#fff;font-size:13px;line-height:35px}calendar-context-menu .option.border{border-bottom:1px solid #fff}calendar-context-menu .option:hover{background:#04408f}", ""]);
	
	// exports


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarComponent = __webpack_require__(1463);
	
	var _calendarComponent2 = _interopRequireDefault(_calendarComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarComponentModule = angular.module('vacations-absences.calendarComponent', []).component('calendarComponent', _calendarComponent2.default).name;
	
	exports.default = calendarComponentModule;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarComponent = __webpack_require__(1464);
	
	var _calendarComponent2 = _interopRequireDefault(_calendarComponent);
	
	var _calendarComponent3 = __webpack_require__(1465);
	
	var _calendarComponent4 = _interopRequireDefault(_calendarComponent3);
	
	__webpack_require__(1466);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarComponentComponent = {
	  restrict: 'E',
	  bindings: {
	    options: '<',
	    onClick: '&',
	    onHoverIn: '&',
	    onHoverOut: '&',
	    beforeShowDay: '&',
	    isMobileApp: '<',
	    dateToday: '<',
	    onClickPrevious: '&',
	    onClickNext: '&'
	  },
	  template: _calendarComponent2.default,
	  controller: _calendarComponent4.default
	};
	
	exports.default = calendarComponentComponent;

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"datepicker{{$ctrl.month}}{{$ctrl.id}}\"></div>\n"

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarComponentController = function () {
	  CalendarComponentController.$inject = ["$scope", "$timeout"];
	  function CalendarComponentController($scope, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CalendarComponentController);
	    this.scope = $scope;
	    this.timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(CalendarComponentController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.id = this.options.id;
	      this.month = this.options.defaultViewDate.month;
	      this.monthCounter = this.month;
	      this.date = new Date(this.options.defaultViewDate.year, this.month, this.options.defaultViewDate.day);
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      var _this = this;
	
	      $(document).ready(function () {
	        _this.options.beforeShowDay = function (date) {
	          return _this.beforeShowDay({ $event: { date: date } });
	        };
	
	        _this._initDatepickerJquery();
	        _this.datepicker.datepicker(_this.options);
	        _this._initComponentParts();
	        _this.extraSettings();
	
	        if (_this.isMobileApp) {
	          _this._initMobileComponentParts();
	        }
	      });
	
	      this.scope.$on(_constants.EVENTS.ADD_PERIOD, function () {
	        _this.restart();
	      });
	
	      this.scope.$on(_constants.EVENTS.FILTER_PERIOD, function () {
	        _this.restart();
	      });
	
	      this.scope.$on(_constants.EVENTS.CALENDAR_INLINE_CHANGE_DATE, function (event, args) {
	        var isMatch = _this.checkCoincidence(args);
	        if (!args.newDate || !isMatch) return;
	        _this.options.defaultViewDate = {
	          year: args.newDate.getFullYear(),
	          month: args.newDate.getMonth(),
	          day: _this.options.defaultViewDate.day
	        };
	        _this.date = new Date(args.newDate.getFullYear(), args.newDate.getMonth(), 1);
	        _this.restart();
	      });
	    }
	  }, {
	    key: 'checkCoincidence',
	    value: function checkCoincidence(args) {
	      var coincidence = true;
	      if (args.id) {
	        coincidence = args.id == this.id;
	      }
	
	      return coincidence;
	    }
	  }, {
	    key: 'restart',
	    value: function restart() {
	      var _this2 = this;
	
	      $(document).ready(function () {
	        _this2.datepicker.datepicker('destroy');
	        _this2.options.beforeShowDay = function (date) {
	          return _this2.beforeShowDay({ $event: { date: date } });
	        };
	
	        _this2.datepicker.datepicker(_this2.options);
	        _this2._initDatepickerJquery();
	        _this2._initComponentParts();
	        _this2.extraSettings();
	        _this2.timeout(function () {
	          return _this2.scope.$apply();
	        }, 100);
	      });
	    }
	  }, {
	    key: '_initDatepickerJquery',
	    value: function _initDatepickerJquery() {
	      if (this.id !== undefined) {
	        this.datepicker = $('[id="datepicker' + this.month + this.id + '"]');
	      } else {
	        this.datepicker = $('[id="datepicker' + this.month + '"]');
	      }
	    }
	  }, {
	    key: '_initComponentParts',
	    value: function _initComponentParts() {
	      if (this.id !== undefined) {
	        this.datepickerPreviousMonth = $('[id="datepicker' + this.month + this.id + '"] .datepicker-days thead .prev');
	        this.datepickerDay = $('[id="datepicker' + this.month + this.id + '"] td');
	        this.title = $('[id="datepicker' + this.month + this.id + '"] .datepicker-switch');
	      } else {
	        this.datepickerPreviousMonth = $('[id="datepicker' + this.month + '"] .datepicker-days thead .prev');
	        this.datepickerDay = $('[id="datepicker' + this.month + '"] td');
	        this.title = $('[id="datepicker' + this.month + '"] .datepicker-switch');
	      }
	    }
	  }, {
	    key: '_initMobileComponentParts',
	    value: function _initMobileComponentParts() {
	      if (this.id !== undefined) {
	        this.datepickerPreviousMonth = $('[id="datepicker' + this.month + this.id + '"] .datepicker-days thead .prev');
	        this.datepickerNextMonth = $('[id="datepicker' + this.month + this.id + '"] .datepicker-days thead .next');
	      } else {
	        this.datepickerPreviousMonth = $('[id="datepicker' + this.month + '"] .datepicker-days thead .prev');
	        this.datepickerNextMonth = $('[id="datepicker' + this.month + '"] .datepicker-days thead .next');
	      }
	      this._addIconClassCalendarMonth();
	      this._bindDatepickerMobileEvents();
	    }
	  }, {
	    key: '_addIconClassCalendarMonth',
	    value: function _addIconClassCalendarMonth() {
	      this.datepickerPreviousMonth.addClass('icon-arrow-select-up');
	      this.datepickerNextMonth.addClass('icon-arrow-select-up');
	    }
	  }, {
	    key: 'extraSettings',
	    value: function extraSettings() {
	      this.bindDatepickerEvents();
	      if (this.options.displayYear === false) this.removeYearFromTitle();
	    }
	  }, {
	    key: 'removeYearFromTitle',
	    value: function removeYearFromTitle() {
	      if (this.title.html() != undefined) this.title.html(this.title.html().replace(/[0-9]/g, ''));
	    }
	  }, {
	    key: 'bindDatepickerEvents',
	    value: function bindDatepickerEvents() {
	      this._initClick();
	      this._initHover();
	    }
	  }, {
	    key: '_bindDatepickerMobileEvents',
	    value: function _bindDatepickerMobileEvents() {
	      this._initClickPreviousMonth();
	      this._initClickNextMonth();
	    }
	  }, {
	    key: '_initClick',
	    value: function _initClick() {
	      var _this3 = this;
	
	      this.datepickerDay.click(function (event) {
	        event.stopPropagation();
	        var dayClicked = event.currentTarget;
	        var dateDayClicked = new Date(_this3.date.getFullYear(), _this3.date.getMonth(), event.target.innerText);
	        _this3.onClick({ $event: { dayClicked: dayClicked, dateDayClicked: dateDayClicked } });
	      });
	    }
	  }, {
	    key: '_initHover',
	    value: function _initHover() {
	      var _this4 = this;
	
	      this.datepickerDay.hover(function (event) {
	        event.stopPropagation();
	        var dayHovered = event.currentTarget;
	        var dateDayHovered = new Date(_this4.date.getFullYear(), _this4.date.getMonth(), event.target.innerText);
	        _this4.onHoverIn({ $event: { dayHovered: dayHovered, dateDayHovered: dateDayHovered } });
	      }, function (event) {
	        var dayHovered = event.currentTarget;
	        var dateDayHovered = new Date(_this4.date.getFullYear(), _this4.date.getMonth(), event.target.innerText);
	        _this4.onHoverOut({ $event: { dayHovered: dayHovered, dateDayHovered: dateDayHovered } });
	      });
	    }
	  }, {
	    key: '_initClickPreviousMonth',
	    value: function _initClickPreviousMonth() {
	      var _this5 = this;
	
	      this.datepickerPreviousMonth.click(function (event) {
	        var isFirstMonth = _this5.monthCounter === _constants.JANUARY_INDEX;
	        var isLastMonthPaginable = _this5.dateToday.getFullYear() === _constants.CALENDAR_LAST_YEAR_PAGINATION_ALLOWED && isFirstMonth;
	
	        if (isLastMonthPaginable) {
	          event.stopPropagation();
	          return;
	        }
	
	        if (isFirstMonth) {
	          _this5.monthCounter = _constants.DECEMBER_INDEX;
	          _this5.onClickPrevious();
	        } else {
	          _this5.monthCounter -= 1;
	        }
	      });
	    }
	  }, {
	    key: '_initClickNextMonth',
	    value: function _initClickNextMonth() {
	      var _this6 = this;
	
	      this.datepickerNextMonth.click(function () {
	        var today = new Date();
	        var isLastMonth = _this6.monthCounter === _constants.DECEMBER_INDEX;
	        var isLastMonthOfNewYear = _this6.dateToday.getFullYear() === today.getFullYear() + 1 && isLastMonth;
	        var isBeforeTwentyNovember = today.getMonth() < _constants.NOVEMBER_INDEX && today.getDay() < 20 && _this6.dateToday.getFullYear() === today.getFullYear();
	        var notShouldPaginateToNewYear = isLastMonth && isBeforeTwentyNovember;
	
	        if (isLastMonthOfNewYear || notShouldPaginateToNewYear) {
	          event.stopPropagation();
	          return;
	        }
	
	        if (isLastMonth) {
	          _this6.monthCounter = _constants.JANUARY_INDEX;
	          _this6.onClickNext();
	        } else {
	          _this6.monthCounter += 1;
	        }
	      });
	    }
	  }]);
	  return CalendarComponentController;
	}();
	
	exports.default = CalendarComponentController;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1467);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./calendarComponent.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./calendarComponent.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "calendar-component{display:block;margin-bottom:32px}calendar-component.responsiveMobile{pointer-events:none;margin-bottom:0}calendar-component.responsiveMobile .datepicker-days{margin-bottom:0;height:300px;padding-top:0}calendar-component.responsiveMobile .datepicker-days .table-condensed{display:block}calendar-component.responsiveMobile .datepicker-days thead{display:table;width:100%;text-align:center}calendar-component.responsiveMobile .datepicker-days thead tr{display:table;width:100%}calendar-component.responsiveMobile .datepicker-days thead tr:last-child{display:inline-table;text-align:center;margin-top:5px;font-size:12px;width:90%}calendar-component.responsiveMobile .datepicker-days thead .datepicker-switch{width:100px}calendar-component.responsiveMobile .datepicker-days tbody{display:table;width:90%;margin:0 auto}calendar-component.responsiveMobile .datepicker-days tbody tr{border-top:5px solid #fff;border-bottom:5px solid #fff}calendar-component.responsiveMobile .datepicker-days tbody td.start-period{border-left:5px solid #fff}calendar-component.responsiveMobile .datepicker-days tbody td.end-period{border-right:5px solid #fff}calendar-component.responsiveMobile .next,calendar-component.responsiveMobile .next:hover,calendar-component.responsiveMobile .prev,calendar-component.responsiveMobile .prev:hover{pointer-events:auto;background-color:#0072c9;color:transparent!important;padding:0;display:block;border-radius:0;width:40px;height:40px}calendar-component.responsiveMobile .next:before,calendar-component.responsiveMobile .next:hover:before,calendar-component.responsiveMobile .prev:before,calendar-component.responsiveMobile .prev:hover:before{color:#fff;display:block;font-size:10px;position:absolute;left:0;right:0;top:14px}@media print{calendar-component.responsiveMobile .next,calendar-component.responsiveMobile .next:hover,calendar-component.responsiveMobile .prev,calendar-component.responsiveMobile .prev:hover{visibility:visible!important}}calendar-component.responsiveMobile .next{float:right}calendar-component.responsiveMobile .next.icon-arrow-select-up{transform:rotate(90deg)}calendar-component.responsiveMobile .prev{float:left}calendar-component.responsiveMobile .prev.icon-arrow-select-up{transform:rotate(270deg)}@media print{calendar-component{margin-bottom:5px}}calendar-component .day{font-family:Stag Sans;font-size:12px;font-weight:400;width:31px;height:26px;padding:0;text-align:center;color:#666;border-color:#fff}@media print{calendar-component .day{color:#666!important}calendar-component .day.vacation:not(.disabled-date):not(.new),calendar-component .day.vacation:not(.disabled-date):not(.new) .always-paint,calendar-component .day.vacation:not(.disabled-date):not(.new) .last-day{color:#fff!important}calendar-component .day.absence:not(.disabled-date):not(.new){color:#666!important}calendar-component .day.absence:not(.disabled-date):not(.new) .always-paint,calendar-component .day.absence:not(.disabled-date):not(.new) .last-day{color:#fff!important}calendar-component .day.holiday{color:#000!important}}calendar-component .active{color:#fff!important;border:#dddfe2!important;border-radius:0!important;background-color:#0072c9!important;text-shadow:none!important}calendar-component .datepicker-inline{display:block;width:auto}calendar-component .datepicker-days{height:253px;margin-bottom:14px;padding-top:1px;box-shadow:0 2px 4px 0 #dddfe2,0 -1px 4px 0 #dddfe2!important}@media print{calendar-component .datepicker-days{height:241px;margin:0 auto!important}}calendar-component .datepicker-days .table-condensed{position:relative;width:100%;height:100%}calendar-component .new,calendar-component .old{font-family:Stag Sans;font-size:12px;font-weight:300;cursor:default;text-align:center!important;pointer-events:none;color:#a8a8a8!important;border:none!important;background-color:#fff!important}calendar-component .dow{font-family:ArialMT;font-size:11px;font-weight:300!important;width:31px;height:41px;color:#666!important}calendar-component .datepicker-switch{font-family:ArialMT;font-size:13px;font-weight:500;position:relative;top:2px;width:50px;height:15px;cursor:default;text-align:center;pointer-events:none;color:#0072c9!important;border-bottom:1px solid #eaebed!important}calendar-component .datepicker-switch:hover{background-color:#fff!important}calendar-component .next,calendar-component .prev{cursor:default;pointer-events:none;color:#fff!important;border-bottom:1px #fff!important}@media print{calendar-component .next,calendar-component .prev{visibility:hidden!important}}calendar-component .next .disabled,calendar-component .prev .disabled{pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarInline = __webpack_require__(1469);
	
	var _calendarInline2 = _interopRequireDefault(_calendarInline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarInlineModule = angular.module('vacations-absences.calendarInline', []).component('calendarInline', _calendarInline2.default).name;
	
	exports.default = calendarInlineModule;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarInline = __webpack_require__(1470);
	
	var _calendarInline2 = _interopRequireDefault(_calendarInline);
	
	var _calendarInline3 = __webpack_require__(1471);
	
	var _calendarInline4 = _interopRequireDefault(_calendarInline3);
	
	__webpack_require__(1472);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarInlineComponent = {
	  restrict: 'E',
	  bindings: {
	    date: '<',
	    events: '<',
	    id: '<'
	  },
	  template: _calendarInline2.default,
	  controller: _calendarInline4.default
	};
	
	exports.default = calendarInlineComponent;

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"calendar-container\">\n  <calendar-component\n    class=\"{{$ctrl.format}}\"\n    options=\"$ctrl.options\"\n    on-click=\"$ctrl.clicked($event)\"\n    before-show-day=\"$ctrl.onDayRender($event)\"\n    on-hover-in=\"$ctrl.hoverIn($event)\"\n    on-hover-out=\"$ctrl.hoverOut($event)\">\n  </calendar-component>\n</div>\n"

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _periods = __webpack_require__(1359);
	
	var _periods2 = _interopRequireDefault(_periods);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarInlineController = function () {
	  CalendarInlineController.$inject = ["$scope"];
	  function CalendarInlineController($scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CalendarInlineController);
	    this.scope = $scope;
	  }
	
	  (0, _createClass3.default)(CalendarInlineController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.refreshDate();
	      this.scope.$watch(function () {
	        return _this.date;
	      }, function () {
	        if (_this.date.getTime() === _this.oldDate.getTime()) return;
	        _this.refreshDate();
	      });
	    }
	  }, {
	    key: 'refreshDate',
	    value: function refreshDate() {
	      this.month = this.date.getMonth();
	      this.year = this.date.getFullYear();
	      this.options = this._initOptions();
	      this.oldDate = this.date;
	    }
	  }, {
	    key: '_initOptions',
	    value: function _initOptions() {
	      var dateToInsert = {
	        year: this.year,
	        month: this.month,
	        day: 1
	      };
	      var option = {
	        id: this.id,
	        displayYear: false,
	        todayHighlight: true,
	        language: 'es',
	        defaultViewDate: dateToInsert
	      };
	
	      return option;
	    }
	  }, {
	    key: 'onDayRender',
	    value: function onDayRender(_ref) {
	      var date = _ref.date;
	
	      var dayInEvents = this.findDayInEvents(date);
	      return _periods2.default.getDayWithContent(date, dayInEvents);
	    }
	  }, {
	    key: 'findDayInEvents',
	    value: function findDayInEvents(date) {
	      var day = this.events.filter(function (event) {
	        return (0, _moment2.default)(event.day).isSame(date);
	      });
	      return day;
	    }
	  }]);
	  return CalendarInlineController;
	}();
	
	exports.default = CalendarInlineController;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1473);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./calendarInline.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./calendarInline.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "calendar-container{overflox-x:auto}calendar-inline{display:flex}calendar-inline calendar-component{margin-bottom:2px;background-color:#fff}calendar-inline calendar-component .datepicker-days{box-shadow:none}calendar-inline thead{display:none}calendar-inline tbody{display:-moz-flex;display:-ms-flexbox;display:flex}calendar-inline tfoot{display:none}calendar-inline tr{display:block;padding-top:15px;padding-bottom:15px;border-left:.5px solid #eaebed;box-shadow:0 1px 3px 0 hsla(220,8%,92%,.5)}calendar-inline .datepicker-days{max-height:60px;margin-bottom:0!important}calendar-inline .new,calendar-inline .old{display:none}calendar-inline .day{font-size:13px;min-width:35.9px;border-radius:0!important;border-top:1px solid #fff!important}calendar-inline .today{border:1px solid #287cba!important}calendar-inline .vacation{color:#fff!important;background-color:#52bcec!important}calendar-inline .vacation.disabled,calendar-inline .vacation.filtered{color:#666!important;background-color:#fff!important}calendar-inline .vacation.filtered .icon-approved,calendar-inline .vacation.filtered .icon-requested{display:none}calendar-inline .holiday{color:#000!important}calendar-inline .absence{color:#666!important;background-color:#fdbd2c!important}calendar-inline .absence.disabled,calendar-inline .absence.filtered{color:#666!important;background-color:#fff!important}calendar-inline .absence.filtered .icon-approved,calendar-inline .absence.filtered .icon-requested{display:none}calendar-inline .icon-approved,calendar-inline .icon-requested{font-size:20px;position:relative;top:-31px;left:31px;display:none!important;width:0!important;height:0!important;pointer-events:none;object-fit:contain}calendar-inline .icon-approved .path1:before,calendar-inline .icon-requested .path1:before{position:relative;left:-10px}calendar-inline .icon-approved .path2:before,calendar-inline .icon-approved .path3:before,calendar-inline .icon-requested .path2:before,calendar-inline .icon-requested .path3:before{position:relative;left:10px}calendar-inline .always-paint .icon-approved,calendar-inline .always-paint .icon-requested,calendar-inline .last-day .icon-approved,calendar-inline .last-day .icon-requested{display:block!important}", ""]);
	
	// exports


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarInlineHeader = __webpack_require__(1475);
	
	var _calendarInlineHeader2 = _interopRequireDefault(_calendarInlineHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarInlineHeaderModule = angular.module('vacations-absences.calendarInlineHeader', []).component('calendarInlineHeader', _calendarInlineHeader2.default).name;
	
	exports.default = calendarInlineHeaderModule;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarInlineHeader = __webpack_require__(1476);
	
	var _calendarInlineHeader2 = _interopRequireDefault(_calendarInlineHeader);
	
	var _calendarInlineHeader3 = __webpack_require__(1477);
	
	var _calendarInlineHeader4 = _interopRequireDefault(_calendarInlineHeader3);
	
	__webpack_require__(1478);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarInlineHeaderComponent = {
	  restrict: 'E',
	  bindings: {
	    date: '<',
	    id: '<'
	  },
	  template: _calendarInlineHeader2.default,
	  controller: _calendarInlineHeader4.default
	};
	
	exports.default = calendarInlineHeaderComponent;

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"days-header-container\">\n  <div class=\"dn {{day}}\"ng-repeat=\"day in $ctrl.dayNameArray track by $index\">{{day}}</div>\n</div>\n"

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarInlineHeaderController = function () {
	  CalendarInlineHeaderController.$inject = ["$rootScope", "$scope", "$timeout"];
	  function CalendarInlineHeaderController($rootScope, $scope, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CalendarInlineHeaderController);
	    this.rootScope = $rootScope;
	    this.scope = $scope;
	    this.timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(CalendarInlineHeaderController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.month = this.date.getMonth();
	      this.year = this.date.getFullYear();
	      this.momentDate = (0, _moment2.default)(this.date);
	      this.momentDate.locale('es');
	      this.monthName = this.momentDate.format('MMMM YYYY');
	      this.weekdays = this._startWeekDayNames();
	      this._initComponentDays();
	
	      this.scope.$on(_constants.EVENTS.CALENDAR_INLINE_CHANGE_DATE, function (event, args) {
	        _this._reset(args.newDate, args.idHeader);
	      });
	    }
	  }, {
	    key: '_initComponentDays',
	    value: function _initComponentDays() {
	      this.monthInDays = this._loadMonthDays(this.month, this.year);
	      this.dayNameArray = this._loadDayNames(this.monthInDays);
	    }
	  }, {
	    key: '_loadMonthDays',
	    value: function _loadMonthDays(month, year) {
	      var daysDateFormat = [];
	      var daysInMonth = this.daysInMonth(month, year);
	      for (var i = 1; i <= daysInMonth; i++) {
	        daysDateFormat.push(new Date(year, month, i));
	      }
	      return daysDateFormat;
	    }
	  }, {
	    key: '_loadDayNames',
	    value: function _loadDayNames(monthDays) {
	      var _this2 = this;
	
	      var dayNames = [];
	      monthDays.forEach(function (day) {
	        dayNames.push(_this2.weekdays[day.getDay()]);
	      });
	      return dayNames;
	    }
	  }, {
	    key: '_startWeekDayNames',
	    value: function _startWeekDayNames() {
	      //TODO Ferran I18N
	      var weekday = [];
	      weekday[1] = 'Lu';
	      weekday[2] = 'Ma';
	      weekday[3] = 'Mi';
	      weekday[4] = 'Ju';
	      weekday[5] = 'Vi';
	      weekday[6] = 'Sa';
	      weekday[0] = 'Do';
	      return weekday;
	    }
	  }, {
	    key: '_reset',
	    value: function _reset(tempDate, id) {
	      if (this.id) {
	        var isNotCurrentCalendar = !tempDate || id !== this.id[0];
	        if (isNotCurrentCalendar) {
	          return;
	        }
	      }
	
	      this.momentDate = (0, _moment2.default)(tempDate);
	      this.momentDate.locale('es');
	      this.monthName = this.momentDate.format('MMMM YYYY');
	      this.month = tempDate.getMonth();
	      this.year = tempDate.getFullYear();
	      this._initComponentDays();
	    }
	  }, {
	    key: 'daysInMonth',
	    value: function daysInMonth(month, year) {
	      var TO_MONTH_0_BASED_ARRAY = 1 + month;
	      return new Date(year, TO_MONTH_0_BASED_ARRAY, 0).getDate();
	    }
	  }]);
	  return CalendarInlineHeaderController;
	}();
	
	exports.default = CalendarInlineHeaderController;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1479);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./calendarInlineHeader.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./calendarInlineHeader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "calendar-inline-header .days-header-container{display:flex}calendar-inline-header .dn{background-color:hsla(220,8%,92%,.5);padding-left:6px;padding-top:12px;min-width:36.14px;height:40px;font-family:Stag Sans;font-size:12px;text-align:center;color:#666}calendar-inline-header .Do,calendar-inline-header .Sa{font-weight:300}calendar-inline-header .Do{border-right:1px solid #fff}", ""]);
	
	// exports


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarInlineCard = __webpack_require__(1481);
	
	var _calendarInlineCard2 = _interopRequireDefault(_calendarInlineCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarInlineCardModule = angular.module('vacations-absences.calendarInlineCard', []).component('calendarInlineCard', _calendarInlineCard2.default).name;
	
	exports.default = calendarInlineCardModule;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarInlineCard = __webpack_require__(1482);
	
	var _calendarInlineCard2 = _interopRequireDefault(_calendarInlineCard);
	
	__webpack_require__(1483);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarInlineCardComponent = {
	  restrict: 'E',
	  bindings: {
	    employee: '<',
	    inceptEmployee: '&',
	    isDisabled: '<'
	  },
	  template: _calendarInlineCard2.default
	};
	
	exports.default = calendarInlineCardComponent;

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"inline-card\">\n\n  <avatar-app name=\"$ctrl.employee.name\" email=\"$ctrl.employee.email\" user-id=\"$ctrl.employee.userId\"></avatar-app>\n  <div\n    class=\"title\"\n    ng-class=\"{'remove-pointer-events': $ctrl.isDisabled}\"\n    ng-click=\"$ctrl.inceptEmployee({$event: {employeeId : $ctrl.employee.employeeId}})\">\n      <employee-name\n        name=\"{{$ctrl.employee.name}}\"\n        enrollment=\"{{$ctrl.employee.employeeId}}\">\n      </employee-name>\n  </div>\n\n  <div class=\"day-count\">\n    <span class=\"days\">{{$ctrl.employee.daysAvailables}}\n    </span>{{ 'VACATIONS_ABSENCES.GENERAL.AVAILABLE_DAYS_CAPITALIZE' | translate }}\n  </div>\n</div>\n"

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1484);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./calendarInlineCard.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./calendarInlineCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "calendar-inline-card .inline-card{background-color:#fff;width:234px;height:60px;box-shadow:0 1px 3px 0 hsla(220,8%,92%,.5);padding-top:11px;padding-left:20px}calendar-inline-card .title{max-width:140px;max-height:17px;font-family:Stag Sans;font-size:14.5px;color:#0072c9;position:relative;bottom:38px;left:55px;cursor:pointer;text-transform:capitalize;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}calendar-inline-card .day-count{width:122.7px;height:12px;font-family:Stag Sans;font-size:12px;font-weight:300;position:relative;color:#666;bottom:35px;margin-left:55px}calendar-inline-card .day-count .days{font-weight:500}", ""]);
	
	// exports


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarInlinePaginator = __webpack_require__(1486);
	
	var _calendarInlinePaginator2 = _interopRequireDefault(_calendarInlinePaginator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarInlinePaginatorModule = angular.module('vacations-absences.calendarInlinePaginator', []).component('calendarInlinePaginator', _calendarInlinePaginator2.default).name;
	
	exports.default = calendarInlinePaginatorModule;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarInlinePaginator = __webpack_require__(1487);
	
	var _calendarInlinePaginator2 = _interopRequireDefault(_calendarInlinePaginator);
	
	var _calendarInlinePaginator3 = __webpack_require__(1488);
	
	var _calendarInlinePaginator4 = _interopRequireDefault(_calendarInlinePaginator3);
	
	__webpack_require__(1489);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarInlinePaginatorComponent = {
	  restrict: 'E',
	  bindings: {
	    date: '<',
	    id: '<',
	    nextPage: '&',
	    prevPage: '&',
	    onYearPaginationChanges: '&'
	  },
	  template: _calendarInlinePaginator2.default,
	  controller: _calendarInlinePaginator4.default
	};
	
	exports.default = calendarInlinePaginatorComponent;

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

	module.exports = "<header>\n  <span class=\"subtitle\">{{'VACATIONS_ABSENCES.TEAM_REQUESTS.COINCIDENCES.TITLE' | translate}}</span>\n  <h1>\n    <a ng-hide=\"$ctrl.hidePrevArrow()\" href=\"\" ng-click=\"$ctrl.prevMonth()\">&lt;</a>\n    <span class=\"title\">{{$ctrl.monthName}}</span>\n    <a href=\"\" ng-click=\"$ctrl.nextMonth()\">&gt;</a>\n  </h1>\n</header>\n"

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarInlinePaginatorController = function () {
	  CalendarInlinePaginatorController.$inject = ["$rootScope", "EventEmitter"];
	  function CalendarInlinePaginatorController($rootScope, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CalendarInlinePaginatorController);
	    this.rootScope = $rootScope;
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(CalendarInlinePaginatorController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.month = this.date.getMonth();
	      this.year = this.date.getFullYear();
	      this.showingYear = this.year;
	      this.momentDate = (0, _moment2.default)(this.date);
	      this.momentDate.locale('es');
	      this.monthName = this.momentDate.format('MMMM YYYY');
	      this._resetIds();
	    }
	  }, {
	    key: 'nextMonth',
	    value: function nextMonth() {
	      this.nextPage();
	      this.tempDate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
	      this._reset();
	    }
	  }, {
	    key: 'prevMonth',
	    value: function prevMonth() {
	      this.prevPage();
	      this.tempDate = new Date(this.date.getFullYear(), this.date.getMonth() - 1, 1);
	      this._reset();
	    }
	  }, {
	    key: '_reset',
	    value: function _reset() {
	      this.momentDate = (0, _moment2.default)(this.tempDate);
	      this.momentDate.locale('es');
	      this.monthName = this.momentDate.format('MMMM YYYY');
	      this.month = this.tempDate.getMonth();
	      this.year = this.tempDate.getFullYear();
	      this.checkYearChanges();
	
	      this._resetIds();
	      this._resetBindings();
	    }
	  }, {
	    key: '_resetIds',
	    value: function _resetIds() {
	      this.rowsId = this.id;
	      if (this.id) {
	        this.idCalendar = this.id[0];
	      }
	    }
	  }, {
	    key: '_resetBindings',
	    value: function _resetBindings() {
	      var _this = this;
	
	      if (!this.rowsId) {
	        return this._bindCalendarChangeEvent(this.tempDate);
	      }
	
	      this.rowsId.forEach(function (id) {
	        _this._bindCalendarChangeEvent(_this.tempDate, _this.idCalendar, id);
	      });
	    }
	  }, {
	    key: '_bindCalendarChangeEvent',
	    value: function _bindCalendarChangeEvent(newDate, idCalendar, lineCalendarId) {
	      this.rootScope.$broadcast(_constants.EVENTS.CALENDAR_INLINE_CHANGE_DATE, { newDate: newDate, id: lineCalendarId, idHeader: idCalendar });
	    }
	  }, {
	    key: 'checkYearChanges',
	    value: function checkYearChanges() {
	      if (this.year !== this.showingYear) {
	        this.onYearPaginationChanges(this.EventEmitter({ year: this.year }));
	        this.showingYear = this.year;
	      }
	    }
	  }, {
	    key: 'hidePrevArrow',
	    value: function hidePrevArrow() {
	      return this.showingYear === _constants.CALENDAR_LAST_YEAR_PAGINATION_ALLOWED && this.month === _constants.JANUARY_INDEX;
	    }
	  }]);
	  return CalendarInlinePaginatorController;
	}();
	
	exports.default = CalendarInlinePaginatorController;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1490);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./calendarInlinePaginator.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./calendarInlinePaginator.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "calendar-inline-paginator header{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;height:50px;border:1px solid #eaebed}calendar-inline-paginator header .subtitle{position:absolute;top:13px;left:24px;height:16px;font-family:Stag Sans;font-size:16px;font-weight:300;text-align:center;color:#666}calendar-inline-paginator header h1{margin:0;position:relative;display:block;top:13px;height:14px;font-family:Stag Sans;font-weight:400;text-transform:capitalize;font-size:14px;text-align:center;color:#0072c9}calendar-inline-paginator header h1 a{padding-left:5px;padding-right:5px;font-size:20px;line-height:20px;vertical-align:middle}calendar-inline-paginator header h1 a:focus,calendar-inline-paginator header h1 a:hover{text-decoration:none;background-color:inherit}calendar-inline-paginator header h1 .title{display:inline-block;width:110px}", ""]);
	
	// exports


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarInlineHide = __webpack_require__(1492);
	
	var _calendarInlineHide2 = _interopRequireDefault(_calendarInlineHide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarInlineHideModule = angular.module('vacations-absences.calendarInlineHide', []).component('calendarInlineHide', _calendarInlineHide2.default).name;
	
	exports.default = calendarInlineHideModule;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calendarInlineHide = __webpack_require__(1493);
	
	var _calendarInlineHide2 = _interopRequireDefault(_calendarInlineHide);
	
	__webpack_require__(1494);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarInlineHideComponent = {
	  restrict: 'E',
	  bindings: {
	    isHide: '<',
	    clicked: '&'
	  },
	  template: _calendarInlineHide2.default
	};
	
	exports.default = calendarInlineHideComponent;

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-hide-info-btn\" ng-click=\"$ctrl.clicked({$event: {hide: !$ctrl.isHide}})\">\n  <span class=\"text\" ng-if=\"!$ctrl.isHide\"><span class=\"icon icon-hide\"></span> {{'GLOBALS.BUTTON_ACTION.HIDE_INFO' | translate}}</span>\n  <span class=\"text\" ng-if=\"$ctrl.isHide\"><span class=\"icon icon-expand\"></span></span>\n</div>\n"

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1495);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./calendarInlineHide.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./calendarInlineHide.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "calendar-inline-hide .container{width:300px;height:40px;border:1px solid #f9f9f9;padding-left:10px}calendar-inline-hide .text{cursor:pointer;font-family:Stag Sans;font-size:13px;color:#287cba}calendar-inline-hide .icon{font-size:22px;color:#287cba;padding-right:5px;position:relative;top:5px;padding-left:20px}", ""]);
	
	// exports


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _holidaySummary = __webpack_require__(1497);
	
	var _holidaySummary2 = _interopRequireDefault(_holidaySummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var holidaySummaryModule = angular.module('vacations-absences.holidaySummary', []).component('holidaySummary', _holidaySummary2.default).name;
	
	exports.default = holidaySummaryModule;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _holidaySummary = __webpack_require__(1498);
	
	var _holidaySummary2 = _interopRequireDefault(_holidaySummary);
	
	var _holidaySummary3 = __webpack_require__(1499);
	
	var _holidaySummary4 = _interopRequireDefault(_holidaySummary3);
	
	__webpack_require__(1500);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var holidaySummaryComponent = {
	  restrict: 'E',
	  bindings: {
	    pendingDays: '<',
	    ownDays: '<',
	    christmasDays: '<',
	    lastYear: '<',
	    isInception: '<',
	    isManager: '<',
	    insertedIn: '@',
	    isMobileApp: '<'
	  },
	  template: _holidaySummary2.default,
	  controller: _holidaySummary4.default
	};
	
	exports.default = holidaySummaryComponent;

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	module.exports = "<!--Full version-->\n<div class=\"summary-container\" ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\">\n  <h4 class=\"summary-title\" ng-if=\"!$ctrl.isInception\">{{ $ctrl.titleKey | translate }}</h4>\n  <h4 class=\"summary-title\" ng-if=\"$ctrl.isInception\">{{'VACATIONS_ABSENCES.HOLIDAY_SUMMARY.DAYS_AVAILABLE_EMPLOYEE' | translate}}</h4>\n  <div class=\"summary-content\">\n    <span ng-if=\"$ctrl.hasDays('lastYear')\">{{ $ctrl.lastYear }} {{'VACATIONS_ABSENCES.GENERAL.LASTYEAR' | translate}}</span>\n    <span ng-if=\"$ctrl.hasDays('pendingDays')\">{{ $ctrl.pendingDays }} {{'VACATIONS_ABSENCES.GENERAL.AGREEMENT' | translate}}</span>\n    <span ng-if=\"$ctrl.hasDays('ownDays')\">{{ $ctrl.ownDays }} {{'VACATIONS_ABSENCES.GENERAL.FREE' | translate}}</span>\n    <span ng-if=\"$ctrl.hasDays('christmasDays')\">{{ $ctrl.christmasDays}} {{'VACATIONS_ABSENCES.GENERAL.CHRISTMAS' | translate}}</span>\n    <span ng-if=\"$ctrl.noInfo()\">{{'GLOBALS.NO_DATA' | translate}}</span>\n  </div>\n</div>\n\n<!--Dropdown version-->\n<div class=\"summary-container-dropdown dropdown\">\n  <a class=\"summary-title\" id=\"summary-manager-dropdown-label\" data-href=\"#\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">\n    <span ng-if=\"!$ctrl.isInception\">{{ $ctrl.titleKey | translate }}</span>\n    <span ng-if=\"$ctrl.isInception\">{{'VACATIONS_ABSENCES.HOLIDAY_SUMMARY.DAYS_AVAILABLE_EMPLOYEE' | translate}}</span>\n    <span class=\"icon icon-arrow-select-down\"></span>\n    <span class=\"icon icon-arrow-select-up\"></span>\n  </a>\n  <ul class=\"dropdown-menu\" aria-labelledby=\"summary-manager-dropdown-label\">\n    <li ng-if=\"$ctrl.hasDays('lastYear')\">{{ $ctrl.lastYear }} {{'VACATIONS_ABSENCES.GENERAL.LASTYEAR' | translate}}</li>\n    <li ng-if=\"$ctrl.hasDays('pendingDays')\">{{ $ctrl.pendingDays }} {{'VACATIONS_ABSENCES.GENERAL.AGREEMENT' | translate}}</li>\n    <li ng-if=\"$ctrl.hasDays('ownDays')\">{{ $ctrl.ownDays }} {{'VACATIONS_ABSENCES.GENERAL.FREE' | translate}}</li>\n    <li ng-if=\"$ctrl.hasDays('christmasDays')\">{{ $ctrl.christmasDays}} {{'VACATIONS_ABSENCES.GENERAL.CHRISTMAS' | translate}}</li>\n    <li ng-if=\"$ctrl.noInfo()\">{{'GLOBALS.NO_DATA' | translate}}</li>\n  </ul>\n</div>\n"

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var types = {
	  AGREEMENT: 'christmasDays',
	  FREE: 'ownDays',
	  CHRISTMAS: 'christmasDays',
	  LASTYEAR: 'lastYear'
	};
	
	var HolidaySummaryController = function () {
	  function HolidaySummaryController() {
	    (0, _classCallCheck3.default)(this, HolidaySummaryController);
	  }
	
	  (0, _createClass3.default)(HolidaySummaryController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titleKey = this.getTitleKey(this.watchingEmployee);
	    }
	  }, {
	    key: 'hasDays',
	    value: function hasDays(prop) {
	      return this[prop] !== null && this[prop] !== undefined && this[prop] > -1;
	    }
	  }, {
	    key: 'noInfo',
	    value: function noInfo() {
	      return !this.hasDays(types.AGREEMENT) && !this.hasDays(types.FREE) && !this.hasDays(types.CHRISTMAS) && !this.hasDays(types.CHRISTMAS);
	    }
	  }, {
	    key: 'getTitleKey',
	    value: function getTitleKey(watchingEmployee) {
	      return watchingEmployee ? 'VACATIONS_ABSENCES.HOLIDAY_SUMMARY.DAYS_AVAILABLE_EMPLOYEE' : 'VACATIONS_ABSENCES.HOLIDAY_SUMMARY.DAYS_AVAILABLE';
	    }
	  }]);
	  return HolidaySummaryController;
	}();
	
	exports.default = HolidaySummaryController;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1501);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./holidaySummary.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./holidaySummary.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "holiday-summary,holiday-summary .summary-container{display:block}holiday-summary .summary-container-dropdown{display:none}@media(max-width:1199px){holiday-summary .summary-container{display:none}holiday-summary .summary-container-dropdown{display:-moz-flex;display:-ms-flexbox;display:flex}}@media(max-width:1199px){holiday-summary.holiday-summary-header .summary-container{display:block}holiday-summary.holiday-summary-header .summary-container-dropdown{display:none}}holiday-summary .summary-container{background-color:#fff;border:1px solid #eaebed;min-height:60px;padding:12px 6px;width:400px;margin-left:-119px}holiday-summary .summary-container.responsiveMobile{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;min-height:100px;width:100%;border:none;border-bottom:1px solid #dddfe2;margin-left:0;margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px;box-sizing:border-box}holiday-summary .summary-container.responsiveMobile .summary-title{color:#666}holiday-summary .summary-title{color:#0072c9;font-family:Stag Sans;font-size:17px;font-weight:400;margin:0;text-align:center}holiday-summary .summary-content{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;color:#666;font-family:Stag Sans;font-size:12px;font-weight:400;margin-left:auto;margin-right:auto;margin-top:5px;width:100%;gap:6px 0;text-align:center}holiday-summary .summary-content span{border-right:1px solid #666;line-height:11px;margin-right:7px;padding-right:7px}holiday-summary .summary-content span:last-child{border:none;padding-right:0;margin-right:0}holiday-summary .summary-container-dropdown{-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:148px;height:37px;background-color:#fff;border:1px solid #dddfe2;padding:0;line-height:35px;padding-left:9px}holiday-summary .summary-container-dropdown.dropdown .icon{position:absolute;top:12px;right:10px;font-weight:100;font-size:11px;color:#0072c9;cursor:pointer}holiday-summary .summary-container-dropdown.dropdown .icon-arrow-select-down{display:inline-block}holiday-summary .summary-container-dropdown.dropdown .icon-arrow-select-up{display:none}holiday-summary .summary-container-dropdown.dropdown.open{border:1px solid #287cba}holiday-summary .summary-container-dropdown.dropdown.open .icon-arrow-select-down{display:none}holiday-summary .summary-container-dropdown.dropdown.open .icon-arrow-select-up{display:inline-block}holiday-summary .summary-container-dropdown .dropdown-menu{min-width:148px;max-width:148px;min-height:71px;max-height:77px;border-radius:0;border:1px solid #eaebed;box-shadow:none;padding:10px 9px;margin-left:-1px;margin-top:1px}holiday-summary .summary-container-dropdown .dropdown-menu li{font-family:Stag Sans;font-size:12px;height:16px;line-height:16px;color:#666}holiday-summary .summary-container-dropdown .summary-title{font-family:Stag Sans;font-size:13px;color:#0072c9;text-transform:uppercase;text-decoration:none!important;display:inline-block;line-height:1;text-align:left}holiday-summary .summary-container-dropdown .summary-title:hover{color:#0072c9;background:#fff}", ""]);
	
	// exports


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warnLastDay = __webpack_require__(1503);
	
	var _warnLastDay2 = _interopRequireDefault(_warnLastDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warnLastDayModule = angular.module('vacations-absences.warnLastDay', []).component('warnLastDay', _warnLastDay2.default).name;
	
	exports.default = warnLastDayModule;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warnLastDay = __webpack_require__(1504);
	
	var _warnLastDay2 = _interopRequireDefault(_warnLastDay);
	
	var _warnLastDay3 = __webpack_require__(1505);
	
	var _warnLastDay4 = _interopRequireDefault(_warnLastDay3);
	
	__webpack_require__(1506);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warnLastDayComponent = {
	  restrict: 'E',
	  bindings: {
	    date: '<',
	    isMobileApp: '<'
	  },
	  template: _warnLastDay2.default,
	  controller: _warnLastDay4.default
	};
	
	exports.default = warnLastDayComponent;

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"warn-last-day\" ng-show=\"!$ctrl.hideWarningCard\">\n  <span class=\"icon icon-warning\"></span>\n  <p class=\"warn-last-day-message\">\n    {{'VACATIONS_ABSENCES.WARNING_REQUEST_VACATION.HOME_MESSAGE' | translate}} {{$ctrl.date}}\n  </p>\n  <span class=\"icon-cross-blue\"\n        ng-if=\"$ctrl.isMobileApp\"\n        ng-click=\"$ctrl.hideWarningVacation()\">\n  </span>\n</div>\n"

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WarnLastDayController = function () {
	  function WarnLastDayController() {
	    (0, _classCallCheck3.default)(this, WarnLastDayController);
	
	    this.hideWarningCard = false;
	  }
	
	  (0, _createClass3.default)(WarnLastDayController, [{
	    key: "hideWarningVacation",
	    value: function hideWarningVacation() {
	      this.hideWarningCard = true;
	    }
	  }]);
	  return WarnLastDayController;
	}();
	
	exports.default = WarnLastDayController;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1507);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./warnLastDay.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./warnLastDay.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "warn-last-day.responsiveMobile{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;padding-top:10px}warn-last-day.responsiveMobile .warn-last-day{-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;height:70px;width:90%;min-width:0;border-radius:8px;padding:0}warn-last-day.responsiveMobile .icon-cross-blue{padding:10px}warn-last-day.responsiveMobile .icon-cross-blue:before{color:#c8175e!important}warn-last-day.responsiveMobile .icon-warning{padding:10px}warn-last-day .warn-last-day{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:center;-moz-align-items:center;align-items:center;border:.5px solid #c8175e;width:263px;height:140px;padding:19px 27px}warn-last-day .warn-last-day .icon-warning{color:#c8175e;font-size:35px}warn-last-day .warn-last-day .warn-last-day-message{margin-top:13px;font-size:13px;font-family:ArialMT;color:#666;text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _employeeAfk = __webpack_require__(1509);
	
	var _employeeAfk2 = _interopRequireDefault(_employeeAfk);
	
	var _employeeAfk3 = __webpack_require__(1514);
	
	var _employeeAfk4 = _interopRequireDefault(_employeeAfk3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeAfkModule = angular.module('vacations-absences.employeeAfk', []).component('employeeAfk', _employeeAfk2.default).service('employeeAfkService', _employeeAfk4.default).name;
	
	exports.default = employeeAfkModule;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _employeeAfk = __webpack_require__(1510);
	
	var _employeeAfk2 = _interopRequireDefault(_employeeAfk);
	
	var _employeeAfk3 = __webpack_require__(1511);
	
	var _employeeAfk4 = _interopRequireDefault(_employeeAfk3);
	
	__webpack_require__(1512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeAfkComponent = {
	  restrict: 'E',
	  bindings: {
	    userId: '@',
	    hasDelegated: '<',
	    delegation: '<',
	    sendIncept: '&',
	    isDisabled: '<'
	  },
	  template: _employeeAfk2.default,
	  controller: _employeeAfk4.default
	};
	
	exports.default = employeeAfkComponent;

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dropdown\">\n\n  <a\n    class=\"employee-afk-title\"\n    id=\"dLabel\"\n    data-href=\"#\"\n    data-toggle=\"dropdown\"\n    role=\"button\"\n    aria-haspopup=\"true\"\n    aria-expanded=\"false\"\n    ng-disabled=\"!$ctrl.employees || $ctrl.employees.length === 0\">\n    <span class=\"number\">{{ $ctrl.employeesNumber }}</span>\n    <span class=\"long-title\">{{ 'VACATIONS_ABSENCES.EMPLOYEE_AFK.TITLE' | translate }}</span>\n    <span class=\"short-title\">{{ 'VACATIONS_ABSENCES.EMPLOYEE_AFK.SHORT_TITLE' | translate }}</span>\n    <span class=\"icon icon-arrow-select-down\"></span>\n    <span class=\"icon icon-arrow-select-up\"></span>\n  </a>\n\n  <employee-dropdown-list\n    is-disabled=\"$ctrl.isDisabled\"\n    class=\"dropdown-menu dropdown-menu-right\"\n    on-select-employee=\"$ctrl.onSelectEmployee($event)\"\n    ng-if=\"$ctrl.employees && $ctrl.employees.length > 0\"\n    employees=\"$ctrl.employees\"\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    limit-results=\"1000\">\n  </employee-dropdown-list>\n\n  <modal-warning-delegation\n    ng-if=\"$ctrl.hasDelegated\"\n    title-body=\"{{ 'VACATIONS_ABSENCES.MAIN.WARNING_DELEGATION_TITLE' | translate }}\"\n    delegation=\"$ctrl.delegation\"\n    url-destination=\"$ctrl.urlDestination\">\n  </modal-warning-delegation>\n\n</div>\n"

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeAfkController = function () {
	  EmployeeAfkController.$inject = ["employeeAfkService", "$state", "EventEmitter"];
	  function EmployeeAfkController(employeeAfkService, $state, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, EmployeeAfkController);
	    this.employeeAfkService = employeeAfkService;
	    this.state = $state;
	    this.eventEmitter = EventEmitter;
	    this.employees = [];
	    this.employeesNumber = '00';
	  }
	
	  (0, _createClass3.default)(EmployeeAfkController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.urlDestination = _states.STATES.VACATIONS_ABSENCES.DELEGATE;
	      this._initData();
	    }
	  }, {
	    key: '_initData',
	    value: function _initData() {
	      var _this = this;
	
	      this.employeeAfkService.getEmployeesAfk(this.userId).then(function (_ref) {
	        var employees = _ref.employees,
	            employeesNumber = _ref.employeesNumber;
	
	        _this.employees = employees;
	        _this.employeesNumber = employeesNumber;
	      });
	    }
	  }, {
	    key: 'onSelectEmployee',
	    value: function onSelectEmployee($event) {
	      if (this.hasDelegated) {
	        return this._showModalWarningDelegation();
	      }
	
	      var from = this.getStateNested(this.state.current.name) || '';
	      this.sendIncept(this.eventEmitter({ from: from, employee: $event.employeeId }));
	    }
	  }, {
	    key: '_showModalWarningDelegation',
	    value: function _showModalWarningDelegation() {
	      this.modalWarningDelegation.modal('show');
	    }
	  }, {
	    key: 'getStateNested',
	    value: function getStateNested(state) {
	      return state.split(_states.STATES.VACATIONS_ABSENCES.ROOT + '.')[1] || '';
	    }
	  }, {
	    key: 'modalWarningDelegation',
	    get: function get() {
	      var $modal = $(_constants.MODALS.WARNING_DELEGATION_MODAL);
	      return $modal;
	    }
	  }]);
	  return EmployeeAfkController;
	}();
	
	exports.default = EmployeeAfkController;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1513);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./employeeAfk.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./employeeAfk.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "employee-afk{display:inline-block;top:9px;position:relative;float:right;margin-right:-15px}employee-afk .dropdown{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:300px;height:37px;border-radius:2px;background-color:#fff;box-shadow:0 1px 4px 0 #eaebed;border:1px solid #dddfe2}@media(max-width:1050px){employee-afk .dropdown{width:148px}}employee-afk .dropdown .employee-afk-title{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:center;-moz-align-items:center;align-items:center;font-family:Stag Sans;font-size:13px;color:#666;text-transform:uppercase;text-decoration:none!important;line-height:1;text-align:left}employee-afk .dropdown .employee-afk-title[disabled]{cursor:not-allowed;pointer-events:none}employee-afk .dropdown .employee-afk-title .short-title{display:none}@media(max-width:1050px){employee-afk .dropdown .employee-afk-title .long-title{display:none}employee-afk .dropdown .employee-afk-title .short-title{display:inline-block;width:90px}}employee-afk .dropdown .employee-afk-title .number{font-size:18px;display:inline-block;margin-left:14px;margin-right:8px;color:#0072c9}employee-afk .dropdown .employee-afk-title:hover{color:#0072c9;background:#fff}employee-afk .dropdown.open{border:1px solid #287cba}employee-afk .dropdown.open .employee-afk-title{color:#0072c9}employee-afk .dropdown.open .icon-arrow-select-down{display:none}employee-afk .dropdown.open .icon-arrow-select-up{display:inline-block}employee-afk .dropdown .icon{position:absolute;top:12px;right:10px;font-weight:100;font-size:11px;color:#0072c9;cursor:pointer}employee-afk .dropdown .icon-arrow-select-down{display:inline-block}employee-afk .dropdown .icon-arrow-select-up{display:none}employee-afk employee-dropdown-list.dropdown-menu{padding:0;margin:1px 0 0 -1px;border:0;height:302px;overflow-y:scroll;overflow-x:hidden;max-width:298px}", ""]);
	
	// exports


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vacationsAbsences = __webpack_require__(1120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeAfkService = function () {
	  EmployeeAfkService.$inject = ["$http", "$log"];
	  function EmployeeAfkService($http, $log) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, EmployeeAfkService);
	    this.$http = $http;
	    this.$log = $log;
	  }
	
	  (0, _createClass3.default)(EmployeeAfkService, [{
	    key: 'getEmployeesAfk',
	    value: function getEmployeesAfk(managerId) {
	      var _this = this;
	
	      var year = new Date().getFullYear();
	      return this.$http.get(_vacationsAbsences.ENDPOINTS_MANAGER.get.initial(managerId, year)).then(function (response) {
	        try {
	          var employees = response.data.employeesOutOffice.employees;
	          var employeesNumber = _this._parseNumber(response.data.employeesOutOffice.employeesNumber);
	          return { employees: employees, employeesNumber: employeesNumber };
	        } catch (error) {
	          return _this.$log.error('EmployeeAfkService.getEmployeesAfk:', error);
	        }
	      }).catch(function (response) {
	        return _this.$log.error('EmployeeAfkService.getEmployeesAfk:', response);
	      });
	    }
	  }, {
	    key: '_parseNumber',
	    value: function _parseNumber(rawNumber) {
	      var employeesLength = parseInt(rawNumber, 10);
	      return employeesLength < 10 ? '0' + rawNumber : rawNumber;
	    }
	  }]);
	  return EmployeeAfkService;
	}();
	
	exports.default = EmployeeAfkService;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _employeeSearchTags = __webpack_require__(1516);
	
	var _employeeSearchTags2 = _interopRequireDefault(_employeeSearchTags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeSearchTagsModule = angular.module('vacations-absences.employeeSearchTags', []).component('employeeSearchTags', _employeeSearchTags2.default).name;
	
	exports.default = employeeSearchTagsModule;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _employeeSearchTags = __webpack_require__(1517);
	
	var _employeeSearchTags2 = _interopRequireDefault(_employeeSearchTags);
	
	var _employeeSearchTags3 = __webpack_require__(1518);
	
	var _employeeSearchTags4 = _interopRequireDefault(_employeeSearchTags3);
	
	__webpack_require__(1519);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeSearchTagsComponent = {
	  restrict: 'E',
	  bindings: {
	    employeeFilters: '<',
	    onRemoveEmployeeFilter: '&',
	    onCleanEmployeeFilters: '&'
	  },
	  template: _employeeSearchTags2.default,
	  controller: _employeeSearchTags4.default
	};
	
	exports.default = employeeSearchTagsComponent;

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"employeeSearchTags\" ng-if=\"$ctrl.employeeFilters && $ctrl.employeeFilters.length > 0\">\n\n  <div\n    class=\"employeeSearchTagsTag\"\n    ng-repeat=\"employee in $ctrl.employeeFilters track by $index\">\n    <span class=\"name\">{{employee.name}}</span>\n    <i class=\"icon icon-cross\" ng-click=\"$ctrl.removeEmployeeFilter(employee)\"></i>\n  </div>\n\n  <div class=\"employeeSearchTagsClean\" ng-click=\"$ctrl.cleanEmployeeFilters()\">\n    <span>{{'GLOBALS.BUTTON_ACTION.CLEAN' | translate}}</span>\n    <span class=\"icon icon-cross\"></span>\n  </div>\n\n</div>\n"

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeSearchTagsController = function () {
	  EmployeeSearchTagsController.$inject = ["EventEmitter"];
	  function EmployeeSearchTagsController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, EmployeeSearchTagsController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(EmployeeSearchTagsController, [{
	    key: 'removeEmployeeFilter',
	    value: function removeEmployeeFilter(employee) {
	      this.onRemoveEmployeeFilter(this.EventEmitter(employee));
	    }
	  }, {
	    key: 'cleanEmployeeFilters',
	    value: function cleanEmployeeFilters() {
	      this.onCleanEmployeeFilters();
	    }
	  }]);
	  return EmployeeSearchTagsController;
	}();
	
	exports.default = EmployeeSearchTagsController;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1520);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./employeeSearchTags.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./employeeSearchTags.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "employee-search-tags{display:block;min-height:70px;width:100%}employee-search-tags .employeeSearchTags{-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;min-height:70px;padding:20px 0}employee-search-tags .employeeSearchTags .employeeSearchTagsTag{width:170px;height:30px;border-radius:100px;background-color:#0072c9;line-height:30px;position:relative;margin-right:12px;min-width:166px;float:left;margin-bottom:12px}employee-search-tags .employeeSearchTags .employeeSearchTagsTag span{color:#fff}employee-search-tags .employeeSearchTags .employeeSearchTagsTag span.name{font-family:Stag Sans;font-size:11px;font-weight:500;color:#fff;display:inline-block;padding-left:12px;text-transform:uppercase;max-width:145px;white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis}employee-search-tags .employeeSearchTags .employeeSearchTagsTag i.icon-cross{color:#fff;position:absolute;right:8px;top:10px;font-size:11px;cursor:pointer}employee-search-tags .employeeSearchTags .employeeSearchTagsClean{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:170px;height:30px;background-color:#fff;position:relative;margin-left:6px;cursor:pointer}employee-search-tags .employeeSearchTags .employeeSearchTagsClean span{font-family:Stag Sans;font-size:13px;font-weight:300;color:#666;display:inline-block;margin-right:5px}employee-search-tags .employeeSearchTags .employeeSearchTagsClean span:not(.icon-cross){height:16px}employee-search-tags .employeeSearchTags .employeeSearchTagsClean span.icon-cross{color:#aeaeae;font-size:11px}", ""]);
	
	// exports


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _sicknessLeaveDate = __webpack_require__(1522);
	
	var _sicknessLeaveDate2 = _interopRequireDefault(_sicknessLeaveDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sicknessLeaveDateModule = _angular2.default.module('sicknessLeaveDate', [
	  //uiRouter
	]).component('sicknessLeaveDate', _sicknessLeaveDate2.default).name;
	//import uiRouter from 'angular-ui-router';
	exports.default = sicknessLeaveDateModule;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sicknessLeaveDate = __webpack_require__(1523);
	
	var _sicknessLeaveDate2 = _interopRequireDefault(_sicknessLeaveDate);
	
	var _sicknessLeaveDate3 = __webpack_require__(1524);
	
	var _sicknessLeaveDate4 = _interopRequireDefault(_sicknessLeaveDate3);
	
	__webpack_require__(1525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sicknessLeaveDateComponent = {
	  restrict: 'E',
	  bindings: {
	    isRelapse: '<',
	    isCreateSickness: '&',
	    sicknessStartDate: '<',
	    initLeaveDateKnown: '<',
	    datepickLeaveDateKnown: '&',
	    sicknessLeaveDateKnownReasons: '<',
	    selectSicknessLeaveDateKnownReason: '&',
	    setLeaveDateSendStatus: '&',
	    minDate: '<',
	    isMobileApp: '<'
	  },
	  template: _sicknessLeaveDate2.default,
	  controller: _sicknessLeaveDate4.default
	};
	
	exports.default = sicknessLeaveDateComponent;

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"$ctrl.getClassWhenRelapseIsActive()\"\n     ng-show=\"$ctrl.isCreateSickness()\">\n  <div class=\"row\">\n    <div class=\"col-xs-6\">\n      <div class=\"checkbox on-right\">\n        <input type=\"checkbox\"\n              id=\"sicknessLeaveDateKnownCheck\"\n              ng-model=\"$ctrl.sicknessLeaveDateKnownCheck\"\n              ng-change=\"$ctrl.onChangeLeaveDateCheckbox()\">\n        <label for=\"sicknessLeaveDateKnownCheck\">{{ 'VACATIONS_ABSENCES.REQUEST_MODAL.SICKNESS_LEAVE_DATE_CHECK' | translate }}</label>\n      </div>\n    </div>\n    <div class=\"col-xs-6\">\n      <input-datepicker\n        ng-show=\"$ctrl.sicknessLeaveDateKnownCheck\"\n        is-mobile-app=\"$ctrl.isMobileApp\"\n        name=\"sicknessLeaveDate\"\n        start-date=\"$ctrl.sicknessStartDate\"\n        init-date=\"$ctrl.initLeaveDateKnown\"\n        is-required=\"$ctrl.sicknessLeaveDateKnownCheck && $ctrl.isCreateSickness()\"\n        class=\"pull-left\"\n        on-datepick=\"$ctrl.onDatepickLeaveDateKnown($event);\"\n        label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.SICKNESS_LEAVE_DATE' | translate}}\"\n        min-date=\"$ctrl.minSicknessLeaveDate\"></input-datepicker>\n    </div>\n  </div>\n\n  <div\n    class=\"row\"\n    ng-if=\"$ctrl.sicknessLeaveDateKnownCheck\">\n    <div class=\"col-xs-12\">\n      <select-app\n        class=\"sickness-reason-select\"\n        name=\"sicknessLeaveDateKnownReason\"\n        options=\"$ctrl.sicknessLeaveDateKnownReasons\"\n        disabled=\"!$ctrl.sicknessLeaveDateKnownReasons || $ctrl.sicknessLeaveDateKnownReasons.length === 0\"\n        label=\"{{'VACATIONS_ABSENCES.REQUEST_MODAL.LEAVE_SICKNESS_REASON' | translate}}\"\n        required=\"$ctrl.sicknessLeaveDateKnownCheck && $ctrl.isCreateSickness()\"\n        on-select=\"$ctrl.onSelectSicknessLeaveDateKnownReason($event);\"\n        in-two-lines=\"true\"></select-app>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SicknessLeaveDateController = function () {
	  SicknessLeaveDateController.$inject = ["EventEmitter", "$scope"];
	  function SicknessLeaveDateController(EventEmitter, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SicknessLeaveDateController);
	    this.eventEmitter = EventEmitter;
	    this.scope = $scope;
	    this.sicknessLeaveDateKnownCheck = false;
	  }
	
	  (0, _createClass3.default)(SicknessLeaveDateController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.setMinDateInMobile();
	    }
	  }, {
	    key: 'setMinDateInMobile',
	    value: function setMinDateInMobile() {
	      var _this = this;
	
	      if (this.isMobileApp) {
	        this.scope.$watch(function () {
	          return _this.minDate;
	        }, function () {
	          _this.minSicknessLeaveDate = _this.minDate;
	        });
	      }
	    }
	  }, {
	    key: 'getClassWhenRelapseIsActive',
	    value: function getClassWhenRelapseIsActive() {
	      return {
	        'leave-date-known-form': this.isRelapse && !this.isMobileApp,
	        'leave-date-known-form mobile': this.isRelapse && this.isMobileApp,
	        'responsiveMobile': !this.isRelapse && this.isMobileApp
	      };
	    }
	  }, {
	    key: 'onDatepickLeaveDateKnown',
	    value: function onDatepickLeaveDateKnown($event) {
	      this.datepickLeaveDateKnown(this.eventEmitter({ date: $event.date }));
	    }
	  }, {
	    key: 'onChangeLeaveDateCheckbox',
	    value: function onChangeLeaveDateCheckbox() {
	      this.setLeaveDateSendStatus(this.eventEmitter({ selected: this.sicknessLeaveDateKnownCheck }));
	    }
	  }, {
	    key: 'onSelectSicknessLeaveDateKnownReason',
	    value: function onSelectSicknessLeaveDateKnownReason($event) {
	      this.selectSicknessLeaveDateKnownReason(this.eventEmitter({ value: $event.$item.value }));
	    }
	  }]);
	  return SicknessLeaveDateController;
	}();
	
	exports.default = SicknessLeaveDateController;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1526);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./sicknessLeaveDate.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./sicknessLeaveDate.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "sickness-leave-date .leave-date-known-form{margin-top:35px}", ""]);
	
	// exports


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inception = __webpack_require__(1528);
	
	var _inception2 = _interopRequireDefault(_inception);
	
	var _teamRequestData = __webpack_require__(1529);
	
	var _teamRequestData2 = _interopRequireDefault(_teamRequestData);
	
	var _vacationsUserData = __webpack_require__(1530);
	
	var _vacationsUserData2 = _interopRequireDefault(_vacationsUserData);
	
	var _employeeRepository = __webpack_require__(1543);
	
	var _employeeRepository2 = _interopRequireDefault(_employeeRepository);
	
	var _initialData = __webpack_require__(1547);
	
	var _initialData2 = _interopRequireDefault(_initialData);
	
	var _managerRepository = __webpack_require__(1548);
	
	var _managerRepository2 = _interopRequireDefault(_managerRepository);
	
	var _initialDataManager = __webpack_require__(1551);
	
	var _initialDataManager2 = _interopRequireDefault(_initialDataManager);
	
	var _vacationDelegationRepository = __webpack_require__(1552);
	
	var _vacationDelegationRepository2 = _interopRequireDefault(_vacationDelegationRepository);
	
	var _periods = __webpack_require__(1298);
	
	var _periods2 = _interopRequireDefault(_periods);
	
	var _modalsBehaviour = __webpack_require__(1556);
	
	var _modalsBehaviour2 = _interopRequireDefault(_modalsBehaviour);
	
	var _teamCalendar = __webpack_require__(1557);
	
	var _teamCalendar2 = _interopRequireDefault(_teamCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationsAbsencesCommon = angular.module('vacations-absences.common', []).service('inceptionService', _inception2.default).service('vacationTeamRequestDataService', _teamRequestData2.default).service('vacationUserDataService', _vacationsUserData2.default).service('vacationInitialDataService', _initialData2.default).service('vacationEmployeeRepositoryService', _employeeRepository2.default).service('vacationManagerRepositoryService', _managerRepository2.default).service('vacationInitialDataManagerService', _initialDataManager2.default).service('vacationDelegationService', _vacationDelegationRepository2.default).service('modalsBehaviourService', _modalsBehaviour2.default).service('teamCalendarService', _teamCalendar2.default).filter('filterPeriods', _periods2.default).name;
	
	exports.default = vacationsAbsencesCommon;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _routes = __webpack_require__(1040);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INCEPTION = {
	  DESKTOP: '' + _routes.ROUTES.VACATIONS_ABSENCES.ROOT + _routes.ROUTES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR,
	  MOBILE: '' + _routes.ROUTES.VACATIONS_ABSENCES.ROOT + _routes.ROUTES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR_MOBILE
	};
	
	var InceptionService = function () {
	  InceptionService.$inject = ["$location", "$window"];
	  function InceptionService($location, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, InceptionService);
	    this.location = $location;
	    this.isMobileApp = $window.innerWidth < 1024;
	  }
	
	  (0, _createClass3.default)(InceptionService, [{
	    key: 'incept',
	    value: function incept(employeeId, from) {
	      var url = this.getUrl();
	      url = this.setEmployeeId(url, employeeId);
	      url = this.setFrom(url, from);
	      this.location.url(url);
	    }
	  }, {
	    key: 'getUrl',
	    value: function getUrl() {
	      var url = this.isMobileApp ? INCEPTION.MOBILE : INCEPTION.DESKTOP;
	      return url;
	    }
	  }, {
	    key: 'setEmployeeId',
	    value: function setEmployeeId(url, employeeId) {
	      return url.replace(':employeeId', employeeId);
	    }
	  }, {
	    key: 'setFrom',
	    value: function setFrom(url, from) {
	      if (from) {
	        url += '=' + from;
	      }
	
	      return url;
	    }
	  }]);
	  return InceptionService;
	}();
	
	exports.default = InceptionService;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamRequestDataService = function () {
	  function TeamRequestDataService() {
	    (0, _classCallCheck3.default)(this, TeamRequestDataService);
	  }
	
	  (0, _createClass3.default)(TeamRequestDataService, [{
	    key: "setData",
	    value: function setData(data) {
	      this._data = data;
	    }
	  }, {
	    key: "getData",
	    value: function getData() {
	      return this._data;
	    }
	  }, {
	    key: "clean",
	    value: function clean() {
	      this._data = undefined;
	    }
	  }, {
	    key: "isEmpty",
	    value: function isEmpty() {
	      return this._data === undefined;
	    }
	  }]);
	  return TeamRequestDataService;
	}();
	
	exports.default = TeamRequestDataService;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1531);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1534);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1535);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _userDataService = __webpack_require__(567);
	
	var _userDataService2 = _interopRequireDefault(_userDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VacationUserDataService = function (_UserDataService) {
	  (0, _inherits3.default)(VacationUserDataService, _UserDataService);
	
	  function VacationUserDataService() {
	    (0, _classCallCheck3.default)(this, VacationUserDataService);
	    return (0, _possibleConstructorReturn3.default)(this, (VacationUserDataService.__proto__ || (0, _getPrototypeOf2.default)(VacationUserDataService)).call(this));
	  }
	
	  (0, _createClass3.default)(VacationUserDataService, [{
	    key: 'getVacationTypes',
	    value: function getVacationTypes() {
	      return this._employee.vacationTypes;
	    }
	  }, {
	    key: 'getAbsenceTypes',
	    value: function getAbsenceTypes() {
	      return this._employee.absenceTypes;
	    }
	  }, {
	    key: 'getMatPatPeriods',
	    value: function getMatPatPeriods() {
	      return this._employee.maternityPaternityLeavePeriods;
	    }
	  }, {
	    key: 'getDischargeReasons',
	    value: function getDischargeReasons() {
	      return this._employee.dischargeReasons;
	    }
	  }]);
	  return VacationUserDataService;
	}(_userDataService2.default);
	
	exports.default = VacationUserDataService;

/***/ }),
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vacationsAbsences = __webpack_require__(1120);
	
	var _employeeRepository = __webpack_require__(1544);
	
	var _employeeRepository2 = _interopRequireDefault(_employeeRepository);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeRepositoryService = function () {
	  employeeRepositoryService.$inject = ["$http", "$window"];
	  function employeeRepositoryService($http, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, employeeRepositoryService);
	    this.http = $http;
	    this.isMobileApp = $window.innerWidth < 1024;
	  }
	
	  (0, _createClass3.default)(employeeRepositoryService, [{
	    key: 'getEmployee',
	    value: function getEmployee(employeeId, year, userInceptionId) {
	      var endpoint = _vacationsAbsences.ENDPOINTS_EMPLOYEE.get.initial(employeeId, year);
	      if (userInceptionId) {
	        endpoint = _vacationsAbsences.ENDPOINTS_MANAGER.get.initialEmployee(employeeId, userInceptionId, year);
	      }
	      return this.http.get(endpoint).then(function (response) {
	        var employeeData = response.data;
	        return _employeeRepository2.default.assemble(employeeId, employeeData);
	      });
	    }
	  }]);
	  return employeeRepositoryService;
	}();
	
	exports.default = employeeRepositoryService;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _profile = __webpack_require__(1172);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _vacationsAbsencesUser = __webpack_require__(1545);
	
	var _vacationsAbsencesUser2 = _interopRequireDefault(_vacationsAbsencesUser);
	
	var _formatter = __webpack_require__(1362);
	
	var _formatter2 = _interopRequireDefault(_formatter);
	
	var _error = __webpack_require__(1361);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _periods = __webpack_require__(1359);
	
	var _periods2 = _interopRequireDefault(_periods);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function assembleProfile(data) {
	  var profile = new _profile2.default();
	  profile.name = data.name;
	  profile.email = data.email;
	  profile.userId = data.enrolment;
	  if (data.manager) {
	    profile.role = _profile2.default.ROLE_MANAGER;
	  }
	  if (data.bbvaUserId) {
	    profile.bbvaUserId = data.bbvaUserId;
	  }
	
	  if (data.delegations && data.delegations.hasDelegation) {
	    profile.delegation = data.delegations.hasDelegation;
	  }
	
	  return profile;
	}
	
	var employeeDataAssembler = function () {
	  function employeeDataAssembler() {
	    (0, _classCallCheck3.default)(this, employeeDataAssembler);
	  }
	
	  (0, _createClass3.default)(employeeDataAssembler, null, [{
	    key: 'assemble',
	    value: function assemble(userId, data) {
	      var profile = void 0;
	      (0, _error2.default)(function () {
	        profile = assembleProfile(data.profile);
	      }, _formatter2.default.ASSEMBLE_PROFILE);
	      var user = new _vacationsAbsencesUser2.default(userId, profile);
	      user.absenceTypes = data.absenceTypes || [];
	      user.dischargeReasons = data.dischargeReasons || [];
	      user.vacationTypes = data.vacationTypes || [];
	      user.vacationPeriods = data.vacationPeriods || [];
	      user.absencePeriods = data.absencePeriods || [];
	      user.maternityPaternityLeavePeriods = data.maternityPaternityLeavePeriods || [];
	      user.nationalHolidays = data.nationalHolidays || [];
	      user.localHolidays = data.localHolidays || [];
	      user.holidays = _periods2.default.formatHolidays(user.nationalHolidays, user.localHolidays);
	      user.allPeriods = _periods2.default.formatAllPeriods(user.absencePeriods, user.vacationPeriods, user.holidays);
	      user.availableVacations = _periods2.default.formatAvailableVacations(data.summaryAvailableVacations);
	      user.periodInDays = _periods2.default.formatPeriodInDays(user.allPeriods);
	      return user;
	    }
	  }]);
	  return employeeDataAssembler;
	}();
	
	exports.default = employeeDataAssembler;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1531);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1534);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1535);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _user = __webpack_require__(1546);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _periods = __webpack_require__(1359);
	
	var _periods2 = _interopRequireDefault(_periods);
	
	var _availableDayTypes = __webpack_require__(1145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationsAbsencesUser = function (_User) {
	  (0, _inherits3.default)(vacationsAbsencesUser, _User);
	
	  function vacationsAbsencesUser(userId, profile) {
	    (0, _classCallCheck3.default)(this, vacationsAbsencesUser);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (vacationsAbsencesUser.__proto__ || (0, _getPrototypeOf2.default)(vacationsAbsencesUser)).call(this, userId, profile));
	
	    _this.absenceTypes = [];
	    _this.vacationTypes = [];
	    _this.vacationPeriods = [];
	    _this.absencePeriods = [];
	    _this.nationalHolidays = [];
	    _this.localHolidays = [];
	    _this.holidays = [];
	    _this.allPeriods = [];
	    _this.availableVacations = [];
	    _this.periodInDays = [];
	    _this.maternityPaternityLeavePeriods = [];
	    return _this;
	  }
	
	  (0, _createClass3.default)(vacationsAbsencesUser, [{
	    key: 'addPeriod',
	    value: function addPeriod(period) {
	      this.allPeriods.push(period);
	      this._periodInDays = _periods2.default.formatPeriodInDays(this.allPeriods);
	      return this._periodInDays;
	    }
	  }, {
	    key: 'getAgreementVacationCount',
	    value: function getAgreementVacationCount() {
	      return this.vacationPeriods.filter(function (periode) {
	        return periode.availableDayType === _availableDayTypes.AvailableDay.TYPES.AGREEMENT;
	      }).length;
	    }
	  }, {
	    key: 'getPeriodById',
	    value: function getPeriodById(periodId) {
	      return this.allPeriods[periodId];
	    }
	  }]);
	  return vacationsAbsencesUser;
	}(_user2.default);
	
	exports.default = vacationsAbsencesUser;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _profile = __webpack_require__(1172);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = function () {
	  function User(userId, profile) {
	    (0, _classCallCheck3.default)(this, User);
	
	    this.userId = userId;
	    this._profile = profile;
	  }
	
	  (0, _createClass3.default)(User, [{
	    key: 'getProfile',
	    value: function getProfile() {
	      return this._profile;
	    }
	  }, {
	    key: 'isManager',
	    value: function isManager() {
	      return this._profile.role === _profile2.default.ROLE_MANAGER;
	    }
	  }, {
	    key: 'hasDelegation',
	    value: function hasDelegation() {
	      return !!this._profile.delegation;
	    }
	  }]);
	  return User;
	}();
	
	exports.default = User;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitialDataService = function () {
	  InitialDataService.$inject = ["$http", "AuthenticationService", "$state", "vacationUserDataService", "vacationEmployeeRepositoryService"];
	  function InitialDataService($http, AuthenticationService, $state, vacationUserDataService, vacationEmployeeRepositoryService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, InitialDataService);
	    this.$http = $http;
	    this.employeeRepositoryService = vacationEmployeeRepositoryService;
	    this.state = $state;
	    this.userDataService = vacationUserDataService;
	    this.year = new Date().getFullYear();
	    this.employeeId = AuthenticationService.getEmployeeId();
	  }
	
	  (0, _createClass3.default)(InitialDataService, [{
	    key: 'initMainData',
	    value: function initMainData() {
	      var _this = this;
	
	      return this.employeeRepositoryService.getEmployee(this.employeeId, this.year).then(function (employee) {
	        _this.userDataService.setEmployee(employee);
	        _this.manager = employee.isManager();
	        _this.hasDelegation = employee.hasDelegation();
	        return employee;
	      });
	    }
	  }]);
	  return InitialDataService;
	}();
	
	exports.default = InitialDataService;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vacationsAbsences = __webpack_require__(1120);
	
	var _managerRepository = __webpack_require__(1549);
	
	var _managerRepository2 = _interopRequireDefault(_managerRepository);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerRepositoryService = function () {
	  managerRepositoryService.$inject = ["$http", "ManagerDataService"];
	  function managerRepositoryService($http, ManagerDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, managerRepositoryService);
	    this.http = $http;
	    this.ManagerDataService = ManagerDataService;
	  }
	
	  (0, _createClass3.default)(managerRepositoryService, [{
	    key: 'getManager',
	    value: function getManager(managerId, year) {
	      return this.http.get(_vacationsAbsences.ENDPOINTS_MANAGER.get.initial(managerId, year)).then(function (response) {
	        return _managerRepository2.default.assemble(response.data);
	      });
	    }
	  }]);
	  return managerRepositoryService;
	}();
	
	exports.default = managerRepositoryService;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vacationsAbsencesManager = __webpack_require__(1550);
	
	var _vacationsAbsencesManager2 = _interopRequireDefault(_vacationsAbsencesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerDataAssembler = function () {
	  function managerDataAssembler() {
	    (0, _classCallCheck3.default)(this, managerDataAssembler);
	  }
	
	  (0, _createClass3.default)(managerDataAssembler, null, [{
	    key: 'assemble',
	    value: function assemble(data) {
	      var manager = new _vacationsAbsencesManager2.default();
	      manager.employeesOutOffice = data.employeesOutOffice || [];
	      manager.listRequestsEmployees = data.listRequestsEmployees || [];
	      return manager;
	    }
	  }]);
	  return managerDataAssembler;
	}();
	
	exports.default = managerDataAssembler;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VacationsAbsencesManager = function VacationsAbsencesManager() {
	  (0, _classCallCheck3.default)(this, VacationsAbsencesManager);
	
	  this.employeesOutOffice = {};
	  this.listRequestsEmployees = [];
	};
	
	exports.default = VacationsAbsencesManager;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitialDataManagerService = function () {
	  InitialDataManagerService.$inject = ["AuthenticationService", "ManagerDataService", "vacationManagerRepositoryService"];
	  function InitialDataManagerService(AuthenticationService, ManagerDataService, vacationManagerRepositoryService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, InitialDataManagerService);
	    this.managerId = AuthenticationService.getEmployeeId();
	    this.managerRepositoryService = vacationManagerRepositoryService;
	    this.ManagerDataService = ManagerDataService;
	    this.year = new Date().getFullYear();
	  }
	
	  (0, _createClass3.default)(InitialDataManagerService, [{
	    key: 'initMainData',
	    value: function initMainData() {
	      var _this = this;
	
	      return this.managerRepositoryService.getManager(this.managerId, this.year).then(function (manager) {
	        _this.ManagerDataService.setManager(manager);
	        return manager;
	      });
	    }
	  }]);
	  return InitialDataManagerService;
	}();
	
	exports.default = InitialDataManagerService;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vacationDelegation = __webpack_require__(1553);
	
	var _vacationDelegation2 = _interopRequireDefault(_vacationDelegation);
	
	var _constants = __webpack_require__(723);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationDelegationService = function () {
	  vacationDelegationService.$inject = ["$http", "DelegationService"];
	  function vacationDelegationService($http, DelegationService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, vacationDelegationService);
	    this.http = $http;
	    this.delegationService = DelegationService;
	  }
	
	  (0, _createClass3.default)(vacationDelegationService, [{
	    key: 'getDelegations',
	    value: function getDelegations(employeeId) {
	      return this.delegationService.getDelegations(employeeId, _constants.MODULE_ID).then(function (response) {
	        return _vacationDelegation2.default.assemble(response.data);
	      });
	    }
	  }, {
	    key: 'deleteDelegation',
	    value: function deleteDelegation(employeeId, delegationToDelete) {
	      return this.delegationService.cancelDelegation(employeeId, delegationToDelete);
	    }
	  }, {
	    key: 'updateDelegation',
	    value: function updateDelegation(employeeId, delegationToUpdate) {
	      return this.delegationService.updateDelegations(employeeId, delegationToUpdate);
	    }
	  }, {
	    key: 'createDelegation',
	    value: function createDelegation(employeeId, delegationToCreate) {
	      return this.delegationService.createDelegations(employeeId, delegationToCreate);
	    }
	  }, {
	    key: 'hasDelegated',
	    value: function hasDelegated(employeeId) {
	      var _this = this;
	
	      return this.delegationService.getDelegations(employeeId, _constants.MODULE_ID).then(function (response) {
	        var delegations = response.data.delegations;
	        var isDelegationActive = _this._isDelegationActiveToday(delegations);
	        var resultDelegation = {
	          hasDelegated: !!delegations.length && isDelegationActive,
	          delegations: delegations
	        };
	        return resultDelegation;
	      });
	    }
	  }, {
	    key: '_isDelegationActiveToday',
	    value: function _isDelegationActiveToday(delegations) {
	      return delegations.some(function (delegation) {
	        var todayFormatted = (0, _moment2.default)().format('YYYY-MM-DD');
	        var delegationStartDate = delegation.startDate;
	        var delegationEndDate = delegation.endDate;
	
	        if (todayFormatted === delegationEndDate) {
	          // When the delegation end date is today, overlaps returns false
	          delegationEndDate = (0, _moment2.default)(delegationEndDate).add('days', 1).format('YYYY-MM-DD');
	        }
	
	        var delegationDateRange = (0, _moment2.default)(delegationStartDate).twix(delegationEndDate);
	        var today = new Date();
	        var todayRange = new _moment2.default(today).twix(today);
	        return todayRange.overlaps(delegationDateRange);
	      });
	    }
	  }, {
	    key: 'findDelegationActive',
	    value: function findDelegationActive(today, delegations) {
	      var _this2 = this;
	
	      var delegationToReturn = delegations.find(function (delegation) {
	        return _this2._checkDataDelegation(delegation, today);
	      });
	
	      return delegationToReturn !== undefined ? delegationToReturn : {};
	    }
	  }, {
	    key: '_checkDataDelegation',
	    value: function _checkDataDelegation(delegation, today) {
	      var endDateSmaller = today <= delegation.endDate;
	      var startDateGreater = today >= delegation.startDate;
	      return endDateSmaller && startDateGreater;
	    }
	  }]);
	  return vacationDelegationService;
	}();
	
	exports.default = vacationDelegationService;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _delegations = __webpack_require__(1554);
	
	var _delegations2 = _interopRequireDefault(_delegations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegationDataAssembler = function () {
	  function delegationDataAssembler() {
	    (0, _classCallCheck3.default)(this, delegationDataAssembler);
	  }
	
	  (0, _createClass3.default)(delegationDataAssembler, null, [{
	    key: 'assemble',
	    value: function assemble(dataArray) {
	      var delegations = [];
	      dataArray.delegations.forEach(function (data) {
	        var delegation = new _delegations2.default();
	        delegation.startDate = data.startDate || '';
	        delegation.endDate = data.endDate || '';
	        delegation.employeeId = data.employeeId || '';
	        delegation.name = data.name || '';
	        delegation.email = data.email || '';
	        delegation.isNotified = data.isNotified || false;
	        delegation.id = data.id || '';
	        delegations.push(delegation);
	      });
	      return delegations;
	    }
	  }]);
	  return delegationDataAssembler;
	}();
	
	exports.default = delegationDataAssembler;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1531);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1534);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1535);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _delegations = __webpack_require__(1555);
	
	var _delegations2 = _interopRequireDefault(_delegations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vacationsAbsencesDelegations = function (_Delegations) {
	  (0, _inherits3.default)(vacationsAbsencesDelegations, _Delegations);
	
	  function vacationsAbsencesDelegations() {
	    (0, _classCallCheck3.default)(this, vacationsAbsencesDelegations);
	    return (0, _possibleConstructorReturn3.default)(this, (vacationsAbsencesDelegations.__proto__ || (0, _getPrototypeOf2.default)(vacationsAbsencesDelegations)).call(this));
	  }
	
	  return vacationsAbsencesDelegations;
	}(_delegations2.default);
	
	exports.default = vacationsAbsencesDelegations;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Delegations = function Delegations() {
	  (0, _classCallCheck3.default)(this, Delegations);
	
	  this.startDate = '';
	  this.endDate = '';
	  this.employeeId = '';
	  this.name = '';
	  this.isNotified = false;
	};
	
	exports.default = Delegations;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalsBehaviourService = function () {
	  ModalsBehaviourService.$inject = ["$cookies"];
	  function ModalsBehaviourService($cookies) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalsBehaviourService);
	    this.cookies = $cookies;
	    this.reset();
	  }
	
	  (0, _createClass3.default)(ModalsBehaviourService, [{
	    key: 'reset',
	    value: function reset() {
	      this.warnLastDayShouldBeVisible = false;
	      this.coachmarkModalDismissed = false;
	      this.coachmarkHasBeenSeen = this.userHasSeenCoachmark();
	    }
	  }, {
	    key: 'userHasSeenCoachmark',
	    value: function userHasSeenCoachmark() {
	      return this.cookies && this.cookies.get(_constants.COOKIES.COACHMARK);
	    }
	  }, {
	    key: 'warLastDayShouldBeVisibleAndWarnModalHasBeenDisplayed',
	    value: function warLastDayShouldBeVisibleAndWarnModalHasBeenDisplayed() {
	      if (this.warnLastDayShouldBeVisible) {
	        return process.isWarnModalBeenDisplayed;
	      }
	
	      return !this.warnLastDayShouldBeVisible;
	    }
	  }, {
	    key: 'isDelegationVisibleWhenCoachmarkHasBeenSeen',
	    value: function isDelegationVisibleWhenCoachmarkHasBeenSeen() {
	      if (!this.coachmarkHasBeenSeen) {
	        return false;
	      }
	
	      return this.warLastDayShouldBeVisibleAndWarnModalHasBeenDisplayed();
	    }
	  }, {
	    key: 'isDelegationVisibleWhenCoachmarkHasBeenDismissed',
	    value: function isDelegationVisibleWhenCoachmarkHasBeenDismissed() {
	      if (!this.coachmarkModalDismissed) {
	        return false;
	      }
	
	      return this.warLastDayShouldBeVisibleAndWarnModalHasBeenDisplayed();
	    }
	  }, {
	    key: 'delegationIsVisible',
	    value: function delegationIsVisible() {
	      return this.isDelegationVisibleWhenCoachmarkHasBeenSeen() || this.isDelegationVisibleWhenCoachmarkHasBeenDismissed();
	    }
	  }]);
	  return ModalsBehaviourService;
	}();
	
	exports.default = ModalsBehaviourService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1113)))

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(1360);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _teamCalendar = __webpack_require__(1558);
	
	var _teamCalendar2 = _interopRequireDefault(_teamCalendar);
	
	var _dateUtils = __webpack_require__(1132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamCalendarService = function () {
	  TeamCalendarService.$inject = ["$q", "managerYearInlineService", "vacationDelegationService", "vacationUserDataService"];
	  function TeamCalendarService($q, managerYearInlineService, vacationDelegationService, vacationUserDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TeamCalendarService);
	    this.q = $q;
	    this.managerYearInlineService = managerYearInlineService;
	    this.vacationDelegationService = vacationDelegationService;
	    this.vacationUserDataService = vacationUserDataService;
	    this.teamCalendarAssembler = new _teamCalendar2.default();
	  }
	
	  (0, _createClass3.default)(TeamCalendarService, [{
	    key: 'initData',
	    value: function initData(userId, year) {
	      var _this = this;
	
	      var teamCalendarData = {};
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	
	      return this.q(function (resolve, reject) {
	        _this.managerYearInlineService.getData(userId, year).then(function (response) {
	          teamCalendarData.rawEmployeeList = response;
	          teamCalendarData.employeeList = response;
	          teamCalendarData.employeesForSearch = _this.teamCalendarAssembler.buildListFromResponse(response);
	
	          _this.vacationDelegationService.hasDelegated(userId).then(function (response) {
	            teamCalendarData.hasDelegated = response.hasDelegated;
	
	            if (teamCalendarData.hasDelegated) {
	              teamCalendarData.delegation = _this.vacationDelegationService.findDelegationActive(today, response.delegations);
	            }
	
	            return resolve(teamCalendarData);
	          }).catch(function (error) {
	            return reject(error);
	          });
	        }).catch(function (error) {
	          return reject(error);
	        });
	      });
	    }
	  }, {
	    key: 'formatEmployeeList',
	    value: function formatEmployeeList(employeeList) {
	      var id = 0;
	      var calendarLines = [];
	
	      employeeList.forEach(function (employee) {
	        var employeeId = employee.employeeId;
	        var name = employee.name;
	        var iconDays = [];
	        var periodInDays = [];
	        var remarks = '';
	
	        iconDays = (0, _dateUtils.returnIconDays)(employee.periods);
	
	        employee.periods = [].concat((0, _toConsumableArray3.default)(employee.periods), (0, _toConsumableArray3.default)(employee.localAndNationalHolidays));
	
	        employee.periods.map(function (item) {
	          var startDate = item.startDate || item.date;
	          var endDate = item.endDate || item.date || new Date();
	          var status = item.status || '';
	          var periodId = id++;
	          remarks = item.remarks || remarks;
	          var type = item.type || '';
	          var code = item.code || '';
	          periodInDays = periodInDays.concat((0, _dateUtils.fromRangeToArray)(startDate, endDate, status, periodId, type, code, iconDays));
	        });
	
	        var line = { employeeId: employeeId, name: name, remarks: remarks, employee: employee, periodInDays: periodInDays };
	        calendarLines.push(line);
	      });
	
	      return calendarLines;
	    }
	  }, {
	    key: 'getTeamCalendarList',
	    value: function getTeamCalendarList(employeeList, date, employeeFilters) {
	      var _this2 = this;
	
	      var teamCalendarList = [];
	      var month = date.getMonth();
	      var year = date.getFullYear();
	
	      var employeeListFiltered = employeeList;
	
	      if (this._atLeastOneFilter(employeeFilters)) {
	        employeeListFiltered = this._discardEmployeesNotInFilters(employeeList, employeeFilters);
	      }
	
	      employeeListFiltered.forEach(function (employee) {
	        var periodsInDate = _this2._getPeriodsInMonthAndYear(employee.periods, month, year);
	        _this2._addTeamCalendarListMatch(teamCalendarList, employee, periodsInDate);
	      });
	
	      return teamCalendarList;
	    }
	  }, {
	    key: '_atLeastOneFilter',
	    value: function _atLeastOneFilter(employeeFilters) {
	      return employeeFilters.length > 0;
	    }
	  }, {
	    key: '_discardEmployeesNotInFilters',
	    value: function _discardEmployeesNotInFilters(employeeList, employeeFilters) {
	      var _this3 = this;
	
	      return employeeList.filter(function (employee) {
	        return _this3._isPresent(employeeFilters, employee.employeeId);
	      });
	    }
	  }, {
	    key: '_isPresent',
	    value: function _isPresent(employeeFilters, employeeId) {
	      return employeeFilters.some(function (profile) {
	        return profile.userId === employeeId;
	      });
	    }
	  }, {
	    key: '_getPeriodsInMonthAndYear',
	    value: function _getPeriodsInMonthAndYear(periods, month, year) {
	
	      return periods.filter(function (period) {
	
	        if (period.type === 'holiday') {
	          return false;
	        }
	
	        var startDate = new Date(period.startDate);
	        var endDate = new Date();
	
	        if (period.endDate) {
	          endDate = new Date(period.endDate);
	        }
	
	        var periodStartMonth = startDate.getMonth();
	        var periodEndMonth = endDate.getMonth();
	
	        var monthMatch = month === periodStartMonth || month === periodEndMonth;
	
	        var periodStartYear = startDate.getFullYear();
	        var periodEndYear = endDate.getFullYear();
	
	        var yearMatch = year === periodStartYear || year === periodEndYear;
	
	        return monthMatch && yearMatch;
	      });
	    }
	  }, {
	    key: '_addTeamCalendarListMatch',
	    value: function _addTeamCalendarListMatch(teamCalendarList, employee, periodsInDate) {
	      var employeeId = employee.employeeId,
	          name = employee.name,
	          email = employee.email;
	
	      teamCalendarList.push({ employeeId: employeeId, name: name, email: email, periodsInDate: periodsInDate });
	    }
	  }]);
	  return TeamCalendarService;
	}();
	
	exports.default = TeamCalendarService;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _profile = __webpack_require__(1172);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamCalendarAssembler = function () {
	  function TeamCalendarAssembler() {
	    (0, _classCallCheck3.default)(this, TeamCalendarAssembler);
	  }
	
	  (0, _createClass3.default)(TeamCalendarAssembler, [{
	    key: 'buildListFromResponse',
	    value: function buildListFromResponse(response) {
	      var clonedResponse = _lodash2.default.cloneDeep(response);
	      var requests = _lodash2.default.flatten(clonedResponse);
	      return _lodash2.default.uniqBy(requests.map(this.buildFromRequest), 'userId');
	    }
	  }, {
	    key: 'buildFromRequest',
	    value: function buildFromRequest(request) {
	      return new _profile2.default(request.employeeId, request.name, request.image);
	    }
	  }]);
	  return TeamCalendarAssembler;
	}();
	
	exports.default = TeamCalendarAssembler;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VacationsAbsencesService = function () {
	  VacationsAbsencesService.$inject = ["vacationUserDataService", "vacationInitialDataService", "vacationInitialDataManagerService", "teamRequestsService", "vacationTeamRequestDataService", "ManagerDataService", "$log"];
	  function VacationsAbsencesService(vacationUserDataService, vacationInitialDataService, vacationInitialDataManagerService, teamRequestsService, vacationTeamRequestDataService, ManagerDataService, $log) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, VacationsAbsencesService);
	    this.initialDataService = vacationInitialDataService;
	    this.ManagerDataService = ManagerDataService;
	    this.userDataService = vacationUserDataService;
	    this.initialDataManagerService = vacationInitialDataManagerService;
	    this.teamRequestsService = teamRequestsService;
	    this.TeamRequestDataService = vacationTeamRequestDataService;
	    this.loaded = false;
	    this.manager = false;
	    this.log = $log;
	  }
	
	  (0, _createClass3.default)(VacationsAbsencesService, [{
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;
	
	      if (!this.userDataService.isEmpty()) {
	        return;
	      }
	
	      this.initialDataService.initMainData().then(function (employee) {
	        if (!employee) return;
	        _this.employee = employee;
	        _this.manager = employee.isManager();
	        _this.hasDelegation = employee.hasDelegation();
	        if (_this.manager || _this.hasDelegation) {
	          _this._loadManagerData();
	          _this._loadTeamRequestData();
	        } else {
	          _this.loaded = true;
	        }
	        return employee;
	      }, function (err) {
	        _this.employee = {};
	        _this.manager = false;
	        throw err;
	      });
	    }
	  }, {
	    key: '_loadManagerData',
	    value: function _loadManagerData() {
	      var _this2 = this;
	
	      if (!this.ManagerDataService.isEmpty()) {
	        return;
	      }
	
	      this.initialDataManagerService.initMainData().then(function (manager) {
	        if (!manager) return;
	        _this2.managerData = manager;
	        return manager;
	      }, function (err) {
	        _this2.managerData = {};
	        throw err;
	      });
	    }
	  }, {
	    key: '_loadTeamRequestData',
	    value: function _loadTeamRequestData() {
	      var _this3 = this;
	
	      var managerId = this.userDataService.getEmployee().userId;
	      var nextId = 0;
	      return this.teamRequestsService.getRequests(managerId).then(function (data) {
	        _this3.loaded = true;
	        _this3.log.info('teamRequestsService.getRequests:', managerId, data);
	        var requests = data.requestPeriods;
	        requests.forEach(function (request) {
	          return request._id = nextId++;
	        });
	        _this3.TeamRequestDataService.setData(requests);
	      }).catch(function (error) {
	        _this3.log.error('teamRequestsService.getRequests:', managerId, error);
	      });
	    }
	  }]);
	  return VacationsAbsencesService;
	}();
	
	exports.default = VacationsAbsencesService;

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  setGlobalConfig: function setGlobalConfig(toastrConfig, isMobileApp) {
	    toastrConfig.positionClass = 'toast-bottom-right';
	    toastrConfig.closeButton = true;
	    toastrConfig.onclick = null;
	    toastrConfig.timeOut = 0;
	    toastrConfig.extendedTimeOut = 0;
	    toastrConfig.preventDuplicates = true;
	    toastrConfig.tapToDismiss = false;
	
	    if (isMobileApp) {
	      toastrConfig.toastClass += ' mobile';
	    }
	  }
	};

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _foodBenefit = __webpack_require__(1562);
	
	var _foodBenefit2 = _interopRequireDefault(_foodBenefit);
	
	var _foodBenefit3 = __webpack_require__(1595);
	
	var _foodBenefit4 = _interopRequireDefault(_foodBenefit3);
	
	var _foodBenefit5 = __webpack_require__(1742);
	
	var _foodBenefit6 = _interopRequireDefault(_foodBenefit5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitModule = angular.module('food-benefit', [_foodBenefit6.default, _foodBenefit2.default, _foodBenefit4.default]).config(["$translatePartialLoaderProvider", function ($translatePartialLoaderProvider) {
	  'ngInject';
	
	  $translatePartialLoaderProvider.addPart('food-benefit.module');
	}]).name;
	
	exports.default = foodBenefitModule;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myFoodBenefit = __webpack_require__(1563);
	
	var _myFoodBenefit2 = _interopRequireDefault(_myFoodBenefit);
	
	var _foodBenefitRouting = __webpack_require__(1570);
	
	var _foodBenefitRouting2 = _interopRequireDefault(_foodBenefitRouting);
	
	var _foodBenefitManager = __webpack_require__(1577);
	
	var _foodBenefitManager2 = _interopRequireDefault(_foodBenefitManager);
	
	var _foodBenefitDelegations = __webpack_require__(1583);
	
	var _foodBenefitDelegations2 = _interopRequireDefault(_foodBenefitDelegations);
	
	var _foodBenefitWorkTeam = __webpack_require__(1589);
	
	var _foodBenefitWorkTeam2 = _interopRequireDefault(_foodBenefitWorkTeam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitFeatures = angular.module('food-benefit.features', [_myFoodBenefit2.default, _foodBenefitRouting2.default, _foodBenefitManager2.default, _foodBenefitDelegations2.default, _foodBenefitWorkTeam2.default]).name;
	
	exports.default = foodBenefitFeatures;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myFoodBenefit = __webpack_require__(1564);
	
	var _myFoodBenefit2 = _interopRequireDefault(_myFoodBenefit);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myFoodBenefitModule = angular.module('food-benefit.myFoodBenefit', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.FOOD_BENEFIT.MY_FOOD_BENEFIT, {
	    url: _routes.ROUTES.FOOD_BENEFIT.MY_FOOD_BENEFIT,
	    component: 'myFoodBenefit',
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).component('myFoodBenefit', _myFoodBenefit2.default).name;
	
	exports.default = myFoodBenefitModule;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myFoodBenefit = __webpack_require__(1565);
	
	var _myFoodBenefit2 = _interopRequireDefault(_myFoodBenefit);
	
	__webpack_require__(1566);
	
	var _myFoodBenefit3 = __webpack_require__(1568);
	
	var _myFoodBenefit4 = _interopRequireDefault(_myFoodBenefit3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myFoodBenefit = {
	  restrict: 'E',
	  bindings: {},
	  controller: _myFoodBenefit4.default,
	  template: _myFoodBenefit2.default
	};
	
	exports.default = myFoodBenefit;

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"!$ctrl.employeeopplus\">\n  <modal-coachmark\n    ng-if=\"!$ctrl.isMobileApp\"\n    data=\"$ctrl.coachmarkData\"\n    user-id=\"$ctrl.userId\"\n  ></modal-coachmark>\n\n  <benefit-request-modal\n    modal-id=\"modalRequestList\"\n    request=\"$ctrl.requestModal\"\n    remove-period=\"$ctrl.removePeriod()\"\n    modal-state=\"$ctrl.modalState\"\n    description=\"$ctrl.description\"\n    modified-card-count=\"$ctrl.countModifiedCards\"\n    action-in-modal=\"$ctrl.onModalResponse($event)\"\n    error-msg=\"$ctrl.modalMessage\"\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    without-manager=\"$ctrl.areCardsWithoutManager\"\n  >\n  </benefit-request-modal>\n\n  <modal-warning-delegation\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    title-body=\"{{ 'FOOD_BENEFIT.MAIN.PERMISSION_USER' | translate }}\"\n    delegation=\"$ctrl.delegation\"\n    url-destination=\"$ctrl.urlDestination\"\n  >\n  </modal-warning-delegation>\n\n  <div\n    class=\"container hpd animation-appear\"\n    ng-class=\"{'mobile': $ctrl.isMobileApp}\"\n    ng-if=\"$ctrl.loaded\"\n    pull-to-refresh=\"$ctrl._init()\"\n  >\n    <div class=\"content-my-food-benefit\" ng-show=\"!$ctrl.openEmployeeSearch\">\n      <div class=\"welcome-msg\">\n        <p>{{\"FOOD_BENEFIT.MAIN.WELCOME\" | translate}}</p>\n        <employee-search\n          ng-if=\"!$ctrl.isMobileApp\"\n          on-search=\"$ctrl.onSearch($event)\"\n          on-select-employee=\"$ctrl.onSelectEmployeeSearch($event)\"\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          enable-alert=\"true\"\n        >\n        </employee-search>\n      </div>\n\n      <div class=\"row\" ng-if=\"!$ctrl.isMobileApp\">\n        <div class=\"col-md-10\">\n          <employee-search-tags\n            ng-if=\"$ctrl.existFilters\"\n            employee-filters=\"$ctrl.employeeFilters\"\n            on-remove-employee-filter=\"$ctrl.onRemoveEmployeeFilter($event)\"\n            on-clean-employee-filters=\"$ctrl.onCleanEmployeeFilters()\"\n          >\n          </employee-search-tags>\n        </div>\n        <div class=\"send-all-button col-md-2\">\n          <button\n            type=\"button\"\n            class=\"btn btn-app btn-primary\"\n            ng-if=\"$ctrl.cardModified\"\n            ng-click=\"$ctrl.openModalRequestAll()\"\n          >\n            {{'GLOBALS.BUTTON_ACTION.SEND_ALL' | translate}}\n          </button>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <user-card-list\n          employees=\"$ctrl.employees\"\n          on-modify=\"$ctrl.onModify($event)\"\n          on-send-card=\"$ctrl.onSendCard($event)\"\n          new-card-state=\"$ctrl.newCardState\"\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          on-close-card=\"$ctrl.onCloseCard()\"\n          card-days-focused=\"$ctrl.daysIsFocused($event)\"\n        >\n        </user-card-list>\n      </div>\n    </div>\n\n    <div\n      class=\"row mobile-search\"\n      ng-if=\"$ctrl.showEmployeeSearch()\"\n      ng-click=\"$ctrl.onClickOnEmployeeSearch()\"\n    >\n      <employee-search\n        fixed-selection=\"true\"\n        on-search=\"$ctrl.onSearch($event)\"\n        on-clean-search=\"$ctrl.onCleanSearch($event)\"\n        on-select-employee=\"$ctrl.onSelectEmployeeSearch($event)\"\n        is-mobile-app=\"$ctrl.isMobileApp\"\n        enable-alert=\"true\"\n      >\n      </employee-search>\n    </div>\n\n    <div class=\"row\" ng-if=\"$ctrl.isMobileApp\">\n      <delegated-card-list-mobile\n        employees=\"$ctrl.delegatedEmployees\"\n        is-mobile-app=\"$ctrl.isMobileApp\"\n        update-data-employees=\"$ctrl.updateDelegatedEmployees($event)\"\n      >\n      </delegated-card-list-mobile>\n    </div>\n\n    <floating-action-buttons\n      ng-if=\"$ctrl.showSendAllRequest() && !$ctrl.openEmployeeSearch\"\n      buttons=\"$ctrl.floatingActionButtons\"\n      on-click-first-button=\"$ctrl.openModalRequestAll()\"\n    >\n    </floating-action-buttons>\n  </div>\n</div>\n<div ng-if=\"$ctrl.employeeopplus\" class=\"modal-body\">\n  <span class=\"icon-warning\"></span>\n  <p class=\"description\">{{'GLOBALS.ERROROPPLUS' | translate}}</p>\n</div>\n<loading ng-hide=\"$ctrl.loaded\" ng-if=\"!$ctrl.isMobileApp\"> </loading>\n"

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1567);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./myFoodBenefit.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./myFoodBenefit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "my-food-benefit{display:block;cursor:pointer}my-food-benefit .capitalize{text-transform:capitalize}my-food-benefit .container .welcome-msg{font-family:Arial;margin-right:-15px;margin-bottom:9px;margin-left:-15px;padding:12px 20px 23px;border-bottom:2px solid #eaebed}my-food-benefit .container .welcome-msg>employee-search{margin-top:-43px;float:right}my-food-benefit .container .welcome-msg>p{font-size:15px;margin-bottom:0;color:#666}my-food-benefit .container .send-all-button{display:flex;flex-direction:row-reverse}my-food-benefit .container .flex-row{margin:9px 0;display:-moz-flex;display:-ms-flexbox;display:flex}my-food-benefit .container .flex-row .flex-item{flex:1}my-food-benefit .container.mobile .welcome-msg{padding:12px 15px 0;border-bottom:none;margin-bottom:0}my-food-benefit .container.mobile .welcome-msg>p{font-size:13px}my-food-benefit .container.mobile .mobile-search{margin-top:10px;margin-left:0;margin-right:0}my-food-benefit .container.mobile .mobile-search .employee-search-container.mobile{margin-top:0}my-food-benefit .modal-body{padding-top:30px;text-align:center}my-food-benefit .modal-body .description{color:#0072c9;font-family:ArialMT;font-size:20px;line-height:1.4;margin-bottom:31px;margin:0 auto 29px;max-width:200px}my-food-benefit .icon-warning{color:#0072c9;font-size:30px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(916);
	
	var _constants2 = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	var _employeesDataFormatter = __webpack_require__(1569);
	
	var _employeesDataFormatter2 = _interopRequireDefault(_employeesDataFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PERMISSION = {
	  USER: 'R'
	};
	
	var MyFoodBenefitController = function () {
	  MyFoodBenefitController.$inject = ["$translate", "$window", "foodBenefitService", "myFoodBenefitHelper", "foodDelegationService", "ManagerForEmployeeService", "FoodBenefitUserDataService", "$scope", "HelperDelegationsService", "loadingMobileService", "floatingActionButtonsService", "$timeout", "$log"];
	  function MyFoodBenefitController($translate, $window, foodBenefitService, myFoodBenefitHelper, foodDelegationService, ManagerForEmployeeService, FoodBenefitUserDataService, $scope, HelperDelegationsService, loadingMobileService, floatingActionButtonsService, $timeout, $log) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyFoodBenefitController);
	    this.log = $log;
	    this.translate = $translate;
	    this.foodBenefitService = foodBenefitService;
	    this.myFoodBenefitHelper = myFoodBenefitHelper;
	    this.foodDelegationService = foodDelegationService;
	    this.floatingActionButtonsService = floatingActionButtonsService;
	    this.ManagerForEmployeeService = ManagerForEmployeeService;
	    this.UserDataService = FoodBenefitUserDataService;
	    this.scope = $scope;
	    this.window = $window;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.loadingMobileService = loadingMobileService;
	    this.loaded = false;
	    this.cardModified = false;
	    this.hasNoManager = false;
	    this.delegation = {};
	    this.helperDelegations = HelperDelegationsService;
	    this.timeout = $timeout;
	    this.coachmarkData = _constants.AA_MY_FOOD_BENEFIT_MODAL_COACHMARK_CONFIG;
	    this.employee = this.UserDataService.getEmployee();
	    this.userId = this.employee.userId;
	    this.employeeopplus = false;
	    this.openEmployeeSearch = false;
	  }
	
	  (0, _createClass3.default)(MyFoodBenefitController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this._init();
	
	      this.urlDestination = _states.STATES.FOOD_BENEFIT.DELEGATE;
	
	      this.scope.$watch(function () {
	        return _this.foodBenefitService.loaded;
	      }, function (newValue) {
	        if (newValue) {
	          _this._initData();
	        }
	      });
	
	      this._translate();
	
	      this.visitedDelegation = this.helperDelegations.getVisitDelegation(this.userId, PERMISSION.USER);
	
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.myFoodBenefitHelper.getFloatingSendAllButton();
	      }
	    }
	  }, {
	    key: '_init',
	    value: function _init() {
	      var _this2 = this;
	
	      this.loaded = false;
	      this.cardModified = false;
	
	      this.loadingMobileService.show();
	
	      this.foodBenefitService.getUserDataSync().then(function () {
	        _this2._initData();
	        _this2.loaded = true;
	      }).finally(function () {
	        return _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '_initData',
	    value: function _initData() {
	      this.employee = this.UserDataService.getEmployee();
	      this.userId = this.employee.userId;
	      this.employeeopplus = this.employee._profile.employeeopplus;
	      this.employees = _employeesDataFormatter2.default.assemble(this.employee);
	      this.employeesBackup = angular.copy(this.employees);
	      if (this.isMobileApp) {
	        this.employees = this.myFoodBenefitHelper.getOwnEmployee(this.employeesBackup, this.userId);
	        this.delegatedEmployees = this.myFoodBenefitHelper.getDelegatedEmployees(this.employeesBackup, this.userId);
	      }
	
	      this.profile = this.employee.getProfile();
	      this.employeeManager = this.ManagerForEmployeeService.getManagerForEmployee(this.userId);
	      this._checkEmployeeHasManager();
	      this._getDelegations();
	      this.employeesIds = this.employees.map(this.myFoodBenefitHelper.getEmployeeToFilter);
	      this.employeeFilters = [];
	    }
	  }, {
	    key: 'showModalWarningDelegation',
	    value: function showModalWarningDelegation() {
	      var delegationEmpty = this.helperDelegations.isDelegationEmpty(this.delegation);
	      if (this.visitedDelegation || delegationEmpty) {
	        return;
	      }
	      this.modalWarningDelegation.modal('show');
	    }
	  }, {
	    key: 'showEmployeeSearch',
	    value: function showEmployeeSearch() {
	      return this.isMobileApp && this.delegatedEmployees.length > 0;
	    }
	  }, {
	    key: 'onSearch',
	    value: function onSearch() {
	      var searchFilter = this.isMobileApp ? _lodash2.default.map(this.delegatedEmployees, 'profile') : this.employeesIds;
	      return this.helperDelegations.onSearchEmployeeDelegations(searchFilter);
	    }
	  }, {
	    key: '_getDelegations',
	    value: function _getDelegations() {
	      var _this3 = this;
	
	      this.loadingMobileService.show();
	      this.foodDelegationService.getDelegations(this.userId).then(function (delegations) {
	        _this3.delegationsObject = delegations;
	        _this3.delegation = _this3.myFoodBenefitHelper.findDelegation(_this3.delegationsObject);
	        _this3.showModalWarningDelegation();
	      }).finally(function () {
	        return _this3.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'onSelectEmployeeSearch',
	    value: function onSelectEmployeeSearch($event) {
	      var employeeIdInFilters = this.employeeFilters.find(function (employee) {
	        return employee.employeeId === $event.employeeId;
	      });
	      if (!employeeIdInFilters) this.employeeFilters.push($event);
	      this.existFilters = true;
	      this._updateFilters();
	    }
	  }, {
	    key: '_updateFilters',
	    value: function _updateFilters() {
	      var _this4 = this;
	
	      this.employees = this.employeesBackup.filter(function (employee) {
	        var id = employee.profile.employeeId || employee.profile.userId;
	        return _this4.employeeFilters.some(function (filter) {
	          return (filter.employeeId || filter.userId) === id;
	        });
	      });
	
	      this.delegatedEmployees = this.employees;
	    }
	  }, {
	    key: 'onCleanEmployeeFilters',
	    value: function onCleanEmployeeFilters() {
	      this.employeeFilters = [];
	      this.employees = this.employeesBackup;
	      this.existFilters = false;
	    }
	  }, {
	    key: 'onRemoveEmployeeFilter',
	    value: function onRemoveEmployeeFilter($event) {
	      _lodash2.default.remove(this.employeeFilters, function (filter) {
	        return filter.employeeId === $event.employeeId;
	      });
	      if (this.employeeFilters.length === 0) {
	        this.onCleanEmployeeFilters();
	        return;
	      }
	
	      this._updateFilters();
	    }
	  }, {
	    key: '_checkEmployeeHasManager',
	    value: function _checkEmployeeHasManager() {
	      var _this5 = this;
	
	      this.loadingMobileService.show();
	
	      this.ManagerForEmployeeService.getManagerForEmployee(this.userId).then(function (manager) {
	        if (manager.managerId === null) _this5.setNoManager();else _this5.hasNoManager = false;
	      }, function (error) {
	        _this5.log.error('_checkEmployeeHasManager', error);
	        _this5.setNoManager(error.data);
	      }).finally(function () {
	        return _this5.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'setNoManager',
	    value: function setNoManager(errorData) {
	      this.noManagerMessage = errorData ? errorData.message : 'No manager data';
	      this.hasNoManager = true;
	    }
	  }, {
	    key: 'daysIsFocused',
	    value: function daysIsFocused($event) {
	      this.daysInCardIsFocused = $event.isFocused;
	    }
	  }, {
	    key: 'showSendAllRequest',
	    value: function showSendAllRequest() {
	      return this.isMobileApp && this.cardModified && !this.floatingActionButtonsService.isFocused && !this.daysInCardIsFocused;
	    }
	  }, {
	    key: 'onModify',
	    value: function onModify(modifiedArray) {
	      this.modifiedArray = modifiedArray;
	      this.cardModified = this.myFoodBenefitHelper.checkMoreThanOneModified(this.modifiedArray);
	    }
	  }, {
	    key: 'onSendCard',
	    value: function onSendCard(card) {
	      var arrayToSend = new Array();
	      arrayToSend.push(card);
	      arrayToSend = arrayToSend.map(this.myFoodBenefitHelper.formatRequest);
	      this.requestType = _constants.REQUEST_TYPE.INDIVIDUAL;
	      this.requestFoodBenefits(arrayToSend, card);
	    }
	  }, {
	    key: 'openModalRequestAll',
	    value: function openModalRequestAll() {
	      this.areCardsWithoutManager = this.checkAreModifiedCardsWithoutManager();
	      this.countModifiedCards = this.modifiedArray.length;
	      this.modalState = this.myFoodBenefitHelper.getModalStateSendAll();
	      this.modalBenefitRequestList.modal('show');
	    }
	  }, {
	    key: 'checkAreModifiedCardsWithoutManager',
	    value: function checkAreModifiedCardsWithoutManager() {
	      return this.modifiedArray.find(function (card) {
	        return card.hasManager === false;
	      });
	    }
	  }, {
	    key: 'hideModal',
	    value: function hideModal() {
	      this.modalBenefitRequestList.modal('hide');
	    }
	  }, {
	    key: 'onModalResponse',
	    value: function onModalResponse($event) {
	      this.modalAction = $event.status;
	      var cardsToSend = this.modifiedArray.map(this.myFoodBenefitHelper.formatRequest);
	      if ($event.status === _constants.MODAL_ACTIONS.CANCEL) {
	        this.hideModal();
	        return;
	      }
	      if ($event.status === _constants.MODAL_ACTIONS.SEND) {
	        this.requestType = _constants.REQUEST_TYPE.COLLECTIVE;
	        this.requestFoodBenefits(cardsToSend, null);
	      }
	    }
	  }, {
	    key: 'onCloseCard',
	    value: function onCloseCard() {
	      this._initData();
	    }
	  }, {
	    key: 'requestFoodBenefits',
	    value: function requestFoodBenefits(requests, card) {
	      var _this6 = this;
	
	      this.loadingMobileService.show();
	      this.foodBenefitService.requestFoodBenefits(requests, this.userId).then(function () {
	        _this6._reloadData(card, false);
	        _this6.requestModal = requests;
	        _this6.modalMessage = requests.length + ' ' + _this6.allRequestApprovedText;
	      }).catch(function (error) {
	        if (card === null) {
	          _this6._showModalErrorWhenFailedSendAllCards(error.data.message);
	        } else {
	          card.requestErrorMsg = error.data.message;
	        }
	
	        _this6._reloadData(card, true);
	      }).finally(function () {
	        return _this6.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '_reloadData',
	    value: function _reloadData(card, isErrored) {
	      var _this7 = this;
	
	      this.cardModified = false;
	      this.loadingMobileService.show();
	      this.foodBenefitService.getUserDataSync().then(function () {
	        if (_this7.requestType !== _constants.REQUEST_TYPE.INDIVIDUAL) {
	          _this7._initData();
	        }
	
	        if (isErrored) {
	          _this7.setStateFailed(card);
	        } else {
	          _this7.setStateApprove(card);
	        }
	      }).finally(function () {
	        return _this7.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'setStateApprove',
	    value: function setStateApprove(card) {
	      if (card) {
	        this.newCardState = this.myFoodBenefitHelper.setCardStateApproved(card, this.employees);
	      } else {
	        this.modalState = this.myFoodBenefitHelper.getModalStateApproved();
	      }
	    }
	  }, {
	    key: 'setStateFailed',
	    value: function setStateFailed(card) {
	      if (card) {
	        this.newCardState = this.myFoodBenefitHelper.setCardStateFailed(card, this.employees);
	      } else {
	        this.modalState = this.myFoodBenefitHelper.getModalStateFailed();
	      }
	    }
	  }, {
	    key: '_showModalErrorWhenFailedSendAllCards',
	    value: function _showModalErrorWhenFailedSendAllCards(messageError) {
	      this.modalMessage = messageError;
	      this.modalState = this.myFoodBenefitHelper.getModalStateFailed();
	    }
	  }, {
	    key: '_assembleDelegatedEmployeeEdited',
	    value: function _assembleDelegatedEmployeeEdited(employee) {
	      var employeeId = employee.profile.employeeId;
	      return this.delegatedEmployees.map(function (delegated) {
	        var equalDelegated = delegated.profile.employeeId === employeeId;
	        return equalDelegated ? employee : delegated;
	      });
	    }
	  }, {
	    key: 'updateDelegatedEmployees',
	    value: function updateDelegatedEmployees($event) {
	      var employeeEdited = $event;
	      this.delegatedEmployees = this._assembleDelegatedEmployeeEdited(employeeEdited);
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this8 = this;
	
	      return this.myFoodBenefitHelper.getApproveAllMessage().then(function (translation) {
	        _this8.allRequestApprovedText = translation;
	      });
	    }
	  }, {
	    key: 'onCleanSearch',
	    value: function onCleanSearch($event) {
	      var _this9 = this;
	
	      if ($event.searchText.length) {
	        return;
	      }
	
	      this.timeout(function () {
	        _this9.openEmployeeSearch = false;
	        _this9.scrollToTop();
	      });
	
	      this.delegatedEmployees = this.myFoodBenefitHelper.getDelegatedEmployees(this.employeesBackup, this.userId);
	      this.employeeFilters = [];
	    }
	  }, {
	    key: 'onClickOnEmployeeSearch',
	    value: function onClickOnEmployeeSearch() {
	      this.openEmployeeSearch = true;
	      this.scrollToTop();
	    }
	  }, {
	    key: 'scrollToTop',
	    value: function scrollToTop() {
	      $('html,body').animate({ scrollTop: 0 }, 'slow');
	    }
	  }, {
	    key: 'modalBenefitRequestList',
	    get: function get() {
	      return $(_constants2.MODALS.BENEFIT_REQUEST_LIST);
	    }
	  }, {
	    key: 'modalWarningDelegation',
	    get: function get() {
	      var _this10 = this;
	
	      var $modal = $(_constants2.MODALS.WARNING_DELEGATION_MODAL);
	      $modal.on('hidden.bs.modal', function () {
	        _this10.helperDelegations.setVisitedDelegation(_this10.userId, PERMISSION.USER);
	      });
	      return $modal;
	    }
	  }]);
	  return MyFoodBenefitController;
	}();
	
	exports.default = MyFoodBenefitController;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(1360);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeesDataFormatter = function () {
	  function employeesDataFormatter() {
	    (0, _classCallCheck3.default)(this, employeesDataFormatter);
	  }
	
	  (0, _createClass3.default)(employeesDataFormatter, null, [{
	    key: 'assemble',
	    value: function assemble(data) {
	      var user = buildUser(data);
	      var delegatedUsers = buildDelegated(data);
	      var employees = [];
	      employees.push(user);
	      employees = [].concat((0, _toConsumableArray3.default)(employees), (0, _toConsumableArray3.default)(delegatedUsers));
	      return employees;
	    }
	  }]);
	  return employeesDataFormatter;
	}();
	
	function buildUser(data) {
	  var formattedCards = formatCardsMonth(data.cards);
	  var employee = {
	    profile: data.getProfile(),
	    cards: formattedCards
	  };
	  return employee;
	}
	
	function buildDelegated(data) {
	  var employees = [];
	  data.delegations.forEach(function (delegation) {
	    var employee = {
	      profile: delegation.profile,
	      cards: delegation.cards
	    };
	    employees.push(employee);
	  });
	  return employees;
	}
	
	function formatCardsMonth(cards) {
	  var cardsFormat = [];
	  cards.forEach(function (card) {
	    if (card.enjoymentMonth.toString().length === 1) {
	      card.enjoymentMonth = '0' + card.enjoymentMonth.toString();
	    }
	    cardsFormat.push(card);
	  });
	
	  return cardsFormat;
	}
	
	exports.default = employeesDataFormatter;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _foodBenefitRouting = __webpack_require__(1571);
	
	var _foodBenefitRouting2 = _interopRequireDefault(_foodBenefitRouting);
	
	var _foodBenefitRouting3 = __webpack_require__(1576);
	
	var _foodBenefitRouting4 = _interopRequireDefault(_foodBenefitRouting3);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitRoutingModule = angular.module('food-benefit.routing', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.FOOD_BENEFIT.ROOT, {
	    abstract: true,
	    parent: _states.STATES.MAIN_ROUTING,
	    url: _routes.ROUTES.FOOD_BENEFIT.ROOT,
	    component: 'foodBenefitRouting',
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      moduleClosed: ["StatusAppCheckers", function moduleClosed(StatusAppCheckers) {
	        return StatusAppCheckers.getClosedModules();
	      }]
	    }
	  });
	}]).component('foodBenefitRouting', _foodBenefitRouting2.default).service('foodBenefitRoutingService', _foodBenefitRouting4.default).name;
	
	exports.default = foodBenefitRoutingModule;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _foodBenefitRouting = __webpack_require__(1572);
	
	var _foodBenefitRouting2 = _interopRequireDefault(_foodBenefitRouting);
	
	var _foodBenefitRouting3 = __webpack_require__(1573);
	
	var _foodBenefitRouting4 = _interopRequireDefault(_foodBenefitRouting3);
	
	__webpack_require__(1574);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitRoutingComponent = {
	  restrict: 'E',
	  bindings: {
	    moduleClosed: '<'
	  },
	  template: _foodBenefitRouting2.default,
	  controller: _foodBenefitRouting4.default
	};
	
	exports.default = foodBenefitRoutingComponent;

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	module.exports = "<main-menu\n  ng-if=\"!$ctrl.isMobileApp && !$ctrl.employeeopplus\"\n  class=\"food-benefit\"\n  links=\"$ctrl.links\"\n>\n  <last-day-alert></last-day-alert>\n</main-menu>\n\n<main-menu-mobile\n  ng-if=\"$ctrl.isMobileApp && $ctrl.links && !$ctrl.employeeopplus\"\n  links=\"$ctrl.links\"\n  employee-info=\"$ctrl.employee\"\n  module=\"AA\"\n  manager-info=\"$ctrl.manager\"\n  show-links=\"true\"\n>\n</main-menu-mobile>\n\n<div ng-if=\"$ctrl.isLoaded\" ui-view></div>\n"

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _link = __webpack_require__(1104);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _states = __webpack_require__(565);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FoodBenefitRoutingController = function () {
	  FoodBenefitRoutingController.$inject = ["$scope", "$state", "$window", "FoodBenefitUserDataService", "foodBenefitService", "foodDelegationService", "ManagerNavigationService", "HelperDelegationsService", "metricsService"];
	  function FoodBenefitRoutingController($scope, $state, $window, FoodBenefitUserDataService, foodBenefitService, foodDelegationService, ManagerNavigationService, HelperDelegationsService, metricsService) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, FoodBenefitRoutingController);
	    this.state = $state;
	    this.scope = $scope;
	
	    this.foodBenefitUserDataService = FoodBenefitUserDataService;
	    this.foodBenefitService = foodBenefitService;
	    this.foodDelegationService = foodDelegationService;
	    this.ManagerNavigationService = ManagerNavigationService;
	    this.helperDelegations = HelperDelegationsService;
	    this.metricsService = metricsService;
	
	    this.isMobileApp = $window.innerWidth < 1024;
	
	    this.isLoaded = false;
	    this.hasAlert = false;
	
	    this.scope.$on(_constants.EVENTS.ICON_DELEGATIONS, function () {
	      _this._initData();
	    });
	  }
	
	  (0, _createClass3.default)(FoodBenefitRoutingController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      if (this.isModuleClosed()) {
	        return;
	      }
	
	      this.foodBenefitService.loadData();
	
	      this.metricsService.init();
	
	      this.scope.$watch(function () {
	        return _this2.foodBenefitService.loaded;
	      }, function (newValue) {
	        if (newValue) {
	          _this2.isLoaded = true;
	          _this2.employee = _this2.foodBenefitUserDataService.getEmployee();
	          _this2.manager = _this2.foodBenefitService.ManagerDataService._manager;
	          _this2.userId = _this2.employee.userId;
	          _this2.employeeopplus = _this2.employee._profile.employeeopplus;
	          _this2.isManager = _this2.employee._profile.role() === 'manager';
	          _this2._initData();
	          _this2.hasElevatedRights = _this2.employee.hasManagerDelegation() || _this2.employee.isManager();
	          _this2.ManagerNavigationService.canNavigateToState(_this2.hasElevatedRights);
	        }
	      });
	    }
	  }, {
	    key: '_initData',
	    value: function _initData() {
	      var _this3 = this;
	
	      this._checkDelegations().then(function () {
	        _this3._initLinks();
	      });
	    }
	  }, {
	    key: '_initLinks',
	    value: function _initLinks() {
	      this.links = [];
	      this.links.push(new _link2.default('MI AYUDA ALIMENTARIA', 'MI AYUDA ALIMENTARIA', _states.STATES.FOOD_BENEFIT.MY_FOOD_BENEFIT, ''));
	      if (this.hasElevatedRights) {
	        //this.links.push(new Link('SOLICITUDES DE EQUIPO', 'SOLICITUDES DE EQUIPO', STATES.FOOD_BENEFIT.TEAM_REQUESTS, ''));
	        this.links.push(new _link2.default('MIS COLABORADORES', 'MIS COLABORADORES', _states.STATES.FOOD_BENEFIT.WORK_TEAM, ''));
	      }
	
	      var delegationLink = new _link2.default('DELEGACIÓN PERMISO', 'DELEGACIÓN PERMISO', _states.STATES.FOOD_BENEFIT.DELEGATE, '');
	      if (this.hasAlert) {
	        delegationLink.setAlertIcon('icon-warning');
	      }
	
	      this.links.push(delegationLink);
	    }
	  }, {
	    key: '_checkDelegations',
	    value: function _checkDelegations() {
	      var _this4 = this;
	
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	      return this.foodDelegationService.getDelegations(this.userId).then(function (delegations) {
	        _this4.delegationsObject = delegations;
	        var delegation = _this4.foodDelegationService.findDelegationActive(today, _this4.delegationsObject);
	        _this4.hasAlert = !_this4.helperDelegations.isDelegationEmpty(delegation);
	      }, function (error) {
	        _this4.delegationsErrorMessage = error.data.message;
	        _this4.hasAlert = false;
	      });
	    }
	  }, {
	    key: 'isModuleClosed',
	    value: function isModuleClosed() {
	      if (this.moduleClosed.isFoodBenefitClosed && this.moduleClosed.foodBenefitsClosedMessage) {
	        this.state.go(_states.STATES.ERROR, { stateName: _constants.PAGE_ERROR.CLOSED, errorMessage: this.moduleClosed.foodBenefitsClosedMessage });
	        return true;
	      } else if (this.moduleClosed.isFoodBenefitClosed) {
	        this.state.go(_states.STATES.ERROR, { stateName: _constants.PAGE_ERROR.CLOSED });
	        return true;
	      }
	
	      return false;
	    }
	  }]);
	  return FoodBenefitRoutingController;
	}();
	
	exports.default = FoodBenefitRoutingController;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1575);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./foodBenefitRouting.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./foodBenefitRouting.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FoodBenefitRoutingService = function () {
	  FoodBenefitRoutingService.$inject = ["$transitions"];
	  function FoodBenefitRoutingService($transitions) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FoodBenefitRoutingService);
	    this.transitions = $transitions;
	    this.start();
	  }
	
	  (0, _createClass3.default)(FoodBenefitRoutingService, [{
	    key: 'start',
	    value: function start() {
	      this.visited = {};
	      this.registerOnBeforeTo('my-food-benefit');
	    }
	  }, {
	    key: 'registerOnBeforeTo',
	    value: function registerOnBeforeTo(stateName) {
	      var _this = this;
	
	      var criteria = { to: stateName };
	      this.transitions.onBefore(criteria, function () {
	        return _this.setVisited(stateName);
	      });
	    }
	  }, {
	    key: 'setVisited',
	    value: function setVisited(stateName) {
	      this.visited[stateName] = true;
	    }
	  }, {
	    key: 'stateVisited',
	    value: function stateVisited(stateName) {
	      return this.visited[stateName] === true;
	    }
	  }]);
	  return FoodBenefitRoutingService;
	}();
	
	exports.default = FoodBenefitRoutingService;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _foodBenefitManager = __webpack_require__(1578);
	
	var _foodBenefitManager2 = _interopRequireDefault(_foodBenefitManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitManagerModule = _angular2.default.module('food-benefit.foodBenefitManager', [_angularUiRouter2.default]).component('foodBenefitManager', _foodBenefitManager2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.FOOD_BENEFIT.MANAGER, {
	    url: _routes.ROUTES.FOOD_BENEFIT.MANAGER,
	    component: 'foodBenefitManager',
	    data: {
	      requiresAuth: true,
	      requiresManager: true
	    }
	  });
	}]).name;
	
	exports.default = foodBenefitManagerModule;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _foodBenefitManager = __webpack_require__(1579);
	
	var _foodBenefitManager2 = _interopRequireDefault(_foodBenefitManager);
	
	var _foodBenefitManager3 = __webpack_require__(1580);
	
	var _foodBenefitManager4 = _interopRequireDefault(_foodBenefitManager3);
	
	__webpack_require__(1581);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitManagerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _foodBenefitManager2.default,
	  controller: _foodBenefitManager4.default
	};
	
	exports.default = foodBenefitManagerComponent;

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	module.exports = "<modal-coachmark\n  ng-if=\"!$ctrl.isMobileApp\"\n  data=\"$ctrl.coachmarkData\"\n  user-id=\"$ctrl.userId\"\n></modal-coachmark>\n\n<modal-warning-delegation\n  is-mobile-app=\"$ctrl.isMobileApp\"\n  title-body=\"{{ 'FOOD_BENEFIT.MAIN.PERMISSION_MANAGER' | translate }}\"\n  delegation=\"$ctrl.delegation\"\n  url-destination=\"$ctrl.urlDestination\">\n</modal-warning-delegation>\n\n<div ng-if=\"$ctrl.loaded\"\n     class=\"container hpd animation-appear\"\n     ng-class=\"$ctrl.getClasses()\"\n     pull-to-refresh=\"$ctrl.reloadData()\">\n\n  <section class=\"manager-bar\" ng-class=\"$ctrl.getClassToManagerBar()\">\n    <employee-search\n      ng-if=\"$ctrl.hasEmployeePeriods\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      fixed-selection=\"$ctrl.isMobileApp\"\n      on-search=\"$ctrl.onSearch($event)\"\n      on-select-employee=\"$ctrl.onSelectEmployeeSearch($event)\"\n      on-clean-search=\"$ctrl.onCleanSearch($event)\"\n      enable-alert=\"true\">\n    </employee-search>\n  </section>\n\n  <section class=\"list-container\">\n    <employee-search-tags\n      ng-if=\"$ctrl.showEmployeeSearchTags()\"\n      employee-filters=\"$ctrl.employeeFilters\"\n      on-remove-employee-filter=\"$ctrl.onRemoveEmployeeFilter($event)\"\n      on-clean-employee-filters=\"$ctrl.onCleanEmployeeFilters()\">\n    </employee-search-tags>\n\n    <benefit-request-list\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      has-delegations=\"$ctrl.hasDelegations\"\n      periods=\"$ctrl.employeePeriods\"\n      request-data-update=\"$ctrl.reloadData()\">\n    </benefit-request-list>\n  </section>\n</div>\n\n<loading ng-if=\"!$ctrl.isMobileApp\" ng-hide=\"$ctrl.loaded\"></loading>\n"

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	var _constants2 = __webpack_require__(916);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PERMISSION = {
	  MANAGER: 'A'
	};
	
	var FoodBenefitManagerController = function () {
	  FoodBenefitManagerController.$inject = ["foodDelegationService", "ManagerDataService", "foodBenefitService", "$scope", "$rootScope", "$window", "FoodBenefitUserDataService", "HelperDelegationsService", "loadingMobileService", "floatingActionButtonsService"];
	  function FoodBenefitManagerController(foodDelegationService, ManagerDataService, foodBenefitService, $scope, $rootScope, $window, FoodBenefitUserDataService, HelperDelegationsService, loadingMobileService, floatingActionButtonsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FoodBenefitManagerController);
	    this.foodBenefitService = foodBenefitService;
	    this.floatingActionButtonsService = floatingActionButtonsService;
	    this.ManagerDataService = ManagerDataService;
	    this.foodDelegationService = foodDelegationService;
	    this.scope = $scope;
	    this.rootScope = $rootScope;
	    this.UserDataService = FoodBenefitUserDataService;
	    this.helperDelegations = HelperDelegationsService;
	    this.loadingMobileService = loadingMobileService;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.loaded = false;
	    this.employeeFilters = [];
	    this.existFilters = false;
	    this.delegation = {};
	    this.coachmarkData = _constants2.AA_MANAGER_MODAL_COACHMARK_CONFIG;
	    this.hasEmployeePeriods = false;
	  }
	
	  (0, _createClass3.default)(FoodBenefitManagerController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this._initData();
	      this.visitedDelegation = this.helperDelegations.getVisitDelegation(this.userId, PERMISSION.MANAGER);
	      this.loadingMobileService.show();
	      this.checkDelegations().then(function () {
	        _this.loaded = true;
	      }).finally(function () {
	        return _this.loadingMobileService.hide();
	      });
	      this.reloadData();
	    }
	  }, {
	    key: '_initData',
	    value: function _initData() {
	      this.userId = this._getIdEmployee();
	      this.manager = this.ManagerDataService.getManager();
	      this.rawEmployeePeriods = this.manager.employeesFoodBenefitPeriods;
	      this._setApprovedDays(this.rawEmployeePeriods);
	      this.searchEmployees = this._formatEmployeesToSearch();
	      this.employeePeriods = this.rawEmployeePeriods;
	      this._checkEmployeePeriodsNumber();
	      this.employeeFilters = [];
	      this.urlDestination = _states.STATES.FOOD_BENEFIT.DELEGATE;
	    }
	  }, {
	    key: '_setApprovedDays',
	    value: function _setApprovedDays(periods) {
	      periods.forEach(function (period) {
	        var daysDifference = parseInt(period.daysDifference, 10) || 0;
	
	        if (daysDifference > 0) {
	          period.approvedDays = period.enjoymentDays - daysDifference;
	        }
	
	        if (daysDifference < 0) {
	          period.approvedDays = period.enjoymentDays + daysDifference * -1;
	        }
	      });
	    }
	  }, {
	    key: '_getIdEmployee',
	    value: function _getIdEmployee() {
	      return this.UserDataService.getEmployee().userId;
	    }
	  }, {
	    key: '_formatEmployeesToSearch',
	    value: function _formatEmployeesToSearch() {
	      var employeeIdList = [];
	      return this.manager.employeesFoodBenefitPeriods.filter(function (employee) {
	        var id = employee.employeeId;
	        if (employeeIdList.indexOf(id) >= 0) {
	          return false;
	        }
	
	        employeeIdList.push(id);
	        return employee;
	      });
	    }
	  }, {
	    key: 'onSearch',
	    value: function onSearch() {
	      return this.helperDelegations.onSearchEmployeeDelegations(this.searchEmployees);
	    }
	  }, {
	    key: 'onCleanSearch',
	    value: function onCleanSearch($event) {
	      if (!this.isMobileApp) return;
	      if ($event.searchText.length) return;
	      this.employeeFilters = [];
	      this.employeePeriods = angular.copy(this.rawEmployeePeriods);
	      this._checkEmployeePeriodsNumber();
	    }
	  }, {
	    key: 'onSelectEmployeeSearch',
	    value: function onSelectEmployeeSearch($event) {
	      var employeeIdInFilters = this.employeeFilters.find(function (employee) {
	        return employee.employeeId === $event.employeeId;
	      });
	      if (!employeeIdInFilters) this.employeeFilters.push($event);
	      this.existFilters = true;
	      this._updateFilters();
	    }
	  }, {
	    key: '_updateFilters',
	    value: function _updateFilters() {
	      var _this2 = this;
	
	      this.employeePeriods = this.rawEmployeePeriods.filter(function (employee) {
	        return _this2.employeeFilters.some(function (filter) {
	          return filter.employeeId === employee.employeeId;
	        });
	      });
	    }
	  }, {
	    key: 'onRemoveEmployeeFilter',
	    value: function onRemoveEmployeeFilter($event) {
	      _lodash2.default.remove(this.employeeFilters, function (filter) {
	        return filter.employeeId === $event.employeeId;
	      });
	      if (this.employeeFilters.length === 0) {
	        this.onCleanEmployeeFilters();
	        return;
	      }
	
	      this._updateFilters();
	    }
	  }, {
	    key: 'onCleanEmployeeFilters',
	    value: function onCleanEmployeeFilters() {
	      this.employeeFilters.length = 0;
	      this.existFilters = false;
	      this.employeePeriods = this.rawEmployeePeriods;
	      this._checkEmployeePeriodsNumber();
	    }
	  }, {
	    key: 'reloadData',
	    value: function reloadData() {
	      var _this3 = this;
	
	      this.loadingMobileService.show();
	      this.foodBenefitService.getManagerDataSync().then(function (managerData) {
	        _this3._resetData(managerData);
	        _this3.rootScope.$broadcast(_constants.EVENTS.REFRESH_ON_FOOD_BENEFIT_MANAGER, { isReloaded: true });
	        _this3.floatingActionButtonsService.run();
	      }).finally(function () {
	        return _this3.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '_resetData',
	    value: function _resetData(managerData) {
	      this.manager = managerData;
	      this.rawEmployeePeriods = this.manager.employeesFoodBenefitPeriods;
	      this._setApprovedDays(this.rawEmployeePeriods);
	      this.employeePeriods = this.rawEmployeePeriods;
	      this._checkEmployeePeriodsNumber();
	      if (this.isMobileApp) {
	        this.rootScope.$broadcast(_constants.EVENTS.BADGE_NUMBER, { badgeNumber: this.rawEmployeePeriods.length });
	      }
	    }
	  }, {
	    key: 'checkDelegations',
	    value: function checkDelegations() {
	      var _this4 = this;
	
	      this.loadingMobileService.show();
	      return this.foodDelegationService.getDelegations(this.userId).then(function (delegations) {
	        _this4.delegationsObject = delegations;
	        _this4.hasDelegations = _this4.delegationsObject.length > 0;
	        _this4.findDelegation();
	        _this4.showModalWarningDelegation();
	      }, function (error) {
	        _this4.delegationsErrorMessage = error.data.message;
	        _this4.hasDelegations = false;
	      }).finally(function () {
	        return _this4.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'findDelegation',
	    value: function findDelegation() {
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	      this.delegation = this.foodDelegationService.findDelegationActive(today, this.delegationsObject, PERMISSION.MANAGER);
	    }
	  }, {
	    key: 'showModalWarningDelegation',
	    value: function showModalWarningDelegation() {
	      var delegationEmpty = this.helperDelegations.isDelegationEmpty(this.delegation);
	      if (this.visitedDelegation || delegationEmpty) {
	        return;
	      }
	
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'showEmployeeSearchTags',
	    value: function showEmployeeSearchTags() {
	      return this.existFilters && !this.isMobileApp;
	    }
	  }, {
	    key: '_checkEmployeePeriodsNumber',
	    value: function _checkEmployeePeriodsNumber() {
	      this.hasEmployeePeriods = false;
	      if (this.employeePeriods.length > 0) {
	        this.hasEmployeePeriods = true;
	      }
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        responsiveMobile: this.isMobileApp,
	        'with-floating-action-buttons': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'getClassToManagerBar',
	    value: function getClassToManagerBar() {
	      return {
	        'responsiveMobile': this.isMobileApp,
	        'no-requests': !this.hasEmployeePeriods
	      };
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      var _this5 = this;
	
	      var $modal = $(_constants.MODALS.WARNING_DELEGATION_MODAL);
	      $modal.on('hidden.bs.modal', function () {
	        _this5.helperDelegations.setVisitedDelegation(_this5.userId, PERMISSION.MANAGER);
	      });
	      return $modal;
	    }
	  }]);
	  return FoodBenefitManagerController;
	}();
	
	exports.default = FoodBenefitManagerController;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1582);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./foodBenefitManager.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./foodBenefitManager.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "food-benefit-manager .manager-bar{width:100%;padding:0 5px 5px;display:inline-flex;border-bottom:2px solid #dddfe2}food-benefit-manager .manager-bar.mobile{display:block;padding:0;border-bottom:none}food-benefit-manager .manager-bar.no-requests{border-bottom:none}food-benefit-manager employee-search-tags{margin-top:-70px;position:relative;top:70px}", ""]);
	
	// exports


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _foodBenefitDelegations = __webpack_require__(1584);
	
	var _foodBenefitDelegations2 = _interopRequireDefault(_foodBenefitDelegations);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitDelegationsModule = _angular2.default.module('food-benefit.foodBenefitDelegations', [_angularUiRouter2.default]).component('foodBenefitDelegations', _foodBenefitDelegations2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.FOOD_BENEFIT.DELEGATE, {
	    url: _routes.ROUTES.FOOD_BENEFIT.DELEGATE,
	    component: 'foodBenefitDelegations',
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).name;
	
	exports.default = foodBenefitDelegationsModule;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _foodBenefitDelegations = __webpack_require__(1585);
	
	var _foodBenefitDelegations2 = _interopRequireDefault(_foodBenefitDelegations);
	
	var _foodBenefitDelegations3 = __webpack_require__(1586);
	
	var _foodBenefitDelegations4 = _interopRequireDefault(_foodBenefitDelegations3);
	
	__webpack_require__(1587);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitDelegationsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _foodBenefitDelegations2.default,
	  controller: _foodBenefitDelegations4.default
	};
	
	exports.default = foodBenefitDelegationsComponent;

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	module.exports = "<modal-coachmark\n  ng-if=\"!$ctrl.isMobileApp\"\n  data=\"$ctrl.coachmarkData\"\n  user-id=\"$ctrl.userId\">\n</modal-coachmark>\n\n<modal-delegation-manager\n  is-mobile-app=\"$ctrl.isMobileApp\"\n  state=\"$ctrl.modalState\"\n  delegation=\"$ctrl.selectedDelegation\"\n  modal-close=\"$ctrl.closeModal()\"\n  module-id=\"$ctrl.moduleId\"\n  custom-title=\"$ctrl.modalTitle\"\n  employee-role=\"$ctrl.employeeRole\"\n  message=\"$ctrl.modalMessage\"\n  cancel-delegation-request=\"$ctrl.sendCancelDelegation($event)\"\n  edit-delegation-request=\"$ctrl.sendEditDelegation($event)\"\n  on-send-delegation=\"$ctrl.sendDelegation($event)\"\n  set-delegation-type=\"$ctrl.getTypeOfDelegation($event)\"\n  employee-id=\"$ctrl.userId\">\n</modal-delegation-manager>\n\n<div ng-if=\"$ctrl.loaded\"\n     class=\"container hpd animation-appear\"\n     ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'with-floating-action-buttons': $ctrl.isMobileApp }\"\n     pull-to-refresh=\"$ctrl.getDelegationsFromBack()\">\n\n  <delegations-list\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    open-delegation-modal=\"$ctrl.openModal($event)\"\n    delegations=\"$ctrl.delegationsObject\">\n  </delegations-list>\n</div>\n\n<loading ng-if=\"!$ctrl.isMobileApp\" ng-hide=\"$ctrl.loaded\"></loading>\n"

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(916);
	
	var _dateUtils = __webpack_require__(1132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FoodBenefitDelegationsController = function () {
	  FoodBenefitDelegationsController.$inject = ["$window", "$log", "foodDelegationService", "FoodBenefitUserDataService", "HelperDelegationsService", "loadingMobileService", "metricsService"];
	  function FoodBenefitDelegationsController($window, $log, foodDelegationService, FoodBenefitUserDataService, HelperDelegationsService, loadingMobileService, metricsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FoodBenefitDelegationsController);
	    this.log = $log;
	    this.foodDelegationService = foodDelegationService;
	    this.FoodBenefitUserDataService = FoodBenefitUserDataService;
	    this.helperDelegations = HelperDelegationsService;
	    this.loadingMobileService = loadingMobileService;
	    this.metricsService = metricsService;
	
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.loaded = false;
	    this.moduleId = _constants2.MODULE_ID;
	    this.userId = this.FoodBenefitUserDataService.getEmployee().userId;
	    this.employeeRole = this.FoodBenefitUserDataService.getEmployee()._profile.role();
	    this.successTitle = 'GLOBALS.SUCCESS_DELEGATION';
	    this.cancelDelegationSuccessTitle = 'GLOBALS.CANCEL_SUCCESS_DELEGATION';
	    this.coachmarkData = _constants2.AA_DELEGATIONS_MANAGER_MODAL_COACHMARK_CONFIG;
	  }
	
	  (0, _createClass3.default)(FoodBenefitDelegationsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getDelegationsFromBack();
	    }
	  }, {
	    key: 'getDelegationsFromBack',
	    value: function getDelegationsFromBack() {
	      var _this = this;
	
	      this.loadingMobileService.show();
	      this.foodDelegationService.getDelegations(this.userId).then(function (delegations) {
	        _this.delegationsObject = delegations;
	        _this.helperDelegations.sendEventToChangeIconDelegations();
	        _this.loaded = true;
	      }).finally(function () {
	        _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(_ref) {
	      var action = _ref.action,
	          delegation = _ref.delegation;
	
	      this.modalState = action;
	      this.selectedDelegation = delegation;
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.modalState = '';
	      this.selectedDelegation = {};
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'onDismiss',
	    value: function onDismiss() {
	      this.closeModal();
	    }
	  }, {
	    key: 'sendCancelDelegation',
	    value: function sendCancelDelegation() {
	      var _this2 = this;
	
	      var objectToCancel = {
	        startDate: this.selectedDelegation.startDate,
	        employeeId: this.selectedDelegation.employeeId,
	        service: _constants2.MODULE_ID,
	        type: this.selectedDelegation.type
	      };
	
	      this.loadingMobileService.show();
	      this.foodDelegationService.deleteDelegation(this.userId, objectToCancel).then(function () {
	        _this2.modalState = _constants.DELEGATION_STATES.SUCCESS;
	        _this2.modalTitle = _this2.cancelDelegationSuccessTitle;
	        _this2.getDelegationsFromBack();
	      }, function (error) {
	        _this2.modalState = _constants.DELEGATION_STATES.ERROR;
	        _this2.modalMessage = error.data.message;
	        _this2.modalTitle = error.data.errors.codigo;
	      }).finally(function () {
	        _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'sendEditDelegation',
	    value: function sendEditDelegation(_ref2) {
	      var _this3 = this;
	
	      var startDate = _ref2.startDate,
	          endDate = _ref2.endDate;
	
	      startDate = (0, _dateUtils.formatDate)(startDate);
	      endDate = (0, _dateUtils.formatDate)(endDate);
	
	      var objectToSend = {
	        startDate: startDate,
	        endDate: endDate,
	        id: this.selectedDelegation.id,
	        type: this.selectedDelegation.type,
	        service: _constants2.MODULE_ID
	      };
	
	      this.loadingMobileService.show();
	      this.foodDelegationService.updateDelegation(this.userId, objectToSend).then(function () {
	        _this3.modalState = _constants.DELEGATION_STATES.SUCCESS;
	        _this3.modalTitle = _this3.successTitle;
	        _this3.getDelegationsFromBack();
	      }, function (error) {
	        _this3.modalState = _constants.DELEGATION_STATES.ERROR;
	        _this3.modalMessage = error.data.message;
	        _this3.modalTitle = error.data.errors.codigo;
	      }).finally(function () {
	        _this3.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'getTypeOfDelegation',
	    value: function getTypeOfDelegation($event) {
	      this.typeOfDelegation = $event.option;
	      this.typeOfDelegation = this.typeOfDelegation === _constants.SWITCHOPTIONS.USER ? _constants2.DELEGATION_TYPE.EMPLOYEE : _constants2.DELEGATION_TYPE.MANAGER;
	    }
	  }, {
	    key: 'sendDelegation',
	    value: function sendDelegation($event) {
	      var _this4 = this;
	
	      var startDate = (0, _dateUtils.formatDate)($event.startDate);
	      var endDate = (0, _dateUtils.formatDate)($event.endDate);
	      var employeeId = $event.employee;
	
	      var delegationToCreate = {
	        startDate: startDate,
	        endDate: endDate,
	        employeeId: employeeId,
	        service: _constants2.MODULE_ID,
	        type: this.typeOfDelegation || _constants2.DELEGATION_TYPE.EMPLOYEE
	      };
	
	      this.log.info({ delegationToCreate: delegationToCreate });
	      this.loadingMobileService.show();
	      this.foodDelegationService.createDelegation(this.userId, delegationToCreate).then(function () {
	        _this4.modalState = _constants.DELEGATION_STATES.SUCCESS;
	        _this4.modalTitle = _this4.successTitle;
	        _this4.getDelegationsFromBack();
	
	        _this4.metricsService.trackFoodBenefitDelegation({ delegationType: delegationToCreate.type });
	      }, function (error) {
	        _this4.modalState = _constants.DELEGATION_STATES.ERROR;
	        _this4.modalMessage = error.data.message;
	        _this4.modalTitle = error.data.errors.codigo;
	      }).finally(function () {
	        _this4.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return $(_constants.MODALS.DELEGATIONS_MANAGER);
	    }
	  }]);
	  return FoodBenefitDelegationsController;
	}();
	
	exports.default = FoodBenefitDelegationsController;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1588);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./foodBenefitDelegations.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./foodBenefitDelegations.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _foodBenefitWorkTeam = __webpack_require__(1590);
	
	var _foodBenefitWorkTeam2 = _interopRequireDefault(_foodBenefitWorkTeam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitWorkTeamModule = _angular2.default.module('foodBenefitWorkTeam', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.FOOD_BENEFIT.WORK_TEAM, {
	    url: _routes.ROUTES.FOOD_BENEFIT.WORK_TEAM,
	    component: 'foodBenefitWorkTeam',
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).component('foodBenefitWorkTeam', _foodBenefitWorkTeam2.default).name;
	
	exports.default = foodBenefitWorkTeamModule;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _foodBenefitWorkTeam = __webpack_require__(1591);
	
	var _foodBenefitWorkTeam2 = _interopRequireDefault(_foodBenefitWorkTeam);
	
	var _foodBenefitWorkTeam3 = __webpack_require__(1592);
	
	var _foodBenefitWorkTeam4 = _interopRequireDefault(_foodBenefitWorkTeam3);
	
	__webpack_require__(1593);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitWorkTeamComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _foodBenefitWorkTeam2.default,
	  controller: _foodBenefitWorkTeam4.default
	};
	
	exports.default = foodBenefitWorkTeamComponent;

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	module.exports = "<modal-coachmark\n  ng-if=\"!$ctrl.isMobileApp && $ctrl.coachmarkData\"\n  data=\"$ctrl.coachmarkData\"\n  user-id=\"$ctrl.userId\">\n</modal-coachmark>\n\n<div class=\"container hpd animation-appear\"\n     ng-class=\"{'mobile': $ctrl.isMobileApp}\"\n     pull-to-refresh=\"$ctrl.$onInit()\">\n\n  <div class=\"welcome-msg\">\n    <span>\n      {{\"FOOD_BENEFIT.WORK_TEAM.HEADER\" | translate}}\n    </span>\n    <employee-search\n      on-search=\"$ctrl.onSearch($event)\"\n      on-select-employee=\"$ctrl.onSelectEmployeeSearch($event)\"\n      on-clean-search=\"$ctrl.onCleanSearchPlaceholder($event)\"\n      report-search-state=\"$ctrl.reportSearchState($event)\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      fixed-selection=\"true\">\n    </employee-search>\n  </div>\n\n  <alert-card class=\"alert-desktop\" ng-if=\"$ctrl.noHasResults() && !$ctrl.isMobileApp\" alert-style=\"red\" disabled-close=\"true\">\n    {{ 'EMPLOYEE_SEARCH.MSG_ALERT' | translate }} \"{{ $ctrl.searchText }}\"\n  </alert-card>\n\n  <div class=\"not-found-message responsiveMobile\">\n    <alert-card ng-if=\"$ctrl.noHasResults() && $ctrl.isMobileApp\">\n      {{ 'EMPLOYEE_SEARCH.MSG_ALERT' | translate }} \"{{ $ctrl.searchText }}\"\n    </alert-card>\n  </div>\n\n  <section class=\"restaurant-message\" ng-hide=\"$ctrl.noHasResults() && !$ctrl.isMobileApp\">\n    <alert-card is-mobile-app=\"$ctrl.isMobileApp\" alert-style=\"bluish\">{{'FOOD_BENEFIT.WORK_TEAM.RESTAURANT_MSG' | translate}}</alert-card>\n  </section>\n\n  <section class=\"team-list\">\n    <work-team-list employees=\"$ctrl.employees\" filtered-employees=\"$ctrl.employeeFilters\" on-clean-search=\"$ctrl.onCleanSearch($event)\" is-mobile-app=\"$ctrl.isMobileApp\"></work-team-list>\n  </section>\n</div>"

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(916);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FoodBenefitWorkTeamController = function () {
	  FoodBenefitWorkTeamController.$inject = ["$window", "FoodBenefitUserDataService", "ManagerDataService", "HelperDelegationsService", "FoodBenefitInitialDataManagerService"];
	  function FoodBenefitWorkTeamController($window, FoodBenefitUserDataService, ManagerDataService, HelperDelegationsService, FoodBenefitInitialDataManagerService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FoodBenefitWorkTeamController);
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.UserDataService = FoodBenefitUserDataService;
	    this.ManagerDataService = ManagerDataService;
	    this.helperDelegationsService = HelperDelegationsService;
	    this.InitialDataManagerService = FoodBenefitInitialDataManagerService;
	  }
	
	  (0, _createClass3.default)(FoodBenefitWorkTeamController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.isLoaded = false;
	      this.InitialDataManagerService.initMainData().then(function () {
	        _this.oneSearchIsDone = false;
	        _this.employeeFilters = [];
	        _this.userId = _this.UserDataService.getEmployee().userId;
	        _this.manager = _this.ManagerDataService.getManager();
	        _this.teamFoodBenefitsFormatted = _this.assembleTeamFoodBenefits(_this.manager.employeesFoodBenefitPeriods);
	        _this.employees = _this.formatInexistentMonthsWithCero(_this.teamFoodBenefitsFormatted);
	        _this.rawEmployeePeriods = _this.manager.employeesFoodBenefitPeriods;
	        _this.coachmarkData = _constants.AA_WORK_TEAM_MODAL_COACHMARK_CONFIG;
	        _this.isLoaded = true;
	      });
	    }
	  }, {
	    key: 'onSearch',
	    value: function onSearch() {
	      return this.helperDelegationsService.onSearchEmployeeDelegations(this.employees);
	    }
	  }, {
	    key: 'onSelectEmployeeSearch',
	    value: function onSelectEmployeeSearch($event) {
	      var employeeIdInFilters = this.employeeFilters.find(function (employee) {
	        return employee.employeeId === $event.employeeId;
	      });
	      if (!employeeIdInFilters) this.employeeFilters.push($event);
	      this.existFilters = true;
	    }
	  }, {
	    key: 'onCleanSearch',
	    value: function onCleanSearch($event) {
	      if ($event.searchText == '') {
	        this.employeeFilters = [];
	      }
	    }
	  }, {
	    key: 'onCleanSearchPlaceholder',
	    value: function onCleanSearchPlaceholder($event) {
	      if (this.isMobileApp) {
	        if ($event.searchText == '') {
	          this.employeeFilters = [];
	        }
	      }
	    }
	  }, {
	    key: 'reportSearchState',
	    value: function reportSearchState($event) {
	      this.hasResults = $event.hasResults;
	      this.searchText = $event.searchText;
	      this.oneSearchIsDone = true;
	    }
	  }, {
	    key: 'noHasResults',
	    value: function noHasResults() {
	      return this.hasResults === false && this.oneSearchIsDone === true;
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        responsiveMobile: this.isMobileApp
	      };
	    }
	  }, {
	    key: 'assembleTeamFoodBenefits',
	    value: function assembleTeamFoodBenefits(employeesFoodbenefits) {
	      var formattedFoodbenefits = [];
	      employeesFoodbenefits.forEach(function (period) {
	        var existEmployeeInArray = formattedFoodbenefits.find(function (employee) {
	          return employee.employeeId === period.employeeId;
	        });
	        if (!existEmployeeInArray) {
	          var newEmployeeToArray = {
	            name: period.name,
	            email: period.email,
	            employeeId: period.employeeId,
	            foodBenefits: [{
	              tickets: period.enjoymentDays,
	              enjoymentMonth: period.enjoymentMonth
	            }]
	          };
	          formattedFoodbenefits.push(newEmployeeToArray);
	        } else {
	          var newFoodBenefitToArray = {
	            tickets: period.enjoymentDays,
	            enjoymentMonth: period.enjoymentMonth
	          };
	          formattedFoodbenefits.forEach(function (employee) {
	            if (employee.employeeId === period.employeeId) {
	              employee.foodBenefits.push(newFoodBenefitToArray);
	            }
	          });
	        }
	      });
	
	      return formattedFoodbenefits;
	    }
	  }, {
	    key: 'formatInexistentMonthsWithCero',
	    value: function formatInexistentMonthsWithCero(employeesFoodBenefits) {
	      var currentMonthNumber = (0, _moment2.default)().format('MM');
	      var currentPreviousMonth = (0, _moment2.default)().month(currentMonthNumber - 2).format('MM');
	      var secondPreviousMonth = (0, _moment2.default)().month(currentMonthNumber - 3).format('MM');
	      var thirdPreviousMonth = (0, _moment2.default)().month(currentMonthNumber - 4).format('MM');
	      var fourthPreviousMonth = (0, _moment2.default)().month(currentMonthNumber - 5).format('MM');
	
	      var months = [currentPreviousMonth, secondPreviousMonth, thirdPreviousMonth, fourthPreviousMonth];
	
	      employeesFoodBenefits.forEach(function (employee) {
	        months.forEach(function (month) {
	          var existMonth = employee.foodBenefits.find(function (foodBenefit) {
	            return foodBenefit.enjoymentMonth === month;
	          });
	
	          if (!existMonth) {
	            var newMonth = {
	              tickets: 0,
	              enjoymentMonth: month
	            };
	            employee.foodBenefits.push(newMonth);
	          }
	        });
	      });
	
	      return employeesFoodBenefits;
	    }
	  }]);
	  return FoodBenefitWorkTeamController;
	}();
	
	exports.default = FoodBenefitWorkTeamController;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1594);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./foodBenefitWorkTeam.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./foodBenefitWorkTeam.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "food-benefit-work-team .container.hpd.mobile{padding-right:0;padding-left:0}food-benefit-work-team .container.hpd.mobile .welcome-msg{padding-top:0;padding-left:30px;padding-right:30px;border-bottom:0}food-benefit-work-team .container.hpd.mobile .welcome-msg>span{display:none}food-benefit-work-team .container.hpd.mobile .card-message-alert{margin-bottom:10px}food-benefit-work-team .welcome-msg{font-family:Arial;margin-right:-15px;margin-bottom:9px;margin-left:-15px;padding:12px 20px 23px;border-bottom:2px solid #eaebed;height:61px}food-benefit-work-team .welcome-msg>employee-search{margin-top:-22px}food-benefit-work-team .welcome-msg>span{font-size:15px;margin-bottom:0;color:#666;top:5px;position:relative;float:left}food-benefit-work-team .alert-desktop .card-message-alert{margin-top:0;padding:8px 10px;margin-left:7px;margin-bottom:41px}food-benefit-work-team .restaurant-message{padding-left:16px;padding-right:15px;padding-bottom:15px}food-benefit-work-team .not-found-message.mobile{padding-left:16px;padding-right:15px}food-benefit-work-team .not-found-message.mobile alert-card .icon-warning{color:#c8175e!important}food-benefit-work-team .not-found-message.mobile alert-card .card-message-alert{border-color:#c8175e;color:#c8175e}food-benefit-work-team .not-found-message.mobile alert-card .icon-cross,food-benefit-work-team .not-found-message.mobile alert-card .message-container{color:#c8175e}food-benefit-work-team employee-search .employee-search-container{max-width:449px;margin-top:0}food-benefit-work-team employee-search .employee-search-container .employee-search-input,food-benefit-work-team employee-search .employee-search-container input[type=text]{max-width:449px}food-benefit-work-team employee-dropdown-list ul{max-width:449px;width:100%}food-benefit-work-team .team-list{max-width:1034px}", ""]);
	
	// exports


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardBase = __webpack_require__(1596);
	
	var _cardBase2 = _interopRequireDefault(_cardBase);
	
	var _cardRequestDays = __webpack_require__(1602);
	
	var _cardRequestDays2 = _interopRequireDefault(_cardRequestDays);
	
	var _cardRequestSuccess = __webpack_require__(1608);
	
	var _cardRequestSuccess2 = _interopRequireDefault(_cardRequestSuccess);
	
	var _cardRequestFailure = __webpack_require__(1614);
	
	var _cardRequestFailure2 = _interopRequireDefault(_cardRequestFailure);
	
	var _cardAvatar = __webpack_require__(1620);
	
	var _cardAvatar2 = _interopRequireDefault(_cardAvatar);
	
	var _benefitRequestList = __webpack_require__(1626);
	
	var _benefitRequestList2 = _interopRequireDefault(_benefitRequestList);
	
	var _benefitRequestCard = __webpack_require__(1634);
	
	var _benefitRequestCard2 = _interopRequireDefault(_benefitRequestCard);
	
	var _benefitRequestModal = __webpack_require__(1647);
	
	var _benefitRequestModal2 = _interopRequireDefault(_benefitRequestModal);
	
	var _userCardList = __webpack_require__(1671);
	
	var _userCardList2 = _interopRequireDefault(_userCardList);
	
	var _userCardRow = __webpack_require__(1677);
	
	var _userCardRow2 = _interopRequireDefault(_userCardRow);
	
	var _lastDayAlert = __webpack_require__(1683);
	
	var _lastDayAlert2 = _interopRequireDefault(_lastDayAlert);
	
	var _benefitRequestDays = __webpack_require__(1689);
	
	var _benefitRequestDays2 = _interopRequireDefault(_benefitRequestDays);
	
	var _delegatedCardListMobile = __webpack_require__(1695);
	
	var _delegatedCardListMobile2 = _interopRequireDefault(_delegatedCardListMobile);
	
	var _delegatedCardRow = __webpack_require__(1701);
	
	var _delegatedCardRow2 = _interopRequireDefault(_delegatedCardRow);
	
	var _delegatedCardAvatar = __webpack_require__(1707);
	
	var _delegatedCardAvatar2 = _interopRequireDefault(_delegatedCardAvatar);
	
	var _delegatedCardRequest = __webpack_require__(1712);
	
	var _delegatedCardRequest2 = _interopRequireDefault(_delegatedCardRequest);
	
	var _delegatedCardRequestCounter = __webpack_require__(1718);
	
	var _delegatedCardRequestCounter2 = _interopRequireDefault(_delegatedCardRequestCounter);
	
	var _delegatedRequestModal = __webpack_require__(1724);
	
	var _delegatedRequestModal2 = _interopRequireDefault(_delegatedRequestModal);
	
	var _workTeamList = __webpack_require__(1730);
	
	var _workTeamList2 = _interopRequireDefault(_workTeamList);
	
	var _workTeamCard = __webpack_require__(1736);
	
	var _workTeamCard2 = _interopRequireDefault(_workTeamCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitComponents = angular.module('food-benefit.components', [_cardBase2.default, _cardAvatar2.default, _cardRequestDays2.default, _benefitRequestList2.default, _benefitRequestCard2.default, _cardRequestSuccess2.default, _cardRequestFailure2.default, _benefitRequestModal2.default, _userCardList2.default, _userCardRow2.default, _lastDayAlert2.default, _benefitRequestDays2.default, _delegatedCardListMobile2.default, _delegatedCardRow2.default, _delegatedCardAvatar2.default, _delegatedCardRequest2.default, _delegatedCardRequestCounter2.default, _delegatedRequestModal2.default, _workTeamList2.default, _workTeamCard2.default]).name;
	
	exports.default = foodBenefitComponents;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cardBase = __webpack_require__(1597);
	
	var _cardBase2 = _interopRequireDefault(_cardBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardBaseModule = _angular2.default.module('food-benefit.cardBase', [_angularUiRouter2.default]).component('cardBase', _cardBase2.default).name;
	
	exports.default = cardBaseModule;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardBase = __webpack_require__(1598);
	
	var _cardBase2 = _interopRequireDefault(_cardBase);
	
	var _cardBase3 = __webpack_require__(1599);
	
	var _cardBase4 = _interopRequireDefault(_cardBase3);
	
	__webpack_require__(1600);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardBaseComponent = {
	  transclude: true,
	  restrict: 'E',
	  bindings: {
	    card: '<',
	    requestErrorMsg: '<',
	    requestFoodBenefits: '&',
	    checkModify: '&',
	    resetCardState: '&',
	    daysIsFocused: '&',
	    isMobileApp: '<',
	    withoutManager: '<',
	    cardBaseId: '@'
	  },
	  template: _cardBase2.default,
	  controller: _cardBase4.default
	};
	
	exports.default = cardBaseComponent;

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card-base\"\n     ng-class=\"$ctrl.getContainerCss()\">\n  <card-request-days ng-if=\"$ctrl.isInitialOrSended()\"\n                     id=\"{{$ctrl.cardBaseId}}\"\n                     card-data=\"$ctrl.card\"\n                     requested=\"$ctrl.card.state === $ctrl.states.requested\"\n                     approved=\"$ctrl.card.state === $ctrl.states.approved\"\n                     modified=\"$ctrl.card.state === $ctrl.states.modified\"\n                     send-edit-notification=\"$ctrl.notifyEdition($event)\"\n                     send-request=\"$ctrl.createPeriod($event)\"\n                     focused=\"$ctrl.isFocused($event)\"\n                     is-mobile-app=\"$ctrl.isMobileApp\">\n  </card-request-days>\n  <card-request-success ng-if=\"$ctrl.hasSuccess()\"\n                        on-close=\"$ctrl.realoadCardState()\"\n                        is-mobile-app=\"$ctrl.isMobileApp\"\n                        without-manager=\"$ctrl.withoutManager\">\n  </card-request-success>\n  <card-request-failure ng-if=\"$ctrl.hasError()\"\n                        days=\"$ctrl.numberDaysError\"\n                        on-close=\"$ctrl.realoadCardState()\"\n                        error-msg=\"$ctrl.card.requestErrorMsg\"\n                        is-mobile-app=\"$ctrl.isMobileApp\">\n  </card-request-failure>\n</div>\n"

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardBaseController = function () {
	  CardBaseController.$inject = ["$location", "$translate", "EventEmitter"];
	  function CardBaseController($location, $translate, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CardBaseController);
	    this.location = $location;
	    this.name = 'cardBase';
	    this.states = _constants.FOOD_BENEFIT_STATES;
	    this.translate = $translate;
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(CardBaseController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.numberDaysError = this.card.maximumNumberDaysPerMonth;
	      this.previousState = this.card.state;
	    }
	  }, {
	    key: 'hasSuccess',
	    value: function hasSuccess() {
	      return this.card.state === this.states.success;
	    }
	  }, {
	    key: 'hasError',
	    value: function hasError() {
	      return this.card.state === this.states.error;
	    }
	  }, {
	    key: 'isInitialOrSended',
	    value: function isInitialOrSended() {
	      return this.card.state === this.states.initial || this.card.state === this.states.requested || this.card.state === this.states.approved || this.card.state === this.states.modified;
	    }
	  }, {
	    key: 'createPeriod',
	    value: function createPeriod($event) {
	      var event = this.EventEmitter($event);
	      this.requestFoodBenefits(event);
	    }
	  }, {
	    key: 'notifyEdition',
	    value: function notifyEdition($event) {
	      this.card = $event;
	      var event = this.EventEmitter(this.card);
	      this.checkModify(event);
	    }
	  }, {
	    key: 'realoadCardState',
	    value: function realoadCardState() {
	      var event = this.EventEmitter(this.card);
	      this.resetCardState(event);
	    }
	  }, {
	    key: 'isFocused',
	    value: function isFocused($event) {
	      var event = this.EventEmitter($event);
	      this.isInEditMode = $event.isFocused;
	      this.daysIsFocused(event);
	
	      if ($event.isFocused) this.scrollToCurrentCard(this.cardBaseId);
	    }
	  }, {
	    key: 'getContainerCss',
	    value: function getContainerCss() {
	      return {
	        'active': this.isInEditMode,
	        'success': this.hasSuccess(),
	        'error': this.hasError(),
	        'responsiveMobile': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'scrollToCurrentCard',
	    value: function scrollToCurrentCard(id) {
	      var page = $('html, body');
	      var cardOffset = 75; //px
	      var card = $('#' + id).offset().top - cardOffset;
	      page.animate({ scrollTop: card }, 'slow');
	    }
	  }]);
	  return CardBaseController;
	}();
	
	exports.default = CardBaseController;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1601);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardBase.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardBase.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, ".card-base{margin:0 6px;min-width:180px;height:164px;border-radius:10px;background-color:#fff;border:1px solid #dddfe2}.card-base.active{border:1px solid #0072c9}.card-base.success{border:1px solid #86c82d}.card-base.error{border:1px solid #c8175e}.card-base.mobile{min-width:0}", ""]);
	
	// exports


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cardRequestDays = __webpack_require__(1603);
	
	var _cardRequestDays2 = _interopRequireDefault(_cardRequestDays);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardRequestDaysModule = _angular2.default.module('cardRequestDays', [_angularUiRouter2.default]).component('cardRequestDays', _cardRequestDays2.default).name;
	
	exports.default = cardRequestDaysModule;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardRequestDays = __webpack_require__(1604);
	
	var _cardRequestDays2 = _interopRequireDefault(_cardRequestDays);
	
	var _cardRequestDays3 = __webpack_require__(1605);
	
	var _cardRequestDays4 = _interopRequireDefault(_cardRequestDays3);
	
	__webpack_require__(1606);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardRequestDaysComponent = {
	  restrict: 'E',
	  bindings: {
	    cardData: '<',
	    requested: '<',
	    approved: '<',
	    sendRequest: '&',
	    sendEditNotification: '&',
	    focused: '&',
	    isMobileApp: '<'
	  },
	  template: _cardRequestDays2.default,
	  controller: _cardRequestDays4.default
	};
	
	exports.default = cardRequestDaysComponent;

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"card-request-container\" ng-class\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"status-icon\">\n    <span class=\"icon-requested\" ng-show=\"$ctrl.showRequestedIcon()\">\n      <span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span>\n    </span>\n    <span class=\"icon icon-approved\" ng-show=\"$ctrl.showApprovedIcon()\">\n      <span class=\"path1\"></span><span class=\"path2\"></span>\n    </span>\n  </div>\n  <h1 class=\"title\">{{$ctrl.month | translate}}</h1>\n  <div class=\"input-group-actions\">\n    <i class=\"icon icon-minus-circle\"\n       ng-click=\"$ctrl.decreaseOneDay()\"\n       ng-show=\"$ctrl.inEditMode\"\n       ng-if=\"!$ctrl.isMobileApp\"></i>\n    <input class=\"days-input\"\n           type=\"tel\"\n           name=\"days\"\n           focus-position-end\n           ng-class=\"$ctrl.getClassInDaysInput()\"\n           ng-model=\"$ctrl.days\"\n           ng-click=\"$ctrl.toEditMode()\"\n           ng-blur=\"$ctrl.toNotEditMode()\"\n           ng-change=\"$ctrl.edit()\">\n    <i class=\"icon icon-plus-circle\"\n        ng-click=\"$ctrl.increaseOneDay()\"\n        ng-show=\"$ctrl.inEditMode\"\n        ng-if=\"!$ctrl.isMobileApp\"></i>\n  </div>\n  <span class=\"input-label\"\n        ng-hide=\"$ctrl.inEditMode && !$ctrl.isMobileApp\">\n        {{'FOOD_BENEFIT.MAIN.WORKDAY' | translate}}</span>\n  <button class=\"btn btn-app btn-primary send-button\"\n          ng-if=\"!$ctrl.isMobileApp\"\n          type=\"button\"\n          ng-show=\"$ctrl.inEditMode\"\n          ng-click=\"$ctrl.send()\"\n          ng-disabled=\"$ctrl.isSendDisabled()\">\n          {{'GLOBALS.BUTTON_ACTION.SEND' | translate}}</button>\n  <div class=\"status-label\" ng-if=\"$ctrl.isModifiedByManager()\">\n    <span>\n      {{ 'FOOD_BENEFIT.MAIN.MODIFIED_BY_MANAGER' | translate }}\n    </span>\n  </div>\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp && $ctrl.cardIsEdited()\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.send()\">\n  </floating-action-buttons>\n</section>\n"

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(598);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MIN_DAYS = 0;
	
	var CardRequestDaysController = function () {
	  CardRequestDaysController.$inject = ["EventEmitter", "$scope", "floatingActionButtonsService"];
	  function CardRequestDaysController(EventEmitter, $scope, floatingActionButtonsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CardRequestDaysController);
	    this.inEditMode = false;
	    this.wasFirstEdition = false;
	    this.eventEmitter = EventEmitter;
	    this.days = 0;
	    this.month = '';
	    this.coinSide;
	    this.scope = $scope;
	    this.floatingActionButtonsService = floatingActionButtonsService;
	  }
	
	  (0, _createClass3.default)(CardRequestDaysController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (!this.cardData) return;
	      _moment2.default.locale('es');
	      var dateToGetMonth = new Date(this.cardData.enjoymentYear, this.cardData.enjoymentMonth - 1);
	      this.month = (0, _moment2.default)(dateToGetMonth).format('MMMM');
	      this.initDays = this.cardData.enjoymentDays;
	      this.days = this.cardData.enjoymentDays;
	      this.daysBackup = this.days;
	      this.initState = this.cardData.state;
	      this.stateBackup = this.cardData.state;
	      this.startWatchingDays();
	
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'startWatchingDays',
	    value: function startWatchingDays() {
	      var _this = this;
	
	      this.scope.$watch(function () {
	        return _this.days;
	      }, function () {
	        if ((0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(_this.days)) {
	          return;
	        }
	        if (_this.isNotValidAmountOfDays()) {
	          _this.cardData.state = _constants.FOOD_BENEFIT_STATES.error;
	        }
	      });
	    }
	  }, {
	    key: 'cardIsEdited',
	    value: function cardIsEdited() {
	      return !this.floatingActionButtonsService.isFocused && !this.daysIsFocused && this.isDayModified();
	    }
	  }, {
	    key: 'isDayModified',
	    value: function isDayModified() {
	      return this.inEditMode && !this.isSendDisabled();
	    }
	  }, {
	    key: 'toNotEditMode',
	    value: function toNotEditMode() {
	      if (this.isMobileApp) {
	        this.daysIsFocused = false;
	        var event = this.eventEmitter({
	          isFocused: this.daysIsFocused
	        });
	        this.focused(event);
	        this._setDefaultDaysValueWhenEmpty();
	      }
	    }
	  }, {
	    key: 'toEditMode',
	    value: function toEditMode() {
	      this.inEditMode = true;
	      if (this.isMobileApp) {
	        this.daysIsFocused = true;
	        var event = this.eventEmitter({
	          isFocused: this.daysIsFocused
	        });
	        this.focused(event);
	      }
	      this.checkFirstEdition();
	    }
	  }, {
	    key: 'setModified',
	    value: function setModified() {
	      if (this.cardData.state === '' || !this.isSendDisabled()) this.cardData.state = _constants.FOOD_BENEFIT_STATES.modified;
	    }
	  }, {
	    key: 'checkFirstEdition',
	    value: function checkFirstEdition() {
	      if (this.cardData.state === '' && this.days == 0) {
	        this.wasFirstEdition = true;
	        this.edit();
	      }
	    }
	  }, {
	    key: 'toOriginalState',
	    value: function toOriginalState() {
	      this.cardData.state = this.stateBackup;
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      this.sanitizeDayPeriods();
	      this.cardData.enjoymentDays = this.days;
	      this.setCardState();
	      var event = this.eventEmitter(this.cardData);
	      this.sendEditNotification(event);
	    }
	  }, {
	    key: 'setCardState',
	    value: function setCardState() {
	      var isEditedToOriginalData = parseInt(this.cardData.enjoymentDays) === parseInt(this.daysBackup) && !this.wasFirstEdition;
	      this.setModified();
	      if (isEditedToOriginalData) {
	        this.inEditMode = false;
	        this.toOriginalState();
	      }
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      this.inEditMode = false;
	      this.cardData.requestErrorMsg = '';
	      if (this.isNotValidAmountOfDays()) {
	        this.cardData.state = _constants.FOOD_BENEFIT_STATES.error;
	        return;
	      }
	
	      var event = this.eventEmitter(this.cardData);
	      this.sendRequest(event);
	    }
	  }, {
	    key: 'isNotValidAmountOfDays',
	    value: function isNotValidAmountOfDays() {
	      return this.days < MIN_DAYS || (0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.days) || this.days > this.cardData.maximumNumberDaysPerMonth;
	    }
	  }, {
	    key: 'increaseOneDay',
	    value: function increaseOneDay() {
	      var NEXT_DAY = this.days + 1;
	      if (NEXT_DAY <= this.cardData.maximumNumberDaysPerMonth) {
	        this.days = this.days + 1;
	      } else {
	        this.cardData.state = _constants.FOOD_BENEFIT_STATES.error;
	      }
	
	      this.edit();
	    }
	  }, {
	    key: 'decreaseOneDay',
	    value: function decreaseOneDay() {
	      var PREV_DAY = this.days - 1;
	      if (PREV_DAY >= MIN_DAYS) {
	        this.days = this.days - 1;
	      } else {
	        if (!this.wasFirstEdition) this.cardData.state = _constants.FOOD_BENEFIT_STATES.error;
	      }
	
	      this.edit();
	    }
	  }, {
	    key: 'isRequestSended',
	    value: function isRequestSended() {
	      return this.requested || this.approved;
	    }
	  }, {
	    key: 'isModifiedByManager',
	    value: function isModifiedByManager() {
	      var SHOW_LABEL = false;
	      return !this.inEditMode && this.approved && SHOW_LABEL;
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.SEND'
	      }];
	    }
	  }, {
	    key: 'isSendDisabled',
	    value: function isSendDisabled() {
	      return parseInt(this.days) === parseInt(this.initDays) && (this.initState === _constants.FOOD_BENEFIT_STATES.approved || this.initState === _constants.FOOD_BENEFIT_STATES.requested);
	    }
	  }, {
	    key: 'sanitizeDayPeriods',
	    value: function sanitizeDayPeriods() {
	      if (!this.isMobileApp) {
	        this._setDefaultDaysValueWhenEmpty();
	
	        if (this.days < MIN_DAYS) this.days = MIN_DAYS;
	
	        this.days = parseInt(this.days);
	      }
	    }
	  }, {
	    key: '_setDefaultDaysValueWhenEmpty',
	    value: function _setDefaultDaysValueWhenEmpty() {
	      var isDaysEmpty = isNaN(this.days) || this.days === '' || !this.days;
	      if (isDaysEmpty) this.days = MIN_DAYS;
	    }
	  }, {
	    key: 'getClassInDaysInput',
	    value: function getClassInDaysInput() {
	      return {
	        'active': this.inEditMode && !this.isSendDisabled(),
	        'requested': this.isRequestSended() && !this.inEditMode,
	        'not-modified': this.isMobileApp && !this.daysIsFocused && this.isSendDisabled()
	      };
	    }
	  }, {
	    key: 'showRequestedIcon',
	    value: function showRequestedIcon() {
	      return this.requested && !this.daysIsFocused && this.isSendDisabled();
	    }
	  }, {
	    key: 'showApprovedIcon',
	    value: function showApprovedIcon() {
	      return this.approved && !this.daysIsFocused && this.isSendDisabled();
	    }
	  }]);
	  return CardRequestDaysController;
	}();
	
	exports.default = CardRequestDaysController;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1607);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardRequestDays.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardRequestDays.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "card-request-days .card-request-container{text-align:center}card-request-days .card-request-container h1.title{color:#666;font-size:16px;font-weight:400;padding:11px 0 4px;margin:0 auto 16px;max-width:116px;border-bottom:1px solid #eaebed;text-transform:capitalize}card-request-days .card-request-container .status-icon{font-size:20px;float:right;padding:5px 7px}card-request-days .card-request-container .input-group-actions{display:flex;align-items:center;justify-content:space-around}card-request-days .card-request-container .input-group-actions .icon{font-size:32px;padding-bottom:4px;cursor:pointer}card-request-days .card-request-container .input-group-actions .icon-minus-circle{padding-left:10px}card-request-days .card-request-container .input-group-actions .icon-plus-circle{padding-right:10px}card-request-days .card-request-container input.days-input{background-color:#fff;display:block;cursor:pointer;width:70px;height:50px;line-height:50px;border-radius:3px;border:1px solid #dddfe2;font-family:Stag Sans;padding:0;margin-bottom:4px;font-size:42px;text-align:center;color:#0072c9;padding-top:2px}card-request-days .card-request-container input.days-input.active,card-request-days .card-request-container input.days-input:focus{outline:none;border:1px solid #0072c9}card-request-days .card-request-container input.days-input.not-modified,card-request-days .card-request-container input.days-input.requested{border:none}card-request-days .card-request-container .input-label{display:block;font-family:Stag Sans;font-size:16px;color:#666}card-request-days .card-request-container .current-days{font-size:42px;line-height:1;padding:6px;color:#0072c9}card-request-days .card-request-container .send-button{width:120px;height:38px;margin-top:10px;line-height:.9}card-request-days .card-request-container .status-label{width:163px;height:24px;padding-top:3px;margin:13px auto;background-color:#f4f4f4}card-request-days .card-request-container .status-label span{font-family:Stag Sans;font-size:12px;color:#666}", ""]);
	
	// exports


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cardRequestSuccess = __webpack_require__(1609);
	
	var _cardRequestSuccess2 = _interopRequireDefault(_cardRequestSuccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardRequestSuccessModule = _angular2.default.module('cardRequestSuccess', [_angularUiRouter2.default]).component('cardRequestSuccess', _cardRequestSuccess2.default).name;
	
	exports.default = cardRequestSuccessModule;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardRequestSuccess = __webpack_require__(1610);
	
	var _cardRequestSuccess2 = _interopRequireDefault(_cardRequestSuccess);
	
	var _cardRequestSuccess3 = __webpack_require__(1611);
	
	var _cardRequestSuccess4 = _interopRequireDefault(_cardRequestSuccess3);
	
	__webpack_require__(1612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardRequestSuccessComponent = {
	  restrict: 'E',
	  bindings: {
	    onClose: '&',
	    withoutManager: '<'
	  },
	  template: _cardRequestSuccess2.default,
	  controller: _cardRequestSuccess4.default
	};
	
	exports.default = cardRequestSuccessComponent;

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card-request-success\">\n  <i class=\"icon icon-cross\" ng-click=\"$ctrl.onClose()\"></i>\n  <i class=\"icon icon-confirmation\"></i>\n  <p ng-if=\"!$ctrl.withoutManager\">{{'FOOD_BENEFIT.CARD_REQUEST_SUCCESS.MESSAGE' | translate}}</p>\n  <p ng-if=\"$ctrl.withoutManager\">{{'FOOD_BENEFIT.CARD_REQUEST_SUCCESS.MESSAGE_WITHOUT_MANAGER' | translate}}</p>\n</div>\n"

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardRequestSuccessController = function CardRequestSuccessController() {
	  (0, _classCallCheck3.default)(this, CardRequestSuccessController);
	};
	
	exports.default = CardRequestSuccessController;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1613);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardRequestSuccess.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardRequestSuccess.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, ".card-request-success{position:relative}.card-request-success .icon-cross{position:absolute;top:10px;right:10px;font-size:15px;color:#aeaeae;cursor:pointer}.card-request-success .icon-confirmation{display:block;font-size:40px;width:40px;margin:auto;padding-top:22px;padding-bottom:15px;color:#86c82d}.card-request-success p{max-height:70px;overflow-x:hidden;text-align:center;letter-spacing:.5px;padding:0 15px;line-height:1.3;font-family:Stag Sans}", ""]);
	
	// exports


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cardRequestFailure = __webpack_require__(1615);
	
	var _cardRequestFailure2 = _interopRequireDefault(_cardRequestFailure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardRequestFailureModule = _angular2.default.module('cardRequestFailure', [_angularUiRouter2.default]).component('cardRequestFailure', _cardRequestFailure2.default).name;
	
	exports.default = cardRequestFailureModule;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardRequestFailure = __webpack_require__(1616);
	
	var _cardRequestFailure2 = _interopRequireDefault(_cardRequestFailure);
	
	var _cardRequestFailure3 = __webpack_require__(1617);
	
	var _cardRequestFailure4 = _interopRequireDefault(_cardRequestFailure3);
	
	__webpack_require__(1618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardRequestFailureComponent = {
	  restrict: 'E',
	  bindings: {
	    days: '<',
	    errorMsg: '<',
	    onClose: '&'
	  },
	  template: _cardRequestFailure2.default,
	  controller: _cardRequestFailure4.default
	};
	
	exports.default = cardRequestFailureComponent;

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card-request-failure\">\n  <i class=\"icon icon-cross\" ng-click=\"$ctrl.onClose()\"></i>\n  <i class=\"icon icon-warning\"></i>\n  <p ng-if=\"$ctrl.errorMsgIsEmpty()\">\n    {{'FOOD_BENEFIT.CARD_REQUEST_FAILURE.MESSAGE' | translate}}\n    <strong>{{$ctrl.days}} {{'FOOD_BENEFIT.CARD_REQUEST_FAILURE.MESSAGE_DAYS' | translate}}</strong>\n  </p>\n  <p ng-if=\"!$ctrl.errorMsgIsEmpty()\" ng-bind=\"$ctrl.errorMsg\"></p>\n</div>\n"

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardRequestFailureController = function () {
	  function CardRequestFailureController() {
	    (0, _classCallCheck3.default)(this, CardRequestFailureController);
	  }
	
	  (0, _createClass3.default)(CardRequestFailureController, [{
	    key: "errorMsgIsEmpty",
	    value: function errorMsgIsEmpty() {
	      return !this.errorMsg;
	    }
	  }]);
	  return CardRequestFailureController;
	}();
	
	exports.default = CardRequestFailureController;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1619);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardRequestFailure.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardRequestFailure.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, ".card-request-failure{position:relative}.card-request-failure .icon-cross{position:absolute;top:10px;right:10px;font-size:15px;color:#aeaeae;cursor:pointer}.card-request-failure .icon-warning{display:block;font-size:40px;width:40px;margin:auto;padding-top:22px;padding-bottom:15px;color:#c8175e}.card-request-failure p{max-height:70px;overflow-x:hidden;text-align:center;letter-spacing:.5px;padding:0 15px;line-height:1.3;font-family:Stag Sans}.card-request-failure p strong{font-weight:500}", ""]);
	
	// exports


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cardAvatar = __webpack_require__(1621);
	
	var _cardAvatar2 = _interopRequireDefault(_cardAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardAvatarModule = _angular2.default.module('cardAvatar', [_angularUiRouter2.default]).component('cardAvatar', _cardAvatar2.default).name;
	
	exports.default = cardAvatarModule;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardAvatar = __webpack_require__(1622);
	
	var _cardAvatar2 = _interopRequireDefault(_cardAvatar);
	
	var _cardAvatar3 = __webpack_require__(1623);
	
	var _cardAvatar4 = _interopRequireDefault(_cardAvatar3);
	
	__webpack_require__(1624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardAvatarComponent = {
	  restrict: 'E',
	  bindings: {
	    employee: '<'
	  },
	  template: _cardAvatar2.default,
	  controller: _cardAvatar4.default
	};
	
	exports.default = cardAvatarComponent;

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card-avatar\">\n  <h2 class=\"name\">\n    <employee-name name=\"{{$ctrl.employee.name}}\" enrollment=\"{{$ctrl.employee.userId}}\"></employee-name>\n  </h2>\n  <avatar-app ng-if=\"$ctrl.employee !== undefined\"\n              size-big\n              name=\"$ctrl.employee.name\"\n              email=\"$ctrl.employee.email\"\n              user-id=\"$ctrl.employee.userId\"></avatar-app>\n</div>\n"

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardAvatarController = function CardAvatarController() {
	  (0, _classCallCheck3.default)(this, CardAvatarController);
	};
	
	exports.default = CardAvatarController;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1625);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardAvatar.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardAvatar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, ".card-avatar{margin:0 6px;width:136px;height:164px;border-radius:10px;border:1px solid #dddfe2;background:linear-gradient(180deg,#fff 58%,#f4f4f4 0);position:relative;text-transform:capitalize}.card-avatar .name{font-size:14px;font-family:Stag Sans;font-weight:300;line-height:1.1;text-align:center;color:#3e3e3e;margin:17px 5px 10px}.card-avatar avatar-app{position:absolute;top:37%;right:25%}.card-avatar avatar-app .avatar-container{width:70px;height:70px;line-height:70px}", ""]);
	
	// exports


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _benefitRequestList = __webpack_require__(1627);
	
	var _benefitRequestList2 = _interopRequireDefault(_benefitRequestList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var benefitRequestListModule = _angular2.default.module('benefitRequestList', [_angularUiRouter2.default]).component('benefitRequestList', _benefitRequestList2.default).name;
	
	exports.default = benefitRequestListModule;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _benefitRequestList = __webpack_require__(1628);
	
	var _benefitRequestList2 = _interopRequireDefault(_benefitRequestList);
	
	var _benefitRequestList3 = __webpack_require__(1629);
	
	var _benefitRequestList4 = _interopRequireDefault(_benefitRequestList3);
	
	__webpack_require__(1632);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var benefitRequestListComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    periods: '<',
	    isRequestOk: '<',
	    requestDataUpdate: '&',
	    hasDelegations: '<'
	  },
	  template: _benefitRequestList2.default,
	  controller: _benefitRequestList4.default
	};
	
	exports.default = benefitRequestListComponent;

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	module.exports = "<benefit-request-modal\n  is-mobile-app=\"$ctrl.isMobileApp\"\n  modal-id=\"modalBenefitRequest\"\n  request=\"$ctrl.requestModal\"\n  modal-state=\"$ctrl.modalState\"\n  action-in-modal=\"$ctrl.setStatus($event)\"\n  period-count=\"$ctrl.getRequestCount()\"\n  error-msg=\"$ctrl.errorMsg\">\n</benefit-request-modal>\n\n<div>\n\n  <div class=\"accept-all-container\" ng-if=\"!$ctrl.isEmpty()\">\n    <button\n      ng-if=\"!$ctrl.isMobileApp\"\n      type=\"button\"\n      class=\"btn btn-app btn-primary right-aligned\"\n      ng-class=\"$ctrl.getApproveAllClasses()\"\n      ng-click=\"$ctrl.openModalAcceptAll()\">\n      {{'GLOBALS.BUTTON_ACTION.ACCEPT_ALL' | translate}}\n    </button>\n\n    <div ng-repeat=\"request in $ctrl.periods\">\n      <benefit-request-card\n        is-mobile-app=\"$ctrl.isMobileApp\"\n        card-id=\"benefit-request-card-{{$index}}\"\n        request=\"request\"\n        process-request=\"$ctrl.onProcessPeriod($event)\"\n        day-periods=\"request.enjoymentDays\">\n      </benefit-request-card>\n    </div>\n  </div>\n\n  <div class=\"list-empty\" ng-if=\"$ctrl.isEmpty()\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n    <span class=\"icon-warning\"></span>\n    <span>{{'FOOD_BENEFIT.BENEFIT_REQUEST_LIST.EMPTY_REQUESTS_LIST' | translate}}</span>\n  </div>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.showSendAllRequest()\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.openModalAcceptAll()\">\n  </floating-action-buttons>\n\n</div>\n"

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(916);
	
	var _periodsHelper = __webpack_require__(1630);
	
	var _periodsHelper2 = _interopRequireDefault(_periodsHelper);
	
	var _messageFormatter = __webpack_require__(1631);
	
	var _messageFormatter2 = _interopRequireDefault(_messageFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BenefitRequestListController = function () {
	  BenefitRequestListController.$inject = ["foodBenefitService", "FoodBenefitUserDataService", "$translate", "loadingMobileService", "floatingActionButtonsService"];
	  function BenefitRequestListController(foodBenefitService, FoodBenefitUserDataService, $translate, loadingMobileService, floatingActionButtonsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BenefitRequestListController);
	    this.translate = $translate;
	    this.foodBenefitService = foodBenefitService;
	    this.FoodBenefitUserDataService = FoodBenefitUserDataService;
	    this.loadingMobileService = loadingMobileService;
	    this.requestsToSend = [];
	    this.periodsHelper = new _periodsHelper2.default();
	    this.messageFormatter = new _messageFormatter2.default();
	    this.floatingActionButtonsService = floatingActionButtonsService;
	  }
	
	  (0, _createClass3.default)(BenefitRequestListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.managerId = this.FoodBenefitUserDataService.getEmployee().userId;
	      this._translate();
	
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'isEmpty',
	    value: function isEmpty() {
	      return !this.periods.some(function (period) {
	        return period.status !== _constants2.CARD_STATUS.APPROVE;
	      });
	    }
	  }, {
	    key: 'getApproveAllClasses',
	    value: function getApproveAllClasses() {
	      return {
	        invisible: this.periods.length === 1
	      };
	    }
	  }, {
	    key: 'onProcessPeriod',
	    value: function onProcessPeriod(_ref) {
	      var request = _ref.request;
	
	      if (request.status === _constants2.CARD_STATUS.REJECT) {
	        this.openModalReject(request);
	      } else if (request.status === _constants2.CARD_STATUS.APPROVE) {
	        this.loadPeriodToSend(request);
	      }
	    }
	  }, {
	    key: 'openModalIsDelegated',
	    value: function openModalIsDelegated() {
	      this.modalState = _constants2.MODAL_STATES.isDelegated;
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'openModalAcceptAll',
	    value: function openModalAcceptAll() {
	      this.modalState = _constants2.MODAL_STATES.managerListConfirmAll;
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'openModalReject',
	    value: function openModalReject(request) {
	      this.modalState = _constants2.MODAL_STATES.isManagerRejecting;
	      this.requestModal = request;
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'loadPeriodToSend',
	    value: function loadPeriodToSend(request) {
	      var rawPeriod = Array(request);
	      this.requestsToSend = [];
	      this.requestsToSend.push(request);
	      this.requestsToSend = this.formatPeriodsToSendRequest(this.requestsToSend);
	      this.send(this.requestsToSend, rawPeriod, this.managerId);
	    }
	  }, {
	    key: 'setStatus',
	    value: function setStatus($event) {
	      this.modalAction = $event.status;
	
	      if (!this.modalAction) {
	        return;
	      }
	
	      if ($event.status === _constants2.MODAL_ACTIONS.CANCEL) {
	        this.modal.modal('hide');
	      }
	
	      if ($event.status === _constants2.MODAL_ACTIONS.REJECT) {
	        this.loadPeriodToSend($event.request);
	      }
	
	      if ($event.status === _constants2.MODAL_ACTIONS.APPROVE_ALL) {
	        this.onAcceptAll();
	      }
	    }
	  }, {
	    key: 'getRequestCount',
	    value: function getRequestCount() {
	      return this.periods.length;
	    }
	  }, {
	    key: 'onAcceptAll',
	    value: function onAcceptAll() {
	      this.rawPeriods = this.periods;
	      this.requestsToSend = this.periods;
	      this.requestsToSend = this.setAllAsSuccess(this.requestsToSend);
	      var formattedPeriods = this.formatPeriodsToSendRequest(this.requestsToSend);
	      this.send(formattedPeriods, this.rawPeriods, this.managerId);
	    }
	  }, {
	    key: 'formatPeriodsToSendRequest',
	    value: function formatPeriodsToSendRequest(periods) {
	      var _this = this;
	
	      var periodsProcessed = [];
	      periods.forEach(function (period) {
	        periodsProcessed.push(_this.transformPeriodToRequest(period));
	      });
	      return periodsProcessed;
	    }
	  }, {
	    key: 'transformPeriodToRequest',
	    value: function transformPeriodToRequest(period) {
	      return {
	        employeeId: period.employeeId,
	        enjoymentYear: period.enjoymentYear,
	        enjoymentMonth: period.enjoymentMonth,
	        enjoymentDays: period.enjoymentDays,
	        remarks: period.remarks,
	        status: period.status
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(request, rawPeriods, managerId) {
	      var _this2 = this;
	
	      this.loadingMobileService.show();
	      this.foodBenefitService.validateFoodBenefits(request, managerId).then(function () {
	        _this2._buildModalMessage(request, rawPeriods);
	        _this2.modalState = _this2.getModalStateOnSuccess(_this2.modalState);
	        _this2.modal.modal('show');
	        _this2.periods = [];
	        _this2.requestDataUpdate();
	      }, function (err) {
	        _this2.errorMsg = err.data.message;
	        _this2.setAllAsRequested(_this2.requestsToSend);
	        _this2.modalState = _constants2.MODAL_STATES.failed;
	        _this2.modal.modal('show');
	      }).finally(function () {
	        return _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'getModalStateOnSuccess',
	    value: function getModalStateOnSuccess(currentModalState) {
	      if (currentModalState === _constants2.MODAL_STATES.isManagerRejecting) {
	        return _constants2.MODAL_STATES.approveReject;
	      }
	
	      return _constants2.MODAL_STATES.approve;
	    }
	  }, {
	    key: 'setAllAsSuccess',
	    value: function setAllAsSuccess(requests) {
	      requests.forEach(function (request) {
	        request.status = _constants.FOOD_BENEFIT_STATES.approve;
	      });
	      this.requestModal = requests;
	      return requests;
	    }
	  }, {
	    key: 'setAllAsRequested',
	    value: function setAllAsRequested(requests) {
	      requests.forEach(function (request) {
	        request.status = _constants.FOOD_BENEFIT_STATES.requested;
	      });
	      this.requestModal = requests;
	      return requests;
	    }
	  }, {
	    key: '_buildModalMessage',
	    value: function _buildModalMessage(request, rawPeriods) {
	      if (request.length > 1) {
	        this.errorMsg = this.getApproveAllMessage(request, rawPeriods);
	      } else {
	        var onlyRequest = request[0];
	        var period = this.periodsHelper.findPeriod(onlyRequest, rawPeriods);
	        this.errorMsg = this.messageFormatter.getApproveSinglePeriodMessage(period, this.msgString, this.positiveDaysDifferenceText, this.negativeDaysDifferenceText);
	      }
	    }
	  }, {
	    key: 'getApproveAllMessage',
	    value: function getApproveAllMessage(requests, rawPeriods) {
	      var _this3 = this;
	
	      var message = '';
	
	      message += this.messageFormatter.getApprovePeriodsInitialMessage(requests, this.allRequestApprovedText);
	
	      requests.forEach(function (request) {
	        var period = _this3.periodsHelper.findPeriod(request, rawPeriods);
	        message += _this3.messageFormatter.getApprovePeriodMessage(period, _this3.msgString, _this3.positiveDaysDifferenceText, _this3.negativeDaysDifferenceText, _this3.isMobileApp);
	      });
	
	      return message;
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this4 = this;
	
	      this.translate('FOOD_BENEFIT.MODAL_REJECT_REQUEST.JOURNEYS').then(function (translation) {
	        _this4.msgString = translation;
	      });
	
	      this.translate('FOOD_BENEFIT.BENEFIT_REQUEST_CARD.POSITIVE_REQUESTED_DAYS').then(function (translation) {
	        _this4.positiveDaysDifferenceText = translation;
	      });
	
	      this.translate('FOOD_BENEFIT.BENEFIT_REQUEST_CARD.NEGATIVE_REQUESTED_DAYS').then(function (translation) {
	        _this4.negativeDaysDifferenceText = translation;
	      });
	
	      this.translate('FOOD_BENEFIT.MODAL_APPROVE_ALL.OK').then(function (translation) {
	        _this4.allRequestApprovedText = translation;
	      });
	    }
	  }, {
	    key: 'showSendAllRequest',
	    value: function showSendAllRequest() {
	      var requestsEmpty = this.isEmpty();
	      return this.isMobileApp && !requestsEmpty && !this.isInputFocused();
	    }
	  }, {
	    key: 'isInputFocused',
	    value: function isInputFocused() {
	      return this.floatingActionButtonsService.isFocused;
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.ACCEPT_ALL'
	      }];
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return $(_constants.MODALS.BENEFIT_REQUEST);
	    }
	  }]);
	  return BenefitRequestListController;
	}();
	
	exports.default = BenefitRequestListController;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeriodsHelper = function () {
	  function PeriodsHelper() {
	    (0, _classCallCheck3.default)(this, PeriodsHelper);
	  }
	
	  (0, _createClass3.default)(PeriodsHelper, [{
	    key: "findPeriod",
	    value: function findPeriod(request, periods) {
	      return periods.find(function (period) {
	        return period.employeeId === request.employeeId && period.enjoymentMonth === request.enjoymentMonth && period.enjoymentDays === request.enjoymentDays;
	      });
	    }
	  }]);
	  return PeriodsHelper;
	}();
	
	exports.default = PeriodsHelper;

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MessageFormatter = function () {
	  function MessageFormatter() {
	    (0, _classCallCheck3.default)(this, MessageFormatter);
	  }
	
	  (0, _createClass3.default)(MessageFormatter, [{
	    key: 'getApprovePeriodsInitialMessage',
	    value: function getApprovePeriodsInitialMessage(periods) {
	      var additionalText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      return periods.length + ' ' + additionalText + '</br>' + '</br>';
	    }
	  }, {
	    key: 'getApprovePeriodMessage',
	    value: function getApprovePeriodMessage(period) {
	      var singleDaysText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var positiveDaysDifferenceText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	      var negativeDaysDifferenceText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	      var isMobileApp = arguments[4];
	
	      var month = this.getMonthInTextFormat(period.enjoymentMonth);
	      var message = period.name + ' -' + (' ' + this.getDays(period, singleDaysText, positiveDaysDifferenceText, negativeDaysDifferenceText)) + (' ' + month) + ' </br>';
	      if (isMobileApp) {
	        message = '' + period.name + ' </br>' + (' ' + this.getDays(period, singleDaysText, positiveDaysDifferenceText, negativeDaysDifferenceText)) + (' ' + month) + ' </br>' + ' </br>';
	      }
	      return message;
	    }
	  }, {
	    key: 'getApproveSinglePeriodMessage',
	    value: function getApproveSinglePeriodMessage(period) {
	      var singleDaysText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var positiveDaysDifferenceText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	      var negativeDaysDifferenceText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	      var month = this.getMonthInTextFormat(period.enjoymentMonth);
	      return '<span class="period-name">' + period.name + '</span>' + ' </br>' + (' ' + this.getDays(period, singleDaysText, positiveDaysDifferenceText, negativeDaysDifferenceText)) + (' ' + month);
	    }
	  }, {
	    key: 'getMonthInTextFormat',
	    value: function getMonthInTextFormat(month) {
	      return (0, _moment2.default)().month(month - 1).format('MMMM');
	    }
	  }, {
	    key: 'getDays',
	    value: function getDays(period, singleDaysText, positiveDaysDifferenceText, negativeDaysDifferenceText) {
	      var daysDifference = parseInt(period.daysDifference, 10) || 0;
	
	      if (period.enjoymentDays - period.approvedDays > 0) {
	        return period.enjoymentDays - period.approvedDays + ' ' + positiveDaysDifferenceText;
	      } else if (daysDifference === 0) {
	        return period.enjoymentDays + ' ' + singleDaysText;
	      } else {
	        return period.approvedDays - period.enjoymentDays + ' ' + negativeDaysDifferenceText;
	      }
	    }
	  }]);
	  return MessageFormatter;
	}();
	
	exports.default = MessageFormatter;

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1633);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benefitRequestList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benefitRequestList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "benefit-request-list{display:block}benefit-request-list .invisible{visibility:hidden}benefit-request-list .accept-all-container{margin-top:15px;margin-bottom:15px}benefit-request-list .accept-all-container>.btn{margin-bottom:15px}benefit-request-list .right-aligned{float:right}benefit-request-list .card-container{margin-bottom:5px;margin-top:5px}benefit-request-list .list-empty{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}benefit-request-list .list-empty.mobile{margin-top:120px;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;padding-bottom:10px;border-bottom:1px solid #dddfe2}benefit-request-list .list-empty.mobile .icon-warning{margin-right:0}benefit-request-list .list-empty.shown-filter{margin-top:0}benefit-request-list .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _benefitRequestCard = __webpack_require__(1635);
	
	var _benefitRequestCard2 = _interopRequireDefault(_benefitRequestCard);
	
	var _benefitDaysRequestSwitch = __webpack_require__(1641);
	
	var _benefitDaysRequestSwitch2 = _interopRequireDefault(_benefitDaysRequestSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var benefitRequestCardModule = _angular2.default.module('benefitRequestCard', [_angularUiRouter2.default, _benefitDaysRequestSwitch2.default]).component('benefitRequestCard', _benefitRequestCard2.default).name;
	
	exports.default = benefitRequestCardModule;

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _benefitRequestCard = __webpack_require__(1636);
	
	var _benefitRequestCard2 = _interopRequireDefault(_benefitRequestCard);
	
	var _benefitRequestCard3 = __webpack_require__(1637);
	
	var _benefitRequestCard4 = _interopRequireDefault(_benefitRequestCard3);
	
	__webpack_require__(1639);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var benefitRequestCardComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    request: '<',
	    processRequest: '&',
	    dayPeriods: '<',
	    cardId: '@'
	  },
	  template: _benefitRequestCard2.default,
	  controller: _benefitRequestCard4.default
	};
	
	exports.default = benefitRequestCardComponent;

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"card-container {{$ctrl.cardId}} swipe-container\"\n         ng-class=\"$ctrl.getClasses()\"\n         ng-if=\"$ctrl.shouldDisplayCard()\">\n\n  <div class=\"user-info-avatar\">\n    <avatar-app email=\"$ctrl.request.email\" name=\"$ctrl.request.name\" user-id=\"$ctrl.request.userId\"></avatar-app>\n  </div>\n\n  <div class=\"user-info-text\">\n    <employee-name name=\"{{$ctrl.request.name}}\" enrollment=\"{{$ctrl.request.employeeId}}\"></employee-name>\n\n    <div class=\"requested-date\">\n      <span class=\"month\">{{$ctrl.displayMonth}}</span>\n      <span class=\"year\" ng-if=\"!$ctrl.isMobileApp\">{{$ctrl.request.enjoymentYear}} - </span>\n      <span class=\"year\" ng-if=\"$ctrl.isMobileApp\">{{$ctrl.request.enjoymentYear}}<br></span>\n      <benefit-request-days is-mobile-app=\"$ctrl.isMobileApp\"\n                            request=\"$ctrl.request\">\n      </benefit-request-days>\n      <div class=\"line\" ng-if=\"!$ctrl.isMobileApp\"></div>\n    </div>\n  </div>\n\n  <div class=\"request-container\">\n    <benefit-days-request-switch card-data=\"$ctrl.card\"\n                                 change-days=\"$ctrl.setDays($event)\"\n                                 display-month=\"$ctrl.displayMonth\"\n                                 day-periods=\"$ctrl.dayPeriods\"\n                                 is-mobile-app=\"$ctrl.isMobileApp\">\n    </benefit-days-request-switch>\n  </div>\n\n  <div class=\"buttons-container\" ng-if=\"!$ctrl.isMobileApp\">\n    <div class=\"request-reject-accept\">\n      <button type=\"button\" class=\"btn btn-app btn-default\"\n              ng-click=\"$ctrl.onReject()\">\n        {{'GLOBALS.BUTTON_ACTION.REJECT' | translate}}\n      </button>\n      <button type=\"button\" class=\"btn btn-app btn-primary\"\n              ng-click=\"$ctrl.onAccept()\">\n        {{'GLOBALS.BUTTON_ACTION.ACCEPT' | translate}}\n      </button>\n    </div>\n  </div>\n\n  <div class=\"mobile-buttons-container\" ng-if=\"$ctrl.isMobileApp\">\n    <div class=\"swipe-button remove\" ng-click=\"$ctrl.onReject()\">\n      <span class=\"icon-cross-white\"></span>\n    </div>\n    <div class=\"swipe-button edit\" ng-click=\"$ctrl.onAccept()\">\n      <span class=\"icon-approved\"><span class=\"path1\"></span><span class=\"path2\"></span></span>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _foodBenefitCard = __webpack_require__(1638);
	
	var _foodBenefitCard2 = _interopRequireDefault(_foodBenefitCard);
	
	var _constants = __webpack_require__(916);
	
	var _swipe = __webpack_require__(724);
	
	var _swipe2 = _interopRequireDefault(_swipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BenefitRequestCardController = function () {
	  BenefitRequestCardController.$inject = ["EventEmitter", "$timeout"];
	  function BenefitRequestCardController(EventEmitter, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BenefitRequestCardController);
	    this.EventEmitter = EventEmitter;
	    this.timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(BenefitRequestCardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      _moment2.default.locale('es');
	      var dateToGetMonth = new Date(this.request.enjoymentYear, this.request.enjoymentMonth - 1);
	      this.displayMonth = (0, _moment2.default)(dateToGetMonth).format('MMMM');
	      this.card = new _foodBenefitCard2.default(this.request);
	      this.days = this.request.enjoymentDays;
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      var _this = this;
	
	      if (this.isMobileApp) {
	        this.timeout(function () {
	          _this.initSwipe();
	        });
	      }
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        responsiveMobile: this.isMobileApp,
	        swiped: this.swiped
	      };
	    }
	  }, {
	    key: 'initSwipe',
	    value: function initSwipe() {
	      var _this2 = this;
	
	      var swiper = new _swipe2.default(this.getBenefitRequestCardSelector());
	      swiper.onLeft(function () {
	        return _this2.onSwipeLeft();
	      });
	      swiper.onRight(function () {
	        return _this2.onSwipeRight();
	      });
	      swiper.run();
	    }
	  }, {
	    key: 'getBenefitRequestCardSelector',
	    value: function getBenefitRequestCardSelector() {
	      return 'benefit-request-card .' + this.cardId;
	    }
	  }, {
	    key: 'onSwipeRight',
	    value: function onSwipeRight() {
	      var _this3 = this;
	
	      this.timeout(function () {
	        _this3.swiped = false;
	      });
	    }
	  }, {
	    key: 'onSwipeLeft',
	    value: function onSwipeLeft() {
	      var _this4 = this;
	
	      this.timeout(function () {
	        _this4.swiped = true;
	      });
	    }
	  }, {
	    key: 'setDays',
	    value: function setDays(_ref) {
	      var days = _ref.days;
	
	      this.dayPeriods = days;
	      this.request.enjoymentDays = this.dayPeriods;
	    }
	  }, {
	    key: 'shouldDisplayCard',
	    value: function shouldDisplayCard() {
	      return this.request.status !== _constants.MODAL_STATES.approved || this.request.status !== _constants.MODAL_STATES.rejected;
	    }
	  }, {
	    key: 'onAccept',
	    value: function onAccept() {
	      this.request.enjoymentDays = this.dayPeriods;
	      this.request.status = _constants.CARD_STATUS.APPROVE;
	
	      var event = this.EventEmitter({
	        request: this.request
	      });
	
	      this.processRequest(event);
	    }
	  }, {
	    key: 'onReject',
	    value: function onReject() {
	      this.request.enjoymentDays = this.dayPeriods;
	      this.request.status = _constants.CARD_STATUS.REJECT;
	
	      var event = this.EventEmitter({
	        request: this.request
	      });
	
	      this.processRequest(event);
	    }
	  }]);
	  return BenefitRequestCardController;
	}();
	
	exports.default = BenefitRequestCardController;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitCard = function foodBenefitCard(cardInitialData) {
	  (0, _classCallCheck3.default)(this, foodBenefitCard);
	
	  this.id = cardInitialData.id || '';
	  this.enjoymentDays = cardInitialData.enjoymentDays || 0;
	  this.enjoymentMonth = cardInitialData.enjoymentMonth || 0;
	  this.enjoymentYear = cardInitialData.enjoymentYear || new Date().getFullYear();
	  this.maximumNumberDaysPerMonth = cardInitialData.maximumNumberDaysPerMonth || 0;
	  this.remarks = cardInitialData.remarks || '';
	  this.state = cardInitialData.status || _constants.FOOD_BENEFIT_STATES.initial;
	  this.requestErrorMsg = '';
	};
	
	exports.default = foodBenefitCard;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1640);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./benefitRequestCard.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./benefitRequestCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "benefit-request-card .card-container{width:100%;min-height:170px;display:inline-flex;background-color:#fff;box-shadow:0 2px 4px 0 hsla(216,8%,88%,.32);border:1px solid #dddfe2;padding-right:15px}benefit-request-card .card-container.mobile{position:relative;margin:0 -30px;min-width:100vw;min-height:100px;display:block;box-shadow:none;border:0;border-bottom:1px solid #dddfe2;cursor:pointer;left:0;transition:all .5s ease}benefit-request-card .card-container.mobile.swiped{left:-160px}benefit-request-card .card-container.mobile .user-info-avatar{float:left;margin-top:0;padding-left:15px;padding-top:25px}benefit-request-card .card-container.mobile .user-info-avatar avatar-app{margin-top:0;margin-left:0;transform:scale(1)}benefit-request-card .card-container.mobile .user-info-text{float:left;width:auto;margin-top:0;margin-left:15px}benefit-request-card .card-container.mobile .user-info-text employee-name{line-height:1;margin-top:15px;font-size:16px;color:#0072c9}benefit-request-card .card-container.mobile .user-info-text .requested-date{font-size:12px;color:#666!important}benefit-request-card .mobile-buttons-container{position:absolute;right:-160px;min-height:100px;float:right}benefit-request-card .mobile-buttons-container,benefit-request-card .mobile-buttons-container .swipe-button{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row}benefit-request-card .mobile-buttons-container .swipe-button{-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;width:80px;height:100px}benefit-request-card .mobile-buttons-container .swipe-button.remove{background:#eaebed}benefit-request-card .mobile-buttons-container .swipe-button.remove span{font-size:18px}benefit-request-card .mobile-buttons-container .swipe-button.remove span:before{color:#c8175e!important}benefit-request-card .mobile-buttons-container .swipe-button.edit{background:#86c82d}benefit-request-card .mobile-buttons-container .swipe-button.edit span{font-size:44px}benefit-request-card .user-info-avatar{padding-top:26px;padding-left:37px}benefit-request-card .user-info-avatar avatar-app{margin-top:41px;margin-left:19px;transform:scale(1.9)}benefit-request-card .user-info-text{margin-left:44px;margin-top:24px;width:310px}benefit-request-card .user-info-text .request-date{font-family:Stag Sans;font-size:12px;font-weight:300;text-align:left;color:#666}benefit-request-card .user-info-text employee-name{margin-top:30px;font-family:Stag Sans;font-size:22px;text-align:left;color:#666;text-transform:capitalize}benefit-request-card .user-info-text .requested-date{font-family:Stag Sans;font-size:16px;font-weight:300;text-align:left;color:#666}benefit-request-card .user-info-text .requested-date .month{text-transform:capitalize;font-weight:400}benefit-request-card .user-info-text .requested-date .line{margin-top:10px;border-bottom:1px solid #eaebed}benefit-request-card .request-container{min-width:300px}@media(max-width:944px){benefit-request-card .request-container{min-width:260px}}benefit-request-card .line{min-width:280px;background-color:#dddfe2;border-bottom:2px solid #dddfe2}benefit-request-card .buttons-container{float:right;margin-top:105px}@media(max-width:1170px){benefit-request-card .buttons-container{margin-top:26px;margin-left:auto}}benefit-request-card .buttons-container .request-reject-accept{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-item-align:start;align-self:flex-start;padding-bottom:11px}@media(max-width:1170px){benefit-request-card .buttons-container .request-reject-accept{-moz-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}}benefit-request-card .buttons-container .request-reject-accept .btn{margin-left:23px}@media(max-width:1170px){benefit-request-card .buttons-container .request-reject-accept .btn{margin-left:0}benefit-request-card .buttons-container .request-reject-accept .btn.btn-default{margin-top:42px}}benefit-request-card .buttons-container .request-reject-accept .btn.btn-default,benefit-request-card .buttons-container .request-reject-accept .btn.btn-primary{width:154px;height:38px;line-height:40px}", ""]);
	
	// exports


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _benefitDaysRequestSwitch = __webpack_require__(1642);
	
	var _benefitDaysRequestSwitch2 = _interopRequireDefault(_benefitDaysRequestSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BenefitDaysRequestSwitchModule = _angular2.default.module('BenefitDaysRequestSwitch', [_angularUiRouter2.default]).component('benefitDaysRequestSwitch', _benefitDaysRequestSwitch2.default).name;
	
	exports.default = BenefitDaysRequestSwitchModule;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _benefitDaysRequestSwitch = __webpack_require__(1643);
	
	var _benefitDaysRequestSwitch2 = _interopRequireDefault(_benefitDaysRequestSwitch);
	
	var _benefitDaysRequestSwitch3 = __webpack_require__(1644);
	
	var _benefitDaysRequestSwitch4 = _interopRequireDefault(_benefitDaysRequestSwitch3);
	
	__webpack_require__(1645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BenefitDaysRequestSwitchComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    cardData: '<',
	    displayMonth: '<',
	    changeDays: '&',
	    dayPeriods: '<'
	  },
	  template: _benefitDaysRequestSwitch2.default,
	  controller: _benefitDaysRequestSwitch4.default
	};
	
	exports.default = BenefitDaysRequestSwitchComponent;

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

	module.exports = "<section ng-class=\"{responsiveMobile: $ctrl.isMobileApp}\">\n  <h1 class=\"title\"\n      ng-if=\"!$ctrl.isMobileApp\">\n    {{$ctrl.displayMonth}}\n  </h1>\n  <h1 class=\"title\"\n      ng-if=\"$ctrl.isMobileApp\">\n    {{$ctrl.displayMonth |limitTo:3}}\n  </h1>\n  <div class=\"input-group-actions\">\n    <i ng-if=\"!$ctrl.isMobileApp\"\n       class=\"icon icon-minus-circle\"\n       ng-click=\"$ctrl.decreaseOneDay()\"\n       ng-show=\"$ctrl.inEditMode\"></i>\n    <div class=\"days-input-container\">\n      <input class=\"days-input\"\n             type=\"tel\"\n             name=\"days\"\n             focus-position-end\n             ng-class=\"{active: $ctrl.inEditMode && $ctrl.isDayModified}\"\n             ng-model=\"$ctrl.dayPeriods\"\n             ng-change=\"$ctrl.onChangeValue()\"\n             ng-click=\"$ctrl.edit()\"\n             ng-blur=\"$ctrl.notEdit()\"/>\n      <span class=\"input-label\">\n        {{'FOOD_BENEFIT.MAIN.WORKDAY' | translate}}</span>\n    </div>\n    <i ng-if=\"!$ctrl.isMobileApp\"\n       class=\"icon icon-plus-circle\"\n       ng-click=\"$ctrl.increaseOneDay()\"\n       ng-show=\"$ctrl.inEditMode\"></i>\n  </div>\n</section>\n"

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_DAYS = 23;
	var MIN_DAYS = 0;
	
	var BenefitDaysRequestSwitchController = function () {
	  BenefitDaysRequestSwitchController.$inject = ["EventEmitter", "$rootScope"];
	  function BenefitDaysRequestSwitchController(EventEmitter, $rootScope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BenefitDaysRequestSwitchController);
	    this.EventEmitter = EventEmitter;
	    this.rootScope = $rootScope;
	    this.inEditMode = false;
	    this.isDayModified = false;
	  }
	
	  (0, _createClass3.default)(BenefitDaysRequestSwitchController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.days = this.cardData.enjoymentDays || 0;
	      this.originalDayValue = this.days;
	      this._onRefreshData();
	    }
	  }, {
	    key: '_onRefreshData',
	    value: function _onRefreshData() {
	      var _this = this;
	
	      this.rootScope.$on(_constants.EVENTS.REFRESH_ON_FOOD_BENEFIT_MANAGER, function (event, data) {
	        if (data.isReloaded) _this.inEditMode = false;
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      this.inEditMode = true;
	    }
	  }, {
	    key: 'notEdit',
	    value: function notEdit() {
	      if (this.isMobileApp) {
	        this._setDefaultDaysValueWhenEmpty();
	      }
	    }
	  }, {
	    key: '_setDefaultDaysValueWhenEmpty',
	    value: function _setDefaultDaysValueWhenEmpty() {
	      if (isNaN(this.days) || this.dayPeriods === '' || !this.dayPeriods) this.dayPeriods = MIN_DAYS;
	    }
	  }, {
	    key: 'increaseOneDay',
	    value: function increaseOneDay() {
	      this.days = this.days + 1;
	      if (this.days > MAX_DAYS) this.days = MAX_DAYS;
	      var event = this.EventEmitter({ days: this.days });
	      this.changeDays(event);
	    }
	  }, {
	    key: 'decreaseOneDay',
	    value: function decreaseOneDay() {
	      if (this.days > MIN_DAYS) this.days = this.days - 1;
	      var event = this.EventEmitter({ days: this.days });
	      this.changeDays(event);
	    }
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue() {
	      this.sanitizeDayPeriods();
	      this.days = this.dayPeriods;
	
	      this.isDayModified = true;
	      if (parseInt(this.days) === this.originalDayValue) {
	        this.isDayModified = false;
	      }
	
	      var event = this.EventEmitter({ days: parseInt(this.days) });
	
	      this.changeDays(event);
	    }
	  }, {
	    key: 'sanitizeDayPeriods',
	    value: function sanitizeDayPeriods() {
	      if (!this.isMobileApp) {
	        this._setDefaultDaysValueWhenEmpty();
	      }
	      if (this.dayPeriods < MIN_DAYS) this.dayPeriods = MIN_DAYS;
	      if (this.dayPeriods > MAX_DAYS) this.dayPeriods = MAX_DAYS;
	    }
	  }]);
	  return BenefitDaysRequestSwitchController;
	}();
	
	exports.default = BenefitDaysRequestSwitchController;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1646);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./benefitDaysRequestSwitch.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./benefitDaysRequestSwitch.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "benefit-days-request-switch{text-align:center}benefit-days-request-switch .responsiveMobile{display:block;position:relative;float:right;width:60px;height:60px;margin-top:22px}benefit-days-request-switch .responsiveMobile .input-group-actions .days-input-container{border-radius:5px;width:60px;height:60px}benefit-days-request-switch .responsiveMobile .input-group-actions .days-input-container .days-input{line-height:28px;font-size:24px;height:28px;width:42px;margin:12px 9px 16px;padding-left:3px}benefit-days-request-switch .responsiveMobile .input-group-actions .input-label{position:absolute;font-size:10px;bottom:2px;left:11px}benefit-days-request-switch .responsiveMobile h1.title{top:-11px;padding:0;margin:0;font-size:10px}benefit-days-request-switch h1.title{text-transform:capitalize;z-index:3;background-color:#fff;display:inline-block;width:auto;position:relative;top:10px;color:#666;font-size:16px;font-weight:400;padding:11px 5px 4px;margin:0 0 16px;max-width:116px}benefit-days-request-switch .input-group-actions{position:relative;bottom:21px;display:flex;align-items:center;justify-content:center}benefit-days-request-switch .input-group-actions .icon{font-size:40px;padding-bottom:4px;cursor:pointer}benefit-days-request-switch .days-input-container{border:1px solid #dddfe2;width:134px;height:118px;margin:0 19px}benefit-days-request-switch input.days-input{background-color:#fff;display:block;cursor:pointer;width:70px;height:50px;line-height:50px;border-radius:3px;border:none;font-family:Stag Sans;padding:0;margin:23px 35px 3px;font-size:48px;text-align:center;letter-spacing:4px;color:#0072c9}benefit-days-request-switch input.days-input.active,benefit-days-request-switch input.days-input:focus{outline:none;width:100px;margin:23px 20px 3px;border:1px solid #0072c9}benefit-days-request-switch .input-label{display:block;font-family:Stag Sans;font-size:16px;color:#666}benefit-days-request-switch .btn.btn-app.btn-primary{width:120px;height:38px;margin-top:10px;line-height:.9}", ""]);
	
	// exports


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _benefitRequestModal = __webpack_require__(1648);
	
	var _benefitRequestModal2 = _interopRequireDefault(_benefitRequestModal);
	
	var _modalRejectRequest = __webpack_require__(1653);
	
	var _modalRejectRequest2 = _interopRequireDefault(_modalRejectRequest);
	
	var _modalSendAllCards = __webpack_require__(1659);
	
	var _modalSendAllCards2 = _interopRequireDefault(_modalSendAllCards);
	
	var _managerAcceptAll = __webpack_require__(1665);
	
	var _managerAcceptAll2 = _interopRequireDefault(_managerAcceptAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var benefitRequestModalModule = _angular2.default.module('benefitRequestModal', [_angularUiRouter2.default, _modalRejectRequest2.default, _modalSendAllCards2.default, _managerAcceptAll2.default]).component('benefitRequestModal', _benefitRequestModal2.default).name;
	
	exports.default = benefitRequestModalModule;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _benefitRequestModal = __webpack_require__(1649);
	
	var _benefitRequestModal2 = _interopRequireDefault(_benefitRequestModal);
	
	var _benefitRequestModal3 = __webpack_require__(1650);
	
	var _benefitRequestModal4 = _interopRequireDefault(_benefitRequestModal3);
	
	__webpack_require__(1651);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var benefitRequestModalComponent = {
	  restrict: 'E',
	  bindings: {
	    modalId: '@',
	    request: '<',
	    modalState: '<',
	    description: '<',
	    modifiedCardCount: '<',
	    errorMsg: '<',
	    periodCount: '<',
	    actionInModal: '&',
	    isMobileApp: '<',
	    withoutManager: '<'
	  },
	  template: _benefitRequestModal2.default,
	  controller: _benefitRequestModal4.default
	};
	
	exports.default = benefitRequestModalComponent;

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"{{$ctrl.modalId}}\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"RequestCardModalLabel\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <successful-action\n      title=\"{{ 'FOOD_BENEFIT.MODAL_APPROVE_ALL.SUCCESS' | translate }}\"\n      ng-if=\"$ctrl.isApproved()\"\n      close-modal=\"true\"\n      modal-id-to-close=\"{{ $ctrl.modalId }}\"\n      message=\"{{ $ctrl.errorMsg }}\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      without-manager=\"$ctrl.withoutManager\"\n      scrollable-body=\"$ctrl.isModalBodyScrollable\">\n    </successful-action>\n\n    <successful-action\n      title=\"{{ 'FOOD_BENEFIT.MODAL_REJECT_REQUEST.SUCCESS' | translate }}\"\n      ng-if=\"$ctrl.isApprovedReject()\"\n      close-modal=\"true\"\n      modal-id-to-close=\"{{ $ctrl.modalId }}\"\n      message=\"{{ $ctrl.errorMsg }}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </successful-action>\n\n    <failed-action\n      ng-if=\"$ctrl.isFailed() || $ctrl.isDelegated()\"\n      title=\"{{'GLOBALS.REQUEST_DENIED' | translate}}\"\n      description=\"{{ $ctrl.description || $ctrl.errorMsg|| 'FOOD_BENEFIT.BENEFIT_REQUEST_CARD.REQUEST_DENIED_MSG' | translate }}\"\n      close-modal=\"true\"\n      button-text=\"{{'GLOBALS.BUTTON_ACTION.OK' | translate}}\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </failed-action>\n\n    <modal-reject-request\n      ng-if=\"$ctrl.isManagerRejecting()\"\n      month=\"$ctrl.monthName\"\n      request=\"$ctrl.request\"\n      set-action=\"$ctrl.actionInModal({$event : $event})\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </modal-reject-request>\n\n    <modal-send-all-cards\n      ng-if=\"$ctrl.isUserSendingAllCards()\"\n      request=\"$ctrl.request\"\n      set-action=\"$ctrl.actionInModal({$event : $event})\"\n      card-count=\"$ctrl.modifiedCardCount\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </modal-send-all-cards>\n\n    <manager-accept-all\n      ng-if=\"$ctrl.isManagerApprovingAll()\"\n      request-count=\"$ctrl.periodCount\"\n      request=\"$ctrl.request\"\n      set-action=\"$ctrl.actionInModal({$event : $event})\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </manager-accept-all>\n\n  </div>\n</div>\n"

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(916);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BenefitRequestModalController = function () {
	  BenefitRequestModalController.$inject = ["$translate"];
	  function BenefitRequestModalController($translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BenefitRequestModalController);
	    this.translate = $translate;
	    this.$modal = $(_constants.MODALS.BENEFIT_REQUEST_LIST);
	    this.message = '';
	    this._translate();
	    this.isModalBodyScrollable = false;
	  }
	
	  (0, _createClass3.default)(BenefitRequestModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      _moment2.default.locale('es');
	      this._loadErrorMsg();
	      if (this.isMobileApp) {
	        this.isModalBodyScrollable = true;
	      }
	    }
	  }, {
	    key: '_loadErrorMsg',
	    value: function _loadErrorMsg() {
	      var _this = this;
	
	      this.translate('FOOD_BENEFIT.BENEFIT_REQUEST_CARD.REQUEST_DENIED_MSG').then(function (translation) {
	        _this.errorMsg = _this.errorMsg || translation;
	      });
	    }
	  }, {
	    key: 'isManagerApprovingAll',
	    value: function isManagerApprovingAll() {
	      return this.modalState === _constants2.MODAL_STATES.managerListConfirmAll;
	    }
	  }, {
	    key: 'isManagerRejecting',
	    value: function isManagerRejecting() {
	      if (!this.request) return;
	      this.formatMonthToBind();
	      return this.modalState === _constants2.MODAL_STATES.isManagerRejecting;
	    }
	  }, {
	    key: 'isUserSendingAllCards',
	    value: function isUserSendingAllCards() {
	      return this.modalState === _constants2.MODAL_STATES.isSendingAllCards;
	    }
	  }, {
	    key: 'isDelegated',
	    value: function isDelegated() {
	      return this.modalState === _constants2.MODAL_STATES.isDelegated;
	    }
	  }, {
	    key: 'formatMonthToBind',
	    value: function formatMonthToBind() {
	      _moment2.default.locale('es');
	      var dateToGetMonth = new Date(this.request.enjoymentYear, this.request.enjoymentMonth - 1);
	      this.monthName = (0, _moment2.default)(dateToGetMonth).format('MMMM');
	    }
	  }, {
	    key: 'isApproved',
	    value: function isApproved() {
	      return this.modalState === _constants2.MODAL_STATES.approve;
	    }
	  }, {
	    key: 'isApprovedReject',
	    value: function isApprovedReject() {
	      return this.modalState === _constants2.MODAL_STATES.approveReject;
	    }
	  }, {
	    key: 'isFailed',
	    value: function isFailed() {
	      return this.modalState === _constants2.MODAL_STATES.failed;
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this2 = this;
	
	      this.translate('FOOD_BENEFIT.MODAL_REJECT_REQUEST.JOURNEYS').then(function (translation) {
	        _this2.msgString = translation;
	      });
	
	      this.translate('FOOD_BENEFIT.MODAL_APPROVE_ALL.OK').then(function (translation) {
	        _this2.allRequestApprovedText = translation;
	      });
	    }
	  }]);
	  return BenefitRequestModalController;
	}();
	
	exports.default = BenefitRequestModalController;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1652);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benefitRequestModal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benefitRequestModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "benefit-request-modal successful-action .modal-content .modal-body .period-name{font-size:18px;line-height:1.17;text-align:center;color:#666}benefit-request-modal successful-action .modal-content .modal-body .description{max-width:380px}", ""]);
	
	// exports


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _modalRejectRequest = __webpack_require__(1654);
	
	var _modalRejectRequest2 = _interopRequireDefault(_modalRejectRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalRejectRequestModule = _angular2.default.module('modalRejectRequest', [_angularUiRouter2.default]).component('modalRejectRequest', _modalRejectRequest2.default).name;
	
	exports.default = modalRejectRequestModule;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalRejectRequest = __webpack_require__(1655);
	
	var _modalRejectRequest2 = _interopRequireDefault(_modalRejectRequest);
	
	var _modalRejectRequest3 = __webpack_require__(1656);
	
	var _modalRejectRequest4 = _interopRequireDefault(_modalRejectRequest3);
	
	__webpack_require__(1657);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalRejectRequestComponent = {
	  restrict: 'E',
	  bindings: {
	    request: '<',
	    month: '<',
	    setAction: '&',
	    isMobileApp: '<'
	  },
	  template: _modalRejectRequest2.default,
	  controller: _modalRejectRequest4.default
	};
	
	exports.default = modalRejectRequestComponent;

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <div class=\"modal-header\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\" id=\"{{$ctrl.modalId}}Label\">{{\"FOOD_BENEFIT.MODAL_REJECT_REQUEST.TITLE\" | translate }}</h4>\n  </div>\n\n  <div class=\"modal-body\">\n\n    <div class=\"body-header\">\n      <p>{{$ctrl.request.name}}</p>\n      <p class=\"little-detail\">\n        <benefit-request-days request=\"$ctrl.request\"></benefit-request-days>\n        {{ $ctrl.month }}\n      </p>\n    </div>\n\n    <form-errors-summary\n      ng-if=\"$ctrl.form.$invalid\"\n      errors=\"$ctrl.errors\">\n    </form-errors-summary>\n\n  </div>\n\n  <div class=\"modal-footer row\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-one btn-primary\"\n      data-dismiss=\"modal\">{{\"GLOBALS.BUTTON_ACTION.CANCEL\" | translate}}</button>\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-two btn-primary\"\n      ng-disabled=\"$ctrl.form.$invalid\"\n      ng-click=\"$ctrl.actionButton($ctrl.reject)\">{{\"GLOBALS.BUTTON_ACTION.REJECT\" | translate}}</button>\n  </div>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.actionButton($ctrl.reject)\"\n    on-click-second-button=\"$ctrl.dismiss()\">\n  </floating-action-buttons>\n\n</div>\n"

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(916);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalRejectRequestController = function () {
	  ModalRejectRequestController.$inject = ["EventEmitter"];
	  function ModalRejectRequestController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalRejectRequestController);
	    this.EventEmitter = EventEmitter;
	    this.cancel = _constants.MODAL_ACTIONS.CANCEL;
	    this.reject = _constants.MODAL_ACTIONS.REJECT;
	  }
	
	  (0, _createClass3.default)(ModalRejectRequestController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      $('.modal').modal('hide');
	    }
	  }, {
	    key: 'actionButton',
	    value: function actionButton(action) {
	      this.setAction(this.EventEmitter({ status: action, request: this.request }));
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.REJECT'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }]);
	  return ModalRejectRequestController;
	}();
	
	exports.default = ModalRejectRequestController;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1658);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./modalRejectRequest.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./modalRejectRequest.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-reject-request .modal-content{padding-top:58px}modal-reject-request .modal-content .modal-header{border-bottom:1px solid #dddfe2}modal-reject-request .modal-content .modal-header .icon-interrogation{color:#0072c9;display:block;font-size:77px;height:76px;margin:0 auto 22px;margin-bottom:26px;width:76px}modal-reject-request .modal-content .modal-header h4{color:#0072c9;margin-left:-18px;padding-bottom:10px;width:110%}modal-reject-request .modal-content .modal-body{padding-top:17px}modal-reject-request .modal-content .modal-body .body-header{border-bottom:1px solid #dddfe2;color:#666;margin-bottom:24px;padding-bottom:16px;padding-top:1px;text-align:center}modal-reject-request .modal-content .modal-body .body-header p{color:#666;font-family:ArialMT;font-size:18px;line-height:1.3;margin:0}modal-reject-request .modal-content .modal-body .body-header p.little-detail,modal-reject-request .modal-content .modal-body .body-header p.little-detail span{font-size:15px}modal-reject-request .modal-content .modal-body .textarea-description{margin-bottom:7px}modal-reject-request .modal-content .modal-body textarea{border-color:#dddfe2;box-shadow:0 2px 4px 0 #dddfe2,0 -1px 4px 0 #dddfe2;color:#666;font-family:Stag Sans;font-style:italic;height:135.3px;margin-left:-1px;padding-left:20px;padding-right:26px;padding-top:9.2px;resize:none;width:100%}modal-reject-request .modal-content .modal-body textarea::-moz-placeholder{color:#aeaeae;opacity:1}modal-reject-request .modal-content .modal-body textarea:-ms-input-placeholder{color:#aeaeae}modal-reject-request .modal-content .modal-body textarea::-webkit-input-placeholder{color:#aeaeae}modal-reject-request .modal-content .modal-body textarea:focus{outline:none}modal-reject-request .modal-content .modal-body span:not(.icon-warning){color:#666;font-family:Stag Sans;font-size:13px;font-style:normal}modal-reject-request .modal-content .modal-body .light{color:#666;font-size:13px;font-weight:300}modal-reject-request .modal-content .modal-body .description{color:#666;font-family:ArialMT;font-size:15px;line-height:1.4;margin:0 auto 29px;margin-bottom:31px;max-width:200px}modal-reject-request .modal-content .modal-footer{margin-top:35px;text-align:center}modal-reject-request .modal-content .modal-footer .btn{float:left;height:48px;line-height:38px;margin-left:14px;width:160px}modal-reject-request .modal-content .modal-footer .btn-one{background-color:#f9f9f9;border-color:#dddfe2;color:#0072c9;float:left;height:48px;line-height:38px;margin-right:14px;padding-left:1px;padding-top:1px;width:160px}modal-reject-request .modal-content .modal-footer .btn-two{float:right;height:48px;line-height:38px;margin-right:16px;padding-top:3px;width:160px}", ""]);
	
	// exports


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _modalSendAllCards = __webpack_require__(1660);
	
	var _modalSendAllCards2 = _interopRequireDefault(_modalSendAllCards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalSendAllCardsModule = _angular2.default.module('modalSendAllCards', [_angularUiRouter2.default]).component('modalSendAllCards', _modalSendAllCards2.default).name;
	
	exports.default = modalSendAllCardsModule;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalSendAllCards = __webpack_require__(1661);
	
	var _modalSendAllCards2 = _interopRequireDefault(_modalSendAllCards);
	
	var _modalSendAllCards3 = __webpack_require__(1662);
	
	var _modalSendAllCards4 = _interopRequireDefault(_modalSendAllCards3);
	
	__webpack_require__(1663);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalSendAllCardsComponent = {
	  restrict: 'E',
	  bindings: {
	    request: '<',
	    modalState: '<',
	    cardCount: '<',
	    setAction: '&',
	    isMobileApp: '<'
	  },
	  template: _modalSendAllCards2.default,
	  controller: _modalSendAllCards4.default
	};
	
	exports.default = modalSendAllCardsComponent;

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <div class=\"modal-header\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" ng-click=\"$ctrl.actionButton($ctrl.cancel)\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\" id=\"{{$ctrl.modalId}}Label\">{{\"FOOD_BENEFIT.MODAL_SEND_ALL.TITLE\" | translate }}</h4>\n  </div>\n\n  <div class=\"modal-body\">\n\n    <div class=\"body-header\">\n      <p class=\"detail\">{{$ctrl.cardCount}} {{\"FOOD_BENEFIT.MODAL_SEND_ALL.APPLICATIONS\" | translate}}</p>\n    </div>\n\n  </div>\n\n  <div class=\"modal-footer row\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-one btn-default\"\n      data-dismiss=\"modal\">{{\"GLOBALS.BUTTON_ACTION.CANCEL\" | translate}}</button>\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-two btn-primary\"\n      ng-click=\"$ctrl.actionButton($ctrl.send)\">{{\"GLOBALS.BUTTON_ACTION.SEND\" | translate}}</button>\n  </div>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.actionButton($ctrl.send)\"\n    on-click-second-button=\"$ctrl.actionButton($ctrl.cancel)\">\n  </floating-action-buttons>\n\n</div>\n"

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(916);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalSendAllCardsController = function () {
	  ModalSendAllCardsController.$inject = ["EventEmitter"];
	  function ModalSendAllCardsController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalSendAllCardsController);
	    this.EventEmitter = EventEmitter;
	    this.cancel = _constants.MODAL_ACTIONS.CANCEL;
	    this.send = _constants.MODAL_ACTIONS.SEND;
	  }
	
	  (0, _createClass3.default)(ModalSendAllCardsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'actionButton',
	    value: function actionButton(action) {
	      this.setAction(this.EventEmitter({
	        status: action
	      }));
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.SEND'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }]);
	  return ModalSendAllCardsController;
	}();
	
	exports.default = ModalSendAllCardsController;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1664);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./modalSendAllCards.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./modalSendAllCards.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-send-all-cards .modal-content{padding-top:58px}modal-send-all-cards .modal-content .modal-header{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}modal-send-all-cards .modal-content .modal-header .icon-interrogation{font-size:77px;display:block;width:76px;height:76px;margin:0 auto 22px;margin-bottom:26px;color:#0072c9}modal-send-all-cards .modal-content .modal-header h4{-ms-flex-item-align:center;align-self:center;width:12em;padding-bottom:10px;color:#0072c9}modal-send-all-cards .modal-content .modal-body{padding-top:17px}modal-send-all-cards .modal-content .modal-body .body-header{margin-bottom:24px;padding-top:1px;padding-bottom:16px;text-align:center;color:#666}modal-send-all-cards .modal-content .modal-body .body-header p{font-family:ArialMT;font-size:18px;line-height:1.3;margin:0;color:#666}modal-send-all-cards .modal-content .modal-body .body-header p.detail{font-size:15px}modal-send-all-cards .modal-content .modal-footer{margin-top:35px;text-align:center}modal-send-all-cards .modal-content .modal-footer .btn{line-height:38px;float:left;width:160px;height:48px;margin-left:14px}modal-send-all-cards .modal-content .modal-footer .btn-one{line-height:38px;float:left;width:160px;height:48px;margin-right:14px;padding-top:1px;padding-left:1px;color:#0072c9;border-color:#dddfe2;background-color:#f9f9f9}modal-send-all-cards .modal-content .modal-footer .btn-two{line-height:38px;float:right;width:160px;height:48px;margin-right:16px;padding-top:3px}", ""]);
	
	// exports


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _managerAcceptAll = __webpack_require__(1666);
	
	var _managerAcceptAll2 = _interopRequireDefault(_managerAcceptAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerAcceptAllModule = _angular2.default.module('managerAcceptAll', [_angularUiRouter2.default]).component('managerAcceptAll', _managerAcceptAll2.default).name;
	
	exports.default = managerAcceptAllModule;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _managerAcceptAll = __webpack_require__(1667);
	
	var _managerAcceptAll2 = _interopRequireDefault(_managerAcceptAll);
	
	var _managerAcceptAll3 = __webpack_require__(1668);
	
	var _managerAcceptAll4 = _interopRequireDefault(_managerAcceptAll3);
	
	__webpack_require__(1669);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerAcceptAllComponent = {
	  restrict: 'E',
	  bindings: {
	    request: '<',
	    requestCount: '<',
	    setAction: '&',
	    isMobileApp: '<'
	  },
	  template: _managerAcceptAll2.default,
	  controller: _managerAcceptAll4.default
	};
	
	exports.default = managerAcceptAllComponent;

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <div class=\"modal-header\">\n    <span class=\"icon-interrogation\"></span>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n    <h4 class=\"modal-title\" id=\"{{$ctrl.modalId}}Label\">{{\"FOOD_BENEFIT.MODAL_APPROVE_ALL.TITLE\" | translate }}</h4>\n  </div>\n\n  <div class=\"modal-body\">\n\n    <div class=\"body-header\">\n      <p class=\"little-detail\">{{$ctrl.requestCount}} {{\"FOOD_BENEFIT.MODAL_APPROVE_ALL.TO_APPROVE\" | translate }}</p>\n    </div>\n  </div>\n\n  <div class=\"modal-footer row\" ng-if=\"!$ctrl.isMobileApp\">\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-one btn-default\"\n      data-dismiss=\"modal\">{{\"GLOBALS.BUTTON_ACTION.CANCEL\" | translate}}</button>\n    <button\n      type=\"button\"\n      class=\"btn btn-app btn-two btn-primary\"\n      ng-disabled=\"$ctrl.form.$invalid\"\n      ng-click=\"$ctrl.actionButton($ctrl.approveAll)\">{{\"GLOBALS.BUTTON_ACTION.SEND\" | translate}}</button>\n  </div>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.actionButton($ctrl.approveAll)\"\n    on-click-second-button=\"$ctrl.actionButton($ctrl.cancel)\">\n  </floating-action-buttons>\n\n</div>\n"

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(916);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManagerAcceptAllController = function () {
	  ManagerAcceptAllController.$inject = ["EventEmitter"];
	  function ManagerAcceptAllController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ManagerAcceptAllController);
	    this.EventEmitter = EventEmitter;
	    this.cancel = _constants.MODAL_ACTIONS.CANCEL;
	    this.approveAll = _constants.MODAL_ACTIONS.APPROVE_ALL;
	  }
	
	  (0, _createClass3.default)(ManagerAcceptAllController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'actionButton',
	    value: function actionButton(action) {
	      this.setAction(this.EventEmitter({ status: action }));
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.SEND'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }]);
	  return ManagerAcceptAllController;
	}();
	
	exports.default = ManagerAcceptAllController;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1670);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./managerAcceptAll.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./managerAcceptAll.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "manager-accept-all .modal-content{padding-top:58px}manager-accept-all .modal-content .modal-header{border-bottom:1px solid #dddfe2}manager-accept-all .modal-content .modal-header .icon-interrogation{color:#0072c9;display:block;font-size:77px;height:76px;margin:0 auto 22px;margin-bottom:26px;width:76px}manager-accept-all .modal-content .modal-header h4{color:#0072c9;margin-left:-18px;padding-bottom:10px;width:110%}manager-accept-all .modal-content .modal-body{padding-top:17px}manager-accept-all .modal-content .modal-body .body-header{color:#666;margin-bottom:24px;padding-bottom:16px;padding-top:1px;text-align:center}manager-accept-all .modal-content .modal-body .body-header p{color:#666;font-family:ArialMT;font-size:18px;line-height:1.3;margin:0}manager-accept-all .modal-content .modal-body .body-header p.little-detail{font-size:15px}manager-accept-all .modal-content .modal-footer{margin-top:35px;text-align:center}manager-accept-all .modal-content .modal-footer .btn{float:left;height:48px;line-height:38px;margin-left:14px;width:160px}manager-accept-all .modal-content .modal-footer .btn-one{background-color:#f9f9f9;border-color:#dddfe2;color:#0072c9;float:left;height:48px;line-height:38px;margin-right:14px;padding-left:1px;padding-top:1px;width:160px}manager-accept-all .modal-content .modal-footer .btn-two{float:right;height:48px;line-height:38px;margin-right:16px;padding-top:3px;width:160px}", ""]);
	
	// exports


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _userCardList = __webpack_require__(1672);
	
	var _userCardList2 = _interopRequireDefault(_userCardList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userCardListModule = _angular2.default.module('userCardList', [_angularUiRouter2.default]).component('userCardList', _userCardList2.default).name;
	
	exports.default = userCardListModule;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userCardList = __webpack_require__(1673);
	
	var _userCardList2 = _interopRequireDefault(_userCardList);
	
	var _userCardList3 = __webpack_require__(1674);
	
	var _userCardList4 = _interopRequireDefault(_userCardList3);
	
	__webpack_require__(1675);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userCardListComponent = {
	  restrict: 'E',
	  bindings: {
	    newCardState: '<',
	    employees: '<',
	    onModify: '&',
	    onSendCard: '&',
	    cardDaysFocused: '&',
	    onCloseCard: '&',
	    isMobileApp: '<'
	  },
	  template: _userCardList2.default,
	  controller: _userCardList4.default
	};
	
	exports.default = userCardListComponent;

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row-list user-card-list\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <user-card-row\n    class=\"flex-row\"\n    ng-repeat=\"employee in $ctrl.employees\"\n    original-card-state=\"$ctrl.newCardState\"\n    cards=\"employee.cards\"\n    profile=\"employee.profile\"\n    notify-modify=\"$ctrl.getModifiedCards($event)\"\n    notify-send=\"$ctrl.onSendCard({$event: $event})\"\n    card-days-focused=\"$ctrl.daysIsFocused($event)\"\n    on-close-card=\"$ctrl.onCloseCard()\"\n    is-mobile-app=\"$ctrl.isMobileApp\"\n  ></user-card-row>\n</div>\n"

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserCardListController = function () {
	  UserCardListController.$inject = ["EventEmitter"];
	  function UserCardListController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, UserCardListController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(UserCardListController, [{
	    key: 'getModifiedCards',
	    value: function getModifiedCards(cardModified) {
	      var modified = this._findCardModified(cardModified, this.employees);
	      var event = this.EventEmitter(modified);
	      this.onModify(event);
	    }
	  }, {
	    key: 'daysIsFocused',
	    value: function daysIsFocused($event) {
	      var event = this.EventEmitter($event);
	      this.cardDaysFocused(event);
	    }
	  }, {
	    key: '_findCardModified',
	    value: function _findCardModified(cardModified, employeeAray) {
	      var modified = [];
	      employeeAray.forEach(function (employee) {
	        employee.cards.forEach(function (card) {
	          if (card.state !== 'modified') return;
	          modified.push(card);
	        });
	      });
	      return modified;
	    }
	  }]);
	  return UserCardListController;
	}();
	
	exports.default = UserCardListController;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1676);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./userCardList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./userCardList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "user-card-list .flex-row{margin:9px 0;display:-moz-flex;display:-ms-flexbox;display:flex}user-card-list .flex-row .flex-item{flex:1}user-card-list .user-card-list.mobile .flex-row{margin:0 0 9px;flex-wrap:wrap}user-card-list .user-card-list.mobile .flex-row .flex-item{flex:1 0 49%;margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _userCardRow = __webpack_require__(1678);
	
	var _userCardRow2 = _interopRequireDefault(_userCardRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userCardRowModule = _angular2.default.module('userCardRow', [_angularUiRouter2.default]).component('userCardRow', _userCardRow2.default).name;
	
	exports.default = userCardRowModule;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userCardRow = __webpack_require__(1679);
	
	var _userCardRow2 = _interopRequireDefault(_userCardRow);
	
	var _userCardRow3 = __webpack_require__(1680);
	
	var _userCardRow4 = _interopRequireDefault(_userCardRow3);
	
	__webpack_require__(1681);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userCardRowComponent = {
	  restrict: 'E',
	  bindings: {
	    originalCardState: '<',
	    profile: '<',
	    cards: '<',
	    notifyModify: '&',
	    notifySend: '&',
	    cardDaysFocused: '&',
	    onCloseCard: '&',
	    isMobileApp: '<'
	  },
	  template: _userCardRow2.default,
	  controller: _userCardRow4.default
	};
	
	exports.default = userCardRowComponent;

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

	module.exports = "<card-avatar ng-if=\"!$ctrl.isMobileApp\" employee=\"$ctrl.profile\"></card-avatar>\n<card-base class=\"flex-item\"\n           card-base-id=\"cardBase-{{$index}}\"\n           ng-repeat=\"card in $ctrl.cards| orderBy : $index : true\"\n           card=\"card\"\n           check-modify=\"$ctrl.setModifiedCards($event)\"\n           request-food-benefits=\"$ctrl.createPeriod($event)\"\n           reset-card-state=\"$ctrl.resetCardState($event)\"\n           days-is-focused=\"$ctrl.daysIsFocused($event)\"\n           is-mobile-app=\"$ctrl.isMobileApp\"\n           without-manager=\"$ctrl.withoutManager\">\n</card-base>\n"

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserCardRowController = function () {
	  UserCardRowController.$inject = ["EventEmitter"];
	  function UserCardRowController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, UserCardRowController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(UserCardRowController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cardsBackup = angular.copy(this.cards);
	      this.checkHasManager();
	      this.setCardHasManager();
	    }
	  }, {
	    key: 'setModifiedCards',
	    value: function setModifiedCards($event) {
	      var event = this.EventEmitter($event);
	      this.notifyModify(event);
	    }
	  }, {
	    key: 'createPeriod',
	    value: function createPeriod($event) {
	      var event = this.EventEmitter($event);
	      this.notifySend(event);
	    }
	  }, {
	    key: 'daysIsFocused',
	    value: function daysIsFocused($event) {
	      var event = this.EventEmitter($event);
	      this.cardDaysFocused(event);
	    }
	  }, {
	    key: 'resetCardState',
	    value: function resetCardState(card) {
	      var originalCard = this.cardsBackup.find(function (cardBackup) {
	        return cardBackup.id === card.id && cardBackup.enjoymentMonth === card.enjoymentMonth;
	      });
	
	      if (card.state === _constants.FOOD_BENEFIT_STATES.error && originalCard.state === _constants.FOOD_BENEFIT_STATES.error) {
	        card.state = this.originalCardState;
	      } else if (!this.originalCardState && this.originalCardState !== '') {
	        card.state = _constants.FOOD_BENEFIT_STATES.requested;
	      } else {
	        card.state = this.originalCardState || _constants.FOOD_BENEFIT_STATES.initial;
	      }
	
	      card.requestErrorMsg = undefined;
	      card.enjoymentDays = originalCard.enjoymentDays;
	      this.onCloseCard();
	    }
	  }, {
	    key: 'checkHasManager',
	    value: function checkHasManager() {
	      this.withoutManager = true;
	      if (this.profile.managerId !== null) {
	        this.withoutManager = false;
	      }
	    }
	  }, {
	    key: 'setCardHasManager',
	    value: function setCardHasManager() {
	      var _this = this;
	
	      this.cards.forEach(function (card) {
	        card.hasManager = !_this.withoutManager;
	      });
	    }
	  }]);
	  return UserCardRowController;
	}();
	
	exports.default = UserCardRowController;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1682);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./userCardRow.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./userCardRow.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lastDayAlert = __webpack_require__(1684);
	
	var _lastDayAlert2 = _interopRequireDefault(_lastDayAlert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastDayAlertModule = _angular2.default.module('lastDayAlert', []).component('lastDayAlert', _lastDayAlert2.default).name;
	
	exports.default = lastDayAlertModule;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lastDayAlert = __webpack_require__(1685);
	
	var _lastDayAlert2 = _interopRequireDefault(_lastDayAlert);
	
	var _lastDayAlert3 = __webpack_require__(1686);
	
	var _lastDayAlert4 = _interopRequireDefault(_lastDayAlert3);
	
	__webpack_require__(1687);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastDayAlertComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _lastDayAlert2.default,
	  controller: _lastDayAlert4.default
	};
	
	exports.default = lastDayAlertComponent;

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"card\">\n  <div class=\"vertical-bar-left\"></div>\n  <div class=\"message-container\">\n   <span class=\"alert-message\">{{'FOOD_BENEFIT.HOME.WARN' | translate}}</span>\n  </div>\n</section>\n"

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LastDayAlertController = function () {
	  function LastDayAlertController() {
	    (0, _classCallCheck3.default)(this, LastDayAlertController);
	  }
	
	  (0, _createClass3.default)(LastDayAlertController, [{
	    key: "$onInit",
	    value: function $onInit() {}
	  }]);
	  return LastDayAlertController;
	}();
	
	exports.default = LastDayAlertController;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1688);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./lastDayAlert.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./lastDayAlert.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "last-day-alert{display:block}last-day-alert .card{display:inline-flex;width:327px;max-height:48px;background-color:#fff;box-shadow:0 0 8px 3px hsla(220,8%,92%,.5);border-radius:3px}last-day-alert .message-container{padding:7px 5px 0}last-day-alert .alert-message{font-family:Stag Sans;font-size:14px;font-weight:300;line-height:1.21;text-align:left;color:#666}last-day-alert .vertical-bar-left{margin-right:10px;width:10px;height:48px;border:1px #fff;border-top-left-radius:3px;border-bottom-left-radius:3px;background-color:#52bcec}@media(max-width:944px){last-day-alert .vertical-bar-left{margin-right:5px}}", ""]);
	
	// exports


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _benefitRequestDays = __webpack_require__(1690);
	
	var _benefitRequestDays2 = _interopRequireDefault(_benefitRequestDays);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var benefitRequestDaysModule = _angular2.default.module('benefitRequestDays', []).component('benefitRequestDays', _benefitRequestDays2.default).name;
	
	exports.default = benefitRequestDaysModule;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _benefitRequestDays = __webpack_require__(1691);
	
	var _benefitRequestDays2 = _interopRequireDefault(_benefitRequestDays);
	
	var _benefitRequestDays3 = __webpack_require__(1692);
	
	var _benefitRequestDays4 = _interopRequireDefault(_benefitRequestDays3);
	
	__webpack_require__(1693);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var benefitRequestDaysComponent = {
	  restrict: 'E',
	  bindings: {
	    request: '<'
	  },
	  template: _benefitRequestDays2.default,
	  controller: _benefitRequestDays4.default
	};
	
	exports.default = benefitRequestDaysComponent;

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

	module.exports = "<span class=\"days\">\n  <span ng-if=\"$ctrl.showEnjoymentDays()\">\n    {{ ::$ctrl.request.enjoymentDays }} {{ 'FOOD_BENEFIT.BENEFIT_REQUEST_CARD.REQUESTED_DAYS' | translate }}\n  </span>\n\n  <span ng-if=\"$ctrl.showPositiveDifferenceDays()\">\n    {{ ::$ctrl.request.approvedDays }} {{ 'FOOD_BENEFIT.BENEFIT_REQUEST_CARD.APPROVED_DAYS' | translate }}\n    <br>\n    {{ $ctrl.daysDifference}} {{ 'FOOD_BENEFIT.BENEFIT_REQUEST_CARD.POSITIVE_REQUESTED_DAYS' | translate }}\n  </span>\n\n  <span ng-if=\"$ctrl.showNegativeDifferenceDays()\">\n    {{ ::$ctrl.request.approvedDays }} {{ 'FOOD_BENEFIT.BENEFIT_REQUEST_CARD.APPROVED_DAYS' | translate }}\n    <br>\n    {{ $ctrl.daysDifference * -1 }} {{ 'FOOD_BENEFIT.BENEFIT_REQUEST_CARD.NEGATIVE_REQUESTED_DAYS' | translate }}\n  </span>\n</span>\n"

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BenefitRequestDaysController = function () {
	  BenefitRequestDaysController.$inject = ["$scope"];
	  function BenefitRequestDaysController($scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BenefitRequestDaysController);
	    this.scope = $scope;
	  }
	
	  (0, _createClass3.default)(BenefitRequestDaysController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.getDaysDifference();
	      this.scope.$watch(function () {
	        return _this.request;
	      }, function () {
	        return _this.getDaysDifference();
	      });
	    }
	  }, {
	    key: 'getDaysDifference',
	    value: function getDaysDifference() {
	      this.daysDifference = parseInt(this.request.daysDifference, 10) || 0;
	    }
	  }, {
	    key: 'showEnjoymentDays',
	    value: function showEnjoymentDays() {
	      return this.daysDifference === 0;
	    }
	  }, {
	    key: 'showPositiveDifferenceDays',
	    value: function showPositiveDifferenceDays() {
	      return this.daysDifference > 0;
	    }
	  }, {
	    key: 'showNegativeDifferenceDays',
	    value: function showNegativeDifferenceDays() {
	      return this.daysDifference < 0;
	    }
	  }]);
	  return BenefitRequestDaysController;
	}();
	
	exports.default = BenefitRequestDaysController;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1694);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benefitRequestDays.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./benefitRequestDays.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _delegatedCardListMobile = __webpack_require__(1696);
	
	var _delegatedCardListMobile2 = _interopRequireDefault(_delegatedCardListMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedCardListMobileModule = _angular2.default.module('delegatedCardListMobile', []).component('delegatedCardListMobile', _delegatedCardListMobile2.default).name;
	
	exports.default = delegatedCardListMobileModule;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _delegatedCardListMobile = __webpack_require__(1697);
	
	var _delegatedCardListMobile2 = _interopRequireDefault(_delegatedCardListMobile);
	
	var _delegatedCardListMobileController = __webpack_require__(1698);
	
	var _delegatedCardListMobileController2 = _interopRequireDefault(_delegatedCardListMobileController);
	
	__webpack_require__(1699);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedCardListMobileComponent = {
	  restrict: 'E',
	  bindings: {
	    employees: '<',
	    isMobileApp: '<',
	    updateDataEmployees: '&'
	  },
	  template: _delegatedCardListMobile2.default,
	  controller: _delegatedCardListMobileController2.default
	};
	
	exports.default = delegatedCardListMobileComponent;

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

	module.exports = "<delegated-request-modal\n  ng-if=\"$ctrl.employeeModal !== undefined\"\n  employee-to-edit=\"$ctrl.employeeModal\"\n  update-employee=\"$ctrl.updateEmployees($event)\"\n  is-mobile-app=\"$ctrl.isMobileApp\">\n</delegated-request-modal>\n\n<div class=\"row-list delegated-card-list\">\n  <delegated-card-row\n    ng-repeat=\"employee in $ctrl.employees\"\n    class=\"flex-row\"\n    current-employee=\"employee\"\n    process-employee=\"$ctrl.onProcessEmployee($event)\"\n    is-mobile-app=\"$ctrl.isMobileApp\"></delegated-card-row>\n</div>\n"

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DelegatedCardListMobileController = function () {
	  DelegatedCardListMobileController.$inject = ["$timeout", "EventEmitter"];
	  function DelegatedCardListMobileController($timeout, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DelegatedCardListMobileController);
	    this.timeout = $timeout;
	    this.EventEmitter = EventEmitter;
	    this.employeeModal = undefined;
	  }
	
	  (0, _createClass3.default)(DelegatedCardListMobileController, [{
	    key: 'onProcessEmployee',
	    value: function onProcessEmployee(_ref) {
	      var employee = _ref.employee;
	
	      this.openModalDelegatedRequest(employee);
	    }
	  }, {
	    key: 'updateEmployees',
	    value: function updateEmployees($event) {
	      var event = this.EventEmitter($event);
	      this.updateDataEmployees(event);
	    }
	  }, {
	    key: 'openModalDelegatedRequest',
	    value: function openModalDelegatedRequest(employee) {
	      var _this = this;
	
	      this.employeeModal = employee;
	      this.timeout(function () {
	        _this.delegatedRequestModal.modal('show');
	      });
	    }
	  }, {
	    key: 'delegatedRequestModal',
	    get: function get() {
	      return $(_constants.MODALS.DELEGATED_REQUEST_MODAL);
	    }
	  }]);
	  return DelegatedCardListMobileController;
	}();
	
	exports.default = DelegatedCardListMobileController;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1700);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedCardListMobile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedCardListMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "delegated-card-list-mobile .delegated-card-list{margin-top:20px;margin-bottom:75px}delegated-card-list-mobile .delegated-card-list .flex-row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0 0 9px}delegated-card-list-mobile .delegated-card-list .flex-row .flex-item{flex:1 0 49%;margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _delegatedCardRow = __webpack_require__(1702);
	
	var _delegatedCardRow2 = _interopRequireDefault(_delegatedCardRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedCardRowModule = _angular2.default.module('delegatedCardRow', []).component('delegatedCardRow', _delegatedCardRow2.default).name;
	
	exports.default = delegatedCardRowModule;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _delegatedCardRow = __webpack_require__(1703);
	
	var _delegatedCardRow2 = _interopRequireDefault(_delegatedCardRow);
	
	var _delegatedCardRow3 = __webpack_require__(1704);
	
	var _delegatedCardRow4 = _interopRequireDefault(_delegatedCardRow3);
	
	__webpack_require__(1705);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedCardRowComponent = {
	  restrict: 'E',
	  bindings: {
	    currentEmployee: '<',
	    processEmployee: '&',
	    isMobileApp: '<'
	  },
	  template: _delegatedCardRow2.default,
	  controller: _delegatedCardRow4.default
	};
	
	exports.default = delegatedCardRowComponent;

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"delegated-card-row\" ng-click=\"$ctrl.openModalDelegatedRequest()\">\n  <div class=\"section-row\">\n    <delegated-card-avatar employee-profile=\"$ctrl.currentEmployee.profile\"></card-avatar>\n  </div>\n  <div class=\"section-row\">\n    <delegated-card-request employee-profile=\"$ctrl.currentEmployee.profile\" \n                            cards=\"$ctrl.currentEmployee.cards\">\n    </delegated-card-request>\n  </div>\n  <div class=\"section-row\">\n    <delegated-card-request-counter cards=\"$ctrl.currentEmployee.cards\">\n    </delegated-card-request-counter>    \n  </div>\n</div>"

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DelegatedCardRowController = function () {
	  DelegatedCardRowController.$inject = ["EventEmitter"];
	  function DelegatedCardRowController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DelegatedCardRowController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(DelegatedCardRowController, [{
	    key: 'openModalDelegatedRequest',
	    value: function openModalDelegatedRequest() {
	      var event = this.EventEmitter({
	        employee: this.currentEmployee
	      });
	      this.processEmployee(event);
	    }
	  }]);
	  return DelegatedCardRowController;
	}();
	
	exports.default = DelegatedCardRowController;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1706);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedCardRow.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedCardRow.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, ".delegated-card-row{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;width:100%;padding:15px 0;border-bottom:1px solid #eaebed}.delegated-card-row .section-row{flex:1}.delegated-card-row .section-row:nth-of-type(2){flex:3}", ""]);
	
	// exports


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _delegatedCardAvatar = __webpack_require__(1708);
	
	var _delegatedCardAvatar2 = _interopRequireDefault(_delegatedCardAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedCardAvatarModule = _angular2.default.module('delegatedCardAvatar', []).component('delegatedCardAvatar', _delegatedCardAvatar2.default).name;
	
	exports.default = delegatedCardAvatarModule;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _delegatedCardAvatar = __webpack_require__(1709);
	
	var _delegatedCardAvatar2 = _interopRequireDefault(_delegatedCardAvatar);
	
	__webpack_require__(1710);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedCardAvatarComponent = {
	  restrict: 'E',
	  bindings: {
	    employeeProfile: '<'
	  },
	  template: _delegatedCardAvatar2.default
	};
	
	exports.default = delegatedCardAvatarComponent;

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"delegated-card-avatar\">\n  <avatar-app ng-if=\"$ctrl.employeeProfile !== undefined\"\n              name=\"$ctrl.employeeProfile.name\"\n              email=\"$ctrl.employeeProfile.email\"\n              user-id=\"$ctrl.employeeProfile.userId\"></avatar-app>\n</div>\n"

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1711);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedCardAvatar.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedCardAvatar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, ".delegated-card-avatar{margin:0 6px;position:relative}.delegated-card-avatar avatar-app .avatar-container{width:50px;height:50px;line-height:50px}.delegated-card-avatar avatar-app .avatar-container.size-big .initials-container span{font-size:20px}", ""]);
	
	// exports


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _delegatedCardRequest = __webpack_require__(1713);
	
	var _delegatedCardRequest2 = _interopRequireDefault(_delegatedCardRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedCardRequestModule = _angular2.default.module('delegatedCardRequest', []).component('delegatedCardRequest', _delegatedCardRequest2.default).name;
	
	exports.default = delegatedCardRequestModule;

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _delegatedCardRequest = __webpack_require__(1714);
	
	var _delegatedCardRequest2 = _interopRequireDefault(_delegatedCardRequest);
	
	var _delegatedCardRequest3 = __webpack_require__(1715);
	
	var _delegatedCardRequest4 = _interopRequireDefault(_delegatedCardRequest3);
	
	__webpack_require__(1716);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedCardRequestComponent = {
	  restrict: 'E',
	  bindings: {
	    employeeProfile: '<',
	    cards: '<'
	  },
	  template: _delegatedCardRequest2.default,
	  controller: _delegatedCardRequest4.default
	};
	
	exports.default = delegatedCardRequestComponent;

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"delegated-card-request-container\">\n  <h2 class=\"name\">\n    <span>{{ $ctrl.employeeProfile.name}}</span>\n  </h2>\n  <div class=\"icons-container\">\n    <div class=\"status-icon\" ng-repeat=\"card in $ctrl.cards | orderBy : $index : true\">\n      <span class=\"icon-requested\" ng-show=\"$ctrl.isCardRequested(card)\">\n        <span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span>\n      </span>\n      <span class=\"icon icon-approved\" ng-show=\"$ctrl.isCardApproved(card)\">\n        <span class=\"path1\"></span><span class=\"path2\"></span>\n      </span>\n      <span class=\"without-icon\" ng-show=\"$ctrl.isCardNotApprovedAndNotRequested(card)\"></span>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DelegatedCardRequestController = function () {
	  function DelegatedCardRequestController() {
	    (0, _classCallCheck3.default)(this, DelegatedCardRequestController);
	  }
	
	  (0, _createClass3.default)(DelegatedCardRequestController, [{
	    key: 'isCardRequested',
	    value: function isCardRequested(card) {
	      return card.state === _constants.FOOD_BENEFIT_STATES.requested;
	    }
	  }, {
	    key: 'isCardApproved',
	    value: function isCardApproved(card) {
	      return card.state === _constants.FOOD_BENEFIT_STATES.approved;
	    }
	  }, {
	    key: 'isCardNotApprovedAndNotRequested',
	    value: function isCardNotApprovedAndNotRequested(card) {
	      return !this.isCardRequested(card) && !this.isCardApproved(card);
	    }
	  }]);
	  return DelegatedCardRequestController;
	}();
	
	exports.default = DelegatedCardRequestController;

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1717);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedCardRequest.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedCardRequest.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "delegated-card-request .delegated-card-request-container{padding-left:10px;margin-top:5px}delegated-card-request .delegated-card-request-container .name{font-size:14px;color:#0072c9;line-height:12px;font-weight:400;margin-top:0}delegated-card-request .delegated-card-request-container .icons-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;height:16px}delegated-card-request .delegated-card-request-container .icons-container .status-icon{margin-right:10px;font-size:20px}delegated-card-request .delegated-card-request-container .icons-container .status-icon .without-icon{background-color:#dddfe2;display:block;width:20px;height:20px;border-radius:100%;margin-top:1px}", ""]);
	
	// exports


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _delegatedCardRequestCounter = __webpack_require__(1719);
	
	var _delegatedCardRequestCounter2 = _interopRequireDefault(_delegatedCardRequestCounter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedCardRequestCounterModule = _angular2.default.module('delegatedCardRequestCounter', []).component('delegatedCardRequestCounter', _delegatedCardRequestCounter2.default).name;
	
	exports.default = delegatedCardRequestCounterModule;

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _delegatedCardRequestCounter = __webpack_require__(1720);
	
	var _delegatedCardRequestCounter2 = _interopRequireDefault(_delegatedCardRequestCounter);
	
	var _delegatedCardRequestCounter3 = __webpack_require__(1721);
	
	var _delegatedCardRequestCounter4 = _interopRequireDefault(_delegatedCardRequestCounter3);
	
	__webpack_require__(1722);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedCardRequestCounterComponent = {
	  restrict: 'E',
	  bindings: {
	    cards: '<'
	  },
	  template: _delegatedCardRequestCounter2.default,
	  controller: _delegatedCardRequestCounter4.default
	};
	
	exports.default = delegatedCardRequestCounterComponent;

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"delegated-card-request-counter-container\" ng-if=\"$ctrl.hasMonthEmpty()\">\n  <span class=\"counter-number\">{{$ctrl.monthsEmptyCounter }}</span>\n  <span class=\"counter-label\">meses</span>\n</section>\n"

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DelegatedCardRequestCounterController = function () {
	  function DelegatedCardRequestCounterController() {
	    (0, _classCallCheck3.default)(this, DelegatedCardRequestCounterController);
	  }
	
	  (0, _createClass3.default)(DelegatedCardRequestCounterController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.monthsEmptyCounter = this._getMonthsEmptyCounter();
	    }
	  }, {
	    key: 'hasMonthEmpty',
	    value: function hasMonthEmpty() {
	      var EMPTY_COUNTER_EMPTY = '00';
	      return this.monthsEmptyCounter !== EMPTY_COUNTER_EMPTY;
	    }
	  }, {
	    key: '_getMonthsEmptyCounter',
	    value: function _getMonthsEmptyCounter() {
	      var counter = 0;
	      this.cards.forEach(function (card) {
	        if (card.state === '') counter++;
	      });
	      return this._formatCounter(counter);
	    }
	  }, {
	    key: '_formatCounter',
	    value: function _formatCounter(counterNumber) {
	      return '0' + counterNumber;
	    }
	  }]);
	  return DelegatedCardRequestCounterController;
	}();
	
	exports.default = DelegatedCardRequestCounterController;

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1723);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedCardRequestCounter.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedCardRequestCounter.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "delegated-card-request-counter .delegated-card-request-counter-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;text-align:center;color:#0072c9}delegated-card-request-counter .delegated-card-request-counter-container .counter-number{font-size:28px;height:30px}delegated-card-request-counter .delegated-card-request-counter-container .counter-label{font-size:12px}", ""]);
	
	// exports


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _delegatedRequestModal = __webpack_require__(1725);
	
	var _delegatedRequestModal2 = _interopRequireDefault(_delegatedRequestModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedRequestModalModule = _angular2.default.module('delegatedRequestModal', []).component('delegatedRequestModal', _delegatedRequestModal2.default).name;
	
	exports.default = delegatedRequestModalModule;

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _delegatedRequestModal = __webpack_require__(1726);
	
	var _delegatedRequestModal2 = _interopRequireDefault(_delegatedRequestModal);
	
	var _delegatedRequestModal3 = __webpack_require__(1727);
	
	var _delegatedRequestModal4 = _interopRequireDefault(_delegatedRequestModal3);
	
	__webpack_require__(1728);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegatedRequestModalComponent = {
	  restrict: 'E',
	  bindings: {
	    employeeToEdit: '<',
	    updateEmployee: '&',
	    isMobileApp: '<'
	  },
	  template: _delegatedRequestModal2.default,
	  controller: _delegatedRequestModal4.default
	};
	
	exports.default = delegatedRequestModalComponent;

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal delegated-request-modal\" id=\"modalDelegatedRequest\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"RequestCardModalLabel\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content delegated-request-content\">\n        <benefit-request-modal\n          modal-id=\"modalDelegatedRequestList\"\n          request=\"$ctrl.requestModal\"\n          remove-period=\"$ctrl.removePeriod()\"\n          modal-state=\"$ctrl.modalState\"\n          description=\"$ctrl.description\"\n          modified-card-count=\"$ctrl.countModifiedCards\"\n          action-in-modal=\"$ctrl.onModalResponse($event)\"\n          error-msg=\"$ctrl.modalMessage\"\n          is-mobile-app=\"$ctrl.isMobileApp\">\n      </benefit-request-modal>\n\n      <div class=\"modal-header delegated-request-header\">\n        <button type=\"button\" ng-click=\"$ctrl.hideSelfModal()\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n        <avatar-app ng-if=\"$ctrl.employeeToEdit !== undefined\"\n                    name=\"$ctrl.employeeToEdit.profile.name\"\n                    email=\"$ctrl.employeeToEdit.profile.email\"\n                    user-id=\"$ctrl.employeeToEdit.userId\"></avatar-app>\n        <span class=\"name\">{{ $ctrl.employeeToEdit.profile.name }}</span>\n      </div>\n\n      <div class=\"modal-body delegated-request-body\" id=\"delegatedRequestBody\">\n        <user-card-list\n          employees=\"$ctrl.employeeFormattedToCard\"\n          on-modify=\"$ctrl.onModify($event)\"\n          on-send-card=\"$ctrl.onSendCard($event)\"\n          new-card-state=\"$ctrl.newCardState\"\n          card-days-focused=\"$ctrl.daysIsFocused($event)\"\n          on-close-card=\"$ctrl.resetEmployeeEdited()\"\n          is-mobile-app=\"$ctrl.isMobileApp\">\n        </user-card-list>\n      </div>\n      <floating-action-buttons\n        ng-show=\"$ctrl.showSendAllRequest()\"\n        buttons=\"$ctrl.floatingActionButtons\"\n        on-click-first-button=\"$ctrl.openModalRequestAll()\">\n      </floating-action-buttons>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(916);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DELEGATED_REQUEST_BODY_ID = 'delegatedRequestBody';
	
	var DelegatedRequestModalController = function () {
	  DelegatedRequestModalController.$inject = ["$scope", "$rootScope", "$translate", "$location", "foodBenefitService", "myFoodBenefitHelper", "FoodBenefitUserDataService", "EventEmitter", "loadingMobileService", "floatingActionButtonsService"];
	  function DelegatedRequestModalController($scope, $rootScope, $translate, $location, foodBenefitService, myFoodBenefitHelper, FoodBenefitUserDataService, EventEmitter, loadingMobileService, floatingActionButtonsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DelegatedRequestModalController);
	    this.scope = $scope;
	    this.rootScope = $rootScope;
	    this.translate = $translate;
	    this.location = $location;
	    this.EventEmitter = EventEmitter;
	    this.foodBenefitService = foodBenefitService;
	    this.floatingActionButtonsService = floatingActionButtonsService;
	    this.myFoodBenefitHelper = myFoodBenefitHelper;
	    this.cardModified = false;
	    this.UserDataService = FoodBenefitUserDataService;
	    this.employee = this.UserDataService.getEmployee();
	    this.userId = this.employee.userId;
	    this.loadingMobileService = loadingMobileService;
	  }
	
	  (0, _createClass3.default)(DelegatedRequestModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.employeeFormattedToCard = [this.employeeToEdit];
	      this.employeeInitialValues = angular.copy(this.employeeToEdit);
	      this._translate();
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.myFoodBenefitHelper.getFloatingSendAllButton();
	      }
	      this.scope.$watch(function () {
	        return _this.employeeToEdit;
	      }, function (newValue) {
	        if (newValue) {
	          _this.employeeFormattedToCard = [newValue];
	          _this.employeeInitialValues = angular.copy(newValue);
	        }
	      });
	    }
	  }, {
	    key: 'openModalRequestAll',
	    value: function openModalRequestAll() {
	      this.countModifiedCards = this.modifiedArray.length;
	      this.modalState = this.myFoodBenefitHelper.getModalStateSendAll();
	      this.modalBenefitRequestList.modal('show');
	    }
	  }, {
	    key: '_hideRequestModal',
	    value: function _hideRequestModal() {
	      this.modalBenefitRequestList.modal('hide');
	    }
	  }, {
	    key: 'hideSelfModal',
	    value: function hideSelfModal() {
	      var cardsAreNotSended = this.requestModal === undefined;
	      this.resetEmployeeEdited();
	      var event = this.EventEmitter(this.employeeToEdit);
	      if (cardsAreNotSended) {
	        event = this.EventEmitter(this.employeeInitialValues);
	        this.cardModified = false;
	        this.employeeFormattedToCard = [this.employeeInitialValues];
	      }
	      this.updateEmployee(event);
	      this.modalDelegatedRequest.modal('hide');
	    }
	  }, {
	    key: 'onModalResponse',
	    value: function onModalResponse($event) {
	      this.modalAction = $event.status;
	      var cardsToSend = this.modifiedArray.map(this.myFoodBenefitHelper.formatRequest);
	      if ($event.status === _constants2.MODAL_ACTIONS.CANCEL) {
	        this._hideRequestModal();
	        return;
	      }
	      if ($event.status === _constants2.MODAL_ACTIONS.SEND) {
	        this.requestFoodBenefits(cardsToSend, null);
	      }
	    }
	  }, {
	    key: 'onModify',
	    value: function onModify(modifiedArray) {
	      this.modifiedArray = modifiedArray;
	      this.cardModified = this.myFoodBenefitHelper.checkMoreThanOneModified(this.modifiedArray);
	    }
	  }, {
	    key: 'onSendCard',
	    value: function onSendCard(card) {
	      var arrayToSend = new Array();
	      arrayToSend.push(card);
	      arrayToSend = arrayToSend.map(this.myFoodBenefitHelper.formatRequest);
	      this.requestFoodBenefits(arrayToSend, card);
	    }
	  }, {
	    key: 'requestFoodBenefits',
	    value: function requestFoodBenefits(requests, card) {
	      var _this2 = this;
	
	      this.loadingMobileService.show();
	      this.foodBenefitService.requestFoodBenefits(requests, this.userId).then(function () {
	        _this2._reloadData(card, false);
	        _this2.requestModal = requests;
	        _this2.modalMessage = requests.length + ' ' + _this2.allRequestApprovedText;
	      }).catch(function (error) {
	        if (card === null) {
	          _this2._showModalErrorWhenFailedSendAllCards(error.data.message);
	        } else {
	          card.requestErrorMsg = error.data.message;
	        }
	        _this2._reloadData(card, true);
	      }).finally(function () {
	        return _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '_getDelegatedEmployeeInfo',
	    value: function _getDelegatedEmployeeInfo(mainEmployeeInfo) {
	      var _this3 = this;
	
	      var currentEmployeeDelegated = mainEmployeeInfo.delegations.find(function (delegatedEmployee) {
	        return delegatedEmployee.profile.employeeId === _this3.employeeToEdit.profile.employeeId;
	      });
	      return currentEmployeeDelegated;
	    }
	  }, {
	    key: '_initData',
	    value: function _initData() {
	      var mainEmployeeInfo = this.UserDataService.getEmployee();
	      var employeeToEdit = this._getDelegatedEmployeeInfo(mainEmployeeInfo);
	      var employeesBackup = [];
	      employeesBackup.push(employeeToEdit);
	      this.employeeFormattedToCard = angular.copy(employeesBackup);
	    }
	  }, {
	    key: '_reloadData',
	    value: function _reloadData(card, isErrored) {
	      var _this4 = this;
	
	      this.foodBenefitService.getManagerDataSync().then(function (managerData) {
	        var requestNumber = managerData.employeesFoodBenefitPeriods.length;
	        _this4.rootScope.$broadcast(_constants.EVENTS.BADGE_NUMBER, { badgeNumber: requestNumber });
	      });
	      this.cardModified = false;
	      this.foodBenefitService.getUserDataSync().then(function () {
	        _this4._initData();
	        if (isErrored) {
	          _this4.setStateFailed(card);
	        } else {
	          _this4.setStateApprove(card);
	        }
	      });
	    }
	  }, {
	    key: 'resetEmployeeEdited',
	    value: function resetEmployeeEdited() {
	      var mainEmployeeInfo = this.UserDataService.getEmployee();
	      this.employeeToEdit = this._getDelegatedEmployeeInfo(mainEmployeeInfo);
	    }
	  }, {
	    key: 'daysIsFocused',
	    value: function daysIsFocused($event) {
	      this.daysInCardIsFocused = $event.isFocused;
	      this.scrollToTop();
	    }
	  }, {
	    key: 'scrollToTop',
	    value: function scrollToTop() {
	      this.location.hash(DELEGATED_REQUEST_BODY_ID);
	    }
	  }, {
	    key: 'showSendAllRequest',
	    value: function showSendAllRequest() {
	      return this.isMobileApp && this.cardModified && !this.floatingActionButtonsService.isFocused && !this.daysInCardIsFocused;
	    }
	  }, {
	    key: 'setStateApprove',
	    value: function setStateApprove(card) {
	      if (card) {
	        this.newCardState = this.myFoodBenefitHelper.setCardStateApproved(card, this.employeeFormattedToCard);
	      } else {
	        this.modalState = this.myFoodBenefitHelper.getModalStateApproved();
	      }
	    }
	  }, {
	    key: 'setStateFailed',
	    value: function setStateFailed(card) {
	      if (card) {
	        this.newCardState = this.myFoodBenefitHelper.setCardStateFailed(card, this.employeeFormattedToCard);
	      } else {
	        this.modalState = this.myFoodBenefitHelper.getModalStateFailed();
	      }
	    }
	  }, {
	    key: '_showModalErrorWhenFailedSendAllCards',
	    value: function _showModalErrorWhenFailedSendAllCards(messageError) {
	      this.modalMessage = messageError;
	      this.modalState = this.myFoodBenefitHelper.getModalStateFailed();
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this5 = this;
	
	      return this.myFoodBenefitHelper.getApproveAllMessage().then(function (translation) {
	        _this5.allRequestApprovedText = translation;
	      });
	    }
	  }, {
	    key: 'modalBenefitRequestList',
	    get: function get() {
	      return $(_constants.MODALS.BENEFIT_DELEGATED_REQUEST_LIST);
	    }
	  }, {
	    key: 'modalDelegatedRequest',
	    get: function get() {
	      return $(_constants.MODALS.DELEGATED_REQUEST_MODAL);
	    }
	  }]);
	  return DelegatedRequestModalController;
	}();
	
	exports.default = DelegatedRequestModalController;

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1729);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedRequestModal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./delegatedRequestModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "delegated-request-modal .delegated-request-modal .delegated-request-content{padding:25px 0}delegated-request-modal .delegated-request-modal .delegated-request-content .delegated-request-header{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;box-shadow:0 4px 4px 0 #eaebed}delegated-request-modal .delegated-request-modal .delegated-request-content .delegated-request-header .name,delegated-request-modal .delegated-request-modal .delegated-request-content .delegated-request-header avatar-app{width:100%;text-align:center}delegated-request-modal .delegated-request-modal .delegated-request-content .delegated-request-header .name{font-size:16px;color:#0072c9;padding-bottom:25px;margin-top:10px}delegated-request-modal .delegated-request-modal .delegated-request-content .delegated-request-body{margin:10px 10px 0}", ""]);
	
	// exports


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _workTeamList = __webpack_require__(1731);
	
	var _workTeamList2 = _interopRequireDefault(_workTeamList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workTeamListModule = _angular2.default.module('workTeamList', [_angularUiRouter2.default]).component('workTeamList', _workTeamList2.default).name;
	
	exports.default = workTeamListModule;

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _workTeamList = __webpack_require__(1732);
	
	var _workTeamList2 = _interopRequireDefault(_workTeamList);
	
	var _workTeamList3 = __webpack_require__(1733);
	
	var _workTeamList4 = _interopRequireDefault(_workTeamList3);
	
	__webpack_require__(1734);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workTeamListComponent = {
	  restrict: 'E',
	  bindings: {
	    employees: '<',
	    filteredEmployees: '<',
	    isMobileApp: '<',
	    onCleanSearch: '&'
	  },
	  template: _workTeamList2.default,
	  controller: _workTeamList4.default
	};
	
	exports.default = workTeamListComponent;

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

	module.exports = "<section ng-if=\"!$ctrl.isMobileApp && $ctrl.filteredEmployees.length > 0\">\n  <employee-search-tags\n      employee-filters=\"$ctrl.filteredEmployees\"\n      on-remove-employee-filter=\"$ctrl.onRemoveEmployeeFilter($event)\"\n      on-clean-employee-filters=\"$ctrl.onCleanEmployeeFilters()\">\n  </employee-search-tags>\n</section>\n<div class=\"month-list\" ng-class=\"$ctrl.getClasses()\">\n  <div class=\"col-md-3 col-sm-3 col-xs-3 \"></div>\n  <div ng-repeat=\"month in $ctrl.months\" class=\"col-md-2 col-sm-2 col-xs-2 months col{{$index}}\">{{month.name | capitalizeFirst}}</div>\n</div>\n<work-team-card ng-repeat=\"employeeInfo in ($ctrl.filteredPeople = ($ctrl.employees | employeeFilter: $ctrl.filteredEmployees))\" employee=\"employeeInfo\" ng-class=\"$ctrl.getClasses()\" is-mobile-app=\"$ctrl.isMobileApp\"></work-team-card>\n<div ng-if=\"$ctrl.isEmpty()\" class=\"list-empty\">\n  <span class=\"icon-warning\"></span>\n  <span>{{'VACATIONS_ABSENCES.TEAM_REQUESTS.EMPTY_REQUESTS_LIST' | translate}}</span>\n</div>"

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkTeamListController = function () {
	  WorkTeamListController.$inject = ["$filter", "EventEmitter"];
	  function WorkTeamListController($filter, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WorkTeamListController);
	    this.filter = $filter;
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(WorkTeamListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      _moment2.default.locale('es');
	      this.currentMonthNumber = (0, _moment2.default)().format('MM');
	      this.currentPreviousMonth = (0, _moment2.default)().month(this.currentMonthNumber - 2).format('MMMM');
	      this.secondPreviousMonth = (0, _moment2.default)().month(this.currentMonthNumber - 3).format('MMMM');
	      this.thirdPreviousMonth = (0, _moment2.default)().month(this.currentMonthNumber - 4).format('MMMM');
	      this.fourthPreviousMonth = (0, _moment2.default)().month(this.currentMonthNumber - 5).format('MMMM');
	
	      if (this.isMobileApp) {
	        this.currentPreviousMonth = this.currentPreviousMonth.substr(0, 3);
	        this.secondPreviousMonth = this.secondPreviousMonth.substr(0, 3);
	        this.thirdPreviousMonth = this.thirdPreviousMonth.substr(0, 3);
	        this.fourthPreviousMonth = this.fourthPreviousMonth.substr(0, 3);
	      }
	
	      this.months = [{ name: this.currentPreviousMonth }, { name: this.secondPreviousMonth }, { name: this.thirdPreviousMonth }, { name: this.fourthPreviousMonth }];
	    }
	  }, {
	    key: 'isEmpty',
	    value: function isEmpty() {
	      return (0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.employees) || this._hasNotFilteredResults();
	    }
	  }, {
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.loaded === true;
	    }
	  }, {
	    key: '_hasNotFilteredResults',
	    value: function _hasNotFilteredResults() {
	      var filtered = this.filter('employeeFilter')(this.employees, this.filteredEmployees);
	      return filtered.length === 0;
	    }
	  }, {
	    key: 'hasFilters',
	    value: function hasFilters() {
	      return this.employeeFilters.length > 0;
	    }
	  }, {
	    key: 'onRemoveEmployeeFilter',
	    value: function onRemoveEmployeeFilter($event) {
	      _lodash2.default.remove(this.filteredEmployees, function (filter) {
	        return filter.employeeId === $event.employeeId;
	      });
	    }
	  }, {
	    key: 'onCleanEmployeeFilters',
	    value: function onCleanEmployeeFilters() {
	      this.onCleanSearch(this.EventEmitter({ searchText: '' }));
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        responsiveMobile: this.isMobileApp
	      };
	    }
	  }]);
	  return WorkTeamListController;
	}();
	
	exports.default = WorkTeamListController;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1735);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./workTeamList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./workTeamList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "work-team-list .month-list{height:37px;border-bottom:1px solid #f0f3f8;padding-top:2px}work-team-list .months{font-family:Stag Sans;font-size:16px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:center;color:#121212}work-team-list .col0{margin-left:-3%}work-team-list .col1,work-team-list .col2{margin-left:4%}work-team-list .col3{margin-left:3%}work-team-list .list-empty{margin-top:0;padding-top:40px;padding-bottom:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9;background-color:#fff}work-team-list .list-empty.shown-filter{margin-top:0}work-team-list .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}work-team-list .responsiveMobile .col0{margin-left:-28px}work-team-list .responsiveMobile .col1,work-team-list .responsiveMobile .col2,work-team-list .responsiveMobile .col3{margin-left:unset}", ""]);
	
	// exports


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _workTeamCard = __webpack_require__(1737);
	
	var _workTeamCard2 = _interopRequireDefault(_workTeamCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workTeamCardModule = _angular2.default.module('workTeamCard', [_angularUiRouter2.default]).component('workTeamCard', _workTeamCard2.default).name;
	
	exports.default = workTeamCardModule;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _workTeamCard = __webpack_require__(1738);
	
	var _workTeamCard2 = _interopRequireDefault(_workTeamCard);
	
	var _workTeamCard3 = __webpack_require__(1739);
	
	var _workTeamCard4 = _interopRequireDefault(_workTeamCard3);
	
	__webpack_require__(1740);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workTeamCardComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    employee: '<'
	
	  },
	  template: _workTeamCard2.default,
	  controller: _workTeamCard4.default
	};
	
	exports.default = workTeamCardComponent;

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card\" ng-class=\"$ctrl.getClasses()\">\n    <aside class=\"col-md-3 col-sm-3 col-xs-3 user-info\">\n        <avatar-app name=\"$ctrl.employee.name\" email=\"$ctrl.employee.email\"></avatar-app>\n        <div class=\"name-container\">\n            <employee-name\n              ng-if=\"!$ctrl.isMobileApp\"\n              name=\"{{$ctrl.employee.name}}\"\n              enrollment=\"{{$ctrl.employee.employeeId}}\">\n            </employee-name>\n        </div>\n    </aside>\n    <div ng-repeat=\"food in $ctrl.employee.foodBenefits | orderBy:'-enjoymentMonth':true:$ctrl.monthComparator \"\n         ng-class=\"{'is-cero': food.tickets == 0}\"\n         class=\"col-md-2 col-sm-2 col-xs-2 food-number col{{$index}}\">\n        <div class=\"name-container\">\n            <employee-name\n            name=\"{{$ctrl.employee.name}}\"\n            enrollment=\"{{$ctrl.employee.employeeId}}\"\n            ng-if=\"$ctrl.isMobileApp && $index === 0\">\n          </employee-name>\n        </div>\n      {{food.tickets}}\n    </div>\n</div>\n"

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkTeamCardController = function () {
	  function WorkTeamCardController() {
	    (0, _classCallCheck3.default)(this, WorkTeamCardController);
	  }
	
	  (0, _createClass3.default)(WorkTeamCardController, [{
	    key: "getClasses",
	    value: function getClasses() {
	      return {
	        responsiveMobile: this.isMobileApp
	      };
	    }
	  }, {
	    key: "monthComparator",
	    value: function monthComparator(month1, month2) {
	      if (month1.value < 4 && month2.value > 9) {
	        return -1;
	      }
	      if (month1.value > 9 && month2.value < 4) {
	        return 1;
	      }
	      return month1.value > month2.value ? -1 : 1;
	    }
	  }]);
	  return WorkTeamCardController;
	}();
	
	exports.default = WorkTeamCardController;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1741);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./workTeamCard.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./workTeamCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "work-team-card .card{height:69px;border-bottom:1px solid #f0f3f8}work-team-card .user-info{margin-top:10px;padding-top:8px;padding-left:42px}work-team-card .user-info avatar-app{float:left}work-team-card .user-info .name-container{max-width:154px;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:relative;top:10px;float:left}@media(max-width:1034px){work-team-card .user-info .name-container{max-width:127px}}work-team-card .user-info employee-name{color:#0072c9}work-team-card .user-info employee-name span{margin-left:16px}work-team-card .food-number{margin-top:27px;font-family:Stag Sans;font-size:24px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:center;color:#666}work-team-card .food-number.is-cero{color:#c4c4c4}work-team-card.responsiveMobile .card{height:80px}work-team-card.responsiveMobile .user-info{padding-left:17px;padding-top:8px}work-team-card.responsiveMobile .user-info avatar-app .avatar-container{line-height:46px!important;height:45px!important;width:45px!important}work-team-card.responsiveMobile .name-container{max-width:154px;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}work-team-card.responsiveMobile .food-number{font-size:20px;margin-top:43px}work-team-card.responsiveMobile employee-name{position:absolute;left:20px;bottom:29px;color:#0072c9;font-size:15px}work-team-card.responsiveMobile employee-name span{display:inline-flex;width:300%}", ""]);
	
	// exports


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _initialData = __webpack_require__(1743);
	
	var _initialData2 = _interopRequireDefault(_initialData);
	
	var _employeeRepository = __webpack_require__(1744);
	
	var _employeeRepository2 = _interopRequireDefault(_employeeRepository);
	
	var _managerRepository = __webpack_require__(1750);
	
	var _managerRepository2 = _interopRequireDefault(_managerRepository);
	
	var _initialDataManager = __webpack_require__(1753);
	
	var _initialDataManager2 = _interopRequireDefault(_initialDataManager);
	
	var _foodUserData = __webpack_require__(1754);
	
	var _foodUserData2 = _interopRequireDefault(_foodUserData);
	
	var _foodBenefit = __webpack_require__(1755);
	
	var _foodBenefit2 = _interopRequireDefault(_foodBenefit);
	
	var _myFoodBenefitHelper = __webpack_require__(1756);
	
	var _myFoodBenefitHelper2 = _interopRequireDefault(_myFoodBenefitHelper);
	
	var _foodDelegationRepository = __webpack_require__(1757);
	
	var _foodDelegationRepository2 = _interopRequireDefault(_foodDelegationRepository);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitCommon = angular.module('food-benefit.common', []).service('FoodBenefitInitialDataService', _initialData2.default).service('FoodBenefitEmployeeRepositoryService', _employeeRepository2.default).service('FoodBenefitManagerRepositoryService', _managerRepository2.default).service('FoodBenefitInitialDataManagerService', _initialDataManager2.default).service('FoodBenefitUserDataService', _foodUserData2.default).service('foodBenefitService', _foodBenefit2.default).service('myFoodBenefitHelper', _myFoodBenefitHelper2.default).service('foodDelegationService', _foodDelegationRepository2.default).name;
	
	exports.default = foodBenefitCommon;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitialDataService = function () {
	  InitialDataService.$inject = ["$http", "AuthenticationService", "$state", "FoodBenefitUserDataService", "FoodBenefitEmployeeRepositoryService"];
	  function InitialDataService($http, AuthenticationService, $state, FoodBenefitUserDataService, FoodBenefitEmployeeRepositoryService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, InitialDataService);
	    this.$http = $http;
	    this.employeeRepositoryService = FoodBenefitEmployeeRepositoryService;
	    this.state = $state;
	    this.userDataService = FoodBenefitUserDataService;
	    this.employeeId = AuthenticationService.getEmployeeId();
	  }
	
	  (0, _createClass3.default)(InitialDataService, [{
	    key: 'initMainData',
	    value: function initMainData() {
	      var _this = this;
	
	      return this.employeeRepositoryService.getEmployee(this.employeeId).then(function (employee) {
	        _this.userDataService.setEmployee(employee);
	        _this.manager = employee.isManager();
	        return employee;
	      }).catch(function (err) {
	        throw err;
	      });
	    }
	  }]);
	  return InitialDataService;
	}();
	
	exports.default = InitialDataService;

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _foodBenefit = __webpack_require__(1745);
	
	var _employeeRepository = __webpack_require__(1746);
	
	var _employeeRepository2 = _interopRequireDefault(_employeeRepository);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employeeRepositoryService = function () {
	  employeeRepositoryService.$inject = ["$http", "$window"];
	  function employeeRepositoryService($http, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, employeeRepositoryService);
	    this.http = $http;
	    this.isMobileApp = $window.innerWidth < 1024;
	  }
	
	  (0, _createClass3.default)(employeeRepositoryService, [{
	    key: 'getEmployee',
	    value: function getEmployee(employeeId) {
	      return this.http.get(_foodBenefit.ENDPOINTS_EMPLOYEE.get.initial(employeeId)).then(function (response) {
	        var employeeData = response.data;
	        return _employeeRepository2.default.assemble(employeeId, employeeData);
	      });
	    }
	  }]);
	  return employeeRepositoryService;
	}();
	
	exports.default = employeeRepositoryService;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ENDPOINTS_MANAGER = exports.ENDPOINTS_EMPLOYEE = undefined;
	
	var _endpoints = __webpack_require__(556);
	
	var API_URL = ("https://dev.autoservicios1.bbva.com/v01");
	var EMPLOYEE_URL = API_URL + '/' + _endpoints.FOOD_BENEFIT_URLS.EMPLOYEE_ROOT;
	var MANAGER_URL = API_URL + '/' + _endpoints.FOOD_BENEFIT_URLS.MANAGER_ROOT;
	
	var ENDPOINTS_EMPLOYEE = {
	  get: {
	    initial: function initial(employeeId) {
	      return EMPLOYEE_URL + '/' + employeeId;
	    },
	    payrollClosure: function payrollClosure() {
	      return EMPLOYEE_URL + '/payroll-closure-date';
	    }
	  },
	  post: {
	    create: function create(employeeId) {
	      return EMPLOYEE_URL + '/' + employeeId;
	    }
	  },
	  put: {},
	  delete: {}
	};
	
	var ENDPOINTS_MANAGER = {
	  get: {
	    initial: function initial(managerId) {
	      return MANAGER_URL + '/' + managerId;
	    }
	  },
	  post: {
	    create: function create(managerId) {
	      return MANAGER_URL + '/' + managerId;
	    }
	  },
	  put: {},
	  delete: {}
	};
	
	exports.ENDPOINTS_EMPLOYEE = ENDPOINTS_EMPLOYEE;
	exports.ENDPOINTS_MANAGER = ENDPOINTS_MANAGER;

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _profile = __webpack_require__(1172);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _foodBenefitUser = __webpack_require__(1747);
	
	var _foodBenefitUser2 = _interopRequireDefault(_foodBenefitUser);
	
	var _formatter = __webpack_require__(1362);
	
	var _formatter2 = _interopRequireDefault(_formatter);
	
	var _error = __webpack_require__(1361);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _cardRowDataFormatter = __webpack_require__(1748);
	
	var _cardRowDataFormatter2 = _interopRequireDefault(_cardRowDataFormatter);
	
	var _delegationsFormatter = __webpack_require__(1749);
	
	var _delegationsFormatter2 = _interopRequireDefault(_delegationsFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function assembleProfile(data) {
	  var profile = new _profile2.default();
	  profile.name = data.name;
	  profile.userId = data.employeeId;
	  profile.image = data.image;
	  profile.email = data.email;
	  profile.delegation = data.delegations;
	  profile.employeeopplus = data.employeeopplus;
	
	  if (data.bbvaUserId) {
	    profile.bbvaUserId = data.bbvaUserId;
	  }
	
	  if (data.manager) {
	    profile.role = _profile2.default.ROLE_MANAGER;
	  }
	
	  return profile;
	}
	
	var employeeDataAssembler = function () {
	  function employeeDataAssembler() {
	    (0, _classCallCheck3.default)(this, employeeDataAssembler);
	  }
	
	  (0, _createClass3.default)(employeeDataAssembler, null, [{
	    key: 'assemble',
	    value: function assemble(userId, data) {
	      var profile = void 0;
	      (0, _error2.default)(function () {
	        profile = assembleProfile(data.employeeProfile);
	      }, _formatter2.default.ASSEMBLE_PROFILE);
	      var user = new _foodBenefitUser2.default(userId, profile);
	      user.cards = _cardRowDataFormatter2.default.assemble(data);
	      var rawDelegations = data.delegations || [];
	      user.delegations = _delegationsFormatter2.default.assemble(rawDelegations);
	      return user;
	    }
	  }]);
	  return employeeDataAssembler;
	}();
	
	exports.default = employeeDataAssembler;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1531);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1534);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1535);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _user = __webpack_require__(1546);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _profile = __webpack_require__(1172);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitUser = function (_User) {
	  (0, _inherits3.default)(foodBenefitUser, _User);
	
	  function foodBenefitUser(userId, profile) {
	    (0, _classCallCheck3.default)(this, foodBenefitUser);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (foodBenefitUser.__proto__ || (0, _getPrototypeOf2.default)(foodBenefitUser)).call(this, userId, profile));
	
	    _this.cards = [];
	    _this.delegations = [];
	    return _this;
	  }
	
	  (0, _createClass3.default)(foodBenefitUser, [{
	    key: 'hasManagerDelegation',
	    value: function hasManagerDelegation() {
	      return this._profile.delegation.type === _profile2.default.DELEGATION_MANAGER();
	    }
	  }]);
	  return foodBenefitUser;
	}(_user2.default);
	
	exports.default = foodBenefitUser;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _foodBenefitCard = __webpack_require__(1638);
	
	var _foodBenefitCard2 = _interopRequireDefault(_foodBenefitCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardRowDataFormatter = function () {
	  function cardRowDataFormatter() {
	    (0, _classCallCheck3.default)(this, cardRowDataFormatter);
	  }
	
	  (0, _createClass3.default)(cardRowDataFormatter, null, [{
	    key: 'assemble',
	    value: function assemble(data) {
	      var cardArray = formatCards(data);
	      return cardArray;
	    }
	  }]);
	  return cardRowDataFormatter;
	}();
	
	function formatCards(rawData) {
	  var cards = [];
	  for (var key in rawData.foodBenefitPeriods) {
	    var obj = rawData.foodBenefitPeriods[key];
	    obj.id = rawData.employeeProfile.employeeId;
	    cards.push(new _foodBenefitCard2.default(obj));
	  }
	
	  return cards;
	}
	
	exports.default = cardRowDataFormatter;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _foodBenefitCard = __webpack_require__(1638);
	
	var _foodBenefitCard2 = _interopRequireDefault(_foodBenefitCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegationsFormatter = function () {
	  function delegationsFormatter() {
	    (0, _classCallCheck3.default)(this, delegationsFormatter);
	  }
	
	  (0, _createClass3.default)(delegationsFormatter, null, [{
	    key: 'assemble',
	    value: function assemble(data) {
	      var delegationsArray = buildDelegations(data);
	      return delegationsArray;
	    }
	  }]);
	  return delegationsFormatter;
	}();
	
	function buildDelegations(data) {
	  var delegations = [];
	  data.forEach(function (rawDelegation) {
	    rawDelegation.employeeProfile.userId = rawDelegation.employeeProfile.employeeId;
	    var delegation = {
	      profile: rawDelegation.employeeProfile,
	      cards: []
	    };
	
	    for (var key in rawDelegation.foodBenefitPeriods) {
	      var obj = rawDelegation.foodBenefitPeriods[key];
	      obj.id = delegation.profile.employeeId;
	      delegation.cards.push(new _foodBenefitCard2.default(obj));
	    }
	
	    delegations.push(delegation);
	  });
	
	  return delegations;
	}
	
	exports.default = delegationsFormatter;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _foodBenefit = __webpack_require__(1745);
	
	var _managerRepository = __webpack_require__(1751);
	
	var _managerRepository2 = _interopRequireDefault(_managerRepository);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerRepositoryService = function () {
	  managerRepositoryService.$inject = ["$http", "ManagerDataService"];
	  function managerRepositoryService($http, ManagerDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, managerRepositoryService);
	    this.http = $http;
	    this.ManagerDataService = ManagerDataService;
	  }
	
	  (0, _createClass3.default)(managerRepositoryService, [{
	    key: 'getManager',
	    value: function getManager(managerId) {
	      return this.http.get(_foodBenefit.ENDPOINTS_MANAGER.get.initial(managerId)).then(function (response) {
	        return _managerRepository2.default.assemble(response.data);
	      });
	    }
	  }]);
	  return managerRepositoryService;
	}();
	
	exports.default = managerRepositoryService;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _foodBenefitManager = __webpack_require__(1752);
	
	var _foodBenefitManager2 = _interopRequireDefault(_foodBenefitManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var managerDataAssembler = function () {
	  function managerDataAssembler() {
	    (0, _classCallCheck3.default)(this, managerDataAssembler);
	  }
	
	  (0, _createClass3.default)(managerDataAssembler, null, [{
	    key: 'assemble',
	    value: function assemble(data) {
	      var manager = new _foodBenefitManager2.default();
	      manager.profile = {
	        hireDate: data.managerProfile.hireDate,
	        managerId: data.managerProfile.managerId,
	        image: data.managerProfile.image,
	        name: data.managerProfile.name
	      };
	      manager.employeesFoodBenefitPeriods = data.employeesFoodBenefitPeriods;
	      return manager;
	    }
	  }]);
	  return managerDataAssembler;
	}();
	
	exports.default = managerDataAssembler;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodBenefitManager = function foodBenefitManager() {
	  (0, _classCallCheck3.default)(this, foodBenefitManager);
	};
	
	exports.default = foodBenefitManager;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitialDataManagerService = function () {
	  InitialDataManagerService.$inject = ["$http", "AuthenticationService", "$state", "ManagerDataService", "FoodBenefitManagerRepositoryService"];
	  function InitialDataManagerService($http, AuthenticationService, $state, ManagerDataService, FoodBenefitManagerRepositoryService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, InitialDataManagerService);
	    this.$http = $http;
	    this.managerId = AuthenticationService.getEmployeeId();
	    this.managerRepositoryService = FoodBenefitManagerRepositoryService;
	    this.state = $state;
	    this.ManagerDataService = ManagerDataService;
	  }
	
	  (0, _createClass3.default)(InitialDataManagerService, [{
	    key: 'initMainData',
	    value: function initMainData() {
	      var _this = this;
	
	      return this.managerRepositoryService.getManager(this.managerId).then(function (manager) {
	        _this.ManagerDataService.setManager(manager);
	        return manager;
	      }, function () {
	        // TODO: [Manu] este probablemente también sea motivo de error en la APP. Esperamos a confirmación del cliente
	        _this.state.go(_states.STATES.ERROR);
	      });
	    }
	  }]);
	  return InitialDataManagerService;
	}();
	
	exports.default = InitialDataManagerService;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1531);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1534);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1535);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _userDataService = __webpack_require__(567);
	
	var _userDataService2 = _interopRequireDefault(_userDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FoodUserDataService = function (_UserDataService) {
	  (0, _inherits3.default)(FoodUserDataService, _UserDataService);
	
	  function FoodUserDataService() {
	    (0, _classCallCheck3.default)(this, FoodUserDataService);
	    return (0, _possibleConstructorReturn3.default)(this, (FoodUserDataService.__proto__ || (0, _getPrototypeOf2.default)(FoodUserDataService)).call(this));
	  }
	
	  return FoodUserDataService;
	}(_userDataService2.default);
	
	exports.default = FoodUserDataService;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _foodBenefit = __webpack_require__(1745);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FoodBenefitService = function () {
	  FoodBenefitService.$inject = ["FoodBenefitUserDataService", "FoodBenefitInitialDataService", "FoodBenefitInitialDataManagerService", "ManagerDataService", "$http"];
	  function FoodBenefitService(FoodBenefitUserDataService, FoodBenefitInitialDataService, FoodBenefitInitialDataManagerService, ManagerDataService, $http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FoodBenefitService);
	    this.initialDataService = FoodBenefitInitialDataService;
	    this.ManagerDataService = ManagerDataService;
	    this.userDataService = FoodBenefitUserDataService;
	    this.initialDataManagerService = FoodBenefitInitialDataManagerService;
	    this.http = $http;
	    this.loaded = false;
	    this.manager = false;
	  }
	
	  (0, _createClass3.default)(FoodBenefitService, [{
	    key: 'loadData',
	    value: function loadData() {
	      if (!this.userDataService.isEmpty()) {
	        return;
	      }
	
	      this._getDataFromServer();
	    }
	  }, {
	    key: '_getDataFromServer',
	    value: function _getDataFromServer() {
	      var _this = this;
	
	      this.loaded = false;
	
	      this.initialDataService.initMainData().then(function (employee) {
	        if (!employee) return;
	        _this.employee = employee;
	        _this.manager = employee.isManager();
	
	        if (_this.manager || _this.employee.hasManagerDelegation()) _this._loadManagerData();else _this.loaded = true;
	
	        return employee;
	      }, function () {
	        _this.employee = {};
	        _this.manager = false;
	        // TODO: [Manu] eliminado ya que probablemente sea motivo de error en la APP. Ver si en la Web es necesario o con el errorInterceptor es suficiente
	        // this.state.go(STATES.ERROR);
	      });
	    }
	  }, {
	    key: '_loadManagerData',
	    value: function _loadManagerData() {
	      if (!this.ManagerDataService.isEmpty()) {
	        return;
	      }
	
	      this.getManagerDataFromServer();
	    }
	  }, {
	    key: 'getManagerDataFromServer',
	    value: function getManagerDataFromServer() {
	      var _this2 = this;
	
	      this.loaded = false;
	
	      this.initialDataManagerService.initMainData().then(function (manager) {
	        if (!manager) return;
	        _this2.loaded = true;
	        return manager;
	      }, function (err) {
	        _this2.managerData = {};
	        throw err;
	      });
	    }
	  }, {
	    key: 'getManagerDataSync',
	    value: function getManagerDataSync() {
	      return this.initialDataManagerService.initMainData();
	    }
	  }, {
	    key: 'getUserDataSync',
	    value: function getUserDataSync() {
	      return this.initialDataService.initMainData();
	    }
	  }, {
	    key: 'requestFoodBenefits',
	    value: function requestFoodBenefits(periods, employeeId) {
	      return this.http.post(_foodBenefit.ENDPOINTS_EMPLOYEE.post.create(employeeId), periods).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'validateFoodBenefits',
	    value: function validateFoodBenefits(periods, managerId) {
	      var url = _foodBenefit.ENDPOINTS_MANAGER.post.create(managerId);
	      return this.http.put(url, periods).then(function (response) {
	        return response.data;
	      });
	    }
	  }]);
	  return FoodBenefitService;
	}();
	
	exports.default = FoodBenefitService;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(916);
	
	var _constants2 = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PERMISSION = {
	  USER: 'R'
	};
	
	var myFoodBenefitHelper = function () {
	  myFoodBenefitHelper.$inject = ["$translate", "foodDelegationService"];
	  function myFoodBenefitHelper($translate, foodDelegationService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, myFoodBenefitHelper);
	    this.translate = $translate;
	    this.foodDelegationService = foodDelegationService;
	  }
	
	  (0, _createClass3.default)(myFoodBenefitHelper, [{
	    key: 'getApproveAllMessage',
	    value: function getApproveAllMessage() {
	      return this.translate('FOOD_BENEFIT.MODAL_APPROVE_ALL.OK').then(function (translation) {
	        return translation;
	      });
	    }
	  }, {
	    key: 'getEmployeeToFilter',
	    value: function getEmployeeToFilter(employee) {
	      return {
	        employeeId: employee.profile.userId || employee.profile.employeeId,
	        name: employee.profile.name
	      };
	    }
	  }, {
	    key: 'findDelegation',
	    value: function findDelegation(delegationsObject) {
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	      var delegation = this.foodDelegationService.findDelegationActive(today, delegationsObject, PERMISSION.USER);
	      return delegation;
	    }
	  }, {
	    key: 'getOwnEmployee',
	    value: function getOwnEmployee(employees, userId) {
	      var ownEmployee = [];
	      employees.forEach(function (employeeData) {
	        var currentEmployeeId = employeeData.profile.userId;
	        if (currentEmployeeId === userId) ownEmployee.push(employeeData);
	      });
	      return ownEmployee;
	    }
	  }, {
	    key: 'getDelegatedEmployees',
	    value: function getDelegatedEmployees(employees, userId) {
	      var delegatedEmployees = [];
	      employees.forEach(function (employeeData) {
	        var currentEmployeeId = employeeData.profile.userId;
	        if (currentEmployeeId !== userId) delegatedEmployees.push(employeeData);
	      });
	      return delegatedEmployees;
	    }
	  }, {
	    key: 'getModalStateSendAll',
	    value: function getModalStateSendAll() {
	      return _constants.MODAL_STATES.isSendingAllCards;
	    }
	  }, {
	    key: 'checkMoreThanOneModified',
	    value: function checkMoreThanOneModified(modifiedArray) {
	      return modifiedArray.length > 1;
	    }
	  }, {
	    key: 'formatRequest',
	    value: function formatRequest(card) {
	      return {
	        employeeId: card.id,
	        enjoymentDays: card.enjoymentDays,
	        enjoymentMonth: card.enjoymentMonth,
	        enjoymentYear: card.enjoymentYear
	      };
	    }
	  }, {
	    key: 'getModalStateFailed',
	    value: function getModalStateFailed() {
	      return _constants.MODAL_STATES.failed;
	    }
	  }, {
	    key: 'getModalStateApproved',
	    value: function getModalStateApproved() {
	      return _constants.MODAL_STATES.approve;
	    }
	  }, {
	    key: 'getFloatingSendAllButton',
	    value: function getFloatingSendAllButton() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.SEND_ALL'
	      }];
	    }
	  }, {
	    key: 'setCardStateApproved',
	    value: function setCardStateApproved(card, employees) {
	      var newCard = this.findCard(card, employees);
	      var newCardState = newCard.state;
	      newCard.state = _constants2.FOOD_BENEFIT_STATES.success;
	      return newCardState;
	    }
	  }, {
	    key: 'setCardStateFailed',
	    value: function setCardStateFailed(card, employees) {
	      var newCard = this.findCard(card, employees);
	      var newCardState = _constants2.FOOD_BENEFIT_STATES.error;
	      newCard.requestErrorMsg = card.requestErrorMsg;
	      newCard.state = _constants2.FOOD_BENEFIT_STATES.error;
	      return newCardState;
	    }
	  }, {
	    key: 'findCard',
	    value: function findCard(card, employees) {
	      var newCard = undefined;
	      employees.forEach(function (employee) {
	        if (newCard) return;
	        newCard = employee.cards.find(function (searchCard) {
	          return card.id === searchCard.id && card.enjoymentMonth === searchCard.enjoymentMonth;
	        });
	      });
	      return newCard;
	    }
	  }]);
	  return myFoodBenefitHelper;
	}();
	
	exports.default = myFoodBenefitHelper;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _foodDelegation = __webpack_require__(1758);
	
	var _foodDelegation2 = _interopRequireDefault(_foodDelegation);
	
	var _constants = __webpack_require__(916);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var foodDelegationService = function () {
	  foodDelegationService.$inject = ["$http", "DelegationService"];
	  function foodDelegationService($http, DelegationService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, foodDelegationService);
	    this.http = $http;
	    this.delegationService = DelegationService;
	  }
	
	  (0, _createClass3.default)(foodDelegationService, [{
	    key: 'getDelegations',
	    value: function getDelegations(employeeId) {
	      return this.delegationService.getDelegations(employeeId, _constants.MODULE_ID).then(function (response) {
	        return _foodDelegation2.default.assemble(response.data);
	      });
	    }
	  }, {
	    key: 'updateDelegation',
	    value: function updateDelegation(employeeId, delegationToUpdate) {
	      return this.delegationService.updateDelegations(employeeId, delegationToUpdate);
	    }
	  }, {
	    key: 'createDelegation',
	    value: function createDelegation(employeeId, delegationToCreate) {
	      return this.delegationService.createDelegations(employeeId, delegationToCreate);
	    }
	  }, {
	    key: 'deleteDelegation',
	    value: function deleteDelegation(employeeId, delegationToCreate) {
	      return this.delegationService.cancelDelegation(employeeId, delegationToCreate);
	    }
	  }, {
	    key: 'findDelegationActive',
	    value: function findDelegationActive(today, delegations, permission) {
	      var _this = this;
	
	      var delegationToReturn = delegations.find(function (delegation) {
	        return _this._checkDataDelegation(delegation, today, permission);
	      });
	
	      return delegationToReturn !== undefined ? delegationToReturn : {};
	    }
	  }, {
	    key: '_checkDataDelegation',
	    value: function _checkDataDelegation(delegation, today, permission) {
	      var endDateSmaller = today <= delegation.endDate;
	      var startDateGreater = today >= delegation.startDate;
	      var isTypePermission = permission !== undefined ? delegation.type === permission : true;
	      return endDateSmaller && startDateGreater && isTypePermission;
	    }
	  }]);
	  return foodDelegationService;
	}();
	
	exports.default = foodDelegationService;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _delegations = __webpack_require__(1759);
	
	var _delegations2 = _interopRequireDefault(_delegations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var delegationDataAssembler = function () {
	  function delegationDataAssembler() {
	    (0, _classCallCheck3.default)(this, delegationDataAssembler);
	  }
	
	  (0, _createClass3.default)(delegationDataAssembler, null, [{
	    key: 'assemble',
	    value: function assemble(dataArray) {
	      var delegations = [];
	      dataArray.delegations.forEach(function (data) {
	        var delegation = new _delegations2.default();
	        delegation.startDate = data.startDate || '';
	        delegation.endDate = data.endDate || '';
	        delegation.employeeId = data.employeeId || '';
	        delegation.name = data.name || '';
	        delegation.email = data.email || '';
	        delegation.isNotified = data.isNotified || false;
	        delegation.type = data.type || '';
	        delegation.id = data.id || '';
	        delegations.push(delegation);
	      });
	      return delegations;
	    }
	  }]);
	  return delegationDataAssembler;
	}();
	
	exports.default = delegationDataAssembler;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1531);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1534);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1535);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _delegations = __webpack_require__(1555);
	
	var _delegations2 = _interopRequireDefault(_delegations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FoodBenefitDelegations = function (_Delegations) {
	  (0, _inherits3.default)(FoodBenefitDelegations, _Delegations);
	
	  function FoodBenefitDelegations() {
	    (0, _classCallCheck3.default)(this, FoodBenefitDelegations);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FoodBenefitDelegations.__proto__ || (0, _getPrototypeOf2.default)(FoodBenefitDelegations)).call(this));
	
	    _this.type = '';
	    return _this;
	  }
	
	  (0, _createClass3.default)(FoodBenefitDelegations, [{
	    key: 'getType',
	    value: function getType() {
	      return this.type;
	    }
	  }]);
	  return FoodBenefitDelegations;
	}(_delegations2.default);
	
	exports.default = FoodBenefitDelegations;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loans = __webpack_require__(1761);
	
	var _loans2 = _interopRequireDefault(_loans);
	
	var _loans3 = __webpack_require__(2147);
	
	var _loans4 = _interopRequireDefault(_loans3);
	
	var _loans5 = __webpack_require__(2176);
	
	var _loans6 = _interopRequireDefault(_loans5);
	
	var _loans7 = __webpack_require__(2199);
	
	var _loans8 = _interopRequireDefault(_loans7);
	
	var _angularToastr = __webpack_require__(540);
	
	var _angularToastr2 = _interopRequireDefault(_angularToastr);
	
	var _toastUtils = __webpack_require__(1560);
	
	var _toastUtils2 = _interopRequireDefault(_toastUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansModule = angular.module('loans', [_loans6.default, _loans2.default, _loans4.default, _angularToastr2.default]).config(["$translatePartialLoaderProvider", "toastrConfig", "$windowProvider", function ($translatePartialLoaderProvider, toastrConfig, $windowProvider) {
	  'ngInject';
	
	  _toastUtils2.default.setGlobalConfig(toastrConfig, $windowProvider.$get().isMobileApp);
	  $translatePartialLoaderProvider.addPart('loans.module');
	}]).service('loansService', _loans8.default).name;
	
	exports.default = loansModule;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansRouting = __webpack_require__(1762);
	
	var _loansRouting2 = _interopRequireDefault(_loansRouting);
	
	var _creditworthiness = __webpack_require__(1769);
	
	var _creditworthiness2 = _interopRequireDefault(_creditworthiness);
	
	var _loansCatalog = __webpack_require__(1800);
	
	var _loansCatalog2 = _interopRequireDefault(_loansCatalog);
	
	var _loansDetail = __webpack_require__(1818);
	
	var _loansDetail2 = _interopRequireDefault(_loansDetail);
	
	var _loansSignUp = __webpack_require__(1888);
	
	var _loansSignUp2 = _interopRequireDefault(_loansSignUp);
	
	var _myLoans = __webpack_require__(1950);
	
	var _myLoans2 = _interopRequireDefault(_myLoans);
	
	var _loansRepayment = __webpack_require__(2030);
	
	var _loansRepayment2 = _interopRequireDefault(_loansRepayment);
	
	var _needALoan = __webpack_require__(2061);
	
	var _needALoan2 = _interopRequireDefault(_needALoan);
	
	var _wageAdvance = __webpack_require__(2104);
	
	var _wageAdvance2 = _interopRequireDefault(_wageAdvance);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansFeatures = angular.module('loans.features', [_loansRouting2.default, _creditworthiness2.default, _loansCatalog2.default, _loansDetail2.default, _loansSignUp2.default, _myLoans2.default, _loansRepayment2.default, _needALoan2.default, _wageAdvance2.default]).name;
	
	exports.default = loansFeatures;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansRouting = __webpack_require__(1763);
	
	var _loansRouting2 = _interopRequireDefault(_loansRouting);
	
	var _loansRouting3 = __webpack_require__(1768);
	
	var _loansRouting4 = _interopRequireDefault(_loansRouting3);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRoutingModule = angular.module('loans.routing', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.ROOT, {
	    abstract: true,
	    parent: _states.STATES.MAIN_ROUTING,
	    url: _routes.ROUTES.LOANS.ROOT,
	    component: 'loansRouting',
	    params: {
	      goWageAdvance: null
	    },
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      moduleClosed: ["StatusAppCheckers", function moduleClosed(StatusAppCheckers) {
	        return StatusAppCheckers.getClosedModules();
	      }]
	    }
	  });
	}]).component('loansRouting', _loansRouting2.default).service('loansRoutingService', _loansRouting4.default).name;
	
	exports.default = loansRoutingModule;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansRouting = __webpack_require__(1764);
	
	var _loansRouting2 = _interopRequireDefault(_loansRouting);
	
	var _loansRouting3 = __webpack_require__(1765);
	
	var _loansRouting4 = _interopRequireDefault(_loansRouting3);
	
	__webpack_require__(1766);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRoutingComponent = {
	  restrict: 'E',
	  bindings: {
	    moduleClosed: '<'
	  },
	  template: _loansRouting2.default,
	  controller: _loansRouting4.default
	};
	
	exports.default = loansRoutingComponent;

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

	module.exports = "<main-menu ng-if=\"$ctrl.showMenu()\" ng-class=\"$ctrl.getCssMenu()\" links=\"$ctrl.links\"></main-menu>\n\n<main-menu-mobile ng-if=\"$ctrl.showMenuMobile()\" links=\"$ctrl.links\" employee-info=\"$ctrl.employee\" show-links=\"$ctrl.showMobileLinks()\"></main-menu-mobile>\n\n<div ng-if=\"$ctrl.isLoaded\" ui-view></div>\n"

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansRoutingController = function () {
	  LoansRoutingController.$inject = ["loansService", "$scope", "$state", "$translate", "$rootScope", "$window", "$stateParams", "$log", "LoansUserDataService", "loansMenuService", "toastr", "LoansNeedALoanService", "metricsService", "cookieService"];
	  function LoansRoutingController(loansService, $scope, $state, $translate, $rootScope, $window, $stateParams, $log, LoansUserDataService, loansMenuService, toastr, LoansNeedALoanService, metricsService, cookieService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansRoutingController);
	    this.scope = $scope;
	    this.state = $state;
	    this.translate = $translate;
	    this.rootScope = $rootScope;
	    this.stateParams = $stateParams;
	    this.log = $log;
	
	    this.loansUserDataService = LoansUserDataService;
	    this.loansService = loansService;
	    this.loansMenuService = loansMenuService;
	    this.toastr = toastr;
	    this.loansNeedALoanService = LoansNeedALoanService;
	    this.metricsService = metricsService;
	    this.cookieService = cookieService;
	
	    this.isMobileApp = $window.innerWidth < 1024;
	
	    this.isLoaded = false;
	    this.hasLoansAccess = true;
	  }
	
	  (0, _createClass3.default)(LoansRoutingController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (this.isModuleClosed()) {
	        return;
	      }
	
	      this.loansService.loadEmployeeProfileInfoAndData();
	      this._checkServiceClosed();
	
	      this.metricsService.init();
	
	      this.rootScope.$on(_constants.EVENTS.WITHOUT_LOANS_ACCESS, function () {
	        _this.hasLoansAccess = false;
	      });
	
	      this.scope.$watch(function () {
	        return _this.loansService.loaded;
	      }, function (newValue) {
	        if (newValue) {
	          _this.log.info('loansService loaded');
	          _this.isLoaded = true;
	          _this.employee = _this.loansUserDataService.getEmployee();
	          _this._initLinks();
	          _this.rootScope.$on('$locationChangeSuccess', function () {
	            return _this._checkServiceClosed();
	          });
	        }
	      });
	    }
	  }, {
	    key: '_checkServiceClosed',
	    value: function _checkServiceClosed() {
	      var _this2 = this;
	
	      if (!this.moduleClosed.serviceClosed) {
	        return;
	      }
	      this._translateTextToToast().then(function () {
	        _this2._showOrHideToastr();
	      });
	    }
	  }, {
	    key: 'getCssMenu',
	    value: function getCssMenu() {
	      return {
	        'no-border': this._linkHasNotMenuBorder()
	      };
	    }
	  }, {
	    key: '_initLinks',
	    value: function _initLinks() {
	      var _this3 = this;
	
	      this.links = this.loansMenuService.getLinks();
	
	      this.links.forEach(function (link) {
	        link.onClick = function () {
	          _this3.loansNeedALoanService.clearAllDataSimulation();
	        };
	      });
	    }
	  }, {
	    key: '_showOrHideToastr',
	    value: function _showOrHideToastr() {
	      var isPortalSenior = this.cookieService.get('isPortalSenior');
	
	      if (isPortalSenior === 'true') {
	        return;
	      }
	      var toastElement = angular.element('.toast-container');
	      var currentName = this.state.current.name;
	      var isWageAdvance = _states.STATES.LOANS.WAGE_ADVANCE === currentName;
	      var isHiddenToastr = toastElement.is(':visible') ? false : true;
	
	      if (!isWageAdvance && isHiddenToastr) {
	        this.toastr.error(this.textToast, this.titleToast);
	        toastElement.fadeIn();
	      }
	
	      if (isWageAdvance) {
	        toastElement.fadeOut();
	      }
	    }
	  }, {
	    key: '_translateTextToToast',
	    value: function _translateTextToToast() {
	      var _this4 = this;
	
	      this.translate('GLOBALS.WARNING_TITLE').then(function (translation) {
	        _this4.titleToast = translation.$$unwrapTrustedValue();
	      });
	      return this.translate('GLOBALS.READ_ONLY_WAGE_IN_PROCESS').then(function (translation) {
	        _this4.textToast = translation.$$unwrapTrustedValue();
	      });
	    }
	  }, {
	    key: '_linkHasNotMenuBorder',
	    value: function _linkHasNotMenuBorder() {
	      var _this5 = this;
	
	      var currentLinkHasMenuBorder = function currentLinkHasMenuBorder(link) {
	        return link.target === _this5.state.current.name && link.hasMenuBorder;
	      };
	
	      var stateIsDetail = this.state.current.name === _states.STATES.LOANS.DETAIL;
	      var stateIsSignUp = this.state.current.name === _states.STATES.LOANS.SIGN_UP;
	
	      return this.links && this.links.some(currentLinkHasMenuBorder) || stateIsDetail || stateIsSignUp;
	    }
	  }, {
	    key: 'isModuleClosed',
	    value: function isModuleClosed() {
	      var hasToGoWageAdvance = this.stateParams.goWageAdvance;
	
	      if (hasToGoWageAdvance) {
	        this.goToWageAdvanceWithoutLoansAccess();
	        return;
	      }
	
	      var isLoansAndWageAdvanceClosedWithMessage = this.moduleClosed.isLoansClosed && this.moduleClosed.loansClosedMessage && this.isWageAdvanceClosed;
	      var isLoansAndWageAdvanceClosedWithoutMessage = this.moduleClosed.isLoansClosed && this.isWageAdvanceClosed;
	      var isLoansClosedAndWageOpen = this.moduleClosed.isLoansClosed && !this.isWageAdvanceClosed;
	
	      if (isLoansAndWageAdvanceClosedWithMessage) {
	        this.goToErrorAndShowHRMessage();
	        return true;
	      }
	
	      if (isLoansAndWageAdvanceClosedWithoutMessage) {
	        this.goToErrorWithoutMessage();
	        return true;
	      }
	
	      if (isLoansClosedAndWageOpen) {
	        this.goToErrorWithLinkToWage();
	      }
	      return false;
	    }
	  }, {
	    key: 'goToErrorAndShowHRMessage',
	    value: function goToErrorAndShowHRMessage() {
	      this.state.go(_states.STATES.ERROR, {
	        stateName: _constants.PAGE_ERROR.CLOSED,
	        errorMessage: this.moduleClosed.loansClosedMessage
	      });
	    }
	  }, {
	    key: 'goToErrorWithoutMessage',
	    value: function goToErrorWithoutMessage() {
	      this.state.go(_states.STATES.ERROR, { stateName: _constants.PAGE_ERROR.CLOSED });
	    }
	  }, {
	    key: 'goToErrorWithLinkToWage',
	    value: function goToErrorWithLinkToWage() {
	      this.state.go(_states.STATES.ERROR, {
	        stateName: _constants.PAGE_ERROR.CLOSED,
	        stateRedirection: this.moduleClosed.isWageAdvanceClosed
	      });
	    }
	  }, {
	    key: 'goToWageAdvanceWithoutLoansAccess',
	    value: function goToWageAdvanceWithoutLoansAccess() {
	      if (this.loansUserDataService.getSenior()) {
	        this.state.go(_states.STATES.ERROR, {
	          stateName: _constants.PAGE_ERROR.LOANS_CLOSED_TO_USER_WITHOUT_CREDITWORTHINESS
	        });
	      } else {
	        this.state.go(_states.STATES.LOANS.WAGE_ADVANCE, {
	          stateAccess: _constants.EVENTS.WITHOUT_LOANS_ACCESS
	        });
	      }
	    }
	  }, {
	    key: 'showMenu',
	    value: function showMenu() {
	      return !this.isMobileApp && this.hasLoansAccess;
	    }
	  }, {
	    key: 'showMobileLinks',
	    value: function showMobileLinks() {
	      return this.isMobileApp && this.hasLoansAccess;
	    }
	  }, {
	    key: 'showMenuMobile',
	    value: function showMenuMobile() {
	      return this.isMobileApp && this.isLoaded && this.links;
	    }
	  }]);
	  return LoansRoutingController;
	}();
	
	exports.default = LoansRoutingController;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1767);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansRouting.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansRouting.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansRoutingService = function LoansRoutingService($transitions) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, LoansRoutingService);
	  this.transitions = $transitions;
	};
	LoansRoutingService.$inject = ["$transitions"];
	
	exports.default = LoansRoutingService;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _creditworthiness = __webpack_require__(1770);
	
	var _creditworthiness2 = _interopRequireDefault(_creditworthiness);
	
	var _creditworthinessCard = __webpack_require__(1777);
	
	var _creditworthinessCard2 = _interopRequireDefault(_creditworthinessCard);
	
	var _creditworthinessMoreInfo = __webpack_require__(1782);
	
	var _creditworthinessMoreInfo2 = _interopRequireDefault(_creditworthinessMoreInfo);
	
	var _creditworthinessOfLoan = __webpack_require__(1788);
	
	var _creditworthinessOfLoan2 = _interopRequireDefault(_creditworthinessOfLoan);
	
	var _creditworthinessMobileHeader = __webpack_require__(1794);
	
	var _creditworthinessMobileHeader2 = _interopRequireDefault(_creditworthinessMobileHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditworthinessModule = _angular2.default.module('creditworthiness', [_angularUiRouter2.default, _creditworthinessMoreInfo2.default, _creditworthinessCard2.default, _creditworthinessOfLoan2.default, _creditworthinessMobileHeader2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.CREDITWORTHINESS, {
	    url: _routes.ROUTES.LOANS.CREDITWORTHINESS,
	    component: 'creditworthiness',
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      serviceClosed: ["StatusAppCheckers", function serviceClosed(StatusAppCheckers) {
	        return StatusAppCheckers.isServiceClosed();
	      }]
	    }
	  });
	}]).component('creditworthiness', _creditworthiness2.default).name;
	
	exports.default = creditworthinessModule;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _creditworthiness = __webpack_require__(1771);
	
	var _creditworthiness2 = _interopRequireDefault(_creditworthiness);
	
	var _creditworthiness3 = __webpack_require__(1772);
	
	var _creditworthiness4 = _interopRequireDefault(_creditworthiness3);
	
	__webpack_require__(1775);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditworthinessComponent = {
	  restrict: 'E',
	  bindings: {
	    serviceClosed: '<'
	  },
	  template: _creditworthiness2.default,
	  controller: _creditworthiness4.default
	};
	
	exports.default = creditworthinessComponent;

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd\" ng-class=\"$ctrl.getClasses()\">\n\n  <section ng-if=\"$ctrl.showLoading()\">\n    <loading></loading>\n  </section>\n\n  <section ng-if=\"$ctrl.loaded\" class=\"animation-appear\">\n\n    <modal-coachmark\n      ng-if=\"!$ctrl.isMobileApp\"\n      data=\"$ctrl.coachmarkData\"\n      user-id=\"$ctrl.userId\">\n    </modal-coachmark>\n\n    <loans-header\n      title=\"{{ 'LOANS.CREDITWORTHINESS.TITLE' | translate }}\"\n      ng-if=\"!$ctrl.isMobileApp\">\n      <a ng-click=\"$ctrl.goToNeedALoan()\" class=\"btn btn-app btn-default\">\n        {{ 'LOANS.CREDITWORTHINESS.ASK_FOR_LOAN' | translate }}\n      </a>\n    </loans-header>\n\n    <section-title\n      text=\"{{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TITLE' | translate }}\"\n      ng-if=\"!$ctrl.isMobileApp\">\n    </section-title>\n\n    <p class=\"creditworthiness-description\" \n    ng-if=\"!$ctrl.isMobileApp && $ctrl.creditworthiness.simulationWitness\">\n      {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.DESCRIPTION' | translate }}\n      <a href=\"\" ng-click=\"$ctrl.goToNeedALoan()\">\n        {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.LINK_TEXT' | translate }}\n      </a>.\n    </p>\n\n    <p class=\"creditworthiness-description creditworthiness-mobile\" \n    ng-if=\"$ctrl.isMobileApp && $ctrl.creditworthiness.simulationWitness\">\n      {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.DESCRIPTION' | translate }}\n      <a href=\"\" ng-click=\"$ctrl.goToNeedALoan()\">\n        {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.LINK_TEXT' | translate }}\n      </a>.\n    </p>\n\n    <table-app data=\"$ctrl.data.tableData\" ng-if=\"!$ctrl.isMobileApp\">\n    </table-app>\n\n    <p class=\"creditworthiness-disclaimer\" \n    ng-if=\"!$ctrl.isMobileApp && $ctrl.creditworthiness.simulationWitness\">\n      {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.DISCLAIMER' | translate }}\n      <a href=\"\" ng-click=\"$ctrl.goToNeedALoan()\">\n        {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.LINK_TEXT' | translate }}\n      </a>.\n    </p>\n\n    <creditworthiness-mobile-header\n      ng-if=\"$ctrl.isMobileApp\">\n    </creditworthiness-mobile-header>\n\n    <creditworthiness-of-loan\n      ng-if=\"$ctrl.isMobileApp\"\n      ng-repeat=\"loan in $ctrl.data.creditworthinessOfLoans\"\n      loan=\"loan\">\n    </creditworthiness-of-loan>\n\n    <p class=\"creditworthiness-disclaimer creditworthiness-mobile\" \n    ng-if=\"$ctrl.isMobileApp && $ctrl.creditworthiness.simulationWitness\">\n      {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.DISCLAIMER' | translate }}\n      <a href=\"\" ng-click=\"$ctrl.goToNeedALoan()\">\n        {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.LINK_TEXT' | translate }}\n      </a>.\n    </p>\n\n    <section-title\n      class=\"second\"\n      text=\"{{ 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.TITLE' | translate }}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </section-title>\n\n    <creditworthiness-card\n      ng-repeat=\"card in $ctrl.data.cardsData track by $index\"\n      ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n      information=\"card\">\n    </creditworthiness-card>\n\n    <section-title\n      class=\"second\"\n      text=\"{{ 'LOANS.CREDITWORTHINESS.MORE_INFO.TITLE' | translate }}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </section-title>\n\n    <creditworthiness-more-info\n      ng-repeat=\"moreInfo in $ctrl.data.moreInfoData track by $index\"\n      ng-class=\"{ 'mobile': $ctrl.isMobileApp , 'first-item': $first}\"\n      information=\"moreInfo\">\n    </creditworthiness-more-info>\n\n    <div class=\"creditworthiness-end-button\" ng-if=\"!$ctrl.isMobileApp\">\n      <a ng-click=\"$ctrl.goToNeedALoan()\" class=\"btn btn-app btn-primary pull-right\">\n        {{ 'LOANS.CREDITWORTHINESS.ASK_FOR_LOAN' | translate }}\n      </a>\n    </div>\n\n    <floating-action-buttons\n      ng-if=\"$ctrl.isMobileApp\"\n      buttons=\"$ctrl.floatingActionButtons\"\n      on-click-first-button=\"$ctrl.goToNeedALoan()\">\n    </floating-action-buttons>\n\n  </section>\n\n</div>\n"

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	var _creditworthiness = __webpack_require__(1773);
	
	var _creditworthiness2 = _interopRequireDefault(_creditworthiness);
	
	var _constants = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreditWorthinessController = function () {
	  CreditWorthinessController.$inject = ["$state", "$log", "LoansUserDataService", "LoansOperationsService", "$window", "loadingMobileService"];
	  function CreditWorthinessController($state, $log, LoansUserDataService, LoansOperationsService, $window, loadingMobileService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CreditWorthinessController);
	    this.state = $state;
	    this.log = $log;
	    this.loansUserDataService = LoansUserDataService;
	    this.loansOperationsService = LoansOperationsService;
	    this.loadingMobileService = loadingMobileService;
	
	    this.userId = this.loansUserDataService._employee.userId;
	    this.coachmarkData = _constants.LOANS_CREDITWORTHINESS_MODAL_COACHMARK_CONFIG;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.init();
	  }
	
	  (0, _createClass3.default)(CreditWorthinessController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.initFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.loadingMobileService.show();
	      this.loansOperationsService.getCreditworthiness(this.userId).then(function (creditworthiness) {
	        _this.creditworthiness = creditworthiness;
	        _this.data = new _creditworthiness2.default(creditworthiness, creditworthiness.simulationWitness).format();
	        _this.loaded = true;
	      }, function (error) {
	        _this.log.error('CreditWorthinessController init()', error);
	        // TODO: [Manu] eliminado ya que probablemente sea motivo de error en la APP. Ver si en la Web es necesario o con el errorInterceptor es suficiente
	        // this.state.go(STATES.ERROR);
	      }).finally(function () {
	        _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        'responsiveMobile': this.isMobileApp,
	        'with-floating-action-buttons': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'goToNeedALoan',
	    value: function goToNeedALoan() {
	      if (this.serviceClosed) {
	        return;
	      }
	
	      this.state.go(_states.STATES.LOANS.NEED_A_LOAN);
	    }
	  }, {
	    key: 'initFloatingActionButtons',
	    value: function initFloatingActionButtons() {
	      this.floatingActionButtons = [{
	        literal: 'LOANS.CREDITWORTHINESS.ASK_FOR_LOAN',
	        disabled: this.serviceClosed
	      }];
	    }
	  }, {
	    key: 'showLoading',
	    value: function showLoading() {
	      return !this.loaded && !this.isMobileApp;
	    }
	  }]);
	  return CreditWorthinessController;
	}();
	
	exports.default = CreditWorthinessController;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreditWorthinessFormatter = function () {
	  function CreditWorthinessFormatter(rawData, simulationWitness) {
	    (0, _classCallCheck3.default)(this, CreditWorthinessFormatter);
	
	    this._rawData = rawData;
	    this.simulationWitness = simulationWitness;
	  }
	
	  (0, _createClass3.default)(CreditWorthinessFormatter, [{
	    key: '_formatCurrency',
	    value: function _formatCurrency(value) {
	      return new Intl.NumberFormat('es-ES', {
	        style: 'currency',
	        currency: 'EUR'
	      }).format(value);
	    }
	  }, {
	    key: 'format',
	    value: function format() {
	      var cardsData = this._getCardsData();
	      var moreInfoData = this._getMoreInfoData();
	      var tableData = this._getTableData();
	      var creditworthinessOfLoans = this._getCreditworthinessOfLoans();
	      return { tableData: tableData, cardsData: cardsData, moreInfoData: moreInfoData, creditworthinessOfLoans: creditworthinessOfLoans };
	    }
	  }, {
	    key: '_getCardsData',
	    value: function _getCardsData() {
	      return [{
	        title: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.MAX_MONTH_FEE.TITLE',
	        subtitle: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.MAX_MONTH_FEE.SUBTITLE',
	        description: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.MAX_MONTH_FEE.DESC',
	        amount: this._rawData.maximumMonthFee
	      }, {
	        title: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_OBLIGATIONS.TITLE',
	        subtitle: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_OBLIGATIONS.SUBTITLE',
	        description: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_OBLIGATIONS.DESC',
	        amount: this._rawData.yourObligations
	      }, {
	        title: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_REAL_CAPACITY.TITLE',
	        subtitle: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_REAL_CAPACITY.SUBTITLE',
	        description: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_REAL_CAPACITY.DESC',
	        amount: this._rawData.yourRealCapacity
	      }];
	    }
	  }, {
	    key: '_getMoreInfoData',
	    value: function _getMoreInfoData() {
	      return [{
	        title: 'LOANS.CREDITWORTHINESS.MORE_INFO.ABOUT_CREDITWORTHINESS.SUBTITLE',
	        information: ['LOANS.CREDITWORTHINESS.MORE_INFO.ABOUT_CREDITWORTHINESS.DESCRIPTION1', 'LOANS.CREDITWORTHINESS.MORE_INFO.ABOUT_CREDITWORTHINESS.DESCRIPTION2']
	      }, {
	        title: 'LOANS.CREDITWORTHINESS.MORE_INFO.FACTORS_CREDITWORTHINESS.SUBTITLE',
	        information: ['LOANS.CREDITWORTHINESS.MORE_INFO.FACTORS_CREDITWORTHINESS.DESCRIPTION1', 'LOANS.CREDITWORTHINESS.MORE_INFO.FACTORS_CREDITWORTHINESS.DESCRIPTION2']
	      }, {
	        title: 'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.SUBTITLE',
	        information: ['LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION1', 'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION2', 'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION3', 'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION4']
	      }];
	    }
	  }, {
	    key: '_getTableData',
	    value: function _getTableData() {
	      var headers = this._getTableHeaders();
	      var rows = this._getTableRows();
	      return { headers: headers, rows: rows };
	    }
	  }, {
	    key: '_getTableHeaders',
	    value: function _getTableHeaders() {
	      return [{
	        text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.TYPE',
	        width: 273,
	        translate: true
	      }, {
	        text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT',
	        width: 198,
	        translate: true,
	        tooltip: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_TOOLTIP'
	      }, {
	        text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITHOUT_INSURANCE',
	        width: 264,
	        translate: true,
	        tooltip: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITHOUT_INSURANCE_TOOLTIP'
	      }, {
	        text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITH_INSURANCE',
	        width: 329,
	        translate: true,
	        tooltip: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITH_INSURANCE_TOOLTIP'
	      }];
	    }
	  }, {
	    key: '_getTableRows',
	    value: function _getTableRows() {
	      var rows = [];
	
	      var _rawData = this._rawData,
	          fiveMonth = _rawData.fiveMonth,
	          nineMonth = _rawData.nineMonth,
	          variousCredit = _rawData.variousCredit,
	          socialHousingLoan = _rawData.socialHousingLoan,
	          agreementHousingLoan = _rawData.agreementHousingLoan,
	          socialHousingLoanFixed = _rawData.socialHousingLoanFixed,
	          agreementHousingLoanFixed = _rawData.agreementHousingLoanFixed,
	          diversalAtention = _rawData.diversalAtention;
	
	
	      if (fiveMonth) {
	        rows.push([{
	          text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS',
	          translate: true
	        }, { text: fiveMonth.maximumLimit, currency: true }, { text: fiveMonth.realWithoutInsuranceLimit, currency: true }, { text: fiveMonth.realWithInsuranceLimit, currency: true }]);
	      }
	
	      if (nineMonth) {
	        rows.push([{
	          text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS',
	          translate: true
	        }, { text: nineMonth.maximumLimit, currency: true }, { text: nineMonth.realWithoutInsuranceLimit, currency: true }, { text: nineMonth.realWithInsuranceLimit, currency: true }]);
	      }
	
	      if (variousCredit) {
	        rows.push([{
	          text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.VARIOUS_CREDIT',
	          translate: true
	        }, { text: variousCredit.maximumLimit, currency: true }, { text: variousCredit.realWithoutInsuranceLimit, currency: true }, { text: variousCredit.realWithInsuranceLimit, currency: true }]);
	      }
	
	      if (diversalAtention) {
	        rows.push([{
	          text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.DIVERSAL_ATENTION',
	          translate: true
	        }, { text: diversalAtention.maximumLimit, currency: true }, { text: diversalAtention.realWithoutInsuranceLimit, currency: true }, { text: diversalAtention.realWithInsuranceLimit, currency: true }]);
	      }
	
	      if (socialHousingLoan) {
	        rows.push([{
	          text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_VARIABLE',
	          translate: true
	        }, { text: socialHousingLoan.maximumLimit, currency: true }, { text: 'N/A', currency: false }, {
	          text: this.simulationWitness ? this._formatCurrency(socialHousingLoan.realWithInsuranceLimit) + ' *' : socialHousingLoan.realWithInsuranceLimit,
	          currency: !this.simulationWitness
	        }]);
	      }
	
	      if (socialHousingLoanFixed) {
	        rows.push([{
	          text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_FIXED',
	          translate: true
	        }, { text: socialHousingLoanFixed.maximumLimit, currency: true }, { text: 'N/A', currency: false }, {
	          text: this.simulationWitness ? this._formatCurrency(socialHousingLoanFixed.realWithInsuranceLimit) + ' *' : socialHousingLoanFixed.realWithInsuranceLimit,
	          currency: !this.simulationWitness
	        }]);
	      }
	
	      if (agreementHousingLoan) {
	        rows.push([{
	          text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_VARIABLE',
	          translate: true
	        }, { text: agreementHousingLoan.maximumLimit, currency: true }, { text: 'N/A', currency: false }, {
	          text: this.simulationWitness ? this._formatCurrency(agreementHousingLoan.realWithInsuranceLimit) + ' *' : agreementHousingLoan.realWithInsuranceLimit,
	          currency: !this.simulationWitness
	        }]);
	      }
	
	      if (agreementHousingLoanFixed) {
	        rows.push([{
	          text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_FIXED',
	          translate: true
	        }, { text: agreementHousingLoanFixed.maximumLimit, currency: true }, { text: 'N/A', currency: false }, {
	          text: this.simulationWitness ? this._formatCurrency(agreementHousingLoanFixed.realWithInsuranceLimit) + ' *' : agreementHousingLoanFixed.realWithInsuranceLimit,
	          currency: !this.simulationWitness
	        }]);
	      }
	
	      return rows;
	    }
	  }, {
	    key: '_getCreditworthinessOfLoans',
	    value: function _getCreditworthinessOfLoans() {
	      var _this = this;
	
	      var rows = [];
	      var _rawData2 = this._rawData,
	          fiveMonth = _rawData2.fiveMonth,
	          nineMonth = _rawData2.nineMonth,
	          variousCredit = _rawData2.variousCredit,
	          socialHousingLoan = _rawData2.socialHousingLoan,
	          agreementHousingLoan = _rawData2.agreementHousingLoan,
	          socialHousingLoanFixed = _rawData2.socialHousingLoanFixed,
	          agreementHousingLoanFixed = _rawData2.agreementHousingLoanFixed,
	          diversalAtention = _rawData2.diversalAtention;
	
	
	      if (fiveMonth) {
	        rows.push({
	          loanName: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS',
	          maximumLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT',
	          maximumLimit: fiveMonth.maximumLimit,
	          realWithoutInsuranceLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITHOUT_INSURANCE',
	          realWithoutInsuranceLimit: fiveMonth.realWithoutInsuranceLimit,
	          realWithInsuranceLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITH_INSURANCE',
	          realWithInsuranceLimit: fiveMonth.realWithInsuranceLimit,
	          hasAsterisk: false
	        });
	      }
	
	      if (nineMonth) {
	        rows.push({
	          loanName: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS',
	          maximumLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT',
	          maximumLimit: nineMonth.maximumLimit,
	          realWithoutInsuranceLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITHOUT_INSURANCE',
	          realWithoutInsuranceLimit: nineMonth.realWithoutInsuranceLimit,
	          realWithInsuranceLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITH_INSURANCE',
	          realWithInsuranceLimit: nineMonth.realWithInsuranceLimit,
	          hasAsterisk: false
	        });
	      }
	
	      if (variousCredit) {
	        rows.push({
	          loanName: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.VARIOUS_CREDIT',
	          maximumLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT',
	          maximumLimit: variousCredit.maximumLimit,
	          realWithoutInsuranceLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITHOUT_INSURANCE',
	          realWithoutInsuranceLimit: variousCredit.realWithoutInsuranceLimit,
	          realWithInsuranceLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITH_INSURANCE',
	          realWithInsuranceLimit: variousCredit.realWithInsuranceLimit,
	          hasAsterisk: false
	        });
	      }
	
	      if (diversalAtention) {
	        rows.push({
	          loanName: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.DIVERSAL_ATENTION',
	          maximumLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT',
	          maximumLimit: diversalAtention.maximumLimit,
	          realWithoutInsuranceLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITHOUT_INSURANCE',
	          realWithoutInsuranceLimit: diversalAtention.realWithoutInsuranceLimit,
	          realWithInsuranceLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITH_INSURANCE',
	          realWithInsuranceLimit: diversalAtention.realWithInsuranceLimit,
	          hasAsterisk: false
	        });
	      }
	
	      var formatValueIfZeroNA = function formatValueIfZeroNA(value) {
	        return value === 0 ? 'N/A' : value;
	      };
	
	      var addHousingRow = function addHousingRow(loan, name) {
	        rows.push({
	          loanName: name,
	          maximumLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT',
	          maximumLimit: formatValueIfZeroNA(loan.maximumLimit),
	          realWithoutInsuranceLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITHOUT_INSURANCE',
	          realWithoutInsuranceLimit: formatValueIfZeroNA(loan.realWithoutInsuranceLimit),
	          realWithInsuranceLimitLiteral: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITH_INSURANCE',
	          realWithInsuranceLimit: loan.realWithInsuranceLimit,
	          hasAsterisk: _this.simulationWitness
	        });
	      };
	
	      if (socialHousingLoan) {
	        addHousingRow(socialHousingLoan, 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_VARIABLE');
	      }
	      if (socialHousingLoanFixed) {
	        addHousingRow(socialHousingLoanFixed, 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_FIXED');
	      }
	      if (agreementHousingLoan) {
	        addHousingRow(agreementHousingLoan, 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_VARIABLE');
	      }
	      if (agreementHousingLoanFixed) {
	        addHousingRow(agreementHousingLoanFixed, 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_FIXED');
	      }
	
	      return rows;
	    }
	  }]);
	  return CreditWorthinessFormatter;
	}();
	
	exports.default = CreditWorthinessFormatter;

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOANS = {
	  ID: {
	    FIVE_MONTH: 'fiveMonth',
	    NINE_MONTH: 'nineMonth',
	    SOCIAL_HOUSING_LOAN: 'socialHousingLoan',
	    AGREEMENT_HOUSING_LOAN: 'agreementHousingLoan',
	    SOCIAL_HOUSING_LOAN_FIXED: 'socialHousingLoanFixed',
	    AGREEMENT_HOUSING_LOAN_FIXED: 'agreementHousingLoanFixed',
	    VARIOUS_CREDIT: 'variousCredit',
	    DIVERSAL_ATENTION: 'diversalAtention',
	    ISADHESIVO: 'isAdhesivo'
	  },
	  ID_HR: {
	    FIVE_MONTH: '5S',
	    NINE_MONTH: '9S',
	    SOCIAL_HOUSING_LOAN: 'SV',
	    AGREEMENT_HOUSING_LOAN: 'VC',
	    VARIOUS_CREDIT: 'CV',
	    DIVERSAL_ATENTION: 'AD',
	    HOUSING_MANDATORY_PURPOSE: '09',
	    ISADHESIVO: 'isAdhesivo'
	  },
	  STATES: {
	    ID: {
	      AUTHORIZED: 'A', // Autorizado -> Autorizado
	      NOT_IN_FORCE: 'N', // No vigente -> No vigente
	      ANNULATED: 'B', // Anulado -> No vigente
	      DISCLAIMER: 'C', // Renunciado -> No vigente
	      REGRESSED: 'R', // Retrocedido -> No vigente
	      CANCELLED: '0', // Cancelado -> No vigente
	      DENIED: 'D', // Denegado -> Denegado
	      IN_FORCE: 'L', // En vigor -> En vigor
	      SUBSCRIBER: 'X', // Abonado -> En vigor
	      PENDING: 'P', // Pendiente -> Pendiente
	      PENDING_SIGNATURE: 'F', // Pendiente de firma -> Pendiente de firma
	      IN_STUDIO: '1', // Activo -> ?
	      TRANSITIONAL_INTEGRATION: 'Z' // Transitorio integración -> ?
	    }
	  },
	  STATUS: {
	    OK: 'OK',
	    KO: 'KO'
	  },
	  LINKS: {
	    RECEIPTS: 'https://bbva-intranet.appspot.com?atom=00000159&external=true',
	    POLICY: 'https://portalintranet.es.igrupobbva/EHRA/ehra_mult_web_ehragestor_02/parameterGestorController',
	    TAX: 'https://portalintranet.es.igrupobbva/EHRA/ehra_mult_web_ehragestorrecibosirpf_05/parameterRecibosIrpfController'
	  }
	};
	
	var REPAYMENT_TYPES = {
	  PARTIAL: 'partial',
	  TOTAL: 'total',
	  SIMULATE: 'simulate'
	};
	
	var AMORTIZATION = {
	  FEE: 'C',
	  PERIOD: 'P'
	};
	
	var MIN_LENGTH_OF_SERVICE_FOR_SIGN_UP = 2;
	
	var LOANS_MODAL_STATES = {
	  DETAILS: 'details',
	  SOCIAL_HOUSING_LOAN: 'socialHousingLoan',
	  CADASTRAL_REFERENCE: 'cadastralReference',
	  CLOSE_CADASTRAL_REFERENCE: 'closeCadastralReference',
	  SHOW_JUSTIFICATION: 'showJustificationInformation',
	  SHOW_JUSTIFICATION_MAIL: 'showJustificationMailInformation',
	  DETAILSADHESION: 'adhesion'
	};
	
	var LOANS_REPAYMENT_SWITCH_CONFIG = [{
	  text: 'GLOBALS.BUTTON_ACTION.PARTIAL',
	  value: 'simulate'
	}, {
	  text: 'GLOBALS.BUTTON_ACTION.TOTAL',
	  value: 'total'
	}];
	
	var LOANS_CREDITWORTHINESS_MODAL_COACHMARK_CONFIG = {
	  module: 'LOANS',
	  tab: 'creditworthiness',
	  state: 'my-creditworthiness',
	  title: 'LOANS.COACHMARK.CREDITWORTHINESS.TITLE',
	  subtitles: [{
	    text: 'LOANS.COACHMARK.CREDITWORTHINESS.STEP0'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/loans/01-MCW/01.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var LOANS_NEED_A_LOAN_MODAL_COACHMARK_CONFIG = {
	  module: 'LOANS',
	  tab: 'needALoan',
	  state: 'need-a-loan',
	  title: 'LOANS.COACHMARK.NEED_A_LOAN.TITLE',
	  subtitles: [{
	    text: 'LOANS.COACHMARK.NEED_A_LOAN.STEP0'
	  }, {
	    text: 'LOANS.COACHMARK.NEED_A_LOAN.STEP1'
	  }, {
	    text: 'LOANS.COACHMARK.NEED_A_LOAN.STEP2'
	  }, {
	    text: 'LOANS.COACHMARK.NEED_A_LOAN.STEP3'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/loans/02-NAL/01.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/02-NAL/02.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/02-NAL/03.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/02-NAL/04.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var LOANS_CATALOG_MODAL_COACHMARK_CONFIG = {
	  module: 'LOANS',
	  tab: 'catalog',
	  state: 'catalog',
	  title: 'LOANS.COACHMARK.LOANS_CATALOG.TITLE',
	  subtitles: [{
	    text: 'LOANS.COACHMARK.LOANS_CATALOG.STEP0'
	  }, {
	    text: 'LOANS.COACHMARK.LOANS_CATALOG.STEP1'
	  }, {
	    text: 'LOANS.COACHMARK.LOANS_CATALOG.STEP2'
	  }, {
	    text: 'LOANS.COACHMARK.LOANS_CATALOG.STEP3'
	  }, {
	    text: 'LOANS.COACHMARK.LOANS_CATALOG.STEP4'
	  }, {
	    text: 'LOANS.COACHMARK.LOANS_CATALOG.STEP5'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/loans/03-LC/01.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/03-LC/02.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/03-LC/03.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/03-LC/04.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/03-LC/05.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/03-LC/06.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var LOANS_MY_LOANS_MODAL_COACHMARK_CONFIG = {
	  module: 'LOANS',
	  tab: 'myLoans',
	  state: 'my-loans',
	  title: 'LOANS.COACHMARK.MY_LOANS.TITLE',
	  subtitles: [{
	    text: 'LOANS.COACHMARK.MY_LOANS.STEP0'
	  }, {
	    text: 'LOANS.COACHMARK.MY_LOANS.STEP1'
	  }, {
	    text: 'LOANS.COACHMARK.MY_LOANS.STEP2'
	  }, {
	    text: 'LOANS.COACHMARK.MY_LOANS.STEP3'
	  }, {
	    text: 'LOANS.COACHMARK.MY_LOANS.STEP4'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/loans/04-ML/01.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/04-ML/02.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/04-ML/03.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/04-ML/04.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/04-ML/05.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	var LOANS_WAGE_ADVANCE_MODAL_COACHMARK_CONFIG = {
	  module: 'LOANS',
	  tab: 'waveAdvance',
	  state: 'wage-advance',
	  title: 'LOANS.COACHMARK.WAGE_ADVANCE.TITLE',
	  subtitles: [{
	    text: 'LOANS.COACHMARK.WAGE_ADVANCE.STEP0'
	  }, {
	    text: 'LOANS.COACHMARK.WAGE_ADVANCE.STEP1'
	  }],
	  imgs: [{
	    source: 'img/welcome-modal/loans/05-WA/01.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }, {
	    source: 'img/welcome-modal/loans/05-WA/02.png',
	    alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
	  }]
	};
	
	exports.LOANS = LOANS;
	exports.REPAYMENT_TYPES = REPAYMENT_TYPES;
	exports.AMORTIZATION = AMORTIZATION;
	exports.MIN_LENGTH_OF_SERVICE_FOR_SIGN_UP = MIN_LENGTH_OF_SERVICE_FOR_SIGN_UP;
	exports.LOANS_MODAL_STATES = LOANS_MODAL_STATES;
	exports.LOANS_REPAYMENT_SWITCH_CONFIG = LOANS_REPAYMENT_SWITCH_CONFIG;
	exports.LOANS_CREDITWORTHINESS_MODAL_COACHMARK_CONFIG = LOANS_CREDITWORTHINESS_MODAL_COACHMARK_CONFIG;
	exports.LOANS_CATALOG_MODAL_COACHMARK_CONFIG = LOANS_CATALOG_MODAL_COACHMARK_CONFIG;
	exports.LOANS_MY_LOANS_MODAL_COACHMARK_CONFIG = LOANS_MY_LOANS_MODAL_COACHMARK_CONFIG;
	exports.LOANS_WAGE_ADVANCE_MODAL_COACHMARK_CONFIG = LOANS_WAGE_ADVANCE_MODAL_COACHMARK_CONFIG;
	exports.LOANS_NEED_A_LOAN_MODAL_COACHMARK_CONFIG = LOANS_NEED_A_LOAN_MODAL_COACHMARK_CONFIG;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1776);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./creditworthiness.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./creditworthiness.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "creditworthiness{display:block}creditworthiness .container.hpd.mobile{padding-left:0;padding-right:0;padding-bottom:75px}creditworthiness .container.hpd.mobile section section-title{padding:0 30px 20px}creditworthiness .container.hpd.mobile section creditworthiness-more-info{margin-bottom:0;margin:0 30px}creditworthiness .container.hpd.mobile section .first-item{border-top:1px solid #dddfe2}creditworthiness section section-title{padding-top:20px;padding-bottom:20px}creditworthiness section section-title.second{padding-bottom:40px}creditworthiness section creditworthiness-card,creditworthiness section creditworthiness-more-info{margin-bottom:20px}creditworthiness section .creditworthiness-end-button{margin-top:50px;margin-bottom:55px;height:48px}creditworthiness section .creditworthiness-end-button a.btn.btn-app.btn-primary{height:48px;margin-right:15px;width:167px}creditworthiness .creditworthiness-description{padding-bottom:20px}creditworthiness .creditworthiness-disclaimer{padding-top:20px}creditworthiness .creditworthiness-mobile{padding:20px}creditworthiness .creditworthiness-description a,creditworthiness .creditworthiness-disclaimer a{background:none;text-decoration:underline}creditworthiness .creditworthiness-description a:focus,creditworthiness .creditworthiness-description a:hover,creditworthiness .creditworthiness-disclaimer a:focus,creditworthiness .creditworthiness-disclaimer a:hover{background:none;outline:none}", ""]);
	
	// exports


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _creditworthinessCard = __webpack_require__(1778);
	
	var _creditworthinessCard2 = _interopRequireDefault(_creditworthinessCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditworthinessCardModule = _angular2.default.module('creditworthinessCard', []).component('creditworthinessCard', _creditworthinessCard2.default).name;
	
	exports.default = creditworthinessCardModule;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _creditworthinessCard = __webpack_require__(1779);
	
	var _creditworthinessCard2 = _interopRequireDefault(_creditworthinessCard);
	
	__webpack_require__(1780);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditworthinessCardComponent = {
	  restrict: 'E',
	  bindings: {
	    information: '<'
	  },
	  template: _creditworthinessCard2.default
	};
	exports.default = creditworthinessCardComponent;

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"top-text\">\n  <h2 class=\"title\">\n    {{ $ctrl.information.title | translate }}\n  </h2>\n  <span class=\"subtitle\">\n    {{ $ctrl.information.subtitle | translate }}\n  </span>\n  <span class=\"amount\">{{ $ctrl.information.amount | currency }}</span>\n</div>\n<p class=\"description\">\n  {{ $ctrl.information.description | translate }}\n</p>\n"

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1781);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./creditworthinessCard.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./creditworthinessCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "creditworthiness-card{display:block;width:100%;max-width:1140px;height:auto;padding:30px;background-color:rgba(212,237,252,.5);border-radius:1px}creditworthiness-card.mobile{height:auto;width:auto;padding:15px}creditworthiness-card.mobile .top-text .title{padding-bottom:10px;width:100%;font-size:14px;text-transform:lowercase}creditworthiness-card.mobile .top-text .title:first-letter{text-transform:uppercase}creditworthiness-card.mobile .top-text .subtitle{display:inline-block;margin-left:0;padding-bottom:20px;font-size:13px;text-transform:lowercase}creditworthiness-card.mobile .top-text .subtitle:first-letter{text-transform:uppercase}creditworthiness-card.mobile .top-text .amount{display:inline-block;width:100%;padding-bottom:20px;text-align:center;font-size:18px}creditworthiness-card.mobile .description{margin-bottom:0;font-size:13px}creditworthiness-card .top-text{width:100%}creditworthiness-card .top-text .title{display:inline-block;padding-bottom:19px;margin:0;font-family:Stag Sans;font-weight:400;text-align:left;font-size:20px;line-height:1;color:#0072c9}creditworthiness-card .top-text .subtitle{margin-left:15px;font-size:15px;line-height:1;color:#666}creditworthiness-card .top-text .amount{margin-right:.3%;margin-top:0;float:right;font-size:24px;font-weight:400;line-height:1;color:#0072c9}creditworthiness-card .description{font-family:Stag Sans;font-size:400;font-size:15px}", ""]);
	
	// exports


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _creditworthinessMoreInfo = __webpack_require__(1783);
	
	var _creditworthinessMoreInfo2 = _interopRequireDefault(_creditworthinessMoreInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditworthinessMoreInfoModule = _angular2.default.module('creditworthinessMoreInfo', []).component('creditworthinessMoreInfo', _creditworthinessMoreInfo2.default).name;
	
	exports.default = creditworthinessMoreInfoModule;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _creditworthinessMoreInfo = __webpack_require__(1784);
	
	var _creditworthinessMoreInfo2 = _interopRequireDefault(_creditworthinessMoreInfo);
	
	var _creditworthinessMoreInfo3 = __webpack_require__(1785);
	
	var _creditworthinessMoreInfo4 = _interopRequireDefault(_creditworthinessMoreInfo3);
	
	__webpack_require__(1786);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditworthinessMoreInfoComponent = {
	  restrict: 'E',
	  bindings: {
	    information: '<'
	  },
	  template: _creditworthinessMoreInfo2.default,
	  controller: _creditworthinessMoreInfo4.default
	};
	
	exports.default = creditworthinessMoreInfoComponent;

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"more-info-area\" ng-click=\"$ctrl.toggleMoreInfo()\">\n  <div>\n    <h2 class=\"title\">\n      {{ $ctrl.information.title | translate }}\n    </h2>\n    <i\n      class=\"icon icon-arrow-select-down\"\n      ng-class=\"{ 'show-info-rotation': $ctrl.moreInfoIsVisible === true }\"\n      ng-show=\"$ctrl.moreInfoIsDisplayable()\">\n    </i>\n  </div>\n  <div class=\"more-info-container\" ng-class=\"$ctrl.getClasses()\">\n    <div ng-repeat=\"info in $ctrl.information.information track by $index\">\n      <p class=\"more-info-text\" ng-show=\"$ctrl.moreInfoIsVisible && $ctrl.moreInfoIsDisplayable()\">\n        {{ info | translate }}\n      </p>\n    </div>\n  </div>\n<div>\n"

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreditworthinessMoreInfoController = function () {
	  function CreditworthinessMoreInfoController() {
	    (0, _classCallCheck3.default)(this, CreditworthinessMoreInfoController);
	
	    this.moreInfoIsVisible = false;
	    this.moreInfoIsDisplayableCtrl = true;
	  }
	
	  (0, _createClass3.default)(CreditworthinessMoreInfoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.moreInfoIsDisplayableCtrl = this.information.hasOwnProperty('information');
	    }
	  }, {
	    key: 'toggleMoreInfo',
	    value: function toggleMoreInfo() {
	      this.moreInfoIsVisible = !this.moreInfoIsVisible;
	    }
	  }, {
	    key: 'moreInfoIsDisplayable',
	    value: function moreInfoIsDisplayable() {
	      var isDisplayable = true;
	      if (this.information.information === '' || this.moreInfoIsDisplayableCtrl === false) {
	        isDisplayable = false;
	      }
	      return isDisplayable;
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        'more-info-text-is-show': this.moreInfoIsVisible === true,
	        'more-info-text-is-hide': this.moreInfoIsVisible !== true
	      };
	    }
	  }]);
	  return CreditworthinessMoreInfoController;
	}();
	
	exports.default = CreditworthinessMoreInfoController;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1787);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./creditworthinessMoreInfo.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./creditworthinessMoreInfo.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "creditworthiness-more-info{display:block}creditworthiness-more-info.mobile{position:relative}creditworthiness-more-info.mobile .more-info-area{border-radius:0;border-top:none;margin-top:0;padding:30px 0}creditworthiness-more-info.mobile div .title{width:300px;font-size:13px;padding-right:55px;line-height:16px}creditworthiness-more-info.mobile div i{transition:none;position:absolute;top:30px;margin-right:0}creditworthiness-more-info.mobile .more-info-container{transition:none}creditworthiness-more-info.mobile .more-info-container .more-info-text{transition:none;font-size:13px;line-height:16px;margin-bottom:20px}creditworthiness-more-info.mobile .more-info-container.more-info-text-is-show{max-height:999px;padding-top:15px;transition:all .5s linear;opacity:1}creditworthiness-more-info.mobile .more-info-container.more-info-text-is-hide{max-height:0;transition:all .2s linear;opacity:0}creditworthiness-more-info .more-info-area{cursor:pointer;border-bottom:1px solid #dddfe2;border-radius:1px;border-top:1px solid #dddfe2;margin-top:20px;padding:30px 20px}creditworthiness-more-info div .title{color:#666;display:inline-block;font-family:Stag Sans;font-size:22px;font-weight:400;line-height:.91;margin:0;text-align:left}creditworthiness-more-info div i{transition:.7s;color:#287cba;float:right;margin-right:12px}creditworthiness-more-info div i.show-info-rotation{transform:rotate(180deg)}creditworthiness-more-info .more-info-container{transition:.7s;max-height:0;overflow:hidden}creditworthiness-more-info .more-info-container.more-info-text-is-show{max-height:999px;padding-top:15px}creditworthiness-more-info .more-info-container .more-info-text{transition:.7s;color:#666;font-family:Stag Sans;font-size:15px;font-weight:400;line-height:1.4;margin:0;max-height:999px;text-align:left}creditworthiness-more-info .more-info-container .more-info-text.ng-hide{max-height:0}", ""]);
	
	// exports


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _creditworthinessOfLoan = __webpack_require__(1789);
	
	var _creditworthinessOfLoan2 = _interopRequireDefault(_creditworthinessOfLoan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditworthinessOfLoanModule = _angular2.default.module('creditworthinessOfLoan', []).component('creditworthinessOfLoan', _creditworthinessOfLoan2.default).name;
	
	exports.default = creditworthinessOfLoanModule;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _creditworthinessOfLoan = __webpack_require__(1790);
	
	var _creditworthinessOfLoan2 = _interopRequireDefault(_creditworthinessOfLoan);
	
	var _creditworthinessOfLoan3 = __webpack_require__(1791);
	
	var _creditworthinessOfLoan4 = _interopRequireDefault(_creditworthinessOfLoan3);
	
	__webpack_require__(1792);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditworthinessOfLoanComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<'
	  },
	  template: _creditworthinessOfLoan2.default,
	  controller: _creditworthinessOfLoan4.default
	};
	
	exports.default = creditworthinessOfLoanComponent;

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <h2>{{ $ctrl.loan.loanName | translate }}</h2>\n \n  <div class=\"data\">\n    <div class=\"first-column\">\n      <p>{{ $ctrl.loan.maximumLimitLiteral | translate }}</p>\n      <p>{{ $ctrl.loan.realWithoutInsuranceLimitLiteral | translate }}</p>\n      <p>{{ $ctrl.loan.realWithInsuranceLimitLiteral | translate }}</p>\n    </div>\n \n    <div class=\"second-column\">\n      <p ng-switch on=\"$ctrl.loan.maximumLimit\">\n        <span ng-switch-when=\"N/A\">N/A</span>\n        <span ng-switch-default>{{ $ctrl.loan.maximumLimit | currency }}</span>\n      </p>\n \n      <p ng-switch on=\"$ctrl.loan.realWithoutInsuranceLimit\">\n        <span ng-switch-when=\"N/A\">N/A</span>\n        <span ng-switch-default>{{ $ctrl.loan.realWithoutInsuranceLimit | currency }}</span>\n      </p>\n \n      <p>\n        {{ $ctrl.loan.realWithInsuranceLimit | currency }}\n        <span ng-if=\"$ctrl.loan.hasAsterisk\">*</span>\n      </p>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreditworthinessOfLoanController = function CreditworthinessOfLoanController() {
	  (0, _classCallCheck3.default)(this, CreditworthinessOfLoanController);
	};
	
	exports.default = CreditworthinessOfLoanController;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1793);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./creditworthinessOfLoan.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./creditworthinessOfLoan.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "creditworthiness-of-loan{border-bottom:1px solid #dddfe2;display:block;padding:0 30px 20px}creditworthiness-of-loan h2{color:#666;font-family:Stag Sans;font-size:16px;line-height:1;margin-bottom:10px;text-align:left}creditworthiness-of-loan .data{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}creditworthiness-of-loan .data .first-column p{color:#666;font-family:Stag Sans;font-size:13px;margin-bottom:5px}creditworthiness-of-loan .data .second-column{text-align:right}creditworthiness-of-loan .data .second-column p{color:#666;font-family:Stag Sans;font-size:14px;margin-bottom:5px;font-weight:500}", ""]);
	
	// exports


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _creditworthinessMobileHeader = __webpack_require__(1795);
	
	var _creditworthinessMobileHeader2 = _interopRequireDefault(_creditworthinessMobileHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditworthinessMobileHeaderModule = _angular2.default.module('creditworthinessMobileHeader', []).component('creditworthinessMobileHeader', _creditworthinessMobileHeader2.default).name;
	
	exports.default = creditworthinessMobileHeaderModule;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _creditworthinessMobileHeader = __webpack_require__(1796);
	
	var _creditworthinessMobileHeader2 = _interopRequireDefault(_creditworthinessMobileHeader);
	
	var _creditworthinessMobileHeader3 = __webpack_require__(1797);
	
	var _creditworthinessMobileHeader4 = _interopRequireDefault(_creditworthinessMobileHeader3);
	
	__webpack_require__(1798);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditworthinessMobileHeaderComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _creditworthinessMobileHeader2.default,
	  controller: _creditworthinessMobileHeader4.default
	};
	
	exports.default = creditworthinessMobileHeaderComponent;

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"title-wrapper\">\n    <h1>{{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TITLE' | translate }}</h1>\n\n    <tooltip-mobile name=\"creditworthinessMobileHeaderTooltips\">\n      <p class=\"tooltip-title\">\n        {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT' | translate }}\n      </p>\n      <p>\n        {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_TOOLTIP' | translate }}\n      </p>\n\n      <p class=\"tooltip-title\">\n        {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITHOUT_INSURANCE' | translate }}\n      </p>\n      <p>\n        {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITHOUT_INSURANCE_TOOLTIP' | translate }}\n      </p>\n\n      <p class=\"tooltip-title\">\n        {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITH_INSURANCE' | translate }}\n      </p>\n      <p>\n        {{ 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.MAX_LIMIT_WITH_INSURANCE_TOOLTIP' | translate }}\n      </p>\n    </tooltip-mobile>\n\n  </div>\n</div>\n"

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreditworthinessMobileHeaderController = function CreditworthinessMobileHeaderController() {
	  (0, _classCallCheck3.default)(this, CreditworthinessMobileHeaderController);
	};
	
	exports.default = CreditworthinessMobileHeaderController;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1799);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./creditworthinessMobileHeader.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./creditworthinessMobileHeader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "creditworthiness-mobile-header{display:block;border-bottom:1px solid #dddfe2;padding:0 30px}creditworthiness-mobile-header .title-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}creditworthiness-mobile-header .title-wrapper h1{color:#0072c9;font-family:Stag Sans;font-size:16px;font-weight:400;padding-right:110px;width:100%}", ""]);
	
	// exports


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _loansCatalog = __webpack_require__(1801);
	
	var _loansCatalog2 = _interopRequireDefault(_loansCatalog);
	
	var _loansCatalogCard = __webpack_require__(1806);
	
	var _loansCatalogCard2 = _interopRequireDefault(_loansCatalogCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansCatalogModule = _angular2.default.module('loansCatalog', [_angularUiRouter2.default, _loansCatalogCard2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.LOANS_CATALOG, {
	    url: _routes.ROUTES.LOANS.LOANS_CATALOG,
	    component: 'loansCatalog',
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      serviceClosed: ["StatusAppCheckers", function serviceClosed(StatusAppCheckers) {
	        return StatusAppCheckers.isServiceClosed();
	      }]
	    }
	  });
	}]).component('loansCatalog', _loansCatalog2.default).name;
	
	exports.default = loansCatalogModule;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansCatalog = __webpack_require__(1802);
	
	var _loansCatalog2 = _interopRequireDefault(_loansCatalog);
	
	var _loansCatalog3 = __webpack_require__(1803);
	
	var _loansCatalog4 = _interopRequireDefault(_loansCatalog3);
	
	__webpack_require__(1804);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansCatalogComponent = {
	  restrict: 'E',
	  bindings: {
	    serviceClosed: '<'
	  },
	  template: _loansCatalog2.default,
	  controller: _loansCatalog4.default
	};
	
	exports.default = loansCatalogComponent;

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <section ng-if=\"!$ctrl.loaded\">\n    <loading></loading>\n  </section>\n\n  <section ng-if=\"$ctrl.loaded\" class=\"animation-appear\">\n\n    <modal-coachmark\n      data=\"$ctrl.coachmarkData\"\n      ng-if=\"!$ctrl.isMobileApp\"\n      user-id=\"$ctrl.userId\">\n    </modal-coachmark>\n\n    <div class=\"list-empty\" ng-if=\"$ctrl.emptyCatalog\">\n      <span class=\"icon-warning\"></span>\n      <span>{{ 'LOANS.LOANS_CATALOG.EMPTY' | translate }}</span>\n    </div>\n\n    <loans-catalog-card\n      ng-repeat=\"(id, loan) in $ctrl.loans\"\n      service-closed=\"$ctrl.serviceClosed\"\n      loan=\"loan\"\n      creditworthiness=\"$ctrl.creditworthiness\"\n      user-id=\"$ctrl.userId\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </loans-catalog-card>\n\n  </section>\n\n</div>\n"

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansCatalogController = function () {
	  LoansCatalogController.$inject = ["$log", "$window", "loansStaticService", "LoansUserDataService", "LoansOperationsService", "loadingMobileService"];
	  function LoansCatalogController($log, $window, loansStaticService, LoansUserDataService, LoansOperationsService, loadingMobileService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansCatalogController);
	    this.log = $log;
	    this.loansStaticService = loansStaticService;
	    this.loansUserDataService = LoansUserDataService;
	    this.loansOperationsService = LoansOperationsService;
	    this.loadingMobileService = loadingMobileService;
	
	    this.userId = this.loansUserDataService._employee.userId;
	    this.coachmarkData = _constants.LOANS_CATALOG_MODAL_COACHMARK_CONFIG;
	    this.isMobileApp = $window.innerWidth < 1024;
	
	    this.init();
	  }
	
	  (0, _createClass3.default)(LoansCatalogController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.loadingMobileService.show();
	      this.loansOperationsService.getCreditworthiness(this.userId).then(function (creditworthiness) {
	        _this.creditworthiness = creditworthiness;
	        _this.loans = _this.checkWhatLoansAreAvailable(creditworthiness);
	        _this.emptyCatalog = _this.loans.length === 0;
	        _this.loaded = true;
	      }, function (error) {
	        _this.log.error('LoansCatalogController init()', error);
	        // TODO: [Manu] eliminado ya que en la APP se ve un instante antes de redirigir a login, e incluso pueda causar otros problemas. Ver si en la Web es necesario o con el errorInterceptor es suficiente
	        // this.state.go(STATES.ERROR);
	      }).finally(function () {
	        _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'checkWhatLoansAreAvailable',
	    value: function checkWhatLoansAreAvailable(creditworthiness) {
	      var _this2 = this;
	
	      var availableLoans = (0, _keys2.default)(creditworthiness);
	      var order = [_constants.LOANS.ID.FIVE_MONTH, _constants.LOANS.ID.NINE_MONTH, _constants.LOANS.ID.VARIOUS_CREDIT, _constants.LOANS.ID.DIVERSAL_ATENTION, _constants.LOANS.ID.AGREEMENT_HOUSING_LOAN, _constants.LOANS.ID.SOCIAL_HOUSING_LOAN];
	
	      var loans = _lodash2.default.compact(order.map(function (loanId) {
	        if (availableLoans.includes(loanId)) {
	          var loan = _this2.loansStaticService.get(loanId);
	          loan.maximumLimit = creditworthiness[loanId].maximumLimit;
	          return loan;
	        }
	      }));
	
	      return loans;
	    }
	  }]);
	  return LoansCatalogController;
	}();
	
	exports.default = LoansCatalogController;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1805);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansCatalog.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansCatalog.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-catalog{display:block;margin-top:14px}loans-catalog section loans-catalog-card{margin-bottom:52px;margin-right:35px}loans-catalog section .list-empty{font-size:30px;height:200px;text-align:center;color:#0072c9}loans-catalog section .list-empty .icon-warning{font-size:60px;position:relative;top:13px;right:5px;color:#0072c9}loans-catalog .mobile,loans-catalog .responsiveMobile{text-align:center}loans-catalog .mobile loans-catalog-card,loans-catalog .responsiveMobile loans-catalog-card{display:block;width:100%;margin-right:0;margin-bottom:30px}loans-catalog .mobile loans-catalog-card .loans-catalog-card,loans-catalog .responsiveMobile loans-catalog-card .loans-catalog-card{width:100%;height:auto;border-radius:0}loans-catalog .mobile loans-catalog-card .loans-catalog-card img,loans-catalog .responsiveMobile loans-catalog-card .loans-catalog-card img{height:90px;border-top-left-radius:0;border-top-right-radius:0}loans-catalog .mobile loans-catalog-card .loans-catalog-card-title,loans-catalog .responsiveMobile loans-catalog-card .loans-catalog-card-title{height:auto;padding-top:10px;padding-bottom:20px;border-bottom-left-radius:0;border-bottom-right-radius:0}loans-catalog .mobile loans-catalog-card .loans-catalog-card-title>h2,loans-catalog .responsiveMobile loans-catalog-card .loans-catalog-card-title>h2{font-size:20px}", ""]);
	
	// exports


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansCatalogCard = __webpack_require__(1807);
	
	var _loansCatalogCard2 = _interopRequireDefault(_loansCatalogCard);
	
	var _loansCatalogCardButtons = __webpack_require__(1812);
	
	var _loansCatalogCardButtons2 = _interopRequireDefault(_loansCatalogCardButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansCatalogCardModule = _angular2.default.module('loansCatalogCard', [_loansCatalogCardButtons2.default]).component('loansCatalogCard', _loansCatalogCard2.default).name;
	
	exports.default = loansCatalogCardModule;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansCatalogCard = __webpack_require__(1808);
	
	var _loansCatalogCard2 = _interopRequireDefault(_loansCatalogCard);
	
	var _loansCatalogCard3 = __webpack_require__(1809);
	
	var _loansCatalogCard4 = _interopRequireDefault(_loansCatalogCard3);
	
	__webpack_require__(1810);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansCatalogCardComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    creditworthiness: '<',
	    isMobileApp: '<',
	    serviceClosed: '<',
	    userId: '<'
	  },
	  template: _loansCatalogCard2.default,
	  controller: _loansCatalogCard4.default
	};
	
	exports.default = loansCatalogCardComponent;

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-catalog-card loan-link\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\" ng-click=\"$ctrl.goToDetails($ctrl.loan.id, !$ctrl.isMobileApp)\" >\n  <cannot-signup-modal\n    ng-if=\"!$ctrl.serviceClosed && $ctrl.cannotSignUpError !== undefined\"      \n    on-dismiss=\"$ctrl.goMyLoans()\"\n    cannot-sign-up-error=\"$ctrl.cannotSignUpError\"\n    is-mobile-app=\"$ctrl.isMobileApp\">\n  </cannot-signup-modal>\n  <img ng-src=\"{{$ctrl.loan.img}}\">\n\n  <div class=\"loans-catalog-card-title\">\n    <h2>{{ $ctrl.getTitle() }}</h2>\n\n    <ul class=\"list-card\" ng-if=\"$ctrl.isMobileApp\">\n      <li>{{ $ctrl.getTextInterestType() }}</li>\n      <li>{{ $ctrl.getTextMaximumLimit() }}</li>\n    </ul>\n\n    <loans-catalog-card-buttons\n      service-closed=\"$ctrl.serviceClosed\"\n      ng-if=\"$ctrl.isMobileApp\"\n      on-select-action-card=\"$ctrl.onSelectActionCard($event)\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </loans-catalog-card-buttons>\n  </div>\n\n</div>\n"

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansCatalogCardController = function () {
	  LoansCatalogCardController.$inject = ["$timeout", "$state", "$filter", "$translate", "LoansOperationsService"];
	  function LoansCatalogCardController($timeout, $state, $filter, $translate, LoansOperationsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansCatalogCardController);
	    this.state = $state;
	    this.filter = $filter;
	    this.translate = $translate;
	    this.translations = {};
	    this.timeout = $timeout;
	    this.cannotSignUpError = undefined;
	    this.loansOperationsService = LoansOperationsService;
	  }
	
	  (0, _createClass3.default)(LoansCatalogCardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.loanDetails = this.loan.detail.basicCharacteristics;
	      this._translate();
	    }
	  }, {
	    key: 'goToDetails',
	    value: function goToDetails(loanId, canGoToDetail) {
	      if (canGoToDetail) this.state.go(_states.STATES.LOANS.DETAIL, { loanId: loanId });
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this = this;
	
	      var TITLE = this.loan.title;
	      var INTEREST_TYPE = this.loanDetails[2].title;
	      var INTEREST_TYPE_VALUE = this.loanDetails[2].textToCatalog;
	      var DEADLINE1 = this.loanDetails[1].title;
	      var DEADLINE2 = this.loanDetails[1].desc;
	
	      this.translate('GLOBALS.TO').then(function (translation) {
	        _this.translations.to = translation;
	      });
	      this.translate('GLOBALS.AND_TO').then(function (translation) {
	        _this.translations.andTo = translation;
	      });
	      this.translate(TITLE).then(function (translation) {
	        _this.translations.title = translation;
	      });
	      this.translate(INTEREST_TYPE).then(function (translation) {
	        _this.translations.interestType = translation;
	      });
	      this.translate(INTEREST_TYPE_VALUE).then(function (translation) {
	        _this.translations.interestTypeValue = translation;
	      });
	      this.translate(DEADLINE1).then(function (translation) {
	        _this.translations.deadline1 = translation;
	      });
	      this.translate(DEADLINE2).then(function (translation) {
	        _this.translations.deadline2 = translation;
	      });
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      return this.translations.title;
	    }
	  }, {
	    key: 'getTextInterestType',
	    value: function getTextInterestType() {
	      return this.translations.interestType + ': ' + this.translations.interestTypeValue;
	    }
	  }, {
	    key: 'getTextMaximumLimit',
	    value: function getTextMaximumLimit() {
	      return this.translations.deadline1 + ': ' + this.translations.to + '  ' + this.translations.deadline2;
	    }
	  }, {
	    key: 'presentCannotSignUpModal',
	    value: function presentCannotSignUpModal(reason) {
	      var _this2 = this;
	
	      this.cannotSignUpError = reason;
	      this.timeout(function () {
	        _this2.modalCannotSignup.modal('show');
	      });
	    }
	  }, {
	    key: 'goMyLoans',
	    value: function goMyLoans() {
	      this.modalCannotSignup.modal('hide');
	      this.state.go(_states.STATES.LOANS.MY_LOANS);
	    }
	  }, {
	    key: 'goToSignUp',
	    value: function goToSignUp(loanId, hardReset) {
	      if (this.serviceClosed) {
	        return;
	      }
	
	      var from = _states.STATES.LOANS.LOANS_CATALOG;
	      var creditworthiness = this.creditworthiness;
	      var creditworthinessOfLoan = creditworthiness[loanId];
	      var hireDate = creditworthiness.hireDate;
	
	      try {
	        this.loansOperationsService.canSignUp(loanId, creditworthinessOfLoan, hireDate);
	        return this.state.go(_states.STATES.LOANS.SIGN_UP, {
	          loanId: loanId,
	          from: from,
	          hardReset: hardReset
	        });
	      } catch (reason) {
	        this.presentCannotSignUpModal(reason.message);
	      }
	    }
	  }, {
	    key: 'onSelectActionCard',
	    value: function onSelectActionCard($event) {
	      if ($event.actionInfo) {
	        return this.goToDetails(this.loan.id, this.isMobileApp);
	      }
	
	      this.goToSignUp(this.loan.id, $event.hardReset);
	    }
	  }, {
	    key: 'modalCannotSignup',
	    get: function get() {
	      return $(_constants.MODALS.CANNOT_SIGNUP);
	    }
	  }]);
	  return LoansCatalogCardController;
	}();
	
	exports.default = LoansCatalogCardController;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1811);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansCatalogCard.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansCatalogCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-catalog-card{display:inline-block}loans-catalog-card .loan-link,loans-catalog-card .loan-link:focus,loans-catalog-card .loan-link:hover{text-decoration:none}loans-catalog-card .loans-catalog-card{background-color:#f4f4f4;border-radius:12px;box-shadow:0 1px 4px 0 rgba(0,0,0,.2);cursor:pointer;height:248px;width:345px}loans-catalog-card .loans-catalog-card img{object-fit:cover;font-family:object-fit\\: cover;border-top-left-radius:12px;border-top-right-radius:12px;height:150px;width:100%}loans-catalog-card .loans-catalog-card .loans-catalog-card-title{-ms-flex-align:center;-moz-align-items:center;align-items:center;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;background-color:#fbfbfb;border-bottom-left-radius:12px;border-bottom-right-radius:12px;height:98px;padding:0;text-align:center}loans-catalog-card .loans-catalog-card .loans-catalog-card-title h2{color:#0072c9;font-family:Stag Sans;font-size:24px;font-weight:400;line-height:1.21;margin:0;text-align:center;text-decoration:none}loans-catalog-card .loans-catalog-card .loans-catalog-card-title .list-card{padding:0 20px;list-style-type:none;text-align:start}loans-catalog-card .loans-catalog-card .loans-catalog-card-title .list-card li:before{content:\"-\";padding-right:10px}loans-catalog-card .loans-catalog-card.mobile img{min-height:80px;height:80px}loans-catalog-card .loans-catalog-card.mobile .loans-catalog-card-title h2{font-size:15px}loans-catalog-card .loans-catalog-card.mobile .loans-catalog-card-title .list-card{margin-top:10px;padding:0 30px}loans-catalog-card .loans-catalog-card.mobile .loans-catalog-card-title li{font-size:12px}", ""]);
	
	// exports


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansCatalogCardButtons = __webpack_require__(1813);
	
	var _loansCatalogCardButtons2 = _interopRequireDefault(_loansCatalogCardButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansCatalogCardButtonsModule = _angular2.default.module('loansCatalogCardButtons', []).component('loansCatalogCardButtons', _loansCatalogCardButtons2.default).name;
	
	exports.default = loansCatalogCardButtonsModule;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansCatalogCardButtons = __webpack_require__(1814);
	
	var _loansCatalogCardButtons2 = _interopRequireDefault(_loansCatalogCardButtons);
	
	var _loansCatalogCardButtons3 = __webpack_require__(1815);
	
	var _loansCatalogCardButtons4 = _interopRequireDefault(_loansCatalogCardButtons3);
	
	__webpack_require__(1816);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansCatalogCardButtonsComponent = {
	  restrict: 'E',
	  bindings: {
	    onSelectActionCard: '&',
	    serviceClosed: '<',
	    isMobileApp: '<'
	  },
	  template: _loansCatalogCardButtons2.default,
	  controller: _loansCatalogCardButtons4.default
	};
	
	exports.default = loansCatalogCardButtonsComponent;

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"buttons-card\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <button\n    type=\"button\"\n    class=\"btn btn-app btn-default\"\n    ng-click=\"$ctrl.onSelectActionCard({ $event: { actionInfo: true }})\">\n      {{ 'LOANS.LOANS_DETAIL.MORE_INFO' | translate }}\n   </button>\n\n  <button\n    type=\"button\"\n    class=\"btn btn-app btn-primary\"\n    ng-disabled=\"$ctrl.serviceClosed\"\n    ng-click=\"$ctrl.onSelectActionCard({ $event: { actionInfo: false, hardReset: true }})\">\n      {{ 'LOANS.LOANS_DETAIL.ORDER_NOW' | translate }}\n  </button>\n\n</div>\n"

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansCatalogCardButtonsController = function LoansCatalogCardButtonsController() {
	  (0, _classCallCheck3.default)(this, LoansCatalogCardButtonsController);
	};
	
	exports.default = LoansCatalogCardButtonsController;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1817);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./loansCatalogCardButtons.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./loansCatalogCardButtons.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-catalog-card-buttons{width:100%}loans-catalog-card-buttons .buttons-card{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}loans-catalog-card-buttons .buttons-card .btn.btn-app{width:130px;line-height:38px;height:38px}loans-catalog-card-buttons .buttons-card>:first-child{margin-right:15px}loans-catalog-card-buttons .buttons-card.mobile .btn{font-size:12px}", ""]);
	
	// exports


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _loansDetail = __webpack_require__(1819);
	
	var _loansDetail2 = _interopRequireDefault(_loansDetail);
	
	var _loansDetailHeader = __webpack_require__(1825);
	
	var _loansDetailHeader2 = _interopRequireDefault(_loansDetailHeader);
	
	var _loansDetailCollapse = __webpack_require__(1830);
	
	var _loansDetailCollapse2 = _interopRequireDefault(_loansDetailCollapse);
	
	var _loansDetailPurposes = __webpack_require__(1836);
	
	var _loansDetailPurposes2 = _interopRequireDefault(_loansDetailPurposes);
	
	var _loansDetailBasicCharacteristics = __webpack_require__(1841);
	
	var _loansDetailBasicCharacteristics2 = _interopRequireDefault(_loansDetailBasicCharacteristics);
	
	var _loansDetailMinimumFee = __webpack_require__(1847);
	
	var _loansDetailMinimumFee2 = _interopRequireDefault(_loansDetailMinimumFee);
	
	var _loansDetailRequestIt = __webpack_require__(1853);
	
	var _loansDetailRequestIt2 = _interopRequireDefault(_loansDetailRequestIt);
	
	var _loansDetailPrepayments = __webpack_require__(1859);
	
	var _loansDetailPrepayments2 = _interopRequireDefault(_loansDetailPrepayments);
	
	var _loansDetailSendDocumentation = __webpack_require__(1865);
	
	var _loansDetailSendDocumentation2 = _interopRequireDefault(_loansDetailSendDocumentation);
	
	var _loansDetailFinishDeadline = __webpack_require__(1870);
	
	var _loansDetailFinishDeadline2 = _interopRequireDefault(_loansDetailFinishDeadline);
	
	var _loansDetailStatementIncome = __webpack_require__(1876);
	
	var _loansDetailStatementIncome2 = _interopRequireDefault(_loansDetailStatementIncome);
	
	var _loansDetailNewCreditCapacity = __webpack_require__(1882);
	
	var _loansDetailNewCreditCapacity2 = _interopRequireDefault(_loansDetailNewCreditCapacity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailModule = _angular2.default.module('loansDetail', [_angularUiRouter2.default, _loansDetailHeader2.default, _loansDetailCollapse2.default, _loansDetailPurposes2.default, _loansDetailBasicCharacteristics2.default, _loansDetailMinimumFee2.default, _loansDetailRequestIt2.default, _loansDetailPrepayments2.default, _loansDetailSendDocumentation2.default, _loansDetailFinishDeadline2.default, _loansDetailStatementIncome2.default, _loansDetailNewCreditCapacity2.default]).component('loansDetail', _loansDetail2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.DETAIL, {
	    url: _routes.ROUTES.LOANS.DETAIL,
	    component: 'loansDetail',
	    params: {
	      allowGoBack: false,
	      from: null,
	      originalFrom: null,
	      snapshot: null
	    },
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      serviceClosed: ["StatusAppCheckers", function serviceClosed(StatusAppCheckers) {
	        return StatusAppCheckers.isServiceClosed();
	      }]
	    }
	  });
	}]).name;
	
	exports.default = loansDetailModule;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetail = __webpack_require__(1820);
	
	var _loansDetail2 = _interopRequireDefault(_loansDetail);
	
	var _loansDetail3 = __webpack_require__(1821);
	
	var _loansDetail4 = _interopRequireDefault(_loansDetail3);
	
	__webpack_require__(1823);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailComponent = {
	  restrict: 'E',
	  bindings: {
	    serviceClosed: '<'
	  },
	  template: _loansDetail2.default,
	  controller: _loansDetail4.default
	};
	
	exports.default = loansDetailComponent;

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd loans-detail\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <cannot-signup-modal\n    ng-if=\"!$ctrl.serviceClosed\"\n    on-dismiss=\"$ctrl.goMyLoans()\"\n    cannot-sign-up-error=\"$ctrl.cannotSignUpError\"\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    loan-modality=\"$ctrl.loanId\">\n  </cannot-signup-modal>\n\n  <section ng-if=\"$ctrl.loaded\">\n\n    <div ng-if=\"$ctrl.allowGoBack && !$ctrl.isMobileApp\" ng-click=\"$ctrl.goBack()\" class=\"go-back\">\n      <span class=\"icon icon-arrow-select-up\"></span><span>{{ 'GLOBALS.RETURN' | translate }}</span>\n    </div>\n\n    <loans-detail-header\n      on-navigate=\"$ctrl.onNavigateSignUp()\"\n      hide-signup=\"$ctrl.allowGoBack\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      loan=\"$ctrl.loan\">\n    </loans-detail-header>\n\n    <loans-detail-collapse\n      ng-if=\"$ctrl.hasPurposeSubtitle() && !$ctrl.isVariousCredit() && !$ctrl.isDiversalAtention()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.PURPOSES' | translate }}\"\n      subtitle=\"{{ 'LOANS.LOANS_DETAIL.PURPOSES_DESC' | translate }}\">\n        <loans-detail-purposes\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          loan=\"$ctrl.loanPurposes\">\n        </loans-detail-purposes>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      ng-if=\"$ctrl.hasPurposeSubtitle() && $ctrl.isVariousCredit()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.PURPOSES' | translate }}\"\n      subtitle=\"{{ 'LOANS.LOANS_DETAIL.PURPOSE_VARIOUS_CREDIT' | translate }}\">\n        <loans-detail-purposes\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          loan=\"$ctrl.loanPurposes\">\n        </loans-detail-purposes>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      ng-if=\"$ctrl.hasPurposeSubtitle() && $ctrl.isDiversalAtention()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.PURPOSES' | translate }}\"\n      subtitle=\"{{ 'LOANS.LOANS_DETAIL.PURPOSE_DIVERSAL_ATENTION' | translate }}\">\n        <loans-detail-purposes\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          loan=\"$ctrl.loanPurposes\">\n        </loans-detail-purposes>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      ng-if=\"!$ctrl.hasPurposeSubtitle()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.PURPOSES' | translate }}\">\n      <loans-detail-purposes\n        is-mobile-app=\"$ctrl.isMobileApp\"\n        loan=\"$ctrl.loanPurposes\">\n      </loans-detail-purposes>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.hasMinFeeSection()\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.MINIMUM_FEE' | translate }}\"\n      subtitle=\"{{ 'LOANS.LOANS_DETAIL.MINIMUM_FEE_DESC' | translate }}{{ 'LOANS.LOANS_DETAIL.MINIMUM_FEE_DESC_2' | translate }}\">\n        <loans-detail-minimum-fee\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          loan=\"$ctrl.loan\"\n          on-click=\"$ctrl.calcMinFee()\"\n          minimum-fee=\"$ctrl.minimumFee\">\n        </loans-detail-minimum-fee>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.BASIC_CHARACTERISTICS' | translate }}\"\n      subtitle=\"{{ 'LOANS.LOANS_DETAIL.BASIC_CHARACTERISTICS_DESC' | translate }}\"\n      opened=\"$ctrl.basicCharacteristicsOpened\">\n      <loans-detail-basic-characteristics\n        loan=\"$ctrl.loan\"\n        datatable=\"$ctrl.dataTableBasicCharacteristics\"\n        on-click=\"$ctrl.calcTypeInterest($event)\"\n        result-type-interest=\"$ctrl.resultTypeInterest\"\n        coefficient=\"$ctrl.coefficient\"\n        service-closed=\"$ctrl.serviceClosed\"\n        is-mobile-app=\"$ctrl.isMobileApp\">\n      </loans-detail-basic-characteristics>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.REQUEST_IT' | translate }}\"\n      subtitle=\"{{ 'LOANS.LOANS_DETAIL.REQUEST_IT_DESC' | translate }}\">\n        <loans-detail-request-it\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          loan=\"$ctrl.loan\">\n        </loans-detail-request-it>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.PREPAYMENTS' | translate }}\"\n      subtitle=\"{{ 'LOANS.LOANS_DETAIL.PREPAYMENTS_DESC' | translate }}\">\n        <loans-detail-prepayments\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          loan=\"$ctrl.loan\">\n        </loans-detail-prepayments>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      ng-if=\"$ctrl.showNewCreditCapacity()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.NEW_CREDIT_CAPACITY' | translate }}\">\n      <loans-detail-new-credit-capacity\n        is-mobile-app=\"$ctrl.isMobileApp\"\n        loan=\"$ctrl.loan\">\n      </loans-detail-new-credit-capacity>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.SEND_DOCUMENTATION' | translate }}\"\n      subtitle=\"{{ 'LOANS.LOANS_DETAIL.SEND_DOCUMENTATION_DESC' | translate }}\">\n      <loans-detail-send-documentation\n        is-mobile-app=\"$ctrl.isMobileApp\"\n        loan=\"$ctrl.loan\"\n        service-closed=\"$ctrl.serviceClosed\">\n      </loans-detail-send-documentation>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.FINISH_DEADLINE' | translate }}\">\n        <loans-detail-finish-deadline\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          loan=\"$ctrl.loan\">\n        </loans-detail-finish-deadline>\n    </loans-detail-collapse>\n\n    <loans-detail-collapse\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      title=\"{{ 'LOANS.LOANS_DETAIL.STATEMENT_INCOME' | translate }}\">\n        <loans-detail-statement-income\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          loan=\"$ctrl.loan\">\n        </loans-detail-statement-income>\n    </loans-detail-collapse>\n\n\n    <floating-action-buttons ng-if=\"$ctrl.showFloatingActionButtons()\"\n                             buttons=\"$ctrl.floatingActionButtons\"\n                             on-click-first-button=\"$ctrl.onNavigateSignUp()\">\n    </floating-action-buttons>\n\n  </section>\n\n</div>\n"

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(1774);
	
	var _loansModalities = __webpack_require__(1822);
	
	var _loansModalities2 = _interopRequireDefault(_loansModalities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MIN_AMOUNT = 120000;
	var FIXED_COEFFICIENT = 0.95;
	
	var LoansDetailController = function () {
	  LoansDetailController.$inject = ["$log", "$state", "$stateParams", "$window", "$q", "loansStaticService", "LoansUserDataService", "LoansOperationsService", "mainMenuMobileBehaviourService", "loadingMobileService"];
	  function LoansDetailController($log, $state, $stateParams, $window, $q, loansStaticService, LoansUserDataService, LoansOperationsService, mainMenuMobileBehaviourService, loadingMobileService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansDetailController);
	    this.log = $log;
	    this.state = $state;
	    this.stateParams = $stateParams;
	    this.window = $window;
	    this.q = $q;
	
	    this.loansStaticService = loansStaticService;
	    this.loansUserDataService = LoansUserDataService;
	    this.loansOperationsService = LoansOperationsService;
	    this.mainMenuMobileBehaviourService = mainMenuMobileBehaviourService;
	    this.loadingMobileService = loadingMobileService;
	
	    this.allowGoBack = this.stateParams.allowGoBack;
	    this.loanId = this.stateParams.loanId;
	    this.isMobileApp = $window.innerWidth < 1024;
	
	    this.loan = this.loansStaticService.get(this.loanId);
	    this.init();
	  }
	
	  (0, _createClass3.default)(LoansDetailController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.basicCharacteristicsOpened = this.stateParams.panel === 'basic-characteristics';
	
	      if (this.isMobileApp) {
	        this.mainMenuMobileBehaviourService.clean();
	      }
	
	      if (this.showFloatingActionButtons()) {
	        this.initFloatingActionButtons();
	      }
	
	      this.creditCapacityTypes = [_constants2.LOANS.ID.SOCIAL_HOUSING_LOAN, _constants2.LOANS.ID.AGREEMENT_HOUSING_LOAN];
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.log.info('LoansDetailController init()', this.loansUserDataService._employee.userId);
	      this.loadingMobileService.show();
	
	      this.dataTableBasicCharacteristics = this.loansStaticService.getDataTableBasicCharacteristics();
	      this.getModalities();
	
	      this.q.all([this.loansOperationsService.getCreditworthiness(this.loansUserDataService._employee.userId), this.loansOperationsService.getEuribor()]).then(function (responses) {
	        _this.creditworthiness = responses[0];
	        _this.simulationWitness = _this.creditworthiness.simulationWitness;
	        _this.euribor = responses[1].data.euribor;
	        _this.loaded = true;
	      }, function (error) {
	        _this.log.error('LoansDetailController init()', error);
	        // TODO: [Manu] eliminado ya que en la APP se ve un instante antes de redirigir a login, e incluso pueda causar otros problemas. Ver si en la Web es necesario o con el errorInterceptor es suficiente
	        // this.state.go(STATES.ERROR);
	      }).finally(function () {
	        _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      var _stateParams = this.stateParams,
	          loanId = _stateParams.loanId,
	          from = _stateParams.from,
	          originalFrom = _stateParams.originalFrom,
	          snapshot = _stateParams.snapshot;
	
	
	      var backupFrom = from;
	
	      var flowStartedAtNeedALoan = !!originalFrom && from !== originalFrom;
	
	      if (flowStartedAtNeedALoan) {
	        from = originalFrom;
	      }
	
	      this.state.go(backupFrom, { loanId: loanId, snapshot: snapshot, from: from, originalFrom: originalFrom });
	    }
	  }, {
	    key: 'showFloatingActionButtons',
	    value: function showFloatingActionButtons() {
	      return this.isMobileApp && !this.stateParams.from;
	    }
	  }, {
	    key: 'showNewCreditCapacity',
	    value: function showNewCreditCapacity() {
	      return this.creditCapacityTypes.includes(this.loanId) && this.simulationWitness;
	    }
	  }, {
	    key: 'initFloatingActionButtons',
	    value: function initFloatingActionButtons() {
	      this.floatingActionButtons = [{
	        literal: 'LOANS.LOANS_DETAIL.SIGN_UP'
	      }];
	    }
	  }, {
	    key: 'getCreditworthiness',
	    value: function getCreditworthiness() {
	      var _this2 = this;
	
	      this.log.info('LoansDetailController init() getCreditworthiness()', this.loansUserDataService._employee.userId);
	      this.loadingMobileService.show();
	
	      this.loansOperationsService.getCreditworthiness(this.loansUserDataService._employee.userId).then(function (creditworthiness) {
	        _this2.creditworthiness = creditworthiness;
	        _this2.loaded = true;
	      }, function (error) {
	        _this2.log.error('LoansDetailController init() getCreditworthiness()', error);
	        // TODO: [Manu] revisar esto, no debería hacer falta con errorInterceptor, no falla como en APP Ayuda Alimentaria pq en el routing de loans se hace esta misma llamada pero sin el state.go error
	        // this.state.go(STATES.ERROR);
	      }).finally(function () {
	        _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'getEuribor',
	    value: function getEuribor() {
	      var _this3 = this;
	
	      this.log.info('LoansDetailController init() getEuribor()');
	      this.loansOperationsService.getEuribor().then(function (response) {
	        _this3.euribor = response.data.euribor;
	      }, function (error) {
	        _this3.log.error('LoansDetailController init() getEuribor()', error);
	        // TODO: [Manu] revisar esto, no debería hacer falta con errorInterceptor, no falla como en APP Ayuda Alimentaria pq en el routing de loans se hace esta misma llamada pero sin el state.go error
	        // this.state.go(STATES.ERROR);
	      }).finally(function () {
	        _this3.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'getModalities',
	    value: function getModalities() {
	      var modalities = this.loansUserDataService.getModalities();
	      var loansModalitiesAssembler = new _loansModalities2.default(modalities);
	      var allPurposes = loansModalitiesAssembler.assemble();
	      this.loanPurposes = allPurposes[this.loanId];
	    }
	  }, {
	    key: 'hasPurposeSubtitle',
	    value: function hasPurposeSubtitle() {
	      return this.loanId === _constants2.LOANS.ID.FIVE_MONTH || this.loanId === _constants2.LOANS.ID.NINE_MONTH || this.loanId === _constants2.LOANS.ID.VARIOUS_CREDIT || this.loanId === _constants2.LOANS.ID.DIVERSAL_ATENTION;
	    }
	  }, {
	    key: 'isVariousCredit',
	    value: function isVariousCredit() {
	      return this.loanId === _constants2.LOANS.ID.VARIOUS_CREDIT;
	    }
	  }, {
	    key: 'isDiversalAtention',
	    value: function isDiversalAtention() {
	      return this.loanId === _constants2.LOANS.ID.DIVERSAL_ATENTION;
	    }
	  }, {
	    key: 'hasMinFeeSection',
	    value: function hasMinFeeSection() {
	      return this.loanId === _constants2.LOANS.ID.FIVE_MONTH || this.loanId === _constants2.LOANS.ID.NINE_MONTH;
	    }
	  }, {
	    key: 'calcMinFee',
	    value: function calcMinFee() {
	      if (this.serviceClosed) {
	        return;
	      }
	
	      var creditworthiness = this.creditworthiness;
	      var loanCreditworthiness = creditworthiness[this.loanId];
	      this.minimumFee = loanCreditworthiness.maximumLimit / this.loan.minMonthlyFeeDivider;
	    }
	  }, {
	    key: 'onNavigateSignUp',
	    value: function onNavigateSignUp() {
	      if (this.serviceClosed) {
	        return;
	      }
	
	      var loanId = this.loanId;
	      var from = _states.STATES.LOANS.DETAIL;
	      var creditworthiness = this.creditworthiness;
	      var creditworthinessOfLoan = creditworthiness[loanId];
	      var hireDate = creditworthiness.hireDate;
	
	      var hardReset = true;
	
	      try {
	        this.loansOperationsService.canSignUp(loanId, creditworthinessOfLoan, hireDate);
	        return this.state.go(_states.STATES.LOANS.SIGN_UP, { loanId: loanId, from: from, hardReset: hardReset });
	      } catch (reason) {
	        this.presentCannotSignUpModal(reason.message);
	      }
	    }
	  }, {
	    key: 'presentCannotSignUpModal',
	    value: function presentCannotSignUpModal(reason) {
	      this.cannotSignUpError = reason;
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'goMyLoans',
	    value: function goMyLoans() {
	      this.modal.modal('hide');
	      this.state.go(_states.STATES.LOANS.MY_LOANS);
	    }
	  }, {
	    key: 'calcTypeInterest',
	    value: function calcTypeInterest($event) {
	      if (this.serviceClosed) {
	        return;
	      }
	
	      this.coefficient = this.getCoefficient($event.amount);
	      this.resultTypeInterest = this.coefficient * this.euribor * 0.01;
	      this.resultTypeInterest = (Math.floor(this.resultTypeInterest * 1000) / 1000).toFixed(3) + ' %';
	      return this.resultTypeInterest;
	    }
	  }, {
	    key: 'getCoefficient',
	    value: function getCoefficient(amount) {
	      var theoricalCoefficient = (120000 * 0.95 + (amount - 120000) * 1.10) / amount;
	      var coefficient = amount < MIN_AMOUNT ? FIXED_COEFFICIENT : theoricalCoefficient;
	      var formattedCoefficient = coefficient * 100;
	      return formattedCoefficient;
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return $(_constants.MODALS.CANNOT_SIGNUP);
	    }
	  }]);
	  return LoansDetailController;
	}();
	
	exports.default = LoansDetailController;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansModalitiesAssembler = function () {
	  function LoansModalitiesAssembler(modalities) {
	    (0, _classCallCheck3.default)(this, LoansModalitiesAssembler);
	
	    this.modalities = modalities;
	  }
	
	  (0, _createClass3.default)(LoansModalitiesAssembler, [{
	    key: 'assemble',
	    value: function assemble() {
	      var result = {};
	      for (var loanId in _constants.LOANS.ID) {
	        var loanIdValue = _constants.LOANS.ID[loanId];
	        var purposes = this._findPurposesByHrId(loanId);
	        result[loanIdValue] = purposes.map(this._mapPurpose);
	      }
	
	      return result;
	    }
	  }, {
	    key: '_findPurposesByHrId',
	    value: function _findPurposesByHrId(loanId) {
	      var hrId = _constants.LOANS.ID_HR[loanId];
	      var loanPurposes = this.modalities.find(function (modality) {
	        return modality.code === hrId;
	      });
	      var purposes = [];
	      if (loanPurposes) {
	        purposes = loanPurposes.purposes;
	      }
	
	      return purposes;
	    }
	  }, {
	    key: '_mapPurpose',
	    value: function _mapPurpose(purpose) {
	      return {
	        value: purpose.code,
	        option: purpose.description
	      };
	    }
	  }]);
	  return LoansModalitiesAssembler;
	}();
	
	exports.default = LoansModalitiesAssembler;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1824);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetail.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetail.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail .loans-detail{display:block;margin-top:14px}loans-detail .loans-detail.mobile{margin-top:0;margin-bottom:75px;padding-top:0!important;padding-left:0!important;padding-right:0!important}loans-detail .loans-detail .go-back{cursor:pointer}loans-detail .loans-detail .go-back span{font-family:Stag Sans;font-size:15px;color:#0072c9;text-transform:uppercase}loans-detail .loans-detail .go-back span.icon{transform:rotate(270deg);display:inline-block;margin-right:15px;margin-bottom:28px}", ""]);
	
	// exports


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansDetailHeader = __webpack_require__(1826);
	
	var _loansDetailHeader2 = _interopRequireDefault(_loansDetailHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansCatalogDetailHeaderModule = _angular2.default.module('loansDetailHeader', []).component('loansDetailHeader', _loansDetailHeader2.default).name;
	
	exports.default = loansCatalogDetailHeaderModule;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailHeader = __webpack_require__(1827);
	
	var _loansDetailHeader2 = _interopRequireDefault(_loansDetailHeader);
	
	__webpack_require__(1828);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansCatalogDetailHeaderComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    hideSignup: '<',
	    onNavigate: '&',
	    isMobileApp: '<'
	  },
	  template: _loansDetailHeader2.default
	};
	
	exports.default = loansCatalogDetailHeaderComponent;

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-catalog-detail-header\"\n     ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <img ng-src=\"{{$ctrl.loan.header}}\">\n\n  <div class=\"detail-header-title\">\n    <h1>{{ $ctrl.loan.detail.title | translate }}</h1>\n\n    <button ng-hide=\"$ctrl.hideSignup\"\n            ng-click=\"$ctrl.onNavigate()\"\n            class=\"btn btn-app btn-default btn-signup\">\n      {{ 'LOANS.LOANS_DETAIL.SIGN_UP' | translate }}\n    </button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1829);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailHeader.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailHeader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-header{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block}loans-detail-header .loans-catalog-detail-header{position:relative}loans-detail-header .loans-catalog-detail-header img{height:189px;width:100%}loans-detail-header .loans-catalog-detail-header .detail-header-title{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;width:100%;height:100%;position:absolute;top:0;padding-left:53px;padding-right:21px}loans-detail-header .loans-catalog-detail-header .detail-header-title h1{font-family:Stag Sans;font-weight:400;font-size:36px;color:#fff;text-shadow:1px 2px 4px rgba(0,0,0,.37)}loans-detail-header .loans-catalog-detail-header .detail-header-title .btn-app.btn-default{width:227px;height:70px;background-color:#f9f9f9;border:1px solid #dddfe2;line-height:73px}loans-detail-header .loans-catalog-detail-header.mobile{margin-top:30px;margin-left:-30px;margin-right:-30px}loans-detail-header .loans-catalog-detail-header.mobile img{object-fit:cover;font-family:object-fit\\: cover;height:180px}loans-detail-header .loans-catalog-detail-header.mobile .detail-header-title{padding-left:20px;padding-right:20px;padding-bottom:20px;-ms-flex-align:end;-moz-align-items:flex-end;align-items:flex-end}loans-detail-header .loans-catalog-detail-header.mobile .detail-header-title h1{font-size:22px;margin-left:22px;width:100%}loans-detail-header .loans-catalog-detail-header.mobile button{display:none}", ""]);
	
	// exports


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansDetailCollapse = __webpack_require__(1831);
	
	var _loansDetailCollapse2 = _interopRequireDefault(_loansDetailCollapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailCollapseModule = _angular2.default.module('loansDetailCollapse', [_angularUiRouter2.default]).component('loansDetailCollapse', _loansDetailCollapse2.default).name;
	
	exports.default = loansDetailCollapseModule;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailCollapse = __webpack_require__(1832);
	
	var _loansDetailCollapse2 = _interopRequireDefault(_loansDetailCollapse);
	
	var _loansDetailCollapse3 = __webpack_require__(1833);
	
	var _loansDetailCollapse4 = _interopRequireDefault(_loansDetailCollapse3);
	
	__webpack_require__(1834);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailCollapseComponent = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {
	    title: '@',
	    subtitle: '@',
	    opened: '<',
	    isMobileApp: '<'
	  },
	  template: _loansDetailCollapse2.default,
	  controller: _loansDetailCollapse4.default
	};
	
	exports.default = loansDetailCollapseComponent;

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-detail-collapse\" ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n  <div class=\"loans-detail-collapse-header\" ng-click=\"$ctrl.toggleMoreInfo()\">\n    <h2 class=\"title\">{{ $ctrl.title | translate }}</h2>\n    <i class=\"icon icon-arrow-select-down\" ng-class=\"{ 'show-info-rotation': $ctrl.moreInfoIsVisible === true }\">\n    </i>\n    <p>{{ $ctrl.subtitle | translate }}</p>\n  </div>\n  <div ng-show=\"$ctrl.moreInfoIsVisible\">\n    <ng-transclude></ng-transclude>\n  </div>\n</div>\n"

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansDetailCollapseController = function () {
	  function LoansDetailCollapseController() {
	    (0, _classCallCheck3.default)(this, LoansDetailCollapseController);
	
	    this.moreInfoIsVisible = false;
	  }
	
	  (0, _createClass3.default)(LoansDetailCollapseController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.opened === true) this.moreInfoIsVisible = true;
	    }
	  }, {
	    key: 'toggleMoreInfo',
	    value: function toggleMoreInfo() {
	      this.moreInfoIsVisible = !this.moreInfoIsVisible;
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        'more-info-text-is-show': this.moreInfoIsVisible === true,
	        'more-info-text-is-hide': this.moreInfoIsVisible !== true
	      };
	    }
	  }]);
	  return LoansDetailCollapseController;
	}();
	
	exports.default = LoansDetailCollapseController;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1835);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailCollapse.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailCollapse.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-collapse .loans-detail-collapse{border-top:1px solid #dddfe2;padding:26px 32px 36px}loans-detail-collapse .loans-detail-collapse.mobile,loans-detail-collapse .loans-detail-collapse.responsiveMobile{padding:26px 20px}loans-detail-collapse .loans-detail-collapse.mobile i,loans-detail-collapse .loans-detail-collapse.responsiveMobile i{margin-top:0}loans-detail-collapse .loans-detail-collapse.mobile .loans-detail-collapse-header>.title,loans-detail-collapse .loans-detail-collapse.responsiveMobile .loans-detail-collapse-header>.title{width:84%;font-size:16px}loans-detail-collapse .loans-detail-collapse.mobile .loans-detail-collapse-header p,loans-detail-collapse .loans-detail-collapse.responsiveMobile .loans-detail-collapse-header p{width:84%;font-size:13px}loans-detail-collapse .loans-detail-collapse.mobile p,loans-detail-collapse .loans-detail-collapse.responsiveMobile p{font-size:13px;text-align:left}loans-detail-collapse .loans-detail-collapse.mobile .more-info-text-is-show,loans-detail-collapse .loans-detail-collapse.responsiveMobile .more-info-text-is-show{max-height:none;padding-top:15px;transition:all 1s ease-in-out}loans-detail-collapse .loans-detail-collapse.mobile .more-info-text-is-hide,loans-detail-collapse .loans-detail-collapse.responsiveMobile .more-info-text-is-hide{max-height:none;transition:all 1s ease-in-out;opacity:0}loans-detail-collapse .loans-detail-collapse-header{cursor:pointer}loans-detail-collapse .loans-detail-collapse a:hover{background-color:transparent;cursor:pointer;text-decoration:none}loans-detail-collapse .loans-detail-collapse h2.title{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;font-family:Stag Sans;font-weight:400;font-size:24px;margin:0 0 6px;color:#0072c9}loans-detail-collapse .loans-detail-collapse i{float:right;margin-top:17px;margin-right:14px;font-size:12px;color:#287cba;transition:.7s}loans-detail-collapse .loans-detail-collapse i.show-info-rotation{transform:rotate(180deg)}loans-detail-collapse .loans-detail-collapse p{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:ArialMT;font-size:15px;text-align:justify;color:#666}loans-detail-collapse .legal-conditions-borderbottom .loans-detail-collapse{border-bottom:1px solid #dddfe2;margin-bottom:25px}", ""]);
	
	// exports


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansDetailPurposes = __webpack_require__(1837);
	
	var _loansDetailPurposes2 = _interopRequireDefault(_loansDetailPurposes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailPurposesModule = _angular2.default.module('loansDetailPurposes', [_angularUiRouter2.default]).component('loansDetailPurposes', _loansDetailPurposes2.default).name;
	
	exports.default = loansDetailPurposesModule;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailPurposes = __webpack_require__(1838);
	
	var _loansDetailPurposes2 = _interopRequireDefault(_loansDetailPurposes);
	
	__webpack_require__(1839);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailPurposesComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    isMobileApp: '<'
	  },
	  template: _loansDetailPurposes2.default
	};
	
	exports.default = loansDetailPurposesComponent;

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-detail-purposes\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <ul>\n    <li ng-repeat=\"purpose in $ctrl.loan\">\n      {{ purpose.option | capitalizeFirst }}\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1840);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailPurposes.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailPurposes.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-purposes .loans-detail-purposes.mobile ul{columns:100px 1;list-style-position:unset;padding-top:0}loans-detail-purposes .loans-detail-purposes.mobile li{font-size:13px}loans-detail-purposes .loans-detail-purposes ul{columns:50px 2;list-style-position:inside;padding-top:14px;padding-left:20px}loans-detail-purposes .loans-detail-purposes li{font-size:15px;padding-top:8px;padding-bottom:8px}", ""]);
	
	// exports


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansDetailBasicCharacteristics = __webpack_require__(1842);
	
	var _loansDetailBasicCharacteristics2 = _interopRequireDefault(_loansDetailBasicCharacteristics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailBasicCharacteristicsModule = _angular2.default.module('loansDetailBasicCharacteristics', [_angularUiRouter2.default]).component('loansDetailBasicCharacteristics', _loansDetailBasicCharacteristics2.default).name;
	
	exports.default = loansDetailBasicCharacteristicsModule;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailBasicCharacteristics = __webpack_require__(1843);
	
	var _loansDetailBasicCharacteristics2 = _interopRequireDefault(_loansDetailBasicCharacteristics);
	
	var _loansDetailBasicCharacteristics3 = __webpack_require__(1844);
	
	var _loansDetailBasicCharacteristics4 = _interopRequireDefault(_loansDetailBasicCharacteristics3);
	
	__webpack_require__(1845);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailBasicCharacteristicsComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    datatable: '<',
	    onClick: '&',
	    resultTypeInterest: '<',
	    coefficient: '<',
	    serviceClosed: '<',
	    isMobileApp: '<'
	  },
	  template: _loansDetailBasicCharacteristics2.default,
	  controller: _loansDetailBasicCharacteristics4.default
	};
	
	exports.default = loansDetailBasicCharacteristicsComponent;

/***/ }),
/* 1843 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-detail-basic-characteristics\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"loans-detail-basic-characteristics-item\"\n    ng-repeat=\"basicCharacteristics in $ctrl.loan.detail.basicCharacteristics track by $index\">\n    <h4 ng-class=\"{ 'spacing': basicCharacteristics.hasMargin }\">\n      {{ basicCharacteristics.title | translate }}\n    </h4>\n\n    <p ng-class=\"{ 'spacing': basicCharacteristics.hasMargin }\" ng-if=\"!$ctrl.isArray(basicCharacteristics.desc)\">\n      {{ basicCharacteristics.desc | translate }}\n            <ul>\n        <li ng-repeat=\"list in basicCharacteristics.list \">\n          <span ng-bind-html=\"list.text | translate\"></span>\n        </li>\n      </ul>\n    </p>\n\n    <p ng-class=\"{ 'spacing': basicCharacteristics.hasMargin }\" ng-if=\"$ctrl.isArray(basicCharacteristics.desc)\"\n      ng-repeat=\"description in basicCharacteristics.desc track by $index\">\n      <span ng-if=\"$ctrl.isTypeObject(description)\">\n        {{ description.text | translate }}\n        <a href=\"mailto:{{description.mail}}\" target=\"_blank\" ng-if=\"description.mail\">\n          ({{ description.mail }})\n        </a>\n        <a href=\"{{ description.redirect }}\" target=\"_blank\" ng-if=\"description.textRedirect\">\n          {{ description.textRedirect | translate }}\n        </a>\n      </span>\n      <span ng-if=\"!$ctrl.isTypeObject(description)\">\n        {{ description | translate }}\n      </span>\n    </p>\n\n    <p>{{ basicCharacteristics.dataLink.text | translate }}\n      <a ui-sref=\"loans.{{ basicCharacteristics.dataLink.link }}\">\n        {{ basicCharacteristics.dataLink.textLink | translate }}</a>\n    </p>\n\n    <div class=\"more-data\" ng-repeat=\"amountData in basicCharacteristics.amountMax\">\n      <h5>{{ amountData.title | translate }}</h5>\n      <p>{{ amountData.paragraph | translate }}</p>\n      <ul>\n        <li ng-repeat=\"list in amountData.list\">\n          {{ list.text | translate }}\n          <a ui-sref=\"loans.{{ list.link }}\">{{ list.textLink | translate }}</a>\n        </li>\n      </ul>\n      <p class=\"info\" ng-repeat=\"info in amountData.info\">\n        {{ info | translate }}<br>\n      </p>\n    </div>\n\n    <p ng-repeat=\"item in basicCharacteristics.paragraphs\">\n      {{ item | translate }}\n    </p>\n\n    <div ng-class=\"{ 'spacing': basicCharacteristics.hasMargin }\" ng-repeat=\"typeInterest in basicCharacteristics.typeInterest\">\n\n      <!-- Formula -->\n      <div class=\"type-interest\">\n        <table class=\"table-formula\" ng-if=\"$ctrl.onGetLoanId()\">\n            <tr>\n              <th colspan=\"4\">{{ typeInterest.formula.title | translate }}</th>\n            </tr>\n            <tr>\n              <td rowspan=\"2\" ng-if=\"!$ctrl.isMobileApp\" class=\"coefficient\">{{ typeInterest.formula.coefficient | translate }}</td>\n              <td rowspan=\"2\" ng-if=\"$ctrl.isMobileApp\" class=\"coefficient\">{{ typeInterest.formula.coefficient + '_MOBILE' | translate }}</td>\n              <td ng-if=\"!$ctrl.isMobileApp\">{{ typeInterest.formula.nominator | translate }}</td>\n              <td ng-if=\"$ctrl.isMobileApp\" class=\"text-center\">{{ (typeInterest.formula.nominator + '_MOBILE') | translate }}</td>\n            </tr>\n            <tr ng-if=\"typeInterest.formula.denominator !== undefined\">\n              <td ng-if=\"!$ctrl.isMobileApp\" class=\"denominator\">{{ typeInterest.formula.denominator | translate }}</td>\n              <td ng-if=\"$ctrl.isMobileApp\" class=\"denominator text-center\">{{ (typeInterest.formula.denominator + '_MOBILE') | translate }}</td>\n            </tr>\n            <tr ng-if=\"$ctrl.isMobileApp\">\n              <td colspan=\"2\">\n                {{ (typeInterest.formula.denominator + '_MOBILE_LEGEND_1') | translate }}\n                <br>\n                {{ (typeInterest.formula.denominator + '_MOBILE_LEGEND_2') | translate }}\n              </td>\n            </tr>\n          </table>\n\n        <div ng-if=\"$ctrl.onGetLoanId()\" class=\"calc-coefficient\">\n          <form name=\"$ctrl.form\" ng-submit=\"$ctrl.onClick({$event: {amount: $ctrl.amount}})\" novalidate>\n            <label class=\"uppercase medium blue block how-much-money\" for=\"amount\">\n              {{ 'LOANS.SIGN_UP.FORM_SIMULATION.HOW_MUCH_MONEY' | translate }}\n            </label>\n            <input\n              type=\"text\"\n              id=\"amount\"\n              class=\"amount\"\n              name=\"amount\"\n              currency-input\n              required\n              ng-model=\"$ctrl.amount\"\n              ng-disabled=\"$ctrl.serviceClosed\">\n            <div class=\"calc-coefficient-result\">\n              <button type=\"submit\" class=\"btn btn-app btn-primary calc-button\" ng-disabled=\"$ctrl.form.$invalid || !$ctrl.amount\">\n                {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_CALC' | translate}}\n              </button>\n            </div>\n            <div class=\"calc-coefficient-result\">\n                <p ng-if=\"$ctrl.resultTypeInterest !== undefined\" class=\"animation-appear\">\n                    <span class=\"result-coeficient\">{{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.COEFFICIENT' | translate}}:</span>\n                    <span>{{ $ctrl.coefficient.toFixed(3) }}%</span>\n                    <br>\n                    <span class=\"result-interest\">{{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE4' | translate}}:</span>\n                    <span>{{ $ctrl.resultTypeInterest }}</span>\n                </p>\n            </div>\n          </form>\n        </div>\n      </div>\n\n      <div class=\"ml-2\" ng-if=\"$ctrl.loanId !== 'fiveMonth' && $ctrl.loanId !== 'nineMonth'\">\n        <div class=\"table-responsive\">\n          <table class=\"table table-bordered table-historic\">\n            <tr>\n              <th colspan=\"{{ $ctrl.getTableColumns() }}\">{{ typeInterest.table.titleTable | translate }}</th>\n            </tr>\n            <tr>\n              <td ng-repeat=\"year in $ctrl.datatable[$ctrl.loanId].years\" class=\"years\">{{ year }}</td>\n            </tr>\n            <tr>\n              <td ng-repeat=\"interest in $ctrl.datatable[$ctrl.loanId].percentage track by $index\">\n                <span ng-if= \"$ctrl.datatable[$ctrl.loanId].percentage[$index]\">{{ interest }} %</span>\n              </td>\n            </tr>\n          </table>\n        </div>\n        <div class=\"table-euribor\">\n          <table class=\"table table-bordered table-historic\">\n            <tr>\n              <th colspan=\"2\">{{ typeInterest.table.titleTable | translate }}</th>\n            </tr>\n            <tr ng-repeat=\"mobileDataRow in $ctrl.getMobileInterestRows()\">\n              <td>\n                {{ mobileDataRow.year }}\n              </td>\n              <td>\n                <span ng-if= \"mobileDataRow.percentage\">{{ mobileDataRow.percentage }} %</span>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div ng-class=\"{ 'spacing': basicCharacteristics.hasMargin }\" class=\"fixed-margin\" ng-repeat=\"typeInterestFixed in basicCharacteristics.typeInterestFixed\">\n      <div ng-if=\"$ctrl.loanId === 'socialHousingLoan' || $ctrl.loanId === 'agreementHousingLoan'\">\n        <div class=\"table-responsive\">\n          <table class=\"table table-bordered table-historic\">\n            <tr>\n              <th colspan=\"{{ $ctrl.getTableColumns() }}\">{{ typeInterestFixed.table.titleTable | translate }}</th>\n            </tr>\n            <tr>\n              <td ng-if=\"$ctrl.loanId === 'socialHousingLoan'\" ng-repeat=\"element in $ctrl.socialHousingLoan\" class=\"years\">{{ element.date }}</td>\n            </tr>\n            <tr>\n              <td ng-if=\"$ctrl.loanId === 'socialHousingLoan'\" ng-repeat=\"element in $ctrl.socialHousingLoan\">\n                <span >{{ element.interest }} %</span>\n              </td>\n            </tr>\n            <tr>\n              <td ng-if=\"$ctrl.loanId === 'agreementHousingLoan'\" ng-repeat=\"element in $ctrl.agreementHousingLoan\" class=\"years\">{{ element.date }}</td>\n            </tr>\n            <tr>\n              <td ng-if=\"$ctrl.loanId === 'agreementHousingLoan'\" ng-repeat=\"element in $ctrl.agreementHousingLoan\">\n                <span >{{ element.interest }} %</span>\n              </td>\n            </tr>\n          </table>\n        </div>\n        <div class=\"table-euribor\">\n          <table class=\"table table-bordered table-historic\">\n            <tr>\n              <th colspan=\"2\">{{ typeInterestFixed.table.titleTable | translate }}</th>\n            </tr>\n            <tr ng-if=\"$ctrl.loanId === 'socialHousingLoan'\" ng-repeat=\"element in $ctrl.socialHousingLoan\">\n              <td class=\"years\">{{ element.date }}</td>\n              <td><span >{{ element.interest }} %</span></td>\n            </tr>\n            <tr ng-if=\"$ctrl.loanId === 'agreementHousingLoan'\" ng-repeat=\"element in $ctrl.agreementHousingLoan\">\n              <td class=\"years\">{{ element.date }}</td>\n              <td><span >{{ element.interest }} %</span></td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(649);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansDetailBasicCharacteristicsController = function () {
	  LoansDetailBasicCharacteristicsController.$inject = ["$stateParams", "$q", "LoansOperationsService"];
	  function LoansDetailBasicCharacteristicsController($stateParams, $q, LoansOperationsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansDetailBasicCharacteristicsController);
	    this.loanId = $stateParams.loanId;
	    this.q = $q;
	    this.loansOperationsService = LoansOperationsService;
	    this.createTableFixed();
	  }
	
	  (0, _createClass3.default)(LoansDetailBasicCharacteristicsController, [{
	    key: 'isArray',
	    value: function isArray(value) {
	      return Array.isArray(value);
	    }
	  }, {
	    key: 'whatLoansDetailIs',
	    value: function whatLoansDetailIs(loanType) {
	      return this.loanId === loanType;
	    }
	  }, {
	    key: 'onGetLoanId',
	    value: function onGetLoanId() {
	      return this.loanId === _constants.LOANS.ID.SOCIAL_HOUSING_LOAN;
	    }
	  }, {
	    key: 'isSocialAgreementHousingLoan',
	    value: function isSocialAgreementHousingLoan() {
	      return this.loanId === _constants.LOANS.ID.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'isSocialHousingLoan',
	    value: function isSocialHousingLoan() {
	      return this.loanId === _constants.LOANS.ID.SOCIAL_HOUSING_LOAN;
	    }
	  }, {
	    key: 'isTypeObject',
	    value: function isTypeObject(description) {
	      return (typeof description === 'undefined' ? 'undefined' : (0, _typeof3.default)(description)) === 'object';
	    }
	  }, {
	    key: 'getTableColumns',
	    value: function getTableColumns() {
	      return this.datatable[this.loanId].years.length;
	    }
	  }, {
	    key: 'getMobileInterestRows',
	    value: function getMobileInterestRows() {
	      var loanTable = this.datatable[this.loanId] || {};
	
	      if (Array.isArray(loanTable.dataTableOnMobileApp)) {
	        return loanTable.dataTableOnMobileApp;
	      }
	
	      var legacyKey = (0, _keys2.default)(loanTable).find(function (key) {
	        return key.indexOf('dataTableOn') === 0;
	      });
	      return legacyKey ? loanTable[legacyKey] : [];
	    }
	  }, {
	    key: 'createTableFixed',
	    value: function createTableFixed() {
	      var _this = this;
	
	      var httpSV = this.loansOperationsService.getInterestSV();
	      var httpVC = this.loansOperationsService.getInterestVC();
	      this.q.all([httpSV, httpVC]).then(function (values) {
	        _this.socialHousingLoan = _this.formatList(values[0].data.interestSV);
	        _this.agreementHousingLoan = _this.formatList(values[1].data.interestVC);
	      });
	    }
	  }, {
	    key: 'formatList',
	    value: function formatList(info) {
	      var auxList = [];
	      var date = 0;
	      info.forEach(function (element) {
	        date = Math.round((element.monthEnd - element.monthStart) / 12) + date;
	        auxList.push({ date: 'Hasta ' + date + ' años', interest: element.interestType });
	      });
	      return auxList;
	    }
	  }]);
	  return LoansDetailBasicCharacteristicsController;
	}();
	
	exports.default = LoansDetailBasicCharacteristicsController;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1846);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailBasicCharacteristics.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailBasicCharacteristics.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-basic-characteristics .loans-detail-basic-characteristics{margin-top:25px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .spacing{margin-left:35px}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .loans-detail-basic-characteristics-item{padding-right:0}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .loans-detail-basic-characteristics-item p{display:inline}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .type-interest{padding-left:0}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .calc-coefficient form{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .calc-coefficient form button{margin-top:15px}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .calc-coefficient-result{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .calc-coefficient-result p{margin-left:0;margin-top:10px}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .fixed-margin{margin-left:15px}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .table-responsive{display:none}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .table-euribor{display:block}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .table-formula{font-size:13px}loans-detail-basic-characteristics .loans-detail-basic-characteristics.mobile .table-formula .coefficient{padding-left:0}loans-detail-basic-characteristics .loans-detail-basic-characteristics-item{padding-bottom:3px;padding-right:70px}loans-detail-basic-characteristics .loans-detail-basic-characteristics-item h4{color:#0072c9;text-transform:uppercase;font-size:13px;font-weight:400;margin-bottom:6px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .how-much-money{float:left;margin-right:34px;margin-top:10px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .amount{float:left;margin-right:39px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .calc-button{bottom:7px;position:relative}loans-detail-basic-characteristics .loans-detail-basic-characteristics .result-coeficient{margin-right:80px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .result-interest{margin-right:54px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .type-interest{padding-left:11px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .more-data{padding-top:10px}loans-detail-basic-characteristics .loans-detail-basic-characteristics h5{color:#0072c9;font-size:13px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .info{font-size:12px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-formula{margin-bottom:25px;margin-top:25px;color:#666;font-size:15px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-formula th{color:#0072c9;font-weight:500;padding-bottom:15px;font-size:13px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-formula .coefficient{padding-left:15px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-formula .denominator{border-top:1px solid #666;text-align:center}loans-detail-basic-characteristics .loans-detail-basic-characteristics .calc-coefficient{margin-top:25px;margin-bottom:25px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .calc-coefficient-result{margin-top:10px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .calc-coefficient-result .btn.btn-app{width:200px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .calc-coefficient-result p{display:inline-block}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-interes{width:46%;margin:20px 0 38px 13px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-interes th{font-weight:400;font-size:13px;text-align:center;padding:18px 18px 13px;text-transform:uppercase}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-interes td{color:#666;font-size:15px;padding:17px 20px 7px 30px;border-bottom:0!important;border-top:0}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-interes td:last-child{border-bottom:1px solid #dddfe2}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-historic{text-align:center;margin-top:20px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-historic th{font-weight:400;text-align:center;text-transform:uppercase;padding:14px}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-historic td{padding:17px;color:#666}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-historic .years{font-weight:500}loans-detail-basic-characteristics .loans-detail-basic-characteristics .table-euribor{display:none}", ""]);
	
	// exports


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansDetailMinimumFee = __webpack_require__(1848);
	
	var _loansDetailMinimumFee2 = _interopRequireDefault(_loansDetailMinimumFee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailMinimumFeeModule = _angular2.default.module('loansDetailMinimumFee', [_angularUiRouter2.default]).component('loansDetailMinimumFee', _loansDetailMinimumFee2.default).name;
	
	exports.default = loansDetailMinimumFeeModule;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailMinimumFee = __webpack_require__(1849);
	
	var _loansDetailMinimumFee2 = _interopRequireDefault(_loansDetailMinimumFee);
	
	var _loansDetailMinimumFee3 = __webpack_require__(1850);
	
	var _loansDetailMinimumFee4 = _interopRequireDefault(_loansDetailMinimumFee3);
	
	__webpack_require__(1851);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailMinimumFeeComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    onClick: '&',
	    minimumFee: '<',
	    isMobileApp: '<'
	  },
	  template: _loansDetailMinimumFee2.default,
	  controller: _loansDetailMinimumFee4.default
	};
	
	exports.default = loansDetailMinimumFeeComponent;

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-detail-minimum-fee\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <button type=\"button\" class=\"btn btn-app btn-primary\" ng-click=\"$ctrl.onClick()\">{{ $ctrl.loan.detail.minimumFee | translate }}</button>\n  <p class=\"minimum-fee\"\n     ng-if=\"$ctrl.minimumFee !== undefined\">\n    {{ $ctrl.loan.detail.minimumFeeResult | translate }} = <span>{{ $ctrl.minimumFee | currency }}</span>\n  </p>\n</div>"

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansDetailMinimumFeeController = function LoansDetailMinimumFeeController() {
	  (0, _classCallCheck3.default)(this, LoansDetailMinimumFeeController);
	};
	
	exports.default = LoansDetailMinimumFeeController;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1852);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailMinimumFee.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailMinimumFee.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-minimum-fee .loans-detail-minimum-fee{padding-top:17px;align-items:center;display:-moz-flex;display:-ms-flexbox;display:flex}loans-detail-minimum-fee .loans-detail-minimum-fee.mobile{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;-moz-align-items:start;align-items:start}loans-detail-minimum-fee .loans-detail-minimum-fee.mobile .btn-app.btn-primary{width:210px;height:38px;line-height:41px;margin-bottom:20px}loans-detail-minimum-fee .loans-detail-minimum-fee.mobile .minimum-fee{margin-left:0}loans-detail-minimum-fee .loans-detail-minimum-fee .btn-app.btn-primary{width:252px;height:48px;line-height:52px}loans-detail-minimum-fee .loans-detail-minimum-fee .minimum-fee{margin-left:50px;margin-bottom:0}loans-detail-minimum-fee .loans-detail-minimum-fee .minimum-fee span{font-weight:700;font-size:15px}", ""]);
	
	// exports


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansDetailRequestIt = __webpack_require__(1854);
	
	var _loansDetailRequestIt2 = _interopRequireDefault(_loansDetailRequestIt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailRequestItModule = _angular2.default.module('loansDetailRequestIt', [_angularUiRouter2.default]).component('loansDetailRequestIt', _loansDetailRequestIt2.default).name;
	
	exports.default = loansDetailRequestItModule;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailRequestIt = __webpack_require__(1855);
	
	var _loansDetailRequestIt2 = _interopRequireDefault(_loansDetailRequestIt);
	
	var _loansDetailRequestIt3 = __webpack_require__(1856);
	
	var _loansDetailRequestIt4 = _interopRequireDefault(_loansDetailRequestIt3);
	
	__webpack_require__(1857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailRequestItComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    isMobileApp: '<'
	  },
	  template: _loansDetailRequestIt2.default,
	  controller: _loansDetailRequestIt4.default
	};
	
	exports.default = loansDetailRequestItComponent;

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-detail-request-it\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"loans-detail-request-it-item\" ng-repeat=\"data in $ctrl.loan.detail.requestIt\">\n    <p>{{ data.paragraph | translate }}</p>\n    <ul class=\"first-list\">\n      <li ng-repeat=\"item in data.items\">\n        {{ item.text | translate }}\n        <a ng-click=\"$ctrl.redirectFunctions[item.link]()\">{{ item.textLink | translate }}</a>\n        <span ng-if=\"item.text2 !== undefined\">{{ item.text2 | translate }}</span>\n        <a ng-if=\"item.link2 !== undefined\" ui-sref=\"loans.{{ item.link2 }}\">{{ item.textLink2 | translate }}</a>\n      </li>\n    </ul>\n    <ul class=\"second-list\">\n      <li ng-repeat=\"otherItems in data.otherItems\">\n        {{ otherItems.text | translate }}\n        <a ng-if=\"otherItems.link !== undefined\"\n           ui-sref=\"loans.{{ otherItems.link }}\">\n          {{ otherItems.textLink | translate }}\n        </a>\n        <ul ng-if=\"otherItems.items !== undefined\" class=\"third-list\">\n          <li ng-repeat=\"list2 in otherItems.items\">\n            {{ list2 | translate }}\n          </li>\n        </ul>\n      </li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansDetailRequestItController = function LoansDetailRequestItController($state, $stateParams) {
	  'ngInject';
	
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, LoansDetailRequestItController);
	  this.state = $state;
	  this.loanId = $stateParams.loanId;
	
	  this.redirectFunctions = {
	    'my-creditworthiness': function myCreditworthiness() {
	      return _this.state.go(_states.STATES.LOANS.CREDITWORTHINESS);
	    },
	    'my-loans': function myLoans() {
	      return _this.state.go(_states.STATES.LOANS.MY_LOANS);
	    },
	    'sign-up': function signUp() {
	      return _this.state.go(_states.STATES.LOANS.SIGN_UP, { loanId: _this.loanId });
	    },
	    'need-a-loan': function needALoan() {
	      return _this.state.go(_states.STATES.LOANS.NEED_A_LOAN);
	    }
	  };
	};
	LoansDetailRequestItController.$inject = ["$state", "$stateParams"];
	
	exports.default = LoansDetailRequestItController;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1858);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailRequestIt.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailRequestIt.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-request-it .loans-detail-request-it{text-align:justify;padding-top:18px;padding-right:70px}loans-detail-request-it .loans-detail-request-it.mobile{padding-right:0;text-align:left}loans-detail-request-it .loans-detail-request-it.mobile ul{list-style-position:unset;font-size:13px}loans-detail-request-it .loans-detail-request-it.mobile p{text-align:left}loans-detail-request-it .loans-detail-request-it ul{font-size:15px;list-style-position:inside}loans-detail-request-it .loans-detail-request-it .first-list{padding-top:10px;padding-left:26px}loans-detail-request-it .loans-detail-request-it .first-list li{padding-bottom:20px}loans-detail-request-it .loans-detail-request-it .second-list{list-style-type:decimal}loans-detail-request-it .loans-detail-request-it .second-list li{padding-left:10px;padding-bottom:20px}loans-detail-request-it .loans-detail-request-it .third-list{padding-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansDetailPrepayments = __webpack_require__(1860);
	
	var _loansDetailPrepayments2 = _interopRequireDefault(_loansDetailPrepayments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailPrepaymentsModule = _angular2.default.module('loansDetailPrepayments', [_angularUiRouter2.default]).component('loansDetailPrepayments', _loansDetailPrepayments2.default).name;
	
	exports.default = loansDetailPrepaymentsModule;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailPrepayments = __webpack_require__(1861);
	
	var _loansDetailPrepayments2 = _interopRequireDefault(_loansDetailPrepayments);
	
	var _loansDetailPrepayments3 = __webpack_require__(1862);
	
	var _loansDetailPrepayments4 = _interopRequireDefault(_loansDetailPrepayments3);
	
	__webpack_require__(1863);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailPrepaymentsComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    isMobileApp: '<'
	  },
	  template: _loansDetailPrepayments2.default,
	  controller: _loansDetailPrepayments4.default
	};
	
	exports.default = loansDetailPrepaymentsComponent;

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-detail-prepayments\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <p ng-repeat=\"data in $ctrl.loan.detail.prepayments\">\n    <span>{{ data.text | translate }}</span>\n    <span ng-if=\"data.boldText\" class=\"bold\">{{ data.boldText | translate }}</span>\n    <span ng-if=\"data.text2\">{{ data.text2 | translate }}</span>\n    <span ng-if=\"data.boldText2\" class=\"bold\">{{ data.boldText2 | translate }}</span>\n\n    <a ng-class=\"{bold: data.boldText}\" ng-if=\"data.link\" ui-sref=\"loans.{{ data.link }}\">{{ data.textLink | translate }}</a>\n    <a ng-class=\"{bold: data.boldText}\"  ng-if=\"data.mail\" href=\"mailto:{{data.mail}}\" target=\"_blank\">\n      {{ data.textMail | translate }}\n    </a>\n    <span ng-if=\"data.text3\">{{ data.text3 | translate }}</span>\n  </p>\n</div>"

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansDetailPrepaymentsController = function LoansDetailPrepaymentsController() {
	  (0, _classCallCheck3.default)(this, LoansDetailPrepaymentsController);
	};
	
	exports.default = LoansDetailPrepaymentsController;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1864);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailPrepayments.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailPrepayments.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-prepayments .loans-detail-prepayments{padding-top:17px;padding-right:70px}loans-detail-prepayments .loans-detail-prepayments.mobile{padding-right:0}loans-detail-prepayments .loans-detail-prepayments-paragraph1{padding-bottom:11px}loans-detail-prepayments .loans-detail-prepayments-paragraph2{margin-bottom:0}loans-detail-prepayments .loans-detail-prepayments .bold{font-weight:700}loans-detail-prepayments .loans-detail-prepayments ul{list-style:none;padding-left:0}loans-detail-prepayments .loans-detail-prepayments ul li{font-size:15px}loans-detail-prepayments .loans-detail-prepayments ul li:before{content:\"\\2022\";margin-right:20px}", ""]);
	
	// exports


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansDetailSendDocumentation = __webpack_require__(1866);
	
	var _loansDetailSendDocumentation2 = _interopRequireDefault(_loansDetailSendDocumentation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailSendDocumentationModule = _angular2.default.module('loansDetailSendDocumentation', [_angularUiRouter2.default]).component('loansDetailSendDocumentation', _loansDetailSendDocumentation2.default).name;
	
	exports.default = loansDetailSendDocumentationModule;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailSendDocumentation = __webpack_require__(1867);
	
	var _loansDetailSendDocumentation2 = _interopRequireDefault(_loansDetailSendDocumentation);
	
	__webpack_require__(1868);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailSendDocumentationComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    serviceClosed: '<',
	    isMobileApp: '<'
	  },
	  template: _loansDetailSendDocumentation2.default
	};
	
	exports.default = loansDetailSendDocumentationComponent;

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-detail-send-documentation\" ng-class=\"{ 'mobile': $ctrl.isMobileApp}\">\n  <div ng-repeat=\"sendDocumentation in $ctrl.loan.detail.sendDocumentation\">\n    <p>\n      {{ sendDocumentation.text | translate }}\n      <a href=\"{{sendDocumentation.link}}\" target=\"_blank\" ng-if=\"sendDocumentation.link !== undefined\">\n        <b>{{ sendDocumentation.textLink | translate }}</b>\n      </a>\n      {{ sendDocumentation.text2 | translate }}\n    </p>\n    <dl ng-if=\"sendDocumentation.especifications !== undefined\"\n        ng-repeat=\"especifications in sendDocumentation.especifications\">\n      <dt>\n        {{ especifications.dt | translate }}\n      </dt>\n      <dd ng-repeat=\"ddElements in especifications.dd\">\n        {{ ddElements | translate }}\n      </dd>\n    </dl>\n  </div>\n</div>\n"

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1869);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailSendDocumentation.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailSendDocumentation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-send-documentation .loans-detail-send-documentation{margin-top:26px;padding-right:71px}loans-detail-send-documentation .loans-detail-send-documentation.mobile{padding-right:0}loans-detail-send-documentation .loans-detail-send-documentation.mobile dd{margin-left:0;font-size:13px}loans-detail-send-documentation .loans-detail-send-documentation p:first-child{margin-bottom:21px}loans-detail-send-documentation .loans-detail-send-documentation dt{font-weight:500;color:#0072c9;font-size:13px}loans-detail-send-documentation .loans-detail-send-documentation dd{color:#666;margin-left:30px}loans-detail-send-documentation .loans-detail-send-documentation .email{color:#0072c9}loans-detail-send-documentation .remove-events{pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansDetailFinishDeadline = __webpack_require__(1871);
	
	var _loansDetailFinishDeadline2 = _interopRequireDefault(_loansDetailFinishDeadline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailFinishDeadlineModule = _angular2.default.module('loansDetailFinishDeadline', [_angularUiRouter2.default]).component('loansDetailFinishDeadline', _loansDetailFinishDeadline2.default).name;
	
	exports.default = loansDetailFinishDeadlineModule;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailFinishDeadline = __webpack_require__(1872);
	
	var _loansDetailFinishDeadline2 = _interopRequireDefault(_loansDetailFinishDeadline);
	
	var _loansDetailFinishDeadline3 = __webpack_require__(1873);
	
	var _loansDetailFinishDeadline4 = _interopRequireDefault(_loansDetailFinishDeadline3);
	
	__webpack_require__(1874);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailFinishDeadlineComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    isMobileApp: '<'
	  },
	  template: _loansDetailFinishDeadline2.default,
	  controller: _loansDetailFinishDeadline4.default
	};
	
	exports.default = loansDetailFinishDeadlineComponent;

/***/ }),
/* 1872 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-detail-finish-deadline\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <p>{{ $ctrl.loan.detail.finishDeadline | translate }}</p>\n</div>\n"

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansDetailFinishDeadlineController = function LoansDetailFinishDeadlineController() {
	  (0, _classCallCheck3.default)(this, LoansDetailFinishDeadlineController);
	};
	
	exports.default = LoansDetailFinishDeadlineController;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1875);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailFinishDeadline.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailFinishDeadline.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-finish-deadline .loans-detail-finish-deadline{margin-top:25px;padding-right:70px}loans-detail-finish-deadline .loans-detail-finish-deadline.mobile{padding-right:0}", ""]);
	
	// exports


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansDetailStatementIncome = __webpack_require__(1877);
	
	var _loansDetailStatementIncome2 = _interopRequireDefault(_loansDetailStatementIncome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailStatementIncomeModule = _angular2.default.module('loansDetailStatementIncome', [_angularUiRouter2.default]).component('loansDetailStatementIncome', _loansDetailStatementIncome2.default).name;
	
	exports.default = loansDetailStatementIncomeModule;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailStatementIncome = __webpack_require__(1878);
	
	var _loansDetailStatementIncome2 = _interopRequireDefault(_loansDetailStatementIncome);
	
	var _loansDetailStatementIncome3 = __webpack_require__(1879);
	
	var _loansDetailStatementIncome4 = _interopRequireDefault(_loansDetailStatementIncome3);
	
	__webpack_require__(1880);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailStatementIncomeComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    isMobileApp: '<'
	  },
	  template: _loansDetailStatementIncome2.default,
	  controller: _loansDetailStatementIncome4.default
	};
	
	exports.default = loansDetailStatementIncomeComponent;

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-detail-statement-income\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <p ng-repeat=\"paragraph in $ctrl.loan.detail.statementIncome\">\n    {{ paragraph | translate }}\n  </p>\n</div>\n"

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansDetailStatementIncomeController = function LoansDetailStatementIncomeController() {
	  (0, _classCallCheck3.default)(this, LoansDetailStatementIncomeController);
	};
	
	exports.default = LoansDetailStatementIncomeController;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1881);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailStatementIncome.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailStatementIncome.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-statement-income .loans-detail-statement-income{margin-top:25px;padding-right:70px}loans-detail-statement-income .loans-detail-statement-income.mobile{padding-right:0}", ""]);
	
	// exports


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansDetailNewCreditCapacity = __webpack_require__(1883);
	
	var _loansDetailNewCreditCapacity2 = _interopRequireDefault(_loansDetailNewCreditCapacity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailNewCreditCapacityModule = _angular2.default.module('loansDetailNewCreditCapacity', [_angularUiRouter2.default]).component('loansDetailNewCreditCapacity', _loansDetailNewCreditCapacity2.default).name;
	
	exports.default = loansDetailNewCreditCapacityModule;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansDetailNewCreditCapacity = __webpack_require__(1884);
	
	var _loansDetailNewCreditCapacity2 = _interopRequireDefault(_loansDetailNewCreditCapacity);
	
	var _loansDetailNewCreditCapacity3 = __webpack_require__(1885);
	
	var _loansDetailNewCreditCapacity4 = _interopRequireDefault(_loansDetailNewCreditCapacity3);
	
	__webpack_require__(1886);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansDetailNewCreditCapacityComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    isMobileApp: '<'
	  },
	  template: _loansDetailNewCreditCapacity2.default,
	  controller: _loansDetailNewCreditCapacity4.default
	};
	
	exports.default = loansDetailNewCreditCapacityComponent;

/***/ }),
/* 1884 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loans-detail-new-credit-capacity\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div ng-repeat=\"newCreditCapacity in $ctrl.loan.detail.newCreditCapacity\">\n    <p>\n      {{ newCreditCapacity.text | translate }}\n      <a ng-click=\"$ctrl.redirectFunctions[newCreditCapacity.link]()\" ng-if=\"newCreditCapacity.link !== undefined\">\n        <b>{{ newCreditCapacity.textLink | translate }}</b>\n      </a>\n    </p>\n  </div>\n</div>\n"

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansDetailNewCreditCapacityController = function LoansDetailNewCreditCapacityController($state) {
	  'ngInject';
	
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, LoansDetailNewCreditCapacityController);
	  this.state = $state;
	
	  this.redirectFunctions = {
	    'need-a-loan': function needALoan() {
	      return _this.state.go(_states.STATES.LOANS.NEED_A_LOAN);
	    }
	  };
	};
	LoansDetailNewCreditCapacityController.$inject = ["$state"];
	
	exports.default = LoansDetailNewCreditCapacityController;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1887);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailNewCreditCapacity.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansDetailNewCreditCapacity.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-detail-new-credit-capacity .loans-detail-new-credit-capacity{margin-top:25px;padding-right:70px}loans-detail-new-credit-capacity .loans-detail-new-credit-capacity.mobile{padding-right:0}", ""]);
	
	// exports


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansSignUp = __webpack_require__(1889);
	
	var _loansSignUp2 = _interopRequireDefault(_loansSignUp);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _loansSignUpForm = __webpack_require__(1896);
	
	var _loansSignUpForm2 = _interopRequireDefault(_loansSignUpForm);
	
	var _loansSignUpFormSimulation = __webpack_require__(1914);
	
	var _loansSignUpFormSimulation2 = _interopRequireDefault(_loansSignUpFormSimulation);
	
	var _loansSignUpModal = __webpack_require__(1925);
	
	var _loansSignUpModal2 = _interopRequireDefault(_loansSignUpModal);
	
	var _loansSignUpConfirmationModal = __webpack_require__(1931);
	
	var _loansSignUpConfirmationModal2 = _interopRequireDefault(_loansSignUpConfirmationModal);
	
	var _loansMandatoryInsuranceModal = __webpack_require__(1937);
	
	var _loansMandatoryInsuranceModal2 = _interopRequireDefault(_loansMandatoryInsuranceModal);
	
	var _loansSignUp3 = __webpack_require__(1943);
	
	var _loansSignUp4 = _interopRequireDefault(_loansSignUp3);
	
	var _loansSignUpResume = __webpack_require__(1944);
	
	var _loansSignUpResume2 = _interopRequireDefault(_loansSignUpResume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpModule = _angular2.default.module('loansSignUp', [_angularUiRouter2.default, _loansSignUpForm2.default, _loansSignUpFormSimulation2.default, _loansSignUpModal2.default, _loansSignUpConfirmationModal2.default, _loansMandatoryInsuranceModal2.default, _loansSignUpResume2.default]).component('loansSignUp', _loansSignUp2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.SIGN_UP, {
	    url: _routes.ROUTES.LOANS.SIGN_UP,
	    component: 'loansSignUp',
	    params: {
	      snapshot: null,
	      from: null,
	      originalFrom: null,
	      hardReset: null
	    },
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      serviceClosed: ["StatusAppCheckers", function serviceClosed(StatusAppCheckers) {
	        return StatusAppCheckers.isServiceClosed();
	      }]
	    }
	  });
	}]).service('loansSignUpService', _loansSignUp4.default).name;
	
	exports.default = loansSignUpModule;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansSignUp = __webpack_require__(1890);
	
	var _loansSignUp2 = _interopRequireDefault(_loansSignUp);
	
	var _loansSignUp3 = __webpack_require__(1891);
	
	var _loansSignUp4 = _interopRequireDefault(_loansSignUp3);
	
	__webpack_require__(1894);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpComponent = {
	  restrict: 'E',
	  bindings: {
	    serviceClosed: '<',
	    onClick: '&'
	  },
	  template: _loansSignUp2.default,
	  controller: _loansSignUp4.default
	};
	
	exports.default = loansSignUpComponent;

/***/ }),
/* 1890 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd\" ng-class=\"$ctrl.getClasses()\">\n  <section>\n\n    <loans-header\n      ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n      ng-if=\"!$ctrl.isResume()\"\n      title=\"{{ 'LOANS.SIGN_UP.ACTION' | translate }} {{ ($ctrl.backSimulation.newTitle)? $ctrl.backSimulation.newTitle :$ctrl.loan.title  | translate }}\">\n    </loans-header>\n\n    <div ng-if=\"$ctrl.isResume() && !$ctrl.createLoanSuccess\">\n      <section\n        id=\"request-card-simulation\"\n        class=\"request-card-simulation\"\n        ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n      >\n        <h4 class=\"title-results\">\n          {{ 'LOANS.NEED_A_LOAN.RESULTS' | translate }}\n        </h4>\n        <section ng-if=\"$ctrl.loading\" class=\"loading\">\n          <loading></loading>\n        </section>\n        <section class=\"flex-container\" ng-if=\"$ctrl.checkLoanSimulationRequest() && !$ctrl.loading\">\n          <div ng-repeat=\"loanSimulation in $ctrl.loanSimulationRequest\" class=\"flex-item\">\n            <div class=\"title\">\n              <span class=\"icon-euro-hand\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span></span>\n              <h2>\n                {{ loanSimulation.title | translate }}\n              </h2>\n            </div>\n\n            <div class=\"wrapper-details\" ng-if=\"loanSimulation !== undefined\">\n              <div class=\"details\" ng-show=\"$ctrl.checkSimulationIsOkey(loanSimulation)\">\n\n                <!-- Amount -->\n                <card-simulation-more-info\n                  loan-id=\"loanSimulation.id\"\n                  title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.AMOUNT' | translate }}\"\n                  icon-info-is-visible=\"$ctrl.showIconInfoOnAmount()\"\n                  subtitle=\"{{ loanSimulation.amount | currency }}\"\n                  is-mobile-app=\"$ctrl.isMobileApp\">\n                </card-simulation-more-info>\n                <hr>\n\n                <!-- Interests -->\n                <card-simulation-more-info\n                  loan-id=\"loanSimulation.id\"\n                  title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.TAXES' | translate }}\"\n                  icon-info-is-visible=\"$ctrl.showIconInfoOnInterests(loanSimulation.id)\"\n                  subtitle=\"{{ loanSimulation.interestRates | currency: '%' :3 }}\"\n                  is-mobile-app=\"$ctrl.isMobileApp\">\n\n                  <div ng-if=\"$ctrl.showLoanCV(loanSimulation.id)\">\n                    <p>\n                      {{ 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3' | translate }}\n                    </p>\n                  </div>\n\n                  <div ng-if=\"$ctrl.showLoanDA(loanSimulation.id)\">\n                    <p>\n                      {{ 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG3' | translate }}\n                    </p>\n                  </div>\n\n                  <div ng-if=\"$ctrl.showLoanVC(loanSimulation.id)\">\n                    <p>\n                      {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG3' | translate }}\n                    </p>\n                  </div>\n\n                  <div ng-if=\"$ctrl.showLoanSV(loanSimulation.id)\">\n                    <p>\n                      {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4' | translate }}\n                    </p>\n                    <ul>\n                      <li>\n                        {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_TEXT' | translate }}\n                      </li>\n                      <li>\n                        {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_1' | translate }}\n                        ({{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_2' | translate }}) /\n                        {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_3' | translate }}\n                      </li>\n                    </ul>\n                  </div>\n\n                  <div ng-if=\"$ctrl.showLoan9S(loanSimulation.id)\">\n                    <p>\n                      {{ 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG3' | translate }}\n                    </p>\n                  </div>\n\n                  <div ng-if=\"$ctrl.showLoan5S(loanSimulation.id)\">\n                    <p>\n                      {{ 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG3' | translate }}\n                    </p>\n                  </div>\n                </card-simulation-more-info>\n                <hr>\n\n                <!-- Basic characteristics -->\n                <card-simulation-more-info\n                  loan-id=\"loanSimulation.id\"\n                  title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.TERM' | translate }}\"\n                  icon-info-is-visible=\"$ctrl.showIconInfoOnDeadline()\"\n                  subtitle=\"{{ loanSimulation.deadline }} {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.MONTH' | translate }}\"\n                  is-mobile-app=\"$ctrl.isMobileApp\">\n\n                  <div ng-if=\"$ctrl.showLoanCV(loanSimulation.id)\">\n                    <p>{{ 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG2' | translate }}</p>\n                  </div>\n\n                  <div ng-if=\"$ctrl.showLoanDA(loanSimulation.id)\">\n                    <p>{{ 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG2' | translate }}</p>\n                  </div>\n\n                  <div ng-if=\"$ctrl.showLoanVC(loanSimulation.id)\">\n                    <p>{{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG2' | translate }}</p>\n                  </div>\n\n                  <div ng-if=\"$ctrl.showLoanSV(loanSimulation.id)\">\n                    <p>{{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG3' | translate }}</p>\n                  </div>\n\n                  <div ng-if=\"$ctrl.showLoan9S(loanSimulation.id)\">\n                    <p>{{ 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG2' | translate }}</p>\n                  </div>\n\n                  <div ng-if=\"$ctrl.showLoan5S(loanSimulation.id)\">\n                    <p>{{ 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG2' | translate }}</p>\n                  </div>\n                </card-simulation-more-info>\n                <hr>\n\n                <!-- Insurance -->\n                <card-simulation-more-info\n                  loan-id=\"loanSimulation.id\"\n                  title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.INSURANCE' | translate }}\"\n                  icon-info-is-visible=\"$ctrl.showIconInfoOnInsurance(loanSimulation)\"\n                  insurance=\"loanSimulation.wantInsurance\"\n                  is-mobile-app=\"$ctrl.isMobileApp\">\n                  <p ng-if=\"!$ctrl.isSocialAgreement(loanSimulation.id)\">\n                    {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.INSURANCE_1' | translate }}\n                    {{ loanSimulation.annualTerm | currency}} .\n                    {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.INSURANCE_2' | translate }}\n                  </p>\n                  <p ng-if=\"$ctrl.isSocialAgreement(loanSimulation.id)\">\n                    {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.INSURANCE_1' | translate }}\n                    {{ loanSimulation.annualTerm | currency}} .\n                    {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.INSURANCE_3' | translate }}\n                  </p>\n                </card-simulation-more-info>\n                <hr>\n\n                <!-- Sale Price -->\n                <card-simulation-more-info\n                  ng-if=\"$ctrl.showSalePrice(loanSimulation)\"\n                  loan-id=\"loanSimulation.id\"\n                  title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.SALE_PRICE' | translate }}\"\n                  subtitle=\"{{ $ctrl.simulation.amountSimulation.salePrice | currency }}\"\n                  is-mobile-app=\"$ctrl.isMobileApp\">\n                </card-simulation-more-info>\n                <hr>\n\n                <!-- Monthly amount -->\n                <card-simulation-more-info\n                  loan-id=\"loanSimulation.id\"\n                  title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.MONTHLY_FEE' | translate }}\"\n                  icon-info-is-visible=\"$ctrl.isFiveOrNineMonth(loanSimulation.id)\"\n                  subtitle=\"{{ loanSimulation.monthlyAmount | currency }}\"\n                  is-mobile-app=\"$ctrl.isMobileApp\">\n                  <p>\n                    {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.MIN_FEE' | translate }}\n                    {{ 'LOANS.LOANS_DETAIL.MINIMUM_FEE_DESC_2' | translate }}\n                  </p>\n                </card-simulation-more-info>\n              </div>\n            </div>\n\n            <div class=\"detail-error\" ng-show=\"!$ctrl.checkSimulationIsOkey(loanSimulation)\">\n              <div class=\"detail-error-header\">\n                <span class=\"icon-warning\"></span>\n                <h4 class=\"title-error\">{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.ATTENTION' | translate }}</h4>\n              </div>\n\n              <div class=\"detail-error-body\">\n                <p>{{ loanSimulation.status.message || ('LOANS.NEED_A_LOAN.CARD_SIMULATION.LOAN_NOT_AVAILABLE' | translate) }}</p>\n              </div>\n            </div>\n\n            <div class=\"buttons\">\n              <button\n                class=\"btn btn-app btn-default\"\n                type=\"button\"\n                ng-click=\"$ctrl.openDetail(loanSimulation)\">\n                  {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.SHOW_PRODUCT' | translate }}\n              </button>\n              <button\n                ng-if=\"!$ctrl.selectButtonShouldAppear()\"\n                class=\"btn btn-app btn-primary\"\n                type=\"button\"\n                ng-click=\"$ctrl.selectLoan(loanSimulation, true)\"\n                ng-show=\"$ctrl.checkSimulationIsOkey(loanSimulation)\">\n                  {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.SELECT' | translate }}\n              </button>\n              <button\n                class=\"btn btn-app btn-primary\"\n                type=\"button\"\n                ng-click=\"$ctrl.modifyLoan()\"\n                ng-show=\"!$ctrl.checkSimulationIsOkey(loanSimulation)\">\n                  {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.MODIFY' | translate }}\n              </button>\n            </div>\n\n          </div>\n        </section>\n      </section>\n    </div>\n\n    <loans-sign-up-form-simulation\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-show=\"$ctrl.isSimulation()\"\n      loan=\"$ctrl.loan\"\n      loan-purposes=\"$ctrl.loanPurposes\"\n      simulation=\"$ctrl.simulation\"\n      on-submit=\"$ctrl.setSimulation($event)\"\n      housing-loan=\"$ctrl.housingLoan\"\n      housing-change=\"$ctrl.housingChange\"\n      initial-charges=\"$ctrl.initialCharges\"\n      data=\"$ctrl.data\"\n      simulation-witness=\"$ctrl.simulationWitness\">\n    </loans-sign-up-form-simulation>\n\n    <loans-sign-up-form\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.isForm()\"\n      loan-purposes=\"$ctrl.loanPurposes\"\n      simulation=\"$ctrl.simulation\"\n      back-simulation=\"$ctrl.backSimulation\"\n      loan=\"$ctrl.loan\"\n      on-cancel-create-loan=\"$ctrl.onCancelCreateLoan()\"\n      on-create-loan=\"$ctrl.onCreateLoan($event)\"\n      is-various-credit=\"$ctrl.isVariousCredit\"\n      housing-loan=\"$ctrl.housingLoan\"\n      housing-change=\"$ctrl.housingChange\"\n      on-open-detail=\"$ctrl.onOpenDetail()\"></loans-sign-up-form>\n\n      <loans-sign-up-resume\n      ng-if=\"$ctrl.isResume()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n      loan=\"$ctrl.loan\"\n      success=\"$ctrl.createLoanSuccess\"\n      error=\"$ctrl.createLoanError\"\n      message=\"$ctrl.errorMessage\"\n      loan-response-id=\"$ctrl.loanResponseId\"\n      simulation=\"$ctrl.backSimulation\"\n      go-to-init-form=\"$ctrl.goToInitForm()\"></loans-sign-up-resume>\n\n      <loans-sign-up-modal\n      loan=\"$ctrl.loan\"\n      error=\"$ctrl.errorBackSimulation\"\n      message=\"$ctrl.errorMessage\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      on-click=\"$ctrl.goToInitForm()\"\n      ></loans-sign-up-modal>\n</div>\n"

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	var _constantsLoans = __webpack_require__(1774);
	
	var _constants = __webpack_require__(598);
	
	var _loansModalities = __webpack_require__(1822);
	
	var _loansModalities2 = _interopRequireDefault(_loansModalities);
	
	var _isReloaded = __webpack_require__(1892);
	
	var _isReloaded2 = _interopRequireDefault(_isReloaded);
	
	var _menuFamilyNeedALoanFormatter = __webpack_require__(1893);
	
	var _menuFamilyNeedALoanFormatter2 = _interopRequireDefault(_menuFamilyNeedALoanFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STEPS = {
	  SIMULATION: 'simulation',
	  FORM: 'form',
	  RESUME: 'resume'
	};
	
	var LoansSignUpController = function () {
	  LoansSignUpController.$inject = ["$stateParams", "$log", "$state", "$window", "$rootScope", "loansStaticService", "LoansUserDataService", "LoansOperationsService", "loansSignUpService", "GoBackDataService", "mainMenuMobileBehaviourService", "LoansNeedALoanService", "loadingMobileService", "metricsService", "myLoansService"];
	  function LoansSignUpController($stateParams, $log, $state, $window, $rootScope, loansStaticService, LoansUserDataService, LoansOperationsService, loansSignUpService, GoBackDataService, mainMenuMobileBehaviourService, LoansNeedALoanService, loadingMobileService, metricsService, myLoansService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansSignUpController);
	    this.stateParams = $stateParams;
	    this.log = $log;
	    this.state = $state;
	    this.window = $window;
	    this.rootScope = $rootScope;
	
	    this.loansStaticService = loansStaticService;
	    this.loansUserDataService = LoansUserDataService;
	    this.loansOperationsService = LoansOperationsService;
	    this.loansSignUpService = loansSignUpService;
	    this.goBackDataService = GoBackDataService;
	    this.mainMenuMobileBehaviourService = mainMenuMobileBehaviourService;
	    this.loansNeedALoanService = LoansNeedALoanService;
	    this.loadingMobileService = loadingMobileService;
	    this.metricsService = metricsService;
	    this.simulationWitness = false;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.myLoansService = myLoansService;
	    this.snapshotSeeConditions = this.goBackDataService.getDataSeeConditions();
	    this.snapshotSignUp = this.goBackDataService.getDataBackToSignUp();
	    this.from = _states.STATES.LOANS.LOANS_CATALOG;
	    this.initialCharges = 0;
	    this.data = null;
	    this.preventEnterWithoutSnapshot();
	    this.loading = false;
	    if (this.isDataOnSnapshot()) {
	      this.initFromSnapshot();
	    } else {
	      this.init();
	    }
	  }
	
	  (0, _createClass3.default)(LoansSignUpController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.serviceClosed) {
	        this.state.go(_states.STATES.LOANS.LOANS_CATALOG);
	      }
	
	      if (this.isMobileApp) {
	        this._checkFromToSnapshot();
	      }
	
	      this.setLoanPurposes();
	      this.loadInitialCharges();
	      this.getCreditworthiness();
	    }
	  }, {
	    key: 'isDataOnSnapshot',
	    value: function isDataOnSnapshot() {
	      return (this.stateParams.snapshot || this.snapshotSeeConditions || this.snapshotSignUp) && !this.stateParams.hardReset;
	    }
	  }, {
	    key: '_checkFromToSnapshot',
	    value: function _checkFromToSnapshot() {
	      if (this.form === _states.STATES.LOANS.CADASTRAL_REFERENCE) {
	        this.state.go(_states.STATES.LOANS.LOANS_CATALOG);
	      }
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        responsiveMobile: this.isMobileApp,
	        'with-floating-action-buttons': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'preventEnterWithoutSnapshot',
	    value: function preventEnterWithoutSnapshot() {
	      if (!(0, _isReloaded2.default)()) {
	        return;
	      }
	
	      if (this.stateParams.from === _states.STATES.LOANS.NEED_A_LOAN && !this.stateParams.snapshot) {
	        this.state.go(this.stateParams.from);
	      }
	    }
	  }, {
	    key: 'initFromSnapshot',
	    value: function initFromSnapshot() {
	      this.loading = true;
	      var snapshot = this.stateParams.snapshot || this.snapshotSignUp || this.snapshotSeeConditions;
	      this.loanSimulationRequest = snapshot.loanSimulation;
	      this.step = snapshot.step;
	      this.loan = snapshot.loan;
	      this.simulation = snapshot.simulation;
	      this.backSimulation = snapshot.backSimulation;
	      this.loanPurposes = snapshot.loanPurposes;
	      this.housingChange = snapshot.housingChange;
	      this.housingLoan = snapshot.housingLoan;
	      this.isVariousCredit = snapshot.isVariousCredit;
	      this.dataToGoBack = snapshot.dataToGoBack;
	
	      this.from = snapshot.from || this.stateParams.from;
	      this.originalFrom = this.stateParams.originalFrom;
	
	      if (this.isMobileApp) {
	        this.createLoanError = snapshot.createLoanError;
	        this.createLoanSuccess = snapshot.createLoanSuccess;
	        this.errorMessage = snapshot.errorMessage;
	        this.loanResponseId = snapshot.loanResponseId;
	        this.setTitleMenu(this.from);
	
	        if (this.isForm()) {
	          this.goToFormOnBack();
	        }
	      }
	      this.loading = false;
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      this.loading = true;
	
	      this.step = STEPS.SIMULATION;
	      this.loanId = this.stateParams.loanId;
	      this.loan = this.loansStaticService.get(this.loanId);
	      this.housingLoan = this.loan.id === _constantsLoans.LOANS.ID.SOCIAL_HOUSING_LOAN || this.loan.id === _constantsLoans.LOANS.ID.AGREEMENT_HOUSING_LOAN;
	      this.isVariousCredit = this.loan.id === _constantsLoans.LOANS.ID.VARIOUS_CREDIT;
	      this.loading = false;
	    }
	  }, {
	    key: 'getCreditworthiness',
	    value: function getCreditworthiness() {
	      var _this = this;
	
	      // TODO: [Manu] esta peticion de creditworthiness es solo para comprobar housingWitness, como no es un flag que cambie así como así durante el proceso de contratación, estaría bien arrastrarlo desde el primer paso de sign-up / need a loan
	      this.loading = true;
	      this.loadingMobileService.show();
	      this.loansOperationsService.getCreditworthiness(this.loansUserDataService._employee.userId).then(function (creditworthiness) {
	        _this.creditworthiness = creditworthiness;
	        _this.housingChange = creditworthiness.housingWitness;
	        _this.simulationWitness = creditworthiness.simulationWitness;
	        var creditworthinessPayload = {
	          raw: creditworthiness,
	          simulatedLimits: [creditworthiness.socialHousingLoanSimulated, creditworthiness.socialHousingLoanFixedSimulated, creditworthiness.agreementHousingLoanSimulated, creditworthiness.agreementHousingLoanFixedSimulated]
	        };
	        _this.data = new _menuFamilyNeedALoanFormatter2.default(creditworthinessPayload).format();
	        _this.loaded = true;
	        _this.rootScope.$applyAsync();
	      }, function (error) {
	        _this.log.error('LoansSignUpController constructor getCreditworthiness()', error);
	        // TODO: [Manu] eliminado ya que probablemente sea motivo de error en la APP. Ver si en la Web es necesario o con el errorInterceptor es suficiente
	        // this.state.go(STATES.ERROR);
	      }).finally(function () {
	        _this.loadingMobileService.hide();
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'setTitleMenu',
	    value: function setTitleMenu(from) {
	      if (from === _states.STATES.LOANS.LOANS_CATALOG) {
	        this.rootScope.$broadcast(_constants.EVENTS.CHANGE_TITLE, {
	          title: 'LOANS.LOANS_CATALOG.TITLE'
	        });
	      }
	
	      if (from === _states.STATES.LOANS.NEED_A_LOAN) {
	        this.rootScope.$broadcast(_constants.EVENTS.CHANGE_TITLE, {
	          title: 'LOANS.NEED_A_LOAN.TITLE'
	        });
	      }
	    }
	  }, {
	    key: 'setLoanPurposes',
	    value: function setLoanPurposes() {
	      var modalities = this.loansUserDataService.getModalities();
	      var loansModalitiesAssembler = new _loansModalities2.default(modalities);
	      var allPurposes = loansModalitiesAssembler.assemble();
	      this.loanPurposes = allPurposes[this.loan.id];
	    }
	  }, {
	    key: 'setSimulation',
	    value: function setSimulation($event) {
	      var _this2 = this;
	
	      this.simulation = $event;
	      this.log.info('LOCAL Simulation is:', this.simulation);
	
	      var userId = this.loansUserDataService._employee.userId;
	      var loan = this.loan;
	      var simulationEndpoint = this.buildEndpointSimulation(this.simulation, loan);
	      var codeOptionIsHousingPurpose = this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN;
	
	      this.loadingMobileService.show();
	
	      this.loansSignUpService.createSimulation(userId, simulationEndpoint).then(function (response) {
	        _this2.loanSimulationRequest = _this2.filterSimulation(response, codeOptionIsHousingPurpose);
	        _this2.loanSimulationRequest.simulation = _this2.simulation;
	        _this2.setBackSimulation(response.data.simulations);
	        _this2.log.info('BACK Simulation is:', _this2.backSimulation);
	        _this2.scrollToTop();
	
	        if (_this2._isStatusSimulationKO()) {
	          _this2.errorMessage = _this2.backSimulation.status.message;
	          _this2.errorBackSimulation = true;
	          _this2.openModal();
	          return;
	        }
	
	        if (_this2.isMobileApp) {
	          _this2.goToFormOnBack();
	        }
	      }, function (response) {
	        _this2.errorMessage = response.data.message;
	        _this2.errorBackSimulation = true;
	        _this2.scrollToTop();
	        _this2.openModal();
	      }).finally(function () {
	        _this2.step = STEPS.RESUME;
	        _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'scrollToTop',
	    value: function scrollToTop() {
	      this.window.scrollTo(0, 0);
	    }
	  }, {
	    key: '_isStatusSimulationKO',
	    value: function _isStatusSimulationKO() {
	      return this.backSimulation.status.code === _constantsLoans.LOANS.STATUS.KO;
	    }
	  }, {
	    key: 'buildEndpointSimulation',
	    value: function buildEndpointSimulation(_ref, loan) {
	      var loanPurpose = _ref.loanPurpose,
	          amountSimulation = _ref.amountSimulation;
	
	      var endpointSimulation = {
	        loanId: loan.idHr,
	        loanPurposeId: loanPurpose.value,
	        amount: amountSimulation.amount,
	        wantInsurance: amountSimulation.wantInsurance,
	        typeFixedVariable: amountSimulation.typeFixedVariable || '0',
	        isSimulation: amountSimulation.isSimulation || false
	      };
	
	      if (amountSimulation.fixedFeeNumber) {
	        endpointSimulation.deadline = parseInt(amountSimulation.fixedFeeNumber, 10);
	      }
	
	      if (amountSimulation.monthlyFeeAmount) {
	        endpointSimulation.monthlyAmount = amountSimulation.monthlyFeeAmount;
	      }
	
	      var isHousingPurpose = loanPurpose.value === _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
	      if (isHousingPurpose && loan.idHr !== _constantsLoans.LOANS.ID_HR.VARIOUS_CREDIT && loan.idHr !== _constantsLoans.LOANS.ID_HR.DIVERSAL_ATENTION) {
	        endpointSimulation.acquisitionCost = amountSimulation.acquisitionCost != null ? amountSimulation.acquisitionCost : amountSimulation.diff;
	
	        if (this.housingChange) {
	          endpointSimulation.salePrice = amountSimulation.salePrice;
	        }
	      }
	
	      return endpointSimulation;
	    }
	  }, {
	    key: 'setBackSimulation',
	    value: function setBackSimulation(simulations) {
	      this.backSimulation = simulations[0];
	      this.backSimulation.diff = this.simulation.amountSimulation.diff;
	    }
	  }, {
	    key: 'filterSimulation',
	    value: function filterSimulation(simulation, isHousingPurpose) {
	      var _this3 = this;
	
	      return simulation.data.simulations.filter(function (loanSimulation) {
	        _this3.setInfo(loanSimulation);
	        if (isHousingPurpose) {
	          return loanSimulation.loanId !== _constantsLoans.LOANS.ID_HR.VARIOUS_CREDIT;
	        }
	        return true;
	      });
	    }
	  }, {
	    key: 'setInfo',
	    value: function setInfo(loanSimulation) {
	      var loan = this.getLoan(loanSimulation.loanId);
	      loanSimulation.title = this.loansStaticService.get(loanSimulation.loanId).title;
	      this.setTitleFixedVariable(loanSimulation);
	      loanSimulation.id = loan.id;
	    }
	  }, {
	    key: 'getLoan',
	    value: function getLoan(loanId) {
	      return this.loansStaticService.get(loanId);
	    }
	  }, {
	    key: 'setTitleFixedVariable',
	    value: function setTitleFixedVariable(loanSimulation) {
	      var loanId = loanSimulation.loanId;
	      if (loanId === _constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN || loanId === _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN) {
	        loanSimulation.title += loanSimulation.typeFixedVariable === '1' ? '_FIXED' : '_VARIABLE';
	      }
	    }
	  }, {
	    key: 'onCreateLoan',
	    value: function onCreateLoan($event) {
	      var _this4 = this;
	
	      var userId = this.loansUserDataService._employee.userId;
	      var loan = this.sanitizeLoanOnCreate($event.loan, this.simulation.amountSimulation);
	
	      this.loadingMobileService.show();
	      this.loansOperationsService.createLoan(userId, loan).then(function (response) {
	        _this4.createLoanSuccess = true;
	        _this4.loanResponseId = response.data.loanId;
	
	        _this4.log.info('loansSignUp', loan);
	        _this4.metricsService.trackLoansSignup({ loanType: loan.idHr });
	
	        _this4.setDataLoanOnServiceGoBack();
	        _this4.scrollToTop();
	      }, function (error) {
	        _this4.errorMessage = error.data.message;
	        _this4.createLoanError = true;
	        _this4.setDataLoanOnServiceGoBack();
	        _this4.scrollToTop();
	      }).finally(function () {
	        _this4.step = STEPS.RESUME;
	        _this4.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'setDataLoanOnServiceGoBack',
	    value: function setDataLoanOnServiceGoBack() {
	      var dataBackToSignUp = {
	        loan: this.loan,
	        createLoanSuccess: this.createLoanSuccess,
	        createLoanError: this.createLoanError,
	        errorMessage: this.errorMessage,
	        loanResponseId: this.loanResponseId,
	        backSimulation: this.backSimulation,
	        from: this.from
	      };
	      this.goBackDataService.setDataBackToSignUp(dataBackToSignUp);
	    }
	  }, {
	    key: 'sanitizeLoanOnCreate',
	    value: function sanitizeLoanOnCreate(loan, fieldsSent) {
	      delete loan.annualPercentageRate;
	      delete loan.interestRate;
	      delete loan.tae;
	
	      if (!fieldsSent.fixedFeeNumber) {
	        delete loan.deadline;
	      }
	
	      if (!fieldsSent.monthlyFeeAmount) {
	        delete loan.monthlyAmount;
	      }
	
	      if (!this.housingLoan) {
	        delete loan.acquisitionCost;
	        delete loan.salePrice;
	      } else if (!this.housingChange) {
	        delete loan.salePrice;
	      }
	
	      return loan;
	    }
	  }, {
	    key: 'isSimulation',
	    value: function isSimulation() {
	      return this.step === STEPS.SIMULATION;
	    }
	  }, {
	    key: 'isForm',
	    value: function isForm() {
	      return this.step === STEPS.FORM;
	    }
	  }, {
	    key: 'isResume',
	    value: function isResume() {
	      return this.step === STEPS.RESUME;
	    }
	  }, {
	    key: 'onCancelCreateLoan',
	    value: function onCancelCreateLoan() {
	      if (this.originalFrom) {
	        return this.state.go(this.originalFrom);
	      }
	
	      if (this.from && this.from !== _states.STATES.LOANS.NEED_A_LOAN) {
	        this.step = STEPS.SIMULATION;
	        this.mainMenuMobileBehaviourService.clean();
	        return;
	      }
	
	      this.loansNeedALoanService.setDataSimulation(this.dataToGoBack);
	
	      if (!this.from) {
	        return this.state.go(_states.STATES.LOANS.NEED_A_LOAN);
	      }
	
	      this.window.history.back();
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'goToInitForm',
	    value: function goToInitForm() {
	      this.step = STEPS.SIMULATION;
	    }
	  }, {
	    key: 'onOpenDetail',
	    value: function onOpenDetail() {
	      var snapshot = this.getSnapshot();
	      this.loansNeedALoanService.setDataSimulation(this.dataToGoBack);
	      this.goBackDataService.setDataSeeConditions(snapshot);
	
	      var originalFrom = void 0;
	
	      if (this.from === _states.STATES.LOANS.NEED_A_LOAN) {
	        originalFrom = _states.STATES.LOANS.NEED_A_LOAN;
	      }
	
	      this.state.go(_states.STATES.LOANS.DETAIL, {
	        loanId: this.loan.id,
	        allowGoBack: true,
	        panel: 'basic-characteristics',
	        from: _states.STATES.LOANS.SIGN_UP,
	        originalFrom: originalFrom,
	        snapshot: snapshot
	      });
	    }
	  }, {
	    key: 'getSnapshot',
	    value: function getSnapshot() {
	      return {
	        step: this.step,
	        loan: this.loan,
	        simulation: this.simulation,
	        backSimulation: this.backSimulation,
	        loanPurposes: this.loanPurposes,
	        housingChange: this.housingChange,
	        housingLoan: this.housingLoan,
	        isVariousCredit: this.isVariousCredit,
	        dataToGoBack: this.dataToGoBack
	      };
	    }
	  }, {
	    key: 'goToFormOnBack',
	    value: function goToFormOnBack() {
	      var _this5 = this;
	
	      this.mainMenuMobileBehaviourService.setCustomBehaviour(function () {
	        _this5.onCancelCreateLoan();
	      });
	    }
	  }, {
	    key: 'openDetail',
	    value: function openDetail(loanSimulation) {
	      var dataToDetail = {
	        loanId: loanSimulation.id,
	        allowGoBack: !this.isMobileApp,
	        loanSimulationRequest: this.loanSimulationRequest,
	        simulation: this.simulation,
	        familySelected: this.familySelected,
	        optionFamilySelected: this.optionFamilySelected,
	        families: this.families,
	        codeOptionSelected: this.codeOptionSelected,
	        loan: this.loan
	      };
	
	      this.loansNeedALoanService.onOpenDetailCatalog(dataToDetail);
	    }
	  }, {
	    key: 'checkLoanSimulationRequest',
	    value: function checkLoanSimulationRequest() {
	      return this.loanSimulationRequest !== undefined;
	    }
	  }, {
	    key: 'checkSimulationIsOkey',
	    value: function checkSimulationIsOkey(loanSimulation) {
	      if (loanSimulation === undefined) return;
	      return loanSimulation.status.code === _constantsLoans.LOANS.STATUS.OK;
	    }
	  }, {
	    key: 'selectLoan',
	    value: function selectLoan(loanSimulation, isSignUp) {
	      var response = this.loansNeedALoanService.onSelectLoan({
	        loanId: loanSimulation.id,
	        loanSimulation: loanSimulation,
	        creditworthiness: this.creditworthiness,
	        simulation: this.simulation,
	        dataToGoBack: this.snapshot
	      }, isSignUp);
	
	      this.backSimulation = loanSimulation;
	      if (response !== undefined) {
	        return this.presentCannotSignUpModal(response);
	      }
	      this.step = STEPS.FORM;
	    }
	  }, {
	    key: 'presentCannotSignUpModal',
	    value: function presentCannotSignUpModal(reason) {
	      this.cannotSignUpError = reason;
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'isFiveOrNineMonth',
	    value: function isFiveOrNineMonth(loanId) {
	      return loanId === _constantsLoans.LOANS.ID.FIVE_MONTH || loanId === _constantsLoans.LOANS.ID.NINE_MONTH;
	    }
	  }, {
	    key: 'isSocialAgreement',
	    value: function isSocialAgreement(loanId) {
	      return loanId === _constantsLoans.LOANS.ID.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'showIconInfoOnAmount',
	    value: function showIconInfoOnAmount() {
	      return false;
	    }
	  }, {
	    key: 'showIconInfoOnInterests',
	    value: function showIconInfoOnInterests(loanId) {
	      return !this.isFiveOrNineMonth(loanId);
	    }
	  }, {
	    key: 'showIconInfoOnDeadline',
	    value: function showIconInfoOnDeadline() {
	      return true;
	    }
	  }, {
	    key: 'showIconInfoOnInsurance',
	    value: function showIconInfoOnInsurance(loanSimulation) {
	      return loanSimulation.wantInsurance;
	    }
	  }, {
	    key: 'showLoanCV',
	    value: function showLoanCV(loanId) {
	      return loanId === _constantsLoans.LOANS.ID.VARIOUS_CREDIT;
	    }
	  }, {
	    key: 'showLoanDA',
	    value: function showLoanDA(loanId) {
	      return loanId === _constantsLoans.LOANS.ID.DIVERSAL_ATENTION;
	    }
	  }, {
	    key: 'showLoanVC',
	    value: function showLoanVC(loanId) {
	      return loanId === _constantsLoans.LOANS.ID.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'showLoanSV',
	    value: function showLoanSV(loanId) {
	      return loanId === _constantsLoans.LOANS.ID.SOCIAL_HOUSING_LOAN;
	    }
	  }, {
	    key: 'showLoan9S',
	    value: function showLoan9S(loanId) {
	      return loanId === _constantsLoans.LOANS.ID.NINE_MONTH;
	    }
	  }, {
	    key: 'showLoan5S',
	    value: function showLoan5S(loanId) {
	      return loanId === _constantsLoans.LOANS.ID.FIVE_MONTH;
	    }
	  }, {
	    key: 'modifyLoan',
	    value: function modifyLoan() {
	      if (this.isMobileApp) return this.state.go(_states.STATES.LOANS.NEED_A_LOAN);
	      this.onModifyLoan();
	    }
	  }, {
	    key: 'goMyLoans',
	    value: function goMyLoans() {
	      this.state.go(_states.STATES.LOANS.MY_LOANS);
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'showSalePrice',
	    value: function showSalePrice(loanSimulation) {
	      return loanSimulation.loanPurposeId === _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE && (this.housingWitness === true || this.simulationWitness === true);
	    }
	  }, {
	    key: 'loadInitialCharges',
	    value: function loadInitialCharges() {
	      var _this6 = this;
	
	      var employeeId = this.loansUserDataService._employee.userId;
	      this.myLoansService.getMyLoans(employeeId).then(function (loansList) {
	        var loan = loansList.find(function (l) {
	          return (l.modalityCode === 'SV' || l.modalityCode === 'CV') && l.amortizable === true;
	        });
	        _this6.initialCharges = loan ? loan.amountPending : 0;
	      }).catch(function (err) {
	        _this6.log.error('Error fetching myLoans:', err);
	      });
	    }
	  }, {
	    key: 'selectButtonShouldAppear',
	    value: function selectButtonShouldAppear() {
	      return this.simulationWitness && (this.loan.idHr === _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.loan.idHr === _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.loan.idHr === _constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN);
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      var $modal = $(_constants.MODALS.SIGN_UP);
	      return $modal;
	    }
	  }]);
	  return LoansSignUpController;
	}();
	
	exports.default = LoansSignUpController;

/***/ }),
/* 1892 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return window && window.performance && window.performance.navigation && window.performance.navigation.type === 1;
	};

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuFamilyNeedALoanFormatter = function () {
	  function MenuFamilyNeedALoanFormatter(rawData) {
	    (0, _classCallCheck3.default)(this, MenuFamilyNeedALoanFormatter);
	
	    this._rawData = rawData;
	  }
	
	  (0, _createClass3.default)(MenuFamilyNeedALoanFormatter, [{
	    key: 'format',
	    value: function format() {
	      var cardsData = this._getCardsData();
	      var moreInfoData = this._getMoreInfoData();
	      var tableData = this._getTableData();
	      var creditworthinessOfLoans = this._getCreditworthinessOfLoans();
	      return {
	        cardsData: cardsData,
	        moreInfoData: moreInfoData,
	        tableData: tableData,
	        creditworthinessOfLoans: creditworthinessOfLoans
	      };
	    }
	  }, {
	    key: '_getCardsData',
	    value: function _getCardsData() {
	      return [{
	        title: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.MAX_MONTH_FEE.TITLE',
	        subtitle: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.MAX_MONTH_FEE.SUBTITLE',
	        description: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.MAX_MONTH_FEE.DESC',
	        amount: this._rawData.maximumMonthFee
	      }, {
	        title: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_OBLIGATIONS.TITLE',
	        subtitle: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_OBLIGATIONS.SUBTITLE',
	        description: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_OBLIGATIONS.DESC',
	        amount: this._rawData.yourObligations
	      }, {
	        title: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_REAL_CAPACITY.TITLE',
	        subtitle: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_REAL_CAPACITY.SUBTITLE',
	        description: 'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_REAL_CAPACITY.DESC',
	        amount: this._rawData.yourRealCapacity
	      }];
	    }
	  }, {
	    key: '_getMoreInfoData',
	    value: function _getMoreInfoData() {
	      return [{
	        title: 'LOANS.CREDITWORTHINESS.MORE_INFO.ABOUT_CREDITWORTHINESS.SUBTITLE',
	        information: ['LOANS.CREDITWORTHINESS.MORE_INFO.ABOUT_CREDITWORTHINESS.DESCRIPTION1', 'LOANS.CREDITWORTHINESS.MORE_INFO.ABOUT_CREDITWORTHINESS.DESCRIPTION2']
	      }, {
	        title: 'LOANS.CREDITWORTHINESS.MORE_INFO.FACTORS_CREDITWORTHINESS.SUBTITLE',
	        information: ['LOANS.CREDITWORTHINESS.MORE_INFO.FACTORS_CREDITWORTHINESS.DESCRIPTION1', 'LOANS.CREDITWORTHINESS.MORE_INFO.FACTORS_CREDITWORTHINESS.DESCRIPTION2']
	      }, {
	        title: 'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.SUBTITLE',
	        information: ['LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION1', 'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION2', 'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION3', 'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION4']
	      }];
	    }
	  }, {
	    key: '_getTableData',
	    value: function _getTableData() {
	      var headers = this._getTableHeaders();
	      var labels = ['LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_VARIABLE', 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_FIXED', 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_VARIABLE', 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_FIXED'];
	
	      var rows = this._rawData.simulatedLimits.map(function (value, idx) {
	        return [{ text: labels[idx], translate: true }, { text: value, currency: true }];
	      });
	
	      return { headers: headers, rows: rows };
	    }
	  }, {
	    key: '_getTableHeaders',
	    value: function _getTableHeaders() {
	      return [{
	        text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.TYPE',
	        width: 329,
	        translate: true
	      }, {
	        text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SIMULATION_MAX_LIMIT_WITH_INSURANCE',
	        width: 329,
	        translate: true
	      }];
	    }
	  }, {
	    key: '_getCreditworthinessOfLoans',
	    value: function _getCreditworthinessOfLoans() {
	      var loanNames = ['LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_VARIABLE', 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_FIXED', 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_VARIABLE', 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_FIXED'];
	
	      var rows = this._rawData.simulatedLimits.map(function (value, idx) {
	        return {
	          loanName: loanNames[idx],
	          realWithInsuranceLimit: value
	        };
	      });
	
	      return rows;
	    }
	  }]);
	  return MenuFamilyNeedALoanFormatter;
	}();
	
	exports.default = MenuFamilyNeedALoanFormatter;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1895);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUp.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUp.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-sign-up{display:block}loans-sign-up .loading{padding-bottom:3rem}loans-sign-up .container{min-height:708px}loans-sign-up .container.mobile{min-height:100vh;padding:0}loans-sign-up loans-sign-up-form-fields{margin-top:30px;margin-bottom:50px}loans-sign-up .responsiveMobile.request-card-simulation{margin-top:0;padding-top:0}loans-sign-up .responsiveMobile.request-card-simulation .title-results{display:none}loans-sign-up .responsiveMobile.request-card-simulation .flex-container{-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;margin:80px 20px 20px}loans-sign-up .responsiveMobile.request-card-simulation .flex-container .flex-item{width:100%;height:auto;margin:0;margin-bottom:30px;padding-bottom:25px}loans-sign-up .responsiveMobile.request-card-simulation .flex-container .flex-item .title{padding:20px;min-height:0}loans-sign-up .responsiveMobile.request-card-simulation .flex-container .flex-item .title .icon-euro-hand{font-size:40px}loans-sign-up .responsiveMobile.request-card-simulation .flex-container .flex-item .title h2{font-size:18px}loans-sign-up .responsiveMobile.request-card-simulation .flex-container .flex-item .buttons{margin:0 25px;height:auto}loans-sign-up .responsiveMobile.request-card-simulation .flex-container .flex-item .buttons .btn{width:100%;margin:5px 0}loans-sign-up .responsiveMobile .request-card-simulation__empty{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}loans-sign-up .responsiveMobile .request-card-simulation__empty .icon-warning{margin-bottom:30px}loans-sign-up .request-card-simulation{margin-top:50px;padding-top:20px}loans-sign-up .request-card-simulation .title-results{text-transform:uppercase;color:#0072c9;font-size:13px;font-weight:400}loans-sign-up .request-card-simulation .flex-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-line-pack:start;align-content:flex-start;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:27px 0 120px}loans-sign-up .request-card-simulation .flex-container .flex-item{width:350px;height:auto;margin-right:45px;margin-bottom:45px;padding-bottom:20px;border-radius:3px;box-shadow:0 0 4px rgba(0,0,0,.24)}loans-sign-up .request-card-simulation .flex-container .flex-item:last-child{margin-right:0}loans-sign-up .request-card-simulation .flex-container .flex-item .title{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;padding:8px 22px 10px 20px;background-color:hsla(0,0%,97%,.75);border-bottom:1px solid #e9e9e9;min-height:105px}loans-sign-up .request-card-simulation .flex-container .flex-item .title .icon-euro-hand{font-size:50px;margin-right:15px}loans-sign-up .request-card-simulation .flex-container .flex-item .title h2{font-size:24px;display:inline-block;width:75%;font-weight:400;line-height:1.2;margin:0}loans-sign-up .request-card-simulation .flex-container .flex-item .wrapper-details .details{padding-top:20px;padding-bottom:15px;min-height:340px}loans-sign-up .request-card-simulation .flex-container .flex-item .wrapper-details .details hr{width:85%;margin:0 auto;color:#dddfe2}loans-sign-up .request-card-simulation .flex-container .flex-item .detail-error{padding:0 20px;min-height:340px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}loans-sign-up .request-card-simulation .flex-container .flex-item .detail-error-header{width:100%;text-align:center;border-bottom:1px solid #dddfe2}loans-sign-up .request-card-simulation .flex-container .flex-item .detail-error-header .title-error{font-size:24px;color:#c8175e;text-transform:none}loans-sign-up .request-card-simulation .flex-container .flex-item .detail-error-header .icon-warning{font-size:65px;margin-bottom:30px}loans-sign-up .request-card-simulation .flex-container .flex-item .detail-error-header .icon-warning:before{color:#c8175e}loans-sign-up .request-card-simulation .flex-container .flex-item .detail-error-body{max-width:230px;margin-top:30px;text-align:center}loans-sign-up .request-card-simulation .flex-container .flex-item .detail-error-body p{font-size:15px;color:#666}loans-sign-up .request-card-simulation .flex-container .flex-item .buttons{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;height:23%}loans-sign-up .request-card-simulation .flex-container .flex-item .buttons .btn{width:300px;margin:5px 0;font-size:12px;height:40px;line-height:40px}loans-sign-up .request-card-simulation__empty{text-align:center;color:#0072c9;margin-top:15px}loans-sign-up .request-card-simulation__empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansSignUpForm = __webpack_require__(1897);
	
	var _loansSignUpForm2 = _interopRequireDefault(_loansSignUpForm);
	
	var _loansSignUpFormFields = __webpack_require__(1902);
	
	var _loansSignUpFormFields2 = _interopRequireDefault(_loansSignUpFormFields);
	
	var _loansSignUpFormLegalConditions = __webpack_require__(1908);
	
	var _loansSignUpFormLegalConditions2 = _interopRequireDefault(_loansSignUpFormLegalConditions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpFormModule = _angular2.default.module('loansSignUpForm', [_loansSignUpFormFields2.default, _loansSignUpFormLegalConditions2.default]).component('loansSignUpForm', _loansSignUpForm2.default).name;
	
	exports.default = loansSignUpFormModule;

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansSignUpForm = __webpack_require__(1898);
	
	var _loansSignUpForm2 = _interopRequireDefault(_loansSignUpForm);
	
	var _loansSignUpForm3 = __webpack_require__(1899);
	
	var _loansSignUpForm4 = _interopRequireDefault(_loansSignUpForm3);
	
	__webpack_require__(1900);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpFormComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    simulation: '<',
	    backSimulation: '<',
	    loanPurposes: '<',
	    onCancelCreateLoan: '&',
	    onCreateLoan: '&',
	    housingChange: '<',
	    housingLoan: '<',
	    isVariousCredit: '<',
	    onOpenDetail: '&',
	    isMobileApp: '<'
	  },
	  template: _loansSignUpForm2.default,
	  controller: _loansSignUpForm4.default
	};
	
	exports.default = loansSignUpFormComponent;

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <loans-sign-up-form-fields\n    ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    simulation=\"$ctrl.simulation\"\n    back-simulation=\"$ctrl.backSimulation\"\n    loan=\"$ctrl.loan\"\n    loan-purposes=\"$ctrl.loanPurposes\"\n    is-various-credit=\"$ctrl.isVariousCredit\"\n    housing-loan=\"$ctrl.housingLoan\"\n    housing-change=\"$ctrl.housingChange\"\n    on-open-detail=\"$ctrl.onOpenDetail()\"\n  >\n  </loans-sign-up-form-fields>\n\n  <loans-sign-up-form-legal-conditions\n    ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n    on-accept-legal-conditions=\"$ctrl.onAcceptLegalConditions($event)\"\n    loan-purpose-text=\"$ctrl.simulation.loanPurpose.option\"\n    is-mobile-app=\"$ctrl.isMobileApp\"\n  >\n  </loans-sign-up-form-legal-conditions>\n\n  <div ng-if=\"!$ctrl.isMobileApp\" class=\"sign-up-buttons\">\n    <div class=\"row\">\n      <div class=\"col-xs-12 text-right\">\n        <button\n          ng-disabled=\"$ctrl.isDisabledOnFinished()\"\n          class=\"btn btn-app btn-default\"\n          ng-click=\"$ctrl.cancelCreateLoan()\"\n        >\n          {{ 'GLOBALS.BUTTON_ACTION.CANCEL' | translate }}\n        </button>\n        <button\n          ng-disabled=\"$ctrl.isDisabledCreateLoan()\"\n          class=\"btn btn-app btn-primary\"\n          ng-click=\"$ctrl.openModal()\"\n        >\n          {{ 'GLOBALS.BUTTON_ACTION.CONTRACT' | translate }}\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.openModal()\"\n    on-click-second-button=\"$ctrl.cancelCreateLoan()\"\n  >\n  </floating-action-buttons>\n\n  <loans-sign-up-confirmation-modal\n    loan-id=\"$ctrl.backSimulation.loanId\"\n    confirm-loan=\"$ctrl.createLoan()\"\n    is-mobile-app=\"$ctrl.isMobileApp\">\n  </loans-sign-up-confirmation-modal>\n</section>\n"

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansSignUpFormController = function () {
	  LoansSignUpFormController.$inject = ["EventEmitter", "LoansNeedALoanService"];
	  function LoansSignUpFormController(EventEmitter, LoansNeedALoanService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansSignUpFormController);
	    this.EventEmitter = EventEmitter;
	    this.loansNeedALoanService = LoansNeedALoanService;
	  }
	
	  (0, _createClass3.default)(LoansSignUpFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.CONTRACT',
	        disabled: true
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }, {
	    key: 'isDisabledCreateLoan',
	    value: function isDisabledCreateLoan() {
	      return this.finished || !this.acceptLegalConditions;
	    }
	  }, {
	    key: 'onAcceptLegalConditions',
	    value: function onAcceptLegalConditions($event) {
	      this.acceptLegalConditions = $event.accept;
	
	      if (this.isMobileApp) {
	        this.floatingActionButtons[0].disabled = this.isDisabledCreateLoan();
	      }
	    }
	  }, {
	    key: 'cancelCreateLoan',
	    value: function cancelCreateLoan() {
	      this.onCancelCreateLoan();
	    }
	  }, {
	    key: 'createLoan',
	    value: function createLoan() {
	      this.onCreateLoan(this.EventEmitter({ loan: this.getLoan() }));
	      this.finished = true;
	
	      if (this.isMobileApp) {
	        this.loansNeedALoanService.clearAllDataSimulation();
	      }
	    }
	  }, {
	    key: 'getLoan',
	    value: function getLoan() {
	      return {
	        loanId: this.loan.idHr,
	        loanPurposeId: this.backSimulation.loanPurposeId,
	        amount: this.sanitizeNumber(this.backSimulation.amount),
	        deadline: this.sanitizeNumber(this.backSimulation.deadline),
	        monthlyAmount: this.sanitizeNumber(this.backSimulation.monthlyAmount),
	        interestRate: this.sanitizeNumber(this.backSimulation.interestRates),
	        annualPercentageRate: this.sanitizeNumber(this.backSimulation.tae),
	        wantInsurance: this.backSimulation.wantInsurance,
	        typeFixedVariable: this.backSimulation.typeFixedVariable || '0',
	        acquisitionCost: this.sanitizeNumber(this.simulation.amountSimulation.acquisitionCost),
	        salePrice: this.sanitizeNumber(this.simulation.amountSimulation.salePrice),
	        loanSituation: this.backSimulation.loanSituation
	      };
	    }
	  }, {
	    key: 'sanitizeNumber',
	    value: function sanitizeNumber(n) {
	      return parseFloat(n, 10) || 0;
	    }
	  }, {
	    key: 'isDisabledOnFinished',
	    value: function isDisabledOnFinished() {
	      return this.finished;
	    }
	  }, {
	    key: 'isSocialOrAgreementHousingLoan',
	    value: function isSocialOrAgreementHousingLoan() {
	      return this.backSimulation.loanId === _constants2.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.backSimulation.loanId === _constants2.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.isSocialOrAgreementHousingLoan() ? this.modal.modal('show') : this.createLoan();
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      var $modal = $(_constants.MODALS.LOANS_CONFIRMATION_SIGN_UP);
	      return $modal;
	    }
	  }]);
	  return LoansSignUpFormController;
	}();
	
	exports.default = LoansSignUpFormController;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1901);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpForm.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpForm.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-sign-up-form{display:block}loans-sign-up-form .sign-up-buttons{height:50px}loans-sign-up-form .sign-up-buttons .btn-default{margin-right:30px}", ""]);
	
	// exports


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansSignUpFormFields = __webpack_require__(1903);
	
	var _loansSignUpFormFields2 = _interopRequireDefault(_loansSignUpFormFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpFormFieldsModule = _angular2.default.module('loansSignUpFormFields', [_angularUiRouter2.default]).component('loansSignUpFormFields', _loansSignUpFormFields2.default).name;
	
	exports.default = loansSignUpFormFieldsModule;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansSignUpFormFields = __webpack_require__(1904);
	
	var _loansSignUpFormFields2 = _interopRequireDefault(_loansSignUpFormFields);
	
	var _loansSignUpFormFields3 = __webpack_require__(1905);
	
	var _loansSignUpFormFields4 = _interopRequireDefault(_loansSignUpFormFields3);
	
	__webpack_require__(1906);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpFormFieldsComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    simulation: '<',
	    backSimulation: '<',
	    loanPurposes: '<',
	    housingChange: '<',
	    housingLoan: '<',
	    isVariousCredit: '<',
	    onOpenDetail: '&',
	    isMobileApp: '<'
	  },
	  template: _loansSignUpFormFields2.default,
	  controller: _loansSignUpFormFields4.default
	};
	
	exports.default = loansSignUpFormFieldsComponent;

/***/ }),
/* 1904 */
/***/ (function(module, exports) {

	module.exports = "<form name=\"$ctrl.form\" novalidate>\n\n  <!--Reason-->\n  <div class=\"loans-sign-up-form-row\">\n\n    <span class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM.REASON' | translate }}\n\n      <tooltip-desktop\n        ng-if=\"!$ctrl.isMobileApp\"\n        placement=\"right\"\n        title=\"{{'LOANS.SIGN_UP.TOOLTIPS.' + $ctrl.loan.signUp.tooltipId + '.FINALITY'}}\">\n      </tooltip-desktop>\n\n      <tooltip-mobile  ng-if=\"$ctrl.isMobileApp\" name=\"loansSignUpFormReason\">\n        <p class=\"tooltip-title\">\n          {{ 'LOANS.SIGN_UP.FORM.REASON' | translate }}\n        </p>\n        <p>\n          {{ 'LOANS.SIGN_UP.TOOLTIPS.' + $ctrl.loan.signUp.tooltipId + '.FINALITY' | translate }}\n        </p>\n      </tooltip-mobile>\n\n    </span>\n\n    <div>\n      <span class=\"loans-sign-up-form-text\">\n        {{ $ctrl.backSimulation.loanPurposeDescription }}\n      </span>\n    </div>\n\n  </div>\n\n  <!--Amount-->\n  <div class=\"loans-sign-up-form-row\">\n    <span class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM.AMOUNT' | translate }}\n    </span>\n\n    <span class=\"loans-sign-up-form-text\">\n      {{ $ctrl.amount | currency}}\n    </span>\n  </div>\n\n  <!-- Acquisition cost -->\n  <div class=\"loans-sign-up-form-row\" ng-if=\"$ctrl.isHousingLoan()\">\n    <span class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM_SIMULATION.ACQUISITION_COST' | translate }}\n    </span>\n\n    <span class=\"loans-sign-up-form-text\">\n      {{ $ctrl.acquisitionCost | currency}}\n    </span>\n  </div>\n\n  <!-- Sale price -->\n  <div class=\"loans-sign-up-form-row\" ng-if=\"$ctrl.isHousingChange()\">\n    <span class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM_SIMULATION.SALE_PRICE' | translate }}\n    </span>\n\n    <span class=\"loans-sign-up-form-text\">\n      {{ $ctrl.salePrice | currency}}\n    </span>\n  </div>\n\n  <!-- Difference -->\n  <div class=\"loans-sign-up-form-row\" ng-if=\"$ctrl.isHousingChange()\">\n    <span class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM_SIMULATION.DIFF' | translate }}\n    </span>\n\n    <span class=\"loans-sign-up-form-text\">\n      {{ ($ctrl.diff) | currency}}\n    </span>\n  </div>\n\n  <!--Deadline-->\n  <div class=\"loans-sign-up-form-row\">\n\n    <span class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM.DEADLINE' | translate }}\n\n      <tooltip-desktop\n        ng-if=\"!$ctrl.isMobileApp\"\n        placement=\"right\"\n        title=\"{{ 'LOANS.SIGN_UP.TOOLTIPS.' + $ctrl.loan.signUp.tooltipId + '.DEADLINE'}}\">\n      </tooltip-desktop>\n\n      <tooltip-mobile  ng-if=\"$ctrl.isMobileApp\" name=\"loansSignUpFormDeadline\">\n        <p class=\"tooltip-title\">\n          {{ 'LOANS.SIGN_UP.FORM.DEADLINE' | translate }}\n        </p>\n        <p>\n          {{ 'LOANS.SIGN_UP.TOOLTIPS.' + $ctrl.loan.signUp.tooltipId + '.DEADLINE' | translate }}\n        </p>\n      </tooltip-mobile>\n\n    </span>\n\n    <span class=\"loans-sign-up-form-text\">\n      {{ $ctrl.deadlineView }}\n    </span>\n  </div>\n\n  <!--Monthly payment-->\n  <div class=\"loans-sign-up-form-row\">\n    <span class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM.MONTHLY_PAYMENT' | translate }}\n    </span>\n\n    <span class=\"loans-sign-up-form-text\">\n      {{ $ctrl.monthlyAmount | currency }}\n    </span>\n  </div>\n\n  <!--Interest rate-->\n  <div class=\"loans-sign-up-form-row interest-rate\">\n    <span ng-if=\"!$ctrl.showFullInterestRateLabel()\" class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM.INTEREST_RATE' | translate }}\n    </span>\n\n    <span ng-if=\"$ctrl.showFullInterestRateLabel()\" class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM.CURRENT_INTEREST_RATE' | translate }}\n    </span>\n\n    <div>\n      <span class=\"loans-sign-up-form-text\">\n        {{ $ctrl.backSimulation.interestRates | number:3 }} %\n      </span>\n\n      <a\n        ng-if=\"!$ctrl.isMobile && $ctrl.showFullInterestRateLabel()\"\n        ng-click=\"$ctrl.onOpenDetail()\"\n        ng-init=\"$ctrl.tooltip()\"\n        class=\"loans-sign-up-form-label capitalize pointer see-conditions\"\n        data-toggle=\"tooltip\"\n        data-placement=\"right\"\n        title=\"{{ 'LOANS.SIGN_UP.FORM.SEE_CONDITIONS_TOOLTIP' | translate }}\">\n        &nbsp; {{ 'LOANS.SIGN_UP.FORM.SEE_CONDITIONS' | translate }}\n      </a>\n\n      <a\n        ng-if=\"$ctrl.isMobile && $ctrl.showFullInterestRateLabel()\"\n        ng-click=\"$ctrl.onOpenDetail()\"\n        class=\"loans-sign-up-form-label capitalize pointer see-conditions\">\n        &nbsp; {{ 'LOANS.SIGN_UP.FORM.SEE_CONDITIONS' | translate }}\n      </a>\n    </div>\n\n  </div>\n\n  <!--Annual percentage rate-->\n  <div class=\"loans-sign-up-form-row\">\n    <span ng-if=\"!$ctrl.isHousingChange()\" class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM.ANNUAL_PERCENTAGE_RATE' | translate }}\n    </span>\n    <span ng-if=\"$ctrl.isHousingChange()\" class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM.CURRENT_ANNUAL_PERCENTAGE_RATE' | translate }}\n    </span>\n    <span class=\"loans-sign-up-form-text\">\n      {{ $ctrl.backSimulation.tae | number:3 }} %\n    </span>\n  </div>\n\n  <!--Want insurance-->\n  <div class=\"loans-sign-up-form-row\">\n    <span class=\"loans-sign-up-form-label\">\n      {{ 'LOANS.SIGN_UP.FORM.WANT_INSURANCE' | translate }}\n\n      <tooltip-desktop\n        ng-if=\"!$ctrl.isMobileApp\"\n        placement=\"right\"\n        title=\"{{$ctrl.tooltipTitle()}}\">\n      </tooltip-desktop>\n\n      <tooltip-mobile  ng-if=\"$ctrl.isMobileApp\" name=\"loansSignUpFormInsuranceInfo\">\n        <p class=\"tooltip-title\">\n          {{ 'LOANS.SIGN_UP.FORM.WANT_INSURANCE' | translate }}\n        </p>\n       <p ng-if=\"$ctrl.isSocialAgreementHousingLoan()\"> \n          {{ 'LOANS.SIGN_UP.TOOLTIPS.SOCIAL_HOUSING_AGREEMENT.DETAILED_INSURANCE_INFO2' | translate }} \n        </p>\n        <p ng-if=\"!$ctrl.isSocialAgreementHousingLoan()\"> \n          {{ 'LOANS.SIGN_UP.TOOLTIPS.INSURANCE_INFO' | translate }} \n        </p>\n      </tooltip-mobile>\n    </span>\n\n    <!-- No insurance -->\n    <span\n      ng-class=\"{ 'text-right': $ctrl.isMobileApp }\"\n      ng-if=\"!$ctrl.wantInsurance && !$ctrl.isMandatoryInsurance()\"\n      class=\"loans-sign-up-form-text\">\n      {{ 'LOANS.SIGN_UP.FORM.NO_OPTIONAL' | translate }}\n    </span>\n\n    <!-- Insurance -->\n    <div class=\"two-lines\" ng-if=\"$ctrl.wantInsurance || $ctrl.isMandatoryInsurance()\">\n      <span\n        ng-class=\"{ 'text-right': $ctrl.isMobileApp }\"\n        class=\"loans-sign-up-form-text\">\n        {{ 'GLOBALS.YES' | translate }}\n\n        <i ng-if=\"$ctrl.isMandatoryInsurance()\">( {{ 'LOANS.SIGN_UP.FORM.MANDATORY' | translate }} )</i>\n\n        <i ng-if=\"!$ctrl.isMandatoryInsurance()\">( {{ 'LOANS.SIGN_UP.FORM.OPTIONAL' | translate }} )</i>\n      </span>\n      <span class=\"loans-sign-up-form-text\">\n        {{ 'LOANS.SIGN_UP.FORM.YEARLY_FEE' | translate }} {{ $ctrl.annualTerm | currency }}\n      </span>\n    </div>\n  </div>\n\n</form>\n"

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _isMobile = __webpack_require__(745);
	
	var _isMobile2 = _interopRequireDefault(_isMobile);
	
	var _tooltip = __webpack_require__(744);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _constantsLoans = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansSignUpFormFieldsController = function () {
	  LoansSignUpFormFieldsController.$inject = ["$translate", "$state"];
	  function LoansSignUpFormFieldsController($translate, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansSignUpFormFieldsController);
	    this.translate = $translate;
	    this.tooltip = _tooltip2.default;
	    this.state = $state;
	    this.isMobile = (0, _isMobile2.default)();
	  }
	
	  (0, _createClass3.default)(LoansSignUpFormFieldsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this._initTranslations(this._initDeadLineView);
	      this._assignInitialValues();
	      this.tooltipTitle();
	    }
	  }, {
	    key: '_initTranslations',
	    value: function _initTranslations(callback) {
	      var _this2 = this;
	
	      var _this = this;
	      this.translate('GLOBALS.MONTHS').then(function (translation) {
	        _this2._monthsString = translation;
	        callback.apply(_this);
	      });
	    }
	  }, {
	    key: '_initDeadLineView',
	    value: function _initDeadLineView() {
	      this.deadlineView = this.getDeadlineView();
	    }
	  }, {
	    key: '_assignInitialValues',
	    value: function _assignInitialValues() {
	      var _backSimulation = this.backSimulation,
	          amount = _backSimulation.amount,
	          wantInsurance = _backSimulation.wantInsurance,
	          monthlyAmount = _backSimulation.monthlyAmount,
	          annualTerm = _backSimulation.annualTerm;
	      var _simulation$amountSim = this.simulation.amountSimulation,
	          salePrice = _simulation$amountSim.salePrice,
	          acquisitionCost = _simulation$amountSim.acquisitionCost,
	          diff = _simulation$amountSim.diff;
	
	      this.amount = amount;
	      this.wantInsurance = wantInsurance;
	      this.monthlyAmount = monthlyAmount;
	      this.salePrice = salePrice;
	      this.acquisitionCost = acquisitionCost;
	      this.diff = diff;
	      this.annualTerm = annualTerm;
	    }
	  }, {
	    key: 'getDeadlineView',
	    value: function getDeadlineView() {
	      return this.backSimulation.deadline + ' ' + this._monthsString;
	    }
	  }, {
	    key: 'isHousingLoan',
	    value: function isHousingLoan() {
	      return this.housingLoan === true;
	    }
	  }, {
	    key: 'isHousingChange',
	    value: function isHousingChange() {
	      return this.isHousingLoan() && this.housingChange;
	    }
	  }, {
	    key: 'showFullInterestRateLabel',
	    value: function showFullInterestRateLabel() {
	      return this.housingLoan || this.isVariousCredit;
	    }
	  }, {
	    key: 'isMandatoryInsurance',
	    value: function isMandatoryInsurance() {
	      return this.loan.signUp.mandatoryInsurance;
	    }
	  }, {
	    key: 'isSocialAgreementHousingLoan',
	    value: function isSocialAgreementHousingLoan() {
	      return this.loan && this.loan.id === _constantsLoans.LOANS.ID.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'tooltipTitle',
	    value: function tooltipTitle() {
	      var title = null;
	
	      if (this.isSocialAgreementHousingLoan()) {
	        title = '{{ "LOANS.SIGN_UP.TOOLTIPS.SOCIAL_HOUSING_AGREEMENT.DETAILED_INSURANCE_INFO2" | translate }}';
	      } else {
	        title = '{{ "LOANS.SIGN_UP.TOOLTIPS.INSURANCE_INFO" | translate }}';
	      }
	
	      return title;
	    }
	  }]);
	  return LoansSignUpFormFieldsController;
	}();
	
	exports.default = LoansSignUpFormFieldsController;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1907);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpFormFields.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpFormFields.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-sign-up-form-fields{display:block}loans-sign-up-form-fields.mobile form .loans-sign-up-form-row{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}loans-sign-up-form-fields.mobile form .loans-sign-up-form-row .two-lines{display:flex;flex-direction:column}loans-sign-up-form-fields.mobile form .loans-sign-up-form-row .loans-sign-up-form-label{width:auto;min-width:150px;margin-right:15px;font-size:12px}loans-sign-up-form-fields.mobile form .loans-sign-up-form-row .loans-sign-up-form-label.see-conditions{min-width:unset;margin:0;padding:0}loans-sign-up-form-fields.mobile form .loans-sign-up-form-row .loans-sign-up-form-label+div{text-align:right}loans-sign-up-form-fields.mobile form .loans-sign-up-form-row .loans-sign-up-form-text{font-size:13px}loans-sign-up-form-fields.mobile form .interest-see-conditions-box{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}loans-sign-up-form-fields.mobile form .interest-see-conditions-box a{margin-top:8px}loans-sign-up-form-fields form select-app{width:554px}loans-sign-up-form-fields form .loans-sign-up-form-row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;height:38px;margin-bottom:18px}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-label{color:#0072c9;display:inline-block;font-family:Stag Sans;font-size:13px;font-weight:400;line-height:1;text-transform:uppercase;width:195px}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-label:focus,loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-label:hover{text-decoration:none;background:#fff}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-label.capitalize{text-transform:capitalize}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-label.pointer{cursor:pointer}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-label.see-conditions{width:auto;padding-right:5px;display:inline-block}loans-sign-up-form-fields form .loans-sign-up-form-row .icon-interrogation-color{font-size:19px;display:inline-block;margin-left:5px;vertical-align:middle}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-text{color:#666;font-family:Stag Sans;font-size:15px;font-weight:400;line-height:1}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-text.blue{color:#0072c9}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-text.error{color:#c8175e}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-text.change-reason{cursor:pointer;margin-left:20px}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-input{background-color:#fff;border:1px solid #dddfe2;color:#666;font-family:Stag Sans;font-size:13px;font-weight:400;height:37px;outline:0!important;padding:20px 20px 10px 10px;text-align:right;width:100px}loans-sign-up-form-fields form .loans-sign-up-form-row .loans-sign-up-form-input.ng-dirty.ng-invalid{border-color:#c8175e}", ""]);
	
	// exports


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansSignUpFormLegalConditions = __webpack_require__(1909);
	
	var _loansSignUpFormLegalConditions2 = _interopRequireDefault(_loansSignUpFormLegalConditions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpFormLegalConditionsModule = _angular2.default.module('loansSignUpFormLegalConditions', [_angularUiRouter2.default]).component('loansSignUpFormLegalConditions', _loansSignUpFormLegalConditions2.default).name;
	
	exports.default = loansSignUpFormLegalConditionsModule;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansSignUpFormLegalConditions = __webpack_require__(1910);
	
	var _loansSignUpFormLegalConditions2 = _interopRequireDefault(_loansSignUpFormLegalConditions);
	
	var _loansSignUpFormLegalConditions3 = __webpack_require__(1911);
	
	var _loansSignUpFormLegalConditions4 = _interopRequireDefault(_loansSignUpFormLegalConditions3);
	
	__webpack_require__(1912);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpFormLegalConditionsComponent = {
	  restrict: 'E',
	  bindings: {
	    onAcceptLegalConditions: '&',
	    loanPurposeText: '<',
	    isMobileApp: '<'
	  },
	  template: _loansSignUpFormLegalConditions2.default,
	  controller: _loansSignUpFormLegalConditions4.default
	};
	
	exports.default = loansSignUpFormLegalConditionsComponent;

/***/ }),
/* 1910 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"loans-detail-collapse\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n    <div class=\"loans-detail-collapse-header\">\n      <h2 class=\"title\">{{ 'LOANS.SIGN_UP.LEGAL_CONDITIONS.TITLE' | translate }}</h2>\n      <p>{{ 'LOANS.SIGN_UP.LEGAL_CONDITIONS.SUBTITLE' | translate }}</p>\n    </div>\n  </div>\n\n  <div class=\"checkbox\" class=\"isMobile\">\n    <input\n      type=\"checkbox\"\n      id=\"acceptLegalConditions\"\n      ng-model=\"$ctrl.acceptLegalConditions\"\n      ng-true-value=\"true\"\n      ng-change=\"$ctrl.emit()\">\n    <label for=\"acceptLegalConditions\">\n      {{ 'LOANS.SIGN_UP.FORM.ACCEPT' | translate }}\n    </label>\n    </div>\n    <div class=\"checkbox isMobile\">\n      <label class=\"isMobile\" ng-if='$ctrl.isMobileApp'>\n       <a ng-click=\"$ctrl.openPdf()\" >{{'LOANS.SIGN_UP.FORM.ACCEPT_CONDITIONS_DOWLOAD' | translate }}</a>\n      </label>\n    </div>\n    <div class=\"checkbox web\">\n      <label class=\"web\" ng-if='!$ctrl.isMobileApp'>\n       <a href=\"{{$ctrl.getFileName()}}\" target=\"_blanck\" download=\"Condiciones_de_contratación.pdf\">{{'LOANS.SIGN_UP.FORM.ACCEPT_CONDITIONS_DOWLOAD' | translate }}</a>\n      </label>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansSignUpFormLegalConditionsController = function () {
	  LoansSignUpFormLegalConditionsController.$inject = ["EventEmitter", "$stateParams", "loansStaticService", "$log"];
	  function LoansSignUpFormLegalConditionsController(EventEmitter, $stateParams, loansStaticService, $log) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansSignUpFormLegalConditionsController);
	    this.EventEmitter = EventEmitter;
	    this.log = $log;
	    this.loanId = $stateParams.loanId;
	    this.loan = loansStaticService.get(this.loanId);
	    this.BASE_URL = 'documents/Condiciones_de_contratacion_';
	    this.SOCIAL_HOUSING = 'socialHousingLoan';
	    this.AGREEMENT_HOUSING = 'agreementHousingLoan';
	    this.SOCIAL_AND_AGREEMENT = 'SV_VC_GDPR.pdf';
	    this.MONTHLY_AND_CREDIT = 'CV_5S_9S_GDPR.pdf';
	  }
	
	  (0, _createClass3.default)(LoansSignUpFormLegalConditionsController, [{
	    key: 'emit',
	    value: function emit() {
	      this.onAcceptLegalConditions(this.EventEmitter({ accept: this.acceptLegalConditions }));
	    }
	  }, {
	    key: 'getFileName',
	    value: function getFileName() {
	      var url = this.BASE_URL;
	      url += this.loanId === this.SOCIAL_HOUSING || this.loanId === this.AGREEMENT_HOUSING ? this.SOCIAL_AND_AGREEMENT : this.MONTHLY_AND_CREDIT;
	      return url;
	    }
	  }, {
	    key: 'openPdf',
	    value: function openPdf() {
	      var fileName = this.getFileName();
	      var openedWindow = window.open(fileName, '_blank');
	
	      if (!openedWindow) {
	        this.log.warn('Could not open PDF in a new window, redirecting current view');
	        window.location.href = fileName;
	      }
	    }
	  }]);
	  return LoansSignUpFormLegalConditionsController;
	}();
	
	exports.default = LoansSignUpFormLegalConditionsController;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1913);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpFormLegalConditions.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpFormLegalConditions.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-sign-up-form-legal-conditions.mobile loans-detail-collapse .loans-detail-collapse{margin-left:30px;margin-right:30px;border-bottom:1px solid #dddfe2}loans-sign-up-form-legal-conditions.mobile loans-detail-collapse .loans-sign-up-legal-conditions h2{font-size:13px;font-weight:400}loans-sign-up-form-legal-conditions.mobile loans-detail-collapse .loans-sign-up-legal-conditions li{text-align:left}loans-sign-up-form-legal-conditions.mobile .checkbox{margin-top:4px;margin-bottom:20px}loans-sign-up-form-legal-conditions.mobile .checkbox label{font-size:14px;margin-bottom:0;height:auto;margin-left:9px}loans-sign-up-form-legal-conditions.mobile .checkbox label .isMobile{margin-left:9px}loans-sign-up-form-legal-conditions.mobile .checkbox input[type=checkbox]:checked+label{font-size:14px;padding-bottom:0;height:auto}loans-sign-up-form-legal-conditions.mobile span{padding-bottom:30px;padding-left:20px}loans-sign-up-form-legal-conditions.mobile a{margin-left:20px}loans-sign-up-form-legal-conditions .loans-detail-collapse{border-top:1px solid #dddfe2;padding:36px 32px 20px}loans-sign-up-form-legal-conditions .loans-detail-collapse.mobile{padding:15px 8px 0}loans-sign-up-form-legal-conditions .loans-detail-collapse.mobile .loans-detail-collapse-header>.title{width:84%;font-size:16px}loans-sign-up-form-legal-conditions .loans-detail-collapse.mobile .loans-detail-collapse-header p{width:84%;font-size:13px;padding-bottom:21px}loans-sign-up-form-legal-conditions .loans-detail-collapse.mobile p{font-size:13px;text-align:left}loans-sign-up-form-legal-conditions .loans-detail-collapse h2.title{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;font-family:Stag Sans;font-weight:400;font-size:24px;margin:0 0 6px;color:#0072c9}loans-sign-up-form-legal-conditions .loans-detail-collapse p{font-family:ArialMT;font-size:15px;text-align:justify;color:#666}loans-sign-up-form-legal-conditions .loans-sign-up-legal-conditions{text-align:justify}loans-sign-up-form-legal-conditions .loans-sign-up-legal-conditions .clause{padding-right:50px}loans-sign-up-form-legal-conditions .loans-sign-up-legal-conditions .clause ul{list-style-type:lower-latin}loans-sign-up-form-legal-conditions .loans-sign-up-legal-conditions .declaration{padding-right:50px}loans-sign-up-form-legal-conditions .loans-sign-up-legal-conditions .declaration ul{list-style-type:decimal}loans-sign-up-form-legal-conditions .loans-sign-up-legal-conditions .declaration .info{padding-left:40px;padding-bottom:15px}loans-sign-up-form-legal-conditions .loans-sign-up-legal-conditions h2{color:#0072c9;font-size:18px}loans-sign-up-form-legal-conditions .checkbox label{margin-left:10px;color:#666}loans-sign-up-form-legal-conditions div .web{margin-top:-48px;margin-bottom:30px;margin-left:60px}loans-sign-up-form-legal-conditions div .isMobile{margin-top:-24px;margin-bottom:30px}loans-sign-up-form-legal-conditions label{margin-top:-31px}loans-sign-up-form-legal-conditions label .web{margin-left:61px}loans-sign-up-form-legal-conditions label .isMobile{padding-left:20px}", ""]);
	
	// exports


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansSignUpFormSimulation = __webpack_require__(1915);
	
	var _loansSignUpFormSimulation2 = _interopRequireDefault(_loansSignUpFormSimulation);
	
	var _loansSignUpFormSimulationHousingChangeWarning = __webpack_require__(1920);
	
	var _loansSignUpFormSimulationHousingChangeWarning2 = _interopRequireDefault(_loansSignUpFormSimulationHousingChangeWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpFormSimulationModule = _angular2.default.module('loansSignUpFormSimulation', [_loansSignUpFormSimulationHousingChangeWarning2.default]).component('loansSignUpFormSimulation', _loansSignUpFormSimulation2.default).name;
	
	exports.default = loansSignUpFormSimulationModule;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansSignUpFormSimulation = __webpack_require__(1916);
	
	var _loansSignUpFormSimulation2 = _interopRequireDefault(_loansSignUpFormSimulation);
	
	var _loansSignUpFormSimulation3 = __webpack_require__(1917);
	
	var _loansSignUpFormSimulation4 = _interopRequireDefault(_loansSignUpFormSimulation3);
	
	__webpack_require__(1918);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpFormSimulationComponent = {
	  restrict: 'E',
	  bindings: {
	    simulationWitness: '<',
	    loan: '<',
	    onSubmit: '&',
	    simulation: '<',
	    loanPurposes: '<',
	    housingChange: '<',
	    housingLoan: '<',
	    isMobileApp: '<',
	    initialCharges: '<',
	    data: '<'
	  },
	  template: _loansSignUpFormSimulation2.default,
	  controller: _loansSignUpFormSimulation4.default
	};
	
	exports.default = loansSignUpFormSimulationComponent;

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <section-title\n    text=\"{{ 'LOANS.SIGN_UP.FORM_SIMULATION.TITLE' | translate }}\"\n    is-mobile-app=\"$ctrl.isMobileApp\">\n  </section-title>\n\n  <select-app\n    class=\"small-options\"\n    ng-class=\"{ 'error-options': $ctrl.showErrorSelect, 'mobile': $ctrl.isMobileApp }\"\n    name=\"loanPurpose\"\n    options=\"$ctrl.loanPurposes\"\n    ng-if=\"$ctrl.loanPurposes !== undefined && $ctrl.loanPurposes !== null\"\n    disabled=\"$ctrl.selectLoanPurposesDisabled()\"\n    required=\"true\"\n    on-select=\"$ctrl.onSelectLoanPurpose($event)\"\n    initial-value=\"$ctrl.loanPurpose\">\n  </select-app>\n\n  <loans-sign-up-form-simulation-housing-change-warning\n    ng-class=\"{'mobile': $ctrl.isMobileApp}\"\n    ng-if=\"$ctrl.showHousingChangeWarning() || $ctrl.shouldShowMessageWarning()\"\n    simulation-witness=\"$ctrl.simulationWitness\">\n  </loans-sign-up-form-simulation-housing-change-warning>\n\n  <div class=\"table-container\" ng-if=\"$ctrl.shouldShowCreditCapacitySimulation()\">\n    <h2 class=\"table-title\">{{ 'LOANS.NEED_A_LOAN.SIMULATION_CREDIT_CAPACITY' | translate }}</h2>\n    <table-app class=\"table\" data=\"$ctrl.data.tableData\"></table-app>\n  </div>\n\n  <loans-amount-simulation\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    ng-class=\"{'mobile': $ctrl.isMobileApp}\"\n    ng-hide=\"$ctrl.hideAmountSimulation()\"\n    has-prevalidation=\"true\"\n    pre-valid=\"$ctrl.loanPurpose !== undefined\"\n    loan=\"$ctrl.loan\"\n    simulation=\"$ctrl.simulation.amountSimulation\"\n    on-submit=\"$ctrl.setAmountSimulation($event)\"\n    housing-change=\"$ctrl.housingChange\"\n    simulation-witness=\"$ctrl.simulationWitness\"\n    code-option-selected=\"$ctrl.codeOptionSelected\"\n    initial-charges=\"$ctrl.initialCharges\"\n    should-show-credit-capacity-simulation=\"$ctrl.shouldShowCreditCapacitySimulation()\"\n    is-housing-mandatory-purpose=\"$ctrl.isHousingMandatoryPurpose()\"\n    housing-loan=\"$ctrl.housingLoan\"\n    on-error-in-select=\"$ctrl.onErrorInSelect()\">\n  </loans-amount-simulation>\n</div>\n"

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constantsLoans = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansSignUpFormSimulationController = function () {
	  LoansSignUpFormSimulationController.$inject = ["EventEmitter"];
	  function LoansSignUpFormSimulationController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansSignUpFormSimulationController);
	    this.EventEmitter = EventEmitter;
	    this.HOUSING_MANDATORY_PURPOSE = _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
	    this.showErrorSelect = false;
	    this.codeOptionSelected = null;
	  }
	
	  (0, _createClass3.default)(LoansSignUpFormSimulationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this._setInitialData();
	      this._forceLoanPurpose();
	      this.codeOptionSelected = this.loan.idHr;
	    }
	  }, {
	    key: '_setInitialData',
	    value: function _setInitialData() {
	      if (this.simulation) {
	        this.loanPurpose = this.simulation.loanPurpose;
	      }
	    }
	  }, {
	    key: '_forceLoanPurpose',
	    value: function _forceLoanPurpose() {
	      var isSocialOrAgreementLoan = this.loan.id === _constantsLoans.LOANS.ID.SOCIAL_HOUSING_LOAN || this.loan.id === _constantsLoans.LOANS.ID.AGREEMENT_HOUSING_LOAN;
	
	      if (isSocialOrAgreementLoan) {
	        this.loanPurpose = this._findLoanPurposeByCode(this.HOUSING_MANDATORY_PURPOSE);
	        this.disableLoanPurposeSelector = true;
	      }
	    }
	  }, {
	    key: '_findLoanPurposeByCode',
	    value: function _findLoanPurposeByCode(code) {
	      return this.loanPurposes.find(function (purpose) {
	        return purpose.value === code;
	      });
	    }
	  }, {
	    key: 'selectLoanPurposesDisabled',
	    value: function selectLoanPurposesDisabled() {
	      var invalidLoanPurposes = !this.loanPurposes || this.loanPurposes.length === 0;
	      var forcedSelection = this.disableLoanPurposeSelector;
	      return invalidLoanPurposes || forcedSelection;
	    }
	  }, {
	    key: 'onSelectLoanPurpose',
	    value: function onSelectLoanPurpose($event) {
	      this.loanPurpose = $event.$item;
	      this.showErrorSelect = false;
	    }
	  }, {
	    key: 'onErrorInSelect',
	    value: function onErrorInSelect() {
	      this.showErrorSelect = true;
	    }
	  }, {
	    key: 'setAmountSimulation',
	    value: function setAmountSimulation($event) {
	      this.amountSimulation = $event;
	      this.onSubmit(this.EventEmitter(this._getFormData()));
	    }
	  }, {
	    key: '_getFormData',
	    value: function _getFormData() {
	      return {
	        loanPurpose: this.loanPurpose,
	        amountSimulation: this.amountSimulation
	      };
	    }
	  }, {
	    key: 'showHousingChangeWarning',
	    value: function showHousingChangeWarning() {
	      return this.housingLoan && this.housingChange;
	    }
	  }, {
	    key: 'hideAmountSimulation',
	    value: function hideAmountSimulation() {
	      return this.isMobileApp && !this.loanPurpose;
	    }
	  }, {
	    key: 'isHousingMandatoryPurpose',
	    value: function isHousingMandatoryPurpose() {
	      return this.loan.idHr == _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.loan.idHr == _constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'shouldShowMessageWarning',
	    value: function shouldShowMessageWarning() {
	      return this.housingChange && !this.simulationWitness && this.loan.idHr == _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
	    }
	  }, {
	    key: 'shouldShowCreditCapacitySimulation',
	    value: function shouldShowCreditCapacitySimulation() {
	      return this.simulationWitness && (this.loan.idHr == _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.loan.idHr == _constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN || this.loan.idHr == _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE);
	    }
	  }]);
	  return LoansSignUpFormSimulationController;
	}();
	
	exports.default = LoansSignUpFormSimulationController;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1919);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpFormSimulation.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpFormSimulation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-sign-up-form-simulation section-title{padding-top:20px;margin-bottom:20px}loans-sign-up-form-simulation select-app{margin-bottom:40px;width:554px}loans-sign-up-form-simulation select-app.mobile{width:100%}loans-sign-up-form-simulation .error-options .selectApp span.form-control{border:1px solid #c8175e}loans-sign-up-form-simulation .table{border:1px solid #dddfe2!important}loans-sign-up-form-simulation .table-responsive{border-bottom:none!important}loans-sign-up-form-simulation .table-container{width:100%;padding-bottom:20px}@media(min-width:1021px){loans-sign-up-form-simulation .table-container{max-width:660px}}loans-sign-up-form-simulation th{padding:10px!important;text-align:center!important}loans-sign-up-form-simulation .table-title{font-size:24px;color:#fff;background-color:#227aba;text-align:center;padding:10px;width:100%;margin-bottom:0}loans-sign-up-form-simulation table-app{width:100%}loans-sign-up-form-simulation td{text-align:center!important}loans-sign-up-form-simulation .table tbody tr:last-child td{padding-bottom:20px!important}@media(max-width:1020px){loans-sign-up-form-simulation .table{width:100%;border-top:1px solid #dddfe2}loans-sign-up-form-simulation .table thead{display:none}loans-sign-up-form-simulation .table tbody tr{display:block}loans-sign-up-form-simulation .table tbody tr:not(:last-of-type){margin-bottom:15px!important;border-bottom:1px solid #dddfe2!important;padding-bottom:15px!important}loans-sign-up-form-simulation .table tbody tr:last-of-type{margin-bottom:0!important;border-bottom:none!important;padding-bottom:0!important}loans-sign-up-form-simulation .table tbody tr:last-of-type td{border-bottom:none!important;padding-bottom:0!important}loans-sign-up-form-simulation .table tbody td{display:block;width:100%;text-align:left;padding:10px 0!important}loans-sign-up-form-simulation .table tbody td:before{content:attr(data-label);font-weight:700;display:block;color:#227aba;margin-bottom:4px;font-size:16px;text-transform:uppercase;letter-spacing:.5px}}", ""]);
	
	// exports


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansSignUpFormSimulationHousingChangeWarning = __webpack_require__(1921);
	
	var _loansSignUpFormSimulationHousingChangeWarning2 = _interopRequireDefault(_loansSignUpFormSimulationHousingChangeWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpFormSimulationHousingChangeWarningModule = _angular2.default.module('loansSignUpFormSimulationHousingChangeWarning', []).component('loansSignUpFormSimulationHousingChangeWarning', _loansSignUpFormSimulationHousingChangeWarning2.default).name;
	
	exports.default = loansSignUpFormSimulationHousingChangeWarningModule;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansSignUpFormSimulationHousingChangeWarning = __webpack_require__(1922);
	
	var _loansSignUpFormSimulationHousingChangeWarning2 = _interopRequireDefault(_loansSignUpFormSimulationHousingChangeWarning);
	
	__webpack_require__(1923);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpFormSimulationHousingChangeWarningComponent = {
	  restrict: 'E',
	  bindings: {
	    simulationWitness: '<'
	  },
	  template: _loansSignUpFormSimulationHousingChangeWarning2.default
	};
	
	exports.default = loansSignUpFormSimulationHousingChangeWarningComponent;

/***/ }),
/* 1922 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <span class=\"icon icon-info\"></span>\n\n  <p ng-if=\"!$ctrl.simulationWitness\">\n    {{ 'LOANS.SIGN_UP.FORM_SIMULATION.HOUSING_CHANGE_WARNING' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.simulationWitness\"\n     ng-bind-html=\"'LOANS.SIGN_UP.FORM_SIMULATION.SIMULATION_CHANGE_WARNING' | translate\">\n  </p>\n\n</div>\n"

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1924);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpFormSimulationHousingChangeWarning.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpFormSimulationHousingChangeWarning.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-sign-up-form-simulation-housing-change-warning{display:block}loans-sign-up-form-simulation-housing-change-warning.mobile div{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:100%;height:auto;text-align:center;margin-bottom:40px}loans-sign-up-form-simulation-housing-change-warning.mobile div span{margin:0}loans-sign-up-form-simulation-housing-change-warning.mobile div p{width:100%}loans-sign-up-form-simulation-housing-change-warning div{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;-ms-flex-line-pack:start;align-content:flex-start;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;width:862px;min-height:118px;border-radius:6px;border:1px solid #0072c9;padding:10px 21px 17px 20px;margin-bottom:51px}loans-sign-up-form-simulation-housing-change-warning div span{font-size:34px;margin-right:15px;color:#0072c9;display:inline-block}loans-sign-up-form-simulation-housing-change-warning div p{margin:6px 0 0;width:771px;color:#0072c9;display:inline-block;font-family:ArialMT;font-size:15px;line-height:1.4}", ""]);
	
	// exports


/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansSignUpModal = __webpack_require__(1926);
	
	var _loansSignUpModal2 = _interopRequireDefault(_loansSignUpModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpModalModule = _angular2.default.module('loansSignUpModal', []).component('loansSignUpModal', _loansSignUpModal2.default).name;
	
	exports.default = loansSignUpModalModule;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansSignUpModal = __webpack_require__(1927);
	
	var _loansSignUpModal2 = _interopRequireDefault(_loansSignUpModal);
	
	var _loansSignUpModal3 = __webpack_require__(1928);
	
	var _loansSignUpModal4 = _interopRequireDefault(_loansSignUpModal3);
	
	__webpack_require__(1929);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpModalComponent = {
	  restrict: 'E',
	  bindings: {
	    error: '<',
	    loan: '<',
	    message: '<',
	    isMobileApp: '<',
	    onClick: '&'
	  },
	  template: _loansSignUpModal2.default,
	  controller: _loansSignUpModal4.default
	};
	
	exports.default = loansSignUpModalComponent;

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalSignUp\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalSignUpLabel\"\n     ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <failed-action\n      ng-if=\"$ctrl.requestIsFailed()\"\n      title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n      close-modal=\"true\"\n      mod-size=\"true\"\n      description=\"{{ $ctrl.message || ('LOANS.SIGN_UP.MODAL.FAILED' | translate) }}\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      button-text=\"{{ 'LOANS.SIGN_UP.MODAL.SUCCESS.ACCEPT' | translate }}\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      on-click=\"$ctrl.onClick()\">\n    </failed-action>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansSignUpModalController = function () {
	  function LoansSignUpModalController() {
	    (0, _classCallCheck3.default)(this, LoansSignUpModalController);
	  }
	
	  (0, _createClass3.default)(LoansSignUpModalController, [{
	    key: 'requestIsFailed',
	    value: function requestIsFailed() {
	      return this.error === true;
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'onDismiss',
	    value: function onDismiss() {
	      this.closeModal();
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return $(_constants.MODALS.SIGN_UP);
	    }
	  }]);
	  return LoansSignUpModalController;
	}();
	
	exports.default = LoansSignUpModalController;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1930);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpModal.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansSignUpConfirmationModal = __webpack_require__(1932);
	
	var _loansSignUpConfirmationModal2 = _interopRequireDefault(_loansSignUpConfirmationModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpConfirmationModalModule = _angular2.default.module('loansSignUpConfirmationModal', []).component('loansSignUpConfirmationModal', _loansSignUpConfirmationModal2.default).name;
	
	exports.default = loansSignUpConfirmationModalModule;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansSignUpConfirmationModal = __webpack_require__(1933);
	
	var _loansSignUpConfirmationModal2 = _interopRequireDefault(_loansSignUpConfirmationModal);
	
	var _loansSignUpConfirmationModal3 = __webpack_require__(1934);
	
	var _loansSignUpConfirmationModal4 = _interopRequireDefault(_loansSignUpConfirmationModal3);
	
	__webpack_require__(1935);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpConfirmationModalComponent = {
	  restrict: 'E',
	  bindings: {
	    loanId: '<',
	    confirmLoan: '&',
	    isMobileApp: '<'
	  },
	  template: _loansSignUpConfirmationModal2.default,
	  controller: _loansSignUpConfirmationModal4.default
	};
	
	exports.default = loansSignUpConfirmationModalComponent;

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"modal\"\n  tabindex=\"-1\"\n  id=\"loansConfirmationSignUpModal\"\n  aria-labelledby=\"loansConfirmationSignUpLabel\"\n  role=\"dialog\"\n  ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n>\n  <div class=\"modal-dialog\">\n    <confirm-close-modal\n      title-modal=\"{{ 'GLOBALS.ATTENTION' | translate }}\"\n      small-description=\"{{ 'GLOBALS.CONFIRMATION_LOAN.CONFIRMATION_DESCRIPTION' | translate }}\"\n      button-yes=\"true\"\n      literal-loans-confirmation = \"{{ 'GLOBALS.BUTTON_ACTION.DEC' | translate }}\"\n      on-confirm=\"$ctrl.confirmLoan()\"\n      button-no=\"false\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n    >\n    </confirm-close-modal>\n  </div>\n</div>\n"

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpConfirmationModalController = function () {
	  function loansSignUpConfirmationModalController() {
	    (0, _classCallCheck3.default)(this, loansSignUpConfirmationModalController);
	  }
	
	  (0, _createClass3.default)(loansSignUpConfirmationModalController, [{
	    key: 'modal',
	    get: function get() {
	      return $(_constants.MODALS.LOANS_CONFIRMATION_SIGN_UP);
	    }
	  }]);
	  return loansSignUpConfirmationModalController;
	}();
	
	exports.default = loansSignUpConfirmationModalController;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1936);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpConfirmationModal.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpConfirmationModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-sign-up-confirmation-form{display:block}loans-sign-up-confirmation-form .sign-up-buttons{height:50px}loans-sign-up-confirmation-form .sign-up-buttons .btn-default{margin-right:30px}confirm-close-modal .modal-body .small-description{white-space:pre-wrap;text-align:left}", ""]);
	
	// exports


/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansMandatoryInsuranceModal = __webpack_require__(1938);
	
	var _loansMandatoryInsuranceModal2 = _interopRequireDefault(_loansMandatoryInsuranceModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansMandatoryInsuranceModalModule = _angular2.default.module('loansMandatoryInsuranceModal', []).component('loansMandatoryInsuranceModal', _loansMandatoryInsuranceModal2.default).name;
	
	exports.default = loansMandatoryInsuranceModalModule;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansMandatoryInsuranceModal = __webpack_require__(1939);
	
	var _loansMandatoryInsuranceModal2 = _interopRequireDefault(_loansMandatoryInsuranceModal);
	
	var _loansMandatoryInsuranceModal3 = __webpack_require__(1940);
	
	var _loansMandatoryInsuranceModal4 = _interopRequireDefault(_loansMandatoryInsuranceModal3);
	
	__webpack_require__(1941);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansMandatoryInsuranceModalComponent = {
	  restrict: 'E',
	  bindings: {
	    error: '<',
	    message: '<',
	    isMobileApp: '<'
	  },
	  template: _loansMandatoryInsuranceModal2.default,
	  controller: _loansMandatoryInsuranceModal4.default
	};
	
	exports.default = loansMandatoryInsuranceModalComponent;

/***/ }),
/* 1939 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalMandatoryInsurance\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalMandatoryInsuranceLabel\"\n     ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <failed-action\n      ng-if=\"$ctrl.requestIsFailed()\"\n      title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n      close-modal=\"true\"\n      mod-size=\"true\"\n      description=\"{{ $ctrl.message || ('LOANS.SIGN_UP.MODAL.FAILED' | translate) }}\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      button-text=\"{{ 'LOANS.SIGN_UP.MODAL.SUCCESS.ACCEPT' | translate }}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </failed-action>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansMandatoryInsuranceModalController = function () {
	  function LoansMandatoryInsuranceModalController() {
	    (0, _classCallCheck3.default)(this, LoansMandatoryInsuranceModalController);
	  }
	
	  (0, _createClass3.default)(LoansMandatoryInsuranceModalController, [{
	    key: 'requestIsFailed',
	    value: function requestIsFailed() {
	      return this.error === true;
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'onDismiss',
	    value: function onDismiss() {
	      this.closeModal();
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return $(_constants.MODALS.MANDATORY_INSURANCE);
	    }
	  }]);
	  return LoansMandatoryInsuranceModalController;
	}();
	
	exports.default = LoansMandatoryInsuranceModalController;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1942);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansMandatoryInsuranceModal.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansMandatoryInsuranceModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _loans = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansSignUpService = function () {
	  LoansSignUpService.$inject = ["$http"];
	  function LoansSignUpService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansSignUpService);
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(LoansSignUpService, [{
	    key: 'createSimulation',
	    value: function createSimulation(employeeId, simulation) {
	      return this.http.post(_loans.ENDPOINTS_LOANS.post.createSimulation(employeeId), simulation);
	    }
	  }]);
	  return LoansSignUpService;
	}();
	
	exports.default = LoansSignUpService;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansSignUpResume = __webpack_require__(1945);
	
	var _loansSignUpResume2 = _interopRequireDefault(_loansSignUpResume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpResumeModule = _angular2.default.module('loansSignUpResume', [_angularUiRouter2.default]).component('loansSignUpResume', _loansSignUpResume2.default).name;
	
	exports.default = loansSignUpResumeModule;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansSignUpResume = __webpack_require__(1946);
	
	var _loansSignUpResume2 = _interopRequireDefault(_loansSignUpResume);
	
	var _loansSignUpResume3 = __webpack_require__(1947);
	
	var _loansSignUpResume4 = _interopRequireDefault(_loansSignUpResume3);
	
	__webpack_require__(1948);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansSignUpResumeComponent = {
	  restrict: 'E',
	  bindings: {
	    success: '<',
	    error: '<',
	    loan: '<',
	    message: '<',
	    loanResponseId: '<',
	    simulation: '<',
	    goToInitForm: '&',
	    isMobileApp: '<'
	  },
	  template: _loansSignUpResume2.default,
	  controller: _loansSignUpResume4.default
	};
	
	exports.default = loansSignUpResumeComponent;

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

	module.exports = "<div>\n\n  <!--Title when error-->\n  <div ng-if=\"$ctrl.error\" class=\"error-on-signup\">\n    <span class=\"icon icon-warning\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></span>\n    <h2>\n      {{ 'LOANS.SIGN_UP.CREATE.ERROR' | translate }}\n    </h2>\n  </div>\n\n  <!--Title when success-->\n  <div ng-if=\"$ctrl.success\" class=\"success-on-signup\">\n    <span class=\"icon icon-confirmation\"></span>\n    <h2>\n      {{'LOANS.SIGN_UP.CREATE.SUCCESS' | translate}}\n    </h2>\n  </div>\n\n  <!--Content when success-->\n  <div ng-if=\"$ctrl.success\">\n\n    <my-loans-modal\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      loan=\"$ctrl.loan\"\n      option-is-selected=\"$ctrl.optionModalIsSelected\"\n      on-save=\"$ctrl.onSave($event)\"\n      loan-response-id=\"$ctrl.loanResponseId\"\n      simulation=\"$ctrl.simulation\"\n      show-cadastral-reference=\"$ctrl.showCadastralReference()\"\n      close-modal-cadastral=\"$ctrl.closeModalCadastral($event)\"\n      reset-form-cadastral=\"$ctrl.resetFormCadastral()\"\n      temp-loan-object=\"$ctrl.tempLoanObject\">\n    </my-loans-modal>\n\n    <my-loans-request-cadastral\n      error=\"$ctrl.errorCadastral\"\n      message-error=\"$ctrl.messageError\"\n      on-close-modal-cadastral=\"$ctrl.onCloseModalCadastral()\">\n    </my-loans-request-cadastral>\n\n    <p class=\"description\">\n      {{'LOANS.SIGN_UP.MODAL.SUCCESS.TEXT1' | translate}}\n      \"{{ $ctrl.loan.title | translate}}\"\n      {{'LOANS.SIGN_UP.MODAL.SUCCESS.TEXT2' | translate}}\n    </p>\n\n    <p ng-if=\"$ctrl.success && $ctrl.salaryToShow\">\n      {{'LOANS.SIGN_UP.MODAL.SUCCESS.FINISH_SOON' | translate}}\n    </p>\n\n    <div class=\"documentation\" ng-if=\"$ctrl.success && !$ctrl.salaryToShow\">\n      <ul>\n        <li>\n          {{ 'LOANS.SIGN_UP.MODAL.SUCCESS.DOCUMENTATION.DIGITAL_SIGNATURE' | translate }}\n        </li>\n        <li>\n          {{ 'LOANS.SIGN_UP.MODAL.SUCCESS.DOCUMENTATION.DIGITAL_SIGNATURE_2' | translate }}\n        </li>\n        <li>\n          {{ 'LOANS.SIGN_UP.MODAL.SUCCESS.DOCUMENTATION.DIGITAL_SIGNATURE_3' | translate }}\n          <a ui-sref=\"loans.my-loans\">{{ 'LOANS.SIGN_UP.MODAL.SUCCESS.DOCUMENTATION.DIGITAL_SIGNATURE_3_LINK' | translate }}</a>\n        </li>\n      </ul>\n    </div>\n\n  </div>\n\n  <!--Content when error-->\n  <div ng-if=\"$ctrl.error\">\n    <p class=\"description\">\n      {{ $ctrl.message || ('LOANS.SIGN_UP.CREATE.GENERIC_ERROR' | translate) }}\n    </p>\n  </div>\n\n  <!--Screen buttons-->\n  <div ng-if=\"!$ctrl.isMobileApp\" class=\"buttons\">\n    <button\n      class=\"btn btn-app btn-default\"\n      ng-click=\"$ctrl.openModal()\"\n      ng-if=\"$ctrl.isHousingLoan()\"\n      ng-hide=\"$ctrl.hideButtonCadastral\">\n      {{ 'LOANS.SIGN_UP.CADASTRAL_REFERENCE' | translate }}\n    </button>\n\n    <button\n      class=\"btn btn-app btn-primary\"\n      ng-hide=\"$ctrl.error\"\n      ng-click=\"$ctrl.goToMyLoans()\">\n        {{ 'LOANS.SIGN_UP.TO_MY_LOANS' | translate }}\n    </button>\n\n    <button\n      class=\"btn btn-app btn-primary\"\n      ng-if=\"$ctrl.error\"\n      ng-click=\"$ctrl.goToInitForm()\">\n        {{ 'LOANS.SIGN_UP.ACCEPT' | translate }}\n    </button>\n  </div>\n\n  <!--Screen buttons in mobile-->\n  <div ng-if=\"$ctrl.isMobileApp\">\n\n    <floating-action-buttons\n      ng-if=\"!$ctrl.error && $ctrl.isHousingLoan() && !$ctrl.hideButtonCadastral\"\n      buttons=\"$ctrl.floatingActionButtonsHousingLoan\"\n      on-click-first-button=\"$ctrl.openModal()\"\n      on-click-second-button=\"$ctrl.goToMyLoans()\">\n    </floating-action-buttons>\n\n    <floating-action-buttons\n      ng-if=\"!$ctrl.error && $ctrl.isHousingLoan() && $ctrl.hideButtonCadastral\"\n      buttons=\"$ctrl.floatingActionButtonsSuccess\"\n      on-click-first-button=\"$ctrl.goToMyLoans()\">\n    </floating-action-buttons>\n\n    <floating-action-buttons\n      ng-if=\"!$ctrl.error && !$ctrl.isHousingLoan()\"\n      buttons=\"$ctrl.floatingActionButtonsSuccess\"\n      on-click-first-button=\"$ctrl.goToMyLoans()\">\n    </floating-action-buttons>\n\n    <floating-action-buttons\n      ng-if=\"$ctrl.error\"\n      buttons=\"$ctrl.floatingActionButtonsError\"\n      on-click-first-button=\"$ctrl.goToInitForm()\">\n    </floating-action-buttons>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	var _constantsLoans = __webpack_require__(1774);
	
	var _constants = __webpack_require__(598);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansSignUpResumeController = function () {
	  LoansSignUpResumeController.$inject = ["$state", "GoBackDataService", "mainMenuMobileBehaviourService"];
	  function LoansSignUpResumeController($state, GoBackDataService, mainMenuMobileBehaviourService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansSignUpResumeController);
	    this.state = $state;
	    this.hideButtonCadastral = false;
	    this.goBackDataService = GoBackDataService;
	    this.mainMenuMobileBehaviourService = mainMenuMobileBehaviourService;
	  }
	
	  (0, _createClass3.default)(LoansSignUpResumeController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.salaryToShow = this.shouldSalaryToShow(this.loan);
	
	      if (this.isMobileApp) {
	        this.floatingActionButtonsHousingLoan = this._getFloatingActionButtonsHousingLoan();
	        this.floatingActionButtonsSuccess = this._getFloatingActionButtonsSuccess();
	        this.floatingActionButtonsError = this._getFloatingActionButtonsError();
	        this.mainMenuMobileBehaviourService.setCustomBehaviour(function () {
	          var from = _this.goBackDataService.getDataBackToSignUp().from;
	          _this.state.go(from);
	        });
	
	        this.hideButtonCadastral = this.goBackDataService.getHideOrShowButtonCadastralSignUp();
	      }
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.goBackDataService.setDataBackToSignUp({});
	      this.goBackDataService.setHideOrShowButtonCadastralSignUp(undefined);
	    }
	  }, {
	    key: 'shouldSalaryToShow',
	    value: function shouldSalaryToShow(loan) {
	      return loan.id === _constantsLoans.LOANS.ID.FIVE_MONTH || loan.id === _constantsLoans.LOANS.ID.NINE_MONTH;
	    }
	  }, {
	    key: 'goToMyLoans',
	    value: function goToMyLoans() {
	      this.state.go(_states.STATES.LOANS.MY_LOANS);
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.optionModalIsSelected = _constantsLoans.LOANS_MODAL_STATES.CADASTRAL_REFERENCE;
	      if (this.isMobileApp) {
	        this.loan.identifying = this.loanResponseId;
	        var paramsSignUp = this.goBackDataService.getDataBackToSignUp();
	        var dataParams = {
	          loan: this.loan,
	          simulation: this.simulation,
	          from: 'sign-up',
	          paramsSignUp: paramsSignUp
	        };
	        this.state.go(_states.STATES.LOANS.CADASTRAL_REFERENCE, { dataParams: dataParams });
	      } else {
	        this.modal.modal('show');
	      }
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave($event) {
	      this.modal.modal('hide');
	      this.errorCadastral = $event.error;
	      this.messageError = $event.messageError;
	      $(_constants.MODALS.REQUEST_CADASTRAL).modal('show');
	    }
	  }, {
	    key: 'isHousingLoan',
	    value: function isHousingLoan() {
	      var housingLoan = this.loan.id === _constantsLoans.LOANS.ID.AGREEMENT_HOUSING_LOAN || this.loan.id === _constantsLoans.LOANS.ID.SOCIAL_HOUSING_LOAN;
	      return this.success && housingLoan;
	    }
	  }, {
	    key: 'onCloseModalCadastral',
	    value: function onCloseModalCadastral() {
	      $(_constants.MODALS.REQUEST_CADASTRAL).modal('hide');
	      if (this.errorCadastral === 'failed') {
	        this.modal.modal('show');
	      } else {
	        this.hideButtonCadastral = true;
	      }
	    }
	  }, {
	    key: 'closeModalCadastral',
	    value: function closeModalCadastral($event) {
	      if (!$event.isCadastralCorrect) {
	
	        if (!_lodash2.default.isEmpty($event.cadastralReference)) {
	          this.cadastralReferenceBackup = angular.copy($event.cadastralReference);
	          this.tempLoanObject = $event.cadastralReference;
	        } else {
	          this.tempLoanObject = angular.copy(this.cadastralReferenceBackup);
	        }
	      } else {
	        this.tempLoanObject = {};
	      }
	
	      this.optionModalIsSelected = _constantsLoans.LOANS_MODAL_STATES.CLOSE_CADASTRAL_REFERENCE;
	    }
	  }, {
	    key: 'resetFormCadastral',
	    value: function resetFormCadastral() {
	      this.tempLoanObject = {};
	    }
	  }, {
	    key: 'showCadastralReference',
	    value: function showCadastralReference() {
	      this.optionModalIsSelected = _constantsLoans.LOANS_MODAL_STATES.CADASTRAL_REFERENCE;
	    }
	  }, {
	    key: '_getFloatingActionButtonsHousingLoan',
	    value: function _getFloatingActionButtonsHousingLoan() {
	      return [{
	        literal: 'LOANS.SIGN_UP.CADASTRAL_REFERENCE_SHORT'
	      }, {
	        literal: 'LOANS.SIGN_UP.TO_MY_LOANS'
	      }];
	    }
	  }, {
	    key: '_getFloatingActionButtonsSuccess',
	    value: function _getFloatingActionButtonsSuccess() {
	      return [{
	        literal: 'LOANS.SIGN_UP.TO_MY_LOANS'
	      }];
	    }
	  }, {
	    key: '_getFloatingActionButtonsError',
	    value: function _getFloatingActionButtonsError() {
	      return [{
	        literal: 'LOANS.SIGN_UP.ACCEPT'
	      }];
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return $(_constants.MODALS.MY_LOANS).modal({ backdrop: 'static', keyboard: false });
	    }
	  }]);
	  return LoansSignUpResumeController;
	}();
	
	exports.default = LoansSignUpResumeController;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1949);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpResume.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansSignUpResume.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-sign-up-resume{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;text-align:center;padding-top:58px}loans-sign-up-resume.mobile{padding-top:15px}loans-sign-up-resume.mobile .documentation{width:auto}loans-sign-up-resume.mobile .documentation li{text-align:left}loans-sign-up-resume .error-on-signup h2{color:#c8175e}loans-sign-up-resume h2{width:308px;font-family:Stag Sans;font-weight:400;font-size:24px;text-align:center;color:#86c82d;border-bottom:1px solid #eaebed;margin:27px auto 28px}loans-sign-up-resume .icon{font-size:80px}loans-sign-up-resume .icon.icon-warning{color:#c8175e}loans-sign-up-resume .description{text-align:center;color:#666;font-family:ArialMT;font-size:15px;line-height:1.4;margin:0 auto;margin-bottom:10px;max-width:296px}loans-sign-up-resume .documentation{background-color:#f9f9f9;margin-bottom:15px;text-align:justify;width:497px;padding:20px 32px 0}loans-sign-up-resume .documentation ul{padding-left:26px;padding-bottom:10px}loans-sign-up-resume .documentation ul li a:hover{background-color:transparent}loans-sign-up-resume .documentation ul li a:focus{outline:0}loans-sign-up-resume .buttons{padding-top:20px}loans-sign-up-resume .buttons .btn.btn-app{height:100%;width:220px}loans-sign-up-resume .buttons .btn.btn-app:first-child{margin-right:15px}loans-sign-up-resume .buttons .btn.btn-app:last-child{margin-left:15px}", ""]);
	
	// exports


/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _myLoansFilters = __webpack_require__(1951);
	
	var _myLoansFilters2 = _interopRequireDefault(_myLoansFilters);
	
	var _myLoansMobileFilters = __webpack_require__(1957);
	
	var _myLoansMobileFilters2 = _interopRequireDefault(_myLoansMobileFilters);
	
	var _myLoansCard = __webpack_require__(1963);
	
	var _myLoansCard2 = _interopRequireDefault(_myLoansCard);
	
	var _myLoansContextMenu = __webpack_require__(1969);
	
	var _myLoansContextMenu2 = _interopRequireDefault(_myLoansContextMenu);
	
	var _modals = __webpack_require__(1975);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _cadastralReferenceMobile = __webpack_require__(2013);
	
	var _cadastralReferenceMobile2 = _interopRequireDefault(_cadastralReferenceMobile);
	
	var _myLoans = __webpack_require__(2025);
	
	var _myLoans2 = _interopRequireDefault(_myLoans);
	
	var _myLoans3 = __webpack_require__(1988);
	
	var _myLoans4 = _interopRequireDefault(_myLoans3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansModule = _angular2.default.module('myLoans', [_angularUiRouter2.default, _myLoansFilters2.default, _myLoansMobileFilters2.default, _myLoansCard2.default, _myLoansContextMenu2.default, _modals2.default, _cadastralReferenceMobile2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.MY_LOANS, {
	    url: _routes.ROUTES.LOANS.MY_LOANS,
	    component: 'myLoans',
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      serviceClosed: ["StatusAppCheckers", function serviceClosed(StatusAppCheckers) {
	        return StatusAppCheckers.isServiceClosed();
	      }]
	    }
	  });
	}]).service('myLoansService', _myLoans4.default).component('myLoans', _myLoans2.default).name;
	
	exports.default = myLoansModule;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myLoansFilters = __webpack_require__(1952);
	
	var _myLoansFilters2 = _interopRequireDefault(_myLoansFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansFiltersModule = _angular2.default.module('loansFilters', [_angularUiRouter2.default]).component('myLoansFilters', _myLoansFilters2.default).name;
	
	exports.default = myLoansFiltersModule;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myLoansFilters = __webpack_require__(1953);
	
	var _myLoansFilters2 = _interopRequireDefault(_myLoansFilters);
	
	var _myLoansFilters3 = __webpack_require__(1954);
	
	var _myLoansFilters4 = _interopRequireDefault(_myLoansFilters3);
	
	__webpack_require__(1955);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansFiltersComponent = {
	  restrict: 'E',
	  bindings: {
	    filterByStatus: '&',
	    objectStatesFilter: '<'
	  },
	  template: _myLoansFilters2.default,
	  controller: _myLoansFilters4.default
	};
	
	exports.default = myLoansFiltersComponent;

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex-container\">\n  <p class=\"filter-description\">{{'LOANS.LOANS_FILTERS.TITLES.MAIN' | translate}}:</p>\n\n  <a\n    ng-repeat=\"(key, value) in $ctrl.statesToFilter\"\n    class=\"loans-filter-button\"\n    title=\"{{ $ctrl.loansStates[value].title | translate }}\"\n    ng-class=\"$ctrl.getFilterClass( value )\"\n    ng-click=\"$ctrl.changeFilterByStatus( value )\">\n    <span class=\"{{ $ctrl.loansStates[value].icon }}\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></span>\n    <p>{{ $ctrl.loansStates[value].textFilter | translate }}</p>\n  </a>\n\n</div>\n"

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyLoansFiltersController = function () {
	  MyLoansFiltersController.$inject = ["EventEmitter"];
	  function MyLoansFiltersController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyLoansFiltersController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(MyLoansFiltersController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.statesToFilter = this.objectStatesFilter.statesToFilter;
	      this.loansStates = this.objectStatesFilter.loansStates;
	      this.selectedFilterStatus = '';
	    }
	  }, {
	    key: 'changeFilterByStatus',
	    value: function changeFilterByStatus(state) {
	      this.selectedFilterStatus = this.selectedFilterStatus === state ? '' : state;
	      this.filterByStatus(this.EventEmitter({ status: this.selectedFilterStatus, filterActive: true }));
	    }
	  }, {
	    key: 'getFilterClass',
	    value: function getFilterClass(state) {
	      return {
	        'active': this.selectedFilterStatus === state
	      };
	    }
	  }]);
	  return MyLoansFiltersController;
	}();
	
	exports.default = MyLoansFiltersController;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1956);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansFilters.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansFilters.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "my-loans-filters{display:block;z-index:3}my-loans-filters .flex-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}my-loans-filters .flex-container .filter-description{color:#0072c9;font-family:Stag Sans;font-size:13px;height:19px;margin:0;margin-right:8px;margin-top:9px}my-loans-filters .flex-container .loans-filter-button{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;border:1px solid #dddfe2;border-radius:4px;cursor:pointer;height:37px;margin-right:16px;min-width:98px;text-decoration:none;padding-left:13px;padding-right:12px;margin-top:-5px}my-loans-filters .flex-container .loans-filter-button.active,my-loans-filters .flex-container .loans-filter-button.active+my-loans-filters .flex-container .loans-filter-button:focus{border-color:#0072c9;outline:0}my-loans-filters .flex-container .loans-filter-button p{font-family:Stag Sans;font-size:13px;font-weight:300;margin:0;margin-left:-2px;margin-top:8px;line-height:1}my-loans-filters .flex-container .loans-filter-button .icon{display:inline-block;font-size:21px;margin-right:8px}my-loans-filters .flex-container .loans-filter-button .filter-buttons-group{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}my-loans-filters .flex-container .loans-filter-button.loans-filter-button-clean{-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end;border:none;margin-left:auto;margin-right:12px;width:inherit;padding-top:7px}my-loans-filters .flex-container .loans-filter-button.loans-filter-button-clean:focus .icon-cross,my-loans-filters .flex-container .loans-filter-button.loans-filter-button-clean:focus p{color:#0072c9}my-loans-filters .flex-container .loans-filter-button.loans-filter-button-clean p{line-height:16px}my-loans-filters .flex-container .loans-filter-button.loans-filter-button-clean .icon-cross{display:inline-block;font-size:10px;color:#aeaeae;margin-left:10px}", ""]);
	
	// exports


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _myLoansMobileFilters = __webpack_require__(1958);
	
	var _myLoansMobileFilters2 = _interopRequireDefault(_myLoansMobileFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansMobileFiltersModule = _angular2.default.module('myLoansMobileFilters', []).component('myLoansMobileFilters', _myLoansMobileFilters2.default).name;
	
	exports.default = myLoansMobileFiltersModule;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myLoansMobileFilters = __webpack_require__(1959);
	
	var _myLoansMobileFilters2 = _interopRequireDefault(_myLoansMobileFilters);
	
	var _myLoansMobileFilters3 = __webpack_require__(1960);
	
	var _myLoansMobileFilters4 = _interopRequireDefault(_myLoansMobileFilters3);
	
	__webpack_require__(1961);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansMobileFiltersComponent = {
	  restrict: 'E',
	  bindings: {
	    objectStatesFilter: '<',
	    filterByStatus: '&'
	  },
	  template: _myLoansMobileFilters2.default,
	  controller: _myLoansMobileFilters4.default
	};
	
	exports.default = myLoansMobileFiltersComponent;

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"my-loans-mobile-filters\" id=\"my-loans-mobile-filters\">\n  <div class=\"my-loans-mobile-filters-header\">\n    <p class=\"my-loans-mobile-filters-title\">\n      {{ 'LOANS.LOANS_FILTERS.TITLES.MAIN' | translate }}:\n    </p>\n    <small\n      ng-if=\"$ctrl.labelTextDefault\"\n      ng-click=\"$ctrl.clearFilters()\">\n        X {{ 'LOANS.MY_LOANS.REMOVE_FILTERS' | translate }}\n      </small>\n  </div>\n\n  <div class=\"my-loans-mobile-filters-select\" ng-class=\"$ctrl.getSelectClass()\" ng-click=\"$ctrl.toggle()\">\n    <span class=\"text-default\">\n      {{ ($ctrl.labelTextDefault | translate) || ('LOANS.LOANS_FILTERS.STATE' | translate) }}\n    </span>\n    <span ng-class=\"$ctrl.getArrowClass()\"></span>\n  </div>\n\n  <div ng-if=\"$ctrl.open\" class=\"my-loans-mobile-filters-options\">\n    <div class=\"options\">\n      <div\n        ng-repeat=\"(key, value) in $ctrl.statesToFilter\"\n        class=\"loans-filter-option\"\n        title=\"{{ $ctrl.loansStates[value].title | translate }}\"\n        ng-click=\"$ctrl.changeFilterByStatus( value, $ctrl.loansStates[value].textFilter )\">\n        <span class=\"{{ $ctrl.loansStates[value].icon }}\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></span>\n        <p>{{ $ctrl.loansStates[value].textFilter | translate }}</p>\n      </div>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyLoansMobileFiltersController = function () {
	  MyLoansMobileFiltersController.$inject = ["EventEmitter"];
	  function MyLoansMobileFiltersController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyLoansMobileFiltersController);
	    this.EventEmitter = EventEmitter;
	    this.open = false;
	  }
	
	  (0, _createClass3.default)(MyLoansMobileFiltersController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.statesToFilter = this.objectStatesFilter.statesToFilter;
	      this.loansStates = this.objectStatesFilter.loansStates;
	      this.selectedFilterStatus = '';
	      this.labelTextDefault = '';
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.open = !this.open;
	    }
	  }, {
	    key: 'getArrowClass',
	    value: function getArrowClass() {
	      return {
	        icon: true,
	        'icon-arrow-select-down': !this.open,
	        'icon-arrow-select-up': this.open
	      };
	    }
	  }, {
	    key: 'getSelectClass',
	    value: function getSelectClass() {
	      return {
	        blue: this.open
	      };
	    }
	  }, {
	    key: 'clearFilters',
	    value: function clearFilters() {
	      this.changeFilterByStatus('', '');
	    }
	  }, {
	    key: 'changeFilterByStatus',
	    value: function changeFilterByStatus(state, valueText) {
	      this.selectedFilterStatus = this.selectedFilterStatus === state ? '' : state;
	      this.filterByStatus(this.EventEmitter({ status: this.selectedFilterStatus, filterActive: true }));
	      this.labelTextDefault = this.labelTextDefault === valueText ? '' : valueText;
	      if (state) {
	        this.toggle();
	      }
	    }
	  }]);
	  return MyLoansMobileFiltersController;
	}();
	
	exports.default = MyLoansMobileFiltersController;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1962);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansMobileFilters.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansMobileFilters.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "my-loans-mobile-filters .my-loans-mobile-filters{position:relative;margin-bottom:20px}my-loans-mobile-filters .my-loans-mobile-filters-header{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;margin:9px 0}my-loans-mobile-filters .my-loans-mobile-filters-header small{cursor:pointer}my-loans-mobile-filters .my-loans-mobile-filters-title{color:#0072c9;font-family:Stag Sans;font-size:13px;margin-bottom:0}my-loans-mobile-filters .my-loans-mobile-filters-select{width:100%;height:60px;border:1px solid #eaebed;border-radius:2px;padding:10px 20px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center}my-loans-mobile-filters .my-loans-mobile-filters-select .text-default{font-size:15px;text-transform:uppercase;line-height:20px;color:#666}my-loans-mobile-filters .my-loans-mobile-filters-select .text-default.icon{position:absolute;right:24px}my-loans-mobile-filters .my-loans-mobile-filters-select.blue{border:1px solid #0072c9}my-loans-mobile-filters .my-loans-mobile-filters-select.blue .text-default{color:#0072c9}my-loans-mobile-filters .my-loans-mobile-filters-options{width:100%;text-transform:uppercase;border:1px solid #dddfe2;border-top:0;padding:0;position:absolute;background-color:#fff;z-index:10}my-loans-mobile-filters .my-loans-mobile-filters-options .options{overflow-y:scroll}my-loans-mobile-filters .my-loans-mobile-filters-options .loans-filter-option{font-size:15px;margin:0;height:60px;line-height:36px;padding-left:20px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}my-loans-mobile-filters .my-loans-mobile-filters-options .loans-filter-option .icon{margin-right:18px;font-size:19px}my-loans-mobile-filters .my-loans-mobile-filters-options .loans-filter-option p{margin:0}", ""]);
	
	// exports


/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myLoansCard = __webpack_require__(1964);
	
	var _myLoansCard2 = _interopRequireDefault(_myLoansCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansCardModule = _angular2.default.module('myLoansCard', [_angularUiRouter2.default]).component('myLoansCard', _myLoansCard2.default).name;
	
	exports.default = myLoansCardModule;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myLoansCard = __webpack_require__(1965);
	
	var _myLoansCard2 = _interopRequireDefault(_myLoansCard);
	
	var _myLoansCard3 = __webpack_require__(1966);
	
	var _myLoansCard4 = _interopRequireDefault(_myLoansCard3);
	
	__webpack_require__(1967);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansCardComponent = {
	  restrict: 'E',
	  bindings: {
	    loanObject: '<',
	    viewOptions: '<',
	    onToggleOptions: '&',
	    onChangeOptionSelected: '&',
	    onSelectOption: '&',
	    onJustification: '&',
	    serviceClosed: '<',
	    filterActive: '<',
	    tempLoanObject: '<'
	  },
	  template: _myLoansCard2.default,
	  controller: _myLoansCard4.default
	};
	
	exports.default = myLoansCardComponent;

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"one-loan-card\"\n  ng-class=\"{ 'one-loan-card-alert': $ctrl.hasAlerts, 'mobile': $ctrl.isMobileApp }\"\n>\n  <div class=\"card-content\" ng-hide=\"$ctrl.showingMessageAlert()\">\n    <div class=\"header-card\">\n      <header class=\"title-name loans-title\">\n        <h2 ng-if=\"!$ctrl.isMobileApp\">\n          <span>{{ $ctrl.loanObject.purposeLiteral }}</span>\n          <br />\n          <span\n            >({{ $ctrl.loanObject.modalityCode }} -\n            {{$ctrl.loanObject.identifying | lpad : 3 : '0' }})</span\n          >\n        </h2>\n        <h2 ng-if=\"$ctrl.isMobileApp\">\n          <span ng-class=\"$ctrl.classIcon\"\n            ><span class=\"path1\"></span><span class=\"path2\"></span\n            ><span class=\"path3\"></span\n          ></span>\n          <span class=\"text text-state\">{{$ctrl.currentStateLiteral}}</span>\n        </h2>\n      </header>\n\n      <div ng-if=\"!$ctrl.isMobileApp\" class=\"state-actions\">\n        <span class=\"state\">\n          <span ng-class=\"$ctrl.classIcon\"\n            ><span class=\"path1\"></span><span class=\"path2\"></span\n            ><span class=\"path3\"></span\n          ></span>\n          <span class=\"text text-state\">{{$ctrl.currentStateLiteral}}</span>\n        </span>\n\n        <span\n          class=\"view-options\"\n          ng-click=\"$ctrl.showDifferentOptions()\"\n          ng-if=\"$ctrl.isOptionsForStatusCodeEmpty()\"\n        >\n          <span class=\"icon-plus-circle-big\"></span>\n          <my-loans-context-menu\n            ng-if=\"$ctrl.viewOptions\"\n            loan=\"$ctrl.loanObject\"\n            view-options=\"$ctrl.viewOptions\"\n            status-code=\"$ctrl.loanObject.originalStatusCode\"\n            on-change-option-selected=\"$ctrl.onChangeOptionSelected({$event:$event})\"\n            is-date-cancellation-higher=\"$ctrl.isDateCancellationHigher\"\n            is-date-grant-higher=\"$ctrl.isDateGrantHigher\"\n            service-closed=\"$ctrl.serviceClosed\"\n            class=\"animation-appear\"\n            temp-loan-object=\"$ctrl.tempLoanObject\"\n          >\n          </my-loans-context-menu>\n          <span class=\"text-view-options\">\n            {{'GLOBALS.BUTTON_ACTION.VIEW_OPTIONS' | translate}}\n          </span>\n        </span>\n      </div>\n\n      <div ng-if=\"$ctrl.isMobileApp\" class=\"responsiveMobile-state-actions\">\n        <span\n          class=\"view-options\"\n          ng-click=\"$ctrl.showDifferentOptions()\"\n          ng-if=\"$ctrl.isOptionsForStatusCodeEmpty()\"\n        >\n          <img src=\"img/icons/three-dots.svg\" alt=\"More info\" />\n          <my-loans-context-menu\n            ng-if=\"$ctrl.viewOptions\"\n            loan=\"$ctrl.loanObject\"\n            view-options=\"$ctrl.viewOptions\"\n            status-code=\"$ctrl.loanObject.originalStatusCode\"\n            on-change-option-selected=\"$ctrl.onChangeOptionSelected({$event:$event})\"\n            is-date-cancellation-higher=\"$ctrl.isDateCancellationHigher\"\n            is-date-grant-higher=\"$ctrl.isDateGrantHigher\"\n            service-closed=\"$ctrl.serviceClosed\"\n            class=\"animation-appear\"\n          >\n          </my-loans-context-menu>\n        </span>\n      </div>\n    </div>\n\n    <div class=\"card-body\">\n      <div class=\"loan-state\" ng-if=\"$ctrl.isMobileApp\">\n        <span class=\"state\" ng-if=\"!$ctrl.isMobileApp\">\n          <span ng-class=\"$ctrl.classIcon\"\n            ><span class=\"path1\"></span><span class=\"path2\"></span\n            ><span class=\"path3\"></span\n          ></span>\n          <span class=\"text text-state\">{{$ctrl.currentStateLiteral}}</span>\n        </span>\n      </div>\n\n      <h2 ng-if=\"$ctrl.isMobileApp\" class=\"card-body-name-loan\">\n        {{ $ctrl.loanObject.purposeLiteral }} ({{ $ctrl.loanObject.modalityCode\n        }} - {{$ctrl.loanObject.identifying | lpad : 3 : '0' }})\n      </h2>\n\n      <div ng-if=\"$ctrl.hasAlerts && !$ctrl.isMobileApp\" class=\"card-alert\">\n        <span class=\"icon-alert-red\"></span>\n        <span\n          ng-click=\"$ctrl.showMessageAlert()\"\n          class=\"text-state\"\n          title=\"{{ 'LOANS.MY_LOANS_CARD.ASSOCIATED_ALERTS_TITLE' | translate }}\"\n        >\n          {{ 'LOANS.MY_LOANS_CARD.ASSOCIATED_ALERTS' | translate }} {{\n          $ctrl.numberAlerts }} {{ 'LOANS.MY_LOANS_CARD.ASSOCIATED_ALERTS_2' |\n          translate }}\n        </span>\n      </div>\n\n      <div class=\"loan-info\">\n        <i class=\"icon-calendar\"></i>\n        <span class=\"text\" ng-if=\"!$ctrl.showOtherText()\">\n          {{'LOANS.MY_LOANS_CARD.DATE_OF_GRANT' | translate}}:\n          <strong>{{$ctrl.loanObject.grantDate | date:'dd/MM/yyyy'}}</strong>\n        </span>\n        <span class=\"text\" ng-if=\"$ctrl.showOtherText()\">\n          {{'LOANS.MY_LOANS_CARD.DATE_OF_GRANT2' | translate}}:\n          <strong>{{$ctrl.loanObject.grantDate | date:'dd/MM/yyyy'}}</strong>\n        </span>\n        <span ng-if=\"!$ctrl.isMobileApp\" class=\"separator\"></span>\n        <span class=\"text\" ng-if=\"!$ctrl.showOtherText()\">\n          {{'LOANS.MY_LOANS_CARD.GRANTED' | translate}}:\n          <strong> {{$ctrl.loanObject.grantedQuantity | currency }}</strong>\n        </span>\n        <span class=\"text\" ng-if=\"$ctrl.showOtherText()\">\n          {{'LOANS.MY_LOANS_CARD.GRANTED2' | translate}}:\n          <strong> {{$ctrl.loanObject.grantedQuantity | currency }}</strong>\n        </span>\n        <span\n          ng-if=\"!$ctrl.isMobileApp\"\n          ng-show=\"$ctrl.showAmountPending()\"\n          class=\"separator\"\n        ></span>\n        <span ng-show=\"$ctrl.showAmountPending()\" class=\"text\">\n          {{'LOANS.MY_LOANS_CARD.PENDING_AMOUNT' | translate}}:\n          <strong> {{$ctrl.loanObject.amountPending | currency }}</strong>\n        </span>\n        <span\n          ng-if=\"!$ctrl.isMobileApp\"\n          ng-show=\"$ctrl.showAmountPending()\"\n          class=\"separator\"\n        ></span>\n        <span ng-show=\"$ctrl.showMonthlyFee()\" class=\"text\">\n          {{'LOANS.MY_LOANS_CARD.MONTHLY_FEE' | translate}}:\n          <strong> {{$ctrl.loanObject.monthlyFee | currency }}</strong>\n        </span>\n      </div>\n\n      <div ng-if=\"$ctrl.hasAlerts && $ctrl.isMobileApp\" class=\"card-alert\">\n        <span class=\"icon-alert-red\"></span>\n        <span\n          ng-click=\"$ctrl.showMessageAlert()\"\n          class=\"text-state\"\n          title=\"{{ 'LOANS.MY_LOANS_CARD.ASSOCIATED_ALERTS_TITLE' | translate }}\"\n        >\n          {{ 'LOANS.MY_LOANS_CARD.ASSOCIATED_ALERTS' | translate }} {{\n          $ctrl.numberAlerts }} {{ 'LOANS.MY_LOANS_CARD.ASSOCIATED_ALERTS_2' |\n          translate }}\n        </span>\n      </div>\n    </div>\n  </div>\n\n  <div\n    class=\"card-message-alert\"\n    ng-show=\"$ctrl.showingMessageAlert()\"\n    ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n  >\n    <span class=\"icon-cross-white\" ng-click=\"$ctrl.hideMessageAlert()\"></span>\n    <p>\n      <span class=\"icon-alert-white\"></span>\n      {{ 'LOANS.MY_LOANS_CARD.ALERT_MSG1' | translate }}\n    </p>\n    <ul>\n      <li ng-if=\"$ctrl.hasJustificationError()\">\n        {{ 'LOANS.MY_LOANS_CARD.MISSING_JUSTIFICATION' | translate }}\n        <a\n          class=\"link\"\n          href=\"https://bbvatyc.service-now.com/tyc?id=bbva_hrj_sc_cat_item&sys_id=1693fa2397204e5022b836b3f153af20\"\n          target=\"_blank\"\n          title=\"{{ 'LOANS.MY_LOANS_CARD.MISSING_JUSTIFICATION_TITLE' | translate }}\"\n        >\n          {{ 'LOANS.MY_LOANS_CARD.MISSING_JUSTIFICATION_LINK' | translate }}\n        </a>\n      </li>\n      <li ng-if=\"$ctrl.hasCadastralReferenceError()\">\n        <a\n          ng-click=\"$ctrl.openCadastralReference()\"\n          href=\"\"\n          title=\"{{ 'LOANS.MY_LOANS_CARD.MISSING_CADASTRAL_REFERENCE_TITLE' | translate }}\"\n        >\n          {{ 'LOANS.MY_LOANS_CARD.MISSING_CADASTRAL_REFERENCE' | translate }}\n        </a>\n      </li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	var _constants2 = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyLoansCardController = function () {
	  MyLoansCardController.$inject = ["$translate", "EventEmitter", "LoansStatesService", "$window", "$state"];
	  function MyLoansCardController($translate, EventEmitter, LoansStatesService, $window, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyLoansCardController);
	    this.$translate = $translate;
	    this.EventEmitter = EventEmitter;
	    this.stateLiterals = LoansStatesService.getAll();
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.state = $state;
	  }
	
	  (0, _createClass3.default)(MyLoansCardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.housingLoan = this.loanObject.modalityCode === _constants.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.loanObject.modalityCode === _constants.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN;
	
	      this.$translate(this.stateLiterals[this.loanObject.statusCode]['text']).then(function (translation) {
	        _this.currentStateLiteral = translation;
	      });
	
	      this.classIcon = this.stateLiterals[this.loanObject.statusCode]['icon'];
	      this.numberAlerts = this.getNumberAlerts();
	      this.hasAlerts = this.numberAlerts !== 0;
	
	      if (this.hasAlerts) {
	        this.sendLoanObject(this.loanObject);
	      }
	
	      this.messageAlert = false;
	    }
	  }, {
	    key: 'showDifferentOptions',
	    value: function showDifferentOptions() {
	      var event = this.EventEmitter({
	        loan: this.loanObject
	      });
	
	      this.onToggleOptions(event);
	      this.sendLoanObject(this.loanObject);
	    }
	  }, {
	    key: 'sendLoanObject',
	    value: function sendLoanObject(loan) {
	      this.onSelectOption(this.EventEmitter({
	        loan: loan
	      }));
	    }
	  }, {
	    key: 'isOptionsForStatusCodeEmpty',
	    value: function isOptionsForStatusCodeEmpty() {
	      return this.loanObject.statusCode !== _constants.LOANS.STATES.ID.CANCELLED && this.loanObject.statusCode !== _constants.LOANS.STATES.ID.IN_STUDIO && this.loanObject.statusCode !== _constants.LOANS.STATES.ID.TRANSITIONAL_INTEGRATION;
	    }
	  }, {
	    key: 'showAmountPending',
	    value: function showAmountPending() {
	      return this.loanObject.statusCode === _constants.LOANS.STATES.ID.IN_FORCE;
	    }
	  }, {
	    key: 'showMonthlyFee',
	    value: function showMonthlyFee() {
	      return this.loanObject.statusCode === _constants.LOANS.STATES.ID.IN_FORCE;
	    }
	  }, {
	    key: 'getNumberAlerts',
	    value: function getNumberAlerts() {
	      var numberAlerts = 0;
	
	      if (this.hasCadastralReferenceError()) {
	        numberAlerts++;
	      }
	
	      if (this.hasJustificationError()) {
	        numberAlerts++;
	      }
	
	      return numberAlerts;
	    }
	  }, {
	    key: 'showingMessageAlert',
	    value: function showingMessageAlert() {
	      if (this.filterActive) {
	        this.hideMessageAlert();
	      }
	
	      return this.messageAlert;
	    }
	  }, {
	    key: 'showMessageAlert',
	    value: function showMessageAlert() {
	      this.messageAlert = true;
	      this.filterActive = false;
	    }
	  }, {
	    key: 'showOtherText',
	    value: function showOtherText() {
	      return this.loanObject.statusCode === _constants.LOANS.STATES.ID.PENDING || this.loanObject.statusCode === _constants.LOANS.STATES.ID.PENDING_SIGNATURE || this.loanObject.statusCode === _constants.LOANS.STATES.ID.DENIED;
	    }
	  }, {
	    key: 'hideMessageAlert',
	    value: function hideMessageAlert() {
	      this.messageAlert = false;
	    }
	  }, {
	    key: 'loanHasBeenCancelledThisYear',
	    value: function loanHasBeenCancelledThisYear(loanCancellationDate) {
	      var firstDayOfYear = this.getFirstDayOfCurrentYear();
	      var cancellationDate = new Date(loanCancellationDate);
	      return cancellationDate >= firstDayOfYear;
	    }
	  }, {
	    key: 'getFirstDayOfCurrentYear',
	    value: function getFirstDayOfCurrentYear() {
	      var currentYear = new Date().getFullYear();
	      return new Date(currentYear + '-1-1 01:00:00');
	    }
	  }, {
	    key: 'loanHasBeenHiredAfter2009',
	    value: function loanHasBeenHiredAfter2009(loanGrantDate) {
	      var firstDayOfYear09 = new Date('2009-1-1 01:00:00');
	      var grantDate = new Date(loanGrantDate);
	      return grantDate >= firstDayOfYear09;
	    }
	  }, {
	    key: 'hasCadastralReferenceError',
	    value: function hasCadastralReferenceError() {
	      if (this.isAnnulated() || this.isDenied() || this.isCanceled() || this.isDisclaimer() || this.isRegressed()) {
	        return false;
	      }
	
	      var cadastralReferenceEmpty = !this.loanObject.cadastralReference.cadastralReference;
	      this.isDateGrantHigher = this.loanHasBeenHiredAfter2009(this.loanObject.grantDate);
	
	      if (this.loanObject.statusCode === _constants.LOANS.STATES.ID.NOT_IN_FORCE) {
	        this.isDateCancellationHigher = this.loanHasBeenCancelledThisYear(this.loanObject.cancellationDate);
	        return this.housingLoan && this.isDateCancellationHigher && this.isDateGrantHigher && cadastralReferenceEmpty;
	      }
	
	      return this.housingLoan && cadastralReferenceEmpty && this.isDateGrantHigher;
	    }
	  }, {
	    key: 'hasJustificationError',
	    value: function hasJustificationError() {
	      return this.loanObject.justification === true;
	    }
	  }, {
	    key: 'isAnnulated',
	    value: function isAnnulated() {
	      return this.loanObject.originalStatusCode === _constants.LOANS.STATES.ID.ANNULATED;
	    }
	  }, {
	    key: 'isDenied',
	    value: function isDenied() {
	      return this.loanObject.statusCode === _constants.LOANS.STATES.ID.DENIED;
	    }
	  }, {
	    key: 'isCanceled',
	    value: function isCanceled() {
	      return this.loanObject.originalStatusCode === _constants.LOANS.STATES.ID.CANCELLED;
	    }
	  }, {
	    key: 'isDisclaimer',
	    value: function isDisclaimer() {
	      return this.loanObject.originalStatusCode === _constants.LOANS.STATES.ID.DISCLAIMER;
	    }
	  }, {
	    key: 'isRegressed',
	    value: function isRegressed() {
	      return this.loanObject.originalStatusCode === _constants.LOANS.STATES.ID.REGRESSED;
	    }
	  }, {
	    key: 'openCadastralReference',
	    value: function openCadastralReference() {
	      if (this.serviceClosed) {
	        return;
	      }
	
	      this.onSelectOption(this.EventEmitter({
	        loan: this.loanObject,
	        loanId: this.loanObject.identifying
	      }));
	
	      this.onChangeOptionSelected(this.EventEmitter({
	        optionSelected: _constants.LOANS_MODAL_STATES.CADASTRAL_REFERENCE
	      }));
	
	      if (!this.isMobileApp) {
	        return $(_constants2.MODALS.MY_LOANS).modal({ backdrop: 'static', keyboard: false });
	      }
	
	      var dataParams = {
	        loan: this.loanObject,
	        from: 'my-loans'
	      };
	
	      this.state.go(_states.STATES.LOANS.CADASTRAL_REFERENCE, { dataParams: dataParams });
	    }
	  }]);
	  return MyLoansCardController;
	}();
	
	exports.default = MyLoansCardController;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1968);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansCard.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "my-loans-card{width:100%}my-loans-card .one-loan-card{display:block;height:auto;padding-left:30px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}my-loans-card .one-loan-card .card-content,my-loans-card .one-loan-card .card-message-alert{flex:1 1 auto;-ms-flex-item-align:stretch;align-self:stretch}my-loans-card .one-loan-card .card-message-alert .link{color:#0072c9!important;text-decoration:underline}my-loans-card .one-loan-card.mobile{padding-left:0;min-height:222px}my-loans-card .one-loan-card.mobile .one-loan-card-alert{min-height:222px}my-loans-card .one-loan-card.mobile .header-card{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-line-pack:stretch;align-content:stretch;padding-top:20px;border-bottom:1px solid #dddfe2;padding-bottom:15px}my-loans-card .one-loan-card.mobile .header-card .title-name h2{font-size:16px;margin:0}my-loans-card .one-loan-card.mobile .loan-info{padding-bottom:0}my-loans-card .one-loan-card.mobile .loan-info span:nth-child(2){display:inline-block;margin-left:0}my-loans-card .one-loan-card.mobile .loan-info .text{display:block;margin-left:33px}my-loans-card .one-loan-card-alert{background-color:#fef5dc}my-loans-card .cont{margin-bottom:12px}my-loans-card .title-name{display:inline-block;max-width:70%}my-loans-card .title-name h2{margin-top:22px;width:100%}my-loans-card .icon-calendar{color:#0072c9;font-size:17px;margin-left:2px;margin-right:7px}my-loans-card .separator{border:1px solid #979797;display:inline-block;height:20px;margin-left:5px;margin-right:5px;position:relative;top:5px;width:2px}my-loans-card .text{font-weight:400}my-loans-card .text,my-loans-card strong{color:#666;font-family:Stag Sans;font-size:15px}my-loans-card strong{font-weight:500}my-loans-card .icon{font-size:22px;position:relative}my-loans-card .card-body-name-loan{font-size:14px}my-loans-card .card-body .loan-state{margin-top:10px}my-loans-card .card-body .loan-state .state .icon,my-loans-card .card-body .loan-state .state .icon-plus-circle-big{display:inline-block;margin-right:7px}my-loans-card .loan-info{margin-top:10px;padding-bottom:20px}my-loans-card .text-view-options{position:relative}my-loans-card .responsiveMobile-state-actions{display:inline-block;font-family:ArialMT;font-size:15px;width:25%;line-height:1;position:relative}my-loans-card .responsiveMobile-state-actions .view-options .icon,my-loans-card .responsiveMobile-state-actions .view-options .icon-plus-circle-big{display:inline-block;margin-right:7px}my-loans-card .responsiveMobile-state-actions .view-options{color:#0072c9!important;cursor:pointer;float:right}my-loans-card .state-actions{float:right;font-family:ArialMT;font-size:15px;height:30px;width:250px;line-height:1;position:relative;right:31px;top:18px}my-loans-card .state-actions,my-loans-card .state-actions .state,my-loans-card .state-actions .view-options{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-line-pack:center;align-content:center}my-loans-card .state-actions .state .icon,my-loans-card .state-actions .state .icon-plus-circle-big,my-loans-card .state-actions .view-options .icon,my-loans-card .state-actions .view-options .icon-plus-circle-big{display:inline-block;margin-right:7px}my-loans-card .state-actions .view-options{color:#0072c9!important;cursor:pointer;float:right}my-loans-card h2{color:#0072c9;font-family:Stag Sans;font-size:24px;font-weight:400;margin:0}my-loans-card .card-alert{display:inline-block;width:100%;margin-top:10px}my-loans-card .card-alert span{color:#c8175e;font-size:15px}my-loans-card .card-alert span:before{color:#c8175e!important}my-loans-card .card-alert span:last-child{cursor:pointer;padding-left:8px}my-loans-card .card-alert .text-state{position:relative;top:-1px}my-loans-card .card-message-alert{margin-left:-30px;background-color:#c8175e;font-size:15px;padding-left:30px;padding-top:15px;min-height:161px}my-loans-card .card-message-alert.mobile{margin-right:-30px;min-height:222px;font-size:13px;padding:30px}my-loans-card .card-message-alert.mobile .icon-alert-white{top:0}my-loans-card .card-message-alert ul{margin-bottom:0}my-loans-card .card-message-alert .icon-cross-white{cursor:pointer;float:right;margin-right:10px}my-loans-card .card-message-alert .icon-alert-white{position:relative;top:3px}my-loans-card .card-message-alert p{color:#fff!important;margin:0;margin-bottom:5px}my-loans-card .card-message-alert p span{padding-right:8px}my-loans-card .card-message-alert li,my-loans-card .card-message-alert li a{color:#fff!important}my-loans-card .card-message-alert li a:focus,my-loans-card .card-message-alert li a:hover{background-color:transparent;text-decoration:none}", ""]);
	
	// exports


/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _myLoansContextMenu = __webpack_require__(1970);
	
	var _myLoansContextMenu2 = _interopRequireDefault(_myLoansContextMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansContextMenuModule = _angular2.default.module('myLoansContextMenu', []).component('myLoansContextMenu', _myLoansContextMenu2.default).name;
	
	exports.default = myLoansContextMenuModule;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myLoansContextMenu = __webpack_require__(1971);
	
	var _myLoansContextMenu2 = _interopRequireDefault(_myLoansContextMenu);
	
	var _myLoansContextMenu3 = __webpack_require__(1972);
	
	var _myLoansContextMenu4 = _interopRequireDefault(_myLoansContextMenu3);
	
	__webpack_require__(1973);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansContextMenuComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    statusCode: '<',
	    onChangeOptionSelected: '&',
	    isDateCancellationHigher: '<',
	    isDateGrantHigher: '<',
	    serviceClosed: '<',
	    tempLoanObject: '<'
	  },
	  template: _myLoansContextMenu2.default,
	  controller: _myLoansContextMenu4.default
	};
	
	exports.default = myLoansContextMenuComponent;

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"my-loans-context-menu\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <div class=\"arrow-up\"></div>\n\n  <div class=\"option\" ng-click=\"$ctrl.openModal('details')\">\n    {{'LOANS.CONTEXT_MENU.VIEW_DETAILS' | translate}}\n  </div>\n\n  <div class=\"option\" ng-if=\"$ctrl.showRequestNovation()\" ng-click=\"$ctrl.openModal('adhesion')\">\n    {{ ($ctrl.loan.novationTypeVariable) ? 'LOANS.CONTEXT_MENU.NOVATION_VARIABLE': 'LOANS.CONTEXT_MENU.NOVATION_FIXED' | translate}}\n  </div>\n\n  <div\n    class=\"option\"\n    ng-if=\"$ctrl.showAmortization()\"\n    ng-click=\"$ctrl.openAmortization()\"\n    ng-class=\"{ 'remove-events': $ctrl.serviceClose }\">\n    {{'LOANS.CONTEXT_MENU.AMORTIZE' | translate}}\n  </div>\n\n  <div class=\"option\" ng-if=\"$ctrl.showFiscalInformation()\" ng-click=\"$ctrl.openLink($ctrl.loan.links.tax)\">\n    {{'LOANS.CONTEXT_MENU.FISCAL_INFORMATION' | translate}}\n  </div>\n\n  <div class=\"option\" ng-if=\"$ctrl.showReferenceCatastral()\" ng-click=\"$ctrl.openModal('cadastralReference')\">\n    {{'LOANS.CONTEXT_MENU.REFERENCE' | translate}}\n  </div>\n\n  <div class=\"option\" ng-if=\"$ctrl.showViewReceipts()\" ng-click=\"$ctrl.openLink($ctrl.loan.links.receipts)\">\n    {{'LOANS.CONTEXT_MENU.VIEW_RECEIPTS' | translate}}\n  </div>\n\n  <div class=\"option\" ng-if=\"$ctrl.showViewPolicy()\" ng-click=\"$ctrl.openLink($ctrl.loan.links.policy)\">\n    {{'LOANS.CONTEXT_MENU.VIEW_POLICY' | translate}}\n  </div>\n\n</div>\n"

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	var _constants2 = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyLoansContextMenuController = function () {
	  MyLoansContextMenuController.$inject = ["$state", "EventEmitter", "$window", "LoansUserDataService"];
	  function MyLoansContextMenuController($state, EventEmitter, $window, LoansUserDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyLoansContextMenuController);
	    this.state = $state;
	    this.EventEmitter = EventEmitter;
	    this.window = $window;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.loansUserDataService = LoansUserDataService;
	    this.seniorUser = this.loansUserDataService.getSenior();
	  }
	
	  (0, _createClass3.default)(MyLoansContextMenuController, [{
	    key: 'openModal',
	    value: function openModal(option) {
	      if (this.isCadastralModalWithServiceClosed(option)) {
	        return;
	      }
	      var isCadastralReference = option === _constants2.LOANS_MODAL_STATES.CADASTRAL_REFERENCE;
	      var dataCadastral = isCadastralReference ? this._getDataCadastralReference() : undefined;
	      this.onChangeOptionSelected(this.EventEmitter({
	        optionSelected: option,
	        dataCadastral: dataCadastral
	      }));
	
	      if (!isCadastralReference || !this.isMobileApp) {
	        this.modal.modal({ backdrop: 'static', keyboard: false });
	      }
	    }
	  }, {
	    key: '_getDataCadastralReference',
	    value: function _getDataCadastralReference() {
	      if (this.isMobileApp) {
	        return {
	          loan: this.loan,
	          tempLoanObject: this.tempLoanObject
	        };
	      }
	    }
	  }, {
	    key: 'isCadastralModalWithServiceClosed',
	    value: function isCadastralModalWithServiceClosed(option) {
	      var isModalCadastral = option === _constants2.LOANS_MODAL_STATES.CADASTRAL_REFERENCE;
	      var isEmptyCadastralReference = (0, _keys2.default)(this.loan.cadastralReference).length === 0;
	      return isModalCadastral && isEmptyCadastralReference && this.serviceClosed;
	    }
	  }, {
	    key: 'showAmortization',
	    value: function showAmortization() {
	      return this.statusCode === _constants2.LOANS.STATES.ID.IN_FORCE && !this.serviceClosed && this.loan.amortizable;
	    }
	  }, {
	    key: 'openAmortization',
	    value: function openAmortization() {
	      this.state.go(_states.STATES.LOANS.REPAYMENT, { loan: this.loan });
	    }
	  }, {
	    key: 'showFiscalInformation',
	    value: function showFiscalInformation() {
	      if (this.isMobileApp || this.seniorUser) return false;
	      return this.statusCode === _constants2.LOANS.STATES.ID.IN_FORCE || this.statusCode === _constants2.LOANS.STATES.ID.NOT_IN_FORCE;
	    }
	  }, {
	    key: 'showReferenceCatastral',
	    value: function showReferenceCatastral() {
	      var statusCatastral = this.statusCode === _constants2.LOANS.STATES.ID.AUTHORIZED || this.statusCode === _constants2.LOANS.STATES.ID.IN_FORCE || this.statusCode === _constants2.LOANS.STATES.ID.NOT_IN_FORCE || this.statusCode === _constants2.LOANS.STATES.ID.PENDING || this.statusCode === _constants2.LOANS.STATES.ID.SUBSCRIBER || this.statusCode === _constants2.LOANS.STATES.ID.PENDING_SIGNATURE;
	
	      var loansAuthorized = this.loan.modalityCode === _constants2.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.loan.modalityCode === _constants2.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN;
	
	      if (this.statusCode === _constants2.LOANS.STATES.ID.NOT_IN_FORCE) {
	        return loansAuthorized && this.isDateCancellationHigher && this.isDateGrantHigher;
	      }
	
	      return statusCatastral && loansAuthorized;
	    }
	  }, {
	    key: 'showViewReceipts',
	    value: function showViewReceipts() {
	      if (this.isMobileApp || this.seniorUser) return false;
	      return this.statusCode === _constants2.LOANS.STATES.ID.IN_FORCE || this.statusCode === _constants2.LOANS.STATES.ID.NOT_IN_FORCE;
	    }
	  }, {
	    key: 'showViewPolicy',
	    value: function showViewPolicy() {
	      if (this.isMobileApp || this.seniorUser) return false;
	      var showByStatus = this.statusCode === _constants2.LOANS.STATES.ID.AUTHORIZED || this.statusCode === _constants2.LOANS.STATES.ID.NOT_IN_FORCE || this.statusCode === _constants2.LOANS.STATES.ID.IN_FORCE || this.statusCode === _constants2.LOANS.STATES.ID.SUBSCRIBER;
	      var showByLoanId = this.loan.modalityCode !== _constants2.LOANS.ID_HR.FIVE_MONTH && this.loan.modalityCode !== _constants2.LOANS.ID_HR.NINE_MONTH;
	      return showByStatus && showByLoanId;
	    }
	  }, {
	    key: 'showRequestNovation',
	    value: function showRequestNovation() {
	      return this.loan.novationCollective || this.loan.novationTypeVariable;
	    }
	  }, {
	    key: 'openLink',
	    value: function openLink(link) {
	      this.window.open(link, '_blank');
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return $(_constants.MODALS.MY_LOANS);
	    }
	  }]);
	  return MyLoansContextMenuController;
	}();
	
	exports.default = MyLoansContextMenuController;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1974);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansContextMenu.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansContextMenu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "my-loans-context-menu .my-loans-context-menu{position:absolute;top:26px;right:24px;bottom:0;z-index:1;cursor:pointer;border-radius:1px}my-loans-context-menu .my-loans-context-menu.mobile{top:18px;right:15px}my-loans-context-menu .my-loans-context-menu.mobile .arrow-up{margin:0 0 0 auto;border-right:none}my-loans-context-menu .my-loans-context-menu.mobile .option{text-transform:uppercase}my-loans-context-menu .my-loans-context-menu.mobile .option:last-child{border-bottom:none}my-loans-context-menu .arrow-up{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-bottom:3px solid #0072c9;margin:0 auto}my-loans-context-menu .remove-events{pointer-events:none}my-loans-context-menu .option{width:156px;height:38px;background:#0072c9;text-align:center;color:#fff;font-size:13px;line-height:35px;border-bottom:1px solid #fff}my-loans-context-menu .option:hover{background:#04408f}my-loans-context-menu .btn-footer{display:inline-block}", ""]);
	
	// exports


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myLoansModal = __webpack_require__(1976);
	
	var _myLoansModal2 = _interopRequireDefault(_myLoansModal);
	
	var _modalDetailLoan = __webpack_require__(1982);
	
	var _modalDetailLoan2 = _interopRequireDefault(_modalDetailLoan);
	
	var _myLoansRequestCadastral = __webpack_require__(1995);
	
	var _myLoansRequestCadastral2 = _interopRequireDefault(_myLoansRequestCadastral);
	
	var _modalCadastralReference = __webpack_require__(2001);
	
	var _modalCadastralReference2 = _interopRequireDefault(_modalCadastralReference);
	
	var _modalDetailAdhesion = __webpack_require__(2007);
	
	var _modalDetailAdhesion2 = _interopRequireDefault(_modalDetailAdhesion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansModalsModule = angular.module('myloans.components.modals', [_modalCadastralReference2.default, _myLoansModal2.default, _modalDetailLoan2.default, _myLoansRequestCadastral2.default, _modalDetailAdhesion2.default]).name;
	
	exports.default = myLoansModalsModule;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myLoansModal = __webpack_require__(1977);
	
	var _myLoansModal2 = _interopRequireDefault(_myLoansModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansModalModule = _angular2.default.module('myLoansModal', [_angularUiRouter2.default]).component('myLoansModal', _myLoansModal2.default).name;
	
	exports.default = myLoansModalModule;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myLoansModal = __webpack_require__(1978);
	
	var _myLoansModal2 = _interopRequireDefault(_myLoansModal);
	
	var _myLoansModal3 = __webpack_require__(1979);
	
	var _myLoansModal4 = _interopRequireDefault(_myLoansModal3);
	
	__webpack_require__(1980);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansModalComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    optionIsSelected: '<',
	    onSave: '&',
	    loanResponseId: '<',
	    onCancelAmortization: '&',
	    cancelAmortizationErrorMessage: '<',
	    simulation: '<',
	    closeModalCadastral: '&',
	    showCadastralReference: '&',
	    resetFormCadastral: '&',
	    tempLoanObject: '<',
	    isMobileApp: '<'
	  },
	  template: _myLoansModal2.default,
	  controller: _myLoansModal4.default
	};
	
	exports.default = myLoansModalComponent;

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalMyLoans\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalMyLoansLabel\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-dialog\">\n\n    <modal-detail-loan\n      ng-if=\"$ctrl.getModalShow($ctrl.modalStates.DETAILS)\"\n      loan=\"$ctrl.loan\">\n    </modal-detail-loan>\n\n    <modal-detail-adhesion\n      ng-if=\"$ctrl.getModalShow($ctrl.modalStates.DETAILSADHESION )\"\n      loan=\"$ctrl.loan\">\n    </modal-detail-adhesion>\n\n    <modal-cadastral-reference\n      ng-if=\"$ctrl.getModalShow($ctrl.modalStates.CADASTRAL_REFERENCE)\"\n      loan=\"$ctrl.loan\"\n      on-save=\"$ctrl.onSave({$event:$event})\"\n      loan-response-id=\"$ctrl.loanResponseId\"\n      simulation=\"$ctrl.simulation\"\n      close-modal-cadastral=\"$ctrl.onCloseModalCadastral($event)\"\n      temp-loan-object=\"$ctrl.tempLoanObject\">\n    </modal-cadastral-reference>\n\n    <confirm-close-modal\n      ng-if=\"$ctrl.getModalShow($ctrl.modalStates.CLOSE_CADASTRAL_REFERENCE)\"\n      title-modal=\"¿{{ 'GLOBALS.CONFIRM_CLOSE' | translate }}?\"\n      small-description=\"{{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.CLOSE_MODAL_DESC' | translate }}\"\n      button-yes=\"true\"\n      on-confirm=\"$ctrl.resetFormCadastral()\"\n      button-no=\"true\"\n      on-click-no=\"$ctrl.showCadastralReference()\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </confirm-close-modal>\n\n    <failed-action\n      ng-if=\"$ctrl.getModalShow($ctrl.modalStates.FAILED_CADASTRAL_REFERENCE)\"\n      title=\"{{'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.ERROR.TITLE' | translate}}\"\n      description=\"{{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.ERROR.DESC' | translate }}\"\n      close-modal=\"true\"\n      button-text=\"{{'GLOBALS.BUTTON_ACTION.ACCEPT' | translate}}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </failed-action>\n\n    <failed-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.getModalShow($ctrl.modalStates.CANCEL_AMORTIZATION_ERROR)\"\n      title=\"{{'LOANS.CANCEL_AMORTIZATION.ERROR.TITLE' | translate}}\"\n      description=\"{{ $ctrl.cancelAmortizationErrorMessage || ('LOANS.CANCEL_AMORTIZATION.ERROR.DESC' | translate) }}\"\n      close-modal=\"true\"\n      button-text=\"{{'GLOBALS.BUTTON_ACTION.ACCEPT' | translate}}\">\n    </failed-action>\n\n  </div>\n</div>\n"

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyLoansModalController = function () {
	  MyLoansModalController.$inject = ["EventEmitter"];
	  function MyLoansModalController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyLoansModalController);
	    this.EventEmitter = EventEmitter;
	    this.modalStates = _constants.LOANS_MODAL_STATES;
	  }
	
	  (0, _createClass3.default)(MyLoansModalController, [{
	    key: 'getModalShow',
	    value: function getModalShow(modalToShow) {
	      return this.optionIsSelected === modalToShow;
	    }
	  }, {
	    key: 'changeStateCadastral',
	    value: function changeStateCadastral($event) {
	      this.stateCadastral = $event.stateCadastral;
	      this.optionIsSelected = '';
	    }
	  }, {
	    key: 'onCloseModalCadastral',
	    value: function onCloseModalCadastral($event) {
	      this.closeModalCadastral(this.EventEmitter($event));
	    }
	  }]);
	  return MyLoansModalController;
	}();
	
	exports.default = MyLoansModalController;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1981);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansModal.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _modalDetailLoan = __webpack_require__(1983);
	
	var _modalDetailLoan2 = _interopRequireDefault(_modalDetailLoan);
	
	var _myLoans = __webpack_require__(1988);
	
	var _myLoans2 = _interopRequireDefault(_myLoans);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalDetailLoanModule = _angular2.default.module('modalDetailLoan', [_angularUiRouter2.default]).service('myLoansService', _myLoans2.default).component('modalDetailLoan', _modalDetailLoan2.default).name;
	
	exports.default = modalDetailLoanModule;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalDetailLoan = __webpack_require__(1984);
	
	var _modalDetailLoan2 = _interopRequireDefault(_modalDetailLoan);
	
	var _modalDetailLoan3 = __webpack_require__(1985);
	
	var _modalDetailLoan4 = _interopRequireDefault(_modalDetailLoan3);
	
	__webpack_require__(1986);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalDetailLoanComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<'
	  },
	  template: _modalDetailLoan2.default,
	  controller: _modalDetailLoan4.default
	};
	
	exports.default = modalDetailLoanComponent;

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-header row\">\n    <h1>{{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.TITLE' | translate }}{{ $ctrl.loan.modalityLiteral }}</h1>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n  </div>\n\n  <div class=\"modal-body row\">\n    <p ng-if=\"$ctrl.showGrantDatePurposeGranted() && !$ctrl.showTextInPending()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.DATE' | translate }}: <span>{{ $ctrl.loan.grantDate | date:'dd/MM/yyyy' }}</span>\n    </p>\n    <p ng-if=\"$ctrl.showGrantDatePurposeGranted() && $ctrl.showTextInPending()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.DATE2' | translate }}: <span>{{ $ctrl.loan.grantDate | date:'dd/MM/yyyy' }}</span>\n    </p>\n    <p ng-if=\"$ctrl.showRestOfData()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.EXPIRY_REAL_DATE' | translate }}: <span>{{ $ctrl.loan.expiryRealDate | date:'dd/MM/yyyy' }}</span>\n    </p>\n    <p ng-if=\"$ctrl.showGrantDatePurposeGranted()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.PURPOSE' | translate }}: <span>{{ $ctrl.loan.purposeLiteral }}</span>\n    </p>\n    <p ng-if=\"$ctrl.showGrantDatePurposeGranted() && !$ctrl.showTextInPending()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.GRANTED' | translate }}: <span>{{ $ctrl.loan.grantedQuantity | currency:'€' }}</span>\n    </p>\n    <p ng-if=\"$ctrl.showGrantDatePurposeGranted() && $ctrl.showTextInPending()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.GRANTED2' | translate }}: <span>{{ $ctrl.loan.grantedQuantity | currency:'€' }}</span>\n    </p>\n    <p ng-if=\"$ctrl.showCancellationDate()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.CANCELLATION_DATE' | translate }}: <span>{{ $ctrl.loan.cancellationDate | date:'dd/MM/yyyy' }}</span>\n    </p>\n    <p ng-if=\"$ctrl.showOnlyInForce()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.CURRENT_BALANCE' | translate }}: <span>{{ $ctrl.loan.amountPending | currency:'€' }}</span>\n    </p>\n    <p ng-if=\"$ctrl.showRestOfData()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.MONTHLY_FEE' | translate }}: <span>{{ $ctrl.loan.monthlyFee | currency:'€' }}</span>\n    </p>\n    <p ng-if=\"$ctrl.showRestOfData()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.LOANS_TERM' | translate }}:\n      <span>{{ $ctrl.loan.loanTerm }} {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.MONTH' | translate }}</span>\n    </p>\n    <p ng-if=\"$ctrl.showRestOfData()\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.INTEREST_RATE' | translate }}: <span>{{ $ctrl.loan.interestRate }} %</span>\n    </p>\n    <span\n      ng-if=\"$ctrl.loan.insuranceContracted\"\n      ng-show=\"$ctrl.showRestOfData()\">\n        {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.INSURANCE_CONTRACTED' | translate }}\n        {{ $ctrl.loan.annualTerm | currency:'€' }}\n    </span>\n    <span\n      ng-if=\"!$ctrl.loan.insuranceContracted\"\n      ng-show=\"$ctrl.showRestOfData()\">\n        {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.NON_CONTRACTED_INSURANCE' | translate }}\n    </span>\n  </div>\n\n\n\n  <div ng-if=\"!$ctrl.isMobileApp\" class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-app btn-primary\" data-dismiss=\"modal\">\n      {{ 'GLOBALS.BUTTON_ACTION.CLOSE' | translate }}\n    </button>\n  </div>\n\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.dismiss()\">\n  </floating-action-buttons>\n</div>\n"

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalDetailLoanController = function () {
	  ModalDetailLoanController.$inject = ["$window", "myLoansService", "LoansUserDataService"];
	  function ModalDetailLoanController($window, myLoansService, LoansUserDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalDetailLoanController);
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.myLoansService = myLoansService;
	    this.loansUserDataService = LoansUserDataService;
	    this.userId = this.loansUserDataService._employee.userId;
	  }
	
	  (0, _createClass3.default)(ModalDetailLoanController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) this.floatingActionButtons = this.getFloatingActionButtons();
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      angular.element('.modal').modal('hide');
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.CLOSE'
	      }];
	    }
	  }, {
	    key: 'showGrantDatePurposeGranted',
	    value: function showGrantDatePurposeGranted() {
	      return this.loan.statusCode === _constants.LOANS.STATES.ID.IN_FORCE || this.loan.statusCode === _constants.LOANS.STATES.ID.AUTHORIZED || this.loan.statusCode === _constants.LOANS.STATES.ID.SUBSCRIBER || this.loan.statusCode === _constants.LOANS.STATES.ID.NOT_IN_FORCE || this.loan.statusCode === _constants.LOANS.STATES.ID.PENDING || this.loan.statusCode === _constants.LOANS.STATES.ID.PENDING_SIGNATURE || this.loan.statusCode === _constants.LOANS.STATES.ID.DENIED || this.loan.statusCode === _constants.LOANS.STATES.ID.ANNULATED || this.loan.statusCode === _constants.LOANS.STATES.ID.REGRESSED || this.loan.statusCode === _constants.LOANS.STATES.ID.DISCLAIMER;
	    }
	  }, {
	    key: 'showRestOfData',
	    value: function showRestOfData() {
	      return this.loan.statusCode === _constants.LOANS.STATES.ID.IN_FORCE || this.loan.statusCode === _constants.LOANS.STATES.ID.AUTHORIZED || this.loan.statusCode === _constants.LOANS.STATES.ID.SUBSCRIBER || this.loan.statusCode === _constants.LOANS.STATES.ID.PENDING || this.loan.statusCode === _constants.LOANS.STATES.ID.PENDING_SIGNATURE;
	    }
	  }, {
	    key: 'showOnlyInForce',
	    value: function showOnlyInForce() {
	      return this.loan.statusCode === _constants.LOANS.STATES.ID.IN_FORCE;
	    }
	  }, {
	    key: 'showTextInPending',
	    value: function showTextInPending() {
	      return this.loan.statusCode === _constants.LOANS.STATES.ID.PENDING || this.loan.statusCode === _constants.LOANS.STATES.ID.PENDING_SIGNATURE || this.loan.statusCode === _constants.LOANS.STATES.ID.DENIED || this.loan.statusCode === _constants.LOANS.STATES.ID.ANNULATED || this.loan.statusCode === _constants.LOANS.STATES.ID.REGRESSED || this.loan.statusCode === _constants.LOANS.STATES.ID.DISCLAIMER;
	    }
	  }, {
	    key: 'showCancellationDate',
	    value: function showCancellationDate() {
	      return this.loan.statusCode === _constants.LOANS.STATES.ID.NOT_IN_FORCE;
	    }
	  }]);
	  return ModalDetailLoanController;
	}();
	
	exports.default = ModalDetailLoanController;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1987);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./modalDetailLoan.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./modalDetailLoan.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-detail-loan .modal-content.mobile .modal-header{margin-top:20px}modal-detail-loan .modal-content.mobile .modal-header h1{font-size:16px}modal-detail-loan .modal-content.mobile .modal-body p{font-size:13px}modal-detail-loan .modal-content.mobile .modal-body p>span{font-size:14px}modal-detail-loan .modal-header h1{color:#0072c9;font-size:24px;font-weight:400}modal-detail-loan .modal-header h1:first-letter{text-transform:uppercase}modal-detail-loan .modal-body{margin-top:20px}modal-detail-loan .modal-body p{font-size:15px}modal-detail-loan .modal-body p>span{color:#333}modal-detail-loan .modal-footer{margin-top:39px;text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(1989);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _loans = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyLoansService = function () {
	  MyLoansService.$inject = ["$http", "LoansStatesService"];
	  function MyLoansService($http, LoansStatesService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyLoansService);
	    this.http = $http;
	    this.loansStatesService = LoansStatesService;
	    this._myLoansCache = new _map2.default();
	  }
	
	  (0, _createClass3.default)(MyLoansService, [{
	    key: 'getMyLoans',
	    value: function getMyLoans(employeeId) {
	      var _this = this;
	
	      if (this._myLoansCache.has(employeeId)) {
	        return this._myLoansCache.get(employeeId);
	      }
	
	      var loans = this.http.get(_loans.ENDPOINTS_LOANS.get.myLoans(employeeId)).then(function (response) {
	        return response.data.employeeLoans.map(_this.loansStatesService.mapStatusCode);
	      }).catch(function (err) {
	        _this._myLoansCache.delete(employeeId);
	        throw err;
	      });
	
	      this._myLoansCache.set(employeeId, loans);
	      return loans;
	    }
	  }, {
	    key: 'sendRequestNovation',
	    value: function sendRequestNovation(employeeId, loan) {
	      var data = {
	        requestNovation: loan.identifying
	      };
	      return this.http.post(_loans.ENDPOINTS_LOANS.post.requestNovation(employeeId), data);
	    }
	  }]);
	  return MyLoansService;
	}();
	
	exports.default = MyLoansService;

/***/ }),
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _myLoansRequestCadastral = __webpack_require__(1996);
	
	var _myLoansRequestCadastral2 = _interopRequireDefault(_myLoansRequestCadastral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansRequestCadastralModule = _angular2.default.module('myLoansRequestCadastral', [_angularUiRouter2.default]).component('myLoansRequestCadastral', _myLoansRequestCadastral2.default).name;
	
	exports.default = myLoansRequestCadastralModule;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myLoansRequestCadastral = __webpack_require__(1997);
	
	var _myLoansRequestCadastral2 = _interopRequireDefault(_myLoansRequestCadastral);
	
	var _myLoansRequestCadastral3 = __webpack_require__(1998);
	
	var _myLoansRequestCadastral4 = _interopRequireDefault(_myLoansRequestCadastral3);
	
	__webpack_require__(1999);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansRequestCadastralComponent = {
	  restrict: 'E',
	  bindings: {
	    error: '<',
	    messageError: '<',
	    onCloseModalCadastral: '&'
	  },
	  template: _myLoansRequestCadastral2.default,
	  controller: _myLoansRequestCadastral4.default
	};
	
	exports.default = myLoansRequestCadastralComponent;

/***/ }),
/* 1997 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\"\n     id=\"modalRequestCadastral\"\n     tabindex=\"-1\"\n     role=\"dialog\"\n     aria-labelledby=\"RequestCadastralModalLabel\"\n     ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <div class=\"modal-dialog\"\n       role=\"document\">\n\n    <successful-action ng-if=\"$ctrl.isApproved()\"\n                       close-modal=\"true\"\n                       message=\"{{'LOANS.MY_LOANS.MODAL.MODAL_REQUEST_CADASTRAL.MSG_SUCCESS' | translate}}\"\n                       on-dismiss=\"$ctrl.onCloseModalCadastral()\"\n                       is-mobile-app=\"$ctrl.isMobileApp\">\n    </successful-action>\n\n    <failed-action ng-if=\"$ctrl.isFailed()\"\n                   close-modal=\"true\"\n                   title=\"{{'GLOBALS.REQUEST_DENIED' | translate}}\"\n                   description=\"{{($ctrl.messageError || 'LOANS.MY_LOANS.MODAL.MODAL_REQUEST_CADASTRAL.MSG_FAILED') | translate}}\"\n                   button-text=\"{{'GLOBALS.BUTTON_ACTION.OK' | translate}}\"\n                   on-dismiss=\"$ctrl.onCloseModalCadastral()\"\n                   is-mobile-app=\"$ctrl.isMobileApp\">\n    </failed-action>\n\n  </div>\n</div>\n"

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyLoansRequestCadastralController = function () {
	  MyLoansRequestCadastralController.$inject = ["$window"];
	  function MyLoansRequestCadastralController($window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyLoansRequestCadastralController);
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.error = null;
	    this.messageError = null;
	  }
	
	  (0, _createClass3.default)(MyLoansRequestCadastralController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.STATE_SUCCESS = 'approve';
	    }
	  }, {
	    key: 'isApproved',
	    value: function isApproved() {
	      return this.error === this.STATE_SUCCESS;
	    }
	  }, {
	    key: 'isFailed',
	    value: function isFailed() {
	      return this.error !== null && this.error !== undefined && this.error !== '' && this.error !== this.STATE_SUCCESS;
	    }
	  }]);
	  return MyLoansRequestCadastralController;
	}();
	
	exports.default = MyLoansRequestCadastralController;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2000);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansRequestCadastral.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./myLoansRequestCadastral.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalCadastralReference = __webpack_require__(2002);
	
	var _modalCadastralReference2 = _interopRequireDefault(_modalCadastralReference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCadastralReferenceModule = _angular2.default.module('modalCadastralReference', []).component('modalCadastralReference', _modalCadastralReference2.default).name;
	
	exports.default = modalCadastralReferenceModule;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalCadastralReference = __webpack_require__(2003);
	
	var _modalCadastralReference2 = _interopRequireDefault(_modalCadastralReference);
	
	var _modalCadastralReference3 = __webpack_require__(2004);
	
	var _modalCadastralReference4 = _interopRequireDefault(_modalCadastralReference3);
	
	__webpack_require__(2005);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCadastralReferenceComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    onSave: '&',
	    loanResponseId: '<',
	    simulation: '<',
	    closeModalCadastral: '&',
	    tempLoanObject: '<'
	  },
	  template: _modalCadastralReference2.default,
	  controller: _modalCadastralReference4.default
	};
	
	exports.default = modalCadastralReferenceComponent;

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <div class=\"modal-header\">\n    <h1 class=\"modal-title\">\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.TITLE' | translate }}\n    </h1>\n    <button type=\"button\" ng-click=\"$ctrl.conCloseModalCadastral()\" class=\"close\">\n      <span class=\"icon-cross\"></span>\n    </button>\n  </div>\n\n  <div class=\"modal-body\">\n    <cadastral-reference-form\n      simulation=\"$ctrl.simulation\"\n      loan=\"$ctrl.loan\"\n      loan-response-id=\"$ctrl.loanResponseId\"\n      temp-loan-object=\"$ctrl.tempLoanObject\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      on-save=\"$ctrl.onSaveCadastral($event)\"\n      on-change-form=\"$ctrl.onChangeForm($event)\"\n      show-modal-question=\"$ctrl.showModalQuestion($event)\">\n    </cadastral-reference-form>\n  </div>\n</div>\n"

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCadastralReferenceController = function () {
	  modalCadastralReferenceController.$inject = ["EventEmitter", "$window"];
	  function modalCadastralReferenceController(EventEmitter, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, modalCadastralReferenceController);
	    this.EventEmitter = EventEmitter;
	    this.isMobileApp = $window.innerWidth < 1024;
	  }
	
	  (0, _createClass3.default)(modalCadastralReferenceController, [{
	    key: 'onChangeForm',
	    value: function onChangeForm($event) {
	      this.cadastralReference = $event.cadastralReference;
	      this.isCadastralCorrect = $event.isCadastralCorrect;
	    }
	  }, {
	    key: 'conCloseModalCadastral',
	    value: function conCloseModalCadastral() {
	      var sendToClose = {
	        cadastralReference: this.cadastralReference,
	        isCadastralCorrect: this.isCadastralCorrect
	      };
	      this.closeModalCadastral(this.EventEmitter(sendToClose));
	    }
	  }, {
	    key: 'onSaveCadastral',
	    value: function onSaveCadastral($event) {
	      this.onSave(this.EventEmitter($event));
	    }
	  }]);
	  return modalCadastralReferenceController;
	}();
	
	exports.default = modalCadastralReferenceController;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2006);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./modalCadastralReference.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./modalCadastralReference.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-cadastral-reference .modal-content{padding:43px 30px 50px}modal-cadastral-reference .modal-content.mobile{height:calc(100vh - 75px);overflow-y:scroll;padding-bottom:85px!important}modal-cadastral-reference .modal-content.mobile .modal-header h1{text-align:center}modal-cadastral-reference .modal-header{border-bottom:1px solid #dddfe2;padding-bottom:4px}modal-cadastral-reference .modal-header h1{color:#0072c9;font-family:Stag Sans;font-size:24px;font-weight:400}", ""]);
	
	// exports


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _modalDetailAdhesion = __webpack_require__(2008);
	
	var _modalDetailAdhesion2 = _interopRequireDefault(_modalDetailAdhesion);
	
	var _myLoans = __webpack_require__(1988);
	
	var _myLoans2 = _interopRequireDefault(_myLoans);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalDetailAdhesionModule = _angular2.default.module('modalDetailAdhesion', [_angularUiRouter2.default]).service('myLoansService', _myLoans2.default).component('modalDetailAdhesion', _modalDetailAdhesion2.default).name;
	
	exports.default = modalDetailAdhesionModule;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalDetailAdhesion = __webpack_require__(2009);
	
	var _modalDetailAdhesion2 = _interopRequireDefault(_modalDetailAdhesion);
	
	var _modalDetailAdhesion3 = __webpack_require__(2010);
	
	var _modalDetailAdhesion4 = _interopRequireDefault(_modalDetailAdhesion3);
	
	__webpack_require__(2011);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalDetailAdhesionComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<'
	  },
	  template: _modalDetailAdhesion2.default,
	  controller: _modalDetailAdhesion4.default
	};
	
	exports.default = modalDetailAdhesionComponent;

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-header row\">\n    <h1>{{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.TITLE' | translate }}{{ $ctrl.loan.modalityLiteral }}</h1>\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\"><span class=\"icon-cross\"></span></button>\n  </div>\n\n  <div class=\"modal-body row\">\n\n     <p>\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.TYPE' | translate }}: <span>{{ $ctrl.loan.modalityCode }}</span>\n    </p>\n    <p>\n      {{ 'LOANS.REPAYMENT.LOAN_INFO.ID' | translate }}: <span>{{ $ctrl.loan.identifying }}</span>\n    </p>\n    <p>\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.GRANTED' | translate }}: <span>{{ $ctrl.loan.grantedQuantity | currency:'€' }}</span>\n    </p>\n    <p>\n      {{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.DATE' | translate }}: <span>{{ $ctrl.loan.grantDate | date:'dd/MM/yyyy' }}</span>\n    </p>\n  </div>\n\n\n\n  <div ng-if=\"!$ctrl.isMobileApp\" class=\"modal-footer\">\n    <div class=\"row\" ng-if=\"$ctrl.showRequestNovation()\">\n      <h5>{{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.AGREE_WITH_NOVATION' | translate}}</h5>\n    </div>\n \n    <button type=\"button\" ng-if=\"$ctrl.showRequestNovation()\"  class=\"btn btn-app btn-primary\" ng-click=\"$ctrl.sendRequestNovation()\" >\n      {{ 'GLOBALS.BUTTON_ACTION.ACCEPT' | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-app btn-primary\" data-dismiss=\"modal\">\n      {{ 'GLOBALS.BUTTON_ACTION.CLOSE' | translate }}\n    </button>\n  </div>\n\n\n  <div ng-if=\"$ctrl.isMobileApp\" class=\"modal-footer\">\n    <div class=\"row\" ng-if=\"$ctrl.showRequestNovation()\">\n      <h5>{{ 'LOANS.MY_LOANS.MODAL.MODAL_DETAIL.AGREE_WITH_NOVATION' | translate}}</h5>\n    </div>\n\n    <div class=\"button-adhesion-app\">\n      <button type=\"button\" ng-if=\"$ctrl.showRequestNovation()\"  class=\"btn btn-app btn-primary\" ng-click=\"$ctrl.sendRequestNovation()\" data-dismiss=\"modal\">\n      {{ 'GLOBALS.BUTTON_ACTION.ACCEPT' | translate }}\n      </button>\n\n      <button type=\"button\" class=\"btn btn-app btn-primary\" data-dismiss=\"modal\">\n      {{ 'GLOBALS.BUTTON_ACTION.CLOSE' | translate }}\n      </button>\n    </div>\n\n  </div>\n\n  <successful-action\n    title=\"{{ 'LOANS.MODAL_SUCCESS_ADHESION.SUCCESS' | translate }}\"\n    ng-if=\"$ctrl.isSuccess();\"\n    on-click=\"$ctrl.removeSuccessfulModal()\"\n    close-modal=\"true\"\n    is-mobile-app=\"$ctrl.isMobileApp\">\n  </successful-action>\n</div>\n"

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalDetailAdhesionController = function () {
	  ModalDetailAdhesionController.$inject = ["$window", "myLoansService", "LoansUserDataService"];
	  function ModalDetailAdhesionController($window, myLoansService, LoansUserDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalDetailAdhesionController);
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.myLoansService = myLoansService;
	    this.loansUserDataService = LoansUserDataService;
	    this.userId = this.loansUserDataService._employee.userId;
	    this.showModalSucess = false;
	  }
	
	  (0, _createClass3.default)(ModalDetailAdhesionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) this.floatingActionButtons = this.getFloatingActionButtons();
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      angular.element('.modal').modal('hide');
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.CLOSE'
	      }];
	    }
	  }, {
	    key: 'showCancellationDate',
	    value: function showCancellationDate() {
	      return this.loan.statusCode === _constants.LOANS.STATES.ID.NOT_IN_FORCE;
	    }
	  }, {
	    key: 'showRequestNovation',
	    value: function showRequestNovation() {
	      return this.loan.novationCollective || this.loan.novationTypeVariable;
	    }
	  }, {
	    key: 'sendRequestNovation',
	    value: function sendRequestNovation() {
	      this.myLoansService.sendRequestNovation(this.userId, this.loan);
	      this.loan.novationCollective = false;
	      this.loan.novationTypeVariable = false;
	      this.showModalSucess = true;
	    }
	  }, {
	    key: 'isSuccess',
	    value: function isSuccess() {
	      return this.showModalSucess;
	    }
	  }, {
	    key: 'removeSuccessfulModal',
	    value: function removeSuccessfulModal() {
	      this.showModalSucess = false;
	    }
	  }]);
	  return ModalDetailAdhesionController;
	}();
	
	exports.default = ModalDetailAdhesionController;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2012);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./modalDetailAdhesion.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./modalDetailAdhesion.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "modal-detail-adhesion .modal-content.mobile .modal-header{margin-top:20px}modal-detail-adhesion .modal-content.mobile .modal-header h1{font-size:16px}modal-detail-adhesion .modal-content.mobile .modal-body p{font-size:13px}modal-detail-adhesion .modal-content.mobile .modal-body p>span{font-size:14px}modal-detail-adhesion .modal-header h1{color:#0072c9;font-size:24px;font-weight:400}modal-detail-adhesion .modal-header h1:first-letter{text-transform:uppercase}modal-detail-adhesion .modal-body{margin-top:20px}modal-detail-adhesion .modal-body p{font-size:15px}modal-detail-adhesion .modal-body p>span{color:#333}modal-detail-adhesion .modal-footer{margin-top:39px;text-align:center}modal-detail-adhesion h5{margin-bottom:15px;color:#0072c9}modal-detail-adhesion .button-adhesion-app{display:flex}modal-detail-adhesion successful-action{position:absolute;top:0}", ""]);
	
	// exports


/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _states = __webpack_require__(565);
	
	var _routes = __webpack_require__(1040);
	
	var _cadastralReferenceMobile = __webpack_require__(2014);
	
	var _cadastralReferenceMobile2 = _interopRequireDefault(_cadastralReferenceMobile);
	
	var _modalQuestionCadastral = __webpack_require__(2019);
	
	var _modalQuestionCadastral2 = _interopRequireDefault(_modalQuestionCadastral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cadastralReferenceMobileModule = _angular2.default.module('cadastralReferenceMobile', [_angularUiRouter2.default, _modalQuestionCadastral2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.CADASTRAL_REFERENCE, {
	    url: _routes.ROUTES.LOANS.CADASTRAL_REFERENCE,
	    component: 'cadastralReferenceMobile',
	    params: {
	      dataParams: null
	    },
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).component('cadastralReferenceMobile', _cadastralReferenceMobile2.default).name;
	
	exports.default = cadastralReferenceMobileModule;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cadastralReferenceMobile = __webpack_require__(2015);
	
	var _cadastralReferenceMobile2 = _interopRequireDefault(_cadastralReferenceMobile);
	
	var _cadastralReferenceMobile3 = __webpack_require__(2016);
	
	var _cadastralReferenceMobile4 = _interopRequireDefault(_cadastralReferenceMobile3);
	
	__webpack_require__(2017);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cadastralReferenceMobileComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _cadastralReferenceMobile2.default,
	  controller: _cadastralReferenceMobile4.default
	};
	
	exports.default = cadastralReferenceMobileComponent;

/***/ }),
/* 2015 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"$ctrl.getClasses()\">\n  <cadastral-reference-form\n    ng-if=\"$ctrl.loan !== undefined && !$ctrl.showQuestion\"\n    simulation=\"$ctrl.simulation\"\n    loan=\"$ctrl.loan\"\n    loan-response-id=\"$ctrl.loanResponseId\"\n    temp-loan-object=\"$ctrl.tempLoanObject\"\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    on-save=\"$ctrl.onSave($event)\"\n    show-modal-question=\"$ctrl.showModalQuestion($event)\">\n  </cadastral-reference-form>\n\n  <modal-question-cadastral\n    ng-if=\"$ctrl.showQuestion\"\n    reset-form-cadastral=\"$ctrl.resetFormCadastral()\"\n    show-cadastral-reference=\"$ctrl.showCadastralReference()\"\n    is-mobile-app=\"$ctrl.isMobileApp\">\n  </modal-question-cadastral>\n\n  <my-loans-request-cadastral\n    error=\"$ctrl.error\"\n    message-error=\"$ctrl.messageError\"\n    on-close-modal-cadastral=\"$ctrl.onClose()\">\n  </my-loans-request-cadastral>\n</div>\n"

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CadastralReferenceMobileController = function () {
	  CadastralReferenceMobileController.$inject = ["$window", "$rootScope", "$stateParams", "$state", "$timeout", "GoBackDataService"];
	  function CadastralReferenceMobileController($window, $rootScope, $stateParams, $state, $timeout, GoBackDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CadastralReferenceMobileController);
	    this.window = $window;
	    this.rootScope = $rootScope;
	    this.stateParams = $stateParams;
	    this.state = $state;
	    this.timeout = $timeout;
	    this.goBackDataService = GoBackDataService;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.optionIsSelected = undefined;
	    this.showQuestion = false;
	    this.setTitlePage();
	    if (this.stateParams.dataParams) {
	      this.initFromSnapshot();
	    }
	  }
	
	  (0, _createClass3.default)(CadastralReferenceMobileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (_lodash2.default.isEmpty(this.loan) && this.isMobileApp) {
	        return this.state.go(_states.STATES.LOANS.MY_LOANS);
	      }
	    }
	  }, {
	    key: 'getModal',
	    value: function getModal(item) {
	      var modals = {
	        'requestCadastral': $(_constants.MODALS.REQUEST_CADASTRAL),
	        'questionCadastral': $(_constants.MODALS.QUESTION_CADASTRAL)
	      };
	
	      return modals[item];
	    }
	  }, {
	    key: 'initFromSnapshot',
	    value: function initFromSnapshot() {
	      var snapshot = this.stateParams.dataParams;
	      this.loan = snapshot.loan;
	      this.tempLoanObject = snapshot.tempLoanObject;
	      this.simulation = snapshot.simulation;
	      this.from = snapshot.from;
	      if (this.from === 'sign-up') this.goBackDataService.setDataBackToSignUp(snapshot.paramsSignUp);
	    }
	  }, {
	    key: 'setTitlePage',
	    value: function setTitlePage() {
	      this.rootScope.$broadcast(_constants.EVENTS.CHANGE_TITLE, { title: 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.TITLE' });
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        responsiveMobile: this.isMobileApp,
	        container: this.isMobileApp,
	        hpd: this.isMobileApp,
	        'with-floating-action-buttons': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave($event) {
	      this.error = $event.error;
	      this.messageError = $event.messageError;
	      this.getModal('requestCadastral').modal('show');
	    }
	  }, {
	    key: 'showCadastralReference',
	    value: function showCadastralReference() {
	      this.showQuestion = false;
	      this.getModal('questionCadastral').modal('hide');
	    }
	  }, {
	    key: 'showModalQuestion',
	    value: function showModalQuestion($event) {
	      var _this = this;
	
	      this.isCadastralCorrect = $event.isCadastralCorrect;
	      this.tempLoanObject = $event.tempLoanObject.cadastralReferences[0];
	      if (!this.isCadastralCorrect) {
	        this.showQuestion = true;
	        this.timeout(function () {
	          return _this.getModal('questionCadastral').modal('show');
	        });
	      } else {
	        this.onClose();
	      }
	    }
	  }, {
	    key: 'resetFormCadastral',
	    value: function resetFormCadastral() {
	      this.showQuestion = false;
	      this.tempLoanObject = undefined;
	      this.getModal('questionCadastral').modal('hide');
	      if (this.error === 'failed') {
	        this.error = undefined;
	      }
	
	      this.onClose();
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      var errorApprove = this.error === 'approve';
	      this.checkErrorOnCloseCadastral(errorApprove);
	      if (errorApprove || this.error === undefined) {
	        if (this.from === 'sign-up') this.closeFromSignUp();
	        if (this.from === 'my-loans') this.closeFromMyLoans();
	      }
	    }
	  }, {
	    key: 'onConfirmCloseCadastral',
	    value: function onConfirmCloseCadastral() {
	      this.error = undefined;
	      this.onClose();
	    }
	  }, {
	    key: 'closeFromMyLoans',
	    value: function closeFromMyLoans() {
	      this.state.go(_states.STATES.LOANS.MY_LOANS);
	    }
	  }, {
	    key: 'closeFromSignUp',
	    value: function closeFromSignUp() {
	      var loanId = this.loan.id;
	      var from = _states.STATES.LOANS.CADASTRAL_REFERENCE;
	      this.goBackDataService.setHideOrShowButtonCadastralSignUp(this.hideButtonCadastral);
	      if (!this.showQuestion) this.state.go(_states.STATES.LOANS.SIGN_UP, { loanId: loanId, from: from });
	    }
	  }, {
	    key: 'checkErrorOnCloseCadastral',
	    value: function checkErrorOnCloseCadastral(errorApprove) {
	      errorApprove ? this.hideButtonCadastral = true : this.hideButtonCadastral = false;
	    }
	  }]);
	  return CadastralReferenceMobileController;
	}();
	
	exports.default = CadastralReferenceMobileController;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2018);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./cadastralReferenceMobile.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./cadastralReferenceMobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalQuestionCadastral = __webpack_require__(2020);
	
	var _modalQuestionCadastral2 = _interopRequireDefault(_modalQuestionCadastral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalQuestionCadastralModule = _angular2.default.module('modalQuestionCadastral', []).component('modalQuestionCadastral', _modalQuestionCadastral2.default).name;
	
	exports.default = modalQuestionCadastralModule;

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalQuestionCadastral = __webpack_require__(2021);
	
	var _modalQuestionCadastral2 = _interopRequireDefault(_modalQuestionCadastral);
	
	var _modalQuestionCadastral3 = __webpack_require__(2022);
	
	var _modalQuestionCadastral4 = _interopRequireDefault(_modalQuestionCadastral3);
	
	__webpack_require__(2023);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalQuestionCadastralComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<',
	    resetFormCadastral: '&',
	    showCadastralReference: '&'
	  },
	  template: _modalQuestionCadastral2.default,
	  controller: _modalQuestionCadastral4.default
	};
	
	exports.default = modalQuestionCadastralComponent;

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalQuestionCadastral\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalQuestionCadastralLabel\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-dialog\">\n\n    <confirm-close-modal\n      title-modal=\"¿{{ 'GLOBALS.CONFIRM_CLOSE' | translate }}?\"\n      small-description=\"{{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.CLOSE_MODAL_DESC' | translate }}\"\n      button-yes=\"true\"\n      on-confirm=\"$ctrl.resetFormCadastral()\"\n      button-no=\"true\"\n      on-click-no=\"$ctrl.showCadastralReference()\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </confirm-close-modal>\n\n  </div>\n</div>\n"

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalQuestionCadastralController = function () {
	  function ModalQuestionCadastralController() {
	    (0, _classCallCheck3.default)(this, ModalQuestionCadastralController);
	
	    this.modalStates = _constants.LOANS_MODAL_STATES;
	  }
	
	  (0, _createClass3.default)(ModalQuestionCadastralController, [{
	    key: 'getModalShow',
	    value: function getModalShow(modalToShow) {
	      return this.optionIsSelected === modalToShow;
	    }
	  }]);
	  return ModalQuestionCadastralController;
	}();
	
	exports.default = ModalQuestionCadastralController;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2024);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./modalQuestionCadastral.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./modalQuestionCadastral.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myLoans = __webpack_require__(2026);
	
	var _myLoans2 = _interopRequireDefault(_myLoans);
	
	var _myLoans3 = __webpack_require__(2027);
	
	var _myLoans4 = _interopRequireDefault(_myLoans3);
	
	__webpack_require__(2028);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myLoansComponent = {
	  restrict: 'E',
	  bindings: {
	    serviceClosed: '<'
	  },
	  template: _myLoans2.default,
	  controller: _myLoans4.default
	};
	
	exports.default = myLoansComponent;

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd my-loans\"\n     ng-class=\"$ctrl.getClasses()\"\n     pull-to-refresh=\"$ctrl.getMyLoans()\">\n\n  <modal-coachmark\n    ng-if=\"!$ctrl.isMobileApp\"\n    data=\"$ctrl.coachmarkData\"\n    user-id=\"$ctrl.userId\">\n  </modal-coachmark>\n\n  <!-- Title and filters -->\n  <header ng-if=\"!$ctrl.showLoading()\" class=\"animation-appear\">\n    <section-title\n      class=\"loans-title\"\n      text=\"{{ 'LOANS.MY_LOANS.TITLE' | translate }}\">\n    </section-title>\n    <alert-card\n      ng-if=\"$ctrl.isMobileApp\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n      {{ 'LOANS.MY_LOANS.INFO_BOX' | translate }}\n    </alert-card>\n    <my-loans-filters\n      ng-if=\"!$ctrl.isMobileApp\"\n      class=\"loans-filters\"\n      object-states-filter=\"$ctrl.objectStatesFilter\"\n      filter-by-status=\"$ctrl.filterByStatus($event)\">\n    </my-loans-filters>\n    <my-loans-mobile-filters\n      ng-if=\"$ctrl.isMobileApp\"\n      filter-by-status=\"$ctrl.filterByStatus($event)\"\n      object-states-filter=\"$ctrl.objectStatesFilter\">\n    </my-loans-mobile-filters>\n  </header>\n\n  <!-- Loading message -->\n  <section ng-if=\"$ctrl.showLoading()\" class=\"animation-appear\">\n    <loading></loading>\n  </section>\n\n  <!-- Main section -->\n  <section class=\"animation-appear loans-wrapper\" ng-if=\"!$ctrl.showLoading()\">\n    <my-loans-modal\n      ng-if=\"$ctrl.modalExists\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      loan=\"$ctrl.loanObjectModal\"\n      option-is-selected=\"$ctrl.optionIsSelected\"\n      on-save=\"$ctrl.onSave($event)\"\n      on-cancel-amortization=\"$ctrl.onCancelAmortization()\"\n      cancel-amortization-error-message=\"$ctrl.cancelAmortizationErrorMessage\"\n      close-modal-cadastral=\"$ctrl.closeModalCadastral($event)\"\n      show-cadastral-reference=\"$ctrl.showCadastralReference()\"\n      reset-form-cadastral=\"$ctrl.resetFormCadastral()\"\n      temp-loan-object=\"$ctrl.tempLoanObject\">\n    </my-loans-modal>\n\n    <my-loans-request-cadastral\n      error=\"$ctrl.error\"\n      message-error=\"$ctrl.messageError\"\n      on-close-modal-cadastral=\"$ctrl.onCloseModalCadastral()\">\n    </my-loans-request-cadastral>\n\n    <div ng-repeat=\"currentLoan in $ctrl.myLoans | filter:{ statusCode: $ctrl.selectedFilterStatus } as filteredResults\" class=\"container-card-my-loans\">\n      <div class=\"card-separator\"></div>\n      <my-loans-card\n        loan-object=\"currentLoan\"\n        view-options=\"currentLoan.viewOptions\"\n        on-toggle-options=\"$ctrl.onToggleOptions($event)\"\n        on-change-option-selected=\"$ctrl.onChangeOptionSelected($event)\"\n        on-select-option=\"$ctrl.onSelectOption($event)\"\n        service-closed=\"$ctrl.serviceClosed\"\n        filter-active=\"$ctrl.filterActive\"\n        temp-loan-object=\"$ctrl.tempLoanObject\">\n      </my-loans-card>\n      <div class=\"card-separator\" ng-if=\"$last\"></div>\n    </div>\n\n    <div class=\"list-empty\" ng-if=\"$ctrl.showEmptyMessage() && !$ctrl.selectedFilterStatus\">\n      <span class=\"icon-warning\"></span>\n      <span>{{'LOANS.MY_LOANS.NO_LOANS' | translate}}</span>\n    </div>\n\n    <div class=\"list-empty\" ng-if=\"$ctrl.selectedFilterStatus && filteredResults.length === 0\">\n      <span class=\"icon-warning\"></span>\n      <span>{{'LOANS.MY_LOANS.NO_COICIDENCES' | translate}}</span>\n    </div>\n\n  </section>\n\n</div>\n"

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _states = __webpack_require__(565);
	
	var _constants = __webpack_require__(1774);
	
	var _constants2 = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONTEXT_MENU_TAG = 'my-loans-context-menu';
	var VIEW_OPTIONS_TAG = '.view-options';
	
	var MyLoansController = function () {
	  MyLoansController.$inject = ["$log", "$timeout", "$window", "$state", "$rootScope", "$translate", "LoansUserDataService", "myLoansService", "LoansOperationsService", "LoansStatesService", "GoBackDataService", "$q", "loadingMobileService"];
	  function MyLoansController($log, $timeout, $window, $state, $rootScope, $translate, LoansUserDataService, myLoansService, LoansOperationsService, LoansStatesService, GoBackDataService, $q, loadingMobileService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MyLoansController);
	    this.log = $log;
	    this.timeout = $timeout;
	    this.window = $window;
	    this.state = $state;
	    this.rootScope = $rootScope;
	    this.translate = $translate;
	    this.loansUserDataService = LoansUserDataService;
	    this.myLoansService = myLoansService;
	    this.loansOperationsService = LoansOperationsService;
	    this.loansStatesService = LoansStatesService;
	    this.goBackDataService = GoBackDataService;
	    this.q = $q;
	    this.loadingMobileService = loadingMobileService;
	    this.loaded = false;
	    this.myLoans = [];
	
	    this.coachmarkData = _constants.LOANS_MY_LOANS_MODAL_COACHMARK_CONFIG;
	
	    this.userId = this.loansUserDataService._employee.userId;
	
	    this.isMobileApp = $window.innerWidth < 1024;
	
	    this.objectStatesFilter = this.loansStatesService.statesFilters;
	
	    this.setTitlePage();
	  }
	
	  (0, _createClass3.default)(MyLoansController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      this.selectedFilterStatus = '';
	      this.getMyLoans();
	      this.hideContextMenuAfterClickOutside();
	    }
	  }, {
	    key: 'setTitlePage',
	    value: function setTitlePage() {
	      this.rootScope.$broadcast(_constants2.EVENTS.CHANGE_TITLE, { title: 'LOANS.MY_LOANS.TITLE' });
	    }
	  }, {
	    key: 'getModal',
	    value: function getModal(item) {
	      var availableModals = {
	        cadastral: $(_constants2.MODALS.REQUEST_CADASTRAL),
	        myLoans: $(_constants2.MODALS.MY_LOANS)
	      };
	
	      return availableModals[item];
	    }
	  }, {
	    key: 'getMyLoans',
	    value: function getMyLoans() {
	      var _this = this;
	
	      this.modalExists = false;
	      this.loadingMobileService.show();
	      this.myLoansService.getMyLoans(this.userId).then(function (myLoans) {
	        _this.myLoans = myLoans;
	        _this.initContextMenuViewOptions(_this.myLoans);
	        _this.setLinks(_this.myLoans);
	        _this.modalExists = true;
	      }, function (error) {
	        _this.log.error(error);
	        _this.errorMyLoans = true;
	      }).finally(function () {
	        _this.loaded = true;
	        _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        'responsiveMobile': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'showLoading',
	    value: function showLoading() {
	      return !this.isMobileApp && !this.loaded;
	    }
	  }, {
	    key: 'myLoansAvailable',
	    value: function myLoansAvailable() {
	      return this.myLoans.length > 0 && this.loaded;
	    }
	  }, {
	    key: 'showEmptyMessage',
	    value: function showEmptyMessage() {
	      return this.myLoans.length === 0 && this.loaded;
	    }
	  }, {
	    key: 'initContextMenuViewOptions',
	    value: function initContextMenuViewOptions(loans) {
	      loans.forEach(function (loan) {
	        return loan.viewOptions = false;
	      });
	    }
	  }, {
	    key: 'setLinks',
	    value: function setLinks(loans) {
	      loans.forEach(this.setLoanLinks, this);
	    }
	  }, {
	    key: 'setLoanLinks',
	    value: function setLoanLinks(loan) {
	      var links = _constants.LOANS.LINKS;
	
	      loan.links = {
	        receipts: links.RECEIPTS + '?id=' + loan.identifying + '&matricula=' + this.userId,
	        policy: links.POLICY + '?id=' + loan.identifying + '&matricula=' + this.userId,
	        tax: links.TAX + '?id=' + loan.identifying + '&matricula=' + this.userId
	      };
	    }
	  }, {
	    key: 'filterByStatus',
	    value: function filterByStatus($event) {
	      this.selectedFilterStatus = $event.status;
	      this.filterActive = $event.filterActive;
	    }
	  }, {
	    key: 'onToggleOptions',
	    value: function onToggleOptions($event) {
	      var showAfterHide = !$event.loan.viewOptions;
	      this.initContextMenuViewOptions(this.myLoans);
	      $event.loan.viewOptions = showAfterHide;
	    }
	  }, {
	    key: 'hideContextMenuAfterClickOutside',
	    value: function hideContextMenuAfterClickOutside() {
	      var _this2 = this;
	
	      $(document).click(function (event) {
	        var target = $(event.target);
	        var clickOutsideOfViewOptions = !target.closest(VIEW_OPTIONS_TAG).length;
	        var clickOutsideOfMenu = !target.closest(CONTEXT_MENU_TAG).length;
	        if (clickOutsideOfViewOptions && clickOutsideOfMenu) {
	          _this2.timeout(function () {
	            return _this2.initContextMenuViewOptions(_this2.myLoans);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'onChangeOptionSelected',
	    value: function onChangeOptionSelected($event) {
	      this.optionIsSelected = $event.optionSelected;
	      this.resetForm = true;
	
	      if (!_lodash2.default.isEmpty(this.loanObjectModal.cadastralReference)) {
	        this.resetForm = false;
	      }
	
	      if (this.isMobileApp && $event.dataCadastral) {
	        var dataEvent = $event.dataCadastral ? $event.dataCadastral : $event;
	        var dataCadastral = {
	          loan: dataEvent.loan || this.loanObjectModal,
	          tempLoanObject: dataEvent.tempLoanObject || this.tempLoanObject,
	          optionIsSelected: $event.optionIsSelected,
	          from: 'my-loans'
	        };
	
	        this.state.go(_states.STATES.LOANS.CADASTRAL_REFERENCE, { dataParams: dataCadastral });
	      }
	    }
	  }, {
	    key: 'onSelectOption',
	    value: function onSelectOption($event) {
	      this.loanObjectModal = $event.loan;
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave($event) {
	      this.hideModal();
	      this.error = $event.error;
	      this.messageError = $event.messageError;
	      this.getModal('cadastral').modal('show');
	      this.getMyLoans();
	    }
	  }, {
	    key: 'showCadastralReference',
	    value: function showCadastralReference() {
	      if (this.isMobileApp) {
	        var paramsToCadastral = {
	          loan: this.loanObjectModal,
	          tempLoanObject: this.tempLoanObject,
	          from: 'my-loans'
	        };
	        this.hideModal();
	        return this.state.go(_states.STATES.LOANS.CADASTRAL_REFERENCE, { dataParams: paramsToCadastral });
	      }
	
	      this.optionIsSelected = _constants.LOANS_MODAL_STATES.CADASTRAL_REFERENCE;
	    }
	  }, {
	    key: 'closeModalCadastral',
	    value: function closeModalCadastral($event) {
	      if (!$event.isCadastralCorrect) {
	        this.tempLoanObject = $event.cadastralReference;
	        this.optionIsSelected = _constants.LOANS_MODAL_STATES.CLOSE_CADASTRAL_REFERENCE;
	        this.getModal('myLoans').modal('show');
	      } else {
	        this.optionIsSelected = '';
	        this.hideModal();
	      }
	    }
	  }, {
	    key: 'hideModal',
	    value: function hideModal() {
	      this.getModal('myLoans').modal('hide');
	    }
	  }, {
	    key: 'checkCloseModalCadastral',
	    value: function checkCloseModalCadastral() {
	      return !_lodash2.default.isEmpty(this.loanObjectModal.cadastralReference);
	    }
	  }, {
	    key: 'resetFormCadastral',
	    value: function resetFormCadastral() {
	      if (this.resetForm || !this.isCadastralCorrect) {
	        this.loanObjectModal.cadastralReference = {};
	        this.tempLoanObject = {};
	        this.hideModal();
	      }
	    }
	  }]);
	  return MyLoansController;
	}();
	
	exports.default = MyLoansController;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2029);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./myLoans.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./myLoans.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "my-loans{display:block}my-loans .ptr--ptr{margin-top:60px}my-loans .my-loans.responsiveMobile header section-title h2{font-size:16px}my-loans .my-loans.responsiveMobile .container-card-my-loans{margin-left:-30px;margin-right:-30px}my-loans .my-loans.responsiveMobile .container-card-my-loans .one-loan-card{padding-left:30px;padding-right:30px}my-loans .my-loans.responsiveMobile .loans-title h2{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}my-loans .my-loans.responsiveMobile .loans-title h2 .icon{font-size:16px;margin-right:19px}my-loans .my-loans.responsiveMobile .loans-title h2 .text{font-size:15px}my-loans alert-card .card-message-alert.mobile{margin-bottom:37px}my-loans .loans-filters{margin-top:40px;margin-bottom:40px}my-loans .card-separator{background-color:#dddfe2;height:1px;width:100%}my-loans .last{margin-top:10px}my-loans .list-empty{font-size:30px;height:200px;text-align:center;color:#0072c9}my-loans .icon-warning{font-size:60px;position:relative;top:13px;right:5px;color:#0072c9}my-loans .container.mobile .loans-wrapper{padding-bottom:75px}", ""]);
	
	// exports


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _loansRepayment = __webpack_require__(2031);
	
	var _loansRepayment2 = _interopRequireDefault(_loansRepayment);
	
	var _loansRepaymentLoanInfo = __webpack_require__(2036);
	
	var _loansRepaymentLoanInfo2 = _interopRequireDefault(_loansRepaymentLoanInfo);
	
	var _loansRepaymentForm = __webpack_require__(2042);
	
	var _loansRepaymentForm2 = _interopRequireDefault(_loansRepaymentForm);
	
	var _loansRepaymentModal = __webpack_require__(2048);
	
	var _loansRepaymentModal2 = _interopRequireDefault(_loansRepaymentModal);
	
	var _loansRepayment3 = __webpack_require__(2054);
	
	var _loansRepayment4 = _interopRequireDefault(_loansRepayment3);
	
	var _loansRepaymentSimulate = __webpack_require__(2055);
	
	var _loansRepaymentSimulate2 = _interopRequireDefault(_loansRepaymentSimulate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRepaymentModule = _angular2.default.module('loansRepayment', [_angularUiRouter2.default, _loansRepaymentLoanInfo2.default, _loansRepaymentForm2.default, _loansRepaymentModal2.default, _loansRepaymentSimulate2.default]).component('loansRepayment', _loansRepayment2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.REPAYMENT, {
	    url: _routes.ROUTES.LOANS.REPAYMENT,
	    component: 'loansRepayment',
	    params: {
	      loan: null
	    },
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).service('loansRepaymentService', _loansRepayment4.default).name;
	
	exports.default = loansRepaymentModule;

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansRepayment = __webpack_require__(2032);
	
	var _loansRepayment2 = _interopRequireDefault(_loansRepayment);
	
	var _loansRepayment3 = __webpack_require__(2033);
	
	var _loansRepayment4 = _interopRequireDefault(_loansRepayment3);
	
	__webpack_require__(2034);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRepaymentComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _loansRepayment2.default,
	  controller: _loansRepayment4.default
	};
	
	exports.default = loansRepaymentComponent;

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd\" ng-class=\"$ctrl.getClasses()\">\n\n  <section ng-if=\"$ctrl.isEmpty()\">\n    <div class=\"no-loan\">\n      <span class=\"icon-warning\"></span>\n      <span>{{ 'LOANS.REPAYMENT.ERROR' | translate }}</span>\n    </div>\n  </section>\n\n  <section ng-if=\"!$ctrl.isEmpty()\">\n\n    <loans-repayment-modal\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      success=\"$ctrl.repaymentSuccess\"\n      error=\"$ctrl.repaymentError\"\n      error-message=\"$ctrl.errorMessage\"\n      repayment-amount=\"$ctrl.repaymentAmount\"\n      repayment-type=\"$ctrl.repaymentType\"\n      fee-period=\"$ctrl.feePeriod\">\n    </loans-repayment-modal>\n\n    <loans-header\n      ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n      title=\"{{ 'LOANS.REPAYMENT.ACTION' | translate }} {{ $ctrl.loanData.title | translate }}\">\n    </loans-header>\n\n    <loans-repayment-loan-info\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      loan=\"$ctrl.loan\">\n    </loans-repayment-loan-info>\n\n    <option-switch\n      options-data=\"$ctrl.switchOptions\"\n      on-select=\"$ctrl.onRepaymentType($event)\"\n      id=\"option-switch\">\n    </option-switch>\n\n    <loans-repayment-form\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      loan=\"$ctrl.loan\"\n      repayment-type=\"$ctrl.repaymentType\"\n      on-create-repayment=\"$ctrl.onCreateRepayment($event)\">\n    </loans-repayment-form>\n\n  </section>\n\n</div>\n\n<div ng-if=\"$ctrl.showSimulation\">\n  <loans-repayment-simulate is-mobile-app=\"$ctrl.isMobileApp\" loans-simulation=\"$ctrl.loansSimulation\" repayment-parcial=\"$ctrl.repaymentParcial($event)\"></loans-repayment-simulate>\n</div>\n"

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(1360);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _states = __webpack_require__(565);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansRepaymentController = function () {
	  LoansRepaymentController.$inject = ["$stateParams", "$log", "loansRepaymentService", "LoansUserDataService", "$state", "$q", "$window", "$location"];
	  function LoansRepaymentController($stateParams, $log, loansRepaymentService, LoansUserDataService, $state, $q, $window, $location) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansRepaymentController);
	    this.log = $log;
	    this.q = $q;
	    this.location = $location;
	    this.loan = this.extractLoan($stateParams);
	    this.noLoan = this.setErrorWhenNoLoan(this.loan);
	    this.loansRepaymentService = loansRepaymentService;
	    this.loansUserDataService = LoansUserDataService;
	    this.state = $state;
	    this.switchOptions = _constants2.LOANS_REPAYMENT_SWITCH_CONFIG;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.showSimulation = false;
	    this.loansSimulation = [];
	    this.repaymentValue;
	  }
	
	  (0, _createClass3.default)(LoansRepaymentController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.repaymentType = _constants2.REPAYMENT_TYPES.SIMULATE;
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        responsiveMobile: this.isMobileApp,
	        'with-floating-action-buttons': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'extractLoan',
	    value: function extractLoan(stateParams) {
	      return stateParams.loan;
	    }
	  }, {
	    key: 'setErrorWhenNoLoan',
	    value: function setErrorWhenNoLoan(loan) {
	      return loan === undefined || loan === null;
	    }
	  }, {
	    key: 'isEmpty',
	    value: function isEmpty() {
	      return this.noLoan === true;
	    }
	  }, {
	    key: 'onRepaymentType',
	    value: function onRepaymentType($event) {
	      this.showSimulation = false;
	      this.location.hash('loans-header');
	      this.repaymentType = $event.option;
	    }
	  }, {
	    key: 'onCreateRepayment',
	    value: function onCreateRepayment($event) {
	      var _log;
	
	      var repaymentParams = {
	        employeeId: this.loansUserDataService._employee.userId,
	        loan: this.loan,
	        type: this.repaymentType,
	        capitalMovementTypeDate: (0, _moment2.default)().format('YYYY-MM-DD'),
	        loanId: this.loan.modalityCode,
	        feePeriod: $event
	      };
	
	      (_log = this.log).debug.apply(_log, ['onCreateRepayment:'].concat((0, _toConsumableArray3.default)(repaymentParams)));
	      if (repaymentParams.type === _constants2.REPAYMENT_TYPES.TOTAL) {
	        this.repaymentTotal(repaymentParams);
	      }
	      if (repaymentParams.type === _constants2.REPAYMENT_TYPES.SIMULATE) {
	        this.repaymentAmount = $event.repaymentAmount;
	        repaymentParams.repaymentAmount = this.repaymentAmount;
	
	        this.repaymentSimulate(repaymentParams);
	      }
	    }
	  }, {
	    key: 'repaymentTotal',
	    value: function repaymentTotal(repaymentParams) {
	      var _this = this;
	
	      this.loansRepaymentService.createTotalRepayment(repaymentParams).then(function (response) {
	        _this.repaymentAmount = response.data.amount;
	        _this.repaymentSuccess = true;
	        _this.repaymentError = false;
	      }, function (response) {
	        _this.repaymentSuccess = false;
	        _this.repaymentError = true;
	        _this.errorMessage = response.data.message;
	      }).then(function () {
	        return _this.modal.modal('show');
	      });
	    }
	  }, {
	    key: 'repaymentParcial',
	    value: function repaymentParcial($event) {
	      var _this2 = this;
	
	      this.feePeriod = $event.feePeriod;
	      var repayment = {
	        employeeId: this.loansUserDataService._employee.userId,
	        loan: this.loan,
	        type: this.repaymentType,
	        amount: this.repaymentAmount,
	        capitalMovementTypeDate: (0, _moment2.default)().format('YYYY-MM-DD'),
	        loanId: this.loan.modalityCode
	      };
	      this.loansRepaymentService.createPartialRepayment(repayment, this.feePeriod).then(function (response) {
	        _this2.repaymentAmount = response.data.amount;
	        _this2.showSimulation = false;
	        _this2.repaymentSuccess = true;
	        _this2.repaymentError = false;
	      }, function (response) {
	        _this2.showSimulation = false;
	        _this2.repaymentSuccess = false;
	        _this2.repaymentError = true;
	        _this2.errorMessage = response.data.message;
	      }).then(function () {
	        return _this2.modal.modal('show');
	      });
	    }
	  }, {
	    key: 'repaymentSimulate',
	    value: function repaymentSimulate(repaymentParams) {
	      var _this3 = this;
	
	      this.loansRepaymentService.simulateRepayment(repaymentParams, _constants2.AMORTIZATION.FEE).then(function (response) {
	        var fee = response.data;
	        _this3.loansRepaymentService.simulateRepayment(repaymentParams, _constants2.AMORTIZATION.PERIOD).then(function (response) {
	          _this3.loansSimulation = response.data.simulations.concat(fee.simulations);
	          _this3.showSimulation = true;
	          _this3.scrollToResults();
	        }, function (error) {
	          _this3.repaymentError = true;
	          _this3.errorMessage = error.data.message;
	        });
	      });
	    }
	  }, {
	    key: 'scrollToResults',
	    value: function scrollToResults() {
	      this.location.hash('option-switch');
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      var _this4 = this;
	
	      var modal = $(_constants.MODALS.LOANS_REPAYMENT);
	      modal.on('hidden.bs.modal', function () {
	        return _this4.state.go(_states.STATES.LOANS.MY_LOANS);
	      });
	      return modal;
	    }
	  }]);
	  return LoansRepaymentController;
	}();
	
	exports.default = LoansRepaymentController;

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2035);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansRepayment.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansRepayment.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-repayment .responsiveMobile option-switch{width:100%}loans-repayment .no-loan{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}loans-repayment .no-loan .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}loans-repayment option-switch{width:370px}", ""]);
	
	// exports


/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansRepaymentLoanInfo = __webpack_require__(2037);
	
	var _loansRepaymentLoanInfo2 = _interopRequireDefault(_loansRepaymentLoanInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRepaymentLoanInfoModule = _angular2.default.module('loansRepaymentLoanInfo', [_angularUiRouter2.default]).component('loansRepaymentLoanInfo', _loansRepaymentLoanInfo2.default).name;
	
	exports.default = loansRepaymentLoanInfoModule;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansRepaymentLoanInfo = __webpack_require__(2038);
	
	var _loansRepaymentLoanInfo2 = _interopRequireDefault(_loansRepaymentLoanInfo);
	
	var _loansRepaymentLoanInfo3 = __webpack_require__(2039);
	
	var _loansRepaymentLoanInfo4 = _interopRequireDefault(_loansRepaymentLoanInfo3);
	
	__webpack_require__(2040);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRepaymentLoanInfoComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    isMobileApp: '<'
	  },
	  template: _loansRepaymentLoanInfo2.default,
	  controller: _loansRepaymentLoanInfo4.default
	};
	
	exports.default = loansRepaymentLoanInfoComponent;

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loansRepaymentLoanInfo\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <div class=\"loan-info-row\">\n    <label>{{ 'LOANS.REPAYMENT.LOAN_INFO.ID' | translate }}</label>\n    <label>{{ $ctrl.loan.identifying }}</label>\n  </div>\n\n  <div class=\"loan-info-row\">\n    <label>{{ 'LOANS.REPAYMENT.LOAN_INFO.PURPOSE' | translate }}</label>\n    <label>{{ $ctrl.loan.purposeLiteral }}</label>\n  </div>\n\n  <div class=\"loan-info-row\">\n    <label>{{ 'LOANS.REPAYMENT.LOAN_INFO.STATUS' | translate }}</label>\n    <label>{{ $ctrl.loan.statusLiteral }}</label>\n  </div>\n\n  <div class=\"loan-info-row\">\n    <label>{{ 'LOANS.REPAYMENT.LOAN_INFO.PENDING_AMOUNT' | translate }}</label>\n    <label>{{ $ctrl.loan.amountPending | currency}}</label>\n  </div>\n\n  <div class=\"loan-info-row\">\n    <label>{{ 'LOANS.REPAYMENT.LOAN_INFO.MONTHLY_PAYMENT' | translate }}</label>\n    <label>{{ $ctrl.loan.monthlyFee | currency }}</label>\n  </div>\n\n</div>\n"

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansRepaymentLoanInfoController = function LoansRepaymentLoanInfoController() {
	  (0, _classCallCheck3.default)(this, LoansRepaymentLoanInfoController);
	};
	
	exports.default = LoansRepaymentLoanInfoController;

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2041);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansRepaymentLoanInfo.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansRepaymentLoanInfo.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, ".loansRepaymentLoanInfo{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;display:block;padding:42px 0 0 5px;border-bottom:1px solid #dddfe2}.loansRepaymentLoanInfo.mobile{padding-left:0}.loansRepaymentLoanInfo.mobile .loan-info-row{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.loansRepaymentLoanInfo.mobile .loan-info-row label:first-child,.loansRepaymentLoanInfo.mobile .loan-info-row label:last-child{width:auto}.loansRepaymentLoanInfo .loan-info-row{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;margin-bottom:36px}.loansRepaymentLoanInfo .loan-info-row label:first-child{width:200px;color:#0072c9;font-family:Stag Sans;font-weight:400;font-size:13px;line-height:1;text-align:left;text-transform:uppercase}.loansRepaymentLoanInfo .loan-info-row label:last-child{color:#666;font-family:Stag Sans;font-weight:400;font-size:15px;line-height:1;text-align:right}", ""]);
	
	// exports


/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansRepaymentForm = __webpack_require__(2043);
	
	var _loansRepaymentForm2 = _interopRequireDefault(_loansRepaymentForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRepaymentFormModule = _angular2.default.module('loansRepaymentForm', [_angularUiRouter2.default]).component('loansRepaymentForm', _loansRepaymentForm2.default).name;
	
	exports.default = loansRepaymentFormModule;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansRepaymentForm = __webpack_require__(2044);
	
	var _loansRepaymentForm2 = _interopRequireDefault(_loansRepaymentForm);
	
	var _loansRepaymentForm3 = __webpack_require__(2045);
	
	var _loansRepaymentForm4 = _interopRequireDefault(_loansRepaymentForm3);
	
	__webpack_require__(2046);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRepaymentFormComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    repaymentType: '<',
	    onCreateRepayment: '&',
	    isMobileApp: '<'
	  },
	  template: _loansRepaymentForm2.default,
	  controller: _loansRepaymentForm4.default
	};
	
	exports.default = loansRepaymentFormComponent;

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <form name=\"$ctrl.form\" novalidate ng-submit=\"$ctrl.submit()\">\n\n    <div class=\"form\">\n\n      <div class=\"form-group\" ng-if=\"!$ctrl.blocked\">\n        <label>\n          {{ 'LOANS.REPAYMENT.FORM.AMOUNT' | translate }}\n        </label>\n        <input\n          type=\"text\"\n          name=\"repaymentAmount\"\n          ng-change=\"$ctrl.setFormValidity()\"\n          ng-disabled=\"$ctrl.blocked\"\n          ng-class=\"{ 'amount': $ctrl.isMobileApp, 'mobile': $ctrl.isMobileApp }\"\n          ng-model=\"$ctrl.repaymentAmount\"\n          currency-input>\n      </div>\n\n      <div class=\"form-group\">\n        <label>\n          {{ 'LOANS.REPAYMENT.FORM.MOVEMENT_DATE' | translate }}\n        </label>\n        <span>\n          {{ $ctrl.movementDate | date }}\n        </span>\n      </div>\n    </div>\n\n    <div class=\"errors-container\">\n      <p class=\"label error\" ng-if=\"$ctrl.form.repaymentAmount.$dirty && $ctrl.errors.ltZero\">\n        {{ 'LOANS.REPAYMENT.FORM.ERRORS.LTZERO' | translate }}\n      </p>\n      <p class=\"label error\" ng-if=\"$ctrl.form.repaymentAmount.$dirty && $ctrl.errors.zero\">\n        {{ 'LOANS.REPAYMENT.FORM.ERRORS.ZERO' | translate }}\n      </p>\n      <p class=\"label error\" ng-if=\"$ctrl.form.repaymentAmount.$dirty && $ctrl.errors.gtAmount\">\n        {{ 'LOANS.REPAYMENT.FORM.ERRORS.GTAMOUNT'  | translate}} ({{$ctrl.loan.amountPending | currency}})\n      </p>\n    </div>\n\n    <span class=\"mini-warning\">\n      {{ 'LOANS.REPAYMENT.FORM.MINI_WARNING' | translate }}\n    </span>\n\n    <div ng-if=\"!$ctrl.isMobileApp\" class=\"buttons\">\n      <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-app btn-default\">\n        {{ 'GLOBALS.BUTTON_ACTION.CANCEL' | translate }}\n      </button>\n      <button type=\"submit\" ng-disabled=\"!$ctrl.valid\" class=\"btn btn-app btn-primary\">\n        {{ ($ctrl.blocked) ? 'GLOBALS.BUTTON_ACTION.CONFIRM' : 'GLOBALS.BUTTON_ACTION.SIMULATE' | translate }}\n      </button>\n    </div>\n\n    <floating-action-buttons\n      ng-if=\"$ctrl.isMobileApp\"\n      buttons=\"$ctrl.floatingActionButtons\"\n      is-simulate=\"!$ctrl.blocked\"\n      on-click-first-button=\"$ctrl.submit()\"\n      on-click-second-button=\"$ctrl.cancel()\">\n    </floating-action-buttons>\n\n  </form>\n\n</div>\n"

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	var _states = __webpack_require__(565);
	
	var _constants2 = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansRepaymentFormController = function () {
	  LoansRepaymentFormController.$inject = ["EventEmitter", "$scope", "$state"];
	  function LoansRepaymentFormController(EventEmitter, $scope, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansRepaymentFormController);
	    this.EventEmitter = EventEmitter;
	    this.scope = $scope;
	    this.state = $state;
	
	    this.movementDate = new Date();
	    this.errors = {};
	    this.valid = false;
	
	    this.repaymentAmount = 0;
	    this.previousAmount = 0;
	    this.convertedAmount = 0;
	  }
	
	  (0, _createClass3.default)(LoansRepaymentFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.watchRepaymentType();
	
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'watchRepaymentType',
	    value: function watchRepaymentType() {
	      var _this = this;
	
	      this.scope.$watch(function () {
	        return _this.repaymentType;
	      }, function (newValue) {
	        var isTotalRepayment = newValue && newValue === _constants.REPAYMENT_TYPES.TOTAL;
	        _this.setFormData(isTotalRepayment);
	        _this.setFormValidity();
	        _this.isTotalRepayment = newValue && newValue === _constants.REPAYMENT_TYPES.TOTAL;
	      });
	    }
	  }, {
	    key: 'setFormData',
	    value: function setFormData(isTotalRepayment) {
	      this.blocked = isTotalRepayment;
	
	      if (isTotalRepayment) {
	        this.previousAmount = this.repaymentAmount;
	        this.repaymentAmount = String(angular.copy(this.loan.amountPending)).replace(/\./g, ',');
	      } else {
	        this.repaymentAmount = String(this.previousAmount).replace(/\./g, ',');
	      }
	    }
	  }, {
	    key: 'setFormValidity',
	    value: function setFormValidity() {
	      this.convertedAmount = this.convertAmount(this.repaymentAmount);
	      this.errors.ltZero = this.convertedAmount < 0;
	      this.errors.zero = this.convertedAmount === 0;
	
	      this.errors.gtAmount = this.convertedAmount > this.loan.amountPending;
	
	      this.valid = !this.errors.ltZero && !this.errors.zero && !this.errors.gtAmount;
	
	      if (this.floatingActionButtons) {
	        this.floatingActionButtons[0].disabled = !this.valid;
	      }
	    }
	  }, {
	    key: 'convertAmount',
	    value: function convertAmount(amount) {
	      if (typeof amount === 'string') return parseFloat(parseFloat(amount.replace(/\,/g, '.')).toFixed(2));else return parseFloat(amount.toFixed(2));
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.convertedAmount = this.convertAmount(this.repaymentAmount);
	      this.onCreateRepayment(this.EventEmitter({
	        loan: this.loan,
	        repaymentAmount: this.convertedAmount
	      }));
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.state.go(_states.STATES.LOANS.MY_LOANS);
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.CONFIRM',
	        simulate: 'GLOBALS.BUTTON_ACTION.SIMULATE',
	        disabled: true
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }, {
	    key: 'isVivienda',
	    value: function isVivienda() {
	      return this.loan.modalityCode === _constants2.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.loan.modalityCode === _constants2.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN;
	    }
	  }]);
	  return LoansRepaymentFormController;
	}();
	
	exports.default = LoansRepaymentFormController;

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2047);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansRepaymentForm.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansRepaymentForm.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-repayment-form{display:block}loans-repayment-form .responsiveMobile .info-message{padding:30px 15px;width:100%;height:auto}loans-repayment-form .responsiveMobile .form{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;height:auto}loans-repayment-form .responsiveMobile .form .form-group{width:100%;margin-bottom:15px}loans-repayment-form .responsiveMobile .form .form-group input{width:100%}loans-repayment-form .responsiveMobile .form .form-group label{font-size:24px;text-transform:none}loans-repayment-form .responsiveMobile .form .form-group span{margin-top:0;font-size:22px}loans-repayment-form .responsiveMobile .mini-warning{font-size:16px;width:100%}loans-repayment-form .responsiveMobile .errors-container{margin-bottom:30px;width:100%;height:auto}loans-repayment-form .responsiveMobile .errors-container p{font-size:18px;text-align:left;white-space:normal}loans-repayment-form .info-message{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:557px;height:55px;border-radius:6px;border:1px solid #0072c9;padding:0 0 0 20px;margin-bottom:40px}loans-repayment-form .info-message .icon{color:#0072c9;font-size:35px;display:inline-block;margin-right:15px}loans-repayment-form .info-message .text{font-family:ArialMT;font-size:15px;text-align:left;color:#0072c9}loans-repayment-form .info-message-vivienda{border:1px solid #c8175e;margin-bottom:10px}loans-repayment-form .info-message-vivienda .icon,loans-repayment-form .info-message-vivienda .text{color:#c8175e}loans-repayment-form .info-message2{font-family:ArialMT;font-size:15px;margin-bottom:40px}loans-repayment-form .form{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;height:75px}loans-repayment-form .form .form-group{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;width:215px;margin-bottom:12px}loans-repayment-form .form .form-group input{width:150px}loans-repayment-form .form .form-group label{font-family:Stag Sans;font-weight:400;font-size:13px;text-align:left;color:#0072c9;text-transform:uppercase}loans-repayment-form .form .form-group span{font-family:Stag Sans;font-weight:400;font-size:13px;color:#666;display:inline-block;margin-top:9px}loans-repayment-form .errors-container{height:20px}loans-repayment-form .mini-warning{height:12px;font-family:ArialMT;font-size:15px;text-align:left;color:#666;display:inline-block;margin-bottom:50px}loans-repayment-form .buttons{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}loans-repayment-form .buttons button{width:160px;height:48px;line-height:55px}loans-repayment-form .buttons button:first-child{margin-right:30px}", ""]);
	
	// exports


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansRepaymentModal = __webpack_require__(2049);
	
	var _loansRepaymentModal2 = _interopRequireDefault(_loansRepaymentModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRepaymentModalModule = _angular2.default.module('loansRepaymentModal', []).component('loansRepaymentModal', _loansRepaymentModal2.default).name;
	
	exports.default = loansRepaymentModalModule;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansRepaymentModal = __webpack_require__(2050);
	
	var _loansRepaymentModal2 = _interopRequireDefault(_loansRepaymentModal);
	
	var _loansRepaymentModal3 = __webpack_require__(2051);
	
	var _loansRepaymentModal4 = _interopRequireDefault(_loansRepaymentModal3);
	
	__webpack_require__(2052);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRepaymentModalComponent = {
	  restrict: 'E',
	  bindings: {
	    success: '<',
	    error: '<',
	    errorMessage: '<',
	    isMobileApp: '<',
	    repaymentAmount: '<',
	    repaymentType: '<',
	    feePeriod: '<'
	  },
	  template: _loansRepaymentModal2.default,
	  controller: _loansRepaymentModal4.default
	};
	
	exports.default = loansRepaymentModalComponent;

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalLoansRepayment\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalLoansRepayment\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <successful-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.isSuccess()\"\n      description-big\n      close-modal=\"true\"\n      title=\"{{ 'LOANS.REPAYMENT.MODAL.SUCCESS.TITLE' | translate }}\"\n      repayment-message=\"$ctrl.repaymentDescription\">\n    </successful-action>\n\n    <failed-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.isError()\"\n      close-modal=\"true\"\n      title=\"{{ 'GLOBALS.ATTENTION' | translate }}\"\n      description=\"{{ $ctrl.errorMessage || ('LOANS.REPAYMENT.MODAL.ERROR.MESSAGE' | translate)}}\"\n      button-text=\"{{'GLOBALS.BUTTON_ACTION.OK_GOT_IT' | translate}}\">\n    </failed-action>\n\n  </div>\n</div>\n"

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	var _constants2 = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansRepaymentModalController = function () {
	  LoansRepaymentModalController.$inject = ["$translate", "$scope", "$filter"];
	  function LoansRepaymentModalController($translate, $scope, $filter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansRepaymentModalController);
	    this.scope = $scope;
	    this.translate = $translate;
	    this.currency = $filter('currency');
	  }
	
	  (0, _createClass3.default)(LoansRepaymentModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this._translateText();
	      this.scope.$watch(function () {
	        return _this.repaymentAmount;
	      }, function () {
	        _this.formatRepaymentDespription();
	      });
	      this.scope.$watch(function () {
	        return _this.repaymentType;
	      }, function () {
	        _this.formatRepaymentDespription();
	      });
	      this.scope.$watch(function () {
	        return _this.feePeriod;
	      }, function () {
	        _this.formatRepaymentDespription();
	      });
	    }
	  }, {
	    key: 'isSuccess',
	    value: function isSuccess() {
	      return this.success === true;
	    }
	  }, {
	    key: 'isError',
	    value: function isError() {
	      return this.error === true;
	    }
	  }, {
	    key: '_translateText',
	    value: function _translateText() {
	      var _this2 = this;
	
	      this.translate('LOANS.REPAYMENT.MODAL.SUCCESS.MSG_1').then(function (translation) {
	        _this2.textTranslationMsg1 = translation;
	
	        _this2.translate('LOANS.REPAYMENT.MODAL.SUCCESS.MSG_2').then(function (translation) {
	          _this2.textTranslationMsg2 = translation;
	        });
	
	        _this2.translate('LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.TOTAL').then(function (translation) {
	          _this2.successMessageTotal = translation;
	        });
	
	        _this2.translate('LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.FEE').then(function (translation) {
	          _this2.successMessageFee = translation;
	        });
	
	        _this2.translate('LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.PERIOD').then(function (translation) {
	          _this2.successMessagePeriod = translation;
	        });
	      });
	    }
	  }, {
	    key: 'getSuccesParcialMessage',
	    value: function getSuccesParcialMessage() {
	      if (!this.feePeriod) {
	        return 'LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.TOTAL';
	      }
	
	      if (this.feePeriod === _constants2.AMORTIZATION.FEE) {
	        return 'LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.FEE';
	      }
	
	      if (this.feePeriod === _constants2.AMORTIZATION.PERIOD) {
	        return 'LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.PERIOD';
	      }
	    }
	  }, {
	    key: 'setSuccesParcialMessage',
	    value: function setSuccesParcialMessage() {
	      if (!this.feePeriod) {
	        this.repaymentDescription = this.successMessage;
	      }
	
	      if (this.feePeriod === _constants2.AMORTIZATION.FEE) {
	        this.repaymentDescription = this.successMessageFee;
	      }
	
	      if (this.feePeriod === _constants2.AMORTIZATION.PERIOD) {
	        this.repaymentDescription = this.successMessagePeriod;
	      }
	    }
	  }, {
	    key: 'formatRepaymentDespription',
	    value: function formatRepaymentDespription() {
	      if (this.repaymentType === _constants.REPAYMENT_TYPES.TOTAL) {
	        var repaymentAmountFormatted = this.currency(this.repaymentAmount, '', 2);
	        this.repaymentDescription = this.textTranslationMsg1 + ' ' + repaymentAmountFormatted + ' ' + this.textTranslationMsg2;
	      } else {
	        this.setSuccesParcialMessage();
	      }
	    }
	  }]);
	  return LoansRepaymentModalController;
	}();
	
	exports.default = LoansRepaymentModalController;

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2053);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansRepaymentModal.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansRepaymentModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _loans = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansRepaymentService = function () {
	  LoansRepaymentService.$inject = ["$http"];
	  function LoansRepaymentService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansRepaymentService);
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(LoansRepaymentService, [{
	    key: 'createTotalRepayment',
	    value: function createTotalRepayment(repaymentParams) {
	      var repayment = {
	        loanId: repaymentParams.loanId,
	        identifying: parseInt(repaymentParams.loan.identifying, 10),
	        amount: repaymentParams.repaymentAmount,
	        capitalMovementTypeDate: repaymentParams.capitalMovementTypeDate
	      };
	
	      return this.http.post(_loans.ENDPOINTS_LOANS.post.createTotalRepayment(repaymentParams.employeeId), { amortizations: [repayment] });
	    }
	  }, {
	    key: 'createPartialRepayment',
	    value: function createPartialRepayment(repaymentParams, feePeriod) {
	      var repayment = {
	        loanId: repaymentParams.loanId,
	        identifying: parseInt(repaymentParams.loan.identifying, 10),
	        amount: repaymentParams.amount,
	        capitalMovementTypeDate: repaymentParams.capitalMovementTypeDate,
	        feePeriod: feePeriod
	      };
	
	      return this.http.post(_loans.ENDPOINTS_LOANS.post.createPartialRepayment(repaymentParams.employeeId), { amortizations: [repayment] });
	    }
	  }, {
	    key: 'simulateRepayment',
	    value: function simulateRepayment(repaymentParams, feePeriod) {
	      var repayment = {
	        loanId: repaymentParams.loanId,
	        identifying: parseInt(repaymentParams.loan.identifying, 10).toString(),
	        amount: repaymentParams.repaymentAmount,
	        capitalMovementTypeDate: repaymentParams.capitalMovementTypeDate,
	        feePeriod: feePeriod
	      };
	
	      return this.http.post(_loans.ENDPOINTS_LOANS.post.simulateRepayment(repaymentParams.employeeId), repayment);
	    }
	  }]);
	  return LoansRepaymentService;
	}();
	
	exports.default = LoansRepaymentService;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loansRepaymentSimulate = __webpack_require__(2056);
	
	var _loansRepaymentSimulate2 = _interopRequireDefault(_loansRepaymentSimulate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRepaymentSimulateModule = _angular2.default.module('loansRepaymentSimulate', [_angularUiRouter2.default]).component('loansRepaymentSimulate', _loansRepaymentSimulate2.default).name;
	
	exports.default = loansRepaymentSimulateModule;

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansRepaymentSimulate = __webpack_require__(2057);
	
	var _loansRepaymentSimulate2 = _interopRequireDefault(_loansRepaymentSimulate);
	
	var _loansRepaymentSimulate3 = __webpack_require__(2058);
	
	var _loansRepaymentSimulate4 = _interopRequireDefault(_loansRepaymentSimulate3);
	
	__webpack_require__(2059);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansRepaymentSimulateComponent = {
	  restrict: 'E',
	  bindings: {
	    loan: '<',
	    loansSimulation: '<',
	    repaymentParcial: '&',
	    isMobileApp: '<'
	  },
	  template: _loansRepaymentSimulate2.default,
	  controller: _loansRepaymentSimulate4.default
	};
	
	exports.default = loansRepaymentSimulateComponent;

/***/ }),
/* 2057 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd\" ng-class=\"$ctrl.getClasses()\">\n  <section class=\"flex-container\">\n    <div ng-repeat=\"loanSimulation in $ctrl.loansSimulation\" class=\"flex-item\" ng-if=\"$ctrl.showCard(loanSimulation)\">\n      <div class=\"title\">\n        <span class=\"icon-euro-hand\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span></span>\n        <h2>\n          {{ $ctrl.getTitle(loanSimulation) | translate }}\n        </h2>\n      </div>\n\n      <div class=\"wrapper-details\" ng-if=\"loanSimulation !== undefined\">\n        <div class=\"details\" ng-show=\"$ctrl.checkSimulationIsOkey(loanSimulation)\">\n\n          <!-- Amount -->\n          <card-simulation-more-info\n            loan-id=\"loanSimulation.id\"\n            title=\"{{ 'LOANS.REPAYMENT.SIMULATE.AMOUNT' | translate }}\"\n            icon-info-is-visible=\"$ctrl.showIconInfoOnAmount()\"\n            subtitle=\"{{ loanSimulation.amount | currency }}\"\n            is-mobile-app=\"$ctrl.isMobileApp\">\n          </card-simulation-more-info>\n          <hr>\n          <!-- Term-->\n            <card-simulation-more-info\n            loan-id=\"loanSimulation.id\"\n            ng-if=\"$ctrl.isPeriod(loanSimulation)\"\n            title=\"{{ 'LOANS.REPAYMENT.SIMULATE.CURRENT_PERIOD' | translate }}\"\n            subtitle=\"{{ $ctrl.formatBackendDateToDisplay(loanSimulation.currentDateExpired) }}\"\n            is-mobile-app=\"$ctrl.isMobileApp\">\n          </card-simulation-more-info>\n          <hr>\n\n          <card-simulation-more-info\n            loan-id=\"loanSimulation.id\"\n            ng-if=\"$ctrl.isPeriod(loanSimulation)\"\n            title=\"{{ 'LOANS.REPAYMENT.SIMULATE.NEW_PERIOD' | translate }}\"\n            subtitle=\"{{ $ctrl.formatBackendDateToDisplay(loanSimulation.newDateExpired) }}\"\n            is-mobile-app=\"$ctrl.isMobileApp\">\n          </card-simulation-more-info>\n          <hr>\n\n          <!-- Fee -->\n          <card-simulation-more-info\n            loan-id=\"loanSimulation.id\"\n            ng-if=\"$ctrl.isFee(loanSimulation)\"\n            title=\"{{ 'LOANS.REPAYMENT.SIMULATE.CURRENT_FEE' | translate }}\"\n            subtitle=\"{{ loanSimulation.currentFee | currency }}\"\n            is-mobile-app=\"$ctrl.isMobileApp\">\n        </card-simulation-more-info>\n        <hr>\n        <card-simulation-more-info\n          loan-id=\"loanSimulation.id\"\n          ng-if=\"$ctrl.isFee(loanSimulation)\"\n          title=\"{{ 'LOANS.REPAYMENT.SIMULATE.NEW_FEE' | translate }}\"\n          subtitle=\"{{ loanSimulation.newFee | currency }}\"\n          is-mobile-app=\"$ctrl.isMobileApp\">\n        </card-simulation-more-info>\n          <hr>\n        </div>\n      </div>\n\n      <div class=\"detail-error\" ng-show=\"!$ctrl.checkSimulationIsOkey(loanSimulation)\">\n        <div class=\"detail-error-header\">\n          <span class=\"icon-warning\"></span>\n          <h4 class=\"title-error\">{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.ATTENTION' | translate }}</h4>\n        </div>\n\n        <div class=\"detail-error-body\">\n          <p>{{ loanSimulation.status.message || ('LOANS.NEED_A_LOAN.CARD_SIMULATION.LOAN_NOT_AVAILABLE' | translate) }}</p>\n        </div>\n      </div>\n\n      <div class=\"buttons\">\n        <button\n          class=\"btn btn-app btn-primary\"\n          type=\"button\"\n          ng-click=\"$ctrl.createParcial(loanSimulation)\"\n          ng-show=\"$ctrl.checkSimulationIsOkey(loanSimulation)\">\n            {{ 'GLOBALS.BUTTON_ACTION.CONFIRM' | translate }}\n        </button>\n\n      </div>\n\n    </div>\n\n  </section>\n</div>"

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(1133);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constantsLoans = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansRepaymentSimulateController = function () {
	  LoansRepaymentSimulateController.$inject = ["EventEmitter", "$scope", "$state", "$window"];
	  function LoansRepaymentSimulateController(EventEmitter, $scope, $state, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansRepaymentSimulateController);
	    this.EventEmitter = EventEmitter;
	    this.scope = $scope;
	    this.state = $state;
	    this.window = $window;
	  }
	
	  (0, _createClass3.default)(LoansRepaymentSimulateController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.scope.$watch(function () {
	        return _this.loansSimulation;
	      }, function () {});
	    }
	  }, {
	    key: 'checkSimulationIsOkey',
	    value: function checkSimulationIsOkey(loanSimulation) {
	      if (loanSimulation === undefined) return;
	      return loanSimulation.status.code === _constantsLoans.LOANS.STATUS.OK;
	    }
	  }, {
	    key: 'createParcial',
	    value: function createParcial(loanSimulation) {
	      var feePeriod = this.isFee(loanSimulation) ? _constantsLoans.AMORTIZATION.FEE : _constantsLoans.AMORTIZATION.PERIOD;
	      this.repaymentParcial(this.EventEmitter({
	        feePeriod: feePeriod
	      }));
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle(loanSimulation) {
	      if (this.isFee(loanSimulation)) {
	        return 'LOANS.REPAYMENT.SIMULATE.TITLE_FEE';
	      }
	
	      if (this.isPeriod(loanSimulation)) {
	        return 'LOANS.REPAYMENT.SIMULATE.TITLE_PERIOD';
	      }
	    }
	  }, {
	    key: 'isFee',
	    value: function isFee(loanSimulation) {
	      return loanSimulation.newFee != null && loanSimulation.currentFee != null;
	    }
	  }, {
	    key: 'isPeriod',
	    value: function isPeriod(loanSimulation) {
	      return !!loanSimulation.currentDateExpired && !!loanSimulation.newDateExpired;
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        responsiveMobile: this.window.innerWidth < 1024,
	        'with-floating-action-buttons': this.window.innerWidth < 1024,
	        'simulate-padding': this.window.innerWidth < 1024
	      };
	    }
	  }, {
	    key: 'showCard',
	    value: function showCard(loanSimulation) {
	      return loanSimulation.loanId === _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || loanSimulation.loanId === _constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN || !!loanSimulation.currentDateExpired;
	    }
	  }, {
	    key: 'formatBackendDateToDisplay',
	    value: function formatBackendDateToDisplay(dateString) {
	      if (!dateString) return '';
	
	      var parts = String(dateString).trim().split('-');
	      if (parts.length !== 3) return String(dateString);
	
	      var _parts = (0, _slicedToArray3.default)(parts, 3),
	          year = _parts[0],
	          month = _parts[1],
	          day = _parts[2];
	
	      if (year.length !== 4 || month.length !== 2 || day.length !== 2) return String(dateString);
	
	      return day + '-' + month + '-' + year;
	    }
	  }]);
	  return LoansRepaymentSimulateController;
	}();
	
	exports.default = LoansRepaymentSimulateController;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2060);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansRepaymentSimulate.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansRepaymentSimulate.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-repayment-simulate{display:block}loans-repayment-simulate .container{min-height:708px}loans-repayment-simulate .container.mobile{min-height:100vh;padding:0}loans-repayment-simulate .responsiveMobile{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}loans-repayment-simulate .responsiveMobile .title-results{display:none}loans-repayment-simulate .responsiveMobile .flex-container{-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;-moz-justify-content:center;margin:80px 20px 20px;justify-content:center}loans-repayment-simulate .responsiveMobile .flex-container .flex-item{width:100%;height:auto;margin:0;margin-bottom:30px;padding-bottom:25px}loans-repayment-simulate .responsiveMobile .flex-container .flex-item:last-child{margin-right:auto}loans-repayment-simulate .responsiveMobile .flex-container .flex-item .title{padding:20px;min-height:0}loans-repayment-simulate .responsiveMobile .flex-container .flex-item .title .icon-euro-hand{font-size:40px}loans-repayment-simulate .responsiveMobile .flex-container .flex-item .title h2{font-size:18px}loans-repayment-simulate .responsiveMobile .flex-container .flex-item .buttons{margin:0 25px;height:auto}loans-repayment-simulate .responsiveMobile .flex-container .flex-item .buttons .btn{width:100%;margin:5px 0}loans-repayment-simulate .responsiveMobile .icon-warning{margin-bottom:30px}loans-repayment-simulate .simulate-padding{margin-top:-120px}loans-repayment-simulate .title-results{text-transform:uppercase;color:#0072c9;font-size:13px;font-weight:400}loans-repayment-simulate .flex-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-line-pack:start;align-content:flex-start;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:27px 0}loans-repayment-simulate .flex-container .flex-item{width:350px;height:auto;margin-right:45px;margin-bottom:45px;padding-bottom:20px;border-radius:3px;box-shadow:0 0 4px rgba(0,0,0,.24)}loans-repayment-simulate .flex-container .flex-item:last-child{margin-right:0}loans-repayment-simulate .flex-container .flex-item .title{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;padding:8px 22px 10px 20px;background-color:hsla(0,0%,97%,.75);border-bottom:1px solid #e9e9e9;min-height:105px}loans-repayment-simulate .flex-container .flex-item .title .icon-euro-hand{font-size:50px;margin-right:15px}loans-repayment-simulate .flex-container .flex-item .title h2{font-size:24px;display:inline-block;width:75%;font-weight:400;line-height:1.2;margin:0}loans-repayment-simulate .flex-container .flex-item .wrapper-details .details{padding-top:20px;padding-bottom:15px;min-height:250px}loans-repayment-simulate .flex-container .flex-item .wrapper-details .details hr{width:85%;margin:0 auto;color:#dddfe2}loans-repayment-simulate .flex-container .flex-item .detail-error{padding:0 20px;min-height:200px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}loans-repayment-simulate .flex-container .flex-item .detail-error-header{width:100%;text-align:center;border-bottom:1px solid #dddfe2}loans-repayment-simulate .flex-container .flex-item .detail-error-header .title-error{font-size:24px;color:#c8175e;text-transform:none}loans-repayment-simulate .flex-container .flex-item .detail-error-header .icon-warning{font-size:65px;margin-bottom:30px}loans-repayment-simulate .flex-container .flex-item .detail-error-header .icon-warning:before{color:#c8175e}loans-repayment-simulate .flex-container .flex-item .detail-error-body{max-width:230px;margin-top:30px;text-align:center}loans-repayment-simulate .flex-container .flex-item .detail-error-body p{font-size:15px;color:#666}loans-repayment-simulate .flex-container .flex-item .buttons{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}loans-repayment-simulate .flex-container .flex-item .buttons button{width:160px;height:48px;line-height:55px}loans-repayment-simulate .flex-container .flex-item .buttons button:first-child{margin-right:30px}loans-repayment-simulate .flex-container .flex-item .buttons .btn{width:300px;margin:5px 0;font-size:12px;height:40px;line-height:40px}loans-repayment-simulate__empty{text-align:center;color:#0072c9;margin-top:15px}loans-repayment-simulate__empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _menuFamilyNeedALoan = __webpack_require__(2062);
	
	var _menuFamilyNeedALoan2 = _interopRequireDefault(_menuFamilyNeedALoan);
	
	var _menuOptionsFamily = __webpack_require__(2069);
	
	var _menuOptionsFamily2 = _interopRequireDefault(_menuOptionsFamily);
	
	var _requestCardSimulationFamily = __webpack_require__(2075);
	
	var _requestCardSimulationFamily2 = _interopRequireDefault(_requestCardSimulationFamily);
	
	var _needALoanFamilySelect = __webpack_require__(2087);
	
	var _needALoanFamilySelect2 = _interopRequireDefault(_needALoanFamilySelect);
	
	var _needALoanModal = __webpack_require__(2093);
	
	var _needALoanModal2 = _interopRequireDefault(_needALoanModal);
	
	var _needALoan = __webpack_require__(2099);
	
	var _needALoan2 = _interopRequireDefault(_needALoan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var needALoanModule = _angular2.default.module('needALoan', [_angularUiRouter2.default, _menuFamilyNeedALoan2.default, _menuOptionsFamily2.default, _requestCardSimulationFamily2.default, _needALoanFamilySelect2.default, _needALoanModal2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.NEED_A_LOAN, {
	    url: _routes.ROUTES.LOANS.NEED_A_LOAN,
	    component: 'needALoan',
	    params: {
	      snapshot: null
	    },
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      serviceClosed: ["StatusAppCheckers", function serviceClosed(StatusAppCheckers) {
	        return StatusAppCheckers.isServiceClosed();
	      }]
	    }
	  });
	}]).component('needALoan', _needALoan2.default).name;
	
	exports.default = needALoanModule;

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _menuFamilyNeedALoan = __webpack_require__(2063);
	
	var _menuFamilyNeedALoan2 = _interopRequireDefault(_menuFamilyNeedALoan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuFamilyNeedALoanModule = _angular2.default.module('menuFamilyNeedALoan', []).component('menuFamilyNeedALoan', _menuFamilyNeedALoan2.default).name;
	
	exports.default = menuFamilyNeedALoanModule;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _menuFamilyNeedALoan = __webpack_require__(2064);
	
	var _menuFamilyNeedALoan2 = _interopRequireDefault(_menuFamilyNeedALoan);
	
	var _menuFamilyNeedALoan3 = __webpack_require__(2065);
	
	var _menuFamilyNeedALoan4 = _interopRequireDefault(_menuFamilyNeedALoan3);
	
	__webpack_require__(2066);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuFamilyNeedALoanComponent = {
	  restrict: 'E',
	  bindings: {
	    onGetSimulationFamilies: '&',
	    families: '<',
	    simulation: '<',
	    selectFamily: '&',
	    itemSelected: '<',
	    selectedOptionFamily: '<',
	    onSelectOptionFamily: '&',
	    setSimulation: '&',
	    optionFamilySelected: '<',
	    getCodeLoan: '&',
	    isMobileApp: '<',
	    familiesMobile: '<',
	    codeOptionSelected: '<',
	    optionsFamiliesToSelect: '<',
	    housingWitness: '<',
	    simulationWitness: '<'
	  },
	  template: _menuFamilyNeedALoan2.default,
	  controller: _menuFamilyNeedALoan4.default
	};
	
	exports.default = menuFamilyNeedALoanComponent;

/***/ }),
/* 2064 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex-container\" ng-if=\"!$ctrl.isMobileApp\">\n  <div\n    class=\"flex-item\"\n    ng-click=\"$ctrl.selectFamily({$event: {fam: 'home'}})\"\n    ng-class=\"{'family-selected': $ctrl.itemSelected === 'home'}\">\n    <span class=\"icon icon-house\"></span>\n    <p>{{ $ctrl.families['home'].literal}}</p>\n  </div>\n\n  <div\n    class=\"flex-item\"\n    ng-click=\"$ctrl.selectFamily({$event: {fam: 'car'}})\"\n    ng-class=\"{'family-selected': $ctrl.itemSelected === 'car'}\">\n    <span class=\"icon icon-car\"></span>\n    <p>{{ $ctrl.families['car'].literal}}</p>\n  </div>\n\n  <div\n    class=\"flex-item\"\n    ng-click=\"$ctrl.selectFamily({$event: {fam: 'family'}})\"\n    ng-class=\"{'family-selected': $ctrl.itemSelected === 'family'}\">\n    <span class=\"icon icon-family\"></span>\n    <p>{{ $ctrl.families['family'].literal}}</p>\n  </div>\n\n   <div\n    class=\"flex-item sustainability-center\"\n    ng-click=\"$ctrl.selectFamily({$event: {fam: 'sustainability'}})\"\n    ng-class=\"{'family-selected': $ctrl.itemSelected === 'sustainability'}\">\n    <div class=\"sustainability-photo\"></div>\n   <p>{{ $ctrl.families['sustainability'].literal}}</p>\n  </div>\n\n  <div\n    class=\"flex-item\"\n    ng-click=\"$ctrl.selectFamily({$event: {fam: 'education'}})\"\n    ng-class=\"{'family-selected': $ctrl.itemSelected === 'education'}\">\n    <span class=\"icon icon-education\"></span>\n    <p>{{ $ctrl.families['education'].literal}}</p>\n  </div>\n\n  <div\n    class=\"flex-item\"\n    ng-click=\"$ctrl.selectFamily({$event: {fam: 'taxes'}})\"\n    ng-class=\"{'family-selected': $ctrl.itemSelected === 'taxes'}\">\n    <span class=\"icon icon-euro-ticket\"><span class=\"path1\"></span><span class=\"path2\"></span></span>\n    <p>{{ $ctrl.families['taxes'].literal}}</p>\n  </div>\n\n</div>\n<div class=\"families-responsiveMobile\" ng-if=\"$ctrl.isMobileApp\">\n  <select-app\n    name=\"familiesLoans\"\n    class=\"\"\n    required=\"true\"\n    options=\"$ctrl.familiesMobile\"\n    placeholder=\"{{ 'LOANS.NEED_A_LOAN.CATEGORY' | translate }}\"\n    initial-value=\"$ctrl.initialFam\"\n    on-select=\"$ctrl.onSelectFamily($event)\">\n  </select-app>\n  <select-app\n    ng-if=\"$ctrl.isMobileApp\"\n    name=\"optionsFamiliesLoans\"\n    required=\"true\"\n    options=\"$ctrl.optionsFamiliesToSelect\"\n    placeholder=\"{{ 'LOANS.NEED_A_LOAN.PURPOSE' | translate }}\"\n    initial-value=\"$ctrl.initialCateg\"\n    on-select=\"$ctrl.onSelectCategoryFamily($event)\"\n    disabled=\"$ctrl.isFamilySelected()\">\n  </select-app>\n</div>\n<menu-options-family\n  ng-if=\"$ctrl.showOptionsFamily()\"\n  ng-class=\"$ctrl.shouldRemoveBorderBottom()\"\n  family-details=\"$ctrl.families[$ctrl.itemSelected]\"\n  on-select-option-family=\"$ctrl.onSelectOptionFamily({$event: $event})\"\n  option-family-selected=\"$ctrl.optionFamilySelected\"></menu-options-family>\n\n  <loans-sign-up-form-simulation-housing-change-warning\n  ng-class=\"{'mobile': $ctrl.isMobileApp}\"\n  ng-if=\"$ctrl.shouldShowMessageWarning() || $ctrl.shouldShowCreditCapacitySimulation()\"\n  simulation-witness=\"$ctrl.simulationWitness\">\n</loans-sign-up-form-simulation-housing-change-warning>\n\n<div class=\"table-container\" ng-if=\"$ctrl.shouldShowCreditCapacitySimulation()\">\n  <h2 class=\"table-title\">{{ 'LOANS.NEED_A_LOAN.SIMULATION_CREDIT_CAPACITY' | translate }}</h2>\n  <table-app class=\"table\" data=\"$ctrl.data.tableData\"></table-app>\n</div>\n\n<loans-amount-simulation\n  is-mobile-app=\"$ctrl.isMobileApp\"\n  ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n  ng-if=\"$ctrl.selectedOptionFamily\"\n  housing-loan=\"$ctrl.getCodeLoan()\"\n  simulation=\"$ctrl.simulation\"\n  on-submit=\"$ctrl.setSimulation({$event: $event})\"\n  housing-change=\"$ctrl.housingWitness\"\n  simulation-witness=\"$ctrl.simulationWitness\"\n  code-option-selected=\"$ctrl.codeOptionSelected\"\n  initial-charges=\"$ctrl.initialCharges\"\n  should-show-credit-capacity-simulation=\"$ctrl.shouldShowCreditCapacitySimulation()\"\n  is-housing-mandatory-purpose=\"$ctrl.isHousingMandatoryPurpose()\">\n</loans-amount-simulation>\n"

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constantsLoans = __webpack_require__(1774);
	
	var _menuFamilyNeedALoan = __webpack_require__(1893);
	
	var _menuFamilyNeedALoan2 = _interopRequireDefault(_menuFamilyNeedALoan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuFamilyNeedALoanController = function () {
	  MenuFamilyNeedALoanController.$inject = ["$scope", "$log", "LoansUserDataService", "LoansOperationsService", "loadingMobileService", "myLoansService"];
	  function MenuFamilyNeedALoanController($scope, $log, LoansUserDataService, LoansOperationsService, loadingMobileService, myLoansService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MenuFamilyNeedALoanController);
	    this.scope = $scope;
	    this.log = $log;
	    this.loansUserDataService = LoansUserDataService;
	    this.loansOperationsService = LoansOperationsService;
	    this.loadingMobileService = loadingMobileService;
	    this.myLoansService = myLoansService;
	    this.simulationWitness = false;
	    this.data = null;
	    this.loaded = false;
	    this.userId = this.loansUserDataService._employee.userId;
	    this.initialCharges = 0;
	  }
	
	  (0, _createClass3.default)(MenuFamilyNeedALoanController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.scope.$watch(function () {
	        return _this.itemSelected;
	      }, function (item) {
	        return _this.getInitialFam(item);
	      });
	      this.scope.$watch(function () {
	        return _this.optionFamilySelected;
	      }, function (item) {
	        return _this.getInitialCateg(item);
	      });
	
	      this.loadingMobileService.show();
	      this.loansOperationsService.getCreditworthiness(this.userId).then(function (creditworthiness) {
	        _this.simulationWitness = creditworthiness.simulationWitness;
	        var creditworthinessPayload = {
	          raw: creditworthiness,
	          simulatedLimits: [creditworthiness.socialHousingLoanSimulated, creditworthiness.socialHousingLoanFixedSimulated, creditworthiness.agreementHousingLoanSimulated, creditworthiness.agreementHousingLoanFixedSimulated]
	        };
	        _this.data = new _menuFamilyNeedALoan2.default(creditworthinessPayload).format();
	        _this.loaded = true;
	      }).catch(function (err) {
	        _this.log.error('Error en getCreditworthiness:', err);
	      }).finally(function () {
	        _this.loadingMobileService.hide();
	      });
	
	      this.loadInitialCharges();
	    }
	  }, {
	    key: 'loadInitialCharges',
	    value: function loadInitialCharges() {
	      var _this2 = this;
	
	      var employeeId = this.loansUserDataService._employee.userId;
	      this.myLoansService.getMyLoans(employeeId).then(function (loansList) {
	        var loan = loansList.find(function (l) {
	          return (l.modalityCode === 'SV' || l.modalityCode === 'CV') && l.amortizable === true;
	        });
	        _this2.initialCharges = loan ? loan.amountPending : 0;
	      }).catch(function (err) {
	        _this2.log.error('Error fetching myLoans:', err);
	      });
	    }
	  }, {
	    key: 'onSelectFamily',
	    value: function onSelectFamily($event) {
	      this.optionsFamiliesToSelect = [];
	      this.selectFamily({ $event: { fam: $event.$item.value } });
	    }
	  }, {
	    key: 'onSelectCategoryFamily',
	    value: function onSelectCategoryFamily($event) {
	      this.onSelectOptionFamily({
	        $event: {
	          codeOptionSelected: $event.$item.value,
	          codeLoanSimulation: '' + $event.$item.value + this.families[this.itemSelected].code
	        }
	      });
	    }
	  }, {
	    key: 'showOptionsFamily',
	    value: function showOptionsFamily() {
	      if (this.isMobileApp) return false;
	      return this.itemSelected !== undefined && this.itemSelected !== null;
	    }
	  }, {
	    key: 'getInitialFam',
	    value: function getInitialFam(item) {
	      if (!this.isMobileApp || item === undefined) return;
	      this.initialFam = this.familiesMobile.filter(function (fam) {
	        return fam.value === item;
	      });
	      this.initialFam = this.initialFam[0];
	    }
	  }, {
	    key: 'isFamilySelected',
	    value: function isFamilySelected() {
	      var isOptionSelected = this.codeOptionSelected === undefined || this.codeOptionSelected === null;
	      return this.optionsFamiliesToSelect === undefined && isOptionSelected;
	    }
	  }, {
	    key: 'getInitialCateg',
	    value: function getInitialCateg(item) {
	      if (!this.isMobileApp || item === undefined) return;
	      this.initialCateg = this.getCategorySelected();
	    }
	  }, {
	    key: 'getCategorySelected',
	    value: function getCategorySelected() {
	      var _this3 = this;
	
	      var purposesCategory = this.families[this.itemSelected].purposes;
	      var categorySelected = purposesCategory.find(function (item) {
	        if (item.purposeCode === _this3.codeOptionSelected) {
	          return item;
	        }
	      });
	
	      if (!categorySelected) return;
	      return {
	        value: categorySelected.purposeCode,
	        option: categorySelected.purposeLiteral
	      };
	    }
	  }, {
	    key: 'shouldShowMessageWarning',
	    value: function shouldShowMessageWarning() {
	      return this.housingWitness && !this.simulationWitness && this.codeOptionSelected == _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
	    }
	  }, {
	    key: 'shouldShowCreditCapacitySimulation',
	    value: function shouldShowCreditCapacitySimulation() {
	      return this.simulationWitness && this.codeOptionSelected == _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
	    }
	  }, {
	    key: 'isHousingMandatoryPurpose',
	    value: function isHousingMandatoryPurpose() {
	      return this.codeOptionSelected == _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
	    }
	  }, {
	    key: 'shouldRemoveBorderBottom',
	    value: function shouldRemoveBorderBottom() {
	      return { 'remove-border': this.selectedOptionFamily && this.codeOptionSelected != _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE };
	    }
	  }]);
	  return MenuFamilyNeedALoanController;
	}();
	
	exports.default = MenuFamilyNeedALoanController;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2067);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./menuFamilyNeedALoan.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./menuFamilyNeedALoan.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "menu-family-need-a-loan .flex-container{margin-top:20px;display:flex}menu-family-need-a-loan .flex-item{border:1px solid #dddfe2;padding:17px;padding-top:27px;width:20%;text-align:center;cursor:pointer;border-right:0}menu-family-need-a-loan .flex-item:last-child{border-right:1px solid #dddfe2}menu-family-need-a-loan .flex-item .icon{font-size:35px}menu-family-need-a-loan .flex-item p{text-transform:uppercase;color:#0072c9;padding-top:10px;font-size:13px}menu-family-need-a-loan .families-responsiveMobile{margin-top:15px;margin-bottom:20px}menu-family-need-a-loan .families-responsiveMobile select-app:first-child{margin-bottom:20px}menu-family-need-a-loan .family-selected{background-color:#fbfbfb;border-bottom:0}menu-family-need-a-loan .remove-border>.menu-options{border-bottom:0}menu-family-need-a-loan .sustainability-photo{background-image:url(" + __webpack_require__(2068) + ");background-size:40px 40px;width:40px;height:40px}menu-family-need-a-loan .sustainability-center{display:flex;align-items:center;flex-direction:column}menu-family-need-a-loan .table{border:1px solid #dddfe2!important}menu-family-need-a-loan .table-responsive{border-bottom:none!important}menu-family-need-a-loan .table-container{width:100%;padding-bottom:20px}@media(min-width:1021px){menu-family-need-a-loan .table-container{max-width:660px}}menu-family-need-a-loan th{padding:10px!important;text-align:center!important}menu-family-need-a-loan .table-title{font-size:24px;color:#fff;background-color:#227aba;text-align:center;padding:10px;width:100%;margin-bottom:0}menu-family-need-a-loan table-app{width:100%}menu-family-need-a-loan td{text-align:center!important}menu-family-need-a-loan .table tbody tr:last-child td{padding-bottom:20px!important}@media(max-width:1020px){menu-family-need-a-loan .table{width:100%;border-top:1px solid #dddfe2}menu-family-need-a-loan .table thead{display:none}menu-family-need-a-loan .table tbody tr{display:block}menu-family-need-a-loan .table tbody tr:not(:last-of-type){margin-bottom:15px!important;border-bottom:1px solid #dddfe2!important;padding-bottom:15px!important}menu-family-need-a-loan .table tbody tr:last-of-type{margin-bottom:0!important}menu-family-need-a-loan .table tbody tr:last-of-type,menu-family-need-a-loan .table tbody tr:last-of-type td{border-bottom:none!important;padding-bottom:0!important}menu-family-need-a-loan .table tbody td{display:block;width:100%;text-align:left;padding:10px 0!important}menu-family-need-a-loan .table tbody td:before{content:attr(data-label);font-weight:700;display:block;color:#227aba;margin-bottom:4px;font-size:16px;text-transform:uppercase;letter-spacing:.5px}}", ""]);
	
	// exports


/***/ }),
/* 2068 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _menuOptionsFamily = __webpack_require__(2070);
	
	var _menuOptionsFamily2 = _interopRequireDefault(_menuOptionsFamily);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuOptionsFamilyModule = _angular2.default.module('menuOptionsFamily', [_angularUiRouter2.default]).component('menuOptionsFamily', _menuOptionsFamily2.default).name;
	
	exports.default = menuOptionsFamilyModule;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _menuOptionsFamily = __webpack_require__(2071);
	
	var _menuOptionsFamily2 = _interopRequireDefault(_menuOptionsFamily);
	
	var _menuOptionsFamily3 = __webpack_require__(2072);
	
	var _menuOptionsFamily4 = _interopRequireDefault(_menuOptionsFamily3);
	
	__webpack_require__(2073);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuOptionsFamilyComponent = {
	  restrict: 'E',
	  bindings: {
	    familyDetails: '<',
	    onSelectOptionFamily: '&',
	    optionFamilySelected: '<',
	    simulationWitness: '<'
	  },
	  template: _menuOptionsFamily2.default,
	  controller: _menuOptionsFamily4.default
	};
	
	exports.default = menuOptionsFamilyComponent;

/***/ }),
/* 2071 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"menu-options\">\n  <div class=\"fee-radios\">\n    <div class=\"radio\">\n      <div class=\"single-radio\" ng-repeat=\"purposes in $ctrl.familyDetails.purposes\">\n\n        <input\n          type=\"radio\"\n          id=\"{{ purposes.purposeCode }}{{ $ctrl.familyDetails.code }}\"\n          ng-model=\"$ctrl.purposeCode\"\n          value=\"{{ purposes.purposeCode}}{{ $ctrl.familyDetails.code }}\">\n\n        <label\n          class=\"uppercase medium blue\"\n          ng-click=\"$ctrl.createCodeSimulation({data: {purposesCode: purposes.purposeCode, familyCode: $ctrl.familyDetails.code}})\"\n          for=\"{{ purposes.purposeCode}}{{ $ctrl.familyDetails.code }}\">\n          {{ purposes.purposeLiteral }}\n        </label>\n\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuOptionsFamilyController = function () {
	  MenuOptionsFamilyController.$inject = ["$scope", "EventEmitter"];
	  function MenuOptionsFamilyController($scope, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MenuOptionsFamilyController);
	    this.scope = $scope;
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(MenuOptionsFamilyController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.onChange();
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange() {
	      var _this = this;
	
	      this.scope.$watch(function () {
	        return _this.optionFamilySelected;
	      }, function (newValue) {
	        _this.purposeCode = newValue;
	      });
	    }
	  }, {
	    key: 'createCodeSimulation',
	    value: function createCodeSimulation(_ref) {
	      var data = _ref.data;
	
	      var codeSimulation = '' + data.purposesCode + data.familyCode;
	      var dataSentEvent = {
	        codeLoanSimulation: codeSimulation,
	        codeOptionSelected: data.purposesCode
	      };
	      this.onSelectOptionFamily(this.EventEmitter(dataSentEvent));
	    }
	  }]);
	  return MenuOptionsFamilyController;
	}();
	
	exports.default = MenuOptionsFamilyController;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2074);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./menuOptionsFamily.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./menuOptionsFamily.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "menu-options-family .menu-options{background-color:#fbfbfb;border-left:1px solid #dddfe2;border-bottom:1px solid #dddfe2;border-right:1px solid #dddfe2}menu-options-family .menu-options .fee-radios .radio{-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;flex-wrap:wrap;margin:0;padding:15px}menu-options-family .menu-options .fee-radios .radio .single-radio{background-color:#fff;border:1px solid #dddfe2;padding:8px;border-radius:4px;margin-right:10px;margin-bottom:10px}menu-options-family .menu-options .fee-radios .radio .single-radio label{color:#666}", ""]);
	
	// exports


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _states = __webpack_require__(565);
	
	var _routes = __webpack_require__(1040);
	
	var _requestCardSimulationFamily = __webpack_require__(2076);
	
	var _requestCardSimulationFamily2 = _interopRequireDefault(_requestCardSimulationFamily);
	
	var _cardSimulationMoreInfo = __webpack_require__(2081);
	
	var _cardSimulationMoreInfo2 = _interopRequireDefault(_cardSimulationMoreInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestCardSimulationFamilyModule = _angular2.default.module('requestCardSimulationFamily', [_angularUiRouter2.default, _cardSimulationMoreInfo2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.NEED_A_LOAN_RESULTS, {
	    url: _routes.ROUTES.LOANS.NEED_A_LOAN_RESULTS,
	    component: 'requestCardSimulationFamily',
	    params: {
	      snapshot: null
	    },
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).component('requestCardSimulationFamily', _requestCardSimulationFamily2.default).name;
	
	exports.default = requestCardSimulationFamilyModule;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestCardSimulationFamily = __webpack_require__(2077);
	
	var _requestCardSimulationFamily2 = _interopRequireDefault(_requestCardSimulationFamily);
	
	var _requestCardSimulationFamily3 = __webpack_require__(2078);
	
	var _requestCardSimulationFamily4 = _interopRequireDefault(_requestCardSimulationFamily3);
	
	__webpack_require__(2079);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestCardSimulationFamilyComponent = {
	  restrict: 'E',
	  bindings: {
	    loanSimulation: '<',
	    onSelectLoan: '&',
	    scrollToResults: '&',
	    onModifyLoan: '&',
	    itemSelected: '<',
	    codeLoanSimulation: '<',
	    family: '<',
	    codeOption: '<',
	    myCreditworthiness: '<',
	    dataSimulation: '<',
	    housingWitness: '<',
	    simulationWitness: '<'
	  },
	  template: _requestCardSimulationFamily2.default,
	  controller: _requestCardSimulationFamily4.default
	};
	
	exports.default = requestCardSimulationFamilyComponent;

/***/ }),
/* 2077 */
/***/ (function(module, exports) {

	module.exports = "<need-a-loan-modal\n  cannot-sign-up-error=\"$ctrl.cannotSignUpError\"\n  message-error=\"$ctrl.errorMessage\"\n  on-dismiss=\"$ctrl.goMyLoans()\"\n  is-mobile-app=\"$ctrl.isMobileApp\">\n</need-a-loan-modal>\n\n<section id=\"request-card-simulation\" class=\"request-card-simulation\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <h4 class=\"title-results\">\n    {{ 'LOANS.NEED_A_LOAN.RESULTS' | translate }}\n  </h4>\n\n  <section class=\"flex-container\" ng-if=\"$ctrl.checkLoanSimulationRequest()\">\n    <div ng-if=\"!(loanSimulation.loanId == 'AD' && loanSimulation.loanPurposeId == '09')\" ng-repeat=\"loanSimulation in $ctrl.loanSimulationRequest\" class=\"flex-item\">\n      <div class=\"title\">\n        <span class=\"icon-euro-hand\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span></span>\n        <h2>\n          {{ loanSimulation.newTitle | translate }}\n        </h2>\n      </div>\n\n      <div class=\"wrapper-details\" ng-if=\"loanSimulation !== undefined\">\n        <div class=\"details\" ng-show=\"$ctrl.checkSimulationIsOkey(loanSimulation)\">\n\n          <!-- Amount -->\n          <card-simulation-more-info\n            loan-id=\"loanSimulation.id\"\n            title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.AMOUNT' | translate }}\"\n            icon-info-is-visible=\"$ctrl.showIconInfoOnAmount()\"\n            subtitle=\"{{ loanSimulation.amount | currency }}\"\n            is-mobile-app=\"$ctrl.isMobileApp\">\n          </card-simulation-more-info>\n          <hr>\n\n          <!-- Interests -->\n          <card-simulation-more-info\n            loan-id=\"loanSimulation.id\"\n            title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.TAXES' | translate }}\"\n            icon-info-is-visible=\"$ctrl.showIconInfoOnInterests(loanSimulation.id)\"\n            subtitle=\"{{ loanSimulation.interestRates | currency: '%' :3 }}\"\n            is-mobile-app=\"$ctrl.isMobileApp\">\n\n            <div ng-if=\"loanSimulation.typeFixedVariable === null || loanSimulation.typeFixedVariable === '0'\">\n              <div ng-if=\"$ctrl.showLoanCV(loanSimulation.id)\">\n                <p>\n                  {{ 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3' | translate }}\n                </p>\n              </div>\n\n              <div ng-if=\"$ctrl.showLoanDA(loanSimulation.id)\">\n                <p>\n                  {{ 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG3' | translate }}\n                </p>\n              </div>\n\n              <div ng-if=\"$ctrl.showLoanVC(loanSimulation.id)\">\n                <p>\n                  {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG3' | translate }}\n                </p>\n              </div>\n\n              <div ng-if=\"$ctrl.showLoanSV(loanSimulation.id)\">\n                <p>\n                  {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4' | translate }}\n                </p>\n                <ul>\n                  <li>\n                    {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_TEXT' | translate }}\n                  </li>\n                  <li>\n                    {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_1' | translate }}\n                    ({{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_2' | translate }}) /\n                    {{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_3' | translate }}\n                  </li>\n                </ul>\n              </div>\n\n              <div ng-if=\"$ctrl.showLoan9S(loanSimulation.id)\">\n                <p>\n                  {{ 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG3' | translate }}\n                </p>\n              </div>\n\n              <div ng-if=\"$ctrl.showLoan5S(loanSimulation.id)\">\n                <p>\n                  {{ 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG3' | translate }}\n                </p>\n              </div>\n            </div>\n            <div ng-if=\"loanSimulation.typeFixedVariable === null || loanSimulation.typeFixedVariable === '0'\">\n              {{ 'LOANS.LOANS_FILTERS.TEXT.FIXED_RATE' | translate }}\n            </div>\n          </card-simulation-more-info>\n          <hr>\n\n          <!-- Basic characteristics -->\n          <card-simulation-more-info\n            loan-id=\"loanSimulation.id\"\n            title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.TERM' | translate }}\"\n            icon-info-is-visible=\"$ctrl.showIconInfoOnDeadline()\"\n            subtitle=\"{{ loanSimulation.deadline }} {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.MONTH' | translate }}\"\n            is-mobile-app=\"$ctrl.isMobileApp\">\n\n            <div ng-if=\"$ctrl.showLoanCV(loanSimulation.id)\">\n              <p>{{ 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG2' | translate }}</p>\n            </div>\n\n            <div ng-if=\"$ctrl.showLoanDA(loanSimulation.id)\">\n              <p>{{ 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG2' | translate }}</p>\n            </div>\n\n            <div ng-if=\"$ctrl.showLoanVC(loanSimulation.id)\">\n              <p>{{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG2' | translate }}</p>\n            </div>\n\n            <div ng-if=\"$ctrl.showLoanSV(loanSimulation.id)\">\n              <p>{{ 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG3' | translate }}</p>\n            </div>\n\n            <div ng-if=\"$ctrl.showLoan9S(loanSimulation.id)\">\n              <p>{{ 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG2' | translate }}</p>\n            </div>\n\n            <div ng-if=\"$ctrl.showLoan5S(loanSimulation.id)\">\n              <p>{{ 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG2' | translate }}</p>\n            </div>\n          </card-simulation-more-info>\n          <hr>\n\n          <!-- Insurance -->\n          <card-simulation-more-info\n            loan-id=\"loanSimulation.id\"\n            title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.INSURANCE' | translate }}\"\n            icon-info-is-visible=\"$ctrl.showIconInfoOnInsurance(loanSimulation)\"\n            insurance=\"loanSimulation.wantInsurance\"\n            is-mobile-app=\"$ctrl.isMobileApp\">\n            <p ng-if=\"!$ctrl.isSocialAgreement(loanSimulation.id)\">\n              {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.INSURANCE_1' | translate }}\n              {{ loanSimulation.annualTerm | currency}} .\n              {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.INSURANCE_2' | translate }}\n            </p>\n            <p ng-if=\"$ctrl.isSocialAgreement(loanSimulation.id)\">\n              {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.INSURANCE_1' | translate }}\n              {{ loanSimulation.annualTerm | currency}} .\n              {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.INSURANCE_3' | translate }}\n            </p>\n          </card-simulation-more-info>\n          <hr>\n\n          <!-- Sale Price -->\n          <card-simulation-more-info\n            ng-if=\"$ctrl.showSalePrice(loanSimulation)\"\n            loan-id=\"loanSimulation.id\"\n            title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.SALE_PRICE' | translate }}\"\n            subtitle=\"{{ $ctrl.simulation.salePrice | currency }}\"\n            is-mobile-app=\"$ctrl.isMobileApp\">\n          </card-simulation-more-info>\n          <hr>\n\n          <!-- Monthly amount -->\n          <card-simulation-more-info\n            loan-id=\"loanSimulation.id\"\n            title=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.MONTHLY_FEE' | translate }}\"\n            icon-info-is-visible=\"$ctrl.isFiveOrNineMonth(loanSimulation.id)\"\n            subtitle=\"{{ loanSimulation.monthlyAmount | currency }}\"\n            is-mobile-app=\"$ctrl.isMobileApp\">\n            <p>\n              {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.MIN_FEE' | translate }}\n              {{ 'LOANS.LOANS_DETAIL.MINIMUM_FEE_DESC_2' | translate }}\n            </p>\n          </card-simulation-more-info>\n        </div>\n      </div>\n\n      <div class=\"detail-error\" ng-show=\"!$ctrl.checkSimulationIsOkey(loanSimulation)\">\n        <div class=\"detail-error-header\">\n          <span class=\"icon-warning\"></span>\n          <h4 class=\"title-error\">{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.ATTENTION' | translate }}</h4>\n        </div>\n\n        <div class=\"detail-error-body\">\n          <p>{{ loanSimulation.status.message || ('LOANS.NEED_A_LOAN.CARD_SIMULATION.LOAN_NOT_AVAILABLE' | translate) }}</p>\n        </div>\n      </div>\n\n      <div class=\"buttons\">\n        <button\n          class=\"btn btn-app btn-default\"\n          type=\"button\"\n          ng-click=\"$ctrl.openDetail(loanSimulation)\">\n            {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.SHOW_PRODUCT' | translate }}\n        </button>\n        <button\n          ng-if=\"!$ctrl.selectButtonShouldAppear()\"\n          class=\"btn btn-app btn-primary\"\n          type=\"button\"\n          ng-click=\"$ctrl.selectLoan(loanSimulation, false)\"\n          ng-show=\"$ctrl.checkSimulationIsOkey(loanSimulation)\">\n            {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.SELECT' | translate }}\n        </button>\n        <button\n          class=\"btn btn-app btn-primary\"\n          type=\"button\"\n          ng-click=\"$ctrl.modifyLoan()\"\n          ng-show=\"!$ctrl.checkSimulationIsOkey(loanSimulation)\">\n            {{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.MODIFY' | translate }}\n        </button>\n      </div>\n\n    </div>\n  </section>\n\n  <div class=\"request-card-simulation__empty\" ng-if=\"!$ctrl.checkLoanSimulationRequest()\">\n    <span class=\"icon-warning\"></span>\n    <span>{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.ERROR' | translate }}</span>\n  </div>\n</section>\n"

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	var _constants2 = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestCardSimulationFamilyController = function () {
	  RequestCardSimulationFamilyController.$inject = ["EventEmitter", "$stateParams", "$rootScope", "$state", "$window", "LoansNeedALoanService"];
	  function RequestCardSimulationFamilyController(EventEmitter, $stateParams, $rootScope, $state, $window, LoansNeedALoanService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, RequestCardSimulationFamilyController);
	    this.eventEmitter = EventEmitter;
	    this.stateParams = $stateParams;
	    this.rootScope = $rootScope;
	    this.state = $state;
	    this.window = $window;
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.loansNeedALoanService = LoansNeedALoanService;
	    this.snapshotSimulation = this.loansNeedALoanService.getDataSimulation();
	  }
	
	  (0, _createClass3.default)(RequestCardSimulationFamilyController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.rootScope.$broadcast(_constants2.EVENTS.CHANGE_TITLE, { title: 'LOANS.NEED_A_LOAN.RESULTS' });
	
	      if (!this.isMobileApp) {
	        this.initData();
	        this.scrollToResults();
	      }
	
	      if (this.stateParams.snapshot || this.snapshotSimulation) {
	        this.initFromSnapshot();
	      }
	
	      if (this.isMobileApp && this.loanSimulationRequest === undefined) {
	        this.state.go(_states.STATES.LOANS.NEED_A_LOAN);
	      }
	    }
	  }, {
	    key: 'initData',
	    value: function initData() {
	      this.loanSimulationRequest = this.loanSimulation;
	      this.simulation = this.loanSimulationRequest.simulation;
	      this.familySelected = this.itemSelected;
	      this.optionFamilySelected = this.codeLoanSimulation;
	      this.families = this.family;
	      this.codeOptionSelected = this.codeOption;
	      this.creditworthiness = this.myCreditworthiness;
	    }
	  }, {
	    key: 'initFromSnapshot',
	    value: function initFromSnapshot() {
	      this.snapshot = this.snapshotSimulation || this.stateParams.snapshot;
	
	      if (this.snapshot.loanSimulationRequest) {
	        this.loanSimulationRequest = this.snapshot.loanSimulationRequest;
	      }
	
	      this.loanSimulation = this.snapshot.loanSimulation;
	      this.familySelected = this.snapshot.familySelected;
	      this.optionFamilySelected = this.snapshot.optionFamilySelected;
	      this.families = this.snapshot.families;
	      this.codeOptionSelected = this.snapshot.codeOptionSelected;
	      this.creditworthiness = this.myCreditworthiness;
	      this.simulation = this.snapshot.simulation;
	
	      if (!this.creditworthiness) {
	        this.creditworthiness = this.snapshot.creditworthiness;
	      }
	
	      if (!this.housingWitness) {
	        this.housingWitness = this.creditworthiness.housingWitness;
	      }
	
	      if (!this.simulationWitness) {
	        this.simulationWitness = this.creditworthiness.simulationWitness;
	      }
	
	      // Only store the snapshot on mobile: In desktop this is done by the need a loan controller
	      if (this.isMobileApp) {
	        this.loansNeedALoanService.setDataSimulation(this.snapshot);
	      }
	    }
	  }, {
	    key: 'openDetail',
	    value: function openDetail(loanSimulation) {
	      var dataToDetail = {
	        loanId: loanSimulation.id,
	        allowGoBack: !this.isMobileApp,
	        loanSimulationRequest: this.loanSimulationRequest,
	        simulation: this.simulation,
	        familySelected: this.familySelected,
	        optionFamilySelected: this.optionFamilySelected,
	        families: this.families,
	        codeOptionSelected: this.codeOptionSelected
	      };
	
	      this.loansNeedALoanService.onOpenDetail(dataToDetail);
	    }
	  }, {
	    key: 'checkLoanSimulationRequest',
	    value: function checkLoanSimulationRequest() {
	      return this.loanSimulationRequest !== undefined;
	    }
	  }, {
	    key: 'checkSimulationIsOkey',
	    value: function checkSimulationIsOkey(loanSimulation) {
	      if (loanSimulation === undefined) return;
	      return loanSimulation.status.code === _constants.LOANS.STATUS.OK;
	    }
	  }, {
	    key: 'selectLoan',
	    value: function selectLoan(loanSimulation, isSignUp) {
	      var response = this.loansNeedALoanService.onSelectLoan({
	        loanId: loanSimulation.id,
	        loanSimulation: loanSimulation,
	        creditworthiness: this.creditworthiness,
	        simulation: this.simulation,
	        dataToGoBack: this.snapshot
	      }, isSignUp);
	
	      if (response !== undefined) {
	        return this.presentCannotSignUpModal(response);
	      }
	    }
	  }, {
	    key: 'presentCannotSignUpModal',
	    value: function presentCannotSignUpModal(reason) {
	      this.cannotSignUpError = reason;
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'isFiveOrNineMonth',
	    value: function isFiveOrNineMonth(loanId) {
	      return loanId === _constants.LOANS.ID.FIVE_MONTH || loanId === _constants.LOANS.ID.NINE_MONTH;
	    }
	  }, {
	    key: 'isSocialAgreement',
	    value: function isSocialAgreement(loanId) {
	      return loanId === _constants.LOANS.ID.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'showIconInfoOnAmount',
	    value: function showIconInfoOnAmount() {
	      return false;
	    }
	  }, {
	    key: 'showIconInfoOnInterests',
	    value: function showIconInfoOnInterests(loanId) {
	      return !this.isFiveOrNineMonth(loanId);
	    }
	  }, {
	    key: 'showIconInfoOnDeadline',
	    value: function showIconInfoOnDeadline() {
	      return true;
	    }
	  }, {
	    key: 'showIconInfoOnInsurance',
	    value: function showIconInfoOnInsurance(loanSimulation) {
	      return loanSimulation.wantInsurance;
	    }
	  }, {
	    key: 'showLoanCV',
	    value: function showLoanCV(loanId) {
	      return loanId === _constants.LOANS.ID.VARIOUS_CREDIT;
	    }
	  }, {
	    key: 'showLoanDA',
	    value: function showLoanDA(loanId) {
	      return loanId === _constants.LOANS.ID.DIVERSAL_ATENTION;
	    }
	  }, {
	    key: 'showLoanVC',
	    value: function showLoanVC(loanId) {
	      return loanId === _constants.LOANS.ID.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'showLoanSV',
	    value: function showLoanSV(loanId) {
	      return loanId === _constants.LOANS.ID.SOCIAL_HOUSING_LOAN;
	    }
	  }, {
	    key: 'showLoan9S',
	    value: function showLoan9S(loanId) {
	      return loanId === _constants.LOANS.ID.NINE_MONTH;
	    }
	  }, {
	    key: 'showLoan5S',
	    value: function showLoan5S(loanId) {
	      return loanId === _constants.LOANS.ID.FIVE_MONTH;
	    }
	  }, {
	    key: 'modifyLoan',
	    value: function modifyLoan() {
	      if (this.isMobileApp) return this.state.go(_states.STATES.LOANS.NEED_A_LOAN);
	      this.onModifyLoan();
	    }
	  }, {
	    key: 'goMyLoans',
	    value: function goMyLoans() {
	      this.state.go(_states.STATES.LOANS.MY_LOANS);
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'showSalePrice',
	    value: function showSalePrice(loanSimulation) {
	      return loanSimulation.loanPurposeId === _constants.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE && (this.housingWitness === true || this.simulationWitness === true);
	    }
	  }, {
	    key: 'selectButtonShouldAppear',
	    value: function selectButtonShouldAppear() {
	      return this.simulationWitness && (this.codeOptionSelected === _constants.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === _constants.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.codeOptionSelected === _constants.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN);
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      var $modal = $(_constants2.MODALS.NEED_A_LOAN);
	      return $modal;
	    }
	  }]);
	  return RequestCardSimulationFamilyController;
	}();
	
	exports.default = RequestCardSimulationFamilyController;

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2080);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./requestCardSimulationFamily.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./requestCardSimulationFamily.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "request-card-simulation-family .responsiveMobile.request-card-simulation{margin-top:0;padding-top:0}request-card-simulation-family .responsiveMobile.request-card-simulation .title-results{display:none}request-card-simulation-family .responsiveMobile.request-card-simulation .flex-container{-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;margin:80px 20px 20px}request-card-simulation-family .responsiveMobile.request-card-simulation .flex-container .flex-item{width:100%;height:auto;margin:0;margin-bottom:30px;padding-bottom:25px}request-card-simulation-family .responsiveMobile.request-card-simulation .flex-container .flex-item .title{padding:20px;min-height:0}request-card-simulation-family .responsiveMobile.request-card-simulation .flex-container .flex-item .title .icon-euro-hand{font-size:40px}request-card-simulation-family .responsiveMobile.request-card-simulation .flex-container .flex-item .title h2{font-size:18px}request-card-simulation-family .responsiveMobile.request-card-simulation .flex-container .flex-item .buttons{margin:0 25px;height:auto}request-card-simulation-family .responsiveMobile.request-card-simulation .flex-container .flex-item .buttons .btn{width:100%;margin:5px 0}request-card-simulation-family .responsiveMobile .request-card-simulation__empty{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}request-card-simulation-family .responsiveMobile .request-card-simulation__empty .icon-warning{margin-bottom:30px}request-card-simulation-family .request-card-simulation{margin-top:50px;margin-left:20px;padding-top:20px}request-card-simulation-family .request-card-simulation .title-results{text-transform:uppercase;color:#0072c9;font-size:13px;font-weight:400}request-card-simulation-family .request-card-simulation .flex-container{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-line-pack:start;align-content:flex-start;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:27px 0 120px}request-card-simulation-family .request-card-simulation .flex-container .flex-item{width:350px;height:auto;margin-right:45px;margin-bottom:45px;padding-bottom:20px;border-radius:3px;box-shadow:0 0 4px rgba(0,0,0,.24)}request-card-simulation-family .request-card-simulation .flex-container .flex-item:last-child{margin-right:0}request-card-simulation-family .request-card-simulation .flex-container .flex-item .title{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;padding:8px 22px 10px 20px;background-color:hsla(0,0%,97%,.75);border-bottom:1px solid #e9e9e9;min-height:105px}request-card-simulation-family .request-card-simulation .flex-container .flex-item .title .icon-euro-hand{font-size:50px;margin-right:15px}request-card-simulation-family .request-card-simulation .flex-container .flex-item .title h2{font-size:24px;display:inline-block;width:75%;font-weight:400;line-height:1.2;margin:0}request-card-simulation-family .request-card-simulation .flex-container .flex-item .wrapper-details .details{padding-top:20px;padding-bottom:15px;min-height:340px}request-card-simulation-family .request-card-simulation .flex-container .flex-item .wrapper-details .details hr{width:85%;margin:0 auto;color:#dddfe2}request-card-simulation-family .request-card-simulation .flex-container .flex-item .detail-error{padding:0 20px;min-height:340px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}request-card-simulation-family .request-card-simulation .flex-container .flex-item .detail-error-header{width:100%;text-align:center;border-bottom:1px solid #dddfe2}request-card-simulation-family .request-card-simulation .flex-container .flex-item .detail-error-header .title-error{font-size:24px;color:#c8175e;text-transform:none}request-card-simulation-family .request-card-simulation .flex-container .flex-item .detail-error-header .icon-warning{font-size:65px;margin-bottom:30px}request-card-simulation-family .request-card-simulation .flex-container .flex-item .detail-error-header .icon-warning:before{color:#c8175e}request-card-simulation-family .request-card-simulation .flex-container .flex-item .detail-error-body{max-width:230px;margin-top:30px;text-align:center}request-card-simulation-family .request-card-simulation .flex-container .flex-item .detail-error-body p{font-size:15px;color:#666}request-card-simulation-family .request-card-simulation .flex-container .flex-item .buttons{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;height:23%}request-card-simulation-family .request-card-simulation .flex-container .flex-item .buttons .btn{width:300px;margin:5px 0;font-size:12px;height:40px;line-height:40px}request-card-simulation-family .request-card-simulation__empty{text-align:center;color:#0072c9;margin-top:15px}request-card-simulation-family .request-card-simulation__empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cardSimulationMoreInfo = __webpack_require__(2082);
	
	var _cardSimulationMoreInfo2 = _interopRequireDefault(_cardSimulationMoreInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardSimulationMoreInfoModule = _angular2.default.module('cardSimulationMoreInfo', [_angularUiRouter2.default]).component('cardSimulationMoreInfo', _cardSimulationMoreInfo2.default).name;
	
	exports.default = cardSimulationMoreInfoModule;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardSimulationMoreInfo = __webpack_require__(2083);
	
	var _cardSimulationMoreInfo2 = _interopRequireDefault(_cardSimulationMoreInfo);
	
	var _cardSimulationMoreInfo3 = __webpack_require__(2084);
	
	var _cardSimulationMoreInfo4 = _interopRequireDefault(_cardSimulationMoreInfo3);
	
	__webpack_require__(2085);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardSimulationMoreInfoComponent = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {
	    loanId: '<',
	    title: '@',
	    iconInfoIsVisible: '<',
	    subtitle: '@',
	    insurance: '<',
	    isMobileApp: '<'
	  },
	  template: _cardSimulationMoreInfo2.default,
	  controller: _cardSimulationMoreInfo4.default
	};
	
	exports.default = cardSimulationMoreInfoComponent;

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"more-info-card\" ng-click=\"$ctrl.toggleMoreInfo()\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <h2 class=\"collapse-title\">\n    {{ $ctrl.title }}\n  </h2>\n  <span ng-if=\"$ctrl.isMandatoryInsurance() && $ctrl.isInsuranceDefined()\" class=\"obligatory\">\n    ({{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.OBLIGATORY' | translate }})\n  </span>\n  <span ng-if=\"$ctrl.isInsuranceDefined() && !$ctrl.isMandatoryInsurance()\" class=\"obligatory\">\n    ({{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.OPTIONAL' | translate }})\n  </span>\n  <i\n    class=\"icon icon-arrow-select-down\"\n    ng-class=\"{ 'show-info-rotation': $ctrl.moreInfoIsVisible === true }\"\n    ng-if=\"$ctrl.iconInfoIsVisible\">\n  </i>\n  <span ng-class=\"{ 'subtitle-amount': !$ctrl.iconInfoIsVisible }\">\n    {{ $ctrl.subtitle }}\n  </span>\n  <span ng-if=\"$ctrl.haveInsurance()\">\n    {{ 'GLOBALS.YES' | translate }}\n  </span>\n  <span ng-if=\"!$ctrl.haveInsurance() && $ctrl.isInsuranceDefined()\" class=\"no-insurance\">\n    {{ 'GLOBALS.NO' | translate }}\n  </span>\n  <div ng-if=\"$ctrl.moreInfoIsVisible\" class=\"more-info-transclude animation-appear\">\n    <ng-transclude></ng-transclude>\n  </div>\n<div>\n"

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardSimulationMoreInfoController = function () {
	  function CardSimulationMoreInfoController() {
	    (0, _classCallCheck3.default)(this, CardSimulationMoreInfoController);
	
	    this.moreInfoIsVisible = false;
	  }
	
	  (0, _createClass3.default)(CardSimulationMoreInfoController, [{
	    key: 'toggleMoreInfo',
	    value: function toggleMoreInfo() {
	      this.moreInfoIsVisible = !this.moreInfoIsVisible && this.iconInfoIsVisible;
	    }
	  }, {
	    key: 'haveInsurance',
	    value: function haveInsurance() {
	      return this.insurance === true;
	    }
	  }, {
	    key: 'isInsuranceDefined',
	    value: function isInsuranceDefined() {
	      return this.insurance !== undefined;
	    }
	  }, {
	    key: 'isMandatoryInsurance',
	    value: function isMandatoryInsurance() {
	      if (this.loanId === _constants.LOANS.ID.SOCIAL_HOUSING_LOAN || this.loanId === _constants.LOANS.ID.AGREEMENT_HOUSING_LOAN) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }]);
	  return CardSimulationMoreInfoController;
	}();
	
	exports.default = CardSimulationMoreInfoController;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2086);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardSimulationMoreInfo.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./cardSimulationMoreInfo.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "card-simulation-more-info .more-info-card{cursor:pointer;padding:17px 20px 14px;width:100%}card-simulation-more-info .more-info-card.mobile .more-info-transclude{padding-right:25px}card-simulation-more-info .more-info-card.mobile .more-info-transclude p{text-align:left}card-simulation-more-info .more-info-card .collapse-title{font-size:12px;font-weight:500;color:#666;display:inline-block;margin:0;text-align:left;text-transform:uppercase}card-simulation-more-info .more-info-card i{transition:.7s;color:#287cba;float:right;margin-right:12px}card-simulation-more-info .more-info-card i.show-info-rotation{transform:rotate(180deg)}card-simulation-more-info .more-info-card span{float:right;color:#666;margin-right:15px;font-size:12px}card-simulation-more-info .more-info-card .subtitle-amount{margin-right:41px}card-simulation-more-info .more-info-card .obligatory{float:none}card-simulation-more-info .more-info-card .no-insurance{margin-right:43px}card-simulation-more-info .more-info-card .more-info-transclude{font-size:12px;margin-top:10px;line-height:15px;padding-right:29px}card-simulation-more-info .more-info-card .more-info-transclude p{margin-bottom:4px;width:100%;word-wrap:break-word}card-simulation-more-info .more-info-card .more-info-transclude ul{padding-left:0;margin-bottom:0;margin-left:14px}", ""]);
	
	// exports


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _needALoanFamilySelect = __webpack_require__(2088);
	
	var _needALoanFamilySelect2 = _interopRequireDefault(_needALoanFamilySelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var needALoanFamilySelectModule = _angular2.default.module('needALoanFamilySelect', [_angularUiRouter2.default]).component('needALoanFamilySelect', _needALoanFamilySelect2.default).name;
	
	exports.default = needALoanFamilySelectModule;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _needALoanFamilySelect = __webpack_require__(2089);
	
	var _needALoanFamilySelect2 = _interopRequireDefault(_needALoanFamilySelect);
	
	var _needALoanFamilySelect3 = __webpack_require__(2090);
	
	var _needALoanFamilySelect4 = _interopRequireDefault(_needALoanFamilySelect3);
	
	__webpack_require__(2091);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var needALoanFamilySelectComponent = {
	  restrict: 'E',
	  bindings: {
	    families: '<',
	    codeLoanSimulation: '<',
	    onOptionSelect: '&'
	  },
	  template: _needALoanFamilySelect2.default,
	  controller: _needALoanFamilySelect4.default
	};
	
	exports.default = needALoanFamilySelectComponent;

/***/ }),
/* 2089 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"need-a-loan-family-select\">\n\n  <div class=\"need-a-loan-family-select-select\" ng-click=\"$ctrl.toggle()\" ng-class=\"$ctrl.getSelectClass()\">\n    <span class=\"literal-select\">\n      {{ $ctrl.purposeLiteral || ('LOANS.NEED_A_LOAN.SEE_ALL_PURPOSES' | translate) }}\n    </span>\n    <span ng-class=\"$ctrl.getArrowClass()\"></span>\n  </div>\n\n  <div ng-if=\"$ctrl.open\" class=\"need-a-loan-family-select-options animation-appear\">\n    <div class=\"input-wrapper\">\n      <span class=\"icon icon-cross\" ng-click=\"$ctrl.resetSearchingTerm()\"></span>\n      <span class=\"icon icon-search-blue\"></span>\n      <input type=\"text\" ng-change=\"$ctrl.search()\" ng-model=\"$ctrl.searchingTerm\" />\n    </div>\n    <div class=\"options\">\n      <div ng-repeat=\"(key, value) in $ctrl.families\">\n        <p class=\"family-title\">\n          {{ value.literal }}\n        </p>\n        <p\n          class=\"family-option\"\n          ng-class=\"$ctrl.getPurposeClass(purpose)\"\n          ng-repeat=\"purpose in value.purposes\"\n          ng-click=\"$ctrl.selectPurpose(key, value, purpose)\">\n          {{ purpose.purposeLiteral }}\n        </p>\n      </div>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NeedALoanFamilySelectController = function () {
	  NeedALoanFamilySelectController.$inject = ["EventEmitter", "$scope", "$timeout", "$location"];
	  function NeedALoanFamilySelectController(EventEmitter, $scope, $timeout, $location) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, NeedALoanFamilySelectController);
	    this.eventEmitter = EventEmitter;
	    this.open = false;
	    this.scope = $scope;
	    this.timeout = $timeout;
	    this.location = $location;
	  }
	
	  (0, _createClass3.default)(NeedALoanFamilySelectController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.selectOptionOnPurpose();
	      this.closeOnOutsideClick();
	      if (this.isMobileApp) {
	        this.scope.$watch(function () {
	          return _this.open;
	        }, function (open) {
	          open ? _this.scrollToFamilySelectorAndAddPadding() : _this.scrollToTopAndRemovePadding();
	        });
	      }
	    }
	  }, {
	    key: 'scrollToFamilySelectorAndAddPadding',
	    value: function scrollToFamilySelectorAndAddPadding() {
	      angular.element('#select-families-need-a-loan').css('padding-top', '60px');
	      this.location.hash('select-families-need-a-loan');
	    }
	  }, {
	    key: 'scrollToTopAndRemovePadding',
	    value: function scrollToTopAndRemovePadding() {
	      angular.element('#select-families-need-a-loan').css('padding-top', '0px');
	      this.location.hash('');
	    }
	  }, {
	    key: 'selectOptionOnPurpose',
	    value: function selectOptionOnPurpose() {
	      var _this2 = this;
	
	      this.scope.$watch(function () {
	        return _this2.codeLoanSimulation;
	      }, function (codeLoanSimulation) {
	        if (codeLoanSimulation) {
	          return _this2.purposeLiteral = _this2.findPurposeLiteral(codeLoanSimulation);
	        }
	
	        _this2.purposeLiteral = undefined;
	      });
	    }
	  }, {
	    key: 'findPurposeLiteral',
	    value: function findPurposeLiteral(codeLoanSimulation) {
	      var code = codeLoanSimulation.substring(0, 2);
	      var familyCode = codeLoanSimulation.substring(2, 5);
	
	      for (var key in this.families) {
	        var family = this.families[key];
	
	        if (family.code === familyCode) {
	          var purpose = family.purposes.find(function (purpose) {
	            return purpose.purposeCode === code;
	          });
	          return purpose.purposeLiteral;
	        }
	      }
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.resetSearchingTerm();
	      this.open = !this.open;
	    }
	  }, {
	    key: 'closeOnOutsideClick',
	    value: function closeOnOutsideClick() {
	      var _this3 = this;
	
	      $(document).click(function (event) {
	        var target = $(event.target);
	        var clickOutside = !target.closest('need-a-loan-family-select').length;
	
	        if (clickOutside) {
	          _this3.timeout(function () {
	            return _this3.open = false;
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getSelectClass',
	    value: function getSelectClass() {
	      return {
	        blue: this.open
	      };
	    }
	  }, {
	    key: 'getArrowClass',
	    value: function getArrowClass() {
	      return {
	        icon: true,
	        'icon-arrow-select-down': !this.open,
	        'icon-arrow-select-up': this.open
	      };
	    }
	  }, {
	    key: 'resetSearchingTerm',
	    value: function resetSearchingTerm() {
	      this.searchingTerm = '';
	    }
	  }, {
	    key: 'getPurposeClass',
	    value: function getPurposeClass(purpose) {
	      if (!this.searchingTerm) {
	        return {};
	      }
	
	      var literal = purpose.purposeLiteral.toLowerCase();
	      var searchingTerm = this.searchingTerm.toLowerCase();
	      var highlight = literal.indexOf(searchingTerm) > -1;
	      return { highlight: highlight };
	    }
	  }, {
	    key: 'selectPurpose',
	    value: function selectPurpose(key, family, purpose) {
	      this.purposeLiteral = purpose.purposeLiteral;
	      this.toggle();
	
	      this.onOptionSelect(this.eventEmitter({
	        familyName: key,
	        familyCode: family.code,
	        purposeCode: purpose.purposeCode
	      }));
	    }
	  }]);
	  return NeedALoanFamilySelectController;
	}();
	
	exports.default = NeedALoanFamilySelectController;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2092);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./needALoanFamilySelect.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./needALoanFamilySelect.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "need-a-loan-family-select{display:block;position:relative;width:554px}need-a-loan-family-select.mobile{width:100%}need-a-loan-family-select.mobile .need-a-loan-family-select-select{width:100%;box-sizing:border-box;height:60px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;border-radius:2px;border-color:#eaebed}need-a-loan-family-select.mobile .need-a-loan-family-select-select .literal-select{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1 1 auto}need-a-loan-family-select.mobile .need-a-loan-family-select-select span.icon{position:unset;right:0;flex:0 1 auto}need-a-loan-family-select.mobile .need-a-loan-family-select-select span{font-size:15px}need-a-loan-family-select.mobile .need-a-loan-family-select-options{width:100%;border-radius:0;border-top:0;padding-right:0}need-a-loan-family-select.mobile .need-a-loan-family-select-options .input-wrapper{padding:0 12px;box-sizing:border-box}need-a-loan-family-select.mobile .need-a-loan-family-select-options .input-wrapper .icon.icon-cross{right:20px}need-a-loan-family-select.mobile .need-a-loan-family-select-options .input-wrapper input{width:100%;box-sizing:border-box;font-size:12px;padding-top:0}need-a-loan-family-select.mobile .need-a-loan-family-select-options .options .family-title{font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:40px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}need-a-loan-family-select.mobile .need-a-loan-family-select-options .options .family-option{font-size:12px;white-space:normal;overflow:visible;text-overflow:ellipsis;height:35px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;max-width:244px;line-height:17px;margin-bottom:20px}need-a-loan-family-select.mobile .need-a-loan-family-select-options .options .highlight{background-color:#dddfe2}need-a-loan-family-select.mobile .need-a-loan-family-select .icon-arrow-select-down,need-a-loan-family-select.mobile .need-a-loan-family-select .icon-arrow-select-up{font-size:10px}need-a-loan-family-select .need-a-loan-family-select-select{cursor:pointer;position:relative;width:554px;height:37px;border-radius:3px;border:1px solid #aeaeae;padding:10px 20px}need-a-loan-family-select .need-a-loan-family-select-select.blue{border:1px solid #0072c9}need-a-loan-family-select .need-a-loan-family-select-select.blue span{color:#0072c9}need-a-loan-family-select .need-a-loan-family-select-select span{text-transform:uppercase;font-family:Stag Sans;font-size:15px;color:#666}need-a-loan-family-select .need-a-loan-family-select-select span.icon{position:absolute;right:24px}need-a-loan-family-select .need-a-loan-family-select-options{width:554px;border-radius:3px;border:1px solid #0072c9;padding:12px 11px 14px 0}need-a-loan-family-select .need-a-loan-family-select-options .options{max-height:497px;overflow-y:scroll}need-a-loan-family-select .need-a-loan-family-select-options .input-wrapper{padding-left:11px;position:relative}need-a-loan-family-select .need-a-loan-family-select-options .input-wrapper .icon{position:absolute}need-a-loan-family-select .need-a-loan-family-select-options .input-wrapper .icon.icon-cross{top:10px;font-size:15px;right:10px;color:#aeaeae;cursor:pointer}need-a-loan-family-select .need-a-loan-family-select-options .input-wrapper .icon.icon-search-blue{left:22px;font-size:16px;top:10px}need-a-loan-family-select .need-a-loan-family-select-options .input-wrapper input{width:530px;height:36px;border-radius:3px;border:1px solid #0072c9;line-height:36px;margin-bottom:10px;padding:0 0 0 39px}need-a-loan-family-select .need-a-loan-family-select-options p{font-size:11px;text-transform:uppercase;margin:0;height:36px;line-height:36px;padding-left:13px}need-a-loan-family-select .need-a-loan-family-select-options p.family-title{color:#0072c9}need-a-loan-family-select .need-a-loan-family-select-options p.family-option{padding-left:40px}need-a-loan-family-select .need-a-loan-family-select-options p.family-option:hover,need-a-loan-family-select .need-a-loan-family-select-options p.highlight{background:#f4f4f4;color:#0072c9;cursor:pointer}need-a-loan-family-select .need-a-loan-family-select-options .icon-arrow-select-down,need-a-loan-family-select .need-a-loan-family-select-options .icon-arrow-select-up{font-size:10px}", ""]);
	
	// exports


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _needALoanModal = __webpack_require__(2094);
	
	var _needALoanModal2 = _interopRequireDefault(_needALoanModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var needALoanModalModule = _angular2.default.module('needALoanModal', []).component('needALoanModal', _needALoanModal2.default).name;
	
	exports.default = needALoanModalModule;

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _needALoanModal = __webpack_require__(2095);
	
	var _needALoanModal2 = _interopRequireDefault(_needALoanModal);
	
	var _needALoanModal3 = __webpack_require__(2096);
	
	var _needALoanModal4 = _interopRequireDefault(_needALoanModal3);
	
	__webpack_require__(2097);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var needALoanModalComponent = {
	  restrict: 'E',
	  bindings: {
	    cannotSignUpError: '<',
	    messageError: '<',
	    onDismiss: '&',
	    isMobileApp: '<'
	  },
	  template: _needALoanModal2.default,
	  controller: _needALoanModal4.default
	};
	
	exports.default = needALoanModalComponent;

/***/ }),
/* 2095 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"modalNeedALoan\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalNeedALoan\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <failed-action\n      ng-if=\"$ctrl.cannotSignUpError === true\"\n      class=\"failed-action-creditworthiness\"\n      title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n      description=\"{{ $ctrl.messageError || 'LOANS.NEED_A_LOAN.CANNOT_SIGN_UP_ERROR' | translate }}\"\n      close-modal=\"true\"\n      avoid-callback-on-close=\"$ctrl.avoidCallbackOnClose\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      button-text=\"{{ 'LOANS.NEED_A_LOAN.GO_TO_MY_LOANS' | translate}}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </failed-action>\n\n    <failed-action\n      ng-if=\"$ctrl.cannotSignUpError === 'creditworthinessError'\"\n      class=\"failed-action-creditworthiness\"\n      title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n      description=\"{{ $ctrl.messageError || 'LOANS.NEED_A_LOAN.CANNOT_SIGN_UP_ERROR_CREDITWORTHINESS' | translate }}\"\n      close-modal=\"true\"\n      avoid-callback-on-close=\"$ctrl.avoidCallbackOnClose\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      button-text=\"{{ 'LOANS.NEED_A_LOAN.GO_TO_MY_LOANS' | translate}}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </failed-action>\n\n    <failed-action\n      ng-if=\"$ctrl.cannotSignUpError === 'lengthOfServiceError'\"\n      class=\"failed-action-lengthofservice\"\n      title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n      description=\"{{ $ctrl.messageError || 'LOANS.NEED_A_LOAN.CANNOT_SIGN_UP_ERROR_SERVICE' | translate }}\"\n      close-modal=\"true\"\n      avoid-callback-on-close=\"$ctrl.avoidCallbackOnClose\"\n      on-dismiss=\"$ctrl.onDismiss()\"\n      button-text=\"{{ 'LOANS.NEED_A_LOAN.GO_TO_MY_LOANS' | translate}}\"\n      is-mobile-app=\"$ctrl.isMobileApp\">\n    </failed-action>\n\n  </div>\n</div>\n"

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NeedALoanModalController = function NeedALoanModalController() {
	  (0, _classCallCheck3.default)(this, NeedALoanModalController);
	
	  this.avoidCallbackOnClose = true;
	};
	
	exports.default = NeedALoanModalController;

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2098);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./needALoanModal.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./needALoanModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _needALoan = __webpack_require__(2100);
	
	var _needALoan2 = _interopRequireDefault(_needALoan);
	
	var _needALoan3 = __webpack_require__(2101);
	
	var _needALoan4 = _interopRequireDefault(_needALoan3);
	
	__webpack_require__(2102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var needALoanComponent = {
	  restrict: 'E',
	  bindings: {
	    serviceClosed: '<'
	  },
	  template: _needALoan2.default,
	  controller: _needALoan4.default
	};
	
	exports.default = needALoanComponent;

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

	module.exports = "<modal-coachmark\n  ng-if=\"!$ctrl.isMobileApp\"\n  data=\"$ctrl.coachmarkData\"\n  user-id=\"$ctrl.userId\">\n</modal-coachmark>\n\n<section ng-if=\"$ctrl.showLoading()\">\n  <loading></loading>\n</section>\n\n<div class=\"container hpd need-a-loan animation-appear\" ng-class=\"$ctrl.getClasses()\" ng-if=\"$ctrl.loaded\">\n\n  <header>\n    <section-title class=\"loans-title\" text=\"¿{{ 'LOANS.NEED_A_LOAN.NEED_IT' | translate }}?\">\n    </section-title>\n  </header>\n\n  <section>\n    <menu-family-need-a-loan\n      families=\"$ctrl.families\"\n      simulation=\"$ctrl.simulation\"\n      on-get-simulation-families=\"$ctrl.onGetSimulationFamilies($event)\"\n      select-family=\"$ctrl.selectFamily($event)\"\n      item-selected=\"$ctrl.itemSelected\"\n      selected-option-family=\"$ctrl.selectedOptionFamily\"\n      on-select-option-family=\"$ctrl.onSelectOptionFamily($event)\"\n      set-simulation=\"$ctrl.setSimulation($event)\"\n      option-family-selected=\"$ctrl.codeLoanSimulation\"\n      get-code-loan=\"$ctrl.getCodeLoan()\"\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      families-mobile=\"$ctrl.familiesOnMobileApp\"\n      code-option-selected=\"$ctrl.codeOptionSelected\"\n      options-families-to-select=\"$ctrl.optionsFamiliesToSelect\"\n      housing-witness=\"$ctrl.housingWitness\">\n    </menu-family-need-a-loan>\n  </section>\n\n  <section id=\"select-families-need-a-loan\">\n    <section-title\n      class=\"loans-title need-a-loan-family-select-title\"\n      text=\"{{ 'LOANS.NEED_A_LOAN.SEARCH_IT' | translate }}\">\n    </section-title>\n\n    <need-a-loan-family-select\n      families=\"$ctrl.families\"\n      code-loan-simulation=\"$ctrl.codeLoanSimulation\"\n      ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n      on-option-select=$ctrl.onOptionSelect($event)>\n    </need-a-loan-family-select>\n  </section>\n\n  <request-card-simulation-family\n    ng-if=\"$ctrl.loanSimulationRequest !== undefined && !$ctrl.isMobileApp\"\n    loan-simulation=\"$ctrl.loanSimulationRequest\"\n    on-select-loan=\"$ctrl.onSelectLoan($event)\"\n    scroll-to-results=\"$ctrl.scrollToResults()\"\n    on-modify-loan=\"$ctrl.resetAllSimulation()\"\n    item-selected=\"$ctrl.itemSelected\"\n    code-loan-simulation=\"$ctrl.codeLoanSimulation\"\n    family=\"$ctrl.families\"\n    code-option=\"$ctrl.codeOptionSelected\"\n    my-creditworthiness=\"$ctrl.creditworthiness\"\n    data-simulation=\"$ctrl.simulation\"\n    housing-witness=\"$ctrl.housingWitness\"\n    simulation-witness=\"$ctrl.simulationWitness\">\n  </request-card-simulation-family>\n\n  <need-a-loan-modal\n    cannot-sign-up-error=\"$ctrl.cannotSignUpError\"\n    message-error=\"$ctrl.errorMessage\"\n    on-dismiss=\"$ctrl.goMyLoans()\"\n    is-mobile-app=\"$ctrl.isMobileApp\">\n  </need-a-loan-modal>\n\n</div>\n"

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	var _constantsLoans = __webpack_require__(1774);
	
	var _constants2 = __webpack_require__(1774);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NeedALoanController = function () {
	  NeedALoanController.$inject = ["$state", "$stateParams", "$timeout", "$window", "$location", "$log", "$scope", "$rootScope", "$q", "LoansUserDataService", "loansStaticService", "loansSignUpService", "LoansOperationsService", "LoansNeedALoanService", "loadingMobileService", "metricsService"];
	  function NeedALoanController($state, $stateParams, $timeout, $window, $location, $log, $scope, $rootScope, $q, LoansUserDataService, loansStaticService, loansSignUpService, LoansOperationsService, LoansNeedALoanService, loadingMobileService, metricsService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, NeedALoanController);
	    this.state = $state;
	    this.stateParams = $stateParams;
	    this.timeout = $timeout;
	    this.window = $window;
	    this.location = $location;
	    this.log = $log;
	    this.scope = $scope;
	    this.rootScope = $rootScope;
	    this.q = $q;
	
	    this.loansUserDataService = LoansUserDataService;
	    this.loansStaticService = loansStaticService;
	    this.loansSignUpService = loansSignUpService;
	    this.loansOperationsService = LoansOperationsService;
	    this.loansNeedALoanService = LoansNeedALoanService;
	    this.loadingMobileService = loadingMobileService;
	    this.metricsService = metricsService;
	
	    this.BUY_HOUSING_PURPOSE = _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
	    this.coachmarkData = _constants2.LOANS_NEED_A_LOAN_MODAL_COACHMARK_CONFIG;
	    this.userId = this.loansUserDataService._employee.userId;
	    this.isMobileApp = $window.innerWidth < 1024;
	
	    this.snapshotSimulation = this.loansNeedALoanService.getDataSimulation();
	
	    if (this.stateParams.snapshot || this.snapshotSimulation) {
	      this.initFromSnapshot();
	    } else {
	      this.init();
	    }
	  }
	
	  (0, _createClass3.default)(NeedALoanController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.rootScope.$broadcast(_constants.EVENTS.CHANGE_TITLE, { title: 'LOANS.NEED_A_LOAN.TITLE' });
	    }
	  }, {
	    key: 'initFromSnapshot',
	    value: function initFromSnapshot() {
	      var _this = this;
	
	      this.loadingMobileService.show();
	      this.loansOperationsService.getCreditworthiness(this.userId).then(function (creditworthiness) {
	        _this.creditworthiness = creditworthiness;
	        _this.housingWitness = _this.creditworthiness.housingWitness;
	        _this.initSnapshot();
	        _this.loaded = true;
	      }, function (error) {
	        _this.log.error('NeedALoanController initFromSnapshot()', error);
	        // TODO: [Manu] revisar esto, no debería hacer falta con errorInterceptor, no falla como en APP Ayuda Alimentaria pq en el routing de loans se hace esta misma llamada pero sin el state.go error
	        // this.state.go(STATES.ERROR);
	      }).finally(function () {
	        _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'initSnapshot',
	    value: function initSnapshot() {
	
	      // Prevail snapshot simulation over snapshot from stateparams, its always more recent
	      var snapshot = this.snapshotSimulation || this.stateParams.snapshot;
	
	      // Go back does not has the result loans cards: set it
	      if (!snapshot.loanSimulationRequest && this.snapshotSimulation && (this.snapshotSimulation.loanSimulationRequest || this.snapshotSimulation.loanSimulation)) {
	        snapshot.loanSimulationRequest = this.snapshotSimulation.loanSimulationRequest || this.snapshotSimulation.loanSimulation;
	      }
	
	      this.loanSimulationRequest = {};
	      this.loanSimulationRequest = this.snapshotSimulation ? snapshot.loanSimulationRequest : snapshot.loanSimulation;
	
	      this.simulation = snapshot.simulation;
	      this.itemSelected = snapshot.familySelected;
	      this.codeLoanSimulation = snapshot.optionFamilySelected;
	      this.selectedOptionFamily = true;
	      this.families = snapshot.families;
	      this.codeOptionSelected = snapshot.codeOptionSelected;
	      this.optionsFamiliesToSelect = snapshot.optionsFamiliesToSelect;
	
	      if (this.isMobileApp) this.formatFamiliesOnMobileApp(this.families);
	
	      this.scrollToResults();
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      this.loadingMobileService.show();
	      this.q.all([this.loansOperationsService.getCreditworthiness(this.userId), this.loansOperationsService.getFamilies()]).then(function (responses) {
	        _this2.creditworthiness = responses[0];
	        _this2.families = responses[1].data.needALoanFamiliesList;
	        if (_this2.isMobileApp) _this2.formatFamiliesOnMobileApp(responses[1].data.needALoanFamiliesList);
	        _this2.loaded = true;
	        _this2.housingWitness = _this2.creditworthiness.housingWitness;
	        _this2.simulationWitness = _this2.creditworthiness.simulationWitness;
	      }, function (error) {
	        _this2.log.error('NeedALoanController init()', error);
	        // TODO: [Manu] eliminado ya que en la APP se ve un instante antes de redirigir a login, e incluso pueda causar otros problemas. Ver si en la Web es necesario o con el errorInterceptor es suficiente
	        // this.state.go(STATES.ERROR);
	      }).finally(function () {
	        _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.resetAllSimulation();
	    }
	  }, {
	    key: 'showLoading',
	    value: function showLoading() {
	      return !this.isMobileApp && !this.loaded;
	    }
	  }, {
	    key: 'formatFamiliesOnMobileApp',
	    value: function formatFamiliesOnMobileApp(families) {
	      var keysFamilies = (0, _keys2.default)(families);
	      this.familiesOnMobileApp = keysFamilies.map(function (fam) {
	        return {
	          value: fam,
	          option: families[fam].literal
	        };
	      });
	    }
	  }, {
	    key: 'getLoan',
	    value: function getLoan(loanId) {
	      return this.loansStaticService.get(loanId);
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        'remove-events': this.serviceClosed,
	        responsiveMobile: this.isMobileApp,
	        'with-floating-action-buttons': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'selectFamily',
	    value: function selectFamily($event) {
	      if (this.itemSelected !== $event.fam) {
	        this.itemSelected = null;
	      }
	
	      this.codeLoanSimulation = null;
	      this.loanSimulationRequest = undefined;
	      this.simulation = undefined;
	      this.itemSelected = $event.fam;
	      this.selectedOptionFamily = false;
	      this.optionsFamiliesToSelect = undefined;
	      this.codeOptionSelected = undefined;
	      this.getCategoriesWithFamily();
	    }
	  }, {
	    key: 'getCategoriesWithFamily',
	    value: function getCategoriesWithFamily() {
	      var familyPurposes = this.families[this.itemSelected].purposes;
	      this.optionsFamiliesToSelect = familyPurposes.map(function (purpose) {
	        return {
	          value: purpose.purposeCode,
	          option: purpose.purposeLiteral
	        };
	      });
	    }
	  }, {
	    key: 'onSelectOptionFamily',
	    value: function onSelectOptionFamily($event) {
	      var _this3 = this;
	
	      this.selectedOptionFamily = false;
	      this.timeout(function () {
	        _this3.simulation = undefined;
	        _this3.codeLoanSimulation = $event.codeLoanSimulation;
	        _this3.codeOptionSelected = $event.codeOptionSelected;
	        _this3.selectedOptionFamily = true;
	        _this3.loanSimulationRequest = undefined;
	      });
	    }
	  }, {
	    key: 'setSimulation',
	    value: function setSimulation($event) {
	      var _this4 = this;
	
	      this.loanSimulationRequest = undefined;
	      this.resetLocationHash();
	      this.simulation = $event;
	      var simulationEndpoint = this._buildEndpointSimulation(this.simulation);
	      var codeOptionIsHousingPurpose = this.codeOptionSelected === this.BUY_HOUSING_PURPOSE;
	
	      this.loadingMobileService.show();
	      this.loansSignUpService.createSimulation(this.userId, simulationEndpoint).then(function (response) {
	
	        _this4.loanSimulationRequest = _this4.filterSimulation(response, codeOptionIsHousingPurpose);
	        _this4.loanSimulationRequest.simulation = _this4.simulation;
	        _this4.scrollToResults();
	        var snapshot = _this4.createSnapshot();
	
	        _this4.log.info('Snapshot created after simulation:', snapshot);
	        _this4.loansNeedALoanService.setDataSimulation(snapshot);
	
	        if (_this4.isMobileApp) {
	          _this4.metricsService.trackLoansSimulation();
	          _this4.state.go(_states.STATES.LOANS.NEED_A_LOAN_RESULTS, { snapshot: snapshot });
	        }
	      }, function (response) {
	
	        _this4.cleanPreviousSimulation();
	        _this4.errorMessage = response.data.message;
	        _this4.presentCannotSignUpModal(true);
	      }).finally(function () {
	        return _this4.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'filterSimulation',
	    value: function filterSimulation(simulation, isHousingPurpose) {
	      var _this5 = this;
	
	      return simulation.data.simulations.filter(function (loanSimulation) {
	        _this5.setInfo(loanSimulation);
	        if (isHousingPurpose) {
	          return loanSimulation.loanId !== _constantsLoans.LOANS.ID_HR.VARIOUS_CREDIT;
	        }
	        return true;
	      });
	    }
	  }, {
	    key: 'createSnapshot',
	    value: function createSnapshot() {
	      var snapshot = {
	        loanSimulation: this.loanSimulationRequest,
	        loanSimulationRequest: this.loanSimulationRequest,
	        familySelected: this.itemSelected,
	        optionFamilySelected: this.codeLoanSimulation,
	        families: this.families,
	        codeOptionSelected: this.codeOptionSelected,
	        creditworthiness: this.creditworthiness,
	        simulation: this.simulation,
	        optionsFamiliesToSelect: this.optionsFamiliesToSelect
	      };
	      return snapshot;
	    }
	  }, {
	    key: 'setInfo',
	    value: function setInfo(loanSimulation) {
	      var loan = this.getLoan(loanSimulation.loanId);
	      loanSimulation.title = this.loansStaticService.get(loanSimulation.loanId).title;
	      this.setTitleFixedVariable(loanSimulation);
	      loanSimulation.id = loan.id;
	    }
	  }, {
	    key: 'setTitleFixedVariable',
	    value: function setTitleFixedVariable(loanSimulation) {
	      var loanId = loanSimulation.loanId;
	      var newTitle = loanSimulation.title;
	      if (loanId === _constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN || loanId === _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN) {
	        newTitle += loanSimulation.typeFixedVariable === '1' ? '_FIXED' : '_VARIABLE';
	      }
	      loanSimulation.newTitle = newTitle;
	    }
	  }, {
	    key: 'cleanPreviousSimulation',
	    value: function cleanPreviousSimulation() {
	      this.loanSimulationRequest = null;
	    }
	  }, {
	    key: '_buildEndpointSimulation',
	    value: function _buildEndpointSimulation(amountSimulation) {
	      var endpointSimulation = {
	        loanPurposeId: this.codeOptionSelected,
	        amount: amountSimulation.amount,
	        wantInsurance: amountSimulation.wantInsurance,
	        typeFixedVariable: amountSimulation.typeFixedVariable || '0',
	        isSimulation: amountSimulation.isSimulation || false
	      };
	
	      if (!(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(amountSimulation.fixedFeeNumber)) {
	        endpointSimulation.deadline = parseInt(amountSimulation.fixedFeeNumber, 10);
	      }
	
	      if (!(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(amountSimulation.monthlyFeeAmount)) {
	        endpointSimulation.monthlyAmount = amountSimulation.monthlyFeeAmount;
	      }
	
	      if (this.codeOptionSelected === this.BUY_HOUSING_PURPOSE) {
	        endpointSimulation.acquisitionCost = amountSimulation.acquisitionCost != null ? amountSimulation.acquisitionCost : amountSimulation.diff;
	
	        if (!(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(amountSimulation.salePrice)) {
	          endpointSimulation.salePrice = amountSimulation.salePrice;
	        }
	      } else {
	        delete endpointSimulation.acquisitionCost;
	        delete endpointSimulation.salePrice;
	      }
	
	      return endpointSimulation;
	    }
	  }, {
	    key: 'onOptionSelect',
	    value: function onOptionSelect($event) {
	      var _this6 = this;
	
	      this.selectedOptionFamily = false;
	      this.resetAllSimulation();
	      this.timeout(function () {
	        _this6.itemSelected = $event.familyName;
	        _this6.codeOptionSelected = $event.purposeCode;
	        _this6.codeLoanSimulation = '' + $event.purposeCode + $event.familyCode;
	        _this6.selectedOptionFamily = true;
	        _this6.getCategoriesWithFamily();
	      });
	    }
	  }, {
	    key: 'presentCannotSignUpModal',
	    value: function presentCannotSignUpModal(reason) {
	      this.cannotSignUpError = reason;
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'goMyLoans',
	    value: function goMyLoans() {
	      this.modal.modal('hide');
	      this.state.go(_states.STATES.LOANS.MY_LOANS);
	    }
	  }, {
	    key: 'scrollToResults',
	    value: function scrollToResults() {
	      this.location.hash('request-card-simulation');
	    }
	  }, {
	    key: 'resetLocationHash',
	    value: function resetLocationHash() {
	      this.location.hash('');
	    }
	  }, {
	    key: 'getCodeLoan',
	    value: function getCodeLoan() {
	      return this.codeOptionSelected === this.BUY_HOUSING_PURPOSE;
	    }
	  }, {
	    key: 'resetAllSimulation',
	    value: function resetAllSimulation() {
	      this.selectedOptionFamily = false;
	      this.itemSelected = undefined;
	      this.loanSimulationRequest = undefined;
	      this.codeOptionSelected = null;
	      this.codeLoanSimulation = undefined;
	      this.simulation = {};
	      this.window.scrollTo(0, 0);
	      this.loansNeedALoanService.clearAllDataSimulation();
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      var $modal = $(_constants.MODALS.NEED_A_LOAN);
	      return $modal;
	    }
	  }]);
	  return NeedALoanController;
	}();
	
	exports.default = NeedALoanController;

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2103);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./needALoan.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./needALoan.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "need-a-loan .need-a-loan{padding-bottom:40px}need-a-loan .need-a-loan.responsiveMobile{min-height:100vh;margin-bottom:30px}need-a-loan .need-a-loan.responsiveMobile .need-a-loan-family-select-title h2,need-a-loan .need-a-loan.responsiveMobile header section-title h2{font-size:16px}need-a-loan h2{color:#0072c9}need-a-loan .remove-events{pointer-events:none}need-a-loan .need-a-loan-family-select-title{margin-bottom:20px}need-a-loan loans-sign-up-form-simulation-housing-change-warning{margin-top:40px}", ""]);
	
	// exports


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _wageAdvance = __webpack_require__(2105);
	
	var _wageAdvance2 = _interopRequireDefault(_wageAdvance);
	
	var _wageAdvance3 = __webpack_require__(2110);
	
	var _wageAdvance4 = _interopRequireDefault(_wageAdvance3);
	
	var _wageAdvance5 = __webpack_require__(2111);
	
	var _wageAdvance6 = _interopRequireDefault(_wageAdvance5);
	
	var _wageAdvanceInfo = __webpack_require__(2112);
	
	var _wageAdvanceInfo2 = _interopRequireDefault(_wageAdvanceInfo);
	
	var _wageAdvanceForm = __webpack_require__(2118);
	
	var _wageAdvanceForm2 = _interopRequireDefault(_wageAdvanceForm);
	
	var _wageAdvanceList = __webpack_require__(2124);
	
	var _wageAdvanceList2 = _interopRequireDefault(_wageAdvanceList);
	
	var _wageAdvanceResume = __webpack_require__(2135);
	
	var _wageAdvanceResume2 = _interopRequireDefault(_wageAdvanceResume);
	
	var _wageAdvanceModal = __webpack_require__(2141);
	
	var _wageAdvanceModal2 = _interopRequireDefault(_wageAdvanceModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceModule = _angular2.default.module('wageAdvance', [_angularUiRouter2.default, _wageAdvanceInfo2.default, _wageAdvanceForm2.default, _wageAdvanceList2.default, _wageAdvanceResume2.default, _wageAdvanceModal2.default]).component('wageAdvance', _wageAdvance2.default).service('wageAdvanceService', _wageAdvance4.default).service('wageAdvanceHelper', _wageAdvance6.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.LOANS.WAGE_ADVANCE, {
	    url: _routes.ROUTES.LOANS.WAGE_ADVANCE,
	    component: 'wageAdvance',
	    params: {
	      stateAccess: null
	    },
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      serviceClosed: ["StatusAppCheckers", function serviceClosed(StatusAppCheckers) {
	        return StatusAppCheckers.isWageInProcess();
	      }]
	    }
	  });
	}]).name;
	
	exports.default = wageAdvanceModule;

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _wageAdvance = __webpack_require__(2106);
	
	var _wageAdvance2 = _interopRequireDefault(_wageAdvance);
	
	var _wageAdvance3 = __webpack_require__(2107);
	
	var _wageAdvance4 = _interopRequireDefault(_wageAdvance3);
	
	__webpack_require__(2108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceComponent = {
	  restrict: 'E',
	  bindings: {
	    serviceClosed: '<'
	  },
	  template: _wageAdvance2.default,
	  controller: _wageAdvance4.default
	};
	
	exports.default = wageAdvanceComponent;

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd\" ng-class=\"$ctrl.getClasses()\">\n\n  <modal-coachmark\n    ng-if=\"!$ctrl.isMobileApp\"\n    data=\"$ctrl.coachmarkData\"\n    user-id=\"$ctrl.userId\">\n  </modal-coachmark>\n\n  <wage-advance-modal\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    modal-to-show=\"$ctrl.modalToShow\"\n    message-error=\"$ctrl.messageError\"\n    close-modal=\"$ctrl.closeModal()\"\n    cancel-wage-advance=\"$ctrl.cancelWageAdvance()\">\n  </wage-advance-modal>\n\n  <section ng-if=\"!$ctrl.loaded\">\n    <loading></loading>\n  </section>\n\n  <section ng-if=\"$ctrl.loaded\" class=\"wage-advance\">\n\n    <loans-header\n      title=\"{{ 'LOANS.WAGE_ADVANCE.TITLE' | translate }}\"\n      ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n    </loans-header>\n\n    <section ng-if=\"$ctrl.isForm()\">\n\n      <wage-advance-info is-mobile-app=\"$ctrl.isMobileApp\">\n      </wage-advance-info>\n\n      <div ng-if=\"$ctrl.loaded\">\n        <wage-advance-form\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          on-submit=\"$ctrl.setWadgeAdvance($event)\"\n          wage-advance-reasons-list=\"$ctrl.wageAdvanceReasonsList\"\n          check-service-closed=\"$ctrl.checkServiceClosed()\">\n        </wage-advance-form>\n\n        <wage-advance-list\n          is-mobile-app=\"$ctrl.isMobileApp\"\n          ng-class=\"{ 'remove-events': $ctrl.serviceClosed }\"\n          employee-wages-advance=\"$ctrl.employeeWagesAdvance\"\n          on-cancel=\"$ctrl.onCancel($event)\">\n        </wage-advance-list>\n      </div>\n\n      <loading ng-if=\"!$ctrl.loaded\">\n      </loading>\n\n    </section>\n\n    <section ng-if=\"$ctrl.isResume()\">\n\n      <wage-advance-resume\n        is-mobile-app=\"$ctrl.isMobileApp\"\n        wage-advance=\"$ctrl.wageAdvance\"\n        cancel-wage-advance=\"$ctrl.cancelResume()\"\n        finish-wage-advance=\"$ctrl.finishWageAdvance($event)\">\n      </wage-advance-resume>\n\n    </section>\n\n  </section>\n\n</div>\n"

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constants2 = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STEPS = {
	  FORM: 'form',
	  RESUME: 'resume'
	};
	
	var MODALS_WAGE_ADVANCE = {
	  SUCCESS: 'success',
	  FAILED: 'failed',
	  CUESTION: 'cuestion',
	  SUCCESS_DELETE: 'success-delete',
	  FAILED_DELETE: 'failed-delete'
	};
	
	var WageAdvanceController = function () {
	  WageAdvanceController.$inject = ["$log", "$window", "$q", "$stateParams", "$rootScope", "wageAdvanceService", "wageAdvanceHelper", "LoansUserDataService", "loadingMobileService"];
	  function WageAdvanceController($log, $window, $q, $stateParams, $rootScope, wageAdvanceService, wageAdvanceHelper, LoansUserDataService, loadingMobileService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WageAdvanceController);
	    this.log = $log;
	    this.window = $window;
	    this.q = $q;
	    this.rootScope = $rootScope;
	    this.stateparams = $stateParams;
	
	    this.wageAdvanceService = wageAdvanceService;
	    this.wageAdvanceHelper = wageAdvanceHelper;
	    this.loansUserDataService = LoansUserDataService;
	    this.loadingMobileService = loadingMobileService;
	
	    this.isMobileApp = $window.innerWidth < 1024;
	    this.userId = this.loansUserDataService._employee.userId;
	    this.wageAdvanceReasonsList = [];
	    this.employeeWagesAdvance = [];
	    this.step = STEPS.FORM;
	    this.loaded = false || this.isMobileApp;
	    this.coachmarkData = _constants2.LOANS_WAGE_ADVANCE_MODAL_COACHMARK_CONFIG;
	
	    this.init();
	  }
	
	  (0, _createClass3.default)(WageAdvanceController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.checkLoansAccess();
	      this.loadingMobileService.show();
	      this.q.all([this.wageAdvanceService.getReasonsList(), this.wageAdvanceService.getEmployeeWagesAdvance(this.userId)]).then(function (responses) {
	        _this.wageAdvanceReasonsList = responses[0];
	        _this.log.info('Wage advance reasons list is:', _this.wageAdvanceReasonsList);
	
	        var employeeWagesAdvance = responses[1];
	        _this.log.info('Employee list is:', employeeWagesAdvance);
	        _this.employeeWagesAdvance = _this.wageAdvanceHelper.format(employeeWagesAdvance);
	        _this.loaded = true;
	      }, function (error) {
	        _this.log.error('WageAdvanceController init()', error);
	        // TODO: [Manu] eliminado ya que en la APP se ve un instante antes de redirigir a login, e incluso pueda causar otros problemas. Ver si en la Web es necesario o con el errorInterceptor es suficiente
	        // this.state.go(STATES.ERROR);
	      }).finally(function () {
	        _this.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'checkLoansAccess',
	    value: function checkLoansAccess() {
	      this.withoutLoansAccess = this.stateparams.stateAccess;
	      if (this.withoutLoansAccess) {
	        this.rootScope.$emit(_constants.EVENTS.WITHOUT_LOANS_ACCESS);
	      }
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        'responsiveMobile': this.isMobileApp,
	        'with-floating-action-buttons': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'checkServiceClosed',
	    value: function checkServiceClosed() {
	      return this.serviceClosed;
	    }
	  }, {
	    key: 'setWadgeAdvance',
	    value: function setWadgeAdvance($event) {
	      this.wageAdvance = $event;
	      this.log.info('Wadge advance is:', this.wageAdvance);
	      this.step = STEPS.RESUME;
	    }
	  }, {
	    key: 'isForm',
	    value: function isForm() {
	      return this.step === STEPS.FORM;
	    }
	  }, {
	    key: 'isResume',
	    value: function isResume() {
	      return this.step === STEPS.RESUME;
	    }
	  }, {
	    key: 'onCancel',
	    value: function onCancel($event) {
	      this.cancelAdvance = $event;
	      this.log.info('Cancel advance:', $event);
	      this.openModal(MODALS_WAGE_ADVANCE.CUESTION);
	    }
	  }, {
	    key: 'cancelResume',
	    value: function cancelResume() {
	      this.step = STEPS.FORM;
	    }
	  }, {
	    key: 'cancelWageAdvance',
	    value: function cancelWageAdvance() {
	      var _this2 = this;
	
	      this.loadingMobileService.show();
	      var wageAdvance = this.cancelAdvance.advance;
	      this.wageAdvanceService.deleteWageAdvance(this.userId, wageAdvance).then(function () {
	        _this2.openModal(MODALS_WAGE_ADVANCE.SUCCESS_DELETE);
	      }, function (error) {
	        _this2.messageError = error.data.message;
	        _this2.openModal(MODALS_WAGE_ADVANCE.FAILED_DELETE);
	      }).finally(function () {
	        _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'finishWageAdvance',
	    value: function finishWageAdvance($event) {
	      var _this3 = this;
	
	      this.loadingMobileService.show();
	      this.wageAdvanceService.postWagesAdvance(this.userId, $event).then(function () {
	        _this3.openModal(MODALS_WAGE_ADVANCE.SUCCESS);
	      }, function (error) {
	        _this3.messageError = error.data.message;
	        _this3.openModal(MODALS_WAGE_ADVANCE.FAILED);
	      }).finally(function () {
	        _this3.step = STEPS.FORM;
	        _this3.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(modal) {
	      this.modalToShow = modal;
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var isSuccess = this.modalToShow === MODALS_WAGE_ADVANCE.SUCCESS;
	      var isSuccessDelete = this.modalToShow === MODALS_WAGE_ADVANCE.SUCCESS_DELETE;
	      var closeNeedToRefresh = isSuccess || isSuccessDelete;
	
	      if (closeNeedToRefresh) {
	        return this.init();
	      }
	
	      this.step = STEPS.FORM;
	      this.cancelAdvance = null;
	      this.modal.modal('hide');
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return $(_constants.MODALS.WAGE_ADVANCE_MODAL);
	    }
	  }]);
	  return WageAdvanceController;
	}();
	
	exports.default = WageAdvanceController;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2109);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvance.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvance.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "wage-advance{display:block}wage-advance .responsiveMobile .wage-advance{padding:0 0 85px}wage-advance .wage-advance{padding:0 31px}wage-advance .wage-advance wage-advance-form{margin-bottom:34px}wage-advance .wage-advance .remove-events{pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _loans = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WageAdvanceService = function () {
	  WageAdvanceService.$inject = ["$http"];
	  function WageAdvanceService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WageAdvanceService);
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(WageAdvanceService, [{
	    key: 'getReasonsList',
	    value: function getReasonsList() {
	      var _this = this;
	
	      return this.http.get(_loans.ENDPOINTS_LOANS.get.wageAdvanceReasonsList()).then(function (response) {
	        return response.data.wagesAdvanceReasonsList.map(_this.formatReason);
	      });
	    }
	  }, {
	    key: 'formatReason',
	    value: function formatReason(reason) {
	      return {
	        option: reason.literal,
	        value: reason.code
	      };
	    }
	  }, {
	    key: 'getEmployeeWagesAdvance',
	    value: function getEmployeeWagesAdvance(employeeId) {
	      return this.http.get(_loans.ENDPOINTS_LOANS.get.employeeWagesAdvance(employeeId)).then(function (response) {
	        return response.data.employeeWagesAdvance;
	      });
	    }
	  }, {
	    key: 'postWagesAdvance',
	    value: function postWagesAdvance(employeeId, params) {
	      var wageAdvance = {
	        wagesAdvance: [{
	          amount: params.amount,
	          reasonCode: params.code
	        }]
	      };
	      return this.http.post(_loans.ENDPOINTS_LOANS.post.createWageAdvance(employeeId), wageAdvance);
	    }
	  }, {
	    key: 'deleteWageAdvance',
	    value: function deleteWageAdvance(employeeId, params) {
	      var config = {
	        data: {
	          wagesAdvance: [{
	            identifier: params.identifier,
	            statusCode: params.statusCode
	          }]
	        }
	      };
	      return this.http.delete(_loans.ENDPOINTS_LOANS.delete.deleteWageAdvance(employeeId), config);
	    }
	  }]);
	  return WageAdvanceService;
	}();
	
	exports.default = WageAdvanceService;

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WageAdvanceHelper = function () {
	  function WageAdvanceHelper() {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WageAdvanceHelper);
	  }
	
	  (0, _createClass3.default)(WageAdvanceHelper, [{
	    key: 'format',
	    value: function format(wagesAdvance) {
	      return wagesAdvance.map(this.wageAdvanceCanBeCancelled).sort(this.sortWagesAdvance);
	    }
	  }, {
	    key: 'sortWagesAdvance',
	    value: function sortWagesAdvance(wagesAdvanceA, wagesAdvanceB) {
	      var a = new Date(wagesAdvanceA.requestDate);
	      var b = new Date(wagesAdvanceB.requestDate);
	
	      if (a > b) {
	        return -1;
	      }
	
	      if (a < b) {
	        return 1;
	      }
	
	      return 0;
	    }
	  }, {
	    key: 'wageAdvanceCanBeCancelled',
	    value: function wageAdvanceCanBeCancelled(wageAdvance) {
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	      var requestDay = wageAdvance.requestDate;
	      wageAdvance.canBeCancelled = requestDay === today;
	      return wageAdvance;
	    }
	  }]);
	  return WageAdvanceHelper;
	}();
	
	exports.default = WageAdvanceHelper;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _wageAdvanceInfo = __webpack_require__(2113);
	
	var _wageAdvanceInfo2 = _interopRequireDefault(_wageAdvanceInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceInfoModule = _angular2.default.module('wageAdvanceInfo', []).component('wageAdvanceInfo', _wageAdvanceInfo2.default).name;
	
	exports.default = wageAdvanceInfoModule;

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _wageAdvanceInfo = __webpack_require__(2114);
	
	var _wageAdvanceInfo2 = _interopRequireDefault(_wageAdvanceInfo);
	
	var _wageAdvanceInfo3 = __webpack_require__(2115);
	
	var _wageAdvanceInfo4 = _interopRequireDefault(_wageAdvanceInfo3);
	
	__webpack_require__(2116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceInfoComponent = {
	  restrict: 'E',
	  bindings: {
	    isMobileApp: '<'
	  },
	  template: _wageAdvanceInfo2.default,
	  controller: _wageAdvanceInfo4.default
	};
	
	exports.default = wageAdvanceInfoComponent;

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"wage-advance-info\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <p>\n    {{ 'LOANS.WAGE_ADVANCE.DESC.ONE' | translate }}\n  </p>\n\n  <!--Desktop-->\n  <div ng-if=\"!$ctrl.isMobileApp\">\n    <p>\n      {{ 'LOANS.WAGE_ADVANCE.DESC.TWO' | translate }}\n    </p>\n    <p class=\"highlighted-text\">\n      {{ 'LOANS.WAGE_ADVANCE.DESC.THREE' | translate }}\n    </p>\n    <p>\n      {{ 'LOANS.WAGE_ADVANCE.DESC.FOUR' | translate }}\n    </p>\n    <ul>\n      <li>\n        {{ 'LOANS.WAGE_ADVANCE.DESC.FIVE' | translate }}\n      </li>\n      <li>\n        {{ 'LOANS.WAGE_ADVANCE.DESC.SIX' | translate }}\n      </li>\n    </ul>\n  </div>\n\n  <!--Mobile-->\n  <div ng-if=\"$ctrl.isMobileApp\" class=\"wage-advance-info-toggle\" ng-class=\"{ 'open': $ctrl.showInfo }\">\n    <span\n      ng-if=\"!$ctrl.isMobileApp\"\n      ng-show=\"$ctrl.showInfo\"\n      ng-click=\"$ctrl.toggleInfo()\"\n      class=\"icon icon-arrow-select-up\">\n    </span>\n    <span\n      ng-show=\"!$ctrl.showInfo\"\n      ng-click=\"$ctrl.toggleInfo()\"\n      class=\"icon icon-arrow-select-down\">\n    </span>\n\n    <div ng-show=\"$ctrl.showInfo\">\n      <p>\n        {{ 'LOANS.WAGE_ADVANCE.DESC.TWO' | translate }}\n      </p>\n      <p>\n        {{ 'LOANS.WAGE_ADVANCE.DESC.THREE' | translate }}\n      </p>\n      <p>\n        {{ 'LOANS.WAGE_ADVANCE.DESC.FOUR' | translate }}\n      </p>\n      <ul>\n        <li>\n          {{ 'LOANS.WAGE_ADVANCE.DESC.FIVE' | translate }}\n        </li>\n        <li>\n          {{ 'LOANS.WAGE_ADVANCE.DESC.SIX' | translate }}\n        </li>\n      </ul>      \n    </div>\n    <span\n      ng-if=\"$ctrl.isMobileApp\"\n      ng-show=\"$ctrl.showInfo\"\n      ng-click=\"$ctrl.toggleInfo()\"\n      class=\"icon icon-arrow-select-up\">\n    </span>\n  </div>\n</div>\n"

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WageAdvanceInfoController = function () {
	  WageAdvanceInfoController.$inject = ["$window"];
	  function WageAdvanceInfoController($window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WageAdvanceInfoController);
	    this.window = $window;
	  }
	
	  (0, _createClass3.default)(WageAdvanceInfoController, [{
	    key: 'toggleInfo',
	    value: function toggleInfo() {
	      if (this.showInfo) this.window.scrollTo(0, 0);
	      this.showInfo = !this.showInfo;
	    }
	  }]);
	  return WageAdvanceInfoController;
	}();
	
	exports.default = WageAdvanceInfoController;

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2117);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceInfo.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceInfo.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "wage-advance-info .wage-advance{padding:0 31px}wage-advance-info .wage-advance-info{padding-top:31px;margin-bottom:42px}wage-advance-info .wage-advance-info.mobile{padding-bottom:15px;border-bottom:1px solid #dddfe2}wage-advance-info .wage-advance-info.mobile .icon-arrow-select-down,wage-advance-info .wage-advance-info.mobile .icon-arrow-select-up{color:#0072c9}wage-advance-info .wage-advance-info.mobile p{text-align:left}wage-advance-info .wage-advance-info .wage-advance-info-toggle{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center}wage-advance-info .wage-advance-info .wage-advance-info-toggle .icon-arrow-select-down,wage-advance-info .wage-advance-info .wage-advance-info-toggle .icon-arrow-select-up{cursor:pointer}wage-advance-info .wage-advance-info li,wage-advance-info .wage-advance-info p{margin-bottom:10px;font-family:Stag Sans;font-size:15px;line-height:1.33;text-align:justify;color:#666}wage-advance-info .wage-advance-info ul{list-style:none}wage-advance-info .wage-advance-info ul li:before{content:\"- \"}wage-advance-info .wage-advance-info .highlighted-text{color:#333}", ""]);
	
	// exports


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _wageAdvanceForm = __webpack_require__(2119);
	
	var _wageAdvanceForm2 = _interopRequireDefault(_wageAdvanceForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceFormModule = _angular2.default.module('wageAdvanceForm', []).component('wageAdvanceForm', _wageAdvanceForm2.default).name;
	
	exports.default = wageAdvanceFormModule;

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _wageAdvanceForm = __webpack_require__(2120);
	
	var _wageAdvanceForm2 = _interopRequireDefault(_wageAdvanceForm);
	
	var _wageAdvanceForm3 = __webpack_require__(2121);
	
	var _wageAdvanceForm4 = _interopRequireDefault(_wageAdvanceForm3);
	
	__webpack_require__(2122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceFormComponent = {
	  restrict: 'E',
	  bindings: {
	    onSubmit: '&',
	    wageAdvanceReasonsList: '<',
	    checkServiceClosed: '&',
	    isMobileApp: '<'
	  },
	  template: _wageAdvanceForm2.default,
	  controller: _wageAdvanceForm4.default
	};
	
	exports.default = wageAdvanceFormComponent;

/***/ }),
/* 2120 */
/***/ (function(module, exports) {

	module.exports = "<form\n  name=\"$ctrl.form\"\n  ng-submit=\"$ctrl.submit()\"\n  ng-class=\"{ 'mobile': $ctrl.isMobileApp }\"\n  novalidate>\n\n  <label class=\"medium blue\" ng-if=\"$ctrl.isMobileApp\">\n    {{ 'LOANS.WAGE_ADVANCE.FORM.AMOUNT' | translate }}\n  </label>\n\n  <input\n    type=\"text\"\n    name=\"wageAdvanceAmount\"\n    ng-model=\"$ctrl.wageAdvanceAmount\"\n    currency-input\n    required\n    placeholder=\"{{ 'LOANS.WAGE_ADVANCE.FORM.PLACEHOLDER' | translate }}\"\n    ng-disabled=\"$ctrl.checkServiceClosed()\"\n    ng-class=\"{ 'amount': $ctrl.isMobileApp, 'mobile': $ctrl.isMobileApp }\"\n    ng-keypress=\"$ctrl.onKeyPressEnter($event)\"/>\n\n  <label class=\"medium blue\" ng-if=\"$ctrl.isMobileApp\">\n    {{ 'LOANS.WAGE_ADVANCE.FORM.REASON' | translate }}\n  </label>\n\n  <select-app\n    name=\"wageAdvanceReasonsList\"\n    options=\"$ctrl.wageAdvanceReasonsList\"\n    disabled=\"$ctrl.wageAdvanceReasonsListIsDisabled()\"\n    required=\"true\"\n    placeholder=\"{{ 'LOANS.NEED_A_LOAN.CARD_SIMULATION.SELECT' | translate }}\"\n    on-select=\"$ctrl.onSelectWageAdvanceReason($event);\">\n  </select-app>\n\n  <button\n    ng-if=\"!$ctrl.isMobileApp\"\n    ng-disabled=\"$ctrl.form.$invalid\"\n    type=\"submit\"\n    class=\"btn btn-primary btn-app\">\n    {{ 'LOANS.WAGE_ADVANCE.FORM.ASK' | translate }}\n  </button>\n\n  <floating-action-buttons\n    ng-if=\"$ctrl.isMobileApp\"\n    buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.submit()\">\n  </floating-action-buttons>\n\n</form>\n"

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WageAdvanceFormController = function () {
	  WageAdvanceFormController.$inject = ["EventEmitter", "$scope"];
	  function WageAdvanceFormController(EventEmitter, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WageAdvanceFormController);
	    this.eventEmitter = EventEmitter;
	    this.scope = $scope;
	  }
	
	  (0, _createClass3.default)(WageAdvanceFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	        this.setFloatingActionButtonsDisabled();
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.onSubmit(this.eventEmitter(this.getFormData()));
	    }
	  }, {
	    key: 'getFormData',
	    value: function getFormData() {
	      return {
	        wageAdvanceAmount: this.wageAdvanceAmount,
	        wageAdvanceReason: this.wageAdvanceReason,
	        wageAdvanceOption: this.wageAdvanceOption
	      };
	    }
	  }, {
	    key: 'onSelectWageAdvanceReason',
	    value: function onSelectWageAdvanceReason($event) {
	      this.wageAdvanceReason = $event.$item.value;
	      this.wageAdvanceOption = $event.$item.option;
	    }
	  }, {
	    key: 'wageAdvanceReasonsListIsDisabled',
	    value: function wageAdvanceReasonsListIsDisabled() {
	      return !this.wageAdvanceReasonsList || this.wageAdvanceReasonsList.length === 0;
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'LOANS.WAGE_ADVANCE.FORM.ASK',
	        disabled: true
	      }];
	    }
	  }, {
	    key: 'setFloatingActionButtonsDisabled',
	    value: function setFloatingActionButtonsDisabled() {
	      var _this = this;
	
	      this.scope.$watch(function () {
	        return _this.form.$invalid;
	      }, function (newValue) {
	        _this.floatingActionButtons[0].disabled = newValue;
	      });
	    }
	  }, {
	    key: 'onKeyPressEnter',
	    value: function onKeyPressEnter($event) {
	      if ($event.keyCode === 13) {
	        $event.target.blur();
	      }
	    }
	  }]);
	  return WageAdvanceFormController;
	}();
	
	exports.default = WageAdvanceFormController;

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2123);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceForm.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceForm.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "wage-advance-form{display:block}wage-advance-form form{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start}wage-advance-form form input{width:230px;margin-right:30px}wage-advance-form form select-app{width:452px;margin-right:30px}wage-advance-form form.mobile{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}wage-advance-form form.mobile input{width:100%;margin:20px 0 30px}wage-advance-form form.mobile label{font-size:16px}wage-advance-form form.mobile select-app{width:100%;margin-right:0;margin-top:20px}", ""]);
	
	// exports


/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _wageAdvanceList = __webpack_require__(2125);
	
	var _wageAdvanceList2 = _interopRequireDefault(_wageAdvanceList);
	
	var _wageAdvanceCard = __webpack_require__(2129);
	
	var _wageAdvanceCard2 = _interopRequireDefault(_wageAdvanceCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceListModule = _angular2.default.module('wageAdvanceList', [_wageAdvanceCard2.default]).component('wageAdvanceList', _wageAdvanceList2.default).name;
	
	exports.default = wageAdvanceListModule;

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _wageAdvanceList = __webpack_require__(2126);
	
	var _wageAdvanceList2 = _interopRequireDefault(_wageAdvanceList);
	
	__webpack_require__(2127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceListComponent = {
	  restrict: 'E',
	  bindings: {
	    employeeWagesAdvance: '<',
	    onCancel: '&',
	    isMobileApp: '<'
	  },
	  template: _wageAdvanceList2.default
	};
	
	exports.default = wageAdvanceListComponent;

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"wage-advance-list-content\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <section-title\n    text=\"{{ 'LOANS.WAGE_ADVANCE.LIST.TITLE' | translate }}\"\n    ng-if=\"!$ctrl.isMobileApp\">\n  </section-title>\n\n  <label class=\"medium blue\" ng-if=\"$ctrl.isMobileApp\">\n    {{ 'LOANS.WAGE_ADVANCE.LIST.TITLE' | translate }}\n  </label>\n\n  <p class=\"subtitle\">\n    {{ 'LOANS.WAGE_ADVANCE.LIST.SUBTITLE' | translate }}\n  </p>\n\n  <p class=\"subtitle empty\" ng-if=\"$ctrl.employeeWagesAdvance.length === 0\">\n    {{ 'LOANS.WAGE_ADVANCE.LIST.EMPTY' | translate }}\n  </p>\n\n  <wage-advance-card\n    ng-repeat=\"advance in $ctrl.employeeWagesAdvance\"\n    advance=\"advance\"\n    is-mobile-app=\"$ctrl.isMobileApp\"\n    on-cancel=\"$ctrl.onCancel({$event: $event})\">\n  </wage-advance-card>\n\n</div>\n"

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2128);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceList.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "wage-advance-list .subtitle{font-family:Stag Sans;font-size:15px;line-height:1;text-align:justify;color:#666;margin:13px 0 30px}wage-advance-list wage-advance-card .wage-advance-card:last-child{border-bottom:1px solid #dddfe2}wage-advance-list .wage-advance-list-content.mobile label{font-size:16px}wage-advance-list .wage-advance-list-content.mobile .subtitle{font-size:13px}", ""]);
	
	// exports


/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _wageAdvanceCard = __webpack_require__(2130);
	
	var _wageAdvanceCard2 = _interopRequireDefault(_wageAdvanceCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceCardModule = _angular2.default.module('wageAdvanceCard', []).component('wageAdvanceCard', _wageAdvanceCard2.default).name;
	
	exports.default = wageAdvanceCardModule;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _wageAdvanceCard = __webpack_require__(2131);
	
	var _wageAdvanceCard2 = _interopRequireDefault(_wageAdvanceCard);
	
	var _wageAdvanceCard3 = __webpack_require__(2132);
	
	var _wageAdvanceCard4 = _interopRequireDefault(_wageAdvanceCard3);
	
	__webpack_require__(2133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceCardComponent = {
	  restrict: 'E',
	  bindings: {
	    advance: '<',
	    onCancel: '&',
	    isMobileApp: '<'
	  },
	  template: _wageAdvanceCard2.default,
	  controller: _wageAdvanceCard4.default
	};
	
	exports.default = wageAdvanceCardComponent;

/***/ }),
/* 2131 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"wage-advance-card\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <!-- Date and mobile status -->\n  <div class=\"column date\">\n    <p class=\"header-text\">\n      {{ $ctrl.advance.requestDate | date:'MMMM yyyy' }}\n    </p>\n    <p class=\"request-date\">\n      <span class=\"icon icon-calendar\"></span>\n      {{ 'LOANS.WAGE_ADVANCE.CARD.DATE' | translate }} {{ $ctrl.advance.requestDate | slashDate }}\n    </p>\n    <p class=\"status-literal\" ng-if=\"$ctrl.isMobileApp\">\n      {{ $ctrl.advance.statusLiteral }}\n    </p>\n  </div>\n\n  <!-- Amount and mobile cancel -->\n  <div class=\"column amount\">\n    <p class=\"header-text\">\n      {{ $ctrl.advance.amount | currency }}\n    </p>\n    <p class=\"status-literal\" ng-if=\"!$ctrl.isMobileApp\">\n      {{ $ctrl.advance.statusLiteral }}\n    </p>\n    <div class=\"cancel\" ng-click=\"$ctrl.cancel()\" ng-if=\"$ctrl.isMobileApp && $ctrl.advance.canBeCancelled\">\n      <span class=\"icon icon-cross\"></span>\n      <span>\n        {{ 'GLOBALS.BUTTON_ACTION.ANNUL' | translate }}\n      </span>\n    </div>\n  </div>\n\n  <!-- Desktop actions -->\n  <div class=\"column actions\" ng-if=\"!$ctrl.isMobileApp\">\n    <div class=\"cancel\" ng-click=\"$ctrl.cancel()\" ng-if=\"$ctrl.advance.canBeCancelled\">\n      <span class=\"icon icon-cross\"></span>\n      <span>\n        {{ 'GLOBALS.BUTTON_ACTION.ANNUL' | translate }}\n      </span>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WageAdvanceCardController = function () {
	  WageAdvanceCardController.$inject = ["EventEmitter"];
	  function WageAdvanceCardController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WageAdvanceCardController);
	    this.eventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(WageAdvanceCardController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.onCancel(this.eventEmitter({ advance: this.advance }));
	    }
	  }]);
	  return WageAdvanceCardController;
	}();
	
	exports.default = WageAdvanceCardController;

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2134);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceCard.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "wage-advance-card .wage-advance-card{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;-ms-flex-align:center;-moz-align-items:center;align-items:center;border-top:1px solid #dddfe2;height:105px;padding:23px 30px;width:100%}wage-advance-card .wage-advance-card.mobile{padding:15px 0}wage-advance-card .wage-advance-card.mobile .column{-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;width:auto;height:100%}wage-advance-card .wage-advance-card.mobile .column p.header-text{font-size:16px}wage-advance-card .wage-advance-card.mobile .column p.request-date,wage-advance-card .wage-advance-card.mobile .column p.status-literal{font-size:12px}wage-advance-card .wage-advance-card.mobile .column .cancel{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}wage-advance-card .wage-advance-card.mobile .column .cancel span{font-size:12px}wage-advance-card .wage-advance-card.mobile .column .cancel .icon{font-size:8px;color:#666}wage-advance-card .wage-advance-card.mobile .column.amount{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;width:100%}wage-advance-card .wage-advance-card.mobile .column.amount .header-text{text-align:right}wage-advance-card .wage-advance-card .column{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}wage-advance-card .wage-advance-card .column p{font-family:ArialMT;font-size:15px;line-height:1;text-align:left;color:#666}wage-advance-card .wage-advance-card .column p.header-text{font-family:Stag Sans;font-size:24px;line-height:1;text-align:left;color:#0072c9}wage-advance-card .wage-advance-card .column .cancel{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}wage-advance-card .wage-advance-card .column .cancel span{font-family:Stag Sans;font-size:15px;color:#0072c9}wage-advance-card .wage-advance-card .column .cancel span.icon{display:inline-block;margin-right:5px}wage-advance-card .wage-advance-card .column.date{width:375px}wage-advance-card .wage-advance-card .column.date .icon-calendar{color:#0072c9}wage-advance-card .wage-advance-card .column.actions{cursor:pointer;margin-left:auto}", ""]);
	
	// exports


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _wageAdvanceResume = __webpack_require__(2136);
	
	var _wageAdvanceResume2 = _interopRequireDefault(_wageAdvanceResume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceResumeModule = _angular2.default.module('wageAdvanceResume', []).component('wageAdvanceResume', _wageAdvanceResume2.default).name;
	
	exports.default = wageAdvanceResumeModule;

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _wageAdvanceResume = __webpack_require__(2137);
	
	var _wageAdvanceResume2 = _interopRequireDefault(_wageAdvanceResume);
	
	var _wageAdvanceResume3 = __webpack_require__(2138);
	
	var _wageAdvanceResume4 = _interopRequireDefault(_wageAdvanceResume3);
	
	__webpack_require__(2139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceResumeComponent = {
	  restrict: 'E',
	  bindings: {
	    wageAdvance: '<',
	    finishWageAdvance: '&',
	    cancelWageAdvance: '&',
	    isMobileApp: '<'
	  },
	  template: _wageAdvanceResume2.default,
	  controller: _wageAdvanceResume4.default
	};
	
	exports.default = wageAdvanceResumeComponent;

/***/ }),
/* 2137 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"wage-advance-resume\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <div class=\"wage-advance-resume-row\">\n    <span class=\"wage-advance-resume-label\">\n      {{ 'LOANS.WAGE_ADVANCE.RESUME.REASON' | translate }}\n    </span>\n    <div>\n      <span ng-if=\"!$ctrl.isMobileApp\" class=\"wage-advance-resume-text reason\">{{ $ctrl.wageAdvance.wageAdvanceOption | capitalizeFirst}}</span>\n      <span ng-if=\"$ctrl.isMobileApp\" class=\"wage-advance-resume-text reason\">{{ $ctrl.wageAdvance.wageAdvanceOption | uppercase}}</span>\n    </div>\n  </div>\n\n  <div class=\"wage-advance-resume-row\">\n    <span class=\"wage-advance-resume-label\">{{ 'LOANS.WAGE_ADVANCE.RESUME.AMOUNT' | translate }}</span>\n    <div>\n      <span class=\"wage-advance-resume-text amount\">{{ $ctrl.wageAdvance.wageAdvanceAmount | currency }}</span>\n    </div>\n  </div>\n</div>\n\n<div ng-if=\"!$ctrl.isMobileApp\" class=\"wage-advance-resume-buttons\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 text-right\">\n      <button\n        class=\"btn btn-app btn-default\"\n        ng-click=\"$ctrl.cancelWageAdvance()\">\n        {{ 'GLOBALS.BUTTON_ACTION.CANCEL' | translate }}\n      </button>\n      <button\n        class=\"btn btn-app btn-primary\"\n        ng-click=\"$ctrl.clickOnFinish()\">\n        {{ 'GLOBALS.BUTTON_ACTION.FINISH' | translate }}\n      </button>\n    </div>\n  </div>\n</div>\n\n<floating-action-buttons\n  ng-if=\"$ctrl.isMobileApp\"\n  buttons=\"$ctrl.floatingActionButtons\"\n  on-click-first-button=\"$ctrl.clickOnFinish()\"\n  on-click-second-button=\"$ctrl.cancelWageAdvance()\">\n</floating-action-buttons>\n"

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WageAdvanceResumeController = function () {
	  WageAdvanceResumeController.$inject = ["EventEmitter"];
	  function WageAdvanceResumeController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WageAdvanceResumeController);
	    this.eventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(WageAdvanceResumeController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.isMobileApp) {
	        this.floatingActionButtons = this.getFloatingActionButtons();
	      }
	    }
	  }, {
	    key: 'clickOnFinish',
	    value: function clickOnFinish() {
	      this.finishWageAdvance(this.eventEmitter({
	        code: this.wageAdvance.wageAdvanceReason,
	        amount: this.wageAdvance.wageAdvanceAmount
	      }));
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.FINISH'
	      }, {
	        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
	      }];
	    }
	  }]);
	  return WageAdvanceResumeController;
	}();
	
	exports.default = WageAdvanceResumeController;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2140);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceResume.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceResume.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "wage-advance-resume .wage-advance-resume{padding-top:31px}wage-advance-resume .wage-advance-resume.mobile .wage-advance-resume-row>div{width:100%;text-align:right}wage-advance-resume .wage-advance-resume.mobile .amount,wage-advance-resume .wage-advance-resume.mobile .reason{font-size:13px}wage-advance-resume .wage-advance-resume-row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;height:38px;margin-bottom:18px}wage-advance-resume .wage-advance-resume-label{color:#0072c9;display:inline-block;font-family:Stag Sans;font-size:13px;font-weight:400;line-height:1;text-transform:uppercase;width:195px}wage-advance-resume .wage-advance-resume-text{color:#666;font-family:Stag Sans;font-size:15px;font-weight:400;line-height:1}wage-advance-resume .wage-advance-resume-buttons .btn-default{margin-right:15px}", ""]);
	
	// exports


/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _wageAdvanceModal = __webpack_require__(2142);
	
	var _wageAdvanceModal2 = _interopRequireDefault(_wageAdvanceModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceModalModule = _angular2.default.module('wageAdvanceModal', []).component('wageAdvanceModal', _wageAdvanceModal2.default).name;
	
	exports.default = wageAdvanceModalModule;

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _wageAdvanceModal = __webpack_require__(2143);
	
	var _wageAdvanceModal2 = _interopRequireDefault(_wageAdvanceModal);
	
	var _wageAdvanceModal3 = __webpack_require__(2144);
	
	var _wageAdvanceModal4 = _interopRequireDefault(_wageAdvanceModal3);
	
	__webpack_require__(2145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wageAdvanceModalComponent = {
	  restrict: 'E',
	  bindings: {
	    modalToShow: '<',
	    messageError: '<',
	    closeModal: '&',
	    cancelWageAdvance: '&',
	    isMobileApp: '<'
	  },
	  template: _wageAdvanceModal2.default,
	  controller: _wageAdvanceModal4.default
	};
	
	exports.default = wageAdvanceModalComponent;

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\" id=\"wageAdvanceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"wageAdvanceModalLabel\">\n  <div class=\"modal-dialog\">\n\n    <successful-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.getModalShow($ctrl.states.SUCCESS)\"\n      title=\"{{ 'LOANS.WAGE_ADVANCE.MODAL.SUCCESS.TITLE' | translate }}\"\n      message=\"{{ 'LOANS.WAGE_ADVANCE.MODAL.SUCCESS.DESC' | translate }}\"\n      on-dismiss=\"$ctrl.closeModal()\"\n      close-modal=\"true\">\n    </successful-action>\n\n    <failed-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.getModalShow($ctrl.states.FAILED)\"\n      title=\"{{ 'LOANS.WAGE_ADVANCE.MODAL.FAILED.TITLE' | translate }}\"\n      description=\"{{ $ctrl.messageError || ('LOANS.WAGE_ADVANCE.MODAL.FAILED.DESC' | translate) }}\"\n      close-modal=\"true\"\n      on-dismiss=\"$ctrl.closeModal()\"\n      button-text=\"{{ 'GLOBALS.BUTTON_ACTION.CLOSE' | translate }}\">\n    </failed-action>\n\n    <confirm-close-modal\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.getModalShow($ctrl.states.CUESTION)\"\n      title-modal=\"{{ 'LOANS.WAGE_ADVANCE.MODAL.CUESTION.TITLE' | translate }}\"\n      small-description=\"{{ 'LOANS.WAGE_ADVANCE.MODAL.CUESTION.DESC' | translate }}\"\n      button-yes=\"true\"\n      on-confirm=\"$ctrl.cancelWageAdvance()\"\n      button-no=\"true\"\n      on-click-no=\"$ctrl.closeModal()\">\n    </confirm-close-modal>\n\n    <successful-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.getModalShow($ctrl.states.SUCCESS_DELETE)\"\n      title=\"{{ 'LOANS.WAGE_ADVANCE.MODAL.SUCCESS.TITLE2' | translate }}\"\n      message=\"{{ 'LOANS.WAGE_ADVANCE.MODAL.SUCCESS.DESC2' | translate }}\"\n      on-dismiss=\"$ctrl.closeModal()\"\n      close-modal=\"true\">\n    </successful-action>\n\n    <failed-action\n      is-mobile-app=\"$ctrl.isMobileApp\"\n      ng-if=\"$ctrl.getModalShow($ctrl.states.FAILED_DELETE)\"\n      title=\"{{ 'LOANS.WAGE_ADVANCE.MODAL.FAILED.TITLE' | translate }}\"\n      description=\"{{ $ctrl.messageError || ('LOANS.WAGE_ADVANCE.MODAL.FAILED.DESC2' | translate) }}\"\n      on-dismiss=\"$ctrl.closeModal()\"\n      close-modal=\"true\"\n      button-text=\"{{ 'GLOBALS.BUTTON_ACTION.CLOSE' | translate }}\">\n    </failed-action>\n\n  </div>\n</div>\n"

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATES = {
	  SUCCESS: 'success',
	  FAILED: 'failed',
	  CUESTION: 'cuestion',
	  SUCCESS_DELETE: 'success-delete',
	  FAILED_DELETE: 'failed-delete'
	};
	
	var WageAdvanceModalController = function () {
	  function WageAdvanceModalController() {
	    (0, _classCallCheck3.default)(this, WageAdvanceModalController);
	
	    this.states = STATES;
	  }
	
	  (0, _createClass3.default)(WageAdvanceModalController, [{
	    key: 'getModalShow',
	    value: function getModalShow(item) {
	      return this.modalToShow === item;
	    }
	  }]);
	  return WageAdvanceModalController;
	}();
	
	exports.default = WageAdvanceModalController;

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2146);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceModal.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./wageAdvanceModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "wage-advance-modal .modal:not(.responsiveMobile) .modal-content{margin-left:auto;margin-right:auto;margin-top:70px;padding:50px}wage-advance-modal .modal:not(.responsiveMobile) confirm-close-modal .modal-content,wage-advance-modal .modal:not(.responsiveMobile) failed-action .modal-content,wage-advance-modal .modal:not(.responsiveMobile) successful-action .modal-content{width:520px}wage-advance-modal .modal:not(.responsiveMobile) confirm-close-modal .modal-content .modal-body .description,wage-advance-modal .modal:not(.responsiveMobile) failed-action .modal-content .modal-body .description,wage-advance-modal .modal:not(.responsiveMobile) successful-action .modal-content .modal-body .description{max-width:100%}", ""]);
	
	// exports


/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansHeader = __webpack_require__(2148);
	
	var _loansHeader2 = _interopRequireDefault(_loansHeader);
	
	var _sectionTitle = __webpack_require__(2153);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	var _loansAmountSimulation = __webpack_require__(2158);
	
	var _loansAmountSimulation2 = _interopRequireDefault(_loansAmountSimulation);
	
	var _cadastralReferenceForm = __webpack_require__(2170);
	
	var _cadastralReferenceForm2 = _interopRequireDefault(_cadastralReferenceForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansComponents = angular.module('loans.components', [_loansHeader2.default, _sectionTitle2.default, _loansAmountSimulation2.default, _cadastralReferenceForm2.default]).name;
	
	exports.default = loansComponents;

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansHeader = __webpack_require__(2149);
	
	var _loansHeader2 = _interopRequireDefault(_loansHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansHeaderModule = _angular2.default.module('loansHeader', []).component('loansHeader', _loansHeader2.default).name;
	
	exports.default = loansHeaderModule;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansHeader = __webpack_require__(2150);
	
	var _loansHeader2 = _interopRequireDefault(_loansHeader);
	
	__webpack_require__(2151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansHeaderComponent = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {
	    title: '@'
	  },
	  template: _loansHeader2.default
	};
	
	exports.default = loansHeaderComponent;

/***/ }),
/* 2150 */
/***/ (function(module, exports) {

	module.exports = "<header>\n  <h1>{{ $ctrl.title }}</h1>\n  <div>\n    <ng-transclude></ng-transclude>\n  </div>\n</header>\n"

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2152);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansHeader.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansHeader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-header{display:block;margin-left:-15px;margin-right:-15px}loans-header.mobile{margin-left:-30px;margin-right:-30px}loans-header.mobile header{height:60px}loans-header.mobile header h1{font-size:18px}loans-header header{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;background-color:#49a5e6;height:111px;max-width:1200px;padding:33px 30px;width:100%}loans-header header h1{color:#fff;font-size:34px;font-weight:300;line-height:1.32;margin:0}loans-header header .btn.btn-app.btn-default{height:48px;line-height:49px;padding:0;width:167px}", ""]);
	
	// exports


/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _sectionTitle = __webpack_require__(2154);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sectionTitleModule = _angular2.default.module('sectionTitle', []).component('sectionTitle', _sectionTitle2.default).name;
	
	exports.default = sectionTitleModule;

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sectionTitle = __webpack_require__(2155);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	__webpack_require__(2156);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sectionTitleComponent = {
	  restrict: 'E',
	  bindings: {
	    text: '@',
	    isMobileApp: '<'
	  },
	  template: _sectionTitle2.default
	};
	
	exports.default = sectionTitleComponent;

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

	module.exports = "<header ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <h2>{{ $ctrl.text }}</h2>\n</header>\n"

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2157);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./sectionTitle.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./sectionTitle.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "section-title{display:block}section-title h2{color:#0072c9;font-family:Stag Sans;font-size:24px;font-weight:400;margin:20px 0 0}section-title header.mobile h2{color:#0072c9;font-family:Stag Sans;font-size:16px}", ""]);
	
	// exports


/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansAmountSimulation = __webpack_require__(2159);
	
	var _loansAmountSimulation2 = _interopRequireDefault(_loansAmountSimulation);
	
	var _loansAmountSimulationErrors = __webpack_require__(2164);
	
	var _loansAmountSimulationErrors2 = _interopRequireDefault(_loansAmountSimulationErrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansAmountSimulationModule = _angular2.default.module('loansAmountSimulation', [_loansAmountSimulationErrors2.default]).component('loansAmountSimulation', _loansAmountSimulation2.default).name;
	
	exports.default = loansAmountSimulationModule;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansAmountSimulation = __webpack_require__(2160);
	
	var _loansAmountSimulation2 = _interopRequireDefault(_loansAmountSimulation);
	
	var _loansAmountSimulation3 = __webpack_require__(2161);
	
	var _loansAmountSimulation4 = _interopRequireDefault(_loansAmountSimulation3);
	
	__webpack_require__(2162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansAmountSimulationComponent = {
	  restrict: 'E',
	  bindings: {
	    hasPrevalidation: '@',
	    preValid: '<',
	    loan: '<',
	    onSubmit: '&',
	    simulation: '<',
	    housingChange: '<',
	    housingLoan: '<',
	    onErrorInSelect: '&',
	    isMobileApp: '<',
	    housingWitness: '<',
	    codeOptionSelected: '<',
	    simulationWitness: '<',
	    initialCharges: '<',
	    shouldShowCreditCapacitySimulation: '<',
	    isHousingMandatoryPurpose: '<'
	  },
	  template: _loansAmountSimulation2.default,
	  controller: _loansAmountSimulation4.default
	};
	
	exports.default = loansAmountSimulationComponent;

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

	module.exports = "<loans-amount-simulation-errors ng-if=\"$ctrl.isMobileApp\" is-mobile-app=\"$ctrl.isMobileApp\"\n  is-click-on-submit=\"$ctrl.isClickOnSubmit\" errors=\"$ctrl.errors\">\n</loans-amount-simulation-errors>\n\n<form name=\"$ctrl.form\" ng-class=\"$ctrl.getFormClasses()\" ng-init=\"$ctrl.floatingActionButtonsService.run()\" novalidate>\n\n\n  <div class=\"amount-column pull-left\">\n    <label class=\"uppercase medium blue block\">\n      {{ 'LOANS.SIGN_UP.FORM_SIMULATION.HOW_MUCH_MONEY' | translate }}\n    </label>\n    <input type=\"text\" name=\"amount\" currency-input class=\"amount\"\n      ng-class=\"{'error-amount': $ctrl.showErrorAmount, 'mobile': $ctrl.isMobileApp}\" required ng-model=\"$ctrl.amount\"\n      ng-change=\"$ctrl.onChangeAmount()\">\n\n    <label class=\"uppercase medium blue block with-icon\" ng-if=\"$ctrl.adquisitionShouldAppear()\">\n      {{ 'LOANS.SIGN_UP.FORM_SIMULATION.ACQUISITION_COST' | translate }}\n      <tooltip-desktop ng-if=\"!$ctrl.isMobileApp\" placement=\"right\"\n        title=\"LOANS.SIGN_UP.TOOLTIPS.ACQUISITION_COST\"></tooltip-desktop>\n      <tooltip-mobile ng-if=\"$ctrl.isMobileApp\" name=\"loansAmountSimulationAcquisitionCost\">\n        <p class=\"tooltip-title\">\n          {{ 'LOANS.SIGN_UP.FORM_SIMULATION.ACQUISITION_COST' | translate }}\n        </p>\n        <p>{{ 'LOANS.SIGN_UP.TOOLTIPS.ACQUISITION_COST' | translate }}</p>\n      </tooltip-mobile>\n    </label>\n    <input ng-if=\"$ctrl.adquisitionShouldAppear()\" type=\"text\" name=\"acquisitionCost\" currency-input class=\"amount\"\n      ng-class=\"{'mobile': $ctrl.isMobileApp}\" required ng-model=\"$ctrl.acquisitionCost\"\n      ng-change=\"$ctrl.onChangeAcquisitionCost()\">\n\n    <div class=\"housing-change-fields\">\n\n      <label class=\"uppercase medium blue block with-icon newHomePrice\"\n        ng-if=\"$ctrl.shouldShowCreditCapacitySimulation\">\n        {{ 'LOANS.SIGN_UP.FORM_SIMULATION.ACQUISITION_COST_LOAN_ACTIVE' | translate }}\n      </label>\n      <input type=\"text\" name=\"newHomePrice\" currency-input class=\"amount\" ng-class=\"{'mobile': $ctrl.isMobileApp}\"\n        required ng-model=\"$ctrl.newHomePrice\" ng-change=\"$ctrl.onChangeNewHomePrice()\"\n        ng-if=\"$ctrl.shouldShowCreditCapacitySimulation\">\n\n\n      <label class=\"uppercase medium blue block with-icon\" ng-if=\"$ctrl.shouldShowCreditCapacitySimulation\">\n        {{ 'LOANS.SIGN_UP.FORM_SIMULATION.SALE_PRICE_LOAN_ACTIVE' | translate }}\n      </label>\n      <input type=\"text\" name=\"salePriceActive\" currency-input class=\"amount\" ng-class=\"{'mobile': $ctrl.isMobileApp}\"\n        required ng-model=\"$ctrl.salePriceActive\" ng-change=\"$ctrl.onChangeSalePriceActive()\"\n        ng-if=\"$ctrl.shouldShowCreditCapacitySimulation\">\n\n      <label class=\"uppercase medium blue block with-icon\"\n        ng-if=\"!$ctrl.simulationWitness && ($ctrl.housingWitness || $ctrl.housingChange) && $ctrl.isHousingMandatoryPurpose\">\n        {{ 'LOANS.SIGN_UP.FORM_SIMULATION.SALE_PRICE' | translate }}\n        <tooltip-desktop ng-if=\"!$ctrl.isMobileApp\" placement=\"right\" title=\"LOANS.SIGN_UP.TOOLTIPS.SALE_PRICE\">\n        </tooltip-desktop>\n        <tooltip-mobile ng-if=\"$ctrl.isMobileApp\" name=\"loansAmountSimulationSalePrice\">\n          <p class=\"tooltip-title\">\n            {{ 'LOANS.SIGN_UP.FORM_SIMULATION.SALE_PRICE' | translate }}\n          </p>\n          <p>\n            {{ 'LOANS.SIGN_UP.TOOLTIPS.SALE_PRICE' | translate }}\n          </p>\n        </tooltip-mobile>\n      </label>\n      <input type=\"text\" name=\"salePrice\" currency-input ng-init=\"$ctrl.floatingActionButtonsService.run()\"\n        class=\"amount\" ng-class=\"{'mobile': $ctrl.isMobileApp}\" required ng-model=\"$ctrl.salePrice\"\n        ng-change=\"$ctrl.onChangeSalePrice()\"\n        ng-if=\"!$ctrl.simulationWitness && ($ctrl.housingWitness || $ctrl.housingChange) && $ctrl.isHousingMandatoryPurpose\">\n\n      <label class=\"uppercase medium blue block with-icon\" ng-if=\"$ctrl.shouldShowCreditCapacitySimulation\">\n        {{ 'LOANS.SIGN_UP.FORM_SIMULATION.CHARGES' | translate }}\n        <tooltip-desktop ng-if=\"!$ctrl.isMobileApp\" placement=\"right\"\n          title=\"LOANS.SIGN_UP.TOOLTIPS.CHARGES\"></tooltip-desktop>\n        <tooltip-mobile ng-if=\"$ctrl.isMobileApp\" name=\"loansAmountSimulationCharges\">\n          <p class=\"tooltip-title\">\n            {{ 'LOANS.SIGN_UP.FORM_SIMULATION.CHARGES' | translate }}\n          </p>\n          <p>{{ 'LOANS.SIGN_UP.TOOLTIPS.CHARGES' | translate }}</p>\n        </tooltip-mobile>\n        <p class=\"description-text\">\n          ({{ 'LOANS.SIGN_UP.FORM_SIMULATION.PENDING_BALANCE' | translate }})\n        </p>\n      </label>\n      <input type=\"text\" name=\"charges\" class=\"amount\" ng-class=\"{'error-amount': $ctrl.errors.chargesError || $ctrl.errors.chargesBelowInitial,\n        'mobile': $ctrl.isMobileApp}\" required ng-if=\"$ctrl.shouldShowCreditCapacitySimulation\"\n        ng-model=\"$ctrl.formattedCharges\" ng-blur=\"$ctrl.onBlurCharges()\" ng-focus=\"$ctrl.onFocusCharges()\"\n        ng-change=\"$ctrl.onChangeCharges()\">\n\n      <label class=\"uppercase medium blue block\" ng-if=\"$ctrl.isHousingMandatoryPurpose\">\n        {{ 'LOANS.SIGN_UP.FORM_SIMULATION.DIFF' | translate }}\n      </label>\n\n      <p class=\"diff\" ng-show=\"$ctrl.isHousingMandatoryPurpose\">\n        {{ $ctrl.getDiff() | currency }}\n      </p>\n    </div>\n  </div>\n\n  <div class=\"fee-column pull-left\">\n    <div class=\"fee-radios\">\n      <div class=\"radio\">\n\n        <div class=\"single-radio\">\n          <input type=\"radio\" id=\"minimumFeeInMaxPeriod\" ng-model=\"$ctrl.feeType\" ng-change=\"$ctrl.onChangeFeeType()\"\n            value=\"minimumFeeInMaxPeriod\">\n          <label class=\"uppercase medium blue\" for=\"minimumFeeInMaxPeriod\">\n            {{ 'LOANS.SIGN_UP.FORM_SIMULATION.MINIMUM_FEE_IN_MAX_PERIOD' | translate }}\n          </label>\n        </div>\n\n        <div class=\"single-radio\">\n          <input type=\"radio\" id=\"monthlyFee\" ng-model=\"$ctrl.feeType\" ng-change=\"$ctrl.onChangeFeeType()\"\n            value=\"monthlyFee\">\n          <label class=\"uppercase medium blue\" for=\"monthlyFee\">\n            {{ 'LOANS.SIGN_UP.FORM_SIMULATION.MONTHLY_FEE' | translate }}\n          </label>\n          <input type=\"text\" ng-hide=\"$ctrl.hideMonthlyFeeAmount()\" ng-model=\"$ctrl.monthlyFeeAmount\"\n            ng-change=\"$ctrl.onChangeFeeType()\" name=\"monthlyFeeAmount\"\n            ng-required=\"!$ctrl.isDisabledMonthlyFeeAmount()\" ng-disabled=\"$ctrl.isDisabledMonthlyFeeAmount()\"\n            currency-input ng-init=\"$ctrl.floatingActionButtonsService.run()\"\n            ng-class=\"{'mobile': $ctrl.isMobileApp, 'small': !$ctrl.isMobileApp}\" class=\"amount\">\n        </div>\n\n        <div class=\"single-radio\">\n          <input type=\"radio\" id=\"fixedFeeNumber\" ng-model=\"$ctrl.feeType\" ng-change=\"$ctrl.onChangeFeeType()\"\n            value=\"fixedFeeNumber\">\n          <label class=\"uppercase medium blue\" for=\"fixedFeeNumber\">\n            {{ 'LOANS.SIGN_UP.FORM_SIMULATION.FEE_NUMBER' | translate }}\n          </label>\n          <input type=\"number\" name=\"fixedFeeNumber\" min=\"0\" step=\"1\"\n            onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-hide=\"$ctrl.hideFixedFeeNumber()\"\n            ng-focus=\"$ctrl.focusFixedFeeNumber()\" ng-model=\"$ctrl.fixedFeeNumber\" ng-change=\"$ctrl.onChangeFeeType()\"\n            ng-required=\"!$ctrl.isDisabledFixedFeeNumber()\" ng-disabled=\"$ctrl.isDisabledFixedFeeNumber()\"\n            ng-class=\"{'mobile': $ctrl.isMobileApp, 'small': !$ctrl.isMobileApp}\" class=\"amount\">\n        </div>\n\n      </div>\n    </div>\n  </div>\n\n  <div class=\"insurance-column pull-left\">\n    <label class=\"uppercase medium blue block with-icon\">\n      {{ 'LOANS.SIGN_UP.FORM_SIMULATION.WANT_INSURANCE' | translate }}\n      <tooltip-desktop ng-if=\"!$ctrl.isMobileApp\" placement=\"bottom\"\n        title=\"{{$ctrl.tooltipTitle()}}\"></tooltip-desktop>\n      <tooltip-mobile ng-if=\"$ctrl.isMobileApp\" name=\"loansAmountSimulationInsurance\">\n        <p class=\"tooltip-title\">\n          {{ 'LOANS.SIGN_UP.FORM_SIMULATION.WANT_INSURANCE' | translate }}\n        </p>\n        <p ng-if=\"$ctrl.isUsualHouseSelected() && !$ctrl.isSocialAgreementHousingLoan()\">\n          {{ 'LOANS.SIGN_UP.TOOLTIPS.SOCIAL_HOUSING_AGREEMENT.DETAILED_INSURANCE_INFO' | translate }}\n        </p>\n        <p ng-if=\"$ctrl.isSocialAgreementHousingLoan() && !$ctrl.isUsualHouseSelected()\">\n          {{ 'LOANS.SIGN_UP.TOOLTIPS.SOCIAL_HOUSING_AGREEMENT.DETAILED_INSURANCE_INFO2' | translate }}\n        </p>\n        <p ng-if=\"!$ctrl.isUsualHouseSelected() && !$ctrl.isSocialAgreementHousingLoan()\">\n          {{ 'LOANS.SIGN_UP.TOOLTIPS.INSURANCE_INFO' | translate }}\n        </p>\n      </tooltip-mobile>\n    </label>\n    <toggle-switch enabled=\"$ctrl.wantInsurance\" on-change=\"$ctrl.changeInsurance($event)\"\n      disabled=\"{{$ctrl.mandatoryInsurance()}}\" is-mobile-app=\"$ctrl.isMobileApp\">\n    </toggle-switch>\n  </div>\n\n  <div class=\"submit-column pull-left\" ng-if=\"!$ctrl.isMobileApp\">\n    <button type=\"submit\" ng-click=\"$ctrl.submit()\" class=\"btn btn-app btn-primary pull-right\" \n    ng-disabled=\"$ctrl.isSubmitting\">\n      <span ng-if=\"$ctrl.shouldShowCreditCapacitySimulation\">\n        {{ 'GLOBALS.BUTTON_ACTION.SIMULATE' | translate }}\n      </span>\n      <span ng-if=\"!$ctrl.shouldShowCreditCapacitySimulation\">\n        {{ 'GLOBALS.BUTTON_ACTION.CONTINUE' | translate }}\n      </span>\n    </button>\n  </div>\n  <floating-action-buttons ng-if=\"$ctrl.isMobileApp && !$ctrl.isNotInputFocus()\" buttons=\"$ctrl.floatingActionButtons\"\n    on-click-first-button=\"$ctrl.submit()\">\n  </floating-action-buttons>\n</form>\n<loans-amount-simulation-errors ng-if=\"!$ctrl.isMobileApp\" is-mobile-app=\"$ctrl.isMobileApp\"\n  is-click-on-submit=\"$ctrl.isClickOnSubmit\" errors=\"$ctrl.errors\">\n</loans-amount-simulation-errors>"

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _constantsLoans = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FEE_TYPES = {
	  MINIMUM_FEE_IN_MAX_PERIOD: 'minimumFeeInMaxPeriod',
	  MONTHLY_FEE: 'monthlyFee',
	  FIXED_FEE_NUMBER: 'fixedFeeNumber'
	};
	
	var LoansAmountSimulationController = function () {
	  LoansAmountSimulationController.$inject = ["EventEmitter", "$log", "floatingActionButtonsService", "$scope", "$timeout", "LoansUserDataService", "myLoansService"];
	  function LoansAmountSimulationController(EventEmitter, $log, floatingActionButtonsService, $scope, $timeout, LoansUserDataService, myLoansService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansAmountSimulationController);
	    this.EventEmitter = EventEmitter;
	    this.scope = $scope;
	    this.log = $log;
	    this.errors = {};
	    this.showErrorAmount = false;
	    this.floatingActionButtonsService = floatingActionButtonsService;
	    this.scope = $scope;
	    this.timeout = $timeout;
	    this.loansUserDataService = LoansUserDataService;
	    this.myLoansService = myLoansService;
	  }
	
	  (0, _createClass3.default)(LoansAmountSimulationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      this.amount = 0;
	      this.monthlyFeeAmount = 0;
	      this.fixedFeeNumber = 0;
	      this.acquisitionCost = 0;
	      this.salePrice = undefined;
	      this.diff = 0;
	      this.feeType = FEE_TYPES.MINIMUM_FEE_IN_MAX_PERIOD;
	      this.wantInsurance = false;
	      this.MAX_AMOUNT = 999999999.99;
	      this.isClickOnSubmit = false;
	      this.hasUserEditedCharges = false;
	      this.extraPendingAmount09 = 0;
	      this._myLoansLoadedFor09 = false;
	      this.chargesBase = this.initialCharges || 0;
	      this.isChargesFocused = false;
	      this._myLoansPromise = null;
	      this.recalcAfterChargesChange({ refreshInput: true });
	      this.minChargesBase = this.initialCharges || 0;
	
	      this.isSimulation = this.simulationWitness !== undefined ? this.simulationWitness : this.simulation && this.simulation.simulationWitness || false;
	
	      this.salePriceActive = 0;
	      this.newHomePrice = 0;
	
	      this.tooltipTitle();
	
	      if (this.simulation) {
	        this.assignOriginalValue(this.simulation);
	        this.setDiff();
	      }
	
	      if (this.isMobileApp) {
	        this.initFloatingActionButtons();
	      }
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changes) {
	
	      if (changes.shouldShowCreditCapacitySimulation && changes.shouldShowCreditCapacitySimulation.currentValue != null) {
	        this.shouldShowCreditCapacitySimulation = changes.shouldShowCreditCapacitySimulation.currentValue;
	
	        this.syncExtraPendingFlow();
	
	        if (this.isMobileApp) {
	          this.initFloatingActionButtons();
	        }
	      }
	
	      if (changes.codeOptionSelected && changes.codeOptionSelected.currentValue != null) {
	        this.codeOptionSelected = changes.codeOptionSelected.currentValue;
	        this.syncExtraPendingFlow();
	      }
	
	      if (changes.initialCharges && changes.initialCharges.currentValue != null) {
	        this.initialCharges = changes.initialCharges.currentValue;
	
	        if (!this.hasUserEditedCharges) {
	          var incoming = this.initialCharges || 0;
	
	          if (this.shouldApplyExtraPending()) {
	            var extra = this.extraPendingAmount09 || 0;
	            this.chargesBase = Math.max(0, incoming - extra);
	          } else {
	            this.chargesBase = incoming;
	          }
	          this.minChargesBase = this.chargesBase;
	        }
	
	        this.recalcAfterChargesChange({ refreshInput: true });
	      }
	    }
	  }, {
	    key: 'isPurpose09',
	    value: function isPurpose09() {
	      return this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
	    }
	  }, {
	    key: 'shouldApplyExtraPending',
	    value: function shouldApplyExtraPending() {
	      if (!this.shouldShowCreditCapacitySimulation) return false;
	
	      var v = this.codeOptionSelected;
	
	      return v === _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || v === _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || v === _constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'recalcAfterChargesChange',
	    value: function recalcAfterChargesChange() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$refreshInput = _ref.refreshInput,
	          refreshInput = _ref$refreshInput === undefined ? false : _ref$refreshInput;
	
	      this.updateChargesTotal();
	      if (refreshInput) this.refreshChargesInputIfPossible();
	      this.setDiff();
	      this.scope.$applyAsync && this.scope.$applyAsync();
	    }
	  }, {
	    key: 'resetExtraPending',
	    value: function resetExtraPending() {
	      this.extraPendingAmount09 = 0;
	      this._myLoansLoadedFor09 = false;
	      this._myLoansPromise = null;
	    }
	  }, {
	    key: 'syncExtraPendingFlow',
	    value: function syncExtraPendingFlow() {
	
	      if (this.shouldApplyExtraPending()) {
	        this.loadPendingAmountFor09();
	      } else {
	        this.resetExtraPending();
	        this.recalcAfterChargesChange({ refreshInput: true });
	      }
	    }
	  }, {
	    key: 'updateChargesTotal',
	    value: function updateChargesTotal() {
	      if (this.shouldApplyExtraPending()) {
	        this.charges = (this.chargesBase || 0) + (this.extraPendingAmount09 || 0);
	      } else {
	        this.charges = this.chargesBase || 0;
	      }
	      this.formattedCharges = this.formatToCurrency(this.charges);
	    }
	  }, {
	    key: 'loadPendingAmountFor09',
	    value: function loadPendingAmountFor09() {
	      var _this = this;
	
	      if (!this.shouldApplyExtraPending()) return;
	      if (this._myLoansLoadedFor09) return;
	
	      var employeeId = this.loansUserDataService._employee.userId;
	
	      if (this._myLoansPromise) return;
	
	      this._myLoansPromise = this.myLoansService.getMyLoans(employeeId).then(function (loansList) {
	
	        var loan = loansList.find(function (l) {
	          return (l.statusCode === _constantsLoans.LOANS.STATES.ID.IN_FORCE || l.statusCode === _constantsLoans.LOANS.STATES.ID.SUBSCRIBER) && String(l.purposeCode) === String(_constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE) && (String(l.modalityCode) === String(_constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN) || String(l.modalityCode) === String(_constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN));
	        });
	
	        var newExtra = loan ? loan.amountPending : 0;
	
	        _this._myLoansLoadedFor09 = true;
	        _this._myLoansPromise = null;
	
	        if (newExtra !== _this.extraPendingAmount09) {
	          _this.extraPendingAmount09 = newExtra;
	
	          if (!_this.hasUserEditedCharges) {
	            var incoming = _this.initialCharges || 0;
	            _this.chargesBase = Math.max(0, incoming - newExtra);
	            _this.minChargesBase = _this.chargesBase;
	          }
	
	          _this.recalcAfterChargesChange({ refreshInput: true });
	        }
	      }).catch(function (err) {
	        _this.log.error('Error fetching myLoans:', err);
	        _this.extraPendingAmount09 = 0;
	        _this._myLoansLoadedFor09 = false;
	        _this._myLoansPromise = null;
	        _this.recalcAfterChargesChange({ refreshInput: true });
	      });
	    }
	  }, {
	    key: 'formatToCurrency',
	    value: function formatToCurrency(value) {
	      if (value == null || isNaN(value)) return '';
	      return value.toLocaleString('es-ES', {
	        style: 'currency',
	        currency: 'EUR'
	      });
	    }
	  }, {
	    key: 'parseCurrencyInput',
	    value: function parseCurrencyInput(input) {
	      if (!input) return 0;
	      var raw = input.replace(/[€.]/g, '').replace(/\./g, '').replace(',', '.').trim();
	      return parseFloat(raw);
	    }
	  }, {
	    key: 'onBlurCharges',
	    value: function onBlurCharges() {
	      this.isChargesFocused = false;
	      this.hasUserEditedCharges = true;
	      var total = this.parseCurrencyInput(this.formattedCharges);
	      var currentTotal = Number(this.charges) || 0;
	      var changed = Math.abs(total - currentTotal) > 0.009;
	
	      if (!changed) {
	
	        this.formattedCharges = this.formatToCurrency(this.charges);
	        return;
	      }
	
	      this.hasUserEditedCharges = true;
	
	      if (this.shouldApplyExtraPending()) {
	        this.chargesBase = total - (this.extraPendingAmount09 || 0);
	      } else {
	        this.chargesBase = total;
	      }
	
	      this.updateChargesTotal();
	      this.checkCharges(true);
	      this.setDiff();
	    }
	  }, {
	    key: 'onFocusCharges',
	    value: function onFocusCharges() {
	      this.isChargesFocused = true;
	      this.formattedCharges = this.charges.toString().replace('.', ',');
	    }
	  }, {
	    key: 'isUsualHouseSelected',
	    value: function isUsualHouseSelected() {
	      return this.housingLoan && (this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN);
	    }
	  }, {
	    key: 'isSocialAgreementHousingLoan',
	    value: function isSocialAgreementHousingLoan() {
	      return this.loan && this.loan.id === _constantsLoans.LOANS.ID.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'tooltipTitle',
	    value: function tooltipTitle() {
	      var title = null;
	
	      if (this.isUsualHouseSelected()) {
	        title = '{{ "LOANS.SIGN_UP.TOOLTIPS.SOCIAL_HOUSING_AGREEMENT.DETAILED_INSURANCE_INFO" | translate }}';
	      } else if (this.isSocialAgreementHousingLoan()) {
	        title = '{{ "LOANS.SIGN_UP.TOOLTIPS.SOCIAL_HOUSING_AGREEMENT.DETAILED_INSURANCE_INFO2" | translate }}';
	      } else {
	        title = '{{ "LOANS.SIGN_UP.TOOLTIPS.INSURANCE_INFO" | translate }}';
	      }
	
	      return title;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.amount = 0;
	      this.monthlyFeeAmount = 0;
	      this.fixedFeeNumber = 0;
	      this.acquisitionCost = 0;
	      this.salePrice = undefined;
	      this.diff = 0;
	      this.feeType = FEE_TYPES.MINIMUM_FEE_IN_MAX_PERIOD;
	      this.wantInsurance = false;
	      this.MAX_AMOUNT = 999999999.99;
	      this.isClickOnSubmit = false;
	    }
	  }, {
	    key: 'getFormClasses',
	    value: function getFormClasses() {
	      return {
	        'not-submit': !this.isClickOnSubmit
	      };
	    }
	  }, {
	    key: 'resetErrors',
	    value: function resetErrors() {
	      this.errors = {};
	      this.showErrorAmount = false;
	    }
	  }, {
	    key: 'timeOutSubmit',
	    value: function timeOutSubmit() {
	      var _this2 = this;
	
	      if (!this.isHousingMandatoryPurpose) {
	        this.timeout(function () {
	          _this2.isSubmitting = false;
	          _this2._setFloatingButtonDisabled(false);
	          _this2.scope.$applyAsync && _this2.scope.$applyAsync();
	        }, 4000);
	      } else {
	        this.isSubmitting = false;
	        this._setFloatingButtonDisabled(false);
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      if (this.isSubmitting) {
	        return;
	      }
	      if (this.form && this.form.charges && !this.isChargesFocused) {
	        this.onBlurCharges();
	      }
	      this.isSubmitting = true;
	      this._setFloatingButtonDisabled(true);
	
	      this.isClickOnSubmit = true;
	
	      this.resetErrors();
	
	      if (this.submitIsDisabled(this.isClickOnSubmit)) {
	        this.scope.$broadcast(_constants.EVENTS.LOANS_AMOUNT_SIMULATION_REFRESH_ERRORS);
	        this.scrollToErrors();
	        this.isSubmitting = false;
	        this._setFloatingButtonDisabled(false);
	        return;
	      }
	
	      this.errors = {};
	      this.scope.$broadcast(_constants.EVENTS.LOANS_AMOUNT_SIMULATION_REFRESH_ERRORS);
	      this.onSubmit(this.EventEmitter(this.getFormData()));
	
	      this.timeOutSubmit();
	    }
	  }, {
	    key: 'scrollToErrors',
	    value: function scrollToErrors() {
	      var sizeTitleMenu = 60;
	      var page = $('html, body');
	      var form = $('loans-amount-simulation');
	      var scrollTop = form.first().offset().top - sizeTitleMenu;
	      page.animate({ scrollTop: scrollTop }, 500);
	    }
	  }, {
	    key: 'assignOriginalValue',
	    value: function assignOriginalValue(simulation) {
	      this.amount = simulation.amount;
	      this.monthlyFeeAmount = simulation.monthlyFeeAmount || 0;
	      this.fixedFeeNumber = simulation.fixedFeeNumber || 0;
	      this.feeType = simulation.feeType || FEE_TYPES.MINIMUM_FEE_IN_MAX_PERIOD;
	      this.wantInsurance = simulation.wantInsurance;
	
	      if (this.wantInsurance === undefined) {
	        this.wantInsurance = false;
	      }
	
	      this.acquisitionCost = simulation.acquisitionCost;
	      this.salePrice = simulation.salePrice;
	    }
	  }, {
	    key: 'getFormData',
	    value: function getFormData() {
	      var isSimulation = this.simulationWitness && (this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN) || false;
	      var selectedSalePrice = isSimulation ? this.salePriceActive : this.salePrice;
	
	      var formData = {
	        amount: this.amount,
	        feeType: this.feeType,
	        monthlyFeeAmount: this.monthlyFeeAmount,
	        fixedFeeNumber: this.fixedFeeNumber,
	        wantInsurance: this.wantInsurance,
	        salePrice: selectedSalePrice,
	        diff: this.diff,
	        isSimulation: isSimulation
	      };
	
	      if (this.acquisitionCost > 0) {
	        formData.acquisitionCost = this.acquisitionCost;
	      }
	
	      this.removeFeeTypesFields(formData);
	      return formData;
	    }
	  }, {
	    key: 'removeFeeTypesFields',
	    value: function removeFeeTypesFields(formData) {
	      if (formData.feeType === FEE_TYPES.MINIMUM_FEE_IN_MAX_PERIOD) {
	        delete formData.fixedFeeNumber;
	        delete formData.monthlyFeeAmount;
	      } else if (formData.feeType === FEE_TYPES.MONTHLY_FEE) {
	        delete formData.fixedFeeNumber;
	      } else {
	        delete formData.monthlyFeeAmount;
	      }
	    }
	  }, {
	    key: 'mandatoryInsurance',
	    value: function mandatoryInsurance() {
	      var mandatory = null;
	      var mandatoryInsuranceByLoan = this.loan && this.loan.signUp.mandatoryInsurance;
	
	      if (mandatoryInsuranceByLoan) {
	        mandatory = 'yes';
	        this.wantInsurance = true;
	      }
	
	      var mandatoryInsuranceByCode = this.housingLoan && (this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN);
	
	      if (mandatoryInsuranceByCode) {
	        mandatory = 'yes';
	        this.wantInsurance = true;
	      }
	
	      return mandatory;
	    }
	  }, {
	    key: 'changeInsurance',
	    value: function changeInsurance($event) {
	      this.wantInsurance = $event.enabled;
	      this.submitIsDisabled();
	    }
	  }, {
	    key: 'isDisabledMonthlyFeeAmount',
	    value: function isDisabledMonthlyFeeAmount() {
	      return this.feeType !== FEE_TYPES.MONTHLY_FEE;
	    }
	  }, {
	    key: 'hideMonthlyFeeAmount',
	    value: function hideMonthlyFeeAmount() {
	      return this.isMobileApp && this.isDisabledMonthlyFeeAmount();
	    }
	  }, {
	    key: 'isDisabledFixedFeeNumber',
	    value: function isDisabledFixedFeeNumber() {
	      return this.feeType !== FEE_TYPES.FIXED_FEE_NUMBER;
	    }
	  }, {
	    key: 'hideFixedFeeNumber',
	    value: function hideFixedFeeNumber() {
	      return this.isMobileApp && this.isDisabledFixedFeeNumber();
	    }
	  }, {
	    key: 'submitIsDisabled',
	    value: function submitIsDisabled(isSubmit) {
	      var validPrevalidation = this.checkPrevalidation();
	      this._emitErrorPrevalidation(validPrevalidation);
	      var validAmount = this.checkAmount(isSubmit);
	      var validFeeType = this.checkFeeType(isSubmit);
	      var validHousingFields = this.checkHousingFields(isSubmit);
	      var validForm = this.form.$valid;
	      var invalid = !validPrevalidation || !validAmount || !validFeeType || !validForm;
	
	      if (this.housingLoan) {
	        invalid = invalid || !validHousingFields;
	      }
	
	      return invalid;
	    }
	  }, {
	    key: '_emitErrorPrevalidation',
	    value: function _emitErrorPrevalidation(validPrevalidation) {
	      if (validPrevalidation) {
	        return this.errors.emptyPurpose = false;
	      }
	
	      this.onErrorInSelect();
	      this.errors.emptyPurpose = true;
	    }
	  }, {
	    key: '_checkErrorAmount',
	    value: function _checkErrorAmount(isSubmit) {
	      var input = this.form.amount;
	      this.checkAmount(isSubmit);
	
	      if (input.$pristine && !this.amount && isSubmit) {
	        return this.onErrorInAmount();
	      }
	
	      if (this.amount > this.MAX_AMOUNT) {
	        this.errors.amountMax = true;
	        this.errors.amountLtZero = false;
	        return;
	      }
	
	      this.showErrorAmount = false;
	    }
	  }, {
	    key: 'onErrorInAmount',
	    value: function onErrorInAmount() {
	      this.showErrorAmount = true;
	      this.errors.amountLtZero = true;
	    }
	  }, {
	    key: 'checkPrevalidation',
	    value: function checkPrevalidation() {
	      this.errors.prevalidation = this.hasPrevalidation && !this.preValid;
	      return !this.errors.prevalidation;
	    }
	  }, {
	    key: 'checkAmount',
	    value: function checkAmount(isSubmit) {
	      var input = this.form.amount;
	
	      if (input.$pristine && !this.amount) {
	        return false;
	      }
	
	      this.errors.amountLtZero = this.amount <= 0 || !this.amount;
	      var valid = !this.errors.amountLtZero && this.amount < this.MAX_AMOUNT;
	
	      if (isSubmit) {
	        input.$setValidity('amount', valid);
	      } else {
	        input.$setValidity('amount', true);
	        input.$setValidity('required', true);
	      }
	
	      return valid;
	    }
	  }, {
	    key: 'checkCharges',
	    value: function checkCharges(isSubmit) {
	      var input = this.form && this.form.charges;
	      var validPositive = this.charges >= 0;
	      var extra = this.shouldApplyExtraPending() ? this.extraPendingAmount09 || 0 : 0;
	      var minBase = this.minChargesBase != null ? this.minChargesBase : this.initialCharges || 0;
	      var minTotal = (minBase || 0) + extra;
	      var validMinimum = this.charges >= minTotal;
	
	      this.errors.chargesError = !validPositive;
	      this.errors.chargesBelowInitial = !validMinimum;
	
	      if (!input) return validPositive && validMinimum;
	
	      if (isSubmit) {
	        input.$setValidity('chargesError', validPositive);
	        input.$setValidity('chargesBelowInitial', validMinimum);
	        input.$setDirty();
	      } else {
	        input.$setValidity('chargesError', true);
	        input.$setValidity('chargesBelowInitial', true);
	        input.$setValidity('required', true);
	      }
	
	      return validPositive && validMinimum;
	    }
	  }, {
	    key: 'onChangeFeeType',
	    value: function onChangeFeeType() {
	      this.checkFeeType();
	
	      if (this.feeType !== FEE_TYPES.MONTHLY_FEE) {
	        this.resetMonthlyFeeAmount();
	      }
	
	      if (this.feeType !== FEE_TYPES.FIXED_FEE_NUMBER) {
	        this.resetFixedFeeNumber();
	      }
	    }
	  }, {
	    key: 'checkFeeType',
	    value: function checkFeeType(onSubmit) {
	      if (this.feeType === FEE_TYPES.MONTHLY_FEE) {
	        return this.checkMonthlyFee(onSubmit);
	      } else if (this.feeType === FEE_TYPES.FIXED_FEE_NUMBER) {
	        return this.checkFixedFeeNumber(onSubmit);
	      }
	
	      return true;
	    }
	  }, {
	    key: 'resetMonthlyFeeAmount',
	    value: function resetMonthlyFeeAmount() {
	      this.monthlyFeeAmount = 0;
	      this.errors.monthlyFeeLtZero = false;
	      this.errors.monthlyFeeGtAmount = false;
	      this.form.monthlyFeeAmount.$setViewValue('0,00 €');
	      this.form.monthlyFeeAmount.$setValidity('amount', true);
	      this.form.monthlyFeeAmount.$setPristine();
	      this.form.monthlyFeeAmount.$render();
	    }
	  }, {
	    key: 'resetFixedFeeNumber',
	    value: function resetFixedFeeNumber() {
	      this.fixedFeeNumber = 0;
	      this.errors.fixedFeeNumberLtZero = false;
	      this.errors.fixedFeeNumberGtDivider = false;
	      this.form.fixedFeeNumber.$setViewValue('0');
	      this.form.fixedFeeNumber.$setValidity('amount', true);
	      this.form.fixedFeeNumber.$setPristine();
	      this.form.fixedFeeNumber.$render();
	    }
	  }, {
	    key: 'checkMonthlyFee',
	    value: function checkMonthlyFee(onSubmit) {
	      var input = this.form.monthlyFeeAmount;
	
	      this.monthlyFeeAmount = this.monthlyFeeAmount || 0;
	
	      this.errors.monthlyFeeLtZero = this.monthlyFeeAmount <= 0;
	      this.errors.monthlyFeeGtAmount = this.monthlyFeeAmount > this.amount;
	      var valid = !this.errors.monthlyFeeLtZero && !this.errors.monthlyFeeGtAmount;
	
	      if (onSubmit) {
	        input.$setValidity('amount', valid);
	        input.$setDirty();
	      } else {
	        input.$setValidity('amount', true);
	        input.$setValidity('required', true);
	      }
	
	      return valid;
	    }
	  }, {
	    key: 'checkFixedFeeNumber',
	    value: function checkFixedFeeNumber(onSubmit) {
	      var input = this.form.fixedFeeNumber;
	      this.errors.fixedFeeNumberLtZero = this.fixedFeeNumber <= 0 || this.fixedFeeNumber === undefined;
	
	      if (this.loan) {
	        this.errors.fixedFeeNumberGtDivider = this.fixedFeeNumber > this.loan.minMonthlyFeeDivider;
	      }
	
	      var valid = !this.errors.fixedFeeNumberLtZero && !this.errors.fixedFeeNumberGtDivider;
	
	      if (onSubmit) {
	        input.$setValidity('amount', valid);
	        input.$setDirty();
	      } else {
	        input.$setValidity('amount', true);
	        input.$setValidity('number', true);
	        input.$setValidity('required', true);
	      }
	
	      return valid;
	    }
	  }, {
	    key: 'checkHousingFields',
	    value: function checkHousingFields(isSubmit) {
	      this._checkErrorAmount(isSubmit);
	
	      if (this.shouldShowCreditCapacitySimulation) {
	        var isValidSalePriceActive = this.salePriceActive > 0;
	        var isValidNewHomePrice = this.newHomePrice > 0;
	
	        this.errors.salePriceActiveError = !isValidSalePriceActive;
	        this.errors.newHomePriceError = !isValidNewHomePrice;
	
	        if (isSubmit && this.form.salePriceActive) {
	          this.form.salePriceActive.$setValidity('required', isValidSalePriceActive);
	          this.form.salePriceActive.$setDirty();
	        }
	
	        if (isSubmit && this.form.newHomePrice) {
	          this.form.newHomePrice.$setValidity('required', isValidNewHomePrice);
	          this.form.newHomePrice.$setDirty();
	        }
	
	        this.errors.amountGtAcquisitionCost = false;
	        this.errors.invalidDiff = false;
	
	        this.setDiff();
	        if (this.amount > this.diff) {
	          this.errors.invalidDiffCapacitySimulation = true;
	          return false;
	        }
	
	        return isValidSalePriceActive && isValidNewHomePrice;
	      }
	
	      if (!this.housingLoan) {
	        return true;
	      }
	
	      if (this.housingChange) {
	        this.setDiff();
	        this.checkSalePrice(isSubmit);
	        this.errors.invalidDiff = this.amount > this.diff;
	      } else {
	        this.errors.amountGtAcquisitionCost = this.amount > this.acquisitionCost;
	      }
	
	      return !this.errors.invalidDiff && !this.errors.amountGtAcquisitionCost;
	    }
	  }, {
	    key: 'checkAcquisitionCost',
	    value: function checkAcquisitionCost(isSubmit) {
	      var valid = this.acquisitionCost > 0;
	
	      if (isSubmit) {
	        this.form.acquisitionCost.$setValidity('amount', valid);
	        this.form.acquisitionCost.$setDirty();
	      } else {
	        this.form.acquisitionCost.$setValidity('amount', true);
	        this.form.acquisitionCost.$setValidity('required', true);
	      }
	
	      this.errors.acquisitionCostError = !valid;
	    }
	  }, {
	    key: 'checkSalePrice',
	    value: function checkSalePrice(isSubmit) {
	      var valid = this.salePrice >= 0;
	
	      if (isSubmit) {
	        this.form.salePrice.$setValidity('amount', valid);
	        this.form.salePrice.$setDirty();
	      } else {
	        this.form.salePrice.$setValidity('amount', true);
	        this.form.salePrice.$setValidity('required', true);
	      }
	
	      this.errors.salePriceError = !valid;
	    }
	  }, {
	    key: 'setDiff',
	    value: function setDiff() {
	      this.diff = this.getDiff();
	    }
	  }, {
	    key: 'isNumber',
	    value: function isNumber(valor) {
	      return !isNaN(valor) && typeof valor === 'number';
	    }
	  }, {
	    key: 'getDiff',
	    value: function getDiff() {
	      if (this.simulationWitness) {
	        var newHomePriceTemp = this.isNumber(this.newHomePrice) ? this.newHomePrice : 0;
	        var salePriceActiveTemp = this.isNumber(this.salePriceActive) ? this.salePriceActive : 0;
	        var chargesTemp = this.isNumber(this.charges) ? this.charges : 0;
	        var diff = newHomePriceTemp - (salePriceActiveTemp - chargesTemp);
	        return diff;
	      } else {
	        if (this.acquisitionCost === undefined && this.salePrice === undefined) {
	          return 0;
	        } else if (this.acquisitionCost === undefined) {
	          return this.salePrice * -1;
	        } else if (this.salePrice === undefined) {
	          return this.acquisitionCost;
	        } else {
	          return this.acquisitionCost - this.salePrice;
	        }
	      }
	    }
	  }, {
	    key: 'focusFixedFeeNumber',
	    value: function focusFixedFeeNumber() {
	      if (this.form.fixedFeeNumber.$pristine) {
	        this.fixedFeeNumber = '';
	      }
	
	      this.checkFeeType();
	    }
	  }, {
	    key: 'initFloatingActionButtons',
	    value: function initFloatingActionButtons() {
	      var buttonLiteral = this.shouldShowCreditCapacitySimulation ? 'GLOBALS.BUTTON_ACTION.SIMULATE' : 'GLOBALS.BUTTON_ACTION.CONTINUE';
	
	      this.floatingActionButtons = [{ literal: buttonLiteral }];
	    }
	  }, {
	    key: '_setFloatingButtonDisabled',
	    value: function _setFloatingButtonDisabled(disabled) {
	      if (this.isMobileApp && this.floatingActionButtons && this.floatingActionButtons[0]) {
	        this.floatingActionButtons[0].disabled = !!disabled;
	        if (this.scope && this.scope.$applyAsync) {
	          this.scope.$applyAsync();
	        }
	      }
	    }
	  }, {
	    key: 'isNotInputFocus',
	    value: function isNotInputFocus() {
	      return this.floatingActionButtonsService.isFocused;
	    }
	  }, {
	    key: 'onChangeAmount',
	    value: function onChangeAmount() {
	      this._checkErrorAmount();
	      this.onchangeData();
	    }
	  }, {
	    key: 'onChangeAcquisitionCost',
	    value: function onChangeAcquisitionCost() {
	      this.checkAcquisitionCost();
	      this.onchangeData();
	    }
	  }, {
	    key: 'onChangeSalePrice',
	    value: function onChangeSalePrice() {
	      this.setSalePriceValueWhenEmpty();
	      this.checkSalePrice();
	      this.onchangeData();
	    }
	  }, {
	    key: 'onchangeData',
	    value: function onchangeData() {
	      this.setDiff();
	    }
	  }, {
	    key: 'onChangeNewHomePrice',
	    value: function onChangeNewHomePrice() {
	      this.setDiff();
	    }
	  }, {
	    key: 'onChangeSalePriceActive',
	    value: function onChangeSalePriceActive() {
	      this.setDiff();
	
	      var isValid = this.salePriceActive >= 0;
	      this.errors.salePriceActiveError = !isValid;
	
	      if (this.form.salePriceActive) {
	        this.form.salePriceActive.$setValidity('amount', isValid);
	        this.form.salePriceActive.$setDirty();
	      }
	    }
	  }, {
	    key: 'onChangeCharges',
	    value: function onChangeCharges() {
	
	      this.setDiff();
	    }
	  }, {
	    key: 'setSalePriceValueWhenEmpty',
	    value: function setSalePriceValueWhenEmpty() {
	      var salePriceInput = this.form.salePrice;
	      if (!this.salePrice && !salePriceInput.$pristine) this.salePrice = 0;
	    }
	  }, {
	    key: 'adquisitionShouldAppear',
	    value: function adquisitionShouldAppear() {
	      return !this.simulationWitness && (this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.codeOptionSelected === _constantsLoans.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN);
	    }
	  }, {
	    key: 'refreshChargesInputIfPossible',
	    value: function refreshChargesInputIfPossible() {
	
	      var input = this.form && this.form.charges;
	      if (!input) return;
	
	      if (this.isChargesFocused) return;
	
	      input.$setViewValue(this.formattedCharges);
	      input.$render();
	    }
	  }]);
	  return LoansAmountSimulationController;
	}();
	
	exports.default = LoansAmountSimulationController;

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2163);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansAmountSimulation.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./loansAmountSimulation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-amount-simulation{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}loans-amount-simulation.mobile form{padding:0;border:0}loans-amount-simulation.mobile form div.amount-column,loans-amount-simulation.mobile form div.fee-column,loans-amount-simulation.mobile form div.insurance-column,loans-amount-simulation.mobile form div.submit-column{width:100%}loans-amount-simulation.mobile form div.amount-column{padding-top:0}loans-amount-simulation.mobile form div.amount-column label{font-size:16px;text-transform:none;margin-bottom:20px}loans-amount-simulation.mobile form div.amount-column p.diff{width:100%;font-size:24px}loans-amount-simulation.mobile form div.fee-column .fee-radios .radio label{font-size:15px;text-transform:none;padding-top:0;margin-bottom:10px;color:#666}loans-amount-simulation.mobile form div.fee-column .fee-radios .radio .single-radio{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;width:100%}loans-amount-simulation.mobile form div.insurance-column{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;padding-right:15px;padding-top:0}loans-amount-simulation form{background-color:#fff;border:1px solid #eaebed;display:block;margin-bottom:15px;padding-bottom:20px;padding-left:20px;padding-right:20px}loans-amount-simulation form input[name=amount]{margin-bottom:15px!important}loans-amount-simulation form.not-submit input[type=number],loans-amount-simulation form.not-submit input[type=text]{border:1px solid #dddfe2!important}loans-amount-simulation form .housing-change-fields label{margin-top:15px}loans-amount-simulation form .housing-change-fields label.newHomePrice{margin-top:0!important}loans-amount-simulation form div.amount-column{width:25%;padding-top:28px}loans-amount-simulation form div.amount-column .description-text{text-transform:none;color:#777}loans-amount-simulation form div.amount-column label{padding-left:3px}loans-amount-simulation form div.amount-column .error-amount{border:1px solid #c8175e!important}loans-amount-simulation form div.amount-column p.diff{width:150px;padding-right:15px;font-family:Stag Sans;font-size:13px;color:#666;text-align:right}loans-amount-simulation form div.fee-column{padding-top:15px;width:36%}loans-amount-simulation form div.fee-column .fee-radios .radio{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}loans-amount-simulation form div.fee-column .fee-radios .radio .single-radio{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:66%;margin-bottom:15px}loans-amount-simulation form div.insurance-column{width:14%;padding-top:28px}loans-amount-simulation form div.insurance-column label{margin-bottom:8px}loans-amount-simulation form div.submit-column{width:25%;padding-top:76px}", ""]);
	
	// exports


/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loansAmountSimulationErrors = __webpack_require__(2165);
	
	var _loansAmountSimulationErrors2 = _interopRequireDefault(_loansAmountSimulationErrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansAmountSimulationErrorsModule = _angular2.default.module('loansAmountSimulationErrors', []).component('loansAmountSimulationErrors', _loansAmountSimulationErrors2.default).name;
	
	exports.default = loansAmountSimulationErrorsModule;

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansAmountSimulationErrors = __webpack_require__(2166);
	
	var _loansAmountSimulationErrors2 = _interopRequireDefault(_loansAmountSimulationErrors);
	
	var _loansAmountSimulationErrors3 = __webpack_require__(2167);
	
	var _loansAmountSimulationErrors4 = _interopRequireDefault(_loansAmountSimulationErrors3);
	
	__webpack_require__(2168);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansAmountSimulationErrorsComponent = {
	  restrict: 'E',
	  bindings: {
	    errors: '<',
	    isMobileApp: '<',
	    isClickOnSubmit: '<'
	  },
	  template: _loansAmountSimulationErrors2.default,
	  controller: _loansAmountSimulationErrors4.default
	};
	
	exports.default = loansAmountSimulationErrorsComponent;

/***/ }),
/* 2166 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"errors\" ng-if=\"$ctrl.hasError()\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n\n  <p ng-if=\"$ctrl.errorsSimulation.emptyPurpose\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.EMPTY_PURPOSE' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.amountMax\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.AMOUNT_MAX' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.amountLtZero\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.AMOUNT_LT_ZERO' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.monthlyFeeLtZero\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.MONTHLY_FEE_LT_ZERO' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.acquisitionCostError\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.ACQUISITION_COST_ERROR' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.salePriceError\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.SALE_PRICE_ERROR' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.salePriceActiveError\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.SALE_PRICE_ACTIVE_ERROR' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.newHomePriceError\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.NEW_HOME_PRICE_ERROR' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.chargesError\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.CHARGES_ERROR' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.chargesBelowInitial\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.CHARGES_BELOW_INITIAL' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.monthlyFeeGtAmount\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.MONTHLY_FEE_GT_AMOUNT' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.fixedFeeNumberLtZero\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.FIXED_FEE_NUMBER_LT_ZERO' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.fixedFeeNumberGtDivider\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.FIXED_FEE_NUMBER_GT_DIVIDER' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.invalidDiff\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.DIFF_ERROR' | translate }}\n  </p>\n  <p ng-if=\"$ctrl.errorsSimulation.invalidDiffCapacitySimulation\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.DIFF_CAPACITY_SIMULATION_ERROR' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.errorsSimulation.amountGtAcquisitionCost\">\n    - {{ 'LOANS.SIGN_UP.ERRORS.ACQUISITION_COST' | translate }}\n  </p>\n\n</div>"

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansAmountSimulationErrorsController = function () {
	  LoansAmountSimulationErrorsController.$inject = ["$scope"];
	  function LoansAmountSimulationErrorsController($scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansAmountSimulationErrorsController);
	    this.scope = $scope;
	    this.errorsSimulation = {};
	  }
	
	  (0, _createClass3.default)(LoansAmountSimulationErrorsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.scope.$watch(function () {
	        return _this.isClickOnSubmit;
	      }, function () {
	        if (_this.isClickOnSubmit) {
	          _this.copyErrors();
	        }
	      });
	
	      this.scope.$on(_constants.EVENTS.LOANS_AMOUNT_SIMULATION_REFRESH_ERRORS, function () {
	        _this.copyErrors();
	      });
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changes) {
	      if (changes.errors) {
	        this.copyErrors();
	      }
	    }
	  }, {
	    key: 'copyErrors',
	    value: function copyErrors() {
	      this.errorsSimulation = angular.copy(this.errors);
	    }
	  }, {
	    key: 'hasError',
	    value: function hasError() {
	      var _this2 = this;
	
	      var errorKeys = (0, _keys2.default)(this.errorsSimulation);
	      return errorKeys.some(function (key) {
	        return _this2.errorsSimulation[key] === true;
	      });
	    }
	  }]);
	  return LoansAmountSimulationErrorsController;
	}();
	
	exports.default = LoansAmountSimulationErrorsController;

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2169);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansAmountSimulationErrors.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./loansAmountSimulationErrors.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "loans-amount-simulation-errors{display:block}loans-amount-simulation-errors .errors{margin-bottom:15px;padding:15px;background-color:#fff}loans-amount-simulation-errors .errors p{color:#c8175e}loans-amount-simulation-errors .errors.mobile p{font-size:18px}", ""]);
	
	// exports


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _cadastralReferenceForm = __webpack_require__(2171);
	
	var _cadastralReferenceForm2 = _interopRequireDefault(_cadastralReferenceForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cadastralReferenceFormModule = _angular2.default.module('cadastralReferenceForm', []).component('cadastralReferenceForm', _cadastralReferenceForm2.default).name;
	
	exports.default = cadastralReferenceFormModule;

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cadastralReferenceForm = __webpack_require__(2172);
	
	var _cadastralReferenceForm2 = _interopRequireDefault(_cadastralReferenceForm);
	
	var _cadastralReferenceForm3 = __webpack_require__(2173);
	
	var _cadastralReferenceForm4 = _interopRequireDefault(_cadastralReferenceForm3);
	
	__webpack_require__(2174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cadastralReferenceFormComponent = {
	  restrict: 'E',
	  bindings: {
	    simulation: '<',
	    loan: '<',
	    loanResponseId: '<',
	    tempLoanObject: '<',
	    isMobileApp: '<',
	    onSave: '&',
	    showModalQuestion: '&',
	    onChangeForm: '&'
	  },
	  template: _cadastralReferenceForm2.default,
	  controller: _cadastralReferenceForm4.default
	};
	
	exports.default = cadastralReferenceFormComponent;

/***/ }),
/* 2172 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"cadastral-reference-form\" ng-class=\"$ctrl.getClasses()\">\n  <form\n    name=\"$ctrl.cadastralForm\"\n    ng-submit=\"$ctrl.submitForm()\"\n    novalidate>\n    <div class=\"form-content\">\n      <div class=\"mode-read\" ng-if=\"$ctrl.modeRead\">\n        <span class=\"icon icon-info\"></span>\n        <span>\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.ERROR.TEXT1' | translate }}\n          (<a href=\"mailto:{{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.ERROR.TEXT_LINK' | translate }}\" target=\"_blank\">{{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.ERROR.TEXT_LINK' | translate }}</a>)\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.ERROR.TEXT2' | translate }}\n        </span>\n      </div>\n\n      <span class=\"loan-info\">\n        {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INFO' | translate }}\n        ({{ $ctrl.loan.modalityLiteral || $ctrl.simulation.loanPurposeDescription }})\n        <span class=\"loan-info\" ng-if=\"$ctrl.loan.grantDate\">\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INFO_WORD' | translate }} {{ $ctrl.loan.grantDate | date:'dd/MM/yyyy' }}\n        </span>\n      </span>\n      <div class=\"form-group\" ng-class=\"{ 'has-error' : $ctrl.cadastralForm.reference.$invalid && $ctrl.cadastralForm.reference.$dirty }\">\n        <label for=\"reference\">\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INPUT_TITLE.REFERENCE' | translate }}\n        </label>\n        <input\n          id=\"reference\"\n          type=\"text\"\n          name=\"reference\"\n          class=\"form-control\"\n          ng-change=\"$ctrl.onChangeDataForm()\"\n          ng-model=\"$ctrl.cadastralReference.cadastralReference\"\n          required\n          maxlength=\"20\"\n          ng-disabled=\"$ctrl.modeRead\"\n          autocomplete=\"off\">\n        <p ng-show=\"$ctrl.cadastralForm.reference.$invalid && $ctrl.cadastralForm.reference.$dirty\" class=\"help-block\">\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INTRODUCE' | translate }}\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INPUT_TITLE.REFERENCE' | translate }}</p>\n      </div>\n\n      <div class=\"form-group\" ng-class=\"{ 'has-error' : $ctrl.cadastralForm.address.$invalid && $ctrl.cadastralForm.address.$dirty }\">\n        <label for=\"address\">\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INPUT_TITLE.ADDRESS' | translate }}\n        </label>\n        <input\n          id=\"address\"\n          type=\"text\"\n          name=\"address\"\n          class=\"form-control\"\n          ng-change=\"$ctrl.onChangeDataForm()\"\n          ng-model=\"$ctrl.cadastralReference.streetName\"\n          required\n          maxlength=\"50\"\n          ng-disabled=\"$ctrl.modeRead\"\n          autocomplete=\"off\">\n        <p ng-show=\"$ctrl.cadastralForm.address.$invalid && $ctrl.cadastralForm.address.$dirty\" class=\"help-block\">\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INTRODUCE' | translate }}\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INPUT_TITLE.ADDRESS' | translate }}</p>\n      </div>\n\n      <div class=\"form-group\" ng-class=\"{ 'has-error' : $ctrl.cadastralForm.municipality.$invalid && $ctrl.cadastralForm.municipality.$dirty }\">\n        <label for=\"municipality\">\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INPUT_TITLE.MUNICIPALITY' | translate }}\n        </label>\n        <input\n          id=\"municipality\"\n          type=\"text\"\n          name=\"municipality\"\n          class=\"form-control\"\n          ng-change=\"$ctrl.onChangeDataForm()\"\n          ng-model=\"$ctrl.cadastralReference.township\"\n          required\n          maxlength=\"30\"\n          ng-disabled=\"$ctrl.modeRead\"\n          autocomplete=\"off\">\n        <p ng-show=\"$ctrl.cadastralForm.municipality.$invalid && $ctrl.cadastralForm.municipality.$dirty\" class=\"help-block\">\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INTRODUCE' | translate }}\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INPUT_TITLE.MUNICIPALITY' | translate }}</p>\n      </div>\n\n      <div class=\"form-group\" ng-class=\"{ 'has-error' : $ctrl.cadastralForm.postalCode.$invalid && $ctrl.cadastralForm.postalCode.$dirty }\">\n        <label for=\"postal-code\">\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INPUT_TITLE.POSTALCODE' | translate }}\n        </label>\n        <input\n          id=\"postal-code\"\n          type=\"text\"\n          name=\"postalCode\"\n          class=\"form-control\"\n          ng-change=\"$ctrl.onChangeDataForm()\"\n          ng-model=\"$ctrl.cadastralReference.postalCode\"\n          required\n          maxlength=\"15\"\n          ng-disabled=\"$ctrl.modeRead\"\n          autocomplete=\"off\">\n        <p ng-show=\"$ctrl.cadastralForm.postalCode.$invalid && $ctrl.cadastralForm.postalCode.$dirty\" class=\"help-block\">\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INTRODUCE' | translate }}\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INPUT_TITLE.POSTALCODE' | translate }}</p>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"other-data\">\n          {{ 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.INPUT_TITLE.ADDITIONAL_DATA' | translate }}\n        </label>\n        <input\n          id=\"other-data\"\n          type=\"text\"\n          name=\"otherData\"\n          class=\"form-control\"\n          ng-change=\"$ctrl.onChangeDataForm()\"\n          ng-model=\"$ctrl.cadastralReference.complementaryInformation\"\n          maxlength=\"40\"\n          ng-disabled=\"$ctrl.modeRead\"\n          autocomplete=\"off\">\n      </div>\n    </div>\n\n    <div ng-if=\"!$ctrl.isMobileApp\" class=\"button-footer\">\n      <button\n        type=\"submit\"\n        class=\"btn btn-app btn-primary\"\n        ng-disabled=\"$ctrl.cadastralForm.$invalid || $ctrl.modeRead\">\n          {{\"GLOBALS.BUTTON_ACTION.SAVE\" | translate }}\n      </button>\n    </div>\n\n    <floating-action-buttons\n      ng-if=\"$ctrl.isMobileApp && !$ctrl.isCadastralCorrect && !$ctrl.isNotInputFocus()\"\n      buttons=\"$ctrl.floatingActionButtons\">\n    </floating-action-buttons>\n  </form>\n</div>\n"

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1125);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cadastralReferenceFormController = function () {
	  cadastralReferenceFormController.$inject = ["$window", "$rootScope", "$state", "$scope", "EventEmitter", "LoansUserDataService", "LoansOperationsService", "mainMenuMobileBehaviourService", "loadingMobileService", "floatingActionButtonsService", "$timeout"];
	  function cadastralReferenceFormController($window, $rootScope, $state, $scope, EventEmitter, LoansUserDataService, LoansOperationsService, mainMenuMobileBehaviourService, loadingMobileService, floatingActionButtonsService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, cadastralReferenceFormController);
	    this.window = $window;
	    this.rootScope = $rootScope;
	    this.state = $state;
	    this.scope = $scope;
	    this.EventEmitter = EventEmitter;
	    this.loansUserDataService = LoansUserDataService;
	    this.loansOperationsService = LoansOperationsService;
	    this.mainMenuMobileBehaviourService = mainMenuMobileBehaviourService;
	    this.loadingMobileService = loadingMobileService;
	    this.floatingActionButtonsService = floatingActionButtonsService;
	
	    this.modeRead = false;
	    this.cadastralReference = {};
	    this.timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(cadastralReferenceFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.init();
	
	      $(_constants.MODALS.MY_LOANS).on('show.bs.modal', function () {
	        _this.timeout(function () {
	          _this.init();
	        });
	      });
	
	      if (this.isMobileApp) {
	        this._initFloatinButtons();
	        this.mainMenuMobileBehaviourService.setCustomBehaviour(function () {
	          var dataCadastral = {
	            tempLoanObject: _this.formatCadastralReference(),
	            isCadastralCorrect: _this.isCadastralCorrect
	          };
	          _this.showModalQuestion(_this.EventEmitter(dataCadastral));
	        });
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      if (!_lodash2.default.isEmpty(this.tempLoanObject)) {
	        this.cadastralReference = this.tempLoanObject;
	      }
	
	      if (!_lodash2.default.isEmpty(this.loan.cadastralReference)) {
	        this.setDataCadastral();
	      } else {
	        this.isCadastralCorrect = false;
	      }
	
	      this.onChangeDataForm();
	    }
	  }, {
	    key: '_initFloatinButtons',
	    value: function _initFloatinButtons() {
	      this.floatingActionButtons = this.getFloatingActionButtons();
	      this.setFloatingActionButtonsDisabled();
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      return {
	        'responsiveMobile': this.isMobileApp
	      };
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var employeeId = this.loansUserDataService._employee.userId;
	      this.saveCadastral(employeeId);
	    }
	  }, {
	    key: 'saveCadastral',
	    value: function saveCadastral(employeeId) {
	      var _this2 = this;
	
	      var params = this.formatCadastralReference();
	      this.loadingMobileService.show();
	      this.loansOperationsService.putCadastralReference(employeeId, params).then(function () {
	        _this2.onSave(_this2.EventEmitter({ error: 'approve' }));
	        _this2.isCadastralCorrect = true;
	        _this2.modeRead = true;
	      }).catch(function (response) {
	        _this2.onSave(_this2.EventEmitter({ error: 'failed', messageError: response.data.message }));
	      }).finally(function () {
	        _this2.loadingMobileService.hide();
	      });
	    }
	  }, {
	    key: 'onChangeDataForm',
	    value: function onChangeDataForm() {
	      if (!this.isMobileApp) {
	        var cadastralRef = this.tempLoanObject || this.cadastralReference || this.formatCadastralReference().cadastralReferences[0];
	        var dataForm = {
	          cadastralReference: cadastralRef,
	          isCadastralCorrect: this.isCadastralCorrect
	        };
	
	        this.onChangeForm(this.EventEmitter(dataForm));
	      }
	    }
	  }, {
	    key: 'formatCadastralReference',
	    value: function formatCadastralReference() {
	      return {
	        cadastralReferences: [{
	          postalCode: this.cadastralReference.postalCode,
	          complementaryInformation: this.cadastralReference.complementaryInformation,
	          identifying: parseInt(this.loan.identifying) || parseInt(this.loanResponseId),
	          township: this.cadastralReference.township,
	          streetName: this.cadastralReference.streetName,
	          cadastralReference: this.cadastralReference.cadastralReference
	        }]
	      };
	    }
	  }, {
	    key: 'setFloatingActionButtonsDisabled',
	    value: function setFloatingActionButtonsDisabled() {
	      var _this3 = this;
	
	      this.scope.$watch(function () {
	        return _this3.cadastralForm.$invalid;
	      }, function (newValue) {
	        _this3.floatingActionButtons[0].disabled = newValue;
	      });
	      this.scope.$watch(function () {
	        return _this3.modeRead;
	      }, function (newValue) {
	        _this3.floatingActionButtons[0].disabled = newValue;
	      });
	    }
	  }, {
	    key: 'getFloatingActionButtons',
	    value: function getFloatingActionButtons() {
	      return [{
	        literal: 'GLOBALS.BUTTON_ACTION.SAVE'
	      }];
	    }
	  }, {
	    key: 'isNotInputFocus',
	    value: function isNotInputFocus() {
	      return this.floatingActionButtonsService.isFocused;
	    }
	  }, {
	    key: 'checkCadastralReferenceCorrect',
	    value: function checkCadastralReferenceCorrect() {
	      var isNotEmptyCadastralReference = !!this.loan.cadastralReference.cadastralReference && !!this.loan.cadastralReference.streetName && !!this.loan.cadastralReference.township && !!this.loan.cadastralReference.postalCode;
	
	      if (isNotEmptyCadastralReference) {
	        this.isCadastralCorrect = true;
	        this.modeRead = true;
	      }
	    }
	  }, {
	    key: 'setDataCadastral',
	    value: function setDataCadastral() {
	      this.checkCadastralReferenceCorrect();
	
	      this.cadastralReference = {
	        cadastralReference: this.loan.cadastralReference.cadastralReference,
	        streetName: this.loan.cadastralReference.streetName,
	        township: this.loan.cadastralReference.township,
	        postalCode: this.loan.cadastralReference.postalCode,
	        complementaryInformation: this.loan.cadastralReference.complementaryInformation
	      };
	    }
	  }]);
	  return cadastralReferenceFormController;
	}();
	
	exports.default = cadastralReferenceFormController;

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2175);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./cadastralReferenceForm.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./cadastralReferenceForm.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "cadastral-reference-form .cadastral-reference-form{padding-top:14px;text-align:left}cadastral-reference-form .cadastral-reference-form.mobile{padding-left:0;padding-bottom:10px}cadastral-reference-form .cadastral-reference-form.mobile form .form-group label{font-size:16px;line-height:18px;margin-bottom:20px;text-transform:capitalize}cadastral-reference-form .cadastral-reference-form.mobile form .form-group input{height:60px;border-color:#eaebed;border-radius:2px;font-size:15px;color:#aeaeae}cadastral-reference-form .cadastral-reference-form.mobile form .form-group input:focus{border-color:#0072c9}cadastral-reference-form .cadastral-reference-form.mobile form #municipality,cadastral-reference-form .cadastral-reference-form.mobile form #reference{width:100%}cadastral-reference-form .cadastral-reference-form.mobile form #postal-code{text-align:center}cadastral-reference-form .cadastral-reference-form form{margin-top:27px}cadastral-reference-form .cadastral-reference-form form #reference{width:233px}cadastral-reference-form .cadastral-reference-form form #address{width:100%}cadastral-reference-form .cadastral-reference-form form #municipality{width:250px}cadastral-reference-form .cadastral-reference-form form #postal-code{width:80px}cadastral-reference-form .cadastral-reference-form form #other-data{width:100%}cadastral-reference-form .cadastral-reference-form form .form-content .loan-info{color:#666;font-size:15px}cadastral-reference-form .cadastral-reference-form form .mode-read{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;border:2px solid #287cba;border-radius:5px;padding:10px;margin-bottom:20px}cadastral-reference-form .cadastral-reference-form form .mode-read span{font-family:ArialMT;color:#666}cadastral-reference-form .cadastral-reference-form form .mode-read span.icon{font-size:32px;display:inline-block;margin-right:15px;margin-left:5px}cadastral-reference-form .cadastral-reference-form form .mode-read a:hover{background-color:transparent}cadastral-reference-form .cadastral-reference-form form .form-group{margin-bottom:0}cadastral-reference-form .cadastral-reference-form form .form-group label{color:#0072c9;font-family:Stag Sans;font-size:13px;font-weight:400;margin-top:20px;text-transform:uppercase}cadastral-reference-form .cadastral-reference-form form .form-group input{padding-left:12px;margin-top:-4px;margin-bottom:2px;border-color:#aeaeae}cadastral-reference-form .cadastral-reference-form form .form-group input:focus{outline:0!important;box-shadow:none}cadastral-reference-form .cadastral-reference-form form .button-footer{margin-top:39px;text-align:center}cadastral-reference-form .cadastral-reference-form form .button-footer .btn{height:48px;line-height:48px;margin-left:14px;margin-right:14px;width:156px}cadastral-reference-form .cadastral-reference-form form .has-error .form-control:focus{box-shadow:none}cadastral-reference-form .cadastral-reference-form form .has-error .help-block{color:#c8175e;margin-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loansMenu = __webpack_require__(2177);
	
	var _loansMenu2 = _interopRequireDefault(_loansMenu);
	
	var _loansStatic = __webpack_require__(2178);
	
	var _loansStatic2 = _interopRequireDefault(_loansStatic);
	
	var _initialData = __webpack_require__(2186);
	
	var _initialData2 = _interopRequireDefault(_initialData);
	
	var _employeeRepository = __webpack_require__(2187);
	
	var _employeeRepository2 = _interopRequireDefault(_employeeRepository);
	
	var _loansUserData = __webpack_require__(2190);
	
	var _loansUserData2 = _interopRequireDefault(_loansUserData);
	
	var _loansOperations = __webpack_require__(2195);
	
	var _loansOperations2 = _interopRequireDefault(_loansOperations);
	
	var _loansStates = __webpack_require__(2196);
	
	var _loansStates2 = _interopRequireDefault(_loansStates);
	
	var _loansNeedALoan = __webpack_require__(2197);
	
	var _loansNeedALoan2 = _interopRequireDefault(_loansNeedALoan);
	
	var _loansGoBackData = __webpack_require__(2198);
	
	var _loansGoBackData2 = _interopRequireDefault(_loansGoBackData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansCommon = angular.module('loans.common', []).service('loansMenuService', _loansMenu2.default).service('loansStaticService', _loansStatic2.default).service('LoansInitialDataService', _initialData2.default).service('LoansEmployeeRepositoryService', _employeeRepository2.default).service('LoansUserDataService', _loansUserData2.default).service('LoansOperationsService', _loansOperations2.default).service('LoansNeedALoanService', _loansNeedALoan2.default).service('GoBackDataService', _loansGoBackData2.default).service('LoansStatesService', _loansStates2.default).name;
	
	exports.default = loansCommon;

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	var _link = __webpack_require__(1104);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansMenuService = function () {
	  function loansMenuService() {
	    (0, _classCallCheck3.default)(this, loansMenuService);
	  }
	
	  (0, _createClass3.default)(loansMenuService, [{
	    key: 'getLinks',
	    value: function getLinks() {
	      var menuLabels = ['LOANS.CREDITWORTHINESS.TITLE', 'LOANS.NEED_A_LOAN.TITLE', 'LOANS.LOANS_CATALOG.TITLE', 'LOANS.MY_LOANS.TITLE', 'LOANS.WAGE_ADVANCE.TITLE'];
	
	      var menuTitles = menuLabels;
	
	      var menuTargets = [_states.STATES.LOANS.CREDITWORTHINESS, _states.STATES.LOANS.NEED_A_LOAN, _states.STATES.LOANS.LOANS_CATALOG, _states.STATES.LOANS.MY_LOANS, _states.STATES.LOANS.WAGE_ADVANCE];
	
	      var hasSeparator = [false, false, false, false, true];
	
	      var hasMenuBorder = [true, false, true, false, true];
	
	      var altStates = [null, null, [_states.STATES.LOANS.DETAIL], [_states.STATES.LOANS.REPAYMENT], null];
	
	      var fromStates = [null, [_states.STATES.LOANS.NEED_A_LOAN_RESULTS], [_states.STATES.LOANS.DETAIL, _states.STATES.LOANS.SIGN_UP], [_states.STATES.LOANS.CADASTRAL_REFERENCE], null];
	
	      return menuLabels.map(function (label, index) {
	        var link = new _link2.default(label, menuTitles[index], menuTargets[index]);
	
	        if (hasSeparator[index]) {
	          link.setSeparator();
	        }
	
	        if (!hasMenuBorder[index]) {
	          link.setNoMenuBorder();
	        }
	
	        if (altStates[index]) {
	          link.setAltStates(altStates[index]);
	        }
	
	        if (fromStates[index]) {
	          link.setFromStates(fromStates[index]);
	        }
	
	        return link;
	      });
	    }
	  }]);
	  return loansMenuService;
	}();
	
	exports.default = loansMenuService;

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	var _agreementHousingLoan = __webpack_require__(2179);
	
	var _agreementHousingLoan2 = _interopRequireDefault(_agreementHousingLoan);
	
	var _fiveMonth = __webpack_require__(2180);
	
	var _fiveMonth2 = _interopRequireDefault(_fiveMonth);
	
	var _nineMonth = __webpack_require__(2181);
	
	var _nineMonth2 = _interopRequireDefault(_nineMonth);
	
	var _socialHousingLoan = __webpack_require__(2182);
	
	var _socialHousingLoan2 = _interopRequireDefault(_socialHousingLoan);
	
	var _variousCredit = __webpack_require__(2183);
	
	var _variousCredit2 = _interopRequireDefault(_variousCredit);
	
	var _diversalAtention = __webpack_require__(2184);
	
	var _diversalAtention2 = _interopRequireDefault(_diversalAtention);
	
	var _dataBasicCharacteristicsTable = __webpack_require__(2185);
	
	var _dataBasicCharacteristicsTable2 = _interopRequireDefault(_dataBasicCharacteristicsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansStaticService = function () {
	  LoansStaticService.$inject = ["$http"];
	  function LoansStaticService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansStaticService);
	    this.http = $http;
	    this.loans = {};
	    this.tableBasicCharacteristics = _dataBasicCharacteristicsTable2.default;
	    this.initLoansWithId();
	    this.initLoansWithIdHR();
	  }
	
	  (0, _createClass3.default)(LoansStaticService, [{
	    key: 'initLoansWithId',
	    value: function initLoansWithId() {
	      this.loans[_constants.LOANS.ID.FIVE_MONTH] = _fiveMonth2.default;
	      this.loans[_constants.LOANS.ID.NINE_MONTH] = _nineMonth2.default;
	      this.loans[_constants.LOANS.ID.SOCIAL_HOUSING_LOAN] = _socialHousingLoan2.default;
	      this.loans[_constants.LOANS.ID.AGREEMENT_HOUSING_LOAN] = _agreementHousingLoan2.default;
	      this.loans[_constants.LOANS.ID.VARIOUS_CREDIT] = _variousCredit2.default;
	      this.loans[_constants.LOANS.ID.DIVERSAL_ATENTION] = _diversalAtention2.default;
	    }
	  }, {
	    key: 'initLoansWithIdHR',
	    value: function initLoansWithIdHR() {
	      this.loans[_constants.LOANS.ID_HR.FIVE_MONTH] = _fiveMonth2.default;
	      this.loans[_constants.LOANS.ID_HR.NINE_MONTH] = _nineMonth2.default;
	      this.loans[_constants.LOANS.ID_HR.SOCIAL_HOUSING_LOAN] = _socialHousingLoan2.default;
	      this.loans[_constants.LOANS.ID_HR.AGREEMENT_HOUSING_LOAN] = _agreementHousingLoan2.default;
	      this.loans[_constants.LOANS.ID_HR.VARIOUS_CREDIT] = _variousCredit2.default;
	      this.loans[_constants.LOANS.ID_HR.DIVERSAL_ATENTION] = _diversalAtention2.default;
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      return this.loans;
	    }
	  }, {
	    key: 'get',
	    value: function get(loanId) {
	      return this.loans[loanId];
	    }
	  }, {
	    key: 'getDataTableBasicCharacteristics',
	    value: function getDataTableBasicCharacteristics() {
	      return this.tableBasicCharacteristics;
	    }
	  }]);
	  return LoansStaticService;
	}();
	
	exports.default = LoansStaticService;

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  id: 'agreementHousingLoan',
	  idHr: 'VC',
	  url: 'agreement-housing-loan',
	  title: 'LOANS.LOANS_CATALOG.CARDS.SOCIAL_HOUSING_AGREEMENT',
	  titleSecondary: 'LOANS.LOANS_CATALOG.CARDS.SOCIAL_HOUSING_AGREEMENT',
	  img: 'img/loans/loans-catalog/house-agreement.png',
	  header: 'img/loans/loans-catalog/house-agreement-header.png',
	  minMonthlyFeeDivider: 240,
	  signUp: {
	    deadline: 240,
	    interestRate: 0,
	    annualPercentageRate: 0,
	    mandatoryInsurance: true,
	    tooltipId: 'SOCIAL_HOUSING_AGREEMENT'
	  },
	  detail: {
	    title: 'LOANS.LOANS_CATALOG.CARDS.SOCIAL_HOUSING_AGREEMENT',
	    basicCharacteristics: [{
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.TITLE1',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG1',
	      amountMax: [{
	        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH1_TITLE',
	        paragraph: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH1',
	        list: [{
	          text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH1_ITEM1',
	          link: 'my-creditworthiness',
	          textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH1_ITEM1_TEXTLINK'
	        }, {
	          text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH1_ITEM2'
	        }],
	        info: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH1_INFO']
	      }, {
	        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH2_TITLE',
	        list: [{
	          text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH2_ITEM1',
	          link: 'my-creditworthiness',
	          textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH2_ITEM1_TEXTLINK'
	        }, {
	          text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH2_ITEM2'
	        }],
	        info: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH2_INFO', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH2_INFO2']
	      }],
	      paragraphs: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH3', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.PARAGRAPH4']
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.TITLE2',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG2'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.TITLE11',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG11'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.TITLE3',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG3',
	      hasMargin: true,
	      typeInterest: [{
	        formula: {
	          title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT',
	          nominator: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG3_FORMULA_2'
	        },
	        table: {
	          paragraph: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG3_TEXT',
	          titleTable: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG3_TEXT_TABLE'
	        }
	      }],
	      textToCatalog: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE10',
	      desc: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG10_1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG10_2'],
	      hasMargin: true,
	      typeInterestFixed: [{
	        table: {
	          title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_CALC',
	          items: {
	            header: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TABLE_HEADER1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TABLE_HEADER2']
	          },
	          paragraph: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TEXT',
	          titleTable: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TEXT_TABLE_FIXED'
	        }
	      }],
	      textToCatalog: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT'
	    }, {
	      hasMargin: true,
	      desc: [{
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG12_1',
	        textRedirect: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG12_2',
	        redirect: 'https://bbva-tuybbva-portales.appspot.com/acuerdos-de-empresas/'
	      }]
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.TITLE4',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG4'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.TITLE5',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG5'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.TITLE6',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG6'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.TITLE7',
	      desc: [{
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG7_1'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG7_2'
	      }]
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.TITLE8',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG8_1',
	      dataLink: {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG8_2',
	        link: 'my-creditworthiness',
	        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.BASIC_CHARACTERISTICS.MSG8_2_TEXTLINK'
	      }
	    }],
	    requestIt: [{
	      items: [{
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH1.ITEM1_TEXT1',
	        link: 'my-creditworthiness',
	        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH1.ITEM1_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH1.ITEM2_TEXT1',
	        link: 'sign-up',
	        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH1.ITEM2_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH1.ITEM3_TEXT1',
	        link: 'need-a-loan',
	        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH1.ITEM3_TEXTLINK'
	      }],
	      otherItems: [{
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH2.ITEM1_TEXT'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH2.ITEM2_TEXT',
	        items: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH2.ITEM2_LIST1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH2.ITEM2_LIST2']
	      }, {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH2.ITEM3_TEXT',
	        link: 'my-loans',
	        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.REQUEST_IT.PARAGRAPH2.ITEM3_TEXTLINK'
	      }]
	    }],
	    prepayments: [{
	      text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.PREPAYMENTS.PARAGRAPH1'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.PREPAYMENTS.PARAGRAPH3',
	      boldText: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.PREPAYMENTS.PARAGRAPH3_BOLD_1',
	      text2: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.PREPAYMENTS.PARAGRAPH3_1',
	      boldText2: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.PREPAYMENTS.PARAGRAPH3_BOLD_2',
	      link: 'my-loans',
	      textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.PREPAYMENTS.PARAGRAPH3_TEXTLINK',
	      text3: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.PREPAYMENTS.PARAGRAPH3_2'
	    }],
	    newCreditCapacity: [{
	      text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.NEW_CREDIT_CAPACITY.PARAGRAPH1',
	      link: 'need-a-loan',
	      textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.NEW_CREDIT_CAPACITY.PARAGRAPH1_TEXTLINK'
	    }],
	    sendDocumentation: [{
	      text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH1',
	      textLink: ' LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH1_TEXTLINK',
	      link: 'https://bbvatyc.service-now.com/tyc?id=bbva_hrj_sc_cat_item&sys_id=1693fa2397204e5022b836b3f153af20',
	      text2: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1_2',
	      especifications: [{
	        dt: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH2',
	        dd: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH2_ITEM1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH2_ITEM2']
	      }, {
	        dt: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH3',
	        dd: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH3_ITEM1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH3_ITEM2', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH3_ITEM3', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH3_ITEM4']
	      }]
	    }, {
	      text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.SEND_DOCUMENTATION.PARAGRAPH4',
	      textLink: 'KB0025986',
	      link: 'https://bbvatyc.service-now.com/saeesp?id=bbva_kb_article&sys_id=76a180efdb286f00a6148c994b96194b'
	    }],
	    finishDeadline: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.FINISH_DEADLINE',
	    statementIncome: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.STATEMENT_INCOME.PARAGRAPH1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_AGREEMENT.STATEMENT_INCOME.PARAGRAPH2']
	  },
	  legalConditions: {
	    clause: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM4']
	    },
	    declaration: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM4', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM5'],
	      itemTerm: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM_TERM',
	      info: [{
	        text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO_ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO_ITEM3']
	      }],
	      authorization: {
	        paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM2']
	      }
	    }
	  }
	};

/***/ }),
/* 2180 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  id: 'fiveMonth',
	  idHr: '5S',
	  url: 'fiveMonth',
	  title: 'LOANS.LOANS_CATALOG.CARDS.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS',
	  titleSecondary: 'LOANS.LOANS_CATALOG.CARDS.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS_2',
	  img: 'img/loans/loans-catalog/five-month.png',
	  header: 'img/loans/loans-catalog/five-month-header.png',
	  minMonthlyFeeDivider: 50,
	  signUp: {
	    deadline: 5,
	    interestRate: 0,
	    annualPercentageRate: 0,
	    mandatoryInsurance: false,
	    tooltipId: 'WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS'
	  },
	  detail: {
	    title: 'LOANS.LOANS_CATALOG.CARDS.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS',
	    basicCharacteristics: [{
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE1',
	      desc: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG1'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE2',
	      desc: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG2'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE3',
	      desc: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG3',
	      textToCatalog: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG3'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE4',
	      desc: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG4'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE5',
	      desc: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG5'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE6',
	      desc: ['LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG6_1', 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG6_2']
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE7',
	      desc: ['LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG7_1', 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG7_2']
	    }],
	    minimumFee: 'LOANS.LOANS_DETAIL.MINIMUM_FEE',
	    minimumFeeResult: 'LOANS.LOANS_DETAIL.MINIMUM_FEE_RESULT',
	    requestIt: [{
	      paragraph: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.TEXT',
	      items: [{
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM1_TEXT1',
	        link: 'my-creditworthiness',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM1_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM2_TEXT1',
	        link: 'sign-up',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM2_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM3_TEXT1',
	        link: 'need-a-loan',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM3_TEXTLINK'
	      }]
	    }, {
	      paragraph: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.TEXT',
	      items: [{
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM1_TEXT1',
	        link: 'my-loans',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM1_TEXTLINK1',
	        text2: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM1_TEXT2',
	        link2: 'my-creditworthiness',
	        textLink2: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM1_TEXTLINK2'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM2_TEXT1',
	        link: 'sign-up',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM2_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM3_TEXT1',
	        link: 'need-a-loan',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM3_TEXTLINK'
	      }]
	    }],
	    prepayments: [{
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.PREPAYMENTS.PARAGRAPH1',
	      link: 'my-loans',
	      textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.PREPAYMENTS.PARAGRAPH1_TEXTLINK',
	      text2: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.PREPAYMENTS.PARAGRAPH1_1'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.PREPAYMENTS.PARAGRAPH2'
	    }],
	    sendDocumentation: [{
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH1',
	      textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH1_TEXTLINK',
	      link: 'https://bbvatyc.service-now.com/tyc?id=bbva_hrj_sc_cat_item&sys_id=1693fa2397204e5022b836b3f153af20',
	      text2: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1_2'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH2'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH3'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH4'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH5'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH6',
	      textLink: 'KB0024664',
	      link: 'https://bbvatyc.service-now.com/saeesp?id=bbva_search&q=KB0024664'
	    }],
	    finishDeadline: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.FINISH_DEADLINE',
	    statementIncome: ['LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.STATEMENT_INCOME.PARAGRAPH1', 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_FIVE_MONTHLY_PAYMENTS.STATEMENT_INCOME.PARAGRAPH2']
	  },
	  legalConditions: {
	    clause: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM4']
	    },
	    declaration: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM4', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM5'],
	      info: [{
	        text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM4']
	      }, {
	        text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM4', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM5', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM6']
	      }],
	      authorization: {
	        paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM2']
	      }
	    }
	  }
	};

/***/ }),
/* 2181 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  id: 'nineMonth',
	  idHr: '9S',
	  url: 'nine-month',
	  title: 'LOANS.LOANS_CATALOG.CARDS.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS',
	  titleSecondary: 'LOANS.LOANS_CATALOG.CARDS.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS_2',
	  img: 'img/loans/loans-catalog/nine-month.png',
	  header: 'img/loans/loans-catalog/nine-month-header.png',
	  minMonthlyFeeDivider: 90,
	  signUp: {
	    deadline: 9,
	    interestRate: 0,
	    annualPercentageRate: 0,
	    mandatoryInsurance: false,
	    tooltipId: 'WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS'
	  },
	  detail: {
	    title: 'LOANS.LOANS_CATALOG.CARDS.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS',
	    basicCharacteristics: [{
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE1',
	      desc: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG1'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE2',
	      desc: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG2'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE3',
	      desc: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG3',
	      textToCatalog: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG3'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE4',
	      desc: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG4'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE5',
	      desc: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG5'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE6',
	      desc: ['LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG6_1', 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG6_2']
	    }, {
	      title: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.TITLE7',
	      desc: ['LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG7_1', 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.BASIC_CHARACTERISTICS.MSG7_2']
	    }],
	    minimumFee: 'LOANS.LOANS_DETAIL.MINIMUM_FEE',
	    minimumFeeResult: 'LOANS.LOANS_DETAIL.MINIMUM_FEE_RESULT',
	    requestIt: [{
	      paragraph: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.TEXT',
	      items: [{
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM1_TEXT1',
	        link: 'my-creditworthiness',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM1_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM2_TEXT1',
	        link: 'sign-up',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM2_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM3_TEXT1',
	        link: 'need-a-loan',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH1.ITEM3_TEXTLINK'
	      }]
	    }, {
	      paragraph: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.TEXT',
	      items: [{
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM1_TEXT1',
	        link: 'my-loans',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM1_TEXTLINK1',
	        text2: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM1_TEXT2',
	        link2: 'my-creditworthiness',
	        textLink2: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM1_TEXTLINK2'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM2_TEXT1',
	        link: 'sign-up',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM2_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM3_TEXT1',
	        link: 'need-a-loan',
	        textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.REQUEST_IT.PARAGRAPH2.ITEM3_TEXTLINK'
	      }]
	    }],
	    prepayments: [{
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.PREPAYMENTS.PARAGRAPH1',
	      link: 'my-loans',
	      textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.PREPAYMENTS.PARAGRAPH1_TEXTLINK',
	      text2: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.PREPAYMENTS.PARAGRAPH1_1'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.PREPAYMENTS.PARAGRAPH2'
	    }],
	    sendDocumentation: [{
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH1',
	      textLink: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH1_TEXTLINK',
	      link: 'https://bbvatyc.service-now.com/tyc?id=bbva_hrj_sc_cat_item&sys_id=1693fa2397204e5022b836b3f153af20',
	      text2: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1_2'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH2'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH3'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH4'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH5'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.SEND_DOCUMENTATION.PARAGRAPH6',
	      textLink: 'KB0024940',
	      link: 'https://bbvatyc.service-now.com/saeesp?id=bbva_kb_article&sys_id=d061ccebdb286f00a6148c994b9619b9'
	    }],
	    finishDeadline: 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.FINISH_DEADLINE',
	    statementIncome: ['LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.STATEMENT_INCOME.PARAGRAPH1', 'LOANS.LOANS_DETAIL.WITHOUT_INTERESTS_NINE_MONTHLY_PAYMENTS.STATEMENT_INCOME.PARAGRAPH2']
	  },
	  legalConditions: {
	    clause: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM4']
	    },
	    declaration: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM4', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM5'],
	      info: [{
	        text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM4']
	      }, {
	        text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM4', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM5', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM6']
	      }],
	      authorization: {
	        paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM2']
	      }
	    }
	  }
	};

/***/ }),
/* 2182 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  id: 'socialHousingLoan',
	  idHr: 'SV',
	  url: 'social-housing-loan',
	  title: 'LOANS.LOANS_CATALOG.CARDS.SOCIAL_HOUSING_LOAN',
	  titleSecondary: 'LOANS.LOANS_CATALOG.CARDS.SOCIAL_HOUSING_LOAN',
	  img: 'img/loans/loans-catalog/house-social.png',
	  header: 'img/loans/loans-catalog/house-social-header.png',
	  minMonthlyFeeDivider: 360,
	  signUp: {
	    deadline: 360,
	    interestRate: 0,
	    annualPercentageRate: 0,
	    mandatoryInsurance: true,
	    tooltipId: 'SOCIAL_HOUSING_LOAN'
	  },
	  detail: {
	    title: 'LOANS.LOANS_CATALOG.CARDS.SOCIAL_HOUSING_LOAN',
	    basicCharacteristics: [{
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE1',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG1',
	      amountMax: [{
	        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1_TITLE',
	        paragraph: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1',
	        list: [{
	          text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1_ITEM1',
	          link: 'my-creditworthiness',
	          textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1_ITEM1_TEXTLINK'
	        }, {
	          text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1_ITEM2'
	        }],
	        info: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1_INFO']
	      }, {
	        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_TITLE',
	        list: [{
	          text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_ITEM1',
	          link: 'my-creditworthiness',
	          textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_ITEM1_TEXTLINK'
	        }, {
	          text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_ITEM2'
	        }],
	        info: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_INFO', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_INFO2']
	      }],
	      paragraphs: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH3', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH4']
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE3',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG3'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE11',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG11'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE4',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4',
	      hasMargin: true,
	      typeInterest: [{
	        formula: {
	          title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_TEXT',
	          nominator: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_2',
	          denominator: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_3',
	          coefficient: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_1'
	        },
	        table: {
	          title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_CALC',
	          items: {
	            header: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TABLE_HEADER1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TABLE_HEADER2']
	          },
	          paragraph: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TEXT',
	          titleTable: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TEXT_TABLE'
	        }
	      }],
	      textToCatalog: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE10',
	      desc: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG10_1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG10_2'],
	      hasMargin: true,
	      typeInterestFixed: [{
	        table: {
	          title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_CALC',
	          items: {
	            header: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TABLE_HEADER1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TABLE_HEADER2']
	          },
	          paragraph: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TEXT',
	          titleTable: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TEXT_TABLE_FIXED'
	        }
	      }],
	      textToCatalog: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT'
	    }, {
	      hasMargin: true,
	      desc: [{
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG12_1',
	        textRedirect: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG12_2',
	        redirect: 'https://bbva-tuybbva-portales.appspot.com/acuerdos-de-empresas/'
	      }]
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE2',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG2'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE5',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG5'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE6',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG6'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE7',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG7'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE8',
	      desc: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG8_1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG8_2']
	    }, {
	      title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE9',
	      desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG9_1',
	      dataLink: {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG9_2',
	        link: 'my-creditworthiness',
	        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG9_2_TEXTLINK'
	      }
	    }],
	    requestIt: [{
	      items: [{
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM1_TEXT1',
	        link: 'my-creditworthiness',
	        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM1_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM2_TEXT1',
	        link: 'sign-up',
	        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM2_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM3_TEXT1',
	        link: 'need-a-loan',
	        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM3_TEXTLINK'
	      }],
	      otherItems: [{
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM1_TEXT'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM2_TEXT',
	        items: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM2_LIST1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM2_LIST2']
	      }, {
	        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM3_TEXT',
	        link: 'my-loans',
	        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM3_TEXTLINK'
	      }]
	    }],
	    prepayments: [{
	      text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH1'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3',
	      boldText: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3_BOLD_1',
	      text2: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3_1',
	      boldText2: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3_BOLD_2',
	      link: 'my-loans',
	      textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3_TEXTLINK',
	      text3: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3_2'
	    }],
	    newCreditCapacity: [{
	      text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.NEW_CREDIT_CAPACITY.PARAGRAPH1',
	      link: 'need-a-loan',
	      textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.NEW_CREDIT_CAPACITY.PARAGRAPH1_TEXTLINK'
	    }],
	    sendDocumentation: [{
	      text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH1',
	      textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH1_TEXTLINK',
	      link: 'https://bbvatyc.service-now.com/tyc?id=bbva_hrj_sc_cat_item&sys_id=1693fa2397204e5022b836b3f153af20',
	      text2: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1_2',
	      especifications: [{
	        dt: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH2',
	        dd: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH2_ITEM1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH2_ITEM2']
	      }, {
	        dt: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH3',
	        dd: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH3_ITEM1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH3_ITEM2', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH3_ITEM3', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH3_ITEM4']
	      }]
	    }, {
	      text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH4',
	      textLink: 'KB0025986',
	      link: 'https://bbvatyc.service-now.com/saeesp?id=bbva_kb_article&sys_id=76a180efdb286f00a6148c994b96194b'
	    }],
	    finishDeadline: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.FINISH_DEADLINE',
	    statementIncome: ['LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.STATEMENT_INCOME.PARAGRAPH1', 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.STATEMENT_INCOME.PARAGRAPH2']
	  },
	  legalConditions: {
	    clause: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM4']
	    },
	    declaration: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM4', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM5'],
	      itemTerm: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM_TERM',
	      info: [{
	        text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO_ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO_ITEM3']
	      }],
	      authorization: {
	        paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM2']
	      }
	    }
	  }
	};

/***/ }),
/* 2183 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  id: 'variousCredit',
	  idHr: 'CV',
	  url: 'various-credit',
	  title: 'LOANS.LOANS_CATALOG.CARDS.VARIOUS_CREDIT',
	  titleSecondary: 'LOANS.LOANS_CATALOG.CARDS.VARIOUS_CREDIT_2',
	  img: 'img/loans/loans-catalog/various.png',
	  header: 'img/loans/loans-catalog/various-header.png',
	  minMonthlyFeeDivider: 84,
	  signUp: {
	    deadline: 84,
	    interestRate: 0,
	    annualPercentageRate: 0,
	    mandatoryInsurance: false,
	    tooltipId: 'VARIOUS_CREDIT'
	  },
	  detail: {
	    title: 'LOANS.LOANS_CATALOG.CARDS.VARIOUS_CREDIT',
	    basicCharacteristics: [{
	      title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE1',
	      desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG1'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE2',
	      desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG2'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE3',
	      desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3',
	      typeInterest: [{
	        formula: {
	          title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT',
	          nominator: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3_FORMULA_2'
	        },
	        table: {
	          paragraph: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3_TEXT',
	          titleTable: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3_TEXT_TABLE'
	        }
	      }],
	      textToCatalog: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE7',
	      desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG7'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE4',
	      desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG4'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE5',
	      desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG5'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE6',
	      desc: ['LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG6_1', 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG6_2']
	    }],
	    requestIt: [{
	      items: [{
	        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM1_TEXT1',
	        link: 'my-creditworthiness',
	        textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM1_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM2_TEXT1',
	        link: 'sign-up',
	        textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM2_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM3_TEXT1',
	        link: 'need-a-loan',
	        textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM3_TEXTLINK'
	      }],
	      otherItems: [{
	        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM1_TEXT'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM2_TEXT',
	        items: ['LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM2_LIST1', 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM2_LIST2']
	      }, {
	        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM3_TEXT',
	        link: 'my-loans',
	        textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM3_TEXTLINK'
	      }]
	    }],
	    prepayments: [{
	      text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.PREPAYMENTS.PARAGRAPH1',
	      link: 'my-loans',
	      textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.PREPAYMENTS.PARAGRAPH1_TEXTLINK',
	      text2: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.PREPAYMENTS.PARAGRAPH1_1'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.PREPAYMENTS.PARAGRAPH2'
	    }],
	    sendDocumentation: [{
	      text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1',
	      textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1_TEXTLINK',
	      link: 'https://bbvatyc.service-now.com/tyc?id=bbva_hrj_sc_cat_item&sys_id=1693fa2397204e5022b836b3f153af20',
	      text2: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1_2'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH2'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH3'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH4'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH5',
	      textLink: 'KB0024654',
	      link: 'https://bbvatyc.service-now.com/saeesp?id=bbva_kb_article&sys_id=834144ebdb286f00a6148c994b96192c'
	    }],
	    finishDeadline: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.FINISH_DEADLINE',
	    statementIncome: ['LOANS.LOANS_DETAIL.VARIOUS_CREDIT.STATEMENT_INCOME.PARAGRAPH1', 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.STATEMENT_INCOME.PARAGRAPH2']
	  },
	  legalConditions: {
	    clause: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM4']
	    },
	    declaration: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM4', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM5'],
	      info: [{
	        text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM4']
	      }, {
	        text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM4', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM5', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM6']
	      }],
	      authorization: {
	        paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM2']
	      }
	    }
	  }
	};

/***/ }),
/* 2184 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  id: 'diversalAtention',
	  idHr: 'AD',
	  url: 'diversal-atention',
	  title: 'LOANS.LOANS_CATALOG.CARDS.DIVERSAL_ATENTION',
	  titleSecondary: 'LOANS.LOANS_CATALOG.CARDS.DIVERSAL_ATENTION_2',
	  img: 'img/loans/loans-catalog/diversal-atention.png',
	  header: 'img/loans/loans-catalog/diversal-atention-header.png',
	  minMonthlyFeeDivider: 84,
	  signUp: {
	    deadline: 84,
	    interestRate: 0,
	    annualPercentageRate: 0,
	    mandatoryInsurance: false,
	    tooltipId: 'DIVERSAL_ATENTION'
	  },
	  detail: {
	    title: 'LOANS.LOANS_CATALOG.CARDS.DIVERSAL_ATENTION',
	    basicCharacteristics: [{
	      title: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.TITLE1',
	      desc: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG1',
	      list: [{
	        text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.LIST1'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.LIST2'
	      }]
	    }, {
	      title: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.TITLE2',
	      desc: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG2'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.TITLE3',
	      desc: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG3',
	      typeInterest: [{
	        formula: {
	          title: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT',
	          nominator: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG3_FORMULA_2'
	        },
	        table: {
	          paragraph: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG3_TEXT',
	          titleTable: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG3_TEXT_TABLE'
	        }
	      }],
	      textToCatalog: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.TITLE4',
	      desc: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG4'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.TITLE8',
	      desc: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG8'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.TITLE5',
	      desc: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG5'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.TITLE6',
	      desc: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG6'
	    }, {
	      title: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.TITLE7',
	      desc: ['LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG7_1', 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.BASIC_CHARACTERISTICS.MSG7_2']
	    }],
	    requestIt: [{
	      items: [{
	        text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH1.ITEM1_TEXT1',
	        link: 'my-creditworthiness',
	        textLink: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH1.ITEM1_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH1.ITEM2_TEXT1',
	        link: 'sign-up',
	        textLink: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH1.ITEM2_TEXTLINK'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH1.ITEM3_TEXT1',
	        link: 'need-a-loan',
	        textLink: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH1.ITEM3_TEXTLINK'
	      }],
	      otherItems: [{
	        text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH2.ITEM1_TEXT'
	      }, {
	        text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH2.ITEM2_TEXT',
	        items: ['LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH2.ITEM2_LIST1', 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH2.ITEM2_LIST2']
	      }, {
	        text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH2.ITEM3_TEXT',
	        link: 'my-loans',
	        textLink: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.REQUEST_IT.PARAGRAPH2.ITEM3_TEXTLINK'
	      }]
	    }],
	    prepayments: [{
	      text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.PREPAYMENTS.PARAGRAPH1',
	      link: 'my-loans',
	      textLink: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.PREPAYMENTS.PARAGRAPH1_TEXTLINK',
	      text2: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.PREPAYMENTS.PARAGRAPH1_1'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.PREPAYMENTS.PARAGRAPH2'
	    }],
	    sendDocumentation: [{
	      text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.SEND_DOCUMENTATION.PARAGRAPH1',
	      textLink: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.SEND_DOCUMENTATION.PARAGRAPH1_TEXTLINK',
	      link: 'https://bbvatyc.service-now.com/tyc?id=bbva_hrj_sc_cat_item&sys_id=1693fa2397204e5022b836b3f153af20',
	      text2: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1_2'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.SEND_DOCUMENTATION.PARAGRAPH2'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.SEND_DOCUMENTATION.PARAGRAPH3'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.SEND_DOCUMENTATION.PARAGRAPH4'
	    }, {
	      text: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.SEND_DOCUMENTATION.PARAGRAPH5',
	      textLink: 'KB0024654',
	      link: 'https://bbvatyc.service-now.com/saeesp?id=bbva_kb_article&sys_id=834144ebdb286f00a6148c994b96192c'
	    }],
	    finishDeadline: 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.FINISH_DEADLINE',
	    statementIncome: ['LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.STATEMENT_INCOME.PARAGRAPH1', 'LOANS.LOANS_DETAIL.DIVERSAL_ATENTION.STATEMENT_INCOME.PARAGRAPH2']
	  },
	  legalConditions: {
	    clause: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM4']
	    },
	    declaration: {
	      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.TITLE',
	      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH',
	      items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM4', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM5'],
	      info: [{
	        text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM4']
	      }, {
	        text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM2', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM3', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM4', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM5', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM6']
	      }],
	      authorization: {
	        paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2',
	        items: ['LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM1', 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM2']
	      }
	    }
	  }
	};

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  socialHousingLoan: {
	    percentage: ['­-0,180', '-0,154', '-0,304', '-0,466', '-0,477', '2,629', '4,160', '2,691', '2,187'],
	    dataTableOnMobileApp: [{
	      year: '2018',
	      percentage: '-0,180'
	    }, {
	      year: '2019',
	      percentage: '-0,154'
	    }, {
	      year: '2020',
	      percentage: '-0,304'
	    }, {
	      year: '2021',
	      percentage: '-0,466'
	    }, {
	      year: '2022',
	      percentage: '-0,477'
	    }, {
	      year: '2023',
	      percentage: '2,629'
	    }, {
	      year: '2024',
	      percentage: '4,160'
	    }, {
	      year: '2025',
	      percentage: '2,691'
	    }, {
	      year: '2026',
	      percentage: '2,187'
	    }],
	    years: ['2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'],
	    loanTerm: ['Hasta 15 años', 'Hasta 20 años', 'Hasta 25 años', 'Hasta 30 años'],
	    percentageFixed: ['0,128', '-0,069', '­-0,180', '-0,154'],
	    dataTableFixedOnMobileApp: [{
	      loanTerm: 'Hasta 15 años',
	      percentage: '0,128'
	    }, {
	      loanTerm: 'Hasta 20 años',
	      percentage: '-0,069'
	    }, {
	      loanTerm: 'Hasta 25 años',
	      percentage: '-0,180'
	    }, {
	      loanTerm: 'Hasta 30 años',
	      percentage: '-0,154'
	    }]
	  },
	  agreementHousingLoan: {
	    percentage: ['0,000', '0,000', '0,000', '0,000', '0,000', '2,780', '4,202', '2,697', '2,346'],
	    dataTableOnMobileApp: [{
	      year: '2018',
	      percentage: '0,000'
	    }, {
	      year: '2019',
	      percentage: '0,000'
	    }, {
	      year: '2020',
	      percentage: '0,000'
	    }, {
	      year: '2021',
	      percentage: '0,000'
	    }, {
	      year: '2022',
	      percentage: '0,000'
	    }, {
	      year: '2023',
	      percentage: '2,780'
	    }, {
	      year: '2024',
	      percentage: '4,202'
	    }, {
	      year: '2025',
	      percentage: '2,697'
	    }, {
	      year: '2026',
	      percentage: '2,346'
	    }],
	    years: ['2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'],
	
	    loanTerm: ['Hasta 15 años', 'Hasta 20 años', 'Hasta 25 años', 'Hasta 30 años'],
	
	    percentageFixed: ['0,128', '-0,069', '­-0,180', '-0,154'],
	
	    dataTableFixedOnMobileApp: [{
	      loanTerm: 'Hasta 15 años',
	      percentage: '0,128'
	    }, {
	      loanTerm: 'Hasta 20 años',
	      percentage: '-0,069'
	    }, {
	      loanTerm: 'Hasta 25 años',
	      percentage: '-0,180'
	    }, {
	      loanTerm: 'Hasta 30 años',
	      percentage: '-0,154'
	    }]
	  },
	  variousCredit: {
	    percentage: ['0,820', '0,846', '0,696', '0,534', '0,523', '3,629', '5,160', '3,691', '3,187'],
	    dataTableOnMobileApp: [{
	      year: '2018',
	      percentage: '0,820'
	    }, {
	      year: '2019',
	      percentage: '0,846'
	    }, {
	      year: '2020',
	      percentage: '0,696'
	    }, {
	      year: '2021',
	      percentage: '0,534'
	    }, {
	      year: '2022',
	      percentage: '0,523'
	    }, {
	      year: '2023',
	      percentage: '3,629'
	    }, {
	      year: '2024',
	      percentage: '5,160'
	    }, {
	      year: '2025',
	      percentage: '3,691'
	    }, {
	      year: '2026',
	      percentage: '3,187'
	    }],
	    years: ['2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026']
	  },
	  diversalAtention: {
	    percentage: ['0,761', '0,795', '3,880', '5,302', '3,797', '3,446'],
	    dataTableOnMobileApp: [{
	      year: '2021',
	      percentage: '0,761'
	    }, {
	      year: '2022',
	      percentage: '0,795'
	    }, {
	      year: '2023',
	      percentage: '3,880'
	    }, {
	      year: '2024',
	      percentage: '5,302'
	    }, {
	      year: '2025',
	      percentage: '3,797'
	    }, {
	      year: '2026',
	      percentage: '3,446'
	    }],
	    years: ['2021', '2022', '2023', '2024', '2025', '2026']
	  }
	};

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitialDataService = function () {
	  InitialDataService.$inject = ["$http", "$state", "$log", "AuthenticationService", "LoansUserDataService", "LoansOperationsService", "LoansEmployeeRepositoryService"];
	  function InitialDataService($http, $state, $log, AuthenticationService, LoansUserDataService, LoansOperationsService, LoansEmployeeRepositoryService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, InitialDataService);
	    this.$http = $http;
	    this.state = $state;
	    this.log = $log;
	
	    this.employeeRepositoryService = LoansEmployeeRepositoryService;
	    this.userDataService = LoansUserDataService;
	    this.loansOperationsService = LoansOperationsService;
	    this.employeeId = AuthenticationService.getEmployeeId();
	    this.employeeProfileInfo = {};
	  }
	
	  (0, _createClass3.default)(InitialDataService, [{
	    key: 'initMainData',
	    value: function initMainData() {
	      var _this = this;
	
	      return this.employeeRepositoryService.getEmployee(this.employeeProfileInfo).then(function (employee) {
	        _this.userDataService.setEmployee(employee);
	        return employee;
	      });
	    }
	  }, {
	    key: 'getEmployeeProfileInfo',
	    value: function getEmployeeProfileInfo() {
	      var _this2 = this;
	
	      return this.loansOperationsService.getCreditworthiness(this.employeeId).then(function (creditworthiness) {
	        _this2.employeeProfileInfo = creditworthiness.employeeProfile;
	        _this2.log.info('getEmployeeProfileInfo', _this2.employeeProfileInfo);
	        return creditworthiness.employeeProfile;
	      }, function (error) {
	        _this2.log.error('getEmployeeProfileInfo', error);
	      });
	    }
	  }]);
	  return InitialDataService;
	}();
	
	exports.default = InitialDataService;

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _loans = __webpack_require__(576);
	
	var _employeeRepository = __webpack_require__(2188);
	
	var _employeeRepository2 = _interopRequireDefault(_employeeRepository);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { STATES } from 'common/domain/states';
	var EmployeeRepositoryService = function () {
	  EmployeeRepositoryService.$inject = ["$http", "$log", "$window"];
	  function EmployeeRepositoryService($http, $log, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, EmployeeRepositoryService);
	    this.http = $http;
	    this.log = $log;
	    this.isMobileApp = $window.innerWidth < 1024;
	  }
	
	  (0, _createClass3.default)(EmployeeRepositoryService, [{
	    key: 'getEmployee',
	    value: function getEmployee(employeeProfileInfo) {
	      var _this = this;
	
	      return this.http.get(_loans.ENDPOINTS_LOANS.get.modalities(employeeProfileInfo.employeeId)).then(function (response) {
	        var modalities = response.data.modalities;
	        var employeeData = employeeProfileInfo;
	        return _employeeRepository2.default.assemble(employeeData, { modalities: modalities });
	      }).catch(function (err) {
	        _this.log.error('EmployeeRepositoryService getEmployee() modalities', employeeProfileInfo, err);
	        // TODO: [Manu] eliminado ya que en la APP se ve un instante antes de redirigir a login, e incluso pueda causar otros problemas. Ver si en la Web es necesario o con el errorInterceptor es suficiente
	        // this.state.go(STATES.ERROR);
	      });
	    }
	  }]);
	  return EmployeeRepositoryService;
	}();
	
	exports.default = EmployeeRepositoryService;

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _profile = __webpack_require__(1172);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _loansUser = __webpack_require__(2189);
	
	var _loansUser2 = _interopRequireDefault(_loansUser);
	
	var _formatter = __webpack_require__(1362);
	
	var _formatter2 = _interopRequireDefault(_formatter);
	
	var _error = __webpack_require__(1361);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function assembleProfile(employeeProfileInfo) {
	  var profile = new _profile2.default();
	  profile.name = employeeProfileInfo.name;
	  profile.userId = employeeProfileInfo.employeeId;
	  profile.image = employeeProfileInfo.image;
	  profile.email = employeeProfileInfo.email;
	
	  if (employeeProfileInfo.bbvaUserId) {
	    profile.bbvaUserId = employeeProfileInfo.bbvaUserId;
	  }
	
	  return profile;
	}
	
	var EmployeeDataAssembler = function () {
	  function EmployeeDataAssembler() {
	    (0, _classCallCheck3.default)(this, EmployeeDataAssembler);
	  }
	
	  (0, _createClass3.default)(EmployeeDataAssembler, null, [{
	    key: 'assemble',
	    value: function assemble(employeeProfileInfo, data) {
	      var profile = void 0;
	      (0, _error2.default)(function () {
	        return profile = assembleProfile(employeeProfileInfo);
	      }, _formatter2.default.ASSEMBLE_PROFILE);
	      var user = new _loansUser2.default(employeeProfileInfo.employeeId, profile);
	      user.modalities = data.modalities;
	      user.myLoans = data.myLoans;
	      return user;
	    }
	  }]);
	  return EmployeeDataAssembler;
	}();
	
	exports.default = EmployeeDataAssembler;

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1531);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1534);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1535);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _user = __webpack_require__(1546);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loansUser = function (_User) {
	  (0, _inherits3.default)(loansUser, _User);
	
	  function loansUser(userId, profile) {
	    (0, _classCallCheck3.default)(this, loansUser);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (loansUser.__proto__ || (0, _getPrototypeOf2.default)(loansUser)).call(this, userId, profile));
	
	    _this.creditworthiness = null;
	    return _this;
	  }
	
	  return loansUser;
	}(_user2.default);
	
	exports.default = loansUser;

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1531);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1534);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(2191);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(1535);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _userDataService = __webpack_require__(567);
	
	var _userDataService2 = _interopRequireDefault(_userDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansUserDataService = function (_UserDataService) {
	  (0, _inherits3.default)(LoansUserDataService, _UserDataService);
	
	  function LoansUserDataService() {
	    (0, _classCallCheck3.default)(this, LoansUserDataService);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoansUserDataService.__proto__ || (0, _getPrototypeOf2.default)(LoansUserDataService)).call(this));
	
	    _this.senior = false;
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoansUserDataService, [{
	    key: 'getModalities',
	    value: function getModalities() {
	      return this._employee.modalities;
	    }
	  }, {
	    key: 'setSenior',
	    value: function setSenior(senior) {
	      this.senior = senior;
	    }
	  }, {
	    key: 'getSenior',
	    value: function getSenior() {
	      return this.senior;
	    }
	  }, {
	    key: 'clean',
	    value: function clean() {
	      (0, _get3.default)(LoansUserDataService.prototype.__proto__ || (0, _getPrototypeOf2.default)(LoansUserDataService.prototype), 'clean', this).call(this);
	      this.senior = false;
	    }
	  }]);
	  return LoansUserDataService;
	}(_userDataService2.default);
	
	exports.default = LoansUserDataService;

/***/ }),
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	var _loans = __webpack_require__(576);
	
	var _constants2 = __webpack_require__(1774);
	
	var _moment = __webpack_require__(758);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansOperationsService = function () {
	  LoansOperationsService.$inject = ["$log", "$http", "$state", "$q", "LoansUserDataService"];
	  function LoansOperationsService($log, $http, $state, $q, LoansUserDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansOperationsService);
	    this.log = $log;
	    this.http = $http;
	    this.state = $state;
	    this.q = $q;
	    this.loansUserDataService = LoansUserDataService;
	  }
	
	  (0, _createClass3.default)(LoansOperationsService, [{
	    key: 'getCreditworthiness',
	    value: function getCreditworthiness(employeeId) {
	      var _this = this;
	
	      return this.http.get(_loans.ENDPOINTS_LOANS.get.creditworthiness(employeeId)).then(function (response) {
	        _this.userHasntCreditworthiness = _this.checkIfAllCreditWorthinessIsCero(response.data);
	        _this.loansUserDataService.setSenior(response.data.earlyRetired);
	        if (_this.userHasntCreditworthiness) {
	          _this.goToWageAdvance();
	        }
	        return _this.assembleCreditworthiness(response.data);
	      });
	    }
	  }, {
	    key: 'checkIfAllCreditWorthinessIsCero',
	    value: function checkIfAllCreditWorthinessIsCero(data) {
	      return data.allCero;
	    }
	  }, {
	    key: 'goToWageAdvance',
	    value: function goToWageAdvance() {
	      if (this.loansUserDataService.getSenior()) {
	        this.state.go(_states.STATES.ERROR, {
	          stateName: _constants.PAGE_ERROR.LOANS_CLOSED_TO_USER_WITHOUT_CREDITWORTHINESS
	        });
	      } else {
	        this.state.go(_states.STATES.LOANS.WAGE_ADVANCE, {
	          stateAccess: _constants.EVENTS.WITHOUT_LOANS_ACCESS
	        });
	      }
	    }
	  }, {
	    key: 'assembleCreditworthiness',
	    value: function assembleCreditworthiness(creditworthiness) {
	      var parsedCreditworthiness = void 0;
	
	      try {
	        parsedCreditworthiness = {
	          hireDate: creditworthiness.hireDate,
	          housingWitness: creditworthiness.housingWitness,
	          maximumMonthFee: creditworthiness.maximumMonthFee,
	          yourObligations: creditworthiness.yourObligations,
	          yourRealCapacity: creditworthiness.yourRealCapacity,
	          employeeProfile: creditworthiness.employeeProfile,
	          simulationWitness: creditworthiness.simulationWitness,
	          agreementHousingLoanFixedSimulated: creditworthiness.agreementHousingLoanFixedSimulated,
	          agreementHousingLoanSimulated: creditworthiness.agreementHousingLoanSimulated,
	          socialHousingLoanSimulated: creditworthiness.socialHousingLoanSimulated,
	          socialHousingLoanFixedSimulated: creditworthiness.socialHousingLoanFixedSimulated
	        };
	
	        var showFiveMonth = creditworthiness.fiveMonth && creditworthiness.fiveMonth[0].maximumLimit > 0;
	        var showNineMonth = creditworthiness.nineMonth && creditworthiness.nineMonth[0].maximumLimit > 0;
	        var showVariousCredit = creditworthiness.variousCredit && creditworthiness.variousCredit[0].maximumLimit > 0;
	        var showSocialHousingLoan = creditworthiness.socialHousingLoan && creditworthiness.socialHousingLoan[0].maximumLimit > 0;
	        var showAgreementHousingLoan = creditworthiness.agreementHousingLoan && creditworthiness.agreementHousingLoan[0].maximumLimit > 0;
	        var showAgreementHousingLoanFixed = creditworthiness.agreementHousingLoanFixed && creditworthiness.agreementHousingLoanFixed[0].maximumLimit > 0;
	        var showSocialHousingLoanFixed = creditworthiness.socialHousingLoanFixed && creditworthiness.socialHousingLoanFixed[0].maximumLimit > 0;
	        var showdiversalAtention = creditworthiness.diversalAtention && creditworthiness.diversalAtention[0].maximumLimit > 0;
	
	        if (showFiveMonth) {
	          parsedCreditworthiness.fiveMonth = creditworthiness.fiveMonth[0];
	        }
	        if (showNineMonth) {
	          parsedCreditworthiness.nineMonth = creditworthiness.nineMonth[0];
	        }
	        if (showVariousCredit) {
	          parsedCreditworthiness.variousCredit = creditworthiness.variousCredit[0];
	        }
	        if (showdiversalAtention) {
	          parsedCreditworthiness.diversalAtention = creditworthiness.diversalAtention[0];
	        }
	        if (showSocialHousingLoan) {
	          parsedCreditworthiness.socialHousingLoan = creditworthiness.socialHousingLoan[0];
	        }
	        if (showAgreementHousingLoan) {
	          parsedCreditworthiness.agreementHousingLoan = creditworthiness.agreementHousingLoan[0];
	        }
	        if (showAgreementHousingLoanFixed) {
	          parsedCreditworthiness.agreementHousingLoanFixed = creditworthiness.agreementHousingLoanFixed[0];
	        }
	        if (showSocialHousingLoanFixed) {
	          parsedCreditworthiness.socialHousingLoanFixed = creditworthiness.socialHousingLoanFixed[0];
	        }
	      } catch (error) {
	        this.log.error(error);
	        parsedCreditworthiness = {};
	      }
	
	      return parsedCreditworthiness;
	    }
	  }, {
	    key: 'createLoan',
	    value: function createLoan(employeeId, loan) {
	      var data = {
	        loanSignup: [loan]
	      };
	      this.log.info('LoansOperationsService.create:', employeeId, data);
	      return this.http.post(_loans.ENDPOINTS_LOANS.post.createLoan(employeeId), data);
	    }
	  }, {
	    key: 'cancelAmortization',
	    value: function cancelAmortization(employeeId, loan) {
	      var identifying = loan.identifying;
	      var data = {
	        amortizations: [{
	          identifying: identifying
	        }]
	      };
	      var config = {
	        data: data
	      };
	      this.log.info('LoansOperationsService.cancelAmortization:', employeeId, config);
	      return this.http.delete(_loans.ENDPOINTS_LOANS.delete.amortization(employeeId), config);
	    }
	  }, {
	    key: 'canSignUp',
	    value: function canSignUp(loanId, creditworthinessOfLoan, hireDate) {
	      if (loanId === _constants2.LOANS.ID.SOCIAL_HOUSING_LOAN) {
	        this.checkLengthOfService(hireDate);
	      }
	
	      this.checkCreditworthiness(creditworthinessOfLoan);
	    }
	  }, {
	    key: 'checkLengthOfService',
	    value: function checkLengthOfService(hireDate) {
	      if (!hireDate) {
	        return this.log.info('Hire date is not present, skip length of service check ...');
	      }
	
	      var lengthOfService = this.getLengthOfService(hireDate);
	      var lengthOfServiceError = lengthOfService < _constants2.MIN_LENGTH_OF_SERVICE_FOR_SIGN_UP;
	
	      if (lengthOfServiceError) {
	        throw new Error('lengthOfServiceError');
	      }
	    }
	  }, {
	    key: 'getLengthOfService',
	    value: function getLengthOfService(hireDateString) {
	      var hireDate = new Date(hireDateString);
	      var today = new Date();
	      return (0, _moment2.default)(today).diff(hireDate, 'years');
	    }
	  }, {
	    key: 'checkCreditworthiness',
	    value: function checkCreditworthiness(creditworthinessOfLoan, simulationWitness) {
	      if (simulationWitness) {
	        return true;
	      }
	
	      var invalidInsuranceLimit = creditworthinessOfLoan.realWithInsuranceLimit === 0;
	      var invalidNoInsuranceLimit = creditworthinessOfLoan.realWithoutInsuranceLimit === 0;
	
	      return !(invalidInsuranceLimit && invalidNoInsuranceLimit);
	    }
	  }, {
	    key: 'getEuribor',
	    value: function getEuribor() {
	      return this.http.get(_loans.ENDPOINTS_LOANS.get.dataEuribor());
	    }
	  }, {
	    key: 'getInterestSV',
	    value: function getInterestSV() {
	      return this.http.get(_loans.ENDPOINTS_LOANS.get.dataSV());
	    }
	  }, {
	    key: 'getInterestVC',
	    value: function getInterestVC() {
	      return this.http.get(_loans.ENDPOINTS_LOANS.get.dataVC());
	    }
	  }, {
	    key: 'putCadastralReference',
	    value: function putCadastralReference(employeeId, params) {
	      return this.http.put(_loans.ENDPOINTS_LOANS.put.modifyCadastralReference(employeeId), params).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getFamilies',
	    value: function getFamilies() {
	      return this.http.get(_loans.ENDPOINTS_LOANS.get.familiesNeedALoan());
	    }
	  }]);
	  return LoansOperationsService;
	}();
	
	exports.default = LoansOperationsService;

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATES = _constants.LOANS.STATES.ID;
	var loansStates = {};
	
	loansStates[STATES.CANCELLED] = { // 0 - Cancelado
	  text: 'LOANS.MY_LOANS_CARD.STATES.CANCELLED',
	  icon: 'icon icon-cancel',
	  mapTo: STATES.NOT_IN_FORCE,
	  title: '',
	  textFilter: ''
	};
	
	loansStates[STATES.IN_STUDIO] = { // 1 - Activo
	  text: 'LOANS.MY_LOANS_CARD.STATES.IN_STUDIO',
	  icon: 'icon icon-approved',
	  mapTo: STATES.IN_STUDIO,
	  title: '',
	  textFilter: ''
	};
	
	loansStates[STATES.AUTHORIZED] = { // A - Autorizado
	  text: 'LOANS.MY_LOANS_CARD.STATES.AUTHORIZED',
	  icon: 'icon icon-authorized',
	  mapTo: STATES.AUTHORIZED,
	  title: 'LOANS.LOANS_FILTERS.TITLES.AUTHORIZED',
	  textFilter: 'LOANS.LOANS_FILTERS.TEXT.AUTHORIZED'
	};
	
	loansStates[STATES.ANNULATED] = { // B - Anulado
	  text: 'LOANS.MY_LOANS_CARD.STATES.ANNULATED',
	  icon: 'icon icon-cancel',
	  mapTo: STATES.NOT_IN_FORCE,
	  title: '',
	  textFilter: ''
	};
	
	loansStates[STATES.DISCLAIMER] = { // C - Renunciado
	  text: 'LOANS.MY_LOANS_CARD.STATES.DISCLAIMER',
	  icon: 'icon icon-cancel',
	  mapTo: STATES.NOT_IN_FORCE,
	  title: '',
	  textFilter: ''
	};
	
	loansStates[STATES.DENIED] = { // D - Denegado
	  text: 'LOANS.MY_LOANS_CARD.STATES.DENIED',
	  icon: 'icon icon-cross-circle-deny',
	  mapTo: STATES.DENIED,
	  title: 'LOANS.LOANS_FILTERS.TITLES.DENIED',
	  textFilter: 'LOANS.LOANS_FILTERS.TEXT.DENIED'
	};
	
	loansStates[STATES.IN_FORCE] = { // L - En vigor
	  text: 'LOANS.MY_LOANS_CARD.STATES.IN_FORCE',
	  icon: 'icon icon-approved',
	  mapTo: STATES.IN_FORCE,
	  title: 'LOANS.LOANS_FILTERS.TITLES.IN_FORCE',
	  textFilter: 'LOANS.LOANS_FILTERS.TEXT.IN_FORCE'
	};
	
	loansStates[STATES.NOT_IN_FORCE] = { // N - No vigente
	  text: 'LOANS.MY_LOANS_CARD.STATES.NOT_IN_FORCE',
	  icon: 'icon icon-cross-circle',
	  mapTo: STATES.NOT_IN_FORCE,
	  title: 'LOANS.LOANS_FILTERS.TITLES.NOT_IN_FORCE',
	  textFilter: 'LOANS.LOANS_FILTERS.TEXT.NOT_IN_FORCE'
	};
	
	loansStates[STATES.PENDING] = { // P - Pendiente
	  text: 'LOANS.MY_LOANS_CARD.STATES.PENDING',
	  icon: 'icon icon-requested',
	  mapTo: STATES.PENDING,
	  title: 'LOANS.LOANS_FILTERS.TITLES.PENDING',
	  textFilter: 'LOANS.LOANS_FILTERS.TEXT.PENDING'
	};
	
	loansStates[STATES.REGRESSED] = { // R - Retrocedido
	  text: 'LOANS.MY_LOANS_CARD.STATES.REGRESSED',
	  icon: 'icon icon-requested',
	  mapTo: STATES.NOT_IN_FORCE,
	  title: '',
	  textFilter: ''
	};
	
	loansStates[STATES.SUBSCRIBER] = { // X - Abonado
	  text: 'LOANS.MY_LOANS_CARD.STATES.SUBSCRIBER',
	  icon: 'icon icon-approved',
	  mapTo: STATES.IN_FORCE,
	  title: '',
	  textFilter: ''
	};
	
	loansStates[STATES.TRANSITIONAL_INTEGRATION] = { // Z - Transitorio de integración
	  text: 'LOANS.MY_LOANS_CARD.STATES.TRANSITIONAL_INTEGRATION',
	  icon: 'icon icon-requested',
	  mapTo: STATES.TRANSITIONAL_INTEGRATION,
	  title: '',
	  textFilter: ''
	};
	
	loansStates[STATES.PENDING_SIGNATURE] = { // F - Pendiente de firma
	  text: 'LOANS.MY_LOANS_CARD.STATES.PENDING_SIGNATURE',
	  icon: 'icon icon-pencil-circle',
	  mapTo: STATES.PENDING_SIGNATURE,
	  title: 'LOANS.LOANS_FILTERS.TITLES.PENDING_SIGNATURE',
	  textFilter: 'LOANS.LOANS_FILTERS.TEXT.PENDING_SIGNATURE'
	};
	
	var LoansStatesService = function () {
	  function LoansStatesService() {
	    (0, _classCallCheck3.default)(this, LoansStatesService);
	  }
	
	  (0, _createClass3.default)(LoansStatesService, [{
	    key: '_checkStatesToFilter',
	    value: function _checkStatesToFilter(state) {
	      return state === STATES.IN_FORCE || state === STATES.AUTHORIZED || state === STATES.PENDING || state === STATES.PENDING_SIGNATURE || state === STATES.NOT_IN_FORCE || state === STATES.DENIED;
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      return loansStates;
	    }
	  }, {
	    key: 'mapStatusCode',
	    value: function mapStatusCode(loan) {
	      loan.originalStatusCode = loan.statusCode;
	      loan.statusCode = loansStates[loan.statusCode].mapTo;
	      return loan;
	    }
	  }, {
	    key: 'states',
	    get: function get() {
	      return STATES;
	    }
	  }, {
	    key: 'statesFilters',
	    get: function get() {
	      var statesToFilter = angular.copy(STATES);
	      for (var state in STATES) {
	        if (!this._checkStatesToFilter(STATES[state])) {
	          delete statesToFilter[state];
	        }
	      }
	
	      return {
	        statesToFilter: statesToFilter,
	        loansStates: loansStates
	      };
	    }
	  }]);
	  return LoansStatesService;
	}();
	
	exports.default = LoansStatesService;

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	var _constantsLoans = __webpack_require__(1774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansNeedALoanService = function () {
	  LoansNeedALoanService.$inject = ["$state", "LoansOperationsService", "loansStaticService", "$log"];
	  function LoansNeedALoanService($state, LoansOperationsService, loansStaticService, $log) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansNeedALoanService);
	    this.state = $state;
	    this.loansOperationsService = LoansOperationsService;
	    this.loansStaticService = loansStaticService;
	    this.log = $log;
	    this.isDataSimulationSaved = false;
	  }
	
	  (0, _createClass3.default)(LoansNeedALoanService, [{
	    key: 'onOpenDetail',
	    value: function onOpenDetail(dataLoan) {
	      this.state.go(_states.STATES.LOANS.DETAIL, {
	        loanId: dataLoan.loanId,
	        allowGoBack: dataLoan.allowGoBack,
	        from: _states.STATES.LOANS.NEED_A_LOAN,
	        snapshot: this.getSnapshotDetail(dataLoan)
	      });
	    }
	  }, {
	    key: 'onOpenDetailCatalog',
	    value: function onOpenDetailCatalog(dataLoan) {
	      var snapshotTemp = this.getSnapshotDetail(dataLoan);
	      snapshotTemp.step = 'resume';
	
	      this.state.go(_states.STATES.LOANS.DETAIL, {
	        loanId: dataLoan.loanId,
	        allowGoBack: dataLoan.allowGoBack,
	        from: _states.STATES.LOANS.SIGN_UP,
	        snapshot: snapshotTemp
	      });
	    }
	  }, {
	    key: 'getSnapshotDetail',
	    value: function getSnapshotDetail(dataLoan) {
	      return {
	        loanSimulation: dataLoan.loanSimulationRequest,
	        simulation: dataLoan.simulation,
	        familySelected: dataLoan.familySelected,
	        optionFamilySelected: dataLoan.optionFamilySelected,
	        families: dataLoan.families,
	        codeOptionSelected: dataLoan.codeOptionSelected,
	        loan: dataLoan.loan
	      };
	    }
	  }, {
	    key: 'onSelectLoan',
	    value: function onSelectLoan($event, isSignUp) {
	      var loanId = $event.loanId;
	      var creditworthiness = $event.creditworthiness || this.creditworthiness;
	      var creditworthinessOfLoan = creditworthiness[loanId];
	      var hireDate = creditworthiness.hireDate;
	
	      try {
	        this.loansOperationsService.canSignUp(loanId, creditworthinessOfLoan, hireDate);
	      } catch (reason) {
	        return reason.message;
	      }
	
	      if ($event.simulation) {
	        this.simulation = $event.simulation;
	      }
	
	      this.loan = this.getLoan(loanId);
	      this.loanSimulation = $event.loanSimulation;
	      this.housingLoan = this.isHousingLoan(this.loan.id);
	      this.housingChange = creditworthiness.housingWitness;
	      this.isVariousCredit = this.loan.id === _constantsLoans.LOANS.ID.VARIOUS_CREDIT;
	
	      if (!isSignUp) {
	        var from = _states.STATES.LOANS.NEED_A_LOAN;
	        var snapshot = this.getSnapshotSelect();
	        snapshot.dataToGoBack = $event.dataToGoBack;
	        this.state.go(_states.STATES.LOANS.SIGN_UP, { from: from, loanId: loanId, snapshot: snapshot });
	      }
	    }
	  }, {
	    key: 'getLoan',
	    value: function getLoan(loanId) {
	      return this.loansStaticService.get(loanId);
	    }
	  }, {
	    key: 'isHousingLoan',
	    value: function isHousingLoan(loanId) {
	      return loanId === _constantsLoans.LOANS.ID.SOCIAL_HOUSING_LOAN || loanId === _constantsLoans.LOANS.ID.AGREEMENT_HOUSING_LOAN;
	    }
	  }, {
	    key: 'getSnapshotSelect',
	    value: function getSnapshotSelect() {
	      this.simulation = this._makeSimulation();
	
	      return {
	        loanPurposes: this.loanSimulationRequest,
	        simulation: this.simulation,
	        step: 'form',
	        loan: this.loan,
	        backSimulation: this.loanSimulation,
	        isVariousCredit: this.isVariousCredit,
	        housingChange: this.housingChange,
	        housingLoan: this.housingLoan,
	        from: _states.STATES.LOANS.NEED_A_LOAN
	      };
	    }
	  }, {
	    key: '_makeSimulation',
	    value: function _makeSimulation() {
	      return {
	        amountSimulation: this.simulation,
	        loanPurpose: {
	          option: this.loanSimulation.loanPurposeDescription,
	          value: this.loanSimulation.loanPurposeId
	        }
	      };
	    }
	  }, {
	    key: 'setDataSimulation',
	    value: function setDataSimulation(dataSimulation) {
	
	      if (!dataSimulation) {
	        return;
	      }
	
	      this.loanSimulation = dataSimulation.loanSimulation;
	      this.loanSimulationRequest = dataSimulation.loanSimulationRequest;
	      this.simulation = dataSimulation.simulation;
	      this.familySelected = dataSimulation.familySelected;
	      this.optionFamilySelected = dataSimulation.optionFamilySelected;
	      this.families = dataSimulation.families;
	      this.codeOptionSelected = dataSimulation.codeOptionSelected;
	      this.optionsFamiliesToSelect = dataSimulation.optionsFamiliesToSelect;
	      this.creditworthiness = dataSimulation.creditworthiness;
	      this.isDataSimulationSaved = true;
	    }
	  }, {
	    key: 'getDataSimulation',
	    value: function getDataSimulation() {
	      if (this.isDataSimulationSaved || this.loanSimulationRequest !== undefined) {
	        if (this.simulation.amountSimulation) {
	          this.simulation = this.simulation.amountSimulation;
	        }
	
	        return {
	          loanSimulation: this.loanSimulation,
	          loanSimulationRequest: this.loanSimulationRequest,
	          simulation: this.simulation,
	          familySelected: this.familySelected,
	          optionFamilySelected: this.optionFamilySelected,
	          families: this.families,
	          codeOptionSelected: this.codeOptionSelected,
	          optionsFamiliesToSelect: this.optionsFamiliesToSelect,
	          creditworthiness: this.creditworthiness
	        };
	      }
	    }
	  }, {
	    key: 'clearAllDataSimulation',
	    value: function clearAllDataSimulation() {
	      this.isDataSimulationSaved = false;
	      this.selectedOptionFamily = false;
	      this.itemSelected = undefined;
	      this.loanSimulationRequest = undefined;
	      this.codeOptionSelected = null;
	      this.codeLoanSimulation = undefined;
	      this.simulation = {};
	    }
	  }]);
	  return LoansNeedALoanService;
	}();
	
	exports.default = LoansNeedALoanService;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoBackDataService = function () {
	  function GoBackDataService() {
	    (0, _classCallCheck3.default)(this, GoBackDataService);
	  }
	
	  (0, _createClass3.default)(GoBackDataService, [{
	    key: 'setDataSeeConditions',
	    value: function setDataSeeConditions(dataConditions) {
	      this.step = dataConditions.step;
	      this.loan = dataConditions.loan;
	      this.simulation = dataConditions.simulation;
	      this.backSimulation = dataConditions.backSimulation;
	      this.loanPurposes = dataConditions.loanPurposes;
	      this.housingChange = dataConditions.housingChange;
	      this.housingLoan = dataConditions.housingLoan;
	      this.isVariousCredit = dataConditions.isVariousCredit;
	    }
	  }, {
	    key: 'getDataSeeConditions',
	    value: function getDataSeeConditions() {
	      if (this.loan) {
	        return {
	          step: this.step,
	          loan: this.loan,
	          simulation: this.simulation,
	          backSimulation: this.backSimulation,
	          loanPurposes: this.loanPurposes,
	          housingChange: this.housingChange,
	          housingLoan: this.housingLoan,
	          isVariousCredit: this.isVariousCredit
	        };
	      }
	
	      return undefined;
	    }
	  }, {
	    key: 'setDataBackToSignUp',
	    value: function setDataBackToSignUp(dataBackToSignUp) {
	      this.loanSignUp = dataBackToSignUp.loan;
	      this.createLoanSuccessSignUp = dataBackToSignUp.createLoanSuccess;
	      this.createLoanErrorSignUp = dataBackToSignUp.createLoanError;
	      this.errorMessageSignUp = dataBackToSignUp.errorMessage;
	      this.loanResponseId = dataBackToSignUp.loanResponseId;
	      this.backSimulationSignUp = dataBackToSignUp.backSimulation;
	      this.fromSignUp = dataBackToSignUp.from;
	    }
	  }, {
	    key: 'getDataBackToSignUp',
	    value: function getDataBackToSignUp() {
	      if (!this.loanSignUp) {
	        return undefined;
	      }
	
	      return {
	        step: 'resume',
	        loan: this.loanSignUp,
	        createLoanSuccess: this.createLoanSuccessSignUp,
	        createLoanError: this.createLoanErrorSignUp,
	        errorMessage: this.errorMessageSignUp,
	        loanResponseId: this.loanResponseId,
	        backSimulation: this.backSimulationSignUp,
	        from: this.fromSignUp
	      };
	    }
	  }, {
	    key: 'setHideOrShowButtonCadastralSignUp',
	    value: function setHideOrShowButtonCadastralSignUp(data) {
	      this.hideButtonCadastral = data;
	    }
	  }, {
	    key: 'getHideOrShowButtonCadastralSignUp',
	    value: function getHideOrShowButtonCadastralSignUp() {
	      return this.hideButtonCadastral;
	    }
	  }]);
	  return GoBackDataService;
	}();
	
	exports.default = GoBackDataService;

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoansService = function () {
	  LoansService.$inject = ["LoansUserDataService", "LoansInitialDataService"];
	  function LoansService(LoansUserDataService, LoansInitialDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoansService);
	    this.initialDataService = LoansInitialDataService;
	    this.userDataService = LoansUserDataService;
	    this.loaded = false;
	  }
	
	  (0, _createClass3.default)(LoansService, [{
	    key: 'loadEmployeeProfileInfoAndData',
	    value: function loadEmployeeProfileInfoAndData() {
	      var _this = this;
	
	      this.initialDataService.getEmployeeProfileInfo().then(function () {
	        _this._loadData();
	      });
	    }
	  }, {
	    key: '_loadData',
	    value: function _loadData() {
	      var _this2 = this;
	
	      if (!this.userDataService.isEmpty()) {
	        return;
	      }
	
	      this.initialDataService.initMainData().then(function (employee) {
	        if (!employee) return;
	        _this2.employee = employee;
	        _this2.loaded = true;
	        return employee;
	      }, function (err) {
	        _this2.employee = {};
	        throw err;
	      });
	    }
	  }]);
	  return LoansService;
	}();
	
	exports.default = LoansService;

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _solidarity = __webpack_require__(2201);
	
	var _solidarity2 = _interopRequireDefault(_solidarity);
	
	var _solidarity3 = __webpack_require__(2246);
	
	var _solidarity4 = _interopRequireDefault(_solidarity3);
	
	var _solidarity5 = __webpack_require__(2282);
	
	var _solidarity6 = _interopRequireDefault(_solidarity5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var solidarityModule = angular.module('solidarity', [_solidarity6.default, _solidarity2.default, _solidarity4.default]).config(["$translatePartialLoaderProvider", function ($translatePartialLoaderProvider) {
	  'ngInject';
	
	  $translatePartialLoaderProvider.addPart('solidarity.module');
	}]).name;
	
	exports.default = solidarityModule;

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mySolidarity = __webpack_require__(2202);
	
	var _mySolidarity2 = _interopRequireDefault(_mySolidarity);
	
	var _solidarityRouting = __webpack_require__(2239);
	
	var _solidarityRouting2 = _interopRequireDefault(_solidarityRouting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var solidarityFeatures = angular.module('solidarity.features', [_mySolidarity2.default, _solidarityRouting2.default]).name;
	
	exports.default = solidarityFeatures;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _mySolidarity = __webpack_require__(2203);
	
	var _mySolidarity2 = _interopRequireDefault(_mySolidarity);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _ongsList = __webpack_require__(2215);
	
	var _ongsList2 = _interopRequireDefault(_ongsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mySolidarityModule = angular.module('solidarity.mySolidarity', [_angularUiRouter2.default, _ongsList2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.SOLIDARITY.MY_SOLIDARITY, {
	    url: _routes.ROUTES.SOLIDARITY.MY_SOLIDARITY,
	    component: 'mySolidarity',
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).component('mySolidarity', _mySolidarity2.default).name;
	
	exports.default = mySolidarityModule;

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mySolidarity = __webpack_require__(2204);
	
	var _mySolidarity2 = _interopRequireDefault(_mySolidarity);
	
	__webpack_require__(2205);
	
	var _mySolidarity3 = __webpack_require__(2207);
	
	var _mySolidarity4 = _interopRequireDefault(_mySolidarity3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mySolidarity = {
	  restrict: 'E',
	  bindings: {},
	  controller: _mySolidarity4.default,
	  template: _mySolidarity2.default
	};
	
	exports.default = mySolidarity;

/***/ }),
/* 2204 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd\">\n\n  <solidarity-request-modal\n    modal-state=\"$ctrl.modalState\"\n    on-cancel=\"$ctrl.cancelContribution($event)\"\n    on-create=\"$ctrl.createContribution($event)\"\n    ong=\"$ctrl.ongSelected\"\n    amount=\"$ctrl.amount\"\n    error-message=\"$ctrl.errorMessage\">\n  </solidarity-request-modal>\n\n  <section class=\"what-is-solidary-euro\">\n    <header>\n      <h1 class=\"title\" ng-if=\"$ctrl.showTitle()\">{{'SOLIDARITY.WHAT_IS_SOLIDARY_EURO.TITLE' | translate}}</h1>\n    </header>\n    <what-is-solidary-euro\n      ng-if=\"$ctrl.showWhatIsSolidaryEuro()\"\n      set-show-more-info=\"$ctrl.setShowMoreInfo($event)\"></what-is-solidary-euro>\n    <amplify-information\n      ng-if=\"$ctrl.showMoreInfo()\"\n      on-close=\"$ctrl.setShowMoreInfo($event)\"></amplify-information>\n  </section>\n\n  <ongs-list\n    ongs=\"$ctrl.ongList\"\n    on-cancel=\"$ctrl.openModalCancel($event)\"\n    on-edit=\"$ctrl.updateContribution($event)\"\n\n    on-create=\"$ctrl.openModalAccept($event)\"\n    is-loaded=\"$ctrl.isLoaded\">\n  </ongs-list>\n</div>\n"

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2206);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./mySolidarity.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./mySolidarity.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "my-solidarity{display:block}my-solidarity .container.hpd{max-width:1073px}my-solidarity .container.hpd .what-is-solidary-euro{margin-bottom:50px;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center}my-solidarity .container.hpd .title{font-family:Stag Sans;font-size:32px;font-weight:400;color:#0072c9;text-align:center;margin-bottom:50px;margin-top:50px}", ""]);
	
	// exports


/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	var _constants = __webpack_require__(2208);
	
	var _constants2 = __webpack_require__(598);
	
	var _ong = __webpack_require__(2209);
	
	var _ong2 = _interopRequireDefault(_ong);
	
	var _constants3 = __webpack_require__(2212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MySolidarityController = function () {
	  MySolidarityController.$inject = ["cookieService", "solidarityDataService", "solidarityService", "$q", "$log", "$state"];
	  function MySolidarityController(cookieService, solidarityDataService, solidarityService, $q, $log, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MySolidarityController);
	    this.cookieService = cookieService;
	    this.solidarityDataService = solidarityDataService;
	    this.solidarityService = solidarityService;
	    this.q = $q;
	    this.log = $log;
	    this.state = $state;
	
	    this.isLoaded = false;
	    this.employeeId = this.solidarityService.employee;
	    this.ongList = [];
	    this.moreInfo = false;
	    this.ongSelected = {};
	  }
	
	  (0, _createClass3.default)(MySolidarityController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this._setModalState(_constants.SOLIDARITY_STATES.INITIAL);
	      this._initData();
	    }
	  }, {
	    key: '_initData',
	    value: function _initData() {
	      var _this = this;
	
	      this.q.all([this.solidarityDataService.getOngList(), this.solidarityDataService.getContributions(this.employeeId)]).then(function (responses) {
	        var ongData = {
	          ongList: responses[0].data,
	          contributions: responses[1].data
	        };
	
	        _this.log.info('mySolidarity initData', ongData);
	        _this.ongList = _ong2.default.assemble(ongData);
	        _this.log.info('mySolidarity onList', _this.ongList);
	        _this.isLoaded = true;
	      }).catch(function (error) {
	        _this.log.error(error);
	        // TODO: [Manu] revisar esto, no debería hacer falta con errorInterceptor, no falla como en APP Ayuda Alimentaria pq en el routing de loans se hace esta misma llamada pero sin el state.go error
	        _this.state.go(_states.STATES.ERROR);
	      });
	    }
	  }, {
	    key: 'setShowMoreInfo',
	    value: function setShowMoreInfo($event) {
	      this.moreInfo = $event.state;
	    }
	  }, {
	    key: 'showMoreInfo',
	    value: function showMoreInfo() {
	      return this.moreInfo === true;
	    }
	  }, {
	    key: 'userHasSeenWhatIsSolidaryEuro',
	    value: function userHasSeenWhatIsSolidaryEuro() {
	      var cookie = '' + _constants.COOKIES.WHAT_IS_SOLIDARY_EURO + this.employeeId;
	      return this.cookieService.get(cookie);
	    }
	  }, {
	    key: 'showWhatIsSolidaryEuro',
	    value: function showWhatIsSolidaryEuro() {
	      return !this.showMoreInfo() && !this.userHasSeenWhatIsSolidaryEuro();
	    }
	  }, {
	    key: 'showTitle',
	    value: function showTitle() {
	      return this.showWhatIsSolidaryEuro() || this.showMoreInfo();
	    }
	  }, {
	    key: '_setModalState',
	    value: function _setModalState(state) {
	      this.modalState = state;
	    }
	  }, {
	    key: '_openModal',
	    value: function _openModal() {
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'openModalCancel',
	    value: function openModalCancel($event) {
	      this.ongSelected = this._getOngFromList($event.ong);
	      this._setModalState(_constants.SOLIDARITY_STATES.QUESTION_CANCEL);
	      this._openModal();
	    }
	  }, {
	    key: 'openModalAccept',
	    value: function openModalAccept($event) {
	      this.ongSelected = this._getOngFromList($event.ong);
	      this.amount = $event.amount;
	      this._setModalState(_constants.SOLIDARITY_STATES.QUESTION_ACCEPT);
	      this._openModal();
	    }
	  }, {
	    key: 'createContribution',
	    value: function createContribution($event) {
	      var _this2 = this;
	
	      this.ongSelected = this._getOngFromList($event.ong);
	      this.amount = $event.amount;
	      var data = this._formatContribution($event.ong, $event.amount);
	
	      this.solidarityDataService.createContribution(this.employeeId, data).then(function () {
	
	        _this2._setModalState(_constants.SOLIDARITY_STATES.SUCCESS);
	        _this2._openModal();
	        _this2._initData();
	      }).catch(function (response) {
	        _this2.errorMessage = response.data.message;
	        _this2._setModalState(_constants.SOLIDARITY_STATES.FAILED);
	        _this2._openModal();
	      });
	    }
	  }, {
	    key: 'updateContribution',
	    value: function updateContribution($event) {
	      var _this3 = this;
	
	      this.ongSelected = this._getOngFromList($event.ong);
	      this.amount = $event.amount;
	      var data = this._formatContribution($event.ong, $event.amount);
	
	      this.solidarityDataService.updateContribution(this.employeeId, data).then(function () {
	        _this3._setModalState(_constants.SOLIDARITY_STATES.SUCCESS);
	        _this3._openModal();
	        _this3._initData();
	      }).catch(function (response) {
	        _this3.errorMessage = response.data.message;
	        _this3._setModalState(_constants.SOLIDARITY_STATES.FAILED);
	        _this3._openModal();
	      });
	    }
	  }, {
	    key: 'cancelContribution',
	    value: function cancelContribution($event) {
	      var _this4 = this;
	
	      var data = this._formatContribution($event.ong);
	
	      this.solidarityDataService.deleteContribution(this.employeeId, data).then(function () {
	        _this4._setModalState(_constants.SOLIDARITY_STATES.DELETED);
	        _this4._initData();
	      }).catch(function (response) {
	        _this4.errorMessage = response.data.message;
	        _this4._setModalState(_constants.SOLIDARITY_STATES.FAILED);
	      });
	    }
	  }, {
	    key: '_formatContribution',
	    value: function _formatContribution(ong, amount) {
	      var formattedData = [];
	      var entity = ong.code;
	      var startDate = ong.contribution.startDate;
	      amount = amount || ong.contribution.amount;
	      var ongFormatted = { entity: entity, startDate: startDate, amount: amount };
	      formattedData.push(ongFormatted);
	      return formattedData;
	    }
	  }, {
	    key: '_getOngFromList',
	    value: function _getOngFromList(ongSelected) {
	      var ong = this.ongList.filter(function (ong) {
	        return ong.code === ongSelected.code;
	      });
	      return ong[0];
	    }
	  }, {
	    key: '_setCardState',
	    value: function _setCardState(state) {
	      this.ongSelected.setState(state);
	    }
	  }, {
	    key: '_setCardStateContribution',
	    value: function _setCardStateContribution() {
	      this._setCardState(_constants3.ONG_CARD_STATES.CONTRIBUTION);
	    }
	  }, {
	    key: '_setCardStateInitial',
	    value: function _setCardStateInitial() {
	      this._setCardState(_constants3.ONG_CARD_STATES.INITIAL);
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      var _this5 = this;
	
	      var $modal = $(_constants2.MODALS.SOLIDARITY_REQUEST_MODAL);
	      $modal.on('hidden.bs.modal', function () {
	        _this5.modalState = _constants.SOLIDARITY_STATES.INITIAL;
	      });
	      return $(_constants2.MODALS.SOLIDARITY_REQUEST_MODAL);
	    }
	  }]);
	  return MySolidarityController;
	}();
	
	exports.default = MySolidarityController;

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var WHAT_IS_SOLIDAY_EURO_CARDS = [{
	  name: 'donation',
	  class: 'stars',
	  textLineOne: 'SOLIDARITY.WHAT_IS_SOLIDARY_EURO.DONATION_CARD.TITLE',
	  textLineTwo: 'SOLIDARITY.WHAT_IS_SOLIDARY_EURO.DONATION_CARD.LINE_ONE'
	}, {
	  name: 'descount',
	  class: 'descountStars',
	  textLineOne: 'SOLIDARITY.WHAT_IS_SOLIDARY_EURO.DESCOUNT_CARD.TITLE',
	  textLineTwo: 'SOLIDARITY.WHAT_IS_SOLIDARY_EURO.DESCOUNT_CARD.LINE_ONE'
	}];
	
	var COOKIES = {
	  WHAT_IS_SOLIDARY_EURO: 'dontshowsolidaryconcept'
	};
	
	var SOLIDARITY_STATES = {
	  INITIAL: 'initial',
	  SUCCESS: 'success',
	  FAILED: 'failed',
	  ACCEPT: 'accept',
	  QUESTION_ACCEPT: 'questionAcept',
	  QUESTION_CANCEL: 'question',
	  CANCEL: 'cancel',
	  DELETED: 'deleted',
	  FAILED_CANCELATION: 'cancelationfailed'
	};
	
	var SOLIDARITY_QUESTION_SETTINGS = [{
	  text: 'GLOBALS.BUTTON_ACTION.ACCEPT',
	  value: 'cancel'
	}];
	
	var SOLIDARITY_QUESTION_ACCEPT = [{
	  text: 'GLOBALS.BUTTON_ACTION.ACCEPT',
	  value: 'accept'
	}];
	
	exports.WHAT_IS_SOLIDAY_EURO_CARDS = WHAT_IS_SOLIDAY_EURO_CARDS;
	exports.COOKIES = COOKIES;
	exports.SOLIDARITY_STATES = SOLIDARITY_STATES;
	exports.SOLIDARITY_QUESTION_SETTINGS = SOLIDARITY_QUESTION_SETTINGS;
	exports.SOLIDARITY_QUESTION_ACCEPT = SOLIDARITY_QUESTION_ACCEPT;

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _ong = __webpack_require__(2210);
	
	var _ong2 = _interopRequireDefault(_ong);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ongDataAssembler = function () {
	  function ongDataAssembler() {
	    (0, _classCallCheck3.default)(this, ongDataAssembler);
	  }
	
	  (0, _createClass3.default)(ongDataAssembler, null, [{
	    key: 'assemble',
	    value: function assemble(dataArray) {
	      var ongList = dataArray.ongList;
	      var contributions = dataArray.contributions;
	
	      return ongList.map(function (ongData) {
	        var ong = new _ong2.default(ongData);
	
	        var ongStaticData = ong.getStaticData();
	        ong.imgLogo = ongStaticData.imgLogo;
	
	        ong.setDetails(ongStaticData);
	        ong.setContribution(contributions);
	        return ong;
	      });
	    }
	  }]);
	  return ongDataAssembler;
	}();
	
	exports.default = ongDataAssembler;

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _ongsData = __webpack_require__(2211);
	
	var _ongsData2 = _interopRequireDefault(_ongsData);
	
	var _ongsData3 = __webpack_require__(2213);
	
	var _ongsData4 = _interopRequireDefault(_ongsData3);
	
	var _constants = __webpack_require__(2212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ong = function () {
	  function Ong(data) {
	    (0, _classCallCheck3.default)(this, Ong);
	
	    this.code = data.code;
	    this.name = data.literal;
	    this.maxContribution = data.maxContribution || 1;
	    this.minContribution = data.minContribution || 1;
	    this.details = {};
	    this.contribution = {};
	    this.cardState = _constants.ONG_CARD_STATES.INITIAL;
	  }
	
	  (0, _createClass3.default)(Ong, [{
	    key: 'getStaticData',
	    value: function getStaticData() {
	      var data = _ongsData2.default[this.code];
	
	      if (data === undefined) {
	        data = _ongsData2.default.DEFAULT;
	      }
	
	      return data;
	    }
	  }, {
	    key: 'setDetails',
	    value: function setDetails(staticData) {
	      var isDefaultOng = staticData.code === _ongsData4.default.code;
	
	      if (isDefaultOng) return;
	
	      this.details = new OngDetails(staticData);
	    }
	  }, {
	    key: 'setContribution',
	    value: function setContribution(contributions) {
	      var _this = this;
	
	      var contribution = contributions.filter(function (contribution) {
	        return contribution.entity === _this.code;
	      });
	      var hasNotContribution = contribution.length === 0;
	
	      if (hasNotContribution) return;
	
	      this.contribution = new OngContribution(contribution[0]);
	      this.cardState = _constants.ONG_CARD_STATES.CONTRIBUTION;
	    }
	  }, {
	    key: 'setState',
	    value: function setState(cardState) {
	      this.cardState = cardState;
	
	      if (cardState === _constants.ONG_CARD_STATES.INITIAL) {
	        this.contribution.amount = 0;
	      }
	    }
	  }]);
	  return Ong;
	}();
	
	var OngDetails = function OngDetails(details) {
	  (0, _classCallCheck3.default)(this, OngDetails);
	
	  this.imgDetails = details.imgDetails;
	  this.link = details.link;
	  this.linkText = details.linkText;
	  this.moreInformation = details.moreInformation;
	  this.description = details.description;
	};
	
	var OngContribution = function OngContribution(contribution) {
	  (0, _classCallCheck3.default)(this, OngContribution);
	
	  this.amount = contribution.amount;
	  this.startDate = contribution.startDate;
	  this.dischargeDate = contribution.dischargeDate;
	};
	
	exports.default = Ong;

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2212);
	
	var _ongsData = __webpack_require__(2213);
	
	var _ongsData2 = _interopRequireDefault(_ongsData);
	
	var _ongsData3 = __webpack_require__(2214);
	
	var _ongsData4 = _interopRequireDefault(_ongsData3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var raw = {};
	raw[_constants.ONG.CODE.DEFAULT] = _ongsData2.default;
	raw[_constants.ONG.CODE.MSF] = _ongsData4.default;
	
	exports.default = raw;

/***/ }),
/* 2212 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ONG_CARD_STATES = {
	  INITIAL: 'initial',
	  CONTRIBUTION: 'contribution',
	  ADD: 'add',
	  EDIT: 'edit'
	};
	
	var ONG = {
	  CODE: {
	    DEFAULT: 'DEFAULT',
	    MSF: 'MSF'
	  }
	};
	
	exports.ONG = ONG;
	exports.ONG_CARD_STATES = ONG_CARD_STATES;

/***/ }),
/* 2213 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  code: 'ONG-DEFAULT',
	  imgLogo: 'img/solidarity/ong/default/default.jpg',
	  imgDetails: '',
	  link: '',
	  linkText: '',
	  moreInformation: '',
	  description: []
	};

/***/ }),
/* 2214 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// TODO: change the code to the new ong's code
	exports.default = {
	  code: 'MSF',
	  imgLogo: 'img/solidarity/ong/entreculturas/logo_entreculturas.jpg',
	  imgDetails: 'img/solidarity/ong/entreculturas/PA240359.jpg',
	  link: 'https://www.redec.es/es/redec/red-solidaria-de-jovenes',
	  linkText: 'www.redec.es',
	  moreInformation: 'Más información:',
	  description: [{ thin: 'SOLIDARITY.ONGS.ENTRECULTURAS.PARAGRAPH1' }, { thick: 'SOLIDARITY.ONGS.ENTRECULTURASTHICK.PARAGRAPH2', thin: 'SOLIDARITY.ONGS.ENTRECULTURAS.PARAGRAPH2' }, { thick: 'SOLIDARITY.ONGS.ENTRECULTURASTHICK.PARAGRAPH3', thin: 'SOLIDARITY.ONGS.ENTRECULTURAS.PARAGRAPH3' }, { thick: 'SOLIDARITY.ONGS.ENTRECULTURASTHICK.PARAGRAPH4', thin: 'SOLIDARITY.ONGS.ENTRECULTURAS.PARAGRAPH4' }, { thin: 'SOLIDARITY.ONGS.ENTRECULTURAS.PARAGRAPH5' }]
	};

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ongsList = __webpack_require__(2216);
	
	var _ongsList2 = _interopRequireDefault(_ongsList);
	
	var _ongCard = __webpack_require__(2221);
	
	var _ongCard2 = _interopRequireDefault(_ongCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ongsListModule = angular.module('solidarity.ongsList', [_ongCard2.default]).component('ongsList', _ongsList2.default).name;
	
	exports.default = ongsListModule;

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ongsList = __webpack_require__(2217);
	
	var _ongsList2 = _interopRequireDefault(_ongsList);
	
	var _ongsList3 = __webpack_require__(2218);
	
	var _ongsList4 = _interopRequireDefault(_ongsList3);
	
	__webpack_require__(2219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ongsListComponent = {
	  restrict: 'E',
	  bindings: {
	    ongs: '<',
	    onCancel: '&',
	    onEdit: '&',
	    onCreate: '&',
	    isLoaded: '<'
	  },
	  template: _ongsList2.default,
	  controller: _ongsList4.default
	};
	
	exports.default = ongsListComponent;

/***/ }),
/* 2217 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <header>\n    <h1 class=\"title\">{{'SOLIDARITY.ONGS_LIST.TITLE' | translate}}</h1>\n  </header>\n\n  <div ng-repeat=\"ong in $ctrl.ongs track by $index\">\n    <ong-card\n      ong=\"ong\"\n      on-cancel=\"$ctrl.onCancel({$event : $event})\"\n      on-edit=\"$ctrl.onEdit({$event : $event})\"\n      on-create=\"$ctrl.onCreate({$event : $event})\">\n    </ong-card>\n  </div>\n\n  <div class=\"list-empty\" ng-if=\"$ctrl.isEmpty()\">\n    <span class=\"icon-warning\"></span>\n    <span>{{'SOLIDARITY.ONGS_LIST.EMPTY_LIST' | translate}}</span>\n  </div>\n</section>\n"

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OngsListController = function () {
	  function OngsListController() {
	    (0, _classCallCheck3.default)(this, OngsListController);
	  }
	
	  (0, _createClass3.default)(OngsListController, [{
	    key: 'isEmpty',
	    value: function isEmpty() {
	      return (0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.ongs) && this.isLoaded;
	    }
	  }]);
	  return OngsListController;
	}();
	
	exports.default = OngsListController;

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2220);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./ongsList.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./ongsList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "ongs-list{display:block}ongs-list .list-empty{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}ongs-list .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ongCard = __webpack_require__(2222);
	
	var _ongCard2 = _interopRequireDefault(_ongCard);
	
	var _ongCardDetails = __webpack_require__(2227);
	
	var _ongCardDetails2 = _interopRequireDefault(_ongCardDetails);
	
	var _ongCardSwitch = __webpack_require__(2233);
	
	var _ongCardSwitch2 = _interopRequireDefault(_ongCardSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ongCardModule = angular.module('solidarity.ongCard', [_ongCardDetails2.default, _ongCardSwitch2.default]).component('ongCard', _ongCard2.default).name;
	
	exports.default = ongCardModule;

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ongCard = __webpack_require__(2223);
	
	var _ongCard2 = _interopRequireDefault(_ongCard);
	
	var _ongCard3 = __webpack_require__(2224);
	
	var _ongCard4 = _interopRequireDefault(_ongCard3);
	
	__webpack_require__(2225);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ongCardComponent = {
	  restrict: 'E',
	  bindings: {
	    ong: '<',
	    onCancel: '&',
	    onCreate: '&',
	    onEdit: '&'
	  },
	  template: _ongCard2.default,
	  controller: _ongCard4.default
	};
	
	exports.default = ongCardComponent;

/***/ }),
/* 2223 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"card card-container\">\n  <section class=\"card-description\">\n    <div class=\"card-description-image\">\n      <img ng-src=\"{{$ctrl.ong.imgLogo}}\" alt=\"{{ $ctrl.ong.code }}\"/>\n    </div>\n    <div class=\"card-description-info\">\n      <div class=\"card-description-info-title\">\n        <h4>{{$ctrl.ong.name}}</h4>\n        <p ng-if=\"$ctrl.isContributionState() || $ctrl.isEditState()\">{{ 'SOLIDARITY.CARD.DATE' | translate }}: {{ $ctrl.ong.contribution.dischargeDate | date:'dd/MM/yy' }}</p>\n        <hr>\n      </div>\n      <p class=\"card-description-info-donation\">\n        <small>{{ 'SOLIDARITY.CARD.DONATION_MIN' | translate }} {{ $ctrl.ong.minContribution | currency:'€':0 }}</small> -\n        <small>{{ 'SOLIDARITY.CARD.DONATION_MAX' | translate }} {{ $ctrl.ong.maxContribution | currency:'€':0 }}</small>\n      </p>\n    </div>\n  </section>\n\n  <section class=\"card-switch\">\n    <ong-card-switch\n      amount=\"$ctrl.amount\"\n      on-edit-amount=\"$ctrl.editAmount($event)\"\n      min-donation=\"$ctrl.ong.minContribution\"\n      max-donation=\"$ctrl.ong.maxContribution\"\n      card-state=\"$ctrl.ong.cardState\"\n      on-edit-card-state=\"$ctrl.editCardState($event)\">\n    </ong-card-switch>\n  </section>\n\n  <!-- TODO: ongCardButtons component -->\n  <section class=\"card-buttons\" ng-if=\"$ctrl.isInitialState()\">\n    <button type=\"button\" class=\"btn btn-primary btn-app\" name=\"button\"\n      ng-click=\"$ctrl.goAddDonation()\">\n      {{ 'SOLIDARITY.CARD.BUTTONS.DONATE' | translate }}\n    </button>\n\n  </section>\n\n  <section class=\"card-buttons\" ng-if=\"$ctrl.isAddState()\">\n    <button type=\"button\" class=\"btn btn-primary btn-app\" name=\"button\"\n      ng-click=\"$ctrl.addContribution()\">\n      {{ 'SOLIDARITY.CARD.BUTTONS.DONATE' | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-default btn-app\" name=\"button\"\n      ng-click=\"$ctrl.cancelAddDonation()\">\n      {{ 'SOLIDARITY.CARD.BUTTONS.CANCEL' | translate }}\n    </button>\n  </section>\n\n  <section class=\"card-buttons\" ng-if=\"$ctrl.isContributionState()\">\n    <button type=\"button\" class=\"btn btn-primary btn-app\" name=\"button\"\n      ng-click=\"$ctrl.cancelContribution()\">\n      {{ 'SOLIDARITY.CARD.BUTTONS.CANCEL_DONATION' | translate }}\n    </button>\n  </section>\n\n  <section class=\"card-buttons\" ng-if=\"$ctrl.isEditState()\">\n    <button type=\"button\" class=\"btn btn-primary btn-app\" name=\"button\"\n      ng-click=\"$ctrl.updateContribution()\">\n      {{ 'SOLIDARITY.CARD.BUTTONS.DONATE' | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-default btn-app\" name=\"button\"\n      ng-click=\"$ctrl.cancelEditDonation()\">\n      {{ 'SOLIDARITY.CARD.BUTTONS.CANCEL' | translate }}\n    </button>\n  </section>\n</section>\n\n<card-details header-link-title=\"{{'SOLIDARITY.CARD.DETAILS_TITLE' | translate}}\">\n  <ong-card-details details=\"$ctrl.ong.details\"></ong-card-details>\n</card-details>\n"

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(2212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OngsCardController = function () {
	  OngsCardController.$inject = ["EventEmitter", "$log", "$scope"];
	  function OngsCardController(EventEmitter, $log, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OngsCardController);
	    this.EventEmitter = EventEmitter;
	    this.log = $log;
	    this.scope = $scope;
	
	    this._setWatchAmount();
	  }
	
	  (0, _createClass3.default)(OngsCardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.amount = this.ong.contribution.amount;
	    }
	  }, {
	    key: '_setWatchAmount',
	    value: function _setWatchAmount() {
	      var _this = this;
	
	      this.scope.$watch(function () {
	        return _this.ong.contribution.amount;
	      }, function () {
	        _this.amount = _this.ong.contribution.amount;
	      });
	    }
	
	    // TODO: ongCardButtons component
	
	  }, {
	    key: 'isInitialState',
	    value: function isInitialState() {
	      return this.ong.cardState === _constants.ONG_CARD_STATES.INITIAL;
	    }
	  }, {
	    key: 'isContributionState',
	    value: function isContributionState() {
	      return this.ong.cardState === _constants.ONG_CARD_STATES.CONTRIBUTION;
	    }
	  }, {
	    key: 'isAddState',
	    value: function isAddState() {
	      return this.ong.cardState === _constants.ONG_CARD_STATES.ADD;
	    }
	  }, {
	    key: 'isEditState',
	    value: function isEditState() {
	      return this.ong.cardState === _constants.ONG_CARD_STATES.EDIT;
	    }
	  }, {
	    key: 'goAddDonation',
	    value: function goAddDonation() {
	      this.ong.cardState = _constants.ONG_CARD_STATES.ADD;
	    }
	  }, {
	    key: 'goEditDonation',
	    value: function goEditDonation() {
	      this.ong.cardState = _constants.ONG_CARD_STATES.EDIT;
	    }
	  }, {
	    key: 'cancelAddDonation',
	    value: function cancelAddDonation() {
	      this.ong.cardState = _constants.ONG_CARD_STATES.INITIAL;
	      this.amount = this.ong.contribution.amount;
	    }
	  }, {
	    key: 'cancelEditDonation',
	    value: function cancelEditDonation() {
	      this.ong.cardState = _constants.ONG_CARD_STATES.CONTRIBUTION;
	      this.amount = this.ong.contribution.amount;
	    }
	  }, {
	    key: 'editCardState',
	    value: function editCardState($event) {
	      this.ong.cardState = $event.cardState;
	    }
	  }, {
	    key: 'editAmount',
	    value: function editAmount($event) {
	      this.amount = $event.amount;
	    }
	  }, {
	    key: 'addContribution',
	    value: function addContribution() {
	      if (!this.amount) {
	        this.amount = this.ong.minContribution;
	      }
	
	      this.onCreate(this.EventEmitter({ ong: this.ong, amount: this.amount }));
	    }
	  }, {
	    key: 'updateContribution',
	    value: function updateContribution() {
	      this.onEdit(this.EventEmitter({ ong: this.ong, amount: this.amount }));
	    }
	  }, {
	    key: 'cancelContribution',
	    value: function cancelContribution() {
	      this.onCancel(this.EventEmitter({ ong: this.ong }));
	    }
	  }]);
	  return OngsCardController;
	}();
	
	exports.default = OngsCardController;

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2226);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./ongCard.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/dist/cjs.js!./ongCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "ong-card{display:block;margin-bottom:16px}ong-card .card-container{height:140px;border:1px solid #dddfe2;border-bottom:none;background-color:#fff;box-shadow:0 2px 4px 0 hsla(216,8%,88%,.32);display:-moz-flex;display:-ms-flexbox;display:flex}ong-card .card-description{display:-moz-flex;display:-ms-flexbox;display:flex;flex:auto}ong-card .card-description-image{display:flex;align-items:center;width:224px;height:139px;text-align:center}ong-card .card-description-image img{max-width:224px;max-height:139px}ong-card .card-description-info{-ms-flex-item-align:center;align-self:center}ong-card .card-description-info-title{padding-left:9px;padding-top:16px;color:#666}ong-card .card-description-info-title h4{color:#3e3e3e;font-size:19px;font-weight:400;margin:0}ong-card .card-description-info-title p{font-size:15px;font-weight:300;margin-bottom:6px}ong-card .card-description-info hr{margin:1px 0}ong-card .card-description-info-donation{padding:2px 5px 2px 9px;background-color:#f9f9f9;margin-top:9px;font-size:15px}ong-card .card-switch{min-width:300px;flex:auto}ong-card .card-buttons{width:20%;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;flex:auto}ong-card .card-buttons .btn.btn-app{width:170px;height:38px;line-height:44px}ong-card .card-buttons button:first-child{margin-bottom:15px}ong-card .card-buttons button:only-child{margin-bottom:0}@media(max-width:1024px){ong-card .card-description-image{display:-moz-flex;display:-ms-flexbox;display:flex;width:160px}ong-card .card-description-image img{max-width:160px}ong-card .card-description-info-donation{font-size:14px}ong-card .card-switch{min-width:253px}}", ""]);
	
	// exports


/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ongCardDetails = __webpack_require__(2228);
	
	var _ongCardDetails2 = _interopRequireDefault(_ongCardDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ongCardDetailsModule = angular.module('solidarity.ongCardDetails', []).component('ongCardDetails', _ongCardDetails2.default).name;
	
	exports.default = ongCardDetailsModule;

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ongCardDetails = __webpack_require__(2229);
	
	var _ongCardDetails2 = _interopRequireDefault(_ongCardDetails);
	
	var _ongCardDetails3 = __webpack_require__(2230);
	
	var _ongCardDetails4 = _interopRequireDefault(_ongCardDetails3);
	
	__webpack_require__(2231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ongCardDetailsComponent = {
	  restrict: 'E',
	  bindings: {
	    details: '<'
	  },
	  template: _ongCardDetails2.default,
	  controller: _ongCardDetails4.default
	};
	
	exports.default = ongCardDetailsComponent;

/***/ }),
/* 2229 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"details-container\">\n  <div ng-if=\"$ctrl.hasDetails()\">\n    <div class=\"details-content\">\n      <div class=\"details-image\">\n        <img ng-src=\"{{ $ctrl.details.imgDetails }}\">\n      </div>\n\n      <div class=\"details-description\">\n        <p ng-repeat=\"text in $ctrl.details.description\"> <b>{{text.thick | translate}}</b>{{text.thin | translate}}</p>\n      </div>\n    </div>\n\n    <div class=\"details-link\">\n      <p>{{ $ctrl.details.moreInformation }}\n      <a ng-href=\"{{ $ctrl.details.link }}\" target=\"_blank\">\n        {{ $ctrl.details.linkText }}\n      </a></p>\n    </div>\n  </div>\n\n  <div class=\"details-empty\" ng-if=\"!$ctrl.hasDetails()\">\n    <span class=\"icon-warning\"></span>\n    <span>{{'SOLIDARITY.CARD.DETAILS.EMPTY' | translate}}</span>\n  </div>\n\n</div>\n"

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OngCardDetailsController = function () {
	  function OngCardDetailsController() {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OngCardDetailsController);
	  }
	
	  (0, _createClass3.default)(OngCardDetailsController, [{
	    key: 'hasDetails',
	    value: function hasDetails() {
	      return !(0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.details);
	    }
	  }]);
	  return OngCardDetailsController;
	}();
	
	exports.default = OngCardDetailsController;

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2232);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./ongCardDetails.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./ongCardDetails.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "ong-card-details{display:inline-block;width:100%}ong-card-details .details-container{padding:41px 33px 0;margin:0 34px 32px;background-color:#fff}ong-card-details .details-container .details-content{background-color:#fff;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row}ong-card-details .details-container .details-content .details-image{margin-right:30px}ong-card-details .details-container .details-content .details-image img{width:399px;height:299px}ong-card-details .details-container .details-content .details-description{-ms-flex-item-align:center;align-self:center;font-size:15px;line-height:1.4;text-align:left}ong-card-details .details-container .details-link{text-align:right;padding-bottom:20px}ong-card-details .details-container .details-link a{margin-right:15px;text-decoration:none;color:#0072c9;font-size:15px}ong-card-details .details-container .details-link a:hover{background-color:inherit}ong-card-details .details-container .details-empty{text-align:center;padding-bottom:32px;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}ong-card-details .details-container .details-empty .icon-warning{font-size:57px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _ongCardSwitch = __webpack_require__(2234);
	
	var _ongCardSwitch2 = _interopRequireDefault(_ongCardSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ongCardSwitchModule = _angular2.default.module('solidarity.ongCardSwitch', []).component('ongCardSwitch', _ongCardSwitch2.default).name;
	
	exports.default = ongCardSwitchModule;

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ongCardSwitch = __webpack_require__(2235);
	
	var _ongCardSwitch2 = _interopRequireDefault(_ongCardSwitch);
	
	var _ongCardSwitch3 = __webpack_require__(2236);
	
	var _ongCardSwitch4 = _interopRequireDefault(_ongCardSwitch3);
	
	__webpack_require__(2237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ongCardSwitchComponent = {
	  restrict: 'E',
	  bindings: {
	    amount: '<',
	    onEditAmount: '&',
	    minDonation: '<',
	    maxDonation: '<',
	    cardState: '<',
	    onEditCardState: '&'
	  },
	  template: _ongCardSwitch2.default,
	  controller: _ongCardSwitch4.default
	};
	
	exports.default = ongCardSwitchComponent;

/***/ }),
/* 2235 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"input-group-actions\">\n  <i class=\"icon icon-minus-circle\"\n     ng-click=\"$ctrl.decreaseMoney()\"\n     ng-if=\"$ctrl.isInsertData()\"></i>\n  <div class=\"money-input-container\">\n    <input class=\"money-input\"\n           name=\"money\"\n           type=\"number\"\n           maxlength=\"2\"\n           ng-class=\"$ctrl.getCssMoney()\"\n           ng-model=\"$ctrl.money\"\n           ng-click=\"$ctrl.goInsertData()\"\n           ng-blur=\"$ctrl.onChangeMoney()\"/>\n    <span class=\"input-label\">\n      {{ 'SOLIDARITY.CARD.SWITCH_EURO' | translate }}</span>\n  </div>\n  <i class=\"icon icon-plus-circle\"\n     ng-click=\"$ctrl.increaseMoney()\"\n     ng-if=\"$ctrl.isInsertData()\"></i>\n</div>\n"

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(2212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OngCardSwitchController = function () {
	  OngCardSwitchController.$inject = ["$scope", "EventEmitter"];
	  function OngCardSwitchController($scope, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OngCardSwitchController);
	    this.scope = $scope;
	    this.EventEmitter = EventEmitter;
	
	    this._setWatchAmount();
	  }
	
	  (0, _createClass3.default)(OngCardSwitchController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this._initMoney();
	    }
	  }, {
	    key: '_initMoney',
	    value: function _initMoney() {
	      this.money = this.amount || this.minDonation;
	    }
	  }, {
	    key: '_setWatchAmount',
	    value: function _setWatchAmount() {
	      var _this = this;
	
	      this.scope.$watch(function () {
	        return _this.amount;
	      }, function () {
	        _this.money = _this.amount || _this.minDonation;
	      });
	    }
	  }, {
	    key: 'getCssMoney',
	    value: function getCssMoney() {
	      return {
	        active: this.isInsertData(),
	        'no-contribution': this.cardState === _constants.ONG_CARD_STATES.INITIAL
	      };
	    }
	  }, {
	    key: 'isViewData',
	    value: function isViewData() {
	      return this.cardState === _constants.ONG_CARD_STATES.INITIAL || this.cardState === _constants.ONG_CARD_STATES.CONTRIBUTION;
	    }
	  }, {
	    key: 'isInsertData',
	    value: function isInsertData() {
	      return this.cardState === _constants.ONG_CARD_STATES.ADD || this.cardState === _constants.ONG_CARD_STATES.EDIT;
	    }
	  }, {
	    key: 'goInsertData',
	    value: function goInsertData() {
	      if (this.cardState === _constants.ONG_CARD_STATES.INITIAL) {
	        this.onEditCardState(this.EventEmitter({ cardState: _constants.ONG_CARD_STATES.ADD }));
	        return;
	      }
	
	      if (this.cardState === _constants.ONG_CARD_STATES.CONTRIBUTION) {
	        this.onEditCardState(this.EventEmitter({ cardState: _constants.ONG_CARD_STATES.EDIT }));
	      }
	    }
	  }, {
	    key: 'increaseMoney',
	    value: function increaseMoney() {
	      this.money = this.money + 1 > this.maxDonation ? this.maxDonation : this.money + 1;
	      this.editAmount();
	    }
	  }, {
	    key: 'decreaseMoney',
	    value: function decreaseMoney() {
	      this.money = this.money - 1 < this.minDonation ? this.minDonation : this.money - 1;
	      this.editAmount();
	    }
	  }, {
	    key: 'onChangeMoney',
	    value: function onChangeMoney() {
	      if (this.money > this.maxDonation) {
	        this.money = this.maxDonation;
	      } else if (this.money < this.minDonation) this.money = this.minDonation;
	
	      this.editAmount();
	    }
	  }, {
	    key: 'editAmount',
	    value: function editAmount() {
	      this.onEditAmount(this.EventEmitter({ amount: this.money }));
	    }
	  }]);
	  return OngCardSwitchController;
	}();
	
	exports.default = OngCardSwitchController;

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2238);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./ongCardSwitch.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/dist/cjs.js!./ongCardSwitch.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "ong-card-switch{text-align:center}ong-card-switch .input-group-actions{position:relative;top:10px;display:flex;align-items:center;justify-content:center}ong-card-switch .input-group-actions .icon{font-size:40px;padding-bottom:4px;cursor:pointer}ong-card-switch .money-input-container{border:1px solid #dddfe2;width:134px;height:118px;margin:0 19px}ong-card-switch .money-input-container .money-input{background-color:#fff;cursor:pointer;width:100px;height:50px;border-radius:3px;border:none;margin:20px 18px 3px;font-size:48px;text-align:center;letter-spacing:4px;color:#0072c9;-moz-appearance:textfield;padding:0}ong-card-switch .money-input-container .money-input.no-contribution{color:#aeaeae}ong-card-switch .money-input-container .money-input::-webkit-inner-spin-button,ong-card-switch .money-input-container .money-input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}ong-card-switch .money-input-container .money-input.active,ong-card-switch .money-input-container .money-input:focus{outline:none;width:100px;margin:20px 18px 3px;border:1px solid #0072c9}ong-card-switch .money-input-container .input-label{font-size:16px;color:#666}", ""]);
	
	// exports


/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _solidarityRouting = __webpack_require__(2240);
	
	var _solidarityRouting2 = _interopRequireDefault(_solidarityRouting);
	
	var _solidarityRouting3 = __webpack_require__(2245);
	
	var _solidarityRouting4 = _interopRequireDefault(_solidarityRouting3);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var solidarityRoutingModule = angular.module('solidarity.routing', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.SOLIDARITY.ROOT, {
	    abstract: true,
	    parent: _states.STATES.MAIN_ROUTING,
	    url: _routes.ROUTES.SOLIDARITY.ROOT,
	    component: 'solidarityRouting',
	    data: {
	      requiresAuth: true
	    },
	    resolve: {
	      /* @ngInject */
	      moduleClosed: ["StatusAppCheckers", function moduleClosed(StatusAppCheckers) {
	        return StatusAppCheckers.getClosedModules();
	      }]
	    }
	  });
	}]).component('solidarityRouting', _solidarityRouting2.default).service('solidarityRoutingService', _solidarityRouting4.default).name;
	
	exports.default = solidarityRoutingModule;

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _solidarityRouting = __webpack_require__(2241);
	
	var _solidarityRouting2 = _interopRequireDefault(_solidarityRouting);
	
	var _solidarityRouting3 = __webpack_require__(2242);
	
	var _solidarityRouting4 = _interopRequireDefault(_solidarityRouting3);
	
	__webpack_require__(2243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var solidarityRoutingComponent = {
	  restrict: 'E',
	  bindings: {
	    moduleClosed: '<'
	  },
	  template: _solidarityRouting2.default,
	  controller: _solidarityRouting4.default
	};
	
	exports.default = solidarityRoutingComponent;

/***/ }),
/* 2241 */
/***/ (function(module, exports) {

	module.exports = "<div ui-view></div>\n"

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _states = __webpack_require__(565);
	
	var _constants = __webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolidarityRoutingController = function () {
	  SolidarityRoutingController.$inject = ["$scope", "solidarityService", "$state"];
	  function SolidarityRoutingController($scope, solidarityService, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SolidarityRoutingController);
	    this.scope = $scope;
	    this.solidarityService = solidarityService;
	    this.state = $state;
	  }
	
	  (0, _createClass3.default)(SolidarityRoutingController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.isModuleClosed();
	      this.solidarityService.loadData();
	    }
	  }, {
	    key: 'isModuleClosed',
	    value: function isModuleClosed() {
	      if (this.moduleClosed.isSolidarityEuroClosed && this.moduleClosed.solidarityEuroClosedMessage) {
	        this.state.go(_states.STATES.ERROR, { stateName: _constants.PAGE_ERROR.CLOSED, errorMessage: this.moduleClosed.solidarityEuroClosedMessage });
	        return true;
	      } else if (this.moduleClosed.isSolidarityEuroClosed) {
	        this.state.go(_states.STATES.ERROR, { stateName: _constants.PAGE_ERROR.CLOSED });
	        return true;
	      }
	
	      return false;
	    }
	  }]);
	  return SolidarityRoutingController;
	}();
	
	exports.default = SolidarityRoutingController;

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2244);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./solidarityRouting.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./solidarityRouting.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolidarityRoutingService = function () {
	  SolidarityRoutingService.$inject = ["$transitions"];
	  function SolidarityRoutingService($transitions) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SolidarityRoutingService);
	    this.transitions = $transitions;
	    this.start();
	  }
	
	  (0, _createClass3.default)(SolidarityRoutingService, [{
	    key: 'start',
	    value: function start() {
	      this.visited = {};
	      this.registerOnBeforeTo('my-solidarity');
	    }
	  }, {
	    key: 'registerOnBeforeTo',
	    value: function registerOnBeforeTo(stateName) {
	      var _this = this;
	
	      var criteria = { to: stateName };
	      this.transitions.onBefore(criteria, function () {
	        return _this.setVisited(stateName);
	      });
	    }
	  }, {
	    key: 'setVisited',
	    value: function setVisited(stateName) {
	      this.visited[stateName] = true;
	    }
	  }, {
	    key: 'stateVisited',
	    value: function stateVisited(stateName) {
	      return this.visited[stateName] === true;
	    }
	  }]);
	  return SolidarityRoutingService;
	}();
	
	exports.default = SolidarityRoutingService;

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _whatIsSolidaryEuro = __webpack_require__(2247);
	
	var _whatIsSolidaryEuro2 = _interopRequireDefault(_whatIsSolidaryEuro);
	
	var _amplifyInformation = __webpack_require__(2270);
	
	var _amplifyInformation2 = _interopRequireDefault(_amplifyInformation);
	
	var _solidarityRequestModal = __webpack_require__(2278);
	
	var _solidarityRequestModal2 = _interopRequireDefault(_solidarityRequestModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var solidarityComponents = angular.module('solidarity.components', [_whatIsSolidaryEuro2.default, _amplifyInformation2.default, _solidarityRequestModal2.default]).name;
	
	exports.default = solidarityComponents;

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _whatIsSolidaryEuro = __webpack_require__(2248);
	
	var _whatIsSolidaryEuro2 = _interopRequireDefault(_whatIsSolidaryEuro);
	
	var _whatIsSolidaryList = __webpack_require__(2252);
	
	var _whatIsSolidaryList2 = _interopRequireDefault(_whatIsSolidaryList);
	
	var _whatIsSolidaryCard = __webpack_require__(2258);
	
	var _whatIsSolidaryCard2 = _interopRequireDefault(_whatIsSolidaryCard);
	
	var _whatIsSolidayEuroFooter = __webpack_require__(2264);
	
	var _whatIsSolidayEuroFooter2 = _interopRequireDefault(_whatIsSolidayEuroFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var whatIsSolidaryEuroModule = _angular2.default.module('whatIsSolidaryEuro', [_whatIsSolidaryList2.default, _whatIsSolidaryCard2.default, _whatIsSolidayEuroFooter2.default]).component('whatIsSolidaryEuro', _whatIsSolidaryEuro2.default).name;
	
	exports.default = whatIsSolidaryEuroModule;

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _whatIsSolidaryEuro = __webpack_require__(2249);
	
	var _whatIsSolidaryEuro2 = _interopRequireDefault(_whatIsSolidaryEuro);
	
	__webpack_require__(2250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var whatIsSolidaryEuroComponent = {
	  restrict: 'E',
	  bindings: {
	    setShowMoreInfo: '&'
	  },
	  template: _whatIsSolidaryEuro2.default
	};
	
	exports.default = whatIsSolidaryEuroComponent;

/***/ }),
/* 2249 */
/***/ (function(module, exports) {

	module.exports = "<what-is-solidary-list></what-is-solidary-list>\n<what-is-soliday-euro-footer\n  click-amplify=\"$ctrl.setShowMoreInfo({$event:$event})\">\n</what-is-soliday-euro-footer>\n"

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2251);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./whatIsSolidaryEuro.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./whatIsSolidaryEuro.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "what-is-solidary-euro{width:100%}", ""]);
	
	// exports


/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _whatIsSolidaryList = __webpack_require__(2253);
	
	var _whatIsSolidaryList2 = _interopRequireDefault(_whatIsSolidaryList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var whatIsSolidaryListModule = _angular2.default.module('whatIsSolidaryList', []).component('whatIsSolidaryList', _whatIsSolidaryList2.default).name;
	
	exports.default = whatIsSolidaryListModule;

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _whatIsSolidaryList = __webpack_require__(2254);
	
	var _whatIsSolidaryList2 = _interopRequireDefault(_whatIsSolidaryList);
	
	var _whatIsSolidaryList3 = __webpack_require__(2255);
	
	var _whatIsSolidaryList4 = _interopRequireDefault(_whatIsSolidaryList3);
	
	__webpack_require__(2256);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var whatIsSolidaryListComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _whatIsSolidaryList2.default,
	  controller: _whatIsSolidaryList4.default
	};
	
	exports.default = whatIsSolidaryListComponent;

/***/ }),
/* 2254 */
/***/ (function(module, exports) {

	module.exports = "  <div>  \n    <p>{{\"SOLIDARITY.WHAT_IS_SOLIDARY_EURO.SUBTITLE\" | translate}}</p>\n  </div>\n<div class=\"solidarity-list\">\n  <div class=\"card-list\" ng-repeat=\"card in $ctrl.cards\">\n    <what-is-solidary-card card-data=\"card\"></what-is-solidary-card>\n  </div>\n</div>\n"

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _constants = __webpack_require__(2208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WhatIsSolidaryListController = function WhatIsSolidaryListController() {
	  (0, _classCallCheck3.default)(this, WhatIsSolidaryListController);
	
	  this.cards = _constants.WHAT_IS_SOLIDAY_EURO_CARDS;
	};
	
	exports.default = WhatIsSolidaryListController;

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2257);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./whatIsSolidaryList.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./whatIsSolidaryList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "what-is-solidary-list .solidarity-list{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}what-is-solidary-list .solidarity-list .card-list{flex:auto;overflow:hidden}", ""]);
	
	// exports


/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _whatIsSolidaryCard = __webpack_require__(2259);
	
	var _whatIsSolidaryCard2 = _interopRequireDefault(_whatIsSolidaryCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var whatIsSolidaryCardModule = _angular2.default.module('whatIsSolidaryCard', []).component('whatIsSolidaryCard', _whatIsSolidaryCard2.default).name;
	
	exports.default = whatIsSolidaryCardModule;

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _whatIsSolidaryCard = __webpack_require__(2260);
	
	var _whatIsSolidaryCard2 = _interopRequireDefault(_whatIsSolidaryCard);
	
	__webpack_require__(2261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var whatIsSolidaryCardComponent = {
	  restrict: 'E',
	  bindings: {
	    cardData: '<'
	  },
	  template: _whatIsSolidaryCard2.default
	};
	
	exports.default = whatIsSolidaryCardComponent;

/***/ }),
/* 2260 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"$ctrl.cardData.name\" class=\"card\">\n\n  <div class=\"card-description\">\n    <p class=\"textOne\">{{$ctrl.cardData.textLineOne | translate}}</p>\n    <p class=\"textTwo\">{{$ctrl.cardData.textLineTwo | translate}}</p>\n  </div>\n</div>\n"

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2262);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./whatIsSolidaryCard.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./whatIsSolidaryCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "what-is-solidary-card .card{height:100px;min-width:200px;background-repeat:no-repeat;background-size:cover;background-position:50% 50%}what-is-solidary-card .donation{position:relative;background-image:url(" + __webpack_require__(2263) + ")}what-is-solidary-card .donation .card-description{position:absolute;left:29%;top:25%}what-is-solidary-card .donation .textOne{position:relative;color:#fff;font-size:25px;text-align:left;width:100%;margin-bottom:0;font-weight:550}what-is-solidary-card .descount{margin-left:50px;position:relative;background-image:url(" + __webpack_require__(2263) + ")}what-is-solidary-card .descount .card-description{position:absolute;left:29%;top:25%}what-is-solidary-card .descount .textOne{position:relative;color:#fff;font-size:25px;text-align:left;width:100%;margin-bottom:0;font-weight:550}what-is-solidary-card p{font-family:Stag Sans;position:relative;color:#fff;font-size:16px;text-align:center;width:100%;margin-bottom:0}@media(max-width:944px){what-is-solidary-card .donation .stars{left:15%;bottom:200px}what-is-solidary-card .donation .euro-icon{left:38%}what-is-solidary-card .donation .card-description{left:18%}what-is-solidary-card .descount .descountStars{left:2%}what-is-solidary-card .descount .receipt-icon{left:40%}what-is-solidary-card .descount .card-description{left:12%}}", ""]);
	
	// exports


/***/ }),
/* 2263 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQYAAABWCAIAAACirq8oAAAACXBIWXMAABJ0AAASdAHeZh94AAAAB3RJTUUH5AsLCAsHklNY9AAAAMNJREFUeNrt0zERADAIALFSDUjEGj6ZcMCYSPi7j6x+wPoSgCXAEmAJsARYAiwBlgBLgCXAEmAJsARYAiwBlgBLgCXAEmAJwBJgCbAEWAIsAZYAS4AlwBJgCbAEWAIsAZYAS4AlwBJgCbAEWAKwBFgCLAGWAEuAJcASYAmwBFgCLAGWAEuAJcASYAmwBFgCLAGWACwBlgBLgCXAEmAJsARYAiwBlgBLgCXAEmAJsARYAiwBlgBLgCUAS4AlwBJgCbAEXBlCHQHJ5xI8pQAAAABJRU5ErkJggg=="

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _whatIsSolidayEuroFooter = __webpack_require__(2265);
	
	var _whatIsSolidayEuroFooter2 = _interopRequireDefault(_whatIsSolidayEuroFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var whatIsSolidayEuroFooterModule = _angular2.default.module('whatIsSolidayEuroFooter', []).component('whatIsSolidayEuroFooter', _whatIsSolidayEuroFooter2.default).name;
	
	exports.default = whatIsSolidayEuroFooterModule;

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _whatIsSolidayEuroFooter = __webpack_require__(2266);
	
	var _whatIsSolidayEuroFooter2 = _interopRequireDefault(_whatIsSolidayEuroFooter);
	
	var _whatIsSolidayEuroFooter3 = __webpack_require__(2267);
	
	var _whatIsSolidayEuroFooter4 = _interopRequireDefault(_whatIsSolidayEuroFooter3);
	
	__webpack_require__(2268);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var whatIsSolidayEuroFooterComponent = {
	  restrict: 'E',
	  bindings: {
	    clickAmplify: '&'
	  },
	  template: _whatIsSolidayEuroFooter2.default,
	  controller: _whatIsSolidayEuroFooter4.default
	};
	
	exports.default = whatIsSolidayEuroFooterComponent;

/***/ }),
/* 2266 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content\">\n\n  <div class=\"checkbox pull-left\">\n    <input type=\"checkbox\" id=\"dontShowAgain\" ng-model=\"$ctrl.dontShowAgain\" ng-true-value=\"true\" ng-change=\"$ctrl.setDontShowAgain()\">\n    <label for=\"dontShowAgain\">\n      {{'GLOBALS.COACHMARK.DONTSHOWAGAIN' | translate }}\n    </label>\n  </div>\n\n  <label ng-if=\"False\" ng-click=\"$ctrl.ampInfo()\" class=\"amplify\">\n    {{'SOLIDARITY.MAIN.AMPLIFY_INFORMATION' | translate }}\n  </label>\n\n</div>\n"

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(2208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WhatIsSolidayEuroFooterController = function () {
	  WhatIsSolidayEuroFooterController.$inject = ["EventEmitter", "cookieService", "SolidarityUserDataService"];
	  function WhatIsSolidayEuroFooterController(EventEmitter, cookieService, SolidarityUserDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WhatIsSolidayEuroFooterController);
	    this.EventEmitter = EventEmitter;
	    this.cookieService = cookieService;
	    this.solidarityUserDataService = SolidarityUserDataService;
	  }
	
	  (0, _createClass3.default)(WhatIsSolidayEuroFooterController, [{
	    key: 'ampInfo',
	    value: function ampInfo() {
	      this.setDontShowAgain();
	      this.clickAmplify(this.EventEmitter({ state: true }));
	    }
	  }, {
	    key: 'setDontShowAgain',
	    value: function setDontShowAgain() {
	      if (!this.dontShowAgain) {
	        return;
	      }
	
	      var employeeId = this.solidarityUserDataService._employee;
	      var cookie = '' + _constants.COOKIES.WHAT_IS_SOLIDARY_EURO + employeeId;
	      this.cookieService.put(cookie, this.dontShowAgain);
	    }
	  }]);
	  return WhatIsSolidayEuroFooterController;
	}();
	
	exports.default = WhatIsSolidayEuroFooterController;

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2269);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./whatIsSolidayEuroFooter.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./whatIsSolidayEuroFooter.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "what-is-soliday-euro-footer{position:relative}what-is-soliday-euro-footer label{font-size:15px!important;cursor:pointer;color:#666!important}what-is-soliday-euro-footer .amplify{color:#0072c9!important;float:right;margin-top:10px;padding-right:15px;font-size:15px;font-weight:400!important}what-is-soliday-euro-footer .more label{font-family:Stag Sans!important}what-is-soliday-euro-footer .checkbox input[type=checkbox]+label,what-is-soliday-euro-footer .checkbox input[type=checkbox]:checked+label{background-position-y:2px}what-is-soliday-euro-footer .content{padding-left:15px;padding-top:4px;height:52px;box-shadow:0 2px 4px 0 #dddfe2;border:1px solid #dddfe2;border-top:0}", ""]);
	
	// exports


/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _amplifyInformation = __webpack_require__(2271);
	
	var _amplifyInformation2 = _interopRequireDefault(_amplifyInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var amplifyInformationModule = _angular2.default.module('amplifyInformation', []).component('amplifyInformation', _amplifyInformation2.default).name;
	
	exports.default = amplifyInformationModule;

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _amplifyInformation = __webpack_require__(2272);
	
	var _amplifyInformation2 = _interopRequireDefault(_amplifyInformation);
	
	__webpack_require__(2273);
	
	var _amplifyInformation3 = __webpack_require__(2277);
	
	var _amplifyInformation4 = _interopRequireDefault(_amplifyInformation3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var amplifyInformationComponent = {
	  restrict: 'E',
	  bindings: {
	    onClose: '&'
	  },
	  template: _amplifyInformation2.default,
	  controller: _amplifyInformation4.default
	};
	
	exports.default = amplifyInformationComponent;

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

	module.exports = "<div clas=\"content\">\n  <div class=\"image\">\n    <div class=\"logo\"></div>\n    <p class=\"subtitle\">{{'SOLIDARITY.AMPLIFY_INFORMATION.FEATURE_NAME' | translate }}</p>\n  </div>\n  <div class=\"information\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" class=\"close\" ng-click=\"$ctrl.onDismiss()\"><span class=\"icon-cross\"></span></button>\n    <p>\n      <span class=\"name\">{{'SOLIDARITY.AMPLIFY_INFORMATION.NAME' | translate }}</span>\n      <span>{{'SOLIDARITY.AMPLIFY_INFORMATION.TEXT_MSG1' | translate }}</span>\n    <p>\n    <p>{{'SOLIDARITY.AMPLIFY_INFORMATION.TEXT_MSG2' | translate }}</p>\n    <p>{{'SOLIDARITY.AMPLIFY_INFORMATION.TEXT_MSG3' | translate }}</p>\n  </div>\n</div>\n"

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2274);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./amplifyInformation.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./amplifyInformation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "amplify-information{display:inline-block;width:100%}amplify-information .content{height:300px}amplify-information .image{float:left;width:32%;height:300px;background-image:url(" + __webpack_require__(2275) + ");background-size:334px 300px;display:block}amplify-information .information{width:68%;height:300px;padding:50px;padding-left:48px;box-shadow:0 2px 4px 0 #dddfe2;border:1px solid #dddfe2;font-size:15px;float:left;line-height:1.33;font-family:ArialMT}amplify-information p{margin-bottom:22px}amplify-information .subtitle{font-family:Stag Sans;font-weight:300;position:relative;color:#fff;font-size:18px;text-align:center;width:100%;margin-bottom:-22px;top:122px}amplify-information span{font-size:15px;color:#666}amplify-information .name{font-weight:700}amplify-information .logo{height:36px;top:118px;left:116px;position:relative;background-image:url(" + __webpack_require__(2276) + ");background-repeat:no-repeat}amplify-information .close{position:relative;bottom:35px;left:30px}@media(max-width:944px){amplify-information .image{width:225px;background-size:226px 300px}amplify-information .information{max-width:670px}amplify-information .logo{left:59px}}", ""]);
	
	// exports


/***/ }),
/* 2275 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AmplifyInformationController = function () {
	  AmplifyInformationController.$inject = ["EventEmitter"];
	  function AmplifyInformationController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AmplifyInformationController);
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(AmplifyInformationController, [{
	    key: 'onDismiss',
	    value: function onDismiss() {
	      this.onClose(this.EventEmitter({ state: false }));
	    }
	  }]);
	  return AmplifyInformationController;
	}();
	
	exports.default = AmplifyInformationController;

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _solidarityRequestModal = __webpack_require__(2279);
	
	var _solidarityRequestModal2 = _interopRequireDefault(_solidarityRequestModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var solidarityRequestModalModule = _angular2.default.module('solidarityRequestModal', []).component('solidarityRequestModal', _solidarityRequestModal2.default).name;
	
	exports.default = solidarityRequestModalModule;

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _solidarityRequestModal = __webpack_require__(2280);
	
	var _solidarityRequestModal2 = _interopRequireDefault(_solidarityRequestModal);
	
	var _solidarityRequestModal3 = __webpack_require__(2281);
	
	var _solidarityRequestModal4 = _interopRequireDefault(_solidarityRequestModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var solidarityRequestModalComponent = {
	  restrict: 'E',
	  bindings: {
	    modalState: '<',
	    onCancel: '&',
	    onCreate: '&',
	    ong: '<',
	    errorMessage: '<',
	    amount: '<'
	  },
	  template: _solidarityRequestModal2.default,
	  controller: _solidarityRequestModal4.default
	};
	
	exports.default = solidarityRequestModalComponent;

/***/ }),
/* 2280 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\" id=\"solidarityRequestModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"solidarityRequestModal\">\n  <div class=\"modal-dialog\" role=\"document\">\n\n    <successful-action\n      ng-if=\"$ctrl.isApproved()\"\n      title=\"{{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.SUCCESSFUL_DONATION.TITLE' | translate}}\"\n      description=\"$ctrl.getMessageSuccess()\"\n      close-modal=\"true\">\n    </successful-action>\n\n    <question-modal\n      ng-if=\"$ctrl.isQuestionAccept()\"\n      title=\"{{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.ACCEPT_QUESTION_MODAL.TITLE' | translate }}\"\n      description=\"$ctrl.getMessageQuestionAccept()\"\n      options=\"$ctrl.acceptOptions\"\n      on-selection=\"$ctrl.acceptDonation($event)\">\n     <description-textarea>\n        <p><b>{{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.SUCCESSFUL_DONATION.DETAILED_DESCRIPTION.TITLE' | translate}}</b></p>\n        <p>{{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.SUCCESSFUL_DONATION.DETAILED_DESCRIPTION.MSG_1' | translate}} <span>{{$ctrl.amount}}</span> {{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.SUCCESSFUL_DONATION.DETAILED_DESCRIPTION.MSG_2' | translate}}</p>\n        <p>\n          {{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.SUCCESSFUL_DONATION.DETAILED_DESCRIPTION.MSG_3' | translate}}\n        </p>\n      </description-textarea>\n    </question-modal>\n\n    <successful-action\n      ng-if=\"$ctrl.isDeleted()\"\n      title=\"{{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.DELETED_DONATION.TITLE' | translate}}\"\n      message=\"{{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.DELETED_DONATION.MESSAGE' | translate}}\"\n      close-modal=\"true\">\n    </successful-action>\n\n    <failed-action\n      ng-if=\"$ctrl.isFailed()\"\n      title=\"{{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.DENIED_DONATION' | translate}}\"\n      description=\"{{$ctrl.errorMessage}}\"\n      close-modal=\"true\"\n      button-text=\"{{'GLOBALS.BUTTON_ACTION.OK' | translate}}\"\n      on-dismiss=\"$ctrl.onDismiss()\">\n    </failed-action>\n\n    <failed-action\n      ng-if=\"$ctrl.isFailedCancel()\"\n      title=\"{{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.FAILED_CANCELATION.TITLE' | translate}}\"\n      description=\"{{ 'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.FAILED_CANCELATION.DESCRIPTION' | translate }}\"\n      close-modal=\"true\"\n      button-text=\"{{'GLOBALS.BUTTON_ACTION.OK' | translate}}\"\n      on-dismiss=\"$ctrl.onDismiss()\">\n    </failed-action>\n\n    <question-modal\n      ng-if=\"$ctrl.isQuestionCancel()\"\n      title=\"{{'SOLIDARITY.SOLIDARITY_REQUEST_MODAL.CANCEL_QUESTION_MODAL.TITLE' | translate }}\"\n      description=\"$ctrl.getMessageQuestionCancel()\"\n      options=\"$ctrl.options\"\n      on-selection=\"$ctrl.acceptCancel($event)\">\n    </question-modal>\n\n  </div>\n</div>\n"

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(2208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolidarityRequestModalController = function () {
	  SolidarityRequestModalController.$inject = ["$translate", "EventEmitter"];
	  function SolidarityRequestModalController($translate, EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SolidarityRequestModalController);
	    this.translate = $translate;
	    this.EventEmitter = EventEmitter;
	  }
	
	  (0, _createClass3.default)(SolidarityRequestModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.options = _constants.SOLIDARITY_QUESTION_SETTINGS;
	      this.acceptOptions = _constants.SOLIDARITY_QUESTION_ACCEPT;
	      this._translate();
	    }
	  }, {
	    key: 'isApproved',
	    value: function isApproved() {
	      return this.modalState === _constants.SOLIDARITY_STATES.SUCCESS;
	    }
	  }, {
	    key: 'isFailed',
	    value: function isFailed() {
	      return this.modalState === _constants.SOLIDARITY_STATES.FAILED;
	    }
	  }, {
	    key: 'isDeleted',
	    value: function isDeleted() {
	      return this.modalState === _constants.SOLIDARITY_STATES.DELETED;
	    }
	  }, {
	    key: 'isFailedCancel',
	    value: function isFailedCancel() {
	      return this.modalState === _constants.SOLIDARITY_STATES.FAILED_CANCELATION;
	    }
	  }, {
	    key: 'isQuestionCancel',
	    value: function isQuestionCancel() {
	      return this.modalState === _constants.SOLIDARITY_STATES.QUESTION_CANCEL;
	    }
	  }, {
	    key: 'isQuestionAccept',
	    value: function isQuestionAccept() {
	      return this.modalState === _constants.SOLIDARITY_STATES.QUESTION_ACCEPT;
	    }
	  }, {
	    key: 'acceptCancel',
	    value: function acceptCancel($event) {
	      if ($event.selection === _constants.SOLIDARITY_STATES.CANCEL) {
	        this.onCancel(this.EventEmitter({ ong: this.ong }));
	      }
	    }
	  }, {
	    key: 'acceptDonation',
	    value: function acceptDonation($event) {
	      if ($event.selection === _constants.SOLIDARITY_STATES.ACCEPT) {
	        this.onCreate(this.EventEmitter({ ong: this.ong, amount: this.amount }));
	      }
	    }
	  }, {
	    key: '_translate',
	    value: function _translate() {
	      var _this = this;
	
	      this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.CANCEL_QUESTION_MODAL.DESCRIPTION_MSG1').then(function (translation) {
	        _this.messageQuestionCancelPart1 = translation;
	      });
	
	      this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.CANCEL_QUESTION_MODAL.DESCRIPTION_MSG2').then(function (translation) {
	        _this.messageQuestionCancelPart2 = translation;
	      });
	
	      this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.SUCCESSFUL_DONATION.DESCRIPTION_MSG1').then(function (translation) {
	        _this.messageSuccessPart1 = translation;
	      });
	
	      this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.SUCCESSFUL_DONATION.DESCRIPTION_MSG2').then(function (translation) {
	        _this.messageSuccessPart2 = translation;
	      });
	
	      this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.ACCEPT_QUESTION_MODAL.ACCEPT_MSG1').then(function (translation) {
	        _this.messageQuestionAccetpPart1 = translation;
	      });
	
	      this.translate('SOLIDARITY.SOLIDARITY_REQUEST_MODAL.ACCEPT_QUESTION_MODAL.ACCEPT_MSG2').then(function (translation) {
	        _this.messageQuestionAccetpPart2 = translation;
	      });
	    }
	  }, {
	    key: 'getMessageQuestionCancel',
	    value: function getMessageQuestionCancel() {
	      return this.messageQuestionCancelPart1 + ' ' + this.ong.contribution.amount + ' \u20AC ' + this.messageQuestionCancelPart2 + ' <br> ' + this.ong.name;
	    }
	  }, {
	    key: 'getMessageSuccess',
	    value: function getMessageSuccess() {
	      return this.messageSuccessPart1 + ' ' + this.amount + ' \u20AC ' + this.messageSuccessPart2 + ' <br> ' + this.ong.name;
	    }
	  }, {
	    key: 'getMessageQuestionAccept',
	    value: function getMessageQuestionAccept() {
	      return this.messageQuestionAccetpPart1 + ' ' + this.amount + ' \u20AC ' + this.messageQuestionAccetpPart2 + ' <br> ' + this.ong.name;
	    }
	  }]);
	  return SolidarityRequestModalController;
	}();
	
	exports.default = SolidarityRequestModalController;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _solidarityData = __webpack_require__(2283);
	
	var _solidarityData2 = _interopRequireDefault(_solidarityData);
	
	var _solidarityUserData = __webpack_require__(2285);
	
	var _solidarityUserData2 = _interopRequireDefault(_solidarityUserData);
	
	var _initialData = __webpack_require__(2286);
	
	var _initialData2 = _interopRequireDefault(_initialData);
	
	var _solidarity = __webpack_require__(2287);
	
	var _solidarity2 = _interopRequireDefault(_solidarity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var solidarityCommon = angular.module('solidarity.common', []).service('solidarityDataService', _solidarityData2.default).service('SolidarityUserDataService', _solidarityUserData2.default).service('SolidarityInitialService', _initialData2.default).service('solidarityService', _solidarity2.default).name;
	
	exports.default = solidarityCommon;

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _solidarity = __webpack_require__(2284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolidarityDataService = function () {
	  SolidarityDataService.$inject = ["$http"];
	  function SolidarityDataService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SolidarityDataService);
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(SolidarityDataService, [{
	    key: 'getOngList',
	    value: function getOngList() {
	      return this.http.get(_solidarity.ENDPOINTS_SOLIDARITY.get.ongList());
	    }
	  }, {
	    key: 'getContributions',
	    value: function getContributions(employeeId) {
	      return this.http.get(_solidarity.ENDPOINTS_SOLIDARITY.get.contributions(employeeId));
	    }
	  }, {
	    key: 'createContribution',
	    value: function createContribution(employeeId, data) {
	      var url = _solidarity.ENDPOINTS_SOLIDARITY.post.contributions(employeeId);
	      return this.http.post(url, data);
	    }
	  }, {
	    key: 'updateContribution',
	    value: function updateContribution(employeeId, data) {
	      var url = _solidarity.ENDPOINTS_SOLIDARITY.put.contributions(employeeId);
	      return this.http.put(url, data);
	    }
	  }, {
	    key: 'deleteContribution',
	    value: function deleteContribution(employeeId, data) {
	      var url = _solidarity.ENDPOINTS_SOLIDARITY.delete.contributions(employeeId);
	      var config = {
	        data: data
	      };
	      return this.http.delete(url, config);
	    }
	  }]);
	  return SolidarityDataService;
	}();
	
	exports.default = SolidarityDataService;

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ENDPOINTS_SOLIDARITY = undefined;
	
	var _endpoints = __webpack_require__(556);
	
	var API_URL = ("https://dev.autoservicios1.bbva.com/v01");
	
	var ENDPOINTS_SOLIDARITY = {
	  get: {
	    ongList: function ongList() {
	      return API_URL + '/' + _endpoints.SOLIDARITY_URLS.ROOT + '/' + _endpoints.SOLIDARITY_URLS.ONG_LIST;
	    },
	    contributions: function contributions(employeeId) {
	      return API_URL + '/' + _endpoints.SOLIDARITY_URLS.ROOT + '/' + employeeId + '/' + _endpoints.SOLIDARITY_URLS.CONTRIBUTIONS;
	    }
	  },
	  post: {
	    contributions: function contributions(employeeId) {
	      return API_URL + '/' + _endpoints.SOLIDARITY_URLS.ROOT + '/' + employeeId + '/' + _endpoints.SOLIDARITY_URLS.CONTRIBUTIONS;
	    }
	  },
	  put: {
	    contributions: function contributions(employeeId) {
	      return API_URL + '/' + _endpoints.SOLIDARITY_URLS.ROOT + '/' + employeeId + '/' + _endpoints.SOLIDARITY_URLS.CONTRIBUTIONS;
	    }
	  },
	  delete: {
	    contributions: function contributions(employeeId) {
	      return API_URL + '/' + _endpoints.SOLIDARITY_URLS.ROOT + '/' + employeeId + '/' + _endpoints.SOLIDARITY_URLS.CONTRIBUTIONS;
	    }
	  }
	};
	
	exports.ENDPOINTS_SOLIDARITY = ENDPOINTS_SOLIDARITY;

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1531);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1534);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1535);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _userDataService = __webpack_require__(567);
	
	var _userDataService2 = _interopRequireDefault(_userDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolidarityUserDataService = function (_UserDataService) {
	  (0, _inherits3.default)(SolidarityUserDataService, _UserDataService);
	
	  function SolidarityUserDataService() {
	    (0, _classCallCheck3.default)(this, SolidarityUserDataService);
	    return (0, _possibleConstructorReturn3.default)(this, (SolidarityUserDataService.__proto__ || (0, _getPrototypeOf2.default)(SolidarityUserDataService)).call(this));
	  }
	
	  return SolidarityUserDataService;
	}(_userDataService2.default);
	
	exports.default = SolidarityUserDataService;

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitialDataService = function () {
	  InitialDataService.$inject = ["$http", "AuthenticationService", "$state", "SolidarityUserDataService"];
	  function InitialDataService($http, AuthenticationService, $state, SolidarityUserDataService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, InitialDataService);
	    this.userDataService = SolidarityUserDataService;
	    this.employeeId = AuthenticationService.getEmployeeId();
	  }
	
	  (0, _createClass3.default)(InitialDataService, [{
	    key: 'initMainData',
	    value: function initMainData() {
	      this.userDataService.setEmployee(this.employeeId);
	    }
	  }]);
	  return InitialDataService;
	}();
	
	exports.default = InitialDataService;

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolidarityService = function () {
	  SolidarityService.$inject = ["SolidarityUserDataService", "SolidarityInitialService"];
	  function SolidarityService(SolidarityUserDataService, SolidarityInitialService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SolidarityService);
	    this.initialDataService = SolidarityInitialService;
	    this.userDataService = SolidarityUserDataService;
	    this.loaded = false;
	  }
	
	  (0, _createClass3.default)(SolidarityService, [{
	    key: 'loadData',
	    value: function loadData() {
	      if (!this.userDataService.isEmpty()) {
	        return;
	      }
	
	      this.initialDataService.initMainData();
	      this.employee = this.userDataService.getEmployee();
	    }
	  }]);
	  return SolidarityService;
	}();
	
	exports.default = SolidarityService;

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecurity = __webpack_require__(2289);
	
	var _socialSecurity2 = _interopRequireDefault(_socialSecurity);
	
	var _socialSecurity3 = __webpack_require__(2293);
	
	var _socialSecurity4 = _interopRequireDefault(_socialSecurity3);
	
	var _socialSecurity5 = __webpack_require__(2321);
	
	var _socialSecurity6 = _interopRequireDefault(_socialSecurity5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialsecurityModule = angular.module('social-security', [_socialSecurity2.default, _socialSecurity4.default, _socialSecurity6.default]).config(["$translatePartialLoaderProvider", function ($translatePartialLoaderProvider) {
	  'ngInject';
	
	  $translatePartialLoaderProvider.addPart('social-security.module');
	}]).name;
	
	exports.default = socialsecurityModule;

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userDataService = __webpack_require__(567);
	
	var _userDataService2 = _interopRequireDefault(_userDataService);
	
	var _socialSecurityData = __webpack_require__(2290);
	
	var _socialSecurityData2 = _interopRequireDefault(_socialSecurityData);
	
	var _socialSecurity = __webpack_require__(2292);
	
	var _socialSecurity2 = _interopRequireDefault(_socialSecurity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityCommon = angular.module('social-security.common', []).service('userDataService', _userDataService2.default).service('socialSecurityDataService', _socialSecurityData2.default).service('socialSecurityService', _socialSecurity2.default).name;
	
	exports.default = socialSecurityCommon;

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _socialSecurity = __webpack_require__(2291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TERM_TYPE = {
	  CONTRIBUTION: 'contribution',
	  SETTLEMENT: 'settlement'
	};
	
	var SocialSecurityDataService = function () {
	  SocialSecurityDataService.$inject = ["$http"];
	  function SocialSecurityDataService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SocialSecurityDataService);
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(SocialSecurityDataService, [{
	    key: 'getQuoteBasisInitial',
	    value: function getQuoteBasisInitial(employeeId, data) {
	      data = data || {};
	      return this.http.get(_socialSecurity.ENDPOINTS_SOCIAL_SECURITY.get.quoteBasisInitial(employeeId), data);
	    }
	  }, {
	    key: 'getContributions',
	    value: function getContributions(employeeId, year, month) {
	      var data = {
	        params: {
	          'term_type': TERM_TYPE.CONTRIBUTION,
	          'year': year,
	          'month': month
	        }
	      };
	
	      return this.getQuoteBasisInitial(employeeId, data);
	    }
	  }, {
	    key: 'getSettlements',
	    value: function getSettlements(employeeId, year, month) {
	      var data = {
	        params: {
	          'term_type': TERM_TYPE.SETTLEMENT,
	          'year': year,
	          'month': month
	        }
	      };
	
	      return this.getQuoteBasisInitial(employeeId, data);
	    }
	  }]);
	  return SocialSecurityDataService;
	}();
	
	exports.default = SocialSecurityDataService;

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ENDPOINTS_SOCIAL_SECURITY = undefined;
	
	var _endpoints = __webpack_require__(556);
	
	var API_URL = ("https://dev.autoservicios1.bbva.com/v01");
	
	var ENDPOINTS_SOCIAL_SECURITY = {
	  get: {
	    quoteBasisInitial: function quoteBasisInitial(employeeId) {
	      return API_URL + '/' + _endpoints.SOCIAL_SECURITY_URLS.ROOT + '/' + employeeId + '/' + _endpoints.SOCIAL_SECURITY_URLS.QUOTE_BASIS_INITIAL;
	    }
	  }
	};
	
	exports.ENDPOINTS_SOCIAL_SECURITY = ENDPOINTS_SOCIAL_SECURITY;

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSecurityService = function () {
	  SocialSecurityService.$inject = ["userDataService", "AuthenticationService"];
	  function SocialSecurityService(userDataService, AuthenticationService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SocialSecurityService);
	    this.userDataService = userDataService;
	    this.employeeId = AuthenticationService.getEmployeeId();
	  }
	
	  (0, _createClass3.default)(SocialSecurityService, [{
	    key: 'initData',
	    value: function initData() {
	      if (!this.userDataService.isEmpty()) {
	        return this.userDataService.getEmployee();
	      }
	
	      this.userDataService.setEmployee(this.employeeId);
	    }
	  }]);
	  return SocialSecurityService;
	}();
	
	exports.default = SocialSecurityService;

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecurityCard = __webpack_require__(2294);
	
	var _socialSecurityCard2 = _interopRequireDefault(_socialSecurityCard);
	
	var _socialSecurityHeaderEmployee = __webpack_require__(2304);
	
	var _socialSecurityHeaderEmployee2 = _interopRequireDefault(_socialSecurityHeaderEmployee);
	
	var _socialSecuritySearch = __webpack_require__(2309);
	
	var _socialSecuritySearch2 = _interopRequireDefault(_socialSecuritySearch);
	
	var _socialSecurityModal = __webpack_require__(2316);
	
	var _socialSecurityModal2 = _interopRequireDefault(_socialSecurityModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityComponents = angular.module('social-security.components', [_socialSecurityCard2.default, _socialSecurityHeaderEmployee2.default, _socialSecuritySearch2.default, _socialSecurityModal2.default]).name;
	
	exports.default = socialSecurityComponents;

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _socialSecurityCard = __webpack_require__(2295);
	
	var _socialSecurityCard2 = _interopRequireDefault(_socialSecurityCard);
	
	var _socialSecurityData = __webpack_require__(2299);
	
	var _socialSecurityData2 = _interopRequireDefault(_socialSecurityData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityCardModule = _angular2.default.module('socialSecurityCard', [_socialSecurityData2.default]).component('socialSecurityCard', _socialSecurityCard2.default).name;
	
	exports.default = socialSecurityCardModule;

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecurityCard = __webpack_require__(2296);
	
	var _socialSecurityCard2 = _interopRequireDefault(_socialSecurityCard);
	
	__webpack_require__(2297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityCardComponent = {
	  restrict: 'E',
	  bindings: {
	    ssData: '<'
	  },
	  template: _socialSecurityCard2.default
	};
	
	exports.default = socialSecurityCardComponent;

/***/ }),
/* 2296 */
/***/ (function(module, exports) {

	module.exports = "<hr />\n\n<div class=\"first-row row\">\n  <div class=\"col-md-4 col-sm-12  row\">\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.QUOTATION_PERIOD' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.SETTLEMENT_PERIOD' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.CCC' | translate}}</span>\n      </p>\n    </div>\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.contributionTerm}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.settlementTerm}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.settlementCentre}}\"></social-security-data>\n      </p>\n    </div>\n  </div>\n  <div class=\"col-md-4 col-sm-12 row\">\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.SETTLEMENT_TYPE' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.SECTION_START' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.GROUP_RATE' | translate}}</span>\n      </p>\n    </div>\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.settlementType}} {{$ctrl.ssData.settlementTypeLiteral}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.contributionStartDate}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.fareGroup}}\"></social-security-data>\n      </p>\n    </div>\n  </div>\n  <div class=\"col-md-4 col-sm-12 row\">\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.FINGERPRINT' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.SECTION_END' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.CONTRACT' | translate}}</span>\n      </p>\n    </div>\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.trace}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.contributionEndDate}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.employeeAgreementType}}\"></social-security-data>\n      </p>\n   </div>\n  </div>\n</div>\n\n<div class=\"second-row row\">\n  <div class=\"col-md-4 col-sm-12 row\">\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.QUOTATION_DAYS' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.QUOTATION_HOURS' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.COMPLEMENTARI_HOURS' | translate}}</span>\n      </p>\n    </div>\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.contributionDays}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.quoteHours}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.complementaryHours}}\"></social-security-data>\n      </p>\n    </div>\n  </div>\n  <div class=\"col-md-4 col-sm-12 row middle\">\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.BASE_CC' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.BASE_AT' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.COMP_IT_ENF_COMMON' | translate}}</span>\n      </p>\n    </div>\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.commonContingencyBasis}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.unemploymentBasis}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.commonDiseasePerk}}\"></social-security-data>\n      </p>\n    </div>\n  </div>\n  <div class=\"col-md-4 col-sm-12 row\">\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.COMP_IT_ACC_TRAB' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.EXTRA_BASE_HH' | translate}}</span>\n      </p>\n      <p>\n        <span>{{ 'SOCIAL_SECURITY.SOCIAL_SECURITY_CARD.COMPLEMETARY_BASE_HH' | translate}}</span>\n      </p>\n    </div>\n    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.workAccidentPerk}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.extraHoursBasis}}\"></social-security-data>\n      </p>\n      <p>\n        <social-security-data text=\"{{$ctrl.ssData.complementaryHoursBasis}}\"></social-security-data>\n      </p>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2298);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurityCard.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurityCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "social-security-card{display:block;background-color:#fff;margin-top:10px}social-security-card p{margin:0}social-security-card hr{margin:0;height:11px;background-color:#04408f;border-bottom:1px solid #dddfe2;border-top:1px solid #dddfe2}social-security-card span{display:block;white-space:nowrap;color:#04408f;font-family:Stag Sans;line-height:2.5;font-size:15px}social-security-card .first-row{border-bottom:1px solid #aeaeae;border-left:1px solid #dddfe2;border-right:1px solid #eaebed;padding:12px}social-security-card .second-row{padding:10px;border-left:1px solid #dddfe2;border-bottom:1px solid #dddfe2;border-right:1px solid #eaebed}social-security-card .second-row .middle{border-left:1px solid #aeaeae;border-right:1px solid #aeaeae}@media(max-width:944px){social-security-card .second-row .middle{border-left:0;border-right:0}}social-security-card .row{margin-left:0;margin-right:0}", ""]);
	
	// exports


/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecurityData = __webpack_require__(2300);
	
	var _socialSecurityData2 = _interopRequireDefault(_socialSecurityData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityDataModule = angular.module('socialSecurityData', []).component('socialSecurityData', _socialSecurityData2.default).name;
	
	exports.default = socialSecurityDataModule;

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecurityData = __webpack_require__(2301);
	
	var _socialSecurityData2 = _interopRequireDefault(_socialSecurityData);
	
	__webpack_require__(2302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityDataComponent = {
	  restrict: 'E',
	  bindings: {
	    text: '@'
	  },
	  template: _socialSecurityData2.default
	};
	
	exports.default = socialSecurityDataComponent;

/***/ }),
/* 2301 */
/***/ (function(module, exports) {

	module.exports = "<span title=\"{{$ctrl.text}}\">{{$ctrl.text}}</span>\n"

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2303);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurityData.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurityData.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "social-security-data{display:block}social-security-data span{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#0072c9;padding-left:10px;padding-right:10px}", ""]);
	
	// exports


/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _socialSecurityHeaderEmployee = __webpack_require__(2305);
	
	var _socialSecurityHeaderEmployee2 = _interopRequireDefault(_socialSecurityHeaderEmployee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityHeaderEmployeeModule = _angular2.default.module('socialSecurityHeaderEmployee', []).component('socialSecurityHeaderEmployee', _socialSecurityHeaderEmployee2.default).name;
	
	exports.default = socialSecurityHeaderEmployeeModule;

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecurityHeaderEmployee = __webpack_require__(2306);
	
	var _socialSecurityHeaderEmployee2 = _interopRequireDefault(_socialSecurityHeaderEmployee);
	
	__webpack_require__(2307);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityHeaderEmployeeComponent = {
	  restrict: 'E',
	  bindings: {
	    employeeData: '<'
	  },
	  template: _socialSecurityHeaderEmployee2.default
	};
	
	exports.default = socialSecurityHeaderEmployeeComponent;

/***/ }),
/* 2306 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n\n  <div class=\"col-xs-4 col-sm-4 col-md-4\">\n    <span>{{'SOCIAL_SECURITY.SOCIAL_SECURITY_HEADER_EMPLOYEE.SOCIAL_SECURITY_MEMBERSHIP_NUMBER' | translate}}</span>\n    <div class=\"data\">\n      <span>{{$ctrl.employeeData.socialSecurityMembershipNumber}}</span>\n    </div>\n  </div>\n\n  <div class=\"col-xs-4 col-sm-4 col-md-4\">\n    <span>{{'SOCIAL_SECURITY.SOCIAL_SECURITY_HEADER_EMPLOYEE.ID_IDENTIFICATION' | translate}}</span>\n    <div class=\"data\">\n      <span>{{$ctrl.employeeData.idIdentification}}</span>\n    </div>\n  </div>\n\n  <div class=\"col-xs-4 col-sm-4 col-md-4\">\n    <span>{{'SOCIAL_SECURITY.SOCIAL_SECURITY_HEADER_EMPLOYEE.NAME_INITIALS' | translate}}</span>\n    <div class=\"data\">\n      <span>{{$ctrl.employeeData.nameInicials}}</span>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2308);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurityHeaderEmployee.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurityHeaderEmployee.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "social-security-header-employee{display:block;background-color:#eaebed;height:60px;width:100%;padding-top:20px;padding-left:80px;border:1px solid #eaebed;font-size:15px;font-family:Stag Sans}social-security-header-employee .data{display:inline-block;text-align:center;width:200px}social-security-header-employee .data span{color:#0072c9}social-security-header-employee span{color:#04408f}", ""]);
	
	// exports


/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _socialSecuritySearch = __webpack_require__(2310);
	
	var _socialSecuritySearch2 = _interopRequireDefault(_socialSecuritySearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecuritySearchModule = _angular2.default.module('socialSecuritySearch', []).component('socialSecuritySearch', _socialSecuritySearch2.default).name;
	
	exports.default = socialSecuritySearchModule;

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecuritySearch = __webpack_require__(2311);
	
	var _socialSecuritySearch2 = _interopRequireDefault(_socialSecuritySearch);
	
	var _socialSecuritySearch3 = __webpack_require__(2312);
	
	var _socialSecuritySearch4 = _interopRequireDefault(_socialSecuritySearch3);
	
	__webpack_require__(2314);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecuritySearchComponent = {
	  restrict: 'E',
	  bindings: {
	    onSearch: '&'
	  },
	  template: _socialSecuritySearch2.default,
	  controller: _socialSecuritySearch4.default
	};
	
	exports.default = socialSecuritySearchComponent;

/***/ }),
/* 2311 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"form-search\">\n  <div class=\"period-switch\">\n    <label class=\"select\">{{'SOCIAL_SECURITY.SOCIAL_SECURITY_SEARCH.TYPE_OF_PERIOD' | translate}}</label>\n    <div class=\"type\">\n      <option-switch\n        options-data=\"$ctrl.switchOptions\"\n        selected-option=\"$ctrl.option\"\n        on-select=\"$ctrl.getSwitchOption($event)\"></option-switch>\n    </div>\n  </div>\n\n  <div class=\"period-form\">\n    <form name=\"$ctrl.form\">\n      <label>{{'SOCIAL_SECURITY.SOCIAL_SECURITY_SEARCH.SELECT_MONTH' | translate}}</label>\n      <input\n        name=\"month\"\n        type=\"number\"\n        ng-model=\"$ctrl.month\"\n        ng-min=\"$ctrl.minMonthNumber\"\n        ng-max=\"$ctrl.maxMonthNumber\"\n        required=true>\n      <label>{{'SOCIAL_SECURITY.SOCIAL_SECURITY_SEARCH.SELECT_YEAR' | translate}}</label>\n      <input\n        name=\"year\"\n        type=\"number\"\n        ng-model=\"$ctrl.year\"\n        ng-max=\"$ctrl.currentYear\"\n        required=true>\n      <span>{{'SOCIAL_SECURITY.SOCIAL_SECURITY_SEARCH.OF_THE_PERIOD' | translate}}</span>\n    </form>\n  </div>\n\n  <div class=\"button-container\">\n     <button\n      type=\"button\"\n      class=\"btn btn-app btn-default\"\n      ng-click=\"$ctrl.loadInitialData()\"\n      ng-disabled=\"$ctrl.isDisabledButtonInitial()\">{{'SOCIAL_SECURITY.SOCIAL_SECURITY_SEARCH.LOAD_INITIAL_DATA' | translate}}</button>\n\n      <button\n       type=\"button\"\n       class=\"btn btn-app btn-primary\"\n       ng-click=\"$ctrl.searchPeriod()\"\n       ng-disabled=\"$ctrl.isDisabledButtonSearch()\">{{'GLOBALS.BUTTON_ACTION.SEARCH' | translate}}</button>\n  </div>\n</div>\n"

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(2313);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_SWITCH_OPTION = _constants.SS_SWITCH_CONFIG[0].value;
	
	var SocialSecuritySearchController = function () {
	  SocialSecuritySearchController.$inject = ["EventEmitter"];
	  function SocialSecuritySearchController(EventEmitter) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SocialSecuritySearchController);
	    this.EventEmitter = EventEmitter;
	
	    this.maxMonthNumber = _constants.MAX_MONTH_NUMBER;
	    this.minMonthNumber = _constants.MIN_MONTH_NUMBER;
	    this.currentYear = new Date().getFullYear();
	    this._initSwitch();
	    this.initialSearch = true;
	  }
	
	  (0, _createClass3.default)(SocialSecuritySearchController, [{
	    key: 'searchPeriod',
	    value: function searchPeriod() {
	      var searchCriteria = this._formatData();
	      this.initialSearch = false;
	      this.onSearch(this.EventEmitter({ data: searchCriteria }));
	    }
	  }, {
	    key: 'loadInitialData',
	    value: function loadInitialData() {
	      this.initialSearch = true;
	      this._resetForm();
	      this.onSearch();
	    }
	  }, {
	    key: '_initSwitch',
	    value: function _initSwitch() {
	      this.switchOptions = _constants.SS_SWITCH_CONFIG;
	      this.option = DEFAULT_SWITCH_OPTION;
	    }
	  }, {
	    key: '_resetForm',
	    value: function _resetForm() {
	      this.form.$setPristine();
	      this.option = DEFAULT_SWITCH_OPTION;
	      this.month = null;
	      this.year = null;
	    }
	  }, {
	    key: '_formatData',
	    value: function _formatData() {
	      var searchCriteria = {
	        'month': this.month,
	        'year': this.year,
	        'periodType': this.option
	      };
	      return searchCriteria;
	    }
	  }, {
	    key: 'getSwitchOption',
	    value: function getSwitchOption($event) {
	      this.option = $event.option;
	    }
	  }, {
	    key: 'isDisabledButtonSearch',
	    value: function isDisabledButtonSearch() {
	      return this.form.$invalid || this.form.month.$pristine || this.form.year.$pristine;
	    }
	  }, {
	    key: 'isDisabledButtonInitial',
	    value: function isDisabledButtonInitial() {
	      return this.initialSearch;
	    }
	  }]);
	  return SocialSecuritySearchController;
	}();
	
	exports.default = SocialSecuritySearchController;

/***/ }),
/* 2313 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAX_MONTH_NUMBER = 12;
	var MIN_MONTH_NUMBER = 1;
	
	var SS_SWITCH_CONFIG = [{
	  text: 'SOCIAL_SECURITY.SOCIAL_SECURITY_SEARCH.QUOTATION',
	  value: 'quotation'
	}, {
	  text: 'SOCIAL_SECURITY.SOCIAL_SECURITY_SEARCH.SETTLEMENT',
	  value: 'settlement'
	}];
	
	exports.MAX_MONTH_NUMBER = MAX_MONTH_NUMBER;
	exports.MIN_MONTH_NUMBER = MIN_MONTH_NUMBER;
	exports.SS_SWITCH_CONFIG = SS_SWITCH_CONFIG;

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2315);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecuritySearch.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecuritySearch.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "social-security-search{display:block;background-color:#f9f9f9;padding-top:20px;padding-bottom:15px}social-security-search .form-search{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;margin-left:10px;margin-right:10px}social-security-search .form-search label,social-security-search .form-search span{font-size:15px;font-family:Stag Sans;font-weight:400;color:#3e3e3e}social-security-search .form-search .period-switch{-ms-flex-item-align:end;align-self:flex-end;margin-right:10px}social-security-search .form-search .period-switch .type{width:210px!important}social-security-search .form-search .period-switch .type option-switch{display:inline}social-security-search .form-search .period-form{margin-right:10px}social-security-search .form-search .button-container,social-security-search .form-search .period-form{-ms-flex-item-align:end;align-self:flex-end;margin-left:10px}social-security-search input[type=number]{background-color:#fff;box-shadow:0 2px 4px 0 #dddfe2;border:1px solid #dddfe2;color:#0072c9;font-family:Stag Sans;font-size:13px;width:50px;max-width:200px;height:38px;padding-left:10px;text-align:left;margin-left:5px;margin-right:5px;position:relative;top:-2px}social-security-search input[type=number]:focus{border:1px solid #0072c9}social-security-search .btn{width:180px!important;display:block}social-security-search .btn.btn-primary{margin-top:10px}social-security-search .btn-app{height:37px!important;line-height:37px!important}", ""]);
	
	// exports


/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _socialSecurityModal = __webpack_require__(2317);
	
	var _socialSecurityModal2 = _interopRequireDefault(_socialSecurityModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityModalModule = _angular2.default.module('socialSecurityModal', []).component('socialSecurityModal', _socialSecurityModal2.default).name;
	
	exports.default = socialSecurityModalModule;

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecurityModal = __webpack_require__(2318);
	
	var _socialSecurityModal2 = _interopRequireDefault(_socialSecurityModal);
	
	__webpack_require__(2319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityModalComponent = {
	  restrict: 'E',
	  bindings: {
	    errorMsg: '<'
	  },
	  template: _socialSecurityModal2.default
	};
	
	exports.default = socialSecurityModalComponent;

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal\"\n     id=\"socialSecurityModal\"\n     tabindex=\"-1\"\n     role=\"dialog\"\n     aria-labelledby=\"socialSecurityModalLabel\">\n\n  <div class=\"modal-dialog\"\n       role=\"document\">\n\n    <failed-action title=\"{{'GLOBALS.ATTENTION' | translate}}\"\n                   close-modal=\"true\"\n                   modal-id=\"socialSecurityModal\"\n                   button-text=\"{{'GLOBALS.BUTTON_ACTION.OK_GOT_IT' | translate}}\"\n                   on-dismiss=\"$ctrl.onDismiss()\"\n                   description=\"{{$ctrl.errorMsg}}\">\n    </failed-action>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2320);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurityModal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurityModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "social-security-modal .modal-dialog{max-height:410px;max-width:520px}", ""]);
	
	// exports


/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecurity = __webpack_require__(2322);
	
	var _socialSecurity2 = _interopRequireDefault(_socialSecurity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityFeatures = angular.module('social-security.features', [_socialSecurity2.default]).name;
	
	exports.default = socialSecurityFeatures;

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(450);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _socialSecurity = __webpack_require__(2323);
	
	var _socialSecurity2 = _interopRequireDefault(_socialSecurity);
	
	var _routes = __webpack_require__(1040);
	
	var _states = __webpack_require__(565);
	
	var _headerSS = __webpack_require__(2328);
	
	var _headerSS2 = _interopRequireDefault(_headerSS);
	
	var _socialSecurityList = __webpack_require__(2333);
	
	var _socialSecurityList2 = _interopRequireDefault(_socialSecurityList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityModule = angular.module('social-security.socialSecurity', [_angularUiRouter2.default, _headerSS2.default, _socialSecurityList2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state(_states.STATES.SOCIAL_SECURITY, {
	    parent: _states.STATES.MAIN_ROUTING,
	    url: _routes.ROUTES.SOCIAL_SECURITY,
	    component: 'socialSecurity',
	    data: {
	      requiresAuth: true
	    }
	  });
	}]).component('socialSecurity', _socialSecurity2.default).name;
	
	exports.default = socialSecurityModule;

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecurity = __webpack_require__(2324);
	
	var _socialSecurity2 = _interopRequireDefault(_socialSecurity);
	
	__webpack_require__(2325);
	
	var _socialSecurity3 = __webpack_require__(2327);
	
	var _socialSecurity4 = _interopRequireDefault(_socialSecurity3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurity = {
	  restrict: 'E',
	  bindings: {},
	  controller: _socialSecurity4.default,
	  template: _socialSecurity2.default
	};
	
	exports.default = socialSecurity;

/***/ }),
/* 2324 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container hpd\">\n  <social-security-modal error-msg=\"$ctrl.errorMessage\"></social-security-modal>\n\n  <header-ss>{{'SOCIAL_SECURITY.MAIN.TITLE' | translate}}</header-ss>\n\n  <social-security-search on-search=\"$ctrl.searchPeriod($event)\"></social-security-search>\n\n  <div class=\"container-data\">\n    <social-security-header-employee ng-if=\"$ctrl.showHeaderEmployee()\" employee-data=\"$ctrl.employeeData\"></social-security-header-employee>\n\n    <social-security-list ss-data=\"$ctrl.ssData\"></social-security-list>\n  </div>\n</div>\n"

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2326);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurity.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurity.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "social-security{display:block}social-security .container-data{padding:10px;padding-top:5px;background-color:#f9f9f9}", ""]);
	
	// exports


/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(2313);
	
	var _constants2 = __webpack_require__(598);
	
	var _states = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSecurityController = function () {
	  SocialSecurityController.$inject = ["socialSecurityService", "socialSecurityDataService", "$log", "$state"];
	  function SocialSecurityController(socialSecurityService, socialSecurityDataService, $log, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SocialSecurityController);
	    this.socialSecurityService = socialSecurityService;
	    this.socialSecurityDataService = socialSecurityDataService;
	    this.log = $log;
	    this.state = $state;
	
	    this.socialSecurityService.initData();
	  }
	
	  (0, _createClass3.default)(SocialSecurityController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.employeeId = this.socialSecurityService.employeeId;
	      this._loadData();
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.modal.modal('show');
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.modal.modal('hide');
	    }
	  }, {
	    key: '_loadData',
	    value: function _loadData() {
	      var _this = this;
	
	      this.socialSecurityDataService.getQuoteBasisInitial(this.employeeId).then(function (response) {
	        _this.log.info('socialSecurityDataService.getQuoteBasisInitial', response.data);
	        _this.ssData = response.data.quoteBasisList;
	        _this.employeeData = response.data.quoteBasisProfile;
	      }).catch(function (error) {
	        _this.log.error(error);
	        // TODO: [Manu] revisar esto, no debería hacer falta con errorInterceptor, no falla como en APP Ayuda Alimentaria pq en el routing de loans se hace esta misma llamada pero sin el state.go error
	        _this.state.go(_states.STATES.ERROR);
	      });
	    }
	  }, {
	    key: 'showHeaderEmployee',
	    value: function showHeaderEmployee() {
	      return this.employeeData && this.employeeData.idIdentification && this.employeeData.nameInicials && this.employeeData.socialSecurityMembershipNumber;
	    }
	  }, {
	    key: 'searchPeriod',
	    value: function searchPeriod($event) {
	      if (!$event) {
	        this._loadData();
	        return;
	      }
	
	      var isContribution = $event.data.periodType == _constants.SS_SWITCH_CONFIG[0].value;
	
	      isContribution ? this.searchContribution($event.data) : this.searchSettlement($event.data);
	    }
	  }, {
	    key: 'searchContribution',
	    value: function searchContribution(data) {
	      var _this2 = this;
	
	      this.socialSecurityDataService.getContributions(this.employeeId, data.year, data.month).then(function (response) {
	        _this2.ssData = response.data.quoteBasisList;
	      }).catch(function (error) {
	        _this2.errorMessage = error.data.message;
	        _this2.openModal();
	        _this2.log.error(error);
	      });
	    }
	  }, {
	    key: 'searchSettlement',
	    value: function searchSettlement(data) {
	      var _this3 = this;
	
	      this.socialSecurityDataService.getSettlements(this.employeeId, data.year, data.month).then(function (response) {
	        _this3.ssData = response.data.quoteBasisList;
	      }).catch(function (error) {
	        _this3.errorMessage = error.data.message;
	        _this3.openModal();
	        _this3.log.error(error);
	      });
	    }
	  }, {
	    key: 'modal',
	    get: function get() {
	      return $(_constants2.MODALS.SOCIAL_SECURITY_MODAL);
	    }
	  }]);
	  return SocialSecurityController;
	}();
	
	exports.default = SocialSecurityController;

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _headerSS = __webpack_require__(2329);
	
	var _headerSS2 = _interopRequireDefault(_headerSS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerSSModule = angular.module('social-security.headerSS', []).component('headerSs', _headerSS2.default).name;
	
	exports.default = headerSSModule;

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _headerSS = __webpack_require__(2330);
	
	var _headerSS2 = _interopRequireDefault(_headerSS);
	
	__webpack_require__(2331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerSS = {
	  restrict: 'E',
	  transclude: true,
	  bindings: {},
	  template: _headerSS2.default
	};
	
	exports.default = headerSS;

/***/ }),
/* 2330 */
/***/ (function(module, exports) {

	module.exports = "<header>\n  <div>\n    <img src=\"img/social-security/ministerio.png\" alt=\"{{'SOCIAL_SECURITY.HEADER_SS.MINISTRY' | translate}}\" class=\"header-image-left\" />\n    <h1>\n      <ng-transclude></ng-transclude>\n    </h1>\n    <img src=\"img/social-security/tesoreria.png\" alt=\"{{'SOCIAL_SECURITY.HEADER_SS.TREASURY' | translate}}\" class=\"header-image-right\"/>\n  </div>\n\n  <h2>\n    {{'SOCIAL_SECURITY.HEADER_SS.INDIVIDUAL_EXTRACT_NOTE' | translate}}\n  </h2>\n</header>\n"

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2332);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./headerSS.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./headerSS.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "header-ss{display:block}header-ss header div{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;height:111px;max-width:1200px;padding:33px 30px;width:100%}@media(max-width:1120px){header-ss header div{padding:33px 0}}header-ss header div h1{font-size:25px;font-weight:500;margin:0;text-transform:uppercase}@media(max-width:1120px){header-ss header div h1{font-size:22px}}header-ss header div img.header-image-left{height:70px}header-ss header div img.header-image-right{height:50px}header-ss header h2{font-size:15px;font-weight:400;text-align:center;color:#777676;margin-top:0;margin-bottom:15px}", ""]);
	
	// exports


/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _socialSecurityList = __webpack_require__(2334);
	
	var _socialSecurityList2 = _interopRequireDefault(_socialSecurityList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityListModule = _angular2.default.module('socialSecurityList', []).component('socialSecurityList', _socialSecurityList2.default).name;
	
	exports.default = socialSecurityListModule;

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialSecurityList = __webpack_require__(2335);
	
	var _socialSecurityList2 = _interopRequireDefault(_socialSecurityList);
	
	var _socialSecurityList3 = __webpack_require__(2336);
	
	var _socialSecurityList4 = _interopRequireDefault(_socialSecurityList3);
	
	__webpack_require__(2337);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socialSecurityListComponent = {
	  restrict: 'E',
	  bindings: {
	    ssData: '<'
	  },
	  template: _socialSecurityList2.default,
	  controller: _socialSecurityList4.default
	};
	
	exports.default = socialSecurityListComponent;

/***/ }),
/* 2335 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <social-security-card ng-repeat=\"ssRow in $ctrl.ssData track by $index\" ss-data=\"ssRow\">\n  </social-security-card>\n\n  <div class=\"list-empty\" ng-if=\"$ctrl.isEmpty()\">\n    <span class=\"icon-warning\"></span>\n    <span>{{'SOCIAL_SECURITY.MAIN.EMPTY_LIST' | translate}}</span>\n  </div>\n</section>\n"

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _isUndefinedOrNullOrEmpty = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSecurityListController = function () {
	  function SocialSecurityListController() {
	    (0, _classCallCheck3.default)(this, SocialSecurityListController);
	  }
	
	  (0, _createClass3.default)(SocialSecurityListController, [{
	    key: 'isEmpty',
	    value: function isEmpty() {
	      return (0, _isUndefinedOrNullOrEmpty.isUndefinedOrNullOrEmpty)(this.ssData);
	    }
	  }]);
	  return SocialSecurityListController;
	}();
	
	exports.default = SocialSecurityListController;

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2338);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(425)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurityList.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/dist/cjs.js!./socialSecurityList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(424)();
	// imports
	
	
	// module
	exports.push([module.id, "social-security-list{display:block}social-security-list .list-empty{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}social-security-list .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(448);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _metrics = __webpack_require__(2340);
	
	var _metrics2 = _interopRequireDefault(_metrics);
	
	var _gprofile = __webpack_require__(2341);
	
	var _gprofile2 = _interopRequireDefault(_gprofile);
	
	var _accessToken = __webpack_require__(559);
	
	var _accessToken2 = _interopRequireDefault(_accessToken);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mobileModule = _angular2.default.module('mobile', []).service('accessTokenService', _accessToken2.default).service('metricsService', _metrics2.default).service('gProfileService', _gprofile2.default).name;
	
	exports.default = mobileModule;

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(561);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(916);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENV = {
	  pro: 'HPDBBVAG2PROD',
	  pre: 'HPDBBVAG2PRE'
	}; /*eslint camelcase: ["error", {properties: "never"}]*/
	/*global setEnviorment, Stadistic*/
	
	
	var ATOM = {
	  loans: '00000160',
	  'food-benefit': 'AYAL',
	  'vacations-absences': '00000060'
	};
	
	var DATA_ORIGIN = 'móvil'; //Web o móvil
	
	var MetricsService = function () {
	  MetricsService.$inject = ["$log", "$window", "gProfileService"];
	  function MetricsService($log, $window, gProfileService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MetricsService);
	    this.log = $log;
	    this.window = $window;
	
	    this.gProfileService = gProfileService;
	
	    if (this.getIsMobileApp()) {
	      this.env = this.getEnv();
	      this.atom = this.getAtom();
	      this.device = this.initDeviceInfo();
	      try {
	        setEnviorment(this.env);
	        this.stadistic = new Stadistic();
	      } catch (e) {
	        this.log.error('error stadistic setEnviorment and/or new Stadistic()', e);
	      }
	    }
	  }
	
	  (0, _createClass3.default)(MetricsService, [{
	    key: 'getIsMobileApp',
	    value: function getIsMobileApp() {
	      return !!this.window.isMobileApp;
	    }
	  }, {
	    key: 'getEnv',
	    value: function getEnv() {
	      var env =  true ? ENV.pre : ENV.pro;
	      this.log.info('stadistic environment', env);
	      return env;
	    }
	  }, {
	    key: 'getAtom',
	    value: function getAtom() {
	      var atom = ATOM[(undefined)] || 'Web Autoservicios';
	      this.log.info('stadistic atom', atom);
	      return atom;
	    }
	  }, {
	    key: 'initDeviceInfo',
	    value: function initDeviceInfo() {
	      if (window.device === undefined) {
	        this.window.device = {
	          version: 'notADevice'
	        };
	      }
	      this.log.info('stadistic device info', this.window.device);
	      return this.window.device;
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.log.info('stadistic init isMobileApp', this.getIsMobileApp());
	
	      if (this.getIsMobileApp()) {
	        // Obtain authenticated user google profile data
	        this.gProfileService.getSession().then(function (response) {
	          var gprofile = response;
	          _this.log.info('init stadistic with gprofile', (0, _stringify2.default)(gprofile));
	
	          var data = {};
	          data.Idioma = gprofile.locale;
	          data.UID = gprofile.employeeId;
	          data.CargoFuncional = gprofile.functionalCode;
	          data.Empleado = gprofile.sIsEmployee;
	          data.Directivo = _this.isExecutive(gprofile.globalRange);
	          data.App_actual = _this.atom;
	          data.OrigenDatos = DATA_ORIGIN;
	          data.Pais = gprofile.countryCode;
	          data.Empresa = gprofile.companyCode;
	          data.UONivel1 = gprofile.ous[0].ouCode;
	          data.UONivel2 = gprofile.ous[1].ouCode;
	          data.UONivel3 = gprofile.ous[2].ouCode;
	          data.UONivel4 = gprofile.ous[3].ouCode;
	          data.UONivel5 = gprofile.ous[4].ouCode;
	          data.UONivel6 = gprofile.ous[5].ouCode;
	          data.UONivel7 = gprofile.ous[6].ouCode;
	          data.UONivel8 = gprofile.ous[7].ouCode;
	          data.UONivel9 = gprofile.ous[8].ouCode;
	          data.UONivel10 = gprofile.ous[9].ouCode;
	          _this.log.info('stadistic data', (0, _stringify2.default)(data));
	
	          try {
	            _this.stadistic.init(data);
	            _this.log.info('stadistic object', (0, _stringify2.default)(_this.stadistic));
	
	            _this._trackAccessApp();
	          } catch (e) {
	            _this.log.error('error stadistic.init', e);
	          }
	        }, function (error) {
	          _this.log.error('Error al obtener el GProfile: ', (0, _stringify2.default)(error));
	        });
	      }
	    }
	  }, {
	    key: 'isExecutive',
	    value: function isExecutive(globalRange) {
	      return globalRange != null && (globalRange == '6' || globalRange == '7' || globalRange == '0');
	    }
	  }, {
	    key: '_trackAccessApp',
	    value: function _trackAccessApp() {
	      this.log.info('_trackAccessApp isMobileApp', this.getIsMobileApp());
	
	      var eVars = {
	        'eVar73': this.atom,
	        'eVar75': this.device.version
	      };
	      var props = {
	        'prop73': this.atom,
	        'prop75': this.device.version
	      };
	      this.log.info('_trackAccessApp', (0, _stringify2.default)(eVars), (0, _stringify2.default)(props));
	
	      if (this.getIsMobileApp()) {
	        try {
	          this.log.info('_trackAccessApp stadistic environment', this.env);
	          this.log.info('_trackAccessApp stadistic atom', this.atom);
	          this.log.info('_trackAccessApp stadistic object', (0, _stringify2.default)(this.stadistic));
	          this.log.info('_trackAccessApp', (0, _stringify2.default)(eVars), (0, _stringify2.default)(props));
	          this.stadistic.registraSeguimientoGenerico(eVars, props, ['event71', 'event1'], true);
	        } catch (e) {
	          this.log.error('error stadistic.registraSeguimientoGenerico', e);
	        }
	      }
	    }
	  }, {
	    key: 'trackLoansSimulation',
	    value: function trackLoansSimulation() {
	      this.log.info('trackLoansSimulation');
	      var SIMULATION = 'Simulación';
	
	      if (this.getIsMobileApp()) {
	        var eVars = {
	          'eVar70': this.atom,
	          'eVar71': SIMULATION,
	          'eVar75': this.device.version
	        };
	        var props = {
	          'prop70': this.atom,
	          'prop71': SIMULATION,
	          'prop75': this.device.version
	        };
	        this._trackAction(eVars, props);
	      }
	    }
	  }, {
	    key: 'trackLoansSignup',
	    value: function trackLoansSignup(params) {
	      this.log.info('trackLoansSignup', params);
	      var SIGN_UP = 'Contratación';
	      var PARAM_LOAN_TYPE = 'loanType';
	
	      if (this.getIsMobileApp()) {
	        var eVars = {
	          'eVar70': this.atom,
	          'eVar71': SIGN_UP,
	          'eVar72': params[PARAM_LOAN_TYPE],
	          'eVar75': this.device.version
	        };
	        var props = {
	          'prop70': this.atom,
	          'prop71': SIGN_UP,
	          'prop72': params[PARAM_LOAN_TYPE],
	          'prop75': this.device.version
	        };
	        this._trackAction(eVars, props);
	      }
	    }
	  }, {
	    key: 'trackFoodBenefitDelegation',
	    value: function trackFoodBenefitDelegation(params) {
	      this.log.info('trackFoodBenefitDelegation', params);
	      var PARAM_DELEGATION_TYPE = 'delegationType';
	      var DELEGATION_TYPES = {};
	      DELEGATION_TYPES[_constants.DELEGATION_TYPE.MANAGER] = 'Delegación manager';
	      DELEGATION_TYPES[_constants.DELEGATION_TYPE.EMPLOYEE] = 'Delegación empleado';
	      var delegationType = DELEGATION_TYPES[params[PARAM_DELEGATION_TYPE]];
	
	      if (this.getIsMobileApp()) {
	        var eVars = {
	          'eVar70': this.atom,
	          'eVar71': delegationType,
	          'eVar75': this.device.version
	        };
	        var props = {
	          'prop70': this.atom,
	          'prop71': delegationType,
	          'prop75': this.device.version
	        };
	        this._trackAction(eVars, props);
	      }
	    }
	  }, {
	    key: 'trackVacationsAbsencesDelegation',
	    value: function trackVacationsAbsencesDelegation() {
	      this.log.info('trackVacationsAbsencesDelegation');
	      var DELEGATION = 'Delegación';
	
	      if (this.getIsMobileApp()) {
	        var eVars = {
	          'eVar70': this.atom,
	          'eVar71': DELEGATION,
	          'eVar75': this.device.version
	        };
	        var props = {
	          'prop70': this.atom,
	          'prop71': DELEGATION,
	          'prop75': this.device.version
	        };
	        this._trackAction(eVars, props);
	      }
	    }
	  }, {
	    key: 'trackVacationsAbsencesCreateAbsenceFromManagerToEmployee',
	    value: function trackVacationsAbsencesCreateAbsenceFromManagerToEmployee() {
	      this.log.info('trackVacationsAbsencesCreateAbsenceFromManagerToEmployee');
	      var CREATE_ABSENCE = 'Crear ausencia de manager a empleado';
	
	      if (this.getIsMobileApp()) {
	        var eVars = {
	          'eVar70': this.atom,
	          'eVar71': CREATE_ABSENCE,
	          'eVar75': this.device.version
	        };
	        var props = {
	          'prop70': this.atom,
	          'prop71': CREATE_ABSENCE,
	          'prop75': this.device.version
	        };
	        this._trackAction(eVars, props);
	      }
	    }
	  }, {
	    key: '_trackAction',
	    value: function _trackAction(eVars, props) {
	      this.log.info('_trackAction isMobileApp', this.getIsMobileApp());
	      this.log.info('_trackAction', (0, _stringify2.default)(eVars), (0, _stringify2.default)(props));
	
	      if (this.getIsMobileApp()) {
	        try {
	          this.log.info('_trackAction stadistic environment', this.env);
	          this.log.info('_trackAction stadistic atom', this.atom);
	          this.log.info('_trackAction stadistic object', (0, _stringify2.default)(this.stadistic));
	          this.stadistic.registraSeguimientoGenerico(eVars, props, ['event70']);
	        } catch (e) {
	          this.log.error('error stadistic.registraSeguimientoGenerico', e);
	        }
	      }
	    }
	  }, {
	    key: 'trackNavigationVacationsAbsencesTeamCalendar',
	    value: function trackNavigationVacationsAbsencesTeamCalendar() {
	      var TEAM_CALENDAR = 'Calendario de Equipo';
	      this._trackNavigation(TEAM_CALENDAR);
	    }
	  }, {
	    key: '_trackNavigation',
	    value: function _trackNavigation(navigateTo) {
	      this.log.info('_trackNavigation isMobileApp', this.getIsMobileApp());
	
	      var eVars = {
	        'eVar73': this.atom,
	        'eVar74': navigateTo,
	        'eVar75': this.device.version
	      };
	      var props = {
	        'prop73': this.atom,
	        'prop74': navigateTo,
	        'prop75': this.device.version
	      };
	      this.log.info('_trackNavigation', (0, _stringify2.default)(eVars), (0, _stringify2.default)(props));
	
	      if (this.getIsMobileApp()) {
	        try {
	          this.log.info('_trackNavigation stadistic environment', this.env);
	          this.log.info('_trackNavigation stadistic atom', this.atom);
	          this.log.info('_trackNavigation stadistic object', (0, _stringify2.default)(this.stadistic));
	          this.stadistic.registraSeguimientoGenerico(eVars, props, ['event72', 'event1'], true);
	        } catch (e) {
	          this.log.error('error stadistic.registraSeguimientoGenerico', e);
	        }
	      }
	    }
	  }]);
	  return MetricsService;
	}();
	
	exports.default = MetricsService;

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(561);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(551);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(552);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _bbvaGapis = __webpack_require__(2342);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GProfileService = function () {
	  GProfileService.$inject = ["$http", "$log", "$q", "accessTokenService"];
	  function GProfileService($http, $log, $q, accessTokenService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, GProfileService);
	    this.http = $http;
	    this.log = $log;
	    this.q = $q;
	    this.accessTokenService = accessTokenService;
	
	    this.gprofile = null;
	  }
	
	  (0, _createClass3.default)(GProfileService, [{
	    key: 'getSession',
	    value: function getSession() {
	      var _this = this;
	
	      if (this.gprofile) {
	        var deferred = this.q.defer();
	        deferred.resolve(this.gprofile);
	        return deferred.promise;
	      }
	
	      return this.http({
	        method: 'POST',
	        url: _bbvaGapis.ENDPOINTS_GPROFILE.post.session(),
	        headers: {
	          'Skip-Request': 'true',
	          'Authorization': 'Bearer ' + this.accessTokenService.getToken()
	        }
	      }).then(function (response) {
	        _this.gprofile = response.data.data;
	        _this.log.info('GProfile Session', (0, _stringify2.default)(_this.gprofile));
	        return _this.gprofile;
	      });
	    }
	  }]);
	  return GProfileService;
	}();
	
	exports.default = GProfileService;

/***/ }),
/* 2342 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API_URL = 'https://bbva-gateway.appspot.com';
	var GPROFILE = '/gprofile/s/v2';
	
	var ENDPOINTS_GPROFILE = {
	  post: {
	    session: function session() {
	      return '' + API_URL + GPROFILE + '/session';
	    }
	  }
	};
	
	exports.ENDPOINTS_GPROFILE = ENDPOINTS_GPROFILE;

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js